
      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequiref159"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequiref159"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("lJcBI", function(module, exports) {
module.exports = import.meta.resolve("jifDK");

});

parcelRegister("2wacE", function(module, exports) {
module.exports = import.meta.resolve("8rZie");

});

parcelRegister("lVXFz", function(module, exports) {
module.exports = import.meta.resolve("6MrIs");

});

parcelRegister("gdAbz", function(module, exports) {
module.exports = import.meta.resolve("1UQRF");

});

parcelRegister("j5YnW", function(module, exports) {
module.exports = import.meta.resolve("aNKJu");

});

parcelRegister("cHkr5", function(module, exports) {
module.exports = import.meta.resolve("dcBqe");

});

parcelRegister("7QupC", function(module, exports) {
module.exports = import.meta.resolve("8ETm3");

});

parcelRegister("epA4r", function(module, exports) {
module.exports = import.meta.resolve("2rMb0");

});

parcelRegister("hDzLx", function(module, exports) {
module.exports = import.meta.resolve("gLdyq");

});

parcelRegister("i0ki7", function(module, exports) {
module.exports = import.meta.resolve("8yOKg");

});

parcelRegister("g9kxe", function(module, exports) {
module.exports = import.meta.resolve("89Jg2");

});

parcelRegister("59lhO", function(module, exports) {
module.exports = import.meta.resolve("gmfHh");

});

parcelRegister("7Jo3t", function(module, exports) {
module.exports = JSON.parse("{\"version\":2,\"name\":\"Vendovi Island\",\"displayInfo\":{\"description\":\"A single small island in Washington's Rosario Strait. A compact playground for short trips and close-quarters handling.\",\"difficulty\":\"beginner\"},\"region\":{\"datasetPath\":\"wash_bellingham/\",\"bbox\":{\"minLat\":48.603606,\"minLon\":-122.617323,\"maxLat\":48.617294,\"maxLon\":-122.595673},\"interval\":25,\"simplify\":5,\"scale\":1,\"minPerimeter\":1500,\"minPoints\":4,\"flipY\":true},\"waves\":{\"sources\":[{\"amplitude\":0.32,\"wavelength\":32,\"direction\":0.79,\"phaseOffset\":0},{\"amplitude\":0.14,\"wavelength\":12,\"direction\":0.85,\"phaseOffset\":1.62},{\"amplitude\":0.18,\"wavelength\":22,\"direction\":0,\"phaseOffset\":3.24},{\"amplitude\":0.06,\"wavelength\":5,\"direction\":0.75,\"phaseOffset\":4.85}]},\"wind\":{\"sources\":[{\"direction\":0.6}]},\"startPosition\":[-500,2000],\"biome\":{\"zones\":[{\"maxHeight\":8,\"color\":[0.55,0.52,0.45],\"colorAlt\":[0.48,0.45,0.4],\"noiseBlend\":0.3,\"treeDensity\":0},{\"maxHeight\":25,\"color\":[0.22,0.3,0.14],\"colorAlt\":[0.18,0.22,0.1],\"noiseBlend\":0.5,\"treeDensity\":0.6},{\"maxHeight\":120,\"color\":[0.1,0.2,0.07],\"colorAlt\":[0.14,0.16,0.06],\"noiseBlend\":0.5,\"treeDensity\":0.85},{\"maxHeight\":300,\"color\":[0.08,0.16,0.05],\"colorAlt\":[0.12,0.12,0.05],\"noiseBlend\":0.4,\"treeDensity\":0.8},{\"maxHeight\":600,\"color\":[0.38,0.42,0.36],\"colorAlt\":[0.42,0.4,0.35],\"noiseBlend\":0.3,\"treeDensity\":0.3},{\"maxHeight\":9999,\"color\":[0.52,0.52,0.5],\"colorAlt\":[0.48,0.48,0.45],\"noiseBlend\":0.2,\"treeDensity\":0}],\"rockColor\":[0.42,0.42,0.4],\"rockThreshold\":0.55,\"snowlineHeight\":-1,\"largeNoiseScale\":0.004,\"smallNoiseScale\":0.25},\"trees\":{\"spacing\":15,\"density\":1,\"minElevation\":8,\"maxElevation\":300}}");

});

parcelRegister("fg22G", function(module, exports) {
module.exports = JSON.parse("{\"version\":2,\"name\":\"San Juan Islands\",\"displayInfo\":{\"description\":\"A sprawling archipelago between Washington and Vancouver Island. Strong tidal currents, narrow passes, and plenty of ports to explore.\",\"difficulty\":\"expert\"},\"region\":{\"datasetPath\":\"wash_bellingham/\",\"bbox\":{\"minLat\":48.4,\"minLon\":-123.35,\"maxLat\":48.75,\"maxLon\":-122.75},\"interval\":[[-300,50],[-50,10],[0,5],[25,25]],\"simplify\":[[-300,20],[-25,5],[0,1],[50,10]],\"scale\":1,\"minPerimeter\":3000,\"minPoints\":4,\"flipY\":true},\"waves\":{\"sources\":[{\"amplitude\":0.7,\"wavelength\":60,\"direction\":0.79,\"phaseOffset\":0},{\"amplitude\":0.22,\"wavelength\":18,\"direction\":0.85,\"phaseOffset\":1.62},{\"amplitude\":0.4,\"wavelength\":380,\"direction\":-0.39,\"phaseOffset\":3.24},{\"amplitude\":0.15,\"wavelength\":640,\"direction\":0.02,\"phaseOffset\":4.85},{\"amplitude\":0.3,\"wavelength\":38,\"direction\":-0.75,\"phaseOffset\":0.19},{\"amplitude\":0.08,\"wavelength\":7,\"direction\":0.8,\"phaseOffset\":1.81}]},\"wind\":{\"sources\":[{\"direction\":0.6}]},\"startPosition\":[0,0],\"biome\":{\"zones\":[{\"maxHeight\":3,\"color\":[0.55,0.52,0.45],\"colorAlt\":[0.48,0.45,0.4],\"noiseBlend\":0.3,\"treeDensity\":0},{\"maxHeight\":25,\"color\":[0.22,0.3,0.14],\"colorAlt\":[0.18,0.22,0.1],\"noiseBlend\":0.5,\"treeDensity\":0.6},{\"maxHeight\":120,\"color\":[0.1,0.2,0.07],\"colorAlt\":[0.14,0.16,0.06],\"noiseBlend\":0.5,\"treeDensity\":0.85},{\"maxHeight\":300,\"color\":[0.08,0.16,0.05],\"colorAlt\":[0.12,0.12,0.05],\"noiseBlend\":0.4,\"treeDensity\":0.8},{\"maxHeight\":600,\"color\":[0.38,0.42,0.36],\"colorAlt\":[0.42,0.4,0.35],\"noiseBlend\":0.3,\"treeDensity\":0.3},{\"maxHeight\":9999,\"color\":[0.52,0.52,0.5],\"colorAlt\":[0.48,0.48,0.45],\"noiseBlend\":0.2,\"treeDensity\":0}],\"rockColor\":[0.42,0.42,0.4],\"rockThreshold\":0.55,\"snowlineHeight\":-1,\"largeNoiseScale\":0.004,\"smallNoiseScale\":0.25},\"trees\":{\"spacing\":35,\"density\":0.75,\"minElevation\":4,\"maxElevation\":500}}");

});

parcelRegister("50ium", function(module, exports) {
module.exports = JSON.parse("{\"version\":2,\"name\":\"Isles of Scilly\",\"displayInfo\":{\"description\":\"A low-lying archipelago off the coast of Cornwall. Exposed Atlantic swell, shallow rocks, and no shelter when the weather turns.\",\"difficulty\":\"expert\"},\"region\":{\"dataSource\":{\"type\":\"emodnet-wcs\",\"coverageId\":\"emodnet__mean\"},\"bbox\":{\"minLat\":49.85,\"minLon\":-6.45,\"maxLat\":49.99,\"maxLon\":-6.2},\"interval\":30,\"simplify\":200,\"scale\":1,\"minPerimeter\":1500,\"minPoints\":4,\"flipY\":true},\"waves\":{\"sources\":[{\"amplitude\":1.2,\"wavelength\":520,\"direction\":0,\"phaseOffset\":0},{\"amplitude\":0.7,\"wavelength\":620,\"direction\":-0.39,\"phaseOffset\":1.62},{\"amplitude\":0.5,\"wavelength\":400,\"direction\":0.39,\"phaseOffset\":3.24},{\"amplitude\":0.3,\"wavelength\":900,\"direction\":-0.18,\"phaseOffset\":4.85},{\"amplitude\":0.55,\"wavelength\":75,\"direction\":-0.79,\"phaseOffset\":0.19},{\"amplitude\":0.35,\"wavelength\":48,\"direction\":0.05,\"phaseOffset\":1.81},{\"amplitude\":0.22,\"wavelength\":22,\"direction\":-0.75,\"phaseOffset\":3.43},{\"amplitude\":0.1,\"wavelength\":9,\"direction\":0,\"phaseOffset\":5.04}]},\"wind\":{\"sources\":[{\"direction\":-0.79}]},\"startPosition\":[0,0],\"trees\":{\"spacing\":35,\"density\":0.75,\"minElevation\":4,\"maxElevation\":500}}");

});

parcelRegister("1qR3l", function(module, exports) {
module.exports = JSON.parse("{\"version\":2,\"displayInfo\":{\"description\":\"An open test basin with deep water and steady winds. Good for trying out the controls before heading somewhere real.\",\"difficulty\":\"beginner\"},\"defaultDepth\":-300,\"waves\":{\"sources\":[{\"amplitude\":0.4,\"wavelength\":200,\"direction\":0.8},{\"amplitude\":0.15,\"wavelength\":20,\"direction\":0.8}]},\"wind\":{\"sources\":[{\"direction\":0.785}]},\"startPosition\":[40,710],\"startingPortId\":\"bayview-harbor\",\"ports\":[{\"id\":\"bayview-harbor\",\"name\":\"Bayview Harbor\",\"position\":[30,680],\"angle\":1.57},{\"id\":\"shield-cove\",\"name\":\"Shield Cove\",\"position\":[500,1870],\"angle\":-1.57},{\"id\":\"eastern-point\",\"name\":\"Eastern Point\",\"position\":[1050,2650],\"angle\":0}],\"missions\":[{\"id\":\"first-voyage\",\"name\":\"First Voyage\",\"description\":\"Deliver supplies from Bayview Harbor to Shield Cove across the channel.\",\"type\":\"delivery\",\"sourcePortId\":\"bayview-harbor\",\"destinationPortId\":\"shield-cove\",\"prerequisites\":{},\"rewards\":{\"money\":100,\"revealPorts\":[\"eastern-point\"]}},{\"id\":\"supply-run\",\"name\":\"Supply Run\",\"description\":\"Bring provisions back from Shield Cove to Bayview Harbor.\",\"type\":\"delivery\",\"sourcePortId\":\"shield-cove\",\"destinationPortId\":\"bayview-harbor\",\"prerequisites\":{\"completedMissions\":[\"first-voyage\"]},\"rewards\":{\"money\":150}},{\"id\":\"long-haul\",\"name\":\"Long Haul\",\"description\":\"Transport cargo from Bayview Harbor around to the remote Eastern Point.\",\"type\":\"delivery\",\"sourcePortId\":\"bayview-harbor\",\"destinationPortId\":\"eastern-point\",\"prerequisites\":{\"completedMissions\":[\"supply-run\"]},\"rewards\":{\"money\":300}},{\"id\":\"return-trip\",\"name\":\"Return Trip\",\"description\":\"Navigate back from Eastern Point to Bayview Harbor with the final delivery.\",\"type\":\"delivery\",\"sourcePortId\":\"eastern-point\",\"destinationPortId\":\"bayview-harbor\",\"prerequisites\":{\"completedMissions\":[\"long-haul\"]},\"rewards\":{\"money\":200}}],\"contours\":[{\"name\":\"Bay Island Shore\",\"height\":0,\"controlPoints\":[[355.5905782577893,610.884661230437],[688.8781515194332,468.8901524390393],[852.4549190631374,105.76385125413628],[838.8781515194332,-331.1098475609607],[638.8781515194332,-631.1098475609606],[188.87815151943323,-781.1098475609606],[-261.12184848056677,-631.1098475609606],[-461.12184848056677,-331.1098475609607],[-511.12184848056677,68.8901524390393],[-311.12184848056677,468.8901524390393],[3.486245294338005,629.5641407171762],[68.87815151943323,518.8901524390395],[-11.121848480566769,318.8901524390393],[-91.12184848056677,118.8901524390393],[-111.12184848056677,-81.1098475609607],[188.87815151943323,-181.1098475609607],[488.87815151943323,-81.1098475609607],[468.87815151943323,118.8901524390393],[388.87815151943323,318.8901524390393],[308.87815151943323,518.8901524390395]]},{\"name\":\"Great Shield Island Shore\",\"height\":0,\"controlPoints\":[[-584.462887091739,1637.053023402415],[-633.2524091331031,2018.7403334823066],[-294.18628583735165,2098.1792159582274],[79.83373724933517,2063.8786341095],[379.8337372493352,2013.8786341095004],[677.0260050985471,1913.8786341095004],[933.216518960144,1867.261415820309],[979.8337372493356,2213.8786341095],[1027.9620306691727,2633.3952511625052],[402.34205742910854,2619.2451875309366],[111.23978379297523,2721.6367129843843],[93.64664742837658,3028.8882611350596],[288.59764566273725,3265.0310131811007],[630.0834117193049,3279.5005645243896],[1033.5771504096606,3039.282974980399],[979.8337372493356,3413.8786341094997],[879.8337372493356,3813.8786341094997],[679.8337372493356,3863.8786341094997],[379.8337372493352,3913.8786341094997],[79.83373724933517,3963.8786341094997],[-220.16626275066483,3913.8786341094997],[-520.1662627506648,3863.8786341094997],[-720.1662627506648,3813.8786341094997],[-820.1662627506648,3413.8786341094997],[-870.1662627506648,2813.8786341094997],[-870.1662627506648,2213.8786341095],[-820.1662627506648,1813.8786341095001]]},{\"name\":\"Beginner Islands inner shelf\",\"height\":-155.3,\"controlPoints\":[[-752.4225826733605,-1004.0787866149094],[1434.2440852001164,-739.8565635177501],[1390.2378759696987,3792.9674651643404],[-1352.7808227581006,3637.0572385940636]]},{\"name\":\"Beginner islands outer shelf\",\"height\":-300,\"controlPoints\":[[-1446.1662881509471,-2156.3465574180723],[2595.1560298842232,-1784.445728956608],[1785.2386701237015,4232.0832113516735],[-1793.273728048314,3975.8848628559967]]},{\"name\":\"Contour 6\",\"height\":20,\"controlPoints\":[[-162.9629601447973,-532.6162906722698],[581.9362523518308,-457.9129292773789],[722.8054481250537,-48.11165218069016],[268.00083952630655,-290.89753730802624],[-380.6698990670509,-101.47119603418366]]},{\"name\":\"Contour 7\",\"height\":20,\"controlPoints\":[[-640.6606242653818,2402.134241342826],[-253.72494530073538,2358.0826007635997],[-165.36819972455726,3362.136528716606],[-438.47086882008966,3534.8338041609536]]}],\"trees\":{\"spacing\":35,\"density\":0.75,\"minElevation\":4,\"maxElevation\":500}}");

});

parcelRegister("bKg0i", function(module, exports) {
module.exports = JSON.parse("{\"version\":2,\"name\":\"Apostle Islands\",\"displayInfo\":{\"description\":\"A cluster of forested islands on the south shore of Lake Superior. Shifty winds in the channels and long fetches out in open water.\",\"difficulty\":\"intermediate\"},\"region\":{\"dataSource\":{\"type\":\"usace-s3\",\"baseUrl\":\"https://noaa-nos-coastal-lidar-pds.s3.us-east-1.amazonaws.com/dem/USACE_Superior_DEM_2019_9185/\",\"statePrefix\":\"wi/\",\"urlList\":\"urllist9185.txt\"},\"bbox\":{\"minLat\":46.85,\"minLon\":-90.9,\"maxLat\":47.05,\"maxLon\":-90.2},\"interval\":100,\"simplify\":100,\"scale\":1,\"minPerimeter\":1500,\"minPoints\":4,\"flipY\":true},\"waves\":{\"sources\":[{\"amplitude\":0.5,\"wavelength\":48,\"direction\":0,\"phaseOffset\":0},{\"amplitude\":0.22,\"wavelength\":14,\"direction\":0.05,\"phaseOffset\":1.62},{\"amplitude\":0.3,\"wavelength\":55,\"direction\":-0.79,\"phaseOffset\":3.24},{\"amplitude\":0.3,\"wavelength\":100,\"direction\":2.36,\"phaseOffset\":4.85},{\"amplitude\":0.12,\"wavelength\":18,\"direction\":-0.75,\"phaseOffset\":0.19},{\"amplitude\":0.07,\"wavelength\":6,\"direction\":0.1,\"phaseOffset\":1.81}]},\"wind\":{\"sources\":[{\"direction\":0}]},\"startPosition\":[-68000,0],\"trees\":{\"spacing\":35,\"density\":0.75,\"minElevation\":4,\"maxElevation\":500}}");

});

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol, Iterator */ var $5c96a02c592fcff1$var$extendStatics = function(d, b) {
    $5c96a02c592fcff1$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $5c96a02c592fcff1$var$extendStatics(d, b);
};
function $5c96a02c592fcff1$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $5c96a02c592fcff1$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $5c96a02c592fcff1$export$18ce0697a983be9b = function() {
    $5c96a02c592fcff1$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $5c96a02c592fcff1$export$18ce0697a983be9b.apply(this, arguments);
};
function $5c96a02c592fcff1$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $5c96a02c592fcff1$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $5c96a02c592fcff1$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $5c96a02c592fcff1$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $5c96a02c592fcff1$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $5c96a02c592fcff1$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $5c96a02c592fcff1$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $5c96a02c592fcff1$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $5c96a02c592fcff1$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $5c96a02c592fcff1$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $5c96a02c592fcff1$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $5c96a02c592fcff1$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $5c96a02c592fcff1$export$45d3717a4c69092e(o, m, p);
}
function $5c96a02c592fcff1$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $5c96a02c592fcff1$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $5c96a02c592fcff1$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($5c96a02c592fcff1$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $5c96a02c592fcff1$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $5c96a02c592fcff1$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $5c96a02c592fcff1$export$10c90e4f7922046c(v) {
    return this instanceof $5c96a02c592fcff1$export$10c90e4f7922046c ? (this.v = v, this) : new $5c96a02c592fcff1$export$10c90e4f7922046c(v);
}
function $5c96a02c592fcff1$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $5c96a02c592fcff1$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $5c96a02c592fcff1$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $5c96a02c592fcff1$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $5c96a02c592fcff1$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $5c96a02c592fcff1$export$19a8beecd37a4c45 === "function" ? $5c96a02c592fcff1$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $5c96a02c592fcff1$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $5c96a02c592fcff1$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
var $5c96a02c592fcff1$var$ownKeys = function(o) {
    $5c96a02c592fcff1$var$ownKeys = Object.getOwnPropertyNames || function(o) {
        var ar = [];
        for(var k in o)if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
        return ar;
    };
    return $5c96a02c592fcff1$var$ownKeys(o);
};
function $5c96a02c592fcff1$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k = $5c96a02c592fcff1$var$ownKeys(mod), i = 0; i < k.length; i++)if (k[i] !== "default") $5c96a02c592fcff1$export$45d3717a4c69092e(result, mod, k[i]);
    }
    $5c96a02c592fcff1$var$__setModuleDefault(result, mod);
    return result;
}
function $5c96a02c592fcff1$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $5c96a02c592fcff1$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $5c96a02c592fcff1$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $5c96a02c592fcff1$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $5c96a02c592fcff1$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose, inner;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
            if (async) inner = dispose;
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        if (inner) dispose = function() {
            try {
                inner.call(this);
            } catch (e) {
                return Promise.reject(e);
            }
        };
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $5c96a02c592fcff1$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $5c96a02c592fcff1$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $5c96a02c592fcff1$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    var r, s = 0;
    function next() {
        while(r = env.stack.pop())try {
            if (!r.async && s === 1) return s = 0, env.stack.push(r), Promise.resolve().then(next);
            if (r.dispose) {
                var result = r.dispose.call(r.value);
                if (r.async) return s |= 2, Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } else s |= 1;
        } catch (e) {
            fail(e);
        }
        if (s === 1) return env.hasError ? Promise.reject(env.error) : Promise.resolve();
        if (env.hasError) throw env.error;
    }
    return next();
}
function $5c96a02c592fcff1$export$889dfb5d17574b0b(path, preserveJsx) {
    if (typeof path === "string" && /^\.\.?\//.test(path)) return path.replace(/\.(tsx)$|((?:\.d)?)((?:\.[^./]+?)?)\.([cm]?)ts$/i, function(m, tsx, d, ext, cm) {
        return tsx ? preserveJsx ? ".jsx" : ".js" : d && (!ext || !cm) ? m : d + ext + "." + cm.toLowerCase() + "js";
    });
    return path;
}
var $5c96a02c592fcff1$export$2e2bcd8739ae039 = {
    __extends: $5c96a02c592fcff1$export$a8ba968b8961cb8a,
    __assign: $5c96a02c592fcff1$export$18ce0697a983be9b,
    __rest: $5c96a02c592fcff1$export$3c9a16f847548506,
    __decorate: $5c96a02c592fcff1$export$29e00dfd3077644b,
    __param: $5c96a02c592fcff1$export$d5ad3fd78186038f,
    __esDecorate: $5c96a02c592fcff1$export$3a84e1ae4e97e9b0,
    __runInitializers: $5c96a02c592fcff1$export$d831c04e792af3d,
    __propKey: $5c96a02c592fcff1$export$6a2a36740a146cb8,
    __setFunctionName: $5c96a02c592fcff1$export$d1a06452d3489bc7,
    __metadata: $5c96a02c592fcff1$export$f1db080c865becb9,
    __awaiter: $5c96a02c592fcff1$export$1050f835b63b671e,
    __generator: $5c96a02c592fcff1$export$67ebef60e6f28a6,
    __createBinding: $5c96a02c592fcff1$export$45d3717a4c69092e,
    __exportStar: $5c96a02c592fcff1$export$f33643c0debef087,
    __values: $5c96a02c592fcff1$export$19a8beecd37a4c45,
    __read: $5c96a02c592fcff1$export$8d051b38c9118094,
    __spread: $5c96a02c592fcff1$export$afc72e2116322959,
    __spreadArrays: $5c96a02c592fcff1$export$6388937ca91ccae8,
    __spreadArray: $5c96a02c592fcff1$export$1216008129fb82ed,
    __await: $5c96a02c592fcff1$export$10c90e4f7922046c,
    __asyncGenerator: $5c96a02c592fcff1$export$e427f37a30a4de9b,
    __asyncDelegator: $5c96a02c592fcff1$export$bbd80228419bb833,
    __asyncValues: $5c96a02c592fcff1$export$e3b29a3d6162315f,
    __makeTemplateObject: $5c96a02c592fcff1$export$4fb47efe1390b86f,
    __importStar: $5c96a02c592fcff1$export$c21735bcef00d192,
    __importDefault: $5c96a02c592fcff1$export$da59b14a69baef04,
    __classPrivateFieldGet: $5c96a02c592fcff1$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $5c96a02c592fcff1$export$d40a35129aaff81f,
    __classPrivateFieldIn: $5c96a02c592fcff1$export$81fdc39f203e4e04,
    __addDisposableResource: $5c96a02c592fcff1$export$88ac25d8e944e405,
    __disposeResources: $5c96a02c592fcff1$export$8f076105dc360e92,
    __rewriteRelativeImportExtension: $5c96a02c592fcff1$export$889dfb5d17574b0b
};






function $3480ec8c2fb5ff20$export$d2aa6c54a5925f01(x, y, z) {
    if (x instanceof $3480ec8c2fb5ff20$export$d2de7ccaa2f4bf9f) return x.clone();
    else if (x instanceof Array || x instanceof Float32Array || x instanceof Float64Array) return new $3480ec8c2fb5ff20$export$d2de7ccaa2f4bf9f(x[0], x[1], x[2]);
    else if (typeof x === "object") // object with x, y, z properties
    return new $3480ec8c2fb5ff20$export$d2de7ccaa2f4bf9f(x.x, x.y, x.z);
    return new $3480ec8c2fb5ff20$export$d2de7ccaa2f4bf9f(x ?? 0, y ?? x ?? 0, z ?? x ?? 0);
}
class $3480ec8c2fb5ff20$export$d2de7ccaa2f4bf9f extends Array {
    constructor(x, y, z){
        super(), this.length = 3;
        if (isNaN(x) || isNaN(y) || isNaN(z)) throw new Error(`Can't make a V3d with NaN ${x},${y},${z}`);
        this[0] = x;
        this[1] = y;
        this[2] = z;
    }
    static fromPolar(radius, theta, z = 0) {
        return new $3480ec8c2fb5ff20$export$d2de7ccaa2f4bf9f(radius * Math.cos(theta), radius * Math.sin(theta), z);
    }
    /** Create a V3d from a 2D vector and a z component. */ static fromV2d(v, z = 0) {
        return new $3480ec8c2fb5ff20$export$d2de7ccaa2f4bf9f(v[0], v[1], z);
    }
    get v() {
        return this;
    }
    /** Return the result of adding this vector to another. */ add(other) {
        return this.clone().iadd(other);
    }
    /** (In Place) Return the result of adding this vector to another. */ iadd(other) {
        this[0] += other[0];
        this[1] += other[1];
        this[2] += other[2];
        return this;
    }
    /** Return the result of multiplying a scalar by another vector and adding it to this. */ addScaled(other, scale) {
        return this.clone().iaddScaled(other, scale);
    }
    /** (In Place) Return the result of multiplying a scalar by another vector and adding it to this. */ iaddScaled(other, scale = 1) {
        this[0] += other[0] * scale;
        this[1] += other[1] * scale;
        this[2] += other[2] * scale;
        return this;
    }
    /** Return the result of subtracting a vector from this one. */ sub(other) {
        return this.clone().isub(other);
    }
    /** (In Place) Return the result of subtracting a vector from this one. */ isub(other) {
        this[0] -= other[0];
        this[1] -= other[1];
        this[2] -= other[2];
        return this;
    }
    /** Return the result of multiplying this vector by a scalar. */ mul(scalar) {
        return this.clone().imul(scalar);
    }
    /** (In Place) Return the result of multiplying this vector by a scalar. */ imul(scalar) {
        this[0] *= scalar;
        this[1] *= scalar;
        this[2] *= scalar;
        return this;
    }
    /** Return the result of multiplying this vector by another vector componentwise. */ mulComponent(other) {
        return this.clone().imulComponent(other);
    }
    /** (In Place) Return the result of multiplying this vector by another vector componentwise. */ imulComponent(other) {
        this[0] *= other[0];
        this[1] *= other[1];
        this[2] *= other[2];
        return this;
    }
    /** Return the dot product of this and another vector */ dot(other) {
        return this[0] * other[0] + this[1] * other[1] + this[2] * other[2];
    }
    set(x, y, z) {
        if (typeof x === "number") {
            this[0] = x;
            this[1] = y;
            this[2] = z;
        } else {
            this[0] = x[0];
            this[1] = x[1];
            this[2] = x[2];
        }
        return this;
    }
    /** Return a normalized version of this vector */ normalize(length = 1) {
        return this.clone().inormalize(length);
    }
    /** (In Place) Return a normalized version of this vector */ inormalize(length = 1) {
        if (!(this[0] === 0 && this[1] === 0 && this[2] === 0)) this.magnitude = length;
        return this;
    }
    /**
   * Returns a new vector with magnitude limited to the specified maximum.
   * If current magnitude is less than max, returns unchanged vector.
   * @param max - Maximum allowed magnitude
   * @returns New vector with limited magnitude
   */ limit(max) {
        return this.clone().ilimit(max);
    }
    /**
   * (In-place) Limits this vector's magnitude to the specified maximum.
   * If current magnitude is less than max, vector remains unchanged.
   * @param max - Maximum allowed magnitude
   * @returns This vector for method chaining
   */ ilimit(max) {
        if (this.magnitude > max) this.magnitude = max;
        return this;
    }
    /** Return a new vector with the same values as this one */ clone() {
        return new $3480ec8c2fb5ff20$export$d2de7ccaa2f4bf9f(this[0], this[1], this[2]);
    }
    /** Return a vector that is between this and other */ lerp(other, t = 0) {
        return this.clone().ilerp(other, t);
    }
    /** (In place) Return a vector that is between this and other */ ilerp(other, t = 0) {
        this[0] = (0, $2172aedd5a25ff17$export$3a89f8d6f6bf6c9f)(this[0], other[0], t);
        this[1] = (0, $2172aedd5a25ff17$export$3a89f8d6f6bf6c9f)(this[1], other[1], t);
        this[2] = (0, $2172aedd5a25ff17$export$3a89f8d6f6bf6c9f)(this[2], other[2], t);
        return this;
    }
    equals(other) {
        return other != undefined && other[0] == this[0] && other[1] == this[1] && other[2] == this[2];
    }
    /** Alias for [0]. */ get x() {
        return this[0];
    }
    set x(value) {
        this[0] = value;
    }
    /** Alias for [1] */ get y() {
        return this[1];
    }
    set y(value) {
        this[1] = value;
    }
    /** Alias for [2] */ get z() {
        return this[2];
    }
    set z(value) {
        this[2] = value;
    }
    /**
   * The magnitude (length) of this vector.
   * Changing it does not change the direction.
   */ get magnitude() {
        return Math.sqrt(this[0] * this[0] + this[1] * this[1] + this[2] * this[2]) || 0;
    }
    set magnitude(value) {
        if (this[0] !== 0 || this[1] !== 0 || this[2] !== 0) this.imul(value / this.magnitude);
    }
    /**
   * The squared magnitude (length) of this vector.
   * Faster than magnitude when you only need to compare distances.
   */ get squaredMagnitude() {
        return this[0] * this[0] + this[1] * this[1] + this[2] * this[2];
    }
    /**
   * Returns the cross product of this and another 3D vector.
   */ cross(other) {
        return this.clone().icross(other);
    }
    /** (In Place) Cross product of this vector with another 3D vector. */ icross(other) {
        const x = this[0];
        const y = this[1];
        const z = this[2];
        this[0] = y * other[2] - z * other[1];
        this[1] = z * other[0] - x * other[2];
        this[2] = x * other[1] - y * other[0];
        return this;
    }
    /** Returns the distance from this point to another point. */ distanceTo(other) {
        const dx = other[0] - this[0];
        const dy = other[1] - this[1];
        const dz = other[2] - this[2];
        return Math.sqrt(dx * dx + dy * dy + dz * dz);
    }
    /** Returns the squared distance from this point to another point. Faster than distanceTo. */ squaredDistanceTo(other) {
        const dx = other[0] - this[0];
        const dy = other[1] - this[1];
        const dz = other[2] - this[2];
        return dx * dx + dy * dy + dz * dz;
    }
    /** Returns this vector reflected across a normal. */ reflect(normal) {
        return this.clone().ireflect(normal);
    }
    /** (In Place) Reflects this vector across a normal. */ ireflect(normal) {
        const d = 2 * this.dot(normal);
        this[0] -= normal[0] * d;
        this[1] -= normal[1] * d;
        this[2] -= normal[2] * d;
        return this;
    }
    /** Returns the negation of this vector. */ negate() {
        return this.clone().inegate();
    }
    /** (In Place) Negates this vector. */ inegate() {
        this[0] = -this[0];
        this[1] = -this[1];
        this[2] = -this[2];
        return this;
    }
    /** Return the result of dividing this vector by a scalar. */ div(scalar) {
        return this.clone().idiv(scalar);
    }
    /** (In Place) Divides this vector by a scalar. */ idiv(scalar) {
        this[0] /= scalar;
        this[1] /= scalar;
        this[2] /= scalar;
        return this;
    }
    /** Returns a new V2d containing the x and y components of this vector, dropping z. */ toV2d() {
        return new (0, $6b6a54a072724620$export$19606695c7c6ab3a)(this[0], this[1]);
    }
}


function $2172aedd5a25ff17$export$8a63f25cc62965f1(...values) {
    return values.reduce((acc, val)=>acc + val, 0);
}
function $2172aedd5a25ff17$export$842a2cf37af977e1(a, b) {
    return (a % b + b) % b;
}
function $2172aedd5a25ff17$export$f982906e4d317fcc(value) {
    return Math.max(value, 0);
}
function $2172aedd5a25ff17$export$7d15b64cf5a3a4c4(value, min = 0, max = 1) {
    return Math.max(min, Math.min(max, value));
}
function $2172aedd5a25ff17$export$56196e15071099de(t) {
    t = $2172aedd5a25ff17$export$7d15b64cf5a3a4c4(t);
    return 3 * t ** 2 - 2 * t ** 3;
}
function $2172aedd5a25ff17$export$92900799e793e1cd(t) {
    t = $2172aedd5a25ff17$export$7d15b64cf5a3a4c4(t);
    return 6 * t ** 5 - 15 * t ** 4 + 10 * t ** 3;
}
function $2172aedd5a25ff17$export$3a89f8d6f6bf6c9f(a, b, t = 0.5) {
    return (1 - t) * a + t * b;
}
function $2172aedd5a25ff17$export$4444e85a8e8eb4d3(a, b, value) {
    return (value - a) / (b - a);
}
function $2172aedd5a25ff17$export$249619bf5c02b900(a, b, t = 0.5) {
    const x = $2172aedd5a25ff17$export$3a89f8d6f6bf6c9f(a[0], b[0], t);
    const y = $2172aedd5a25ff17$export$3a89f8d6f6bf6c9f(a[1], b[1], t);
    return (0, $6b6a54a072724620$export$e7c866399fa523f5)(x, y);
}
function $2172aedd5a25ff17$export$a790e375ceecf689(a, b, t = 0.5) {
    const x = $2172aedd5a25ff17$export$3a89f8d6f6bf6c9f(a[0], b[0], t);
    const y = $2172aedd5a25ff17$export$3a89f8d6f6bf6c9f(a[1], b[1], t);
    const z = $2172aedd5a25ff17$export$3a89f8d6f6bf6c9f(a[2], b[2], t);
    return (0, $3480ec8c2fb5ff20$export$d2aa6c54a5925f01)(x, y, z);
}
function $2172aedd5a25ff17$export$e4d952dcf42a5ff5(a, b, t = 0.5, threshold = 0.01) {
    if (Math.abs(b - a) < threshold) return b;
    return $2172aedd5a25ff17$export$3a89f8d6f6bf6c9f(a, b, t);
}
function $2172aedd5a25ff17$export$e3df76cf4464bc81(angle) {
    return $2172aedd5a25ff17$export$842a2cf37af977e1(angle + Math.PI, Math.PI * 2) - Math.PI;
}
function $2172aedd5a25ff17$export$ff5848069bdbaf5a(a, b) {
    return $2172aedd5a25ff17$export$842a2cf37af977e1(b - a + Math.PI, Math.PI * 2) - Math.PI;
}
function $2172aedd5a25ff17$export$e6bfdeff8bfc94f9(degrees) {
    return degrees * Math.PI / 180;
}
function $2172aedd5a25ff17$export$54390e3b44c4a9cb(radians) {
    return radians * 180 / Math.PI;
}
function $2172aedd5a25ff17$export$33ee1f58d7bb6e30(theta) {
    return $2172aedd5a25ff17$export$e3df76cf4464bc81(Math.PI - theta);
}
function $2172aedd5a25ff17$export$f20e6a45c2713c2c(theta) {
    return $2172aedd5a25ff17$export$e3df76cf4464bc81(-theta);
}
function $2172aedd5a25ff17$export$d429e27eb9ce77d1(theta) {
    return $2172aedd5a25ff17$export$e3df76cf4464bc81(theta - Math.PI);
}
function $2172aedd5a25ff17$export$240e5320db1c20ee(theta, r) {
    return (0, $6b6a54a072724620$export$e7c866399fa523f5)(r * Math.cos(theta), r * Math.sin(theta));
}
function $2172aedd5a25ff17$export$d9385b944d276332(points) {
    let total = 0;
    for(let i = 1; i < points.length; i++){
        const [x1, y1] = points[i - 1];
        const [x2, y2] = points[i];
        total += (x2 - x1) * (y2 + y1);
    }
    return total > 0;
}
function $2172aedd5a25ff17$export$b26f3c29b28fecef(from, to, stepSize) {
    if (from < to) return Math.min(from + stepSize, to);
    else return Math.max(from - stepSize, to);
}


function $6b6a54a072724620$export$e7c866399fa523f5(x, y) {
    if (x instanceof $6b6a54a072724620$export$19606695c7c6ab3a) return x.clone();
    else if (x instanceof Array || x instanceof Float32Array || x instanceof Float64Array) return new $6b6a54a072724620$export$19606695c7c6ab3a(x[0], x[1]);
    else if (typeof x === "object") // object with x, y properties
    return new $6b6a54a072724620$export$19606695c7c6ab3a(x.x, x.y);
    return new $6b6a54a072724620$export$19606695c7c6ab3a(x ?? 0, y ?? x ?? 0);
}
class $6b6a54a072724620$export$19606695c7c6ab3a extends Array {
    constructor(x, y){
        super(), this.length = 2;
        if (isNaN(x) || isNaN(y)) throw new Error(`Can't make a V2d with NaN ${x},${y}`);
        this[0] = x;
        this[1] = y;
    }
    static fromPolar(radius, theta) {
        return new $6b6a54a072724620$export$19606695c7c6ab3a(radius * Math.cos(theta), radius * Math.sin(theta));
    }
    get v() {
        return this;
    }
    /** Return the result of adding this vector to another. */ add(other) {
        return this.clone().iadd(other);
    }
    /** (In Place) Return the result of adding this vector to another. */ iadd(other) {
        this[0] += other[0];
        this[1] += other[1];
        return this;
    }
    /** Return the result of multiplying a scalar by another vector and adding it to this. */ addScaled(other, scale) {
        return this.clone().iaddScaled(other, scale);
    }
    /** (In Place) Return the result of multiplying a scalar by another vector and adding it to this. */ iaddScaled(other, scale = 1) {
        this[0] += other[0] * scale;
        this[1] += other[1] * scale;
        return this;
    }
    /** Return the result of subtracting a vector from this one. */ sub(other) {
        return this.clone().isub(other);
    }
    /** (In Place) Return the result of subtracting a vector from this one. */ isub(other) {
        this[0] -= other[0];
        this[1] -= other[1];
        return this;
    }
    /** Return the result of multiplying this vector by a scalar. */ mul(scalar) {
        return this.clone().imul(scalar);
    }
    /** (In Place) Return the result of multiplying this vector by a scalar. */ imul(scalar) {
        this[0] *= scalar;
        this[1] *= scalar;
        return this;
    }
    /** Return the result of multiplying this vector by another vector componentwise. */ mulComponent(other) {
        return this.clone().imulComponent(other);
    }
    /** (In Place) Return the result of multiplying this vector by another vector componentwise. */ imulComponent(other) {
        this[0] *= other[0];
        this[1] *= other[1];
        return this;
    }
    /** Returns the result of rotating this vector 90 decgrees clockwise */ rotate90cw() {
        return new $6b6a54a072724620$export$19606695c7c6ab3a(this[1], -this[0]);
    }
    /** (In Place) Returns the result of rotating this vector 90 decgrees clockwise */ irotate90cw() {
        [this[0], this[1]] = [
            this[1],
            -this[0]
        ];
        return this;
    }
    /** Returns the result of rotating this vector 90 decgrees counter-clockwise */ rotate90ccw() {
        return new $6b6a54a072724620$export$19606695c7c6ab3a(-this[1], this[0]);
    }
    /** (In Place) Returns the result of rotating this vector 90 decgrees counter-clockwise */ irotate90ccw() {
        [this[0], this[1]] = [
            -this[1],
            this[0]
        ];
        return this;
    }
    /** Return the result of rotating this angle by `angle` radians ccw. */ rotate(angle) {
        return this.clone().irotate(angle);
    }
    /** (In Place) Return the result of rotating this angle by `angle` radians ccw. */ irotate(angle) {
        const cos = Math.cos(angle);
        const sin = Math.sin(angle);
        const x = this[0];
        const y = this[1];
        this[0] = cos * x - sin * y;
        this[1] = sin * x + cos * y;
        return this;
    }
    /** Return the dot product of this and another vector */ dot(other) {
        return this[0] * other[0] + this[1] * other[1];
    }
    set(x, y) {
        if (typeof x === "number") {
            this[0] = x;
            this[1] = y;
        } else {
            this[0] = x[0];
            this[1] = x[1];
        }
        return this;
    }
    /** Return a normalized version of this vector */ normalize(length = 1) {
        return this.clone().inormalize(length);
    }
    /** (In Place) Return a normalized version of this vector */ inormalize(length = 1) {
        if (!(this[0] === 0 && this[1] === 0)) this.magnitude = length;
        return this;
    }
    /**
   * Returns a new vector with magnitude limited to the specified maximum.
   * If current magnitude is less than max, returns unchanged vector.
   * @param max - Maximum allowed magnitude
   * @returns New vector with limited magnitude
   */ limit(max) {
        return this.clone().ilimit(max);
    }
    /**
   * (In-place) Limits this vector's magnitude to the specified maximum.
   * If current magnitude is less than max, vector remains unchanged.
   * @param max - Maximum allowed magnitude
   * @returns This vector for method chaining
   */ ilimit(max) {
        if (this.magnitude > max) this.magnitude = max;
        return this;
    }
    /** Return a new vector with the same values as this one */ clone() {
        return new $6b6a54a072724620$export$19606695c7c6ab3a(this[0], this[1]);
    }
    /** Return a vector that is between this and other */ lerp(other, t = 0) {
        return this.clone().ilerp(other, t);
    }
    /** (In place) Return a vector that is between this and other */ ilerp(other, t = 0) {
        this[0] = (0, $2172aedd5a25ff17$export$3a89f8d6f6bf6c9f)(this[0], other[0], t);
        this[1] = (0, $2172aedd5a25ff17$export$3a89f8d6f6bf6c9f)(this[1], other[1], t);
        return this;
    }
    equals(other) {
        return other != undefined && other[0] == this[0] && other[1] == this[1];
    }
    /** Alias for [0]. */ get x() {
        return this[0];
    }
    set x(value) {
        this[0] = value;
    }
    /** Alias for [1] */ get y() {
        return this[1];
    }
    set y(value) {
        this[1] = value;
    }
    /**
   * The magnitude (length) of this vector.
   * Changing it does not change the angle.
   */ get magnitude() {
        return Math.sqrt(this[0] * this[0] + this[1] * this[1]) || 0;
    }
    set magnitude(value) {
        if (this[0] !== 0 || this[1] !== 0) this.imul(value / this.magnitude);
    }
    /**
   * The angle in radians ccw from east of this vector.
   * Changing it does not change the magnitude.
   */ get angle() {
        return Math.atan2(this[1], this[0]);
    }
    set angle(value) {
        this.irotate(value - this.angle);
    }
    /**
   * The squared magnitude (length) of this vector.
   * Faster than magnitude when you only need to compare distances.
   */ get squaredMagnitude() {
        return this[0] * this[0] + this[1] * this[1];
    }
    /**
   * Returns the z-component of the cross product of this and another 2D vector.
   * This is equivalent to the signed area of the parallelogram formed by the two vectors.
   */ crossLength(other) {
        return this[0] * other[1] - this[1] * other[0];
    }
    /**
   * Cross product of this vector with a z-component scalar.
   * Rotates 90 degrees clockwise and scales by zcomp.
   */ crossVZ(zcomp) {
        return this.clone().icrossVZ(zcomp);
    }
    /** (In Place) Cross product of this vector with a z-component scalar. */ icrossVZ(zcomp) {
        const x = this[0];
        const y = this[1];
        this[0] = y * zcomp;
        this[1] = -x * zcomp;
        return this;
    }
    /**
   * Cross product of a z-component scalar with this vector.
   * Rotates 90 degrees counter-clockwise and scales by zcomp.
   */ crossZV(zcomp) {
        return this.clone().icrossZV(zcomp);
    }
    /** (In Place) Cross product of a z-component scalar with this vector. */ icrossZV(zcomp) {
        const x = this[0];
        const y = this[1];
        this[0] = -y * zcomp;
        this[1] = x * zcomp;
        return this;
    }
    /** Returns the distance from this point to another point. */ distanceTo(other) {
        const dx = other[0] - this[0];
        const dy = other[1] - this[1];
        return Math.sqrt(dx * dx + dy * dy);
    }
    /** Returns the squared distance from this point to another point. Faster than distanceTo. */ squaredDistanceTo(other) {
        const dx = other[0] - this[0];
        const dy = other[1] - this[1];
        return dx * dx + dy * dy;
    }
    /** Returns this vector reflected across a normal. */ reflect(normal) {
        return this.clone().ireflect(normal);
    }
    /** (In Place) Reflects this vector across a normal. */ ireflect(normal) {
        const d = 2 * this.dot(normal);
        this[0] -= normal[0] * d;
        this[1] -= normal[1] * d;
        return this;
    }
    /** Returns the negation of this vector. */ negate() {
        return this.clone().inegate();
    }
    /** (In Place) Negates this vector. */ inegate() {
        this[0] = -this[0];
        this[1] = -this[1];
        return this;
    }
    /** Return the result of dividing this vector by a scalar. */ div(scalar) {
        return this.clone().idiv(scalar);
    }
    /** (In Place) Divides this vector by a scalar. */ idiv(scalar) {
        this[0] /= scalar;
        this[1] /= scalar;
        return this;
    }
    /** Transform this world point to a local frame defined by position and angle. */ toLocalFrame(framePosition, frameAngle) {
        return this.clone().itoLocalFrame(framePosition, frameAngle);
    }
    /** (In Place) Transform this world point to a local frame. */ itoLocalFrame(framePosition, frameAngle) {
        return this.isub(framePosition).irotate(-frameAngle);
    }
    /** Transform this local point to world frame defined by position and angle. */ toGlobalFrame(framePosition, frameAngle) {
        return this.clone().itoGlobalFrame(framePosition, frameAngle);
    }
    /** (In Place) Transform this local point to world frame. */ itoGlobalFrame(framePosition, frameAngle) {
        return this.irotate(frameAngle).iadd(framePosition);
    }
    // Static utility methods
    /** Returns the intersection point of two line segments, or null if they don't intersect. */ static lineSegmentsIntersection(p0, p1, p2, p3) {
        const t = $6b6a54a072724620$export$19606695c7c6ab3a.lineSegmentsIntersectionFraction(p0, p1, p2, p3);
        if (t < 0) return null;
        return new $6b6a54a072724620$export$19606695c7c6ab3a(p0[0] + t * (p1[0] - p0[0]), p0[1] + t * (p1[1] - p0[1]));
    }
    /**
   * Returns the intersection fraction (0-1) along the first line segment,
   * or -1 if the segments don't intersect.
   */ static lineSegmentsIntersectionFraction(p0, p1, p2, p3) {
        const s1_x = p1[0] - p0[0];
        const s1_y = p1[1] - p0[1];
        const s2_x = p3[0] - p2[0];
        const s2_y = p3[1] - p2[1];
        const denom = -s2_x * s1_y + s1_x * s2_y;
        if (denom === 0) return -1; // Parallel lines
        const s = (-s1_y * (p0[0] - p2[0]) + s1_x * (p0[1] - p2[1])) / denom;
        const t = (s2_x * (p0[1] - p2[1]) - s2_y * (p0[0] - p2[0])) / denom;
        if (s >= 0 && s <= 1 && t >= 0 && t <= 1) return t;
        return -1;
    }
    /** Returns the centroid of a triangle defined by three points. */ static centroid(a, b, c) {
        return new $6b6a54a072724620$export$19606695c7c6ab3a((a[0] + b[0] + c[0]) / 3, (a[1] + b[1] + c[1]) / 3);
    }
}






class $dd0ee6ed41f5ec2f$export$8ec70f2db73b49aa {
    constructor(options = {}){
        this.lowerBound = (0, $6b6a54a072724620$export$e7c866399fa523f5)();
        if (options.lowerBound) this.lowerBound.set(options.lowerBound);
        this.upperBound = (0, $6b6a54a072724620$export$e7c866399fa523f5)();
        if (options.upperBound) this.upperBound.set(options.upperBound);
    }
    /** Set the AABB bounds from a set of points, transformed by the given position and angle. */ setFromPoints(points, position, angle = 0, skinSize = 0) {
        const l = this.lowerBound;
        const u = this.upperBound;
        // Set to the first point
        if (angle !== 0) l.set(points[0]).irotate(angle);
        else l.set(points[0]);
        u.set(l);
        // Compute cosines and sines just once
        const cosAngle = Math.cos(angle);
        const sinAngle = Math.sin(angle);
        for(let i = 1; i < points.length; i++){
            let p = points[i];
            if (angle !== 0) {
                const x = p[0];
                const y = p[1];
                const rotated = (0, $6b6a54a072724620$export$e7c866399fa523f5)(cosAngle * x - sinAngle * y, sinAngle * x + cosAngle * y);
                p = rotated;
            }
            if (p[0] > u[0]) u[0] = p[0];
            if (p[1] > u[1]) u[1] = p[1];
            if (p[0] < l[0]) l[0] = p[0];
            if (p[1] < l[1]) l[1] = p[1];
        }
        // Add offset
        if (position) {
            this.lowerBound.iadd(position);
            this.upperBound.iadd(position);
        }
        if (skinSize) {
            this.lowerBound[0] -= skinSize;
            this.lowerBound[1] -= skinSize;
            this.upperBound[0] += skinSize;
            this.upperBound[1] += skinSize;
        }
        return this;
    }
    /** Copy bounds from an AABB to this AABB */ copy(aabb) {
        this.lowerBound.set(aabb.lowerBound);
        this.upperBound.set(aabb.upperBound);
        return this;
    }
    /** Extend this AABB so that it covers the given AABB too. */ extend(aabb) {
        for(let i = 1; i >= 0; i--){
            // Extend lower bound
            const l = aabb.lowerBound[i];
            if (this.lowerBound[i] > l) this.lowerBound[i] = l;
            // Upper
            const u = aabb.upperBound[i];
            if (this.upperBound[i] < u) this.upperBound[i] = u;
        }
        return this;
    }
    /** Returns true if the given AABB overlaps this AABB. */ overlaps(aabb) {
        const l1 = this.lowerBound;
        const u1 = this.upperBound;
        const l2 = aabb.lowerBound;
        const u2 = aabb.upperBound;
        return (l2[0] <= u1[0] && u1[0] <= u2[0] || l1[0] <= u2[0] && u2[0] <= u1[0]) && (l2[1] <= u1[1] && u1[1] <= u2[1] || l1[1] <= u2[1] && u2[1] <= u1[1]);
    }
    /** Check if this AABB contains the given point */ containsPoint(point) {
        const l = this.lowerBound;
        const u = this.upperBound;
        return l[0] <= point[0] && point[0] <= u[0] && l[1] <= point[1] && point[1] <= u[1];
    }
    /**
   * Check if the AABB is hit by a ray.
   * @returns -1 if no hit, a number between 0 and 1 if hit.
   */ overlapsRay(ray) {
        // ray.direction is unit direction vector of ray
        const dirFracX = 1 / ray.direction[0];
        const dirFracY = 1 / ray.direction[1];
        // this.lowerBound is the corner of AABB with minimal coordinates - left bottom, rt is maximal corner
        const t1 = (this.lowerBound[0] - ray.from[0]) * dirFracX;
        const t2 = (this.upperBound[0] - ray.from[0]) * dirFracX;
        const t3 = (this.lowerBound[1] - ray.from[1]) * dirFracY;
        const t4 = (this.upperBound[1] - ray.from[1]) * dirFracY;
        const tmin = Math.max(Math.min(t1, t2), Math.min(t3, t4));
        const tmax = Math.min(Math.max(t1, t2), Math.max(t3, t4));
        // if tmax < 0, ray (line) is intersecting AABB, but whole AABB is behind us
        if (tmax < 0) return -1;
        // if tmin > tmax, ray doesn't intersect AABB
        if (tmin > tmax) return -1;
        return tmin;
    }
}


/**
 * Event object passed to listeners
 */ class $6c2df9ba61f1f24d$export$4fae95256245c8c0 {
    /**
   * Add an event listener
   * @param type Event type
   * @param listener Callback function
   * @param context Optional context to bind the listener to
   * @returns The self object, for chainability.
   */ on(type, listener, context) {
        const stored = listener;
        stored.context = context ?? this;
        if (this._listeners === undefined) this._listeners = {};
        const listeners = this._listeners;
        if (listeners[type] === undefined) listeners[type] = [];
        const typeListeners = listeners[type];
        if (typeListeners.indexOf(stored) === -1) typeListeners.push(stored);
        return this;
    }
    /**
   * Check if an event listener is added
   * @param type Event type
   * @param listener Optional specific listener to check for
   * @returns True if listener(s) exist for the type
   */ has(type, listener) {
        const typeListeners = this._listeners?.[type];
        if (!typeListeners) return false;
        if (listener) return typeListeners.indexOf(listener) !== -1;
        return true;
    }
    /**
   * Remove an event listener
   * @param type Event type
   * @param listener The listener to remove
   * @returns The self object, for chainability.
   */ off(type, listener) {
        const typeListeners = this._listeners?.[type];
        if (typeListeners) {
            const index = typeListeners.indexOf(listener);
            if (index !== -1) typeListeners.splice(index, 1);
        }
        return this;
    }
    /**
   * Emit an event.
   * @param event The event object to emit
   * @returns The self object, for chainability.
   */ emit(event) {
        const listenerArray = this._listeners?.[event.type];
        if (listenerArray) {
            event.target = this;
            for (const listener of listenerArray)listener.call(listener.context, event);
        }
        return this;
    }
}



class $970bf599a9c225a4$export$22c052d9a14d44c {
    constructor(config){
        this._sleepState = (0, $8793a8b9f94904cc$export$6593f13021cce3f9).AWAKE;
        this._wantsToSleep = false;
        /** Time spent below sleep speed limit. */ this.idleTime = 0;
        /** @internal */ this.timeLastSleepy = 0;
        this._allowSleep = config.allowSleep;
        this._sleepSpeedLimit = config.sleepSpeedLimit;
        this._sleepTimeLimit = config.sleepTimeLimit;
    }
    /** Current sleep state. */ get sleepState() {
        return this._sleepState;
    }
    /** Whether this body is allowed to sleep. */ get allowSleep() {
        return this._allowSleep;
    }
    /** Speed threshold below which body becomes sleepy. */ get sleepSpeedLimit() {
        return this._sleepSpeedLimit;
    }
    /** @internal True if body is ready to sleep (used for island sleeping). */ get wantsToSleep() {
        return this._wantsToSleep;
    }
    /** Returns true if the body is currently sleeping. */ isSleeping() {
        return this._sleepState === (0, $8793a8b9f94904cc$export$6593f13021cce3f9).SLEEPING;
    }
    /** Returns true if the body is currently awake. */ isAwake() {
        return this._sleepState === (0, $8793a8b9f94904cc$export$6593f13021cce3f9).AWAKE;
    }
    /**
   * Wake the body up.
   * @param body - The host body (for event emission and world notification)
   */ wakeUp(body) {
        if (!this.isAwake()) {
            this._sleepState = (0, $8793a8b9f94904cc$export$6593f13021cce3f9).AWAKE;
            this.idleTime = 0;
            body.world?.bodies.onSleepStateChanged(body);
            body.emit({
                type: "wakeup",
                body: body
            });
        }
    }
    /**
   * Force body to sleep.
   * @param body - The host body (for velocity clearing and event emission)
   */ sleep(body) {
        this._sleepState = (0, $8793a8b9f94904cc$export$6593f13021cce3f9).SLEEPING;
        body.angularVelocity = 0;
        body.angularForce = 0;
        body.velocity.set(0, 0);
        body.force.set(0, 0);
        body.world?.bodies.onSleepStateChanged(body);
        body.emit({
            type: "sleep",
            body: body
        });
    }
    /**
   * Called every timestep to update internal sleep timer and change sleep state if needed.
   * @param body - The host body (for velocity reading)
   * @param time - Current simulation time (unused but kept for API compat)
   * @param dontSleep - If true, don't actually sleep, just set wantsToSleep
   * @param dt - Time step
   */ sleepTick(body, time, dontSleep, dt) {
        if (!this._allowSleep || this._sleepState === (0, $8793a8b9f94904cc$export$6593f13021cce3f9).SLEEPING) return;
        this._wantsToSleep = false;
        const speedSquared = body.velocity.squaredMagnitude + Math.pow(body.angularVelocity, 2);
        const speedLimitSquared = Math.pow(this._sleepSpeedLimit, 2);
        if (speedSquared >= speedLimitSquared) {
            this.idleTime = 0;
            this._sleepState = (0, $8793a8b9f94904cc$export$6593f13021cce3f9).AWAKE;
        } else {
            this.idleTime += dt;
            this._sleepState = (0, $8793a8b9f94904cc$export$6593f13021cce3f9).SLEEPY;
        }
        if (this.idleTime > this._sleepTimeLimit) {
            if (!dontSleep) this.sleep(body);
            else this._wantsToSleep = true;
        }
    }
}



function $1e37aa1a6c2e96e3$export$a41f76e09f6b89bb(body) {
    const shapes = body.shapes;
    const N = shapes.length;
    const bodyAngle = body.angle;
    for(let i = 0; i !== N; i++){
        const shape = shapes[i];
        const angle = shape.angle + bodyAngle;
        const offset = (0, $6b6a54a072724620$export$e7c866399fa523f5)(shape.position);
        offset.irotate(bodyAngle);
        offset.iadd(body.position);
        const aabb = shape.computeAABB(offset, angle);
        if (i === 0) body.aabb.copy(aabb);
        else body.aabb.extend(aabb);
    }
    body.aabbNeedsUpdate = false;
}


/**
 * Compute `(1 - damping) ^ dt` with damping clamped to [0, 1].
 *
 * Unclamped damping is a NaN risk: `Math.pow(negative, non-integer)` is NaN,
 * so a rogue `body.damping = 1.5` would produce NaN velocities on the very
 * next step. Clamping here makes damping robust against bad game-code input
 * without silently hiding the bug elsewhere.
 */ function $68b8ececbe2239df$var$dampingFactor(damping, dt) {
    if (damping <= 0) return 1;
    if (damping >= 1) return 0;
    return Math.pow(1 - damping, dt);
}
function $68b8ececbe2239df$export$df7e1ba7d171fdbd(body, dt) {
    const f = $68b8ececbe2239df$var$dampingFactor(body.damping, dt);
    body.velocity.x *= f;
    body.velocity.y *= f;
}
function $68b8ececbe2239df$export$535e8b47fdd462b8(body, dt) {
    const lf = $68b8ececbe2239df$var$dampingFactor(body.damping, dt);
    body.velocity.x *= lf;
    body.velocity.y *= lf;
    body.angularVelocity3[2] *= $68b8ececbe2239df$var$dampingFactor(body.angularDamping, dt);
}
function $68b8ececbe2239df$export$f32aecaf3c45006b(body, dt) {
    const lf = $68b8ececbe2239df$var$dampingFactor(body.damping, dt);
    body.velocity.x *= lf;
    body.velocity.y *= lf;
    body.zVelocity *= $68b8ececbe2239df$var$dampingFactor(body.zDamping, dt);
}
function $68b8ececbe2239df$export$3d3c8ef379ec480a(body, dt) {
    const lf = $68b8ececbe2239df$var$dampingFactor(body.damping, dt);
    body.velocity.x *= lf;
    body.velocity.y *= lf;
    body.zVelocity *= $68b8ececbe2239df$var$dampingFactor(body.zDamping, dt);
    const rpDamp = $68b8ececbe2239df$var$dampingFactor(body.rollPitchDamping, dt);
    body.angularVelocity3[0] *= rpDamp;
    body.angularVelocity3[1] *= rpDamp;
    body.angularVelocity3[2] *= $68b8ececbe2239df$var$dampingFactor(body.angularDamping, dt);
}
function $68b8ececbe2239df$export$da1fe76f9b6a25f(bodies, dt) {
    for (const body of bodies){
        if (body.motion !== "dynamic") continue;
        switch(body.shape){
            case "pm2d":
                $68b8ececbe2239df$export$df7e1ba7d171fdbd(body, dt);
                break;
            case "rigid2d":
                $68b8ececbe2239df$export$535e8b47fdd462b8(body, dt);
                break;
            case "pm3d":
                $68b8ececbe2239df$export$f32aecaf3c45006b(body, dt);
                break;
            case "rigid3d":
                $68b8ececbe2239df$export$3d3c8ef379ec480a(body, dt);
                break;
        }
    }
}


function $ab1a75484f40dd41$export$da81038170e85b8c(body, force, relativeWorldPoint) {
    if (!isFinite(force.x) || !isFinite(force.y)) {
        console.trace(`applyForce NaN on body "${body.id}":`, force.x, force.y);
        return;
    }
    body.force.iadd(force);
    if (relativeWorldPoint && (body.shape === "rigid2d" || body.shape === "rigid3d")) {
        const rotForce = relativeWorldPoint.crossLength(force);
        body.angularForce3[2] += rotForce;
    }
}
function $ab1a75484f40dd41$export$ab54d956780e55d5(body, localForce, localPoint) {
    const worldForce = body.vectorToWorldFrame(localForce);
    const worldPoint = localPoint ? body.vectorToWorldFrame(localPoint) : undefined;
    $ab1a75484f40dd41$export$da81038170e85b8c(body, worldForce, worldPoint);
}
function $ab1a75484f40dd41$export$87842afadc15cca2(body, fxOrForce, fyOrLocalPoint, fzArg, localXArg, localYArg, localZArg) {
    let fx, fy, fz;
    let localX, localY, localZ;
    if (typeof fxOrForce === "number") {
        fx = fxOrForce;
        fy = fyOrLocalPoint;
        fz = fzArg;
        localX = localXArg;
        localY = localYArg;
        localZ = localZArg;
    } else {
        fx = fxOrForce[0];
        fy = fxOrForce[1];
        fz = fxOrForce[2];
        const lp = fyOrLocalPoint;
        localX = lp[0];
        localY = lp[1];
        localZ = lp[2];
    }
    if (!isFinite(fx) || !isFinite(fy) || !isFinite(fz) || !isFinite(localX) || !isFinite(localY) || !isFinite(localZ)) {
        console.trace(`applyForce3D NaN on body "${body.id}":`, {
            fx: fx,
            fy: fy,
            fz: fz,
            localX: localX,
            localY: localY,
            localZ: localZ
        });
        return;
    }
    body.force.x += fx;
    body.force.y += fy;
    body.zForce += fz;
    const R = body.orientation;
    const rx = R[0] * localX + R[1] * localY + R[2] * localZ;
    const ry = R[3] * localX + R[4] * localY + R[5] * localZ;
    const rz = R[6] * localX + R[7] * localY + R[8] * localZ;
    // τ = r × F (world frame)
    body.angularForce3[0] += ry * fz - rz * fy;
    body.angularForce3[1] += rz * fx - rx * fz;
    body.angularForce3[2] += rx * fy - ry * fx;
}
function $ab1a75484f40dd41$export$56a1f0332a3583db(body, impulse, relativeWorldPoint) {
    body.velocity.x += impulse.x * body.invMass;
    body.velocity.y += impulse.y * body.invMass;
    if (relativeWorldPoint && (body.shape === "rigid2d" || body.shape === "rigid3d")) {
        const rotVelo = relativeWorldPoint.crossLength(impulse) * body.invInertia;
        body.angularVelocity3[2] += rotVelo;
    }
}
function $ab1a75484f40dd41$export$bec7df03941ad93d(body, localImpulse, localPoint) {
    const worldImpulse = body.vectorToWorldFrame(localImpulse);
    const worldPoint = localPoint ? body.vectorToWorldFrame(localPoint) : undefined;
    $ab1a75484f40dd41$export$56a1f0332a3583db(body, worldImpulse, worldPoint);
}
function $ab1a75484f40dd41$export$e81daad8c0a35a92(body) {
    body.force.x = 0;
    body.force.y = 0;
    body.angularForce3[0] = 0;
    body.angularForce3[1] = 0;
    body.angularForce3[2] = 0;
    body.zForce = 0;
}



function $8ce7dcb8aad6bd19$export$12988264671ae4af(body, self, config, world, dt) {
    // Early exit if CCD disabled or velocity below threshold
    if (config.ccdSpeedThreshold < 0 || body.velocity.squaredMagnitude < Math.pow(config.ccdSpeedThreshold, 2)) return false;
    const direction = (0, $6b6a54a072724620$export$e7c866399fa523f5)(body.velocity);
    direction.inormalize();
    const end = (0, $6b6a54a072724620$export$e7c866399fa523f5)(body.velocity);
    end.imul(dt);
    end.iadd(body.position);
    const startToEnd = (0, $6b6a54a072724620$export$e7c866399fa523f5)(end);
    startToEnd.isub(body.position);
    const startToEndAngle = body.angularVelocity * dt;
    const len = startToEnd.magnitude;
    // Degenerate case: start == end (zero travel distance despite velocity
    // above threshold — e.g. dt is 0). Nothing to detect, skip CCD.
    if (len === 0) return false;
    let timeOfImpact = 1;
    // Raycast to find potential collision (exclude self)
    const raycastHit = world.raycast(body.position, end, {
        filter: (b)=>b !== self
    });
    if (!raycastHit) return false;
    // Update end point and time of impact based on hit
    end.set(raycastHit.point);
    startToEnd.set(end).isub(body.position);
    timeOfImpact = startToEnd.magnitude / len;
    const hitBody = raycastHit.body;
    const rememberAngle = body.angle;
    const rememberPosition = (0, $6b6a54a072724620$export$e7c866399fa523f5)(body.position);
    // Binary search for time of impact
    let iter = 0;
    let tmin = 0;
    let tmid = 0;
    let tmax = timeOfImpact;
    while(tmax >= tmin && iter < config.ccdIterations){
        iter++;
        tmid = (tmax + tmin) / 2;
        const velodt = (0, $6b6a54a072724620$export$e7c866399fa523f5)(startToEnd);
        velodt.imul(tmid);
        body.position.set(rememberPosition).iadd(velodt);
        body.angle = rememberAngle + startToEndAngle * tmid;
        body.updateAABB();
        const overlaps = body.aabb.overlaps(hitBody.aabb) && world.overlapKeeper.bodiesAreOverlapping(self, hitBody);
        if (overlaps) tmin = tmid;
        else tmax = tmid;
    }
    timeOfImpact = tmid;
    // Restore position/angle
    body.position.set(rememberPosition);
    body.angle = rememberAngle;
    // Move to TOI
    const velodt = (0, $6b6a54a072724620$export$e7c866399fa523f5)(startToEnd);
    velodt.imul(timeOfImpact);
    body.position.iadd(velodt);
    if (!body.fixedRotation) body.angle += startToEndAngle * timeOfImpact;
    return true;
}




// Module-level scratch CCD config so `integratePosition` doesn't allocate an
// options object on every body every substep when CCD is enabled. CCD runs
// synchronously within a single body's integration; reuse is safe.
const $063e11872313d4b3$var$ccdConfigScratch = {
    ccdSpeedThreshold: 0,
    ccdIterations: 0,
    set (threshold, iterations) {
        this.ccdSpeedThreshold = threshold;
        this.ccdIterations = iterations;
        return this;
    }
};
// Adapter shim so the existing `integrateToTimeOfImpact` helper — which
// expects a CCDBodyState with `fixedRotation` and `updateAABB()` — can run
// against a Body. Shape "pm2d" / "pm3d" are treated as fixedRotation.
const $063e11872313d4b3$var$ccdBodyAdapter = {
    body: null,
    get velocity () {
        return this.body.velocity;
    },
    get angularVelocity () {
        return this.body.angularVelocity;
    },
    get position () {
        return this.body.position;
    },
    set position (_v){
    /* never assigned whole — positions are mutated in place */ },
    get angle () {
        return this.body.angle;
    },
    set angle (v){
        this.body.angle = v;
    },
    get fixedRotation () {
        const s = this.body.shape;
        return s === "pm2d" || s === "pm3d";
    },
    get aabb () {
        return this.body.aabb;
    },
    updateAABB () {
        (0, $1e37aa1a6c2e96e3$export$a41f76e09f6b89bb)(this.body);
    }
};
function $063e11872313d4b3$export$d86a5ecabd82904b(body, dt) {
    const f = body.force;
    const v1 = body.velocity;
    body._skipPositionThisStep = false;
    if (!isFinite(f.x) || !isFinite(f.y)) {
        f.x = 0;
        f.y = 0;
        v1.x = 0;
        v1.y = 0;
        body._skipPositionThisStep = true;
        return;
    }
    const minv = body.invMass;
    v1.x += f.x * minv * dt;
    v1.y += f.y * minv * dt;
    if (!isFinite(v1.x) || !isFinite(v1.y)) {
        console.error(`Body "${body.id}": NaN in integrate, resetting.`);
        v1.x = 0;
        v1.y = 0;
        body._skipPositionThisStep = true;
        return;
    }
    (0, $ab1a75484f40dd41$export$e81daad8c0a35a92)(body);
}
function $063e11872313d4b3$export$283b63eae50998be(body, dt) {
    const f = body.force;
    const v1 = body.velocity;
    body._skipPositionThisStep = false;
    if (!isFinite(f.x) || !isFinite(f.y)) {
        f.x = 0;
        f.y = 0;
        v1.x = 0;
        v1.y = 0;
        body.angularVelocity3[2] = 0;
        body.angularForce3[2] = 0;
        body._skipPositionThisStep = true;
        return;
    }
    const minv = body.invMass;
    v1.x += f.x * minv * dt;
    v1.y += f.y * minv * dt;
    body.angularVelocity3[2] += body.angularForce3[2] * body.invInertia * dt;
    if (!isFinite(v1.x) || !isFinite(v1.y) || !isFinite(body.angularVelocity3[2])) {
        console.error(`Body "${body.id}": NaN in integrate, resetting.`);
        v1.x = 0;
        v1.y = 0;
        body.angularVelocity3[2] = 0;
        body._skipPositionThisStep = true;
        return;
    }
    (0, $ab1a75484f40dd41$export$e81daad8c0a35a92)(body);
}
function $063e11872313d4b3$export$87460c0791037fa0(body, dt) {
    const f = body.force;
    const v1 = body.velocity;
    body._skipPositionThisStep = false;
    if (!isFinite(f.x) || !isFinite(f.y) || !isFinite(body.zForce)) {
        f.x = 0;
        f.y = 0;
        v1.x = 0;
        v1.y = 0;
        body.zForce = 0;
        body.zVelocity = 0;
        body._skipPositionThisStep = true;
        return;
    }
    const minv = body.invMass;
    v1.x += f.x * minv * dt;
    v1.y += f.y * minv * dt;
    body.zVelocity += body.zForce * body.invZMass * dt;
    if (!isFinite(v1.x) || !isFinite(v1.y) || !isFinite(body.zVelocity)) {
        console.error(`Body "${body.id}": NaN in integrate, resetting.`);
        v1.x = 0;
        v1.y = 0;
        body.zVelocity = 0;
        body._skipPositionThisStep = true;
        return;
    }
    (0, $ab1a75484f40dd41$export$e81daad8c0a35a92)(body);
}
function $063e11872313d4b3$export$aa7816bddb426373(body, dt) {
    const f = body.force;
    const v1 = body.velocity;
    body._skipPositionThisStep = false;
    if (!isFinite(f.x) || !isFinite(f.y)) {
        f.x = 0;
        f.y = 0;
        v1.x = 0;
        v1.y = 0;
        body.angularVelocity3[0] = 0;
        body.angularVelocity3[1] = 0;
        body.angularVelocity3[2] = 0;
        body.zVelocity = 0;
        body.zForce = 0;
        body.angularForce3[0] = 0;
        body.angularForce3[1] = 0;
        body.angularForce3[2] = 0;
        body._skipPositionThisStep = true;
        return;
    }
    const minv = body.invMass;
    v1.x += f.x * minv * dt;
    v1.y += f.y * minv * dt;
    const iI = body.invWorldInertia;
    const tf = body.angularForce3;
    body.angularVelocity3[0] += (iI[0] * tf[0] + iI[1] * tf[1] + iI[2] * tf[2]) * dt;
    body.angularVelocity3[1] += (iI[3] * tf[0] + iI[4] * tf[1] + iI[5] * tf[2]) * dt;
    body.angularVelocity3[2] += (iI[6] * tf[0] + iI[7] * tf[1] + iI[8] * tf[2]) * dt;
    body.zVelocity += body.zForce * body.invZMass * dt;
    if (!isFinite(v1.x) || !isFinite(v1.y) || !isFinite(body.zVelocity) || !isFinite(body.angularVelocity3[0]) || !isFinite(body.angularVelocity3[1]) || !isFinite(body.angularVelocity3[2])) {
        console.error(`Body "${body.id}": NaN in integrate, resetting.`);
        v1.x = 0;
        v1.y = 0;
        body.zVelocity = 0;
        body.angularVelocity3[0] = 0;
        body.angularVelocity3[1] = 0;
        body.angularVelocity3[2] = 0;
        body._skipPositionThisStep = true;
        return;
    }
    (0, $ab1a75484f40dd41$export$e81daad8c0a35a92)(body);
}
function $063e11872313d4b3$export$948d9ae5e880ee82(bodies, dt) {
    for (const body of bodies){
        if (body.motion !== "dynamic") continue;
        switch(body.shape){
            case "pm2d":
                $063e11872313d4b3$export$d86a5ecabd82904b(body, dt);
                break;
            case "rigid2d":
                $063e11872313d4b3$export$283b63eae50998be(body, dt);
                break;
            case "pm3d":
                $063e11872313d4b3$export$87460c0791037fa0(body, dt);
                break;
            case "rigid3d":
                $063e11872313d4b3$export$aa7816bddb426373(body, dt);
                break;
        }
    }
}
// ─── Position integration ─────────────────────────────────────────────────
/** Attempt CCD for a 2D-moving body; returns true if CCD consumed the step. */ function $063e11872313d4b3$var$tryCCD(body, world, dt) {
    if (!world || body.ccdSpeedThreshold < 0) return false;
    $063e11872313d4b3$var$ccdBodyAdapter.body = body;
    const applied = (0, $8ce7dcb8aad6bd19$export$12988264671ae4af)($063e11872313d4b3$var$ccdBodyAdapter, body, $063e11872313d4b3$var$ccdConfigScratch.set(body.ccdSpeedThreshold, body.ccdIterations), world, dt);
    $063e11872313d4b3$var$ccdBodyAdapter.body = null;
    return applied;
}
function $063e11872313d4b3$export$de261112a6794c68(body, dt, world) {
    if (body._skipPositionThisStep) {
        body._skipPositionThisStep = false;
        return;
    }
    if (!$063e11872313d4b3$var$tryCCD(body, world, dt)) {
        body.position[0] += body.velocity[0] * dt;
        body.position[1] += body.velocity[1] * dt;
    }
    body.aabbNeedsUpdate = true;
}
function $063e11872313d4b3$export$1aae89b6100e000c(body, dt, world) {
    if (body._skipPositionThisStep) {
        body._skipPositionThisStep = false;
        return;
    }
    if (!$063e11872313d4b3$var$tryCCD(body, world, dt)) {
        body.position[0] += body.velocity[0] * dt;
        body.position[1] += body.velocity[1] * dt;
        body.angle = body.angle + body.angularVelocity3[2] * dt;
    }
    body.aabbNeedsUpdate = true;
}
function $063e11872313d4b3$export$994981423ef611fe(body, dt, world) {
    if (body._skipPositionThisStep) {
        body._skipPositionThisStep = false;
        return;
    }
    if (!$063e11872313d4b3$var$tryCCD(body, world, dt)) {
        body.position[0] += body.velocity[0] * dt;
        body.position[1] += body.velocity[1] * dt;
        body.z += body.zVelocity * dt;
    }
    body.aabbNeedsUpdate = true;
}
function $063e11872313d4b3$export$261b515eeb5ae993(body, dt, world) {
    if (body._skipPositionThisStep) {
        body._skipPositionThisStep = false;
        return;
    }
    if (!$063e11872313d4b3$var$tryCCD(body, world, dt)) {
        body.position[0] += body.velocity[0] * dt;
        body.position[1] += body.velocity[1] * dt;
        body.z += body.zVelocity * dt;
        $063e11872313d4b3$var$integrateOrientation(body, dt);
        // Extract yaw directly; _angle is the backing field via the setter, but
        // writing to `angle` would re-sync the matrix we just integrated. Use
        // the backing field on Body.
        body._angle = Math.atan2(body.orientation[3], body.orientation[0]);
    }
    body.aabbNeedsUpdate = true;
}
/** Kinematic bodies advance their position using externally-set velocity. */ function $063e11872313d4b3$var$integratePositionKinematic(body, dt) {
    body.position[0] += body.velocity[0] * dt;
    body.position[1] += body.velocity[1] * dt;
    if (body.shape === "rigid2d" || body.shape === "rigid3d") body.angle = body.angle + body.angularVelocity3[2] * dt;
    if (body.shape === "pm3d" || body.shape === "rigid3d") body.z += body.zVelocity * dt;
    body.aabbNeedsUpdate = true;
}
function $063e11872313d4b3$export$965491f85494ebf8(bodies, dt, world) {
    for (const body of bodies){
        if (body.motion === "static") continue;
        if (body.motion === "kinematic") {
            $063e11872313d4b3$var$integratePositionKinematic(body, dt);
            continue;
        }
        switch(body.shape){
            case "pm2d":
                $063e11872313d4b3$export$de261112a6794c68(body, dt, world);
                break;
            case "rigid2d":
                $063e11872313d4b3$export$1aae89b6100e000c(body, dt, world);
                break;
            case "pm3d":
                $063e11872313d4b3$export$994981423ef611fe(body, dt, world);
                break;
            case "rigid3d":
                $063e11872313d4b3$export$261b515eeb5ae993(body, dt, world);
                break;
        }
    }
}
// ─── Rigid3D orientation helpers ──────────────────────────────────────────
/**
 * Advance the 3x3 rotation matrix via Rodrigues exponential map:
 * R_new = exp(skew(ω·dt)) · R_old. Exact for constant ω over the step.
 */ function $063e11872313d4b3$var$integrateOrientation(body, dt) {
    const R = body.orientation;
    const vx = body.angularVelocity3[0] * dt;
    const vy = body.angularVelocity3[1] * dt;
    const vz = body.angularVelocity3[2] * dt;
    const theta2 = vx * vx + vy * vy + vz * vz;
    let s;
    let c;
    if (theta2 < 1e-8) {
        s = 1 - theta2 / 6;
        c = 0.5 - theta2 / 24;
    } else {
        const theta = Math.sqrt(theta2);
        s = Math.sin(theta) / theta;
        c = (1 - Math.cos(theta)) / theta2;
    }
    const e00 = 1 + c * (-vy * vy - vz * vz);
    const e01 = -s * vz + c * vx * vy;
    const e02 = s * vy + c * vx * vz;
    const e10 = s * vz + c * vx * vy;
    const e11 = 1 + c * (-vx * vx - vz * vz);
    const e12 = -s * vx + c * vy * vz;
    const e20 = -s * vy + c * vx * vz;
    const e21 = s * vx + c * vy * vz;
    const e22 = 1 + c * (-vx * vx - vy * vy);
    const r00 = R[0], r01 = R[1], r02 = R[2];
    const r10 = R[3], r11 = R[4], r12 = R[5];
    const r20 = R[6], r21 = R[7], r22 = R[8];
    R[0] = e00 * r00 + e01 * r10 + e02 * r20;
    R[1] = e00 * r01 + e01 * r11 + e02 * r21;
    R[2] = e00 * r02 + e01 * r12 + e02 * r22;
    R[3] = e10 * r00 + e11 * r10 + e12 * r20;
    R[4] = e10 * r01 + e11 * r11 + e12 * r21;
    R[5] = e10 * r02 + e11 * r12 + e12 * r22;
    R[6] = e20 * r00 + e21 * r10 + e22 * r20;
    R[7] = e20 * r01 + e21 * r11 + e22 * r21;
    R[8] = e20 * r02 + e21 * r12 + e22 * r22;
    $063e11872313d4b3$var$orthogonalizeOrientation(R);
}
/**
 * Gram-Schmidt re-orthogonalization of a rotation matrix (row-major).
 * Guards against long-term numerical drift.
 */ function $063e11872313d4b3$var$orthogonalizeOrientation(R) {
    let len = Math.sqrt(R[0] * R[0] + R[1] * R[1] + R[2] * R[2]);
    if (len > 0) {
        R[0] /= len;
        R[1] /= len;
        R[2] /= len;
    }
    let dot = R[3] * R[0] + R[4] * R[1] + R[5] * R[2];
    R[3] -= dot * R[0];
    R[4] -= dot * R[1];
    R[5] -= dot * R[2];
    len = Math.sqrt(R[3] * R[3] + R[4] * R[4] + R[5] * R[5]);
    if (len > 0) {
        R[3] /= len;
        R[4] /= len;
        R[5] /= len;
    }
    R[6] = R[1] * R[5] - R[2] * R[4];
    R[7] = R[2] * R[3] - R[0] * R[5];
    R[8] = R[0] * R[4] - R[1] * R[3];
}


function $1d06a007aaf31ecb$export$901c32d7b645c825(body) {
    if (body.motion !== "dynamic") return;
    const shapes = body.shapes;
    const N = shapes.length;
    const m = body.mass / (N || 1);
    const hasRotation = body.shape === "rigid2d" || body.shape === "rigid3d";
    if (hasRotation) {
        let I = 0;
        for(let i = 0; i < N; i++){
            const shape = shapes[i];
            const r2 = shape.position.squaredMagnitude;
            const Icm = shape.computeMomentOfInertia(m);
            I += Icm + m * r2;
        }
        body.inertia = I;
        body.invInertia = I > 0 ? 1 / I : 0;
    } else {
        body.inertia = Number.MAX_VALUE;
        body.invInertia = 0;
    }
    body.invMass = body.mass > 0 ? 1 / body.mass : 0;
    if (body.shape === "rigid3d") $1d06a007aaf31ecb$export$e2af56f017d1585a(body);
    else {
        // 2D yaw-only world inertia: only element [8] is non-zero.
        const iI = body.invWorldInertia;
        iI[0] = 0;
        iI[1] = 0;
        iI[2] = 0;
        iI[3] = 0;
        iI[4] = 0;
        iI[5] = 0;
        iI[6] = 0;
        iI[7] = 0;
        iI[8] = body.invInertia;
    }
}
function $1d06a007aaf31ecb$export$e2af56f017d1585a(body) {
    if (body.shape !== "rigid3d" || body.motion !== "dynamic") return;
    const R = body.orientation;
    const iI = body.invWorldInertia;
    const invIx = body.invRollInertia;
    const invIy = body.invPitchInertia;
    const invIz = body.invInertia;
    for(let i = 0; i < 3; i++)for(let j = i; j < 3; j++){
        const val = R[i * 3] * invIx * R[j * 3] + R[i * 3 + 1] * invIy * R[j * 3 + 1] + R[i * 3 + 2] * invIz * R[j * 3 + 2];
        iI[i * 3 + j] = val;
        iI[j * 3 + i] = val;
    }
}


function $0cf06cf062f69100$export$d4f9d0a945edd8a8(body, time, dontSleep, dt) {
    if (body.motion !== "dynamic") return;
    body._sleep.sleepTick(body, time, dontSleep, dt);
}
function $0cf06cf062f69100$export$334bf303fcef1251(body) {
    body.wakeUp();
}
function $0cf06cf062f69100$export$e772c8ff12451969(body) {
    body.sleep();
}
function $0cf06cf062f69100$export$777bd0b1973d677f(bodies, time, dt, dontSleep = false) {
    for (const body of bodies){
        if (body.motion !== "dynamic") continue;
        body._sleep.sleepTick(body, time, dontSleep, dt);
    }
}


var $8793a8b9f94904cc$export$6593f13021cce3f9 = /*#__PURE__*/ function(SleepState) {
    /** Body is active and simulated. */ SleepState[SleepState["AWAKE"] = 0] = "AWAKE";
    /** Body is nearly idle and may sleep soon. */ SleepState[SleepState["SLEEPY"] = 1] = "SLEEPY";
    /** Body is sleeping and not simulated until woken. */ SleepState[SleepState["SLEEPING"] = 2] = "SLEEPING";
    return SleepState;
}({});
class $8793a8b9f94904cc$export$4b2c32e08f77ff18 extends (0, $6c2df9ba61f1f24d$export$4fae95256245c8c0) {
    static{
        /** @internal Monotonic id counter. */ this._idCounter = 0;
    }
    static{
        // Shared arrays for non-6DOF accessor defaults. Never written to.
        /** @internal */ this.ZERO_3 = new Float64Array(3);
    }
    static{
        /** @internal */ this.ZERO_9 = new Float64Array(9);
    }
    static{
        /** @internal */ this.IDENTITY_3X3 = new Float64Array([
            1,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            1
        ]);
    }
    constructor(options){
        super(), this.world = null, this.shapes = [], this.concavePath = null, this.aabb = new (0, $dd0ee6ed41f5ec2f$export$8ec70f2db73b49aa)(), this.aabbNeedsUpdate = true, this.boundingRadius = 0, /** @internal */ this._wakeUpAfterNarrowphase = false, /** @internal CCD sets this when it's nuked a substep so position integrate skips. */ this._skipPositionThisStep = false, // ── Position / orientation ───────────────────────────────────────────
        this.position = (0, $6b6a54a072724620$export$e7c866399fa523f5)(), /** @internal backing field for the {@link angle} accessor. */ this._angle = 0, this.z = 0, /** 3x3 rotation matrix (row-major). Always allocated; identity for non-rigid3d bodies. */ this.orientation = new Float64Array([
            1,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            1
        ]), // ── Velocity ─────────────────────────────────────────────────────────
        this.velocity = (0, $6b6a54a072724620$export$e7c866399fa523f5)(), this.zVelocity = 0, /** 3D angular velocity [wx, wy, wz]. Only [2] is meaningful for 2D bodies. */ this.angularVelocity3 = new Float64Array(3), // ── Forces ───────────────────────────────────────────────────────────
        this.force = (0, $6b6a54a072724620$export$e7c866399fa523f5)(), this.zForce = 0, this.angularForce3 = new Float64Array(3), // ── Mass / inertia ───────────────────────────────────────────────────
        this.mass = 0, this.invMass = 0, this.inertia = 0, this.invInertia = 0, this.invZMass = 0, this.invRollInertia = 0, this.invPitchInertia = 0, this.invWorldInertia = new Float64Array(9), // ── Damping / CCD ────────────────────────────────────────────────────
        this.damping = 0, this.angularDamping = 0, this.zDamping = 0, this.rollPitchDamping = 0, this.ccdSpeedThreshold = -1, this.ccdIterations = 10;
        this.id = options.id ?? ++$8793a8b9f94904cc$export$4b2c32e08f77ff18._idCounter;
        this.shape = options.shape;
        this.motion = options.motion;
        this.collisionResponse = options.collisionResponse ?? true;
        if (options.position) this.position.set(options.position);
        this._angle = options.angle ?? 0;
        this.z = options.z ?? 0;
        // Allocate sleep behavior for every body; SleepSystem filters to dynamic.
        this._sleep = new (0, $970bf599a9c225a4$export$22c052d9a14d44c)({
            allowSleep: options.allowSleep ?? true,
            sleepSpeedLimit: options.sleepSpeedLimit ?? 0.2,
            sleepTimeLimit: options.sleepTimeLimit ?? 1
        });
        if (options.motion === "dynamic") {
            this.mass = options.mass ?? 0;
            if (options.velocity) this.velocity.set(options.velocity);
            if (options.angularVelocity !== undefined) this.angularVelocity3[2] = options.angularVelocity;
            this.zVelocity = options.zVelocity ?? 0;
            this.damping = options.damping ?? 0;
            this.angularDamping = options.angularDamping ?? 0;
            this.zDamping = (0, $2172aedd5a25ff17$export$7d15b64cf5a3a4c4)(options.zDamping ?? 0, 0, 1);
            this.rollPitchDamping = (0, $2172aedd5a25ff17$export$7d15b64cf5a3a4c4)(options.rollPitchDamping ?? 0, 0, 1);
            this.ccdSpeedThreshold = options.ccdSpeedThreshold ?? -1;
            this.ccdIterations = options.ccdIterations ?? 10;
            // Z-axis mass applies to any 3D body (pm3d and rigid3d) — without this,
            // invZMass stays 0 and the body never responds to Z forces/constraints.
            if (options.shape === "pm3d" || options.shape === "rigid3d") {
                const zMass = options.zMass ?? this.mass;
                this.invZMass = zMass > 0 ? 1 / zMass : 0;
            }
            // Roll/pitch inertia only exists for rigid3d; pm3d has no rotation.
            if (options.shape === "rigid3d") {
                this.invRollInertia = options.rollInertia && options.rollInertia > 0 ? 1 / options.rollInertia : 0;
                this.invPitchInertia = options.pitchInertia && options.pitchInertia > 0 ? 1 / options.pitchInertia : 0;
            }
            // Initialize invMass / invInertia / invWorldInertia from mass (and from
            // shapes if any were added pre-construction). Callers typically add
            // shapes after construction; addShape re-runs this.
            (0, $1d06a007aaf31ecb$export$901c32d7b645c825)(this);
        } else if (options.motion === "kinematic") {
            if (options.velocity) this.velocity.set(options.velocity);
            if (options.angularVelocity !== undefined) this.angularVelocity3[2] = options.angularVelocity;
        }
        // Sync orientation matrix from initial yaw for rigid3d bodies.
        if (this.shape === "rigid3d" && this._angle !== 0) this._syncOrientationFromAngle();
    }
    // ── Accessors that proxy into backing arrays/fields ──────────────────
    get angle() {
        return this._angle;
    }
    set angle(value) {
        this._angle = value;
        // Rigid3D keeps a full orientation matrix; sync its yaw component.
        if (this.shape === "rigid3d") this._syncOrientationFromAngle();
    }
    get angularVelocity() {
        return this.angularVelocity3[2];
    }
    set angularVelocity(value) {
        this.angularVelocity3[2] = value;
    }
    get angularForce() {
        return this.angularForce3[2];
    }
    set angularForce(value) {
        this.angularForce3[2] = value;
    }
    // ── Sleep proxies ────────────────────────────────────────────────────
    get sleepState() {
        return this._sleep.sleepState;
    }
    get allowSleep() {
        return this._sleep.allowSleep;
    }
    get sleepSpeedLimit() {
        return this._sleep.sleepSpeedLimit;
    }
    get wantsToSleep() {
        return this._sleep.wantsToSleep;
    }
    get idleTime() {
        return this._sleep.idleTime;
    }
    set idleTime(value) {
        this._sleep.idleTime = value;
    }
    get timeLastSleepy() {
        return this._sleep.timeLastSleepy;
    }
    set timeLastSleepy(value) {
        this._sleep.timeLastSleepy = value;
    }
    isSleeping() {
        return this._sleep.isSleeping();
    }
    isAwake() {
        return this._sleep.isAwake();
    }
    wakeUp() {
        this._sleep.wakeUp(this);
        return this;
    }
    sleep() {
        this._sleep.sleep(this);
        return this;
    }
    // ── Shape bookkeeping ────────────────────────────────────────────────
    /**
   * Add a shape with an optional local transform. Recomputes mass
   * properties and bounding radius.
   */ addShape(shape, offset, angle) {
        if (shape.body) throw new Error("A shape can only be added to one body.");
        shape.body = this;
        if (offset) shape.position.set(offset);
        shape.angle = angle ?? 0;
        this.shapes.push(shape);
        (0, $1d06a007aaf31ecb$export$901c32d7b645c825)(this);
        this.updateBoundingRadius();
        this.aabbNeedsUpdate = true;
        return this;
    }
    removeShape(shape) {
        const idx = this.shapes.indexOf(shape);
        if (idx !== -1) {
            this.shapes.splice(idx, 1);
            this.aabbNeedsUpdate = true;
            shape.body = null;
            return true;
        }
        return false;
    }
    updateBoundingRadius() {
        const shapes = this.shapes;
        const N = shapes.length;
        let radius = 0;
        for(let i = 0; i !== N; i++){
            const shape = shapes[i];
            const offset = shape.position.magnitude;
            const r = shape.boundingRadius;
            if (offset + r > radius) radius = offset + r;
        }
        this.boundingRadius = radius;
        return this;
    }
    // ── Pure transforms (2D) ─────────────────────────────────────────────
    toLocalFrame(worldPoint) {
        return worldPoint.toLocalFrame(this.position, this._angle);
    }
    toWorldFrame(localPoint) {
        return localPoint.toGlobalFrame(this.position, this._angle);
    }
    vectorToLocalFrame(worldVector) {
        return worldVector.rotate(-this._angle);
    }
    vectorToWorldFrame(localVector) {
        return localVector.rotate(this._angle);
    }
    overlaps(body) {
        return this.world.overlapKeeper.bodiesAreOverlapping(this, body);
    }
    getVelocityAtPoint(localPoint) {
        return localPoint.crossVZ(this.angularVelocity).imul(-1).iadd(this.velocity);
    }
    getVelocityAtWorldPoint(worldPoint) {
        return worldPoint.toLocalFrame(this.position, this._angle).icrossVZ(this.angularVelocity).imul(-1).iadd(this.velocity);
    }
    // ── Pure transforms (3D) ─────────────────────────────────────────────
    /**
   * World Z-height of a body-local 3D point. Uses the orientation matrix
   * directly — valid for every shape because the matrix is always allocated
   * (identity for non-rigid3d bodies, meaning localZ passes through).
   */ worldZ(localX, localY, localZ) {
        const R = this.orientation;
        return R[6] * localX + R[7] * localY + R[8] * localZ + this.z;
    }
    toWorldFrame3D(localXOrPoint, localYOrOut, localZ, out) {
        let lx, ly, lz;
        let target;
        if (typeof localXOrPoint === "number") {
            lx = localXOrPoint;
            ly = localYOrOut;
            lz = localZ;
            target = out;
        } else {
            lx = localXOrPoint[0];
            ly = localXOrPoint[1];
            lz = localXOrPoint[2];
            target = localYOrOut;
        }
        const R = this.orientation;
        const wx = R[0] * lx + R[1] * ly + R[2] * lz + this.position[0];
        const wy = R[3] * lx + R[4] * ly + R[5] * lz + this.position[1];
        const wz = R[6] * lx + R[7] * ly + R[8] * lz + this.z;
        if (target) return target.set(wx, wy, wz);
        return new (0, $3480ec8c2fb5ff20$export$d2de7ccaa2f4bf9f)(wx, wy, wz);
    }
    toLocalFrame3D(worldXOrPoint, worldY, worldZ) {
        let wx, wy, wz;
        if (typeof worldXOrPoint === "number") {
            wx = worldXOrPoint;
            wy = worldY;
            wz = worldZ;
        } else {
            wx = worldXOrPoint[0];
            wy = worldXOrPoint[1];
            wz = worldXOrPoint[2];
        }
        const R = this.orientation;
        const dx = wx - this.position[0];
        const dy = wy - this.position[1];
        const dz = wz - this.z;
        return new (0, $3480ec8c2fb5ff20$export$d2de7ccaa2f4bf9f)(R[0] * dx + R[3] * dy + R[6] * dz, R[1] * dx + R[4] * dy + R[7] * dz, R[2] * dx + R[5] * dy + R[8] * dz);
    }
    zParallaxX(z) {
        return this.orientation[2] * z;
    }
    zParallaxY(z) {
        return this.orientation[5] * z;
    }
    // ── Legacy-compat convenience getters ────────────────────────────────
    /** True for rigid3d bodies; the solver reads this to pick integration paths. */ get is6DOF() {
        return this.shape === "rigid3d";
    }
    /** True for point-mass shapes (pm2d / pm3d): rotation is not simulated. */ get fixedRotation() {
        return this.shape === "pm2d" || this.shape === "pm3d";
    }
    /** Inverse Z-axis mass (alias of invZMass). */ get invMassZ() {
        return this.invZMass;
    }
    /** Roll angle extracted from orientation matrix. */ get roll() {
        const R = this.orientation;
        return Math.atan2(-R[7], R[8]);
    }
    /** Pitch angle extracted from orientation matrix. */ get pitch() {
        const R = this.orientation;
        return Math.atan2(R[6], Math.sqrt(R[0] * R[0] + R[3] * R[3]));
    }
    get rollVelocity() {
        const R = this.orientation;
        const w = this.angularVelocity3;
        return R[0] * w[0] + R[3] * w[1] + R[6] * w[2];
    }
    get pitchVelocity() {
        const R = this.orientation;
        const w = this.angularVelocity3;
        return R[1] * w[0] + R[4] * w[1] + R[7] * w[2];
    }
    get density() {
        const totalArea = this.getArea();
        return totalArea > 0 ? this.mass / totalArea : 0;
    }
    set density(density) {
        const totalArea = this.getArea();
        this.mass = totalArea * density;
        this.updateMassProperties();
    }
    // ── AABB / area helpers ──────────────────────────────────────────────
    getAABB() {
        if (this.aabbNeedsUpdate) this.updateAABB();
        return this.aabb;
    }
    updateAABB() {
        (0, $1e37aa1a6c2e96e3$export$a41f76e09f6b89bb)(this);
        return this;
    }
    getArea() {
        let totalArea = 0;
        for(let i = 0; i < this.shapes.length; i++)totalArea += this.shapes[i].area;
        return totalArea;
    }
    // ── Force / impulse application (delegates to ForceSystem) ───────────
    applyForce(force, relativePoint) {
        (0, $ab1a75484f40dd41$export$da81038170e85b8c)(this, force, relativePoint);
        return this;
    }
    applyForceLocal(localForce, localPoint) {
        (0, $ab1a75484f40dd41$export$ab54d956780e55d5)(this, localForce, localPoint);
        return this;
    }
    applyForce3D(fxOrForce, fyOrLocalPoint, fz, localX, localY, localZ) {
        if (typeof fxOrForce === "number") (0, $ab1a75484f40dd41$export$87842afadc15cca2)(this, fxOrForce, fyOrLocalPoint, fz, localX, localY, localZ);
        else (0, $ab1a75484f40dd41$export$87842afadc15cca2)(this, fxOrForce, fyOrLocalPoint);
        return this;
    }
    applyImpulse(impulse, relativePoint) {
        (0, $ab1a75484f40dd41$export$56a1f0332a3583db)(this, impulse, relativePoint);
        return this;
    }
    applyImpulseLocal(localImpulse, localPoint) {
        (0, $ab1a75484f40dd41$export$bec7df03941ad93d)(this, localImpulse, localPoint);
        return this;
    }
    setZeroForce() {
        (0, $ab1a75484f40dd41$export$e81daad8c0a35a92)(this);
        return this;
    }
    // ── Mass properties / integration / damping (delegate to systems) ────
    updateMassProperties() {
        (0, $1d06a007aaf31ecb$export$901c32d7b645c825)(this);
        return this;
    }
    recomputeWorldInertia() {
        (0, $1d06a007aaf31ecb$export$e2af56f017d1585a)(this);
    }
    integrateVelocity(dt) {
        if (this.motion !== "dynamic") return;
        switch(this.shape){
            case "pm2d":
                (0, $063e11872313d4b3$export$d86a5ecabd82904b)(this, dt);
                break;
            case "rigid2d":
                (0, $063e11872313d4b3$export$283b63eae50998be)(this, dt);
                break;
            case "pm3d":
                (0, $063e11872313d4b3$export$87460c0791037fa0)(this, dt);
                break;
            case "rigid3d":
                (0, $063e11872313d4b3$export$aa7816bddb426373)(this, dt);
                break;
        }
    }
    integratePosition(dt) {
        if (this.motion === "static") return;
        if (this.motion === "kinematic") {
            this.position[0] += this.velocity[0] * dt;
            this.position[1] += this.velocity[1] * dt;
            if (this.shape === "rigid2d" || this.shape === "rigid3d") this.angle = this.angle + this.angularVelocity3[2] * dt;
            if (this.shape === "pm3d" || this.shape === "rigid3d") this.z += this.zVelocity * dt;
            this.aabbNeedsUpdate = true;
            return;
        }
        switch(this.shape){
            case "pm2d":
                (0, $063e11872313d4b3$export$de261112a6794c68)(this, dt, this.world);
                break;
            case "rigid2d":
                (0, $063e11872313d4b3$export$1aae89b6100e000c)(this, dt, this.world);
                break;
            case "pm3d":
                (0, $063e11872313d4b3$export$994981423ef611fe)(this, dt, this.world);
                break;
            case "rigid3d":
                (0, $063e11872313d4b3$export$261b515eeb5ae993)(this, dt, this.world);
                break;
        }
    }
    integrate(dt) {
        this.integrateVelocity(dt);
        this.integratePosition(dt);
    }
    applyDamping(dt) {
        if (this.motion !== "dynamic") return;
        switch(this.shape){
            case "pm2d":
                (0, $68b8ececbe2239df$export$df7e1ba7d171fdbd)(this, dt);
                break;
            case "rigid2d":
                (0, $68b8ececbe2239df$export$535e8b47fdd462b8)(this, dt);
                break;
            case "pm3d":
                (0, $68b8ececbe2239df$export$f32aecaf3c45006b)(this, dt);
                break;
            case "rigid3d":
                (0, $68b8ececbe2239df$export$3d3c8ef379ec480a)(this, dt);
                break;
        }
    }
    sleepTick(time, dontSleep, dt) {
        (0, $0cf06cf062f69100$export$d4f9d0a945edd8a8)(this, time, dontSleep, dt);
    }
    // ── Center-of-mass adjustment (legacy helper) ────────────────────────
    adjustCenterOfMass() {
        const sum = (0, $6b6a54a072724620$export$e7c866399fa523f5)();
        let totalArea = 0;
        for(let i = 0; i !== this.shapes.length; i++){
            const s = this.shapes[i];
            const offset_times_area = (0, $6b6a54a072724620$export$e7c866399fa523f5)(s.position);
            offset_times_area.imul(s.area);
            sum.iadd(offset_times_area);
            totalArea += s.area;
        }
        const cm = (0, $6b6a54a072724620$export$e7c866399fa523f5)(sum);
        cm.imul(1 / totalArea);
        for(let i = 0; i !== this.shapes.length; i++)this.shapes[i].position.isub(cm);
        this.position.iadd(cm);
        for(let i = 0; this.concavePath && i < this.concavePath.length; i++)this.concavePath[i].isub(cm);
        this.updateMassProperties();
        this.updateBoundingRadius();
        return this;
    }
    // ── Private helpers ──────────────────────────────────────────────────
    /** Update the 2D yaw submatrix of the orientation matrix from `_angle`. */ _syncOrientationFromAngle() {
        const c = Math.cos(this._angle);
        const s = Math.sin(this._angle);
        const R = this.orientation;
        R[0] = c;
        R[1] = -s;
        R[3] = s;
        R[4] = c;
    // z-row/column left as identity for rigid3d; roll/pitch integration writes
    // them later.
    }
}


function $4aa863c0a97fa3b4$export$7d27618aebc86361(opts) {
    return new (0, $8793a8b9f94904cc$export$4b2c32e08f77ff18)({
        shape: "pm2d",
        ...opts
    });
}
function $4aa863c0a97fa3b4$export$c9dd59e0dcee4be9(opts) {
    return new (0, $8793a8b9f94904cc$export$4b2c32e08f77ff18)({
        shape: "rigid2d",
        ...opts
    });
}
function $4aa863c0a97fa3b4$export$f49b83b66b23fb37(opts) {
    return new (0, $8793a8b9f94904cc$export$4b2c32e08f77ff18)({
        shape: "pm3d",
        ...opts
    });
}
function $4aa863c0a97fa3b4$export$d8062929709d2dca(opts) {
    return new (0, $8793a8b9f94904cc$export$4b2c32e08f77ff18)({
        shape: "rigid3d",
        ...opts
    });
}






class $ecce3222fc0a9651$export$6428a7f2611ef1fa {
    static{
        /** @internal */ this.idCounter = 0;
    }
    constructor(options = {}){
        /** The body this shape is attached to, or null. */ this.body = null;
        /** Bounding circle radius for broad-phase collision. */ this.boundingRadius = 0;
        /** Surface area of this shape. */ this.area = 0;
        this.position = (0, $6b6a54a072724620$export$e7c866399fa523f5)();
        if (options.position) this.position.set(options.position);
        this.angle = options.angle ?? 0;
        this.id = $ecce3222fc0a9651$export$6428a7f2611ef1fa.idCounter++;
        this.collisionGroup = options.collisionGroup ?? 1;
        this.collisionResponse = options.collisionResponse ?? true;
        this.collisionMask = options.collisionMask ?? 1;
        this.material = options.material;
        this.sensor = options.sensor ?? false;
    // Note: updateBoundingRadius() and updateArea() are NOT called here
    // because subclasses need to initialize their shape-specific properties first.
    // Each subclass (Circle, Convex, etc.) calls these methods in their own constructor.
    }
    /** Compute moment of inertia for the given mass. Override in subclasses. */ computeMomentOfInertia(_mass) {
        return 0;
    }
}


class $6ae562c24c0aa510$export$bc1767a8c6770562 extends (0, $ecce3222fc0a9651$export$6428a7f2611ef1fa) {
    constructor(options = {}){
        super(options);
        this.vertices = [];
        // Copy the verts
        const vertices = options.vertices ?? [];
        for(let i = 0; i < vertices.length; i++){
            const v = (0, $6b6a54a072724620$export$e7c866399fa523f5)();
            v.set(vertices[i]);
            this.vertices.push(v);
        }
        this.axes = [];
        if (options.axes) // Copy the axes
        for(let i = 0; i < options.axes.length; i++){
            const axis = (0, $6b6a54a072724620$export$e7c866399fa523f5)();
            axis.set(options.axes[i]);
            this.axes.push(axis);
        }
        else // Construct axes from the vertex data
        for(let i = 0; i < this.vertices.length; i++){
            const worldPoint0 = this.vertices[i];
            const worldPoint1 = this.vertices[(i + 1) % this.vertices.length];
            const normal = (0, $6b6a54a072724620$export$e7c866399fa523f5)();
            normal.set(worldPoint1).isub(worldPoint0);
            // Get normal - just rotate 90 degrees since vertices are given in CCW
            normal.irotate90cw();
            normal.inormalize();
            this.axes.push(normal);
        }
        this.centerOfMass = (0, $6b6a54a072724620$export$e7c866399fa523f5)();
        this.triangles = [];
        if (this.vertices.length) {
            this.updateTriangles();
            this.updateCenterOfMass();
        }
        this.boundingRadius = 0;
        this.updateBoundingRadius();
        this.updateArea();
        if (this.area < 0) throw new Error("Convex vertices must be given in counter-clockwise winding.");
    }
    projectOntoLocalAxis(localAxis) {
        let max = null;
        let min = null;
        const axis = (0, $6b6a54a072724620$export$e7c866399fa523f5)(localAxis);
        for(let i = 0; i < this.vertices.length; i++){
            const v = this.vertices[i];
            const value = v.dot(axis);
            if (max === null || value > max) max = value;
            if (min === null || value < min) min = value;
        }
        if (min > max) {
            const t = min;
            min = max;
            max = t;
        }
        return (0, $6b6a54a072724620$export$e7c866399fa523f5)(min, max);
    }
    projectOntoWorldAxis(localAxis, shapeOffset, shapeAngle) {
        const result = this.projectOntoLocalAxis(localAxis);
        // Project the position of the body onto the axis
        const worldAxis = shapeAngle !== 0 ? (0, $6b6a54a072724620$export$e7c866399fa523f5)(localAxis).rotate(shapeAngle) : (0, $6b6a54a072724620$export$e7c866399fa523f5)(localAxis);
        const offset = shapeOffset.dot(worldAxis);
        return (0, $6b6a54a072724620$export$e7c866399fa523f5)(result[0] + offset, result[1] + offset);
    }
    updateTriangles() {
        this.triangles.length = 0;
        // Triangulate the polygon using ear clipping
        const triangleIndices = $6ae562c24c0aa510$export$bc1767a8c6770562.triangulate(this.vertices);
        // Convert flat array of indices to triangle arrays
        for(let i = 0; i < triangleIndices.length; i += 3){
            const id1 = triangleIndices[i];
            const id2 = triangleIndices[i + 1];
            const id3 = triangleIndices[i + 2];
            this.triangles.push([
                id1,
                id2,
                id3
            ]);
        }
    }
    updateCenterOfMass() {
        const triangles = this.triangles;
        const verts = this.vertices;
        const cm = this.centerOfMass;
        cm.set(0, 0);
        let totalArea = 0;
        for(let i = 0; i !== triangles.length; i++){
            const t = triangles[i];
            const a = verts[t[0]];
            const b = verts[t[1]];
            const c = verts[t[2]];
            const centroid = (0, $6b6a54a072724620$export$19606695c7c6ab3a).centroid(a, b, c);
            const m = $6ae562c24c0aa510$export$bc1767a8c6770562.triangleArea(a, b, c);
            totalArea += m;
            const centroid_times_mass = (0, $6b6a54a072724620$export$e7c866399fa523f5)(centroid).mul(m);
            cm.iadd(centroid_times_mass);
        }
        cm.imul(1 / totalArea);
    }
    computeMomentOfInertia(mass) {
        let denom = 0.0;
        let numer = 0.0;
        const N = this.vertices.length;
        for(let j = N - 1, i = 0; i < N; j = i, i++){
            const p0 = this.vertices[j];
            const p1 = this.vertices[i];
            const a = Math.abs(p0.crossLength(p1));
            const b = p1.dot(p1) + p1.dot(p0) + p0.dot(p0);
            denom += a * b;
            numer += a;
        }
        return mass / 6.0 * (denom / numer);
    }
    updateBoundingRadius() {
        const verts = this.vertices;
        let r2 = 0;
        for(let i = 0; i !== verts.length; i++){
            const l2 = verts[i].squaredMagnitude;
            if (l2 > r2) r2 = l2;
        }
        this.boundingRadius = Math.sqrt(r2);
    }
    static triangleArea(a, b, c) {
        return ((b[0] - a[0]) * (c[1] - a[1]) - (c[0] - a[0]) * (b[1] - a[1])) * 0.5;
    }
    updateArea() {
        this.updateTriangles();
        this.area = 0;
        const triangles = this.triangles;
        const verts = this.vertices;
        for(let i = 0; i !== triangles.length; i++){
            const t = triangles[i];
            const a = verts[t[0]];
            const b = verts[t[1]];
            const c = verts[t[2]];
            const m = $6ae562c24c0aa510$export$bc1767a8c6770562.triangleArea(a, b, c);
            this.area += m;
        }
    }
    computeAABB(position, angle) {
        const out = new (0, $dd0ee6ed41f5ec2f$export$8ec70f2db73b49aa)();
        out.setFromPoints(this.vertices, position, angle, 0);
        return out;
    }
    raycast(from, to, position, angle, _skipBackfaces) {
        const vertices = this.vertices;
        // Transform ray to local shape space
        const rayStart = (0, $6b6a54a072724620$export$e7c866399fa523f5)(from).toLocalFrame(position, angle);
        const rayEnd = (0, $6b6a54a072724620$export$e7c866399fa523f5)(to).toLocalFrame(position, angle);
        const n = vertices.length;
        let closestFraction = Infinity;
        let closestHit = null;
        const rayLength = from.distanceTo(to);
        for(let i = 0; i < n; i++){
            const q1 = vertices[i];
            const q2 = vertices[(i + 1) % n];
            const fraction = (0, $6b6a54a072724620$export$19606695c7c6ab3a).lineSegmentsIntersectionFraction(rayStart, rayEnd, q1, q2);
            if (fraction >= 0 && fraction < closestFraction) {
                closestFraction = fraction;
                // Compute normal perpendicular to edge, rotated to world space
                const normal = (0, $6b6a54a072724620$export$e7c866399fa523f5)(q2).sub(q1);
                normal.irotate(-Math.PI / 2 + angle);
                normal.inormalize();
                const point = (0, $6b6a54a072724620$export$e7c866399fa523f5)(from).ilerp(to, fraction);
                closestHit = {
                    point: point,
                    normal: normal,
                    distance: rayLength * fraction,
                    fraction: fraction
                };
            }
        }
        return closestHit;
    }
    /**
   * Triangulate a polygon using ear clipping algorithm.
   * @param vertices Array of polygon vertices in counter-clockwise order
   * @returns Array of triangle vertex indices [i0, i1, i2, i3, i4, i5, ...]
   */ static triangulate(vertices) {
        const n = vertices.length;
        if (n < 3) return [];
        const triangles = [];
        const available = [];
        for(let i = 0; i < n; i++)available.push(i);
        let i = 0;
        let al = n;
        while(al > 3){
            const i0 = available[(i + 0) % al];
            const i1 = available[(i + 1) % al];
            const i2 = available[(i + 2) % al];
            const a = vertices[i0];
            const b = vertices[i1];
            const c = vertices[i2];
            let earFound = false;
            if ($6ae562c24c0aa510$export$bc1767a8c6770562.isConvexAngle(a, b, c)) {
                earFound = true;
                // Check if any other vertex is inside this triangle
                for(let j = 0; j < al; j++){
                    const vi = available[j];
                    if (vi === i0 || vi === i1 || vi === i2) continue;
                    if ($6ae562c24c0aa510$export$bc1767a8c6770562.isPointInTriangle(vertices[vi], a, b, c)) {
                        earFound = false;
                        break;
                    }
                }
            }
            if (earFound) {
                triangles.push(i0, i1, i2);
                available.splice((i + 1) % al, 1);
                al--;
                i = 0;
            } else if (i++ > 3 * al) break;
        }
        // Add final triangle
        triangles.push(available[0], available[1], available[2]);
        return triangles;
    }
    /**
   * Check if point p is inside triangle abc.
   */ static isPointInTriangle(p, a, b, c) {
        const v0x = c.x - a.x;
        const v0y = c.y - a.y;
        const v1x = b.x - a.x;
        const v1y = b.y - a.y;
        const v2x = p.x - a.x;
        const v2y = p.y - a.y;
        const dot00 = v0x * v0x + v0y * v0y;
        const dot01 = v0x * v1x + v0y * v1y;
        const dot02 = v0x * v2x + v0y * v2y;
        const dot11 = v1x * v1x + v1y * v1y;
        const dot12 = v1x * v2x + v1y * v2y;
        const invDenom = 1 / (dot00 * dot11 - dot01 * dot01);
        const u = (dot11 * dot02 - dot01 * dot12) * invDenom;
        const v = (dot00 * dot12 - dot01 * dot02) * invDenom;
        return u >= 0 && v >= 0 && u + v < 1;
    }
    /**
   * Check if three points form a convex angle (for counter-clockwise winding).
   */ static isConvexAngle(a, b, c) {
        return (a.y - b.y) * (c.x - b.x) + (b.x - a.x) * (c.y - b.y) >= 0;
    }
}



class $7cebb72687875576$export$e71c4d32a2263218 extends (0, $6ae562c24c0aa510$export$bc1767a8c6770562) {
    constructor(options = {}){
        const width = options.width ?? 1;
        const height = options.height ?? 1;
        const verts = [
            (0, $6b6a54a072724620$export$e7c866399fa523f5)(-width / 2, -height / 2),
            (0, $6b6a54a072724620$export$e7c866399fa523f5)(width / 2, -height / 2),
            (0, $6b6a54a072724620$export$e7c866399fa523f5)(width / 2, height / 2),
            (0, $6b6a54a072724620$export$e7c866399fa523f5)(-width / 2, height / 2)
        ];
        // Need 4 axes (one per edge) for circleConvex collision to work correctly
        const axes = [
            (0, $6b6a54a072724620$export$e7c866399fa523f5)(0, -1),
            (0, $6b6a54a072724620$export$e7c866399fa523f5)(1, 0),
            (0, $6b6a54a072724620$export$e7c866399fa523f5)(0, 1),
            (0, $6b6a54a072724620$export$e7c866399fa523f5)(-1, 0)
        ];
        const opts = {
            ...options,
            vertices: verts,
            axes: axes
        };
        super(opts);
        this.width = width;
        this.height = height;
        // Re-calculate with correct width/height (Convex uses vertex-based calculation)
        this.updateBoundingRadius();
        this.updateArea();
    }
    computeMomentOfInertia(mass) {
        const w = this.width;
        const h = this.height;
        return mass * (h * h + w * w) / 12;
    }
    updateBoundingRadius() {
        const w = this.width;
        const h = this.height;
        this.boundingRadius = Math.sqrt(w * w + h * h) / 2;
    }
    computeAABB(position, angle) {
        const out = new (0, $dd0ee6ed41f5ec2f$export$8ec70f2db73b49aa)();
        out.setFromPoints(this.vertices, position, angle, 0);
        return out;
    }
    updateArea() {
        this.area = this.width * this.height;
    }
}





class $45a22be5c0ab570f$export$c89a927ffc67e6fa extends (0, $ecce3222fc0a9651$export$6428a7f2611ef1fa) {
    constructor(options = {}){
        super(options);
        this.radius = options.radius ?? 1;
        this.updateBoundingRadius();
        this.updateArea();
    }
    computeMomentOfInertia(mass) {
        const r = this.radius;
        return mass * r * r / 2;
    }
    updateBoundingRadius() {
        this.boundingRadius = this.radius;
    }
    updateArea() {
        this.area = Math.PI * this.radius * this.radius;
    }
    computeAABB(position, _angle) {
        const r = this.radius;
        const out = new (0, $dd0ee6ed41f5ec2f$export$8ec70f2db73b49aa)();
        out.upperBound.set(r, r);
        out.lowerBound.set(-r, -r);
        if (position) {
            out.lowerBound.iadd(position);
            out.upperBound.iadd(position);
        }
        return out;
    }
    raycast(from, to, position, _angle, _skipBackfaces) {
        const r = this.radius;
        const a = Math.pow(to[0] - from[0], 2) + Math.pow(to[1] - from[1], 2);
        const b = 2 * ((to[0] - from[0]) * (from[0] - position[0]) + (to[1] - from[1]) * (from[1] - position[1]));
        const c = Math.pow(from[0] - position[0], 2) + Math.pow(from[1] - position[1], 2) - Math.pow(r, 2);
        const delta = Math.pow(b, 2) - 4 * a * c;
        if (delta < 0) // No intersection
        return null;
        // Find the closest valid intersection
        let fraction;
        if (delta === 0) fraction = -b / (2 * a);
        else {
            const sqrtDelta = Math.sqrt(delta);
            const inv2a = 1 / (2 * a);
            const d1 = (-b - sqrtDelta) * inv2a;
            const d2 = (-b + sqrtDelta) * inv2a;
            // Pick the closest intersection that's within the ray segment
            if (d1 >= 0 && d1 <= 1) fraction = d1;
            else if (d2 >= 0 && d2 <= 1) fraction = d2;
            else return null;
        }
        if (fraction < 0 || fraction > 1) return null;
        const point = (0, $6b6a54a072724620$export$e7c866399fa523f5)(from).ilerp(to, fraction);
        const normal = (0, $6b6a54a072724620$export$e7c866399fa523f5)(point).isub(position).inormalize();
        const distance = from.distanceTo(to) * fraction;
        return {
            point: point,
            normal: normal,
            distance: distance,
            fraction: fraction
        };
    }
}






const $d7d213b64e83977c$var$points = [
    (0, $6b6a54a072724620$export$e7c866399fa523f5)(),
    (0, $6b6a54a072724620$export$e7c866399fa523f5)()
];
class $d7d213b64e83977c$export$17d680238e50603e extends (0, $ecce3222fc0a9651$export$6428a7f2611ef1fa) {
    constructor(options = {}){
        super(options);
        this.length = options.length ?? 1;
        this.updateBoundingRadius();
        this.updateArea();
    }
    computeMomentOfInertia(mass) {
        return mass * Math.pow(this.length, 2) / 12;
    }
    updateBoundingRadius() {
        this.boundingRadius = this.length / 2;
    }
    updateArea() {
        this.area = 0;
    }
    computeAABB(position, angle) {
        const l2 = this.length / 2;
        $d7d213b64e83977c$var$points[0].set(-l2, 0);
        $d7d213b64e83977c$var$points[1].set(l2, 0);
        const out = new (0, $dd0ee6ed41f5ec2f$export$8ec70f2db73b49aa)();
        out.setFromPoints($d7d213b64e83977c$var$points, position, angle, 0);
        return out;
    }
    raycast(from, to, position, angle, _skipBackfaces) {
        // Get start and end of the line in world space
        const halfLen = this.length / 2;
        const l0 = (0, $6b6a54a072724620$export$e7c866399fa523f5)(-halfLen, 0).itoGlobalFrame(position, angle);
        const l1 = (0, $6b6a54a072724620$export$e7c866399fa523f5)(halfLen, 0).itoGlobalFrame(position, angle);
        const fraction = (0, $6b6a54a072724620$export$19606695c7c6ab3a).lineSegmentsIntersectionFraction(l0, l1, from, to);
        if (fraction >= 0) {
            const normal = (0, $6b6a54a072724620$export$e7c866399fa523f5)(0, 1).irotate(angle);
            const point = (0, $6b6a54a072724620$export$e7c866399fa523f5)(from).ilerp(to, fraction);
            const distance = from.distanceTo(to) * fraction;
            return {
                point: point,
                normal: normal,
                distance: distance,
                fraction: fraction
            };
        }
        return null;
    }
}



function $9744a747137c6926$export$9d43ca2c1f9c9b92(p1, p2) {
    const vector = p2.sub(p1);
    const midpoint = p1.lerp(p2, 0.5);
    return new (0, $d7d213b64e83977c$export$17d680238e50603e)({
        position: midpoint,
        angle: vector.angle,
        length: vector.magnitude
    });
}
function $9744a747137c6926$export$5398643d93d9cfa1(shapeDef) {
    const shape = $9744a747137c6926$var$baseShapeFromDef(shapeDef);
    shape.collisionGroup = shapeDef.collisionGroup;
    shape.collisionMask = shapeDef.collisionMask;
    return shape;
}
function $9744a747137c6926$var$baseShapeFromDef(shapeDef) {
    switch(shapeDef.type){
        case "line":
            return $9744a747137c6926$export$9d43ca2c1f9c9b92((0, $6b6a54a072724620$export$e7c866399fa523f5)(shapeDef.start), (0, $6b6a54a072724620$export$e7c866399fa523f5)(shapeDef.end));
        case "circle":
            return new (0, $45a22be5c0ab570f$export$c89a927ffc67e6fa)({
                radius: shapeDef.radius,
                position: (0, $6b6a54a072724620$export$e7c866399fa523f5)(shapeDef.center),
                angle: 0
            });
        case "box":
            return new (0, $7cebb72687875576$export$e71c4d32a2263218)({
                width: shapeDef.size[0],
                height: shapeDef.size[1],
                position: (0, $6b6a54a072724620$export$e7c866399fa523f5)(shapeDef.center),
                angle: shapeDef.angle
            });
        case "convex":
            return new (0, $6ae562c24c0aa510$export$bc1767a8c6770562)({
                vertices: [
                    ...shapeDef.vertices
                ]
            });
    }
}
function $9744a747137c6926$export$7c04771a442b0848(vertices) {
    let area = 0;
    for(let i = 0; i < vertices.length; i++){
        const j = (i + 1) % vertices.length;
        area += vertices[i].x * vertices[j].y;
        area -= vertices[j].x * vertices[i].y;
    }
    return Math.abs(area) / 2;
}



/**
 * Type-safe event handler decorator for entities.
 *
 * Usage:
 *   @on("tick")
 *   onTick({ dt }: GameEventMap["tick"]) { ... }
 */ // Map from class constructor to its directly declared handlers
const $aa1f0309d9dba6d2$var$classHandlers = new WeakMap();
function $aa1f0309d9dba6d2$export$af631764ddc44097(event) {
    return function(target, propertyKey, _descriptor) {
        // Validate method name matches expected pattern
        const expectedName = `on${event.charAt(0).toUpperCase()}${event.slice(1)}`;
        if (propertyKey !== expectedName) throw new Error(`@on("${event}") requires the method to be named "${expectedName}", but found "${propertyKey}"`);
        // Register this event for the class that owns the method
        const owningClass = target.constructor;
        let handlers = $aa1f0309d9dba6d2$var$classHandlers.get(owningClass);
        if (!handlers) {
            handlers = new Set();
            $aa1f0309d9dba6d2$var$classHandlers.set(owningClass, handlers);
        }
        handlers.add(event);
    };
}
function $aa1f0309d9dba6d2$export$2f4ceae90681485c(entity) {
    const result = new Set();
    // Walk up the prototype chain to collect all handlers
    let current = entity.constructor;
    while(current && current !== Object && current !== Function){
        const handlers = $aa1f0309d9dba6d2$var$classHandlers.get(current);
        if (handlers) for (const event of handlers)result.add(event);
        current = Object.getPrototypeOf(current);
    }
    return Array.from(result);
}


class $c59361981bac2575$export$4342ba5c6ad1f6f1 {
    get game() {
        if (!this._game) throw new Error(`Entity ${this.constructor.name} accessed 'game' before being added`);
        return this._game;
    }
    set game(value) {
        this._game = value;
    }
    get isAdded() {
        return this._game != null;
    }
    constructor(entityDef){
        this.children = [];
        this.pausable = true;
        this.persistenceLevel = 0;
        this.tags = [];
        if (entityDef) this.loadFromDef(entityDef);
    }
    loadFromDef(def) {
        if (this._game) throw new Error("Can't load from def after entity has been added to game.");
        if (def.body) {
            this.body = (0, $4aa863c0a97fa3b4$export$c9dd59e0dcee4be9)({
                motion: "dynamic",
                mass: def.body.mass
            });
            for (const shapeDef of def.body.shapes){
                const shape = (0, $9744a747137c6926$export$5398643d93d9cfa1)(shapeDef);
                this.body.addShape(shape, shape.position, shape.angle);
            }
        }
    }
    /** Convert local coordinates to world coordinates. Requires a body */ localToWorld(localPoint) {
        if (this.body) {
            const local = Array.isArray(localPoint) ? (0, $6b6a54a072724620$export$e7c866399fa523f5)(localPoint[0], localPoint[1]) : localPoint;
            return this.body.toWorldFrame(local);
        }
        return (0, $6b6a54a072724620$export$e7c866399fa523f5)(0, 0);
    }
    worldToLocal(worldPoint) {
        if (this.body) {
            const world = Array.isArray(worldPoint) ? (0, $6b6a54a072724620$export$e7c866399fa523f5)(worldPoint[0], worldPoint[1]) : worldPoint;
            return this.body.toLocalFrame(world);
        }
        return (0, $6b6a54a072724620$export$e7c866399fa523f5)(0, 0);
    }
    getPosition() {
        if (this.body) return (0, $6b6a54a072724620$export$e7c866399fa523f5)(this.body.position);
        throw new Error("Position is not implemented for this entity");
    }
    get isDestroyed() {
        return this._game == null;
    }
    // Removes this from the game. You probably shouldn't override this method.
    destroy() {
        if (this._game) {
            this._game.removeEntity(this);
            while(this.children?.length)this.children[this.children.length - 1].destroy();
            if (this.parent?.children) {
                const index = this.parent.children.lastIndexOf(this);
                if (index >= 0) this.parent.children.splice(index, 1);
            }
        }
    }
    /** Add another entity as a child of this one. Child entities will get destroyed when their parent is destroyed. */ addChild(child, changeParent = false) {
        if (child.parent) {
            if (changeParent) {
                // This can lead to weird state where a child is added but its parent isn't, dunno if that's bad
                const oldParent = child.parent;
                if (oldParent.children) {
                    const index = oldParent.children.indexOf(child);
                    if (index >= 0) oldParent.children.splice(index, 1);
                }
            } else throw new Error("Child already has a parent.");
        }
        child.parent = this;
        this.children = this.children ?? [];
        this.children.push(child);
        if (this._game && !child.isAdded) this._game.addEntity(child);
        return child;
    }
    /** Add multiple entities as children of this one. See addChild. */ addChildren(...children) {
        for (const child of children)this.addChild(child);
    }
    /**
   * Fulfills after the given amount of game time.
   * Use with delay=0 to wait until the next tick.
   * @param onTick  Do something every tick while waiting
   */ wait(delay = 0, onTick, timerId) {
        return new Promise((resolve)=>{
            const timer = new $c59361981bac2575$var$Timer(delay, ()=>resolve(), onTick, timerId);
            timer.persistenceLevel = this.persistenceLevel;
            this.addChild(timer);
        });
    }
    /**
   * Fulfills after the given amount of game time.
   * Use with delay=0 to wait until the next tick.
   * @param onRender  Do something every render while waiting
   */ waitRender(delay = 0, onRender, timerId) {
        return new Promise((resolve)=>{
            const timer = new $c59361981bac2575$var$RenderTimer(delay, ()=>resolve(), onRender, timerId);
            timer.persistenceLevel = this.persistenceLevel;
            this.addChild(timer);
        });
    }
    /** Wait until a condition is filled. Probably not great to use, but seems kinda cool too. */ waitUntil(predicate, onTick, timerId) {
        return new Promise((resolve)=>{
            const timer = new $c59361981bac2575$var$Timer(Infinity, ()=>resolve(), (dt, t)=>{
                if (onTick) onTick(dt, t);
                if (predicate()) timer.timeRemaining = 0;
            }, timerId);
            timer.persistenceLevel = this.persistenceLevel;
            this.addChild(timer);
        });
    }
    /** Remove all timers from this instance. i.e. cancel all 'waits'. */ clearTimers(timerId) {
        if (this.children) {
            const timers = this.children.filter($c59361981bac2575$var$isTimer);
            for (const timer of timers)if (!timerId || timerId === timer.timerId) timer.destroy();
        }
    }
    /** Update the time remaing on a timer (or all timers). */ updateTimers(value = 0, timerId) {
        if (this.children) {
            const timers = this.children.filter($c59361981bac2575$var$isTimer);
            for (const timer of timers)if (!timerId || timerId === timer.timerId) timer.timeRemaining = value;
        }
    }
    /** Dispatch an event. */ dispatch(eventName, data, respectPause) {
        if (this._game) this._game.dispatch(eventName, data, respectPause);
    }
}
class $c59361981bac2575$var$Timer extends $c59361981bac2575$export$4342ba5c6ad1f6f1 {
    constructor(delay, endEffect, duringEffect, timerId){
        super(), this.delay = delay, this.timerId = timerId, this.timeRemaining = 0;
        this.timeRemaining = delay;
        this.endEffect = endEffect;
        this.duringEffect = duringEffect;
    }
    onTick({ dt: dt }) {
        this.timeRemaining -= dt;
        const t = (0, $2172aedd5a25ff17$export$7d15b64cf5a3a4c4)(1.0 - this.timeRemaining / this.delay);
        this.duringEffect?.(dt, t);
        if (this.timeRemaining <= 0) {
            this.endEffect?.();
            this.destroy();
        }
    }
}
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $aa1f0309d9dba6d2$export$af631764ddc44097)("tick")
], $c59361981bac2575$var$Timer.prototype, "onTick", null);
class $c59361981bac2575$var$RenderTimer extends $c59361981bac2575$export$4342ba5c6ad1f6f1 {
    constructor(delay, endEffect, duringEffect, timerId){
        super(), this.delay = delay, this.timerId = timerId, this.timeRemaining = 0;
        this.timeRemaining = delay;
        this.endEffect = endEffect;
        this.duringEffect = duringEffect;
    }
    onRender({ dt: dt }) {
        this.timeRemaining -= dt;
        const t = (0, $2172aedd5a25ff17$export$7d15b64cf5a3a4c4)(1.0 - this.timeRemaining / this.delay);
        this.duringEffect?.(dt, t);
        if (this.timeRemaining <= 0) {
            this.endEffect?.();
            this.destroy();
        }
    }
}
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $aa1f0309d9dba6d2$export$af631764ddc44097)("render")
], $c59361981bac2575$var$RenderTimer.prototype, "onRender", null);
function $c59361981bac2575$var$isTimer(e) {
    return e instanceof $c59361981bac2575$var$Timer;
}



class $0fd7a79b4c40c2d4$export$a74d3484492ce83d extends (0, $c59361981bac2575$export$4342ba5c6ad1f6f1) {
    onAdd() {
        document.addEventListener("visibilitychange", this.onVisibilityChange);
    }
    onDestroy() {
        document.removeEventListener("visibilitychange", this.onVisibilityChange);
    }
    constructor(...args){
        super(...args), this.pausable = false, this.persistenceLevel = 100, this.autoPaused = false, this.onVisibilityChange = ()=>{
            if (document.hidden) {
                if (!this.game.paused) {
                    this.game.pause();
                    this.autoPaused = true;
                }
            } else if (this.autoPaused && this.game.paused) {
                this.game.unpause();
                this.autoPaused = false;
            }
        };
    }
}
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $aa1f0309d9dba6d2$export$af631764ddc44097)("add")
], $0fd7a79b4c40c2d4$export$a74d3484492ce83d.prototype, "onAdd", null);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $aa1f0309d9dba6d2$export$af631764ddc44097)("destroy")
], $0fd7a79b4c40c2d4$export$a74d3484492ce83d.prototype, "onDestroy", null);





class $348f60db61f8cc25$export$ee4b0c6dc2df0875 {
    constructor({ parallax: parallax = (0, $6b6a54a072724620$export$e7c866399fa523f5)(1.0, 1.0), anchor: anchor = (0, $6b6a54a072724620$export$e7c866399fa523f5)(0, 0), alpha: alpha = 1.0, depth: depth = "none" } = {}){
        this.parallax = parallax;
        this.anchor = anchor;
        this.alpha = alpha;
        this.depth = depth;
    }
}


const $4fdefd1822880974$export$fdca3ba65b5cceec = {
    // Rendered first (on the bottom)
    // Boat renders FIRST with depth read-write. Intra-boat depth testing works
    // (deck covers keel, rigging over hull, etc). Depth buffer cleared to 0.
    boat: new (0, $348f60db61f8cc25$export$ee4b0c6dc2df0875)({
        depth: "read-write"
    }),
    // Surface renders AFTER the boat. Reads the depth buffer (boat z-heights) to
    // blend water over submerged boat parts with alpha based on submersion depth.
    // Terrain and deep water (no boat) render opaque. Shallow submersion is translucent.
    surface: new (0, $348f60db61f8cc25$export$ee4b0c6dc2df0875)({
        depth: "read-write"
    }),
    wake: new (0, $348f60db61f8cc25$export$ee4b0c6dc2df0875)(),
    trees: new (0, $348f60db61f8cc25$export$ee4b0c6dc2df0875)(),
    windParticles: new (0, $348f60db61f8cc25$export$ee4b0c6dc2df0875)(),
    // Wind visualization layer (toggled on/off)
    windViz: new (0, $348f60db61f8cc25$export$ee4b0c6dc2df0875)({
        alpha: 0
    }),
    // Stuff not in the world
    hud: new (0, $348f60db61f8cc25$export$ee4b0c6dc2df0875)({
        parallax: (0, $6b6a54a072724620$export$e7c866399fa523f5)(0, 0)
    }),
    // Stuff on the absolute top that's just used for debugging
    debugHud: new (0, $348f60db61f8cc25$export$ee4b0c6dc2df0875)({
        parallax: (0, $6b6a54a072724620$export$e7c866399fa523f5)(0, 0)
    })
};
const $4fdefd1822880974$export$3d0b505b9576cf7e = "boat";


/**
 * Define the layers that entities can tick in.
 * Layers are processed in the order they are defined in this array.
 * The first layer is processed first, and the last layer is processed last.
 */ const $6145a191889e9b21$export$14b9f468219135 = [
    "input",
    "environment",
    "query",
    "main",
    "sail",
    "effects",
    "camera"
];
const $6145a191889e9b21$export$259dfd4c89c896a0 = "main";


class $1d29da6ad0b954b4$export$909c3b6a9e12845c {
    beginContact(event) {
        if ($1d29da6ad0b954b4$var$shouldTrack(event)) this.contacts.push(event);
    }
    endContact(event) {
        if ($1d29da6ad0b954b4$var$shouldTrack(event)) {
            const index = this.contacts.findIndex((info)=>$1d29da6ad0b954b4$var$contactsAreEqual(info, event));
            if (index !== -1) this.contacts.splice(index, 1);
        }
    }
    getContacts() {
        return this.contacts;
    }
    constructor(){
        this.contacts = [];
    }
}
/** Whether or not this is a collision we need to keep track of */ function $1d29da6ad0b954b4$var$shouldTrack(_event) {
    return true;
}
/** Whether or not two contact events represent the same contact */ function $1d29da6ad0b954b4$var$contactsAreEqual(a, b) {
    return a.bodyA === b.bodyA && a.bodyB === b.bodyB && a.shapeA === b.shapeA && a.shapeB === b.shapeB || a.bodyA === b.bodyB && a.bodyB === b.bodyA && a.shapeA === b.shapeB && a.shapeB === b.shapeA;
}





const $82e66643116ed123$export$57d24cb2f04f6e96 = (e)=>Boolean(e.body);


/** Function that takes an item and returns true if it is of the desired type */ class $04179bd0fe63c1d8$export$7ac4a5983ab98376 {
    constructor(predicate){
        this.predicate = predicate;
        this.items = new Set();
    }
    addIfValid(item) {
        if (this.predicate(item)) this.items.add(item);
        else this.remove(item);
    }
    remove(item) {
        // No predicate check - item may have changed state since being added
        this.items.delete(item);
    }
    clear() {
        this.items.clear();
    }
    get size() {
        return this.items.size;
    }
    get length() {
        return this.items.size;
    }
    [Symbol.iterator]() {
        return this.items[Symbol.iterator]();
    }
}


class $2bdf816bbe356527$export$eadac383198be9f3 {
    constructor(filters = []){
        this.sets = new Map();
        for (const filter of filters)this.addFilter(filter);
    }
    addFilter(filter, all = []) {
        if (!this.sets.has(filter)) {
            const set = new (0, $04179bd0fe63c1d8$export$7ac4a5983ab98376)(filter);
            for (const item of all)set.addIfValid(item);
            this.sets.set(filter, set);
        }
    }
    removeFilter(filter) {
        this.sets.delete(filter);
    }
    addItem(item) {
        for (const list of this.sets.values())list.addIfValid(item);
    }
    removeItem(item) {
        for (const list of this.sets.values())list.remove(item);
    }
    getItems(filter) {
        return this.sets.get(filter);
    }
}


const $87f8f36bde0fd367$var$EMPTY_SET = new Set();
class $87f8f36bde0fd367$export$c43b025112e292e2 {
    constructor(){
        this.map = new Map();
    }
    add(key, value) {
        if (!this.map.has(key)) this.map.set(key, new Set([
            value
        ]));
        else this.map.get(key).add(value);
    }
    get(key) {
        return this.map.get(key) ?? $87f8f36bde0fd367$var$EMPTY_SET;
    }
    has(key, value) {
        return this.map.has(key) && this.map.get(key).has(value);
    }
    remove(key, value) {
        const set = this.map.get(key);
        if (!set) throw new Error(`<${key}:${value}> not found`);
        const existed = set.delete(value);
        if (!existed) throw new Error(`<${key}:${value}> not found`);
        if (set.size === 0) this.map.delete(key);
    }
}


class $913c3d10ae4e12ec$export$8bb466c13870163e {
    constructor(){
        /** Maps entity ids to entities */ this.idToEntity = new Map();
        /** Maps tags to entities */ this.tagged = new (0, $87f8f36bde0fd367$export$c43b025112e292e2)();
        /** Maps event types to entities that handle them */ this.handlers = new (0, $87f8f36bde0fd367$export$c43b025112e292e2)();
        /** Maps filters to entities that pass them */ this.filters = new (0, $2bdf816bbe356527$export$eadac383198be9f3)();
        /** Maps render layers to entities that render on them */ this.renderLayerEntities = new (0, $87f8f36bde0fd367$export$c43b025112e292e2)();
        /** Maps tick layers to entities that tick on them */ this.tickLayerEntities = new (0, $87f8f36bde0fd367$export$c43b025112e292e2)();
        /** Maps constructors to entities of that type */ this.constructorMap = new (0, $87f8f36bde0fd367$export$c43b025112e292e2)();
        /** All entities */ this.all = new Set();
        this.addFilter((0, $82e66643116ed123$export$57d24cb2f04f6e96));
    }
    get withBody() {
        return this.getByFilter((0, $82e66643116ed123$export$57d24cb2f04f6e96));
    }
    /** Adds an entity to this list and all sublists and does all the bookkeeping */ add(entity) {
        this.all.add(entity);
        this.filters.addItem(entity);
        if (entity.tags) for (const tag of entity.tags)this.tagged.add(tag, entity);
        for (const eventName of (0, $aa1f0309d9dba6d2$export$2f4ceae90681485c)(entity))this.handlers.add(eventName, entity);
        // Index by render layer for efficient per-layer rendering
        if (this.handlers.get("render").has(entity)) {
            const layers = entity.layers ?? [
                entity.layer ?? (0, $4fdefd1822880974$export$3d0b505b9576cf7e)
            ];
            for (const layer of layers)this.renderLayerEntities.add(layer, entity);
        }
        // Index by tick layer for efficient per-layer ticking
        if (this.handlers.get("tick").has(entity)) {
            const tickLayers = entity.tickLayers ?? [
                entity.tickLayer ?? (0, $6145a191889e9b21$export$259dfd4c89c896a0)
            ];
            for (const layer of tickLayers)this.tickLayerEntities.add(layer, entity);
        }
        // Index by constructor for type-based queries
        this.constructorMap.add(entity.constructor, entity);
        if (entity.id) {
            if (this.idToEntity.has(entity.id)) throw new Error(`entities with duplicate ids: ${entity.id}`);
            this.idToEntity.set(entity.id, entity);
        }
    }
    /** Removes an entity from this list and all the sublists and does some bookkeeping */ remove(entity) {
        this.all.delete(entity);
        this.filters.removeItem(entity);
        if (entity.tags) for (const tag of entity.tags)this.tagged.remove(tag, entity);
        // Remove from layer index before removing from handlers (need to check handlers.has first)
        if (this.handlers.has("render", entity)) {
            const layers = entity.layers ?? [
                entity.layer ?? (0, $4fdefd1822880974$export$3d0b505b9576cf7e)
            ];
            for (const layer of layers)this.renderLayerEntities.remove(layer, entity);
        }
        // Remove from tick layer index before removing from handlers
        if (this.handlers.has("tick", entity)) {
            const tickLayers = entity.tickLayers ?? [
                entity.tickLayer ?? (0, $6145a191889e9b21$export$259dfd4c89c896a0)
            ];
            for (const layer of tickLayers)this.tickLayerEntities.remove(layer, entity);
        }
        for (const eventName of (0, $aa1f0309d9dba6d2$export$2f4ceae90681485c)(entity))this.handlers.remove(eventName, entity);
        // Remove from constructor index
        this.constructorMap.remove(entity.constructor, entity);
        if (entity.id) this.idToEntity.delete(entity.id);
    }
    /** Get the entity with the given id. */ getById(id) {
        return this.idToEntity.get(id);
    }
    /** Returns all entities with the given tag. */ getTagged(tag) {
        return this.tagged.get(tag);
    }
    /** Returns all entities that have all the given tags */ getTaggedAll(...tags) {
        if (tags.length === 0) return [];
        const result = new Set();
        const [firstTag, ...otherTags] = tags;
        for (const e of this.getTagged(firstTag))if (otherTags.every((t)=>e.tags.includes(t))) result.add(e);
        return result;
    }
    /** Returns all entities that have at least one of the given tags */ getTaggedAny(...tags) {
        const result = new Set();
        for (const tag of tags)for (const e of this.getTagged(tag))result.add(e);
        return result;
    }
    /** Adds a filter for fast lookup with getByFilter() in the future. */ addFilter(filter) {
        this.filters.addFilter(filter, this.all);
    }
    /** Removes a filter that was added with addFilter(). */ removeFilter(filter) {
        this.filters.removeFilter(filter);
    }
    /**
   * Return all the entities that pass a type guard.
   * Pair with addFilter() to make this fast.
   */ getByFilter(filter) {
        const result = this.filters.getItems(filter);
        return result ?? [
            ...this.all
        ].filter(filter);
    }
    /** Get all entities that handle a specific event type. */ getHandlers(eventType) {
        return this.handlers.get(eventType);
    }
    /** Get all entities that render on a specific layer. */ getRenderersOnLayer(layer) {
        return this.renderLayerEntities.get(layer);
    }
    /** Get all entities that tick on a specific layer. */ getTickersOnLayer(layer) {
        return this.tickLayerEntities.get(layer);
    }
    /**
   * Get all entities of a specific type.
   * @param constructor The entity class constructor
   * @returns A readonly set of all entities of that type
   */ byConstructor(constructor) {
        return this.constructorMap.get(constructor);
    }
    /**
   * Get the single entity of a specific type.
   * Throws if zero or multiple instances are found.
   * @param constructor The entity class constructor
   * @returns The single entity of that type
   */ getSingleton(constructor) {
        const instances = this.byConstructor(constructor);
        if (instances.size === 0) throw new Error(`No instance of ${constructor.name} found`);
        if (instances.size > 1) throw new Error(`Multiple instances of ${constructor.name} found (expected singleton)`);
        return [
            ...instances
        ][0];
    }
    /**
   * Try to get the single entity of a specific type.
   * Returns undefined if not found, throws if multiple instances are found.
   * @param constructor The entity class constructor
   * @returns The single entity of that type, or undefined if not found
   */ tryGetSingleton(constructor) {
        const instances = this.byConstructor(constructor);
        if (instances.size === 0) return undefined;
        if (instances.size > 1) throw new Error(`Multiple instances of ${constructor.name} found (expected singleton)`);
        return [
            ...instances
        ][0];
    }
    /** Iterate through all the entities. */ [Symbol.iterator]() {
        return this.all[Symbol.iterator]();
    }
}



function $c0f9b00b45d3abcb$export$e4d4fc2de3f8add7(eventName) {
    return `on${eventName.charAt(0).toUpperCase()}${eventName.slice(1)}`;
}
function $c0f9b00b45d3abcb$export$7f9b4f9156103c75(handlerName) {
    const firstLetter = handlerName[2];
    const rest = handlerName.slice(3);
    return firstLetter.toLowerCase() + rest;
}




/**
 * Polygon triangulation utilities.
 *
 * Provides ear clipping algorithm for triangulating simple (non-self-intersecting)
 * polygons. Works with both convex and concave polygons.
 */ function $dc2c60c9a54ba1c2$export$5c3967c9691b3a1b(points) {
    let area = 0;
    const n = points.length;
    for(let i = 0; i < n; i++){
        const j = (i + 1) % n;
        area += points[i].x * points[j].y;
        area -= points[j].x * points[i].y;
    }
    return area / 2;
}
/**
 * Check if point C is to the left of line AB.
 */ function $dc2c60c9a54ba1c2$var$isLeftOf(a, b, c) {
    return (b.x - a.x) * (c.y - a.y) - (b.y - a.y) * (c.x - a.x) > 0;
}
/**
 * Check if a point is strictly inside a triangle (not on edges).
 * Uses cross product signs - all three must have the same sign for point to be inside.
 */ function $dc2c60c9a54ba1c2$var$pointStrictlyInTriangle(p, a, b, c) {
    const d1 = (p.x - a.x) * (b.y - a.y) - (p.y - a.y) * (b.x - a.x);
    const d2 = (p.x - b.x) * (c.y - b.y) - (p.y - b.y) * (c.x - b.x);
    const d3 = (p.x - c.x) * (a.y - c.y) - (p.y - c.y) * (a.x - c.x);
    const eps = 1e-6;
    const allPositive = d1 > eps && d2 > eps && d3 > eps;
    const allNegative = d1 < -eps && d2 < -eps && d3 < -eps;
    return allPositive || allNegative;
}
/**
 * Check if vertex at index i is an ear (can be clipped).
 */ function $dc2c60c9a54ba1c2$var$isEar(polygon, points, i, isCCW) {
    const n = polygon.length;
    const prevIdx = polygon[(i - 1 + n) % n];
    const currIdx = polygon[i];
    const nextIdx = polygon[(i + 1) % n];
    const prev = points[prevIdx];
    const curr = points[currIdx];
    const next = points[nextIdx];
    // For CCW polygon, convex vertices "bulge out" to the RIGHT of chord prev->next
    // For CW polygon, convex vertices "bulge out" to the LEFT of chord prev->next
    const isConvex = isCCW ? !$dc2c60c9a54ba1c2$var$isLeftOf(prev, next, curr) : $dc2c60c9a54ba1c2$var$isLeftOf(prev, next, curr);
    if (!isConvex) return false;
    for(let j = 0; j < n; j++){
        if (j === (i - 1 + n) % n || j === i || j === (i + 1) % n) continue;
        const testIdx = polygon[j];
        if ($dc2c60c9a54ba1c2$var$pointStrictlyInTriangle(points[testIdx], prev, curr, next)) return false;
    }
    return true;
}
function $dc2c60c9a54ba1c2$export$4d77c9cbb3bd528(points) {
    const n = points.length;
    if (n < 3) return null;
    if (n === 3) return [
        0,
        1,
        2
    ];
    const area = $dc2c60c9a54ba1c2$export$5c3967c9691b3a1b(points);
    // Degenerate polygon with zero area
    if (Math.abs(area) < 1e-10) return null;
    const isCCW = area > 0;
    const polygon = [];
    for(let i = 0; i < n; i++)polygon.push(i);
    const triangles = [];
    let safety = n * n;
    while(polygon.length > 3 && safety > 0){
        safety--;
        let earFound = false;
        for(let i = 0; i < polygon.length; i++)if ($dc2c60c9a54ba1c2$var$isEar(polygon, points, i, isCCW)) {
            const prevI = (i - 1 + polygon.length) % polygon.length;
            const nextI = (i + 1) % polygon.length;
            triangles.push(polygon[prevI], polygon[i], polygon[nextI]);
            polygon.splice(i, 1);
            earFound = true;
            break;
        }
        if (!earFound) // Triangulation failed - likely self-intersecting or degenerate polygon
        return null;
    }
    if (polygon.length === 3) triangles.push(polygon[0], polygon[1], polygon[2]);
    return triangles;
}


/** Unpack a hex color (0xRRGGBB) into normalized rgba components. */ function $4ef1bda80ee10042$export$fdc57c66c20e939a(color, alpha) {
    return {
        r: (color >> 16 & 0xff) / 255,
        g: (color >> 8 & 0xff) / 255,
        b: (color & 0xff) / 255,
        a: alpha
    };
}



/**
 * Consumer interface for primitive tessellators.
 *
 * The shape vertex layout carried through this sink is:
 *   position(2) + color(4) + lightAffected(1) + z(1) = 8 floats = 32 bytes/vertex
 * Transform (modelCol0..2, zCoeffs, zDepth, tint) is applied per-instance
 * in the vertex shader via a storage buffer — no transform data is written
 * through this sink.
 *
 * `lightAffected` is a 0..1 scalar that gates the global scene-lighting
 * tint applied by the shape pipeline. 1 = fully tinted (world objects),
 * 0 = pass-through (UI, debug overlays). Callers that go through Draw /
 * MeshBuilder set this via the `ignoreLight` option.
 *
 * Two concrete implementations exist:
 *   - ShapeBatch: writes into the live per-frame GPU batch. `base` is the
 *     running vertex count within that batch.
 *   - MeshBuilder: writes into a private growable buffer. `base` is the
 *     running vertex count within the mesh being built; the final mesh's
 *     indices are therefore 0-based relative to the mesh.
 *
 * Index semantics: callers write `base + localIdx` where `localIdx` is in
 * the primitive's own 0..n range. This keeps tessellators sink-agnostic —
 * the same code works for immediate-mode and retained-mode.
 */ const $0858672ccca83b12$export$c54d233df6da0831 = 8;
function $0858672ccca83b12$export$7e54ad1d2333ebc5(view, i, x, y, r, g, b, a, lightAffected, z) {
    const o = i * $0858672ccca83b12$export$c54d233df6da0831;
    view[o] = x;
    view[o + 1] = y;
    view[o + 2] = r;
    view[o + 3] = g;
    view[o + 4] = b;
    view[o + 5] = a;
    view[o + 6] = lightAffected;
    view[o + 7] = z;
}


function $fb3cdcc7c0040bec$export$f94a86f019a975b5(sink, points, zPerPoint, width, color, alpha, lightAffected, opts = {}) {
    const n = points.length;
    if (n < 2) return;
    const { r: r, g: g, b: b, a: a } = (0, $4ef1bda80ee10042$export$fdc57c66c20e939a)(color, alpha);
    const halfWidth = width / 2;
    const closed = opts.closed ?? false;
    const roundJoins = opts.roundJoins ?? false;
    const roundCaps = opts.roundCaps ?? false;
    const zAt = typeof zPerPoint === "number" ? (_)=>zPerPoint : (i)=>zPerPoint[i];
    // Phase 1: compute offset vertex pairs (and optional round-join fans).
    // This mirrors the old tessellatePolylineToStrip logic but writes directly
    // via VertexSink. We do two passes: first gather vertex data into small
    // arrays, then reserve and write it in one shot per primitive.
    const emits = [];
    const pairStartForPoint = [];
    const perp = (dx, dy)=>{
        const len = Math.sqrt(dx * dx + dy * dy);
        if (len === 0) return [
            0,
            0
        ];
        return [
            -dy / len,
            dx / len
        ];
    };
    for(let i = 0; i < n; i++){
        const curr = points[i];
        const z = zAt(i);
        let prev = null;
        let next = null;
        if (i > 0) prev = points[i - 1];
        else if (closed) prev = points[n - 1];
        if (i < n - 1) next = points[i + 1];
        else if (closed) next = points[0];
        pairStartForPoint.push(emits.length);
        if (prev === null && next !== null) {
            const [nx, ny] = perp(next[0] - curr[0], next[1] - curr[1]);
            emits.push({
                cx: curr[0],
                cy: curr[1],
                z: z,
                nx: nx,
                ny: ny
            });
        } else if (next === null && prev !== null) {
            const [nx, ny] = perp(curr[0] - prev[0], curr[1] - prev[1]);
            emits.push({
                cx: curr[0],
                cy: curr[1],
                z: z,
                nx: nx,
                ny: ny
            });
        } else if (prev !== null && next !== null) {
            const [n1x, n1y] = perp(curr[0] - prev[0], curr[1] - prev[1]);
            const [n2x, n2y] = perp(next[0] - curr[0], next[1] - curr[1]);
            let mx = (n1x + n2x) / 2;
            let my = (n1y + n2y) / 2;
            const mLen = Math.sqrt(mx * mx + my * my);
            const dot = mLen > 0.001 ? n1x * mx + n1y * my : 0;
            const miterScale = dot > 0.1 ? 1 / dot : 10;
            if (roundJoins && miterScale > 1.05) {
                const angle1 = Math.atan2(n1y, n1x);
                let angle2 = Math.atan2(n2y, n2x);
                let angleDiff = angle2 - angle1;
                if (angleDiff > Math.PI) angleDiff -= 2 * Math.PI;
                if (angleDiff < -Math.PI) angleDiff += 2 * Math.PI;
                const steps = Math.max(2, Math.ceil(Math.abs(angleDiff) / (Math.PI / 8)));
                for(let s = 0; s <= steps; s++){
                    const angle = angle1 + angleDiff * (s / steps);
                    emits.push({
                        cx: curr[0],
                        cy: curr[1],
                        z: z,
                        nx: Math.cos(angle),
                        ny: Math.sin(angle)
                    });
                }
            } else {
                if (mLen > 0.001) {
                    const clampedScale = Math.min(miterScale, 1);
                    mx = mx / mLen * clampedScale;
                    my = my / mLen * clampedScale;
                } else {
                    mx = n1x;
                    my = n1y;
                }
                emits.push({
                    cx: curr[0],
                    cy: curr[1],
                    z: z,
                    nx: mx,
                    ny: my
                });
            }
        } else emits.push({
            cx: curr[0],
            cy: curr[1],
            z: z,
            nx: 0,
            ny: 1
        });
    }
    pairStartForPoint.push(emits.length);
    const caps = [];
    const capSteps = 8;
    if (roundCaps && !closed && n >= 2) {
        // Start cap: fan perpendicular-of-first-segment, sweeping backward.
        const p0 = points[0];
        const p1 = points[1];
        const [sp0x, sp0y] = perp(p1[0] - p0[0], p1[1] - p0[1]);
        caps.push({
            cx: p0[0],
            cy: p0[1],
            z: zAt(0),
            perpAngle: Math.atan2(sp0y, sp0x),
            sweep: Math.PI,
            capSteps: capSteps
        });
        const pLast = points[n - 1];
        const pPrev = points[n - 2];
        const [spLx, spLy] = perp(pLast[0] - pPrev[0], pLast[1] - pPrev[1]);
        caps.push({
            cx: pLast[0],
            cy: pLast[1],
            z: zAt(n - 1),
            perpAngle: Math.atan2(spLy, spLx),
            sweep: -Math.PI,
            capSteps: capSteps
        });
    }
    // Compute index count:
    //   For each strip segment between two vertex groups: (vertsInGroup_prev-1) * 6
    //   Plus within-group fans: (vertsInGroup - 1) * 6 where vertsInGroup > 1 (round-join)
    //   Plus cap fans: capSteps * 3 each
    let totalVerts = emits.length * 2;
    let totalIndices = 0;
    for(let i = 0; i < n; i++){
        const pairStart = pairStartForPoint[i];
        const pairEnd = pairStartForPoint[i + 1];
        const pairsHere = pairEnd - pairStart;
        if (pairsHere > 1) totalIndices += (pairsHere - 1) * 6;
    }
    const segmentConnections = closed ? n : n - 1;
    totalIndices += segmentConnections * 6;
    for (const cap of caps){
        totalVerts += cap.capSteps + 2; // center + (capSteps+1) rim
        totalIndices += cap.capSteps * 3;
    }
    const { base: base, view: view } = sink.reserveVertices(totalVerts);
    const idxData = sink.reserveIndices(totalIndices);
    // Write offset pairs.
    for(let e = 0; e < emits.length; e++){
        const { cx: cx, cy: cy, z: z, nx: nx, ny: ny } = emits[e];
        (0, $0858672ccca83b12$export$7e54ad1d2333ebc5)(view, e * 2, cx + nx * halfWidth, cy + ny * halfWidth, r, g, b, a, lightAffected, z);
        (0, $0858672ccca83b12$export$7e54ad1d2333ebc5)(view, e * 2 + 1, cx - nx * halfWidth, cy - ny * halfWidth, r, g, b, a, lightAffected, z);
    }
    // Build index list.
    let iOut = 0;
    // Within-vertex fans (round joins produce multiple pairs per vertex).
    for(let i = 0; i < n; i++){
        const pairStart = pairStartForPoint[i];
        const pairEnd = pairStartForPoint[i + 1];
        for(let p = pairStart; p < pairEnd - 1; p++){
            const p0 = base + p * 2;
            const p1 = base + p * 2 + 1;
            const p2 = base + (p + 1) * 2;
            const p3 = base + (p + 1) * 2 + 1;
            idxData[iOut++] = p0;
            idxData[iOut++] = p2;
            idxData[iOut++] = p3;
            idxData[iOut++] = p0;
            idxData[iOut++] = p3;
            idxData[iOut++] = p1;
        }
    }
    // Between-vertex strip connections.
    for(let i = 0; i < segmentConnections; i++){
        const a0 = pairStartForPoint[i + 1] - 1; // last pair of vertex i
        const b0 = pairStartForPoint[closed && i === n - 1 ? 0 : i + 1]; // first pair of vertex i+1 (or 0 when closing)
        const v0 = base + a0 * 2;
        const v1 = base + a0 * 2 + 1;
        const v2 = base + b0 * 2;
        const v3 = base + b0 * 2 + 1;
        idxData[iOut++] = v0;
        idxData[iOut++] = v2;
        idxData[iOut++] = v3;
        idxData[iOut++] = v0;
        idxData[iOut++] = v3;
        idxData[iOut++] = v1;
    }
    // Caps.
    let capVertBase = emits.length * 2;
    for (const cap of caps){
        const center = base + capVertBase;
        (0, $0858672ccca83b12$export$7e54ad1d2333ebc5)(view, capVertBase, cap.cx, cap.cy, r, g, b, a, lightAffected, cap.z);
        for(let s = 0; s <= cap.capSteps; s++){
            const angle = cap.perpAngle + cap.sweep * s / cap.capSteps;
            (0, $0858672ccca83b12$export$7e54ad1d2333ebc5)(view, capVertBase + 1 + s, cap.cx + Math.cos(angle) * halfWidth, cap.cy + Math.sin(angle) * halfWidth, r, g, b, a, lightAffected, cap.z);
            if (s > 0) {
                idxData[iOut++] = center;
                idxData[iOut++] = center + s;
                idxData[iOut++] = center + s + 1;
            }
        }
        capVertBase += cap.capSteps + 2;
    }
}
function $fb3cdcc7c0040bec$export$7b4f6c6bc77609bd(sink, points, zPerPoint, width, tilt, color, alpha, lightAffected, opts = {}) {
    const n = points.length;
    if (n < 2) return;
    const { r: r, g: g, b: b, a: a } = (0, $4ef1bda80ee10042$export$fdc57c66c20e939a)(color, alpha);
    const halfWidth = width / 2;
    const closed = opts.closed ?? false;
    const roundJoins = opts.roundJoins ?? false;
    const roundCaps = opts.roundCaps ?? false;
    // Unit screen-space perpendicular for a local segment.
    const screenPerpDir = (dx, dy, dz)=>{
        const sx = tilt.m00 * dx + tilt.m01 * dy + tilt.zx * dz;
        const sy = tilt.m10 * dx + tilt.m11 * dy + tilt.zy * dz;
        const len = Math.sqrt(sx * sx + sy * sy);
        if (len === 0) return [
            0,
            0
        ];
        return [
            -sy / len,
            sx / len
        ];
    };
    const toLocal = (sx, sy)=>[
            tilt.inv00 * sx + tilt.inv01 * sy,
            tilt.inv10 * sx + tilt.inv11 * sy
        ];
    const emits = [];
    const pairStartForPoint = [];
    for(let i = 0; i < n; i++){
        const curr = points[i];
        const currZ = zPerPoint[i];
        let prev = null;
        let prevZ = currZ;
        let next = null;
        let nextZ = currZ;
        if (i > 0) {
            prev = points[i - 1];
            prevZ = zPerPoint[i - 1];
        } else if (closed) {
            prev = points[n - 1];
            prevZ = zPerPoint[n - 1];
        }
        if (i < n - 1) {
            next = points[i + 1];
            nextZ = zPerPoint[i + 1];
        } else if (closed) {
            next = points[0];
            nextZ = zPerPoint[0];
        }
        pairStartForPoint.push(emits.length);
        if (prev === null && next !== null) {
            const [sx, sy] = screenPerpDir(next[0] - curr[0], next[1] - curr[1], nextZ - currZ);
            emits.push({
                cx: curr[0],
                cy: curr[1],
                z: currZ,
                sx: sx,
                sy: sy
            });
        } else if (next === null && prev !== null) {
            const [sx, sy] = screenPerpDir(curr[0] - prev[0], curr[1] - prev[1], currZ - prevZ);
            emits.push({
                cx: curr[0],
                cy: curr[1],
                z: currZ,
                sx: sx,
                sy: sy
            });
        } else if (prev !== null && next !== null) {
            const [s1x, s1y] = screenPerpDir(curr[0] - prev[0], curr[1] - prev[1], currZ - prevZ);
            const [s2x, s2y] = screenPerpDir(next[0] - curr[0], next[1] - curr[1], nextZ - currZ);
            let mx = (s1x + s2x) / 2;
            let my = (s1y + s2y) / 2;
            const mLen = Math.sqrt(mx * mx + my * my);
            const dot = mLen > 0.001 ? s1x * mx + s1y * my : 0;
            const miterScale = dot > 0.1 ? 1 / dot : 10;
            if (roundJoins && miterScale > 1.05) {
                const angle1 = Math.atan2(s1y, s1x);
                let angle2 = Math.atan2(s2y, s2x);
                let angleDiff = angle2 - angle1;
                if (angleDiff > Math.PI) angleDiff -= 2 * Math.PI;
                if (angleDiff < -Math.PI) angleDiff += 2 * Math.PI;
                const steps = Math.max(2, Math.ceil(Math.abs(angleDiff) / (Math.PI / 8)));
                for(let s = 0; s <= steps; s++){
                    const angle = angle1 + angleDiff * (s / steps);
                    emits.push({
                        cx: curr[0],
                        cy: curr[1],
                        z: currZ,
                        sx: Math.cos(angle),
                        sy: Math.sin(angle)
                    });
                }
            } else {
                if (mLen > 0.001) {
                    const clampedScale = Math.min(miterScale, 1);
                    mx = mx / mLen * clampedScale;
                    my = my / mLen * clampedScale;
                } else {
                    mx = s1x;
                    my = s1y;
                }
                emits.push({
                    cx: curr[0],
                    cy: curr[1],
                    z: currZ,
                    sx: mx,
                    sy: my
                });
            }
        } else emits.push({
            cx: curr[0],
            cy: curr[1],
            z: currZ,
            sx: 0,
            sy: 1
        });
    }
    pairStartForPoint.push(emits.length);
    const capSteps = 8;
    const caps = [];
    if (roundCaps && !closed && n >= 2) {
        const p0 = points[0];
        const p1 = points[1];
        const [sp0x, sp0y] = screenPerpDir(p1[0] - p0[0], p1[1] - p0[1], zPerPoint[1] - zPerPoint[0]);
        caps.push({
            cx: p0[0],
            cy: p0[1],
            z: zPerPoint[0],
            perpSx: sp0x,
            perpSy: sp0y,
            sweep: Math.PI
        });
        const pLast = points[n - 1];
        const pPrev = points[n - 2];
        const [spLx, spLy] = screenPerpDir(pLast[0] - pPrev[0], pLast[1] - pPrev[1], zPerPoint[n - 1] - zPerPoint[n - 2]);
        caps.push({
            cx: pLast[0],
            cy: pLast[1],
            z: zPerPoint[n - 1],
            perpSx: spLx,
            perpSy: spLy,
            sweep: -Math.PI
        });
    }
    let totalVerts = emits.length * 2;
    let totalIndices = 0;
    for(let i = 0; i < n; i++){
        const pairsHere = pairStartForPoint[i + 1] - pairStartForPoint[i];
        if (pairsHere > 1) totalIndices += (pairsHere - 1) * 6;
    }
    const segmentConnections = closed ? n : n - 1;
    totalIndices += segmentConnections * 6;
    for (const _ of caps){
        totalVerts += capSteps + 2;
        totalIndices += capSteps * 3;
    }
    const { base: base, view: view } = sink.reserveVertices(totalVerts);
    const idxData = sink.reserveIndices(totalIndices);
    for(let e = 0; e < emits.length; e++){
        const { cx: cx, cy: cy, z: z, sx: sx, sy: sy } = emits[e];
        const [lx, ly] = toLocal(sx, sy);
        (0, $0858672ccca83b12$export$7e54ad1d2333ebc5)(view, e * 2, cx + lx * halfWidth, cy + ly * halfWidth, r, g, b, a, lightAffected, z);
        (0, $0858672ccca83b12$export$7e54ad1d2333ebc5)(view, e * 2 + 1, cx - lx * halfWidth, cy - ly * halfWidth, r, g, b, a, lightAffected, z);
    }
    let iOut = 0;
    for(let i = 0; i < n; i++){
        const pairStart = pairStartForPoint[i];
        const pairEnd = pairStartForPoint[i + 1];
        for(let p = pairStart; p < pairEnd - 1; p++){
            const p0 = base + p * 2;
            const p1 = base + p * 2 + 1;
            const p2 = base + (p + 1) * 2;
            const p3 = base + (p + 1) * 2 + 1;
            idxData[iOut++] = p0;
            idxData[iOut++] = p2;
            idxData[iOut++] = p3;
            idxData[iOut++] = p0;
            idxData[iOut++] = p3;
            idxData[iOut++] = p1;
        }
    }
    for(let i = 0; i < segmentConnections; i++){
        const a0 = pairStartForPoint[i + 1] - 1;
        const b0 = pairStartForPoint[closed && i === n - 1 ? 0 : i + 1];
        const v0 = base + a0 * 2;
        const v1 = base + a0 * 2 + 1;
        const v2 = base + b0 * 2;
        const v3 = base + b0 * 2 + 1;
        idxData[iOut++] = v0;
        idxData[iOut++] = v2;
        idxData[iOut++] = v3;
        idxData[iOut++] = v0;
        idxData[iOut++] = v3;
        idxData[iOut++] = v1;
    }
    let capVertBase = emits.length * 2;
    for (const cap of caps){
        const perpAngle = Math.atan2(cap.perpSy, cap.perpSx);
        const center = base + capVertBase;
        (0, $0858672ccca83b12$export$7e54ad1d2333ebc5)(view, capVertBase, cap.cx, cap.cy, r, g, b, a, lightAffected, cap.z);
        for(let s = 0; s <= capSteps; s++){
            const angle = perpAngle + cap.sweep * s / capSteps;
            const sx = Math.cos(angle);
            const sy = Math.sin(angle);
            const [lx, ly] = toLocal(sx, sy);
            (0, $0858672ccca83b12$export$7e54ad1d2333ebc5)(view, capVertBase + 1 + s, cap.cx + lx * halfWidth, cap.cy + ly * halfWidth, r, g, b, a, lightAffected, cap.z);
            if (s > 0) {
                idxData[iOut++] = center;
                idxData[iOut++] = center + s;
                idxData[iOut++] = center + s + 1;
            }
        }
        capVertBase += capSteps + 2;
    }
}



function $16042ed6b16a1b3f$export$9d17f42aa9bfb878(sink, vertices, color, alpha, lightAffected, z) {
    if (vertices.length < 3) return;
    const indices = (0, $dc2c60c9a54ba1c2$export$4d77c9cbb3bd528)(vertices);
    if (!indices) return;
    const { r: r, g: g, b: b, a: a } = (0, $4ef1bda80ee10042$export$fdc57c66c20e939a)(color, alpha);
    const { base: base, view: view } = sink.reserveVertices(vertices.length);
    for(let i = 0; i < vertices.length; i++)(0, $0858672ccca83b12$export$7e54ad1d2333ebc5)(view, i, vertices[i].x, vertices[i].y, r, g, b, a, lightAffected, z);
    const idxSlice = sink.reserveIndices(indices.length);
    for(let i = 0; i < indices.length; i++)idxSlice[i] = base + indices[i];
}
function $16042ed6b16a1b3f$export$c179dbc0644b9f5(sink, vertices, color, alpha, lightAffected, z) {
    const n = vertices.length;
    if (n < 3) return;
    const { r: r, g: g, b: b, a: a } = (0, $4ef1bda80ee10042$export$fdc57c66c20e939a)(color, alpha);
    const { base: base, view: view } = sink.reserveVertices(n);
    for(let i = 0; i < n; i++)(0, $0858672ccca83b12$export$7e54ad1d2333ebc5)(view, i, vertices[i][0], vertices[i][1], r, g, b, a, lightAffected, z);
    const idxSlice = sink.reserveIndices((n - 2) * 3);
    for(let i = 1; i < n - 1; i++){
        idxSlice[(i - 1) * 3 + 0] = base;
        idxSlice[(i - 1) * 3 + 1] = base + i;
        idxSlice[(i - 1) * 3 + 2] = base + i + 1;
    }
}
function $16042ed6b16a1b3f$export$72864f48dc9653a5(sink, vertices, width, color, alpha, lightAffected, z) {
    if (vertices.length < 2) return;
    const points = [];
    for (const v of vertices)points.push([
        v.x,
        v.y
    ]);
    (0, $fb3cdcc7c0040bec$export$f94a86f019a975b5)(sink, points, z, width, color, alpha, lightAffected, {
        closed: true
    });
}



function $4dd2b661c536c138$export$8d57a5ceabfaabff(sink, points, color, alpha, lightAffected, z) {
    if (points.length < 3) return;
    const arr = [];
    for (const p of points)arr.push([
        p.x,
        p.y
    ]);
    (0, $16042ed6b16a1b3f$export$c179dbc0644b9f5)(sink, arr, color, alpha, lightAffected, z);
}
function $4dd2b661c536c138$export$5eac3d443640e09c(sink, points, width, closed, color, alpha, lightAffected, z) {
    let pts = points;
    if (closed && pts.length >= 3) {
        const first = pts[0];
        const last = pts[pts.length - 1];
        const dx = last.x - first.x;
        const dy = last.y - first.y;
        if (dx * dx + dy * dy < 1e-6) pts = pts.slice(0, -1);
    }
    if (pts.length < 2) return;
    const arr = [];
    for (const p of pts)arr.push([
        p.x,
        p.y
    ]);
    (0, $fb3cdcc7c0040bec$export$f94a86f019a975b5)(sink, arr, z, width, color, alpha, lightAffected, {
        closed: closed
    });
}


class $36c62e853c0e746f$export$e714624f7828404d {
    static{
        this.warningKeys = new Set();
    }
    constructor(renderer){
        this.renderer = renderer;
        this.points = [];
        this.pathStarted = false;
        this.closed = false;
    }
    warnOnce(key, message) {
        if ($36c62e853c0e746f$export$e714624f7828404d.warningKeys.has(key)) return;
        $36c62e853c0e746f$export$e714624f7828404d.warningKeys.add(key);
        console.warn(message);
    }
    /** Move to a point without drawing */ moveTo(x, y) {
        this.points = [
            (0, $6b6a54a072724620$export$e7c866399fa523f5)(x, y)
        ];
        this.pathStarted = true;
        return this;
    }
    /** Draw a line to a point */ lineTo(x, y) {
        if (!this.pathStarted) {
            this.warnOnce("lineTo-implicit-moveTo", "PathBuilder.lineTo called before moveTo; starting path at the line endpoint.");
            this.moveTo(x, y);
        } else this.points.push((0, $6b6a54a072724620$export$e7c866399fa523f5)(x, y));
        return this;
    }
    /** Draw a quadratic Bézier curve */ quadraticTo(cpx, cpy, x, y) {
        if (!this.pathStarted || this.points.length === 0) {
            this.warnOnce("quadraticTo-implicit-start", "PathBuilder.quadraticTo called before moveTo; starting path at control point.");
            this.moveTo(cpx, cpy);
            this.lineTo(x, y);
            return this;
        }
        // Approximate quadratic bezier with line segments
        const start = this.points[this.points.length - 1];
        const cp = (0, $6b6a54a072724620$export$e7c866399fa523f5)(cpx, cpy);
        const end = (0, $6b6a54a072724620$export$e7c866399fa523f5)(x, y);
        const segments = 8;
        for(let i = 1; i <= segments; i++){
            const t = i / segments;
            const t2 = t * t;
            const mt = 1 - t;
            const mt2 = mt * mt;
            // Quadratic bezier: B(t) = (1-t)²P0 + 2(1-t)tP1 + t²P2
            const px = mt2 * start.x + 2 * mt * t * cp.x + t2 * end.x;
            const py = mt2 * start.y + 2 * mt * t * cp.y + t2 * end.y;
            this.points.push((0, $6b6a54a072724620$export$e7c866399fa523f5)(px, py));
        }
        return this;
    }
    /** Draw a cubic Bézier curve */ cubicTo(cp1x, cp1y, cp2x, cp2y, x, y) {
        if (!this.pathStarted || this.points.length === 0) {
            this.warnOnce("cubicTo-implicit-start", "PathBuilder.cubicTo called before moveTo; starting path at first control point.");
            this.moveTo(cp1x, cp1y);
            this.lineTo(x, y);
            return this;
        }
        const start = this.points[this.points.length - 1];
        const cp1 = (0, $6b6a54a072724620$export$e7c866399fa523f5)(cp1x, cp1y);
        const cp2 = (0, $6b6a54a072724620$export$e7c866399fa523f5)(cp2x, cp2y);
        const end = (0, $6b6a54a072724620$export$e7c866399fa523f5)(x, y);
        const segments = 16;
        for(let i = 1; i <= segments; i++){
            const t = i / segments;
            const t2 = t * t;
            const t3 = t2 * t;
            const mt = 1 - t;
            const mt2 = mt * mt;
            const mt3 = mt2 * mt;
            // Cubic bezier: B(t) = (1-t)³P0 + 3(1-t)²tP1 + 3(1-t)t²P2 + t³P3
            const px = mt3 * start.x + 3 * mt2 * t * cp1.x + 3 * mt * t2 * cp2.x + t3 * end.x;
            const py = mt3 * start.y + 3 * mt2 * t * cp1.y + 3 * mt * t2 * cp2.y + t3 * end.y;
            this.points.push((0, $6b6a54a072724620$export$e7c866399fa523f5)(px, py));
        }
        return this;
    }
    /**
   * Draw a Catmull-Rom spline through the given points.
   * The spline continues from the current path position through all points.
   */ splineTo(points, tension = 0.5) {
        if (!this.pathStarted || this.points.length === 0) {
            if (points.length > 0) {
                this.moveTo(points[0].x, points[0].y);
                points = points.slice(1);
            } else return this;
        }
        if (points.length === 0) return this;
        // Include the current position as the first control point
        const allPoints = [
            this.points[this.points.length - 1],
            ...points
        ];
        const n = allPoints.length;
        const segmentsPerSpan = 8;
        for(let i = 0; i < n - 1; i++){
            const p0 = allPoints[Math.max(0, i - 1)];
            const p1 = allPoints[i];
            const p2 = allPoints[i + 1];
            const p3 = allPoints[Math.min(n - 1, i + 2)];
            // Compute tangents with tension
            const m1x = tension * (p2.x - p0.x);
            const m1y = tension * (p2.y - p0.y);
            const m2x = tension * (p3.x - p1.x);
            const m2y = tension * (p3.y - p1.y);
            for(let j = 1; j <= segmentsPerSpan; j++){
                const t = j / segmentsPerSpan;
                const t2 = t * t;
                const t3 = t2 * t;
                // Hermite basis functions
                const h00 = 2 * t3 - 3 * t2 + 1;
                const h10 = t3 - 2 * t2 + t;
                const h01 = -2 * t3 + 3 * t2;
                const h11 = t3 - t2;
                const px = h00 * p1.x + h10 * m1x + h01 * p2.x + h11 * m2x;
                const py = h00 * p1.y + h10 * m1y + h01 * p2.y + h11 * m2y;
                this.points.push((0, $6b6a54a072724620$export$e7c866399fa523f5)(px, py));
            }
        }
        return this;
    }
    /**
   * Apply Chaikin's corner-cutting algorithm to smooth the path.
   * Each iteration doubles the number of points and smooths corners.
   */ smooth(iterations = 2) {
        if (this.points.length < 3) {
            this.warnOnce("smooth-too-few-points", "PathBuilder.smooth skipped because path has fewer than 3 points.");
            return this;
        }
        for(let iter = 0; iter < iterations; iter++){
            const newPoints = [];
            const n = this.points.length;
            const isClosed = this.closed;
            for(let i = 0; i < n; i++){
                const curr = this.points[i];
                const nextIdx = isClosed ? (i + 1) % n : Math.min(i + 1, n - 1);
                const next = this.points[nextIdx];
                if (!isClosed && i === n - 1) // Keep the last point for open paths
                newPoints.push(curr.clone());
                else {
                    // Q = 0.75 * P[i] + 0.25 * P[i+1]
                    // R = 0.25 * P[i] + 0.75 * P[i+1]
                    newPoints.push((0, $6b6a54a072724620$export$e7c866399fa523f5)(0.75 * curr.x + 0.25 * next.x, 0.75 * curr.y + 0.25 * next.y));
                    newPoints.push((0, $6b6a54a072724620$export$e7c866399fa523f5)(0.25 * curr.x + 0.75 * next.x, 0.25 * curr.y + 0.75 * next.y));
                }
            }
            this.points = newPoints;
        }
        return this;
    }
    /** Close the path back to the starting point */ close() {
        this.closed = true;
        return this;
    }
    /** Fill the path with a color */ fill(color, alpha = 1, ignoreLight = false) {
        if (this.points.length < 3) {
            this.warnOnce("fill-too-few-points", "PathBuilder.fill skipped because path has fewer than 3 points.");
            return;
        }
        // Pass 0 as the per-vertex z: the transform's zBase already carries
        // currentZ, so emitting currentZ again per-vertex would double-apply.
        (0, $4dd2b661c536c138$export$8d57a5ceabfaabff)(this.renderer.prepareShapeSink(), this.points, color, alpha, ignoreLight ? 0 : 1, 0);
    }
    /** Stroke the path outline */ stroke(color, width = 1, alpha = 1, ignoreLight = false) {
        if (this.points.length < 2) {
            this.warnOnce("stroke-too-few-points", "PathBuilder.stroke skipped because path has fewer than 2 points.");
            return;
        }
        (0, $4dd2b661c536c138$export$5eac3d443640e09c)(this.renderer.prepareShapeSink(), this.points, width, this.closed && this.points.length >= 3, color, alpha, ignoreLight ? 0 : 1, 0);
    }
}




function $d901f631a5871919$export$5565c25cb2b768d0(sink, cx, cy, radius, segments, color, alpha, lightAffected, z) {
    const { r: r, g: g, b: b, a: a } = (0, $4ef1bda80ee10042$export$fdc57c66c20e939a)(color, alpha);
    const { base: base, view: view } = sink.reserveVertices(segments + 2);
    (0, $0858672ccca83b12$export$7e54ad1d2333ebc5)(view, 0, cx, cy, r, g, b, a, lightAffected, z);
    for(let i = 0; i <= segments; i++){
        const angle = i / segments * Math.PI * 2;
        (0, $0858672ccca83b12$export$7e54ad1d2333ebc5)(view, i + 1, cx + Math.cos(angle) * radius, cy + Math.sin(angle) * radius, r, g, b, a, lightAffected, z);
    }
    const idx = sink.reserveIndices(segments * 3);
    for(let i = 0; i < segments; i++){
        idx[i * 3] = base;
        idx[i * 3 + 1] = base + 1 + i;
        idx[i * 3 + 2] = base + 1 + (i + 1) % (segments + 1);
    }
}
function $d901f631a5871919$export$f45a1332dc3b17ed(sink, cx, cy, radius, cos, sin, color, alpha, lightAffected, z) {
    const segments = cos.length - 1;
    const { r: r, g: g, b: b, a: a } = (0, $4ef1bda80ee10042$export$fdc57c66c20e939a)(color, alpha);
    const { base: base, view: view } = sink.reserveVertices(segments + 2);
    (0, $0858672ccca83b12$export$7e54ad1d2333ebc5)(view, 0, cx, cy, r, g, b, a, lightAffected, z);
    for(let i = 0; i <= segments; i++)(0, $0858672ccca83b12$export$7e54ad1d2333ebc5)(view, i + 1, cx + cos[i] * radius, cy + sin[i] * radius, r, g, b, a, lightAffected, z);
    const idx = sink.reserveIndices(segments * 3);
    for(let i = 0; i < segments; i++){
        idx[i * 3] = base;
        idx[i * 3 + 1] = base + 1 + i;
        idx[i * 3 + 2] = base + 1 + (i + 1) % (segments + 1);
    }
}




function $fe0225da88bd1ba6$export$7abebd0236210336(sink, x1, y1, x2, y2, width, color, alpha, lightAffected, z) {
    const dx = x2 - x1;
    const dy = y2 - y1;
    const len = Math.sqrt(dx * dx + dy * dy);
    if (len === 0) return;
    const hw = width / 2;
    const nx = -dy / len * hw;
    const ny = dx / len * hw;
    const { r: r, g: g, b: b, a: a } = (0, $4ef1bda80ee10042$export$fdc57c66c20e939a)(color, alpha);
    const { base: base, view: view } = sink.reserveVertices(4);
    (0, $0858672ccca83b12$export$7e54ad1d2333ebc5)(view, 0, x1 + nx, y1 + ny, r, g, b, a, lightAffected, z);
    (0, $0858672ccca83b12$export$7e54ad1d2333ebc5)(view, 1, x2 + nx, y2 + ny, r, g, b, a, lightAffected, z);
    (0, $0858672ccca83b12$export$7e54ad1d2333ebc5)(view, 2, x2 - nx, y2 - ny, r, g, b, a, lightAffected, z);
    (0, $0858672ccca83b12$export$7e54ad1d2333ebc5)(view, 3, x1 - nx, y1 - ny, r, g, b, a, lightAffected, z);
    const idx = sink.reserveIndices(6);
    idx[0] = base;
    idx[1] = base + 1;
    idx[2] = base + 2;
    idx[3] = base;
    idx[4] = base + 2;
    idx[5] = base + 3;
}
function $fe0225da88bd1ba6$export$a0b980ce0bbd9b6b(sink, x1, y1, z1, x2, y2, z2, width, tilt, color, alpha, lightAffected, roundCaps = false) {
    const dlx = x2 - x1;
    const dly = y2 - y1;
    const dlz = z2 - z1;
    const dsx = tilt.m00 * dlx + tilt.m01 * dly + tilt.zx * dlz;
    const dsy = tilt.m10 * dlx + tilt.m11 * dly + tilt.zy * dlz;
    const sLen = Math.sqrt(dsx * dsx + dsy * dsy);
    if (sLen < 1e-6) return;
    const hw = width / 2;
    const spx = -dsy / sLen * hw;
    const spy = dsx / sLen * hw;
    const nx = tilt.inv00 * spx + tilt.inv01 * spy;
    const ny = tilt.inv10 * spx + tilt.inv11 * spy;
    const { r: r, g: g, b: b, a: a } = (0, $4ef1bda80ee10042$export$fdc57c66c20e939a)(color, alpha);
    if (!roundCaps) {
        const { base: base, view: view } = sink.reserveVertices(4);
        (0, $0858672ccca83b12$export$7e54ad1d2333ebc5)(view, 0, x1 + nx, y1 + ny, r, g, b, a, lightAffected, z1);
        (0, $0858672ccca83b12$export$7e54ad1d2333ebc5)(view, 1, x2 + nx, y2 + ny, r, g, b, a, lightAffected, z2);
        (0, $0858672ccca83b12$export$7e54ad1d2333ebc5)(view, 2, x2 - nx, y2 - ny, r, g, b, a, lightAffected, z2);
        (0, $0858672ccca83b12$export$7e54ad1d2333ebc5)(view, 3, x1 - nx, y1 - ny, r, g, b, a, lightAffected, z1);
        const idx = sink.reserveIndices(6);
        idx[0] = base;
        idx[1] = base + 1;
        idx[2] = base + 2;
        idx[3] = base;
        idx[4] = base + 2;
        idx[5] = base + 3;
        return;
    }
    // With round caps: main quad (4 verts) + start cap (1 center + 9 rim) + end cap (1 + 9)
    const capSteps = 8;
    const vertsPerCap = capSteps + 2; // center + (capSteps + 1) rim
    const totalVerts = 4 + vertsPerCap * 2;
    const totalIdx = 6 + capSteps * 6;
    const { base: base, view: view } = sink.reserveVertices(totalVerts);
    (0, $0858672ccca83b12$export$7e54ad1d2333ebc5)(view, 0, x1 + nx, y1 + ny, r, g, b, a, lightAffected, z1);
    (0, $0858672ccca83b12$export$7e54ad1d2333ebc5)(view, 1, x2 + nx, y2 + ny, r, g, b, a, lightAffected, z2);
    (0, $0858672ccca83b12$export$7e54ad1d2333ebc5)(view, 2, x2 - nx, y2 - ny, r, g, b, a, lightAffected, z2);
    (0, $0858672ccca83b12$export$7e54ad1d2333ebc5)(view, 3, x1 - nx, y1 - ny, r, g, b, a, lightAffected, z1);
    const idx = sink.reserveIndices(totalIdx);
    idx[0] = base;
    idx[1] = base + 1;
    idx[2] = base + 2;
    idx[3] = base;
    idx[4] = base + 2;
    idx[5] = base + 3;
    const perpAngle = Math.atan2(spy, spx);
    const writeCap = (vStart, iStart, cx, cy, cz, sweep)=>{
        const center = base + vStart;
        (0, $0858672ccca83b12$export$7e54ad1d2333ebc5)(view, vStart, cx, cy, r, g, b, a, lightAffected, cz);
        for(let s = 0; s <= capSteps; s++){
            const angle = perpAngle + sweep * s / capSteps;
            const sx = Math.cos(angle) * hw;
            const sy = Math.sin(angle) * hw;
            (0, $0858672ccca83b12$export$7e54ad1d2333ebc5)(view, vStart + 1 + s, cx + tilt.inv00 * sx + tilt.inv01 * sy, cy + tilt.inv10 * sx + tilt.inv11 * sy, r, g, b, a, lightAffected, cz);
            if (s > 0) {
                idx[iStart + (s - 1) * 3] = center;
                idx[iStart + (s - 1) * 3 + 1] = center + s;
                idx[iStart + (s - 1) * 3 + 2] = center + s + 1;
            }
        }
    };
    writeCap(4, 6, x1, y1, z1, Math.PI);
    writeCap(4 + vertsPerCap, 6 + capSteps * 3, x2, y2, z2, -Math.PI);
}






function $8f4e7d9aea438fce$var$getCornerSegments(offset) {
    return (0, $2172aedd5a25ff17$export$7d15b64cf5a3a4c4)(Math.ceil(offset), 4, 12);
}
function $8f4e7d9aea438fce$export$ba3e537e375a99f9(vertices, radius) {
    const n = vertices.length;
    if (n < 3) return vertices.map((v)=>[
            v.x,
            v.y
        ]);
    const out = [];
    for(let i = 0; i < n; i++){
        const prev = vertices[(i - 1 + n) % n];
        const curr = vertices[i];
        const next = vertices[(i + 1) % n];
        const toPrevX = prev.x - curr.x;
        const toPrevY = prev.y - curr.y;
        const toNextX = next.x - curr.x;
        const toNextY = next.y - curr.y;
        const prevLen = Math.sqrt(toPrevX * toPrevX + toPrevY * toPrevY);
        const nextLen = Math.sqrt(toNextX * toNextX + toNextY * toNextY);
        const maxR = Math.min(prevLen, nextLen) / 2;
        const r = Math.min(radius, maxR);
        if (r <= 0.001) {
            out.push([
                curr.x,
                curr.y
            ]);
            continue;
        }
        const startX = curr.x + toPrevX / prevLen * r;
        const startY = curr.y + toPrevY / prevLen * r;
        const endX = curr.x + toNextX / nextLen * r;
        const endY = curr.y + toNextY / nextLen * r;
        const segments = $8f4e7d9aea438fce$var$getCornerSegments(r);
        for(let j = 0; j <= segments; j++){
            const t = j / segments;
            const mt = 1 - t;
            const mt2 = mt * mt;
            const t2 = t * t;
            out.push([
                mt2 * startX + 2 * mt * t * curr.x + t2 * endX,
                mt2 * startY + 2 * mt * t * curr.y + t2 * endY
            ]);
        }
    }
    return out;
}
function $8f4e7d9aea438fce$export$4da7bae4f644af90(sink, vertices, radius, color, alpha, lightAffected, z) {
    const rounded = $8f4e7d9aea438fce$export$ba3e537e375a99f9(vertices, radius);
    if (rounded.length < 3) return;
    (0, $16042ed6b16a1b3f$export$c179dbc0644b9f5)(sink, rounded, color, alpha, lightAffected, z);
}
function $8f4e7d9aea438fce$export$377d402a1c3d7c0a(sink, vertices, radius, width, color, alpha, lightAffected, z) {
    const rounded = $8f4e7d9aea438fce$export$ba3e537e375a99f9(vertices, radius);
    if (rounded.length < 2) return;
    (0, $16042ed6b16a1b3f$export$72864f48dc9653a5)(sink, rounded.map(([x, y])=>({
            x: x,
            y: y
        })), width, color, alpha, lightAffected, z);
}




function $5fb5fa1f65341e4a$export$4202d7a1c044998c(sink, cx, cy, z, radius, segments, tilt, color, alpha, lightAffected) {
    const { r: r, g: g, b: b, a: a } = (0, $4ef1bda80ee10042$export$fdc57c66c20e939a)(color, alpha);
    const { base: base, view: view } = sink.reserveVertices(segments + 2);
    (0, $0858672ccca83b12$export$7e54ad1d2333ebc5)(view, 0, cx, cy, r, g, b, a, lightAffected, z);
    for(let i = 0; i <= segments; i++){
        const angle = i / segments * Math.PI * 2;
        const sx = Math.cos(angle) * radius;
        const sy = Math.sin(angle) * radius;
        (0, $0858672ccca83b12$export$7e54ad1d2333ebc5)(view, i + 1, cx + tilt.inv00 * sx + tilt.inv01 * sy, cy + tilt.inv10 * sx + tilt.inv11 * sy, r, g, b, a, lightAffected, z);
    }
    const idx = sink.reserveIndices(segments * 3);
    for(let i = 0; i < segments; i++){
        idx[i * 3] = base;
        idx[i * 3 + 1] = base + 1 + i;
        idx[i * 3 + 2] = base + 1 + (i + 1) % (segments + 1);
    }
}






function $3f0fefa32edaa9b2$export$21836aba51a6a44c(points, closed, tension = 0.5, segmentsPerSpan = 8) {
    const n = points.length;
    if (n < 2) return points.map((p)=>[
            p.x,
            p.y
        ]);
    const result = [];
    const segmentCount = closed ? n : n - 1;
    for(let i = 0; i < segmentCount; i++){
        const p0 = points[(i - 1 + n) % n];
        const p1 = points[i];
        const p2 = points[(i + 1) % n];
        const p3 = points[(i + 2) % n];
        let actualP0X = p0.x;
        let actualP0Y = p0.y;
        let actualP3X = p3.x;
        let actualP3Y = p3.y;
        if (!closed) {
            if (i === 0) {
                actualP0X = 2 * p1.x - p2.x;
                actualP0Y = 2 * p1.y - p2.y;
            }
            if (i === n - 2) {
                actualP3X = 2 * p2.x - p1.x;
                actualP3Y = 2 * p2.y - p1.y;
            }
        }
        const m1x = tension * (p2.x - actualP0X);
        const m1y = tension * (p2.y - actualP0Y);
        const m2x = tension * (actualP3X - p1.x);
        const m2y = tension * (actualP3Y - p1.y);
        for(let j = 0; j < segmentsPerSpan; j++){
            const t = j / segmentsPerSpan;
            const t2 = t * t;
            const t3 = t2 * t;
            const h00 = 2 * t3 - 3 * t2 + 1;
            const h10 = t3 - 2 * t2 + t;
            const h01 = -2 * t3 + 3 * t2;
            const h11 = t3 - t2;
            result.push([
                h00 * p1.x + h10 * m1x + h01 * p2.x + h11 * m2x,
                h00 * p1.y + h10 * m1y + h01 * p2.y + h11 * m2y
            ]);
        }
    }
    if (closed) result.push([
        points[0].x,
        points[0].y
    ]);
    else result.push([
        points[n - 1].x,
        points[n - 1].y
    ]);
    return result;
}
function $3f0fefa32edaa9b2$export$c9ef76019d16ee77(sink, vertices, tension, color, alpha, lightAffected, z) {
    const spline = $3f0fefa32edaa9b2$export$21836aba51a6a44c(vertices, true, tension);
    if (spline.length < 3) return;
    // Ear-clip requires {x, y} objects; allocate a lightweight adapter.
    const asV2d = spline.map(([x, y])=>({
            x: x,
            y: y
        }));
    const indices = (0, $dc2c60c9a54ba1c2$export$4d77c9cbb3bd528)(asV2d);
    if (!indices) return;
    const { r: r, g: g, b: b, a: a } = (0, $4ef1bda80ee10042$export$fdc57c66c20e939a)(color, alpha);
    const { base: base, view: view } = sink.reserveVertices(spline.length);
    for(let i = 0; i < spline.length; i++)(0, $0858672ccca83b12$export$7e54ad1d2333ebc5)(view, i, spline[i][0], spline[i][1], r, g, b, a, lightAffected, z);
    const idxSlice = sink.reserveIndices(indices.length);
    for(let i = 0; i < indices.length; i++)idxSlice[i] = base + indices[i];
}
function $3f0fefa32edaa9b2$export$74599777bda5527d(sink, vertices, tension, width, color, alpha, lightAffected, z) {
    const spline = $3f0fefa32edaa9b2$export$21836aba51a6a44c(vertices, true, tension);
    if (spline.length < 2) return;
    (0, $16042ed6b16a1b3f$export$72864f48dc9653a5)(sink, spline.map(([x, y])=>({
            x: x,
            y: y
        })), width, color, alpha, lightAffected, z);
}




function $94c013fb708d8351$export$bc68866a77c7b396(sink, vertices, tension, width, color, alpha, lightAffected, z) {
    const spline = (0, $3f0fefa32edaa9b2$export$21836aba51a6a44c)(vertices, false, tension);
    if (spline.length < 2) return;
    (0, $fb3cdcc7c0040bec$export$f94a86f019a975b5)(sink, spline, z, width, color, alpha, lightAffected, {
        closed: false
    });
}




function $50d1df9b78e4cd2f$export$9117e86816eabe7e(sink, x, y, w, h, color, alpha, lightAffected, z) {
    const { r: r, g: g, b: b, a: a } = (0, $4ef1bda80ee10042$export$fdc57c66c20e939a)(color, alpha);
    const { base: base, view: view } = sink.reserveVertices(4);
    (0, $0858672ccca83b12$export$7e54ad1d2333ebc5)(view, 0, x, y, r, g, b, a, lightAffected, z);
    (0, $0858672ccca83b12$export$7e54ad1d2333ebc5)(view, 1, x + w, y, r, g, b, a, lightAffected, z);
    (0, $0858672ccca83b12$export$7e54ad1d2333ebc5)(view, 2, x + w, y + h, r, g, b, a, lightAffected, z);
    (0, $0858672ccca83b12$export$7e54ad1d2333ebc5)(view, 3, x, y + h, r, g, b, a, lightAffected, z);
    const idx = sink.reserveIndices(6);
    idx[0] = base;
    idx[1] = base + 1;
    idx[2] = base + 2;
    idx[3] = base;
    idx[4] = base + 2;
    idx[5] = base + 3;
}
function $50d1df9b78e4cd2f$export$b85c2944e2ca4e14(sink, cx, cy, offsetX, offsetY, w, h, angle, color, alpha, lightAffected, z) {
    const { r: r, g: g, b: b, a: a } = (0, $4ef1bda80ee10042$export$fdc57c66c20e939a)(color, alpha);
    const cos = Math.cos(angle);
    const sin = Math.sin(angle);
    const { base: base, view: view } = sink.reserveVertices(4);
    const corners = [
        [
            offsetX,
            offsetY
        ],
        [
            offsetX + w,
            offsetY
        ],
        [
            offsetX + w,
            offsetY + h
        ],
        [
            offsetX,
            offsetY + h
        ]
    ];
    for(let i = 0; i < 4; i++){
        const [lx, ly] = corners[i];
        (0, $0858672ccca83b12$export$7e54ad1d2333ebc5)(view, i, cx + cos * lx - sin * ly, cy + sin * lx + cos * ly, r, g, b, a, lightAffected, z);
    }
    const idx = sink.reserveIndices(6);
    idx[0] = base;
    idx[1] = base + 1;
    idx[2] = base + 2;
    idx[3] = base;
    idx[4] = base + 2;
    idx[5] = base + 3;
}


/**
 * Tilt projection parameters for the hull's Yaw·Pitch·Roll rotation.
 *
 * Used by screen-width tessellation (lines, polylines, circles whose on-screen
 * thickness shouldn't depend on tilt). The forward matrix projects local-space
 * directions to screen space; the inverse converts a screen-space perpendicular
 * back to local-space offsets so the GPU's own tilt transform reproduces the
 * desired constant-width screen output.
 */ function $0180785820f28c5a$export$be524feb371e374f(angle, roll, pitch) {
    const ca = Math.cos(angle);
    const sa = Math.sin(angle);
    const sr = Math.sin(roll);
    const sp = Math.sin(pitch);
    const cr = Math.cos(roll);
    const cp = Math.cos(pitch);
    const m00 = ca * cp;
    const m10 = sa * cp;
    const m01 = ca * sp * sr - sa * cr;
    const m11 = sa * sp * sr + ca * cr;
    const zx = -(ca * sp * cr + sa * sr);
    const zy = -(sa * sp * cr - ca * sr);
    const det = m00 * m11 - m01 * m10;
    const invDet = det !== 0 ? 1 / det : 1;
    return {
        m00: m00,
        m10: m10,
        m01: m01,
        m11: m11,
        zx: zx,
        zy: zy,
        inv00: m11 * invDet,
        inv10: -m10 * invDet,
        inv01: -m01 * invDet,
        inv11: m00 * invDet
    };
}


const $3a182ab185f8c532$var$MIN_CIRCLE_SEGMENTS = 4;
const $3a182ab185f8c532$var$MAX_CIRCLE_SEGMENTS = 64;
function $3a182ab185f8c532$var$getCircleSegments(radius) {
    return (0, $2172aedd5a25ff17$export$7d15b64cf5a3a4c4)(Math.floor(radius * 4), $3a182ab185f8c532$var$MIN_CIRCLE_SEGMENTS, $3a182ab185f8c532$var$MAX_CIRCLE_SEGMENTS);
}
/** Map the `ignoreLight` option to the 0..1 vertex scalar. */ function $3a182ab185f8c532$var$lightAffectedFrom(opts) {
    return opts?.ignoreLight ? 0 : 1;
}
class $3a182ab185f8c532$export$dca20402ebea5ece {
    constructor(/** The underlying WebGPU renderer */ renderer, /** The camera for coordinate conversions and zoom */ camera){
        this.renderer = renderer;
        this.camera = camera;
    }
    /**
   * Execute draw commands at a specific position, rotation, and scale.
   * Automatically handles save/restore of transform state.
   *
   * @example
   * draw.at({ pos: this.position, angle: this.rotation }, () => {
   *   draw.fillRect(-10, -10, 20, 20, { color: 0xFF0000 });
   * });
   */ at({ pos: pos, angle: angle, scale: scale, tilt: tilt }, draw) {
        this.renderer.save();
        const prevTilt = this.renderer.getCurrentTilt();
        if (tilt) {
            const cam = this.renderer.getTransform();
            const a = angle ?? 0;
            const ca = Math.cos(a);
            const sa = Math.sin(a);
            const sr = Math.sin(tilt.roll);
            const sp = Math.sin(tilt.pitch);
            const cr = Math.cos(tilt.roll);
            const cp = Math.cos(tilt.pitch);
            const r00 = ca * cp;
            const r10 = sa * cp;
            const r01 = ca * sp * sr - sa * cr;
            const r11 = sa * sp * sr + ca * cr;
            const px = pos.x;
            const py = pos.y;
            const m = this.renderer.getTransform();
            m.a = cam.a * r00 + cam.c * r10;
            m.b = cam.b * r00 + cam.d * r10;
            m.c = cam.a * r01 + cam.c * r11;
            m.d = cam.b * r01 + cam.d * r11;
            m.tx = cam.a * px + cam.c * py + cam.tx;
            m.ty = cam.b * px + cam.d * py + cam.ty;
            this.renderer.setTransform(m);
            const worldZX = -(ca * sp * cr + sa * sr);
            const worldZY = -(sa * sp * cr - ca * sr);
            this.renderer.setZCoeffs(cam.a * worldZX + cam.c * worldZY, cam.b * worldZX + cam.d * worldZY);
            this.renderer.setZRow(sp, -(cp * sr), cp * cr);
            if (tilt.zOffset !== undefined) this.renderer.setZ(tilt.zOffset);
            // Make the local-space tilt projection available to screenLine /
            // screenCircle / etc. Uses the same angle+roll+pitch.
            this.renderer.setCurrentTilt((0, $0180785820f28c5a$export$be524feb371e374f)(a, tilt.roll, tilt.pitch));
        } else {
            this.renderer.translate(pos);
            if (angle !== undefined) this.renderer.rotate(angle);
        }
        if (scale !== undefined) {
            if (typeof scale === "number") this.renderer.scale(scale, scale);
            else this.renderer.scale(scale.x, scale.y);
        }
        draw();
        this.renderer.setCurrentTilt(prevTilt);
        this.renderer.restore();
    }
    /** Submit a cached or dynamic mesh. */ mesh(m) {
        this.renderer.drawMesh(m);
    }
    /**
   * Temporarily override the renderer's z for a single primitive. The
   * tessellator emits per-vertex z = 0, so the final depth comes from the
   * transform's zBase; this keeps the old `opts.z`-as-absolute semantics
   * without double-applying the current z.
   */ applyZ(z) {
        const prev = this.renderer.getZ();
        if (z !== undefined) this.renderer.setZ(z);
        return prev;
    }
    // ============ Fills ============
    /** Draw a filled rectangle */ fillRect(x, y, w, h, opts) {
        const color = opts?.color ?? 0xffffff;
        const alpha = opts?.alpha ?? 1;
        const lightAffected = $3a182ab185f8c532$var$lightAffectedFrom(opts);
        const prevZ = this.applyZ(opts?.z);
        (0, $50d1df9b78e4cd2f$export$9117e86816eabe7e)(this.renderer.prepareShapeSink(), x, y, w, h, color, alpha, lightAffected, 0);
        this.renderer.setZ(prevZ);
    }
    /** Draw a filled circle */ fillCircle(x, y, radius, opts) {
        const color = opts?.color ?? 0xffffff;
        const alpha = opts?.alpha ?? 1;
        const lightAffected = $3a182ab185f8c532$var$lightAffectedFrom(opts);
        const radiusOnScreen = radius * this.renderer.getCurrentScale();
        const segments = opts?.segments ?? $3a182ab185f8c532$var$getCircleSegments(radiusOnScreen);
        const prevZ = this.applyZ(opts?.z);
        (0, $d901f631a5871919$export$5565c25cb2b768d0)(this.renderer.prepareShapeSink(), x, y, radius, segments, color, alpha, lightAffected, 0);
        this.renderer.setZ(prevZ);
    }
    /** Draw a filled polygon (supports concave polygons) */ fillPolygon(vertices, opts) {
        const color = opts?.color ?? 0xffffff;
        const alpha = opts?.alpha ?? 1;
        const lightAffected = $3a182ab185f8c532$var$lightAffectedFrom(opts);
        const prevZ = this.applyZ(opts?.z);
        (0, $16042ed6b16a1b3f$export$9d17f42aa9bfb878)(this.renderer.prepareShapeSink(), vertices, color, alpha, lightAffected, 0);
        this.renderer.setZ(prevZ);
    }
    /** Draw a filled triangle */ fillTriangle(v1, v2, v3, opts) {
        this.fillPolygon([
            {
                x: v1.x,
                y: v1.y
            },
            {
                x: v2.x,
                y: v2.y
            },
            {
                x: v3.x,
                y: v3.y
            }
        ], opts);
    }
    /** Draw a filled rounded rectangle */ fillRoundedRect(x, y, w, h, radius, opts) {
        const vertices = [
            {
                x: x,
                y: y
            },
            {
                x: x + w,
                y: y
            },
            {
                x: x + w,
                y: y + h
            },
            {
                x: x,
                y: y + h
            }
        ];
        this.fillRoundedPolygon(vertices, radius, opts);
    }
    /** Draw a filled polygon with rounded corners */ fillRoundedPolygon(vertices, radius, opts) {
        const color = opts?.color ?? 0xffffff;
        const alpha = opts?.alpha ?? 1;
        const lightAffected = $3a182ab185f8c532$var$lightAffectedFrom(opts);
        const prevZ = this.applyZ(opts?.z);
        (0, $8f4e7d9aea438fce$export$4da7bae4f644af90)(this.renderer.prepareShapeSink(), vertices, radius, color, alpha, lightAffected, 0);
        this.renderer.setZ(prevZ);
    }
    /** Draw a filled smooth polygon (Catmull-Rom through the control points). */ fillSmoothPolygon(vertices, opts) {
        const color = opts?.color ?? 0xffffff;
        const alpha = opts?.alpha ?? 1;
        const lightAffected = $3a182ab185f8c532$var$lightAffectedFrom(opts);
        const tension = opts?.tension ?? 0.5;
        const prevZ = this.applyZ(opts?.z);
        (0, $3f0fefa32edaa9b2$export$c9ef76019d16ee77)(this.renderer.prepareShapeSink(), vertices, tension, color, alpha, lightAffected, 0);
        this.renderer.setZ(prevZ);
    }
    // ============ Strokes ============
    /** Draw a stroked rectangle outline */ strokeRect(x, y, w, h, opts) {
        this.strokePolygon([
            {
                x: x,
                y: y
            },
            {
                x: x + w,
                y: y
            },
            {
                x: x + w,
                y: y + h
            },
            {
                x: x,
                y: y + h
            }
        ], opts);
    }
    /** Draw a stroked circle outline (miter-jointed polyline). */ strokeCircle(x, y, radius, opts) {
        const color = opts?.color ?? 0xffffff;
        const alpha = opts?.alpha ?? 1;
        const lightAffected = $3a182ab185f8c532$var$lightAffectedFrom(opts);
        const width = opts?.width ?? 1;
        const segments = $3a182ab185f8c532$var$getCircleSegments(radius);
        const points = [];
        for(let i = 0; i < segments; i++){
            const angle = i / segments * Math.PI * 2;
            points.push([
                x + Math.cos(angle) * radius,
                y + Math.sin(angle) * radius
            ]);
        }
        const prevZ = this.applyZ(opts?.z);
        (0, $fb3cdcc7c0040bec$export$f94a86f019a975b5)(this.renderer.prepareShapeSink(), points, 0, width, color, alpha, lightAffected, {
            closed: true
        });
        this.renderer.setZ(prevZ);
    }
    /** Draw a stroked polygon outline (closed) */ strokePolygon(vertices, opts) {
        const color = opts?.color ?? 0xffffff;
        const alpha = opts?.alpha ?? 1;
        const lightAffected = $3a182ab185f8c532$var$lightAffectedFrom(opts);
        const width = opts?.width ?? 1;
        const prevZ = this.applyZ(opts?.z);
        (0, $16042ed6b16a1b3f$export$72864f48dc9653a5)(this.renderer.prepareShapeSink(), vertices, width, color, alpha, lightAffected, 0);
        this.renderer.setZ(prevZ);
    }
    /** Draw a stroked rounded rectangle */ strokeRoundedRect(x, y, w, h, radius, opts) {
        const vertices = [
            {
                x: x,
                y: y
            },
            {
                x: x + w,
                y: y
            },
            {
                x: x + w,
                y: y + h
            },
            {
                x: x,
                y: y + h
            }
        ];
        this.strokeRoundedPolygon(vertices, radius, opts);
    }
    /** Draw a stroked polygon with rounded corners */ strokeRoundedPolygon(vertices, radius, opts) {
        const color = opts?.color ?? 0xffffff;
        const alpha = opts?.alpha ?? 1;
        const lightAffected = $3a182ab185f8c532$var$lightAffectedFrom(opts);
        const width = opts?.width ?? 1;
        const prevZ = this.applyZ(opts?.z);
        (0, $8f4e7d9aea438fce$export$377d402a1c3d7c0a)(this.renderer.prepareShapeSink(), vertices, radius, width, color, alpha, lightAffected, 0);
        this.renderer.setZ(prevZ);
    }
    /** Draw a stroked smooth polygon (Catmull-Rom). */ strokeSmoothPolygon(vertices, opts) {
        const color = opts?.color ?? 0xffffff;
        const alpha = opts?.alpha ?? 1;
        const lightAffected = $3a182ab185f8c532$var$lightAffectedFrom(opts);
        const width = opts?.width ?? 1;
        const tension = opts?.tension ?? 0.5;
        const prevZ = this.applyZ(opts?.z);
        (0, $3f0fefa32edaa9b2$export$74599777bda5527d)(this.renderer.prepareShapeSink(), vertices, tension, width, color, alpha, lightAffected, 0);
        this.renderer.setZ(prevZ);
    }
    /** Draw a smooth open curve (spline) through the given points */ spline(vertices, opts) {
        const color = opts?.color ?? 0xffffff;
        const alpha = opts?.alpha ?? 1;
        const lightAffected = $3a182ab185f8c532$var$lightAffectedFrom(opts);
        const width = opts?.width ?? 1;
        const tension = opts?.tension ?? 0.5;
        const prevZ = this.applyZ(opts?.z);
        (0, $94c013fb708d8351$export$bc68866a77c7b396)(this.renderer.prepareShapeSink(), vertices, tension, width, color, alpha, lightAffected, 0);
        this.renderer.setZ(prevZ);
    }
    // ============ Lines ============
    /** Draw a line (world-space width - scales with zoom) */ line(x1, y1, x2, y2, opts) {
        const color = opts?.color ?? 0xffffff;
        const alpha = opts?.alpha ?? 1;
        const lightAffected = $3a182ab185f8c532$var$lightAffectedFrom(opts);
        const width = opts?.width ?? 1;
        const prevZ = this.applyZ(opts?.z);
        (0, $fe0225da88bd1ba6$export$7abebd0236210336)(this.renderer.prepareShapeSink(), x1, y1, x2, y2, width, color, alpha, lightAffected, 0);
        this.renderer.setZ(prevZ);
    }
    /**
   * Draw a line with screen-space width (constant pixel width regardless of zoom).
   * If a tilt context is active, uses tilt-aware screen-width math; otherwise
   * scales the world-width by the camera zoom.
   */ screenLine(x1, y1, x2, y2, opts) {
        const tilt = this.renderer.getCurrentTilt();
        const color = opts?.color ?? 0xffffff;
        const alpha = opts?.alpha ?? 1;
        const lightAffected = $3a182ab185f8c532$var$lightAffectedFrom(opts);
        const width = opts?.width ?? 1;
        const z = opts?.z ?? this.renderer.getZ();
        if (tilt) (0, $fe0225da88bd1ba6$export$a0b980ce0bbd9b6b)(this.renderer.prepareShapeSink(), x1, y1, z, x2, y2, z, width, tilt, color, alpha, lightAffected);
        else (0, $fe0225da88bd1ba6$export$7abebd0236210336)(this.renderer.prepareShapeSink(), x1, y1, x2, y2, width / this.camera.z, color, alpha, lightAffected, z);
    }
    /**
   * Screen-width polyline with per-vertex z. Requires an active tilt context.
   */ screenPolyline(points, zPerPoint, width, opts) {
        const tilt = this.renderer.getCurrentTilt();
        const color = opts?.color ?? 0xffffff;
        const alpha = opts?.alpha ?? 1;
        const lightAffected = opts?.ignoreLight ? 0 : 1;
        if (!tilt) {
            // Fallback: treat as world-width polyline at mean z.
            (0, $fb3cdcc7c0040bec$export$f94a86f019a975b5)(this.renderer.prepareShapeSink(), points, zPerPoint, width / this.camera.z, color, alpha, lightAffected, {
                closed: opts?.closed,
                roundCaps: opts?.roundCaps
            });
            return;
        }
        (0, $fb3cdcc7c0040bec$export$7b4f6c6bc77609bd)(this.renderer.prepareShapeSink(), points, zPerPoint, width, tilt, color, alpha, lightAffected, {
            closed: opts?.closed,
            roundCaps: opts?.roundCaps
        });
    }
    /** Tilt-aware screen-width circle (stays circular on screen under tilt). */ screenCircle(x, y, z, radius, segments, opts) {
        const tilt = this.renderer.getCurrentTilt();
        const color = opts?.color ?? 0xffffff;
        const alpha = opts?.alpha ?? 1;
        const lightAffected = opts?.ignoreLight ? 0 : 1;
        if (!tilt) {
            (0, $d901f631a5871919$export$5565c25cb2b768d0)(this.renderer.prepareShapeSink(), x, y, radius, segments, color, alpha, lightAffected, z);
            return;
        }
        (0, $5fb5fa1f65341e4a$export$4202d7a1c044998c)(this.renderer.prepareShapeSink(), x, y, z, radius, segments, tilt, color, alpha, lightAffected);
    }
    // ============ Sprites ============
    /** Draw a textured image/sprite */ image(texture, x, y, opts) {
        const spriteOpts = opts ? {
            rotation: opts.rotation,
            scaleX: opts.scaleX,
            scaleY: opts.scaleY,
            alpha: opts.alpha,
            tint: opts.color,
            anchorX: opts.anchorX,
            anchorY: opts.anchorY
        } : undefined;
        this.renderer.drawImage(texture, x, y, spriteOpts);
    }
    // ============ Paths ============
    /**
   * Start a new path for complex shapes.
   *
   * @example
   * draw.path()
   *   .moveTo(0, 0)
   *   .lineTo(10, 0)
   *   .lineTo(5, 10)
   *   .close()
   *   .fill(0xFF0000);
   */ path() {
        return new (0, $36c62e853c0e746f$export$e714624f7828404d)(this.renderer);
    }
}









class $b29a77d98f1bc0d5$export$8ff26dafa08918 {
    static{
        this.warningKeys = new Set();
    }
    constructor(){
        this.data = new Float32Array(9);
        this.identity();
    }
    static warnOnce(key, message) {
        if ($b29a77d98f1bc0d5$export$8ff26dafa08918.warningKeys.has(key)) return;
        $b29a77d98f1bc0d5$export$8ff26dafa08918.warningKeys.add(key);
        console.warn(message);
    }
    /** Create an identity matrix */ static identity() {
        return new $b29a77d98f1bc0d5$export$8ff26dafa08918();
    }
    /** Create a translation matrix */ static translation(x, y) {
        const m = new $b29a77d98f1bc0d5$export$8ff26dafa08918();
        m.data[6] = x;
        m.data[7] = y;
        return m;
    }
    /** Create a rotation matrix (angle in radians) */ static rotation(radians) {
        const m = new $b29a77d98f1bc0d5$export$8ff26dafa08918();
        const c = Math.cos(radians);
        const s = Math.sin(radians);
        m.data[0] = c;
        m.data[1] = s;
        m.data[3] = -s;
        m.data[4] = c;
        return m;
    }
    /** Create a scaling matrix */ static scaling(sx, sy = sx) {
        const m = new $b29a77d98f1bc0d5$export$8ff26dafa08918();
        m.data[0] = sx;
        m.data[4] = sy;
        return m;
    }
    /** Clone this matrix */ clone() {
        const m = new $b29a77d98f1bc0d5$export$8ff26dafa08918();
        m.data.set(this.data);
        return m;
    }
    /** Reset to identity */ identity() {
        this.data[0] = 1;
        this.data[1] = 0;
        this.data[2] = 0;
        this.data[3] = 0;
        this.data[4] = 1;
        this.data[5] = 0;
        this.data[6] = 0;
        this.data[7] = 0;
        this.data[8] = 1;
        return this;
    }
    /** Set from individual values (row-major input for convenience) */ set(a, c, tx, b, d, ty) {
        this.data[0] = a;
        this.data[1] = b;
        this.data[2] = 0;
        this.data[3] = c;
        this.data[4] = d;
        this.data[5] = 0;
        this.data[6] = tx;
        this.data[7] = ty;
        this.data[8] = 1;
        return this;
    }
    /** Copy from another matrix */ copyFrom(other) {
        this.data.set(other.data);
        return this;
    }
    translate(xOrV, y) {
        let tx, ty;
        if (typeof xOrV === "number") {
            tx = xOrV;
            ty = y;
        } else {
            tx = xOrV[0];
            ty = xOrV[1];
        }
        // Multiply by translation matrix on the right
        this.data[6] += this.data[0] * tx + this.data[3] * ty;
        this.data[7] += this.data[1] * tx + this.data[4] * ty;
        return this;
    }
    /** Rotate by angle (radians) - modifies this matrix */ rotate(radians) {
        const c = Math.cos(radians);
        const s = Math.sin(radians);
        const a = this.data[0];
        const b = this.data[1];
        const d = this.data[3];
        const e = this.data[4];
        this.data[0] = a * c + d * s;
        this.data[1] = b * c + e * s;
        this.data[3] = a * -s + d * c;
        this.data[4] = b * -s + e * c;
        return this;
    }
    scale(sx, sy) {
        const scaleY = sy ?? sx;
        this.data[0] *= sx;
        this.data[1] *= sx;
        this.data[3] *= scaleY;
        this.data[4] *= scaleY;
        return this;
    }
    /** Multiply this matrix by another: this = this * other */ multiply(other) {
        const a1 = this.data[0], b1 = this.data[1];
        const c1 = this.data[3], d1 = this.data[4];
        const tx1 = this.data[6], ty1 = this.data[7];
        const a2 = other.data[0], b2 = other.data[1];
        const c2 = other.data[3], d2 = other.data[4];
        const tx2 = other.data[6], ty2 = other.data[7];
        this.data[0] = a1 * a2 + c1 * b2;
        this.data[1] = b1 * a2 + d1 * b2;
        this.data[3] = a1 * c2 + c1 * d2;
        this.data[4] = b1 * c2 + d1 * d2;
        this.data[6] = a1 * tx2 + c1 * ty2 + tx1;
        this.data[7] = b1 * tx2 + d1 * ty2 + ty1;
        return this;
    }
    /** Premultiply this matrix by another: this = other * this */ premultiply(other) {
        const a1 = other.data[0], b1 = other.data[1];
        const c1 = other.data[3], d1 = other.data[4];
        const tx1 = other.data[6], ty1 = other.data[7];
        const a2 = this.data[0], b2 = this.data[1];
        const c2 = this.data[3], d2 = this.data[4];
        const tx2 = this.data[6], ty2 = this.data[7];
        this.data[0] = a1 * a2 + c1 * b2;
        this.data[1] = b1 * a2 + d1 * b2;
        this.data[3] = a1 * c2 + c1 * d2;
        this.data[4] = b1 * c2 + d1 * d2;
        this.data[6] = a1 * tx2 + c1 * ty2 + tx1;
        this.data[7] = b1 * tx2 + d1 * ty2 + ty1;
        return this;
    }
    /** Invert this matrix - modifies this matrix */ invert() {
        const a = this.data[0], b = this.data[1];
        const c = this.data[3], d = this.data[4];
        const tx = this.data[6], ty = this.data[7];
        const det = a * d - b * c;
        if (det === 0) {
            $b29a77d98f1bc0d5$export$8ff26dafa08918.warnOnce("invert-singular", "Matrix3.invert encountered a singular matrix; resetting to identity.");
            return this.identity();
        }
        const invDet = 1 / det;
        this.data[0] = d * invDet;
        this.data[1] = -b * invDet;
        this.data[3] = -c * invDet;
        this.data[4] = a * invDet;
        this.data[6] = (c * ty - d * tx) * invDet;
        this.data[7] = (b * tx - a * ty) * invDet;
        return this;
    }
    /** Apply this matrix to a point. If `out` is provided, writes result there and returns it. */ apply(point, out) {
        const x = point[0];
        const y = point[1];
        const rx = this.data[0] * x + this.data[3] * y + this.data[6];
        const ry = this.data[1] * x + this.data[4] * y + this.data[7];
        if (out) {
            out[0] = rx;
            out[1] = ry;
            return out;
        }
        return (0, $6b6a54a072724620$export$e7c866399fa523f5)(rx, ry);
    }
    /** Apply the inverse of this matrix to a point, returning a new V2d */ applyInverse(point) {
        const a = this.data[0], b = this.data[1];
        const c = this.data[3], d = this.data[4];
        const tx = this.data[6], ty = this.data[7];
        const det = a * d - b * c;
        if (det === 0) {
            $b29a77d98f1bc0d5$export$8ff26dafa08918.warnOnce("applyInverse-singular", "Matrix3.applyInverse encountered a singular matrix; returning (0, 0).");
            return (0, $6b6a54a072724620$export$e7c866399fa523f5)(0, 0);
        }
        const invDet = 1 / det;
        const x = point[0] - tx;
        const y = point[1] - ty;
        return (0, $6b6a54a072724620$export$e7c866399fa523f5)((d * x - c * y) * invDet, (a * y - b * x) * invDet);
    }
    toArray(transpose = false, out) {
        const result = out ?? new Float32Array(9);
        if (transpose) {
            // Row-major order
            result[0] = this.data[0];
            result[1] = this.data[3];
            result[2] = this.data[6];
            result[3] = this.data[1];
            result[4] = this.data[4];
            result[5] = this.data[7];
            result[6] = this.data[2];
            result[7] = this.data[5];
            result[8] = this.data[8];
        } else // Column-major order (default for GPU)
        result.set(this.data);
        return result;
    }
    /** Get individual matrix elements (row, col) */ get a() {
        return this.data[0];
    }
    get b() {
        return this.data[1];
    }
    get c() {
        return this.data[3];
    }
    get d() {
        return this.data[4];
    }
    get tx() {
        return this.data[6];
    }
    get ty() {
        return this.data[7];
    }
    /** Set individual matrix elements */ set a(value) {
        this.data[0] = value;
    }
    set b(value) {
        this.data[1] = value;
    }
    set c(value) {
        this.data[3] = value;
    }
    set d(value) {
        this.data[4] = value;
    }
    set tx(value) {
        this.data[6] = value;
    }
    set ty(value) {
        this.data[7] = value;
    }
    /** Get the determinant of this matrix */ get determinant() {
        return this.data[0] * this.data[4] - this.data[1] * this.data[3];
    }
    /** Decompose this matrix into translation, rotation, scale, and skew */ decompose() {
        const a = this.data[0];
        const b = this.data[1];
        const c = this.data[3];
        const d = this.data[4];
        const skewX = Math.atan2(-c, d);
        const skewY = Math.atan2(b, a);
        const rotation = skewY;
        const scaleX = Math.sqrt(a * a + b * b);
        const scaleY = Math.sqrt(c * c + d * d);
        return {
            x: this.data[6],
            y: this.data[7],
            rotation: rotation,
            scaleX: scaleX,
            scaleY: scaleY,
            skewX: skewX,
            skewY: skewY
        };
    }
}


// Bounds for camera position/velocity validation
const $5fd8a8f6f7c6b09a$var$MAX_CAMERA_POSITION = 1000000000;
const $5fd8a8f6f7c6b09a$var$MAX_CAMERA_VELOCITY = 1000000000;
const $5fd8a8f6f7c6b09a$var$MAX_CAMERA_ZOOM = 1000000;
class $5fd8a8f6f7c6b09a$export$d10b745905c2533b extends (0, $c59361981bac2575$export$4342ba5c6ad1f6f1) {
    constructor(viewportProvider, position = (0, $6b6a54a072724620$export$e7c866399fa523f5)([
        0,
        0
    ]), z = 25.0, angle = 0){
        super(), this.tags = [
            "camera"
        ], this.persistenceLevel = 100, this.paralaxScale = 0.1, // Cache for getWorldViewport (set to null to invalidate)
        this._cachedViewport = null, // Cache for viewport dimensions (to detect external resize)
        this._lastViewportWidth = 0, this._lastViewportHeight = 0, // Cache for getMatrix with default parallax [1,1] and anchor [0,0]
        this._cachedMatrix = null;
        this.viewportProvider = viewportProvider;
        this._position = position;
        this._z = z;
        this._angle = angle;
        this.velocity = (0, $6b6a54a072724620$export$e7c866399fa523f5)([
            0,
            0
        ]);
    }
    /** Check if a value is valid (finite and within bounds) */ isValidPosition(value) {
        return isFinite(value) && Math.abs(value) <= $5fd8a8f6f7c6b09a$var$MAX_CAMERA_POSITION;
    }
    isValidVelocity(value) {
        return isFinite(value) && Math.abs(value) <= $5fd8a8f6f7c6b09a$var$MAX_CAMERA_VELOCITY;
    }
    isValidZoom(value) {
        return isFinite(value) && value > 0 && value <= $5fd8a8f6f7c6b09a$var$MAX_CAMERA_ZOOM;
    }
    /** Invalidate caches (called when camera properties change) */ invalidateCache() {
        this._cachedViewport = null;
        this._cachedMatrix = null;
    }
    /** Read-only access to position. Use x/y setters or setPosition() to modify. */ get position() {
        return this._position;
    }
    get x() {
        return this._position[0];
    }
    set x(value) {
        if (!this.isValidPosition(value)) {
            console.warn("Camera2d: Invalid x position rejected:", value);
            return;
        }
        this._position[0] = value;
        this.invalidateCache();
    }
    get y() {
        return this._position[1];
    }
    set y(value) {
        if (!this.isValidPosition(value)) {
            console.warn("Camera2d: Invalid y position rejected:", value);
            return;
        }
        this._position[1] = value;
        this.invalidateCache();
    }
    get z() {
        return this._z;
    }
    set z(value) {
        if (!this.isValidZoom(value)) {
            console.warn("Camera2d: Invalid zoom rejected:", value);
            return;
        }
        this._z = value;
        this.invalidateCache();
    }
    get angle() {
        return this._angle;
    }
    set angle(value) {
        this._angle = value;
        this.invalidateCache();
    }
    /** Set position directly (invalidates cache) */ setPosition(x, y) {
        if (!this.isValidPosition(x) || !this.isValidPosition(y)) {
            console.warn("Camera2d.setPosition: Invalid position rejected:", x, y);
            return;
        }
        this._position[0] = x;
        this._position[1] = y;
        this.invalidateCache();
    }
    get vx() {
        return this.velocity[0];
    }
    set vx(value) {
        if (!this.isValidVelocity(value)) {
            console.warn("Camera2d: Invalid vx velocity rejected:", value);
            return;
        }
        this.velocity[0] = value;
    }
    get vy() {
        return this.velocity[1];
    }
    set vy(value) {
        if (!this.isValidVelocity(value)) {
            console.warn("Camera2d: Invalid vy velocity rejected:", value);
            return;
        }
        this.velocity[1] = value;
    }
    getPosition() {
        return this._position;
    }
    onTick({ dt: dt }) {
        this.x += this.vx * dt;
        this.y += this.vy * dt;
    }
    /** Center the camera on a position */ center([x, y]) {
        this.setPosition(x, y);
    }
    /** Move the camera toward being centered on a position, with a target velocity */ smoothCenter([x, y], [vx, vy] = (0, $6b6a54a072724620$export$e7c866399fa523f5)([
        0,
        0
    ]), stiffness = 1.0, damping = 1.0) {
        if (!this.isValidPosition(x) || !this.isValidPosition(y)) {
            console.warn("Camera2d.smoothCenter: Invalid position rejected:", x, y);
            return;
        }
        if (!this.isValidVelocity(vx) || !this.isValidVelocity(vy)) {
            console.warn("Camera2d.smoothCenter: Invalid velocity rejected:", vx, vy);
            return;
        }
        const dx = x - this.x;
        const dy = y - this.y;
        const dt = this.game.averageDt;
        this.vx += (stiffness * dx - damping * (this.vx - vx)) * dt;
        this.vy += (stiffness * dy - damping * (this.vy - vy)) * dt;
    }
    smoothSetVelocity([vx, vy], stiffness = 0.9) {
        if (!this.isValidVelocity(vx) || !this.isValidVelocity(vy)) {
            console.warn("Camera2d.smoothSetVelocity: Invalid velocity rejected:", vx, vy);
            return;
        }
        this.vx = (0, $2172aedd5a25ff17$export$e4d952dcf42a5ff5)(this.vx, vx, stiffness, 0.001);
        this.vy = (0, $2172aedd5a25ff17$export$e4d952dcf42a5ff5)(this.vy, vy, stiffness, 0.001);
    }
    /** Move the camera part of the way to the desired zoom. */ smoothZoom(z, smooth = 0.9) {
        if (!this.isValidZoom(z)) {
            console.warn("Camera2d.smoothZoom: Invalid zoom rejected:", z);
            return;
        }
        this.z = smooth * this.z + (1 - smooth) * z;
    }
    /** Returns [width, height] of the viewport in pixels */ getViewportSize() {
        return (0, $6b6a54a072724620$export$e7c866399fa523f5)(this.viewportProvider.getWidth(), this.viewportProvider.getHeight());
    }
    /**
   * Calculates the world coordinate bounds of the current camera viewport.
   * Useful for culling, bounds checking, and viewport-relative positioning.
   * Results are cached and only recomputed when camera or viewport changes.
   */ getWorldViewport() {
        const viewportWidth = this.viewportProvider.getWidth();
        const viewportHeight = this.viewportProvider.getHeight();
        // Check if viewport dimensions changed (external resize)
        if (viewportWidth !== this._lastViewportWidth || viewportHeight !== this._lastViewportHeight) {
            this._cachedViewport = null;
            this._lastViewportWidth = viewportWidth;
            this._lastViewportHeight = viewportHeight;
        }
        // Return cached viewport if valid
        if (this._cachedViewport) return this._cachedViewport;
        // Transform all 4 screen corners to world space and compute AABB.
        // With camera rotation, opposite corners aren't sufficient.
        const w = viewportWidth;
        const h = viewportHeight;
        const c0 = this.toWorld((0, $6b6a54a072724620$export$e7c866399fa523f5)(0, 0));
        const c1 = this.toWorld((0, $6b6a54a072724620$export$e7c866399fa523f5)(w, 0));
        const c2 = this.toWorld((0, $6b6a54a072724620$export$e7c866399fa523f5)(w, h));
        const c3 = this.toWorld((0, $6b6a54a072724620$export$e7c866399fa523f5)(0, h));
        const left = Math.min(c0[0], c1[0], c2[0], c3[0]);
        const right = Math.max(c0[0], c1[0], c2[0], c3[0]);
        const top = Math.min(c0[1], c1[1], c2[1], c3[1]);
        const bottom = Math.max(c0[1], c1[1], c2[1], c3[1]);
        const width = right - left;
        const height = bottom - top;
        // Cache and return
        this._cachedViewport = {
            top: top,
            bottom: bottom,
            left: left,
            right: right,
            width: width,
            height: height
        };
        return this._cachedViewport;
    }
    /** Convert screen coordinates to world coordinates */ toWorld([x, y], parallax = (0, $6b6a54a072724620$export$e7c866399fa523f5)(1.0, 1.0)) {
        const matrix = this.getMatrix(parallax);
        return matrix.applyInverse((0, $6b6a54a072724620$export$e7c866399fa523f5)(x, y));
    }
    /** Convert world coordinates to screen coordinates */ toScreen([x, y], parallax = (0, $6b6a54a072724620$export$e7c866399fa523f5)(1.0, 1.0)) {
        const matrix = this.getMatrix(parallax);
        return matrix.apply((0, $6b6a54a072724620$export$e7c866399fa523f5)(x, y));
    }
    /** Creates a transformation matrix to go from world space to screen space. */ getMatrix(/** Parallax factors for X and Y axes */ [px, py] = [
        1,
        1
    ], /** Anchor point for transformations */ [ax, ay] = [
        0,
        0
    ]) {
        // Special case: parallax (0,0) means screen-space rendering (HUD)
        // Flip Y to convert from screen coords (Y-down) to match clip space (Y-up)
        if (px === 0 && py === 0) {
            const h = this.viewportProvider.getHeight();
            const matrix = new (0, $b29a77d98f1bc0d5$export$8ff26dafa08918)();
            matrix.identity();
            matrix.translate(0, h);
            matrix.scale(1, -1);
            return matrix;
        }
        const [w, h] = this.getViewportSize();
        // Check if viewport dimensions changed (invalidates matrix cache)
        if (w !== this._lastViewportWidth || h !== this._lastViewportHeight) {
            this._cachedMatrix = null;
            this._lastViewportWidth = w;
            this._lastViewportHeight = h;
        }
        // Use cached matrix for default case (parallax [1,1], anchor [0,0])
        const isDefaultCase = px === 1 && py === 1 && ax === 0 && ay === 0;
        if (isDefaultCase && this._cachedMatrix) return this._cachedMatrix;
        const { x: cx, y: cy, z: z, angle: angle } = this;
        const matrix = new (0, $b29a77d98f1bc0d5$export$8ff26dafa08918)();
        // With right-multiplication (this = this * T), operations are applied to
        // points in reverse order from how they're coded. So we code them in
        // reverse order of desired application:
        //
        // Desired application order to point:
        // 1. Align anchor with camera (first applied to point)
        // 2. Move camera to world origin
        // 3. Scale (zoom with parallax)
        // 4. Rotate
        // 5. Restore anchor position
        // 6. Undo parallax scale
        // 7. Y-flip (convert from Y-up world to Y-down screen)
        // 8. Center on screen (last applied to point)
        // Center on screen (applied last to point)
        matrix.translate(w / 2.0, h / 2.0);
        // Y-flip for screen coordinates (Y increases downward on screen)
        matrix.scale(1, -1);
        // Undo parallax scale
        matrix.scale(1 / px, 1 / py);
        // Restore anchor position
        matrix.translate(-ax * z, -ay * z);
        // Rotate
        matrix.rotate(angle);
        // Scale (zoom with parallax)
        matrix.scale(z * px, z * py);
        // Move camera to world origin
        matrix.translate(-cx * px, -cy * py);
        // Align anchor with camera (applied first to point)
        matrix.translate(ax * px, ay * py);
        // Cache for default case
        if (isDefaultCase) this._cachedMatrix = matrix;
        return matrix;
    }
    /**
   * Check if a circle at (x, y) with given radius is visible in the viewport.
   * Uses cached viewport bounds - no allocations.
   * Useful for culling objects before rendering.
   */ isVisible(x, y, radius) {
        const v = this.getWorldViewport();
        return x + radius >= v.left && x - radius <= v.right && y + radius >= v.top && y - radius <= v.bottom;
    }
}
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $aa1f0309d9dba6d2$export$af631764ddc44097)("tick")
], $5fd8a8f6f7c6b09a$export$d10b745905c2533b.prototype, "onTick", null);
function $5fd8a8f6f7c6b09a$export$3fdd4f1b5815476b(viewport, point) {
    return point.x >= viewport.left && point.x <= viewport.right && point.y >= viewport.top && point.y <= viewport.bottom;
}


/**
 * Immediate-mode 2D WebGPU renderer.
 * All draw calls are batched and flushed at frame end or on state change.
 *
 * Architecture:
 * - Two batch types: shapes (untextured) and sprites (textured)
 * - Transform stack with Matrix3
 * - Batched rendering with automatic flushing
 */ 
function $913afda613ebf2cb$export$34d09c4a771c46ef({ r: r, g: g, b: b }) {
    return (0, $2172aedd5a25ff17$export$7d15b64cf5a3a4c4)(b, 0, 255) + ((0, $2172aedd5a25ff17$export$7d15b64cf5a3a4c4)(g, 0, 255) << 8) + ((0, $2172aedd5a25ff17$export$7d15b64cf5a3a4c4)(r, 0, 255) << 16);
}
function $913afda613ebf2cb$export$5a544e13ad4e1fa5(hex) {
    return {
        r: hex >> 16,
        g: hex >> 8 & 0xff,
        b: hex & 0xff
    };
}
function $913afda613ebf2cb$export$5c92949fcbf60b21(hsv) {
    return $913afda613ebf2cb$export$34d09c4a771c46ef($913afda613ebf2cb$export$210753cfeec758a5(hsv));
}
function $913afda613ebf2cb$export$abda8a295d582d9f(hsl) {
    return $913afda613ebf2cb$export$34d09c4a771c46ef($913afda613ebf2cb$export$29fb7152bd3f781a(hsl));
}
function $913afda613ebf2cb$export$2077f6edbb2fafb8(hex) {
    return $913afda613ebf2cb$export$c85ca4f4753af384($913afda613ebf2cb$export$5a544e13ad4e1fa5(hex));
}
function $913afda613ebf2cb$export$54b4a3c46816d611(hex) {
    return $913afda613ebf2cb$export$f76e85ca00a47f5c($913afda613ebf2cb$export$5a544e13ad4e1fa5(hex));
}
function $913afda613ebf2cb$export$c2f8695086bb1728(hex) {
    const rgb = $913afda613ebf2cb$export$5a544e13ad4e1fa5(hex);
    return [
        rgb.r / 255.0,
        rgb.g / 255.0,
        rgb.b / 255.0
    ];
}
function $913afda613ebf2cb$export$d7d5a315d4eeef37(from, to, steps) {
    const perStepFade = 1.0 / steps;
    const out = [];
    for(let i = 0; i < steps; i++)out.push($913afda613ebf2cb$export$d150b9d32f0aee0c(from, to, perStepFade * i));
    return out;
}
function $913afda613ebf2cb$export$d150b9d32f0aee0c(from, to, percentTo) {
    // Extract color components directly using bit operations
    const fromR = from >> 16;
    const fromG = from >> 8 & 0xff;
    const fromB = from & 0xff;
    const toR = to >> 16;
    const toG = to >> 8 & 0xff;
    const toB = to & 0xff;
    // Lerp and round in one step using | 0 instead of Math.round()
    const percentFrom = 1.0 - percentTo;
    const r = (fromR * percentFrom + toR * percentTo + 0.5 | 0) & 0xff;
    const g = (fromG * percentFrom + toG * percentTo + 0.5 | 0) & 0xff;
    const b = (fromB * percentFrom + toB * percentTo + 0.5 | 0) & 0xff;
    // Pack directly into hex
    return r << 16 | g << 8 | b;
}
function $913afda613ebf2cb$export$c0816ed86df316af(from, percent = 0.1) {
    return $913afda613ebf2cb$export$d150b9d32f0aee0c(from, 0xffffff, percent);
}
function $913afda613ebf2cb$export$4b073707ff63303(from, percent = 0.1) {
    return $913afda613ebf2cb$export$d150b9d32f0aee0c(from, 0x000000, percent);
}
function $913afda613ebf2cb$export$8e914cb8c2fd9b82(a, b) {
    return $913afda613ebf2cb$export$34d09c4a771c46ef($913afda613ebf2cb$export$bb033e2093dc55fb($913afda613ebf2cb$export$5a544e13ad4e1fa5(a), $913afda613ebf2cb$export$5a544e13ad4e1fa5(b)));
}
function $913afda613ebf2cb$export$bb033e2093dc55fb(a, b) {
    return {
        r: (0, $2172aedd5a25ff17$export$7d15b64cf5a3a4c4)(a.r + b.r, 0, 255),
        g: (0, $2172aedd5a25ff17$export$7d15b64cf5a3a4c4)(a.g + b.g, 0, 255),
        b: (0, $2172aedd5a25ff17$export$7d15b64cf5a3a4c4)(a.b + b.b, 0, 255)
    };
}
function $913afda613ebf2cb$export$d808461c1e143846(c1, c2) {
    const rgb1 = $913afda613ebf2cb$export$5a544e13ad4e1fa5(c1);
    const rgb2 = $913afda613ebf2cb$export$5a544e13ad4e1fa5(c2);
    return Math.max(Math.abs(rgb1.r - rgb2.r) / 255, Math.abs(rgb1.g - rgb2.g) / 255, Math.abs(rgb1.b - rgb2.b) / 255);
}
function $913afda613ebf2cb$export$29fb7152bd3f781a({ h: h, s: s, l: l }) {
    let r, g, b;
    if (s == 0) r = g = b = l; // achromatic
    else {
        const hueTorgb = function hue2rgb(p, q, t) {
            if (t < 0) t += 1;
            if (t > 1) t -= 1;
            if (t < 1 / 6) return p + (q - p) * 6 * t;
            if (t < 0.5) return q;
            if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
            return p;
        };
        const q = l < 0.5 ? l * (1 + s) : l + s - l * s;
        const p = 2 * l - q;
        r = hueTorgb(p, q, h + 1 / 3);
        g = hueTorgb(p, q, h);
        b = hueTorgb(p, q, h - 1 / 3);
    }
    return {
        r: Math.round(r * 255),
        g: Math.round(g * 255),
        b: Math.round(b * 255)
    };
}
function $913afda613ebf2cb$export$c85ca4f4753af384({ r: r, g: g, b: b }) {
    r /= 255, g /= 255, b /= 255;
    var max = Math.max(r, g, b), min = Math.min(r, g, b);
    let h;
    let s;
    let l = (max + min) / 2;
    if (max == min) h = s = 0; // achromatic
    else {
        var d = max - min;
        s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
        switch(max){
            case r:
                h = (g - b) / d + (g < b ? 6 : 0);
                break;
            case g:
                h = (b - r) / d + 2;
                break;
            case b:
                h = (r - g) / d + 4;
                break;
            default:
                throw new Error("Unreachable");
        }
        h /= 6;
    }
    return {
        h: h,
        s: s,
        l: l
    };
}
function $913afda613ebf2cb$export$210753cfeec758a5({ h: h, s: s, v: v }) {
    var r, g, b, i, f, p, q, t;
    i = Math.floor(h * 6);
    f = h * 6 - i;
    p = v * (1 - s);
    q = v * (1 - f * s);
    t = v * (1 - (1 - f) * s);
    switch(i % 6){
        case 0:
            r = v, g = t, b = p;
            break;
        case 1:
            r = q, g = v, b = p;
            break;
        case 2:
            r = p, g = v, b = t;
            break;
        case 3:
            r = p, g = q, b = v;
            break;
        case 4:
            r = t, g = p, b = v;
            break;
        case 5:
            r = v, g = p, b = q;
            break;
        default:
            throw new Error("unreachable");
    }
    return {
        r: Math.round(r * 255),
        g: Math.round(g * 255),
        b: Math.round(b * 255)
    };
}
function $913afda613ebf2cb$export$f76e85ca00a47f5c({ r: r, g: g, b: b }) {
    var max = Math.max(r, g, b), min = Math.min(r, g, b), d = max - min, h, s = max === 0 ? 0 : d / max, v = max / 255;
    switch(max){
        case min:
            h = 0;
            break;
        case r:
            h = g - b + d * (g < b ? 6 : 0);
            h /= 6 * d;
            break;
        case g:
            h = b - r + d * 2;
            h /= 6 * d;
            break;
        case b:
            h = r - g + d * 4;
            h /= 6 * d;
            break;
        default:
            throw new Error("unreachable");
    }
    return {
        h: h,
        s: s,
        v: v
    };
}



/**
 * Per-frame CPU+GPU storage for instance transforms.
 *
 * Each Transform struct lays out as 16 floats (64 bytes), std430-friendly:
 *   modelCol0: vec2  (offset  0)
 *   modelCol1: vec2  (offset  8)
 *   modelCol2: vec2  (offset 16)
 *   zCoeffs:   vec2  (offset 24)
 *   zDepth:    vec4  (offset 32)  — (zRow.x, zRow.y, zRow.z, zBase)
 *   tint:      vec4  (offset 48)
 *
 * Slot 0 is reserved as the identity-root transform (untinted, no parallax).
 * On overflow, alloc returns 0 so the caller renders in root space — visually
 * wrong for the offending primitive, but non-crashing.
 */ const $f80e684830d9eeb0$export$68b04b8247b1c5d3 = 4096;
const $f80e684830d9eeb0$export$9eb537fcbaf28d36 = 16;
const $f80e684830d9eeb0$var$TRANSFORM_STRIDE_BYTES = $f80e684830d9eeb0$export$9eb537fcbaf28d36 * 4;
class $f80e684830d9eeb0$export$3996232f9c1e10d3 {
    constructor(capacity = $f80e684830d9eeb0$export$68b04b8247b1c5d3){
        this.capacity = capacity;
        this.gpuBuffer = null;
        this.count = 0;
        this.overflowWarned = false;
        this.cpuBuffer = new Float32Array(capacity * $f80e684830d9eeb0$export$9eb537fcbaf28d36);
        this.writeIdentity(0);
        this.count = 1;
    }
    /** Size of each instance in bytes; useful for binding layout. */ get strideBytes() {
        return $f80e684830d9eeb0$var$TRANSFORM_STRIDE_BYTES;
    }
    /** Number of slots used this frame (includes the identity at index 0). */ get used() {
        return this.count;
    }
    /**
   * Reset for a new frame. The identity transform at slot 0 is preserved.
   * `overflowWarned` intentionally persists — if one frame overflows, later
   * frames usually do too, and we don't want to spam once-per-frame.
   */ reset() {
        this.count = 1;
    }
    /**
   * Allocate a new slot and write `t` into it.
   * Returns the slot index, or 0 on overflow (identity root).
   */ alloc(t) {
        if (this.count >= this.capacity) {
            if (!this.overflowWarned) {
                console.warn(`[TransformBuffer] overflow: more than ${this.capacity} transforms in one frame, rendering affected primitives in identity space`);
                this.overflowWarned = true;
            }
            return 0;
        }
        const idx = this.count++;
        this.writeSlot(idx, t);
        return idx;
    }
    /** Ensure the GPU buffer is created and at least as large as needed. */ ensureGpuBuffer(device) {
        if (this.gpuBuffer) return this.gpuBuffer;
        this.gpuBuffer = device.createBuffer({
            label: "TransformBuffer",
            size: this.capacity * $f80e684830d9eeb0$var$TRANSFORM_STRIDE_BYTES,
            usage: GPUBufferUsage.STORAGE | GPUBufferUsage.COPY_DST
        });
        return this.gpuBuffer;
    }
    /** Upload the CPU-side range [0, used) to the GPU buffer. */ upload(device) {
        const buf = this.ensureGpuBuffer(device);
        const byteLength = this.count * $f80e684830d9eeb0$var$TRANSFORM_STRIDE_BYTES;
        device.queue.writeBuffer(buf, 0, this.cpuBuffer.buffer, this.cpuBuffer.byteOffset, byteLength);
        return buf;
    }
    /** Free the GPU buffer (called on renderer dispose). */ dispose() {
        if (this.gpuBuffer) {
            this.gpuBuffer.destroy();
            this.gpuBuffer = null;
        }
    }
    writeIdentity(slot) {
        const o = slot * $f80e684830d9eeb0$export$9eb537fcbaf28d36;
        const b = this.cpuBuffer;
        b[o + 0] = 1;
        b[o + 1] = 0; // modelCol0
        b[o + 2] = 0;
        b[o + 3] = 1; // modelCol1
        b[o + 4] = 0;
        b[o + 5] = 0; // modelCol2
        b[o + 6] = 0;
        b[o + 7] = 0; // zCoeffs
        b[o + 8] = 0;
        b[o + 9] = 0;
        b[o + 10] = 1;
        b[o + 11] = 0; // zDepth
        b[o + 12] = 1;
        b[o + 13] = 1;
        b[o + 14] = 1;
        b[o + 15] = 1; // tint
    }
    writeSlot(slot, t) {
        const o = slot * $f80e684830d9eeb0$export$9eb537fcbaf28d36;
        const b = this.cpuBuffer;
        b[o + 0] = t.modelCol0X;
        b[o + 1] = t.modelCol0Y;
        b[o + 2] = t.modelCol1X;
        b[o + 3] = t.modelCol1Y;
        b[o + 4] = t.modelCol2X;
        b[o + 5] = t.modelCol2Y;
        b[o + 6] = t.zCoeffX;
        b[o + 7] = t.zCoeffY;
        b[o + 8] = t.zRowX;
        b[o + 9] = t.zRowY;
        b[o + 10] = t.zRowZ;
        b[o + 11] = t.zBase;
        b[o + 12] = t.tintR;
        b[o + 13] = t.tintG;
        b[o + 14] = t.tintB;
        b[o + 15] = t.tintA;
    }
}


/**
 * Type-safe uniform buffer system.
 *
 * Generates both TypeScript accessors and WGSL shader structs from a single definition.
 * Handles WGSL alignment rules automatically.
 *
 * @example
 * const SurfaceUniforms = defineUniformStruct('Uniforms', {
 *   cameraMatrix: mat3x3,
 *   time: f32,
 *   renderMode: i32,
 * });
 *
 * // WGSL generation
 * const shaderCode = `${SurfaceUniforms.wgsl}`;
 *
 * // Type-safe setters
 * const uniforms = SurfaceUniforms.create();
 * uniforms.set.time(1.5);
 * uniforms.set.cameraMatrix(matrix);
 */ const $ca6793d1abd58997$export$e33361ff41014190 = {
    _brand: "f32",
    wgslType: "f32",
    size: 4,
    align: 4,
    floatCount: 1
};
const $ca6793d1abd58997$export$b71748db06371c77 = {
    _brand: "i32",
    wgslType: "i32",
    size: 4,
    align: 4,
    floatCount: 1
};
const $ca6793d1abd58997$export$8bacf4ad828c7fe7 = {
    _brand: "u32",
    wgslType: "u32",
    size: 4,
    align: 4,
    floatCount: 1
};
const $ca6793d1abd58997$export$e9830bc863290a54 = {
    _brand: "vec2",
    wgslType: "vec2<f32>",
    size: 8,
    align: 8,
    floatCount: 2
};
const $ca6793d1abd58997$export$9100789c9d999364 = {
    _brand: "vec3",
    wgslType: "vec3<f32>",
    size: 12,
    align: 16,
    floatCount: 3
};
const $ca6793d1abd58997$export$6dba2a1f0d609415 = {
    _brand: "vec4",
    wgslType: "vec4<f32>",
    size: 16,
    align: 16,
    floatCount: 4
};
const $ca6793d1abd58997$export$a4a790709c608b06 = {
    _brand: "vec4u",
    wgslType: "vec4<u32>",
    size: 16,
    align: 16,
    floatCount: 4
};
const $ca6793d1abd58997$export$a9b01fc77c97438b = {
    _brand: "mat3x3",
    wgslType: "mat3x3<f32>",
    size: 48,
    align: 16,
    floatCount: 12
};
// ============ Implementation ============
/**
 * Align a value up to the given alignment.
 */ function $ca6793d1abd58997$var$alignUp(value, alignment) {
    return Math.ceil(value / alignment) * alignment;
}
/**
 * Compute field layouts with proper WGSL alignment.
 */ function $ca6793d1abd58997$var$computeFieldLayouts(fields) {
    const result = [];
    let currentOffset = 0;
    for (const [name, type] of Object.entries(fields)){
        // Align to the field's required alignment
        currentOffset = $ca6793d1abd58997$var$alignUp(currentOffset, type.align);
        result.push({
            name: name,
            type: type,
            byteOffset: currentOffset,
            offset: currentOffset / 4
        });
        currentOffset += type.size;
    }
    return result;
}
/**
 * Compute total struct size with final alignment padding.
 * WGSL structs must be aligned to their largest member alignment.
 */ function $ca6793d1abd58997$var$computeStructSize(fields) {
    if (fields.length === 0) return 0;
    const lastField = fields[fields.length - 1];
    const endOffset = lastField.byteOffset + lastField.type.size;
    // Find largest alignment
    const maxAlign = Math.max(...fields.map((f)=>f.type.align));
    // Pad to largest alignment for array usage
    return $ca6793d1abd58997$var$alignUp(endOffset, maxAlign);
}
/**
 * Generate WGSL struct declaration.
 */ function $ca6793d1abd58997$var$generateWGSL(name, fields) {
    const lines = [
        `struct ${name} {`
    ];
    for (const [fieldName, fieldType] of Object.entries(fields))lines.push(`  ${fieldName}: ${fieldType.wgslType},`);
    lines.push("}");
    return lines.join("\n");
}
/**
 * Create setter functions for all fields.
 */ function $ca6793d1abd58997$var$createSetters(fields, data) {
    // Use any for the internal record since we build this dynamically
    // The public API is type-safe via SetterMap<T>
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const setters = {};
    const intView = new Int32Array(data.buffer);
    const uintView = new Uint32Array(data.buffer);
    for (const field of fields){
        const { name: name, type: type, offset: offset } = field;
        const brand = type._brand;
        if (brand === "f32") setters[name] = (value)=>{
            data[offset] = value;
        };
        else if (brand === "i32") setters[name] = (value)=>{
            intView[offset] = value;
        };
        else if (brand === "u32") setters[name] = (value)=>{
            uintView[offset] = value;
        };
        else if (brand === "vec2") setters[name] = (value)=>{
            data[offset] = value[0];
            data[offset + 1] = value[1];
        };
        else if (brand === "vec3") setters[name] = (value)=>{
            data[offset] = value[0];
            data[offset + 1] = value[1];
            data[offset + 2] = value[2];
        // Note: vec3 uses 12 bytes but offset 3 is padding
        };
        else if (brand === "vec4") setters[name] = (value)=>{
            data[offset] = value[0];
            data[offset + 1] = value[1];
            data[offset + 2] = value[2];
            data[offset + 3] = value[3];
        };
        else if (brand === "vec4u") setters[name] = (value)=>{
            uintView[offset] = value[0];
            uintView[offset + 1] = value[1];
            uintView[offset + 2] = value[2];
            uintView[offset + 3] = value[3];
        };
        else if (brand === "mat3x3") setters[name] = (value)=>{
            // mat3x3 in WGSL is column-major with each column padded to vec4
            if ("toArray" in value) {
                // Matrix3 object - convert to padded format
                const arr = value.toArray();
                // Column 0
                data[offset] = arr[0]; // a
                data[offset + 1] = arr[1]; // b
                data[offset + 2] = arr[2]; // 0 (from 2D matrix)
                data[offset + 3] = 0; // padding
                // Column 1
                data[offset + 4] = arr[3]; // c
                data[offset + 5] = arr[4]; // d
                data[offset + 6] = arr[5]; // 0
                data[offset + 7] = 0; // padding
                // Column 2
                data[offset + 8] = arr[6]; // tx
                data[offset + 9] = arr[7]; // ty
                data[offset + 10] = arr[8]; // 1
                data[offset + 11] = 0; // padding
            } else // Already a Float32Array in the correct padded format
            for(let i = 0; i < 12; i++)data[offset + i] = value[i];
        };
    }
    return setters;
}
let $ca6793d1abd58997$var$deviceRef = null;
function $ca6793d1abd58997$export$3314b1eef7700541(device) {
    $ca6793d1abd58997$var$deviceRef = device;
}
function $ca6793d1abd58997$export$99bb2281c7368d10(name, fields) {
    const computedFields = $ca6793d1abd58997$var$computeFieldLayouts(fields);
    const byteSize = $ca6793d1abd58997$var$computeStructSize(computedFields);
    const wgsl = $ca6793d1abd58997$var$generateWGSL(name, fields);
    return {
        name: name,
        fields: fields,
        wgsl: wgsl,
        byteSize: byteSize,
        create () {
            const buffer = new ArrayBuffer(byteSize);
            const data = new Float32Array(buffer);
            const setters = $ca6793d1abd58997$var$createSetters(computedFields, data);
            return {
                data: data,
                buffer: buffer,
                byteSize: byteSize,
                set: setters,
                uploadTo (gpuBuffer, offset = 0) {
                    if (!$ca6793d1abd58997$var$deviceRef) throw new Error("GPU device not set. Call setUniformDevice() during initialization.");
                    $ca6793d1abd58997$var$deviceRef.queue.writeBuffer(gpuBuffer, offset, buffer);
                }
            };
        }
    };
}


/**
 * GPU profiler using WebGPU timestamp queries for accurate GPU timing.
 *
 * Supports multiple named sections (render, surface.water, surface.terrain, etc.)
 * with independent timing for each. Uses double-buffered read buffers to avoid
 * mapping conflicts since mapAsync is asynchronous.
 */ 
/**
 * Profiler for tracking async operation callback CPU time.
 *
 * Key distinction from regular profiler:
 * - Regular profiler tracks synchronous code execution within a frame
 * - AsyncProfiler tracks callback CPU time that runs on the main thread
 *   but happens at unpredictable times (between frames, during yield points)
 *
 * The callback CPU time DOES affect FPS because it runs on the main thread.
 *
 * Usage:
 *   // Wrap a promise-returning operation
 *   const result = await asyncProfiler.measureAsync("GPU.mapAsync",
 *     () => buffer.mapAsync(GPUMapMode.READ)
 *   );
 *
 *   // Or wrap just the callback
 *   buffer.mapAsync(GPUMapMode.READ).then(
 *     asyncProfiler.wrapCallback("GPU.processData", () => {
 *       // process mapped data
 *     })
 *   );
 */ class $87110bde7a27e156$var$AsyncProfiler {
    /**
   * Wrap an async operation to track its callback CPU time.
   * Tracks both the latency (start to completion) and callback time.
   */ measureAsync(label, asyncFn) {
        if (!this.enabled) return asyncFn();
        const entry = this.getOrCreate(label);
        const timing = {
            startTime: performance.now(),
            startFrame: this.currentFrame
        };
        entry.inFlight.push(timing);
        entry.peakInFlight = Math.max(entry.peakInFlight, entry.inFlight.length);
        return asyncFn().then((result)=>{
            this.recordCompletion(label, timing);
            return result;
        }, (error)=>{
            this.recordCompletion(label, timing);
            throw error;
        });
    }
    /**
   * Wrap a callback function to track its CPU time.
   * Use this when you can't use measureAsync directly,
   * or when you only want to track the callback without latency.
   */ wrapCallback(label, callback) {
        if (!this.enabled) return callback;
        const entry = this.getOrCreate(label);
        return (...args)=>{
            const callbackStart = performance.now();
            try {
                return callback(...args);
            } finally{
                const elapsed = performance.now() - callbackStart;
                entry.frame.completions++;
                entry.frame.callbackMs += elapsed;
                entry.frame.maxCallbackMs = Math.max(entry.frame.maxCallbackMs, elapsed);
                entry.peakCallbackMs = Math.max(entry.peakCallbackMs, elapsed);
            }
        };
    }
    /**
   * Start tracking an async operation manually.
   * Call endAsync when the callback completes.
   */ startAsync(label) {
        if (!this.enabled) return {
            label: label,
            timing: null
        };
        const entry = this.getOrCreate(label);
        const timing = {
            startTime: performance.now(),
            startFrame: this.currentFrame
        };
        entry.inFlight.push(timing);
        entry.peakInFlight = Math.max(entry.peakInFlight, entry.inFlight.length);
        return {
            label: label,
            timing: timing
        };
    }
    /**
   * End tracking an async operation and record timing.
   * The elapsed time since the token was created becomes the callback time.
   */ endAsync(token) {
        if (!this.enabled || !token.timing) return;
        this.recordCompletion(token.label, token.timing);
    }
    /**
   * Called by the main profiler when a frame ends.
   * Updates smoothed values and resets frame accumulators.
   */ endFrame() {
        this.currentFrame++;
        for (const entry of this.entries.values()){
            entry.smoothedCompletionsPerFrame = (0, $2172aedd5a25ff17$export$3a89f8d6f6bf6c9f)(entry.frame.completions, entry.smoothedCompletionsPerFrame, this.smoothing);
            entry.smoothedCallbackMsPerFrame = (0, $2172aedd5a25ff17$export$3a89f8d6f6bf6c9f)(entry.frame.callbackMs, entry.smoothedCallbackMsPerFrame, this.smoothing);
            entry.smoothedMaxCallbackMs = (0, $2172aedd5a25ff17$export$3a89f8d6f6bf6c9f)(entry.frame.maxCallbackMs, entry.smoothedMaxCallbackMs, this.smoothing);
            const avgLatency = entry.frame.completions > 0 ? entry.frame.totalLatencyMs / entry.frame.completions : entry.smoothedLatencyMs;
            entry.smoothedLatencyMs = (0, $2172aedd5a25ff17$export$3a89f8d6f6bf6c9f)(avgLatency, entry.smoothedLatencyMs, this.smoothing);
            entry.frame = {
                completions: 0,
                callbackMs: 0,
                maxCallbackMs: 0,
                totalLatencyMs: 0
            };
        }
    }
    /**
   * Get all async profile stats for display, sorted by callback time.
   */ getStats() {
        const stats = [];
        for (const [label, entry] of this.entries)stats.push({
            label: label,
            callbackMsPerFrame: entry.smoothedCallbackMsPerFrame,
            completionsPerFrame: entry.smoothedCompletionsPerFrame,
            avgLatencyMs: entry.smoothedLatencyMs,
            inFlightCount: entry.inFlight.length,
            peakCallbackMs: entry.peakCallbackMs,
            peakLatencyMs: entry.peakLatencyMs,
            peakInFlight: entry.peakInFlight
        });
        stats.sort((a, b)=>b.callbackMsPerFrame - a.callbackMsPerFrame);
        return stats;
    }
    /**
   * Get total callback CPU time per frame across all async operations.
   */ getTotalCallbackMs() {
        let total = 0;
        for (const entry of this.entries.values())total += entry.smoothedCallbackMsPerFrame;
        return total;
    }
    setEnabled(enabled) {
        this.enabled = enabled;
    }
    isEnabled() {
        return this.enabled;
    }
    reset() {
        this.entries.clear();
    }
    recordCompletion(label, timing) {
        const entry = this.entries.get(label);
        if (!entry) return;
        const idx = entry.inFlight.indexOf(timing);
        if (idx >= 0) entry.inFlight.splice(idx, 1);
        const now = performance.now();
        const callbackMs = now - timing.startTime;
        const latencyMs = callbackMs;
        entry.frame.completions++;
        entry.frame.callbackMs += callbackMs;
        entry.frame.maxCallbackMs = Math.max(entry.frame.maxCallbackMs, callbackMs);
        entry.frame.totalLatencyMs += latencyMs;
        entry.peakCallbackMs = Math.max(entry.peakCallbackMs, callbackMs);
        entry.peakLatencyMs = Math.max(entry.peakLatencyMs, latencyMs);
    }
    getOrCreate(label) {
        let entry = this.entries.get(label);
        if (!entry) {
            entry = {
                frame: {
                    completions: 0,
                    callbackMs: 0,
                    maxCallbackMs: 0,
                    totalLatencyMs: 0
                },
                smoothedCompletionsPerFrame: 0,
                smoothedCallbackMsPerFrame: 0,
                smoothedMaxCallbackMs: 0,
                smoothedLatencyMs: 0,
                inFlight: [],
                peakCallbackMs: 0,
                peakLatencyMs: 0,
                peakInFlight: 0
            };
            this.entries.set(label, entry);
        }
        return entry;
    }
    constructor(){
        this.entries = new Map();
        this.enabled = true;
        this.currentFrame = 0;
        this.smoothing = 0.975;
    }
}
const $87110bde7a27e156$export$c160a1ab3b49575c = new $87110bde7a27e156$var$AsyncProfiler();


/**
 * Simple double buffer for alternating read/write access.
 * Useful for async operations where one buffer is read while another is written.
 */ class $e41ebc4a8c7c6fe6$export$1c311eac3da4c8b9 {
    constructor(a, b){
        this.a = a;
        this.b = b;
        this.readPtr = a;
    }
    /** Get the buffer currently available for reading */ getRead() {
        return this.readPtr;
    }
    /** Get the buffer currently available for writing */ getWrite() {
        return this.readPtr === this.a ? this.b : this.a;
    }
    /** Swap read and write buffers */ swap() {
        this.readPtr = this.getWrite();
    }
}


class $13cb06f920708adf$export$774f3675766e58a7 {
    static{
        // Section definitions
        this.SECTIONS = [
            "render",
            "surface",
            "surface.water",
            "surface.terrain",
            "surface.rasterize",
            "surface.modifiers",
            "surface.wetness",
            "query",
            "query.terrain",
            "query.water",
            "query.wind",
            "trees"
        ];
    }
    static{
        this.QUERY_COUNT = $13cb06f920708adf$export$774f3675766e58a7.SECTIONS.length * 2;
    }
    static{
        /**
   * Groups share timestamp indices with their first/last child sections.
   * The first section's begin writes to the group's begin slot,
   * and the last section's end writes to the group's end slot.
   * This gives accurate wall-clock GPU time spanning all passes in the group.
   */ this.GROUPS = [
            {
                group: "surface",
                firstSection: "surface.terrain",
                lastSection: "surface.wetness"
            },
            {
                group: "query",
                firstSection: "query.terrain",
                lastSection: "query.wind"
            }
        ];
    }
    constructor(device){
        this.enabled = false;
        this.pendingMap = false;
        this.smoothing = 0.95;
        this.device = device;
        // Create query set for all sections (2 queries per section)
        this.querySet = device.createQuerySet({
            type: "timestamp",
            count: $13cb06f920708adf$export$774f3675766e58a7.QUERY_COUNT
        });
        // Buffer to resolve queries into
        const bufferSize = $13cb06f920708adf$export$774f3675766e58a7.QUERY_COUNT * 8; // 8 bytes per timestamp
        this.resolveBuffer = device.createBuffer({
            size: bufferSize,
            usage: GPUBufferUsage.QUERY_RESOLVE | GPUBufferUsage.COPY_SRC
        });
        // Double-buffered read buffers to avoid mapping conflicts
        this.readBuffers = new (0, $e41ebc4a8c7c6fe6$export$1c311eac3da4c8b9)(device.createBuffer({
            size: bufferSize,
            usage: GPUBufferUsage.COPY_DST | GPUBufferUsage.MAP_READ
        }), device.createBuffer({
            size: bufferSize,
            usage: GPUBufferUsage.COPY_DST | GPUBufferUsage.MAP_READ
        }));
        // Initialize section data with query indices
        this.sections = new Map();
        $13cb06f920708adf$export$774f3675766e58a7.SECTIONS.forEach((section, i)=>{
            this.sections.set(section, {
                queryStartIndex: i * 2,
                queryEndIndex: i * 2 + 1,
                smoothedMs: 0
            });
        });
        // Apply group index sharing: the first section's begin writes to the
        // group's begin slot, and the last section's end writes to the group's
        // end slot. Since these happen at the same GPU instant, individual
        // section timings remain accurate.
        for (const { group: group, firstSection: firstSection, lastSection: lastSection } of $13cb06f920708adf$export$774f3675766e58a7.GROUPS){
            const groupData = this.sections.get(group);
            const firstData = this.sections.get(firstSection);
            const lastData = this.sections.get(lastSection);
            firstData.queryStartIndex = groupData.queryStartIndex;
            lastData.queryEndIndex = groupData.queryEndIndex;
        }
    }
    /**
   * Get timestampWrites config for a render pass.
   * Returns undefined if profiling is disabled.
   */ getTimestampWrites(section = "render") {
        if (!this.enabled) return undefined;
        const data = this.sections.get(section);
        if (!data) return undefined;
        return {
            querySet: this.querySet,
            beginningOfPassWriteIndex: data.queryStartIndex,
            endOfPassWriteIndex: data.queryEndIndex
        };
    }
    /**
   * Get timestampWrites that only records the beginning-of-pass timestamp.
   * Use with getTimestampWritesEnd on another pass to span timing across
   * multiple render passes on the same command encoder.
   */ getTimestampWritesBegin(section) {
        if (!this.enabled) return undefined;
        const data = this.sections.get(section);
        if (!data) return undefined;
        return {
            querySet: this.querySet,
            beginningOfPassWriteIndex: data.queryStartIndex
        };
    }
    /**
   * Get timestampWrites that only records the end-of-pass timestamp.
   * Use with getTimestampWritesBegin on another pass to span timing across
   * multiple render passes on the same command encoder.
   */ getTimestampWritesEnd(section) {
        if (!this.enabled) return undefined;
        const data = this.sections.get(section);
        if (!data) return undefined;
        return {
            querySet: this.querySet,
            endOfPassWriteIndex: data.queryEndIndex
        };
    }
    /**
   * Get timestampWrites config for a compute pass.
   * Returns undefined if profiling is disabled.
   */ getComputeTimestampWrites(section) {
        if (!this.enabled) return undefined;
        const data = this.sections.get(section);
        if (!data) return undefined;
        return {
            querySet: this.querySet,
            beginningOfPassWriteIndex: data.queryStartIndex,
            endOfPassWriteIndex: data.queryEndIndex
        };
    }
    /**
   * Resolve all timestamps and copy to read buffer.
   * Call after all command encoders are finished, before submit.
   */ resolve(encoder) {
        if (!this.enabled) return;
        // Resolve all timestamps to buffer
        encoder.resolveQuerySet(this.querySet, 0, $13cb06f920708adf$export$774f3675766e58a7.QUERY_COUNT, this.resolveBuffer, 0);
        // Copy to mappable read buffer (use the buffer we're NOT currently reading from)
        encoder.copyBufferToBuffer(this.resolveBuffer, 0, this.readBuffers.getWrite(), 0, $13cb06f920708adf$export$774f3675766e58a7.QUERY_COUNT * 8);
    }
    /**
   * Start async read of results from previous frame.
   * Call after submit.
   */ readResults() {
        if (!this.enabled || this.pendingMap) return;
        const readBuffer = this.readBuffers.getRead();
        this.pendingMap = true;
        readBuffer.mapAsync(GPUMapMode.READ).then((0, $87110bde7a27e156$export$c160a1ab3b49575c).wrapCallback("GPUProfiler.processResults", ()=>{
            const times = new BigUint64Array(readBuffer.getMappedRange());
            // Process each section
            for (const [, data] of this.sections){
                const startNs = times[data.queryStartIndex];
                const endNs = times[data.queryEndIndex];
                // Only update if we have valid timestamps (non-zero)
                if (startNs > 0 && endNs > 0 && endNs >= startNs) {
                    const elapsedMs = Number(endNs - startNs) / 1000000;
                    data.smoothedMs = this.smoothing * data.smoothedMs + (1 - this.smoothing) * elapsedMs;
                }
            }
            readBuffer.unmap();
            this.pendingMap = false;
            // Swap to other buffer for next frame
            this.readBuffers.swap();
        })).catch(()=>{
            // Mapping failed (e.g., buffer already mapped), ignore
            this.pendingMap = false;
        });
    }
    /**
   * Get the smoothed GPU time in milliseconds for a section.
   * Defaults to "render" for backwards compatibility.
   */ getMs(section = "render") {
        return this.sections.get(section)?.smoothedMs ?? 0;
    }
    /**
   * Get all section timings.
   */ getAllMs() {
        return Object.fromEntries($13cb06f920708adf$export$774f3675766e58a7.SECTIONS.map((section)=>[
                section,
                this.getMs(section)
            ]));
    }
    setEnabled(enabled) {
        this.enabled = enabled;
    }
    isEnabled() {
        return this.enabled;
    }
    /**
   * Reset all smoothed values (e.g., when profiler is toggled).
   */ reset() {
        for (const data of this.sections.values())data.smoothedMs = 0;
    }
}


/**
 * Runtime MSAA state. Lets the renderer and every MSAA-aware pipeline owner
 * rebuild in sync when the user toggles antialiasing on or off.
 *
 * Setting persists to localStorage so the choice survives reloads.
 * Subscribers fire synchronously; they are expected to destroy their old
 * pipeline (textures stay the same) and create a new one at the current
 * sample count. The renderer also destroys/recreates MSAA color and depth
 * textures at the new sample count as part of its own subscriber.
 */ const $3d4164726c38f33c$var$KEY = "msaa";
let $3d4164726c38f33c$var$currentSampleCount = typeof localStorage !== "undefined" && localStorage.getItem($3d4164726c38f33c$var$KEY) === "off" ? 1 : 4;
const $3d4164726c38f33c$var$subscribers = new Set();
function $3d4164726c38f33c$export$688369c54d530641() {
    return $3d4164726c38f33c$var$currentSampleCount;
}
function $3d4164726c38f33c$export$8f47e656fde7db88() {
    return $3d4164726c38f33c$var$currentSampleCount > 1;
}
function $3d4164726c38f33c$export$d7ca61431a454ec7(enabled) {
    const next = enabled ? 4 : 1;
    if (next === $3d4164726c38f33c$var$currentSampleCount) return;
    $3d4164726c38f33c$var$currentSampleCount = next;
    if (typeof localStorage !== "undefined") localStorage.setItem($3d4164726c38f33c$var$KEY, enabled ? "on" : "off");
    for (const cb of $3d4164726c38f33c$var$subscribers)cb();
}
function $3d4164726c38f33c$export$19f5a511f7104745(cb) {
    $3d4164726c38f33c$var$subscribers.add(cb);
    return ()=>$3d4164726c38f33c$var$subscribers.delete(cb);
}



const $e2d5197080de0e53$export$547e49c5a71c21ad = (0, $0858672ccca83b12$export$c54d233df6da0831); // 7
const $e2d5197080de0e53$export$33c641a0abf307 = 262144; // ~7 MiB of vertex data (~1 MiB of tx indices)
const $e2d5197080de0e53$export$20203cb0f829828e = $e2d5197080de0e53$export$33c641a0abf307 * 6;
const $e2d5197080de0e53$var$GPU_BUFFER_FLUSH_CAPACITY = 4;
class $e2d5197080de0e53$export$c9632bc23d642f0e {
    static{
        this.overflowWarned = false;
    }
    constructor(maxVertices = $e2d5197080de0e53$export$33c641a0abf307, maxIndices = $e2d5197080de0e53$export$20203cb0f829828e){
        this.maxVertices = maxVertices;
        this.maxIndices = maxIndices;
        this.vertexCount = 0;
        this.indexCount = 0;
        this./** Transform-buffer slot index to stamp on newly reserved vertices. */ currentTransformIndex = 0;
        this.vertexBuffer = null;
        this.indexBuffer = null;
        this.txIndexBuffer = null;
        this.gpuVertexByteOffset = 0;
        this.gpuIndexByteOffset = 0;
        this.gpuTxIndexByteOffset = 0;
        this.vertexData = new Float32Array(maxVertices * $e2d5197080de0e53$export$547e49c5a71c21ad);
        this.txIndexData = new Uint32Array(maxVertices);
        this.indexData = new Uint32Array(maxIndices);
    }
    createGpuBuffers(device) {
        if (this.vertexBuffer) return;
        this.vertexBuffer = device.createBuffer({
            size: this.vertexData.byteLength * $e2d5197080de0e53$var$GPU_BUFFER_FLUSH_CAPACITY,
            usage: GPUBufferUsage.VERTEX | GPUBufferUsage.COPY_DST,
            label: "Shape Vertex Buffer"
        });
        this.txIndexBuffer = device.createBuffer({
            size: this.txIndexData.byteLength * $e2d5197080de0e53$var$GPU_BUFFER_FLUSH_CAPACITY,
            usage: GPUBufferUsage.VERTEX | GPUBufferUsage.COPY_DST,
            label: "Shape TransformIndex Buffer"
        });
        this.indexBuffer = device.createBuffer({
            size: this.indexData.byteLength * $e2d5197080de0e53$var$GPU_BUFFER_FLUSH_CAPACITY,
            usage: GPUBufferUsage.INDEX | GPUBufferUsage.COPY_DST,
            label: "Shape Index Buffer"
        });
    }
    resetFrameOffsets() {
        this.gpuVertexByteOffset = 0;
        this.gpuIndexByteOffset = 0;
        this.gpuTxIndexByteOffset = 0;
    }
    resetBatch() {
        this.vertexCount = 0;
        this.indexCount = 0;
    }
    // VertexSink impl -----------------------------------------------------------
    reserveVertices(n) {
        if (this.vertexCount + n > this.maxVertices) {
            if (!$e2d5197080de0e53$export$c9632bc23d642f0e.overflowWarned) {
                $e2d5197080de0e53$export$c9632bc23d642f0e.overflowWarned = true;
                console.warn(`ShapeBatch: reserveVertices(${n}) would overflow (${this.vertexCount}/${this.maxVertices}); dropping geometry. Caller should flush before exceeding capacity.`);
            }
            return {
                base: 0,
                view: this.vertexData.subarray(0, 0)
            };
        }
        const base = this.vertexCount;
        const startFloat = base * $e2d5197080de0e53$export$547e49c5a71c21ad;
        const view = this.vertexData.subarray(startFloat, startFloat + n * $e2d5197080de0e53$export$547e49c5a71c21ad);
        const tx = this.currentTransformIndex;
        for(let i = 0; i < n; i++)this.txIndexData[base + i] = tx;
        this.vertexCount += n;
        return {
            base: base,
            view: view
        };
    }
    reserveIndices(n) {
        if (this.indexCount + n > this.maxIndices) {
            if (!$e2d5197080de0e53$export$c9632bc23d642f0e.overflowWarned) {
                $e2d5197080de0e53$export$c9632bc23d642f0e.overflowWarned = true;
                console.warn(`ShapeBatch: reserveIndices(${n}) would overflow (${this.indexCount}/${this.maxIndices}); dropping geometry.`);
            }
            return this.indexData.subarray(0, 0);
        }
        const start = this.indexCount;
        this.indexCount += n;
        return this.indexData.subarray(start, start + n);
    }
    /**
   * Upload + issue one draw command for the currently-accumulated batch.
   * Returns the number of vertices drawn (0 if nothing to flush).
   */ flush(device, pass, pipeline, bindGroup) {
        if (this.indexCount === 0 || !this.vertexBuffer || !this.indexBuffer || !this.txIndexBuffer) return {
            vertices: 0,
            triangles: 0
        };
        const vertexByteSize = this.vertexCount * $e2d5197080de0e53$export$547e49c5a71c21ad * 4;
        const txByteSize = this.vertexCount * 4;
        // writeBuffer requires 4-byte-aligned sizes; Uint32 is naturally aligned.
        const indexByteSize = this.indexCount * 4;
        const vbCapacity = this.vertexData.byteLength * $e2d5197080de0e53$var$GPU_BUFFER_FLUSH_CAPACITY;
        const ibCapacity = this.indexData.byteLength * $e2d5197080de0e53$var$GPU_BUFFER_FLUSH_CAPACITY;
        const tbCapacity = this.txIndexData.byteLength * $e2d5197080de0e53$var$GPU_BUFFER_FLUSH_CAPACITY;
        if (this.gpuVertexByteOffset + vertexByteSize > vbCapacity || this.gpuIndexByteOffset + indexByteSize > ibCapacity || this.gpuTxIndexByteOffset + txByteSize > tbCapacity) {
            this.gpuVertexByteOffset = 0;
            this.gpuIndexByteOffset = 0;
            this.gpuTxIndexByteOffset = 0;
        }
        device.queue.writeBuffer(this.vertexBuffer, this.gpuVertexByteOffset, this.vertexData.buffer, this.vertexData.byteOffset, vertexByteSize);
        device.queue.writeBuffer(this.txIndexBuffer, this.gpuTxIndexByteOffset, this.txIndexData.buffer, this.txIndexData.byteOffset, txByteSize);
        device.queue.writeBuffer(this.indexBuffer, this.gpuIndexByteOffset, this.indexData.buffer, this.indexData.byteOffset, indexByteSize);
        pass.setPipeline(pipeline);
        pass.setBindGroup(0, bindGroup);
        pass.setVertexBuffer(0, this.vertexBuffer, this.gpuVertexByteOffset);
        pass.setVertexBuffer(1, this.txIndexBuffer, this.gpuTxIndexByteOffset);
        pass.setIndexBuffer(this.indexBuffer, "uint32", this.gpuIndexByteOffset);
        pass.drawIndexed(this.indexCount);
        const result = {
            vertices: this.vertexCount,
            triangles: this.indexCount / 3
        };
        this.gpuVertexByteOffset += vertexByteSize;
        this.gpuTxIndexByteOffset += txByteSize;
        this.gpuIndexByteOffset += indexByteSize;
        this.vertexCount = 0;
        this.indexCount = 0;
        return result;
    }
    dispose() {
        this.vertexBuffer?.destroy();
        this.indexBuffer?.destroy();
        this.txIndexBuffer?.destroy();
        this.vertexBuffer = null;
        this.indexBuffer = null;
        this.txIndexBuffer = null;
    }
}


/**
 * CPU-side batch for textured sprite vertices.
 *
 * Layout per vertex: position(2) + texCoord(2) + color(4) + z(1) = 9 floats
 * = 36 bytes. A parallel Uint32 stream carries transformIndex. Indices are
 * Uint32.
 *
 * Sprites don't use the generic VertexSink contract; `drawImage` writes the
 * vertex pairs directly.
 */ const $71282c70e923b5a2$export$dee6fd314400385a = 9;
const $71282c70e923b5a2$export$c0856ca054c1a2ff = 262144;
const $71282c70e923b5a2$export$8887db73cf14d60a = $71282c70e923b5a2$export$c0856ca054c1a2ff / 4 * 6;
const $71282c70e923b5a2$var$GPU_BUFFER_FLUSH_CAPACITY = 4;
class $71282c70e923b5a2$export$3ed609ab8670b5c5 {
    constructor(maxVertices = $71282c70e923b5a2$export$c0856ca054c1a2ff, maxIndices = $71282c70e923b5a2$export$8887db73cf14d60a){
        this.maxVertices = maxVertices;
        this.maxIndices = maxIndices;
        this.vertexCount = 0;
        this.indexCount = 0;
        this.currentTransformIndex = 0;
        this.vertexBuffer = null;
        this.indexBuffer = null;
        this.txIndexBuffer = null;
        this.gpuVertexByteOffset = 0;
        this.gpuIndexByteOffset = 0;
        this.gpuTxIndexByteOffset = 0;
        this.vertexData = new Float32Array(maxVertices * $71282c70e923b5a2$export$dee6fd314400385a);
        this.txIndexData = new Uint32Array(maxVertices);
        this.indexData = new Uint32Array(maxIndices);
    }
    createGpuBuffers(device) {
        if (this.vertexBuffer) return;
        this.vertexBuffer = device.createBuffer({
            size: this.vertexData.byteLength * $71282c70e923b5a2$var$GPU_BUFFER_FLUSH_CAPACITY,
            usage: GPUBufferUsage.VERTEX | GPUBufferUsage.COPY_DST,
            label: "Sprite Vertex Buffer"
        });
        this.txIndexBuffer = device.createBuffer({
            size: this.txIndexData.byteLength * $71282c70e923b5a2$var$GPU_BUFFER_FLUSH_CAPACITY,
            usage: GPUBufferUsage.VERTEX | GPUBufferUsage.COPY_DST,
            label: "Sprite TransformIndex Buffer"
        });
        this.indexBuffer = device.createBuffer({
            size: this.indexData.byteLength * $71282c70e923b5a2$var$GPU_BUFFER_FLUSH_CAPACITY,
            usage: GPUBufferUsage.INDEX | GPUBufferUsage.COPY_DST,
            label: "Sprite Index Buffer"
        });
    }
    resetFrameOffsets() {
        this.gpuVertexByteOffset = 0;
        this.gpuIndexByteOffset = 0;
        this.gpuTxIndexByteOffset = 0;
    }
    /** Write a single sprite quad (4 verts + 6 indices) using the current transform index. */ writeQuad(corners, uvs, r, g, b, a, z) {
        const base = this.vertexCount;
        const tx = this.currentTransformIndex;
        for(let i = 0; i < 4; i++){
            const o = (base + i) * $71282c70e923b5a2$export$dee6fd314400385a;
            this.vertexData[o + 0] = corners[i][0];
            this.vertexData[o + 1] = corners[i][1];
            this.vertexData[o + 2] = uvs[i][0];
            this.vertexData[o + 3] = uvs[i][1];
            this.vertexData[o + 4] = r;
            this.vertexData[o + 5] = g;
            this.vertexData[o + 6] = b;
            this.vertexData[o + 7] = a;
            this.vertexData[o + 8] = z;
            this.txIndexData[base + i] = tx;
        }
        this.vertexCount += 4;
        const idx = this.indexCount;
        this.indexData[idx + 0] = base + 0;
        this.indexData[idx + 1] = base + 1;
        this.indexData[idx + 2] = base + 2;
        this.indexData[idx + 3] = base + 0;
        this.indexData[idx + 4] = base + 2;
        this.indexData[idx + 5] = base + 3;
        this.indexCount += 6;
    }
    flush(device, pass, pipeline, uniformBindGroup, textureBindGroup) {
        if (this.indexCount === 0 || !this.vertexBuffer || !this.indexBuffer || !this.txIndexBuffer) return {
            vertices: 0,
            triangles: 0
        };
        const vertexByteSize = this.vertexCount * $71282c70e923b5a2$export$dee6fd314400385a * 4;
        const txByteSize = this.vertexCount * 4;
        const indexByteSize = this.indexCount * 4;
        const vbCapacity = this.vertexData.byteLength * $71282c70e923b5a2$var$GPU_BUFFER_FLUSH_CAPACITY;
        const ibCapacity = this.indexData.byteLength * $71282c70e923b5a2$var$GPU_BUFFER_FLUSH_CAPACITY;
        const tbCapacity = this.txIndexData.byteLength * $71282c70e923b5a2$var$GPU_BUFFER_FLUSH_CAPACITY;
        if (this.gpuVertexByteOffset + vertexByteSize > vbCapacity || this.gpuIndexByteOffset + indexByteSize > ibCapacity || this.gpuTxIndexByteOffset + txByteSize > tbCapacity) {
            this.gpuVertexByteOffset = 0;
            this.gpuIndexByteOffset = 0;
            this.gpuTxIndexByteOffset = 0;
        }
        device.queue.writeBuffer(this.vertexBuffer, this.gpuVertexByteOffset, this.vertexData.buffer, this.vertexData.byteOffset, vertexByteSize);
        device.queue.writeBuffer(this.txIndexBuffer, this.gpuTxIndexByteOffset, this.txIndexData.buffer, this.txIndexData.byteOffset, txByteSize);
        device.queue.writeBuffer(this.indexBuffer, this.gpuIndexByteOffset, this.indexData.buffer, this.indexData.byteOffset, indexByteSize);
        pass.setPipeline(pipeline);
        pass.setBindGroup(0, uniformBindGroup);
        pass.setBindGroup(1, textureBindGroup);
        pass.setVertexBuffer(0, this.vertexBuffer, this.gpuVertexByteOffset);
        pass.setVertexBuffer(1, this.txIndexBuffer, this.gpuTxIndexByteOffset);
        pass.setIndexBuffer(this.indexBuffer, "uint32", this.gpuIndexByteOffset);
        pass.drawIndexed(this.indexCount);
        const result = {
            vertices: this.vertexCount,
            triangles: this.indexCount / 3
        };
        this.gpuVertexByteOffset += vertexByteSize;
        this.gpuTxIndexByteOffset += txByteSize;
        this.gpuIndexByteOffset += indexByteSize;
        this.vertexCount = 0;
        this.indexCount = 0;
        return result;
    }
    dispose() {
        this.vertexBuffer?.destroy();
        this.indexBuffer?.destroy();
        this.txIndexBuffer?.destroy();
        this.vertexBuffer = null;
        this.indexBuffer = null;
        this.txIndexBuffer = null;
    }
}


/**
 * Singleton manager for WebGPU device initialization and access.
 * Provides app-wide access to the GPU adapter and device.
 */ 
/**
 * Tracks GPU buffer allocations for memory profiling.
 *
 * Installed by WebGPUDeviceManager after device init — intercepts
 * device.createBuffer so every buffer (regardless of call site) is
 * automatically registered and unregistered on destroy.
 */ let $f1a2ee5243e5db50$var$instance = null;
class $f1a2ee5243e5db50$export$36a764d7d1b6286 {
    static getInstance() {
        if (!$f1a2ee5243e5db50$var$instance) $f1a2ee5243e5db50$var$instance = new $f1a2ee5243e5db50$export$36a764d7d1b6286();
        return $f1a2ee5243e5db50$var$instance;
    }
    /**
   * Patch a GPUDevice so every createBuffer call is tracked.
   * Also patches each buffer's destroy() to unregister it.
   */ install(device) {
        const tracker = this;
        const originalCreateBuffer = device.createBuffer.bind(device);
        device.createBuffer = (descriptor)=>{
            const buffer = originalCreateBuffer(descriptor);
            tracker.register(buffer, descriptor.label ?? "(unlabelled)", descriptor.size);
            const originalDestroy = buffer.destroy.bind(buffer);
            buffer.destroy = ()=>{
                tracker.unregister(buffer);
                originalDestroy();
            };
            return buffer;
        };
    }
    register(buffer, label, size) {
        this.buffers.set(buffer, {
            label: label,
            size: size
        });
    }
    unregister(buffer) {
        this.buffers.delete(buffer);
    }
    /** Aggregate live buffers by label, sorted by total size descending. */ getStats() {
        const groups = new Map();
        let totalBytes = 0;
        for (const { label: label, size: size } of this.buffers.values()){
            totalBytes += size;
            const existing = groups.get(label);
            if (existing) {
                existing.size += size;
                existing.count++;
            } else groups.set(label, {
                size: size,
                count: 1
            });
        }
        const entries = Array.from(groups.entries()).map(([label, { size: size, count: count }])=>({
                label: label,
                size: size,
                count: count
            })).sort((a, b)=>b.size - a.size);
        return {
            entries: entries,
            totalBytes: totalBytes
        };
    }
    constructor(){
        this.buffers = new Map();
    }
}


let $558c2f47f1fdd57f$var$instance = null;
function $558c2f47f1fdd57f$var$formatWGSLCompilationMessages(code, messages) {
    const lines = code.split(/\r?\n/);
    return messages.map((message)=>{
        const lineNum = message.lineNum ?? 0;
        const linePos = message.linePos ?? 0;
        const sourceLine = lineNum > 0 ? lines[lineNum - 1] ?? "" : "";
        const location = lineNum > 0 ? `:${lineNum}:${Math.max(0, linePos) + 1}` : "";
        const snippet = sourceLine ? `\n  ${sourceLine}` : "";
        return `- [${message.type}]${location} ${message.message}${snippet}`;
    }).join("\n");
}
async function $558c2f47f1fdd57f$export$bdd7f96686113d46(shaderModule, code, label) {
    const info = await shaderModule.getCompilationInfo();
    if (info.messages.length === 0) return;
    const prefix = label ? `[${label}]` : "[Shader]";
    const warnings = info.messages.filter((message)=>message.type === "warning");
    if (warnings.length > 0) console.warn(`${prefix} WGSL compilation warnings:\n${$558c2f47f1fdd57f$var$formatWGSLCompilationMessages(code, warnings)}`);
    const errors = info.messages.filter((message)=>message.type === "error");
    if (errors.length > 0) throw new Error(`${prefix} WGSL compilation failed:\n${$558c2f47f1fdd57f$var$formatWGSLCompilationMessages(code, errors)}`);
}
class $558c2f47f1fdd57f$export$d6935dc84c2cd4b0 {
    constructor(){
        this._adapter = null;
        this._device = null;
        this._initialized = false;
        /** Preferred texture format for the current adapter */ this._preferredFormat = "bgra8unorm";
        /** Feature support flags */ this._features = {
            float32Filterable: false,
            timestampQuery: false,
            shaderF16: false,
            depthClipControl: false
        };
    }
    /** Get the singleton instance */ static getInstance() {
        if (!$558c2f47f1fdd57f$var$instance) $558c2f47f1fdd57f$var$instance = new $558c2f47f1fdd57f$export$d6935dc84c2cd4b0();
        return $558c2f47f1fdd57f$var$instance;
    }
    /** Check if WebGPU is available in this browser */ static isAvailable() {
        return typeof navigator !== "undefined" && "gpu" in navigator;
    }
    /**
   * Initialize the WebGPU adapter and device.
   * Must be called before using any WebGPU features.
   * @throws Error if WebGPU is not available
   */ async init() {
        if (this._initialized) return;
        if (!$558c2f47f1fdd57f$export$d6935dc84c2cd4b0.isAvailable()) throw new Error("WebGPU is not available in this browser. Please use Chrome 113+, Edge 113+, or Firefox Nightly with WebGPU enabled.");
        // Request adapter with high-performance preference
        this._adapter = await navigator.gpu.requestAdapter({
            powerPreference: "high-performance"
        });
        if (!this._adapter) throw new Error("Failed to get WebGPU adapter. Your GPU may not support WebGPU.");
        // Check for optional features
        const wantedFeatures = [];
        if (this._adapter.features.has("float32-filterable")) {
            wantedFeatures.push("float32-filterable");
            this._features.float32Filterable = true;
        }
        if (this._adapter.features.has("timestamp-query")) {
            wantedFeatures.push("timestamp-query");
            this._features.timestampQuery = true;
        }
        if (this._adapter.features.has("shader-f16")) {
            wantedFeatures.push("shader-f16");
            this._features.shaderF16 = true;
        }
        if (this._adapter.features.has("depth-clip-control")) {
            wantedFeatures.push("depth-clip-control");
            this._features.depthClipControl = true;
        }
        // Request device with optional features and higher limits
        this._device = await this._adapter.requestDevice({
            requiredFeatures: wantedFeatures,
            requiredLimits: {
                maxStorageBufferBindingSize: this._adapter.limits.maxStorageBufferBindingSize,
                maxBufferSize: this._adapter.limits.maxBufferSize
            }
        });
        if (!this._device) throw new Error("Failed to create WebGPU device.");
        // Set up device lost handler
        this._device.lost.then((info)=>{
            console.error(`WebGPU device lost: ${info.message}`);
            if (info.reason !== "destroyed") {
                // Attempt to reinitialize on unexpected loss
                this._initialized = false;
                this._device = null;
                this._adapter = null;
            }
        });
        // Get preferred canvas format
        this._preferredFormat = navigator.gpu.getPreferredCanvasFormat();
        // Install GPU buffer tracker before anything else creates buffers
        (0, $f1a2ee5243e5db50$export$36a764d7d1b6286).getInstance().install(this._device);
        // Initialize uniform struct system with device reference
        (0, $ca6793d1abd58997$export$3314b1eef7700541)(this._device);
        this._initialized = true;
    }
    /** Get the WebGPU adapter */ get adapter() {
        if (!this._adapter) throw new Error("WebGPU not initialized. Call init() first.");
        return this._adapter;
    }
    /** Get the WebGPU device */ get device() {
        if (!this._device) throw new Error("WebGPU not initialized. Call init() first.");
        return this._device;
    }
    /** Get the preferred texture format for canvases */ get preferredFormat() {
        return this._preferredFormat;
    }
    /** Check if the device has been initialized */ get isInitialized() {
        return this._initialized;
    }
    /** Get feature support info */ get features() {
        return this._features;
    }
    /** Get adapter limits */ get limits() {
        return this._adapter?.limits ?? null;
    }
    /**
   * Create a shader module from WGSL source.
   * @param code - WGSL shader source code
   * @param label - Optional debug label
   */ createShaderModule(code, label) {
        return this.device.createShaderModule({
            code: code,
            label: label
        });
    }
    /**
   * Create a shader module and fail fast on WGSL compilation errors.
   */ async createShaderModuleChecked(code, label) {
        const shaderModule = this.createShaderModule(code, label);
        await $558c2f47f1fdd57f$export$bdd7f96686113d46(shaderModule, code, label);
        return shaderModule;
    }
    /**
   * Create a buffer with optional initial data.
   */ createBuffer(descriptor) {
        return this.device.createBuffer(descriptor);
    }
    /**
   * Create a buffer initialized with data.
   */ createBufferWithData(data, usage, label) {
        const buffer = this.device.createBuffer({
            size: data.byteLength,
            usage: usage,
            label: label,
            mappedAtCreation: true
        });
        const mappedRange = buffer.getMappedRange();
        if (data instanceof Float32Array) new Float32Array(mappedRange).set(data);
        else if (data instanceof Uint16Array) new Uint16Array(mappedRange).set(data);
        else if (data instanceof Uint32Array) new Uint32Array(mappedRange).set(data);
        else if (data instanceof Uint8Array) new Uint8Array(mappedRange).set(data);
        else new Uint8Array(mappedRange).set(new Uint8Array(data.buffer));
        buffer.unmap();
        return buffer;
    }
    /** Clean up resources */ destroy() {
        if (this._device) {
            this._device.destroy();
            this._device = null;
        }
        this._adapter = null;
        this._initialized = false;
        $558c2f47f1fdd57f$var$instance = null;
    }
}
function $558c2f47f1fdd57f$export$297162150ea0f6af() {
    return $558c2f47f1fdd57f$export$d6935dc84c2cd4b0.getInstance();
}


/**
 * Manages loading and caching of WebGPU textures.
 */ 
class $cb7cbb6c3620557f$export$cfd7b9871d9e8b83 {
    constructor(){
        /** Cache of loaded textures by URL */ this.cache = new Map();
        /** Pending loads */ this.pending = new Map();
        /** Cached samplers by configuration key */ this.samplers = new Map();
        /** Default sampler for most textures */ this.defaultSampler = null;
    // Initialize default sampler lazily
    }
    /** Get or create the default linear sampler */ getDefaultSampler() {
        if (!this.defaultSampler) this.defaultSampler = this.createSampler("linear", "clamp-to-edge");
        return this.defaultSampler;
    }
    /**
   * Create a sampler with the specified configuration.
   * Samplers are cached and reused.
   */ createSampler(filter = "linear", addressMode = "clamp-to-edge") {
        const key = `${filter}-${addressMode}`;
        let sampler = this.samplers.get(key);
        if (!sampler) {
            const device = (0, $558c2f47f1fdd57f$export$297162150ea0f6af)().device;
            const filterMode = filter === "linear" ? "linear" : "nearest";
            const wrapMode = addressMode;
            sampler = device.createSampler({
                magFilter: filterMode,
                minFilter: filterMode,
                mipmapFilter: filterMode,
                addressModeU: wrapMode,
                addressModeV: wrapMode,
                addressModeW: wrapMode
            });
            this.samplers.set(key, sampler);
        }
        return sampler;
    }
    /**
   * Load a texture from a URL.
   * Returns a cached texture if already loaded.
   */ async load(url, options) {
        // Check cache
        const cached = this.cache.get(url);
        if (cached) return cached;
        // Check if already loading
        const pendingLoad = this.pending.get(url);
        if (pendingLoad) return pendingLoad;
        // Start loading
        const loadPromise = this.loadImage(url, options);
        this.pending.set(url, loadPromise);
        try {
            const texture = await loadPromise;
            this.cache.set(url, texture);
            return texture;
        } finally{
            this.pending.delete(url);
        }
    }
    /**
   * Load a texture synchronously from an already-loaded image.
   */ fromImage(image, options) {
        const device = (0, $558c2f47f1fdd57f$export$297162150ea0f6af)().device;
        const format = options?.format ?? "rgba8unorm";
        const usage = options?.usage ?? GPUTextureUsage.TEXTURE_BINDING | GPUTextureUsage.COPY_DST | GPUTextureUsage.RENDER_ATTACHMENT;
        const texture = device.createTexture({
            size: {
                width: image.width,
                height: image.height
            },
            format: format,
            usage: usage,
            label: options?.label
        });
        // Copy image data to texture
        device.queue.copyExternalImageToTexture({
            source: image
        }, {
            texture: texture
        }, {
            width: image.width,
            height: image.height
        });
        const view = texture.createView();
        return {
            texture: texture,
            view: view,
            width: image.width,
            height: image.height,
            sampler: this.getDefaultSampler()
        };
    }
    /**
   * Create a texture from a canvas.
   */ fromCanvas(canvas, options) {
        const device = (0, $558c2f47f1fdd57f$export$297162150ea0f6af)().device;
        const format = options?.format ?? "rgba8unorm";
        const usage = options?.usage ?? GPUTextureUsage.TEXTURE_BINDING | GPUTextureUsage.COPY_DST | GPUTextureUsage.RENDER_ATTACHMENT;
        const texture = device.createTexture({
            size: {
                width: canvas.width,
                height: canvas.height
            },
            format: format,
            usage: usage,
            label: options?.label
        });
        // Copy canvas data to texture
        device.queue.copyExternalImageToTexture({
            source: canvas
        }, {
            texture: texture
        }, {
            width: canvas.width,
            height: canvas.height
        });
        const view = texture.createView();
        return {
            texture: texture,
            view: view,
            width: canvas.width,
            height: canvas.height,
            sampler: this.getDefaultSampler()
        };
    }
    /**
   * Create an empty texture of the specified size.
   */ createEmpty(width, height, options) {
        const device = (0, $558c2f47f1fdd57f$export$297162150ea0f6af)().device;
        const format = options?.format ?? "rgba8unorm";
        const usage = options?.usage ?? GPUTextureUsage.TEXTURE_BINDING | GPUTextureUsage.COPY_DST | GPUTextureUsage.RENDER_ATTACHMENT;
        const texture = device.createTexture({
            size: {
                width: width,
                height: height
            },
            format: format,
            usage: usage,
            label: options?.label
        });
        const view = texture.createView();
        return {
            texture: texture,
            view: view,
            width: width,
            height: height,
            sampler: this.getDefaultSampler()
        };
    }
    /**
   * Create a render target texture (for off-screen rendering).
   */ createRenderTarget(width, height, format = "rgba16float", label) {
        const device = (0, $558c2f47f1fdd57f$export$297162150ea0f6af)().device;
        const texture = device.createTexture({
            size: {
                width: width,
                height: height
            },
            format: format,
            usage: GPUTextureUsage.TEXTURE_BINDING | GPUTextureUsage.RENDER_ATTACHMENT | GPUTextureUsage.COPY_SRC,
            label: label
        });
        const view = texture.createView();
        return {
            texture: texture,
            view: view,
            width: width,
            height: height,
            sampler: this.getDefaultSampler()
        };
    }
    /**
   * Create a storage texture (for compute shader output).
   */ createStorageTexture(width, height, format = "rgba16float", label) {
        const device = (0, $558c2f47f1fdd57f$export$297162150ea0f6af)().device;
        const texture = device.createTexture({
            size: {
                width: width,
                height: height
            },
            format: format,
            usage: GPUTextureUsage.TEXTURE_BINDING | GPUTextureUsage.STORAGE_BINDING | GPUTextureUsage.COPY_SRC,
            label: label
        });
        const view = texture.createView();
        return {
            texture: texture,
            view: view,
            width: width,
            height: height,
            sampler: this.getDefaultSampler()
        };
    }
    /**
   * Create a texture from raw pixel data.
   */ fromPixels(data, width, height, options) {
        const device = (0, $558c2f47f1fdd57f$export$297162150ea0f6af)().device;
        const format = options?.format ?? "rgba8unorm";
        const usage = options?.usage ?? GPUTextureUsage.TEXTURE_BINDING | GPUTextureUsage.COPY_DST | GPUTextureUsage.RENDER_ATTACHMENT;
        const texture = device.createTexture({
            size: {
                width: width,
                height: height
            },
            format: format,
            usage: usage,
            label: options?.label
        });
        // Upload pixel data
        device.queue.writeTexture({
            texture: texture
        }, data.buffer, {
            bytesPerRow: width * 4,
            rowsPerImage: height
        }, {
            width: width,
            height: height
        });
        const view = texture.createView();
        return {
            texture: texture,
            view: view,
            width: width,
            height: height,
            sampler: this.getDefaultSampler()
        };
    }
    /**
   * Update a texture with new pixel data.
   */ updateTexture(tex, data) {
        const device = (0, $558c2f47f1fdd57f$export$297162150ea0f6af)().device;
        device.queue.writeTexture({
            texture: tex.texture
        }, data.buffer, {
            bytesPerRow: tex.width * 4,
            rowsPerImage: tex.height
        }, {
            width: tex.width,
            height: tex.height
        });
    }
    /**
   * Create a 1x1 white texture (useful as default).
   */ createWhiteTexture() {
        return this.fromPixels(new Uint8Array([
            255,
            255,
            255,
            255
        ]), 1, 1);
    }
    /**
   * Delete a texture and free its resources.
   */ delete(tex) {
        tex.texture.destroy();
        // Remove from cache if present
        for (const [url, cached] of this.cache.entries())if (cached === tex) {
            this.cache.delete(url);
            break;
        }
    }
    /**
   * Clear all cached textures.
   */ clearCache() {
        for (const tex of this.cache.values())tex.texture.destroy();
        this.cache.clear();
    }
    /**
   * Clean up all resources.
   */ destroy() {
        this.clearCache();
        this.samplers.clear();
        this.defaultSampler = null;
    }
    /**
   * Get the number of cached textures.
   */ getTextureCount() {
        return this.cache.size;
    }
    /**
   * Load an image from URL and create a texture.
   */ async loadImage(url, options) {
        const response = await fetch(url);
        const blob = await response.blob();
        const imageBitmap = await createImageBitmap(blob);
        return this.fromImage(imageBitmap, {
            ...options,
            label: options?.label ?? url
        });
    }
}


const $5453fd34f01ad367$export$738c420ee12b9cdb = -300;
const $5453fd34f01ad367$export$e06187491332e57c = 100.0;
const $5453fd34f01ad367$var$DEPTH_FORMAT = "depth24plus";
const $5453fd34f01ad367$export$f9aebfc6c08dbb1c = (0, $3d4164726c38f33c$export$688369c54d530641)();
// Transform struct (std430) shared by shape + sprite shaders.
// Matches TransformBuffer.ts CPU layout: 16 floats / 64 bytes.
const $5453fd34f01ad367$var$transformStructWGSL = /*wgsl*/ `
struct Transform {
  modelCol0: vec2<f32>,
  modelCol1: vec2<f32>,
  modelCol2: vec2<f32>,
  zCoeffs:   vec2<f32>,
  zDepth:    vec4<f32>,  // (zRow.x, zRow.y, zRow.z, zBase)
  tint:      vec4<f32>,
}
`;
// Shape shader: Renders untextured colored primitives with optional depth
const $5453fd34f01ad367$var$shapeShaderSource = /*wgsl*/ `
const Z_MIN: f32 = ${$5453fd34f01ad367$export$738c420ee12b9cdb};
const Z_MAX: f32 = ${$5453fd34f01ad367$export$e06187491332e57c};

struct Uniforms {
  viewMatrix: mat3x3<f32>,
  ambientLight: vec3<f32>,
}

${$5453fd34f01ad367$var$transformStructWGSL}

struct VertexInput {
  @location(0) position: vec2<f32>,
  @location(1) color: vec4<f32>,
  @location(2) lightAffected: f32,
  @location(3) z: f32,
  @location(4) transformIndex: u32,
}

struct VertexOutput {
  @builtin(position) position: vec4<f32>,
  @location(0) color: vec4<f32>,
}

@group(0) @binding(0) var<uniform> uniforms: Uniforms;
@group(0) @binding(1) var<storage, read> transforms: array<Transform>;

@vertex
fn vs_main(in: VertexInput) -> VertexOutput {
  let t = transforms[in.transformIndex];
  let worldX = t.modelCol0.x * in.position.x + t.modelCol1.x * in.position.y
               + t.zCoeffs.x * in.z + t.modelCol2.x;
  let worldY = t.modelCol0.y * in.position.x + t.modelCol1.y * in.position.y
               + t.zCoeffs.y * in.z + t.modelCol2.y;
  let clipPos = uniforms.viewMatrix * vec3<f32>(worldX, worldY, 1.0);

  let depthZ = t.zDepth.w
             + t.zDepth.x * in.position.x
             + t.zDepth.y * in.position.y
             + t.zDepth.z * in.z;
  let depth = (depthZ - Z_MIN) / (Z_MAX - Z_MIN);

  // Global scene-lighting tint, gated per-vertex. lightAffected=1 \u{2192} tinted
  // by ambientLight; 0 \u{2192} pass-through (UI/debug geometry).
  let lightTint = mix(vec3<f32>(1.0), uniforms.ambientLight, in.lightAffected);

  var out: VertexOutput;
  out.position = vec4<f32>(clipPos.xy, depth, 1.0);
  out.color = in.color * t.tint * vec4<f32>(lightTint, 1.0);
  return out;
}

@fragment
fn fs_main(in: VertexOutput) -> @location(0) vec4<f32> {
  return in.color;
}
`;
// Sprite shader: Renders textured quads with tinting and optional depth
const $5453fd34f01ad367$var$spriteShaderSource = /*wgsl*/ `
const Z_MIN: f32 = ${$5453fd34f01ad367$export$738c420ee12b9cdb};
const Z_MAX: f32 = ${$5453fd34f01ad367$export$e06187491332e57c};

struct Uniforms {
  viewMatrix: mat3x3<f32>,
}

${$5453fd34f01ad367$var$transformStructWGSL}

struct VertexInput {
  @location(0) position: vec2<f32>,
  @location(1) texCoord: vec2<f32>,
  @location(2) color: vec4<f32>,
  @location(3) z: f32,
  @location(4) transformIndex: u32,
}

struct VertexOutput {
  @builtin(position) position: vec4<f32>,
  @location(0) texCoord: vec2<f32>,
  @location(1) color: vec4<f32>,
}

@group(0) @binding(0) var<uniform> uniforms: Uniforms;
@group(0) @binding(1) var textureSampler: sampler;
@group(0) @binding(2) var<storage, read> transforms: array<Transform>;
@group(1) @binding(0) var spriteTexture: texture_2d<f32>;

@vertex
fn vs_main(in: VertexInput) -> VertexOutput {
  let t = transforms[in.transformIndex];
  let worldX = t.modelCol0.x * in.position.x + t.modelCol1.x * in.position.y
               + t.zCoeffs.x * in.z + t.modelCol2.x;
  let worldY = t.modelCol0.y * in.position.x + t.modelCol1.y * in.position.y
               + t.zCoeffs.y * in.z + t.modelCol2.y;
  let clipPos = uniforms.viewMatrix * vec3<f32>(worldX, worldY, 1.0);

  let depthZ = t.zDepth.w
             + t.zDepth.x * in.position.x
             + t.zDepth.y * in.position.y
             + t.zDepth.z * in.z;
  let depth = (depthZ - Z_MIN) / (Z_MAX - Z_MIN);

  var out: VertexOutput;
  out.position = vec4<f32>(clipPos.xy, depth, 1.0);
  out.texCoord = in.texCoord;
  out.color = in.color * t.tint;
  return out;
}

@fragment
fn fs_main(in: VertexOutput) -> @location(0) vec4<f32> {
  let texColor = textureSample(spriteTexture, textureSampler, in.texCoord);
  return texColor * in.color;
}
`;
// Type-safe uniform buffer definition (view matrix + global scene lighting
// — per-instance transforms live in the TransformBuffer storage buffer).
// ambientLight is the combined sun+sky illumination color pushed each frame
// by SurfaceRenderer; the shape shader multiplies vertex color by it when
// the vertex's lightAffected flag is 1 (and passes color through when 0).
const $5453fd34f01ad367$var$ViewUniforms = (0, $ca6793d1abd58997$export$99bb2281c7368d10)("Uniforms", {
    viewMatrix: (0, $ca6793d1abd58997$export$a9b01fc77c97438b),
    ambientLight: (0, $ca6793d1abd58997$export$9100789c9d999364)
});
const $5453fd34f01ad367$var$UNIFORM_BUFFER_SIZE = $5453fd34f01ad367$var$ViewUniforms.byteSize;
class $5453fd34f01ad367$export$19fd8015bd4822d4 {
    static{
        this.warningKeys = new Set();
    }
    constructor(canvas){
        this.context = null;
        this.device = null;
        // Pipeline variants:
        // Pipeline variants for different depth modes:
        // - default: depth always-pass, no-write (main pass, non-depth layers)
        // - depth: depth greater-equal, write (main pass, depth-tested layers)
        // - alwaysWrite: depth always-pass, write (main pass, boat layer — draws on top, writes z)
        // - noDepth: no depthStencil at all (offscreen passes without depth attachment)
        this.shapePipeline = null;
        this.shapePipelineDepth = null;
        this.shapePipelineAlwaysWrite = null;
        this.shapePipelineNoDepth = null;
        this.spritePipeline = null;
        this.spritePipelineDepth = null;
        this.spritePipelineAlwaysWrite = null;
        this.spritePipelineNoDepth = null;
        // Depth state
        this.depthMode = "none";
        this.inOffscreenPass = false;
        // MSAA depth render attachment — only exists when MSAA is enabled.
        this.mainDepthTextureMS = null;
        this.mainDepthTextureMSView = null;
        // 1x depth — always exists.
        //   MSAA on:  written by the depth-resolve pass, sampled by overlays.
        //   MSAA off: the render attachment itself.
        this.mainDepthTexture = null;
        this.mainDepthTextureView = null;
        // Separate 1x sampleable copy of the depth buffer. Only used when MSAA is
        // disabled (then mainDepthTexture is the render attachment and can't be
        // sampled in the same pass). Populated by copyTextureToTexture.
        this.depthCopyTexture = null;
        this.depthCopyTextureView = null;
        // Intermediate color buffer — scene renders here, then water filter reads
        // a copy and outputs to the swapchain. Enables the water filter to apply
        // physically-based absorption to already-drawn content.
        //   MSAA on:  mainColorTextureMS is the render attachment, mainColorTexture
        //             is its 1x resolve target.
        //   MSAA off: mainColorTexture is the render attachment directly; the MS
        //             fields are null.
        this.mainColorTextureMS = null;
        this.mainColorTextureMSView = null;
        this.mainColorTexture = null;
        this.mainColorTextureView = null;
        this.colorCopyTexture = null;
        this.colorCopyTextureView = null;
        // Swapchain texture for this frame (stored in beginFrame for endFrame fallback)
        this.swapchainTexture = null;
        // True once copyColorBuffer has been called this frame (render target now
        // points to swapchain). If false at endFrame, mainColorTexture is blitted
        // to the swapchain as a fallback (e.g. editor mode with no water filter).
        this.colorCopied = false;
        // Z-height state for 3D tilt projection (saved/restored with transform stack).
        //
        // The tilt context decomposes the 3×3 Yaw·Pitch·Roll rotation matrix R into:
        //   zCoeffs = R's z-column (R[0,2], R[1,2]) — maps local z → screen xy offset (parallax)
        //   zRow    = R's z-row    (R[2,0], R[2,1], R[2,2]) — maps local (x,y,z) → world z (depth)
        //   currentZ = body's world z position (additive base for depth)
        //
        // World z for depth: worldZ = currentZ + zRowX·localX + zRowY·localY + zRowZ·localZ
        // Default zRow (0,0,1) passes local z through unchanged (no tilt).
        this.currentZ = 0;
        this.currentZCoeffX = 0;
        this.currentZCoeffY = 0;
        this.currentZRowX = 0;
        this.currentZRowY = 0;
        this.currentZRowZ = 1;
        this.zStack = [];
        // Batch state — vertex/index CPU + GPU resources live on these classes.
        this.shapeBatch = new (0, $e2d5197080de0e53$export$c9632bc23d642f0e)();
        this.spriteBatch = new (0, $71282c70e923b5a2$export$3ed609ab8670b5c5)();
        // Per-instance transform storage.
        this.transformBuffer = new (0, $f80e684830d9eeb0$export$3996232f9c1e10d3)();
        // Pending transform state gets lazily allocated into transformBuffer on
        // the next submit after any state change. `pendingTransformDirty` marks
        // that `shapeBatch.currentTransformIndex` / `spriteBatch.currentTransformIndex`
        // are stale and need to be refreshed.
        this.pendingTransformDirty = true;
        // Shape pipeline / bind-group resources
        this.shapeUniformBuffer = null;
        this.shapeBindGroup = null;
        // Sprite pipeline / bind-group resources
        this.spriteUniformBuffer = null;
        this.spriteBindGroupLayout = null;
        this.spriteTextureBindGroupLayout = null;
        this.spriteUniformBindGroup = null;
        this.currentTexture = null;
        this.currentTextureBindGroup = null;
        this.textureBindGroupCache = new Map();
        // Default sampler for sprites
        this.defaultSampler = null;
        // Transform stack
        this.transformStack = [];
        this.currentTransform = new (0, $b29a77d98f1bc0d5$export$8ff26dafa08918)();
        // View matrix (screen projection)
        this.viewMatrix = new (0, $b29a77d98f1bc0d5$export$8ff26dafa08918)();
        // Stats for debugging
        this.drawCallCount = 0;
        this.triangleCount = 0;
        this.vertexCount = 0;
        this.lastDrawCallCount = 0;
        this.lastTriangleCount = 0;
        this.lastVertexCount = 0;
        // Pixel ratio for high-DPI displays
        this.pixelRatio = 1;
        // Type-safe uniform instance
        this.viewUniforms = $5453fd34f01ad367$var$ViewUniforms.create();
        // Pre-allocated Matrix3 for building sprite transforms
        this.spriteMatrix = new (0, $b29a77d98f1bc0d5$export$8ff26dafa08918)();
        // Current render pass encoder (set during frame)
        this.currentCommandEncoder = null;
        this.currentRenderPass = null;
        this.currentRenderTarget = null;
        // Resolve target for MSAA — paired with currentRenderTarget. Null in
        // offscreen passes (which are 1x and don't resolve).
        this.currentResolveTarget = null;
        // Pipeline used by copyDepthBuffer() to resolve MSAA depth → 1x depth.
        this.depthResolvePipeline = null;
        this.depthResolveBindGroupLayout = null;
        // Cached inputs for MSAA-sensitive pipeline rebuilds.
        this.shapeShaderModule = null;
        this.shapePipelineLayout = null;
        this.shapeVertexBufferLayout = null;
        this.shapeTxIndexBufferLayout = null;
        this.spriteShaderModule = null;
        this.spritePipelineLayout = null;
        this.spriteVertexBufferLayout = null;
        this.spriteTxIndexBufferLayout = null;
        this.pipelinePrimitiveState = null;
        this.unsubscribeMSAA = null;
        // Track initialization state
        this.initialized = false;
        // GPU profiler (null if timestamp queries not supported)
        this.gpuProfiler = null;
        /** Cached tilt projection for the current context, if draw.at({ tilt }) is active. */ this.currentTiltProjection = null;
        /** Current global scene illumination. Defaults to (1,1,1) — no tint. */ this.ambientLight = [
            1,
            1,
            1
        ];
        this.canvas = canvas ?? document.createElement("canvas");
        this.textureManager = new (0, $cb7cbb6c3620557f$export$cfd7b9871d9e8b83)();
    // shapeBatch / spriteBatch / transformBuffer allocate their CPU-side
    // Float32Array / Uint32Array storage in their own constructors.
    }
    warnOnce(key, message) {
        if ($5453fd34f01ad367$export$19fd8015bd4822d4.warningKeys.has(key)) return;
        $5453fd34f01ad367$export$19fd8015bd4822d4.warningKeys.add(key);
        console.warn(message);
    }
    /**
   * Initialize WebGPU resources.
   * Must be called after WebGPUDevice.init().
   */ async init() {
        if (this.initialized) return;
        const gpuManager = (0, $558c2f47f1fdd57f$export$297162150ea0f6af)();
        this.device = gpuManager.device;
        // Configure canvas context
        this.context = this.canvas.getContext("webgpu");
        if (!this.context) throw new Error("Failed to get WebGPU canvas context");
        this.context.configure({
            device: this.device,
            format: gpuManager.preferredFormat,
            alphaMode: "opaque",
            usage: GPUTextureUsage.RENDER_ATTACHMENT | GPUTextureUsage.COPY_DST
        });
        // Create default sampler
        this.defaultSampler = this.device.createSampler({
            magFilter: "linear",
            minFilter: "linear",
            mipmapFilter: "linear",
            addressModeU: "clamp-to-edge",
            addressModeV: "clamp-to-edge"
        });
        // Create shape pipeline and resources
        await this.createShapePipeline();
        // Create sprite pipeline and resources
        await this.createSpritePipeline();
        // Listen for runtime MSAA toggles and rebuild textures/pipelines in sync.
        this.unsubscribeMSAA = (0, $3d4164726c38f33c$export$19f5a511f7104745)(()=>this.rebuildForMSAA());
        this.initialized = true;
    }
    async createShapePipeline() {
        if (!this.device) return;
        const gpu = (0, $558c2f47f1fdd57f$export$297162150ea0f6af)();
        const device = this.device;
        this.pipelinePrimitiveState = {
            topology: "triangle-list",
            ...gpu.features.depthClipControl ? {
                unclippedDepth: true
            } : {}
        };
        const primitiveState = this.pipelinePrimitiveState;
        // Create shader module
        const shaderModule = await gpu.createShaderModuleChecked($5453fd34f01ad367$var$shapeShaderSource, "Shape Shader");
        this.shapeShaderModule = shaderModule;
        // Create uniform buffer
        this.shapeUniformBuffer = device.createBuffer({
            size: $5453fd34f01ad367$var$UNIFORM_BUFFER_SIZE,
            usage: GPUBufferUsage.UNIFORM | GPUBufferUsage.COPY_DST,
            label: "Shape Uniform Buffer"
        });
        // Ensure the transform storage buffer exists before building the bind group.
        const transformGpuBuffer = this.transformBuffer.ensureGpuBuffer(device);
        // Create bind group layout: uniforms (0), transforms (1).
        const bindGroupLayout = device.createBindGroupLayout({
            entries: [
                {
                    binding: 0,
                    visibility: GPUShaderStage.VERTEX,
                    buffer: {
                        type: "uniform"
                    }
                },
                {
                    binding: 1,
                    visibility: GPUShaderStage.VERTEX,
                    buffer: {
                        type: "read-only-storage"
                    }
                }
            ],
            label: "Shape Bind Group Layout"
        });
        this.shapeBindGroup = device.createBindGroup({
            layout: bindGroupLayout,
            entries: [
                {
                    binding: 0,
                    resource: {
                        buffer: this.shapeUniformBuffer
                    }
                },
                {
                    binding: 1,
                    resource: {
                        buffer: transformGpuBuffer
                    }
                }
            ],
            label: "Shape Bind Group"
        });
        const pipelineLayout = device.createPipelineLayout({
            bindGroupLayouts: [
                bindGroupLayout
            ],
            label: "Shape Pipeline Layout"
        });
        this.shapePipelineLayout = pipelineLayout;
        // Two-stream vertex layout: geometry + transformIndex.
        const geometryStride = (0, $e2d5197080de0e53$export$547e49c5a71c21ad) * 4; // 32 bytes
        const geometryLayout = {
            arrayStride: geometryStride,
            attributes: [
                {
                    shaderLocation: 0,
                    offset: 0,
                    format: "float32x2"
                },
                {
                    shaderLocation: 1,
                    offset: 8,
                    format: "float32x4"
                },
                {
                    shaderLocation: 2,
                    offset: 24,
                    format: "float32"
                },
                {
                    shaderLocation: 3,
                    offset: 28,
                    format: "float32"
                }
            ]
        };
        const txIndexLayout = {
            arrayStride: 4,
            attributes: [
                {
                    shaderLocation: 4,
                    offset: 0,
                    format: "uint32"
                }
            ]
        };
        this.shapeVertexBufferLayout = geometryLayout;
        this.shapeTxIndexBufferLayout = txIndexLayout;
        const fragmentState = {
            module: shaderModule,
            entryPoint: "fs_main",
            targets: [
                {
                    format: (0, $558c2f47f1fdd57f$export$297162150ea0f6af)().preferredFormat,
                    blend: {
                        color: {
                            srcFactor: "src-alpha",
                            dstFactor: "one-minus-src-alpha",
                            operation: "add"
                        },
                        alpha: {
                            srcFactor: "one",
                            dstFactor: "one-minus-src-alpha",
                            operation: "add"
                        }
                    }
                }
            ]
        };
        const vertexState = {
            module: shaderModule,
            entryPoint: "vs_main",
            buffers: [
                geometryLayout,
                txIndexLayout
            ]
        };
        // Depth-attached pipelines (MSAA-sensitive) — extracted so they can be
        // rebuilt when the MSAA toggle changes.
        this.rebuildShapeMSAAPipelines();
        // Create pipeline without any depthStencil (for offscreen passes without depth attachment)
        this.shapePipelineNoDepth = device.createRenderPipeline({
            layout: pipelineLayout,
            vertex: vertexState,
            fragment: fragmentState,
            primitive: primitiveState,
            label: "Shape Pipeline (No Depth)"
        });
        // Allocate batch GPU buffers (vertex, txIndex, index streams).
        this.shapeBatch.createGpuBuffers(device);
    }
    async createSpritePipeline() {
        if (!this.device) return;
        const gpu = (0, $558c2f47f1fdd57f$export$297162150ea0f6af)();
        const device = this.device;
        const primitiveState = this.pipelinePrimitiveState ?? {
            topology: "triangle-list",
            ...gpu.features.depthClipControl ? {
                unclippedDepth: true
            } : {}
        };
        // Create shader module
        const shaderModule = await gpu.createShaderModuleChecked($5453fd34f01ad367$var$spriteShaderSource, "Sprite Shader");
        this.spriteShaderModule = shaderModule;
        // Create uniform buffer
        this.spriteUniformBuffer = device.createBuffer({
            size: $5453fd34f01ad367$var$UNIFORM_BUFFER_SIZE,
            usage: GPUBufferUsage.UNIFORM | GPUBufferUsage.COPY_DST,
            label: "Sprite Uniform Buffer"
        });
        const transformGpuBuffer = this.transformBuffer.ensureGpuBuffer(device);
        // Create bind group layout for uniforms + sampler + transforms (group 0)
        this.spriteBindGroupLayout = device.createBindGroupLayout({
            entries: [
                {
                    binding: 0,
                    visibility: GPUShaderStage.VERTEX,
                    buffer: {
                        type: "uniform"
                    }
                },
                {
                    binding: 1,
                    visibility: GPUShaderStage.FRAGMENT,
                    sampler: {
                        type: "filtering"
                    }
                },
                {
                    binding: 2,
                    visibility: GPUShaderStage.VERTEX,
                    buffer: {
                        type: "read-only-storage"
                    }
                }
            ],
            label: "Sprite Uniform Bind Group Layout"
        });
        // Create bind group layout for texture (group 1)
        this.spriteTextureBindGroupLayout = device.createBindGroupLayout({
            entries: [
                {
                    binding: 0,
                    visibility: GPUShaderStage.FRAGMENT,
                    texture: {
                        sampleType: "float"
                    }
                }
            ],
            label: "Sprite Texture Bind Group Layout"
        });
        this.spriteUniformBindGroup = device.createBindGroup({
            layout: this.spriteBindGroupLayout,
            entries: [
                {
                    binding: 0,
                    resource: {
                        buffer: this.spriteUniformBuffer
                    }
                },
                {
                    binding: 1,
                    resource: this.defaultSampler
                },
                {
                    binding: 2,
                    resource: {
                        buffer: transformGpuBuffer
                    }
                }
            ],
            label: "Sprite Uniform Bind Group"
        });
        const pipelineLayout = device.createPipelineLayout({
            bindGroupLayouts: [
                this.spriteBindGroupLayout,
                this.spriteTextureBindGroupLayout
            ],
            label: "Sprite Pipeline Layout"
        });
        this.spritePipelineLayout = pipelineLayout;
        // Two-stream vertex layout: geometry (9 floats) + transformIndex (u32).
        const geometryStride = (0, $71282c70e923b5a2$export$dee6fd314400385a) * 4; // 36 bytes
        const geometryLayout = {
            arrayStride: geometryStride,
            attributes: [
                {
                    shaderLocation: 0,
                    offset: 0,
                    format: "float32x2"
                },
                {
                    shaderLocation: 1,
                    offset: 8,
                    format: "float32x2"
                },
                {
                    shaderLocation: 2,
                    offset: 16,
                    format: "float32x4"
                },
                {
                    shaderLocation: 3,
                    offset: 32,
                    format: "float32"
                }
            ]
        };
        const txIndexLayout = {
            arrayStride: 4,
            attributes: [
                {
                    shaderLocation: 4,
                    offset: 0,
                    format: "uint32"
                }
            ]
        };
        this.spriteVertexBufferLayout = geometryLayout;
        this.spriteTxIndexBufferLayout = txIndexLayout;
        const fragmentState = {
            module: shaderModule,
            entryPoint: "fs_main",
            targets: [
                {
                    format: (0, $558c2f47f1fdd57f$export$297162150ea0f6af)().preferredFormat,
                    blend: {
                        color: {
                            srcFactor: "src-alpha",
                            dstFactor: "one-minus-src-alpha",
                            operation: "add"
                        },
                        alpha: {
                            srcFactor: "one",
                            dstFactor: "one-minus-src-alpha",
                            operation: "add"
                        }
                    }
                }
            ]
        };
        const vertexState = {
            module: shaderModule,
            entryPoint: "vs_main",
            buffers: [
                geometryLayout,
                txIndexLayout
            ]
        };
        // Depth-attached pipelines (MSAA-sensitive) — extracted so they can be
        // rebuilt when the MSAA toggle changes.
        this.rebuildSpriteMSAAPipelines();
        // Create pipeline without any depthStencil (for offscreen passes without depth attachment)
        this.spritePipelineNoDepth = device.createRenderPipeline({
            layout: pipelineLayout,
            vertex: vertexState,
            fragment: fragmentState,
            primitive: primitiveState,
            label: "Sprite Pipeline (No Depth)"
        });
        this.spriteBatch.createGpuBuffers(device);
        // Initialize GPU profiler if timestamp queries are supported
        const gpuManager = (0, $558c2f47f1fdd57f$export$297162150ea0f6af)();
        if (gpuManager.features.timestampQuery) {
            this.gpuProfiler = new (0, $13cb06f920708adf$export$774f3675766e58a7)(device);
            this.gpuProfiler.setEnabled(true);
        }
    }
    /** Rebuild the 3 depth-attached shape pipelines at the current MSAA count. */ rebuildShapeMSAAPipelines() {
        if (!this.device || !this.shapeShaderModule || !this.shapePipelineLayout || !this.shapeVertexBufferLayout || !this.shapeTxIndexBufferLayout || !this.pipelinePrimitiveState) return;
        const device = this.device;
        const format = (0, $558c2f47f1fdd57f$export$297162150ea0f6af)().preferredFormat;
        const vertexState = {
            module: this.shapeShaderModule,
            entryPoint: "vs_main",
            buffers: [
                this.shapeVertexBufferLayout,
                this.shapeTxIndexBufferLayout
            ]
        };
        const fragmentState = {
            module: this.shapeShaderModule,
            entryPoint: "fs_main",
            targets: [
                {
                    format: format,
                    blend: {
                        color: {
                            srcFactor: "src-alpha",
                            dstFactor: "one-minus-src-alpha",
                            operation: "add"
                        },
                        alpha: {
                            srcFactor: "one",
                            dstFactor: "one-minus-src-alpha",
                            operation: "add"
                        }
                    }
                }
            ]
        };
        const msaa = {
            count: (0, $3d4164726c38f33c$export$688369c54d530641)()
        };
        const base = {
            layout: this.shapePipelineLayout,
            vertex: vertexState,
            fragment: fragmentState,
            primitive: this.pipelinePrimitiveState,
            multisample: msaa
        };
        this.shapePipeline = device.createRenderPipeline({
            ...base,
            depthStencil: {
                format: $5453fd34f01ad367$var$DEPTH_FORMAT,
                depthCompare: "always",
                depthWriteEnabled: false
            },
            label: "Shape Pipeline"
        });
        this.shapePipelineDepth = device.createRenderPipeline({
            ...base,
            depthStencil: {
                format: $5453fd34f01ad367$var$DEPTH_FORMAT,
                depthCompare: "greater-equal",
                depthWriteEnabled: true
            },
            label: "Shape Pipeline (Depth)"
        });
        this.shapePipelineAlwaysWrite = device.createRenderPipeline({
            ...base,
            depthStencil: {
                format: $5453fd34f01ad367$var$DEPTH_FORMAT,
                depthCompare: "always",
                depthWriteEnabled: true
            },
            label: "Shape Pipeline (Always Write)"
        });
    }
    /** Rebuild the 3 depth-attached sprite pipelines at the current MSAA count. */ rebuildSpriteMSAAPipelines() {
        if (!this.device || !this.spriteShaderModule || !this.spritePipelineLayout || !this.spriteVertexBufferLayout || !this.spriteTxIndexBufferLayout || !this.pipelinePrimitiveState) return;
        const device = this.device;
        const format = (0, $558c2f47f1fdd57f$export$297162150ea0f6af)().preferredFormat;
        const vertexState = {
            module: this.spriteShaderModule,
            entryPoint: "vs_main",
            buffers: [
                this.spriteVertexBufferLayout,
                this.spriteTxIndexBufferLayout
            ]
        };
        const fragmentState = {
            module: this.spriteShaderModule,
            entryPoint: "fs_main",
            targets: [
                {
                    format: format,
                    blend: {
                        color: {
                            srcFactor: "src-alpha",
                            dstFactor: "one-minus-src-alpha",
                            operation: "add"
                        },
                        alpha: {
                            srcFactor: "one",
                            dstFactor: "one-minus-src-alpha",
                            operation: "add"
                        }
                    }
                }
            ]
        };
        const msaa = {
            count: (0, $3d4164726c38f33c$export$688369c54d530641)()
        };
        const base = {
            layout: this.spritePipelineLayout,
            vertex: vertexState,
            fragment: fragmentState,
            primitive: this.pipelinePrimitiveState,
            multisample: msaa
        };
        this.spritePipeline = device.createRenderPipeline({
            ...base,
            depthStencil: {
                format: $5453fd34f01ad367$var$DEPTH_FORMAT,
                depthCompare: "always",
                depthWriteEnabled: false
            },
            label: "Sprite Pipeline"
        });
        this.spritePipelineDepth = device.createRenderPipeline({
            ...base,
            depthStencil: {
                format: $5453fd34f01ad367$var$DEPTH_FORMAT,
                depthCompare: "greater-equal",
                depthWriteEnabled: true
            },
            label: "Sprite Pipeline (Depth)"
        });
        this.spritePipelineAlwaysWrite = device.createRenderPipeline({
            ...base,
            depthStencil: {
                format: $5453fd34f01ad367$var$DEPTH_FORMAT,
                depthCompare: "always",
                depthWriteEnabled: true
            },
            label: "Sprite Pipeline (Always Write)"
        });
    }
    /**
   * Called when the user toggles MSAA on/off. Rebuilds MSAA-sensitive
   * textures and pipelines so the next frame matches the new sample count.
   * Safe to call between frames.
   */ rebuildForMSAA() {
        // Invalidate current render-pass state. The running frame's encoder (if
        // any) still references old attachments — we'll let it finish on the old
        // configuration. Next beginFrame will see the new textures.
        this.ensureMSTextures();
        this.rebuildShapeMSAAPipelines();
        this.rebuildSpriteMSAAPipelines();
        // Depth-resolve pipeline is only needed when MSAA is enabled. Force
        // recreation so it matches the current multisample state of the MSAA
        // depth view when that view changes from multisampled → 1x or vice versa.
        this.depthResolvePipeline = null;
        this.depthResolveBindGroupLayout = null;
    }
    /**
   * Set up MSAA color/depth textures and the off-mode depthCopyTexture to
   * match the current MSAA state.
   *
   * MSAA on:  mainColorTextureMS + mainDepthTextureMS exist; depthCopyTexture
   *           is unused (resolve pass writes mainDepthTexture directly).
   * MSAA off: MSAA textures are null; depthCopyTexture exists as a 1x
   *           copy-destination for copyDepthBuffer's copyTextureToTexture.
   */ ensureMSTextures() {
        if (!this.device || !this.mainColorTexture || !this.mainDepthTexture) return;
        const w = this.mainColorTexture.width;
        const h = this.mainColorTexture.height;
        const enabled = (0, $3d4164726c38f33c$export$8f47e656fde7db88)();
        const sampleCount = (0, $3d4164726c38f33c$export$688369c54d530641)();
        if (enabled) {
            if (!this.mainColorTextureMS || this.mainColorTextureMS.width !== w || this.mainColorTextureMS.height !== h || this.mainColorTextureMS.sampleCount !== sampleCount) {
                this.mainColorTextureMS?.destroy();
                this.mainColorTextureMS = this.device.createTexture({
                    size: {
                        width: w,
                        height: h
                    },
                    format: (0, $558c2f47f1fdd57f$export$297162150ea0f6af)().preferredFormat,
                    sampleCount: sampleCount,
                    usage: GPUTextureUsage.RENDER_ATTACHMENT,
                    label: "Main Color Texture (MSAA)"
                });
                this.mainColorTextureMSView = this.mainColorTextureMS.createView({
                    label: "Main Color Texture (MSAA) View"
                });
            }
            if (!this.mainDepthTextureMS || this.mainDepthTextureMS.width !== w || this.mainDepthTextureMS.height !== h || this.mainDepthTextureMS.sampleCount !== sampleCount) {
                this.mainDepthTextureMS?.destroy();
                this.mainDepthTextureMS = this.device.createTexture({
                    size: {
                        width: w,
                        height: h
                    },
                    format: $5453fd34f01ad367$var$DEPTH_FORMAT,
                    sampleCount: sampleCount,
                    usage: GPUTextureUsage.RENDER_ATTACHMENT | GPUTextureUsage.TEXTURE_BINDING,
                    label: "Main Depth Texture (MSAA)"
                });
                this.mainDepthTextureMSView = this.mainDepthTextureMS.createView({
                    label: "Main Depth Texture (MSAA) View"
                });
            }
            if (this.depthCopyTexture) {
                this.depthCopyTexture.destroy();
                this.depthCopyTexture = null;
                this.depthCopyTextureView = null;
            }
        } else {
            if (this.mainColorTextureMS) {
                this.mainColorTextureMS.destroy();
                this.mainColorTextureMS = null;
                this.mainColorTextureMSView = null;
            }
            if (this.mainDepthTextureMS) {
                this.mainDepthTextureMS.destroy();
                this.mainDepthTextureMS = null;
                this.mainDepthTextureMSView = null;
            }
            if (!this.depthCopyTexture || this.depthCopyTexture.width !== w || this.depthCopyTexture.height !== h) {
                this.depthCopyTexture?.destroy();
                this.depthCopyTexture = this.device.createTexture({
                    size: {
                        width: w,
                        height: h
                    },
                    format: $5453fd34f01ad367$var$DEPTH_FORMAT,
                    usage: GPUTextureUsage.COPY_DST | GPUTextureUsage.TEXTURE_BINDING,
                    label: "Depth Copy Texture"
                });
                this.depthCopyTextureView = this.depthCopyTexture.createView({
                    label: "Depth Copy Texture View"
                });
            }
        }
    }
    /** Resize the canvas to match the window size */ resize(width, height, pixelRatio = window.devicePixelRatio) {
        this.pixelRatio = pixelRatio;
        const w = Math.floor(width * pixelRatio);
        const h = Math.floor(height * pixelRatio);
        if (this.canvas.width !== w || this.canvas.height !== h) {
            this.canvas.width = w;
            this.canvas.height = h;
            this.canvas.style.width = `${width}px`;
            this.canvas.style.height = `${height}px`;
        }
        // Recreate 1x color/depth textures if canvas size changed. MSAA textures
        // are kept in sync via ensureMSTextures().
        if (this.device && (!this.mainDepthTexture || this.mainDepthTexture.width !== w || this.mainDepthTexture.height !== h)) {
            this.mainDepthTextureMS?.destroy();
            this.mainDepthTextureMS = null;
            this.mainDepthTextureMSView = null;
            this.mainDepthTexture?.destroy();
            this.depthCopyTexture?.destroy();
            this.depthCopyTexture = null;
            this.depthCopyTextureView = null;
            this.mainDepthTexture = this.device.createTexture({
                size: {
                    width: w,
                    height: h
                },
                format: $5453fd34f01ad367$var$DEPTH_FORMAT,
                usage: GPUTextureUsage.RENDER_ATTACHMENT | GPUTextureUsage.TEXTURE_BINDING | GPUTextureUsage.COPY_SRC,
                label: "Main Depth Texture"
            });
            this.mainDepthTextureView = this.mainDepthTexture.createView({
                label: "Main Depth Texture View"
            });
        }
        if (this.device && (!this.mainColorTexture || this.mainColorTexture.width !== w || this.mainColorTexture.height !== h)) {
            this.mainColorTextureMS?.destroy();
            this.mainColorTextureMS = null;
            this.mainColorTextureMSView = null;
            this.mainColorTexture?.destroy();
            this.mainColorTexture = this.device.createTexture({
                size: {
                    width: w,
                    height: h
                },
                format: (0, $558c2f47f1fdd57f$export$297162150ea0f6af)().preferredFormat,
                usage: GPUTextureUsage.RENDER_ATTACHMENT | GPUTextureUsage.COPY_SRC | GPUTextureUsage.TEXTURE_BINDING,
                label: "Main Color Texture"
            });
            this.mainColorTextureView = this.mainColorTexture.createView({
                label: "Main Color Texture View"
            });
        }
        this.ensureMSTextures();
        // Update view matrix to convert from pixel coords to clip space
        this.viewMatrix.identity();
        this.viewMatrix.scale(2 / width, 2 / height);
        this.viewMatrix.translate(-width / 2, -height / 2);
    }
    /** Get logical width in CSS pixels */ getWidth() {
        return this.canvas.width / this.pixelRatio;
    }
    /** Get logical height in CSS pixels */ getHeight() {
        return this.canvas.height / this.pixelRatio;
    }
    /** Get physical framebuffer width in device pixels. */ getPhysicalWidth() {
        return this.canvas.width;
    }
    /** Get physical framebuffer height in device pixels. */ getPhysicalHeight() {
        return this.canvas.height;
    }
    /** Get the device pixel ratio that the framebuffer is scaled by. */ getPixelRatio() {
        return this.pixelRatio;
    }
    /** Get the current view matrix for custom render pipelines. */ getViewMatrix() {
        return this.viewMatrix;
    }
    /** Begin a new frame */ beginFrame() {
        if (!this.device || !this.context) return;
        // Reset transform stack and z state
        this.transformStack.length = 0;
        this.currentTransform.identity();
        this.zStack.length = 0;
        this.currentZ = 0;
        this.currentZCoeffX = 0;
        this.currentZCoeffY = 0;
        this.currentZRowX = 0;
        this.currentZRowY = 0;
        this.currentZRowZ = 1;
        this.depthMode = "none";
        this.inOffscreenPass = false;
        // Reset per-frame transform buffer; slot 0 is the identity root.
        this.transformBuffer.reset();
        this.pendingTransformDirty = true;
        // Reset batches
        this.shapeBatch.resetBatch();
        this.shapeBatch.resetFrameOffsets();
        this.spriteBatch.vertexCount = 0;
        this.spriteBatch.indexCount = 0;
        this.spriteBatch.resetFrameOffsets();
        this.currentTexture = null;
        this.currentTextureBindGroup = null;
        // Reset stats
        this.drawCallCount = 0;
        this.triangleCount = 0;
        this.vertexCount = 0;
        // Create command encoder
        this.currentCommandEncoder = this.device.createCommandEncoder({
            label: "Frame Command Encoder"
        });
        // Save the swapchain texture for endFrame (used as fallback blit target
        // when copyColorBuffer is never called, and by copyColorBuffer itself).
        this.swapchainTexture = this.context.getCurrentTexture();
        this.colorCopied = false;
        // Scene renders to mainColorTextureMS when MSAA is on (auto-resolves to
        // mainColorTexture) or directly to mainColorTexture when MSAA is off.
        // The water filter (or endFrame fallback) produces the final swapchain.
        if ((0, $3d4164726c38f33c$export$8f47e656fde7db88)()) {
            this.currentRenderTarget = this.mainColorTextureMSView ?? this.swapchainTexture.createView();
            this.currentResolveTarget = this.mainColorTextureView;
        } else {
            this.currentRenderTarget = this.mainColorTextureView ?? this.swapchainTexture.createView();
            this.currentResolveTarget = null;
        }
        const depthView = this.mainDepthTextureMSView ?? this.mainDepthTextureView;
        // Begin render pass with depth attachment
        this.currentRenderPass = this.currentCommandEncoder.beginRenderPass({
            colorAttachments: [
                {
                    view: this.currentRenderTarget,
                    resolveTarget: this.currentResolveTarget ?? undefined,
                    loadOp: "clear",
                    storeOp: "store",
                    clearValue: {
                        r: 0,
                        g: 0,
                        b: 0,
                        a: 1
                    }
                }
            ],
            depthStencilAttachment: depthView ? {
                view: depthView,
                depthLoadOp: "clear",
                depthStoreOp: "store",
                depthClearValue: 0.0
            } : undefined,
            timestampWrites: this.gpuProfiler?.getTimestampWrites(),
            label: "Main Render Pass"
        });
    }
    /** Get rendering stats from the last completed frame */ getStats() {
        return {
            drawCalls: this.lastDrawCallCount,
            triangles: this.lastTriangleCount,
            vertices: this.lastVertexCount,
            textures: this.textureManager.getTextureCount(),
            canvasWidth: this.canvas.width,
            canvasHeight: this.canvas.height,
            pixelRatio: this.pixelRatio
        };
    }
    /** Get the number of draw calls in the current/last frame */ getDrawCallCount() {
        return this.drawCallCount;
    }
    /** End frame and flush all batches */ endFrame() {
        if (!this.device || !this.currentCommandEncoder || !this.currentRenderPass) return;
        // Flush any remaining batches
        this.flushShapes();
        this.flushSprites();
        // End render pass
        this.currentRenderPass.end();
        // Fallback: if no one called copyColorBuffer this frame, the scene is
        // still sitting in mainColorTexture and the swapchain is empty. Blit it
        // now. Happens in editor mode or any frame without SurfaceRenderer.
        if (!this.colorCopied && this.mainColorTexture && this.swapchainTexture && this.mainColorTexture.width === this.swapchainTexture.width && this.mainColorTexture.height === this.swapchainTexture.height) this.currentCommandEncoder.copyTextureToTexture({
            texture: this.mainColorTexture
        }, {
            texture: this.swapchainTexture
        }, {
            width: this.mainColorTexture.width,
            height: this.mainColorTexture.height
        });
        // Resolve GPU profiler timestamps before submit
        this.gpuProfiler?.resolve(this.currentCommandEncoder);
        // Submit command buffer
        this.device.queue.submit([
            this.currentCommandEncoder.finish()
        ]);
        // Start async read of GPU profiler results
        this.gpuProfiler?.readResults();
        // Save stats for display
        this.lastDrawCallCount = this.drawCallCount;
        this.lastTriangleCount = this.triangleCount;
        this.lastVertexCount = this.vertexCount;
        // Clear current pass
        this.currentCommandEncoder = null;
        this.currentRenderPass = null;
        this.currentRenderTarget = null;
        this.swapchainTexture = null;
    }
    /** Flush all pending shape and sprite batches to ensure correct layer ordering before custom pipeline draws. */ flush() {
        this.flushShapes();
        this.flushSprites();
    }
    /**
   * Prepare the shape batch for a tessellator write. Flushes any pending
   * sprites (for layer ordering) and ensures the batch's
   * `currentTransformIndex` reflects the latest transform state. Returns
   * the batch as a VertexSink that tessellators can write through.
   */ prepareShapeSink() {
        if (this.spriteBatch.indexCount > 0) this.flushSprites();
        // Pre-flush when close to capacity so a single tessellator call can't
        // straddle the batch limit. The safety margin covers any reasonable
        // primitive (polylines with round caps, ear-clip on large polygons, etc.).
        const safetyVerts = 8192;
        const safetyIndices = safetyVerts * 3;
        if (this.shapeBatch.vertexCount + safetyVerts > this.shapeBatch.maxVertices || this.shapeBatch.indexCount + safetyIndices > this.shapeBatch.maxIndices) this.flushShapes();
        this.refreshTransformIndex();
        return this.shapeBatch;
    }
    getCurrentTilt() {
        return this.currentTiltProjection;
    }
    setCurrentTilt(tilt) {
        this.currentTiltProjection = tilt;
    }
    /** Get the current render pass encoder for custom rendering */ getCurrentRenderPass() {
        return this.currentRenderPass;
    }
    /**
   * End the current render pass and begin a new one, preserving framebuffer contents.
   * Use this to give a section of rendering its own render pass for GPU profiling
   * via timestamp queries. Returns the new render pass encoder.
   */ restartRenderPass(timestampWrites, label) {
        if (!this.currentRenderPass || !this.currentCommandEncoder || !this.currentRenderTarget) return null;
        this.flush();
        this.currentRenderPass.end();
        this.currentRenderPass = this.currentCommandEncoder.beginRenderPass({
            colorAttachments: [
                {
                    view: this.currentRenderTarget,
                    resolveTarget: this.currentResolveTarget ?? undefined,
                    loadOp: "load",
                    storeOp: "store"
                }
            ],
            depthStencilAttachment: this.mainDepthTextureMSView ?? this.mainDepthTextureView ? {
                view: this.mainDepthTextureMSView ?? this.mainDepthTextureView,
                depthLoadOp: "load",
                depthStoreOp: "store"
            } : undefined,
            timestampWrites: timestampWrites,
            label: label
        });
        return this.currentRenderPass;
    }
    /**
   * Switch rendering to an offscreen texture target.
   * Flushes pending batches and ends the current render pass before switching.
   * The offscreen target must use the same format as the canvas (preferredFormat).
   */ beginOffscreenPass(target, clearColor) {
        if (!this.currentRenderPass || !this.currentCommandEncoder) return;
        this.flush();
        this.currentRenderPass.end();
        this.inOffscreenPass = true;
        this.currentRenderPass = this.currentCommandEncoder.beginRenderPass({
            colorAttachments: [
                {
                    view: target,
                    loadOp: "clear",
                    storeOp: "store",
                    clearValue: clearColor ?? {
                        r: 0,
                        g: 0,
                        b: 0,
                        a: 0
                    }
                }
            ],
            label: "Offscreen Render Pass"
        });
    }
    /**
   * Resume rendering to the main framebuffer, preserving existing content.
   * Flushes pending batches and ends the current (offscreen) render pass.
   */ resumeMainPass() {
        if (!this.currentRenderPass || !this.currentCommandEncoder || !this.currentRenderTarget) return;
        this.flush();
        this.currentRenderPass.end();
        this.inOffscreenPass = false;
        this.currentRenderPass = this.currentCommandEncoder.beginRenderPass({
            colorAttachments: [
                {
                    view: this.currentRenderTarget,
                    resolveTarget: this.currentResolveTarget ?? undefined,
                    loadOp: "load",
                    storeOp: "store"
                }
            ],
            depthStencilAttachment: this.mainDepthTextureMSView ?? this.mainDepthTextureView ? {
                view: this.mainDepthTextureMSView ?? this.mainDepthTextureView,
                depthLoadOp: "load",
                depthStoreOp: "store"
            } : undefined,
            label: "Resumed Main Render Pass"
        });
    }
    /** Clear the screen with a color */ clear(color = 0x000000, _alpha = 1.0) {}
    // ============ Transform Stack ============
    /** Save the current transform and z state */ save() {
        this.transformStack.push(this.currentTransform.clone());
        this.zStack.push([
            this.currentZ,
            this.currentZCoeffX,
            this.currentZCoeffY,
            this.currentZRowX,
            this.currentZRowY,
            this.currentZRowZ
        ]);
    }
    /** Restore the previous transform and z state */ restore() {
        const prev = this.transformStack.pop();
        if (prev) this.currentTransform = prev;
        else {
            this.warnOnce("restore-stack-underflow", "WebGPURenderer.restore called with an empty transform stack; resetting to identity.");
            this.currentTransform.identity();
        }
        const zPrev = this.zStack.pop();
        if (zPrev) {
            this.currentZ = zPrev[0];
            this.currentZCoeffX = zPrev[1];
            this.currentZCoeffY = zPrev[2];
            this.currentZRowX = zPrev[3];
            this.currentZRowY = zPrev[4];
            this.currentZRowZ = zPrev[5];
        } else {
            this.currentZ = 0;
            this.currentZCoeffX = 0;
            this.currentZCoeffY = 0;
            this.currentZRowX = 0;
            this.currentZRowY = 0;
            this.currentZRowZ = 1;
        }
        this.pendingTransformDirty = true;
    }
    translate(xOrPos, y) {
        if (typeof xOrPos === "number") this.currentTransform.translate(xOrPos, y);
        else this.currentTransform.translate(xOrPos[0], xOrPos[1]);
        this.pendingTransformDirty = true;
    }
    /** Rotate by angle (radians) */ rotate(radians) {
        this.currentTransform.rotate(radians);
        this.pendingTransformDirty = true;
    }
    scale(sx, sy) {
        this.currentTransform.scale(sx, sy ?? sx);
        this.pendingTransformDirty = true;
    }
    /** Set a specific transform matrix */ setTransform(matrix) {
        this.currentTransform.copyFrom(matrix);
        this.pendingTransformDirty = true;
    }
    /** Get the current transform matrix */ getTransform() {
        return this.currentTransform.clone();
    }
    /** Gets the current scale factor (the larger of the two if they're not equal) */ getCurrentScale() {
        // Use basis-vector lengths so rotation doesn't zero out the scale.
        // Matrix3 layout: x-basis = (a, b), y-basis = (c, d).
        const m = this.currentTransform;
        return Math.max(Math.hypot(m.a, m.b), Math.hypot(m.c, m.d));
    }
    // ============ Z-Height / Depth ============
    /** Set the z-height for subsequent draw calls. */ setZ(z) {
        this.currentZ = z;
        this.pendingTransformDirty = true;
    }
    /** Get the current z-height. */ getZ() {
        return this.currentZ;
    }
    /** Set the z-to-position-offset coefficients (z-column of rotation: R[0,2], R[1,2]). */ setZCoeffs(x, y) {
        this.currentZCoeffX = x;
        this.currentZCoeffY = y;
        this.pendingTransformDirty = true;
    }
    /**
   * Set the z-row of the rotation matrix (R[2,0], R[2,1], R[2,2]).
   * Maps local vertex (x, y, z) → world z contribution for depth:
   *   worldZ = currentZ + zRowX·localX + zRowY·localY + zRowZ·localZ
   */ setZRow(x, y, z) {
        this.currentZRowX = x;
        this.currentZRowY = y;
        this.currentZRowZ = z;
        this.pendingTransformDirty = true;
    }
    /** Whether we're currently rendering to an offscreen pass (no depth attachment). */ isInOffscreenPass() {
        return this.inOffscreenPass;
    }
    /**
   * Set the depth mode for subsequent draw calls.
   * Flushes pending batches when the mode changes (pipeline switch required).
   */ setDepthMode(mode) {
        if (this.depthMode !== mode) {
            this.flush();
            this.depthMode = mode;
        }
    }
    /**
   * Get a readable copy of the depth buffer (available after copyDepthBuffer
   * is called). MSAA: returns the resolved 1x depth that the resolve pass
   * wrote. No MSAA: returns depthCopyTexture which was populated via
   * copyTextureToTexture from the main depth texture.
   */ getDepthCopyTextureView() {
        return (0, $3d4164726c38f33c$export$8f47e656fde7db88)() ? this.mainDepthTextureView : this.depthCopyTextureView;
    }
    /** Get a readable copy of the scene color (available after copyColorBuffer is called). */ getColorCopyTextureView() {
        return this.colorCopyTextureView;
    }
    /**
   * Resolve the MSAA depth buffer to a 1x texture readable by overlay shaders.
   * Must be called inside a render pass (ends it, runs a resolve pass, restarts).
   * Under MSAA, copyTextureToTexture from MSAA→1x is not allowed, so we use a
   * small fullscreen pass that samples the multisampled depth and writes the
   * nearest sample (min under reverse-Z) to a 1x depth attachment.
   */ copyDepthBuffer() {
        if (!this.mainDepthTexture || !this.mainDepthTextureView || !this.currentCommandEncoder || !this.currentRenderPass || !this.currentRenderTarget) return;
        this.flush();
        this.currentRenderPass.end();
        if ((0, $3d4164726c38f33c$export$8f47e656fde7db88)()) {
            // MSAA: resolve-pass samples multisampled depth and writes the nearest
            // sample into mainDepthTexture (1x) for overlay shaders to sample.
            const pipeline = this.getOrCreateDepthResolvePipeline();
            const bindGroup = this.device.createBindGroup({
                layout: this.depthResolveBindGroupLayout,
                entries: [
                    {
                        binding: 0,
                        resource: this.mainDepthTextureMSView
                    }
                ],
                label: "Depth Resolve Bind Group"
            });
            const resolvePass = this.currentCommandEncoder.beginRenderPass({
                colorAttachments: [],
                depthStencilAttachment: {
                    view: this.mainDepthTextureView,
                    depthLoadOp: "clear",
                    depthStoreOp: "store",
                    depthClearValue: 0.0
                },
                label: "Depth Resolve Pass"
            });
            resolvePass.setPipeline(pipeline);
            resolvePass.setBindGroup(0, bindGroup);
            resolvePass.draw(3);
            resolvePass.end();
        } else if (this.depthCopyTexture) // No MSAA: copy mainDepthTexture → depthCopyTexture so the water filter
        // can sample it without colliding with the depth render attachment.
        this.currentCommandEncoder.copyTextureToTexture({
            texture: this.mainDepthTexture
        }, {
            texture: this.depthCopyTexture
        }, {
            width: this.mainDepthTexture.width,
            height: this.mainDepthTexture.height
        });
        // Restart main render pass (preserving framebuffer + depth).
        this.currentRenderPass = this.currentCommandEncoder.beginRenderPass({
            colorAttachments: [
                {
                    view: this.currentRenderTarget,
                    resolveTarget: this.currentResolveTarget ?? undefined,
                    loadOp: "load",
                    storeOp: "store"
                }
            ],
            depthStencilAttachment: this.mainDepthTextureMSView ?? this.mainDepthTextureView ? {
                view: this.mainDepthTextureMSView ?? this.mainDepthTextureView,
                depthLoadOp: "load",
                depthStoreOp: "store"
            } : undefined,
            label: "Post-Depth-Resolve Render Pass"
        });
    }
    getOrCreateDepthResolvePipeline() {
        if (this.depthResolvePipeline) return this.depthResolvePipeline;
        const device = this.device;
        const shaderCode = /*wgsl*/ `
@group(0) @binding(0) var depthTex: texture_depth_multisampled_2d;

@vertex
fn vs_main(@builtin(vertex_index) idx: u32) -> @builtin(position) vec4<f32> {
  // Fullscreen triangle covering clip space.
  let x = f32((idx << 1u) & 2u) * 2.0 - 1.0;
  let y = f32(idx & 2u) * 2.0 - 1.0;
  return vec4<f32>(x, y, 0.0, 1.0);
}

@fragment
fn fs_main(@builtin(position) pos: vec4<f32>) -> @builtin(frag_depth) f32 {
  let xy = vec2<i32>(pos.xy);
  // Reverse-Z: closer samples have larger depth. We want the nearest sample,
  // so take the max across all ${$5453fd34f01ad367$export$f9aebfc6c08dbb1c} samples.
  var d = textureLoad(depthTex, xy, 0);
  d = max(d, textureLoad(depthTex, xy, 1));
  d = max(d, textureLoad(depthTex, xy, 2));
  d = max(d, textureLoad(depthTex, xy, 3));
  return d;
}
`;
        const module = device.createShaderModule({
            code: shaderCode,
            label: "Depth Resolve Shader"
        });
        this.depthResolveBindGroupLayout = device.createBindGroupLayout({
            entries: [
                {
                    binding: 0,
                    visibility: GPUShaderStage.FRAGMENT,
                    texture: {
                        sampleType: "depth",
                        viewDimension: "2d",
                        multisampled: true
                    }
                }
            ],
            label: "Depth Resolve Bind Group Layout"
        });
        const pipelineLayout = device.createPipelineLayout({
            bindGroupLayouts: [
                this.depthResolveBindGroupLayout
            ],
            label: "Depth Resolve Pipeline Layout"
        });
        this.depthResolvePipeline = device.createRenderPipeline({
            layout: pipelineLayout,
            vertex: {
                module: module,
                entryPoint: "vs_main"
            },
            fragment: {
                module: module,
                entryPoint: "fs_main",
                targets: []
            },
            primitive: {
                topology: "triangle-list"
            },
            depthStencil: {
                format: $5453fd34f01ad367$var$DEPTH_FORMAT,
                depthCompare: "always",
                depthWriteEnabled: true
            },
            label: "Depth Resolve Pipeline"
        });
        return this.depthResolvePipeline;
    }
    /**
   * Copy the mainColorTexture to colorCopyTexture and switch the active
   * render target to the swapchain. After this, subsequent draw calls go
   * directly to the swapchain, and shaders can sample the frozen scene
   * via getColorCopyTextureView(). Must be called inside a render pass.
   */ copyColorBuffer() {
        if (!this.mainColorTexture || !this.currentCommandEncoder || !this.currentRenderPass || !this.swapchainTexture) return;
        this.flush();
        this.currentRenderPass.end();
        // Lazy create/resize colorCopyTexture
        if (!this.colorCopyTexture || this.colorCopyTexture.width !== this.mainColorTexture.width || this.colorCopyTexture.height !== this.mainColorTexture.height) {
            this.colorCopyTexture?.destroy();
            this.colorCopyTexture = this.device.createTexture({
                size: {
                    width: this.mainColorTexture.width,
                    height: this.mainColorTexture.height
                },
                format: (0, $558c2f47f1fdd57f$export$297162150ea0f6af)().preferredFormat,
                usage: GPUTextureUsage.COPY_DST | GPUTextureUsage.TEXTURE_BINDING,
                label: "Color Copy Texture"
            });
            this.colorCopyTextureView = this.colorCopyTexture.createView({
                label: "Color Copy Texture View"
            });
        }
        this.currentCommandEncoder.copyTextureToTexture({
            texture: this.mainColorTexture
        }, {
            texture: this.colorCopyTexture
        }, {
            width: this.mainColorTexture.width,
            height: this.mainColorTexture.height
        });
        // Switch render target so subsequent draws (water filter + post-water
        // particles) end up on the swapchain. MSAA: render into the MSAA color
        // texture and resolve to swapchain. No MSAA: render to swapchain directly.
        const swapchainView = this.swapchainTexture.createView({
            label: "Swapchain View"
        });
        if ((0, $3d4164726c38f33c$export$8f47e656fde7db88)()) {
            this.currentRenderTarget = this.mainColorTextureMSView;
            this.currentResolveTarget = swapchainView;
        } else {
            this.currentRenderTarget = swapchainView;
            this.currentResolveTarget = null;
        }
        this.colorCopied = true;
        this.currentRenderPass = this.currentCommandEncoder.beginRenderPass({
            colorAttachments: [
                {
                    view: this.currentRenderTarget,
                    resolveTarget: this.currentResolveTarget ?? undefined,
                    loadOp: "clear",
                    storeOp: "store",
                    clearValue: {
                        r: 0,
                        g: 0,
                        b: 0,
                        a: 1
                    }
                }
            ],
            depthStencilAttachment: this.mainDepthTextureMSView ?? this.mainDepthTextureView ? {
                view: this.mainDepthTextureMSView ?? this.mainDepthTextureView,
                depthLoadOp: "load",
                depthStoreOp: "store"
            } : undefined,
            label: "Post-Color-Copy Render Pass (Swapchain)"
        });
    }
    // ============ Transform allocation ============
    /**
   * Build a Transform struct from the current renderer state. Tint defaults
   * to white — future callers wanting per-instance tint will set it.
   */ buildPendingTransform() {
        const m = this.currentTransform;
        return {
            modelCol0X: m.a,
            modelCol0Y: m.b,
            modelCol1X: m.c,
            modelCol1Y: m.d,
            modelCol2X: m.tx,
            modelCol2Y: m.ty,
            zCoeffX: this.currentZCoeffX,
            zCoeffY: this.currentZCoeffY,
            zRowX: this.currentZRowX,
            zRowY: this.currentZRowY,
            zRowZ: this.currentZRowZ,
            zBase: this.currentZ,
            tintR: 1,
            tintG: 1,
            tintB: 1,
            tintA: 1
        };
    }
    /**
   * Allocate a new transform-buffer slot if state has changed since the last
   * submit; otherwise reuse the previously-allocated slot. Both the shape and
   * sprite batches stamp this slot on newly reserved vertices.
   */ refreshTransformIndex() {
        if (!this.pendingTransformDirty) return;
        const idx = this.transformBuffer.alloc(this.buildPendingTransform());
        this.shapeBatch.currentTransformIndex = idx;
        this.spriteBatch.currentTransformIndex = idx;
        this.pendingTransformDirty = false;
    }
    // ============ Core Primitive ============
    /**
   * Submit triangles to the shape batch for rendering.
   */ submitTriangles(vertices, indices, color, alpha) {
        this.submitTrianglesWithZ(vertices, indices, color, alpha, null);
    }
    /**
   * Submit triangles with optional per-vertex z-values for depth testing.
   * When zValues is null, uses the current global z from setZ().
   * When provided, each vertex gets its own z-height for accurate depth.
   */ submitTrianglesWithZ(vertices, indices, color, alpha, zValues) {
        // Flush sprites before drawing shapes (maintains layer ordering)
        if (this.spriteBatch.indexCount > 0) this.flushSprites();
        // Flush if adding this call would overflow the shape batch.
        if (this.shapeBatch.vertexCount + vertices.length > this.shapeBatch.maxVertices || this.shapeBatch.indexCount + indices.length > this.shapeBatch.maxIndices) this.flushShapes();
        // Split oversize submissions into triangle-sized chunks.
        if (vertices.length > this.shapeBatch.maxVertices || indices.length > this.shapeBatch.maxIndices) {
            for(let t = 0; t < indices.length; t += 3){
                const triIndices = indices.slice(t, t + 3);
                this.submitTrianglesWithZ(vertices, triIndices, color, alpha, zValues);
            }
            return;
        }
        this.refreshTransformIndex();
        const [r, g, b] = (0, $913afda613ebf2cb$export$c2f8695086bb1728)(color);
        // Per-vertex z defaults to 0 — zBase in the transform already carries
        // currentZ. Explicit zValues are local z offsets added on top.
        const { base: base, view: view } = this.shapeBatch.reserveVertices(vertices.length);
        for(let i = 0; i < vertices.length; i++){
            const v = vertices[i];
            const z = zValues !== null ? zValues[i] : 0;
            const o = i * (0, $e2d5197080de0e53$export$547e49c5a71c21ad);
            view[o] = v[0];
            view[o + 1] = v[1];
            view[o + 2] = r;
            view[o + 3] = g;
            view[o + 4] = b;
            view[o + 5] = alpha;
            view[o + 6] = 1; // lightAffected — world geometry always tinted
            view[o + 7] = z;
        }
        const idxSlice = this.shapeBatch.reserveIndices(indices.length);
        for(let i = 0; i < indices.length; i++)idxSlice[i] = base + indices[i];
    }
    /**
   * Submit triangles with per-vertex colors for smooth interpolation.
   * Same as submitTriangles but each vertex has its own RGBA color.
   * @param vertices - 2D vertex positions
   * @param indices - Triangle indices
   * @param colors - Per-vertex [r, g, b, a] colors (0-1 range), same length as vertices
   */ submitColoredTriangles(vertices, indices, colors) {
        if (this.spriteBatch.indexCount > 0) this.flushSprites();
        if (this.shapeBatch.vertexCount + vertices.length > this.shapeBatch.maxVertices || this.shapeBatch.indexCount + indices.length > this.shapeBatch.maxIndices) this.flushShapes();
        if (vertices.length > this.shapeBatch.maxVertices || indices.length > this.shapeBatch.maxIndices) {
            for(let t = 0; t < indices.length; t += 3){
                const triIndices = indices.slice(t, t + 3);
                this.submitColoredTriangles(vertices, triIndices, colors);
            }
            return;
        }
        this.refreshTransformIndex();
        // Per-vertex z defaults to 0 — zBase in the transform already carries
        // currentZ, so emitting currentZ per-vertex would double-apply.
        const { base: base, view: view } = this.shapeBatch.reserveVertices(vertices.length);
        for(let i = 0; i < vertices.length; i++){
            const v = vertices[i];
            const c = colors[i];
            const o = i * (0, $e2d5197080de0e53$export$547e49c5a71c21ad);
            view[o] = v[0];
            view[o + 1] = v[1];
            view[o + 2] = c[0];
            view[o + 3] = c[1];
            view[o + 4] = c[2];
            view[o + 5] = c[3];
            view[o + 6] = 1; // lightAffected — world geometry always tinted
            view[o + 7] = 0;
        }
        const idxSlice = this.shapeBatch.reserveIndices(indices.length);
        for(let i = 0; i < indices.length; i++)idxSlice[i] = base + indices[i];
    }
    /**
   * Submit a cached/dynamic mesh — the fast path. Memcpy-grade vertex + tx
   * upload, O(n) integer-add index rebase. One transform slot amortized
   * across the whole mesh.
   */ drawMesh(m) {
        if (m.vertexCount === 0 || m.indexCount === 0) return;
        if (this.spriteBatch.indexCount > 0) this.flushSprites();
        // A mesh bigger than the batch can't be submitted in one shot. Splitting
        // is non-trivial (indices reference local vertices); drop with a warning.
        if (m.vertexCount > this.shapeBatch.maxVertices || m.indexCount > this.shapeBatch.maxIndices) {
            this.warnOnce("drawMesh-oversize", `drawMesh skipped mesh with ${m.vertexCount} verts / ${m.indexCount} indices (exceeds batch capacity).`);
            return;
        }
        if (this.shapeBatch.vertexCount + m.vertexCount > this.shapeBatch.maxVertices || this.shapeBatch.indexCount + m.indexCount > this.shapeBatch.maxIndices) this.flushShapes();
        this.refreshTransformIndex();
        const { base: base, view: view } = this.shapeBatch.reserveVertices(m.vertexCount);
        // Bulk memcpy the packed vertex stream.
        view.set(m.vertexData.subarray(0, m.vertexCount * (0, $e2d5197080de0e53$export$547e49c5a71c21ad)), 0);
        const idxSlice = this.shapeBatch.reserveIndices(m.indexCount);
        for(let i = 0; i < m.indexCount; i++)idxSlice[i] = base + m.indexData[i];
    }
    /** Flush the shape batch to the GPU */ flushShapes() {
        if (this.shapeBatch.indexCount === 0 || !this.currentRenderPass || !this.device) return;
        // Upload view matrix + the per-frame transform range (includes everything
        // allocated up through the slots this batch references).
        this.uploadUniforms(this.shapeUniformBuffer);
        this.transformBuffer.upload(this.device);
        const pipeline = this.inOffscreenPass ? this.shapePipelineNoDepth : this.depthMode === "read-write" ? this.shapePipelineDepth : this.depthMode === "always-write" ? this.shapePipelineAlwaysWrite : this.shapePipeline;
        const { vertices: vertices, triangles: triangles } = this.shapeBatch.flush(this.device, this.currentRenderPass, pipeline, this.shapeBindGroup);
        if (vertices === 0) return;
        this.drawCallCount++;
        this.triangleCount += triangles;
        this.vertexCount += vertices;
    }
    // ============ Sprite Drawing ============
    /** Draw a textured image */ drawImage(texture, x, y, opts = {}) {
        if (this.shapeBatch.indexCount > 0) this.flushShapes();
        if (this.currentTexture && this.currentTexture !== texture) this.flushSprites();
        this.currentTexture = texture;
        this.currentTextureBindGroup = this.getTextureBindGroup(texture);
        const rotation = opts.rotation ?? 0;
        const scaleX = opts.scaleX ?? 1;
        const scaleY = opts.scaleY ?? 1;
        const alpha = opts.alpha ?? 1;
        const tint = opts.tint ?? 0xffffff;
        const anchorX = opts.anchorX ?? 0.5;
        const anchorY = opts.anchorY ?? 0.5;
        const tw = texture.width;
        const th = texture.height;
        // Build combined transform (anchor + scale + rotate + translate, then
        // composed with the current world transform). We allocate a dedicated
        // instance-transform slot for this quad so it can be positioned
        // independently without disturbing the caller's transform state.
        const m = this.spriteMatrix;
        m.identity();
        m.translate(x, y);
        m.rotate(rotation);
        m.scale(scaleX, scaleY);
        m.translate(-anchorX * tw, -anchorY * th);
        m.premultiply(this.currentTransform);
        const tr = (tint >> 16 & 0xff) / 255;
        const tg = (tint >> 8 & 0xff) / 255;
        const tb = (tint & 0xff) / 255;
        // Flush if adding the quad would overflow.
        if (this.spriteBatch.vertexCount + 4 > this.spriteBatch.maxVertices || this.spriteBatch.indexCount + 6 > this.spriteBatch.maxIndices) this.flushSprites();
        // Allocate a one-off transform slot that carries the sprite's local
        // matrix and the current z-state. Identity-tint (no per-sprite tint
        // coloring here — tint is applied to the vertex color RGB).
        const slot = this.transformBuffer.alloc({
            modelCol0X: m.a,
            modelCol0Y: m.b,
            modelCol1X: m.c,
            modelCol1Y: m.d,
            modelCol2X: m.tx,
            modelCol2Y: m.ty,
            zCoeffX: this.currentZCoeffX,
            zCoeffY: this.currentZCoeffY,
            zRowX: this.currentZRowX,
            zRowY: this.currentZRowY,
            zRowZ: this.currentZRowZ,
            zBase: this.currentZ,
            tintR: 1,
            tintG: 1,
            tintB: 1,
            tintA: 1
        });
        this.spriteBatch.currentTransformIndex = slot;
        this.spriteBatch.writeQuad([
            [
                0,
                0
            ],
            [
                tw,
                0
            ],
            [
                tw,
                th
            ],
            [
                0,
                th
            ]
        ], [
            [
                0,
                0
            ],
            [
                1,
                0
            ],
            [
                1,
                1
            ],
            [
                0,
                1
            ]
        ], tr, tg, tb, alpha, // Per-vertex z=0: zBase in the sprite's transform already carries currentZ.
        0);
    }
    /** Get or create a bind group for a texture */ getTextureBindGroup(texture) {
        let bindGroup = this.textureBindGroupCache.get(texture);
        if (!bindGroup) {
            bindGroup = this.device.createBindGroup({
                layout: this.spriteTextureBindGroupLayout,
                entries: [
                    {
                        binding: 0,
                        resource: texture.view
                    }
                ],
                label: "Sprite Texture Bind Group"
            });
            this.textureBindGroupCache.set(texture, bindGroup);
        }
        return bindGroup;
    }
    /** Flush the sprite batch to the GPU */ flushSprites() {
        if (this.spriteBatch.indexCount === 0 || !this.currentTexture || !this.currentRenderPass || !this.device) return;
        this.uploadUniforms(this.spriteUniformBuffer);
        this.transformBuffer.upload(this.device);
        const pipeline = this.inOffscreenPass ? this.spritePipelineNoDepth : this.depthMode === "read-write" ? this.spritePipelineDepth : this.depthMode === "always-write" ? this.spritePipelineAlwaysWrite : this.spritePipeline;
        const { vertices: vertices, triangles: triangles } = this.spriteBatch.flush(this.device, this.currentRenderPass, pipeline, this.spriteUniformBindGroup, this.currentTextureBindGroup);
        if (vertices === 0) return;
        this.drawCallCount++;
        this.triangleCount += triangles;
        this.vertexCount += vertices;
    }
    /** Upload uniforms (view matrix + ambient light). */ uploadUniforms(buffer) {
        if (!this.device) return;
        this.viewUniforms.set.viewMatrix(this.viewMatrix);
        this.viewUniforms.set.ambientLight(this.ambientLight);
        this.viewUniforms.uploadTo(buffer);
    }
    /**
   * Set the global scene illumination color. Multiplied into `draw.*`
   * geometry with `lightAffected=1` (default); bypassed entirely for
   * geometry with `ignoreLight: true`. Called once per frame by whichever
   * entity owns the scene lighting (typically SurfaceRenderer).
   */ setAmbientLight(r, g, b) {
        this.ambientLight[0] = r;
        this.ambientLight[1] = g;
        this.ambientLight[2] = b;
    }
    // ============ Texture Generation ============
    /** Generate a texture from draw commands */ generateTexture(draw, width, height) {
        // Create render target texture
        const texture = this.textureManager.createRenderTarget(width, height, (0, $558c2f47f1fdd57f$export$297162150ea0f6af)().preferredFormat, "Generated Texture");
        // Save current state
        const oldWidth = this.getWidth();
        const oldHeight = this.getHeight();
        const oldViewMatrix = this.viewMatrix.clone();
        const oldTransform = this.currentTransform.clone();
        // Set up for texture rendering
        this.viewMatrix.identity();
        this.viewMatrix.scale(2 / width, 2 / height);
        this.viewMatrix.translate(-width / 2, -height / 2);
        this.currentTransform.identity();
        // Create separate command encoder for texture generation
        const commandEncoder = this.device.createCommandEncoder({
            label: "Generate Texture Command Encoder"
        });
        // Save current render pass state
        const savedPass = this.currentRenderPass;
        const savedEncoder = this.currentCommandEncoder;
        const savedOffscreen = this.inOffscreenPass;
        // Begin render pass to texture (no depth attachment)
        this.currentCommandEncoder = commandEncoder;
        this.inOffscreenPass = true;
        this.currentRenderPass = commandEncoder.beginRenderPass({
            colorAttachments: [
                {
                    view: texture.view,
                    loadOp: "clear",
                    storeOp: "store",
                    clearValue: {
                        r: 0,
                        g: 0,
                        b: 0,
                        a: 0
                    }
                }
            ],
            label: "Generate Texture Render Pass"
        });
        // Draw
        draw(this);
        // Flush and end
        this.flushShapes();
        this.flushSprites();
        this.currentRenderPass.end();
        // Submit
        this.device.queue.submit([
            commandEncoder.finish()
        ]);
        // Restore state
        this.currentRenderPass = savedPass;
        this.currentCommandEncoder = savedEncoder;
        this.inOffscreenPass = savedOffscreen;
        this.resize(oldWidth, oldHeight, this.pixelRatio);
        this.viewMatrix = oldViewMatrix;
        this.currentTransform = oldTransform;
        return texture;
    }
    // ============ GPU Timing ============
    /** Check if GPU timing (timestamp queries) is supported */ hasGpuTimerSupport() {
        return this.gpuProfiler !== null;
    }
    /** Enable/disable GPU timing */ setGpuTimingEnabled(enabled) {
        this.gpuProfiler?.setEnabled(enabled);
    }
    /** Check if GPU timing is currently enabled */ isGpuTimingEnabled() {
        return this.gpuProfiler?.isEnabled() ?? false;
    }
    /** Get GPU time in milliseconds for a specific section (default: render) */ getGpuMs(section) {
        return this.gpuProfiler?.getMs(section) ?? 0;
    }
    /** Get all GPU section timings */ getAllGpuMs() {
        return this.gpuProfiler?.getAllMs() ?? null;
    }
    /** Get the GPU profiler instance (for external systems like water compute) */ getGpuProfiler() {
        return this.gpuProfiler;
    }
    /** Clean up all resources */ destroy() {
        this.unsubscribeMSAA?.();
        this.unsubscribeMSAA = null;
        this.textureManager.destroy();
        this.textureBindGroupCache.clear();
        this.shapeBatch.dispose();
        this.spriteBatch.dispose();
        this.transformBuffer.dispose();
        this.shapeUniformBuffer?.destroy();
        this.spriteUniformBuffer?.destroy();
        this.mainDepthTexture?.destroy();
        this.mainDepthTextureMS?.destroy();
        this.depthCopyTexture?.destroy();
        this.mainColorTexture?.destroy();
        this.mainColorTextureMS?.destroy();
        this.colorCopyTexture?.destroy();
        this.initialized = false;
    }
}


class $fb68242f783e6f0d$export$e8d4f9bbc35b572b {
    constructor(layerInfos, defaultLayerName, onResize){
        this.layerInfos = layerInfos;
        this.defaultLayerName = defaultLayerName;
        this.onResize = onResize;
        this.cursor = "none";
        this.backgroundColor = 0x1a1a2e;
        this.renderer = new (0, $5453fd34f01ad367$export$19fd8015bd4822d4)();
        this.showCursor();
        this.camera = new (0, $5fd8a8f6f7c6b09a$export$d10b745905c2533b)(this, (0, $6b6a54a072724620$export$e7c866399fa523f5)(0, 0));
        this.boundHandleResize = ()=>this.handleResize();
        window.addEventListener("resize", this.boundHandleResize);
    }
    destroy() {
        window.removeEventListener("resize", this.boundHandleResize);
        this.canvas.remove();
        this.renderer.destroy();
    }
    async init(options = {}) {
        if (options.backgroundColor !== undefined) this.backgroundColor = options.backgroundColor;
        // Initialize WebGPU renderer
        await this.renderer.init();
        // Add canvas to document
        document.body.appendChild(this.canvas);
        // Initial resize
        this.handleResize();
    }
    /** Get the canvas element */ get canvas() {
        return this.renderer.canvas;
    }
    /** Request fullscreen on next click */ requestFullscreen() {
        const makeFullScreen = ()=>{
            this.canvas.requestFullscreen();
            this.canvas.removeEventListener("click", makeFullScreen);
        };
        this.canvas.addEventListener("click", makeFullScreen);
    }
    /** Gets the effective height of the renderer viewport in logical pixels. */ getHeight() {
        return this.renderer.getHeight();
    }
    /** Gets the effective width of the renderer viewport in logical pixels. */ getWidth() {
        return this.renderer.getWidth();
    }
    getSize() {
        return (0, $6b6a54a072724620$export$e7c866399fa523f5)(this.getWidth(), this.getHeight());
    }
    handleResize() {
        this.renderer.resize(window.innerWidth, window.innerHeight);
        this.onResize?.(this.getSize());
    }
    hideCursor() {
        this.cursor = "none";
    }
    showCursor() {
        this.cursor = "auto";
    }
    setCursor(value) {
        this.cursor = value;
    }
    /** Get the layer infos */ getLayers() {
        return this.layerInfos;
    }
    /** Get layer names in render order */ getLayerNames() {
        return Object.keys(this.layerInfos);
    }
    /** Get the camera transform for a specific layer */ getLayerTransform(layerName) {
        const layer = this.layerInfos[layerName];
        return this.camera.getMatrix(layer.parallax, layer.anchor);
    }
    /** Begin rendering a frame */ beginFrame() {
        this.renderer.beginFrame();
    }
    /** End the frame and present */ endFrame() {
        this.renderer.endFrame();
        // Update cursor
        if (this.canvas.style) this.canvas.style.cursor = this.cursor;
    }
    /** Clear the screen */ clear(color) {
        this.renderer.clear(color ?? this.backgroundColor);
    }
    /** Set up the renderer for drawing on a specific layer */ setLayer(layerName) {
        const layer = this.layerInfos[layerName];
        const transform = this.getLayerTransform(layerName);
        this.renderer.setTransform(transform);
        this.renderer.setDepthMode(layer.depth);
    }
    /** Get the low-level renderer for direct drawing */ getRenderer() {
        return this.renderer;
    }
    // ============ GPU Timing ============
    /** Check if GPU timing (timestamp queries) is supported */ hasGpuTimerSupport() {
        return this.renderer.hasGpuTimerSupport();
    }
    /** Enable or disable GPU timing */ setGpuTimingEnabled(enabled) {
        this.renderer.setGpuTimingEnabled(enabled);
    }
    /** Check if GPU timing is enabled */ isGpuTimingEnabled() {
        return this.renderer.isGpuTimingEnabled();
    }
    /** Get GPU time in milliseconds for a specific section (default: render) */ getGpuMs(section) {
        return this.renderer.getGpuMs(section);
    }
    /** Get all GPU section timings */ getAllGpuMs() {
        return this.renderer.getAllGpuMs();
    }
    /** Get the GPU profiler instance (for external systems like water compute) */ getGpuProfiler() {
        return this.renderer.getGpuProfiler();
    }
}







var $d52f33955bf62086$export$72d962784102bc5 = /*#__PURE__*/ function(ControllerAxis) {
    ControllerAxis[ControllerAxis["LEFT_X"] = 0] = "LEFT_X";
    ControllerAxis[ControllerAxis["LEFT_Y"] = 1] = "LEFT_Y";
    ControllerAxis[ControllerAxis["RIGHT_X"] = 2] = "RIGHT_X";
    ControllerAxis[ControllerAxis["RIGHT_Y"] = 3] = "RIGHT_Y";
    return ControllerAxis;
}({});
var $d52f33955bf62086$export$a72c135d79aea91b = /*#__PURE__*/ function(ControllerButton) {
    ControllerButton[ControllerButton["A"] = 0] = "A";
    ControllerButton[ControllerButton["B"] = 1] = "B";
    ControllerButton[ControllerButton["X"] = 2] = "X";
    ControllerButton[ControllerButton["Y"] = 3] = "Y";
    ControllerButton[ControllerButton["LB"] = 4] = "LB";
    ControllerButton[ControllerButton["RB"] = 5] = "RB";
    ControllerButton[ControllerButton["LT"] = 6] = "LT";
    ControllerButton[ControllerButton["RT"] = 7] = "RT";
    ControllerButton[ControllerButton["BACK"] = 8] = "BACK";
    ControllerButton[ControllerButton["START"] = 9] = "START";
    ControllerButton[ControllerButton["L3"] = 10] = "L3";
    ControllerButton[ControllerButton["R3"] = 11] = "R3";
    ControllerButton[ControllerButton["D_UP"] = 12] = "D_UP";
    ControllerButton[ControllerButton["D_DOWN"] = 13] = "D_DOWN";
    ControllerButton[ControllerButton["D_LEFT"] = 14] = "D_LEFT";
    ControllerButton[ControllerButton["D_RIGHT"] = 15] = "D_RIGHT";
    ControllerButton[ControllerButton["SPECIAL"] = 16] = "SPECIAL";
    return ControllerButton;
}({});
var $d52f33955bf62086$export$c8f3cb6e59ecec4b = /*#__PURE__*/ function(ControllerType) {
    ControllerType[ControllerType["XBOX"] = 0] = "XBOX";
    ControllerType[ControllerType["PLAYSTATION"] = 1] = "PLAYSTATION";
    ControllerType[ControllerType["NINTENDO"] = 2] = "NINTENDO";
    return ControllerType;
}({});
const $d52f33955bf62086$var$BUTTON_NAMES = {
    [0]: [
        "A",
        "B",
        "X",
        "Y",
        "LB",
        "RB",
        "LT",
        "RT",
        "Back",
        "Start",
        "L3",
        "R3",
        "D-Up",
        "D-Down",
        "D-Left",
        "D-Right",
        "Xbox"
    ],
    [1]: [
        "Cross",
        "Circle",
        "Square",
        "Triangle",
        "L1",
        "R1",
        "L2",
        "R2",
        "Share",
        "Options",
        "L3",
        "R3",
        "D-Up",
        "D-Down",
        "D-Left",
        "D-Right",
        "PS"
    ],
    [2]: [
        "B",
        "A",
        "Y",
        "X",
        "L",
        "R",
        "ZL",
        "ZR",
        "-",
        "+",
        "LS",
        "RS",
        "D-Up",
        "D-Down",
        "D-Left",
        "D-Right",
        "Home"
    ]
};
function $d52f33955bf62086$export$a830fe54721d8e6e(button, type = 0) {
    return $d52f33955bf62086$var$BUTTON_NAMES[type]?.[button] ?? `Button ${button}`;
}
function $d52f33955bf62086$export$4c7b73a26a0e9c53(gamepadId) {
    const id = gamepadId.toLowerCase();
    if (id.includes("playstation") || id.includes("dualsense") || id.includes("dualshock")) return 1;
    if (id.includes("nintendo") || id.includes("pro controller") || id.includes("joy-con")) return 2;
    return 0; // Default for Xbox and unknown controllers
}


const $0fd956160b02c824$var$DEFAULT_CONFIG = {
    pollingFrequency: 250,
    deadzoneMin: 0.2,
    deadzoneMax: 0.95
};
class $0fd956160b02c824$export$58de03bd41c27b2e {
    constructor(dispatch, onDeviceChange, config = {}){
        this.dispatch = dispatch;
        this.onDeviceChange = onDeviceChange;
        this.lastButtons = [];
        this._usingGamepad = false;
        this.wasConnected = false;
        this._pollingFrequency = config.pollingFrequency ?? $0fd956160b02c824$var$DEFAULT_CONFIG.pollingFrequency;
        this._deadzoneMin = config.deadzoneMin ?? $0fd956160b02c824$var$DEFAULT_CONFIG.deadzoneMin;
        this._deadzoneMax = config.deadzoneMax ?? $0fd956160b02c824$var$DEFAULT_CONFIG.deadzoneMax;
        this.intervalId = this.startPolling();
    }
    startPolling() {
        return window.setInterval(()=>this.poll(), 1000 / this._pollingFrequency);
    }
    // --- Configuration getters/setters ---
    /** Polling frequency in Hz. Changing this restarts the polling interval. */ get pollingFrequency() {
        return this._pollingFrequency;
    }
    set pollingFrequency(value) {
        if (value !== this._pollingFrequency && value > 0) {
            this._pollingFrequency = value;
            window.clearInterval(this.intervalId);
            this.intervalId = this.startPolling();
        }
    }
    /** Minimum stick magnitude to register input (inner dead zone). */ get deadzoneMin() {
        return this._deadzoneMin;
    }
    set deadzoneMin(value) {
        this._deadzoneMin = (0, $2172aedd5a25ff17$export$7d15b64cf5a3a4c4)(value, 0, this._deadzoneMax);
    }
    /** Maximum stick magnitude before clamping (outer dead zone). */ get deadzoneMax() {
        return this._deadzoneMax;
    }
    set deadzoneMax(value) {
        this._deadzoneMax = (0, $2172aedd5a25ff17$export$7d15b64cf5a3a4c4)(value, this._deadzoneMin, 1);
    }
    // --- State ---
    /** True if the gamepad is currently the active input device. */ get usingGamepad() {
        return this._usingGamepad;
    }
    /** Sets the gamepad as active/inactive and fires device change event. */ setUsingGamepad(value) {
        if (this._usingGamepad !== value) {
            this._usingGamepad = value;
            this.onDeviceChange(this._usingGamepad);
            this.dispatch("inputDeviceChange", {
                usingGamepad: this._usingGamepad
            });
        }
    }
    /**
   * Polls connected gamepads and fires button events for state changes.
   */ poll() {
        const gamepad = navigator.getGamepads()[0];
        if (gamepad) {
            const buttons = gamepad.buttons.map((button)=>button.pressed);
            for (const [button, isDown] of buttons.entries()){
                if (isDown && !this.lastButtons[button]) {
                    this.setUsingGamepad(true);
                    this.dispatch("buttonDown", {
                        button: button
                    });
                } else if (!isDown && this.lastButtons[button]) this.dispatch("buttonUp", {
                    button: button
                });
            }
            this.lastButtons = buttons;
            this.wasConnected = true;
        } else {
            if (this.wasConnected && this._usingGamepad) this.setUsingGamepad(false);
            this.lastButtons = [];
            this.wasConnected = false;
        }
    }
    /**
   * Returns the detected controller type based on the gamepad ID string.
   * @returns The controller type, or null if no gamepad is connected
   */ getControllerType() {
        const gamepad = navigator.getGamepads()[0];
        if (!gamepad) return null;
        return (0, $d52f33955bf62086$export$4c7b73a26a0e9c53)(gamepad.id);
    }
    /**
   * Gets the current value of a gamepad axis (stick position).
   * @returns Axis value normalized to range [-1, 1], or 0 if no gamepad connected
   */ getAxis(axis) {
        switch(axis){
            case (0, $d52f33955bf62086$export$72d962784102bc5).LEFT_X:
                return this.getStick("left").x;
            case (0, $d52f33955bf62086$export$72d962784102bc5).LEFT_Y:
                return this.getStick("left").y;
            case (0, $d52f33955bf62086$export$72d962784102bc5).RIGHT_X:
                return this.getStick("right").x;
            case (0, $d52f33955bf62086$export$72d962784102bc5).RIGHT_Y:
                return this.getStick("right").y;
            default:
                throw new Error("unknown axis");
        }
    }
    /**
   * Gets the position of a gamepad stick with dead zone normalization applied.
   * @param stick Which stick to read ("left" or "right")
   * @returns Vector with x,y in range [-1, 1], accounting for dead zones
   */ getStick(stick) {
        const axes = (0, $6b6a54a072724620$export$e7c866399fa523f5)(0, 0);
        const gamepad = navigator.getGamepads()[0];
        if (gamepad) {
            if (stick === "left") {
                axes.x = gamepad.axes[(0, $d52f33955bf62086$export$72d962784102bc5).LEFT_X];
                axes.y = gamepad.axes[(0, $d52f33955bf62086$export$72d962784102bc5).LEFT_Y];
            } else {
                axes.x = gamepad.axes[(0, $d52f33955bf62086$export$72d962784102bc5).RIGHT_X];
                axes.y = gamepad.axes[(0, $d52f33955bf62086$export$72d962784102bc5).RIGHT_Y];
            }
            const deadzoneRange = this._deadzoneMax - this._deadzoneMin;
            axes.magnitude = (0, $2172aedd5a25ff17$export$f982906e4d317fcc)((axes.magnitude - this._deadzoneMin) / deadzoneRange);
            axes.x = (0, $2172aedd5a25ff17$export$7d15b64cf5a3a4c4)(axes.x, -1, 1);
            axes.y = (0, $2172aedd5a25ff17$export$7d15b64cf5a3a4c4)(axes.y, -1, 1);
        }
        return axes;
    }
    /**
   * Returns the value of a gamepad button (0-1 for analog triggers, 0 or 1 for digital).
   */ getButton(button) {
        const gamepad = navigator.getGamepads()[0];
        return gamepad?.buttons[button]?.value ?? 0;
    }
    destroy() {
        window.clearInterval(this.intervalId);
    }
}


class $a0af63d786fff8c6$export$46031d614cb84d78 {
    constructor(dispatch, onInputActivity){
        this.dispatch = dispatch;
        this.onInputActivity = onInputActivity;
        this.keys = new Map();
        this.boundOnKeyDown = (e)=>this.onKeyDown(e);
        this.boundOnKeyUp = (e)=>this.onKeyUp(e);
        this.boundOnVisibilityChange = ()=>this.clearAllKeys();
        document.addEventListener("keydown", this.boundOnKeyDown);
        document.addEventListener("keyup", this.boundOnKeyUp);
        document.addEventListener("visibilitychange", this.boundOnVisibilityChange);
    }
    /**
   * Returns true if the given key is currently pressed down.
   */ isKeyDown(key) {
        return Boolean(this.keys.get(key));
    }
    /**
   * Clears all key states and fires onKeyUp for each.
   * Called when the page loses visibility to prevent stuck keys.
   */ clearAllKeys() {
        for (const keyCode of this.keys.keys()){
            this.keys.set(keyCode, false);
            this.dispatch("keyUp", {
                key: keyCode
            });
        }
    }
    /**
   * Determines whether to prevent the default browser action for a key press.
   */ shouldPreventDefault(event) {
        if (event.key === "Tab") return true;
        if (event.key.toLowerCase() === "s") // s for save
        return true;
        // Prevent browser zoom shortcuts (Cmd/Ctrl + Plus/Minus)
        if ((event.metaKey || event.ctrlKey) && (event.key === "=" || event.key === "-")) return true;
        return false;
    }
    onKeyDown(event) {
        this.onInputActivity();
        const code = event.code;
        const wasPressed = this.keys.get(code); // for filtering out auto-repeat stuff
        this.keys.set(code, true);
        if (!wasPressed) this.dispatch("keyDown", {
            key: code,
            event: event
        });
        if (this.shouldPreventDefault(event)) event.preventDefault();
    }
    onKeyUp(event) {
        const code = event.code;
        this.keys.set(code, false);
        this.dispatch("keyUp", {
            key: code,
            event: event
        });
        if (this.shouldPreventDefault(event)) event.preventDefault();
    }
    destroy() {
        document.removeEventListener("keydown", this.boundOnKeyDown);
        document.removeEventListener("keyup", this.boundOnKeyUp);
        document.removeEventListener("visibilitychange", this.boundOnVisibilityChange);
    }
}



const $f19c05c4f687fa4a$export$183b5ff8ae4c0231 = {
    LEFT: 0,
    MIDDLE: 1,
    RIGHT: 2
};


class $9494c9a8b8ad28eb$export$473a5eb790b3816b {
    constructor(view, dispatch, onInputActivity){
        this.view = view;
        this.dispatch = dispatch;
        this.onInputActivity = onInputActivity;
        this.buttons = [
            false,
            false,
            false,
            false,
            false,
            false
        ];
        this._position = (0, $6b6a54a072724620$export$e7c866399fa523f5)(0, 0);
        this.view.onclick = (e)=>this.onClick(e);
        this.view.onmousedown = (e)=>this.onMouseDown(e);
        this.view.onmouseup = (e)=>this.onMouseUp(e);
        this.view.onmousemove = (e)=>this.onMouseMove(e);
        this.view.oncontextmenu = (e)=>{
            e.preventDefault();
            this.onClick(e);
            return false;
        };
    }
    /** Current mouse position in screen coordinates. */ get position() {
        return this._position;
    }
    /** True if the left mouse button is down. */ get lmb() {
        return this.buttons[(0, $f19c05c4f687fa4a$export$183b5ff8ae4c0231).LEFT];
    }
    /** True if the middle mouse button is down. */ get mmb() {
        return this.buttons[(0, $f19c05c4f687fa4a$export$183b5ff8ae4c0231).MIDDLE];
    }
    /** True if the right mouse button is down. */ get rmb() {
        return this.buttons[(0, $f19c05c4f687fa4a$export$183b5ff8ae4c0231).RIGHT];
    }
    /** Returns the state of a specific mouse button. */ isButtonDown(button) {
        return this.buttons[button];
    }
    updatePosition(event) {
        // Note: offsetX/offsetY are relative to target element with Y=0 at top
        // This matches the screen coordinate system used by the camera
        const target = event.target;
        const height = target.clientHeight;
        // Flip Y to match the coordinate system expected by the camera
        this._position = (0, $6b6a54a072724620$export$e7c866399fa523f5)(event.offsetX, height - event.offsetY);
    }
    onMouseMove(event) {
        this.onInputActivity();
        this.updatePosition(event);
    }
    onClick(event) {
        this.onInputActivity();
        this.updatePosition(event);
        switch(event.button){
            case (0, $f19c05c4f687fa4a$export$183b5ff8ae4c0231).LEFT:
                this.dispatch("click", undefined);
                break;
            case (0, $f19c05c4f687fa4a$export$183b5ff8ae4c0231).MIDDLE:
                this.dispatch("middleClick", undefined);
                break;
            case (0, $f19c05c4f687fa4a$export$183b5ff8ae4c0231).RIGHT:
                this.dispatch("rightClick", undefined);
                break;
        }
    }
    onMouseDown(event) {
        this.onInputActivity();
        this.updatePosition(event);
        this.buttons[event.button] = true;
        switch(event.button){
            case (0, $f19c05c4f687fa4a$export$183b5ff8ae4c0231).LEFT:
                this.dispatch("mouseDown", undefined);
                break;
            case (0, $f19c05c4f687fa4a$export$183b5ff8ae4c0231).MIDDLE:
                this.dispatch("middleDown", undefined);
                break;
            case (0, $f19c05c4f687fa4a$export$183b5ff8ae4c0231).RIGHT:
                this.dispatch("rightDown", undefined);
                break;
        }
    }
    onMouseUp(event) {
        this.onInputActivity();
        this.updatePosition(event);
        this.buttons[event.button] = false;
        switch(event.button){
            case (0, $f19c05c4f687fa4a$export$183b5ff8ae4c0231).LEFT:
                this.dispatch("mouseUp", undefined);
                break;
            case (0, $f19c05c4f687fa4a$export$183b5ff8ae4c0231).MIDDLE:
                this.dispatch("middleUp", undefined);
                break;
            case (0, $f19c05c4f687fa4a$export$183b5ff8ae4c0231).RIGHT:
                this.dispatch("rightUp", undefined);
                break;
        }
    }
    destroy() {
        this.view.onclick = null;
        this.view.onmousedown = null;
        this.view.onmouseup = null;
        this.view.onmousemove = null;
        this.view.oncontextmenu = null;
    }
}



const $23c1dfad77480d7e$var$LOGITECH_VENDOR_ID = 0x046d;
const $23c1dfad77480d7e$var$G29_PRODUCT_ID = 0xc24f;
const $23c1dfad77480d7e$var$DRIVING_FORCE_PRODUCT_ID = 0xc294;
const $23c1dfad77480d7e$var$FORCE_PACKET_SIZE = 7;
const $23c1dfad77480d7e$var$DEFAULT_WHEEL_RANGE_DEGREES = 900;
const $23c1dfad77480d7e$var$STEERING_DEADZONE = 0.02;
const $23c1dfad77480d7e$var$FORCE_DEADBAND = 0.01;
const $23c1dfad77480d7e$var$FORCE_UPDATE_INTERVAL_MS = 16;
class $23c1dfad77480d7e$export$537b3a1b2a188dde {
    constructor(){
        this.device = null;
        this.outputReportId = 0;
        this.errorMessage = "";
        this.queuedPacket = null;
        this.isSendingPacket = false;
        this.lastForce = Number.NaN;
        this.lastForceSentAt = 0;
        this.onDisconnect = (event)=>{
            if (this.device && event.device === this.device) {
                this.device = null;
                this._status = "disconnected";
                this.errorMessage = "";
                this.lastForce = Number.NaN;
            }
        };
        this._status = this.isSupported() ? "disconnected" : "unsupported";
        if (!this.isSupported()) return;
        this.getHid()?.addEventListener("disconnect", this.onDisconnect);
        this.tryReconnectGrantedDevice();
    }
    get status() {
        return this._status;
    }
    get isConnected() {
        return this._status === "connected" && this.device?.opened === true;
    }
    get deviceName() {
        return this.device?.productName ?? null;
    }
    getDebugLabel() {
        if (this._status === "unsupported") return "wheel n/a";
        if (this._status === "connecting") return "wheel connecting...";
        if (this._status === "connected") {
            const name = this.deviceName ?? "connected";
            return `wheel ${name}`;
        }
        if (this._status === "error") return this.errorMessage ? `wheel error: ${this.errorMessage}` : "wheel error";
        return "wheel off (H connect)";
    }
    async requestConnection() {
        if (!this.isSupported()) return {
            connected: false,
            message: "WebHID is unavailable in this browser. Chromium-based browsers are required."
        };
        this._status = "connecting";
        this.errorMessage = "";
        try {
            const hid = this.getHid();
            if (!hid) {
                this._status = "unsupported";
                return {
                    connected: false,
                    message: "WebHID is unavailable in this browser. Chromium-based browsers are required."
                };
            }
            const devices = await hid.requestDevice({
                filters: [
                    {
                        vendorId: $23c1dfad77480d7e$var$LOGITECH_VENDOR_ID,
                        productId: $23c1dfad77480d7e$var$G29_PRODUCT_ID
                    },
                    {
                        vendorId: $23c1dfad77480d7e$var$LOGITECH_VENDOR_ID,
                        productId: $23c1dfad77480d7e$var$DRIVING_FORCE_PRODUCT_ID
                    }
                ]
            });
            const device = devices[0];
            if (!device) {
                this._status = "disconnected";
                return {
                    connected: false,
                    message: "Wheel selection was canceled."
                };
            }
            await this.attachDevice(device);
            return {
                connected: true,
                message: `${device.productName ?? "Logitech wheel"} connected.`
            };
        } catch (error) {
            this._status = "error";
            this.errorMessage = this.getErrorMessage(error);
            return {
                connected: false,
                message: `Failed to connect wheel: ${this.errorMessage}`
            };
        }
    }
    getSteeringInput() {
        const gamepad = this.findWheelGamepad();
        if (!gamepad) return null;
        const steerAxis = gamepad.axes[0] ?? 0;
        let steer = (0, $2172aedd5a25ff17$export$7d15b64cf5a3a4c4)(steerAxis, -1, 1);
        if (Math.abs(steer) < $23c1dfad77480d7e$var$STEERING_DEADZONE) steer = 0;
        return steer;
    }
    /**
   * Sets continuous constant-force feedback in [-1, 1].
   */ setForceFeedback(force) {
        if (!this.isConnected) return;
        const now = performance.now();
        const clampedForce = (0, $2172aedd5a25ff17$export$7d15b64cf5a3a4c4)(force, -1, 1);
        if (now - this.lastForceSentAt < $23c1dfad77480d7e$var$FORCE_UPDATE_INTERVAL_MS && Math.abs(clampedForce - this.lastForce) < 0.03) return;
        this.lastForceSentAt = now;
        if (Math.abs(clampedForce) <= $23c1dfad77480d7e$var$FORCE_DEADBAND) {
            if (this.lastForce === 0) return;
            this.lastForce = 0;
            this.queuePacket(this.buildStopForcePacket());
            return;
        }
        this.lastForce = clampedForce;
        this.queuePacket(this.buildConstantForcePacket(clampedForce));
    }
    destroy() {
        if (!this.isSupported()) return;
        this.getHid()?.removeEventListener("disconnect", this.onDisconnect);
        this.queuePacket(this.buildStopForcePacket());
    }
    isSupported() {
        return typeof navigator !== "undefined" && "hid" in navigator;
    }
    async tryReconnectGrantedDevice() {
        if (!this.isSupported()) return;
        if (this.device?.opened) return;
        try {
            const hid = this.getHid();
            if (!hid) return;
            const devices = await hid.getDevices();
            const knownWheel = devices.find((device)=>this.isSupportedWheelProduct(device.productId));
            if (!knownWheel) return;
            await this.attachDevice(knownWheel);
        } catch  {
        // Non-fatal: user can still connect manually with KeyH.
        }
    }
    async attachDevice(device) {
        if (!device.opened) await device.open();
        this.device = device;
        this.outputReportId = this.resolveOutputReportId(device);
        this.lastForce = Number.NaN;
        await this.sendPacketNow(this.buildSetRangePacket($23c1dfad77480d7e$var$DEFAULT_WHEEL_RANGE_DEGREES));
        await this.sendPacketNow(this.buildDisableAutoCenterPacket());
        await this.sendPacketNow(this.buildStopForcePacket());
        this._status = "connected";
        this.errorMessage = "";
    }
    resolveOutputReportId(device) {
        for (const collection of device.collections){
            const report = collection.outputReports[0];
            if (report) return report.reportId;
        }
        return 0;
    }
    isSupportedWheelProduct(productId) {
        return productId === $23c1dfad77480d7e$var$G29_PRODUCT_ID || productId === $23c1dfad77480d7e$var$DRIVING_FORCE_PRODUCT_ID;
    }
    findWheelGamepad() {
        const allGamepads = navigator.getGamepads();
        for (const gamepad of allGamepads){
            if (!gamepad) continue;
            const id = gamepad.id.toLowerCase();
            const isLogitech = id.includes("logitech");
            const isWheel = id.includes("g29") || id.includes("wheel");
            if (isLogitech && isWheel) return gamepad;
        }
        return null;
    }
    buildStopForcePacket() {
        return new Uint8Array([
            0x13,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00
        ]);
    }
    buildConstantForcePacket(force) {
        const level = Math.round((0, $2172aedd5a25ff17$export$7d15b64cf5a3a4c4)(force, -1, 1) * 100);
        const encoded = (0, $2172aedd5a25ff17$export$7d15b64cf5a3a4c4)(Math.round(level * 127 / 100 + 0x80), 0, 0xff);
        return new Uint8Array([
            0x11,
            0x08,
            encoded,
            0x80,
            0x00,
            0x00,
            0x00
        ]);
    }
    buildDisableAutoCenterPacket() {
        return new Uint8Array([
            0xf5,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00
        ]);
    }
    buildSetRangePacket(rangeDegrees) {
        const range = (0, $2172aedd5a25ff17$export$7d15b64cf5a3a4c4)(Math.round(rangeDegrees), 40, 900);
        return new Uint8Array([
            0xf8,
            0x81,
            range & 0xff,
            range >> 8 & 0xff,
            0x00,
            0x00,
            0x00
        ]);
    }
    async sendPacketNow(packet) {
        if (packet.byteLength !== $23c1dfad77480d7e$var$FORCE_PACKET_SIZE) throw new Error("Invalid wheel packet size");
        const device = this.device;
        if (!device?.opened) return;
        await device.sendReport(this.outputReportId, packet);
    }
    queuePacket(packet) {
        this.queuedPacket = packet;
        if (this.isSendingPacket) return;
        this.isSendingPacket = true;
        this.flushPacketQueue();
    }
    async flushPacketQueue() {
        while(this.queuedPacket){
            const packet = this.queuedPacket;
            this.queuedPacket = null;
            try {
                await this.sendPacketNow(packet);
            } catch (error) {
                this._status = "error";
                this.errorMessage = this.getErrorMessage(error);
            }
        }
        this.isSendingPacket = false;
    }
    getErrorMessage(error) {
        if (error instanceof Error && error.message) return error.message;
        return "unknown error";
    }
    getHid() {
        const nav = navigator;
        return nav.hid ?? null;
    }
}


class $1150a8e0cd0aefe2$export$ac2778e3d733463d {
    constructor(view, dispatch){
        this.dispatch = dispatch;
        this.keyboard = new (0, $a0af63d786fff8c6$export$46031d614cb84d78)(this.dispatch, ()=>this.gamepad.setUsingGamepad(false));
        this.mouse = new (0, $9494c9a8b8ad28eb$export$473a5eb790b3816b)(view, this.dispatch, ()=>this.gamepad.setUsingGamepad(false));
        this.gamepad = new (0, $0fd956160b02c824$export$58de03bd41c27b2e)(this.dispatch, ()=>{});
        this.steeringWheel = new (0, $23c1dfad77480d7e$export$537b3a1b2a188dde)();
    }
    destroy() {
        this.keyboard.destroy();
        this.mouse.destroy();
        this.gamepad.destroy();
        this.steeringWheel.destroy();
    }
    // --- Keyboard ---
    /** True if the given key is currently pressed down. */ isKeyDown(key) {
        return this.keyboard.isKeyDown(key);
    }
    // --- Mouse ---
    /** Current mouse position in screen coordinates. */ get mousePosition() {
        return this.mouse.position;
    }
    /** True if the left mouse button is down. */ get lmb() {
        return this.mouse.lmb;
    }
    /** True if the middle mouse button is down. */ get mmb() {
        return this.mouse.mmb;
    }
    /** True if the right mouse button is down. */ get rmb() {
        return this.mouse.rmb;
    }
    // --- Gamepad ---
    /** True if the gamepad is the main input device. */ get usingGamepad() {
        return this.gamepad.usingGamepad;
    }
    /**
   * Gets the current value of a gamepad axis (stick position).
   * @returns Axis value normalized to range [-1, 1], or 0 if no gamepad connected
   */ getAxis(axis) {
        return this.gamepad.getAxis(axis);
    }
    /**
   * Gets the position of a gamepad stick with dead zone normalization.
   */ getStick(stick) {
        return this.gamepad.getStick(stick);
    }
    /** Returns the value of a gamepad button. */ getButton(button) {
        return this.gamepad.getButton(button);
    }
    /**
   * Returns the detected controller type based on the gamepad ID string.
   * @returns The controller type, or null if no gamepad is connected
   */ getControllerType() {
        return this.gamepad.getControllerType();
    }
    get usingSteeringWheel() {
        return this.steeringWheel.isConnected;
    }
    getSteeringWheelDebugLabel() {
        return this.steeringWheel.getDebugLabel();
    }
    async requestSteeringWheelConnection() {
        return this.steeringWheel.requestConnection();
    }
    setSteeringWheelForceFeedback(force) {
        this.steeringWheel.setForceFeedback(force);
    }
    /**
   * Sheet/trim axis (W/S, up/down arrows, or gamepad left stick Y).
   * When a steering wheel is active, gamepad Y is ignored to avoid
   * treating wheel pedal axes as sail trim input.
   */ getSheetInput() {
        if (this.isInputFocused()) return 0;
        let sheet = 0;
        if (this.usingGamepad && !this.usingSteeringWheel) sheet += this.getStick("left").y;
        if (this.isKeyDown("ArrowUp")) sheet -= 1;
        if (this.isKeyDown("ArrowDown")) sheet += 1;
        const hasModifier = this.isKeyDown("MetaLeft") || this.isKeyDown("MetaRight") || this.isKeyDown("ControlLeft") || this.isKeyDown("ControlRight");
        if (!hasModifier) {
            if (this.isKeyDown("KeyW")) sheet -= 1;
            if (this.isKeyDown("KeyS")) sheet += 1;
        }
        return (0, $2172aedd5a25ff17$export$7d15b64cf5a3a4c4)(sheet, -1, 1);
    }
    /**
   * Steering axis for rudder/tiller control.
   * Priority:
   * 1) Steering wheel axis (if connected)
   * 2) Standard gamepad left stick (if active)
   * 3) Keyboard arrows / A,D
   */ getRudderSteerInput() {
        if (this.isInputFocused()) return 0;
        let steer = 0;
        const wheelSteer = this.steeringWheel.getSteeringInput();
        if (wheelSteer !== null) steer += wheelSteer;
        else if (this.usingGamepad) steer += this.getStick("left").x;
        if (this.isKeyDown("ArrowRight")) steer += 1;
        if (this.isKeyDown("ArrowLeft")) steer -= 1;
        const hasModifier = this.isKeyDown("MetaLeft") || this.isKeyDown("MetaRight") || this.isKeyDown("ControlLeft") || this.isKeyDown("ControlRight");
        if (!hasModifier) {
            if (this.isKeyDown("KeyD")) steer += 1;
            if (this.isKeyDown("KeyA")) steer -= 1;
        }
        return (0, $2172aedd5a25ff17$export$7d15b64cf5a3a4c4)(steer, -1, 1);
    }
    // --- Combined Input ---
    /**
   * Check if an input element (input, textarea, select, contenteditable) is focused.
   * Used to prevent keyboard shortcuts from triggering when typing.
   */ isInputFocused() {
        const active = document.activeElement;
        if (!active) return false;
        const tagName = active.tagName.toLowerCase();
        return tagName === "input" || tagName === "textarea" || tagName === "select" || active.isContentEditable;
    }
    /**
   * Gets standardized movement input from WASD keys, arrow keys, or gamepad left stick.
   * Combines keyboard and gamepad input with proper priority handling.
   * Returns zero vector if an input element is focused.
   * WASD keys are ignored if Cmd/Ctrl modifier is held (to allow shortcuts like Cmd+S).
   * @returns Movement vector with components clamped to [-1, 1] range
   */ getMovementVector() {
        const result = (0, $6b6a54a072724620$export$e7c866399fa523f5)(0, 0);
        // Don't respond to keyboard when typing in input fields
        if (this.isInputFocused()) return result;
        if (this.usingGamepad) result.iadd(this.getStick("left"));
        // Check if modifier key is held (for shortcuts like Cmd+S)
        const hasModifier = this.isKeyDown("MetaLeft") || this.isKeyDown("MetaRight") || this.isKeyDown("ControlLeft") || this.isKeyDown("ControlRight");
        // Arrow keys always work
        if (this.isKeyDown("ArrowUp")) result[1] -= 1;
        if (this.isKeyDown("ArrowRight")) result[0] += 1;
        if (this.isKeyDown("ArrowDown")) result[1] += 1;
        if (this.isKeyDown("ArrowLeft")) result[0] -= 1;
        // WASD only works without modifier (to allow Cmd+S, Ctrl+A, etc.)
        if (!hasModifier) {
            if (this.isKeyDown("KeyW")) result[1] -= 1;
            if (this.isKeyDown("KeyD")) result[0] += 1;
            if (this.isKeyDown("KeyS")) result[1] += 1;
            if (this.isKeyDown("KeyA")) result[0] -= 1;
        }
        result[0] = (0, $2172aedd5a25ff17$export$7d15b64cf5a3a4c4)(result[0], -1, 1);
        result[1] = (0, $2172aedd5a25ff17$export$7d15b64cf5a3a4c4)(result[1], -1, 1);
        return result;
    }
}





/**
 * Simple profiler for measuring code performance.
 *
 * Usage:
 *   profiler.start("myFunction");
 *   // ... code to measure ...
 *   profiler.end("myFunction");
 *
 *   // Or use measure() for cleaner code:
 *   profiler.measure("myFunction", () => { ... });
 *
 *   // Just count calls without timing:
 *   profiler.count("frequentOperation");
 *
 *   // View results:
 *   profiler.report();
 *   profiler.reset();
 */ class $5a1d1d3ab1ff9c51$var$Profiler {
    /** Get the current stack as a path string (cached) */ getCurrentPath() {
        if (this.stack.length === 0) return "";
        const cacheKey = this.stack.join("\0");
        let path = this.pathCache.get(cacheKey);
        if (!path) {
            path = this.stack.join(this.separator);
            this.pathCache.set(cacheKey, path);
        }
        return path;
    }
    /** Get the entry key for a label using current stack context */ getEntryKey(label) {
        const currentPath = this.getCurrentPath();
        if (currentPath === "") return label;
        const cacheKey = currentPath + "\0" + label;
        let fullPath = this.pathCache.get(cacheKey);
        if (!fullPath) {
            fullPath = currentPath + this.separator + label;
            this.pathCache.set(cacheKey, fullPath);
        }
        return fullPath;
    }
    /** Register a label as a scope root. When end() fires for this label at stack depth 0,
   *  only entries nested under it get EMA-smoothed and reset. */ registerScope(label, onEnd) {
        this.scopes.set(label, {
            onEnd: onEnd
        });
    }
    /** Start timing a labeled section */ start(label, options) {
        if (!this.enabled) return;
        if (this.stack.length >= this.maxStackDepth) {
            console.warn(`Profiler: max stack depth (${this.maxStackDepth}) exceeded, ignoring: ${label}`);
            return;
        }
        const entryKey = this.getEntryKey(label);
        const entry = this.getOrCreate(entryKey);
        entry.startTime = performance.now();
        this.stack.push(label);
        // Inline scope registration
        if (options?.scope && !this.scopes.has(entryKey)) this.scopes.set(entryKey, {});
    }
    /** End timing a labeled section. Optionally pass explicit elapsed time. */ end(label, explicitElapsedMs) {
        if (!this.enabled) return;
        if (this.stack.length === 0) {
            console.warn(`Profiler: end("${label}") called with empty stack`);
            return;
        }
        const expectedLabel = this.stack[this.stack.length - 1];
        if (expectedLabel !== label) {
            console.warn(`Profiler: mismatched end - expected "${expectedLabel}", got "${label}"`);
            return;
        }
        // Pop the stack to restore parent context
        this.stack.pop();
        // Get the entry key (now with the label as child of current stack)
        const entryKey = this.getEntryKey(label);
        const entry = this.entries.get(entryKey);
        if (!entry) return;
        const elapsed = explicitElapsedMs !== undefined ? explicitElapsedMs : entry.startTime !== undefined ? performance.now() - entry.startTime : 0;
        entry.frameCalls++;
        entry.frameMs += elapsed;
        entry.maxMs = Math.max(entry.maxMs, elapsed);
        entry.startTime = undefined;
        // Trigger scope processing when a registered scope label ends at root
        if (this.stack.length === 0 && this.scopes.has(label)) this.processScope(label);
    }
    /** Process end of a scope - update smoothed values and reset accumulators for entries under this scope */ processScope(scopeLabel) {
        this.cachedStats = null;
        this.cachedStatsParams = null;
        const prefix = scopeLabel + this.separator;
        for (const [key, entry] of this.entries)if (key === scopeLabel || key.startsWith(prefix)) {
            entry.smoothedCallsPerFrame = this.smoothedUpdate(entry.frameCalls, entry.smoothedCallsPerFrame);
            entry.smoothedMsPerFrame = this.smoothedUpdate(entry.frameMs, entry.smoothedMsPerFrame);
            entry.frameCalls = 0;
            entry.frameMs = 0;
        }
        // Fire scope callback
        this.scopes.get(scopeLabel)?.onEnd?.();
    }
    /** EMA update with cold-start fix: initialize directly on first sample */ smoothedUpdate(raw, smoothed) {
        if (smoothed === 0 && raw > 0) return raw;
        return (0, $2172aedd5a25ff17$export$3a89f8d6f6bf6c9f)(raw, smoothed, this.smoothing);
    }
    /** Measure a function's execution time */ measure(label, fn) {
        this.start(label);
        try {
            const result = fn();
            // Detect Promise and attach timing cleanup
            if (result instanceof Promise) return result.finally(()=>this.end(label));
            else {
                this.end(label);
                return result;
            }
        } catch (err) {
            this.end(label);
            throw err;
        }
    }
    /** Just count occurrences (no timing overhead) */ count(label, amount = 1) {
        if (!this.enabled) return;
        const entryKey = this.getEntryKey(label);
        const entry = this.getOrCreate(entryKey);
        entry.frameCalls += amount;
    }
    /**
   * Record an elapsed time atomically (start + end in one call).
   * Safe for parallel async operations since it doesn't span an async gap.
   * The entry will be nested under the current stack context.
   *
   * `count` lets callers bump the frame-call counter by more than 1 —
   * useful for batched work where the interesting "unit" is a work item
   * (e.g. equations solved) rather than a function call. With a non-1
   * count, the displayed `calls/frame` represents the total work items
   * processed, and `ms/frame ÷ calls/frame` yields per-item cost.
   */ recordElapsed(label, elapsedMs, count = 1) {
        if (!this.enabled) return;
        const entryKey = this.getEntryKey(label);
        const entry = this.getOrCreate(entryKey);
        entry.frameCalls += count;
        entry.frameMs += elapsedMs;
        entry.maxMs = Math.max(entry.maxMs, elapsedMs);
    }
    /** Log a formatted report to console */ report() {
        console.log("=== Profiler Report ===");
        const stats = this.getStats();
        for (const stat of stats){
            const indent = "  ".repeat(stat.depth);
            const prefix = stat.depth > 0 ? "- " : "";
            const label = (indent + prefix + stat.shortLabel).padEnd(30);
            if (stat.msPerFrame > 0) console.log(`${label} calls/frame: ${stat.callsPerFrame.toFixed(1).padStart(6)}  ` + `ms/frame: ${stat.msPerFrame.toFixed(2).padStart(7)}  ` + `max: ${stat.maxMs.toFixed(2).padStart(7)}ms`);
            else console.log(`${label} calls/frame: ${stat.callsPerFrame.toFixed(1).padStart(6)}  (count only)`);
        }
        console.log("========================");
    }
    /** Clear all stats */ reset() {
        this.entries.clear();
        this.pathCache.clear();
        this.stack = [];
    }
    /** Enable/disable profiling (disabled = no overhead) */ setEnabled(enabled) {
        this.enabled = enabled;
    }
    /** Check if profiling is enabled */ isEnabled() {
        return this.enabled;
    }
    /**
   * Get all stats sorted hierarchically.
   * Optimized to O(n log n) by building parent-child map in a single pass.
   * @param maxChildrenPerParent If specified, limits the number of children shown per parent
   * @param scope If specified, only return entries under this scope label
   */ getStats(maxChildrenPerParent, scope) {
        // Build parent-child map in a single pass (O(n))
        const childrenMap = new Map();
        const msLookup = new Map();
        // When scoped, only include entries that belong to the scope
        const scopePrefix = scope ? scope + this.separator : undefined;
        for (const [label, entry] of this.entries){
            // Filter to scope if specified
            if (scope && label !== scope && !label.startsWith(scopePrefix)) continue;
            const segments = label.split(this.separator);
            const stat = {
                label: label,
                shortLabel: segments[segments.length - 1],
                depth: segments.length - 1,
                callsPerFrame: entry.smoothedCallsPerFrame,
                msPerFrame: entry.smoothedMsPerFrame,
                maxMs: entry.maxMs
            };
            msLookup.set(label, entry.smoothedMsPerFrame);
            // Determine parent path and register this stat as a child
            const parentPath = segments.length > 1 ? segments.slice(0, -1).join(this.separator) : "";
            let children = childrenMap.get(parentPath);
            if (!children) {
                children = [];
                childrenMap.set(parentPath, children);
            }
            children.push(stat);
        }
        // Recursively build sorted list (O(n log n) total for sorting)
        const buildSortedList = (parentPath)=>{
            const children = childrenMap.get(parentPath);
            if (!children || children.length === 0) return [];
            const parentMs = msLookup.get(parentPath) ?? 0;
            // Sort children by ms descending
            children.sort((a, b)=>{
                if (parentMs > 0) return b.msPerFrame / parentMs - a.msPerFrame / parentMs;
                return b.msPerFrame - a.msPerFrame;
            });
            // Limit children if needed
            const limited = maxChildrenPerParent !== undefined ? children.slice(0, maxChildrenPerParent) : children;
            const result = [];
            for (const child of limited){
                result.push(child);
                result.push(...buildSortedList(child.label));
            }
            return result;
        };
        const children = buildSortedList(scope ?? "");
        // When scoped, prepend the scope's own entry as the root
        if (scope) {
            const scopeEntry = this.entries.get(scope);
            if (scopeEntry) {
                const segments = scope.split(this.separator);
                children.unshift({
                    label: scope,
                    shortLabel: segments[segments.length - 1],
                    depth: segments.length - 1,
                    callsPerFrame: scopeEntry.smoothedCallsPerFrame,
                    msPerFrame: scopeEntry.smoothedMsPerFrame,
                    maxMs: scopeEntry.maxMs
                });
            }
        }
        return children;
    }
    /** Get top N stats by total time (cached within frame) */ getTopStats(n, maxChildrenPerParent, scope) {
        // Check cache
        if (this.cachedStats && this.cachedStatsParams?.maxChildren === maxChildrenPerParent && this.cachedStatsParams?.scope === scope) return this.cachedStats.slice(0, n);
        // Compute and cache
        const stats = this.getStats(maxChildrenPerParent, scope);
        this.cachedStats = stats;
        this.cachedStatsParams = {
            maxChildren: maxChildrenPerParent,
            scope: scope
        };
        return stats.slice(0, n);
    }
    getOrCreate(label) {
        let entry = this.entries.get(label);
        if (!entry) {
            entry = {
                frameCalls: 0,
                frameMs: 0,
                smoothedCallsPerFrame: 0,
                smoothedMsPerFrame: 0,
                maxMs: 0
            };
            this.entries.set(label, entry);
        }
        return entry;
    }
    constructor(){
        this.entries = new Map();
        this.enabled = true;
        // Stack tracking
        this.stack = [];
        this.pathCache = new Map();
        this.separator = " > ";
        this.maxStackDepth = 10;
        // Scope system - registered top-level labels that trigger per-frame processing
        this.scopes = new Map();
        // Smoothing factor (higher = smoother, slower to respond)
        this.smoothing = 0.975;
        // Stats caching - invalidated each frame
        this.cachedStats = null;
        this.cachedStatsParams = null;
    }
}
const $5a1d1d3ab1ff9c51$export$e8e2fad003b4d4ce = new $5a1d1d3ab1ff9c51$var$Profiler();
// Expose profiler globally for debugging
window.profiler = $5a1d1d3ab1ff9c51$export$e8e2fad003b4d4ce;
function $5a1d1d3ab1ff9c51$export$4882ae973e0491e(_target, propertyKey, descriptor) {
    const original = descriptor.value;
    descriptor.value = function(...args) {
        const className = this.constructor.name;
        return $5a1d1d3ab1ff9c51$export$e8e2fad003b4d4ce.measure(`${className}.${propertyKey}`, ()=>{
            return original.call(this, ...args);
        });
    };
}
function $5a1d1d3ab1ff9c51$export$ba371caaa8f2e40(_target, propertyKey, descriptor) {
    const original = descriptor.value;
    descriptor.value = async function(...args) {
        const className = this.constructor.name;
        const label = `${className}.${propertyKey}`;
        const start = performance.now();
        try {
            return await original.call(this, ...args);
        } finally{
            $5a1d1d3ab1ff9c51$export$e8e2fad003b4d4ce.recordElapsed(label, performance.now() - start);
        }
    };
}



let $3a0afeab946181f7$export$e9423e87c6aa4f4e = true;
function $3a0afeab946181f7$export$acf2110ef20a3e62(enabled) {
    $3a0afeab946181f7$export$e9423e87c6aa4f4e = enabled;
}
function $3a0afeab946181f7$export$855cd95009c0b312(body, stage) {
    const v = body.velocity;
    const f = body.force;
    const p = body.position;
    const av = body.angularVelocity3;
    const af = body.angularForce3;
    let bad = null;
    if (!isFinite(p[0]) || !isFinite(p[1])) bad = `position [${p[0]}, ${p[1]}]`;
    else if (!isFinite(v.x) || !isFinite(v.y)) bad = `velocity [${v.x}, ${v.y}]`;
    else if (!isFinite(f.x) || !isFinite(f.y)) bad = `force [${f.x}, ${f.y}]`;
    else if (!isFinite(body._angle)) bad = `angle ${body._angle}`;
    if (!bad && (body.shape === "pm3d" || body.shape === "rigid3d")) {
        if (!isFinite(body.z)) bad = `z ${body.z}`;
        else if (!isFinite(body.zVelocity)) bad = `zVelocity ${body.zVelocity}`;
        else if (!isFinite(body.zForce)) bad = `zForce ${body.zForce}`;
    }
    if (!bad && (body.shape === "rigid2d" || body.shape === "rigid3d")) {
        if (!isFinite(av[2]) || !isFinite(af[2])) bad = `angularVelocity/Force z [${av[2]}, ${af[2]}]`;
    }
    if (!bad && body.shape === "rigid3d") {
        if (!isFinite(av[0]) || !isFinite(av[1])) bad = `angularVelocity roll/pitch [${av[0]}, ${av[1]}]`;
        else if (!isFinite(af[0]) || !isFinite(af[1])) bad = `angularForce roll/pitch [${af[0]}, ${af[1]}]`;
        else {
            const R = body.orientation;
            for(let i = 0; i < 9; i++)if (!isFinite(R[i])) {
                bad = `orientation[${i}] ${R[i]}`;
                break;
            }
        }
    }
    if (bad !== null) throw new Error(`[physics] NaN/Infinity detected on body "${body.id}" (${body.shape}/${body.motion}) ${stage}: ${bad}`);
}
function $3a0afeab946181f7$export$338e2d92a009605e(bodies, stage) {
    if (!$3a0afeab946181f7$export$e9423e87c6aa4f4e) return;
    for (const body of bodies)$3a0afeab946181f7$export$855cd95009c0b312(body, stage);
}





class $5decb6115b59ebc8$export$c36c68baa13912a5 extends (0, $ecce3222fc0a9651$export$6428a7f2611ef1fa) {
    constructor(options = {}){
        super(options);
        this.updateBoundingRadius();
        this.updateArea();
    }
    computeMomentOfInertia(_mass) {
        return 0; // Can't rotate a particle
    }
    updateBoundingRadius() {
        this.boundingRadius = 0;
    }
    updateArea() {
        this.area = 0;
    }
    computeAABB(position, _angle) {
        const out = new (0, $dd0ee6ed41f5ec2f$export$8ec70f2db73b49aa)();
        out.lowerBound.set(position);
        out.upperBound.set(position);
        return out;
    }
    raycast(_from, _to, _position, _angle, _skipBackfaces) {
        return null;
    }
}


function $14794f8f933fd955$export$a4560d1e61908593(body) {
    return body.shapes.every((s)=>s instanceof (0, $5decb6115b59ebc8$export$c36c68baa13912a5));
}
function $14794f8f933fd955$export$bab7033901c7ec81(body) {
    return body.motion === "dynamic" && !body.isSleeping();
}



function $0c8c1abaefcc6cf6$export$26ff2e69979f5b7c(worldPoint, convexShape, convexOffset, convexAngle) {
    const localPoint = (0, $6b6a54a072724620$export$e7c866399fa523f5)(worldPoint).itoLocalFrame(convexOffset, convexAngle);
    return $0c8c1abaefcc6cf6$export$1bebc88c4be8f018(localPoint, convexShape);
}
function $0c8c1abaefcc6cf6$export$1bebc88c4be8f018(localPoint, convexShape) {
    const verts = convexShape.vertices;
    const numVerts = verts.length;
    let lastCross = null;
    const r0 = (0, $6b6a54a072724620$export$e7c866399fa523f5)();
    const r1 = (0, $6b6a54a072724620$export$e7c866399fa523f5)();
    for(let i = 0; i < numVerts + 1; i++){
        const v0 = verts[i % numVerts];
        const v1 = verts[(i + 1) % numVerts];
        r0.set(v0).isub(localPoint);
        r1.set(v1).isub(localPoint);
        const cross = r0.crossLength(r1);
        if (lastCross === null) lastCross = cross;
        // If we got a different sign, the point is outside
        if (cross * lastCross < 0) return false;
        lastCross = cross;
    }
    return true;
}
function $0c8c1abaefcc6cf6$export$a580b18a8c59b6c1(separationOut, poly1, position1, angle1, poly2, position2, angle2) {
    const count1 = poly1.vertices.length;
    const count2 = poly2.vertices.length;
    const normals1 = poly1.axes;
    const vertices1 = poly1.vertices;
    const vertices2 = poly2.vertices;
    const rotatedNormal = (0, $6b6a54a072724620$export$e7c866399fa523f5)();
    const transformedVertex = (0, $6b6a54a072724620$export$e7c866399fa523f5)();
    const vertexDiff = (0, $6b6a54a072724620$export$e7c866399fa523f5)();
    const tempVec = (0, $6b6a54a072724620$export$e7c866399fa523f5)();
    const angle = angle1 - angle2;
    let bestIndex = 0;
    let maxSeparation = -Number.MAX_VALUE;
    for(let i = 0; i < count1; i++){
        // Get poly1 normal in frame2
        rotatedNormal.set(normals1[i]).irotate(angle);
        // Get poly1 vertex in frame2
        tempVec.set(vertices1[i]).itoGlobalFrame(position1, angle1);
        transformedVertex.set(tempVec).itoLocalFrame(position2, angle2);
        // Find deepest point for normal i
        let minSeparation = Number.MAX_VALUE;
        for(let j = 0; j < count2; j++){
            vertexDiff.set(vertices2[j]).isub(transformedVertex);
            const separation = rotatedNormal.dot(vertexDiff);
            if (separation < minSeparation) minSeparation = separation;
        }
        if (minSeparation > maxSeparation) {
            maxSeparation = minSeparation;
            bestIndex = i;
        }
    }
    separationOut[0] = maxSeparation;
    return bestIndex;
}
function $0c8c1abaefcc6cf6$export$51cea0d50a4ecfc8(clipVerticesOut, poly1, position1, angle1, edge1, poly2, position2, angle2) {
    const normals1 = poly1.axes;
    const count2 = poly2.vertices.length;
    const vertices2 = poly2.vertices;
    const normals2 = poly2.axes;
    // Get the normal of the reference edge in poly2's frame
    const referenceNormal = (0, $6b6a54a072724620$export$e7c866399fa523f5)(normals1[edge1]).irotate(angle1 - angle2);
    // Find the incident edge on poly2
    let incidentIndex = 0;
    let minDot = Number.MAX_VALUE;
    for(let i = 0; i < count2; i++){
        const d = referenceNormal.dot(normals2[i]);
        if (d < minDot) {
            minDot = d;
            incidentIndex = i;
        }
    }
    // Build the clip vertices for the incident edge
    const i1 = incidentIndex;
    const i2 = i1 + 1 < count2 ? i1 + 1 : 0;
    clipVerticesOut[0].set(vertices2[i1]).itoGlobalFrame(position2, angle2);
    clipVerticesOut[1].set(vertices2[i2]).itoGlobalFrame(position2, angle2);
}
function $0c8c1abaefcc6cf6$export$96d0049505ea342e(vOut, vIn, normal, offset) {
    let numOut = 0;
    // Calculate distance of end points to the line
    const distance0 = normal.dot(vIn[0]) - offset;
    const distance1 = normal.dot(vIn[1]) - offset;
    // If the points are behind the plane
    if (distance0 <= 0.0) vOut[numOut++].set(vIn[0]);
    if (distance1 <= 0.0) vOut[numOut++].set(vIn[1]);
    // If the points are on different sides of the plane
    if (distance0 * distance1 < 0.0) {
        // Find intersection point
        const interp = distance0 / (distance0 - distance1);
        const v = vOut[numOut];
        v.set(vIn[1]).isub(vIn[0]).imul(interp).iadd(vIn[0]);
        numOut++;
    }
    return numOut;
}
function $0c8c1abaefcc6cf6$export$444559d296aa5afb(convexShape, capsuleShape) {
    const capsuleRadius = capsuleShape.radius;
    const halfCapsuleLength = capsuleShape.length * 0.5;
    const verts = convexShape.vertices;
    verts[0].set(-halfCapsuleLength, -capsuleRadius);
    verts[1].set(halfCapsuleLength, -capsuleRadius);
    verts[2].set(halfCapsuleLength, capsuleRadius);
    verts[3].set(-halfCapsuleLength, capsuleRadius);
}
function $0c8c1abaefcc6cf6$export$4a6bb981cea74008(bodyA, bodyB) {
    // Static and kinematic bodies cannot collide with each other
    if (bodyA.motion !== "dynamic" && bodyB.motion !== "dynamic") return false;
    // Check if bodies are sleeping (only dynamic bodies can sleep)
    const aSleeping = bodyA.motion === "dynamic" && bodyA.isSleeping();
    const bSleeping = bodyB.motion === "dynamic" && bodyB.isSleeping();
    // Cannot collide if both sleeping
    if (aSleeping && bSleeping) return false;
    // Cannot collide if one is sleeping and the other is static
    if (aSleeping && bodyB.motion === "static" || bSleeping && bodyA.motion === "static") return false;
    return true;
}
function $0c8c1abaefcc6cf6$export$5b208537b1539f4e(shapeA, shapeB) {
    return (shapeA.collisionGroup & shapeB.collisionMask) !== 0 && (shapeB.collisionGroup & shapeA.collisionMask) !== 0;
}


class $28a1aa2ac7817540$export$b1da34c0243c37ef {
    constructor(world){
        this.result = [];
        this.world = world ?? null;
    }
    /** Set the world that we are searching for collision pairs in. */ setWorld(world) {
        this.world = world;
    }
    /** Check whether the AABBs of two bodies overlap. */ boundingVolumeCheck(bodyA, bodyB) {
        return bodyA.getAABB().overlaps(bodyB.getAABB());
    }
}


const $a47013ac1bc6d942$var$HUGE_LIMIT = 200;
const $a47013ac1bc6d942$var$DEFAULT_CELL_SIZE = 6;
const $a47013ac1bc6d942$var$HUGE = []; // Sentinel value for huge bodies
class $a47013ac1bc6d942$export$bfb9823bf11a6d41 extends (0, $28a1aa2ac7817540$export$b1da34c0243c37ef) {
    constructor({ cellSize: cellSize = $a47013ac1bc6d942$var$DEFAULT_CELL_SIZE, width: width = 24, height: height = 24 } = {}){
        super(), this.pointShapeBodies = new Set(), this.dynamicBodies = new Set(), this.kinematicBodies = new Set(), this.hugeBodies = new Set(), this.partitions = [], this.bodiesAdded = false, this.debugData = {
            numCollisions: 0
        };
        this.cellSize = cellSize;
        this.width = width;
        this.height = height;
        for(let i = 0; i < width * height; i++)this.partitions.push(new Set());
    }
    setWorld(world) {
        super.setWorld.call(this, world);
        world.on("addBody", (e)=>this.onAddBody(e.body));
        world.on("removeBody", (e)=>this.onRemoveBody(e.body));
    }
    resize(cellSize, width, height) {
        this.cellSize = cellSize;
        const oldBodies = new Set();
        for (const partition of this.partitions)for (const body of partition)oldBodies.add(body);
        this.partitions = [];
        for(let i = 0; i < width * height; i++)this.partitions.push(new Set());
        for (const body of oldBodies)this.addBodyToHash(body);
    }
    onAddBody(body) {
        if (body.motion === "dynamic") {
            if ((0, $14794f8f933fd955$export$a4560d1e61908593)(body)) this.pointShapeBodies.add(body);
            else this.dynamicBodies.add(body);
        } else if (body.motion === "kinematic") this.kinematicBodies.add(body);
        else // body is static
        this.addBodyToHash(body);
    }
    onRemoveBody(body) {
        if (body.motion === "dynamic") {
            this.dynamicBodies.delete(body);
            this.pointShapeBodies.delete(body);
        } else if (body.motion === "kinematic") this.kinematicBodies.delete(body);
        else // body is static
        this.removeBodyFromHash(body);
    }
    addBodyToHash(body) {
        const cells = this.aabbToCells(body.getAABB());
        if (cells === $a47013ac1bc6d942$var$HUGE) this.hugeBodies.add(body);
        else for (const cell of cells)this.partitions[cell].add(body);
    }
    addBodiesToHash(bodies) {
        for (const body of bodies)this.addBodyToHash(body);
    }
    removeBodyFromHash(body) {
        const cells = this.aabbToCells(body.getAABB());
        if (cells === $a47013ac1bc6d942$var$HUGE) this.hugeBodies.delete(body);
        else for (const cell of cells)this.partitions[cell].delete(body);
    }
    removeBodiesFromHash(bodies) {
        for (const body of bodies)this.removeBodyFromHash(body);
    }
    addExtraBodies() {
        for (const kBody of this.kinematicBodies)this.addBodyToHash(kBody);
        for (const dBody of this.dynamicBodies)this.addBodyToHash(dBody);
        for (const pBody of this.pointShapeBodies)this.addBodyToHash(pBody);
    }
    removeExtraBodies() {
        for (const kBody of this.kinematicBodies)this.removeBodyFromHash(kBody);
        for (const dBody of this.dynamicBodies)this.removeBodyFromHash(dBody);
        for (const pBody of this.pointShapeBodies)this.removeBodyFromHash(pBody);
    }
    getCollisionPairs(world) {
        const result = [];
        // Static bodies are already there, we never remove them
        this.addBodiesToHash(this.kinematicBodies);
        this.addBodiesToHash(this.dynamicBodies);
        // Don't add particles because they can't collide with each other, so we just need to check if they're overlapping anything
        for (const pBody of this.pointShapeBodies){
            for (const other of this.aabbQuery(world, pBody.getAABB(), false))if ((0, $0c8c1abaefcc6cf6$export$4a6bb981cea74008)(pBody, other)) result.push([
                pBody,
                other
            ]);
        }
        // For the rest of collisions, at least one of the bodies must be dynamic,
        // so we can find all collisions by iterating through just the dynamic bodies
        for (const dBody of this.dynamicBodies){
            this.removeBodyFromHash(dBody); // This will make sure we don't overlap ourselves, and that we don't double count anything
            for (const other of this.aabbQuery(world, dBody.getAABB(), false))if ((0, $0c8c1abaefcc6cf6$export$4a6bb981cea74008)(dBody, other)) result.push([
                dBody,
                other
            ]);
        }
        this.removeBodiesFromHash(this.kinematicBodies);
        this.debugData.numCollisions = result.length;
        return result;
    }
    xyToCell(x, y) {
        return (0, $2172aedd5a25ff17$export$842a2cf37af977e1)(x, this.width) + (0, $2172aedd5a25ff17$export$842a2cf37af977e1)(y, this.height) * this.width;
    }
    /** Returns the cells that overlap the aabb. Returns HUGE if the aabb is "huge". */ aabbToCells(aabb, checkHuge = true) {
        const result = [];
        const lowX = Math.floor(aabb.lowerBound[0] / this.cellSize);
        const lowY = Math.floor(aabb.lowerBound[1] / this.cellSize);
        const highX = Math.floor(aabb.upperBound[0] / this.cellSize);
        const highY = Math.floor(aabb.upperBound[1] / this.cellSize);
        const size = Math.abs(highX - lowX) * Math.abs(highY - lowY);
        // Check for huge
        if (checkHuge && (!isFinite(lowX) || !isFinite(lowY) || !isFinite(highX) || !isFinite(highY) || size > $a47013ac1bc6d942$var$HUGE_LIMIT)) return $a47013ac1bc6d942$var$HUGE;
        for(let x = lowX; x <= highX; x++)for(let y = lowY; y <= highY; y++)result.push(this.xyToCell(x, y));
        return result;
    }
    aabbQuery(_, aabb, shouldAddBodies = true) {
        if (shouldAddBodies) this.addExtraBodies();
        // Use Set for O(1) deduplication - return directly without array conversion
        const resultSet = new Set();
        for (const cell of this.aabbToCells(aabb, false)){
            for (const body of this.partitions[cell])if (body.getAABB().overlaps(aabb)) resultSet.add(body);
        }
        for (const hugeBody of this.hugeBodies)if (aabb.overlaps(hugeBody.getAABB())) resultSet.add(hugeBody);
        if (shouldAddBodies) this.removeExtraBodies();
        return resultSet;
    }
    /** Query all bodies whose cells intersect the ray using DDA grid traversal. */ rayQuery(ray, shouldAddBodies = true) {
        if (shouldAddBodies) this.addExtraBodies();
        const resultSet = new Set();
        const x1 = ray.from[0] / this.cellSize;
        const y1 = ray.from[1] / this.cellSize;
        const x2 = ray.to[0] / this.cellSize;
        const y2 = ray.to[1] / this.cellSize;
        let cellX = Math.floor(x1);
        let cellY = Math.floor(y1);
        const endCellX = Math.floor(x2);
        const endCellY = Math.floor(y2);
        const dx = x2 - x1;
        const dy = y2 - y1;
        const stepX = dx > 0 ? 1 : dx < 0 ? -1 : 0;
        const stepY = dy > 0 ? 1 : dy < 0 ? -1 : 0;
        // How far along the ray (in t) we move when crossing one cell
        const tDeltaX = stepX !== 0 ? Math.abs(1 / dx) : Infinity;
        const tDeltaY = stepY !== 0 ? Math.abs(1 / dy) : Infinity;
        // t value at which we cross the first cell boundary
        let tMaxX = stepX > 0 ? (Math.ceil(x1) - x1) * tDeltaX : stepX < 0 ? (x1 - Math.floor(x1)) * tDeltaX : Infinity;
        let tMaxY = stepY > 0 ? (Math.ceil(y1) - y1) * tDeltaY : stepY < 0 ? (y1 - Math.floor(y1)) * tDeltaY : Infinity;
        const addCell = (cx, cy)=>{
            const cell = this.xyToCell(cx, cy);
            for (const body of this.partitions[cell])resultSet.add(body);
        };
        // Check starting cell
        addCell(cellX, cellY);
        // Traverse until we reach the end cell
        while(cellX !== endCellX || cellY !== endCellY){
            if (tMaxX < tMaxY) {
                tMaxX += tDeltaX;
                cellX += stepX;
            } else {
                tMaxY += tDeltaY;
                cellY += stepY;
            }
            addCell(cellX, cellY);
        }
        // Check huge bodies (which aren't in the spatial hash)
        for (const hugeBody of this.hugeBodies)resultSet.add(hugeBody);
        if (shouldAddBodies) this.removeExtraBodies();
        return resultSet;
    }
}







const $edc29b4b53f48a09$var$r = (0, $6b6a54a072724620$export$e7c866399fa523f5)();
class $edc29b4b53f48a09$export$28bdb8fc07bf3804 extends (0, $ecce3222fc0a9651$export$6428a7f2611ef1fa) {
    constructor(options = {}){
        super(options);
        this.length = options.length ?? 1;
        this.radius = options.radius ?? 1;
        this.updateBoundingRadius();
        this.updateArea();
    }
    computeMomentOfInertia(mass) {
        // Approximate with rectangle
        const rad = this.radius;
        const w = this.length + rad;
        const h = rad * 2;
        return mass * (h * h + w * w) / 12;
    }
    updateBoundingRadius() {
        this.boundingRadius = this.radius + this.length / 2;
    }
    updateArea() {
        this.area = Math.PI * this.radius * this.radius + this.radius * 2 * this.length;
    }
    computeAABB(position, angle) {
        const radius = this.radius;
        $edc29b4b53f48a09$var$r.set(this.length / 2, 0);
        if (angle !== 0) $edc29b4b53f48a09$var$r.irotate(angle);
        const out = new (0, $dd0ee6ed41f5ec2f$export$8ec70f2db73b49aa)();
        out.upperBound.set(Math.max($edc29b4b53f48a09$var$r[0] + radius, -$edc29b4b53f48a09$var$r[0] + radius), Math.max($edc29b4b53f48a09$var$r[1] + radius, -$edc29b4b53f48a09$var$r[1] + radius));
        out.lowerBound.set(Math.min($edc29b4b53f48a09$var$r[0] - radius, -$edc29b4b53f48a09$var$r[0] - radius), Math.min($edc29b4b53f48a09$var$r[1] - radius, -$edc29b4b53f48a09$var$r[1] - radius));
        out.lowerBound.iadd(position);
        out.upperBound.iadd(position);
        return out;
    }
    raycast(from, to, position, angle, _skipBackfaces) {
        let closestHit = null;
        let closestFraction = Infinity;
        const rayLength = from.distanceTo(to);
        const halfLen = this.length / 2;
        // The sides
        for(let i = 0; i < 2; i++){
            const y = this.radius * (i * 2 - 1);
            const l0 = (0, $6b6a54a072724620$export$e7c866399fa523f5)(-halfLen, y).itoGlobalFrame(position, angle);
            const l1 = (0, $6b6a54a072724620$export$e7c866399fa523f5)(halfLen, y).itoGlobalFrame(position, angle);
            const fraction = (0, $6b6a54a072724620$export$19606695c7c6ab3a).lineSegmentsIntersectionFraction(from, to, l0, l1);
            if (fraction >= 0 && fraction < closestFraction) {
                closestFraction = fraction;
                const normal = (0, $6b6a54a072724620$export$e7c866399fa523f5)(0, 1).irotate(angle).imul(i * 2 - 1);
                const point = (0, $6b6a54a072724620$export$e7c866399fa523f5)(from).ilerp(to, fraction);
                closestHit = {
                    point: point,
                    normal: normal,
                    distance: rayLength * fraction,
                    fraction: fraction
                };
            }
        }
        // End cap circles
        const diagonalLengthSquared = Math.pow(this.radius, 2) + Math.pow(halfLen, 2);
        for(let i = 0; i < 2; i++){
            const circleCenter = (0, $6b6a54a072724620$export$e7c866399fa523f5)(halfLen * (i * 2 - 1), 0).itoGlobalFrame(position, angle);
            const a = Math.pow(to[0] - from[0], 2) + Math.pow(to[1] - from[1], 2);
            const b = 2 * ((to[0] - from[0]) * (from[0] - circleCenter[0]) + (to[1] - from[1]) * (from[1] - circleCenter[1]));
            const c = Math.pow(from[0] - circleCenter[0], 2) + Math.pow(from[1] - circleCenter[1], 2) - Math.pow(this.radius, 2);
            const delta = Math.pow(b, 2) - 4 * a * c;
            if (delta < 0) continue;
            const sqrtDelta = Math.sqrt(delta);
            const inv2a = 1 / (2 * a);
            const d1 = (-b - sqrtDelta) * inv2a;
            const d2 = (-b + sqrtDelta) * inv2a;
            // Check both intersection points
            for (const fraction of [
                d1,
                d2
            ])if (fraction >= 0 && fraction <= 1 && fraction < closestFraction) {
                const hitPoint = (0, $6b6a54a072724620$export$e7c866399fa523f5)(from).ilerp(to, fraction);
                // Only count hits on the end caps (outside the rectangular part)
                if (hitPoint.squaredDistanceTo(position) > diagonalLengthSquared) {
                    closestFraction = fraction;
                    const normal = (0, $6b6a54a072724620$export$e7c866399fa523f5)(hitPoint).isub(circleCenter).inormalize();
                    closestHit = {
                        point: hitPoint,
                        normal: normal,
                        distance: rayLength * fraction,
                        fraction: fraction
                    };
                }
            }
        }
        return closestHit;
    }
}







class $2f5e2d32a4c0fef1$export$fa360b5b58f475b7 extends (0, $ecce3222fc0a9651$export$6428a7f2611ef1fa) {
    constructor(options = {}){
        super(options);
        this.heights = options.heights ? options.heights.slice(0) : [];
        this.elementWidth = options.elementWidth ?? 0.1;
        this.maxValue = options.maxValue ?? 0;
        this.minValue = options.minValue ?? 0;
        if (options.maxValue === undefined || options.minValue === undefined) this.updateMaxMinValues();
        this.updateBoundingRadius();
        this.updateArea();
    }
    updateMaxMinValues() {
        const data = this.heights;
        if (data.length === 0) {
            this.maxValue = 0;
            this.minValue = 0;
            return;
        }
        let maxValue = data[0];
        let minValue = data[0];
        for(let i = 0; i < data.length; i++){
            const v = data[i];
            if (v > maxValue) maxValue = v;
            if (v < minValue) minValue = v;
        }
        this.maxValue = maxValue;
        this.minValue = minValue;
    }
    computeMomentOfInertia(_mass) {
        return Number.MAX_VALUE;
    }
    updateBoundingRadius() {
        this.boundingRadius = Number.MAX_VALUE;
    }
    updateArea() {
        const data = this.heights;
        let area = 0;
        for(let i = 0; i < data.length - 1; i++)area += (data[i] + data[i + 1]) / 2 * this.elementWidth;
        this.area = area;
    }
    computeAABB(position, angle) {
        const out = new (0, $dd0ee6ed41f5ec2f$export$8ec70f2db73b49aa)();
        const points = [
            (0, $6b6a54a072724620$export$e7c866399fa523f5)(0, this.maxValue),
            (0, $6b6a54a072724620$export$e7c866399fa523f5)(this.elementWidth * this.heights.length, this.maxValue),
            (0, $6b6a54a072724620$export$e7c866399fa523f5)(this.elementWidth * this.heights.length, this.minValue),
            (0, $6b6a54a072724620$export$e7c866399fa523f5)(0, this.minValue)
        ];
        out.setFromPoints(points, position, angle, 0);
        return out;
    }
    /**
   * Get a line segment in the heightfield.
   * @param i Index of the segment
   * @returns Start and end points of the segment
   */ getLineSegment(i) {
        const data = this.heights;
        const width = this.elementWidth;
        const start = (0, $6b6a54a072724620$export$e7c866399fa523f5)(i * width, data[i]);
        const end = (0, $6b6a54a072724620$export$e7c866399fa523f5)((i + 1) * width, data[i + 1]);
        return [
            start,
            end
        ];
    }
    /**
   * Get height at a specific index
   */ getHeightAtIndex(i) {
        return this.heights[i] ?? 0;
    }
    raycast(from, to, position, angle, _skipBackfaces) {
        // Transform ray to local space
        const localFrom = (0, $6b6a54a072724620$export$e7c866399fa523f5)(from).itoLocalFrame(position, angle);
        const localTo = (0, $6b6a54a072724620$export$e7c866399fa523f5)(to).itoLocalFrame(position, angle);
        // Find which segments the ray might intersect
        const x0 = localFrom.x;
        const x1 = localTo.x;
        const minX = Math.min(x0, x1);
        const maxX = Math.max(x0, x1);
        const idxStart = Math.max(0, Math.floor(minX / this.elementWidth));
        const idxEnd = Math.min(this.heights.length - 2, Math.ceil(maxX / this.elementWidth));
        let closestHit = null;
        let closestFraction = Infinity;
        const rayLength = from.distanceTo(to);
        for(let i = idxStart; i <= idxEnd; i++){
            const [segStart, segEnd] = this.getLineSegment(i);
            // Check intersection with this segment
            const fraction = (0, $6b6a54a072724620$export$19606695c7c6ab3a).lineSegmentsIntersectionFraction(localFrom, localTo, segStart, segEnd);
            if (fraction >= 0 && fraction < closestFraction) {
                closestFraction = fraction;
                // Compute normal (perpendicular to segment, pointing up)
                const normal = (0, $6b6a54a072724620$export$e7c866399fa523f5)(segEnd).isub(segStart);
                normal.irotate(-Math.PI / 2);
                normal.inormalize();
                // Transform normal to world space
                normal.irotate(angle);
                const point = (0, $6b6a54a072724620$export$e7c866399fa523f5)(from).ilerp(to, fraction);
                closestHit = {
                    point: point,
                    normal: normal,
                    distance: rayLength * fraction,
                    fraction: fraction
                };
            }
        }
        return closestHit;
    }
}







class $4a68a0f4a5a6faef$export$7ff5ac152ef991b0 extends (0, $ecce3222fc0a9651$export$6428a7f2611ef1fa) {
    constructor(options = {}){
        super(options);
        this.updateBoundingRadius();
        this.updateArea();
    }
    computeMomentOfInertia(_mass) {
        return 0; // Infinite plane has infinite moment of inertia (static)
    }
    updateBoundingRadius() {
        this.boundingRadius = Number.MAX_VALUE;
    }
    updateArea() {
        this.area = Number.MAX_VALUE;
    }
    computeAABB(_position, _angle) {
        const out = new (0, $dd0ee6ed41f5ec2f$export$8ec70f2db73b49aa)();
        const max = Number.MAX_VALUE;
        out.lowerBound.set(-max, -max);
        out.upperBound.set(max, max);
        return out;
    }
    raycast(from, to, position, angle, _skipBackfaces) {
        // World normal of plane (rotated +Y)
        const worldNormal = (0, $6b6a54a072724620$export$e7c866399fa523f5)(0, 1).irotate(angle);
        // Direction from ray start to plane position
        const planeToRay = (0, $6b6a54a072724620$export$e7c866399fa523f5)(from).isub(position);
        // Distance from ray start to plane along plane normal
        const d1 = worldNormal.dot(planeToRay);
        // Ray direction projected onto plane normal
        const rayDir = (0, $6b6a54a072724620$export$e7c866399fa523f5)(to).isub(from);
        const d2 = worldNormal.dot(rayDir);
        // Ray is parallel to plane or pointing away
        if (d2 >= 0) return null;
        // Compute intersection fraction
        const fraction = d1 / -d2;
        if (fraction >= 0 && fraction <= 1) {
            const point = (0, $6b6a54a072724620$export$e7c866399fa523f5)(from).ilerp(to, fraction);
            const distance = from.distanceTo(to) * fraction;
            return {
                point: point,
                normal: worldNormal,
                distance: distance,
                fraction: fraction
            };
        }
        return null;
    }
}





function $c6ded5357db9ac08$export$2dc323ef1a86e04b() {
    return {
        contacts: []
    };
}




// Scratch vectors to avoid per-call allocations
const $24ffcd53ca5eb8b7$var$_centerDiff = (0, $6b6a54a072724620$export$e7c866399fa523f5)();
const $24ffcd53ca5eb8b7$var$_normal = (0, $6b6a54a072724620$export$e7c866399fa523f5)();
const $24ffcd53ca5eb8b7$var$_contactOnA = (0, $6b6a54a072724620$export$e7c866399fa523f5)();
const $24ffcd53ca5eb8b7$var$_contactOnB = (0, $6b6a54a072724620$export$e7c866399fa523f5)();
function $24ffcd53ca5eb8b7$export$b85ee8633cdf5ab6(bodyA, shapeA, offsetA, _angleA, bodyB, shapeB, offsetB, _angleB, justTest, radiusA, radiusB) {
    const circleA = shapeA;
    const circleB = shapeB;
    const rA = radiusA ?? circleA.radius;
    const rB = radiusB ?? circleB.radius;
    $24ffcd53ca5eb8b7$var$_centerDiff.set(offsetA).isub(offsetB);
    const radiusSum = rA + rB;
    if ($24ffcd53ca5eb8b7$var$_centerDiff.squaredMagnitude > radiusSum * radiusSum) return null;
    if (justTest) return (0, $c6ded5357db9ac08$export$2dc323ef1a86e04b)();
    // Compute normal from A to B
    $24ffcd53ca5eb8b7$var$_normal.set(offsetB).isub(offsetA).inormalize();
    // Contact point on circle A surface (world space)
    $24ffcd53ca5eb8b7$var$_contactOnA.set($24ffcd53ca5eb8b7$var$_normal).imul(rA).iadd(offsetA);
    // Contact point on circle B surface (world space)
    $24ffcd53ca5eb8b7$var$_contactOnB.set($24ffcd53ca5eb8b7$var$_normal).imul(-rB).iadd(offsetB);
    const result = (0, $c6ded5357db9ac08$export$2dc323ef1a86e04b)();
    result.contacts.push({
        worldContactA: (0, $6b6a54a072724620$export$e7c866399fa523f5)($24ffcd53ca5eb8b7$var$_contactOnA).isub(bodyA.position),
        worldContactB: (0, $6b6a54a072724620$export$e7c866399fa523f5)($24ffcd53ca5eb8b7$var$_contactOnB).isub(bodyB.position),
        normal: (0, $6b6a54a072724620$export$e7c866399fa523f5)($24ffcd53ca5eb8b7$var$_normal),
        depth: radiusSum - $24ffcd53ca5eb8b7$var$_centerDiff.magnitude
    });
    return result;
}









// Scratch vectors to avoid per-call allocations
const $2081d284af2f6844$var$_localCirclePos = (0, $6b6a54a072724620$export$e7c866399fa523f5)();
const $2081d284af2f6844$var$_r = (0, $6b6a54a072724620$export$e7c866399fa523f5)();
const $2081d284af2f6844$var$_candidate = (0, $6b6a54a072724620$export$e7c866399fa523f5)();
const $2081d284af2f6844$var$_candidateDist = (0, $6b6a54a072724620$export$e7c866399fa523f5)();
const $2081d284af2f6844$var$_worldV0 = (0, $6b6a54a072724620$export$e7c866399fa523f5)();
const $2081d284af2f6844$var$_worldV1 = (0, $6b6a54a072724620$export$e7c866399fa523f5)();
const $2081d284af2f6844$var$_edge = (0, $6b6a54a072724620$export$e7c866399fa523f5)();
const $2081d284af2f6844$var$_edgeUnit = (0, $6b6a54a072724620$export$e7c866399fa523f5)();
const $2081d284af2f6844$var$_normal = (0, $6b6a54a072724620$export$e7c866399fa523f5)();
const $2081d284af2f6844$var$_closestEdgePoint = (0, $6b6a54a072724620$export$e7c866399fa523f5)();
const $2081d284af2f6844$var$_dist = (0, $6b6a54a072724620$export$e7c866399fa523f5)();
const $2081d284af2f6844$var$_worldVertex = (0, $6b6a54a072724620$export$e7c866399fa523f5)();
const $2081d284af2f6844$var$_worldDist = (0, $6b6a54a072724620$export$e7c866399fa523f5)();
function $2081d284af2f6844$export$61f0e84b03c18487(bodyA, shapeA, offsetA, _angleA, bodyB, shapeB, offsetB, angleB, justTest, circleRadius) {
    const circleShape = shapeA;
    const convexShape = shapeB;
    const cr = circleRadius ?? circleShape.radius;
    $2081d284af2f6844$var$_localCirclePos.set(offsetA).itoLocalFrame(offsetB, angleB);
    const vertices = convexShape.vertices;
    const normals = convexShape.axes;
    const numVertices = vertices.length;
    let normalIndex = -1;
    // Find the min separating edge
    let separation = -Number.MAX_VALUE;
    const radius = convexShape.boundingRadius + cr;
    for(let i = 0; i < numVertices; i++){
        $2081d284af2f6844$var$_r.set($2081d284af2f6844$var$_localCirclePos).isub(vertices[i]);
        const s = normals[i].dot($2081d284af2f6844$var$_r);
        if (s > radius) return null; // Early out
        if (s > separation) {
            separation = s;
            normalIndex = i;
        }
    }
    // Check edges first
    let found = -1;
    let minCandidateDistance = Number.MAX_VALUE;
    for(let i = normalIndex + numVertices - 1; i < normalIndex + numVertices + 2; i++){
        const v0 = vertices[i % numVertices];
        const n = normals[i % numVertices];
        // Get point on circle closest to the convex
        $2081d284af2f6844$var$_candidate.set(n).imul(-cr).iadd($2081d284af2f6844$var$_localCirclePos);
        if ((0, $0c8c1abaefcc6cf6$export$1bebc88c4be8f018)($2081d284af2f6844$var$_candidate, convexShape)) {
            $2081d284af2f6844$var$_candidateDist.set(v0).isub($2081d284af2f6844$var$_candidate);
            const candidateDistance = Math.abs($2081d284af2f6844$var$_candidateDist.dot(n));
            if (candidateDistance < minCandidateDistance) {
                minCandidateDistance = candidateDistance;
                found = i;
            }
        }
    }
    if (found !== -1) {
        if (justTest) return (0, $c6ded5357db9ac08$export$2dc323ef1a86e04b)();
        const v0 = vertices[found % numVertices];
        const v1 = vertices[(found + 1) % numVertices];
        $2081d284af2f6844$var$_worldV0.set(v0).itoGlobalFrame(offsetB, angleB);
        $2081d284af2f6844$var$_worldV1.set(v1).itoGlobalFrame(offsetB, angleB);
        $2081d284af2f6844$var$_edge.set($2081d284af2f6844$var$_worldV1).isub($2081d284af2f6844$var$_worldV0);
        $2081d284af2f6844$var$_edgeUnit.set($2081d284af2f6844$var$_edge).inormalize();
        // Get tangent (points out of the convex)
        $2081d284af2f6844$var$_normal.set($2081d284af2f6844$var$_edgeUnit).irotate90cw();
        // Get point on circle closest to convex
        $2081d284af2f6844$var$_candidate.set($2081d284af2f6844$var$_normal).imul(-cr).iadd(offsetA);
        $2081d284af2f6844$var$_closestEdgePoint.set($2081d284af2f6844$var$_normal).imul(minCandidateDistance).iadd($2081d284af2f6844$var$_candidate);
        const result = (0, $c6ded5357db9ac08$export$2dc323ef1a86e04b)();
        result.contacts.push({
            worldContactA: (0, $6b6a54a072724620$export$e7c866399fa523f5)($2081d284af2f6844$var$_candidate).isub(bodyA.position),
            worldContactB: (0, $6b6a54a072724620$export$e7c866399fa523f5)($2081d284af2f6844$var$_closestEdgePoint).isub(bodyB.position),
            normal: (0, $6b6a54a072724620$export$e7c866399fa523f5)($2081d284af2f6844$var$_candidate).isub(offsetA).inormalize(),
            depth: minCandidateDistance
        });
        return result;
    }
    // Check closest vertices
    if (cr > 0 && normalIndex !== -1) for(let i = normalIndex + numVertices; i < normalIndex + numVertices + 2; i++){
        const localVertex = vertices[i % numVertices];
        $2081d284af2f6844$var$_dist.set(localVertex).isub($2081d284af2f6844$var$_localCirclePos);
        if ($2081d284af2f6844$var$_dist.squaredMagnitude < cr * cr) {
            if (justTest) return (0, $c6ded5357db9ac08$export$2dc323ef1a86e04b)();
            $2081d284af2f6844$var$_worldVertex.set(localVertex).itoGlobalFrame(offsetB, angleB);
            $2081d284af2f6844$var$_worldDist.set($2081d284af2f6844$var$_worldVertex).isub(offsetA);
            $2081d284af2f6844$var$_normal.set($2081d284af2f6844$var$_worldDist).inormalize();
            const result = (0, $c6ded5357db9ac08$export$2dc323ef1a86e04b)();
            result.contacts.push({
                worldContactA: (0, $6b6a54a072724620$export$e7c866399fa523f5)($2081d284af2f6844$var$_normal).imul(cr).isub(bodyA.position).iadd(offsetA),
                worldContactB: (0, $6b6a54a072724620$export$e7c866399fa523f5)($2081d284af2f6844$var$_worldVertex).isub(bodyB.position),
                normal: (0, $6b6a54a072724620$export$e7c866399fa523f5)($2081d284af2f6844$var$_normal),
                depth: cr - $2081d284af2f6844$var$_worldDist.magnitude
            });
            return result;
        }
    }
    return null;
}





// Scratch arrays for polygon clipping
const $12f5e7419b0514b7$var$clipPoints1 = [
    (0, $6b6a54a072724620$export$e7c866399fa523f5)(),
    (0, $6b6a54a072724620$export$e7c866399fa523f5)()
];
const $12f5e7419b0514b7$var$clipPoints2 = [
    (0, $6b6a54a072724620$export$e7c866399fa523f5)(),
    (0, $6b6a54a072724620$export$e7c866399fa523f5)()
];
const $12f5e7419b0514b7$var$incidentEdgePoints = [
    (0, $6b6a54a072724620$export$e7c866399fa523f5)(),
    (0, $6b6a54a072724620$export$e7c866399fa523f5)()
];
const $12f5e7419b0514b7$var$maxManifoldPoints = 2;
// Scratch vectors to avoid per-call allocations
const $12f5e7419b0514b7$var$_separationA_out = (0, $6b6a54a072724620$export$e7c866399fa523f5)();
const $12f5e7419b0514b7$var$_separationB_out = (0, $6b6a54a072724620$export$e7c866399fa523f5)();
const $12f5e7419b0514b7$var$_v11 = (0, $6b6a54a072724620$export$e7c866399fa523f5)();
const $12f5e7419b0514b7$var$_v12 = (0, $6b6a54a072724620$export$e7c866399fa523f5)();
const $12f5e7419b0514b7$var$_localTangent = (0, $6b6a54a072724620$export$e7c866399fa523f5)();
const $12f5e7419b0514b7$var$_tangent = (0, $6b6a54a072724620$export$e7c866399fa523f5)();
const $12f5e7419b0514b7$var$_normal = (0, $6b6a54a072724620$export$e7c866399fa523f5)();
const $12f5e7419b0514b7$var$_negativeTangent = (0, $6b6a54a072724620$export$e7c866399fa523f5)();
const $12f5e7419b0514b7$var$_contactPointOnPoly2 = (0, $6b6a54a072724620$export$e7c866399fa523f5)();
const $12f5e7419b0514b7$var$_dist = (0, $6b6a54a072724620$export$e7c866399fa523f5)();
const $12f5e7419b0514b7$var$_contactPointOnPoly1 = (0, $6b6a54a072724620$export$e7c866399fa523f5)();
function $12f5e7419b0514b7$export$6f51f77cc14ca3e6(bodyA, shapeA, offsetA, angleA, bodyB, shapeB, offsetB, angleB, justTest) {
    const polyA = shapeA;
    const polyB = shapeB;
    const totalRadius = 0;
    const edgeA = (0, $0c8c1abaefcc6cf6$export$a580b18a8c59b6c1)($12f5e7419b0514b7$var$_separationA_out, polyA, offsetA, angleA, polyB, offsetB, angleB);
    const separationA = $12f5e7419b0514b7$var$_separationA_out[0];
    if (separationA > totalRadius) return null;
    const edgeB = (0, $0c8c1abaefcc6cf6$export$a580b18a8c59b6c1)($12f5e7419b0514b7$var$_separationB_out, polyB, offsetB, angleB, polyA, offsetA, angleA);
    const separationB = $12f5e7419b0514b7$var$_separationB_out[0];
    if (separationB > totalRadius) return null;
    let poly1;
    let poly2;
    let position1;
    let position2;
    let angle1;
    let angle2;
    let body1;
    let body2;
    let edge1;
    if (separationB > separationA) {
        poly1 = polyB;
        poly2 = polyA;
        body1 = bodyB;
        body2 = bodyA;
        position1 = offsetB;
        angle1 = angleB;
        position2 = offsetA;
        angle2 = angleA;
        edge1 = edgeB;
    } else {
        poly1 = polyA;
        poly2 = polyB;
        body1 = bodyA;
        body2 = bodyB;
        position1 = offsetA;
        angle1 = angleA;
        position2 = offsetB;
        angle2 = angleB;
        edge1 = edgeA;
    }
    (0, $0c8c1abaefcc6cf6$export$51cea0d50a4ecfc8)($12f5e7419b0514b7$var$incidentEdgePoints, poly1, position1, angle1, edge1, poly2, position2, angle2);
    const count1 = poly1.vertices.length;
    const vertices1 = poly1.vertices;
    const iv1 = edge1;
    const iv2 = edge1 + 1 < count1 ? edge1 + 1 : 0;
    $12f5e7419b0514b7$var$_v11.set(vertices1[iv1]);
    $12f5e7419b0514b7$var$_v12.set(vertices1[iv2]);
    $12f5e7419b0514b7$var$_localTangent.set($12f5e7419b0514b7$var$_v12).isub($12f5e7419b0514b7$var$_v11).inormalize();
    $12f5e7419b0514b7$var$_tangent.set($12f5e7419b0514b7$var$_localTangent).irotate(angle1);
    $12f5e7419b0514b7$var$_normal.set($12f5e7419b0514b7$var$_tangent).icrossVZ(1.0);
    $12f5e7419b0514b7$var$_v11.itoGlobalFrame(position1, angle1);
    $12f5e7419b0514b7$var$_v12.itoGlobalFrame(position1, angle1);
    // Face offset
    const frontOffset = $12f5e7419b0514b7$var$_normal.dot($12f5e7419b0514b7$var$_v11);
    // Side offsets
    const sideOffset1 = -$12f5e7419b0514b7$var$_tangent.dot($12f5e7419b0514b7$var$_v11) + totalRadius;
    const sideOffset2 = $12f5e7419b0514b7$var$_tangent.dot($12f5e7419b0514b7$var$_v12) + totalRadius;
    // Clip incident edge
    $12f5e7419b0514b7$var$_negativeTangent.set($12f5e7419b0514b7$var$_tangent).imul(-1);
    let np = (0, $0c8c1abaefcc6cf6$export$96d0049505ea342e)($12f5e7419b0514b7$var$clipPoints1, $12f5e7419b0514b7$var$incidentEdgePoints, $12f5e7419b0514b7$var$_negativeTangent, sideOffset1);
    if (np < 2) return null;
    np = (0, $0c8c1abaefcc6cf6$export$96d0049505ea342e)($12f5e7419b0514b7$var$clipPoints2, $12f5e7419b0514b7$var$clipPoints1, $12f5e7419b0514b7$var$_tangent, sideOffset2);
    if (np < 2) return null;
    const result = (0, $c6ded5357db9ac08$export$2dc323ef1a86e04b)();
    for(let i = 0; i < $12f5e7419b0514b7$var$maxManifoldPoints; i++){
        const separation = $12f5e7419b0514b7$var$_normal.dot($12f5e7419b0514b7$var$clipPoints2[i]) - frontOffset;
        if (separation <= totalRadius) {
            if (justTest) return (0, $c6ded5357db9ac08$export$2dc323ef1a86e04b)();
            $12f5e7419b0514b7$var$_contactPointOnPoly2.set($12f5e7419b0514b7$var$clipPoints2[i]);
            $12f5e7419b0514b7$var$_dist.set($12f5e7419b0514b7$var$_normal).imul(-separation);
            $12f5e7419b0514b7$var$_contactPointOnPoly1.set($12f5e7419b0514b7$var$clipPoints2[i]).iadd($12f5e7419b0514b7$var$_dist);
            result.contacts.push({
                worldContactA: (0, $6b6a54a072724620$export$e7c866399fa523f5)($12f5e7419b0514b7$var$_contactPointOnPoly1).isub(body1.position),
                worldContactB: (0, $6b6a54a072724620$export$e7c866399fa523f5)($12f5e7419b0514b7$var$_contactPointOnPoly2).isub(body2.position),
                normal: (0, $6b6a54a072724620$export$e7c866399fa523f5)($12f5e7419b0514b7$var$_normal),
                depth: -separation
            });
        }
    }
    if (result.contacts.length === 0) return null;
    // If bodies were swapped, swap the result back
    if (separationB > separationA) for (const contact of result.contacts){
        const temp = contact.worldContactA;
        contact.worldContactA = contact.worldContactB;
        contact.worldContactB = temp;
        contact.normal.imul(-1);
    }
    return result;
}


const $6818e2e66e50d778$var$capsuleMiddleRect = new (0, $7cebb72687875576$export$e71c4d32a2263218)({
    width: 1,
    height: 1
});
// Scratch vectors to avoid per-call allocations
const $6818e2e66e50d778$var$_circlePos1 = (0, $6b6a54a072724620$export$e7c866399fa523f5)();
const $6818e2e66e50d778$var$_circlePos2 = (0, $6b6a54a072724620$export$e7c866399fa523f5)();
function $6818e2e66e50d778$export$7cf2323b2d15d3a0(bodyA, shapeA, offsetA, angleA, bodyB, shapeB, offsetB, angleB, justTest) {
    const convexShape = shapeA;
    const capsuleShape = shapeB;
    const halfLength = capsuleShape.length / 2;
    // Check the end circles
    $6818e2e66e50d778$var$_circlePos1.set(halfLength, 0).itoGlobalFrame(offsetB, angleB);
    const result1 = (0, $2081d284af2f6844$export$61f0e84b03c18487)(bodyB, capsuleShape, $6818e2e66e50d778$var$_circlePos1, angleB, bodyA, convexShape, offsetA, angleA, justTest, capsuleShape.radius);
    $6818e2e66e50d778$var$_circlePos2.set(-halfLength, 0).itoGlobalFrame(offsetB, angleB);
    const result2 = (0, $2081d284af2f6844$export$61f0e84b03c18487)(bodyB, capsuleShape, $6818e2e66e50d778$var$_circlePos2, angleB, bodyA, convexShape, offsetA, angleA, justTest, capsuleShape.radius);
    if (justTest && (result1 || result2)) return (0, $c6ded5357db9ac08$export$2dc323ef1a86e04b)();
    // Check center rect
    (0, $0c8c1abaefcc6cf6$export$444559d296aa5afb)($6818e2e66e50d778$var$capsuleMiddleRect, capsuleShape);
    const result3 = (0, $12f5e7419b0514b7$export$6f51f77cc14ca3e6)(bodyA, convexShape, offsetA, angleA, bodyB, $6818e2e66e50d778$var$capsuleMiddleRect, offsetB, angleB, justTest);
    if (!result1 && !result2 && !result3) return null;
    if (justTest) return (0, $c6ded5357db9ac08$export$2dc323ef1a86e04b)();
    // Combine results, swapping contacts from circle-convex tests
    const result = (0, $c6ded5357db9ac08$export$2dc323ef1a86e04b)();
    if (result1) for (const contact of result1.contacts)result.contacts.push({
        worldContactA: contact.worldContactB,
        worldContactB: contact.worldContactA,
        normal: (0, $6b6a54a072724620$export$e7c866399fa523f5)(contact.normal).imul(-1),
        depth: contact.depth
    });
    if (result2) for (const contact of result2.contacts)result.contacts.push({
        worldContactA: contact.worldContactB,
        worldContactB: contact.worldContactA,
        normal: (0, $6b6a54a072724620$export$e7c866399fa523f5)(contact.normal).imul(-1),
        depth: contact.depth
    });
    if (result3) result.contacts.push(...result3.contacts);
    return result;
}


const $567eb89778a9e4a6$var$capsuleMiddleRect = new (0, $7cebb72687875576$export$e71c4d32a2263218)({
    width: 1,
    height: 1
});
const $567eb89778a9e4a6$var$capsuleMiddleRect2 = new (0, $7cebb72687875576$export$e71c4d32a2263218)({
    width: 1,
    height: 1
});
// Scratch vectors to avoid per-call allocations
const $567eb89778a9e4a6$var$_circlePosA = (0, $6b6a54a072724620$export$e7c866399fa523f5)();
const $567eb89778a9e4a6$var$_circlePosB = (0, $6b6a54a072724620$export$e7c866399fa523f5)();
function $567eb89778a9e4a6$export$c0e0f660f83dcbd8(bodyA, shapeA, offsetA, angleA, bodyB, shapeB, offsetB, angleB, justTest) {
    const capsuleA = shapeA;
    const capsuleB = shapeB;
    const result = (0, $c6ded5357db9ac08$export$2dc323ef1a86e04b)();
    // Need 4 circle checks between all endpoints
    for(let i = 0; i < 2; i++){
        $567eb89778a9e4a6$var$_circlePosA.set((i === 0 ? -1 : 1) * (capsuleA.length / 2), 0).itoGlobalFrame(offsetA, angleA);
        for(let j = 0; j < 2; j++){
            $567eb89778a9e4a6$var$_circlePosB.set((j === 0 ? -1 : 1) * (capsuleB.length / 2), 0).itoGlobalFrame(offsetB, angleB);
            const circleResult = (0, $24ffcd53ca5eb8b7$export$b85ee8633cdf5ab6)(bodyA, capsuleA, $567eb89778a9e4a6$var$_circlePosA, angleA, bodyB, capsuleB, $567eb89778a9e4a6$var$_circlePosB, angleB, justTest, capsuleA.radius, capsuleB.radius);
            if (justTest && circleResult) return (0, $c6ded5357db9ac08$export$2dc323ef1a86e04b)();
            if (circleResult) result.contacts.push(...circleResult.contacts);
        }
    }
    // Check circles against center boxes
    (0, $0c8c1abaefcc6cf6$export$444559d296aa5afb)($567eb89778a9e4a6$var$capsuleMiddleRect, capsuleA);
    const rect1Result = (0, $6818e2e66e50d778$export$7cf2323b2d15d3a0)(bodyA, $567eb89778a9e4a6$var$capsuleMiddleRect, offsetA, angleA, bodyB, capsuleB, offsetB, angleB, justTest);
    if (justTest && rect1Result) return (0, $c6ded5357db9ac08$export$2dc323ef1a86e04b)();
    if (rect1Result) result.contacts.push(...rect1Result.contacts);
    (0, $0c8c1abaefcc6cf6$export$444559d296aa5afb)($567eb89778a9e4a6$var$capsuleMiddleRect2, capsuleB);
    const rect2Result = (0, $6818e2e66e50d778$export$7cf2323b2d15d3a0)(bodyB, $567eb89778a9e4a6$var$capsuleMiddleRect2, offsetB, angleB, bodyA, capsuleA, offsetA, angleA, justTest);
    if (justTest && rect2Result) return (0, $c6ded5357db9ac08$export$2dc323ef1a86e04b)();
    if (rect2Result) // Swap contacts since we called with swapped bodies
    for (const contact of rect2Result.contacts)result.contacts.push({
        worldContactA: contact.worldContactB,
        worldContactB: contact.worldContactA,
        normal: (0, $6b6a54a072724620$export$e7c866399fa523f5)(contact.normal).imul(-1),
        depth: contact.depth
    });
    if (result.contacts.length === 0) return null;
    return result;
}




// Scratch vectors to avoid per-call allocations
const $799b21ef67e3d5bc$var$_lineStart = (0, $6b6a54a072724620$export$e7c866399fa523f5)();
const $799b21ef67e3d5bc$var$_lineEnd = (0, $6b6a54a072724620$export$e7c866399fa523f5)();
const $799b21ef67e3d5bc$var$_lineEdge = (0, $6b6a54a072724620$export$e7c866399fa523f5)();
const $799b21ef67e3d5bc$var$_lineEdgeUnit = (0, $6b6a54a072724620$export$e7c866399fa523f5)();
const $799b21ef67e3d5bc$var$_lineTangent = (0, $6b6a54a072724620$export$e7c866399fa523f5)();
const $799b21ef67e3d5bc$var$_circleToLineStart = (0, $6b6a54a072724620$export$e7c866399fa523f5)();
const $799b21ef67e3d5bc$var$_orthoDist = (0, $6b6a54a072724620$export$e7c866399fa523f5)();
const $799b21ef67e3d5bc$var$_projectedPoint = (0, $6b6a54a072724620$export$e7c866399fa523f5)();
const $799b21ef67e3d5bc$var$_lineToCircle = (0, $6b6a54a072724620$export$e7c866399fa523f5)();
const $799b21ef67e3d5bc$var$_lineToCircleOrtho = (0, $6b6a54a072724620$export$e7c866399fa523f5)();
const $799b21ef67e3d5bc$var$_normal = (0, $6b6a54a072724620$export$e7c866399fa523f5)();
const $799b21ef67e3d5bc$var$_contactOnCircle = (0, $6b6a54a072724620$export$e7c866399fa523f5)();
const $799b21ef67e3d5bc$var$_contactOnLine = (0, $6b6a54a072724620$export$e7c866399fa523f5)();
const $799b21ef67e3d5bc$var$_dist = (0, $6b6a54a072724620$export$e7c866399fa523f5)();
function $799b21ef67e3d5bc$export$b59bd4edcf048b1(bodyA, shapeA, offsetA, _angleA, bodyB, shapeB, offsetB, angleB, justTest, lineRadius, circleRadius) {
    const circleShape = shapeA;
    const lineShape = shapeB;
    const lr = lineRadius ?? 0;
    const cr = circleRadius ?? circleShape.radius;
    const halfLineLength = lineShape.length / 2;
    // Get line endpoints in world space
    $799b21ef67e3d5bc$var$_lineStart.set(-halfLineLength, 0).itoGlobalFrame(offsetB, angleB);
    $799b21ef67e3d5bc$var$_lineEnd.set(halfLineLength, 0).itoGlobalFrame(offsetB, angleB);
    // Get vector along the line
    $799b21ef67e3d5bc$var$_lineEdge.set($799b21ef67e3d5bc$var$_lineEnd).isub($799b21ef67e3d5bc$var$_lineStart);
    $799b21ef67e3d5bc$var$_lineEdgeUnit.set($799b21ef67e3d5bc$var$_lineEdge).inormalize();
    // Get tangent to the edge (perpendicular, pointing away from line)
    $799b21ef67e3d5bc$var$_lineTangent.set($799b21ef67e3d5bc$var$_lineEdgeUnit).irotate90cw();
    // Check distance from the plane spanned by the edge vs the circle
    $799b21ef67e3d5bc$var$_circleToLineStart.set(offsetA).isub($799b21ef67e3d5bc$var$_lineStart);
    const perpDistance = $799b21ef67e3d5bc$var$_circleToLineStart.dot($799b21ef67e3d5bc$var$_lineTangent);
    const radiusSum = cr + lr;
    if (Math.abs(perpDistance) < radiusSum) {
        // Project circle center onto the line
        $799b21ef67e3d5bc$var$_orthoDist.set($799b21ef67e3d5bc$var$_lineTangent).imul(perpDistance);
        $799b21ef67e3d5bc$var$_projectedPoint.set(offsetA).isub($799b21ef67e3d5bc$var$_orthoDist);
        // Add the line radius offset
        $799b21ef67e3d5bc$var$_lineToCircle.set(offsetA).isub(offsetB);
        $799b21ef67e3d5bc$var$_lineToCircleOrtho.set($799b21ef67e3d5bc$var$_lineTangent).imul($799b21ef67e3d5bc$var$_lineTangent.dot($799b21ef67e3d5bc$var$_lineToCircle));
        $799b21ef67e3d5bc$var$_lineToCircleOrtho.inormalize().imul(lr);
        $799b21ef67e3d5bc$var$_projectedPoint.iadd($799b21ef67e3d5bc$var$_lineToCircleOrtho);
        // Check if the point is within the edge span
        const pos = $799b21ef67e3d5bc$var$_lineEdgeUnit.dot($799b21ef67e3d5bc$var$_projectedPoint);
        const pos0 = $799b21ef67e3d5bc$var$_lineEdgeUnit.dot($799b21ef67e3d5bc$var$_lineStart);
        const pos1 = $799b21ef67e3d5bc$var$_lineEdgeUnit.dot($799b21ef67e3d5bc$var$_lineEnd);
        if (pos > pos0 && pos < pos1) {
            if (justTest) return (0, $c6ded5357db9ac08$export$2dc323ef1a86e04b)();
            $799b21ef67e3d5bc$var$_normal.set($799b21ef67e3d5bc$var$_orthoDist).imul(-1).inormalize();
            // Contact point on circle
            $799b21ef67e3d5bc$var$_contactOnCircle.set($799b21ef67e3d5bc$var$_normal).imul(cr).iadd(offsetA);
            // Contact point on line
            $799b21ef67e3d5bc$var$_contactOnLine.set($799b21ef67e3d5bc$var$_projectedPoint);
            const result = (0, $c6ded5357db9ac08$export$2dc323ef1a86e04b)();
            result.contacts.push({
                worldContactA: (0, $6b6a54a072724620$export$e7c866399fa523f5)($799b21ef67e3d5bc$var$_contactOnCircle).isub(bodyA.position),
                worldContactB: (0, $6b6a54a072724620$export$e7c866399fa523f5)($799b21ef67e3d5bc$var$_contactOnLine).isub(bodyB.position),
                normal: (0, $6b6a54a072724620$export$e7c866399fa523f5)($799b21ef67e3d5bc$var$_normal),
                depth: radiusSum - Math.abs(perpDistance)
            });
            return result;
        }
    }
    // Check corners (line endpoints)
    const endpoints = [
        $799b21ef67e3d5bc$var$_lineStart,
        $799b21ef67e3d5bc$var$_lineEnd
    ];
    for (const endpoint of endpoints){
        $799b21ef67e3d5bc$var$_dist.set(endpoint).isub(offsetA);
        if ($799b21ef67e3d5bc$var$_dist.squaredMagnitude < radiusSum * radiusSum) {
            if (justTest) return (0, $c6ded5357db9ac08$export$2dc323ef1a86e04b)();
            $799b21ef67e3d5bc$var$_normal.set($799b21ef67e3d5bc$var$_dist).inormalize();
            // Contact point on circle
            $799b21ef67e3d5bc$var$_contactOnCircle.set($799b21ef67e3d5bc$var$_normal).imul(cr).iadd(offsetA);
            // Contact point on line endpoint (with line radius offset)
            $799b21ef67e3d5bc$var$_contactOnLine.set(endpoint).iadd((0, $6b6a54a072724620$export$e7c866399fa523f5)($799b21ef67e3d5bc$var$_normal).imul(-lr));
            const result = (0, $c6ded5357db9ac08$export$2dc323ef1a86e04b)();
            result.contacts.push({
                worldContactA: (0, $6b6a54a072724620$export$e7c866399fa523f5)($799b21ef67e3d5bc$var$_contactOnCircle).isub(bodyA.position),
                worldContactB: (0, $6b6a54a072724620$export$e7c866399fa523f5)($799b21ef67e3d5bc$var$_contactOnLine).isub(bodyB.position),
                normal: (0, $6b6a54a072724620$export$e7c866399fa523f5)($799b21ef67e3d5bc$var$_normal),
                depth: radiusSum - $799b21ef67e3d5bc$var$_dist.magnitude
            });
            return result;
        }
    }
    return null;
}


function $b96968a114780dde$export$dad532846b0c06fb(bodyA, shapeA, offsetA, angleA, bodyB, shapeB, offsetB, angleB, justTest) {
    const capsuleShape = shapeB;
    return (0, $799b21ef67e3d5bc$export$b59bd4edcf048b1)(bodyA, shapeA, offsetA, angleA, bodyB, shapeB, offsetB, angleB, justTest, capsuleShape.radius);
}






// Scratch vectors to avoid per-call allocations
const $1eafd6ca9597bb65$var$_v0 = (0, $6b6a54a072724620$export$e7c866399fa523f5)();
const $1eafd6ca9597bb65$var$_v1 = (0, $6b6a54a072724620$export$e7c866399fa523f5)();
const $1eafd6ca9597bb65$var$_edgeNormal = (0, $6b6a54a072724620$export$e7c866399fa523f5)();
const $1eafd6ca9597bb65$var$_candidate = (0, $6b6a54a072724620$export$e7c866399fa523f5)();
const $1eafd6ca9597bb65$var$_dist = (0, $6b6a54a072724620$export$e7c866399fa523f5)();
const $1eafd6ca9597bb65$var$_projectedPoint = (0, $6b6a54a072724620$export$e7c866399fa523f5)();
const $1eafd6ca9597bb65$var$_normal = (0, $6b6a54a072724620$export$e7c866399fa523f5)();
function $1eafd6ca9597bb65$export$2df3a9fca926f682(bodyA, shapeA, offsetA, _angleA, bodyB, shapeB, offsetB, _angleB, justTest, radius) {
    const circleShape = shapeA;
    const hfShape = shapeB;
    const data = hfShape.heights;
    const r = radius ?? circleShape.radius;
    const w = hfShape.elementWidth;
    // Get the index of the points to test against
    let idxA = Math.floor((offsetA[0] - r - offsetB[0]) / w);
    let idxB = Math.ceil((offsetA[0] + r - offsetB[0]) / w);
    if (idxA < 0) idxA = 0;
    if (idxB >= data.length) idxB = data.length - 1;
    // Get max height in range
    let max = data[idxA];
    for(let i = idxA; i < idxB; i++)if (data[i] > max) max = data[i];
    if (offsetA[1] - r > max + offsetB[1]) return null;
    const result = (0, $c6ded5357db9ac08$export$2dc323ef1a86e04b)();
    // Check all edges
    for(let i = idxA; i < idxB; i++){
        $1eafd6ca9597bb65$var$_v0.set(i * w + offsetB[0], data[i] + offsetB[1]);
        $1eafd6ca9597bb65$var$_v1.set((i + 1) * w + offsetB[0], data[i + 1] + offsetB[1]);
        // Get normal (perpendicular to edge, pointing up/out)
        $1eafd6ca9597bb65$var$_edgeNormal.set($1eafd6ca9597bb65$var$_v1).isub($1eafd6ca9597bb65$var$_v0).irotate(Math.PI / 2).inormalize();
        // Get point on circle closest to the edge
        $1eafd6ca9597bb65$var$_candidate.set($1eafd6ca9597bb65$var$_edgeNormal).imul(-r).iadd(offsetA);
        // Distance from v0 to candidate point
        $1eafd6ca9597bb65$var$_dist.set($1eafd6ca9597bb65$var$_candidate).isub($1eafd6ca9597bb65$var$_v0);
        // Check if it is in the element "stick"
        const d = $1eafd6ca9597bb65$var$_dist.dot($1eafd6ca9597bb65$var$_edgeNormal);
        if ($1eafd6ca9597bb65$var$_candidate[0] >= $1eafd6ca9597bb65$var$_v0[0] && $1eafd6ca9597bb65$var$_candidate[0] < $1eafd6ca9597bb65$var$_v1[0] && d <= 0) {
            if (justTest) return (0, $c6ded5357db9ac08$export$2dc323ef1a86e04b)();
            // Project candidate to edge
            $1eafd6ca9597bb65$var$_projectedPoint.set($1eafd6ca9597bb65$var$_edgeNormal).imul(-d).iadd($1eafd6ca9597bb65$var$_candidate);
            result.contacts.push({
                worldContactA: (0, $6b6a54a072724620$export$e7c866399fa523f5)($1eafd6ca9597bb65$var$_edgeNormal).imul(-r).isub(bodyA.position).iadd(offsetA),
                worldContactB: (0, $6b6a54a072724620$export$e7c866399fa523f5)($1eafd6ca9597bb65$var$_projectedPoint).isub(bodyB.position),
                normal: (0, $6b6a54a072724620$export$e7c866399fa523f5)($1eafd6ca9597bb65$var$_edgeNormal),
                depth: -d
            });
        }
    }
    // Check all vertices
    if (r > 0) for(let i = idxA; i <= idxB; i++){
        $1eafd6ca9597bb65$var$_v0.set(i * w + offsetB[0], data[i] + offsetB[1]);
        $1eafd6ca9597bb65$var$_dist.set(offsetA).isub($1eafd6ca9597bb65$var$_v0);
        if ($1eafd6ca9597bb65$var$_dist.squaredMagnitude < r * r) {
            if (justTest) return (0, $c6ded5357db9ac08$export$2dc323ef1a86e04b)();
            $1eafd6ca9597bb65$var$_normal.set($1eafd6ca9597bb65$var$_dist).inormalize();
            result.contacts.push({
                worldContactA: (0, $6b6a54a072724620$export$e7c866399fa523f5)($1eafd6ca9597bb65$var$_normal).imul(-r).isub(bodyA.position).iadd(offsetA),
                worldContactB: (0, $6b6a54a072724620$export$e7c866399fa523f5)($1eafd6ca9597bb65$var$_v0).isub(bodyB.position),
                normal: (0, $6b6a54a072724620$export$e7c866399fa523f5)($1eafd6ca9597bb65$var$_normal),
                depth: r - $1eafd6ca9597bb65$var$_dist.magnitude
            });
        }
    }
    if (result.contacts.length === 0) return null;
    return result;
}



function $fee1cc527301c8c7$export$8ea4088d83da32bd(bodyA, shapeA, offsetA, angleA, bodyB, shapeB, offsetB, angleB, justTest) {
    const capsuleShape = shapeB;
    return (0, $799b21ef67e3d5bc$export$b59bd4edcf048b1)(bodyA, shapeA, offsetA, angleA, bodyB, shapeB, offsetB, angleB, justTest);
}




// Scratch vectors to avoid per-call allocations
const $32285f3aa0b1dd1c$var$_particleToCircle = (0, $6b6a54a072724620$export$e7c866399fa523f5)();
const $32285f3aa0b1dd1c$var$_normal = (0, $6b6a54a072724620$export$e7c866399fa523f5)();
const $32285f3aa0b1dd1c$var$_contactOnCircle = (0, $6b6a54a072724620$export$e7c866399fa523f5)();
function $32285f3aa0b1dd1c$export$99d5208211e738af(bodyA, shapeA, offsetA, _angleA, bodyB, _shapeB, offsetB, _angleB, justTest) {
    const circleShape = shapeA;
    const circleRadius = circleShape.radius;
    $32285f3aa0b1dd1c$var$_particleToCircle.set(offsetB).isub(offsetA);
    if ($32285f3aa0b1dd1c$var$_particleToCircle.squaredMagnitude > circleRadius * circleRadius) return null;
    if (justTest) return (0, $c6ded5357db9ac08$export$2dc323ef1a86e04b)();
    $32285f3aa0b1dd1c$var$_normal.set($32285f3aa0b1dd1c$var$_particleToCircle).inormalize();
    // Contact point on circle surface
    $32285f3aa0b1dd1c$var$_contactOnCircle.set($32285f3aa0b1dd1c$var$_normal).imul(circleRadius).iadd(offsetA);
    const result = (0, $c6ded5357db9ac08$export$2dc323ef1a86e04b)();
    result.contacts.push({
        worldContactA: (0, $6b6a54a072724620$export$e7c866399fa523f5)($32285f3aa0b1dd1c$var$_contactOnCircle).isub(bodyA.position),
        worldContactB: (0, $6b6a54a072724620$export$e7c866399fa523f5)(offsetB).isub(bodyB.position),
        normal: (0, $6b6a54a072724620$export$e7c866399fa523f5)($32285f3aa0b1dd1c$var$_normal),
        depth: circleRadius - $32285f3aa0b1dd1c$var$_particleToCircle.magnitude
    });
    return result;
}




const $8868f2ef5e4af8d0$var$yAxis = (0, $6b6a54a072724620$export$e7c866399fa523f5)(0, 1);
// Scratch vectors to avoid per-call allocations
const $8868f2ef5e4af8d0$var$_circleToPlane = (0, $6b6a54a072724620$export$e7c866399fa523f5)();
const $8868f2ef5e4af8d0$var$_planeNormal = (0, $6b6a54a072724620$export$e7c866399fa523f5)();
const $8868f2ef5e4af8d0$var$_contactOnCircle = (0, $6b6a54a072724620$export$e7c866399fa523f5)();
const $8868f2ef5e4af8d0$var$_projectionOffset = (0, $6b6a54a072724620$export$e7c866399fa523f5)();
const $8868f2ef5e4af8d0$var$_contactOnPlane = (0, $6b6a54a072724620$export$e7c866399fa523f5)();
function $8868f2ef5e4af8d0$export$a980cf319e1f1872(bodyA, shapeA, offsetA, _angleA, bodyB, _shapeB, offsetB, angleB, justTest) {
    // Note: bodyA is circle, bodyB is plane
    const circleShape = shapeA;
    const circleRadius = circleShape.radius;
    $8868f2ef5e4af8d0$var$_circleToPlane.set(offsetA).isub(offsetB);
    $8868f2ef5e4af8d0$var$_planeNormal.set($8868f2ef5e4af8d0$var$yAxis).irotate(angleB);
    const distance = $8868f2ef5e4af8d0$var$_circleToPlane.dot($8868f2ef5e4af8d0$var$_planeNormal);
    if (distance > circleRadius) return null;
    if (justTest) return (0, $c6ded5357db9ac08$export$2dc323ef1a86e04b)();
    // Contact point on circle surface (towards plane)
    $8868f2ef5e4af8d0$var$_contactOnCircle.set($8868f2ef5e4af8d0$var$_planeNormal).imul(-circleRadius).iadd(offsetA);
    // Contact point on plane
    $8868f2ef5e4af8d0$var$_projectionOffset.set($8868f2ef5e4af8d0$var$_planeNormal).imul(distance);
    $8868f2ef5e4af8d0$var$_contactOnPlane.set($8868f2ef5e4af8d0$var$_circleToPlane).isub($8868f2ef5e4af8d0$var$_projectionOffset).iadd(offsetB);
    const result = (0, $c6ded5357db9ac08$export$2dc323ef1a86e04b)();
    result.contacts.push({
        worldContactA: (0, $6b6a54a072724620$export$e7c866399fa523f5)($8868f2ef5e4af8d0$var$_contactOnCircle).isub(bodyA.position),
        worldContactB: (0, $6b6a54a072724620$export$e7c866399fa523f5)($8868f2ef5e4af8d0$var$_contactOnPlane).isub(bodyB.position),
        normal: (0, $6b6a54a072724620$export$e7c866399fa523f5)($8868f2ef5e4af8d0$var$_planeNormal).imul(-1),
        depth: circleRadius - distance
    });
    return result;
}








// Reusable convex for heightfield tiles
const $9224f3ad983aed03$var$heightfieldTileConvex = new (0, $6ae562c24c0aa510$export$bc1767a8c6770562)({
    vertices: [
        (0, $6b6a54a072724620$export$e7c866399fa523f5)(),
        (0, $6b6a54a072724620$export$e7c866399fa523f5)(),
        (0, $6b6a54a072724620$export$e7c866399fa523f5)(),
        (0, $6b6a54a072724620$export$e7c866399fa523f5)()
    ]
});
// Scratch vectors to avoid per-call allocations
const $9224f3ad983aed03$var$_v0 = (0, $6b6a54a072724620$export$e7c866399fa523f5)();
const $9224f3ad983aed03$var$_v1 = (0, $6b6a54a072724620$export$e7c866399fa523f5)();
const $9224f3ad983aed03$var$_tilePos = (0, $6b6a54a072724620$export$e7c866399fa523f5)();
function $9224f3ad983aed03$export$115add4fc7de6aba(bodyA, shapeA, offsetA, angleA, bodyB, shapeB, offsetB, _angleB, justTest) {
    const convexShape = shapeA;
    const hfShape = shapeB;
    const data = hfShape.heights;
    const w = hfShape.elementWidth;
    // Use body's AABB to get index range
    const aabb = bodyA.aabb;
    let idxA = Math.floor((aabb.lowerBound[0] - offsetB[0]) / w);
    let idxB = Math.ceil((aabb.upperBound[0] - offsetB[0]) / w);
    if (idxA < 0) idxA = 0;
    if (idxB >= data.length) idxB = data.length - 1;
    // Get max height in range
    let max = data[idxA];
    for(let i = idxA; i < idxB; i++)if (data[i] > max) max = data[i];
    if (aabb.lowerBound[1] > max + offsetB[1]) return null;
    const result = (0, $c6ded5357db9ac08$export$2dc323ef1a86e04b)();
    // Loop over all edges
    for(let i = idxA; i < idxB; i++){
        $9224f3ad983aed03$var$_v0.set(i * w + offsetB[0], data[i] + offsetB[1]);
        $9224f3ad983aed03$var$_v1.set((i + 1) * w + offsetB[0], data[i + 1] + offsetB[1]);
        // Construct a convex tile
        const tileHeight = 100;
        $9224f3ad983aed03$var$_tilePos.set(($9224f3ad983aed03$var$_v1[0] + $9224f3ad983aed03$var$_v0[0]) * 0.5, ($9224f3ad983aed03$var$_v1[1] + $9224f3ad983aed03$var$_v0[1] - tileHeight) * 0.5);
        $9224f3ad983aed03$var$heightfieldTileConvex.vertices[0].set($9224f3ad983aed03$var$_v1).isub($9224f3ad983aed03$var$_tilePos);
        $9224f3ad983aed03$var$heightfieldTileConvex.vertices[1].set($9224f3ad983aed03$var$_v0).isub($9224f3ad983aed03$var$_tilePos);
        $9224f3ad983aed03$var$heightfieldTileConvex.vertices[2].set($9224f3ad983aed03$var$heightfieldTileConvex.vertices[1]);
        $9224f3ad983aed03$var$heightfieldTileConvex.vertices[3].set($9224f3ad983aed03$var$heightfieldTileConvex.vertices[0]);
        $9224f3ad983aed03$var$heightfieldTileConvex.vertices[2][1] -= tileHeight;
        $9224f3ad983aed03$var$heightfieldTileConvex.vertices[3][1] -= tileHeight;
        // Update normals for the tile
        for(let j = 0; j < 4; j++){
            const v0j = $9224f3ad983aed03$var$heightfieldTileConvex.vertices[j];
            const v1j = $9224f3ad983aed03$var$heightfieldTileConvex.vertices[(j + 1) % 4];
            $9224f3ad983aed03$var$heightfieldTileConvex.axes[j].set(v1j).isub(v0j);
            $9224f3ad983aed03$var$heightfieldTileConvex.axes[j].irotate90cw();
            $9224f3ad983aed03$var$heightfieldTileConvex.axes[j].inormalize();
        }
        // Do convex collision
        const tileResult = (0, $12f5e7419b0514b7$export$6f51f77cc14ca3e6)(bodyA, convexShape, offsetA, angleA, bodyB, $9224f3ad983aed03$var$heightfieldTileConvex, $9224f3ad983aed03$var$_tilePos, 0, justTest);
        if (justTest && tileResult) return (0, $c6ded5357db9ac08$export$2dc323ef1a86e04b)();
        if (tileResult) result.contacts.push(...tileResult.contacts);
    }
    if (result.contacts.length === 0) return null;
    return result;
}



function $f3f4231dea551833$export$79ea493cd09eddd6(bodyA, shapeA, offsetA, angleA, bodyB, shapeB, offsetB, angleB, justTest) {
    const capsuleShape = shapeB;
    return (0, $799b21ef67e3d5bc$export$b59bd4edcf048b1)(bodyA, shapeA, offsetA, angleA, bodyB, shapeB, offsetB, angleB, justTest, capsuleShape.radius, 0);
}





// Scratch vectors to avoid per-call allocations
const $57729e839e3a46e6$var$_closestPoint = (0, $6b6a54a072724620$export$e7c866399fa523f5)();
const $57729e839e3a46e6$var$_closestNormal = (0, $6b6a54a072724620$export$e7c866399fa523f5)();
const $57729e839e3a46e6$var$_worldV0 = (0, $6b6a54a072724620$export$e7c866399fa523f5)();
const $57729e839e3a46e6$var$_worldV1 = (0, $6b6a54a072724620$export$e7c866399fa523f5)();
const $57729e839e3a46e6$var$_edge = (0, $6b6a54a072724620$export$e7c866399fa523f5)();
const $57729e839e3a46e6$var$_edgeUnit = (0, $6b6a54a072724620$export$e7c866399fa523f5)();
const $57729e839e3a46e6$var$_tangent = (0, $6b6a54a072724620$export$e7c866399fa523f5)();
const $57729e839e3a46e6$var$_vertToParticle = (0, $6b6a54a072724620$export$e7c866399fa523f5)();
function $57729e839e3a46e6$export$a87fb97eac1527a3(bodyA, _shapeA, offsetA, _angleA, bodyB, shapeB, offsetB, angleB, justTest) {
    // Note: bodyA is particle, bodyB is convex
    const convexShape = shapeB;
    const verts = convexShape.vertices;
    // Check if particle is inside polygon
    if (!(0, $0c8c1abaefcc6cf6$export$26ff2e69979f5b7c)(offsetA, convexShape, offsetB, angleB)) return null;
    if (justTest) return (0, $c6ded5357db9ac08$export$2dc323ef1a86e04b)();
    // Find closest edge
    let minDistance = Number.MAX_VALUE;
    for(let i = 0; i < verts.length; i++){
        const v0 = verts[i];
        const v1 = verts[(i + 1) % verts.length];
        // Transform vertices to world
        $57729e839e3a46e6$var$_worldV0.set(v0).irotate(angleB).iadd(offsetB);
        $57729e839e3a46e6$var$_worldV1.set(v1).irotate(angleB).iadd(offsetB);
        // Get world edge
        $57729e839e3a46e6$var$_edge.set($57729e839e3a46e6$var$_worldV1).isub($57729e839e3a46e6$var$_worldV0);
        $57729e839e3a46e6$var$_edgeUnit.set($57729e839e3a46e6$var$_edge).inormalize();
        // Get tangent (points out of the convex)
        $57729e839e3a46e6$var$_tangent.set($57729e839e3a46e6$var$_edgeUnit).irotate90cw();
        $57729e839e3a46e6$var$_vertToParticle.set($57729e839e3a46e6$var$_worldV0).isub(offsetA);
        const distance = Math.abs($57729e839e3a46e6$var$_vertToParticle.dot($57729e839e3a46e6$var$_tangent));
        if (distance < minDistance) {
            minDistance = distance;
            $57729e839e3a46e6$var$_closestPoint.set($57729e839e3a46e6$var$_tangent).imul(distance).iadd(offsetA);
            $57729e839e3a46e6$var$_closestNormal.set($57729e839e3a46e6$var$_tangent);
        }
    }
    const result = (0, $c6ded5357db9ac08$export$2dc323ef1a86e04b)();
    result.contacts.push({
        worldContactA: (0, $6b6a54a072724620$export$e7c866399fa523f5)(offsetA).isub(bodyA.position),
        worldContactB: (0, $6b6a54a072724620$export$e7c866399fa523f5)($57729e839e3a46e6$var$_closestPoint).isub(bodyB.position),
        normal: (0, $6b6a54a072724620$export$e7c866399fa523f5)($57729e839e3a46e6$var$_closestNormal).imul(-1),
        depth: minDistance
    });
    return result;
}




const $476c218c0f3d5149$var$yAxis = (0, $6b6a54a072724620$export$e7c866399fa523f5)(0, 1);
// Scratch vectors to avoid per-call allocations
const $476c218c0f3d5149$var$_particleToPlane = (0, $6b6a54a072724620$export$e7c866399fa523f5)();
const $476c218c0f3d5149$var$_planeNormal = (0, $6b6a54a072724620$export$e7c866399fa523f5)();
const $476c218c0f3d5149$var$_projectionOffset = (0, $6b6a54a072724620$export$e7c866399fa523f5)();
const $476c218c0f3d5149$var$_contactOnPlane = (0, $6b6a54a072724620$export$e7c866399fa523f5)();
function $476c218c0f3d5149$export$48f1b22f9cf873f7(bodyA, _shapeA, offsetA, _angleA, bodyB, _shapeB, offsetB, angleB, justTest) {
    // Note: bodyA is particle, bodyB is plane
    $476c218c0f3d5149$var$_particleToPlane.set(offsetA).isub(offsetB);
    $476c218c0f3d5149$var$_planeNormal.set($476c218c0f3d5149$var$yAxis).irotate(angleB);
    const distance = $476c218c0f3d5149$var$_particleToPlane.dot($476c218c0f3d5149$var$_planeNormal);
    if (distance > 0) return null;
    if (justTest) return (0, $c6ded5357db9ac08$export$2dc323ef1a86e04b)();
    // Project particle onto plane
    $476c218c0f3d5149$var$_projectionOffset.set($476c218c0f3d5149$var$_planeNormal).imul(distance);
    $476c218c0f3d5149$var$_contactOnPlane.set(offsetA).isub($476c218c0f3d5149$var$_projectionOffset);
    const result = (0, $c6ded5357db9ac08$export$2dc323ef1a86e04b)();
    // Note: Normal points out of plane (bodyB), so we need to flip for bodyA
    result.contacts.push({
        worldContactA: (0, $6b6a54a072724620$export$e7c866399fa523f5)(offsetA).isub(bodyA.position),
        worldContactB: (0, $6b6a54a072724620$export$e7c866399fa523f5)($476c218c0f3d5149$var$_contactOnPlane).isub(bodyB.position),
        normal: (0, $6b6a54a072724620$export$e7c866399fa523f5)($476c218c0f3d5149$var$_planeNormal).imul(-1),
        depth: -distance
    });
    return result;
}






const $64dd194f1bf0b593$var$tempCircle = new (0, $45a22be5c0ab570f$export$c89a927ffc67e6fa)({
    radius: 1
});
// Scratch vectors to avoid per-call allocations
const $64dd194f1bf0b593$var$_end1 = (0, $6b6a54a072724620$export$e7c866399fa523f5)();
const $64dd194f1bf0b593$var$_end2 = (0, $6b6a54a072724620$export$e7c866399fa523f5)();
function $64dd194f1bf0b593$export$185e5ece20541eb3(bodyA, shapeA, offsetA, angleA, bodyB, shapeB, offsetB, angleB, justTest) {
    // Note: bodyA is plane, bodyB is capsule
    const capsuleShape = shapeB;
    const halfLength = capsuleShape.length / 2;
    // Compute world end positions
    $64dd194f1bf0b593$var$_end1.set(-halfLength, 0).itoGlobalFrame(offsetB, angleB);
    $64dd194f1bf0b593$var$_end2.set(halfLength, 0).itoGlobalFrame(offsetB, angleB);
    $64dd194f1bf0b593$var$tempCircle.radius = capsuleShape.radius;
    // Check both ends against the plane
    const result1 = (0, $8868f2ef5e4af8d0$export$a980cf319e1f1872)(bodyB, $64dd194f1bf0b593$var$tempCircle, $64dd194f1bf0b593$var$_end1, 0, bodyA, shapeA, offsetA, angleA, justTest);
    const result2 = (0, $8868f2ef5e4af8d0$export$a980cf319e1f1872)(bodyB, $64dd194f1bf0b593$var$tempCircle, $64dd194f1bf0b593$var$_end2, 0, bodyA, shapeA, offsetA, angleA, justTest);
    if (!result1 && !result2) return null;
    if (justTest) return (0, $c6ded5357db9ac08$export$2dc323ef1a86e04b)();
    // Combine results, swapping A and B since we called with swapped order
    const result = (0, $c6ded5357db9ac08$export$2dc323ef1a86e04b)();
    if (result1) for (const contact of result1.contacts)result.contacts.push({
        worldContactA: contact.worldContactB,
        worldContactB: contact.worldContactA,
        normal: (0, $6b6a54a072724620$export$e7c866399fa523f5)(contact.normal).imul(-1),
        depth: contact.depth
    });
    if (result2) for (const contact of result2.contacts)result.contacts.push({
        worldContactA: contact.worldContactB,
        worldContactB: contact.worldContactA,
        normal: (0, $6b6a54a072724620$export$e7c866399fa523f5)(contact.normal).imul(-1),
        depth: contact.depth
    });
    return result;
}




const $027759db8f1f11a7$var$yAxis = (0, $6b6a54a072724620$export$e7c866399fa523f5)(0, 1);
// Scratch vectors to avoid per-call allocations
const $027759db8f1f11a7$var$_planeNormal = (0, $6b6a54a072724620$export$e7c866399fa523f5)();
const $027759db8f1f11a7$var$_localPlaneNormal = (0, $6b6a54a072724620$export$e7c866399fa523f5)();
const $027759db8f1f11a7$var$_localPlaneOffset = (0, $6b6a54a072724620$export$e7c866399fa523f5)();
const $027759db8f1f11a7$var$_localDist = (0, $6b6a54a072724620$export$e7c866399fa523f5)();
const $027759db8f1f11a7$var$_worldVertex = (0, $6b6a54a072724620$export$e7c866399fa523f5)();
const $027759db8f1f11a7$var$_dist = (0, $6b6a54a072724620$export$e7c866399fa523f5)();
const $027759db8f1f11a7$var$_projectionOffset = (0, $6b6a54a072724620$export$e7c866399fa523f5)();
const $027759db8f1f11a7$var$_contactOnPlane = (0, $6b6a54a072724620$export$e7c866399fa523f5)();
function $027759db8f1f11a7$export$708c9d6e8d24e6fc(bodyA, _shapeA, offsetA, angleA, bodyB, shapeB, offsetB, angleB, justTest) {
    // Note: bodyA is plane, bodyB is convex
    const convexShape = shapeB;
    $027759db8f1f11a7$var$_planeNormal.set($027759db8f1f11a7$var$yAxis).irotate(angleA);
    // Get convex-local plane offset and normal
    $027759db8f1f11a7$var$_localPlaneNormal.set($027759db8f1f11a7$var$_planeNormal).irotate(-angleB);
    $027759db8f1f11a7$var$_localPlaneOffset.set(offsetA).itoLocalFrame(offsetB, angleB);
    const result = (0, $c6ded5357db9ac08$export$2dc323ef1a86e04b)();
    const vertices = convexShape.vertices;
    for (const v of vertices){
        $027759db8f1f11a7$var$_localDist.set(v).isub($027759db8f1f11a7$var$_localPlaneOffset);
        if ($027759db8f1f11a7$var$_localDist.dot($027759db8f1f11a7$var$_localPlaneNormal) <= 0) {
            if (justTest) return (0, $c6ded5357db9ac08$export$2dc323ef1a86e04b)();
            $027759db8f1f11a7$var$_worldVertex.set(v).itoGlobalFrame(offsetB, angleB);
            $027759db8f1f11a7$var$_dist.set($027759db8f1f11a7$var$_worldVertex).isub(offsetA);
            const d = $027759db8f1f11a7$var$_dist.dot($027759db8f1f11a7$var$_planeNormal);
            $027759db8f1f11a7$var$_projectionOffset.set($027759db8f1f11a7$var$_planeNormal).imul(d);
            $027759db8f1f11a7$var$_contactOnPlane.set($027759db8f1f11a7$var$_worldVertex).isub($027759db8f1f11a7$var$_projectionOffset);
            result.contacts.push({
                worldContactA: (0, $6b6a54a072724620$export$e7c866399fa523f5)($027759db8f1f11a7$var$_contactOnPlane).isub(bodyA.position),
                worldContactB: (0, $6b6a54a072724620$export$e7c866399fa523f5)($027759db8f1f11a7$var$_worldVertex).isub(bodyB.position),
                normal: (0, $6b6a54a072724620$export$e7c866399fa523f5)($027759db8f1f11a7$var$_planeNormal),
                depth: -d
            });
        }
    }
    if (result.contacts.length === 0) return null;
    return result;
}




const $315c230460e2ed00$var$yAxis = (0, $6b6a54a072724620$export$e7c866399fa523f5)(0, 1);
// Scratch vectors to avoid per-call allocations
const $315c230460e2ed00$var$_lineStart = (0, $6b6a54a072724620$export$e7c866399fa523f5)();
const $315c230460e2ed00$var$_lineEnd = (0, $6b6a54a072724620$export$e7c866399fa523f5)();
const $315c230460e2ed00$var$_planeNormal = (0, $6b6a54a072724620$export$e7c866399fa523f5)();
const $315c230460e2ed00$var$_dist = (0, $6b6a54a072724620$export$e7c866399fa523f5)();
const $315c230460e2ed00$var$_projectionOffset = (0, $6b6a54a072724620$export$e7c866399fa523f5)();
const $315c230460e2ed00$var$_contactOnPlane = (0, $6b6a54a072724620$export$e7c866399fa523f5)();
function $315c230460e2ed00$export$c471e90d0fa0af4(bodyA, _shapeA, offsetA, angleA, bodyB, shapeB, offsetB, angleB, justTest) {
    // Note: bodyA is plane, bodyB is line
    const lineShape = shapeB;
    const halfLength = lineShape.length / 2;
    // Get line endpoints
    $315c230460e2ed00$var$_lineStart.set(-halfLength, 0).itoGlobalFrame(offsetB, angleB);
    $315c230460e2ed00$var$_lineEnd.set(halfLength, 0).itoGlobalFrame(offsetB, angleB);
    $315c230460e2ed00$var$_planeNormal.set($315c230460e2ed00$var$yAxis).irotate(angleA);
    const result = (0, $c6ded5357db9ac08$export$2dc323ef1a86e04b)();
    // Check line endpoints against plane
    const endpoints = [
        $315c230460e2ed00$var$_lineStart,
        $315c230460e2ed00$var$_lineEnd
    ];
    for (const endpoint of endpoints){
        $315c230460e2ed00$var$_dist.set(endpoint).isub(offsetA);
        const distance = $315c230460e2ed00$var$_dist.dot($315c230460e2ed00$var$_planeNormal);
        if (distance < 0) {
            if (justTest) return (0, $c6ded5357db9ac08$export$2dc323ef1a86e04b)();
            // Project endpoint onto plane
            $315c230460e2ed00$var$_projectionOffset.set($315c230460e2ed00$var$_planeNormal).imul(distance);
            $315c230460e2ed00$var$_contactOnPlane.set(endpoint).isub($315c230460e2ed00$var$_projectionOffset);
            result.contacts.push({
                worldContactA: (0, $6b6a54a072724620$export$e7c866399fa523f5)($315c230460e2ed00$var$_contactOnPlane).isub(bodyA.position),
                worldContactB: (0, $6b6a54a072724620$export$e7c866399fa523f5)(endpoint).isub(bodyB.position),
                normal: (0, $6b6a54a072724620$export$e7c866399fa523f5)($315c230460e2ed00$var$_planeNormal),
                depth: -distance
            });
        }
    }
    if (result.contacts.length === 0) return null;
    return result;
}


/** Wraps a collision handler to swap A and B inputs/outputs. */ function $427489304b21ad7c$var$swapped(handler) {
    return (bodyA, shapeA, offsetA, angleA, bodyB, shapeB, offsetB, angleB, justTest)=>{
        const result = handler(bodyB, shapeB, offsetB, angleB, bodyA, shapeA, offsetA, angleA, justTest);
        if (!result) return null;
        // Swap contact points and negate normal
        for (const contact of result.contacts){
            const temp = contact.worldContactA;
            contact.worldContactA = contact.worldContactB;
            contact.worldContactB = temp;
            contact.normal = (0, $6b6a54a072724620$export$e7c866399fa523f5)(-contact.normal.x, -contact.normal.y);
        }
        return result;
    };
}
// Nested map: ShapeA constructor -> ShapeB constructor -> handler
const $427489304b21ad7c$var$handlerRegistry = new Map();
function $427489304b21ad7c$var$registerHandler(shapeTypeA, shapeTypeB, handler, bidirectional = true) {
    if (!$427489304b21ad7c$var$handlerRegistry.has(shapeTypeA)) $427489304b21ad7c$var$handlerRegistry.set(shapeTypeA, new Map());
    // Cast is safe: runtime dispatch ensures shapeA/shapeB match T1/T2
    $427489304b21ad7c$var$handlerRegistry.get(shapeTypeA).set(shapeTypeB, handler);
    if (bidirectional && shapeTypeA !== shapeTypeB) {
        if (!$427489304b21ad7c$var$handlerRegistry.has(shapeTypeB)) $427489304b21ad7c$var$handlerRegistry.set(shapeTypeB, new Map());
        $427489304b21ad7c$var$handlerRegistry.get(shapeTypeB).set(shapeTypeA, $427489304b21ad7c$var$swapped(handler));
    }
}
// Circle collisions
$427489304b21ad7c$var$registerHandler((0, $45a22be5c0ab570f$export$c89a927ffc67e6fa), (0, $45a22be5c0ab570f$export$c89a927ffc67e6fa), (0, $24ffcd53ca5eb8b7$export$b85ee8633cdf5ab6));
$427489304b21ad7c$var$registerHandler((0, $45a22be5c0ab570f$export$c89a927ffc67e6fa), (0, $5decb6115b59ebc8$export$c36c68baa13912a5), (0, $32285f3aa0b1dd1c$export$99d5208211e738af));
$427489304b21ad7c$var$registerHandler((0, $45a22be5c0ab570f$export$c89a927ffc67e6fa), (0, $4a68a0f4a5a6faef$export$7ff5ac152ef991b0), (0, $8868f2ef5e4af8d0$export$a980cf319e1f1872));
$427489304b21ad7c$var$registerHandler((0, $45a22be5c0ab570f$export$c89a927ffc67e6fa), (0, $6ae562c24c0aa510$export$bc1767a8c6770562), (0, $2081d284af2f6844$export$61f0e84b03c18487));
$427489304b21ad7c$var$registerHandler((0, $45a22be5c0ab570f$export$c89a927ffc67e6fa), (0, $d7d213b64e83977c$export$17d680238e50603e), (0, $fee1cc527301c8c7$export$8ea4088d83da32bd));
$427489304b21ad7c$var$registerHandler((0, $45a22be5c0ab570f$export$c89a927ffc67e6fa), (0, $edc29b4b53f48a09$export$28bdb8fc07bf3804), (0, $b96968a114780dde$export$dad532846b0c06fb));
$427489304b21ad7c$var$registerHandler((0, $45a22be5c0ab570f$export$c89a927ffc67e6fa), (0, $2f5e2d32a4c0fef1$export$fa360b5b58f475b7), (0, $1eafd6ca9597bb65$export$2df3a9fca926f682));
// Particle collisions
$427489304b21ad7c$var$registerHandler((0, $5decb6115b59ebc8$export$c36c68baa13912a5), (0, $4a68a0f4a5a6faef$export$7ff5ac152ef991b0), (0, $476c218c0f3d5149$export$48f1b22f9cf873f7));
$427489304b21ad7c$var$registerHandler((0, $5decb6115b59ebc8$export$c36c68baa13912a5), (0, $6ae562c24c0aa510$export$bc1767a8c6770562), (0, $57729e839e3a46e6$export$a87fb97eac1527a3));
$427489304b21ad7c$var$registerHandler((0, $5decb6115b59ebc8$export$c36c68baa13912a5), (0, $edc29b4b53f48a09$export$28bdb8fc07bf3804), (0, $f3f4231dea551833$export$79ea493cd09eddd6));
// Plane collisions
$427489304b21ad7c$var$registerHandler((0, $4a68a0f4a5a6faef$export$7ff5ac152ef991b0), (0, $6ae562c24c0aa510$export$bc1767a8c6770562), (0, $027759db8f1f11a7$export$708c9d6e8d24e6fc));
$427489304b21ad7c$var$registerHandler((0, $4a68a0f4a5a6faef$export$7ff5ac152ef991b0), (0, $d7d213b64e83977c$export$17d680238e50603e), (0, $315c230460e2ed00$export$c471e90d0fa0af4));
$427489304b21ad7c$var$registerHandler((0, $4a68a0f4a5a6faef$export$7ff5ac152ef991b0), (0, $edc29b4b53f48a09$export$28bdb8fc07bf3804), (0, $64dd194f1bf0b593$export$185e5ece20541eb3));
// Convex collisions
$427489304b21ad7c$var$registerHandler((0, $6ae562c24c0aa510$export$bc1767a8c6770562), (0, $6ae562c24c0aa510$export$bc1767a8c6770562), (0, $12f5e7419b0514b7$export$6f51f77cc14ca3e6));
$427489304b21ad7c$var$registerHandler((0, $6ae562c24c0aa510$export$bc1767a8c6770562), (0, $edc29b4b53f48a09$export$28bdb8fc07bf3804), (0, $6818e2e66e50d778$export$7cf2323b2d15d3a0));
$427489304b21ad7c$var$registerHandler((0, $6ae562c24c0aa510$export$bc1767a8c6770562), (0, $2f5e2d32a4c0fef1$export$fa360b5b58f475b7), (0, $9224f3ad983aed03$export$115add4fc7de6aba));
// Capsule collisions
$427489304b21ad7c$var$registerHandler((0, $edc29b4b53f48a09$export$28bdb8fc07bf3804), (0, $edc29b4b53f48a09$export$28bdb8fc07bf3804), (0, $567eb89778a9e4a6$export$c0e0f660f83dcbd8));
function $427489304b21ad7c$var$getCollisionHandler(shapeA, shapeB) {
    return $427489304b21ad7c$var$handlerRegistry.get(shapeA.constructor)?.get(shapeB.constructor) ?? (()=>null);
}
function $427489304b21ad7c$export$d83224947f8aba38(bodyA, shapeA, offsetA, angleA, bodyB, shapeB, offsetB, angleB, justTest = false) {
    const handler = $427489304b21ad7c$var$getCollisionHandler(shapeA, shapeB);
    return handler(bodyA, shapeA, offsetA, angleA, bodyB, shapeB, offsetB, angleB, justTest);
}


function $5b9d44bb2e6e52f9$export$7f58631b3746eb17(pairs) {
    const collisions = [];
    const sensorOverlaps = [];
    for (const [bodyA, bodyB] of pairs){
        for (const shapeA of bodyA.shapes)for (const shapeB of bodyB.shapes){
            // Check collision groups and masks
            if (!(0, $0c8c1abaefcc6cf6$export$5b208537b1539f4e)(shapeA, shapeB)) continue;
            // Get world position and angle of each shape
            const positionA = bodyA.toWorldFrame(shapeA.position);
            const positionB = bodyB.toWorldFrame(shapeB.position);
            const angleA = shapeA.angle + bodyA.angle;
            const angleB = shapeB.angle + bodyB.angle;
            const isSensor = shapeA.sensor || shapeB.sensor;
            const collisionResult = (0, $427489304b21ad7c$export$d83224947f8aba38)(bodyA, shapeA, positionA, angleA, bodyB, shapeB, positionB, angleB, isSensor);
            if (collisionResult) {
                if (isSensor) sensorOverlaps.push({
                    bodyA: bodyA,
                    shapeA: shapeA,
                    bodyB: bodyB,
                    shapeB: shapeB
                });
                else collisions.push({
                    bodyA: bodyA,
                    shapeA: shapeA,
                    bodyB: bodyB,
                    shapeB: shapeB,
                    ...collisionResult
                });
            }
        }
    }
    return {
        collisions: collisions,
        sensorOverlaps: sensorOverlaps
    };
}




/** Create ray data from two points. */ function $d9cbdfb0e7d73d1e$var$createRay(from, to) {
    const fromV = (0, $6b6a54a072724620$export$e7c866399fa523f5)(from[0], from[1]);
    const toV = (0, $6b6a54a072724620$export$e7c866399fa523f5)(to[0], to[1]);
    const direction = (0, $6b6a54a072724620$export$e7c866399fa523f5)(toV).isub(fromV);
    const length = direction.magnitude;
    direction.inormalize();
    return {
        from: fromV,
        to: toV,
        direction: direction,
        length: length
    };
}
/** Get AABB containing the ray. */ function $d9cbdfb0e7d73d1e$var$getRayAABB(ray) {
    const aabb = new (0, $dd0ee6ed41f5ec2f$export$8ec70f2db73b49aa)();
    aabb.lowerBound.set(Math.min(ray.from[0], ray.to[0]), Math.min(ray.from[1], ray.to[1]));
    aabb.upperBound.set(Math.max(ray.from[0], ray.to[0]), Math.max(ray.from[1], ray.to[1]));
    return aabb;
}
/** Check if ray potentially intersects a body's AABB. */ function $d9cbdfb0e7d73d1e$var$rayMayHitBody(ray, body) {
    const aabb = body.getAABB();
    return aabb.overlapsRay(ray) >= 0 || aabb.containsPoint(ray.from);
}
function $d9cbdfb0e7d73d1e$export$630e89aab3ddc1d6(world, from, to, options) {
    const ray = $d9cbdfb0e7d73d1e$var$createRay(from, to);
    const aabb = $d9cbdfb0e7d73d1e$var$getRayAABB(ray);
    // Get candidate bodies from broadphase
    const candidates = world.broadphase.aabbQuery(world, aabb, true);
    let closestHit = null;
    let closestFraction = Infinity;
    for (const body of candidates){
        // Skip bodies that don't respond to collisions (if checking)
        if (!body.collisionResponse) continue;
        // Check AABB first
        if (!$d9cbdfb0e7d73d1e$var$rayMayHitBody(ray, body)) continue;
        // Apply custom filter
        if (options?.filter && !options.filter(body, body.shapes[0])) continue;
        // Test each shape
        for (const shape of body.shapes){
            if (!shape.collisionResponse) continue;
            // Check collision mask
            if (options?.collisionMask !== undefined) {
                if ((shape.collisionGroup & options.collisionMask) === 0) continue;
            }
            // Apply filter for this specific shape
            if (options?.filter && !options.filter(body, shape)) continue;
            // Get world position and angle of the shape
            const worldPosition = (0, $6b6a54a072724620$export$e7c866399fa523f5)(shape.position).irotate(body.angle).iadd(body.position);
            const worldAngle = shape.angle + body.angle;
            // Perform shape-specific raycast
            const hit = shape.raycast(ray.from, ray.to, worldPosition, worldAngle, options?.skipBackfaces ?? false);
            if (hit && hit.fraction < closestFraction) {
                closestFraction = hit.fraction;
                closestHit = {
                    body: body,
                    shape: shape,
                    point: hit.point,
                    normal: hit.normal,
                    distance: hit.distance,
                    fraction: hit.fraction
                };
            }
        }
    }
    return closestHit;
}
function $d9cbdfb0e7d73d1e$export$e6ff08404a53afd2(world, from, to, options) {
    const ray = $d9cbdfb0e7d73d1e$var$createRay(from, to);
    const aabb = $d9cbdfb0e7d73d1e$var$getRayAABB(ray);
    // Get candidate bodies from broadphase
    const candidates = world.broadphase.aabbQuery(world, aabb, true);
    const hits = [];
    for (const body of candidates){
        if (!body.collisionResponse) continue;
        if (!$d9cbdfb0e7d73d1e$var$rayMayHitBody(ray, body)) continue;
        if (options?.filter && !options.filter(body, body.shapes[0])) continue;
        for (const shape of body.shapes){
            if (!shape.collisionResponse) continue;
            if (options?.collisionMask !== undefined) {
                if ((shape.collisionGroup & options.collisionMask) === 0) continue;
            }
            if (options?.filter && !options.filter(body, shape)) continue;
            const worldPosition = (0, $6b6a54a072724620$export$e7c866399fa523f5)(shape.position).irotate(body.angle).iadd(body.position);
            const worldAngle = shape.angle + body.angle;
            const hit = shape.raycast(ray.from, ray.to, worldPosition, worldAngle, options?.skipBackfaces ?? false);
            if (hit) hits.push({
                body: body,
                shape: shape,
                point: hit.point,
                normal: hit.normal,
                distance: hit.distance,
                fraction: hit.fraction
            });
        }
    }
    // Sort by distance (closest first)
    hits.sort((a, b)=>a.distance - b.distance);
    return hits;
}



/**
 * Shape-specialized 2-body equation for **2D planar rigid-rigid** constraints
 * where both bodies move in the XY plane and rotate only about Z. The Jacobian
 * has the shape:
 *
 *   G = [ -linX, -linY, 0,   0, 0, angAz,   linX, linY, 0,   0, 0, angBz ]
 *        └──── linA ────┘ └──── angA ────┘ └──── linB ────┘ └──── angB ────┘
 *
 * The linear contribution is symmetric by Newton's 3rd law: body A receives
 * `-(linX, linY)` and body B receives `+(linX, linY)`. The angular
 * contribution is a single Z-axis scalar per body (`angAz` / `angBz`), which
 * can differ because each body has its own lever arm to the contact point.
 *
 * ## Storage
 *
 * Four floats in named fields instead of a 12-element `G`:
 *   - `linX, linY` — shared linear direction (body A gets the negation)
 *   - `angAz` — body A angular Z component
 *   - `angBz` — body B angular Z component
 *
 * ## When to use
 *
 * Any 2D contact or friction constraint between two bodies that are
 * effectively planar (boat hulls, sails, obstacles). Used by:
 *   - {@link ContactEquation} — non-penetration along a contact normal
 *   - {@link FrictionEquation} — tangential slip resistance at a contact
 *
 * Gear-ratio-style angular constraints (where linear is zero and angular is
 * asymmetric) should use {@link AngularEquation2D} instead.
 *
 * ## Inertia tensor reads
 *
 * The solver only needs the Z column of each body's inverse inertia tensor
 * (since the angular Jacobian is purely Z). For a typical 2D dynamic body
 * the inverse inertia is effectively scalar on the Z axis, but the code
 * here reads the full Z column (`iI[2], iI[5], iI[8]`) so it works for both
 * pure-2D and 3DOF bodies without a branch.
 */ /**
 * Symbols for solver-internal properties on equations.
 * Import these only in solver code, not in game code.
 *
 * Using symbols hides these properties from autocomplete,
 * making the public API cleaner and more focused.
 */ // Equation solver internals
const $d28dd663c1e16271$export$4478cbdd71bb855f = Symbol("B");
const $d28dd663c1e16271$export$4ec04f732cb63a3e = Symbol("invC");
const $d28dd663c1e16271$export$a0a67faf5a4e6d5c = Symbol("lambda");
const $d28dd663c1e16271$export$c7bfe79b661dbb1 = Symbol("maxForceDt");
const $d28dd663c1e16271$export$e0d79db2efbf7abf = Symbol("minForceDt");
const $d28dd663c1e16271$export$1d1b51a214a8f673 = Symbol("indexA");
const $d28dd663c1e16271$export$941aeb6a025e2399 = Symbol("indexB");
const $d28dd663c1e16271$export$b0ca2c790f54fca9 = Symbol("indexC");
const $d28dd663c1e16271$export$d8a965ecb4c5b716 = Symbol("eqSlot");


/**
 * Base constraint equation for the physics solver.
 *
 * ## Constraint formulation
 *
 * Each equation represents a single scalar constraint of the form:
 *
 *   C(q) = 0          (position-level: "these bodies should be at this configuration")
 *   dC/dt = G * v = 0 (velocity-level: "the relative velocity along this constraint axis is zero")
 *
 * where:
 *   - C(q) is the constraint function evaluated at the current positions/orientations
 *   - G is the constraint Jacobian — a 1x12 row vector (see the G field below)
 *   - v is the 12-component generalized velocity vector of the two bodies:
 *     [vxA, vyA, vzA, wxA, wyA, wzA, vxB, vyB, vzB, wxB, wyB, wzB]
 *
 * The Jacobian G encodes *how* the constraint responds to each body's motion.
 * For example, a contact normal constraint sets G so that G*v gives the
 * relative velocity along the contact normal.
 *
 * ## Stiffness, damping, and the a/b/epsilon parameters
 *
 * Rather than enforcing C=0 rigidly (which requires infinite stiffness and
 * can cause instability), constraints are modeled as damped springs:
 *
 *   F = -k*C - d*(dC/dt)
 *
 * where k = stiffness (N/m) and d = relaxation (dimensionless damping ratio,
 * not seconds — higher values = more damping).
 *
 * The update() method converts (k, d, h) into solver-friendly parameters:
 *   a       = 4 / (h * (1 + 4d))       — position error feedback gain (1/s)
 *   b       = 4d / (1 + 4d)             — velocity error feedback gain (dimensionless, 0..1)
 *   epsilon = 4 / (h^2 * k * (1 + 4d)) — compliance/regularization (s^2/kg/m or equivalent)
 *
 * These appear in the solver's right-hand side: B = -a*Gq - b*GW - h*GiMf
 * and in the effective mass: invC = 1/(G*M^-1*G^T + epsilon).
 *
 * High stiffness (k -> inf) makes epsilon -> 0, recovering a rigid constraint.
 * High relaxation (d -> inf) makes b -> 1 and a -> 0, prioritizing velocity
 * correction over position correction (more damped, less springy).
 */ 
class $0113af86cc04b089$export$9e6be560da9da590 {
    static{
        this.DEFAULT_STIFFNESS = 1e6;
    }
    static{
        this.DEFAULT_RELAXATION = 4;
    }
    static{
        this.idCounter = 0;
    }
    constructor(bodyA, bodyB, minForce = -Number.MAX_VALUE, maxForce = Number.MAX_VALUE){
        /**
   * Jacobian vector (12 components):
   * [vxA, vyA, vzA, wxA, wyA, wzA, vxB, vyB, vzB, wxB, wyB, wzB]
   *
   * For 3DOF-only constraints, components 2,3,4 (vzA, wxA, wyA) and
   * 8,9,10 (vzB, wxB, wyB) are 0 — the solver handles this correctly
   * because the corresponding inverse mass/inertia values are also 0.
   */ this.G = new Float32Array(12);
        // Solver-internal properties (hidden from autocomplete via symbols)
        this[0, $d28dd663c1e16271$export$4478cbdd71bb855f] = 0;
        this[0, $d28dd663c1e16271$export$4ec04f732cb63a3e] = 0;
        this[0, $d28dd663c1e16271$export$a0a67faf5a4e6d5c] = 0;
        this[0, $d28dd663c1e16271$export$c7bfe79b661dbb1] = 0;
        this[0, $d28dd663c1e16271$export$e0d79db2efbf7abf] = 0;
        /** Workspace row index for bodyA during the current solve. -1 when unset. */ this[0, $d28dd663c1e16271$export$1d1b51a214a8f673] = -1;
        /** Workspace row index for bodyB during the current solve. -1 when unset. */ this[0, $d28dd663c1e16271$export$941aeb6a025e2399] = -1;
        /** Slot in workspace.Bs / invCs / lambda for the current solve. -1 when unset. */ this[0, $d28dd663c1e16271$export$d8a965ecb4c5b716] = -1;
        this.id = $0113af86cc04b089$export$9e6be560da9da590.idCounter++;
        this.minForce = minForce;
        this.maxForce = maxForce;
        this.bodyA = bodyA;
        this.bodyB = bodyB;
        this.stiffness = $0113af86cc04b089$export$9e6be560da9da590.DEFAULT_STIFFNESS;
        this.relaxation = $0113af86cc04b089$export$9e6be560da9da590.DEFAULT_RELAXATION;
        this.offset = 0;
        this.a = 0;
        this.b = 0;
        this.epsilon = 0;
        this.timeStep = 1 / 60;
        this.needsUpdate = true;
        this.multiplier = 0;
        this.relativeVelocity = 0;
        this.enabled = true;
        this.warmLambda = 0;
        this.solverOrder = 0;
    }
    /**
   * Recompute the solver parameters (a, b, epsilon) from stiffness, relaxation,
   * and the current timestep. Called automatically by the solver when the
   * timestep changes or needsUpdate is set.
   *
   * Derivation: models the constraint as a damped spring C'' + 2d/h*C' + k*C = 0,
   * discretized with implicit Euler. The resulting formulas are:
   *   a       = 4 / (h * (1 + 4d))        — position correction rate
   *   b       = 4d / (1 + 4d)             — velocity correction blend (0 = spring, 1 = damper)
   *   epsilon = 4 / (h^2 * k * (1 + 4d)) — constraint softness (compliance)
   */ update() {
        const k = this.stiffness;
        const d = this.relaxation;
        const h = this.timeStep;
        this.a = 4.0 / (h * (1 + 4 * d));
        this.b = 4.0 * d / (1 + 4 * d);
        this.epsilon = 4.0 / (h * h * k * (1 + 4 * d));
        this.needsUpdate = false;
        return this;
    }
    /**
   * Assign workspace row indices for this equation's bodies. Called once
   * per solve during setup. Subclasses with extra bodies (e.g. PulleyEquation)
   * should override and call super.
   */ assignIndices(ws) {
        this[0, $d28dd663c1e16271$export$1d1b51a214a8f673] = ws.indexOf(this.bodyA);
        this[0, $d28dd663c1e16271$export$941aeb6a025e2399] = ws.indexOf(this.bodyB);
    }
    /**
   * Compute the right-hand side (B) of the constraint equation for the solver.
   *
   *   B = -a * Gq - b * GW - h * GiMf
   *
   * This combines three correction terms:
   * - **Gq** (position error): how far the constraint is violated right now.
   *   Scaled by `a` to control position correction aggressiveness (Baumgarte).
   * - **GW** (velocity error): the current relative velocity along the constraint.
   *   Scaled by `b` to provide velocity-level damping.
   * - **GiMf** (force term): the acceleration that external forces would cause
   *   along the constraint direction. Scaled by `h` to predict the velocity
   *   change from external forces over this timestep.
   *
   * @param a - Position error feedback gain (1/s), from update()
   * @param b - Velocity error feedback gain (dimensionless), from update()
   * @param h - Timestep (s)
   * @param ws - Solver workspace (provides inverse mass/inertia by body index)
   */ computeB(a, b, h, ws) {
        const GW = this.computeGW();
        const Gq = this.computeGq();
        const GiMf = this.computeGiMf(ws);
        return -Gq * a - GW * b - GiMf * h;
    }
    /**
   * Position-level constraint evaluation.
   * Default: G · [posA, zA, 0, 0, yawA, posB, zB, 0, 0, yawB] + offset.
   * Most constraint types override this with a custom geometric computation.
   */ computeGq() {
        const G = this.G;
        const bi = this.bodyA;
        const bj = this.bodyB;
        return G[0] * bi.position[0] + G[1] * bi.position[1] + G[2] * bi.z + // G[3], G[4]: roll/pitch position terms — 0 for standard constraints
        G[5] * bi.angle + G[6] * bj.position[0] + G[7] * bj.position[1] + G[8] * bj.z + // G[9], G[10]: roll/pitch position terms — 0 for standard constraints
        G[11] * bj.angle + this.offset;
    }
    /**
   * Velocity-level constraint evaluation: G * v.
   *
   * Computes the current relative velocity along the constraint direction
   * using the bodies' actual velocities (not the solver accumulators).
   * This is the "GW" term in the RHS: it tells the solver how fast the
   * constraint is currently being violated.
   *
   * The `relativeVelocity` field is added as a bias — used by motor
   * constraints to drive toward a target speed.
   */ computeGW() {
        const G = this.G;
        const bi = this.bodyA;
        const bj = this.bodyB;
        const wA = bi.angularVelocity3;
        const wB = bj.angularVelocity3;
        return G[0] * bi.velocity[0] + G[1] * bi.velocity[1] + G[2] * bi.zVelocity + G[3] * wA[0] + G[4] * wA[1] + G[5] * wA[2] + G[6] * bj.velocity[0] + G[7] * bj.velocity[1] + G[8] * bj.zVelocity + G[9] * wB[0] + G[10] * wB[1] + G[11] * wB[2] + this.relativeVelocity;
    }
    /**
   * Compute the constraint velocity from accumulated solver impulses: G * v_lambda.
   *
   * This is the "GWlambda" term in the solver iteration. It represents
   * how much constraint-velocity has already been accumulated from impulses
   * applied by this and other equations during the current solve. The solver
   * subtracts this from B to find the remaining violation to correct.
   */ computeGWlambda(ws) {
        const G = this.G;
        const iA = this[0, $d28dd663c1e16271$export$1d1b51a214a8f673] * 3;
        const iB = this[0, $d28dd663c1e16271$export$941aeb6a025e2399] * 3;
        const vl = ws.vlambda;
        const wl = ws.wlambda;
        return G[0] * vl[iA] + G[1] * vl[iA + 1] + G[2] * vl[iA + 2] + G[3] * wl[iA] + G[4] * wl[iA + 1] + G[5] * wl[iA + 2] + G[6] * vl[iB] + G[7] * vl[iB + 1] + G[8] * vl[iB + 2] + G[9] * wl[iB] + G[10] * wl[iB + 1] + G[11] * wl[iB + 2];
    }
    /**
   * External force contribution: G · [invM*f, invI*τ] for both bodies.
   * The angular part uses the full 3x3 world-frame inverse inertia tensor.
   */ computeGiMf(ws) {
        const G = this.G;
        const bi = this.bodyA;
        const bj = this.bodyB;
        const idxA = this[0, $d28dd663c1e16271$export$1d1b51a214a8f673];
        const idxB = this[0, $d28dd663c1e16271$export$941aeb6a025e2399];
        const invMassSolve = ws.invMassSolve;
        const invMassSolveZ = ws.invMassSolveZ;
        const invInertia = ws.invInertia;
        const iMA = invMassSolve[idxA];
        const iMzA = invMassSolveZ[idxA];
        const iMB = invMassSolve[idxB];
        const iMzB = invMassSolveZ[idxB];
        // Body A: invI_world * torque3
        const iIA = invInertia[idxA];
        const tA = bi.angularForce3;
        const aA0 = iIA[0] * tA[0] + iIA[1] * tA[1] + iIA[2] * tA[2];
        const aA1 = iIA[3] * tA[0] + iIA[4] * tA[1] + iIA[5] * tA[2];
        const aA2 = iIA[6] * tA[0] + iIA[7] * tA[1] + iIA[8] * tA[2];
        // Body B: invI_world * torque3
        const iIB = invInertia[idxB];
        const tB = bj.angularForce3;
        const aB0 = iIB[0] * tB[0] + iIB[1] * tB[1] + iIB[2] * tB[2];
        const aB1 = iIB[3] * tB[0] + iIB[4] * tB[1] + iIB[5] * tB[2];
        const aB2 = iIB[6] * tB[0] + iIB[7] * tB[1] + iIB[8] * tB[2];
        return G[0] * bi.force[0] * iMA + G[1] * bi.force[1] * iMA + G[2] * bi.zForce * iMzA + G[3] * aA0 + G[4] * aA1 + G[5] * aA2 + G[6] * bj.force[0] * iMB + G[7] * bj.force[1] * iMB + G[8] * bj.zForce * iMzB + G[9] * aB0 + G[10] * aB1 + G[11] * aB2;
    }
    /**
   * Effective mass: G · invM · G^T.
   * Linear part: G_lin^T * diag(invM, invM, invMz) * G_lin.
   * Angular part: G_ang^T * invI_world * G_ang (quadratic form with 3x3 tensor).
   */ computeGiMGt(ws) {
        const G = this.G;
        const idxA = this[0, $d28dd663c1e16271$export$1d1b51a214a8f673];
        const idxB = this[0, $d28dd663c1e16271$export$941aeb6a025e2399];
        const iMA = ws.invMassSolve[idxA];
        const iMB = ws.invMassSolve[idxB];
        const iMzA = ws.invMassSolveZ[idxA];
        const iMzB = ws.invMassSolveZ[idxB];
        // Body A linear
        let result = G[0] * G[0] * iMA + G[1] * G[1] * iMA + G[2] * G[2] * iMzA;
        // Body A angular: G_ang^T * invI * G_ang (symmetric quadratic form)
        const iIA = ws.invInertia[idxA];
        result += G[3] * (iIA[0] * G[3] + iIA[1] * G[4] + iIA[2] * G[5]) + G[4] * (iIA[3] * G[3] + iIA[4] * G[4] + iIA[5] * G[5]) + G[5] * (iIA[6] * G[3] + iIA[7] * G[4] + iIA[8] * G[5]);
        // Body B linear
        result += G[6] * G[6] * iMB + G[7] * G[7] * iMB + G[8] * G[8] * iMzB;
        // Body B angular
        const iIB = ws.invInertia[idxB];
        result += G[9] * (iIB[0] * G[9] + iIB[1] * G[10] + iIB[2] * G[11]) + G[10] * (iIB[3] * G[9] + iIB[4] * G[10] + iIB[5] * G[11]) + G[11] * (iIB[6] * G[9] + iIB[7] * G[10] + iIB[8] * G[11]);
        return result;
    }
    /**
   * Apply impulse to both bodies' solver state.
   * Linear: vlambda += invM * G_lin * deltalambda
   * Angular: wlambda += invI_world * G_ang * deltalambda
   */ addToWlambda(deltalambda, ws) {
        const G = this.G;
        const idxA = this[0, $d28dd663c1e16271$export$1d1b51a214a8f673];
        const idxB = this[0, $d28dd663c1e16271$export$941aeb6a025e2399];
        const iA = idxA * 3;
        const iB = idxB * 3;
        const vl = ws.vlambda;
        const wl = ws.wlambda;
        const iMA = ws.invMassSolve[idxA];
        const iMB = ws.invMassSolve[idxB];
        const iMzA = ws.invMassSolveZ[idxA];
        const iMzB = ws.invMassSolveZ[idxB];
        const dl = deltalambda;
        // Body A linear
        vl[iA] += iMA * G[0] * dl;
        vl[iA + 1] += iMA * G[1] * dl;
        vl[iA + 2] += iMzA * G[2] * dl;
        // Body A angular: wlambda += invI * (G_ang * dl)
        const iIA = ws.invInertia[idxA];
        const gA3 = G[3] * dl;
        const gA4 = G[4] * dl;
        const gA5 = G[5] * dl;
        wl[iA] += iIA[0] * gA3 + iIA[1] * gA4 + iIA[2] * gA5;
        wl[iA + 1] += iIA[3] * gA3 + iIA[4] * gA4 + iIA[5] * gA5;
        wl[iA + 2] += iIA[6] * gA3 + iIA[7] * gA4 + iIA[8] * gA5;
        // Body B linear
        vl[iB] += iMB * G[6] * dl;
        vl[iB + 1] += iMB * G[7] * dl;
        vl[iB + 2] += iMzB * G[8] * dl;
        // Body B angular
        const iIB = ws.invInertia[idxB];
        const gB9 = G[9] * dl;
        const gB10 = G[10] * dl;
        const gB11 = G[11] * dl;
        wl[iB] += iIB[0] * gB9 + iIB[1] * gB10 + iIB[2] * gB11;
        wl[iB + 1] += iIB[3] * gB9 + iIB[4] * gB10 + iIB[5] * gB11;
        wl[iB + 2] += iIB[6] * gB9 + iIB[7] * gB10 + iIB[8] * gB11;
        return this;
    }
    /**
   * Compute the inverse effective mass for this constraint:
   *   invC = 1 / (G * M^-1 * G^T + epsilon)
   *
   * The denominator is the "effective mass" — how much impulse is needed to
   * produce a unit velocity change along this constraint. The epsilon term
   * regularizes the computation: it prevents division by zero when bodies
   * are massless along the constraint direction, and softens the constraint
   * to model compliance (springiness).
   */ computeInvC(eps, ws) {
        const denom = this.computeGiMGt(ws) + eps;
        if (denom <= 0 || !isFinite(denom)) return 0;
        const inv = 1.0 / denom;
        return isFinite(inv) ? inv : 0;
    }
}


class $a406b5b317398f9e$export$87c9791c969e8729 extends (0, $0113af86cc04b089$export$9e6be560da9da590) {
    constructor(bodyA, bodyB, minForce = -Number.MAX_VALUE, maxForce = Number.MAX_VALUE){
        super(bodyA, bodyB, minForce, maxForce), /** Shared linear direction. Body A gets `-(linX, linY)`, body B gets `+(linX, linY)`. */ this.linX = 0, this.linY = 0, /** Body A angular Z component. */ this.angAz = 0, /** Body B angular Z component. */ this.angBz = 0;
    }
    /** Position error. Owning constraints set `offset` each substep. */ computeGq() {
        return this.offset;
    }
    computeGW() {
        const a = this.bodyA;
        const b = this.bodyB;
        const wA = a.angularVelocity3;
        const wB = b.angularVelocity3;
        return this.linX * (b.velocity[0] - a.velocity[0]) + this.linY * (b.velocity[1] - a.velocity[1]) + this.angAz * wA[2] + this.angBz * wB[2] + this.relativeVelocity;
    }
    computeGWlambda(ws) {
        const iA = this[0, $d28dd663c1e16271$export$1d1b51a214a8f673] * 3;
        const iB = this[0, $d28dd663c1e16271$export$941aeb6a025e2399] * 3;
        const vl = ws.vlambda;
        const wl = ws.wlambda;
        return this.linX * (vl[iB] - vl[iA]) + this.linY * (vl[iB + 1] - vl[iA + 1]) + this.angAz * wl[iA + 2] + this.angBz * wl[iB + 2];
    }
    computeGiMf(ws) {
        const idxA = this[0, $d28dd663c1e16271$export$1d1b51a214a8f673];
        const idxB = this[0, $d28dd663c1e16271$export$941aeb6a025e2399];
        const iMA = ws.invMassSolve[idxA];
        const iMB = ws.invMassSolve[idxB];
        const a = this.bodyA;
        const b = this.bodyB;
        // Body A angular through world-frame inverse inertia — only the Z column
        // of the torque-to-angular-acceleration transform matters, because we
        // multiply by angAz on the single Z axis.
        const iIA = ws.invInertia[idxA];
        const tA = a.angularForce3;
        const aAz = iIA[6] * tA[0] + iIA[7] * tA[1] + iIA[8] * tA[2];
        const iIB = ws.invInertia[idxB];
        const tB = b.angularForce3;
        const aBz = iIB[6] * tB[0] + iIB[7] * tB[1] + iIB[8] * tB[2];
        return this.linX * (b.force[0] * iMB - a.force[0] * iMA) + this.linY * (b.force[1] * iMB - a.force[1] * iMA) + this.angAz * aAz + this.angBz * aBz;
    }
    computeGiMGt(ws) {
        const idxA = this[0, $d28dd663c1e16271$export$1d1b51a214a8f673];
        const idxB = this[0, $d28dd663c1e16271$export$941aeb6a025e2399];
        const iMA = ws.invMassSolve[idxA];
        const iMB = ws.invMassSolve[idxB];
        const lin2 = this.linX * this.linX + this.linY * this.linY;
        let result = lin2 * (iMA + iMB);
        // Body A angular: angAz² · invI[Z,Z]. For diagonal Z-only inverse inertia
        // (typical 2D body) this is exact; for a general 3×3 matrix we take the
        // (2,2) element since we're projecting onto the Z axis only.
        const iIA = ws.invInertia[idxA];
        result += this.angAz * this.angAz * iIA[8];
        const iIB = ws.invInertia[idxB];
        result += this.angBz * this.angBz * iIB[8];
        return result;
    }
    addToWlambda(deltalambda, ws) {
        const idxA = this[0, $d28dd663c1e16271$export$1d1b51a214a8f673];
        const idxB = this[0, $d28dd663c1e16271$export$941aeb6a025e2399];
        const iA = idxA * 3;
        const iB = idxB * 3;
        const vl = ws.vlambda;
        const wl = ws.wlambda;
        const iMA = ws.invMassSolve[idxA];
        const iMB = ws.invMassSolve[idxB];
        const dl = deltalambda;
        // Body A linear (-lin)
        vl[iA] -= iMA * this.linX * dl;
        vl[iA + 1] -= iMA * this.linY * dl;
        // Body B linear (+lin)
        vl[iB] += iMB * this.linX * dl;
        vl[iB + 1] += iMB * this.linY * dl;
        // Body A angular: wl += invI · (0,0,angAz*dl). That's the Z column of invI
        // scaled by angAz*dl.
        const iIA = ws.invInertia[idxA];
        const gAz = this.angAz * dl;
        wl[iA] += iIA[2] * gAz;
        wl[iA + 1] += iIA[5] * gAz;
        wl[iA + 2] += iIA[8] * gAz;
        // Body B angular
        const iIB = ws.invInertia[idxB];
        const gBz = this.angBz * dl;
        wl[iB] += iIB[2] * gBz;
        wl[iB + 1] += iIB[5] * gBz;
        wl[iB + 2] += iIB[8] * gBz;
        return this;
    }
}


class $a822b4417170d1ab$export$9197d1b6f1213c3 extends (0, $a406b5b317398f9e$export$87c9791c969e8729) {
    constructor(bodyA, bodyB){
        super(bodyA, bodyB, 0, Number.MAX_VALUE), /** Restitution to use (0 = no bounciness, 1 = max bounciness). */ this.restitution = 0, /**
   * True on the first tick of an impact (as opposed to persistent contact).
   * Used to inject restitution-based rebound velocity.
   */ this.firstImpact = false, /** The shape on body A that triggered this contact. */ this.shapeA = null, /** The shape on body B that triggered this contact. */ this.shapeB = null;
        this.contactPointA = (0, $6b6a54a072724620$export$e7c866399fa523f5)();
        this.penetrationVec = (0, $6b6a54a072724620$export$e7c866399fa523f5)();
        this.contactPointB = (0, $6b6a54a072724620$export$e7c866399fa523f5)();
        this.normalA = (0, $6b6a54a072724620$export$e7c866399fa523f5)();
    }
    computeB(a, b, h, ws) {
        const bi = this.bodyA;
        const bj = this.bodyB;
        const ri = this.contactPointA;
        const rj = this.contactPointB;
        const xi = bi.position;
        const xj = bj.position;
        const penetrationVec = this.penetrationVec;
        const n = this.normalA;
        // Write the planar-shape Jacobian fields. Linear is symmetric (body A
        // receives `-lin`, body B receives `+lin`). The angular Z component per
        // body comes from the lever-arm cross products ri × n and rj × n.
        this.linX = n[0];
        this.linY = n[1];
        this.angAz = -ri.crossLength(n);
        this.angBz = rj.crossLength(n);
        // q = xj + rj − (xi + ri), i.e. the penetration vector
        penetrationVec.set(xj).iadd(rj).isub(xi).isub(ri);
        let GW;
        let Gq;
        if (this.firstImpact && this.restitution !== 0) {
            Gq = 0;
            GW = 1 / b * (1 + this.restitution) * this.computeGW();
        } else {
            Gq = n.dot(penetrationVec) + this.offset;
            GW = this.computeGW();
        }
        const GiMf = this.computeGiMf(ws);
        return -Gq * a - GW * b - h * GiMf;
    }
    /** Current relative velocity along the contact normal. */ getVelocityAlongNormal() {
        const vi = this.bodyA.getVelocityAtPoint(this.contactPointA);
        const vj = this.bodyB.getVelocityAtPoint(this.contactPointB);
        const relVel = vi.isub(vj);
        return this.normalA.dot(relVel);
    }
}


function $c5764dc7c93dbd5e$export$a6f1fdf48954e3f0({ bodyA: bodyA, shapeA: shapeA, bodyB: bodyB, shapeB: shapeB, contacts: contacts }, contactMaterial, isFirstImpact) {
    // Only enable equations if all parties have collisionResponse enabled
    const enabled = bodyA.collisionResponse && bodyB.collisionResponse && shapeA.collisionResponse && shapeB.collisionResponse;
    return contacts.map((contact)=>{
        const eq = new (0, $a822b4417170d1ab$export$9197d1b6f1213c3)(bodyA, bodyB);
        eq.shapeA = shapeA;
        eq.shapeB = shapeB;
        eq.restitution = contactMaterial.restitution;
        eq.stiffness = contactMaterial.stiffness;
        eq.relaxation = contactMaterial.relaxation;
        eq.offset = contactMaterial.contactSkinSize;
        eq.normalA.set(contact.normal);
        eq.contactPointA.set(contact.worldContactA);
        eq.contactPointB.set(contact.worldContactB);
        eq.needsUpdate = true;
        eq.enabled = enabled;
        eq.firstImpact = isFirstImpact;
        return eq;
    });
}




class $0331ac7467aaeda3$export$aaf1bc25025a5803 extends (0, $a406b5b317398f9e$export$87c9791c969e8729) {
    constructor(bodyA, bodyB, slipForce = 0){
        super(bodyA, bodyB, -slipForce, slipForce), /**
   * Contact equations associated with this friction equation. The contact
   * normal forces are used to rescale the friction slip bound. If more
   * than one contact is given, the bound is averaged across them.
   */ this.contactEquations = [], /** Shape on body A that triggered this friction. */ this.shapeA = null, /** Shape on body B that triggered this friction. */ this.shapeB = null, /** Coulomb friction coefficient. */ this.frictionCoefficient = 0.3;
        this.contactPointA = (0, $6b6a54a072724620$export$e7c866399fa523f5)();
        this.contactPointB = (0, $6b6a54a072724620$export$e7c866399fa523f5)();
        this.t = (0, $6b6a54a072724620$export$e7c866399fa523f5)();
    }
    /** Set the friction slip bound. */ setSlipForce(slipForce) {
        this.maxForce = slipForce;
        this.minForce = -slipForce;
    }
    /** Get the current friction slip bound. */ getSlipForce() {
        return this.maxForce;
    }
    computeB(a, b, h, ws) {
        const ri = this.contactPointA;
        const rj = this.contactPointB;
        const t = this.t;
        // Write the planar-shape Jacobian fields. This is a pure velocity
        // constraint (g ≡ 0), so only GW and GiMf contribute to B.
        this.linX = t[0];
        this.linY = t[1];
        this.angAz = -ri.crossLength(t);
        this.angBz = rj.crossLength(t);
        const GW = this.computeGW();
        const GiMf = this.computeGiMf(ws);
        return /* - Gq * a */ -GW * b - h * GiMf;
    }
}


/**
 * Initial slip force value used before the solver recalculates based on contact forces.
 * The solver will update friction bounds after an initial iteration phase using:
 * slipForce = sum(contactMultipliers) * frictionCoefficient / numContacts
 */ const $28966d70a7fe65ee$var$INITIAL_SLIP_FORCE = 10.0;
function $28966d70a7fe65ee$export$4ed2e1c2f6a9031f(collision, contactEquations, contactMaterial, frictionReduction) {
    if (frictionReduction && contactEquations.length > 1) return [
        $28966d70a7fe65ee$var$generateAverageFrictionEquationForCollision(collision, contactEquations, contactMaterial)
    ];
    else return $28966d70a7fe65ee$var$generateAllFrictionEquationsForCollision(collision, contactEquations, contactMaterial);
}
function $28966d70a7fe65ee$var$generateAllFrictionEquationsForCollision(collision, contactEquations, contactMaterial) {
    // Only enable equations if all parties have collisionResponse enabled
    const enabled = collision.bodyA.collisionResponse && collision.bodyB.collisionResponse && collision.shapeA.collisionResponse && collision.shapeB.collisionResponse;
    return contactEquations.map((contact)=>{
        const eq = new (0, $0331ac7467aaeda3$export$aaf1bc25025a5803)(contact.bodyA, contact.bodyB, $28966d70a7fe65ee$var$INITIAL_SLIP_FORCE);
        eq.shapeA = contact.shapeA;
        eq.shapeB = contact.shapeB;
        eq.contactPointA.set(contact.contactPointA);
        eq.contactPointB.set(contact.contactPointB);
        eq.t.set(contact.normalA).irotate90cw();
        eq.contactEquations.push(contact);
        eq.frictionCoefficient = contactMaterial.friction;
        eq.relativeVelocity = contactMaterial.surfaceVelocity;
        eq.stiffness = contactMaterial.frictionStiffness;
        eq.relaxation = contactMaterial.frictionRelaxation;
        eq.needsUpdate = true;
        eq.enabled = enabled;
        return eq;
    });
}
function $28966d70a7fe65ee$var$generateAverageFrictionEquationForCollision(collision, contactEquations, contactMaterial) {
    const eq = new (0, $0331ac7467aaeda3$export$aaf1bc25025a5803)(collision.bodyA, collision.bodyB, $28966d70a7fe65ee$var$INITIAL_SLIP_FORCE);
    eq.shapeA = collision.shapeA;
    eq.shapeB = collision.shapeB;
    eq.frictionCoefficient = contactMaterial.friction;
    eq.relativeVelocity = contactMaterial.surfaceVelocity;
    eq.stiffness = contactMaterial.frictionStiffness;
    eq.relaxation = contactMaterial.frictionRelaxation;
    // Only enable equations if all parties have collisionResponse enabled
    eq.enabled = collision.bodyA.collisionResponse && collision.bodyB.collisionResponse && collision.shapeA.collisionResponse && collision.shapeB.collisionResponse;
    eq.contactPointA.set(0, 0);
    eq.contactPointB.set(0, 0);
    eq.t.set(0, 0);
    for (const contact of contactEquations){
        if (contact.bodyA === collision.bodyA) {
            eq.t.iadd(contact.normalA);
            eq.contactPointA.iadd(contact.contactPointA);
            eq.contactPointB.iadd(contact.contactPointB);
        } else {
            eq.t.isub(contact.normalA);
            eq.contactPointA.iadd(contact.contactPointB);
            eq.contactPointB.iadd(contact.contactPointA);
        }
        eq.contactEquations.push(contact);
    }
    const invNumContacts = 1 / contactEquations.length;
    eq.contactPointA.imul(invNumContacts);
    eq.contactPointB.imul(invNumContacts);
    eq.t.inormalize();
    eq.t.irotate90cw();
    return eq;
}



/**
 * Gauss-Seidel Sequential Impulse (SI) constraint solver.
 *
 * This module implements an iterative Gauss-Seidel method for solving systems
 * of constraint equations in a rigid body physics simulation. The algorithm
 * is equivalent to projected Gauss-Seidel (PGS) — the standard approach used
 * by most real-time physics engines (Box2D, Bullet, etc.).
 *
 * ## Algorithm overview
 *
 * Given N constraint equations, each with a Jacobian row G_i, the solver
 * finds impulse magnitudes lambda_i that satisfy all constraints simultaneously
 * (within tolerance). On each iteration it sweeps through every equation and
 * computes an impulse correction:
 *
 *   delta_lambda_i = invC_i * (B_i - G_i * v_lambda - epsilon_i * lambda_i)
 *
 * where:
 *   - **lambda** is the accumulated constraint impulse (units: N*s = kg*m/s).
 *     Clamped to [minForce*dt, maxForce*dt] to enforce inequality constraints
 *     (e.g. contacts can push but not pull, friction is bounded).
 *   - **B** (the "right-hand side") encodes the constraint violation to be
 *     corrected this timestep. It combines three terms:
 *       B = -a * Gq - b * GW - h * GiMf
 *     where Gq is position error, GW is velocity error, and GiMf is the
 *     external-force contribution. The coefficients a, b come from the
 *     Baumgarte-like stabilization derived from stiffness/relaxation.
 *   - **invC** is the inverse effective mass for the constraint:
 *       invC = 1 / (G * M^-1 * G^T + epsilon)
 *     This is a scalar because each equation is 1-DOF.
 *   - **epsilon** is a compliance/regularization term (units: 1/(kg*m^2/s^2*s^2)
 *     effectively dimensionless after scaling). It softens the constraint,
 *     preventing the effective mass from becoming infinite or ill-conditioned
 *     when bodies have extreme mass ratios. Derived from stiffness and
 *     relaxation: epsilon = 4 / (h^2 * k * (1 + 4d)).
 *
 * After each equation update, the impulse is immediately applied to the
 * participating bodies' velocity accumulators (vlambda, wlambda), so
 * subsequent equations in the same iteration see the updated velocities.
 * This is what makes it "Gauss-Seidel" rather than "Jacobi".
 *
 * ## Per-body state storage
 *
 * The solver stores per-body scratch state (vlambda, wlambda, inverse mass,
 * inverse inertia) in a {@link SolverWorkspace}. Bodies are assigned integer
 * indices at the start of each solve; equations read/write the flat
 * Float64Arrays in the workspace by index. This replaces an earlier design
 * that used `Map<Body, SolverBodyState>` — the index-based layout removes
 * two Map lookups from the inner loop of every equation iteration.
 *
 * ## Friction pre-iterations
 *
 * Friction equations depend on the normal force magnitude from their
 * associated contact equations (Coulomb friction: |f_t| <= mu * |f_n|).
 * The `frictionIterations` parameter runs a preliminary solve pass to
 * estimate contact forces, then updates friction bounds before the main
 * solve. Without this, friction limits on the first iteration would use
 * stale or zero normal force estimates, leading to sliding artifacts.
 *
 * ## Convergence
 *
 * The solver terminates early when the total absolute change in lambda
 * across all equations falls below `tolerance` (squared comparison for
 * efficiency). This means the system has settled and further iterations
 * would produce negligible improvement.
 */ 
/**
 * Shape-specialized 2-body equation for **pure 2D rotational** constraints —
 * no linear contribution, and rotation only about the Z axis. The Jacobian
 * has the shape:
 *
 *   G = [ 0, 0, 0,  0, 0, angAz,   0, 0, 0,  0, 0, angBz ]
 *        └─ linA ─┘ └── angA ──┘ └─ linB ─┘ └── angB ──┘
 *
 * Unlike {@link AngularEquation3D} this is **not antisymmetric** — the two
 * angular scalars are stored independently so we can represent gear-ratio
 * style coupling (e.g. `angAz = ratio`, `angBz = -1`).
 *
 * ## Storage
 *
 * Two floats in named fields:
 *   - `angAz` — body A angular Z contribution
 *   - `angBz` — body B angular Z contribution
 *
 * ## When to use
 *
 * 2D angular constraints between two planar rigid bodies. Used by:
 *   - {@link RotationalLockEquation} — hard-limit on relative angle
 *   - {@link AngleLockEquation} — hinge limit with optional gear ratio
 *   - {@link RotationalVelocityEquation} — motor that drives a target angular velocity
 */ 

class $943ba62602b49937$export$3fce07844b86e138 extends (0, $0113af86cc04b089$export$9e6be560da9da590) {
    constructor(bodyA, bodyB, minForce = -Number.MAX_VALUE, maxForce = Number.MAX_VALUE){
        super(bodyA, bodyB, minForce, maxForce), /** Body A angular Z contribution. */ this.angAz = 0, /** Body B angular Z contribution. */ this.angBz = 0;
    }
    /** Position error. Owning constraints set `offset` each substep. */ computeGq() {
        return this.offset;
    }
    computeGW() {
        const wA = this.bodyA.angularVelocity3;
        const wB = this.bodyB.angularVelocity3;
        return this.angAz * wA[2] + this.angBz * wB[2] + this.relativeVelocity;
    }
    computeGWlambda(ws) {
        const iA = this[0, $d28dd663c1e16271$export$1d1b51a214a8f673] * 3;
        const iB = this[0, $d28dd663c1e16271$export$941aeb6a025e2399] * 3;
        const wl = ws.wlambda;
        return this.angAz * wl[iA + 2] + this.angBz * wl[iB + 2];
    }
    computeGiMf(ws) {
        const idxA = this[0, $d28dd663c1e16271$export$1d1b51a214a8f673];
        const idxB = this[0, $d28dd663c1e16271$export$941aeb6a025e2399];
        // Only the Z row of each body's world-frame inverse inertia matters,
        // because the angular Jacobian is pure Z.
        const iIA = ws.invInertia[idxA];
        const tA = this.bodyA.angularForce3;
        const aAz = iIA[6] * tA[0] + iIA[7] * tA[1] + iIA[8] * tA[2];
        const iIB = ws.invInertia[idxB];
        const tB = this.bodyB.angularForce3;
        const aBz = iIB[6] * tB[0] + iIB[7] * tB[1] + iIB[8] * tB[2];
        return this.angAz * aAz + this.angBz * aBz;
    }
    computeGiMGt(ws) {
        const idxA = this[0, $d28dd663c1e16271$export$1d1b51a214a8f673];
        const idxB = this[0, $d28dd663c1e16271$export$941aeb6a025e2399];
        const iIA = ws.invInertia[idxA];
        const iIB = ws.invInertia[idxB];
        // angAz² · invI_A[Z,Z] + angBz² · invI_B[Z,Z]
        return this.angAz * this.angAz * iIA[8] + this.angBz * this.angBz * iIB[8];
    }
    addToWlambda(deltalambda, ws) {
        const idxA = this[0, $d28dd663c1e16271$export$1d1b51a214a8f673];
        const idxB = this[0, $d28dd663c1e16271$export$941aeb6a025e2399];
        const iA = idxA * 3;
        const iB = idxB * 3;
        const wl = ws.wlambda;
        const dl = deltalambda;
        // Body A: wl += invI · (0,0,angAz*dl) — the Z column of invI scaled
        const iIA = ws.invInertia[idxA];
        const gAz = this.angAz * dl;
        wl[iA] += iIA[2] * gAz;
        wl[iA + 1] += iIA[5] * gAz;
        wl[iA + 2] += iIA[8] * gAz;
        // Body B
        const iIB = ws.invInertia[idxB];
        const gBz = this.angBz * dl;
        wl[iB] += iIB[2] * gBz;
        wl[iB + 1] += iIB[5] * gBz;
        wl[iB + 2] += iIB[8] * gBz;
        return this;
    }
}


/**
 * Shape-specialized 2-body equation for **pure 3D rotational** constraints —
 * no linear contribution on either body. The Jacobian has the shape:
 *
 *   G = [ 0, 0, 0,  cx, cy, cz,   0, 0, 0,  -cx, -cy, -cz ]
 *        └─ linA ─┘ └─── angA ───┘ └─ linB ─┘ └──── angB ────┘
 *
 * The angular contribution is **antisymmetric**: body A receives `+c` and
 * body B receives `-c` (typical of alignment-style constraints derived from
 * a dot-product that equals zero at rest).
 *
 * ## Storage
 *
 * Three floats in named fields instead of a 12-element `G`:
 *   - `cx, cy, cz` — the angular direction vector (A side positive, B negative)
 *
 * ## When to use
 *
 * Pure orientation coupling in 3D — no linear force is applied. Used by:
 *   - {@link AxisAlignmentEquation} — locks two world-frame axes perpendicular,
 *     the building block for a 3D revolute joint's axis alignment.
 *
 * Constraints that need to *both* translate and rotate two bodies (like a
 * generic 3D distance with lever arms on both ends) should use the base
 * {@link Equation} class, not this shape.
 */ 

class $db841a8c0b719e01$export$5056eba3315bf3f4 extends (0, $0113af86cc04b089$export$9e6be560da9da590) {
    constructor(bodyA, bodyB, minForce = -Number.MAX_VALUE, maxForce = Number.MAX_VALUE){
        super(bodyA, bodyB, minForce, maxForce), /** Angular direction vector. Body A gets `+c`, body B gets `-c`. */ this.cx = 0, this.cy = 0, this.cz = 0;
    }
    /** Position error. Owning constraints set `offset` each substep. */ computeGq() {
        return this.offset;
    }
    computeGW() {
        const wA = this.bodyA.angularVelocity3;
        const wB = this.bodyB.angularVelocity3;
        return this.cx * (wA[0] - wB[0]) + this.cy * (wA[1] - wB[1]) + this.cz * (wA[2] - wB[2]) + this.relativeVelocity;
    }
    computeGWlambda(ws) {
        const iA = this[0, $d28dd663c1e16271$export$1d1b51a214a8f673] * 3;
        const iB = this[0, $d28dd663c1e16271$export$941aeb6a025e2399] * 3;
        const wl = ws.wlambda;
        return this.cx * (wl[iA] - wl[iB]) + this.cy * (wl[iA + 1] - wl[iB + 1]) + this.cz * (wl[iA + 2] - wl[iB + 2]);
    }
    computeGiMf(ws) {
        const idxA = this[0, $d28dd663c1e16271$export$1d1b51a214a8f673];
        const idxB = this[0, $d28dd663c1e16271$export$941aeb6a025e2399];
        // Body A angular force through world-frame inverse inertia
        const iIA = ws.invInertia[idxA];
        const tA = this.bodyA.angularForce3;
        const aA0 = iIA[0] * tA[0] + iIA[1] * tA[1] + iIA[2] * tA[2];
        const aA1 = iIA[3] * tA[0] + iIA[4] * tA[1] + iIA[5] * tA[2];
        const aA2 = iIA[6] * tA[0] + iIA[7] * tA[1] + iIA[8] * tA[2];
        const iIB = ws.invInertia[idxB];
        const tB = this.bodyB.angularForce3;
        const aB0 = iIB[0] * tB[0] + iIB[1] * tB[1] + iIB[2] * tB[2];
        const aB1 = iIB[3] * tB[0] + iIB[4] * tB[1] + iIB[5] * tB[2];
        const aB2 = iIB[6] * tB[0] + iIB[7] * tB[1] + iIB[8] * tB[2];
        return this.cx * (aA0 - aB0) + this.cy * (aA1 - aB1) + this.cz * (aA2 - aB2);
    }
    computeGiMGt(ws) {
        const idxA = this[0, $d28dd663c1e16271$export$1d1b51a214a8f673];
        const idxB = this[0, $d28dd663c1e16271$export$941aeb6a025e2399];
        const cx = this.cx;
        const cy = this.cy;
        const cz = this.cz;
        // Body A: +c^T · invI_A · +c
        const iIA = ws.invInertia[idxA];
        let result = cx * (iIA[0] * cx + iIA[1] * cy + iIA[2] * cz) + cy * (iIA[3] * cx + iIA[4] * cy + iIA[5] * cz) + cz * (iIA[6] * cx + iIA[7] * cy + iIA[8] * cz);
        // Body B: (-c)^T · invI_B · (-c) — signs cancel, same quadratic form
        const iIB = ws.invInertia[idxB];
        result += cx * (iIB[0] * cx + iIB[1] * cy + iIB[2] * cz) + cy * (iIB[3] * cx + iIB[4] * cy + iIB[5] * cz) + cz * (iIB[6] * cx + iIB[7] * cy + iIB[8] * cz);
        return result;
    }
    addToWlambda(deltalambda, ws) {
        const idxA = this[0, $d28dd663c1e16271$export$1d1b51a214a8f673];
        const idxB = this[0, $d28dd663c1e16271$export$941aeb6a025e2399];
        const iA = idxA * 3;
        const iB = idxB * 3;
        const wl = ws.wlambda;
        const dl = deltalambda;
        // Body A: wl += invI_A · (+c) · dl
        const iIA = ws.invInertia[idxA];
        const gAx = this.cx * dl;
        const gAy = this.cy * dl;
        const gAz = this.cz * dl;
        wl[iA] += iIA[0] * gAx + iIA[1] * gAy + iIA[2] * gAz;
        wl[iA + 1] += iIA[3] * gAx + iIA[4] * gAy + iIA[5] * gAz;
        wl[iA + 2] += iIA[6] * gAx + iIA[7] * gAy + iIA[8] * gAz;
        // Body B: wl += invI_B · (-c) · dl
        const iIB = ws.invInertia[idxB];
        wl[iB] -= iIB[0] * gAx + iIB[1] * gAy + iIB[2] * gAz;
        wl[iB + 1] -= iIB[3] * gAx + iIB[4] * gAy + iIB[5] * gAz;
        wl[iB + 2] -= iIB[6] * gAx + iIB[7] * gAy + iIB[8] * gAz;
        return this;
    }
}




/**
 * Shape-specialized 2-body equation for **2D particle ↔ 2D particle**
 * constraints. Both bodies contribute only linear XY terms — no angular and
 * no Z. The Jacobian has the shape:
 *
 *   G = [ -nx, -ny, 0,  0, 0, 0,   nx, ny, 0,   0, 0, 0 ]
 *
 * Linear is symmetric by Newton's 3rd law: body A receives `-(nx, ny)`,
 * body B receives `+(nx, ny)`. Neither body contributes angular terms, so
 * the solver's specialized batch iterator never touches `wlambda` or
 * `invInertia` for these equations.
 *
 * ## Storage
 *
 * Two floats instead of a 12-element `G`:
 *   - `nx, ny` — the unit direction (body A side gets the negation)
 *
 * ## When to use
 *
 * 2D distance-like constraints where both bodies are particle-like
 * (`pm2d × pm2d`). Rope chain links between adjacent 2D rope particles.
 */ 

class $c4f03894cac5871e$export$632992fd3b57ba7 extends (0, $0113af86cc04b089$export$9e6be560da9da590) {
    constructor(bodyA, bodyB, minForce = -Number.MAX_VALUE, maxForce = Number.MAX_VALUE){
        super(bodyA, bodyB, minForce, maxForce), /** Unit direction vector `n`. Body A gets `-n`, body B gets `+n`. */ this.nx = 0, this.ny = 0;
    }
    computeGq() {
        return this.offset;
    }
    computeGW() {
        const a = this.bodyA;
        const b = this.bodyB;
        return this.nx * (b.velocity[0] - a.velocity[0]) + this.ny * (b.velocity[1] - a.velocity[1]) + this.relativeVelocity;
    }
    computeGWlambda(ws) {
        const iA = this[0, $d28dd663c1e16271$export$1d1b51a214a8f673] * 3;
        const iB = this[0, $d28dd663c1e16271$export$941aeb6a025e2399] * 3;
        const vl = ws.vlambda;
        return this.nx * (vl[iB] - vl[iA]) + this.ny * (vl[iB + 1] - vl[iA + 1]);
    }
    computeGiMf(ws) {
        const idxA = this[0, $d28dd663c1e16271$export$1d1b51a214a8f673];
        const idxB = this[0, $d28dd663c1e16271$export$941aeb6a025e2399];
        const iMA = ws.invMassSolve[idxA];
        const iMB = ws.invMassSolve[idxB];
        const a = this.bodyA;
        const b = this.bodyB;
        return this.nx * (b.force[0] * iMB - a.force[0] * iMA) + this.ny * (b.force[1] * iMB - a.force[1] * iMA);
    }
    computeGiMGt(ws) {
        const idxA = this[0, $d28dd663c1e16271$export$1d1b51a214a8f673];
        const idxB = this[0, $d28dd663c1e16271$export$941aeb6a025e2399];
        const iMA = ws.invMassSolve[idxA];
        const iMB = ws.invMassSolve[idxB];
        const n2 = this.nx * this.nx + this.ny * this.ny;
        return n2 * (iMA + iMB);
    }
    addToWlambda(deltalambda, ws) {
        const idxA = this[0, $d28dd663c1e16271$export$1d1b51a214a8f673];
        const idxB = this[0, $d28dd663c1e16271$export$941aeb6a025e2399];
        const iA = idxA * 3;
        const iB = idxB * 3;
        const vl = ws.vlambda;
        const iMA = ws.invMassSolve[idxA];
        const iMB = ws.invMassSolve[idxB];
        const dl = deltalambda;
        vl[iA] -= iMA * this.nx * dl;
        vl[iA + 1] -= iMA * this.ny * dl;
        vl[iB] += iMB * this.nx * dl;
        vl[iB + 1] += iMB * this.ny * dl;
        return this;
    }
}


/**
 * Shape-specialized 2-body equation where **both bodies are points** — they
 * contribute only linear terms, no angular. The Jacobian has the shape:
 *
 *   G = [ -nx, -ny, -nz,  0, 0, 0,   nx, ny, nz,  0, 0, 0 ]
 *        └──── linA ────┘ └─ angA ─┘ └──── linB ────┘ └─ angB ─┘
 *
 * The linear contribution is symmetric by Newton's 3rd law: body A receives
 * `-n`, body B receives `+n`. Both bodies' angular blocks are structurally
 * zero, and the solver's specialized batch iterator never touches `wlambda`
 * or `invInertia` for these equations at all.
 *
 * ## Storage
 *
 * Three floats in named fields instead of a 12-element `G`:
 *   - `nx, ny, nz` — the unit direction (body A side gets the negation)
 *
 * ## When to use
 *
 * 2-body constraints where both sides are particle-like (`fixedRotation` or
 * zero-moment-arm anchors). Used by:
 *   - {@link ParticleDistanceConstraint3D} — rope chain links between
 *     adjacent rope particles
 *
 * ## Position error
 *
 * `computeGq` returns the inherited `offset` field. Owning constraints set
 * `offset` in their `update()` method each substep (typically `currentDist -
 * targetDist` for distance constraints).
 */ 

class $c53593a95af5b97e$export$585406d705fecfce extends (0, $0113af86cc04b089$export$9e6be560da9da590) {
    constructor(bodyA, bodyB, minForce = -Number.MAX_VALUE, maxForce = Number.MAX_VALUE){
        super(bodyA, bodyB, minForce, maxForce), /** Unit direction vector `n`. Body A gets `-n`, body B gets `+n`. */ this.nx = 0, this.ny = 0, this.nz = 0;
    }
    /** Position error. Owning constraints set `offset` each substep. */ computeGq() {
        return this.offset;
    }
    /** Linear-only relative velocity: `n · (vB − vA)`. */ computeGW() {
        const a = this.bodyA;
        const b = this.bodyB;
        return this.nx * (b.velocity[0] - a.velocity[0]) + this.ny * (b.velocity[1] - a.velocity[1]) + this.nz * (b.zVelocity - a.zVelocity) + this.relativeVelocity;
    }
    /** Constraint-velocity from accumulated solver impulses: `n · (vlB − vlA)`. */ computeGWlambda(ws) {
        const iA = this[0, $d28dd663c1e16271$export$1d1b51a214a8f673] * 3;
        const iB = this[0, $d28dd663c1e16271$export$941aeb6a025e2399] * 3;
        const vl = ws.vlambda;
        return this.nx * (vl[iB] - vl[iA]) + this.ny * (vl[iB + 1] - vl[iA + 1]) + this.nz * (vl[iB + 2] - vl[iA + 2]);
    }
    /** External force contribution: linear only (no angular on either side). */ computeGiMf(ws) {
        const idxA = this[0, $d28dd663c1e16271$export$1d1b51a214a8f673];
        const idxB = this[0, $d28dd663c1e16271$export$941aeb6a025e2399];
        const iMA = ws.invMassSolve[idxA];
        const iMB = ws.invMassSolve[idxB];
        const iMzA = ws.invMassSolveZ[idxA];
        const iMzB = ws.invMassSolveZ[idxB];
        const a = this.bodyA;
        const b = this.bodyB;
        return this.nx * (b.force[0] * iMB - a.force[0] * iMA) + this.ny * (b.force[1] * iMB - a.force[1] * iMA) + this.nz * (b.zForce * iMzB - a.zForce * iMzA);
    }
    /**
   * Effective-mass denominator: `G · M^-1 · G^T`. Linear only.
   *   = (nx² + ny²)·(invMA + invMB) + nz²·(invMzA + invMzB)
   *
   * For isotropic bodies (`invM == invMz`) this further reduces to
   * `invMA + invMB`, but keeping the general form costs ~3 ops and handles
   * mixed-mass bodies correctly.
   */ computeGiMGt(ws) {
        const idxA = this[0, $d28dd663c1e16271$export$1d1b51a214a8f673];
        const idxB = this[0, $d28dd663c1e16271$export$941aeb6a025e2399];
        const iMA = ws.invMassSolve[idxA];
        const iMB = ws.invMassSolve[idxB];
        const iMzA = ws.invMassSolveZ[idxA];
        const iMzB = ws.invMassSolveZ[idxB];
        const nxy2 = this.nx * this.nx + this.ny * this.ny;
        const nz2 = this.nz * this.nz;
        return nxy2 * (iMA + iMB) + nz2 * (iMzA + iMzB);
    }
    /** Apply an impulse linearly only. Never touches `wlambda` or `invInertia`. */ addToWlambda(deltalambda, ws) {
        const idxA = this[0, $d28dd663c1e16271$export$1d1b51a214a8f673];
        const idxB = this[0, $d28dd663c1e16271$export$941aeb6a025e2399];
        const iA = idxA * 3;
        const iB = idxB * 3;
        const vl = ws.vlambda;
        const iMA = ws.invMassSolve[idxA];
        const iMB = ws.invMassSolve[idxB];
        const iMzA = ws.invMassSolveZ[idxA];
        const iMzB = ws.invMassSolveZ[idxB];
        const dl = deltalambda;
        vl[iA] -= iMA * this.nx * dl;
        vl[iA + 1] -= iMA * this.ny * dl;
        vl[iA + 2] -= iMzA * this.nz * dl;
        vl[iB] += iMB * this.nx * dl;
        vl[iB + 1] += iMB * this.ny * dl;
        vl[iB + 2] += iMzB * this.nz * dl;
        return this;
    }
}


/**
 * Shape-specialized 2-body equation for **2D particle (bodyA) ↔ 2D rigid
 * (bodyB)** constraints. Body A is a particle with only linear XY
 * contribution; body B is a rigid 2D body with linear XY + scalar yaw
 * angular contribution. The Jacobian has the shape:
 *
 *   G = [ -nx, -ny, 0,  0, 0, 0,   nx, ny, 0,   0, 0, rjCrossN ]
 *
 * Linear is symmetric by Newton's 3rd law (A gets `-n`, B gets `+n`). Body
 * A contributes no angular term; body B contributes a single scalar Z-axis
 * (`rjCrossN = rj × n` projected to Z).
 *
 * ## Storage
 *
 * Three floats instead of a 12-element `G`:
 *   - `nx, ny` — the unit direction (body A side gets the negation)
 *   - `rjCrossN` — body B scalar yaw angular contribution
 *
 * ## Convention
 *
 * **bodyA is always the particle, bodyB is always the rigid.** Constraints
 * that naturally have the point on side B should swap body order when
 * creating the equation so this invariant holds. This matches the
 * convention used by {@link PointToRigidEquation3D}.
 */ 

class $0db35f7ff61d3604$export$6a45afae7f6f373e extends (0, $0113af86cc04b089$export$9e6be560da9da590) {
    constructor(bodyA, bodyB, minForce = -Number.MAX_VALUE, maxForce = Number.MAX_VALUE){
        super(bodyA, bodyB, minForce, maxForce), /** Unit direction vector `n`. Body A gets `-n`, body B gets `+n`. */ this.nx = 0, this.ny = 0, /** Body B scalar yaw angular contribution: `(rj × n)` projected to Z. */ this.rjCrossN = 0;
    }
    computeGq() {
        return this.offset;
    }
    computeGW() {
        const a = this.bodyA;
        const b = this.bodyB;
        const wB = b.angularVelocity3;
        return this.nx * (b.velocity[0] - a.velocity[0]) + this.ny * (b.velocity[1] - a.velocity[1]) + this.rjCrossN * wB[2] + this.relativeVelocity;
    }
    computeGWlambda(ws) {
        const iA = this[0, $d28dd663c1e16271$export$1d1b51a214a8f673] * 3;
        const iB = this[0, $d28dd663c1e16271$export$941aeb6a025e2399] * 3;
        const vl = ws.vlambda;
        const wl = ws.wlambda;
        return this.nx * (vl[iB] - vl[iA]) + this.ny * (vl[iB + 1] - vl[iA + 1]) + this.rjCrossN * wl[iB + 2];
    }
    computeGiMf(ws) {
        const idxA = this[0, $d28dd663c1e16271$export$1d1b51a214a8f673];
        const idxB = this[0, $d28dd663c1e16271$export$941aeb6a025e2399];
        const iMA = ws.invMassSolve[idxA];
        const iMB = ws.invMassSolve[idxB];
        const a = this.bodyA;
        const b = this.bodyB;
        // Body B angular: only the Z row of invI matters (we multiply by
        // rjCrossN on the Z axis only).
        const iIB = ws.invInertia[idxB];
        const tB = b.angularForce3;
        const aBz = iIB[6] * tB[0] + iIB[7] * tB[1] + iIB[8] * tB[2];
        return this.nx * (b.force[0] * iMB - a.force[0] * iMA) + this.ny * (b.force[1] * iMB - a.force[1] * iMA) + this.rjCrossN * aBz;
    }
    computeGiMGt(ws) {
        const idxA = this[0, $d28dd663c1e16271$export$1d1b51a214a8f673];
        const idxB = this[0, $d28dd663c1e16271$export$941aeb6a025e2399];
        const iMA = ws.invMassSolve[idxA];
        const iMB = ws.invMassSolve[idxB];
        const n2 = this.nx * this.nx + this.ny * this.ny;
        let result = n2 * (iMA + iMB);
        // Body B angular on Z only: rjCrossN² * invI[Z,Z]
        const iIB = ws.invInertia[idxB];
        result += this.rjCrossN * this.rjCrossN * iIB[8];
        return result;
    }
    addToWlambda(deltalambda, ws) {
        const idxA = this[0, $d28dd663c1e16271$export$1d1b51a214a8f673];
        const idxB = this[0, $d28dd663c1e16271$export$941aeb6a025e2399];
        const iA = idxA * 3;
        const iB = idxB * 3;
        const vl = ws.vlambda;
        const wl = ws.wlambda;
        const iMA = ws.invMassSolve[idxA];
        const iMB = ws.invMassSolve[idxB];
        const dl = deltalambda;
        // Body A linear (-n)
        vl[iA] -= iMA * this.nx * dl;
        vl[iA + 1] -= iMA * this.ny * dl;
        // Body B linear (+n)
        vl[iB] += iMB * this.nx * dl;
        vl[iB + 1] += iMB * this.ny * dl;
        // Body B angular: wl += invI_col2 * (rjCrossN * dl)
        const iIB = ws.invInertia[idxB];
        const g = this.rjCrossN * dl;
        wl[iB] += iIB[2] * g;
        wl[iB + 1] += iIB[5] * g;
        wl[iB + 2] += iIB[8] * g;
        return this;
    }
}


/**
 * Shape-specialized 2-body equation where **body A is a point** (no angular
 * contribution) and **body B is a rigid body** with full linear + angular
 * response. The Jacobian has the shape:
 *
 *   G = [ -n, 0, n, rjXn ]
 *     └─ linA ─┘ └─ angA ─┘ └─ linB ─┘ └──── angB ────┘
 *
 * where `n` is a unit direction at the contact and `rjXn = rj × n` is the
 * cross product of body B's lever arm with `n`. Linear is symmetric (body A
 * receives `-n`, body B receives `+n`) by Newton's 3rd law. Body A's angular
 * block is structurally zero and never touched by the solver.
 *
 * ## Storage
 *
 * Only 6 floats are stored in named fields instead of a 12-element `G`:
 *   - `nx, ny, nz` — the unit direction (body A side gets the negation)
 *   - `rjXnX, rjXnY, rjXnZ` — body B angular contribution (`rj × n`)
 *
 * The base class's `G` Float32Array is inherited but unused; the 48-byte
 * overhead per equation is negligible and keeps the class hierarchy simple.
 *
 * ## When to use
 *
 * Any 2-body constraint where one side is a particle-like body (`fixedRotation`
 * or zero-moment-arm anchor) and the other side is a full rigid body. Examples:
 *   - Rope particle contacting a hull deck / wall
 *   - Rope endpoint chain links (particle to rigid attachment point)
 *   - Rope attached to a cleat on a rotating boat part
 *
 * **Convention**: the point-like body must always be `bodyA`. Constraints that
 * naturally have the point on side B should swap the body order when creating
 * the equation so this invariant holds. This lets the solver's specialized
 * batch iterator always skip angular-A work without a runtime branch.
 *
 * ## Position error
 *
 * `computeGq` returns the inherited `offset` field. Owning constraints set
 * `offset` in their `update()` method each substep (typically to a signed
 * distance or penetration depth). Friction-like equations that want pure
 * velocity constraints set `offset = 0`.
 */ 

class $7c2ab345e8402709$export$72aece4f82bc5bee extends (0, $0113af86cc04b089$export$9e6be560da9da590) {
    constructor(bodyA, bodyB, minForce = -Number.MAX_VALUE, maxForce = Number.MAX_VALUE){
        super(bodyA, bodyB, minForce, maxForce), /** Unit direction vector `n`. Body A gets `-n`, body B gets `+n`. */ this.nx = 0, this.ny = 0, this.nz = 0, /** Body B angular contribution: `rj × n`. */ this.rjXnX = 0, this.rjXnY = 0, this.rjXnZ = 0;
    }
    /** Position error. Owning constraints set `offset` each substep. */ computeGq() {
        return this.offset;
    }
    /** Relative velocity along the constraint direction. Linear A + linear B + angular B. */ computeGW() {
        const a = this.bodyA;
        const b = this.bodyB;
        const wB = b.angularVelocity3;
        return this.nx * (b.velocity[0] - a.velocity[0]) + this.ny * (b.velocity[1] - a.velocity[1]) + this.nz * (b.zVelocity - a.zVelocity) + this.rjXnX * wB[0] + this.rjXnY * wB[1] + this.rjXnZ * wB[2] + this.relativeVelocity;
    }
    /**
   * Constraint-velocity from accumulated solver impulses. Skips body A angular
   * (structurally zero).
   */ computeGWlambda(ws) {
        const iA = this[0, $d28dd663c1e16271$export$1d1b51a214a8f673] * 3;
        const iB = this[0, $d28dd663c1e16271$export$941aeb6a025e2399] * 3;
        const vl = ws.vlambda;
        const wl = ws.wlambda;
        return this.nx * (vl[iB] - vl[iA]) + this.ny * (vl[iB + 1] - vl[iA + 1]) + this.nz * (vl[iB + 2] - vl[iA + 2]) + this.rjXnX * wl[iB] + this.rjXnY * wl[iB + 1] + this.rjXnZ * wl[iB + 2];
    }
    /** External force contribution: linear A + linear B + angular B (no angular A). */ computeGiMf(ws) {
        const idxA = this[0, $d28dd663c1e16271$export$1d1b51a214a8f673];
        const idxB = this[0, $d28dd663c1e16271$export$941aeb6a025e2399];
        const iMA = ws.invMassSolve[idxA];
        const iMB = ws.invMassSolve[idxB];
        const iMzA = ws.invMassSolveZ[idxA];
        const iMzB = ws.invMassSolveZ[idxB];
        const a = this.bodyA;
        const b = this.bodyB;
        // Body B angular force through world-frame inverse inertia
        const iIB = ws.invInertia[idxB];
        const tB = b.angularForce3;
        const aB0 = iIB[0] * tB[0] + iIB[1] * tB[1] + iIB[2] * tB[2];
        const aB1 = iIB[3] * tB[0] + iIB[4] * tB[1] + iIB[5] * tB[2];
        const aB2 = iIB[6] * tB[0] + iIB[7] * tB[1] + iIB[8] * tB[2];
        return this.nx * (b.force[0] * iMB - a.force[0] * iMA) + this.ny * (b.force[1] * iMB - a.force[1] * iMA) + this.nz * (b.zForce * iMzB - a.zForce * iMzA) + this.rjXnX * aB0 + this.rjXnY * aB1 + this.rjXnZ * aB2;
    }
    /**
   * Effective-mass denominator: `G · M^-1 · G^T`. Linear contribution from both
   * bodies, angular contribution only from body B.
   */ computeGiMGt(ws) {
        const idxA = this[0, $d28dd663c1e16271$export$1d1b51a214a8f673];
        const idxB = this[0, $d28dd663c1e16271$export$941aeb6a025e2399];
        const iMA = ws.invMassSolve[idxA];
        const iMB = ws.invMassSolve[idxB];
        const iMzA = ws.invMassSolveZ[idxA];
        const iMzB = ws.invMassSolveZ[idxB];
        const nx = this.nx;
        const ny = this.ny;
        const nz = this.nz;
        const nxy2 = nx * nx + ny * ny;
        const nz2 = nz * nz;
        let result = nxy2 * (iMA + iMB) + nz2 * (iMzA + iMzB);
        // Body B angular: (rjXn)^T · invI · (rjXn)
        const iIB = ws.invInertia[idxB];
        const g0 = this.rjXnX;
        const g1 = this.rjXnY;
        const g2 = this.rjXnZ;
        result += g0 * (iIB[0] * g0 + iIB[1] * g1 + iIB[2] * g2) + g1 * (iIB[3] * g0 + iIB[4] * g1 + iIB[5] * g2) + g2 * (iIB[6] * g0 + iIB[7] * g1 + iIB[8] * g2);
        return result;
    }
    /**
   * Apply an impulse: linear to both bodies, angular only to body B. Body A
   * angular (`wlambda[iA..iA+2]`) is left untouched.
   */ addToWlambda(deltalambda, ws) {
        const idxA = this[0, $d28dd663c1e16271$export$1d1b51a214a8f673];
        const idxB = this[0, $d28dd663c1e16271$export$941aeb6a025e2399];
        const iA = idxA * 3;
        const iB = idxB * 3;
        const vl = ws.vlambda;
        const wl = ws.wlambda;
        const iMA = ws.invMassSolve[idxA];
        const iMB = ws.invMassSolve[idxB];
        const iMzA = ws.invMassSolveZ[idxA];
        const iMzB = ws.invMassSolveZ[idxB];
        const dl = deltalambda;
        // Body A linear (-n direction)
        vl[iA] -= iMA * this.nx * dl;
        vl[iA + 1] -= iMA * this.ny * dl;
        vl[iA + 2] -= iMzA * this.nz * dl;
        // Body B linear (+n direction)
        vl[iB] += iMB * this.nx * dl;
        vl[iB + 1] += iMB * this.ny * dl;
        vl[iB + 2] += iMzB * this.nz * dl;
        // Body B angular through world-frame inverse inertia
        const iIB = ws.invInertia[idxB];
        const g0 = this.rjXnX * dl;
        const g1 = this.rjXnY * dl;
        const g2 = this.rjXnZ * dl;
        wl[iB] += iIB[0] * g0 + iIB[1] * g1 + iIB[2] * g2;
        wl[iB + 1] += iIB[3] * g0 + iIB[4] * g1 + iIB[5] * g2;
        wl[iB + 2] += iIB[6] * g0 + iIB[7] * g1 + iIB[8] * g2;
        return this;
    }
}


/**
 * 3-body constraint equation for a pulley/block.
 *
 * Enforces: |rA - rP| + |rP - rB| ≤ totalLength
 *
 * Where rA, rP, rB are the world-space anchor positions on bodyA (particle),
 * bodyC (pulley/block body), and bodyB (particle) respectively.
 *
 * The Jacobian has 18 elements (6 per body × 3 bodies) instead of the
 * base class's 12. All compute/apply methods are overridden to include
 * bodyC's contributions. The GSSolver only calls virtual methods, so
 * this slots into the existing solver without modification.
 */ 

class $4cbe2797c05b4302$export$ceac37790edf003 extends (0, $0113af86cc04b089$export$9e6be560da9da590) {
    constructor(bodyA, bodyB, bodyC){
        super(bodyA, bodyB), /**
   * Extended Jacobian: 18 elements.
   * [bodyA linear(3), bodyA angular(3),
   *  bodyC linear(3), bodyC angular(3),
   *  bodyB linear(3), bodyB angular(3)]
   */ this.G18 = new Float64Array(18), /** Workspace row index for bodyC during the current solve. */ this[0, $d28dd663c1e16271$export$b0ca2c790f54fca9] = -1;
        this.bodyC = bodyC;
    }
    assignIndices(ws) {
        super.assignIndices(ws);
        this[0, $d28dd663c1e16271$export$b0ca2c790f54fca9] = ws.indexOf(this.bodyC);
    }
    /**
   * Fill the 18-element Jacobian from pre-computed directions and lever arms.
   * Called by PulleyConstraint3D.update().
   */ setJacobian(// Unit direction from pulley toward A
    nAx, nAy, nAz, // Unit direction from pulley toward B
    nBx, nBy, nBz, // Lever arm: world anchor A minus bodyA center
    rAx, rAy, rAz, // Lever arm: world pulley anchor minus bodyC center
    rCx, rCy, rCz, // Lever arm: world anchor B minus bodyB center
    rBx, rBy, rBz) {
        const G = this.G18;
        // Body A: pulled toward pulley → force direction = nA
        G[0] = nAx;
        G[1] = nAy;
        G[2] = nAz;
        // Body A angular: rA × nA
        G[3] = rAy * nAz - rAz * nAy;
        G[4] = rAz * nAx - rAx * nAz;
        G[5] = rAx * nAy - rAy * nAx;
        // Body C (pulley): receives resultant = -nA - nB
        const cLx = -nAx - nBx;
        const cLy = -nAy - nBy;
        const cLz = -nAz - nBz;
        G[6] = cLx;
        G[7] = cLy;
        G[8] = cLz;
        // Body C angular: rC × (-nA - nB)
        G[9] = rCy * cLz - rCz * cLy;
        G[10] = rCz * cLx - rCx * cLz;
        G[11] = rCx * cLy - rCy * cLx;
        // Body B: pulled toward pulley → force direction = nB
        G[12] = nBx;
        G[13] = nBy;
        G[14] = nBz;
        // Body B angular: rB × nB
        G[15] = rBy * nBz - rBz * nBy;
        G[16] = rBz * nBx - rBx * nBz;
        G[17] = rBx * nBy - rBy * nBx;
    }
    // ---- Override all virtual methods to use G18 and 3 bodies ----
    computeGW() {
        const G = this.G18;
        const a = this.bodyA;
        const c = this.bodyC;
        const b = this.bodyB;
        const wA = a.angularVelocity3;
        const wC = c.angularVelocity3;
        const wB = b.angularVelocity3;
        return G[0] * a.velocity[0] + G[1] * a.velocity[1] + G[2] * a.zVelocity + G[3] * wA[0] + G[4] * wA[1] + G[5] * wA[2] + G[6] * c.velocity[0] + G[7] * c.velocity[1] + G[8] * c.zVelocity + G[9] * wC[0] + G[10] * wC[1] + G[11] * wC[2] + G[12] * b.velocity[0] + G[13] * b.velocity[1] + G[14] * b.zVelocity + G[15] * wB[0] + G[16] * wB[1] + G[17] * wB[2] + this.relativeVelocity;
    }
    computeGWlambda(ws) {
        const G = this.G18;
        const iA = this[0, $d28dd663c1e16271$export$1d1b51a214a8f673] * 3;
        const iC = this[0, $d28dd663c1e16271$export$b0ca2c790f54fca9] * 3;
        const iB = this[0, $d28dd663c1e16271$export$941aeb6a025e2399] * 3;
        const vl = ws.vlambda;
        const wl = ws.wlambda;
        return G[0] * vl[iA] + G[1] * vl[iA + 1] + G[2] * vl[iA + 2] + G[3] * wl[iA] + G[4] * wl[iA + 1] + G[5] * wl[iA + 2] + G[6] * vl[iC] + G[7] * vl[iC + 1] + G[8] * vl[iC + 2] + G[9] * wl[iC] + G[10] * wl[iC + 1] + G[11] * wl[iC + 2] + G[12] * vl[iB] + G[13] * vl[iB + 1] + G[14] * vl[iB + 2] + G[15] * wl[iB] + G[16] * wl[iB + 1] + G[17] * wl[iB + 2];
    }
    computeGiMf(ws) {
        const G = this.G18;
        const a = this.bodyA;
        const c = this.bodyC;
        const b = this.bodyB;
        const idxA = this[0, $d28dd663c1e16271$export$1d1b51a214a8f673];
        const idxC = this[0, $d28dd663c1e16271$export$b0ca2c790f54fca9];
        const idxB = this[0, $d28dd663c1e16271$export$941aeb6a025e2399];
        const invMassSolve = ws.invMassSolve;
        const invMassSolveZ = ws.invMassSolveZ;
        const invInertia = ws.invInertia;
        // Body A: invI_world * torque3
        const iIA = invInertia[idxA];
        const tA = a.angularForce3;
        const aA0 = iIA[0] * tA[0] + iIA[1] * tA[1] + iIA[2] * tA[2];
        const aA1 = iIA[3] * tA[0] + iIA[4] * tA[1] + iIA[5] * tA[2];
        const aA2 = iIA[6] * tA[0] + iIA[7] * tA[1] + iIA[8] * tA[2];
        // Body C: invI_world * torque3
        const iIC = invInertia[idxC];
        const tC = c.angularForce3;
        const aC0 = iIC[0] * tC[0] + iIC[1] * tC[1] + iIC[2] * tC[2];
        const aC1 = iIC[3] * tC[0] + iIC[4] * tC[1] + iIC[5] * tC[2];
        const aC2 = iIC[6] * tC[0] + iIC[7] * tC[1] + iIC[8] * tC[2];
        // Body B: invI_world * torque3
        const iIB = invInertia[idxB];
        const tB = b.angularForce3;
        const aB0 = iIB[0] * tB[0] + iIB[1] * tB[1] + iIB[2] * tB[2];
        const aB1 = iIB[3] * tB[0] + iIB[4] * tB[1] + iIB[5] * tB[2];
        const aB2 = iIB[6] * tB[0] + iIB[7] * tB[1] + iIB[8] * tB[2];
        return G[0] * a.force[0] * invMassSolve[idxA] + G[1] * a.force[1] * invMassSolve[idxA] + G[2] * a.zForce * invMassSolveZ[idxA] + G[3] * aA0 + G[4] * aA1 + G[5] * aA2 + G[6] * c.force[0] * invMassSolve[idxC] + G[7] * c.force[1] * invMassSolve[idxC] + G[8] * c.zForce * invMassSolveZ[idxC] + G[9] * aC0 + G[10] * aC1 + G[11] * aC2 + G[12] * b.force[0] * invMassSolve[idxB] + G[13] * b.force[1] * invMassSolve[idxB] + G[14] * b.zForce * invMassSolveZ[idxB] + G[15] * aB0 + G[16] * aB1 + G[17] * aB2;
    }
    computeGiMGt(ws) {
        const G = this.G18;
        const idxA = this[0, $d28dd663c1e16271$export$1d1b51a214a8f673];
        const idxC = this[0, $d28dd663c1e16271$export$b0ca2c790f54fca9];
        const idxB = this[0, $d28dd663c1e16271$export$941aeb6a025e2399];
        const iMA = ws.invMassSolve[idxA];
        const iMC = ws.invMassSolve[idxC];
        const iMB = ws.invMassSolve[idxB];
        const iMzA = ws.invMassSolveZ[idxA];
        const iMzC = ws.invMassSolveZ[idxC];
        const iMzB = ws.invMassSolveZ[idxB];
        // Body A linear
        let result = G[0] * G[0] * iMA + G[1] * G[1] * iMA + G[2] * G[2] * iMzA;
        // Body A angular: G_ang^T * invI * G_ang
        const iIA = ws.invInertia[idxA];
        result += G[3] * (iIA[0] * G[3] + iIA[1] * G[4] + iIA[2] * G[5]) + G[4] * (iIA[3] * G[3] + iIA[4] * G[4] + iIA[5] * G[5]) + G[5] * (iIA[6] * G[3] + iIA[7] * G[4] + iIA[8] * G[5]);
        // Body C linear
        result += G[6] * G[6] * iMC + G[7] * G[7] * iMC + G[8] * G[8] * iMzC;
        // Body C angular
        const iIC = ws.invInertia[idxC];
        result += G[9] * (iIC[0] * G[9] + iIC[1] * G[10] + iIC[2] * G[11]) + G[10] * (iIC[3] * G[9] + iIC[4] * G[10] + iIC[5] * G[11]) + G[11] * (iIC[6] * G[9] + iIC[7] * G[10] + iIC[8] * G[11]);
        // Body B linear
        result += G[12] * G[12] * iMB + G[13] * G[13] * iMB + G[14] * G[14] * iMzB;
        // Body B angular
        const iIB = ws.invInertia[idxB];
        result += G[15] * (iIB[0] * G[15] + iIB[1] * G[16] + iIB[2] * G[17]) + G[16] * (iIB[3] * G[15] + iIB[4] * G[16] + iIB[5] * G[17]) + G[17] * (iIB[6] * G[15] + iIB[7] * G[16] + iIB[8] * G[17]);
        return result;
    }
    addToWlambda(deltalambda, ws) {
        const G = this.G18;
        const dl = deltalambda;
        const idxA = this[0, $d28dd663c1e16271$export$1d1b51a214a8f673];
        const idxC = this[0, $d28dd663c1e16271$export$b0ca2c790f54fca9];
        const idxB = this[0, $d28dd663c1e16271$export$941aeb6a025e2399];
        const iA = idxA * 3;
        const iCoff = idxC * 3;
        const iB = idxB * 3;
        const vl = ws.vlambda;
        const wl = ws.wlambda;
        const iMA = ws.invMassSolve[idxA];
        const iMC = ws.invMassSolve[idxC];
        const iMB = ws.invMassSolve[idxB];
        const iMzA = ws.invMassSolveZ[idxA];
        const iMzC = ws.invMassSolveZ[idxC];
        const iMzB = ws.invMassSolveZ[idxB];
        // Body A linear
        vl[iA] += iMA * G[0] * dl;
        vl[iA + 1] += iMA * G[1] * dl;
        vl[iA + 2] += iMzA * G[2] * dl;
        // Body A angular
        const iIA = ws.invInertia[idxA];
        const gA3 = G[3] * dl;
        const gA4 = G[4] * dl;
        const gA5 = G[5] * dl;
        wl[iA] += iIA[0] * gA3 + iIA[1] * gA4 + iIA[2] * gA5;
        wl[iA + 1] += iIA[3] * gA3 + iIA[4] * gA4 + iIA[5] * gA5;
        wl[iA + 2] += iIA[6] * gA3 + iIA[7] * gA4 + iIA[8] * gA5;
        // Body C linear
        vl[iCoff] += iMC * G[6] * dl;
        vl[iCoff + 1] += iMC * G[7] * dl;
        vl[iCoff + 2] += iMzC * G[8] * dl;
        // Body C angular
        const iIC = ws.invInertia[idxC];
        const gC9 = G[9] * dl;
        const gC10 = G[10] * dl;
        const gC11 = G[11] * dl;
        wl[iCoff] += iIC[0] * gC9 + iIC[1] * gC10 + iIC[2] * gC11;
        wl[iCoff + 1] += iIC[3] * gC9 + iIC[4] * gC10 + iIC[5] * gC11;
        wl[iCoff + 2] += iIC[6] * gC9 + iIC[7] * gC10 + iIC[8] * gC11;
        // Body B linear
        vl[iB] += iMB * G[12] * dl;
        vl[iB + 1] += iMB * G[13] * dl;
        vl[iB + 2] += iMzB * G[14] * dl;
        // Body B angular
        const iIB = ws.invInertia[idxB];
        const gB15 = G[15] * dl;
        const gB16 = G[16] * dl;
        const gB17 = G[17] * dl;
        wl[iB] += iIB[0] * gB15 + iIB[1] * gB16 + iIB[2] * gB17;
        wl[iB + 1] += iIB[3] * gB15 + iIB[4] * gB16 + iIB[5] * gB17;
        wl[iB + 2] += iIB[6] * gB15 + iIB[7] * gB16 + iIB[8] * gB17;
        return this;
    }
}



const $cc24bdd8dd0c74ab$export$b41695af87c85f04 = {
    iterations: 20,
    tolerance: 1e-3,
    frictionIterations: 0,
    useZeroRHS: false,
    equationSortFunction: (a, b)=>a.solverOrder - b.solverOrder
};
function $cc24bdd8dd0c74ab$export$754399b061a0a10b(equations, dynamicBodies, workspace) {
    workspace.reset();
    for (const body of dynamicBodies)workspace.registerDynamic(body);
    const Neq = equations.length;
    const generalEquations = workspace.generalEquations;
    const pulleyEquations = workspace.pulleyEquations;
    const pointToPointEquations = workspace.pointToPointEquations;
    const pointToRigidEquations = workspace.pointToRigidEquations;
    const pointToPoint2DEquations = workspace.pointToPoint2DEquations;
    const pointToRigid2DEquations = workspace.pointToRigid2DEquations;
    const planar2DEquations = workspace.planar2DEquations;
    const angular3DEquations = workspace.angular3DEquations;
    const angular2DEquations = workspace.angular2DEquations;
    for(let i = 0; i < Neq; i++){
        const eq = equations[i];
        eq.assignIndices(workspace);
        // Each equation gets a stable slot in Bs/invCs/lambda, independent of
        // which partitioned group it ends up in.
        eq[0, $d28dd663c1e16271$export$d8a965ecb4c5b716] = i;
        // Partition by Jacobian shape. Most specific first — PulleyEquation is
        // checked before its ancestor shapes (none apply), but the other shape
        // classes don't have subclass relationships so order only matters for
        // readability.
        if (eq instanceof (0, $c53593a95af5b97e$export$585406d705fecfce)) pointToPointEquations.push(eq);
        else if (eq instanceof (0, $7c2ab345e8402709$export$72aece4f82bc5bee)) pointToRigidEquations.push(eq);
        else if (eq instanceof (0, $c4f03894cac5871e$export$632992fd3b57ba7)) pointToPoint2DEquations.push(eq);
        else if (eq instanceof (0, $0db35f7ff61d3604$export$6a45afae7f6f373e)) pointToRigid2DEquations.push(eq);
        else if (eq instanceof (0, $a406b5b317398f9e$export$87c9791c969e8729)) planar2DEquations.push(eq);
        else if (eq instanceof (0, $db841a8c0b719e01$export$5056eba3315bf3f4)) angular3DEquations.push(eq);
        else if (eq instanceof (0, $943ba62602b49937$export$3fce07844b86e138)) angular2DEquations.push(eq);
        else if (eq instanceof (0, $4cbe2797c05b4302$export$ceac37790edf003)) pulleyEquations.push(eq);
        else generalEquations.push(eq);
    }
    workspace.ensureEqCapacity(Neq);
}
function $cc24bdd8dd0c74ab$export$6a40b5454173f07a(equations, h, config, workspace) {
    const { iterations: iterations, tolerance: tolerance, frictionIterations: frictionIterations, useZeroRHS: useZeroRHS } = config;
    (0, $5a1d1d3ab1ff9c51$export$e8e2fad003b4d4ce).start("Solver.setup");
    const Neq = equations.length;
    if (Neq === 0) {
        (0, $5a1d1d3ab1ff9c51$export$e8e2fad003b4d4ce).end("Solver.setup");
        return {
            usedIterations: 0
        };
    }
    const tolSquared = tolerance ** 2;
    let usedIterations = 0;
    // Zero the per-substep accumulators. Indices and per-body inverse mass
    // data are preserved from prepareSolverStep.
    workspace.resetAccumulators();
    const lambda = workspace.lambda;
    const Bs = workspace.Bs;
    const invCs = workspace.invCs;
    lambda.fill(0, 0, Neq);
    // Prepare equations - compute B and invC values. Each shape group gets
    // its own per-shape batch function so the `computeB` / `computeInvC` call
    // sites inside are monomorphic and V8 can inline the override chain
    // (computeGq / computeGW / computeGiMf / computeGiMGt). A single generic
    // helper won't work: V8 compiles one bytecode for the helper with shared
    // ICs, which go megamorphic once it's called with multiple shape types.
    $cc24bdd8dd0c74ab$var$setupPointToPointBatch(workspace.pointToPointEquations, h, Bs, invCs, workspace);
    $cc24bdd8dd0c74ab$var$setupPointToRigidBatch(workspace.pointToRigidEquations, h, Bs, invCs, workspace);
    $cc24bdd8dd0c74ab$var$setupPointToPoint2DBatch(workspace.pointToPoint2DEquations, h, Bs, invCs, workspace);
    $cc24bdd8dd0c74ab$var$setupPointToRigid2DBatch(workspace.pointToRigid2DEquations, h, Bs, invCs, workspace);
    $cc24bdd8dd0c74ab$var$setupPlanar2DBatch(workspace.planar2DEquations, h, Bs, invCs, workspace);
    $cc24bdd8dd0c74ab$var$setupAngular3DBatch(workspace.angular3DEquations, h, Bs, invCs, workspace);
    $cc24bdd8dd0c74ab$var$setupAngular2DBatch(workspace.angular2DEquations, h, Bs, invCs, workspace);
    $cc24bdd8dd0c74ab$var$setupPulleyBatch(workspace.pulleyEquations, h, Bs, invCs, workspace);
    $cc24bdd8dd0c74ab$var$setupGeneralBatch(workspace.generalEquations, h, Bs, invCs, workspace);
    (0, $5a1d1d3ab1ff9c51$export$e8e2fad003b4d4ce).end("Solver.setup");
    (0, $5a1d1d3ab1ff9c51$export$e8e2fad003b4d4ce).start("Solver.warmStart");
    // Warm start: initialize lambda from the cached solution (previous frame
    // on substep 0, previous substep thereafter) and pre-apply the cached
    // impulses to body velocity deltas. Partitioned per shape so `addToWlambda`
    // is monomorphic and inlineable at each call site.
    $cc24bdd8dd0c74ab$var$warmStartPointToPointBatch(workspace.pointToPointEquations, h, lambda, workspace);
    $cc24bdd8dd0c74ab$var$warmStartPointToRigidBatch(workspace.pointToRigidEquations, h, lambda, workspace);
    $cc24bdd8dd0c74ab$var$warmStartPointToPoint2DBatch(workspace.pointToPoint2DEquations, h, lambda, workspace);
    $cc24bdd8dd0c74ab$var$warmStartPointToRigid2DBatch(workspace.pointToRigid2DEquations, h, lambda, workspace);
    $cc24bdd8dd0c74ab$var$warmStartPlanar2DBatch(workspace.planar2DEquations, h, lambda, workspace);
    $cc24bdd8dd0c74ab$var$warmStartAngular3DBatch(workspace.angular3DEquations, h, lambda, workspace);
    $cc24bdd8dd0c74ab$var$warmStartAngular2DBatch(workspace.angular2DEquations, h, lambda, workspace);
    $cc24bdd8dd0c74ab$var$warmStartPulleyBatch(workspace.pulleyEquations, h, lambda, workspace);
    $cc24bdd8dd0c74ab$var$warmStartGeneralBatch(workspace.generalEquations, h, lambda, workspace);
    (0, $5a1d1d3ab1ff9c51$export$e8e2fad003b4d4ce).end("Solver.warmStart");
    // Optional friction pre-iteration phase
    if (frictionIterations > 0) {
        for(let iter = 0; iter < frictionIterations; iter++){
            const deltaTot = $cc24bdd8dd0c74ab$var$runIteration(Bs, invCs, lambda, useZeroRHS, h, workspace);
            usedIterations++;
            if (deltaTot * deltaTot <= tolSquared) break;
        }
        $cc24bdd8dd0c74ab$var$updateMultipliers(equations, lambda, 1 / h);
        $cc24bdd8dd0c74ab$var$updateFrictionBounds(equations);
    }
    // Main iteration phase
    (0, $5a1d1d3ab1ff9c51$export$e8e2fad003b4d4ce).start("Solver.iterate");
    for(let iter = 0; iter < iterations; iter++){
        const deltaTot = $cc24bdd8dd0c74ab$var$runIteration(Bs, invCs, lambda, useZeroRHS, h, workspace);
        usedIterations++;
        if (deltaTot * deltaTot <= tolSquared) break;
    }
    (0, $5a1d1d3ab1ff9c51$export$e8e2fad003b4d4ce).end("Solver.iterate");
    (0, $5a1d1d3ab1ff9c51$export$e8e2fad003b4d4ce).start("Solver.finalize");
    // Apply constraint velocities to dynamic bodies. The workspace's parallel
    // dynamicBodies/dynamicBodyIndices arrays give us each dynamic body along
    // with its slot in the flat vlambda/wlambda arrays.
    const dynBodies = workspace.dynamicBodies;
    const dynIdx = workspace.dynamicBodyIndices;
    const vl = workspace.vlambda;
    const wl = workspace.wlambda;
    const dynCount = dynBodies.length;
    for(let i = 0; i < dynCount; i++){
        const body = dynBodies[i];
        const base = dynIdx[i] * 3;
        // Linear velocity (x, y always; z only for 6DOF)
        body.velocity.x += vl[base];
        body.velocity.y += vl[base + 1];
        // Angular velocity (all 3 axes via the 3-vector)
        const av = body.angularVelocity3;
        av[0] += wl[base];
        av[1] += wl[base + 1];
        av[2] += wl[base + 2];
        // Z velocity. For 2D bodies (pm2d/rigid2d) invMassSolveZ is 0 so the
        // solver never writes to vlambda[base+2] and this is a no-op. For any
        // 3D body (pm3d or rigid3d) invMassSolveZ is non-zero and this is where
        // Z-axis constraint impulses land. The previous `is6DOF` gate dropped
        // Z-impulses on pm3d bodies, causing sailor/rope particles to fall
        // through constraints.
        body.zVelocity += vl[base + 2];
    }
    // Cache lambda for warm starting next frame, then update multipliers.
    // Disabled equations retain their previous warmLambda / multiplier so
    // game code reading those fields sees stable values. Partitioned per
    // shape so the field reads/writes are monomorphic.
    const invDt = 1 / h;
    $cc24bdd8dd0c74ab$var$finalizePointToPointBatch(workspace.pointToPointEquations, lambda, invDt);
    $cc24bdd8dd0c74ab$var$finalizePointToRigidBatch(workspace.pointToRigidEquations, lambda, invDt);
    $cc24bdd8dd0c74ab$var$finalizePointToPoint2DBatch(workspace.pointToPoint2DEquations, lambda, invDt);
    $cc24bdd8dd0c74ab$var$finalizePointToRigid2DBatch(workspace.pointToRigid2DEquations, lambda, invDt);
    $cc24bdd8dd0c74ab$var$finalizePlanar2DBatch(workspace.planar2DEquations, lambda, invDt);
    $cc24bdd8dd0c74ab$var$finalizeAngular3DBatch(workspace.angular3DEquations, lambda, invDt);
    $cc24bdd8dd0c74ab$var$finalizeAngular2DBatch(workspace.angular2DEquations, lambda, invDt);
    $cc24bdd8dd0c74ab$var$finalizePulleyBatch(workspace.pulleyEquations, lambda, invDt);
    $cc24bdd8dd0c74ab$var$finalizeGeneralBatch(workspace.generalEquations, lambda, invDt);
    (0, $5a1d1d3ab1ff9c51$export$e8e2fad003b4d4ce).end("Solver.finalize");
    return {
        usedIterations: usedIterations
    };
}
function $cc24bdd8dd0c74ab$export$ca8510321a6d54(equations, dynamicBodies, h, config, workspace) {
    // Sort if configured
    if (config.equationSortFunction) equations = equations.toSorted(config.equationSortFunction);
    $cc24bdd8dd0c74ab$export$754399b061a0a10b(equations, dynamicBodies, workspace);
    return $cc24bdd8dd0c74ab$export$6a40b5454173f07a(equations, h, config, workspace);
}
function $cc24bdd8dd0c74ab$export$6b7cd7c22cb50dd4(island, h, config, workspace) {
    // Extract dynamic bodies from island
    const dynamicBodies = [];
    for (const body of island.bodies)if (body.motion === "dynamic") dynamicBodies.push(body);
    return $cc24bdd8dd0c74ab$export$ca8510321a6d54(island.equations, dynamicBodies, h, config, workspace);
}
// --- Helper Functions ---
// --- Per-shape setup / warmStart / finalize batch functions ---
//
// Each of these is a separate top-level function so V8 compiles it with its
// own inline-cache feedback. Because each function is only ever called with
// equations of a single concrete shape, the `eq.computeB` / `eq.addToWlambda`
// / field-access sites inside stay monomorphic, and V8 can inline the shape
// override. A single generic helper called 7 times would share one bytecode
// with megamorphic ICs — which is what we started with.
//
// The bodies are intentionally identical across shapes. Don't try to DRY them
// by factoring into a generic helper; that defeats the whole point.
function $cc24bdd8dd0c74ab$var$setupPointToPointBatch(eqs, h, Bs, invCs, ws) {
    for(let i = 0; i < eqs.length; i++){
        const eq = eqs[i];
        if (!eq.enabled) continue;
        if (eq.timeStep !== h || eq.needsUpdate) {
            eq.timeStep = h;
            eq.update();
        }
        const slot = eq[0, $d28dd663c1e16271$export$d8a965ecb4c5b716];
        Bs[slot] = eq.computeB(eq.a, eq.b, h, ws);
        invCs[slot] = eq.computeInvC(eq.epsilon, ws);
    }
}
function $cc24bdd8dd0c74ab$var$setupPointToRigidBatch(eqs, h, Bs, invCs, ws) {
    for(let i = 0; i < eqs.length; i++){
        const eq = eqs[i];
        if (!eq.enabled) continue;
        if (eq.timeStep !== h || eq.needsUpdate) {
            eq.timeStep = h;
            eq.update();
        }
        const slot = eq[0, $d28dd663c1e16271$export$d8a965ecb4c5b716];
        Bs[slot] = eq.computeB(eq.a, eq.b, h, ws);
        invCs[slot] = eq.computeInvC(eq.epsilon, ws);
    }
}
function $cc24bdd8dd0c74ab$var$setupPlanar2DBatch(eqs, h, Bs, invCs, ws) {
    for(let i = 0; i < eqs.length; i++){
        const eq = eqs[i];
        if (!eq.enabled) continue;
        if (eq.timeStep !== h || eq.needsUpdate) {
            eq.timeStep = h;
            eq.update();
        }
        const slot = eq[0, $d28dd663c1e16271$export$d8a965ecb4c5b716];
        Bs[slot] = eq.computeB(eq.a, eq.b, h, ws);
        invCs[slot] = eq.computeInvC(eq.epsilon, ws);
    }
}
function $cc24bdd8dd0c74ab$var$setupAngular3DBatch(eqs, h, Bs, invCs, ws) {
    for(let i = 0; i < eqs.length; i++){
        const eq = eqs[i];
        if (!eq.enabled) continue;
        if (eq.timeStep !== h || eq.needsUpdate) {
            eq.timeStep = h;
            eq.update();
        }
        const slot = eq[0, $d28dd663c1e16271$export$d8a965ecb4c5b716];
        Bs[slot] = eq.computeB(eq.a, eq.b, h, ws);
        invCs[slot] = eq.computeInvC(eq.epsilon, ws);
    }
}
function $cc24bdd8dd0c74ab$var$setupAngular2DBatch(eqs, h, Bs, invCs, ws) {
    for(let i = 0; i < eqs.length; i++){
        const eq = eqs[i];
        if (!eq.enabled) continue;
        if (eq.timeStep !== h || eq.needsUpdate) {
            eq.timeStep = h;
            eq.update();
        }
        const slot = eq[0, $d28dd663c1e16271$export$d8a965ecb4c5b716];
        Bs[slot] = eq.computeB(eq.a, eq.b, h, ws);
        invCs[slot] = eq.computeInvC(eq.epsilon, ws);
    }
}
function $cc24bdd8dd0c74ab$var$setupPulleyBatch(eqs, h, Bs, invCs, ws) {
    for(let i = 0; i < eqs.length; i++){
        const eq = eqs[i];
        if (!eq.enabled) continue;
        if (eq.timeStep !== h || eq.needsUpdate) {
            eq.timeStep = h;
            eq.update();
        }
        const slot = eq[0, $d28dd663c1e16271$export$d8a965ecb4c5b716];
        Bs[slot] = eq.computeB(eq.a, eq.b, h, ws);
        invCs[slot] = eq.computeInvC(eq.epsilon, ws);
    }
}
function $cc24bdd8dd0c74ab$var$setupGeneralBatch(eqs, h, Bs, invCs, ws) {
    for(let i = 0; i < eqs.length; i++){
        const eq = eqs[i];
        if (!eq.enabled) continue;
        if (eq.timeStep !== h || eq.needsUpdate) {
            eq.timeStep = h;
            eq.update();
        }
        const slot = eq[0, $d28dd663c1e16271$export$d8a965ecb4c5b716];
        Bs[slot] = eq.computeB(eq.a, eq.b, h, ws);
        invCs[slot] = eq.computeInvC(eq.epsilon, ws);
    }
}
function $cc24bdd8dd0c74ab$var$warmStartPointToPointBatch(eqs, h, lambda, ws) {
    for(let i = 0; i < eqs.length; i++){
        const eq = eqs[i];
        if (!eq.enabled) continue;
        let warm = eq.warmLambda;
        if (warm === 0 || !isFinite(warm)) continue;
        const minFDt = eq.minForce * h;
        const maxFDt = eq.maxForce * h;
        if (warm < minFDt) warm = minFDt;
        else if (warm > maxFDt) warm = maxFDt;
        lambda[eq[0, $d28dd663c1e16271$export$d8a965ecb4c5b716]] = warm;
        eq.addToWlambda(warm, ws);
    }
}
function $cc24bdd8dd0c74ab$var$warmStartPointToRigidBatch(eqs, h, lambda, ws) {
    for(let i = 0; i < eqs.length; i++){
        const eq = eqs[i];
        if (!eq.enabled) continue;
        let warm = eq.warmLambda;
        if (warm === 0 || !isFinite(warm)) continue;
        const minFDt = eq.minForce * h;
        const maxFDt = eq.maxForce * h;
        if (warm < minFDt) warm = minFDt;
        else if (warm > maxFDt) warm = maxFDt;
        lambda[eq[0, $d28dd663c1e16271$export$d8a965ecb4c5b716]] = warm;
        eq.addToWlambda(warm, ws);
    }
}
function $cc24bdd8dd0c74ab$var$warmStartPlanar2DBatch(eqs, h, lambda, ws) {
    for(let i = 0; i < eqs.length; i++){
        const eq = eqs[i];
        if (!eq.enabled) continue;
        let warm = eq.warmLambda;
        if (warm === 0 || !isFinite(warm)) continue;
        const minFDt = eq.minForce * h;
        const maxFDt = eq.maxForce * h;
        if (warm < minFDt) warm = minFDt;
        else if (warm > maxFDt) warm = maxFDt;
        lambda[eq[0, $d28dd663c1e16271$export$d8a965ecb4c5b716]] = warm;
        eq.addToWlambda(warm, ws);
    }
}
function $cc24bdd8dd0c74ab$var$warmStartAngular3DBatch(eqs, h, lambda, ws) {
    for(let i = 0; i < eqs.length; i++){
        const eq = eqs[i];
        if (!eq.enabled) continue;
        let warm = eq.warmLambda;
        if (warm === 0 || !isFinite(warm)) continue;
        const minFDt = eq.minForce * h;
        const maxFDt = eq.maxForce * h;
        if (warm < minFDt) warm = minFDt;
        else if (warm > maxFDt) warm = maxFDt;
        lambda[eq[0, $d28dd663c1e16271$export$d8a965ecb4c5b716]] = warm;
        eq.addToWlambda(warm, ws);
    }
}
function $cc24bdd8dd0c74ab$var$warmStartAngular2DBatch(eqs, h, lambda, ws) {
    for(let i = 0; i < eqs.length; i++){
        const eq = eqs[i];
        if (!eq.enabled) continue;
        let warm = eq.warmLambda;
        if (warm === 0 || !isFinite(warm)) continue;
        const minFDt = eq.minForce * h;
        const maxFDt = eq.maxForce * h;
        if (warm < minFDt) warm = minFDt;
        else if (warm > maxFDt) warm = maxFDt;
        lambda[eq[0, $d28dd663c1e16271$export$d8a965ecb4c5b716]] = warm;
        eq.addToWlambda(warm, ws);
    }
}
function $cc24bdd8dd0c74ab$var$warmStartPulleyBatch(eqs, h, lambda, ws) {
    for(let i = 0; i < eqs.length; i++){
        const eq = eqs[i];
        if (!eq.enabled) continue;
        let warm = eq.warmLambda;
        if (warm === 0 || !isFinite(warm)) continue;
        const minFDt = eq.minForce * h;
        const maxFDt = eq.maxForce * h;
        if (warm < minFDt) warm = minFDt;
        else if (warm > maxFDt) warm = maxFDt;
        lambda[eq[0, $d28dd663c1e16271$export$d8a965ecb4c5b716]] = warm;
        eq.addToWlambda(warm, ws);
    }
}
function $cc24bdd8dd0c74ab$var$warmStartGeneralBatch(eqs, h, lambda, ws) {
    for(let i = 0; i < eqs.length; i++){
        const eq = eqs[i];
        if (!eq.enabled) continue;
        let warm = eq.warmLambda;
        if (warm === 0 || !isFinite(warm)) continue;
        const minFDt = eq.minForce * h;
        const maxFDt = eq.maxForce * h;
        if (warm < minFDt) warm = minFDt;
        else if (warm > maxFDt) warm = maxFDt;
        lambda[eq[0, $d28dd663c1e16271$export$d8a965ecb4c5b716]] = warm;
        eq.addToWlambda(warm, ws);
    }
}
function $cc24bdd8dd0c74ab$var$finalizePointToPointBatch(eqs, lambda, invDt) {
    for(let i = 0; i < eqs.length; i++){
        const eq = eqs[i];
        if (!eq.enabled) continue;
        const slot = eq[0, $d28dd663c1e16271$export$d8a965ecb4c5b716];
        const l = lambda[slot];
        eq.warmLambda = isFinite(l) ? l : 0;
        eq.multiplier = isFinite(l) ? l * invDt : 0;
    }
}
function $cc24bdd8dd0c74ab$var$finalizePointToRigidBatch(eqs, lambda, invDt) {
    for(let i = 0; i < eqs.length; i++){
        const eq = eqs[i];
        if (!eq.enabled) continue;
        const slot = eq[0, $d28dd663c1e16271$export$d8a965ecb4c5b716];
        const l = lambda[slot];
        eq.warmLambda = isFinite(l) ? l : 0;
        eq.multiplier = isFinite(l) ? l * invDt : 0;
    }
}
function $cc24bdd8dd0c74ab$var$finalizePlanar2DBatch(eqs, lambda, invDt) {
    for(let i = 0; i < eqs.length; i++){
        const eq = eqs[i];
        if (!eq.enabled) continue;
        const slot = eq[0, $d28dd663c1e16271$export$d8a965ecb4c5b716];
        const l = lambda[slot];
        eq.warmLambda = isFinite(l) ? l : 0;
        eq.multiplier = isFinite(l) ? l * invDt : 0;
    }
}
function $cc24bdd8dd0c74ab$var$finalizeAngular3DBatch(eqs, lambda, invDt) {
    for(let i = 0; i < eqs.length; i++){
        const eq = eqs[i];
        if (!eq.enabled) continue;
        const slot = eq[0, $d28dd663c1e16271$export$d8a965ecb4c5b716];
        const l = lambda[slot];
        eq.warmLambda = isFinite(l) ? l : 0;
        eq.multiplier = isFinite(l) ? l * invDt : 0;
    }
}
function $cc24bdd8dd0c74ab$var$finalizeAngular2DBatch(eqs, lambda, invDt) {
    for(let i = 0; i < eqs.length; i++){
        const eq = eqs[i];
        if (!eq.enabled) continue;
        const slot = eq[0, $d28dd663c1e16271$export$d8a965ecb4c5b716];
        const l = lambda[slot];
        eq.warmLambda = isFinite(l) ? l : 0;
        eq.multiplier = isFinite(l) ? l * invDt : 0;
    }
}
function $cc24bdd8dd0c74ab$var$finalizePulleyBatch(eqs, lambda, invDt) {
    for(let i = 0; i < eqs.length; i++){
        const eq = eqs[i];
        if (!eq.enabled) continue;
        const slot = eq[0, $d28dd663c1e16271$export$d8a965ecb4c5b716];
        const l = lambda[slot];
        eq.warmLambda = isFinite(l) ? l : 0;
        eq.multiplier = isFinite(l) ? l * invDt : 0;
    }
}
function $cc24bdd8dd0c74ab$var$finalizeGeneralBatch(eqs, lambda, invDt) {
    for(let i = 0; i < eqs.length; i++){
        const eq = eqs[i];
        if (!eq.enabled) continue;
        const slot = eq[0, $d28dd663c1e16271$export$d8a965ecb4c5b716];
        const l = lambda[slot];
        eq.warmLambda = isFinite(l) ? l : 0;
        eq.multiplier = isFinite(l) ? l * invDt : 0;
    }
}
/** Sets the .multiplier property of each enabled equation from lambda values. */ function $cc24bdd8dd0c74ab$var$updateMultipliers(equations, lambda, invDt) {
    for(let i = equations.length - 1; i >= 0; i--){
        const eq = equations[i];
        if (eq.enabled) eq.multiplier = lambda[eq[0, $d28dd663c1e16271$export$d8a965ecb4c5b716]] * invDt;
    }
}
/**
 * Runs one iteration over all equations in the workspace's partitioned
 * groups. Each group is handled by a specialized batch function whose inner
 * loop is monomorphic — so V8 can inline the hot math and avoid virtual
 * dispatch through `Equation.computeGWlambda` / `addToWlambda`.
 *
 * Group execution order is fixed. Within each group, equations are iterated
 * in the order they were inserted during prepareSolverStep (which is the
 * caller's sort order). This is a slight ordering change from the old
 * fully-flat-list behavior when mixed equation types had interleaved
 * solverOrder values; in practice it is fine for chain-like structures and
 * often better, since related equations of the same type stay adjacent.
 *
 * Each batch is only called when its group is non-empty. Timings are
 * reported via `profiler.recordElapsed` with the equation count as the
 * "work unit" — so the profiler's `calls/frame` for each batch label is
 * the total equations solved that frame (per-call count × iterations ×
 * substeps), and `ms/frame ÷ calls/frame` yields the per-equation cost.
 */ function $cc24bdd8dd0c74ab$var$runIteration(Bs, invCs, lambda, useZeroRHS, h, workspace) {
    let deltaTot = 0;
    if (workspace.pointToPointEquations.length > 0) {
        const t0 = performance.now();
        deltaTot += $cc24bdd8dd0c74ab$var$iteratePointToPointBatch(workspace.pointToPointEquations, Bs, invCs, lambda, useZeroRHS, h, workspace);
        (0, $5a1d1d3ab1ff9c51$export$e8e2fad003b4d4ce).recordElapsed("pointToPoint", performance.now() - t0, workspace.pointToPointEquations.length);
    }
    if (workspace.pointToRigidEquations.length > 0) {
        const t0 = performance.now();
        deltaTot += $cc24bdd8dd0c74ab$var$iteratePointToRigidBatch(workspace.pointToRigidEquations, Bs, invCs, lambda, useZeroRHS, h, workspace);
        (0, $5a1d1d3ab1ff9c51$export$e8e2fad003b4d4ce).recordElapsed("pointToRigid", performance.now() - t0, workspace.pointToRigidEquations.length);
    }
    if (workspace.pointToPoint2DEquations.length > 0) {
        const t0 = performance.now();
        deltaTot += $cc24bdd8dd0c74ab$var$iteratePointToPoint2DBatch(workspace.pointToPoint2DEquations, Bs, invCs, lambda, useZeroRHS, h, workspace);
        (0, $5a1d1d3ab1ff9c51$export$e8e2fad003b4d4ce).recordElapsed("pointToPoint2D", performance.now() - t0, workspace.pointToPoint2DEquations.length);
    }
    if (workspace.pointToRigid2DEquations.length > 0) {
        const t0 = performance.now();
        deltaTot += $cc24bdd8dd0c74ab$var$iteratePointToRigid2DBatch(workspace.pointToRigid2DEquations, Bs, invCs, lambda, useZeroRHS, h, workspace);
        (0, $5a1d1d3ab1ff9c51$export$e8e2fad003b4d4ce).recordElapsed("pointToRigid2D", performance.now() - t0, workspace.pointToRigid2DEquations.length);
    }
    if (workspace.planar2DEquations.length > 0) {
        const t0 = performance.now();
        deltaTot += $cc24bdd8dd0c74ab$var$iteratePlanar2DBatch(workspace.planar2DEquations, Bs, invCs, lambda, useZeroRHS, h, workspace);
        (0, $5a1d1d3ab1ff9c51$export$e8e2fad003b4d4ce).recordElapsed("planar2D", performance.now() - t0, workspace.planar2DEquations.length);
    }
    if (workspace.angular3DEquations.length > 0) {
        const t0 = performance.now();
        deltaTot += $cc24bdd8dd0c74ab$var$iterateAngular3DBatch(workspace.angular3DEquations, Bs, invCs, lambda, useZeroRHS, h, workspace);
        (0, $5a1d1d3ab1ff9c51$export$e8e2fad003b4d4ce).recordElapsed("angular3D", performance.now() - t0, workspace.angular3DEquations.length);
    }
    if (workspace.angular2DEquations.length > 0) {
        const t0 = performance.now();
        deltaTot += $cc24bdd8dd0c74ab$var$iterateAngular2DBatch(workspace.angular2DEquations, Bs, invCs, lambda, useZeroRHS, h, workspace);
        (0, $5a1d1d3ab1ff9c51$export$e8e2fad003b4d4ce).recordElapsed("angular2D", performance.now() - t0, workspace.angular2DEquations.length);
    }
    if (workspace.generalEquations.length > 0) {
        const t0 = performance.now();
        deltaTot += $cc24bdd8dd0c74ab$var$iterateGeneralBatch(workspace.generalEquations, Bs, invCs, lambda, useZeroRHS, h, workspace);
        (0, $5a1d1d3ab1ff9c51$export$e8e2fad003b4d4ce).recordElapsed("general", performance.now() - t0, workspace.generalEquations.length);
    }
    if (workspace.pulleyEquations.length > 0) {
        const t0 = performance.now();
        deltaTot += $cc24bdd8dd0c74ab$var$iteratePulleyBatch(workspace.pulleyEquations, Bs, invCs, lambda, useZeroRHS, h, workspace);
        (0, $5a1d1d3ab1ff9c51$export$e8e2fad003b4d4ce).recordElapsed("pulley", performance.now() - t0, workspace.pulleyEquations.length);
    }
    return deltaTot;
}
/**
 * Specialized PGS iteration loop for 2-body equations that use the base
 * Equation's 12-component Jacobian. Inlines computeGWlambda and addToWlambda
 * so the call site is monomorphic and V8 can keep the math in one function.
 * Covers every equation type except PulleyEquation.
 */ function $cc24bdd8dd0c74ab$var$iterateGeneralBatch(equations, Bs, invCs, lambda, useZeroRHS, dt, ws) {
    const vl = ws.vlambda;
    const wl = ws.wlambda;
    const invMassSolve = ws.invMassSolve;
    const invMassSolveZ = ws.invMassSolveZ;
    const invInertia = ws.invInertia;
    let deltaTot = 0;
    const N = equations.length;
    for(let k = 0; k < N; k++){
        const eq = equations[k];
        if (!eq.enabled) continue;
        const slot = eq[0, $d28dd663c1e16271$export$d8a965ecb4c5b716];
        const G = eq.G;
        const idxA = eq[0, $d28dd663c1e16271$export$1d1b51a214a8f673];
        const idxB = eq[0, $d28dd663c1e16271$export$941aeb6a025e2399];
        const iA = idxA * 3;
        const iB = idxB * 3;
        // Inlined computeGWlambda: G · v_lambda (12 components)
        const GWlambda = G[0] * vl[iA] + G[1] * vl[iA + 1] + G[2] * vl[iA + 2] + G[3] * wl[iA] + G[4] * wl[iA + 1] + G[5] * wl[iA + 2] + G[6] * vl[iB] + G[7] * vl[iB + 1] + G[8] * vl[iB + 2] + G[9] * wl[iB] + G[10] * wl[iB + 1] + G[11] * wl[iB + 2];
        const B = useZeroRHS ? 0 : Bs[slot];
        const invC = invCs[slot];
        const lambdaj = lambda[slot];
        const eps = eq.epsilon;
        let dl = invC * (B - GWlambda - eps * lambdaj);
        if (!isFinite(dl)) dl = 0;
        // Clamp the new total lambda into [minForce*dt, maxForce*dt]
        const minFDt = eq.minForce * dt;
        const maxFDt = eq.maxForce * dt;
        const newTotal = lambdaj + dl;
        if (newTotal < minFDt) dl = minFDt - lambdaj;
        else if (newTotal > maxFDt) dl = maxFDt - lambdaj;
        lambda[slot] = lambdaj + dl;
        // Inlined addToWlambda
        const iMA = invMassSolve[idxA];
        const iMB = invMassSolve[idxB];
        const iMzA = invMassSolveZ[idxA];
        const iMzB = invMassSolveZ[idxB];
        // Body A linear
        vl[iA] += iMA * G[0] * dl;
        vl[iA + 1] += iMA * G[1] * dl;
        vl[iA + 2] += iMzA * G[2] * dl;
        // Body A angular: wlambda += invI_world * (G_ang * dl)
        const iIA = invInertia[idxA];
        const gA3 = G[3] * dl;
        const gA4 = G[4] * dl;
        const gA5 = G[5] * dl;
        wl[iA] += iIA[0] * gA3 + iIA[1] * gA4 + iIA[2] * gA5;
        wl[iA + 1] += iIA[3] * gA3 + iIA[4] * gA4 + iIA[5] * gA5;
        wl[iA + 2] += iIA[6] * gA3 + iIA[7] * gA4 + iIA[8] * gA5;
        // Body B linear
        vl[iB] += iMB * G[6] * dl;
        vl[iB + 1] += iMB * G[7] * dl;
        vl[iB + 2] += iMzB * G[8] * dl;
        // Body B angular
        const iIB = invInertia[idxB];
        const gB9 = G[9] * dl;
        const gB10 = G[10] * dl;
        const gB11 = G[11] * dl;
        wl[iB] += iIB[0] * gB9 + iIB[1] * gB10 + iIB[2] * gB11;
        wl[iB + 1] += iIB[3] * gB9 + iIB[4] * gB10 + iIB[5] * gB11;
        wl[iB + 2] += iIB[6] * gB9 + iIB[7] * gB10 + iIB[8] * gB11;
        deltaTot += dl >= 0 ? dl : -dl;
    }
    return deltaTot;
}
/**
 * Specialized PGS iteration loop for 3-body pulley equations. Still calls
 * PulleyEquation's computeGWlambda / addToWlambda because they touch a third
 * body — but the call site is monomorphic (only PulleyEquation lives in this
 * group), so V8 can inline them through the polymorphic inline cache.
 */ function $cc24bdd8dd0c74ab$var$iteratePulleyBatch(equations, Bs, invCs, lambda, useZeroRHS, dt, ws) {
    let deltaTot = 0;
    const N = equations.length;
    for(let k = 0; k < N; k++){
        const eq = equations[k];
        if (!eq.enabled) continue;
        const slot = eq[0, $d28dd663c1e16271$export$d8a965ecb4c5b716];
        const B = useZeroRHS ? 0 : Bs[slot];
        const invC = invCs[slot];
        const lambdaj = lambda[slot];
        const GWlambda = eq.computeGWlambda(ws);
        let dl = invC * (B - GWlambda - eq.epsilon * lambdaj);
        if (!isFinite(dl)) dl = 0;
        const minFDt = eq.minForce * dt;
        const maxFDt = eq.maxForce * dt;
        const newTotal = lambdaj + dl;
        if (newTotal < minFDt) dl = minFDt - lambdaj;
        else if (newTotal > maxFDt) dl = maxFDt - lambdaj;
        lambda[slot] = lambdaj + dl;
        eq.addToWlambda(dl, ws);
        deltaTot += dl >= 0 ? dl : -dl;
    }
    return deltaTot;
}
/**
 * Specialized PGS iteration loop for `PointToPointEquation3D` — 3D
 * 2-body constraints where both bodies are point-like (no angular
 * contribution). Reads the direction vector `(nx, ny, nz)` directly from
 * the equation and touches only `vlambda` + `invMassSolve` — never
 * `wlambda` or `invInertia`. Used for rope chain links between rope
 * particles.
 *
 * Per-equation op count vs. the general batch:
 *  - computeGWlambda: 6 mul-adds instead of 12
 *  - addToWlambda: 6 linear writes + 6 mul-adds, with zero angular work
 *  - computeInvC (already done in setup): doesn't run here
 */ function $cc24bdd8dd0c74ab$var$iteratePointToPointBatch(equations, Bs, invCs, lambda, useZeroRHS, dt, ws) {
    const vl = ws.vlambda;
    const invMassSolve = ws.invMassSolve;
    const invMassSolveZ = ws.invMassSolveZ;
    let deltaTot = 0;
    const N = equations.length;
    for(let k = 0; k < N; k++){
        const eq = equations[k];
        if (!eq.enabled) continue;
        const slot = eq[0, $d28dd663c1e16271$export$d8a965ecb4c5b716];
        const idxA = eq[0, $d28dd663c1e16271$export$1d1b51a214a8f673];
        const idxB = eq[0, $d28dd663c1e16271$export$941aeb6a025e2399];
        const iA = idxA * 3;
        const iB = idxB * 3;
        const nx = eq.nx;
        const ny = eq.ny;
        const nz = eq.nz;
        // GWlambda = n · (vlB - vlA). No angular component.
        const GWlambda = nx * (vl[iB] - vl[iA]) + ny * (vl[iB + 1] - vl[iA + 1]) + nz * (vl[iB + 2] - vl[iA + 2]);
        const B = useZeroRHS ? 0 : Bs[slot];
        const invC = invCs[slot];
        const lambdaj = lambda[slot];
        const eps = eq.epsilon;
        let dl = invC * (B - GWlambda - eps * lambdaj);
        if (!isFinite(dl)) dl = 0;
        const minFDt = eq.minForce * dt;
        const maxFDt = eq.maxForce * dt;
        const newTotal = lambdaj + dl;
        if (newTotal < minFDt) dl = minFDt - lambdaj;
        else if (newTotal > maxFDt) dl = maxFDt - lambdaj;
        lambda[slot] = lambdaj + dl;
        // Linear-only impulse: vl += invM * (±n) * dl
        const iMA = invMassSolve[idxA];
        const iMB = invMassSolve[idxB];
        const iMzA = invMassSolveZ[idxA];
        const iMzB = invMassSolveZ[idxB];
        vl[iA] -= iMA * nx * dl;
        vl[iA + 1] -= iMA * ny * dl;
        vl[iA + 2] -= iMzA * nz * dl;
        vl[iB] += iMB * nx * dl;
        vl[iB + 1] += iMB * ny * dl;
        vl[iB + 2] += iMzB * nz * dl;
        deltaTot += dl >= 0 ? dl : -dl;
    }
    return deltaTot;
}
/**
 * Specialized PGS iteration loop for `PointToRigidEquation3D` — 3D 2-body
 * constraints where body A is a point (no angular) and body B is a rigid
 * body (full linear + angular). Reads `(nx, ny, nz)` and `(rjXnX, rjXnY,
 * rjXnZ)` directly instead of a 12-element G, and skips body-A angular
 * work entirely.
 *
 * Per-equation op count vs. the general batch:
 *  - computeGWlambda: 9 mul-adds instead of 12 (skip body A angular)
 *  - addToWlambda: skips the 3×3 `invInertia[idxA]` read and the 9-mult
 *    angular-A update
 */ function $cc24bdd8dd0c74ab$var$iteratePointToRigidBatch(equations, Bs, invCs, lambda, useZeroRHS, dt, ws) {
    const vl = ws.vlambda;
    const wl = ws.wlambda;
    const invMassSolve = ws.invMassSolve;
    const invMassSolveZ = ws.invMassSolveZ;
    const invInertia = ws.invInertia;
    let deltaTot = 0;
    const N = equations.length;
    for(let k = 0; k < N; k++){
        const eq = equations[k];
        if (!eq.enabled) continue;
        const slot = eq[0, $d28dd663c1e16271$export$d8a965ecb4c5b716];
        const idxA = eq[0, $d28dd663c1e16271$export$1d1b51a214a8f673];
        const idxB = eq[0, $d28dd663c1e16271$export$941aeb6a025e2399];
        const iA = idxA * 3;
        const iB = idxB * 3;
        const nx = eq.nx;
        const ny = eq.ny;
        const nz = eq.nz;
        const rjXnX = eq.rjXnX;
        const rjXnY = eq.rjXnY;
        const rjXnZ = eq.rjXnZ;
        // GWlambda = n · (vlB - vlA) + rjXn · wlB. No body-A angular term.
        const GWlambda = nx * (vl[iB] - vl[iA]) + ny * (vl[iB + 1] - vl[iA + 1]) + nz * (vl[iB + 2] - vl[iA + 2]) + rjXnX * wl[iB] + rjXnY * wl[iB + 1] + rjXnZ * wl[iB + 2];
        const B = useZeroRHS ? 0 : Bs[slot];
        const invC = invCs[slot];
        const lambdaj = lambda[slot];
        const eps = eq.epsilon;
        let dl = invC * (B - GWlambda - eps * lambdaj);
        if (!isFinite(dl)) dl = 0;
        const minFDt = eq.minForce * dt;
        const maxFDt = eq.maxForce * dt;
        const newTotal = lambdaj + dl;
        if (newTotal < minFDt) dl = minFDt - lambdaj;
        else if (newTotal > maxFDt) dl = maxFDt - lambdaj;
        lambda[slot] = lambdaj + dl;
        const iMA = invMassSolve[idxA];
        const iMB = invMassSolve[idxB];
        const iMzA = invMassSolveZ[idxA];
        const iMzB = invMassSolveZ[idxB];
        // Body A linear (-n)
        vl[iA] -= iMA * nx * dl;
        vl[iA + 1] -= iMA * ny * dl;
        vl[iA + 2] -= iMzA * nz * dl;
        // Body B linear (+n)
        vl[iB] += iMB * nx * dl;
        vl[iB + 1] += iMB * ny * dl;
        vl[iB + 2] += iMzB * nz * dl;
        // Body B angular through world-frame inverse inertia
        const iIB = invInertia[idxB];
        const g0 = rjXnX * dl;
        const g1 = rjXnY * dl;
        const g2 = rjXnZ * dl;
        wl[iB] += iIB[0] * g0 + iIB[1] * g1 + iIB[2] * g2;
        wl[iB + 1] += iIB[3] * g0 + iIB[4] * g1 + iIB[5] * g2;
        wl[iB + 2] += iIB[6] * g0 + iIB[7] * g1 + iIB[8] * g2;
        deltaTot += dl >= 0 ? dl : -dl;
    }
    return deltaTot;
}
/**
 * Specialized PGS iteration loop for `PlanarEquation2D` — 2D rigid-rigid
 * constraints whose Jacobian is `(linX, linY, angAz, angBz)`. The angular
 * impulse only touches the Z component, so we read just the Z columns of
 * each body's inverse inertia tensor instead of the full 3×3 block.
 *
 * Per-equation op count vs. the general batch:
 *  - computeGWlambda: 6 mul-adds instead of 12
 *  - addToWlambda: ~12 fewer ops by skipping the zero-row angular math
 */ function $cc24bdd8dd0c74ab$var$iteratePlanar2DBatch(equations, Bs, invCs, lambda, useZeroRHS, dt, ws) {
    const vl = ws.vlambda;
    const wl = ws.wlambda;
    const invMassSolve = ws.invMassSolve;
    const invInertia = ws.invInertia;
    let deltaTot = 0;
    const N = equations.length;
    for(let k = 0; k < N; k++){
        const eq = equations[k];
        if (!eq.enabled) continue;
        const slot = eq[0, $d28dd663c1e16271$export$d8a965ecb4c5b716];
        const idxA = eq[0, $d28dd663c1e16271$export$1d1b51a214a8f673];
        const idxB = eq[0, $d28dd663c1e16271$export$941aeb6a025e2399];
        const iA = idxA * 3;
        const iB = idxB * 3;
        const linX = eq.linX;
        const linY = eq.linY;
        const angAz = eq.angAz;
        const angBz = eq.angBz;
        // GWlambda = lin · (vlB - vlA) + angAz * wlA_z + angBz * wlB_z
        const GWlambda = linX * (vl[iB] - vl[iA]) + linY * (vl[iB + 1] - vl[iA + 1]) + angAz * wl[iA + 2] + angBz * wl[iB + 2];
        const B = useZeroRHS ? 0 : Bs[slot];
        const invC = invCs[slot];
        const lambdaj = lambda[slot];
        const eps = eq.epsilon;
        let dl = invC * (B - GWlambda - eps * lambdaj);
        if (!isFinite(dl)) dl = 0;
        const minFDt = eq.minForce * dt;
        const maxFDt = eq.maxForce * dt;
        const newTotal = lambdaj + dl;
        if (newTotal < minFDt) dl = minFDt - lambdaj;
        else if (newTotal > maxFDt) dl = maxFDt - lambdaj;
        lambda[slot] = lambdaj + dl;
        const iMA = invMassSolve[idxA];
        const iMB = invMassSolve[idxB];
        // Body A linear (-lin); body B linear (+lin)
        vl[iA] -= iMA * linX * dl;
        vl[iA + 1] -= iMA * linY * dl;
        vl[iB] += iMB * linX * dl;
        vl[iB + 1] += iMB * linY * dl;
        // Angular impulse on Z axis: wl += invI_col2 * (angXz * dl)
        const iIA = invInertia[idxA];
        const gAz = angAz * dl;
        wl[iA] += iIA[2] * gAz;
        wl[iA + 1] += iIA[5] * gAz;
        wl[iA + 2] += iIA[8] * gAz;
        const iIB = invInertia[idxB];
        const gBz = angBz * dl;
        wl[iB] += iIB[2] * gBz;
        wl[iB + 1] += iIB[5] * gBz;
        wl[iB + 2] += iIB[8] * gBz;
        deltaTot += dl >= 0 ? dl : -dl;
    }
    return deltaTot;
}
/**
 * Specialized PGS iteration loop for `AngularEquation3D` — pure 3D
 * rotational constraints, typically used for 3D revolute-joint axis
 * alignment. Calls the subclass's specialized `computeGWlambda` /
 * `addToWlambda` methods, which are monomorphic here (only
 * `AngularEquation3D` lives in this group) so V8 inlines them through
 * the PIC. Low volume, so the method-call form is kept for clarity.
 */ function $cc24bdd8dd0c74ab$var$iterateAngular3DBatch(equations, Bs, invCs, lambda, useZeroRHS, dt, ws) {
    let deltaTot = 0;
    const N = equations.length;
    for(let k = 0; k < N; k++){
        const eq = equations[k];
        if (!eq.enabled) continue;
        const slot = eq[0, $d28dd663c1e16271$export$d8a965ecb4c5b716];
        const B = useZeroRHS ? 0 : Bs[slot];
        const invC = invCs[slot];
        const lambdaj = lambda[slot];
        const GWlambda = eq.computeGWlambda(ws);
        let dl = invC * (B - GWlambda - eq.epsilon * lambdaj);
        if (!isFinite(dl)) dl = 0;
        const minFDt = eq.minForce * dt;
        const maxFDt = eq.maxForce * dt;
        const newTotal = lambdaj + dl;
        if (newTotal < minFDt) dl = minFDt - lambdaj;
        else if (newTotal > maxFDt) dl = maxFDt - lambdaj;
        lambda[slot] = lambdaj + dl;
        eq.addToWlambda(dl, ws);
        deltaTot += dl >= 0 ? dl : -dl;
    }
    return deltaTot;
}
/**
 * Specialized PGS iteration loop for `AngularEquation2D` — pure 2D
 * rotational constraints (angle locks, motors). Monomorphic method calls
 * for the same reason as {@link iterateAngular3DBatch}.
 */ function $cc24bdd8dd0c74ab$var$iterateAngular2DBatch(equations, Bs, invCs, lambda, useZeroRHS, dt, ws) {
    let deltaTot = 0;
    const N = equations.length;
    for(let k = 0; k < N; k++){
        const eq = equations[k];
        if (!eq.enabled) continue;
        const slot = eq[0, $d28dd663c1e16271$export$d8a965ecb4c5b716];
        const B = useZeroRHS ? 0 : Bs[slot];
        const invC = invCs[slot];
        const lambdaj = lambda[slot];
        const GWlambda = eq.computeGWlambda(ws);
        let dl = invC * (B - GWlambda - eq.epsilon * lambdaj);
        if (!isFinite(dl)) dl = 0;
        const minFDt = eq.minForce * dt;
        const maxFDt = eq.maxForce * dt;
        const newTotal = lambdaj + dl;
        if (newTotal < minFDt) dl = minFDt - lambdaj;
        else if (newTotal > maxFDt) dl = maxFDt - lambdaj;
        lambda[slot] = lambdaj + dl;
        eq.addToWlambda(dl, ws);
        deltaTot += dl >= 0 ? dl : -dl;
    }
    return deltaTot;
}
/** Updates friction equation bounds based on contact equation multipliers. */ function $cc24bdd8dd0c74ab$var$updateFrictionBounds(equations) {
    for (const eq of equations){
        if (!eq.enabled) continue;
        if (eq instanceof (0, $0331ac7467aaeda3$export$aaf1bc25025a5803)) {
            let f = 0.0;
            for(let k = 0; k < eq.contactEquations.length; k++)f += eq.contactEquations[k].multiplier;
            f *= eq.frictionCoefficient / eq.contactEquations.length;
            eq.maxForce = f;
            eq.minForce = -f;
        }
    }
}
function $cc24bdd8dd0c74ab$var$setupPointToPoint2DBatch(eqs, h, Bs, invCs, ws) {
    for(let i = 0; i < eqs.length; i++){
        const eq = eqs[i];
        if (!eq.enabled) continue;
        if (eq.timeStep !== h || eq.needsUpdate) {
            eq.timeStep = h;
            eq.update();
        }
        const slot = eq[0, $d28dd663c1e16271$export$d8a965ecb4c5b716];
        Bs[slot] = eq.computeB(eq.a, eq.b, h, ws);
        invCs[slot] = eq.computeInvC(eq.epsilon, ws);
    }
}
function $cc24bdd8dd0c74ab$var$setupPointToRigid2DBatch(eqs, h, Bs, invCs, ws) {
    for(let i = 0; i < eqs.length; i++){
        const eq = eqs[i];
        if (!eq.enabled) continue;
        if (eq.timeStep !== h || eq.needsUpdate) {
            eq.timeStep = h;
            eq.update();
        }
        const slot = eq[0, $d28dd663c1e16271$export$d8a965ecb4c5b716];
        Bs[slot] = eq.computeB(eq.a, eq.b, h, ws);
        invCs[slot] = eq.computeInvC(eq.epsilon, ws);
    }
}
function $cc24bdd8dd0c74ab$var$warmStartPointToPoint2DBatch(eqs, h, lambda, ws) {
    for(let i = 0; i < eqs.length; i++){
        const eq = eqs[i];
        if (!eq.enabled) continue;
        let warm = eq.warmLambda;
        if (warm === 0 || !isFinite(warm)) continue;
        const minFDt = eq.minForce * h;
        const maxFDt = eq.maxForce * h;
        if (warm < minFDt) warm = minFDt;
        else if (warm > maxFDt) warm = maxFDt;
        lambda[eq[0, $d28dd663c1e16271$export$d8a965ecb4c5b716]] = warm;
        eq.addToWlambda(warm, ws);
    }
}
function $cc24bdd8dd0c74ab$var$warmStartPointToRigid2DBatch(eqs, h, lambda, ws) {
    for(let i = 0; i < eqs.length; i++){
        const eq = eqs[i];
        if (!eq.enabled) continue;
        let warm = eq.warmLambda;
        if (warm === 0 || !isFinite(warm)) continue;
        const minFDt = eq.minForce * h;
        const maxFDt = eq.maxForce * h;
        if (warm < minFDt) warm = minFDt;
        else if (warm > maxFDt) warm = maxFDt;
        lambda[eq[0, $d28dd663c1e16271$export$d8a965ecb4c5b716]] = warm;
        eq.addToWlambda(warm, ws);
    }
}
function $cc24bdd8dd0c74ab$var$finalizePointToPoint2DBatch(eqs, lambda, invDt) {
    for(let i = 0; i < eqs.length; i++){
        const eq = eqs[i];
        if (!eq.enabled) continue;
        const slot = eq[0, $d28dd663c1e16271$export$d8a965ecb4c5b716];
        const l = lambda[slot];
        eq.warmLambda = isFinite(l) ? l : 0;
        eq.multiplier = isFinite(l) ? l * invDt : 0;
    }
}
function $cc24bdd8dd0c74ab$var$finalizePointToRigid2DBatch(eqs, lambda, invDt) {
    for(let i = 0; i < eqs.length; i++){
        const eq = eqs[i];
        if (!eq.enabled) continue;
        const slot = eq[0, $d28dd663c1e16271$export$d8a965ecb4c5b716];
        const l = lambda[slot];
        eq.warmLambda = isFinite(l) ? l : 0;
        eq.multiplier = isFinite(l) ? l * invDt : 0;
    }
}
/**
 * Specialized PGS iteration loop for `PointToPointEquation2D` — 2D 2-body
 * constraints where both bodies are 2D particles. Reads `(nx, ny)` directly
 * and touches only `vlambda` + `invMassSolve`. No `wlambda` or `invInertia`.
 *
 * Per-equation op count vs. the general batch:
 *  - computeGWlambda: 4 mul-adds instead of 12
 *  - addToWlambda: 4 linear writes, zero angular work
 */ function $cc24bdd8dd0c74ab$var$iteratePointToPoint2DBatch(equations, Bs, invCs, lambda, useZeroRHS, dt, ws) {
    const vl = ws.vlambda;
    const invMassSolve = ws.invMassSolve;
    let deltaTot = 0;
    const N = equations.length;
    for(let k = 0; k < N; k++){
        const eq = equations[k];
        if (!eq.enabled) continue;
        const slot = eq[0, $d28dd663c1e16271$export$d8a965ecb4c5b716];
        const idxA = eq[0, $d28dd663c1e16271$export$1d1b51a214a8f673];
        const idxB = eq[0, $d28dd663c1e16271$export$941aeb6a025e2399];
        const iA = idxA * 3;
        const iB = idxB * 3;
        const nx = eq.nx;
        const ny = eq.ny;
        const GWlambda = nx * (vl[iB] - vl[iA]) + ny * (vl[iB + 1] - vl[iA + 1]);
        const B = useZeroRHS ? 0 : Bs[slot];
        const invC = invCs[slot];
        const lambdaj = lambda[slot];
        const eps = eq.epsilon;
        let dl = invC * (B - GWlambda - eps * lambdaj);
        if (!isFinite(dl)) dl = 0;
        const minFDt = eq.minForce * dt;
        const maxFDt = eq.maxForce * dt;
        const newTotal = lambdaj + dl;
        if (newTotal < minFDt) dl = minFDt - lambdaj;
        else if (newTotal > maxFDt) dl = maxFDt - lambdaj;
        lambda[slot] = lambdaj + dl;
        const iMA = invMassSolve[idxA];
        const iMB = invMassSolve[idxB];
        vl[iA] -= iMA * nx * dl;
        vl[iA + 1] -= iMA * ny * dl;
        vl[iB] += iMB * nx * dl;
        vl[iB + 1] += iMB * ny * dl;
        deltaTot += dl >= 0 ? dl : -dl;
    }
    return deltaTot;
}
/**
 * Specialized PGS iteration loop for `PointToRigidEquation2D` — 2D 2-body
 * constraints where body A is a 2D particle (no angular) and body B is a
 * 2D rigid body (linear + scalar yaw angular). Reads `(nx, ny)` and
 * `rjCrossN` directly and touches only the Z component of body B's
 * angular accumulator.
 *
 * Per-equation op count vs. the general batch:
 *  - computeGWlambda: 5 mul-adds instead of 12
 *  - addToWlambda: skips body-A angular work and reads only the Z column
 *    of body B's inverse inertia
 */ function $cc24bdd8dd0c74ab$var$iteratePointToRigid2DBatch(equations, Bs, invCs, lambda, useZeroRHS, dt, ws) {
    const vl = ws.vlambda;
    const wl = ws.wlambda;
    const invMassSolve = ws.invMassSolve;
    const invInertia = ws.invInertia;
    let deltaTot = 0;
    const N = equations.length;
    for(let k = 0; k < N; k++){
        const eq = equations[k];
        if (!eq.enabled) continue;
        const slot = eq[0, $d28dd663c1e16271$export$d8a965ecb4c5b716];
        const idxA = eq[0, $d28dd663c1e16271$export$1d1b51a214a8f673];
        const idxB = eq[0, $d28dd663c1e16271$export$941aeb6a025e2399];
        const iA = idxA * 3;
        const iB = idxB * 3;
        const nx = eq.nx;
        const ny = eq.ny;
        const rjCrossN = eq.rjCrossN;
        const GWlambda = nx * (vl[iB] - vl[iA]) + ny * (vl[iB + 1] - vl[iA + 1]) + rjCrossN * wl[iB + 2];
        const B = useZeroRHS ? 0 : Bs[slot];
        const invC = invCs[slot];
        const lambdaj = lambda[slot];
        const eps = eq.epsilon;
        let dl = invC * (B - GWlambda - eps * lambdaj);
        if (!isFinite(dl)) dl = 0;
        const minFDt = eq.minForce * dt;
        const maxFDt = eq.maxForce * dt;
        const newTotal = lambdaj + dl;
        if (newTotal < minFDt) dl = minFDt - lambdaj;
        else if (newTotal > maxFDt) dl = maxFDt - lambdaj;
        lambda[slot] = lambdaj + dl;
        const iMA = invMassSolve[idxA];
        const iMB = invMassSolve[idxB];
        // Body A linear (-n); body B linear (+n)
        vl[iA] -= iMA * nx * dl;
        vl[iA + 1] -= iMA * ny * dl;
        vl[iB] += iMB * nx * dl;
        vl[iB + 1] += iMB * ny * dl;
        // Body B angular on Z: wl += invI_col2 * (rjCrossN * dl)
        const iIB = invInertia[idxB];
        const g = rjCrossN * dl;
        wl[iB] += iIB[2] * g;
        wl[iB + 1] += iIB[5] * g;
        wl[iB + 2] += iIB[8] * g;
        deltaTot += dl >= 0 ? dl : -dl;
    }
    return deltaTot;
}


/**
 * Solver scratch state for a single `solveEquations` call.
 *
 * Replaces the previous `Map<Body, SolverBodyState>` approach with an
 * index-based Structure-of-Arrays layout. Bodies receive a stable integer
 * index for the duration of one solve; all per-body solver state lives in
 * flat Float64Arrays owned by this workspace.
 *
 * ## Why
 *
 * The old Map-based design allocated a Map, per-body state objects, and
 * per-body Float64Arrays on every solve (8x per physics step with substeps),
 * and the hot iteration loop did 2-4 Map lookups per equation per iteration.
 * Profiling showed `Solver.iterate` at ~5ms per step, dominated by the Map
 * traffic rather than the actual constraint math.
 *
 * This workspace is constructed once, owned by `World`, and reused across
 * every solve. The backing arrays grow geometrically on demand and then
 * stabilize; after the first few frames, a solve performs zero allocations
 * outside the index-assignment Map (which is cleared between calls).
 *
 * ## Separation of concerns
 *
 * `Body` and `Body` remain unaware of the solver. Equations accept
 * a `SolverWorkspace` as an opaque handle — they know the workspace exposes
 * `vlambda`, `wlambda`, `invMassSolve`, etc. by index, but not how that
 * storage is organized. A different solver could supply its own workspace.
 */ 
class $cf0c146e6934a01d$export$384471cc3c9a8569 {
    /**
   * Fully clear per-step state. Drops the index assignment, registered
   * dynamic bodies, and zeroes the accumulators. Call when starting a fresh
   * solve that isn't reusing prepared indices (e.g. between islands, or at
   * the start of a new step when using `prepareSolverStep`).
   */ reset() {
        this.resetAccumulators();
        this.bodyCount = 0;
        this.bodyToIndex.clear();
        this.dynamicBodies.length = 0;
        this.dynamicBodyIndices.length = 0;
        this.generalEquations.length = 0;
        this.pulleyEquations.length = 0;
        this.pointToPointEquations.length = 0;
        this.pointToRigidEquations.length = 0;
        this.pointToPoint2DEquations.length = 0;
        this.pointToRigid2DEquations.length = 0;
        this.planar2DEquations.length = 0;
        this.angular3DEquations.length = 0;
        this.angular2DEquations.length = 0;
    }
    /**
   * Zero the solver accumulators (vlambda, wlambda, lambda) without touching
   * the body index assignment. Call this between substeps when the indices
   * are being reused — it's significantly cheaper than a full `reset()`
   * because it skips the Map clear and dynamic-body list churn.
   */ resetAccumulators() {
        // Only clear the live region; the tail may hold stale values from a
        // larger previous solve but is never read.
        if (this.bodyCount > 0) {
            const count3 = this.bodyCount * 3;
            this.vlambda.fill(0, 0, count3);
            this.wlambda.fill(0, 0, count3);
        }
    }
    /** Ensure per-body arrays can hold at least `needed` bodies. */ ensureBodyCapacity(needed) {
        if (needed <= this.bodyCapacity) return;
        const newCap = Math.max(needed, this.bodyCapacity * 2, 16);
        const newVl = new Float64Array(newCap * 3);
        const newWl = new Float64Array(newCap * 3);
        const newInvM = new Float64Array(newCap);
        const newInvMz = new Float64Array(newCap);
        // Copy live region (reset() will zero it next solve, but be safe mid-solve
        // if we ever grow during a single call).
        newVl.set(this.vlambda);
        newWl.set(this.wlambda);
        newInvM.set(this.invMassSolve);
        newInvMz.set(this.invMassSolveZ);
        this.vlambda = newVl;
        this.wlambda = newWl;
        this.invMassSolve = newInvM;
        this.invMassSolveZ = newInvMz;
        // invInertia is a plain array of references; just extend it.
        while(this.invInertia.length < newCap)this.invInertia.push((0, $8793a8b9f94904cc$export$4b2c32e08f77ff18).ZERO_9);
        this.bodyCapacity = newCap;
    }
    /** Ensure per-equation arrays can hold at least `needed` equations. */ ensureEqCapacity(needed) {
        if (needed <= this.eqCapacity) return;
        const newCap = Math.max(needed, this.eqCapacity * 2, 64);
        this.lambda = new Float32Array(newCap);
        this.Bs = new Float32Array(newCap);
        this.invCs = new Float32Array(newCap);
        this.eqCapacity = newCap;
    }
    /**
   * Look up or assign an index for this body. Defaults to treating the body
   * as non-sleeping, which is correct for static/kinematic bodies pulled in
   * via equations (their invMass is naturally 0).
   *
   * Dynamic bodies should be registered via `registerDynamic()` instead so
   * the finalize pass knows about them.
   */ indexOf(body) {
        const existing = this.bodyToIndex.get(body);
        if (existing !== undefined) return existing;
        return this.assign(body, false);
    }
    /**
   * Register a dynamic body. Sets invMass/invInertia from the body (or to
   * zero if sleeping) and records it for the finalize pass.
   */ registerDynamic(body) {
        const existing = this.bodyToIndex.get(body);
        if (existing !== undefined) return existing;
        const idx = this.assign(body, body.isSleeping());
        this.dynamicBodies.push(body);
        this.dynamicBodyIndices.push(idx);
        return idx;
    }
    /** @internal */ assign(body, isSleeping) {
        const idx = this.bodyCount++;
        this.ensureBodyCapacity(this.bodyCount);
        // Freshly-grown vlambda/wlambda slots are already zero (new Float64Array).
        if (isSleeping) {
            this.invMassSolve[idx] = 0;
            this.invMassSolveZ[idx] = 0;
            this.invInertia[idx] = (0, $8793a8b9f94904cc$export$4b2c32e08f77ff18).ZERO_9;
        } else {
            this.invMassSolve[idx] = body.invMass;
            this.invMassSolveZ[idx] = body.invMassZ;
            this.invInertia[idx] = body.invWorldInertia;
        }
        this.bodyToIndex.set(body, idx);
        return idx;
    }
    constructor(){
        /** Number of bodies currently registered in this solve. */ this.bodyCount = 0;
        /** Backing capacity for per-body arrays. Grows geometrically. */ this.bodyCapacity = 0;
        /** Linear constraint-velocity accumulator, 3 floats per body: [vx, vy, vz]. */ this.vlambda = new Float64Array(0);
        /** Angular constraint-velocity accumulator, 3 floats per body: [wx, wy, wz]. */ this.wlambda = new Float64Array(0);
        /** Linear inverse mass for x/y, per body. Zero for sleeping/static/kinematic bodies. */ this.invMassSolve = new Float64Array(0);
        /** Linear inverse mass for z, per body. Zero for non-6DOF bodies and sleeping ones. */ this.invMassSolveZ = new Float64Array(0);
        /**
   * World-frame 3x3 inverse inertia tensor reference per body. Each entry is
   * either `body.invWorldInertia` (for awake dynamic) or `Body.ZERO_9` (for
   * sleeping/static/kinematic). Kept as references — no copy.
   */ this.invInertia = [];
        /**
   * Dynamic bodies that should receive their accumulated vlambda/wlambda on
   * finalize. Populated in the order they are registered. Parallel to
   * `dynamicBodyIndices`.
   */ this.dynamicBodies = [];
        /** Workspace index for each entry in `dynamicBodies`. */ this.dynamicBodyIndices = [];
        /** Per-equation impulse accumulator. Length = current equation count. */ this.lambda = new Float32Array(0);
        /** Per-equation right-hand side. Length = current equation count. */ this.Bs = new Float32Array(0);
        /** Per-equation inverse effective mass. Length = current equation count. */ this.invCs = new Float32Array(0);
        /** Backing capacity for per-equation arrays. Grows geometrically. */ this.eqCapacity = 0;
        /**
   * Equations partitioned by which specialized batch iterator handles them.
   * Populated by prepareSolverStep; the hot solver loop iterates each group
   * with a monomorphic, inlined function (no virtual dispatch).
   *
   * Each group corresponds to a Jacobian "shape" — which components of `G`
   * are structurally non-zero. See the equation class docs for the exact
   * shape and `src/core/physics/CLAUDE.md` for the full taxonomy:
   *
   *  - `pointToPointEquations` — both bodies linear only (rope chain links)
   *  - `pointToRigidEquations` — body A linear, body B rigid (deck contacts,
   *    rope endpoint chain links)
   *  - `planar2DEquations` — 2D rigid-rigid, linear XY + angular Z per body
   *    (2D contacts, friction)
   *  - `angular3DEquations` — pure 3D rotational (axis alignment)
   *  - `angular2DEquations` — pure 2D rotational (angle locks, motors)
   *  - `generalEquations` — fully general 2-body (anything that doesn't fit
   *    a specialized shape)
   *  - `pulleyEquations` — 3-body pulley
   */ this.generalEquations = [];
        this.pulleyEquations = [];
        this.pointToPointEquations = [];
        this.pointToRigidEquations = [];
        this.pointToPoint2DEquations = [];
        this.pointToRigid2DEquations = [];
        this.planar2DEquations = [];
        this.angular3DEquations = [];
        this.angular2DEquations = [];
        /**
   * Body -> index map. Only touched during the setup phase of a solve (never
   * by the hot iteration loop). Cleared in `reset()`.
   */ this.bodyToIndex = new Map();
    }
}



const $a5fd11c7a1cbe128$var$isDynamic = (b)=>b.motion === "dynamic";
const $a5fd11c7a1cbe128$var$isKinematic = (b)=>b.motion === "kinematic";
const $a5fd11c7a1cbe128$var$isStatic = (b)=>b.motion === "static";
const $a5fd11c7a1cbe128$var$isAwakeDynamic = (b)=>b.motion === "dynamic" && !b.isSleeping();
class $a5fd11c7a1cbe128$export$baceff01c79776a7 {
    constructor(world){
        /** All bodies in the collection. Exposed for direct array access. */ this.all = new Set();
        /** Keeps filtered lists for optimized iteration */ this.filtered = new (0, $2bdf816bbe356527$export$eadac383198be9f3)();
        /** Map of all bodies indexed by their id. */ this.allById = new Map();
        this.pendingRemoval = [];
        this.world = world;
        this.filtered.addFilter($a5fd11c7a1cbe128$var$isDynamic);
        this.filtered.addFilter($a5fd11c7a1cbe128$var$isKinematic);
        this.filtered.addFilter($a5fd11c7a1cbe128$var$isStatic);
        this.filtered.addFilter($a5fd11c7a1cbe128$var$isAwakeDynamic);
        this.world.on("postStep", ()=>this.endStep());
    }
    /** Set of dynamic bodies for optimized iteration. */ get dynamic() {
        return this.filtered.getItems($a5fd11c7a1cbe128$var$isDynamic);
    }
    /** Set of kinematic bodies for optimized iteration. */ get kinematic() {
        return this.filtered.getItems($a5fd11c7a1cbe128$var$isKinematic);
    }
    /** Set of static bodies for optimized iteration. */ get static() {
        return this.filtered.getItems($a5fd11c7a1cbe128$var$isStatic);
    }
    /** Set of awake dynamic bodies for optimized simulation loops. */ get dynamicAwake() {
        return this.filtered.getItems($a5fd11c7a1cbe128$var$isAwakeDynamic);
    }
    /** Update dynamicAwake filter membership when a body's sleep state changes. */ onSleepStateChanged(body) {
        this.dynamicAwake.addIfValid(body);
    }
    /** Add a body to the world. */ add(body) {
        if (this.all.has(body)) throw new Error("Body is already added to the world");
        if (this.allById.has(body.id)) throw new Error(`Body with id ${body.id} already exists in the world`);
        this.all.add(body);
        this.filtered.addItem(body);
        this.allById.set(body.id, body);
        body.world = this.world;
        this.world.emit({
            type: "addBody",
            body: body
        });
    }
    /** Remove a body from the world. Defers removal if stepping. */ remove(body) {
        if (this.world.stepping) this.pendingRemoval.push(body);
        else this.removeImmediate(body);
    }
    removeImmediate(body) {
        if (!this.all.has(body)) return;
        body.world = null;
        this.all.delete(body);
        this.filtered.removeItem(body);
        this.allById.delete(body.id);
        this.world.emit({
            type: "removeBody",
            body: body
        });
    }
    /** Get a body by its id. */ getById(id) {
        return this.allById.get(id);
    }
    /** Call at the end of a physics step to process deferred removals. */ endStep() {
        for (const body of this.pendingRemoval)this.removeImmediate(body);
        this.pendingRemoval = [];
    }
    /** Remove all bodies from the world. */ clear() {
        this.all.clear();
        this.allById.clear();
        this.filtered = new (0, $2bdf816bbe356527$export$eadac383198be9f3)();
        this.pendingRemoval = [];
    }
    /** Number of bodies in the collection. */ get length() {
        return this.all.size;
    }
    [Symbol.iterator]() {
        return this.all[Symbol.iterator]();
    }
}



function $c56311e3d93db672$export$18a378792c232bc(a, b) {
    return a < b ? `${a}:${b}` : `${b}:${a}`;
}
function $c56311e3d93db672$export$f3cb68f57a58f8c9(shapeA, shapeB) {
    return $c56311e3d93db672$export$18a378792c232bc(shapeA.id, shapeB.id);
}
function $c56311e3d93db672$export$d9bab0a6917fe95a(bodyA, bodyB) {
    return $c56311e3d93db672$export$18a378792c232bc(bodyA.id, bodyB.id);
}
class $c56311e3d93db672$export$7bd008fc8aa4a2 {
    /** Update with current frame's overlaps and return what changed. */ updateOverlaps(currentOverlaps) {
        // Build map of current shape overlaps and set of body overlaps
        const currentShapeMap = new Map();
        const currentBodySet = new Set();
        for (const overlap of currentOverlaps){
            currentShapeMap.set($c56311e3d93db672$export$f3cb68f57a58f8c9(overlap.shapeA, overlap.shapeB), overlap);
            currentBodySet.add($c56311e3d93db672$export$d9bab0a6917fe95a(overlap.bodyA, overlap.bodyB));
        }
        // New overlaps: in current but not in previous
        const newOverlaps = [];
        for (const [key, overlap] of currentShapeMap)if (!this.previousShapeOverlaps.has(key)) newOverlaps.push(overlap);
        // Ended overlaps: in previous but not in current
        const endedOverlaps = [];
        for (const [key, overlap] of this.previousShapeOverlaps)if (!currentShapeMap.has(key)) endedOverlaps.push(overlap);
        // Body pairs that just started overlapping
        const newlyOverlappingBodies = new Set();
        for (const key of currentBodySet)if (!this.previousBodyOverlaps.has(key)) newlyOverlappingBodies.add(key);
        // Store current as previous for next frame
        this.previousShapeOverlaps = new Map();
        for (const [key, overlap] of currentShapeMap)this.previousShapeOverlaps.set(key, {
            bodyA: overlap.bodyA,
            shapeA: overlap.shapeA,
            bodyB: overlap.bodyB,
            shapeB: overlap.shapeB
        });
        this.previousBodyOverlaps = this.currentBodyOverlaps;
        this.currentBodyOverlaps = currentBodySet;
        return {
            newOverlaps: newOverlaps,
            endedOverlaps: endedOverlaps,
            newlyOverlappingBodies: newlyOverlappingBodies
        };
    }
    /** Check if two bodies are currently overlapping (any of their shapes). */ bodiesAreOverlapping(bodyA, bodyB) {
        return this.currentBodyOverlaps.has($c56311e3d93db672$export$d9bab0a6917fe95a(bodyA, bodyB));
    }
    constructor(){
        this.previousShapeOverlaps = new Map();
        this.previousBodyOverlaps = new Set();
        this.currentBodyOverlaps = new Set();
    }
}


class $b326b3ee42ae1021$export$b37cc45031f58908 {
    /** Add a constraint to the world. */ add(constraint) {
        this.items.add(constraint);
        this.dontCollideConnected.addIfValid(constraint);
        if (!constraint.collideConnected) this._disabledBodyKeys.add((0, $c56311e3d93db672$export$d9bab0a6917fe95a)(constraint.bodyA, constraint.bodyB));
        const ctor = constraint.constructor;
        let bucket = this._byType.get(ctor);
        if (!bucket) {
            bucket = [];
            this._byType.set(ctor, bucket);
        }
        bucket.push(constraint);
    }
    /** Remove a constraint from the world. */ remove(constraint) {
        this.items.delete(constraint);
        this.dontCollideConnected.remove(constraint);
        if (!constraint.collideConnected) this._disabledBodyKeys.delete((0, $c56311e3d93db672$export$d9bab0a6917fe95a)(constraint.bodyA, constraint.bodyB));
        const bucket = this._byType.get(constraint.constructor);
        if (bucket) {
            const idx = bucket.indexOf(constraint);
            if (idx >= 0) {
                const last = bucket.length - 1;
                if (idx !== last) bucket[idx] = bucket[last];
                bucket.pop();
            }
        }
    }
    /** Remove all constraints from the world. */ clear() {
        this.items.clear();
        this._disabledBodyKeys.clear();
        this._byType.clear();
    }
    /** Iterate constraints grouped by concrete class. */ get byType() {
        return this._byType;
    }
    /** Number of constraints in the collection. */ get length() {
        return this.items.size;
    }
    [Symbol.iterator]() {
        return this.items[Symbol.iterator]();
    }
    get collideConnectedDisabled() {
        return this.dontCollideConnected;
    }
    /** Pre-computed body keys for constraints with collideConnected=false */ get disabledBodyKeys() {
        return this._disabledBodyKeys;
    }
    constructor(){
        this.items = new Set();
        this.dontCollideConnected = new (0, $04179bd0fe63c1d8$export$7ac4a5983ab98376)((constraint)=>!constraint.collideConnected);
        /** Cached body keys for constraints with collideConnected=false */ this._disabledBodyKeys = new Set();
        /** Constraints bucketed by concrete class, so hot-path update loops can
   *  run monomorphically and be measured per-type. */ this._byType = new Map();
    }
}


/**
 * A material identifier. Used with ContactMaterial to define friction and restitution
 * between pairs of materials. Assign to shapes via shape.material.
 */ class $ef974ad607b2b548$export$a2d8b23205c25948 {
    static{
        /** @internal */ this.idCounter = 0;
    }
    /** Create a new material with an optional custom ID. */ constructor(id){
        this.id = id ?? $ef974ad607b2b548$export$a2d8b23205c25948.idCounter++;
    }
}



class $7e20bc9b94ef4d40$export$a172e4020a254255 {
    static{
        /** @internal */ this.idCounter = 0;
    }
    constructor(materialA, materialB, options = {}){
        if (!(materialA instanceof (0, $ef974ad607b2b548$export$a2d8b23205c25948)) || !(materialB instanceof (0, $ef974ad607b2b548$export$a2d8b23205c25948))) throw new Error("First two arguments must be Material instances.");
        this.id = $7e20bc9b94ef4d40$export$a172e4020a254255.idCounter++;
        this.materialA = materialA;
        this.materialB = materialB;
        this.friction = options.friction !== undefined ? Number(options.friction) : 0.3;
        this.restitution = options.restitution !== undefined ? Number(options.restitution) : 0;
        this.stiffness = options.stiffness !== undefined ? Number(options.stiffness) : (0, $0113af86cc04b089$export$9e6be560da9da590).DEFAULT_STIFFNESS;
        this.relaxation = options.relaxation !== undefined ? Number(options.relaxation) : (0, $0113af86cc04b089$export$9e6be560da9da590).DEFAULT_RELAXATION;
        this.frictionStiffness = options.frictionStiffness !== undefined ? Number(options.frictionStiffness) : (0, $0113af86cc04b089$export$9e6be560da9da590).DEFAULT_STIFFNESS;
        this.frictionRelaxation = options.frictionRelaxation !== undefined ? Number(options.frictionRelaxation) : (0, $0113af86cc04b089$export$9e6be560da9da590).DEFAULT_RELAXATION;
        this.surfaceVelocity = options.surfaceVelocity !== undefined ? Number(options.surfaceVelocity) : 0;
        this.contactSkinSize = 0.005;
    }
}



function $25c6ed34d0d559af$export$259b4dd69e654a7a(obj) {
    return Object.keys(obj);
}
function $25c6ed34d0d559af$export$6a29ade99f81ec8a(obj) {
    return Object.entries(obj);
}
function $25c6ed34d0d559af$export$58aefef1ff9edd34(obj, fn) {
    return $25c6ed34d0d559af$export$259b4dd69e654a7a(obj).reduce((acc, key)=>{
        acc[key] = fn(obj[key], key);
        return acc;
    }, {});
}
function $25c6ed34d0d559af$export$357523c63a2253b9(obj, keys) {
    return keys.reduce((acc, key)=>{
        acc[key] = obj[key];
        return acc;
    }, {});
}
function $25c6ed34d0d559af$export$a188e271553f9211(arr, getKey) {
    return $25c6ed34d0d559af$export$6a29ade99f81ec8a(arr.reduce((acc, item)=>{
        const key = getKey(item);
        if (!acc[key]) acc[key] = [];
        acc[key].push(item);
        return acc;
    }, {}));
}
/** Check if a value is a plain object (not an array or class instance) */ function $25c6ed34d0d559af$var$isPlainObject(value) {
    return typeof value === "object" && value !== null && !Array.isArray(value) && value.constructor === Object;
}
function $25c6ed34d0d559af$export$6969335ea1e4e77c(base, overrides) {
    const result = {
        ...base
    };
    for(const key in overrides){
        const override = overrides[key];
        if (override !== undefined) {
            if ($25c6ed34d0d559af$var$isPlainObject(override) && $25c6ed34d0d559af$var$isPlainObject(base[key])) result[key] = $25c6ed34d0d559af$export$6969335ea1e4e77c(base[key], override);
            else result[key] = override;
        }
    }
    return result;
}
function $25c6ed34d0d559af$export$9859237ef1323ecc(entity) {
    const methods = [];
    let current = entity;
    // Traverse up the prototype chain
    while(current !== null && current !== undefined && current !== Object.prototype){
        // Get own property names of the current object
        const propertyNames = Object.getOwnPropertyNames(current);
        // Filter out non-function properties and already added methods
        for (const name of propertyNames)// Access on entity and not currentObject because we're looking at prototypes
        if (typeof entity[name] === "function" && !methods.includes(name)) methods.push(name);
        // Move up the prototype chain
        current = Object.getPrototypeOf(current);
    }
    return methods;
}


class $aa702c19e7ba4fb6$export$111170f9735154e5 {
    *[Symbol.iterator]() {
        for (const key of this.keys)yield this.data[key];
    }
    get keys() {
        return (0, $25c6ed34d0d559af$export$259b4dd69e654a7a)(this.data);
    }
    get length() {
        return this.keys.length;
    }
    /**
   * Generate a key given two integers.
   * Ids MUST be less than 2^16.
   */ makeKey(id1, id2) {
        if (id1 === id2) return -1;
        return id1 > id2 ? id1 << 16 | id2 & 0xffff : id2 << 16 | id1 & 0xffff;
    }
    getByKey(key) {
        return this.data[key];
    }
    get(i, j) {
        return this.data[this.makeKey(i, j)];
    }
    set(i, j, value) {
        this.data[this.makeKey(i, j)] = value;
    }
    reset() {
        this.data = {};
    }
    copy(other) {
        this.reset();
        for (const key of other.keys)this.data[key] = other.data[key];
    }
    /** Delete data for the given pair. */ delete(i, j) {
        const key = this.makeKey(i, j);
        delete this.data[key];
    }
    constructor(){
        this.data = {};
        this.m = new Map();
    }
}


class $e12336751e5961c3$export$d58552c3b487f1d0 {
    constructor(defaultMaterial = new (0, $ef974ad607b2b548$export$a2d8b23205c25948)()){
        this.byMaterialPair = new (0, $aa702c19e7ba4fb6$export$111170f9735154e5)();
        this.defaultMaterial = defaultMaterial;
        this.defaultContactMaterial = new (0, $7e20bc9b94ef4d40$export$a172e4020a254255)(defaultMaterial, defaultMaterial);
    }
    /** Add a contact material to the world. */ add(cm) {
        this.byMaterialPair.set(cm.materialA.id, cm.materialB.id, cm);
    }
    /** Remove a contact material from the world. */ remove(cm) {
        this.byMaterialPair.delete(cm.materialA.id, cm.materialB.id);
    }
    /** Get a contact material for the given material pair. */ get(materialA = this.defaultMaterial, materialB = this.defaultMaterial) {
        return this.byMaterialPair.get(materialA.id, materialB.id) ?? this.defaultContactMaterial;
    }
    /** Number of contact materials in the collection. */ get length() {
        return this.byMaterialPair.length;
    }
    [Symbol.iterator]() {
        return this.byMaterialPair[Symbol.iterator]();
    }
}


function $c1677dee8c5429f6$export$67774aba15f1f45b(bodies, equations) {
    // Create nodes for each body
    const bodyToNode = new Map();
    const dynamicNodes = [];
    for (const body of bodies){
        const node = {
            body: body,
            neighbors: [],
            equations: [],
            visited: false
        };
        bodyToNode.set(body, node);
        if (body.motion === "dynamic") dynamicNodes.push(node);
    }
    // Add connectivity from equations
    for (const eq of equations){
        const nodeA = bodyToNode.get(eq.bodyA);
        const nodeB = bodyToNode.get(eq.bodyB);
        if (nodeA && nodeB) {
            nodeA.neighbors.push(nodeB);
            nodeB.neighbors.push(nodeA);
            nodeA.equations.push(eq);
            nodeB.equations.push(eq);
        }
        // 3-body equations (PulleyEquation) have a bodyC — connect it too
        const eqAny = eq;
        if (eqAny.bodyC) {
            const nodeC = bodyToNode.get(eqAny.bodyC);
            if (nodeC) {
                if (nodeA && !nodeA.neighbors.includes(nodeC)) {
                    nodeA.neighbors.push(nodeC);
                    nodeC.neighbors.push(nodeA);
                }
                if (nodeB && !nodeB.neighbors.includes(nodeC)) {
                    nodeB.neighbors.push(nodeC);
                    nodeC.neighbors.push(nodeB);
                }
                nodeC.equations.push(eq);
            }
        }
    }
    // BFS to find connected components starting from dynamic bodies
    const islands = [];
    const unvisited = new Set(dynamicNodes);
    while(unvisited.size > 0){
        // Get any unvisited dynamic node
        const root = unvisited.values().next().value;
        unvisited.delete(root);
        const islandBodies = [];
        const islandEquations = new Set();
        // BFS from root
        const queue = [
            root
        ];
        root.visited = true;
        while(queue.length > 0){
            const node = queue.pop();
            islandBodies.push(node.body);
            for (const eq of node.equations)islandEquations.add(eq);
            // Visit unvisited dynamic neighbors
            for (const neighbor of node.neighbors)if (!neighbor.visited && neighbor.body.motion === "dynamic") {
                neighbor.visited = true;
                unvisited.delete(neighbor);
                queue.push(neighbor);
            }
        }
        islands.push({
            bodies: islandBodies,
            equations: [
                ...islandEquations
            ]
        });
    }
    return islands;
}



var $916dbba8a53e4e40$export$10571ba4375f2188 = /*#__PURE__*/ function(SleepMode) {
    /** Bodies never sleep. */ SleepMode[SleepMode["NO_SLEEPING"] = 1] = "NO_SLEEPING";
    /** Individual bodies sleep when idle. */ SleepMode[SleepMode["BODY_SLEEPING"] = 2] = "BODY_SLEEPING";
    /** Connected body groups (islands) sleep together. Requires islandSplit=true. */ SleepMode[SleepMode["ISLAND_SLEEPING"] = 4] = "ISLAND_SLEEPING";
    return SleepMode;
}({});
class $916dbba8a53e4e40$export$812cd9544993280d extends (0, $6c2df9ba61f1f24d$export$4fae95256245c8c0) {
    /** Creates a new physics world. */ constructor(options = {}){
        super(), /** Total simulated time in seconds. */ this.time = 0.0, /** True while step() is executing. */ this.stepping = false, /** Whether to emit "impact" events on first contact. */ this.emitImpactEvent = true, /** When true, multiple contacts between shapes produce one averaged friction equation instead of many. */ this.frictionReduction = true, /** @internal */ this._constraintIdCounter = 0, /** @internal */ this._bodyIdCounter = 0, // Solver stats from the most recent step (for debug overlays)
        /** Total equations solved in the most recent step. */ this.solverEquationCount = 0, /** Number of islands solved in the most recent step (0 if island splitting is off). */ this.solverIslandCount = 0, /** Total solver iterations across all islands in the most recent step. */ this.solverIterations = 0, /** Max iterations used by any single island (or the global solve) in the most recent step. */ this.solverMaxIterations = 0, /** Solver scratch state, reused across every `step()` to avoid per-solve
   *  allocation. See {@link SolverWorkspace}. */ this.solverWorkspace = new (0, $cf0c146e6934a01d$export$384471cc3c9a8569)();
        this.bodies = new (0, $a5fd11c7a1cbe128$export$baceff01c79776a7)(this);
        this.constraints = new (0, $b326b3ee42ae1021$export$b37cc45031f58908)();
        this.springs = new Set();
        this.solverConfig = {
            ...(0, $cc24bdd8dd0c74ab$export$b41695af87c85f04),
            ...options.solverConfig
        };
        this.broadphase = options.broadphase ?? new (0, $a47013ac1bc6d942$export$bfb9823bf11a6d41)();
        this.broadphase.setWorld(this);
        this.contactMaterials = new (0, $e12336751e5961c3$export$d58552c3b487f1d0)();
        this.islandSplit = options.islandSplit ?? false;
        this.substeps = Math.max(1, Math.floor(options.substeps ?? 1));
        this.sleepMode = 1;
        this.overlapKeeper = new (0, $c56311e3d93db672$export$7bd008fc8aa4a2)();
    }
    /**
   * Step the simulation forward by dt seconds.
   *
   * ## Pipeline (executed in order)
   *
   * 1. **Apply forces** — Spring forces are computed and applied to bodies.
   *    6DOF bodies recompute their world-frame inertia tensor. Velocity
   *    damping is applied to all awake dynamic bodies.
   *
   * 2. **Broadphase** — The spatial hashing broadphase returns candidate
   *    collision pairs. Pairs disabled by constraints (e.g. bodies connected
   *    by a hinge with `collideConnected=false`) are filtered out.
   *    Emits: `postBroadphase` with the filtered pair list.
   *
   * 3. **Narrowphase** — Exact collision detection runs on candidate pairs,
   *    producing Collision objects (with contact points and normals) and
   *    SensorOverlap objects (for sensor/trigger shapes).
   *
   * 4. **Overlap tracking** — The OverlapKeeper diffs current overlaps
   *    against the previous frame to determine newly-begun and newly-ended
   *    contacts (for beginContact/endContact events).
   *
   * 5. **Contact equations** — ContactEquations are generated from
   *    collisions. These encode "don't penetrate" constraints with
   *    restitution from ContactMaterials. First-impact detection is set
   *    for newly overlapping body pairs.
   *
   * 6. **Friction equations** — FrictionEquations are generated alongside
   *    contacts. When frictionReduction is enabled, multiple contact points
   *    between the same shape pair produce a single averaged friction
   *    equation instead of one per contact.
   *
   * 7. **Collision wake-ups** — Sleeping bodies are flagged for wake-up if
   *    hit by a fast-moving awake body (speed >= 2x the sleep threshold).
   *
   * 8. **Events & wake** — `beginContact` and `endContact` events are
   *    emitted. Flagged bodies are woken. Then `preSolve` is emitted,
   *    giving listeners a chance to modify contact/friction equations
   *    (e.g. disable contacts, adjust friction coefficients).
   *
   * 9. **Solve constraints** — All equations (contacts + friction +
   *    constraint equations from joints/motors) are collected. If island
   *    splitting is enabled, bodies are partitioned into connected islands
   *    and each is solved independently (better cache performance and
   *    enables island sleeping). Otherwise all equations are solved as
   *    one system. Uses the Gauss-Seidel Sequential Impulse solver.
   *
   * 10. **Integrate** — Velocities (including solver impulses) are
   *     integrated to update positions and angles for all kinematic and
   *     awake dynamic bodies. Forces are zeroed after integration.
   *
   * 11. **Impact events** — `impact` events are emitted for first-time
   *     contacts (contacts between body pairs that were not overlapping
   *     in the previous frame). Only fires if emitImpactEvent is true.
   *
   * 12. **Sleep update** — Depending on sleepMode:
   *     - BODY_SLEEPING: each body independently tracks idle time and
   *       sleeps when below the speed threshold for long enough.
   *     - ISLAND_SLEEPING: bodies track idle time, but only sleep when
   *       *all* bodies in their island want to sleep (prevents one body
   *       in a stack from sleeping while others are active).
   *
   * Finally, `postStep` is emitted and `this.time` is advanced by dt.
   *
   * ## Substepping
   *
   * When `substeps > 1`, phases 1-8 and 11-12 still run exactly once per
   * `step()` call. Constraint resolution and position integration (the
   * "substep core") run `substeps` times with `h = dt / substeps`:
   *
   *   for s in 1..N:
   *     for c in constraints: c.update()   // refresh Jacobians
   *     solve(h, contacts, friction, constraints)
   *     integratePositions(h)
   *
   * This stiffens constraint enforcement without paying N× the collision
   * detection cost. Forces (entity-applied + spring + damping) are folded
   * into velocity once, up front — so entities continue to see their usual
   * single `onTick` force application per game tick.
   *
   * @param dt - Timestep in seconds (typically 1/60 or 1/120)
   */ step(dt) {
        this.stepping = true;
        (0, $3a0afeab946181f7$export$338e2d92a009605e)(this.bodies.dynamicAwake, "at step() entry");
        // 1. Apply forces (springs, damping) — once per step
        this.applyForces(dt);
        (0, $3a0afeab946181f7$export$338e2d92a009605e)(this.bodies.dynamicAwake, "after applyForces");
        // 2. Broadphase - get potential collision pairs
        const pairsToCheck = this.doBroadphase();
        // 3. Narrowphase - get actual collisions
        const { collisions: collisions, sensorOverlaps: sensorOverlaps } = (0, $5a1d1d3ab1ff9c51$export$e8e2fad003b4d4ce).measure("World.narrowphase", ()=>(0, $5b9d44bb2e6e52f9$export$7f58631b3746eb17)(pairsToCheck));
        // 4. Update overlap tracking
        const overlapChanges = this.updateOverlapTracking(collisions, sensorOverlaps);
        // 5. Build contact equations to resolve overlaps
        (0, $5a1d1d3ab1ff9c51$export$e8e2fad003b4d4ce).start("World.contactEquations");
        const collisionsWithContactEquations = collisions.map((collision)=>[
                collision,
                (0, $c5764dc7c93dbd5e$export$a6f1fdf48954e3f0)(collision, this.contactMaterials.get(collision.shapeA.material, collision.shapeB.material), overlapChanges.newlyOverlappingBodies.has((0, $c56311e3d93db672$export$d9bab0a6917fe95a)(collision.bodyA, collision.bodyB)))
            ]);
        const contactEquations = collisionsWithContactEquations.flatMap(([, contactEquations])=>contactEquations);
        (0, $5a1d1d3ab1ff9c51$export$e8e2fad003b4d4ce).end("World.contactEquations");
        // 6. Build friction equations and flatten all equations
        (0, $5a1d1d3ab1ff9c51$export$e8e2fad003b4d4ce).start("World.frictionEquations");
        const frictionEquations = collisionsWithContactEquations.flatMap(([collision, contactEquations])=>(0, $28966d70a7fe65ee$export$4ed2e1c2f6a9031f)(collision, contactEquations, this.contactMaterials.get(collision.shapeA.material, collision.shapeB.material), this.frictionReduction));
        (0, $5a1d1d3ab1ff9c51$export$e8e2fad003b4d4ce).end("World.frictionEquations");
        // 7. Handle wake-ups for sleeping bodies
        this.handleCollisionWakeUps(collisions);
        // 8. Emit collision events (using overlapChanges from step 4)
        this.emitContactEvents(overlapChanges, collisionsWithContactEquations);
        this.emitPreSolveAndWakeUp(contactEquations, frictionEquations);
        // 9. Fold accumulated forces into velocity once, up front. This consumes
        //    and zeroes body.force, so the subsequent substep loop only advances
        //    positions from velocity (plus constraint impulses).
        this.integrateForcesToVelocity(dt);
        (0, $3a0afeab946181f7$export$338e2d92a009605e)(this.bodies.dynamicAwake, "after integrateForcesToVelocity");
        // 10. Collect equations once per step (not per substep) and — for the
        //     non-island path — sort + assign workspace indices up front. The
        //     body/equation membership is stable across substeps thanks to
        //     deferred body removal, so this setup is all hoisted out of the
        //     inner loop.
        (0, $5a1d1d3ab1ff9c51$export$e8e2fad003b4d4ce).start("World.collectEquations");
        const allEquations = [
            ...contactEquations,
            ...frictionEquations,
            ...[
                ...this.constraints
            ].flatMap((c)=>c.equations)
        ];
        if (!this.islandSplit && this.solverConfig.equationSortFunction) // In-place sort — unlike toSorted this doesn't allocate a new array.
        allEquations.sort(this.solverConfig.equationSortFunction);
        (0, $5a1d1d3ab1ff9c51$export$e8e2fad003b4d4ce).end("World.collectEquations");
        if (!this.islandSplit && allEquations.length > 0) (0, $cc24bdd8dd0c74ab$export$754399b061a0a10b)(allEquations, this.bodies.dynamicAwake, this.solverWorkspace);
        // 11. Substep loop: solve constraints + integrate positions with h = dt/N
        const N = this.substeps;
        const h = dt / N;
        let lastIslands;
        let totalIter = 0;
        let maxIter = 0;
        let totalIslandCount = 0;
        for(let s = 0; s < N; s++){
            // Refresh constraint Jacobians against current positions. (On the
            // first substep this matches legacy behavior where solve() called
            // c.update() once.)
            (0, $5a1d1d3ab1ff9c51$export$e8e2fad003b4d4ce).start("World.constraintUpdate");
            for (const [ctor, bucket] of this.constraints.byType){
                if (bucket.length === 0) continue;
                const t0 = performance.now();
                for(let i = 0; i < bucket.length; i++)bucket[i].update();
                (0, $5a1d1d3ab1ff9c51$export$e8e2fad003b4d4ce).recordElapsed(ctor.name, performance.now() - t0, bucket.length);
            }
            (0, $5a1d1d3ab1ff9c51$export$e8e2fad003b4d4ce).end("World.constraintUpdate");
            const result = this.solve(h, allEquations);
            lastIslands = result.islands;
            totalIter += result.usedIterations;
            if (result.maxIterations > maxIter) maxIter = result.maxIterations;
            totalIslandCount = result.islandCount;
            (0, $3a0afeab946181f7$export$338e2d92a009605e)(this.bodies.dynamicAwake, `after solve (substep ${s})`);
            this.integratePositions(h);
            (0, $3a0afeab946181f7$export$338e2d92a009605e)(this.bodies.dynamicAwake, `after integratePositions (substep ${s})`);
        }
        this.solverEquationCount = allEquations.length;
        this.solverIslandCount = totalIslandCount;
        this.solverIterations = totalIter;
        this.solverMaxIterations = maxIter;
        // 12. Emit impact events
        this.emitImpactEvents(contactEquations);
        // 13. Update sleeping
        this.updateSleeping(dt, lastIslands);
        this.time += dt;
        this.stepping = false;
        this.emit({
            type: "postStep"
        });
    }
    applyForces(dt) {
        // Add spring forces
        for (const spring of this.springs)spring.applyForce();
        // Apply damping and recompute world inertia for 6DOF bodies
        for (const body of this.bodies.dynamicAwake){
            if (body.is6DOF) body.recomputeWorldInertia();
            body.applyDamping(dt);
        }
    }
    doBroadphase() {
        const possibleCollisions = this.broadphase.getCollisionPairs(this);
        // Use pre-computed disabled body keys from ConstraintManager
        const disabledBodyKeys = this.constraints.disabledBodyKeys;
        const filteredPossibleCollisions = possibleCollisions.filter(([bodyA, bodyB])=>!disabledBodyKeys.has((0, $c56311e3d93db672$export$d9bab0a6917fe95a)(bodyA, bodyB)));
        this.emit({
            type: "postBroadphase",
            pairs: filteredPossibleCollisions
        });
        return filteredPossibleCollisions;
    }
    /** Update overlap tracking and return changes (called before contact equation generation) */ updateOverlapTracking(collisions, sensorOverlaps) {
        // Build overlap input (without contact equations - they don't exist yet)
        const currentOverlaps = [
            ...collisions.map((collision)=>({
                    ...collision,
                    contactEquations: []
                })),
            ...sensorOverlaps.map((sensor)=>({
                    ...sensor,
                    contactEquations: []
                }))
        ];
        return this.overlapKeeper.updateOverlaps(currentOverlaps);
    }
    /** Handle wake-up logic for sleeping bodies that collide with fast-moving bodies */ handleCollisionWakeUps(collisions) {
        for (const { bodyA: bodyA, bodyB: bodyB } of collisions){
            // Only dynamic bodies can sleep or wake other bodies
            const dynA = bodyA.motion === "dynamic" ? bodyA : null;
            const dynB = bodyB.motion === "dynamic" ? bodyB : null;
            // Check if bodyA (sleeping) should be woken by bodyB (fast-moving)
            if (dynA && dynB && dynA.allowSleep && dynA.sleepState === (0, $8793a8b9f94904cc$export$6593f13021cce3f9).SLEEPING && dynB.sleepState === (0, $8793a8b9f94904cc$export$6593f13021cce3f9).AWAKE) {
                const speedSquaredB = dynB.velocity.squaredMagnitude + dynB.angularVelocity ** 2;
                const speedLimitSquaredB = dynB.sleepSpeedLimit ** 2;
                if (speedSquaredB >= speedLimitSquaredB * 2) dynA._wakeUpAfterNarrowphase = true;
            }
            // Check if bodyB (sleeping) should be woken by bodyA (fast-moving)
            if (dynA && dynB && dynB.allowSleep && dynB.sleepState === (0, $8793a8b9f94904cc$export$6593f13021cce3f9).SLEEPING && dynA.sleepState === (0, $8793a8b9f94904cc$export$6593f13021cce3f9).AWAKE) {
                const speedSquaredA = dynA.velocity.squaredMagnitude + dynA.angularVelocity ** 2;
                const speedLimitSquaredA = dynA.sleepSpeedLimit ** 2;
                if (speedSquaredA >= speedLimitSquaredA * 2) dynB._wakeUpAfterNarrowphase = true;
            }
        }
    }
    /** Emit beginContact/endContact events using pre-computed overlap changes */ emitContactEvents(overlapChanges, collisionsWithContacts) {
        const { newOverlaps: newOverlaps, endedOverlaps: endedOverlaps } = overlapChanges;
        // Emit beginContact events, but only if we have at least one listener
        if (this.has("beginContact")) {
            // Build lookup for contact equations (newOverlaps don't have them yet)
            const contactsByShapePair = new Map();
            for (const [collision, contacts] of collisionsWithContacts){
                const key = `${collision.shapeA.id}:${collision.shapeB.id}`;
                contactsByShapePair.set(key, contacts);
            }
            for (const overlap of newOverlaps){
                const key = `${overlap.shapeA.id}:${overlap.shapeB.id}`;
                const contacts = contactsByShapePair.get(key) ?? [];
                this.emit({
                    type: "beginContact",
                    ...overlap,
                    contactEquations: contacts
                });
            }
        }
        // Emit endContact events, but only if we have at least one listener
        if (this.has("endContact")) for (const overlap of endedOverlaps)this.emit({
            type: "endContact",
            ...overlap
        });
    }
    /** Wake up bodies and emit preSolve event */ emitPreSolveAndWakeUp(contacts, friction) {
        // Wake up bodies that need it - check all dynamic bodies since sleeping ones may have the flag
        for (const body of this.bodies.dynamic)if (body._wakeUpAfterNarrowphase) {
            body.wakeUp();
            body._wakeUpAfterNarrowphase = false;
        }
        this.emit({
            type: "preSolve",
            contactEquations: contacts,
            frictionEquations: friction
        });
    }
    /**
   * Run one substep of the constraint solver. For the non-island path,
   * `allEquations` must already be sorted and the workspace must already
   * be prepared (done once per step in `step()` before the substep loop).
   * For the island path, islands are rebuilt per substep.
   */ solve(dt, allEquations) {
        if (allEquations.length === 0) return {
            islands: undefined,
            usedIterations: 0,
            maxIterations: 0,
            islandCount: 0
        };
        if (this.islandSplit) {
            // Split into islands and solve each. Island membership can shift
            // between substeps (as the body graph changes with constraint limit
            // toggles), so the split runs per substep.
            const islands = (0, $c1677dee8c5429f6$export$67774aba15f1f45b)(this.bodies.all, allEquations);
            let totalIter = 0;
            let maxIter = 0;
            for (const island of islands)if (island.equations.length) {
                const result = (0, $cc24bdd8dd0c74ab$export$6b7cd7c22cb50dd4)(island, dt, this.solverConfig, this.solverWorkspace);
                totalIter += result.usedIterations;
                if (result.usedIterations > maxIter) maxIter = result.usedIterations;
            }
            return {
                islands: islands,
                usedIterations: totalIter,
                maxIterations: maxIter,
                islandCount: islands.length
            };
        } else {
            // Non-island path: the workspace was prepared once in step() before
            // the substep loop. Each substep just runs the iteration phases
            // against the cached indices.
            const result = (0, $cc24bdd8dd0c74ab$export$6a40b5454173f07a)(allEquations, dt, this.solverConfig, this.solverWorkspace);
            return {
                islands: undefined,
                usedIterations: result.usedIterations,
                maxIterations: result.usedIterations,
                islandCount: 0
            };
        }
    }
    /**
   * Apply accumulated forces to body velocities and zero the forces. Called
   * once per physics step (before the substep loop) so entity-applied forces
   * are integrated at the full tick dt rather than multiplied by N substeps.
   */ integrateForcesToVelocity(dt) {
        for (const body of this.bodies.dynamicAwake)body.integrateVelocity(dt);
    }
    /**
   * Advance positions/orientations from current velocity. Called once per
   * substep with `h = dt / substeps`. Forces are not touched here.
   */ integratePositions(h) {
        for (const body of this.bodies.kinematic)body.integratePosition(h);
        for (const body of this.bodies.dynamicAwake)body.integratePosition(h);
    }
    /** Emit impact events for first-time contacts */ emitImpactEvents(contacts) {
        if (this.emitImpactEvent && this.has("impact")) {
            for (const eq of contacts)if (eq.firstImpact && eq.shapeA && eq.shapeB) this.emit({
                type: "impact",
                bodyA: eq.bodyA,
                bodyB: eq.bodyB,
                shapeA: eq.shapeA,
                shapeB: eq.shapeB,
                contactEquation: eq
            });
        }
    }
    updateSleeping(dt, islands) {
        if (this.sleepMode === 2) // Only awake dynamic bodies participate in sleep logic
        // Use Array.from since sleepTick may modify the set via sleep()
        for (const body of Array.from(this.bodies.dynamicAwake))body.sleepTick(this.time, false, dt);
        else if (this.sleepMode === 4 && this.islandSplit && islands) {
            // Only awake dynamic bodies participate in sleep logic
            for (const body of this.bodies.dynamicAwake)body.sleepTick(this.time, true, dt);
            // Sleep islands where all dynamic bodies want to sleep
            for (const island of islands){
                const allWantToSleep = island.bodies.every((body)=>body.motion !== "dynamic" || body.wantsToSleep);
                if (allWantToSleep) {
                    for (const body of island.bodies)if (body.motion === "dynamic") body.sleep();
                }
            }
        }
    }
    /** Add a spring to the simulation */ addSpring(spring) {
        this.springs.add(spring);
        this.emit({
            type: "addSpring",
            spring: spring
        });
    }
    /** Remove a spring */ removeSpring(spring) {
        this.springs.delete(spring);
    }
    /** Resets the World, removes all bodies, constraints and springs. */ clear() {
        this.time = 0;
        // Remove all constraints
        this.constraints.clear();
        // Remove all bodies
        this.bodies.clear();
        this.springs.clear();
        this.contactMaterials = new (0, $e12336751e5961c3$export$d58552c3b487f1d0)();
    }
    /**
   * Cast a ray and return the closest hit, or null if nothing was hit.
   *
   * @param from - Start point of the ray
   * @param to - End point of the ray
   * @param options - Optional raycast configuration
   * @returns The closest hit, or null if nothing was hit
   */ raycast(from, to, options) {
        return (0, $d9cbdfb0e7d73d1e$export$630e89aab3ddc1d6)(this, from, to, options);
    }
    /**
   * Cast a ray and return all hits, sorted by distance (closest first).
   *
   * @param from - Start point of the ray
   * @param to - End point of the ray
   * @param options - Optional raycast configuration
   * @returns Array of all hits, sorted by distance
   */ raycastAll(from, to, options) {
        return (0, $d9cbdfb0e7d73d1e$export$e6ff08404a53afd2)(this, from, to, options);
    }
}
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $5a1d1d3ab1ff9c51$export$4882ae973e0491e)
], $916dbba8a53e4e40$export$812cd9544993280d.prototype, "step", null);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $5a1d1d3ab1ff9c51$export$4882ae973e0491e)
], $916dbba8a53e4e40$export$812cd9544993280d.prototype, "applyForces", null);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $5a1d1d3ab1ff9c51$export$4882ae973e0491e)
], $916dbba8a53e4e40$export$812cd9544993280d.prototype, "doBroadphase", null);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $5a1d1d3ab1ff9c51$export$4882ae973e0491e)
], $916dbba8a53e4e40$export$812cd9544993280d.prototype, "updateOverlapTracking", null);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $5a1d1d3ab1ff9c51$export$4882ae973e0491e)
], $916dbba8a53e4e40$export$812cd9544993280d.prototype, "handleCollisionWakeUps", null);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $5a1d1d3ab1ff9c51$export$4882ae973e0491e)
], $916dbba8a53e4e40$export$812cd9544993280d.prototype, "emitContactEvents", null);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $5a1d1d3ab1ff9c51$export$4882ae973e0491e)
], $916dbba8a53e4e40$export$812cd9544993280d.prototype, "emitPreSolveAndWakeUp", null);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $5a1d1d3ab1ff9c51$export$4882ae973e0491e)
], $916dbba8a53e4e40$export$812cd9544993280d.prototype, "solve", null);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $5a1d1d3ab1ff9c51$export$4882ae973e0491e)
], $916dbba8a53e4e40$export$812cd9544993280d.prototype, "integrateForcesToVelocity", null);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $5a1d1d3ab1ff9c51$export$4882ae973e0491e)
], $916dbba8a53e4e40$export$812cd9544993280d.prototype, "integratePositions", null);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $5a1d1d3ab1ff9c51$export$4882ae973e0491e)
], $916dbba8a53e4e40$export$812cd9544993280d.prototype, "emitImpactEvents", null);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $5a1d1d3ab1ff9c51$export$4882ae973e0491e)
], $916dbba8a53e4e40$export$812cd9544993280d.prototype, "updateSleeping", null);


/**
 * Runtime master volume. Applied to the `masterGain` node on the Game's
 * AudioContext so it scales every sound uniformly.
 *
 * Setting persists to localStorage so the choice survives reloads.
 * Subscribers fire synchronously on change.
 */ const $396ca6dbf1c6942d$var$KEY = "masterVolume";
const $396ca6dbf1c6942d$var$DEFAULT_VOLUME = 1;
function $396ca6dbf1c6942d$var$load() {
    if (typeof localStorage === "undefined") return $396ca6dbf1c6942d$var$DEFAULT_VOLUME;
    const raw = localStorage.getItem($396ca6dbf1c6942d$var$KEY);
    if (raw === null) return $396ca6dbf1c6942d$var$DEFAULT_VOLUME;
    const parsed = Number(raw);
    if (!Number.isFinite(parsed)) return $396ca6dbf1c6942d$var$DEFAULT_VOLUME;
    return Math.min(1, Math.max(0, parsed));
}
let $396ca6dbf1c6942d$var$currentVolume = $396ca6dbf1c6942d$var$load();
const $396ca6dbf1c6942d$var$subscribers = new Set();
function $396ca6dbf1c6942d$export$657f181f46dbfffb() {
    return $396ca6dbf1c6942d$var$currentVolume;
}
function $396ca6dbf1c6942d$export$bd9196e59b031aae(volume) {
    const next = Math.min(1, Math.max(0, volume));
    if (next === $396ca6dbf1c6942d$var$currentVolume) return;
    $396ca6dbf1c6942d$var$currentVolume = next;
    if (typeof localStorage !== "undefined") localStorage.setItem($396ca6dbf1c6942d$var$KEY, String(next));
    for (const cb of $396ca6dbf1c6942d$var$subscribers)cb(next);
}
function $396ca6dbf1c6942d$export$f3427187b83b5bd8(cb) {
    $396ca6dbf1c6942d$var$subscribers.add(cb);
    return ()=>$396ca6dbf1c6942d$var$subscribers.delete(cb);
}





class $e4c72b6b95368f7f$export$985739bfa5723e08 {
    get io() {
        return this._io;
    }
    set io(value) {
        this._io = value;
    }
    /** Get the camera */ get camera() {
        return this.renderer.camera;
    }
    get averageDt() {
        return this.slowMo / (this.averageFrameDuration * this.ticksPerSecond);
    }
    /** Multiplier of time that passes during tick */ get slowMo() {
        return this._slowMo;
    }
    set slowMo(value) {
        if (value != this._slowMo) {
            this._slowMo = value;
            this.dispatch("slowMoChanged", {
                slowMo: this._slowMo
            });
        }
    }
    /**
   * Create a new Game.
   * NOTE: You must call .init() before actually using the game.
   */ constructor({ audio: audio, ticksPerSecond: ticksPerSecond = 120, world: world } = {}){
        /** Readonly. Whether or not the game is paused */ this.paused = false;
        /** Readonly. Number of frames that have gone by */ this.framenumber = 0;
        /** Readonly. Number of ticks that have gone by */ this.ticknumber = 0;
        /** The timestamp when the last frame started */ this.lastFrameTime = window.performance.now();
        /** Maximum allowed ticks per frame. */ this.maxTicksPerFrame = 5;
        /** ID of the current animation frame request, used for cancellation */ this.animationFrameId = 0;
        /** Whether the game has been destroyed */ this.destroyed = false;
        /** Whether the animation-frame loop is currently running. */ this.looping = false;
        /** Total amount of game time that has elapsed */ this.elapsedTime = 0;
        /** Total amount of game time that has elapsed while not paused */ this.elapsedUnpausedTime = 0;
        /** Keep track of how long each frame is taking on average */ this.averageFrameDuration = 1 / 60;
        this._slowMo = 1.0;
        /** Whether WebGPU has been initialized */ this.webGpuInitialized = false;
        /** Add an entity to the game. */ this.addEntity = (entity)=>{
            entity.game = this;
            if (entity.onAdd) entity.onAdd({
                game: this
            });
            // If the entity was destroyed during it's onAdd, we shouldn't add it
            if (!entity.isAdded) return entity;
            this.entities.add(entity);
            if (entity.body) {
                entity.body.owner = entity;
                this.world.bodies.add(entity.body);
            }
            if (entity.bodies) for (const body of entity.bodies){
                body.owner = entity;
                this.world.bodies.add(body);
            }
            if (entity.springs) for (const spring of entity.springs)this.world.addSpring(spring);
            if (entity.constraints) for (const constraint of entity.constraints)this.world.constraints.add(constraint);
            if (entity.onResize) entity.onResize({
                size: this.renderer.getSize()
            });
            if (entity.children) {
                for (const child of entity.children)if (!child.isAdded) this.addEntity(child);
            }
            if (entity.onAfterAdded) entity.onAfterAdded({
                game: this
            });
            return entity;
        };
        this.timeToSimulate = 0.0;
        /** Audio time at the end of the last frame's tick loop */ this.lastAudioTime = 0;
        // Handle beginning of collision between things.
        // Fired during narrowphase.
        this.beginContact = (event)=>{
            this.contactList.beginContact(event);
            const { shapeA: shapeA, shapeB: shapeB, bodyA: bodyA, bodyB: bodyB, contactEquations: contactEquations } = event;
            const ownerA = shapeA.owner ?? bodyA.owner;
            const ownerB = shapeB.owner ?? bodyB.owner;
            // If either owner has been removed from the game, we shouldn't do the contact
            if (ownerA?.isAdded && ownerB?.isAdded) {
                if (ownerA?.onBeginContact) ownerA.onBeginContact({
                    other: ownerB,
                    thisShape: shapeA,
                    otherShape: shapeB,
                    contactEquations: contactEquations
                });
                if (ownerB?.onBeginContact) ownerB.onBeginContact({
                    other: ownerA,
                    thisShape: shapeB,
                    otherShape: shapeA,
                    contactEquations: contactEquations
                });
            }
        };
        // Handle end of collision between things.
        // Fired during narrowphase.
        this.endContact = (event)=>{
            this.contactList.endContact(event);
            const { shapeA: shapeA, shapeB: shapeB, bodyA: bodyA, bodyB: bodyB } = event;
            const ownerA = shapeA.owner ?? bodyA.owner;
            const ownerB = shapeB.owner ?? bodyB.owner;
            // If either owner has been removed from the game, we shouldn't do the contact
            if (ownerA?.isAdded && ownerB?.isAdded) {
                if (ownerA?.onEndContact) ownerA.onEndContact({
                    other: ownerB,
                    thisShape: shapeA,
                    otherShape: shapeB
                });
                if (ownerB?.onEndContact) ownerB.onEndContact({
                    other: ownerA,
                    thisShape: shapeB,
                    otherShape: shapeA
                });
            }
        };
        // Handle collision between things.
        // Fired after physics step.
        this.impact = (event)=>{
            const ownerA = event.bodyA.owner;
            const ownerB = event.bodyB.owner;
            // If either owner has been removed from the game, we shouldn't do the contact
            if (ownerA?.isAdded && ownerB?.isAdded) {
                if (ownerA?.onImpact) ownerA.onImpact({
                    other: ownerB
                });
                if (ownerB?.onImpact) ownerB.onImpact({
                    other: ownerA
                });
            }
        };
        this.entities = new (0, $913c3d10ae4e12ec$export$8bb466c13870163e)();
        this.entitiesToRemove = new Set();
        this.renderer = new (0, $fb68242f783e6f0d$export$e8d4f9bbc35b572b)((0, $4fdefd1822880974$export$fdca3ba65b5cceec), (0, $4fdefd1822880974$export$3d0b505b9576cf7e), this.onResize.bind(this));
        this.ticksPerSecond = ticksPerSecond;
        this.tickDuration = 1.0 / this.ticksPerSecond;
        this.world = world ?? new (0, $916dbba8a53e4e40$export$812cd9544993280d)();
        this.world.on("beginContact", this.beginContact, null);
        this.world.on("endContact", this.endContact, null);
        this.world.on("impact", this.impact, null);
        this.ground = (0, $4aa863c0a97fa3b4$export$c9dd59e0dcee4be9)({
            motion: "static"
        });
        this.world.bodies.add(this.ground);
        this.contactList = new (0, $1d29da6ad0b954b4$export$909c3b6a9e12845c)();
        this.audio = audio ?? new AudioContext();
        this.masterGain = this.audio.createGain();
        this.masterGain.gain.value = (0, $396ca6dbf1c6942d$export$657f181f46dbfffb)();
        this.masterGain.connect(this.audio.destination);
        this.unsubscribeMasterVolume = (0, $396ca6dbf1c6942d$export$f3427187b83b5bd8)((volume)=>{
            this.masterGain.gain.setTargetAtTime(volume, this.audio.currentTime, 0.01);
        });
    }
    /** Initialize the game. By default also starts the animation-frame loop. */ async init({ rendererOptions: rendererOptions = {}, autoStart: autoStart = true } = {}) {
        // Initialize WebGPU
        if (!(0, $558c2f47f1fdd57f$export$d6935dc84c2cd4b0).isAvailable()) throw new Error("WebGPU is not available in this browser");
        await (0, $558c2f47f1fdd57f$export$297162150ea0f6af)().init();
        this.webGpuInitialized = true;
        (0, $5a1d1d3ab1ff9c51$export$e8e2fad003b4d4ce).registerScope("Game.nextFrame", ()=>(0, $87110bde7a27e156$export$c160a1ab3b49575c).endFrame());
        await this.renderer.init(rendererOptions);
        // IO events don't respect pause state
        const dispatchIo = (event, data)=>this.dispatch(event, data, false);
        this.io = new (0, $1150a8e0cd0aefe2$export$ac2778e3d733463d)(this.renderer.canvas, dispatchIo);
        this.addEntity(this.renderer.camera);
        if (autoStart) this.startLoop();
    }
    /**
   * Start the animation-frame loop. Called automatically by init() unless
   * autoStart is false. Safe to call if the loop is already running.
   */ startLoop() {
        if (this.looping || this.destroyed) return;
        this.looping = true;
        this.lastFrameTime = window.performance.now();
        this.lastAudioTime = this.audio.currentTime;
        this.animationFrameId = window.requestAnimationFrame((t)=>this.nextFrame(t));
    }
    /**
   * Stop the animation-frame loop. The game will not advance until startLoop()
   * is called or nextFrame() is called manually (e.g. from the DevTools console).
   */ stopLoop() {
        this.looping = false;
        window.cancelAnimationFrame(this.animationFrameId);
    }
    /** Check if WebGPU is available and initialized */ isWebGPUEnabled() {
        return this.webGpuInitialized;
    }
    /** Get the WebGPU device (throws if not initialized) */ getWebGPUDevice() {
        if (!this.webGpuInitialized) throw new Error("WebGPU is not initialized");
        return (0, $558c2f47f1fdd57f$export$297162150ea0f6af)().device;
    }
    /** Get the preferred texture format for canvases (throws if not initialized) */ getWebGPUPreferredFormat() {
        if (!this.webGpuInitialized) throw new Error("WebGPU is not initialized");
        return (0, $558c2f47f1fdd57f$export$297162150ea0f6af)().preferredFormat;
    }
    /** See pause() and unpause(). */ togglePause() {
        if (this.paused) this.unpause();
        else this.pause();
    }
    /** Called when renderer is resized */ onResize(size) {
        this.dispatch("resize", {
            size: (0, $6b6a54a072724620$export$e7c866399fa523f5)(size)
        });
    }
    /**
   * Pauses the game. This stops physics from running, calls onPause()
   * handlers, and stops updating `pausable` entities.
   */ pause() {
        if (!this.paused) {
            this.paused = true;
            this.dispatch("pause", undefined);
        }
    }
    /** Resumes the game and calls onUnpause() handlers. */ unpause() {
        this.paused = false;
        this.dispatch("unpause", undefined);
    }
    /** Destroy the game and clean up all resources. */ destroy() {
        if (this.destroyed) return;
        this.destroyed = true;
        // Cancel the animation frame loop
        window.cancelAnimationFrame(this.animationFrameId);
        // Destroy all entities
        for (const entity of this.entities)this.cleanupEntity(entity);
        this.entitiesToRemove.clear();
        // Remove physics world event listeners
        this.world.off("beginContact", this.beginContact);
        this.world.off("endContact", this.endContact);
        this.world.off("impact", this.impact);
        // Clear physics world
        this.world.clear();
        // Destroy IO manager (clears interval and event listeners)
        this.io.destroy();
        // Destroy renderer
        this.renderer.destroy();
        // Close audio context
        this.unsubscribeMasterVolume();
        this.audio.close();
    }
    /** Dispatch an event. */ dispatch(eventName, data, respectPause = true) {
        const effectivelyPaused = respectPause && this.paused;
        for (const entity of this.entities.getHandlers(eventName))if (entity.isAdded && !(effectivelyPaused && entity.pausable)) {
            const functionName = (0, $c0f9b00b45d3abcb$export$e4d4fc2de3f8add7)(eventName);
            const handler = entity[functionName];
            if (typeof handler !== "function") {
                console.error(`Entity ${entity.constructor.name} registered for "${eventName}" but has no ${functionName} method`, entity);
                continue;
            }
            handler.call(entity, data);
        }
    }
    /** Shortcut for adding multiple entities. */ addEntities(...entities) {
        for (const entity of entities)this.addEntity(entity);
        return entities;
    }
    /**
   * Remove an entity from the game.
   * The entity will actually be removed during the next removal pass.
   * This is because there are times when it's not safe to remove an entity, like in the middle of a physics step.
   */ removeEntity(entity) {
        entity.game = undefined;
        if (this.world.stepping) this.entitiesToRemove.add(entity);
        else this.cleanupEntity(entity);
        return entity;
    }
    /**
   * Removes all non-persistent entities from the game scene.
   * Only removes top-level entities (those without parents) to avoid double-cleanup.
   *
   * @param persistenceThreshold - Entities with persistence level <= this value will be removed (default: 0)
   */ clearScene(persistenceThreshold = 0) {
        for (const entity of this.entities)if (entity.isAdded && // Not already destroyed
        !this.entitiesToRemove.has(entity) && // not already about to be destroyed
        entity.persistenceLevel <= persistenceThreshold && !entity.parent // We only wanna deal with top-level things, let parents handle the rest
        ) entity.destroy();
    }
    /**
   * Run one frame of the game. Normally called by the animation-frame loop,
   * but can also be invoked manually (e.g. from the DevTools console) after
   * stopLoop() to step the simulation forward one frame at a time.
   */ async nextFrame(time = window.performance.now()) {
        if (this.destroyed) return;
        this.framenumber += 1;
        const lastFrameDuration = (time - this.lastFrameTime) / 1000;
        this.lastFrameTime = time;
        // Keep a rolling average
        if (0 < lastFrameDuration && lastFrameDuration < 0.3) // Ignore weird durations because they're probably flukes from the user
        // changing to a different tab/window or loading a new level or something
        this.averageFrameDuration = (0, $2172aedd5a25ff17$export$3a89f8d6f6bf6c9f)(this.averageFrameDuration, lastFrameDuration, 0.05);
        const renderDt = 1.0 / 120.0; // TODO: Remove this hardcoding eventually  //1.0 / this.getScreenFps();
        this.elapsedTime += renderDt;
        if (!this.paused) this.elapsedUnpausedTime += renderDt;
        this.slowTick(renderDt * this.slowMo);
        if (!this.paused) this.timeToSimulate = Math.min(this.timeToSimulate + renderDt * this.slowMo, this.tickDuration * this.maxTicksPerFrame);
        // Distribute real audio time evenly across this frame's ticks
        const audioNow = this.audio.currentTime;
        const tickCount = Math.floor(this.timeToSimulate / this.tickDuration);
        const audioTimeStep = tickCount > 0 ? (audioNow - this.lastAudioTime) / tickCount : 0;
        let tickAudioTime = this.lastAudioTime;
        while(this.timeToSimulate >= this.tickDuration){
            this.timeToSimulate -= this.tickDuration;
            tickAudioTime += audioTimeStep;
            await this.tick(this.tickDuration, tickAudioTime);
            if (!this.paused) {
                const stepDt = this.tickDuration;
                this.world.step(stepDt);
                (0, $5a1d1d3ab1ff9c51$export$e8e2fad003b4d4ce).measure("Game.afterPhysicsStep", ()=>{
                    this.dispatch("afterPhysicsStep", stepDt);
                    this.cleanupEntities();
                });
                this.contacts();
            }
        }
        this.lastAudioTime = audioNow;
        this.afterPhysics();
        this.render(renderDt);
        // CRITICAL: Request next frame at END to prevent concurrent loops
        if (this.looping) this.animationFrameId = window.requestAnimationFrame((t)=>this.nextFrame(t));
    }
    /**
   * Calculates and returns the current screen frames per second based on average frame duration.
   * @returns The current FPS rounded to the nearest integer
   */ getScreenFps() {
        const duration = this.averageFrameDuration;
        return Math.round(1.0 / duration);
    }
    /** Actually remove all the entities slated for removal from the game. */ cleanupEntities() {
        for (const entity of this.entitiesToRemove)this.cleanupEntity(entity);
        this.entitiesToRemove.clear();
    }
    cleanupEntity(entity) {
        entity.game = undefined; // This should be done by `removeEntity`, but better safe than sorry
        this.entities.remove(entity);
        if (entity.body) this.world.bodies.remove(entity.body);
        if (entity.bodies) for (const body of entity.bodies)this.world.bodies.remove(body);
        if (entity.springs) for (const spring of entity.springs)this.world.removeSpring(spring);
        if (entity.constraints) for (const constraint of entity.constraints)this.world.constraints.remove(constraint);
        if (entity.onDestroy) entity.onDestroy({
            game: this
        });
    }
    /** Called before physics. */ async tick(dt, audioTime) {
        this.ticknumber += 1;
        const tickData = {
            dt: dt,
            audioTime: audioTime
        };
        // Dispatch tick events layer by layer
        for (const layerName of (0, $6145a191889e9b21$export$14b9f468219135))await (0, $5a1d1d3ab1ff9c51$export$e8e2fad003b4d4ce).measure(`tick.${layerName}`, ()=>this.dispatchTickForLayer(layerName, tickData));
    }
    /** Dispatch tick event to entities on a specific layer */ async dispatchTickForLayer(layerName, tickData) {
        const effectivelyPaused = this.paused;
        const promises = [];
        for (const entity of this.entities.getTickersOnLayer(layerName))if (entity.isAdded && !(effectivelyPaused && entity.pausable)) {
            const result = entity.onTick?.(tickData);
            // Only collect actual Promises
            if (result && result instanceof Promise) promises.push(result);
        }
        // Only await if there were any Promises
        if (promises.length > 0) await Promise.all(promises);
    }
    /** Called before normal ticks */ slowTick(dt) {
        this.dispatch("slowTick", dt);
    }
    /** Called after physics. */ afterPhysics() {
        this.cleanupEntities();
        this.dispatch("afterPhysics", undefined);
    }
    /** Get the low-level renderer for direct drawing */ getRenderer() {
        return this.renderer.getRenderer();
    }
    /**
   * Enable or disable GPU timing.
   * When enabled, GPU render time will appear in profiler under "gpu".
   */ setGpuTimingEnabled(enabled) {
        this.renderer.setGpuTimingEnabled(enabled);
    }
    /** Check if GPU timer extension is available */ hasGpuTimerSupport() {
        return this.renderer.hasGpuTimerSupport();
    }
    /** Called to render the current frame. */ render(dt) {
        this.cleanupEntities();
        // Begin frame
        this.renderer.beginFrame();
        // Create Draw context for this frame
        const draw = new (0, $3a182ab185f8c532$export$dca20402ebea5ece)(this.renderer.getRenderer(), this.renderer.camera);
        // Render each layer in order
        const layerNames = this.renderer.getLayerNames();
        for (const layerName of layerNames)(0, $5a1d1d3ab1ff9c51$export$e8e2fad003b4d4ce).measure(`layer.${layerName}`, ()=>{
            // Set the camera transform for this layer
            this.renderer.setLayer(layerName);
            // Dispatch render event for entities on this layer
            this.dispatchRenderForLayer(layerName, dt, draw);
        });
        // End frame
        this.renderer.endFrame();
    }
    /** Dispatch render event to entities on a specific layer */ dispatchRenderForLayer(layerName, dt, draw) {
        const renderData = {
            dt: dt,
            layer: layerName,
            draw: draw,
            camera: draw.camera
        };
        for (const entity of this.entities.getRenderersOnLayer(layerName))if (entity.isAdded) (0, $5a1d1d3ab1ff9c51$export$e8e2fad003b4d4ce).measure(entity.constructor.name, ()=>{
            entity.onRender?.(renderData);
        });
    }
    contacts() {
        for (const contact of this.contactList.getContacts()){
            const { shapeA: shapeA, shapeB: shapeB, bodyA: bodyA, bodyB: bodyB, contactEquations: contactEquations } = contact;
            const ownerA = shapeA.owner ?? bodyA.owner;
            const ownerB = shapeB.owner ?? bodyB.owner;
            if (ownerA?.onContacting) ownerA.onContacting({
                other: ownerB,
                otherShape: shapeB,
                thisShape: shapeA,
                contactEquations: contactEquations
            });
            if (ownerB?.onContacting) ownerB.onContacting({
                other: ownerA,
                otherShape: shapeA,
                thisShape: shapeB,
                contactEquations: contactEquations
            });
        }
    }
}
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $5a1d1d3ab1ff9c51$export$4882ae973e0491e)
], $e4c72b6b95368f7f$export$985739bfa5723e08.prototype, "nextFrame", null);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $5a1d1d3ab1ff9c51$export$4882ae973e0491e)
], $e4c72b6b95368f7f$export$985739bfa5723e08.prototype, "tick", null);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $5a1d1d3ab1ff9c51$export$4882ae973e0491e)
], $e4c72b6b95368f7f$export$985739bfa5723e08.prototype, "slowTick", null);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $5a1d1d3ab1ff9c51$export$4882ae973e0491e)
], $e4c72b6b95368f7f$export$985739bfa5723e08.prototype, "render", null);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $5a1d1d3ab1ff9c51$export$4882ae973e0491e)
], $e4c72b6b95368f7f$export$985739bfa5723e08.prototype, "contacts", null);




/**
 * Registry for runtime-tunable values.
 *
 * In development builds, the parcel-transformer-tunables plugin scans for
 * `//#tunable` comments above `let` declarations and injects registration
 * calls that wire each variable to this registry via a setter callback.
 *
 * Usage in game code:
 *
 *   //#tunable { min: 0.1, max: 5 }
 *   let ZOOM_SPEED: number = 0.75;
 *
 * The variable remains a plain `let` — zero overhead on reads.
 * The TuningPanel UI reads from this registry to show sliders.
 */ class $ca380632be0019fe$var$TunableRegistry {
    /**
   * Register a tunable value. Called by transformer-generated code.
   */ register(path, defaultValue, options, setter) {
        const lastSlash = path.lastIndexOf("/");
        const group = lastSlash >= 0 ? path.substring(0, lastSlash) : "General";
        const name = lastSlash >= 0 ? path.substring(lastSlash + 1) : path;
        // Hot reload: if already registered, update the setter but keep current value
        const existing = this.entries.get(path);
        if (existing) {
            existing.setter = setter;
            setter(existing.value);
            return;
        }
        this.entries.set(path, {
            path: path,
            group: group,
            name: name,
            defaultValue: defaultValue,
            value: defaultValue,
            options: options,
            setter: setter
        });
        this.notify();
    }
    /** Update a tunable's value and call its setter. */ set(path, value) {
        const entry = this.entries.get(path);
        if (entry) {
            entry.value = value;
            entry.setter(value);
            this.notify();
        }
    }
    /** Reset one or all tunables to their default values. */ reset(path) {
        if (path) {
            const entry = this.entries.get(path);
            if (entry) {
                entry.value = entry.defaultValue;
                entry.setter(entry.defaultValue);
                this.notify();
            }
        } else {
            for (const entry of this.entries.values()){
                entry.value = entry.defaultValue;
                entry.setter(entry.defaultValue);
            }
            this.notify();
        }
    }
    /** Reset all tunables in a specific group. */ resetGroup(group) {
        for (const entry of this.entries.values())if (entry.group === group) {
            entry.value = entry.defaultValue;
            entry.setter(entry.defaultValue);
        }
        this.notify();
    }
    /** Get all entries grouped by their group name. */ getGroups() {
        const groups = new Map();
        for (const entry of this.entries.values()){
            let group = groups.get(entry.group);
            if (!group) {
                group = [];
                groups.set(entry.group, group);
            }
            group.push(entry);
        }
        return groups;
    }
    /** Whether any tunables have been registered. */ get isEmpty() {
        return this.entries.size === 0;
    }
    /** Subscribe to changes. Returns an unsubscribe function. */ onChange(listener) {
        this.listeners.add(listener);
        return ()=>this.listeners.delete(listener);
    }
    notify() {
        for (const listener of this.listeners)listener();
    }
    constructor(){
        this.entries = new Map();
        this.listeners = new Set();
    }
}
const $ca380632be0019fe$export$8afe3a32a4a965fb = new $ca380632be0019fe$var$TunableRegistry();
globalThis.__tunableRegistry = $ca380632be0019fe$export$8afe3a32a4a965fb;


/**
 * Runtime tuning panel UI.
 *
 * Renders a floating panel with sliders for all registered tunable values.
 * Toggle visibility with the backslash (\) key.
 */ 
var $13c40c34b78c8ee2$var$n, $13c40c34b78c8ee2$export$41c562ebe57d11e2, $13c40c34b78c8ee2$var$u, $13c40c34b78c8ee2$export$a8257692ac88316c, $13c40c34b78c8ee2$var$i, $13c40c34b78c8ee2$var$o, $13c40c34b78c8ee2$var$r, $13c40c34b78c8ee2$var$e, $13c40c34b78c8ee2$var$f, $13c40c34b78c8ee2$var$c, $13c40c34b78c8ee2$var$s, $13c40c34b78c8ee2$var$a, $13c40c34b78c8ee2$var$h, $13c40c34b78c8ee2$var$p = {}, $13c40c34b78c8ee2$var$v = [], $13c40c34b78c8ee2$var$y = /acit|ex(?:s|g|n|p|$)|rph|grid|ows|mnc|ntw|ine[ch]|zoo|^ord|itera/i, $13c40c34b78c8ee2$var$d = Array.isArray;
function $13c40c34b78c8ee2$var$w(n, l) {
    for(var u in l)n[u] = l[u];
    return n;
}
function $13c40c34b78c8ee2$var$g(n) {
    n && n.parentNode && n.parentNode.removeChild(n);
}
function $13c40c34b78c8ee2$export$c8a8987d4410bf2d(l, u, t) {
    var i, o, r, e = {};
    for(r in u)"key" == r ? i = u[r] : "ref" == r ? o = u[r] : e[r] = u[r];
    if (arguments.length > 2 && (e.children = arguments.length > 3 ? $13c40c34b78c8ee2$var$n.call(arguments, 2) : t), "function" == typeof l && null != l.defaultProps) for(r in l.defaultProps)void 0 === e[r] && (e[r] = l.defaultProps[r]);
    return $13c40c34b78c8ee2$var$m(l, e, i, o, null);
}
function $13c40c34b78c8ee2$var$m(n, t, i, o, r) {
    var e = {
        type: n,
        props: t,
        key: i,
        ref: o,
        __k: null,
        __: null,
        __b: 0,
        __e: null,
        __c: null,
        constructor: void 0,
        __v: null == r ? ++$13c40c34b78c8ee2$var$u : r,
        __i: -1,
        __u: 0
    };
    return null == r && null != $13c40c34b78c8ee2$export$41c562ebe57d11e2.vnode && $13c40c34b78c8ee2$export$41c562ebe57d11e2.vnode(e), e;
}
function $13c40c34b78c8ee2$export$7d1e3a5e95ceca43() {
    return {
        current: null
    };
}
function $13c40c34b78c8ee2$export$ffb0004e005737fa(n) {
    return n.children;
}
function $13c40c34b78c8ee2$export$16fa2f45be04daa8(n, l) {
    this.props = n, this.context = l;
}
function $13c40c34b78c8ee2$var$S(n, l) {
    if (null == l) return n.__ ? $13c40c34b78c8ee2$var$S(n.__, n.__i + 1) : null;
    for(var u; l < n.__k.length; l++)if (null != (u = n.__k[l]) && null != u.__e) return u.__e;
    return "function" == typeof n.type ? $13c40c34b78c8ee2$var$S(n) : null;
}
function $13c40c34b78c8ee2$var$C(n) {
    var l, u;
    if (null != (n = n.__) && null != n.__c) {
        for(n.__e = n.__c.base = null, l = 0; l < n.__k.length; l++)if (null != (u = n.__k[l]) && null != u.__e) {
            n.__e = n.__c.base = u.__e;
            break;
        }
        return $13c40c34b78c8ee2$var$C(n);
    }
}
function $13c40c34b78c8ee2$var$M(n) {
    (!n.__d && (n.__d = !0) && $13c40c34b78c8ee2$var$i.push(n) && !$13c40c34b78c8ee2$var$$.__r++ || $13c40c34b78c8ee2$var$o != $13c40c34b78c8ee2$export$41c562ebe57d11e2.debounceRendering) && (($13c40c34b78c8ee2$var$o = $13c40c34b78c8ee2$export$41c562ebe57d11e2.debounceRendering) || $13c40c34b78c8ee2$var$r)($13c40c34b78c8ee2$var$$);
}
function $13c40c34b78c8ee2$var$$() {
    for(var n, u, t, o, r, f, c, s = 1; $13c40c34b78c8ee2$var$i.length;)$13c40c34b78c8ee2$var$i.length > s && $13c40c34b78c8ee2$var$i.sort($13c40c34b78c8ee2$var$e), n = $13c40c34b78c8ee2$var$i.shift(), s = $13c40c34b78c8ee2$var$i.length, n.__d && (t = void 0, o = void 0, r = (o = (u = n).__v).__e, f = [], c = [], u.__P && ((t = $13c40c34b78c8ee2$var$w({}, o)).__v = o.__v + 1, $13c40c34b78c8ee2$export$41c562ebe57d11e2.vnode && $13c40c34b78c8ee2$export$41c562ebe57d11e2.vnode(t), $13c40c34b78c8ee2$var$O(u.__P, t, o, u.__n, u.__P.namespaceURI, 32 & o.__u ? [
        r
    ] : null, f, null == r ? $13c40c34b78c8ee2$var$S(o) : r, !!(32 & o.__u), c), t.__v = o.__v, t.__.__k[t.__i] = t, $13c40c34b78c8ee2$var$N(f, t, c), o.__e = o.__ = null, t.__e != r && $13c40c34b78c8ee2$var$C(t)));
    $13c40c34b78c8ee2$var$$.__r = 0;
}
function $13c40c34b78c8ee2$var$I(n, l, u, t, i, o, r, e, f, c, s) {
    var a, h, y, d, w, g, _, m = t && t.__k || $13c40c34b78c8ee2$var$v, b = l.length;
    for(f = $13c40c34b78c8ee2$var$P(u, l, m, f, b), a = 0; a < b; a++)null != (y = u.__k[a]) && (h = -1 == y.__i ? $13c40c34b78c8ee2$var$p : m[y.__i] || $13c40c34b78c8ee2$var$p, y.__i = a, g = $13c40c34b78c8ee2$var$O(n, y, h, i, o, r, e, f, c, s), d = y.__e, y.ref && h.ref != y.ref && (h.ref && $13c40c34b78c8ee2$var$B(h.ref, null, y), s.push(y.ref, y.__c || d, y)), null == w && null != d && (w = d), (_ = !!(4 & y.__u)) || h.__k === y.__k ? f = $13c40c34b78c8ee2$var$A(y, f, n, _) : "function" == typeof y.type && void 0 !== g ? f = g : d && (f = d.nextSibling), y.__u &= -7);
    return u.__e = w, f;
}
function $13c40c34b78c8ee2$var$P(n, l, u, t, i) {
    var o, r, e, f, c, s = u.length, a = s, h = 0;
    for(n.__k = new Array(i), o = 0; o < i; o++)null != (r = l[o]) && "boolean" != typeof r && "function" != typeof r ? ("string" == typeof r || "number" == typeof r || "bigint" == typeof r || r.constructor == String ? r = n.__k[o] = $13c40c34b78c8ee2$var$m(null, r, null, null, null) : $13c40c34b78c8ee2$var$d(r) ? r = n.__k[o] = $13c40c34b78c8ee2$var$m($13c40c34b78c8ee2$export$ffb0004e005737fa, {
        children: r
    }, null, null, null) : void 0 === r.constructor && r.__b > 0 ? r = n.__k[o] = $13c40c34b78c8ee2$var$m(r.type, r.props, r.key, r.ref ? r.ref : null, r.__v) : n.__k[o] = r, f = o + h, r.__ = n, r.__b = n.__b + 1, e = null, -1 != (c = r.__i = $13c40c34b78c8ee2$var$L(r, u, f, a)) && (a--, (e = u[c]) && (e.__u |= 2)), null == e || null == e.__v ? (-1 == c && (i > s ? h-- : i < s && h++), "function" != typeof r.type && (r.__u |= 4)) : c != f && (c == f - 1 ? h-- : c == f + 1 ? h++ : (c > f ? h-- : h++, r.__u |= 4))) : n.__k[o] = null;
    if (a) for(o = 0; o < s; o++)null != (e = u[o]) && 0 == (2 & e.__u) && (e.__e == t && (t = $13c40c34b78c8ee2$var$S(e)), $13c40c34b78c8ee2$var$D(e, e));
    return t;
}
function $13c40c34b78c8ee2$var$A(n, l, u, t) {
    var i, o;
    if ("function" == typeof n.type) {
        for(i = n.__k, o = 0; i && o < i.length; o++)i[o] && (i[o].__ = n, l = $13c40c34b78c8ee2$var$A(i[o], l, u, t));
        return l;
    }
    n.__e != l && (t && (l && n.type && !l.parentNode && (l = $13c40c34b78c8ee2$var$S(n)), u.insertBefore(n.__e, l || null)), l = n.__e);
    do l = l && l.nextSibling;
    while (null != l && 8 == l.nodeType);
    return l;
}
function $13c40c34b78c8ee2$export$47e4c5b300681277(n, l) {
    return l = l || [], null == n || "boolean" == typeof n || ($13c40c34b78c8ee2$var$d(n) ? n.some(function(n) {
        $13c40c34b78c8ee2$export$47e4c5b300681277(n, l);
    }) : l.push(n)), l;
}
function $13c40c34b78c8ee2$var$L(n, l, u, t) {
    var i, o, r, e = n.key, f = n.type, c = l[u], s = null != c && 0 == (2 & c.__u);
    if (null === c && null == e || s && e == c.key && f == c.type) return u;
    if (t > (s ? 1 : 0)) {
        for(i = u - 1, o = u + 1; i >= 0 || o < l.length;)if (null != (c = l[r = i >= 0 ? i-- : o++]) && 0 == (2 & c.__u) && e == c.key && f == c.type) return r;
    }
    return -1;
}
function $13c40c34b78c8ee2$var$T(n, l, u) {
    "-" == l[0] ? n.setProperty(l, null == u ? "" : u) : n[l] = null == u ? "" : "number" != typeof u || $13c40c34b78c8ee2$var$y.test(l) ? u : u + "px";
}
function $13c40c34b78c8ee2$var$j(n, l, u, t, i) {
    var o, r;
    n: if ("style" == l) {
        if ("string" == typeof u) n.style.cssText = u;
        else {
            if ("string" == typeof t && (n.style.cssText = t = ""), t) for(l in t)u && l in u || $13c40c34b78c8ee2$var$T(n.style, l, "");
            if (u) for(l in u)t && u[l] == t[l] || $13c40c34b78c8ee2$var$T(n.style, l, u[l]);
        }
    } else if ("o" == l[0] && "n" == l[1]) o = l != (l = l.replace($13c40c34b78c8ee2$var$f, "$1")), r = l.toLowerCase(), l = r in n || "onFocusOut" == l || "onFocusIn" == l ? r.slice(2) : l.slice(2), n.l || (n.l = {}), n.l[l + o] = u, u ? t ? u.u = t.u : (u.u = $13c40c34b78c8ee2$var$c, n.addEventListener(l, o ? $13c40c34b78c8ee2$var$a : $13c40c34b78c8ee2$var$s, o)) : n.removeEventListener(l, o ? $13c40c34b78c8ee2$var$a : $13c40c34b78c8ee2$var$s, o);
    else {
        if ("http://www.w3.org/2000/svg" == i) l = l.replace(/xlink(H|:h)/, "h").replace(/sName$/, "s");
        else if ("width" != l && "height" != l && "href" != l && "list" != l && "form" != l && "tabIndex" != l && "download" != l && "rowSpan" != l && "colSpan" != l && "role" != l && "popover" != l && l in n) try {
            n[l] = null == u ? "" : u;
            break n;
        } catch (n) {}
        "function" == typeof u || (null == u || !1 === u && "-" != l[4] ? n.removeAttribute(l) : n.setAttribute(l, "popover" == l && 1 == u ? "" : u));
    }
}
function $13c40c34b78c8ee2$var$F(n) {
    return function(u) {
        if (this.l) {
            var t = this.l[u.type + n];
            if (null == u.t) u.t = $13c40c34b78c8ee2$var$c++;
            else if (u.t < t.u) return;
            return t($13c40c34b78c8ee2$export$41c562ebe57d11e2.event ? $13c40c34b78c8ee2$export$41c562ebe57d11e2.event(u) : u);
        }
    };
}
function $13c40c34b78c8ee2$var$O(n, u, t, i, o, r, e, f, c, s) {
    var a, h, p, v, y, _, m, b, S, C, M, $, P, A, H, L, T, j = u.type;
    if (void 0 !== u.constructor) return null;
    128 & t.__u && (c = !!(32 & t.__u), r = [
        f = u.__e = t.__e
    ]), (a = $13c40c34b78c8ee2$export$41c562ebe57d11e2.__b) && a(u);
    n: if ("function" == typeof j) try {
        if (b = u.props, S = "prototype" in j && j.prototype.render, C = (a = j.contextType) && i[a.__c], M = a ? C ? C.props.value : a.__ : i, t.__c ? m = (h = u.__c = t.__c).__ = h.__E : (S ? u.__c = h = new j(b, M) : (u.__c = h = new $13c40c34b78c8ee2$export$16fa2f45be04daa8(b, M), h.constructor = j, h.render = $13c40c34b78c8ee2$var$E), C && C.sub(h), h.state || (h.state = {}), h.__n = i, p = h.__d = !0, h.__h = [], h._sb = []), S && null == h.__s && (h.__s = h.state), S && null != j.getDerivedStateFromProps && (h.__s == h.state && (h.__s = $13c40c34b78c8ee2$var$w({}, h.__s)), $13c40c34b78c8ee2$var$w(h.__s, j.getDerivedStateFromProps(b, h.__s))), v = h.props, y = h.state, h.__v = u, p) S && null == j.getDerivedStateFromProps && null != h.componentWillMount && h.componentWillMount(), S && null != h.componentDidMount && h.__h.push(h.componentDidMount);
        else {
            if (S && null == j.getDerivedStateFromProps && b !== v && null != h.componentWillReceiveProps && h.componentWillReceiveProps(b, M), u.__v == t.__v || !h.__e && null != h.shouldComponentUpdate && !1 === h.shouldComponentUpdate(b, h.__s, M)) {
                for(u.__v != t.__v && (h.props = b, h.state = h.__s, h.__d = !1), u.__e = t.__e, u.__k = t.__k, u.__k.some(function(n) {
                    n && (n.__ = u);
                }), $ = 0; $ < h._sb.length; $++)h.__h.push(h._sb[$]);
                h._sb = [], h.__h.length && e.push(h);
                break n;
            }
            null != h.componentWillUpdate && h.componentWillUpdate(b, h.__s, M), S && null != h.componentDidUpdate && h.__h.push(function() {
                h.componentDidUpdate(v, y, _);
            });
        }
        if (h.context = M, h.props = b, h.__P = n, h.__e = !1, P = $13c40c34b78c8ee2$export$41c562ebe57d11e2.__r, A = 0, S) {
            for(h.state = h.__s, h.__d = !1, P && P(u), a = h.render(h.props, h.state, h.context), H = 0; H < h._sb.length; H++)h.__h.push(h._sb[H]);
            h._sb = [];
        } else do h.__d = !1, P && P(u), a = h.render(h.props, h.state, h.context), h.state = h.__s;
        while (h.__d && ++A < 25);
        h.state = h.__s, null != h.getChildContext && (i = $13c40c34b78c8ee2$var$w($13c40c34b78c8ee2$var$w({}, i), h.getChildContext())), S && !p && null != h.getSnapshotBeforeUpdate && (_ = h.getSnapshotBeforeUpdate(v, y)), L = a, null != a && a.type === $13c40c34b78c8ee2$export$ffb0004e005737fa && null == a.key && (L = $13c40c34b78c8ee2$var$V(a.props.children)), f = $13c40c34b78c8ee2$var$I(n, $13c40c34b78c8ee2$var$d(L) ? L : [
            L
        ], u, t, i, o, r, e, f, c, s), h.base = u.__e, u.__u &= -161, h.__h.length && e.push(h), m && (h.__E = h.__ = null);
    } catch (n) {
        if (u.__v = null, c || null != r) {
            if (n.then) {
                for(u.__u |= c ? 160 : 128; f && 8 == f.nodeType && f.nextSibling;)f = f.nextSibling;
                r[r.indexOf(f)] = null, u.__e = f;
            } else {
                for(T = r.length; T--;)$13c40c34b78c8ee2$var$g(r[T]);
                $13c40c34b78c8ee2$var$z(u);
            }
        } else u.__e = t.__e, u.__k = t.__k, n.then || $13c40c34b78c8ee2$var$z(u);
        $13c40c34b78c8ee2$export$41c562ebe57d11e2.__e(n, u, t);
    }
    else null == r && u.__v == t.__v ? (u.__k = t.__k, u.__e = t.__e) : f = u.__e = $13c40c34b78c8ee2$var$q(t.__e, u, t, i, o, r, e, c, s);
    return (a = $13c40c34b78c8ee2$export$41c562ebe57d11e2.diffed) && a(u), 128 & u.__u ? void 0 : f;
}
function $13c40c34b78c8ee2$var$z(n) {
    n && n.__c && (n.__c.__e = !0), n && n.__k && n.__k.forEach($13c40c34b78c8ee2$var$z);
}
function $13c40c34b78c8ee2$var$N(n, u, t) {
    for(var i = 0; i < t.length; i++)$13c40c34b78c8ee2$var$B(t[i], t[++i], t[++i]);
    $13c40c34b78c8ee2$export$41c562ebe57d11e2.__c && $13c40c34b78c8ee2$export$41c562ebe57d11e2.__c(u, n), n.some(function(u) {
        try {
            n = u.__h, u.__h = [], n.some(function(n) {
                n.call(u);
            });
        } catch (n) {
            $13c40c34b78c8ee2$export$41c562ebe57d11e2.__e(n, u.__v);
        }
    });
}
function $13c40c34b78c8ee2$var$V(n) {
    return "object" != typeof n || null == n || n.__b && n.__b > 0 ? n : $13c40c34b78c8ee2$var$d(n) ? n.map($13c40c34b78c8ee2$var$V) : $13c40c34b78c8ee2$var$w({}, n);
}
function $13c40c34b78c8ee2$var$q(u, t, i, o, r, e, f, c, s) {
    var a, h, v, y, w, _, m, b = i.props || $13c40c34b78c8ee2$var$p, k = t.props, x = t.type;
    if ("svg" == x ? r = "http://www.w3.org/2000/svg" : "math" == x ? r = "http://www.w3.org/1998/Math/MathML" : r || (r = "http://www.w3.org/1999/xhtml"), null != e) {
        for(a = 0; a < e.length; a++)if ((w = e[a]) && "setAttribute" in w == !!x && (x ? w.localName == x : 3 == w.nodeType)) {
            u = w, e[a] = null;
            break;
        }
    }
    if (null == u) {
        if (null == x) return document.createTextNode(k);
        u = document.createElementNS(r, x, k.is && k), c && ($13c40c34b78c8ee2$export$41c562ebe57d11e2.__m && $13c40c34b78c8ee2$export$41c562ebe57d11e2.__m(t, e), c = !1), e = null;
    }
    if (null == x) b === k || c && u.data == k || (u.data = k);
    else {
        if (e = e && $13c40c34b78c8ee2$var$n.call(u.childNodes), !c && null != e) for(b = {}, a = 0; a < u.attributes.length; a++)b[(w = u.attributes[a]).name] = w.value;
        for(a in b)if (w = b[a], "children" == a) ;
        else if ("dangerouslySetInnerHTML" == a) v = w;
        else if (!(a in k)) {
            if ("value" == a && "defaultValue" in k || "checked" == a && "defaultChecked" in k) continue;
            $13c40c34b78c8ee2$var$j(u, a, null, w, r);
        }
        for(a in k)w = k[a], "children" == a ? y = w : "dangerouslySetInnerHTML" == a ? h = w : "value" == a ? _ = w : "checked" == a ? m = w : c && "function" != typeof w || b[a] === w || $13c40c34b78c8ee2$var$j(u, a, w, b[a], r);
        if (h) c || v && (h.__html == v.__html || h.__html == u.innerHTML) || (u.innerHTML = h.__html), t.__k = [];
        else if (v && (u.innerHTML = ""), $13c40c34b78c8ee2$var$I("template" == t.type ? u.content : u, $13c40c34b78c8ee2$var$d(y) ? y : [
            y
        ], t, i, o, "foreignObject" == x ? "http://www.w3.org/1999/xhtml" : r, e, f, e ? e[0] : i.__k && $13c40c34b78c8ee2$var$S(i, 0), c, s), null != e) for(a = e.length; a--;)$13c40c34b78c8ee2$var$g(e[a]);
        c || (a = "value", "progress" == x && null == _ ? u.removeAttribute("value") : null != _ && (_ !== u[a] || "progress" == x && !_ || "option" == x && _ != b[a]) && $13c40c34b78c8ee2$var$j(u, a, _, b[a], r), a = "checked", null != m && m != u[a] && $13c40c34b78c8ee2$var$j(u, a, m, b[a], r));
    }
    return u;
}
function $13c40c34b78c8ee2$var$B(n, u, t) {
    try {
        if ("function" == typeof n) {
            var i = "function" == typeof n.__u;
            i && n.__u(), i && null == u || (n.__u = n(u));
        } else n.current = u;
    } catch (n) {
        $13c40c34b78c8ee2$export$41c562ebe57d11e2.__e(n, t);
    }
}
function $13c40c34b78c8ee2$var$D(n, u, t) {
    var i, o;
    if ($13c40c34b78c8ee2$export$41c562ebe57d11e2.unmount && $13c40c34b78c8ee2$export$41c562ebe57d11e2.unmount(n), (i = n.ref) && (i.current && i.current != n.__e || $13c40c34b78c8ee2$var$B(i, null, u)), null != (i = n.__c)) {
        if (i.componentWillUnmount) try {
            i.componentWillUnmount();
        } catch (n) {
            $13c40c34b78c8ee2$export$41c562ebe57d11e2.__e(n, u);
        }
        i.base = i.__P = null;
    }
    if (i = n.__k) for(o = 0; o < i.length; o++)i[o] && $13c40c34b78c8ee2$var$D(i[o], u, t || "function" != typeof n.type);
    t || $13c40c34b78c8ee2$var$g(n.__e), n.__c = n.__ = n.__e = void 0;
}
function $13c40c34b78c8ee2$var$E(n, l, u) {
    return this.constructor(n, u);
}
function $13c40c34b78c8ee2$export$b3890eb0ae9dca99(u, t, i) {
    var o, r, e, f;
    t == document && (t = document.documentElement), $13c40c34b78c8ee2$export$41c562ebe57d11e2.__ && $13c40c34b78c8ee2$export$41c562ebe57d11e2.__(u, t), r = (o = "function" == typeof i) ? null : i && i.__k || t.__k, e = [], f = [], $13c40c34b78c8ee2$var$O(t, u = (!o && i || t).__k = $13c40c34b78c8ee2$export$c8a8987d4410bf2d($13c40c34b78c8ee2$export$ffb0004e005737fa, null, [
        u
    ]), r || $13c40c34b78c8ee2$var$p, $13c40c34b78c8ee2$var$p, t.namespaceURI, !o && i ? [
        i
    ] : r ? null : t.firstChild ? $13c40c34b78c8ee2$var$n.call(t.childNodes) : null, e, !o && i ? i : r ? r.__e : t.firstChild, o, f), $13c40c34b78c8ee2$var$N(e, u, f);
}
function $13c40c34b78c8ee2$export$fa8d919ba61d84db(n, l) {
    $13c40c34b78c8ee2$export$b3890eb0ae9dca99(n, l, $13c40c34b78c8ee2$export$fa8d919ba61d84db);
}
function $13c40c34b78c8ee2$export$e530037191fcd5d7(l, u, t) {
    var i, o, r, e, f = $13c40c34b78c8ee2$var$w({}, l.props);
    for(r in l.type && l.type.defaultProps && (e = l.type.defaultProps), u)"key" == r ? i = u[r] : "ref" == r ? o = u[r] : f[r] = void 0 === u[r] && null != e ? e[r] : u[r];
    return arguments.length > 2 && (f.children = arguments.length > 3 ? $13c40c34b78c8ee2$var$n.call(arguments, 2) : t), $13c40c34b78c8ee2$var$m(l.type, f, i || l.key, o || l.ref, null);
}
function $13c40c34b78c8ee2$export$fd42f52fd3ae1109(n) {
    function l(n) {
        var u, t;
        return this.getChildContext || (u = new Set, (t = {})[l.__c] = this, this.getChildContext = function() {
            return t;
        }, this.componentWillUnmount = function() {
            u = null;
        }, this.shouldComponentUpdate = function(n) {
            this.props.value != n.value && u.forEach(function(n) {
                n.__e = !0, $13c40c34b78c8ee2$var$M(n);
            });
        }, this.sub = function(n) {
            u.add(n);
            var l = n.componentWillUnmount;
            n.componentWillUnmount = function() {
                u && u.delete(n), l && l.call(n);
            };
        }), n.children;
    }
    return l.__c = "__cC" + $13c40c34b78c8ee2$var$h++, l.__ = n, l.Provider = l.__l = (l.Consumer = function(n, l) {
        return n.children(l);
    }).contextType = l, l;
}
$13c40c34b78c8ee2$var$n = $13c40c34b78c8ee2$var$v.slice, $13c40c34b78c8ee2$export$41c562ebe57d11e2 = {
    __e: function(n, l, u, t) {
        for(var i, o, r; l = l.__;)if ((i = l.__c) && !i.__) try {
            if ((o = i.constructor) && null != o.getDerivedStateFromError && (i.setState(o.getDerivedStateFromError(n)), r = i.__d), null != i.componentDidCatch && (i.componentDidCatch(n, t || {}), r = i.__d), r) return i.__E = i;
        } catch (l) {
            n = l;
        }
        throw n;
    }
}, $13c40c34b78c8ee2$var$u = 0, $13c40c34b78c8ee2$export$a8257692ac88316c = function(n) {
    return null != n && void 0 === n.constructor;
}, $13c40c34b78c8ee2$export$16fa2f45be04daa8.prototype.setState = function(n, l) {
    var u;
    u = null != this.__s && this.__s != this.state ? this.__s : this.__s = $13c40c34b78c8ee2$var$w({}, this.state), "function" == typeof n && (n = n($13c40c34b78c8ee2$var$w({}, u), this.props)), n && $13c40c34b78c8ee2$var$w(u, n), null != n && this.__v && (l && this._sb.push(l), $13c40c34b78c8ee2$var$M(this));
}, $13c40c34b78c8ee2$export$16fa2f45be04daa8.prototype.forceUpdate = function(n) {
    this.__v && (this.__e = !0, n && this.__h.push(n), $13c40c34b78c8ee2$var$M(this));
}, $13c40c34b78c8ee2$export$16fa2f45be04daa8.prototype.render = $13c40c34b78c8ee2$export$ffb0004e005737fa, $13c40c34b78c8ee2$var$i = [], $13c40c34b78c8ee2$var$r = "function" == typeof Promise ? Promise.prototype.then.bind(Promise.resolve()) : setTimeout, $13c40c34b78c8ee2$var$e = function(n, l) {
    return n.__v.__b - l.__v.__b;
}, $13c40c34b78c8ee2$var$$.__r = 0, $13c40c34b78c8ee2$var$f = /(PointerCapture)$|Capture$/i, $13c40c34b78c8ee2$var$c = 0, $13c40c34b78c8ee2$var$s = $13c40c34b78c8ee2$var$F(!1), $13c40c34b78c8ee2$var$a = $13c40c34b78c8ee2$var$F(!0), $13c40c34b78c8ee2$var$h = 0;


var $7cf5de2d778dc547$var$t = /["&<]/;
function $7cf5de2d778dc547$var$n(r) {
    if (0 === r.length || !1 === $7cf5de2d778dc547$var$t.test(r)) return r;
    for(var e = 0, n = 0, o = "", f = ""; n < r.length; n++){
        switch(r.charCodeAt(n)){
            case 34:
                f = "&quot;";
                break;
            case 38:
                f = "&amp;";
                break;
            case 60:
                f = "&lt;";
                break;
            default:
                continue;
        }
        n !== e && (o += r.slice(e, n)), o += f, e = n + 1;
    }
    return n !== e && (o += r.slice(e, n)), o;
}
var $7cf5de2d778dc547$var$o = /acit|ex(?:s|g|n|p|$)|rph|grid|ows|mnc|ntw|ine[ch]|zoo|^ord|itera/i, $7cf5de2d778dc547$var$f = 0, $7cf5de2d778dc547$var$i = Array.isArray;
function $7cf5de2d778dc547$export$34b9dba7ce09269b(e, t, n, o, i, u) {
    t || (t = {});
    var a, c, p = t;
    if ("ref" in p) for(c in p = {}, t)"ref" == c ? a = t[c] : p[c] = t[c];
    var l = {
        type: e,
        props: p,
        key: n,
        ref: a,
        __k: null,
        __: null,
        __b: 0,
        __e: null,
        __c: null,
        constructor: void 0,
        __v: --$7cf5de2d778dc547$var$f,
        __i: -1,
        __u: 0,
        __source: i,
        __self: u
    };
    if ("function" == typeof e && (a = e.defaultProps)) for(c in a)void 0 === p[c] && (p[c] = a[c]);
    return (0, $13c40c34b78c8ee2$export$41c562ebe57d11e2).vnode && (0, $13c40c34b78c8ee2$export$41c562ebe57d11e2).vnode(l), l;
}
function $7cf5de2d778dc547$export$45700d561b2268ac(r) {
    var t = $7cf5de2d778dc547$export$34b9dba7ce09269b((0, $13c40c34b78c8ee2$export$ffb0004e005737fa), {
        tpl: r,
        exprs: [].slice.call(arguments, 1)
    });
    return t.key = t.__v, t;
}
var $7cf5de2d778dc547$var$c = {}, $7cf5de2d778dc547$var$p = /[A-Z]/g;
function $7cf5de2d778dc547$export$991f6ffe102e5bac(e, t) {
    if ((0, $13c40c34b78c8ee2$export$41c562ebe57d11e2).attr) {
        var f = (0, $13c40c34b78c8ee2$export$41c562ebe57d11e2).attr(e, t);
        if ("string" == typeof f) return f;
    }
    if (t = function(r) {
        return null !== r && "object" == typeof r && "function" == typeof r.valueOf ? r.valueOf() : r;
    }(t), "ref" === e || "key" === e) return "";
    if ("style" === e && "object" == typeof t) {
        var i = "";
        for(var u in t){
            var a = t[u];
            if (null != a && "" !== a) {
                var l = "-" == u[0] ? u : $7cf5de2d778dc547$var$c[u] || ($7cf5de2d778dc547$var$c[u] = u.replace($7cf5de2d778dc547$var$p, "-$&").toLowerCase()), s = ";";
                "number" != typeof a || l.startsWith("--") || $7cf5de2d778dc547$var$o.test(l) || (s = "px;"), i = i + l + ":" + a + s;
            }
        }
        return e + '="' + $7cf5de2d778dc547$var$n(i) + '"';
    }
    return null == t || !1 === t || "function" == typeof t || "object" == typeof t ? "" : !0 === t ? e : e + '="' + $7cf5de2d778dc547$var$n("" + t) + '"';
}
function $7cf5de2d778dc547$export$40e96e718441efeb(r) {
    if (null == r || "boolean" == typeof r || "function" == typeof r) return null;
    if ("object" == typeof r) {
        if (void 0 === r.constructor) return r;
        if ($7cf5de2d778dc547$var$i(r)) {
            for(var e = 0; e < r.length; e++)r[e] = $7cf5de2d778dc547$export$40e96e718441efeb(r[e]);
            return r;
        }
    }
    return $7cf5de2d778dc547$var$n("" + r);
}







class $7d9b0c3658290da5$export$690dd8da38397efd extends (0, $c59361981bac2575$export$4342ba5c6ad1f6f1) {
    constructor(getReactContent, autoRender = true){
        super(), this.getReactContent = getReactContent, this.autoRender = autoRender, this.layer = "hud";
    }
    reactRender() {
        (0, $13c40c34b78c8ee2$export$b3890eb0ae9dca99)(this.getReactContent(), this.el);
    }
    onRender({}) {
        if (this.autoRender) this.reactRender();
    }
    onAdd() {
        this.el = document.createElement("div");
        document.body.append(this.el);
    }
    onDestroy(_data) {
        (0, $13c40c34b78c8ee2$export$b3890eb0ae9dca99)(null, this.el);
        this.el.remove();
    }
}
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $aa1f0309d9dba6d2$export$af631764ddc44097)("render")
], $7d9b0c3658290da5$export$690dd8da38397efd.prototype, "onRender", null);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $aa1f0309d9dba6d2$export$af631764ddc44097)("add")
], $7d9b0c3658290da5$export$690dd8da38397efd.prototype, "onAdd", null);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $aa1f0309d9dba6d2$export$af631764ddc44097)("destroy")
], $7d9b0c3658290da5$export$690dd8da38397efd.prototype, "onDestroy", null);




class $664bda363017f3bb$export$7f20708c5636d338 extends (0, $7d9b0c3658290da5$export$690dd8da38397efd) {
    constructor(){
        super(()=>this.renderPanel(), true), this.id = "tuningPanel", this.persistenceLevel = 100, this.pausable = false, this.visible = false, this.collapsedGroups = new Set();
    }
    onKeyDown({ key: key }) {
        if (key === "Backslash") this.visible = !this.visible;
    }
    renderPanel() {
        if (!this.visible) return /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("div", {
            class: "tuning-panel--hidden"
        });
        const groups = (0, $ca380632be0019fe$export$8afe3a32a4a965fb).getGroups();
        if ((0, $ca380632be0019fe$export$8afe3a32a4a965fb).isEmpty) return /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("div", {
            class: "tuning-panel",
            children: [
                /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("div", {
                    class: "tuning-panel__header",
                    children: /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("span", {
                        class: "tuning-panel__title",
                        children: "Tuning"
                    })
                }),
                /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("div", {
                    class: "tuning-panel__empty",
                    children: [
                        "No tunable values registered.",
                        /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("br", {}),
                        "Add ",
                        /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("code", {
                            children: "//#tunable"
                        }),
                        " above a ",
                        /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("code", {
                            children: "let"
                        }),
                        " declaration."
                    ]
                })
            ]
        });
        return /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("div", {
            class: "tuning-panel",
            children: [
                /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("div", {
                    class: "tuning-panel__header",
                    children: [
                        /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("span", {
                            class: "tuning-panel__title",
                            children: "Tuning"
                        }),
                        /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("button", {
                            class: "tuning-panel__reset-all",
                            onClick: ()=>(0, $ca380632be0019fe$export$8afe3a32a4a965fb).reset(),
                            title: "Reset all values to defaults",
                            children: "Reset All"
                        })
                    ]
                }),
                Array.from(groups.entries()).map(([groupName, entries])=>this.renderGroup(groupName, entries))
            ]
        });
    }
    renderGroup(groupName, entries) {
        const collapsed = this.collapsedGroups.has(groupName);
        const hasModified = entries.some((e)=>e.value !== e.defaultValue);
        return /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("div", {
            class: "tuning-group",
            children: [
                /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("div", {
                    class: "tuning-group__header",
                    onClick: ()=>{
                        if (collapsed) this.collapsedGroups.delete(groupName);
                        else this.collapsedGroups.add(groupName);
                    },
                    children: [
                        /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("span", {
                            class: `tuning-group__chevron ${collapsed ? "" : "tuning-group__chevron--open"}`,
                            children: "\u25B6"
                        }),
                        /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("span", {
                            class: "tuning-group__label",
                            children: groupName
                        }),
                        hasModified && /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("button", {
                            class: "tuning-group__reset",
                            onClick: (e)=>{
                                e.stopPropagation();
                                (0, $ca380632be0019fe$export$8afe3a32a4a965fb).resetGroup(groupName);
                            },
                            title: "Reset group",
                            children: "reset"
                        })
                    ]
                }),
                !collapsed && /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("div", {
                    class: "tuning-group__entries",
                    children: entries.map((entry)=>this.renderEntry(entry))
                })
            ]
        }, groupName);
    }
    renderEntry(entry) {
        const { min: min, max: max, step: step } = $664bda363017f3bb$var$resolveSliderParams(entry);
        const isModified = entry.value !== entry.defaultValue;
        return /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("div", {
            class: "tuning-entry",
            children: [
                /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("div", {
                    class: "tuning-entry__top-row",
                    children: [
                        /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("span", {
                            class: "tuning-entry__name",
                            children: entry.name
                        }),
                        /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("input", {
                            class: `tuning-entry__value-input ${isModified ? "tuning-entry__value-input--modified" : ""}`,
                            type: "number",
                            value: $664bda363017f3bb$var$formatValue(entry.value),
                            step: step,
                            onInput: (e)=>{
                                const v = parseFloat(e.target.value);
                                if (!isNaN(v)) (0, $ca380632be0019fe$export$8afe3a32a4a965fb).set(entry.path, v);
                            }
                        }),
                        /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("button", {
                            class: `tuning-entry__reset ${isModified ? "tuning-entry__reset--visible" : ""}`,
                            onClick: ()=>(0, $ca380632be0019fe$export$8afe3a32a4a965fb).reset(entry.path),
                            title: `Reset to ${entry.defaultValue}`,
                            children: "\u21BA"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("div", {
                    class: "tuning-entry__slider-row",
                    children: /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("input", {
                        class: "tuning-entry__slider",
                        type: "range",
                        min: min,
                        max: max,
                        step: step,
                        value: entry.value,
                        onInput: (e)=>{
                            const v = parseFloat(e.target.value);
                            (0, $ca380632be0019fe$export$8afe3a32a4a965fb).set(entry.path, v);
                        }
                    })
                })
            ]
        }, entry.path);
    }
}
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $aa1f0309d9dba6d2$export$af631764ddc44097)("keyDown")
], $664bda363017f3bb$export$7f20708c5636d338.prototype, "onKeyDown", null);
/**
 * Figure out sensible slider min/max/step from the entry options and default value.
 */ function $664bda363017f3bb$var$resolveSliderParams(entry) {
    const { defaultValue: defaultValue, options: options } = entry;
    // Use explicit bounds if provided, otherwise derive from default value
    let min = options.min ?? 0;
    let max = options.max ?? defaultValue * 3;
    // If the default is 0 and no max was given, pick a reasonable range
    if (defaultValue === 0 && options.max == null) max = 1;
    // Ensure min < max
    if (min >= max) max = min + 1;
    const step = options.step ?? $664bda363017f3bb$var$deriveStep(min, max);
    return {
        min: min,
        max: max,
        step: step
    };
}
/** Derive a reasonable step size from the range. */ function $664bda363017f3bb$var$deriveStep(min, max) {
    const range = max - min;
    if (range > 100) return 1;
    if (range > 10) return 0.1;
    if (range > 1) return 0.01;
    return 0.001;
}
/** Format a number for display: trim trailing zeros, keep it readable. */ function $664bda363017f3bb$var$formatValue(v) {
    if (Number.isInteger(v)) return v.toString();
    // Show enough precision to be useful
    const s = v.toPrecision(4);
    // Strip trailing zeros after decimal point
    return parseFloat(s).toString();
}




/**
 * Interface for entities that want to provide custom stats sections
 * to the StatsOverlay. Implement this interface and add the "statsProvider"
 * tag to your entity to have your stats displayed in the graphics panel.
 */ function $d71a84998a9c6620$export$a9fbc405093b3af2(value) {
    return typeof value === "object" && value !== null && "getStatsSection" in value;
}



const $7a2f573c2e376f50$export$ec098db2733c7492 = ({ label: label, value: value, color: color, indent: indent })=>{
    // Support both boolean and numeric indent levels
    const indentLevel = indent === true ? 1 : indent || 0;
    const indentStyle = indentLevel > 0 ? {
        paddingLeft: `${indentLevel * 12}px`
    } : undefined;
    const valueClass = color ? `stats-row__value stats-row__value--${color}` : "stats-row__value";
    return /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("div", {
        className: "stats-row",
        style: indentStyle,
        children: [
            /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("span", {
                className: "stats-row__label",
                children: label
            }),
            /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("span", {
                className: valueClass,
                children: value
            })
        ]
    });
};


function $4bf2f65ce36aef66$var$formatBytes(bytes) {
    if (bytes < 1024) return `${bytes} B`;
    if (bytes < 1048576) return `${(bytes / 1024).toFixed(1)} KB`;
    return `${(bytes / 1048576).toFixed(1)} MB`;
}
/** Convert camelCase to Title Case: "waterQuery" → "Water Query" */ function $4bf2f65ce36aef66$var$formatCamelCase(key) {
    return key.replace(/([A-Z])/g, " $1").replace(/^./, (s)=>s.toUpperCase()).trim();
}
/** Group GPU sections by prefix (before the dot) and sort by time */ function $4bf2f65ce36aef66$var$groupAndSortGpuSections(sections) {
    const groups = new Map();
    const measuredTotals = new Map();
    for (const [key, value] of Object.entries(sections)){
        const dotIndex = key.indexOf(".");
        const prefix = dotIndex >= 0 ? key.substring(0, dotIndex) : key;
        const suffix = dotIndex >= 0 ? key.substring(dotIndex + 1) : "";
        if (!groups.has(prefix)) groups.set(prefix, {
            prefix: prefix,
            items: [],
            total: 0
        });
        if (suffix === "") // Group-level measurement (e.g. "surface", "query") or standalone section (e.g. "render")
        measuredTotals.set(prefix, value);
        else groups.get(prefix).items.push({
            key: key,
            label: suffix,
            value: value
        });
    }
    // Compute totals: use measured GPU total when available, otherwise sum items.
    // For standalone sections (measured total, no items), add as a single item.
    for (const group of groups.values()){
        const measured = measuredTotals.get(group.prefix);
        if (measured !== undefined && group.items.length === 0) {
            // Standalone section (e.g. "render") — show as single item
            group.items.push({
                key: group.prefix,
                label: $4bf2f65ce36aef66$var$formatCamelCase(group.prefix),
                value: measured
            });
            group.total = measured;
        } else if (measured !== undefined) // Group with real GPU measurement spanning all passes
        group.total = measured;
        else // No group-level measurement — sum individual items
        group.total = group.items.reduce((sum, item)=>sum + item.value, 0);
    }
    // Sort groups by total time (high to low)
    const sortedGroups = Array.from(groups.values()).sort((a, b)=>b.total - a.total);
    // Sort items within each group by time (high to low)
    for (const group of sortedGroups)group.items.sort((a, b)=>b.value - a.value);
    return sortedGroups;
}
function $4bf2f65ce36aef66$export$db38f125d817f3ab() {
    return {
        id: "graphics",
        render: (ctx)=>{
            const gfx = $4bf2f65ce36aef66$var$getGraphicsStats(ctx);
            const bufferStats = (0, $f1a2ee5243e5db50$export$36a764d7d1b6286).getInstance().getStats();
            const customSections = $4bf2f65ce36aef66$var$getCustomSections(ctx);
            // Determine GPU time color
            const gpuColor = gfx.gpuAvgMs > 8.33 ? "error" : undefined;
            const gpuPercent = (gfx.gpuAvgMs / 8.33 * 100).toFixed(0);
            const largeBuffers = bufferStats.entries.filter((entry)=>entry.size >= 1024);
            const tinyBuffers = bufferStats.entries.filter((entry)=>entry.size < 1024);
            const tinyBuffersTotal = tinyBuffers.reduce((sum, entry)=>sum + entry.size, 0);
            return /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)((0, $13c40c34b78c8ee2$export$ffb0004e005737fa), {
                children: [
                    /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("div", {
                        className: "stats-overlay__section",
                        children: [
                            /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("div", {
                                className: "stats-overlay__section-title",
                                children: "Graphics"
                            }),
                            /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("div", {
                                className: "stats-overlay__grid",
                                children: [
                                    gfx.gpuTimerSupported ? /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)((0, $13c40c34b78c8ee2$export$ffb0004e005737fa), {
                                        children: [
                                            /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)((0, $7a2f573c2e376f50$export$ec098db2733c7492), {
                                                label: "GPU Time",
                                                value: `${gfx.gpuAvgMs.toFixed(2)}ms (${gpuPercent}%)`,
                                                color: gpuColor
                                            }),
                                            gfx.gpuSectionGroups.map((group)=>/*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("div", {
                                                    children: [
                                                        group.items.length > 1 && /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)((0, $7a2f573c2e376f50$export$ec098db2733c7492), {
                                                            label: $4bf2f65ce36aef66$var$formatCamelCase(group.prefix),
                                                            value: `${group.total.toFixed(2)}ms`,
                                                            indent: 1,
                                                            color: "muted"
                                                        }),
                                                        group.items.map((item)=>/*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)((0, $7a2f573c2e376f50$export$ec098db2733c7492), {
                                                                label: group.items.length > 1 ? `.${item.label}` : $4bf2f65ce36aef66$var$formatCamelCase(item.key),
                                                                value: `${item.value.toFixed(2)}ms`,
                                                                indent: group.items.length > 1 ? 2 : 1,
                                                                color: "muted"
                                                            }, item.key))
                                                    ]
                                                }, group.prefix))
                                        ]
                                    }) : /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)((0, $7a2f573c2e376f50$export$ec098db2733c7492), {
                                        label: "GPU Time",
                                        value: "not supported",
                                        color: "dim"
                                    }),
                                    /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)((0, $7a2f573c2e376f50$export$ec098db2733c7492), {
                                        label: "Draw Calls",
                                        value: gfx.drawCalls.toLocaleString()
                                    }),
                                    /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)((0, $7a2f573c2e376f50$export$ec098db2733c7492), {
                                        label: "Triangles",
                                        value: gfx.triangles.toLocaleString()
                                    }),
                                    /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)((0, $7a2f573c2e376f50$export$ec098db2733c7492), {
                                        label: "Vertices",
                                        value: gfx.vertices.toLocaleString()
                                    }),
                                    /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("div", {
                                        className: "stats-overlay__divider",
                                        children: [
                                            /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)((0, $7a2f573c2e376f50$export$ec098db2733c7492), {
                                                label: "Textures",
                                                value: gfx.textures
                                            }),
                                            /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)((0, $7a2f573c2e376f50$export$ec098db2733c7492), {
                                                label: "Resolution",
                                                value: `${gfx.resolution} @${gfx.pixelRatio}x`
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("div", {
                        className: "stats-overlay__section",
                        children: [
                            /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("div", {
                                className: "stats-overlay__section-title",
                                children: "GPU Memory"
                            }),
                            /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("div", {
                                className: "stats-overlay__grid",
                                children: [
                                    /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)((0, $7a2f573c2e376f50$export$ec098db2733c7492), {
                                        label: "Buffers",
                                        value: `${$4bf2f65ce36aef66$var$formatBytes(bufferStats.totalBytes)} (${bufferStats.entries.length})`
                                    }),
                                    largeBuffers.map((entry)=>/*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)((0, $7a2f573c2e376f50$export$ec098db2733c7492), {
                                            label: entry.count > 1 ? `${entry.label} (x${entry.count})` : entry.label,
                                            value: $4bf2f65ce36aef66$var$formatBytes(entry.size),
                                            indent: 1,
                                            color: "muted"
                                        }, entry.label)),
                                    tinyBuffers.length > 0 && /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)((0, $7a2f573c2e376f50$export$ec098db2733c7492), {
                                        label: /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("span", {
                                            style: {
                                                fontStyle: "italic"
                                            },
                                            children: [
                                                "Other small buffers (",
                                                "<",
                                                "1KB) (x$",
                                                tinyBuffers.length.toLocaleString(),
                                                ")"
                                            ]
                                        }),
                                        value: $4bf2f65ce36aef66$var$formatBytes(tinyBuffersTotal),
                                        indent: 1,
                                        color: "muted"
                                    }, "tinyBuffers")
                                ]
                            })
                        ]
                    }),
                    customSections.map((section, i)=>/*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("div", {
                            className: "stats-overlay__section",
                            children: [
                                /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("div", {
                                    className: "stats-overlay__section-title",
                                    children: section.title
                                }),
                                /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("div", {
                                    className: "stats-overlay__grid",
                                    children: section.items.map((item, j)=>/*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)((0, $7a2f573c2e376f50$export$ec098db2733c7492), {
                                            label: item.label,
                                            value: item.value,
                                            color: item.color,
                                            indent: item.indent
                                        }, j))
                                })
                            ]
                        }, i))
                ]
            });
        }
    };
}
function $4bf2f65ce36aef66$var$getGraphicsStats(ctx) {
    const renderer = ctx.game.getRenderer();
    const rendererStats = renderer?.getStats();
    const gpuTimerSupported = ctx.game.hasGpuTimerSupport();
    const gpuMs = ctx.game.renderer.getGpuMs();
    const gpuAllMs = ctx.game.renderer.getAllGpuMs();
    return {
        drawCalls: rendererStats?.drawCalls ?? 0,
        triangles: rendererStats?.triangles ?? 0,
        vertices: rendererStats?.vertices ?? 0,
        textures: rendererStats?.textures ?? 0,
        resolution: rendererStats ? `${rendererStats.canvasWidth}x${rendererStats.canvasHeight}` : "N/A",
        pixelRatio: rendererStats?.pixelRatio ?? 1,
        gpuTimerSupported: gpuTimerSupported,
        gpuAvgMs: gpuMs,
        gpuSectionGroups: gpuAllMs ? $4bf2f65ce36aef66$var$groupAndSortGpuSections(gpuAllMs) : []
    };
}
function $4bf2f65ce36aef66$var$getCustomSections(ctx) {
    const sections = [];
    for (const entity of ctx.game.entities.getTagged("statsProvider"))if ((0, $d71a84998a9c6620$export$a9fbc405093b3af2)(entity)) {
        const section = entity.getStatsSection();
        if (section) sections.push(section);
        entity.resetStatsCounters?.();
    }
    return sections;
}



function $c4d0f7c25f5cdbbc$export$10141b7f938afb4f() {
    return {
        id: "lean",
        render: ()=>/*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)((0, $13c40c34b78c8ee2$export$ffb0004e005737fa), {})
    };
}






const $c80ed3509d86ecbb$export$889b0b075f16c167 = ({ stat: stat, frameTotalMs: frameTotalMs })=>{
    const isFrameMetric = stat.shortLabel === "loop" && stat.depth === 0;
    const isSlow = isFrameMetric && stat.msPerFrame > 16.67;
    // Calculate bar width as percentage of frame time
    const barPercent = Math.min(100, 100 - stat.msPerFrame / frameTotalMs * 100);
    // Slight bar color variation by depth
    const barColor = `hsl(235, 80%, ${40 + stat.depth * 4}%)`;
    // Display calls per frame if > 1
    const callsDisplay = stat.callsPerFrame >= 1 ? `(x${Math.round(stat.callsPerFrame).toLocaleString()})` : "";
    const timeDisplay = stat.msPerFrame.toLocaleString(undefined, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    }) + "ms";
    const indent = "  ".repeat(stat.depth);
    const copyText = `${indent}${stat.shortLabel}${callsDisplay ? " " + callsDisplay : ""} ${timeDisplay}`;
    return /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("div", {
        className: `profile-row ${isSlow ? "profile-row--slow" : ""}`,
        style: {
            paddingLeft: `${stat.depth * 16}px`,
            background: `linear-gradient(to right, transparent 0% ${barPercent}%, ${barColor} ${barPercent}%)`
        },
        children: [
            /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("span", {
                className: "profile-row__copy",
                children: copyText
            }),
            /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("div", {
                className: "profile-row__label",
                "aria-hidden": "true",
                children: [
                    stat.shortLabel,
                    callsDisplay && /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("span", {
                        className: "profile-row__calls",
                        children: callsDisplay
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("div", {
                className: "profile-row__time",
                "aria-hidden": "true",
                children: timeDisplay
            })
        ]
    });
};


const $80a5a5748ded5a10$var$TOP_N_PROFILES = 200;
const $80a5a5748ded5a10$var$TOP_N_CHILDREN = 4;
function $80a5a5748ded5a10$export$27668a998e86ec76() {
    let profilingEnabled = true;
    return {
        id: "profiler",
        render: (ctx)=>{
            const profileStats = (0, $5a1d1d3ab1ff9c51$export$e8e2fad003b4d4ce).getTopStats($80a5a5748ded5a10$var$TOP_N_PROFILES, $80a5a5748ded5a10$var$TOP_N_CHILDREN, "Game.nextFrame");
            const basicStats = $80a5a5748ded5a10$var$getBasicStats(ctx);
            const asyncStats = (0, $87110bde7a27e156$export$c160a1ab3b49575c).getStats();
            const totalAsyncMs = (0, $87110bde7a27e156$export$c160a1ab3b49575c).getTotalCallbackMs();
            // Find frame total for bar width calculations
            const frameStat = profileStats.find((s)=>s.label === "Game.nextFrame" && s.depth === 0);
            const frameTotalMs = frameStat?.msPerFrame ?? 1000 / 120;
            return /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)((0, $13c40c34b78c8ee2$export$ffb0004e005737fa), {
                children: [
                    /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("div", {
                        className: "stats-overlay__subheader",
                        children: [
                            "Entities: ",
                            basicStats.entityCount,
                            " | Bodies: ",
                            basicStats.bodyCount
                        ]
                    }),
                    /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("div", {
                        className: "stats-overlay__subheader",
                        children: [
                            "Bodies: ",
                            basicStats.kinematicBodyCount,
                            "K /",
                            " ",
                            basicStats.particleBodyCount,
                            "P / ",
                            basicStats.dynamicBodyCount,
                            "D /",
                            " ",
                            basicStats.hugeBodyCount,
                            "H | Collisions: ",
                            basicStats.collisions
                        ]
                    }),
                    /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("div", {
                        className: "stats-overlay__subheader",
                        children: [
                            "Memory:",
                            " ",
                            performance.memory?.usedJSHeapSize != null ? (performance.memory.usedJSHeapSize / 1e6).toLocaleString(undefined, {
                                maximumFractionDigits: 0
                            }) : "N/A",
                            " / ",
                            performance.memory?.totalJSHeapSize != null ? (performance.memory.totalJSHeapSize / 1e6).toLocaleString(undefined, {
                                maximumFractionDigits: 0
                            }) : "N/A",
                            " / ",
                            (performance.memory?.jsHeapSizeLimit / 1e6).toLocaleString(undefined, {
                                maximumFractionDigits: 0
                            }) ?? "N/A",
                            "MB"
                        ]
                    }),
                    /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("div", {
                        className: "stats-overlay__section",
                        children: [
                            /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("div", {
                                className: "stats-overlay__section-header",
                                children: [
                                    /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("span", {
                                        className: "stats-overlay__section-title",
                                        children: "Profiler"
                                    }),
                                    /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("span", {
                                        className: "stats-overlay__hint",
                                        children: [
                                            "[R] Reset | [P] ",
                                            profilingEnabled ? "On" : "Off"
                                        ]
                                    })
                                ]
                            }),
                            profileStats.map((stat)=>/*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)((0, $c80ed3509d86ecbb$export$889b0b075f16c167), {
                                    stat: stat,
                                    frameTotalMs: frameTotalMs
                                }, stat.label)),
                            profileStats.length === 0 && /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("div", {
                                className: "stats-overlay__empty",
                                children: "No profile data yet"
                            })
                        ]
                    }),
                    asyncStats.length > 0 && /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("div", {
                        className: "stats-overlay__section",
                        children: [
                            /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("div", {
                                className: "stats-overlay__section-header",
                                children: [
                                    /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("span", {
                                        className: "stats-overlay__section-title",
                                        children: "Async Callbacks"
                                    }),
                                    /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("span", {
                                        className: "stats-overlay__hint",
                                        children: [
                                            "Total: ",
                                            totalAsyncMs.toFixed(2),
                                            "ms/frame"
                                        ]
                                    })
                                ]
                            }),
                            asyncStats.map((stat)=>/*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("div", {
                                    className: "stats-row",
                                    children: [
                                        /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("span", {
                                            className: "stats-row__label",
                                            children: stat.label
                                        }),
                                        /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("span", {
                                            className: "stats-row__value",
                                            children: [
                                                stat.callbackMsPerFrame.toFixed(2),
                                                "ms",
                                                " ",
                                                /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("span", {
                                                    className: "stats-row__value--muted",
                                                    children: [
                                                        "x",
                                                        stat.completionsPerFrame.toFixed(1),
                                                        "/frame",
                                                        stat.inFlightCount > 0 && ` (${stat.inFlightCount} pending)`
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }, stat.label))
                        ]
                    })
                ]
            });
        },
        onKeyDown: (_ctx, key)=>{
            if (key === "KeyR") {
                (0, $5a1d1d3ab1ff9c51$export$e8e2fad003b4d4ce).reset();
                (0, $87110bde7a27e156$export$c160a1ab3b49575c).reset();
                return true;
            }
            if (key === "KeyP") {
                profilingEnabled = !profilingEnabled;
                (0, $5a1d1d3ab1ff9c51$export$e8e2fad003b4d4ce).setEnabled(profilingEnabled);
                (0, $87110bde7a27e156$export$c160a1ab3b49575c).setEnabled(profilingEnabled);
                return true;
            }
            return false;
        }
    };
}
function $80a5a5748ded5a10$var$getBasicStats(ctx) {
    const world = ctx.game.world;
    const broadphase = ctx.game.world.broadphase;
    return {
        entityCount: ctx.game.entities.all.size,
        bodyCount: world.bodies.length,
        hugeBodyCount: broadphase.hugeBodies?.size ?? 0,
        dynamicBodyCount: world.bodies.dynamic.length,
        kinematicBodyCount: world.bodies.kinematic.length,
        particleBodyCount: broadphase.pointShapeBodies.size,
        collisions: broadphase.debugData.numCollisions
    };
}








const $1580d22674b34959$var$SMOOTHING = 0.95;
const $1580d22674b34959$var$RENDER_THROTTLE = 3; // Only re-render every N frames
class $1580d22674b34959$export$4f7389558ee2443b extends (0, $7d9b0c3658290da5$export$690dd8da38397efd) {
    constructor(panels){
        super(()=>this.renderContent(), false), this.persistenceLevel = 100, this.activePanelIndex = -1 // -1 = closed
        , this.averageDuration = 0, this.lastUpdate = performance.now(), this.frameCounter = 0, this.layer = "debugHud"; // autoRender = false for throttling
        this.panels = panels;
    }
    renderContent() {
        if (this.activePanelIndex < 0) return /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)((0, $13c40c34b78c8ee2$export$ffb0004e005737fa), {});
        const panel = this.panels[this.activePanelIndex];
        const ctx = this.getContext();
        return /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("div", {
            className: "stats-overlay",
            children: [
                /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("div", {
                    className: "stats-overlay__header",
                    children: /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("span", {
                        children: [
                            "FPS: ",
                            ctx.fps,
                            " (",
                            ctx.fps2,
                            ")"
                        ]
                    })
                }),
                panel.render(ctx)
            ]
        });
    }
    getContext() {
        return {
            game: this.game,
            fps: Math.ceil(1000 / this.averageDuration),
            fps2: this.game.getScreenFps()
        };
    }
    cycleMode(direction) {
        // -1 = closed, 0..n-1 = panel indices
        const total = this.panels.length + 1; // +1 for closed state
        this.activePanelIndex = (this.activePanelIndex + 1 + direction + total) % total - 1;
        // Immediately render to show the change (don't wait for throttle)
        this.reactRender();
    }
    onAdd() {
        super.onAdd();
        this.averageDuration = 1 / 120;
    }
    onRender() {
        const now = performance.now();
        const duration = now - this.lastUpdate;
        this.averageDuration = $1580d22674b34959$var$SMOOTHING * this.averageDuration + (1.0 - $1580d22674b34959$var$SMOOTHING) * duration;
        this.lastUpdate = now;
        // Throttle React re-renders (20fps is plenty for stats display)
        this.frameCounter++;
        if (this.activePanelIndex >= 0 && this.frameCounter % $1580d22674b34959$var$RENDER_THROTTLE === 0) this.reactRender();
    }
    onKeyDown({ key: key, event: event }) {
        if (key === "Backquote") {
            this.cycleMode(event.shiftKey ? -1 : 1);
            return;
        }
        // Delegate to active panel
        if (this.activePanelIndex >= 0) {
            const panel = this.panels[this.activePanelIndex];
            panel.onKeyDown?.(this.getContext(), key, event);
        }
    }
}
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $aa1f0309d9dba6d2$export$af631764ddc44097)("add")
], $1580d22674b34959$export$4f7389558ee2443b.prototype, "onAdd", null);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $aa1f0309d9dba6d2$export$af631764ddc44097)("render"),
    (0, $5a1d1d3ab1ff9c51$export$4882ae973e0491e)
], $1580d22674b34959$export$4f7389558ee2443b.prototype, "onRender", null);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $aa1f0309d9dba6d2$export$af631764ddc44097)("keyDown")
], $1580d22674b34959$export$4f7389558ee2443b.prototype, "onKeyDown", null);










// TypeScript's DOM types are missing FontFaceSet.add()
function $0b526bd68b4c0c41$var$getFontConfigFromManifestName(name) {
    switch(name){
        case "youngSerifRegular":
            return {
                family: "Young Serif",
                descriptors: {
                    style: "normal",
                    weight: "400"
                }
            };
        case "spectralLight":
            return {
                family: "Spectral",
                descriptors: {
                    style: "normal",
                    weight: "300"
                }
            };
        case "spectralRegular":
            return {
                family: "Spectral",
                descriptors: {
                    style: "normal",
                    weight: "400"
                }
            };
        case "spectralSemiBold":
            return {
                family: "Spectral",
                descriptors: {
                    style: "normal",
                    weight: "600"
                }
            };
        case "tangerineRegular":
            return {
                family: "Tangerine",
                descriptors: {
                    style: "normal",
                    weight: "400"
                }
            };
        case "tangerineBold":
            return {
                family: "Tangerine",
                descriptors: {
                    style: "normal",
                    weight: "700"
                }
            };
        default:
            return {
                family: name,
                descriptors: {
                    style: "normal",
                    weight: "400"
                }
            };
    }
}
async function $0b526bd68b4c0c41$export$a0a5b4505e443210(manifest, onFontLoaded) {
    await Promise.all(Object.entries(manifest).map(async ([name, src])=>{
        const { family: family, descriptors: descriptors } = $0b526bd68b4c0c41$var$getFontConfigFromManifestName(name);
        const fontFace = new FontFace(family, `url(${src})`, descriptors);
        document.fonts.add(await fontFace.load());
        onFontLoaded?.();
    }));
}


// Stores all loaded buffers
const $ccca576b723d73ff$var$buffers = new Map();
function $ccca576b723d73ff$export$ac84dee4d6d87cfb(name) {
    return $ccca576b723d73ff$var$buffers.has(name);
}
function $ccca576b723d73ff$export$4addc79a408174e5(name) {
    const buffer = $ccca576b723d73ff$var$buffers.get(name);
    if (!buffer) throw new Error(`Audio Buffer not loaded: ${name}`);
    return buffer;
}
function $ccca576b723d73ff$export$19a3f18ff5ca2035(name) {
    return $ccca576b723d73ff$var$buffers.get(name)?.duration ?? -1;
}
function $ccca576b723d73ff$export$1b9da31cab5f5660(name) {
    return $ccca576b723d73ff$var$buffers.get(name) != undefined;
}
// Keeps track of filesizes, for figuring out how to optimize our asset loading
const $ccca576b723d73ff$var$fileSizes = new Map();
function $ccca576b723d73ff$export$6be99376ef785c18() {
    return [
        ...$ccca576b723d73ff$var$fileSizes.values()
    ].reduce((sum, current)=>sum + current, 0);
}
function $ccca576b723d73ff$export$3884bbcde8456ae4() {
    const entries = [
        ...$ccca576b723d73ff$var$fileSizes.entries()
    ];
    entries.sort(([url1, size1], [url2, size2])=>size2 - size1);
    return entries;
}
function $ccca576b723d73ff$export$b423bdfb9415e6b1(url) {
    if (!$ccca576b723d73ff$var$fileSizes.has(url)) throw new Error(`Sound not loaded: ${url}`);
    return $ccca576b723d73ff$var$fileSizes.get(url);
}
async function $ccca576b723d73ff$export$f00979f1f84fa256(name, url, audioContext) {
    return fetch(url).then((response)=>{
        const bytes = Number(response.headers.get("Content-Length"));
        $ccca576b723d73ff$var$fileSizes.set(url, bytes);
        return response.arrayBuffer();
    }).then((data)=>audioContext.decodeAudioData(data)).then((buffer)=>{
        $ccca576b723d73ff$var$buffers.set(name, buffer);
        return buffer;
    });
}


class $2cad9d9952e2fd36$export$aad6cdef011fb02b extends (0, $c59361981bac2575$export$4342ba5c6ad1f6f1) {
    constructor(manifest, reactRender){
        super(), this.manifest = manifest, this.progress = {
            fonts: {
                loaded: 0,
                total: 0
            },
            images: {
                loaded: 0,
                total: 0
            },
            sounds: {
                loaded: 0,
                total: 0
            }
        };
        this._promise = new Promise((resolve)=>{
            this._resolve = resolve;
        });
        this.addChild(new (0, $7d9b0c3658290da5$export$690dd8da38397efd)(()=>reactRender(this.progress)));
    }
    async onAdd({ game: game }) {
        await Promise.all([
            this.loadFonts(),
            this.loadSounds(game.audio),
            this.loadImages(game)
        ]);
        const bytes = (0, $ccca576b723d73ff$export$6be99376ef785c18)();
        console.groupCollapsed(`Audio Loaded: ${(bytes / 2 ** 20).toFixed(1)}MB total`);
        (0, $ccca576b723d73ff$export$3884bbcde8456ae4)().slice(0, 5).forEach(([url, size])=>console.info(url, "\n", `${(size / 1024).toFixed(1)}kB`));
        console.groupEnd();
        this._resolve();
    }
    waitTillLoaded() {
        return this._promise;
    }
    async loadFonts() {
        this.progress.fonts.total = Object.values(this.manifest.fonts).length;
        this.progress.fonts.loaded = 0;
        try {
            await (0, $0b526bd68b4c0c41$export$a0a5b4505e443210)(this.manifest.fonts, ()=>{
                this.progress.fonts.loaded += 1;
            });
        } catch (e) {
            console.error("Fonts failed to load", e);
        }
    }
    async loadSounds(audioContext) {
        this.progress.sounds.loaded = 0;
        this.progress.sounds.total = Object.values(this.manifest.sounds).length;
        await Promise.all(Object.entries(this.manifest.sounds).map(async ([name, url])=>{
            try {
                await (0, $ccca576b723d73ff$export$f00979f1f84fa256)(name, url, audioContext);
            } catch (e) {
                console.warn(`Sound failed to load: ${url}, ${url}`, e);
            }
            this.progress.sounds.loaded += 1;
        }));
    }
    async loadImages(game) {
        this.progress.images.loaded = 0;
        this.progress.images.total = Object.values(this.manifest.images).length;
        const textureManager = game.getRenderer().textureManager;
        await Promise.all(Object.entries(this.manifest.images).map(async ([name, url])=>{
            try {
                await textureManager.load(url);
            } catch (e) {
                console.warn(`Image failed to load: ${url}`, e);
            }
            this.progress.images.loaded += 1;
        }));
    }
    onDestroy() {
        document.getElementById("preloader")?.remove();
    }
}
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $aa1f0309d9dba6d2$export$af631764ddc44097)("add")
], $2cad9d9952e2fd36$export$aad6cdef011fb02b.prototype, "onAdd", null);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $aa1f0309d9dba6d2$export$af631764ddc44097)("destroy")
], $2cad9d9952e2fd36$export$aad6cdef011fb02b.prototype, "onDestroy", null);



/**
 * Level loader utility.
 *
 * Provides functions for loading level data (terrain + waves + wavemesh) from
 * bundled resources. Used by both the editor and the game.
 */ /**
 * Browser-side loader for prebuilt .wavemesh binary files.
 */ /**
 * Binary .wavemesh file format for prebuilt wave mesh data.
 *
 * Format:
 *   Header (32 bytes):
 *     [0..3]   magic: "WVMH" (ASCII)
 *     [4..5]   version: u16 = 1
 *     [6..7]   waveSourceCount: u16
 *     [8..11]  inputHashHi: u32
 *     [12..15] inputHashLo: u32
 *     [16..31] reserved
 *
 *   Per-wave entry table (16 bytes × waveSourceCount):
 *     vertexDataOffset: u32, vertexCount: u32, indexDataOffset: u32, indexCount: u32
 *
 *   Coverage quad table (36 bytes × waveSourceCount):
 *     hasCoverageQuad: u32, then 8 × f32 (x0,y0,...,x3,y3)
 *
 *   Data sections (concatenated):
 *     Vertex arrays: Float32Array (6 f32/vertex)
 *     Index arrays: Uint32Array
 */ const $9a512b28f94d510d$var$MAGIC = 0x484d5657; // "WVMH" as little-endian u32
const $9a512b28f94d510d$var$VERSION = 1;
const $9a512b28f94d510d$var$HEADER_BYTES = 32;
const $9a512b28f94d510d$var$ENTRY_BYTES = 16; // 4 × u32
const $9a512b28f94d510d$var$COVERAGE_BYTES = 36; // 1 × u32 + 8 × f32
function $9a512b28f94d510d$export$955f64b45bfaf0c6(meshes, inputHash = [
    0,
    0
]) {
    const waveCount = meshes.length;
    // Calculate data section sizes
    let dataSize = 0;
    const vertexOffsets = [];
    const indexOffsets = [];
    for (const mesh of meshes){
        vertexOffsets.push(dataSize);
        dataSize += mesh.vertexCount * 24; // 6 f32 per vertex
        indexOffsets.push(dataSize);
        dataSize += mesh.indexCount * 4; // u32 per index
    }
    const tableStart = $9a512b28f94d510d$var$HEADER_BYTES;
    const coverageStart = tableStart + $9a512b28f94d510d$var$ENTRY_BYTES * waveCount;
    const dataStart = coverageStart + $9a512b28f94d510d$var$COVERAGE_BYTES * waveCount;
    const totalSize = dataStart + dataSize;
    const buffer = new ArrayBuffer(totalSize);
    const view = new DataView(buffer);
    const u8 = new Uint8Array(buffer);
    // Write header
    view.setUint32(0, $9a512b28f94d510d$var$MAGIC, true);
    view.setUint16(4, $9a512b28f94d510d$var$VERSION, true);
    view.setUint16(6, waveCount, true);
    view.setUint32(8, inputHash[0], true);
    view.setUint32(12, inputHash[1], true);
    // bytes 16..31 reserved (already zeroed)
    // Write entry table and coverage quads
    for(let i = 0; i < waveCount; i++){
        const mesh = meshes[i];
        const entryOffset = tableStart + i * $9a512b28f94d510d$var$ENTRY_BYTES;
        view.setUint32(entryOffset + 0, dataStart + vertexOffsets[i], true);
        view.setUint32(entryOffset + 4, mesh.vertexCount, true);
        view.setUint32(entryOffset + 8, dataStart + indexOffsets[i], true);
        view.setUint32(entryOffset + 12, mesh.indexCount, true);
        // Coverage quad
        const covOffset = coverageStart + i * $9a512b28f94d510d$var$COVERAGE_BYTES;
        if (mesh.coverageQuad) {
            view.setUint32(covOffset, 1, true);
            const q = mesh.coverageQuad;
            view.setFloat32(covOffset + 4, q.x0, true);
            view.setFloat32(covOffset + 8, q.y0, true);
            view.setFloat32(covOffset + 12, q.x1, true);
            view.setFloat32(covOffset + 16, q.y1, true);
            view.setFloat32(covOffset + 20, q.x2, true);
            view.setFloat32(covOffset + 24, q.y2, true);
            view.setFloat32(covOffset + 28, q.x3, true);
            view.setFloat32(covOffset + 32, q.y3, true);
        }
        // else: already zeroed (hasCoverageQuad = 0)
        // Copy vertex data
        const vertSrc = new Uint8Array(mesh.vertices.buffer, mesh.vertices.byteOffset, mesh.vertexCount * 24);
        u8.set(vertSrc, dataStart + vertexOffsets[i]);
        // Copy index data
        const idxSrc = new Uint8Array(mesh.indices.buffer, mesh.indices.byteOffset, mesh.indexCount * 4);
        u8.set(idxSrc, dataStart + indexOffsets[i]);
    }
    return buffer;
}
function $9a512b28f94d510d$export$85b339741f6b8122(buffer) {
    const view = new DataView(buffer);
    // Validate header
    const magic = view.getUint32(0, true);
    if (magic !== $9a512b28f94d510d$var$MAGIC) throw new Error(`Invalid wavemesh magic: 0x${magic.toString(16)} (expected 0x${$9a512b28f94d510d$var$MAGIC.toString(16)})`);
    const version = view.getUint16(4, true);
    if (version !== $9a512b28f94d510d$var$VERSION) throw new Error(`Unsupported wavemesh version: ${version}`);
    const waveCount = view.getUint16(6, true);
    const inputHash = [
        view.getUint32(8, true),
        view.getUint32(12, true)
    ];
    const tableStart = $9a512b28f94d510d$var$HEADER_BYTES;
    const coverageStart = tableStart + $9a512b28f94d510d$var$ENTRY_BYTES * waveCount;
    const meshes = [];
    for(let i = 0; i < waveCount; i++){
        const entryOffset = tableStart + i * $9a512b28f94d510d$var$ENTRY_BYTES;
        const vertexDataOffset = view.getUint32(entryOffset + 0, true);
        const vertexCount = view.getUint32(entryOffset + 4, true);
        const indexDataOffset = view.getUint32(entryOffset + 8, true);
        const indexCount = view.getUint32(entryOffset + 12, true);
        // Read coverage quad
        const covOffset = coverageStart + i * $9a512b28f94d510d$var$COVERAGE_BYTES;
        const hasCoverageQuad = view.getUint32(covOffset, true);
        let coverageQuad = null;
        if (hasCoverageQuad) coverageQuad = {
            x0: view.getFloat32(covOffset + 4, true),
            y0: view.getFloat32(covOffset + 8, true),
            x1: view.getFloat32(covOffset + 12, true),
            y1: view.getFloat32(covOffset + 16, true),
            x2: view.getFloat32(covOffset + 20, true),
            y2: view.getFloat32(covOffset + 24, true),
            x3: view.getFloat32(covOffset + 28, true),
            y3: view.getFloat32(covOffset + 32, true)
        };
        // Create typed array views into the buffer
        const vertices = new Float32Array(buffer, vertexDataOffset, vertexCount * 6);
        const indices = new Uint32Array(buffer, indexDataOffset, indexCount);
        meshes.push({
            vertices: vertices,
            indices: indices,
            vertexCount: vertexCount,
            indexCount: indexCount,
            coverageQuad: coverageQuad
        });
    }
    return {
        meshes: meshes,
        inputHash: inputHash
    };
}
function $9a512b28f94d510d$export$c0efb948decf32b(waveSources, terrain, tideHeight) {
    const parts = [
        terrain.vertexData.buffer,
        terrain.contourData,
        terrain.childrenData.buffer,
        $9a512b28f94d510d$var$numberToBuffer(terrain.contourCount),
        $9a512b28f94d510d$var$numberToBuffer(terrain.defaultDepth),
        $9a512b28f94d510d$var$numberToBuffer(tideHeight)
    ];
    for (const ws of waveSources){
        parts.push($9a512b28f94d510d$var$numberToBuffer(ws.wavelength));
        parts.push($9a512b28f94d510d$var$numberToBuffer(ws.direction));
        parts.push($9a512b28f94d510d$var$numberToBuffer(ws.amplitude));
        parts.push($9a512b28f94d510d$var$numberToBuffer(ws.sourceDist));
        parts.push($9a512b28f94d510d$var$numberToBuffer(ws.sourceOffsetX));
        parts.push($9a512b28f94d510d$var$numberToBuffer(ws.sourceOffsetY));
    }
    // Two FNV-1a passes with different offset bases for ~64-bit resistance
    return [
        $9a512b28f94d510d$var$fnv1a32(parts, 0x811c9dc5),
        $9a512b28f94d510d$var$fnv1a32(parts, 0x050c5d1f)
    ];
}
/** FNV-1a 32-bit hash */ function $9a512b28f94d510d$var$fnv1a32(parts, offsetBasis) {
    let h = offsetBasis;
    for (const buf of parts){
        const bytes = new Uint8Array(buf);
        for(let i = 0; i < bytes.length; i++){
            h ^= bytes[i];
            h = Math.imul(h, 0x01000193);
        }
    }
    return h >>> 0;
}
/** Encode a number as 8 bytes (Float64) for hashing */ function $9a512b28f94d510d$var$numberToBuffer(n) {
    const buf = new ArrayBuffer(8);
    new Float64Array(buf)[0] = n;
    return buf;
}


async function $8087c7d7facda7c5$export$773c3b94603a3349(url) {
    const response = await fetch(url);
    if (!response.ok) throw new Error(`Failed to fetch wavemesh: ${response.status} ${url}`);
    const buffer = await response.arrayBuffer();
    const { meshes: meshes } = (0, $9a512b28f94d510d$export$85b339741f6b8122)(buffer);
    return meshes;
}


/**
 * Binary .windmesh file format for prebuilt wind mesh data.
 *
 * Version 2 format (multi-source):
 *   Header (32 bytes):
 *     [0..3]   magic: "WNDM" (ASCII LE)
 *     [4..5]   version: u16 = 2
 *     [6..7]   sourceCount: u16
 *     [8..11]  inputHashHi: u32
 *     [12..15] inputHashLo: u32
 *     [16..31] reserved
 *
 *   Per-source direction table (4 bytes x sourceCount):
 *     direction: f32 (radians)
 *
 *   Per-source entry table (16 bytes x sourceCount):
 *     vertexDataOffset, vertexCount, indexDataOffset, indexCount (all u32)
 *
 *   Shared grid metadata (32 bytes):
 *     gridCols, gridRows, gridMinX, gridMinY, gridCellWidth, gridCellHeight, reserved x2
 *
 *   Data sections (concatenated):
 *     Vertex data per source (5 f32/vertex)
 *     Index data (shared)
 */ const $38b7fd8594996abf$var$MAGIC = 0x4d444e57; // "WNDM" as little-endian u32
const $38b7fd8594996abf$var$V2_HEADER_BYTES = 32;
function $38b7fd8594996abf$var$parseV1(buffer) {
    const view = new DataView(buffer);
    const headerBytes = 16;
    const metadataBytes = 32;
    const metaOffset = headerBytes;
    const vertexCount = view.getUint32(metaOffset, true);
    const indexCount = view.getUint32(metaOffset + 4, true);
    const gridCols = view.getUint32(metaOffset + 8, true);
    const gridRows = view.getUint32(metaOffset + 12, true);
    const gridMinX = view.getFloat32(metaOffset + 16, true);
    const gridMinY = view.getFloat32(metaOffset + 20, true);
    const gridCellWidth = view.getFloat32(metaOffset + 24, true);
    const gridCellHeight = view.getFloat32(metaOffset + 28, true);
    const dataStart = headerBytes + metadataBytes;
    const vertices = new Float32Array(buffer, dataStart, vertexCount * 5);
    const indexStart = dataStart + vertexCount * 20;
    const indices = new Uint32Array(buffer, indexStart, indexCount);
    // Default direction for v1: PI/4 (NE)
    const direction = Math.PI / 4;
    return {
        sources: [
            {
                direction: direction,
                vertices: vertices,
                indices: indices,
                vertexCount: vertexCount,
                indexCount: indexCount
            }
        ],
        sourceCount: 1,
        gridCols: gridCols,
        gridRows: gridRows,
        gridMinX: gridMinX,
        gridMinY: gridMinY,
        gridCellWidth: gridCellWidth,
        gridCellHeight: gridCellHeight
    };
}
function $38b7fd8594996abf$var$parseV2(buffer) {
    const view = new DataView(buffer);
    const sourceCount = view.getUint16(6, true);
    const dirTableStart = $38b7fd8594996abf$var$V2_HEADER_BYTES;
    const dirTableBytes = sourceCount * 4;
    const entryTableStart = dirTableStart + dirTableBytes;
    const entryTableBytes = sourceCount * 16;
    const gridMetaStart = entryTableStart + entryTableBytes;
    // Shared grid metadata
    const gridCols = view.getUint32(gridMetaStart, true);
    const gridRows = view.getUint32(gridMetaStart + 4, true);
    const gridMinX = view.getFloat32(gridMetaStart + 8, true);
    const gridMinY = view.getFloat32(gridMetaStart + 12, true);
    const gridCellWidth = view.getFloat32(gridMetaStart + 16, true);
    const gridCellHeight = view.getFloat32(gridMetaStart + 20, true);
    const sources = [];
    for(let i = 0; i < sourceCount; i++){
        const direction = view.getFloat32(dirTableStart + i * 4, true);
        const entryOff = entryTableStart + i * 16;
        const vertexDataOffset = view.getUint32(entryOff, true);
        const vertexCount = view.getUint32(entryOff + 4, true);
        const indexDataOffset = view.getUint32(entryOff + 8, true);
        const indexCount = view.getUint32(entryOff + 12, true);
        const vertices = new Float32Array(buffer, vertexDataOffset, vertexCount * 5);
        const indices = new Uint32Array(buffer, indexDataOffset, indexCount);
        sources.push({
            direction: direction,
            vertices: vertices,
            indices: indices,
            vertexCount: vertexCount,
            indexCount: indexCount
        });
    }
    return {
        sources: sources,
        sourceCount: sourceCount,
        gridCols: gridCols,
        gridRows: gridRows,
        gridMinX: gridMinX,
        gridMinY: gridMinY,
        gridCellWidth: gridCellWidth,
        gridCellHeight: gridCellHeight
    };
}
function $38b7fd8594996abf$export$2aba5378c86d40cc(buffer) {
    const view = new DataView(buffer);
    const magic = view.getUint32(0, true);
    if (magic !== $38b7fd8594996abf$var$MAGIC) throw new Error(`Invalid windmesh magic: 0x${magic.toString(16)} (expected 0x${$38b7fd8594996abf$var$MAGIC.toString(16)})`);
    const version = view.getUint16(4, true);
    if (version === 1) return $38b7fd8594996abf$var$parseV1(buffer);
    if (version === 2) return $38b7fd8594996abf$var$parseV2(buffer);
    throw new Error(`Unsupported windmesh version: ${version}`);
}


async function $155c9a05e59a886f$export$9135b7975b4a291a(url) {
    const response = await fetch(url);
    if (!response.ok) throw new Error(`Failed to fetch windmesh: ${response.status} ${url}`);
    const buffer = await response.arrayBuffer();
    return (0, $38b7fd8594996abf$export$2aba5378c86d40cc)(buffer);
}


/**
 * Binary .trees file format for prebuilt tree position data.
 *
 * Format:
 *   Header (16 bytes):
 *     [0..3]   magic: "TREE" (ASCII LE) = 0x45455254
 *     [4..5]   version: u16 = 1
 *     [6..7]   reserved: u16 = 0
 *     [8..11]  treeCount: u32
 *     [12..15] reserved: u32 = 0
 *
 *   Tree data (8 bytes per tree):
 *     x: f32 (world feet)
 *     y: f32 (world feet)
 */ const $b5d946ab3e94660c$var$MAGIC = 0x45455254; // "TREE" as little-endian u32
const $b5d946ab3e94660c$var$HEADER_BYTES = 16;
const $b5d946ab3e94660c$var$BYTES_PER_TREE = 8;
function $b5d946ab3e94660c$export$c7c98dbd7670a09(buffer) {
    const view = new DataView(buffer);
    if (buffer.byteLength < $b5d946ab3e94660c$var$HEADER_BYTES) throw new Error(`Tree file too small: ${buffer.byteLength} bytes (need at least ${$b5d946ab3e94660c$var$HEADER_BYTES})`);
    const magic = view.getUint32(0, true);
    if (magic !== $b5d946ab3e94660c$var$MAGIC) throw new Error(`Invalid tree file magic: 0x${magic.toString(16)} (expected 0x${$b5d946ab3e94660c$var$MAGIC.toString(16)})`);
    const version = view.getUint16(4, true);
    if (version !== 1) throw new Error(`Unsupported tree file version: ${version}`);
    const treeCount = view.getUint32(8, true);
    const expectedSize = $b5d946ab3e94660c$var$HEADER_BYTES + treeCount * $b5d946ab3e94660c$var$BYTES_PER_TREE;
    if (buffer.byteLength < expectedSize) throw new Error(`Tree file truncated: ${buffer.byteLength} bytes (expected ${expectedSize} for ${treeCount} trees)`);
    const positions = new Array(treeCount);
    for(let i = 0; i < treeCount; i++){
        const offset = $b5d946ab3e94660c$var$HEADER_BYTES + i * $b5d946ab3e94660c$var$BYTES_PER_TREE;
        positions[i] = [
            view.getFloat32(offset, true),
            view.getFloat32(offset + 4, true)
        ];
    }
    return {
        positions: positions
    };
}


async function $33442a3a058c3ed6$export$90aefa3a77ac044d(url) {
    const response = await fetch(url);
    if (!response.ok) throw new Error(`Failed to fetch trees: ${response.status} ${url}`);
    const buffer = await response.arrayBuffer();
    return (0, $b5d946ab3e94660c$export$c7c98dbd7670a09)(buffer);
}


// This file autogenerated by generate-asset-types.js
// Do not modify it by hand. Any changes will be overwritten.





const $bcae27952f7958f2$var$sounds = {
    snap: (parcelRequire("lJcBI")),
    sheetSnap: (parcelRequire("2wacE")),
    paddle1: (parcelRequire("lVXFz")),
    boomSlam: (parcelRequire("gdAbz")),
    bail1: (parcelRequire("j5YnW"))
};

const $bcae27952f7958f2$var$images = {
    favicon: (parcelRequire("cHkr5"))
};






const $bcae27952f7958f2$var$fonts = {
    spectralLight: (parcelRequire("7QupC")),
    spectralRegular: (parcelRequire("epA4r")),
    spectralSemiBold: (parcelRequire("hDzLx")),
    tangerineBold: (parcelRequire("i0ki7")),
    tangerineRegular: (parcelRequire("g9kxe")),
    youngSerifRegular: (parcelRequire("59lhO"))
};





const $bcae27952f7958f2$var$levels = {
    vendoviIsland: (parcelRequire("7Jo3t")),
    sanJuanIslands: (parcelRequire("fg22G")),
    islesOfScilly: (parcelRequire("50ium")),
    default: (parcelRequire("1qR3l")),
    apostleIslands: (parcelRequire("bKg0i"))
};
const $bcae27952f7958f2$var$terrains = {
    vendoviIsland: "/assets/levels/vendovi-island.terrain",
    sanJuanIslands: "/assets/levels/san-juan-islands.terrain",
    islesOfScilly: "/assets/levels/isles-of-scilly.terrain",
    apostleIslands: "/assets/levels/apostle-islands.terrain"
};
const $bcae27952f7958f2$var$entityDefs = {};
const $bcae27952f7958f2$var$jsonBlobs = {};
const $bcae27952f7958f2$var$wavemeshes = {
    vendoviIsland: "/assets/levels/vendovi-island.wavemesh",
    sanJuanIslands: "/assets/levels/san-juan-islands.wavemesh",
    islesOfScilly: "/assets/levels/isles-of-scilly.wavemesh",
    default: "/assets/levels/default.wavemesh",
    apostleIslands: "/assets/levels/apostle-islands.wavemesh"
};
const $bcae27952f7958f2$var$windmeshes = {
    vendoviIsland: "/assets/levels/vendovi-island.windmesh",
    sanJuanIslands: "/assets/levels/san-juan-islands.windmesh",
    islesOfScilly: "/assets/levels/isles-of-scilly.windmesh",
    default: "/assets/levels/default.windmesh",
    apostleIslands: "/assets/levels/apostle-islands.windmesh"
};
const $bcae27952f7958f2$var$trees = {
    vendoviIsland: "/assets/levels/vendovi-island.trees",
    sanJuanIslands: "/assets/levels/san-juan-islands.trees",
    islesOfScilly: "/assets/levels/isles-of-scilly.trees",
    default: "/assets/levels/default.trees",
    apostleIslands: "/assets/levels/apostle-islands.trees"
};
const $bcae27952f7958f2$export$4e841128923ef26 = {
    sounds: $bcae27952f7958f2$var$sounds,
    images: $bcae27952f7958f2$var$images,
    fonts: $bcae27952f7958f2$var$fonts,
    levels: $bcae27952f7958f2$var$levels,
    terrains: $bcae27952f7958f2$var$terrains,
    entityDefs: $bcae27952f7958f2$var$entityDefs,
    jsonBlobs: $bcae27952f7958f2$var$jsonBlobs,
    wavemeshes: $bcae27952f7958f2$var$wavemeshes,
    windmeshes: $bcae27952f7958f2$var$windmeshes,
    trees: $bcae27952f7958f2$var$trees
};


/**
 * Level file format and serialization utilities.
 *
 * Defines the JSON schema for level files which contain both terrain
 * and wave configuration data.
 */ 

/**
 * Geometry utilities.
 *
 * Provides common geometric algorithms like point-in-polygon tests.
 */ function $7d8da7ce07082450$export$7f6bc8d3d7d61b11(point, polygon) {
    const n = polygon.length;
    if (n < 3) return false;
    let inside = false;
    for(let i = 0, j = n - 1; i < n; j = i++){
        const xi = polygon[i].x, yi = polygon[i].y;
        const xj = polygon[j].x, yj = polygon[j].y;
        if (yi > point.y !== yj > point.y && point.x < (xj - xi) * (point.y - yi) / (yj - yi) + xi) inside = !inside;
    }
    return inside;
}


/**
 * Spline utilities for Catmull-Rom splines.
 *
 * Provides functions for:
 * - Evaluating Catmull-Rom spline points
 * - Sampling closed splines to point arrays
 * - Intersection detection between splines
 * - Point-in-spline and spline-in-spline containment
 */ 

function $b6748a5a9045fb3a$export$60c038c1e719e7c0(p0, p1, p2, p3, t) {
    const t2 = t * t;
    const t3 = t2 * t;
    const x = 0.5 * (2 * p1.x + (-p0.x + p2.x) * t + (2 * p0.x - 5 * p1.x + 4 * p2.x - p3.x) * t2 + (-p0.x + 3 * p1.x - 3 * p2.x + p3.x) * t3);
    const y = 0.5 * (2 * p1.y + (-p0.y + p2.y) * t + (2 * p0.y - 5 * p1.y + 4 * p2.y - p3.y) * t2 + (-p0.y + 3 * p1.y - 3 * p2.y + p3.y) * t3);
    return (0, $6b6a54a072724620$export$e7c866399fa523f5)(x, y);
}
function $b6748a5a9045fb3a$export$107218837c01d40(p0, p1, p2, p3, t) {
    const t2 = t * t;
    // Coefficients for the derivative
    // d/dt[2*p1] = 0
    // d/dt[(-p0 + p2) * t] = (-p0 + p2)
    // d/dt[(2*p0 - 5*p1 + 4*p2 - p3) * t²] = 2 * (2*p0 - 5*p1 + 4*p2 - p3) * t
    // d/dt[(-p0 + 3*p1 - 3*p2 + p3) * t³] = 3 * (-p0 + 3*p1 - 3*p2 + p3) * t²
    const x = 0.5 * (-p0.x + p2.x + 2 * (2 * p0.x - 5 * p1.x + 4 * p2.x - p3.x) * t + 3 * (-p0.x + 3 * p1.x - 3 * p2.x + p3.x) * t2);
    const y = 0.5 * (-p0.y + p2.y + 2 * (2 * p0.y - 5 * p1.y + 4 * p2.y - p3.y) * t + 3 * (-p0.y + 3 * p1.y - 3 * p2.y + p3.y) * t2);
    return (0, $6b6a54a072724620$export$e7c866399fa523f5)(x, y);
}
/** Default number of samples per spline segment */ const $b6748a5a9045fb3a$var$DEFAULT_SAMPLES_PER_SEGMENT = 16;
function $b6748a5a9045fb3a$export$595e6e09919025b7(controlPoints, samplesPerSegment = $b6748a5a9045fb3a$var$DEFAULT_SAMPLES_PER_SEGMENT) {
    const n = controlPoints.length;
    if (n < 3) // Not enough points for a proper spline, return as-is
    return [
        ...controlPoints
    ];
    const result = [];
    for(let i = 0; i < n; i++){
        const p0 = controlPoints[(i - 1 + n) % n];
        const p1 = controlPoints[i];
        const p2 = controlPoints[(i + 1) % n];
        const p3 = controlPoints[(i + 2) % n];
        // Sample this segment (don't include t=1 as it will be t=0 of next segment)
        for(let j = 0; j < samplesPerSegment; j++){
            const t = j / samplesPerSegment;
            result.push($b6748a5a9045fb3a$export$60c038c1e719e7c0(p0, p1, p2, p3, t));
        }
    }
    return result;
}
/**
 * Sample a closed spline with segment metadata for each point.
 */ function $b6748a5a9045fb3a$var$sampleClosedSplineWithMetadata(controlPoints, samplesPerSegment = $b6748a5a9045fb3a$var$DEFAULT_SAMPLES_PER_SEGMENT) {
    const n = controlPoints.length;
    if (n < 3) return controlPoints.map((point, i)=>({
            point: (0, $6b6a54a072724620$export$e7c866399fa523f5)(point.x, point.y),
            segmentIndex: i,
            t: 0
        }));
    const result = [];
    for(let i = 0; i < n; i++){
        const p0 = controlPoints[(i - 1 + n) % n];
        const p1 = controlPoints[i];
        const p2 = controlPoints[(i + 1) % n];
        const p3 = controlPoints[(i + 2) % n];
        for(let j = 0; j < samplesPerSegment; j++){
            const t = j / samplesPerSegment;
            result.push({
                point: $b6748a5a9045fb3a$export$60c038c1e719e7c0(p0, p1, p2, p3, t),
                segmentIndex: i,
                t: t
            });
        }
    }
    return result;
}
/**
 * Compute fraction along a line segment where a point lies.
 */ function $b6748a5a9045fb3a$var$fractionAlongSegment(start, end, point) {
    const dx = end.x - start.x;
    const dy = end.y - start.y;
    const lengthSq = dx * dx + dy * dy;
    if (lengthSq === 0) return 0;
    const px = point.x - start.x;
    const py = point.y - start.y;
    return (px * dx + py * dy) / lengthSq;
}
function $b6748a5a9045fb3a$export$3fd30c74a36792f0(splineA, splineB, samplesPerSegment = $b6748a5a9045fb3a$var$DEFAULT_SAMPLES_PER_SEGMENT) {
    const samplesA = $b6748a5a9045fb3a$var$sampleClosedSplineWithMetadata(splineA, samplesPerSegment);
    const samplesB = $b6748a5a9045fb3a$var$sampleClosedSplineWithMetadata(splineB, samplesPerSegment);
    if (samplesA.length < 2 || samplesB.length < 2) return [];
    const intersections = [];
    // Check all pairs of line segments
    for(let i = 0; i < samplesA.length; i++){
        const a1 = samplesA[i];
        const a2 = samplesA[(i + 1) % samplesA.length];
        for(let j = 0; j < samplesB.length; j++){
            const b1 = samplesB[j];
            const b2 = samplesB[(j + 1) % samplesB.length];
            const intersection = (0, $6b6a54a072724620$export$19606695c7c6ab3a).lineSegmentsIntersection(a1.point, a2.point, b1.point, b2.point);
            if (intersection) {
                // Compute the t values within the sampled segments
                const segmentTa = a1.t + 1 / samplesPerSegment * $b6748a5a9045fb3a$var$fractionAlongSegment(a1.point, a2.point, intersection);
                const segmentTb = b1.t + 1 / samplesPerSegment * $b6748a5a9045fb3a$var$fractionAlongSegment(b1.point, b2.point, intersection);
                intersections.push({
                    point: intersection,
                    segmentA: a1.segmentIndex,
                    segmentB: b1.segmentIndex,
                    tA: Math.min(1, Math.max(0, segmentTa)),
                    tB: Math.min(1, Math.max(0, segmentTb))
                });
            }
        }
    }
    return intersections;
}
function $b6748a5a9045fb3a$export$35d302dd669b8ee4(controlPoints, samplesPerSegment = $b6748a5a9045fb3a$var$DEFAULT_SAMPLES_PER_SEGMENT) {
    const samples = $b6748a5a9045fb3a$var$sampleClosedSplineWithMetadata(controlPoints, samplesPerSegment);
    if (samples.length < 4) return [];
    const intersections = [];
    const numControlPoints = controlPoints.length;
    // Check all pairs of line segments
    for(let i = 0; i < samples.length; i++){
        const s1 = samples[i];
        const s2 = samples[(i + 1) % samples.length];
        // Start j at i+2 to skip adjacent segment
        for(let j = i + 2; j < samples.length; j++){
            // Skip if this is the last segment wrapping back to the first
            // (they share an endpoint at the start/end of the loop)
            if (i === 0 && j === samples.length - 1) continue;
            const s3 = samples[j];
            const s4 = samples[(j + 1) % samples.length];
            // Skip segments from adjacent control point indices
            // (adjacent control point segments naturally share overlap in Catmull-Rom)
            const segDiff = Math.abs(s1.segmentIndex - s3.segmentIndex);
            const isAdjacent = segDiff <= 1 || segDiff === numControlPoints - 1;
            if (isAdjacent) continue;
            const intersection = (0, $6b6a54a072724620$export$19606695c7c6ab3a).lineSegmentsIntersection(s1.point, s2.point, s3.point, s4.point);
            if (intersection) {
                const segmentTa = s1.t + 1 / samplesPerSegment * $b6748a5a9045fb3a$var$fractionAlongSegment(s1.point, s2.point, intersection);
                const segmentTb = s3.t + 1 / samplesPerSegment * $b6748a5a9045fb3a$var$fractionAlongSegment(s3.point, s4.point, intersection);
                intersections.push({
                    point: intersection,
                    segmentA: s1.segmentIndex,
                    segmentB: s3.segmentIndex,
                    tA: Math.min(1, Math.max(0, segmentTa)),
                    tB: Math.min(1, Math.max(0, segmentTb))
                });
            }
        }
    }
    return intersections;
}
function $b6748a5a9045fb3a$export$2df7b06471fb1090(point, controlPoints, samplesPerSegment = $b6748a5a9045fb3a$var$DEFAULT_SAMPLES_PER_SEGMENT) {
    const polygon = $b6748a5a9045fb3a$export$595e6e09919025b7(controlPoints, samplesPerSegment);
    return (0, $7d8da7ce07082450$export$7f6bc8d3d7d61b11)(point, polygon);
}
function $b6748a5a9045fb3a$export$494852548d73a56b(inner, outer, samplesPerSegment = $b6748a5a9045fb3a$var$DEFAULT_SAMPLES_PER_SEGMENT) {
    // First check: no intersections between the splines
    const intersections = $b6748a5a9045fb3a$export$3fd30c74a36792f0(inner, outer, samplesPerSegment);
    if (intersections.length > 0) return false;
    // Sample one point from the inner spline and check if it's inside the outer
    if (inner.length === 0) return false;
    // Use the first point of the sampled inner spline
    const innerSamples = $b6748a5a9045fb3a$export$595e6e09919025b7(inner, samplesPerSegment);
    if (innerSamples.length === 0) return false;
    return $b6748a5a9045fb3a$export$2df7b06471fb1090(innerSamples[0], outer, samplesPerSegment);
}
function $b6748a5a9045fb3a$export$fd68b8f8564815c0(controlPoints, samplesPerSegment = $b6748a5a9045fb3a$var$DEFAULT_SAMPLES_PER_SEGMENT) {
    const samples = $b6748a5a9045fb3a$export$595e6e09919025b7(controlPoints, samplesPerSegment);
    if (samples.length === 0) return (0, $6b6a54a072724620$export$e7c866399fa523f5)(0, 0);
    let cx = 0, cy = 0;
    for (const p of samples){
        cx += p.x;
        cy += p.y;
    }
    return (0, $6b6a54a072724620$export$e7c866399fa523f5)(cx / samples.length, cy / samples.length);
}
function $b6748a5a9045fb3a$export$8c63c434b7904eee(controlPoints, samplesPerSegment = $b6748a5a9045fb3a$var$DEFAULT_SAMPLES_PER_SEGMENT) {
    const samples = $b6748a5a9045fb3a$export$595e6e09919025b7(controlPoints, samplesPerSegment);
    if (samples.length === 0) return null;
    let minX = Infinity;
    let minY = Infinity;
    let maxX = -Infinity;
    let maxY = -Infinity;
    for (const p of samples){
        minX = Math.min(minX, p.x);
        minY = Math.min(minY, p.y);
        maxX = Math.max(maxX, p.x);
        maxY = Math.max(maxY, p.y);
    }
    return {
        minX: minX,
        minY: minY,
        maxX: maxX,
        maxY: maxY
    };
}


/**
 * Shared constants for terrain simulation.
 * These are used by both TypeScript code and WGSL shaders.
 */ // CPU pre-sampling resolution for Catmull-Rom splines
const $50f569eac7e9a7b2$export$be0b6d6c9195b311 = 16; // Samples per control point pair (evaluated on CPU)
const $50f569eac7e9a7b2$export$be1fdb4039ae4e9f = 4096; // Maximum number of contours
const $50f569eac7e9a7b2$export$67e4c5d21b471b82 = 524288; // Maximum total pre-sampled vertices across all contours
const $50f569eac7e9a7b2$export$374147192ca69e15 = 8192; // Maximum total children across all contours (for tree structure)
const $50f569eac7e9a7b2$export$2db1e55928456695 = 64; // 64x64 grid per contour
const $50f569eac7e9a7b2$export$c30998db895198d6 = $50f569eac7e9a7b2$export$2db1e55928456695 * $50f569eac7e9a7b2$export$2db1e55928456695; // 4096 cells
const $50f569eac7e9a7b2$export$3abf0a72dc8746a = $50f569eac7e9a7b2$export$c30998db895198d6 / 16; // 256 u32s (2 bits per cell, 16 cells per u32)
const $50f569eac7e9a7b2$export$5d2b3ec3c5830b3e = 32; // 32×32 grid per contour
const $50f569eac7e9a7b2$export$720cf42e0fadba1e = $50f569eac7e9a7b2$export$5d2b3ec3c5830b3e * $50f569eac7e9a7b2$export$5d2b3ec3c5830b3e; // 256
const $50f569eac7e9a7b2$export$ceb121c650229aae = $50f569eac7e9a7b2$export$720cf42e0fadba1e + 1; // 257 (prefix-sum sentinel)
const $50f569eac7e9a7b2$export$520fbecd11a75b1a = 25165824; // 24M u32s (96MB) for all IDW grid data
const $50f569eac7e9a7b2$export$443d7f6df6e65b63 = 32; // Max contours in one IDW blend (1 parent + 31 children)
const $50f569eac7e9a7b2$export$907000ff90f2b44a = 1024; // 1024×1024 grid
const $50f569eac7e9a7b2$export$858e2636b73e378f = $50f569eac7e9a7b2$export$907000ff90f2b44a * $50f569eac7e9a7b2$export$907000ff90f2b44a; // 65536
const $50f569eac7e9a7b2$export$99fc3a7da177e747 = 6; // cols, rows, min_x, min_y, inv_cell_w, inv_cell_h
const $50f569eac7e9a7b2$export$7f882bb969de14a3 = -300; // ft - deep ocean baseline
const $50f569eac7e9a7b2$export$30c5e31adc700e57 = 1.5; // ft - depth for sand/water blending


function $7bf8a1354b31a70a$var$computeBBox(points) {
    let minX = Infinity, minY = Infinity, maxX = -Infinity, maxY = -Infinity;
    for (const p of points){
        if (p.x < minX) minX = p.x;
        if (p.x > maxX) maxX = p.x;
        if (p.y < minY) minY = p.y;
        if (p.y > maxY) maxY = p.y;
    }
    return {
        minX: minX,
        minY: minY,
        maxX: maxX,
        maxY: maxY
    };
}
/** True if inner bbox is fully contained within outer bbox */ function $7bf8a1354b31a70a$var$bboxContains(outer, inner) {
    return inner.minX >= outer.minX && inner.maxX <= outer.maxX && inner.minY >= outer.minY && inner.maxY <= outer.maxY;
}
/**
 * Fast containment check using precomputed bboxes and sampled polygons.
 * Avoids expensive spline resampling and intersection tests.
 */ function $7bf8a1354b31a70a$var$isContourInsideContour(inner, innerBBox, outer, outerBBox) {
    // Quick rejection: inner bbox must fit inside outer bbox
    if (!$7bf8a1354b31a70a$var$bboxContains(outerBBox, innerBBox)) return false;
    // Check if a point from the inner contour is inside the outer polygon.
    // Since we already know the bboxes are nested, if one point is inside
    // and the contours don't intersect, the whole inner contour is inside.
    const testPoint = inner.sampledPolygon[0];
    return testPoint !== undefined && (0, $7d8da7ce07082450$export$7f6bc8d3d7d61b11)(testPoint, outer.sampledPolygon);
}
const $7bf8a1354b31a70a$export$517cfe62b5c858e2 = 14;
function $7bf8a1354b31a70a$export$880ee1dc2e5da996(controlPoints, height) {
    return {
        type: "spline",
        controlPoints: controlPoints,
        height: height,
        sampledPolygon: (0, $b6748a5a9045fb3a$export$595e6e09919025b7)(controlPoints, $7bf8a1354b31a70a$var$adaptiveSamplesPerSegment(controlPoints))
    };
}
function $7bf8a1354b31a70a$export$ad18007d2f30bf91(points, height) {
    return {
        type: "polygon",
        controlPoints: points,
        height: height,
        sampledPolygon: points
    };
}
/**
 * Choose samples-per-segment based on average segment length.
 * Hand-drawn contours have few, widely-spaced control points and need many
 * interpolation samples for smooth curves. Imported contours have dense points
 * that are already close together and need minimal interpolation.
 */ function $7bf8a1354b31a70a$var$adaptiveSamplesPerSegment(controlPoints) {
    const n = controlPoints.length;
    if (n < 3) return 1;
    let totalLength = 0;
    for(let i = 0; i < n; i++){
        const a = controlPoints[i];
        const b = controlPoints[(i + 1) % n];
        totalLength += Math.hypot(b.x - a.x, b.y - a.y);
    }
    const avgSegmentLength = totalLength / n;
    // Target roughly one sample per SAMPLES_PER_SEGMENT feet of segment length,
    // clamped to [1, SAMPLES_PER_SEGMENT]
    return Math.max(1, Math.min((0, $50f569eac7e9a7b2$export$be0b6d6c9195b311), Math.round(avgSegmentLength / (0, $50f569eac7e9a7b2$export$be0b6d6c9195b311))));
}
function $7bf8a1354b31a70a$export$ad284f4aae8b3935(points) {
    if (points.length < 3) return 0;
    let area = 0;
    const n = points.length;
    for(let i = 0; i < n; i++){
        const j = (i + 1) % n;
        area += points[i].x * points[j].y;
        area -= points[j].x * points[i].y;
    }
    return area / 2;
}
function $7bf8a1354b31a70a$export$7399924c031564a3(contour) {
    // In screen coordinates (Y down), negative signed area = CCW
    return $7bf8a1354b31a70a$export$ad284f4aae8b3935(contour.controlPoints) < 0;
}
function $7bf8a1354b31a70a$export$31bd3ad5f4de9def(contour) {
    if ($7bf8a1354b31a70a$export$7399924c031564a3(contour)) return contour;
    // For polygon contours, controlPoints and sampledPolygon are the same array,
    // so share the reversed array between both fields.
    if (contour.type === "polygon") {
        const reversed = [
            ...contour.controlPoints
        ].reverse();
        return {
            type: "polygon",
            controlPoints: reversed,
            height: contour.height,
            sampledPolygon: reversed
        };
    }
    // Reverse both control points and sampled polygon to flip winding
    return {
        type: "spline",
        controlPoints: [
            ...contour.controlPoints
        ].reverse(),
        height: contour.height,
        sampledPolygon: [
            ...contour.sampledPolygon
        ].reverse()
    };
}
function $7bf8a1354b31a70a$export$6de2c26936e89d30(definition) {
    const normalizedContours = definition.contours.map((contour)=>$7bf8a1354b31a70a$export$31bd3ad5f4de9def(contour));
    return {
        contours: normalizedContours,
        defaultDepth: definition.defaultDepth,
        precomputedGPUData: definition.precomputedGPUData
    };
}
function $7bf8a1354b31a70a$export$a0615e6ccebf146a(contours) {
    const n = contours.length;
    if (n === 0) return {
        nodes: [],
        childrenFlat: [],
        maxDepth: 0
    };
    // Precompute bounding boxes for fast containment rejection
    const bboxes = contours.map((c)=>$7bf8a1354b31a70a$var$computeBBox(c.sampledPolygon));
    // Virtual root node (represents "ocean" - contains all root-level contours)
    const virtualRoot = {
        contourIndex: -1,
        parentIndex: -1,
        children: []
    };
    // Map from contour index to working node for quick lookup
    const nodeMap = new Map();
    /**
   * Recursively insert a new contour into the tree.
   * @param parent - Current node being examined
   * @param newIndex - Index of the contour to insert
   */ function insertContour(parent, newIndex) {
        const newContour = contours[newIndex];
        const newBBox = bboxes[newIndex];
        // Check if any existing child contains the new contour
        for (const child of parent.children)if ($7bf8a1354b31a70a$var$isContourInsideContour(newContour, newBBox, contours[child.contourIndex], bboxes[child.contourIndex])) {
            // New contour is inside this child - recurse deeper
            insertContour(child, newIndex);
            return;
        }
        // No child contains newContour, so it becomes a direct child of parent
        // But first, check if newContour contains any existing children (reparent them)
        const newNode = {
            contourIndex: newIndex,
            parentIndex: parent.contourIndex,
            children: []
        };
        nodeMap.set(newIndex, newNode);
        // Find children that should be reparented to the new node
        const childrenToReparent = [];
        for (const child of parent.children)if ($7bf8a1354b31a70a$var$isContourInsideContour(contours[child.contourIndex], bboxes[child.contourIndex], newContour, newBBox)) childrenToReparent.push(child);
        // Reparent contained children to newNode
        for (const child of childrenToReparent){
            // Remove from parent's children
            const idx = parent.children.indexOf(child);
            if (idx >= 0) parent.children.splice(idx, 1);
            // Add to new node's children
            newNode.children.push(child);
            child.parentIndex = newIndex;
        }
        // Add newNode as child of parent
        parent.children.push(newNode);
    }
    // Insert all contours one by one
    for(let i = 0; i < n; i++)insertContour(virtualRoot, i);
    // Convert working tree to final ContourTreeNode array
    const nodes = contours.map((_, i)=>({
            contourIndex: i,
            parentIndex: -1,
            depth: 0,
            children: []
        }));
    // Copy parent/child relationships from working tree
    for(let i = 0; i < n; i++){
        const workingNode = nodeMap.get(i);
        nodes[i].parentIndex = workingNode.parentIndex;
        nodes[i].children = workingNode.children.map((c)=>c.contourIndex);
    }
    // Compute depths via BFS from roots
    const roots = nodes.filter((node)=>node.parentIndex === -1);
    let maxDepth = 0;
    const queue = roots.map((n)=>n.contourIndex);
    while(queue.length > 0){
        const idx = queue.shift();
        const node = nodes[idx];
        const depth = node.parentIndex >= 0 ? nodes[node.parentIndex].depth + 1 : 0;
        node.depth = depth;
        maxDepth = Math.max(maxDepth, depth);
        for (const childIdx of node.children)queue.push(childIdx);
    }
    // Build flat children array for GPU
    const childrenFlat = [];
    for (const node of nodes)for (const childIdx of node.children)childrenFlat.push(childIdx);
    return {
        nodes: nodes,
        childrenFlat: childrenFlat,
        maxDepth: maxDepth
    };
}
// Track which terrain definitions have been validated to avoid duplicate warnings
const $7bf8a1354b31a70a$var$validatedDefinitions = new WeakSet();
function $7bf8a1354b31a70a$export$3ae5655751e4ee13(definition) {
    // Skip if already validated
    if ($7bf8a1354b31a70a$var$validatedDefinitions.has(definition)) return;
    $7bf8a1354b31a70a$var$validatedDefinitions.add(definition);
    const contours = definition.contours;
    if (contours.length === 0) return;
    // Check each contour for self-intersection (spline contours only —
    // polygon contours are validated by the offline validator instead)
    for(let i = 0; i < contours.length; i++){
        const contour = contours[i];
        if (contour.type === "polygon") continue;
        if (contour.controlPoints.length < 3) {
            console.warn(`Terrain contour ${i} at height ${contour.height} has only ${contour.controlPoints.length} control points`);
            continue;
        }
        const selfIntersections = (0, $b6748a5a9045fb3a$export$35d302dd669b8ee4)(contour.controlPoints);
        if (selfIntersections.length > 0) {
            const first = selfIntersections[0];
            console.warn(`Terrain contour ${i} at height ${contour.height} self-intersects. ` + `Found ${selfIntersections.length} intersection(s). ` + `First at (${first.point.x.toFixed(0)}, ${first.point.y.toFixed(0)}) ` + `between segments ${first.segmentA} and ${first.segmentB}.`);
        }
    }
    // Check all pairs of contours for intersection (spline contours only)
    for(let i = 0; i < contours.length; i++)for(let j = i + 1; j < contours.length; j++){
        const contourA = contours[i];
        const contourB = contours[j];
        if (contourA.type === "polygon" || contourB.type === "polygon") continue;
        if (contourA.controlPoints.length < 3 || contourB.controlPoints.length < 3) continue;
        const intersections = (0, $b6748a5a9045fb3a$export$3fd30c74a36792f0)(contourA.controlPoints, contourB.controlPoints);
        if (intersections.length > 0) {
            const first = intersections[0];
            console.warn(`Terrain contours ${i} (height ${contourA.height}) and ${j} (height ${contourB.height}) intersect. ` + `Found ${intersections.length} intersection(s). ` + `First at (${first.point.x.toFixed(0)}, ${first.point.y.toFixed(0)}).`);
        }
    }
}
// =============================================================================
// Containment Grid — O(1) point-in-contour for GPU queries
// =============================================================================
const $7bf8a1354b31a70a$var$CELL_OUTSIDE = 0;
const $7bf8a1354b31a70a$var$CELL_INSIDE = 1;
const $7bf8a1354b31a70a$var$CELL_BOUNDARY = 2;
/**
 * DDA line rasterization through grid cells, marking each traversed cell as BOUNDARY.
 * Ported from Rust terrain.rs `rasterize_edge_to_grid`.
 */ function $7bf8a1354b31a70a$var$rasterizeEdgeToGrid(ax, ay, bx, by, minX, minY, invCellW, invCellH, cols, rows, cellFlags) {
    const maxCol = cols - 1;
    const maxRow = rows - 1;
    let col = Math.floor((ax - minX) * invCellW);
    let row = Math.floor((ay - minY) * invCellH);
    const endCol = Math.floor((bx - minX) * invCellW);
    const endRow = Math.floor((by - minY) * invCellH);
    // Mark start cell
    if (col >= 0 && col <= maxCol && row >= 0 && row <= maxRow) cellFlags[row * cols + col] = $7bf8a1354b31a70a$var$CELL_BOUNDARY;
    const dx = bx - ax;
    const dy = by - ay;
    const stepCol = dx > 0 ? 1 : dx < 0 ? -1 : 0;
    const stepRow = dy > 0 ? 1 : dy < 0 ? -1 : 0;
    const cellW = 1 / invCellW;
    const cellH = 1 / invCellH;
    let tMaxX = dx !== 0 ? ((dx > 0 ? minX + (col + 1) * cellW : minX + col * cellW) - ax) / dx : Infinity;
    let tMaxY = dy !== 0 ? ((dy > 0 ? minY + (row + 1) * cellH : minY + row * cellH) - ay) / dy : Infinity;
    const tDeltaX = dx !== 0 ? Math.abs(cellW / dx) : Infinity;
    const tDeltaY = dy !== 0 ? Math.abs(cellH / dy) : Infinity;
    const maxSteps = (cols + rows) * 2;
    for(let step = 0; step < maxSteps; step++){
        if (col === endCol && row === endRow) break;
        if (tMaxX < tMaxY) {
            col += stepCol;
            tMaxX += tDeltaX;
        } else {
            row += stepRow;
            tMaxY += tDeltaY;
        }
        if (col >= 0 && col <= maxCol && row >= 0 && row <= maxRow) cellFlags[row * cols + col] = $7bf8a1354b31a70a$var$CELL_BOUNDARY;
    }
}
/**
 * Build a 64x64 containment grid for a contour's sampled polygon.
 * Returns a Uint32Array of 256 elements with 2-bit packed flags
 * (OUTSIDE=0, INSIDE=1, BOUNDARY=2).
 *
 * Algorithm (ported from Rust terrain.rs):
 * 1. DDA-rasterize each polygon edge to mark BOUNDARY cells
 * 2. Test center of each non-BOUNDARY cell with pointInPolygon
 * 3. Pack into 2-bit representation (16 cells per u32)
 */ function $7bf8a1354b31a70a$var$buildContainmentGrid(polygon, bboxMinX, bboxMinY, bboxMaxX, bboxMaxY) {
    const cols = (0, $50f569eac7e9a7b2$export$2db1e55928456695);
    const rows = (0, $50f569eac7e9a7b2$export$2db1e55928456695);
    const numCells = (0, $50f569eac7e9a7b2$export$c30998db895198d6);
    const w = Math.max(bboxMaxX - bboxMinX, 1e-9);
    const h = Math.max(bboxMaxY - bboxMinY, 1e-9);
    const invCellW = cols / w;
    const invCellH = rows / h;
    const cellW = w / cols;
    const cellH = h / rows;
    const cellFlags = new Uint8Array(numCells);
    // cellFlags starts as all CELL_OUTSIDE (0)
    // Rasterize polygon edges to mark BOUNDARY cells
    const n = polygon.length;
    for(let i = 0; i < n; i++){
        const j = (i + 1) % n;
        $7bf8a1354b31a70a$var$rasterizeEdgeToGrid(polygon[i].x, polygon[i].y, polygon[j].x, polygon[j].y, bboxMinX, bboxMinY, invCellW, invCellH, cols, rows, cellFlags);
    }
    // Test center of non-BOUNDARY cells with pointInPolygon
    const testPoint = new (0, $6b6a54a072724620$export$19606695c7c6ab3a)(0, 0);
    for(let cell = 0; cell < numCells; cell++)if (cellFlags[cell] !== $7bf8a1354b31a70a$var$CELL_BOUNDARY) {
        const col = cell % cols;
        const row = Math.floor(cell / cols);
        testPoint.x = bboxMinX + (col + 0.5) * cellW;
        testPoint.y = bboxMinY + (row + 0.5) * cellH;
        if ((0, $7d8da7ce07082450$export$7f6bc8d3d7d61b11)(testPoint, polygon)) cellFlags[cell] = $7bf8a1354b31a70a$var$CELL_INSIDE;
    }
    // Pack into 2-bit representation: 16 cells per u32
    const packed = new Uint32Array((0, $50f569eac7e9a7b2$export$3abf0a72dc8746a));
    for(let i = 0; i < numCells; i++)packed[i >> 4] |= (cellFlags[i] & 3) << (i & 15) * 2;
    return packed;
}
// =============================================================================
// IDW Grid — precomputed candidate edges for GPU IDW blending
// =============================================================================
/** Squared distance from point to segment (no sqrt). */ function $7bf8a1354b31a70a$var$pointToSegmentDistSq(px, py, ax, ay, bx, by) {
    const abx = bx - ax;
    const aby = by - ay;
    const lenSq = Math.max(abx * abx + aby * aby, 1e-20);
    const t = Math.max(0, Math.min(1, ((px - ax) * abx + (py - ay) * aby) / lenSq));
    const nx = ax + t * abx;
    const ny = ay + t * aby;
    const dx = px - nx;
    const dy = py - ny;
    return dx * dx + dy * dy;
}
/** Squared distance from point to axis-aligned rectangle (0 if inside). */ function $7bf8a1354b31a70a$var$pointToRectDistSq(px, py, rx0, ry0, rx1, ry1) {
    const dx = px < rx0 ? rx0 - px : px > rx1 ? px - rx1 : 0;
    const dy = py < ry0 ? ry0 - py : py > ry1 ? py - ry1 : 0;
    return dx * dx + dy * dy;
}
/** Test if segment (ax,ay)-(bx,by) intersects axis-aligned rectangle. */ function $7bf8a1354b31a70a$var$segmentIntersectsRect(ax, ay, bx, by, rx0, ry0, rx1, ry1) {
    if (ax >= rx0 && ax <= rx1 && ay >= ry0 && ay <= ry1) return true;
    if (bx >= rx0 && bx <= rx1 && by >= ry0 && by <= ry1) return true;
    const ddx = bx - ax;
    const ddy = by - ay;
    let tMin = 0;
    let tMax = 1;
    const clips = [
        [
            -ddx,
            ax - rx0
        ],
        [
            ddx,
            rx1 - ax
        ],
        [
            -ddy,
            ay - ry0
        ],
        [
            ddy,
            ry1 - ay
        ]
    ];
    for (const [p, q] of clips)if (Math.abs(p) < 1e-20) {
        if (q < 0) return false;
    } else {
        const r = q / p;
        if (p < 0) {
            if (r > tMax) return false;
            if (r > tMin) tMin = r;
        } else {
            if (r < tMin) return false;
            if (r < tMax) tMax = r;
        }
    }
    return tMin <= tMax;
}
/** Min squared distance from axis-aligned rect to segment (0 if they intersect). */ function $7bf8a1354b31a70a$var$minDistSqRectSegment(rx0, ry0, rx1, ry1, ax, ay, bx, by) {
    if ($7bf8a1354b31a70a$var$segmentIntersectsRect(ax, ay, bx, by, rx0, ry0, rx1, ry1)) return 0;
    let d = Infinity;
    d = Math.min(d, $7bf8a1354b31a70a$var$pointToSegmentDistSq(rx0, ry0, ax, ay, bx, by));
    d = Math.min(d, $7bf8a1354b31a70a$var$pointToSegmentDistSq(rx1, ry0, ax, ay, bx, by));
    d = Math.min(d, $7bf8a1354b31a70a$var$pointToSegmentDistSq(rx0, ry1, ax, ay, bx, by));
    d = Math.min(d, $7bf8a1354b31a70a$var$pointToSegmentDistSq(rx1, ry1, ax, ay, bx, by));
    d = Math.min(d, $7bf8a1354b31a70a$var$pointToRectDistSq(ax, ay, rx0, ry0, rx1, ry1));
    d = Math.min(d, $7bf8a1354b31a70a$var$pointToRectDistSq(bx, by, rx0, ry0, rx1, ry1));
    return d;
}
/** Max squared distance from any rect point to segment (at a corner, since
 *  dist-to-segment is convex). */ function $7bf8a1354b31a70a$var$maxDistSqRectSegment(rx0, ry0, rx1, ry1, ax, ay, bx, by) {
    return Math.max($7bf8a1354b31a70a$var$pointToSegmentDistSq(rx0, ry0, ax, ay, bx, by), $7bf8a1354b31a70a$var$pointToSegmentDistSq(rx1, ry0, ax, ay, bx, by), $7bf8a1354b31a70a$var$pointToSegmentDistSq(rx0, ry1, ax, ay, bx, by), $7bf8a1354b31a70a$var$pointToSegmentDistSq(rx1, ry1, ax, ay, bx, by));
}
/**
 * Build a 16×16 IDW candidate grid for a parent contour and its children.
 * Each grid cell stores candidate (tag, edgeIndex) pairs for edges that could
 * be the nearest boundary for any point in that cell.
 *
 * Returns null if the grid would be too large.
 */ function $7bf8a1354b31a70a$var$buildIDWGrid(parentPolygon, childPolygons, parentBBox) {
    const minX = parentBBox.minX;
    const minY = parentBBox.minY;
    const w = Math.max(parentBBox.maxX - minX, 1e-9);
    const h = Math.max(parentBBox.maxY - minY, 1e-9);
    const cellW = w / (0, $50f569eac7e9a7b2$export$5d2b3ec3c5830b3e);
    const cellH = h / (0, $50f569eac7e9a7b2$export$5d2b3ec3c5830b3e);
    const edges = [];
    // Parent edges (tag 0)
    for(let i = 0; i < parentPolygon.length; i++){
        const j = (i + 1) % parentPolygon.length;
        edges.push({
            ax: parentPolygon[i].x,
            ay: parentPolygon[i].y,
            bx: parentPolygon[j].x,
            by: parentPolygon[j].y,
            tag: 0,
            edgeIndex: i
        });
    }
    // Child edges (tags 1..N)
    for(let ci = 0; ci < childPolygons.length; ci++){
        const poly = childPolygons[ci];
        for(let i = 0; i < poly.length; i++){
            const j = (i + 1) % poly.length;
            edges.push({
                ax: poly[i].x,
                ay: poly[i].y,
                bx: poly[j].x,
                by: poly[j].y,
                tag: ci + 1,
                edgeIndex: i
            });
        }
    }
    // For each cell, find candidate edges using exact rect-to-segment distances.
    // Per-tag upper bound = min over same-tag edges of max_dist(cell_rect, edge).
    // Edge E is included if min_dist(cell_rect, E) ≤ upper bound for its tag.
    const numTags = 1 + childPolygons.length;
    const cellEntries = new Array((0, $50f569eac7e9a7b2$export$720cf42e0fadba1e));
    let totalEntries = 0;
    const perTagUpperBoundSq = new Float64Array(numTags);
    for(let row = 0; row < (0, $50f569eac7e9a7b2$export$5d2b3ec3c5830b3e); row++)for(let col = 0; col < (0, $50f569eac7e9a7b2$export$5d2b3ec3c5830b3e); col++){
        const rx0 = minX + col * cellW;
        const ry0 = minY + row * cellH;
        const rx1 = rx0 + cellW;
        const ry1 = ry0 + cellH;
        // Find per-tag upper bound: smallest max-distance to any edge of that tag
        perTagUpperBoundSq.fill(Infinity);
        for (const e of edges){
            const dMax = $7bf8a1354b31a70a$var$maxDistSqRectSegment(rx0, ry0, rx1, ry1, e.ax, e.ay, e.bx, e.by);
            if (dMax < perTagUpperBoundSq[e.tag]) perTagUpperBoundSq[e.tag] = dMax;
        }
        const cell = row * (0, $50f569eac7e9a7b2$export$5d2b3ec3c5830b3e) + col;
        // Collect candidates passing the rect-segment upper bound filter
        const candidateIndices = [];
        for(let i = 0; i < edges.length; i++){
            const e = edges[i];
            const dMin = $7bf8a1354b31a70a$var$minDistSqRectSegment(rx0, ry0, rx1, ry1, e.ax, e.ay, e.bx, e.by);
            if (dMin <= perTagUpperBoundSq[e.tag]) candidateIndices.push(i);
        }
        // Add all candidates that pass the rect-segment upper bound filter.
        const candidates = candidateIndices.map((i)=>{
            const e = edges[i];
            return e.tag << 16 | e.edgeIndex;
        });
        cellEntries[cell] = candidates;
        totalEntries += candidates.length;
    }
    // Build prefix-sum cell_starts and flat entries
    const cellStarts = new Uint32Array((0, $50f569eac7e9a7b2$export$ceb121c650229aae));
    cellStarts[0] = 0;
    for(let i = 0; i < (0, $50f569eac7e9a7b2$export$720cf42e0fadba1e); i++)cellStarts[i + 1] = cellStarts[i] + cellEntries[i].length;
    const entries = new Uint32Array(totalEntries);
    let writeIdx = 0;
    for(let i = 0; i < (0, $50f569eac7e9a7b2$export$720cf42e0fadba1e); i++)for (const packed of cellEntries[i])entries[writeIdx++] = packed;
    return {
        cellStarts: cellStarts,
        entries: entries
    };
}
function $7bf8a1354b31a70a$export$14b690e8105d8014(definition) {
    const contours = definition.contours;
    if (contours.length === 0) return {
        vertexData: new Float32Array(0),
        contourData: new ArrayBuffer(0),
        childrenData: new Uint32Array(0),
        containmentGridData: new Uint32Array(0),
        idwGridData: new Uint32Array(0),
        lookupGridData: new Uint32Array(0),
        coastlineIndices: new Uint32Array(0),
        contourCount: 0,
        coastlineCount: 0,
        maxDepth: 0,
        defaultDepth: definition.defaultDepth ?? (0, $50f569eac7e9a7b2$export$7f882bb969de14a3)
    };
    // Build containment tree
    const tree = $7bf8a1354b31a70a$export$a0615e6ccebf146a(contours);
    // Compute DFS ordering and skip counts
    // dfsOrder[i] = original contour index at DFS position i
    // originalToDfs[originalIndex] = DFS position
    // skipCounts[dfsPosition] = number of descendants (subtree size)
    const dfsOrder = [];
    const originalToDfs = new Map();
    const skipCounts = new Array(contours.length).fill(0);
    // DFS traversal to build ordering and compute skip counts
    function dfsVisit(originalIndex) {
        const dfsIndex = dfsOrder.length;
        dfsOrder.push(originalIndex);
        originalToDfs.set(originalIndex, dfsIndex);
        // Visit children and accumulate subtree size
        const node = tree.nodes[originalIndex];
        let subtreeSize = 0;
        for (const childOriginalIndex of node.children)subtreeSize += 1 + dfsVisit(childOriginalIndex);
        // Store skip count at the correct DFS index (not push, since we're in post-order here)
        skipCounts[dfsIndex] = subtreeSize;
        return subtreeSize;
    }
    // Start DFS from root nodes (those with parentIndex === -1)
    for(let i = 0; i < tree.nodes.length; i++)if (tree.nodes[i].parentIndex === -1) dfsVisit(i);
    // Use pre-sampled polygons from contours
    const sampledContours = contours.map((contour)=>contour.sampledPolygon);
    // Count total vertices after sampling
    let totalVertices = 0;
    for (const vertices of sampledContours)totalVertices += vertices.length;
    const vertexData = new Float32Array(totalVertices * 2);
    // Use ArrayBuffer + DataView to write mixed u32/f32 data correctly
    // Layout per contour (56 bytes = 14 x 4 bytes):
    //   0-3:   pointStartIndex (u32) - refers to pre-sampled vertices
    //   4-7:   pointCount (u32) - refers to pre-sampled vertices
    //   8-11:  height (f32)
    //   12-15: parentIndex (i32, -1 if root) - in DFS indices
    //   16-19: depth (u32)
    //   20-23: childStartIndex (u32)
    //   24-27: childCount (u32)
    //   28-31: isCoastline (u32, 1 if height == 0)
    //   32-35: bboxMinX (f32)
    //   36-39: bboxMinY (f32)
    //   40-43: bboxMaxX (f32)
    //   44-47: bboxMaxY (f32)
    //   48-51: skipCount (u32) - number of contours in subtree
    //   52-55: idwGridDataOffset (u32) - absolute offset into packed buffer for IDW grid
    const contourBuffer = new ArrayBuffer(contours.length * $7bf8a1354b31a70a$export$517cfe62b5c858e2 * 4);
    const contourView = new DataView(contourBuffer);
    // Build flat children index array in DFS order
    // childStartIndices[dfsIndex] = start index in children buffer
    const childStartIndices = [];
    const childrenFlat = [];
    for(let dfsIndex = 0; dfsIndex < dfsOrder.length; dfsIndex++){
        const originalIndex = dfsOrder[dfsIndex];
        const node = tree.nodes[originalIndex];
        childStartIndices.push(childrenFlat.length);
        // Store children as DFS indices
        for (const childOriginalIndex of node.children)childrenFlat.push(originalToDfs.get(childOriginalIndex));
    }
    const childrenData = new Uint32Array(childrenFlat);
    // Collect coastline indices (height == 0 contours) in DFS order
    const coastlineIndicesList = [];
    for(let dfsIndex = 0; dfsIndex < dfsOrder.length; dfsIndex++){
        const originalIndex = dfsOrder[dfsIndex];
        if (contours[originalIndex].height === 0) coastlineIndicesList.push(dfsIndex);
    }
    const coastlineIndices = new Uint32Array(coastlineIndicesList);
    // Write contour data in DFS order, and build containment grids
    const containmentGridData = new Uint32Array(contours.length * (0, $50f569eac7e9a7b2$export$3abf0a72dc8746a));
    let vertexIndex = 0;
    for(let dfsIndex = 0; dfsIndex < dfsOrder.length; dfsIndex++){
        const originalIndex = dfsOrder[dfsIndex];
        const contour = contours[originalIndex];
        const node = tree.nodes[originalIndex];
        const vertices = sampledContours[originalIndex];
        // Store contour metadata - byte offset for each contour
        const byteBase = dfsIndex * $7bf8a1354b31a70a$export$517cfe62b5c858e2 * 4;
        // u32 fields (must use setUint32, not float)
        contourView.setUint32(byteBase + 0, vertexIndex, true); // pointStartIndex
        contourView.setUint32(byteBase + 4, vertices.length, true); // pointCount
        // f32 field
        contourView.setFloat32(byteBase + 8, contour.height, true);
        // Tree structure fields - parentIndex in DFS indices
        const parentDfsIndex = node.parentIndex === -1 ? -1 : originalToDfs.get(node.parentIndex);
        contourView.setInt32(byteBase + 12, parentDfsIndex, true); // parentIndex (signed)
        contourView.setUint32(byteBase + 16, node.depth, true); // depth
        contourView.setUint32(byteBase + 20, childStartIndices[dfsIndex], true); // childStartIndex
        contourView.setUint32(byteBase + 24, node.children.length, true); // childCount
        contourView.setUint32(byteBase + 28, contour.height === 0 ? 1 : 0, true); // isCoastline
        // Compute bounding box from pre-sampled vertices
        let minX = 0, maxX = 0, minY = 0, maxY = 0;
        if (vertices.length > 0) {
            minX = Infinity;
            maxX = -Infinity;
            minY = Infinity;
            maxY = -Infinity;
            for (const pt of vertices){
                minX = Math.min(minX, pt.x);
                maxX = Math.max(maxX, pt.x);
                minY = Math.min(minY, pt.y);
                maxY = Math.max(maxY, pt.y);
            }
            contourView.setFloat32(byteBase + 32, minX, true); // bboxMinX
            contourView.setFloat32(byteBase + 36, minY, true); // bboxMinY
            contourView.setFloat32(byteBase + 40, maxX, true); // bboxMaxX
            contourView.setFloat32(byteBase + 44, maxY, true); // bboxMaxY
        }
        // Skip count for DFS traversal
        contourView.setUint32(byteBase + 48, skipCounts[dfsIndex], true); // skipCount
        // IDW grid data offset (0 = no grid, set later if grid is built)
        contourView.setUint32(byteBase + 52, 0, true); // idwGridDataOffset
        // Build containment grid for this contour
        if (vertices.length >= 3) {
            const grid = $7bf8a1354b31a70a$var$buildContainmentGrid(vertices, minX, minY, maxX, maxY);
            const gridOffset = dfsIndex * (0, $50f569eac7e9a7b2$export$3abf0a72dc8746a);
            containmentGridData.set(grid, gridOffset);
        }
        // Store pre-sampled vertices
        for (const pt of vertices){
            vertexData[vertexIndex * 2 + 0] = pt.x;
            vertexData[vertexIndex * 2 + 1] = pt.y;
            vertexIndex++;
        }
    }
    // Build IDW grids for contours with children
    const idwGridParts = [];
    let idwGridTotalSize = 0;
    // Count eligible contours (have children and fit IDW limit) for progress reporting
    let eligibleCount = 0;
    for (const originalIndex of dfsOrder){
        const node = tree.nodes[originalIndex];
        if (node.children.length > 0 && node.children.length + 1 <= (0, $50f569eac7e9a7b2$export$443d7f6df6e65b63)) eligibleCount++;
    }
    let processedCount = 0;
    for(let dfsIndex = 0; dfsIndex < dfsOrder.length; dfsIndex++){
        const originalIndex = dfsOrder[dfsIndex];
        const node = tree.nodes[originalIndex];
        const contour = contours[originalIndex];
        if (node.children.length === 0 || node.children.length + 1 > (0, $50f569eac7e9a7b2$export$443d7f6df6e65b63)) continue;
        // Gather parent polygon
        const parentPoly = contour.sampledPolygon;
        const parentBBox = $7bf8a1354b31a70a$var$computeBBox(parentPoly);
        // Gather child polygons
        const childPolygons = [];
        for (const childOrigIdx of node.children)childPolygons.push(contours[childOrigIdx].sampledPolygon);
        const grid = $7bf8a1354b31a70a$var$buildIDWGrid(parentPoly, childPolygons, parentBBox);
        if (grid === null) continue;
        const gridSize = grid.cellStarts.length + grid.entries.length;
        if (idwGridTotalSize + gridSize > (0, $50f569eac7e9a7b2$export$520fbecd11a75b1a)) {
            const pct = (processedCount / eligibleCount * 100).toFixed(1);
            const usedMB = (idwGridTotalSize * 4 / 1048576).toFixed(1);
            const budgetMB = ((0, $50f569eac7e9a7b2$export$520fbecd11a75b1a) * 4 / 1048576).toFixed(1);
            console.warn(`IDW grid data exceeds budget (${usedMB}/${budgetMB} MB), ` + `processed ${processedCount}/${eligibleCount} contours (${pct}%)`);
            break;
        }
        if (gridSize > 100000) {
            const totalEdges = parentPoly.length + childPolygons.reduce((s, p)=>s + p.length, 0);
            console.log(`IDW grid: ${(gridSize * 4 / 1024).toFixed(0)} KB, ` + `${totalEdges} edges, ${childPolygons.length} children, ` + `${grid.entries.length} entries (${(grid.entries.length / totalEdges).toFixed(1)}x duplication)`);
        }
        processedCount++;
        // Record relative offset + 1 (so 0 remains "no grid" sentinel)
        const byteBase = dfsIndex * $7bf8a1354b31a70a$export$517cfe62b5c858e2 * 4;
        contourView.setUint32(byteBase + 52, idwGridTotalSize + 1, true);
        idwGridParts.push(grid.cellStarts);
        idwGridParts.push(grid.entries);
        idwGridTotalSize += gridSize;
    }
    // Assemble flat idwGridData
    const idwGridData = new Uint32Array(idwGridTotalSize);
    let idwWriteOffset = 0;
    for (const part of idwGridParts){
        idwGridData.set(part, idwWriteOffset);
        idwWriteOffset += part.length;
    }
    return {
        vertexData: vertexData,
        contourData: contourBuffer,
        childrenData: childrenData,
        containmentGridData: containmentGridData,
        idwGridData: idwGridData,
        lookupGridData: new Uint32Array(0),
        coastlineIndices: coastlineIndices,
        contourCount: contours.length,
        coastlineCount: coastlineIndices.length,
        maxDepth: tree.maxDepth,
        defaultDepth: definition.defaultDepth ?? (0, $50f569eac7e9a7b2$export$7f882bb969de14a3)
    };
}
function $7bf8a1354b31a70a$export$6375e47041b2104e(precomputed) {
    const contourView = new DataView(precomputed.contourData);
    const coastlineList = [];
    let maxDepth = 0;
    for(let i = 0; i < precomputed.contourCount; i++){
        const base = i * $7bf8a1354b31a70a$export$517cfe62b5c858e2 * 4;
        const height = contourView.getFloat32(base + 8, true);
        const depth = contourView.getUint32(base + 16, true);
        if (height === 0) coastlineList.push(i);
        if (depth > maxDepth) maxDepth = depth;
    }
    return {
        vertexData: precomputed.vertexData,
        contourData: precomputed.contourData,
        childrenData: precomputed.childrenData,
        containmentGridData: precomputed.containmentGridData,
        idwGridData: precomputed.idwGridData,
        lookupGridData: precomputed.lookupGridData,
        coastlineIndices: new Uint32Array(coastlineList),
        contourCount: precomputed.contourCount,
        coastlineCount: coastlineList.length,
        maxDepth: maxDepth,
        defaultDepth: precomputed.defaultDepth
    };
}



/**
 * Wave source configuration types and utilities.
 *
 * Defines the data structures for configuring wave sources in level files,
 * and provides utilities for converting between file format and GPU data.
 */ /**
 * A single wave source configuration.
 * These values define a Gerstner wave component.
 */ const $2f4d0b169c8eccfe$export$d483f8e31075937 = [
    // Single large swell - planar wave from the southwest (direction ~0.8 rad = ~45°)
    {
        amplitude: 0.4,
        wavelength: 200,
        direction: 0.8,
        phaseOffset: 0.0,
        speedMult: 1.0,
        sourceDist: 1e10,
        sourceOffsetX: 0,
        sourceOffsetY: 0
    },
    // Single chop wave - follows wind direction
    {
        amplitude: 0.15,
        wavelength: 20,
        direction: 0.8,
        phaseOffset: 0.0,
        speedMult: 1.0,
        sourceDist: 1e10,
        sourceOffsetX: 0,
        sourceOffsetY: 0
    }
];
const $2f4d0b169c8eccfe$export$483d573411d408a4 = {
    sources: $2f4d0b169c8eccfe$export$d483f8e31075937
};
function $2f4d0b169c8eccfe$export$6487fa7469de11cf(sources) {
    const data = new Float32Array(sources.length * 8);
    for(let i = 0; i < sources.length; i++){
        const wave = sources[i];
        data[i * 8 + 0] = wave.amplitude;
        data[i * 8 + 1] = wave.wavelength;
        data[i * 8 + 2] = wave.direction;
        data[i * 8 + 3] = wave.phaseOffset;
        data[i * 8 + 4] = wave.speedMult;
        data[i * 8 + 5] = wave.sourceDist;
        data[i * 8 + 6] = wave.sourceOffsetX;
        data[i * 8 + 7] = wave.sourceOffsetY;
    }
    return data;
}


/**
 * Wind source configuration types.
 *
 * Wind sources define directions for which terrain influence meshes
 * are precomputed. At runtime, each source has a weight (0-1) and
 * the shader blends all active sources' terrain influence values.
 */ /**
 * A single wind source — represents a wind direction for which
 * terrain influence has been precomputed.
 */ const $26798afcbef2eee0$export$513a719b51f9be3d = [
    {
        direction: Math.PI / 4
    }
];
const $26798afcbef2eee0$export$8a2743f6442658aa = {
    sources: $26798afcbef2eee0$export$513a719b51f9be3d
};


function $8da1130c1201b094$export$f80a896013adf696() {
    return {
        defaultDepth: (0, $50f569eac7e9a7b2$export$7f882bb969de14a3),
        contours: []
    };
}
function $8da1130c1201b094$export$e2ea29958e9cb879(definition) {
    const contours = definition.contours.map((c)=>(0, $7bf8a1354b31a70a$export$880ee1dc2e5da996)([
            ...c.controlPoints
        ], c.height));
    return {
        contours: contours,
        defaultDepth: definition.defaultDepth
    };
}
const $8da1130c1201b094$export$b5dd913340ad12ab = 2;
/** Magic number for binary terrain files: "TRRN" as little-endian u32. */ const $8da1130c1201b094$var$TERRAIN_MAGIC = 0x4e525254;
/** Number of u32 fields per contour in the binary format. */ const $8da1130c1201b094$var$BINARY_FLOATS_PER_CONTOUR = 14;
function $8da1130c1201b094$export$be5e3fd4d754c9c0(buffer) {
    const view = new DataView(buffer);
    const magic = view.getUint32(0, true);
    if (magic !== $8da1130c1201b094$var$TERRAIN_MAGIC) throw new Error(`Invalid terrain file: bad magic 0x${magic.toString(16)} (expected 0x${$8da1130c1201b094$var$TERRAIN_MAGIC.toString(16)})`);
    const version = view.getUint32(4, true);
    if (version !== 2 && version !== 3) throw new Error(`Unsupported terrain version: ${version} (expected 2 or 3)`);
    const defaultDepth = view.getFloat32(8, true);
    const contourCount = view.getUint32(12, true);
    const vertexCount = view.getUint32(16, true);
    const childrenCount = view.getUint32(20, true);
    const containmentGridU32s = view.getUint32(24, true);
    const idwGridU32s = view.getUint32(28, true);
    let lookupGridU32s = 0;
    let headerSize = 32;
    if (version >= 3) {
        lookupGridU32s = view.getUint32(32, true);
        headerSize = 36;
    }
    let offset = headerSize;
    // Section 1: contourData
    const contourBytes = contourCount * $8da1130c1201b094$var$BINARY_FLOATS_PER_CONTOUR * 4;
    const contourData = buffer.slice(offset, offset + contourBytes);
    offset += contourBytes;
    // Section 2: vertexData
    const vertexFloats = vertexCount * 2;
    const vertexData = new Float32Array(buffer, offset, vertexFloats);
    offset += vertexFloats * 4;
    // Section 3: childrenData
    const childrenData = new Uint32Array(buffer, offset, childrenCount);
    offset += childrenCount * 4;
    // Section 4: containmentGrid
    const containmentGridData = new Uint32Array(buffer, offset, containmentGridU32s);
    offset += containmentGridU32s * 4;
    // Section 5: idwGridData
    const idwGridData = new Uint32Array(buffer, offset, idwGridU32s);
    offset += idwGridU32s * 4;
    // Section 6: lookupGridData (v3 only)
    const lookupGridData = lookupGridU32s > 0 ? new Uint32Array(buffer, offset, lookupGridU32s) : new Uint32Array(0);
    // Reconstruct TerrainContourJSON[] for CPU-side TerrainDefinition
    const contourView = new DataView(contourData);
    const contours = [];
    for(let i = 0; i < contourCount; i++){
        const base = i * $8da1130c1201b094$var$BINARY_FLOATS_PER_CONTOUR * 4;
        const pointStart = contourView.getUint32(base + 0, true);
        const pointCount = contourView.getUint32(base + 4, true);
        const height = contourView.getFloat32(base + 8, true);
        const polygon = new Array(pointCount);
        for(let j = 0; j < pointCount; j++){
            const vi = (pointStart + j) * 2;
            polygon[j] = [
                vertexData[vi],
                vertexData[vi + 1]
            ];
        }
        contours.push({
            height: height,
            polygon: polygon
        });
    }
    return {
        terrainFile: {
            version: version,
            defaultDepth: defaultDepth,
            contours: contours
        },
        precomputedGPUData: {
            vertexData: vertexData,
            contourData: contourData,
            childrenData: childrenData,
            containmentGridData: containmentGridData,
            idwGridData: idwGridData,
            lookupGridData: lookupGridData,
            contourCount: contourCount,
            defaultDepth: defaultDepth
        }
    };
}
function $8da1130c1201b094$export$eedffde63d1e54fc(data) {
    if (!data || typeof data !== "object") throw new Error("Invalid level file: expected object");
    const file = data;
    if (typeof file.version !== "number") throw new Error("Invalid level file: missing or invalid version");
    if (file.version > $8da1130c1201b094$export$b5dd913340ad12ab) throw new Error(`Level file version ${file.version} is newer than supported version ${$8da1130c1201b094$export$b5dd913340ad12ab}`);
    // v2 allows region instead of inline contours
    if (file.version >= 2 && file.region != null) ;
    else if (!Array.isArray(file.contours)) throw new Error("Invalid level file: contours must be an array");
    // Validate contours if present
    const contours = Array.isArray(file.contours) ? file.contours : [];
    for(let i = 0; i < contours.length; i++){
        const contour = contours[i];
        if (!contour || typeof contour !== "object") throw new Error(`Invalid level file: contour ${i} is not an object`);
        if (typeof contour.height !== "number") throw new Error(`Invalid level file: contour ${i} missing height`);
        const points = contour.polygon ?? contour.controlPoints;
        const pointsKey = contour.polygon ? "polygon" : "controlPoints";
        if (!Array.isArray(points)) throw new Error(`Invalid level file: contour ${i} must have controlPoints or polygon array`);
        for(let j = 0; j < points.length; j++){
            const pt = points[j];
            if (!Array.isArray(pt) || pt.length !== 2) throw new Error(`Invalid level file: contour ${i} ${pointsKey}[${j}] must be [x, y]`);
            if (typeof pt[0] !== "number" || typeof pt[1] !== "number") throw new Error(`Invalid level file: contour ${i} ${pointsKey}[${j}] coordinates must be numbers`);
        }
    }
    // Validate waves if present
    if (file.waves !== undefined) {
        if (!file.waves || typeof file.waves !== "object") throw new Error("Invalid level file: waves must be an object");
        const waves = file.waves;
        if (!Array.isArray(waves.sources)) throw new Error("Invalid level file: waves.sources must be an array");
        for(let i = 0; i < waves.sources.length; i++){
            const source = waves.sources[i];
            if (!source || typeof source !== "object") throw new Error(`Invalid level file: wave source ${i} is not an object`);
            if (typeof source.amplitude !== "number") throw new Error(`Invalid level file: wave source ${i} missing amplitude`);
            if (typeof source.wavelength !== "number") throw new Error(`Invalid level file: wave source ${i} missing wavelength`);
            if (typeof source.direction !== "number") throw new Error(`Invalid level file: wave source ${i} missing direction`);
        }
    }
    // Validate wind if present
    if (file.wind !== undefined) {
        if (!file.wind || typeof file.wind !== "object") throw new Error("Invalid level file: wind must be an object");
        const wind = file.wind;
        if (!Array.isArray(wind.sources)) throw new Error("Invalid level file: wind.sources must be an array");
        for(let i = 0; i < wind.sources.length; i++){
            const source = wind.sources[i];
            if (!source || typeof source !== "object") throw new Error(`Invalid level file: wind source ${i} is not an object`);
            if (typeof source.direction !== "number") throw new Error(`Invalid level file: wind source ${i} missing direction`);
        }
    }
    // Validate ports if present
    if (file.ports !== undefined) {
        if (!Array.isArray(file.ports)) throw new Error("Invalid level file: ports must be an array");
        const portIds = new Set();
        for(let i = 0; i < file.ports.length; i++){
            const port = file.ports[i];
            if (!port || typeof port !== "object") throw new Error(`Invalid level file: port ${i} is not an object`);
            if (typeof port.id !== "string" || port.id.length === 0) throw new Error(`Invalid level file: port ${i} missing or empty id`);
            if (portIds.has(port.id)) throw new Error(`Invalid level file: duplicate port id "${port.id}"`);
            portIds.add(port.id);
            if (typeof port.name !== "string") throw new Error(`Invalid level file: port ${i} missing name`);
            if (!Array.isArray(port.position) || port.position.length !== 2 || typeof port.position[0] !== "number" || typeof port.position[1] !== "number") throw new Error(`Invalid level file: port ${i} position must be [x, y]`);
            if (typeof port.angle !== "number") throw new Error(`Invalid level file: port ${i} missing angle`);
        }
        // Validate startingPortId references a valid port
        if (typeof file.startingPortId === "string" && !portIds.has(file.startingPortId)) throw new Error(`Invalid level file: startingPortId "${file.startingPortId}" does not match any port id`);
    }
    // Validate missions if present
    if (file.missions !== undefined) {
        if (!Array.isArray(file.missions)) throw new Error("Invalid level file: missions must be an array");
        // Collect port IDs for cross-reference validation
        const portIds = new Set(Array.isArray(file.ports) ? file.ports.map((p)=>p.id) : []);
        const missionIds = new Set();
        for(let i = 0; i < file.missions.length; i++){
            const mission = file.missions[i];
            if (!mission || typeof mission !== "object") throw new Error(`Invalid level file: mission ${i} is not an object`);
            if (typeof mission.id !== "string" || mission.id.length === 0) throw new Error(`Invalid level file: mission ${i} missing or empty id`);
            if (missionIds.has(mission.id)) throw new Error(`Invalid level file: duplicate mission id "${mission.id}"`);
            missionIds.add(mission.id);
            if (typeof mission.name !== "string") throw new Error(`Invalid level file: mission ${i} missing name`);
            if (typeof mission.description !== "string") throw new Error(`Invalid level file: mission ${i} missing description`);
            if (mission.type !== "delivery") throw new Error(`Invalid level file: mission ${i} has invalid type "${mission.type}" (expected "delivery")`);
            if (typeof mission.sourcePortId !== "string") throw new Error(`Invalid level file: mission ${i} missing sourcePortId`);
            if (portIds.size > 0 && !portIds.has(mission.sourcePortId)) throw new Error(`Invalid level file: mission ${i} sourcePortId "${mission.sourcePortId}" does not match any port id`);
            if (typeof mission.destinationPortId !== "string") throw new Error(`Invalid level file: mission ${i} missing destinationPortId`);
            if (portIds.size > 0 && !portIds.has(mission.destinationPortId)) throw new Error(`Invalid level file: mission ${i} destinationPortId "${mission.destinationPortId}" does not match any port id`);
            if (mission.prerequisites != null && typeof mission.prerequisites !== "object") throw new Error(`Invalid level file: mission ${i} prerequisites must be an object`);
            if (mission.rewards != null && typeof mission.rewards !== "object") throw new Error(`Invalid level file: mission ${i} rewards must be an object`);
        }
    }
    return file;
}
/**
 * Convert wave source JSON to game WaveSource.
 */ function $8da1130c1201b094$var$waveSourceJSONToWaveSource(json) {
    return {
        amplitude: json.amplitude,
        wavelength: json.wavelength,
        direction: json.direction,
        phaseOffset: json.phaseOffset ?? 0,
        speedMult: json.speedMult ?? 1.0,
        sourceDist: json.sourceDist ?? 1e10,
        sourceOffsetX: json.sourceOffsetX ?? 0,
        sourceOffsetY: json.sourceOffsetY ?? 0
    };
}
function $8da1130c1201b094$export$e75908bc8efe11c5(json) {
    return {
        sources: json.sources.map($8da1130c1201b094$var$waveSourceJSONToWaveSource)
    };
}
function $8da1130c1201b094$export$b675d469325b3e07(file) {
    const contours = (file.contours ?? []).map((c)=>{
        if (c.polygon) {
            const points = c.polygon.map(([x, y])=>(0, $6b6a54a072724620$export$e7c866399fa523f5)(x, y));
            return (0, $7bf8a1354b31a70a$export$ad18007d2f30bf91)(points, c.height);
        }
        const controlPoints = c.controlPoints.map(([x, y])=>(0, $6b6a54a072724620$export$e7c866399fa523f5)(x, y));
        return (0, $7bf8a1354b31a70a$export$880ee1dc2e5da996)(controlPoints, c.height);
    });
    return {
        contours: contours,
        defaultDepth: file.defaultDepth ?? (0, $50f569eac7e9a7b2$export$7f882bb969de14a3)
    };
}
function $8da1130c1201b094$export$15fac602098629f1(file) {
    if (!file.waves) return 0, $2f4d0b169c8eccfe$export$483d573411d408a4;
    return $8da1130c1201b094$export$e75908bc8efe11c5(file.waves);
}
function $8da1130c1201b094$export$58746aba8ebb0fa4(data) {
    if (!data || typeof data !== "object") throw new Error("Invalid terrain file: expected object");
    const file = data;
    if (!Array.isArray(file.contours)) throw new Error("Invalid terrain file: contours must be an array");
    return file;
}
function $8da1130c1201b094$export$3c1e04e04af02178(file) {
    if (!file.wind) return 0, $26798afcbef2eee0$export$8a2743f6442658aa;
    return {
        sources: file.wind.sources.map((s)=>({
                direction: s.direction
            }))
    };
}
/**
 * Convert port JSON to runtime PortData.
 */ function $8da1130c1201b094$var$portJSONToPortData(json) {
    return {
        id: json.id,
        name: json.name,
        position: (0, $6b6a54a072724620$export$e7c866399fa523f5)(json.position[0], json.position[1]),
        angle: json.angle
    };
}
/**
 * Convert mission def JSON to runtime MissionDef.
 */ function $8da1130c1201b094$var$missionDefJSONToMissionDef(json) {
    return {
        id: json.id,
        name: json.name,
        description: json.description,
        type: json.type,
        sourcePortId: json.sourcePortId,
        destinationPortId: json.destinationPortId,
        prerequisites: {
            ...json.prerequisites.completedMissions && {
                completedMissions: [
                    ...json.prerequisites.completedMissions
                ]
            },
            ...json.prerequisites.money != null && {
                money: json.prerequisites.money
            }
        },
        rewards: {
            ...json.rewards.money != null && {
                money: json.rewards.money
            },
            ...json.rewards.revealPorts && {
                revealPorts: [
                    ...json.rewards.revealPorts
                ]
            }
        }
    };
}
function $8da1130c1201b094$export$944abe0e4124bb99(file) {
    return {
        name: file.name,
        terrain: $8da1130c1201b094$export$b675d469325b3e07(file),
        waves: $8da1130c1201b094$export$15fac602098629f1(file),
        wind: $8da1130c1201b094$export$3c1e04e04af02178(file),
        biome: file.biome,
        startPosition: file.startPosition ? (0, $6b6a54a072724620$export$e7c866399fa523f5)(file.startPosition[0], file.startPosition[1]) : undefined,
        startingPortId: file.startingPortId,
        ports: file.ports?.map($8da1130c1201b094$var$portJSONToPortData),
        missions: file.missions?.map($8da1130c1201b094$var$missionDefJSONToMissionDef)
    };
}
function $8da1130c1201b094$export$716ae48b23abd61f(config) {
    return {
        sources: config.sources.map((source)=>({
                amplitude: source.amplitude,
                wavelength: source.wavelength,
                direction: source.direction,
                // Only include optional fields if they differ from defaults
                ...source.phaseOffset !== 0 && {
                    phaseOffset: source.phaseOffset
                },
                ...source.speedMult !== 1.0 && {
                    speedMult: source.speedMult
                },
                ...source.sourceDist !== 1e10 && {
                    sourceDist: source.sourceDist
                },
                ...source.sourceOffsetX !== 0 && {
                    sourceOffsetX: source.sourceOffsetX
                },
                ...source.sourceOffsetY !== 0 && {
                    sourceOffsetY: source.sourceOffsetY
                }
            }))
    };
}
function $8da1130c1201b094$export$5ed81bdc048e4469(config) {
    return {
        sources: config.sources.map((source)=>({
                direction: source.direction
            }))
    };
}
function $8da1130c1201b094$export$a2c0771c3e10f63a(json) {
    const data = JSON.parse(json);
    return $8da1130c1201b094$export$eedffde63d1e54fc(data);
}
function $8da1130c1201b094$export$903c1e7e27fdae26(file) {
    const contours = (file.contours ?? []).map((c)=>{
        const points = c.polygon ?? c.controlPoints;
        const controlPoints = points.map(([x, y])=>(0, $6b6a54a072724620$export$e7c866399fa523f5)(x, y));
        return {
            name: c.name,
            controlPoints: controlPoints,
            height: c.height
        };
    });
    return {
        terrain: {
            defaultDepth: file.defaultDepth ?? (0, $50f569eac7e9a7b2$export$7f882bb969de14a3),
            contours: contours
        },
        waveConfig: file.waves ? $8da1130c1201b094$export$e75908bc8efe11c5(file.waves) : undefined,
        windConfig: file.wind ? $8da1130c1201b094$export$3c1e04e04af02178({
            wind: file.wind
        }) : undefined,
        biome: file.biome
    };
}
function $8da1130c1201b094$export$f2fed66f2961808(definition) {
    const contours = definition.terrain.contours.map((c)=>({
            name: c.name,
            height: c.height,
            controlPoints: c.controlPoints.map((pt)=>[
                    pt.x,
                    pt.y
                ])
        }));
    return {
        version: $8da1130c1201b094$export$b5dd913340ad12ab,
        defaultDepth: definition.terrain.defaultDepth,
        ...definition.waveConfig && {
            waves: $8da1130c1201b094$export$716ae48b23abd61f(definition.waveConfig)
        },
        ...definition.windConfig && {
            wind: $8da1130c1201b094$export$5ed81bdc048e4469(definition.windConfig)
        },
        ...definition.biome && {
            biome: definition.biome
        },
        contours: contours
    };
}
function $8da1130c1201b094$export$927ac37b95995e12(file) {
    return JSON.stringify(file, null, 2);
}


/**
 * Resolve terrain references in a v2 level file.
 * If the level has a region config, fetch and merge the binary terrain data.
 * Returns the updated file and any precomputed GPU data.
 */ async function $375e214684cd760f$var$resolveTerrainReference(file, levelName) {
    if (!file.region) return {
        file: file,
        precomputedGPUData: undefined
    };
    const terrainKey = levelName;
    const terrainUrl = (0, $bcae27952f7958f2$export$4e841128923ef26).terrains[terrainKey];
    if (!terrainUrl) throw new Error(`Terrain binary for level "${levelName}" not found in resources`);
    const response = await fetch(terrainUrl);
    if (!response.ok) throw new Error(`Failed to fetch terrain: ${response.status} ${terrainUrl}`);
    const buffer = await response.arrayBuffer();
    const result = (0, $8da1130c1201b094$export$be5e3fd4d754c9c0)(buffer);
    return {
        file: {
            ...file,
            defaultDepth: file.defaultDepth ?? result.terrainFile.defaultDepth,
            contours: result.terrainFile.contours
        },
        precomputedGPUData: result.precomputedGPUData
    };
}
async function $375e214684cd760f$export$8394cb0148a08968(levelName) {
    const rawFile = (0, $8da1130c1201b094$export$eedffde63d1e54fc)((0, $bcae27952f7958f2$export$4e841128923ef26).levels[levelName]);
    const { file: file, precomputedGPUData: precomputedGPUData } = await $375e214684cd760f$var$resolveTerrainReference(rawFile, levelName);
    const levelData = (0, $8da1130c1201b094$export$944abe0e4124bb99)(file);
    if (precomputedGPUData) levelData.terrain.precomputedGPUData = precomputedGPUData;
    let wavemeshData;
    const wavemeshUrl = (0, $bcae27952f7958f2$export$4e841128923ef26).wavemeshes[levelName];
    if (wavemeshUrl) try {
        wavemeshData = await (0, $8087c7d7facda7c5$export$773c3b94603a3349)(wavemeshUrl);
        console.log(`[LevelLoader] Loaded prebuilt wavemesh for "${levelName}" (${wavemeshData.length} meshes)`);
    } catch (e) {
        console.error(`[LevelLoader] Failed to load wavemesh for "${levelName}":`, e);
    }
    else console.warn(`[LevelLoader] No wavemesh found for "${levelName}" \u{2014} run 'npm run build-wavemesh' to generate it`);
    let windmeshData;
    const windmeshUrl = (0, $bcae27952f7958f2$export$4e841128923ef26).windmeshes[levelName];
    if (windmeshUrl) try {
        windmeshData = await (0, $155c9a05e59a886f$export$9135b7975b4a291a)(windmeshUrl);
        console.log(`[LevelLoader] Loaded prebuilt windmesh for "${levelName}" (${windmeshData.sourceCount} sources)`);
    } catch (e) {
        console.error(`[LevelLoader] Failed to load windmesh for "${levelName}":`, e);
    }
    let treeData;
    const treesUrl = (0, $bcae27952f7958f2$export$4e841128923ef26).trees[levelName];
    if (treesUrl) try {
        treeData = await (0, $33442a3a058c3ed6$export$90aefa3a77ac044d)(treesUrl);
        console.log(`[LevelLoader] Loaded tree data for "${levelName}" (${treeData.positions.length} trees)`);
    } catch (e) {
        console.error(`[LevelLoader] Failed to load tree data for "${levelName}":`, e);
    }
    return {
        ...levelData,
        wavemeshData: wavemeshData,
        windmeshData: windmeshData,
        treeData: treeData
    };
}
async function $375e214684cd760f$export$1e7511c851341891() {
    const rawFile = (0, $8da1130c1201b094$export$eedffde63d1e54fc)((0, $bcae27952f7958f2$export$4e841128923ef26).levels.default);
    const { file: file } = await $375e214684cd760f$var$resolveTerrainReference(rawFile, "default");
    return (0, $8da1130c1201b094$export$903c1e7e27fdae26)(file);
}
async function $375e214684cd760f$export$fb8db57e535c6768(file) {
    const json = await file.text();
    const parsed = (0, $8da1130c1201b094$export$a2c0771c3e10f63a)(json);
    return (0, $8da1130c1201b094$export$903c1e7e27fdae26)(parsed);
}














/** Utility functions for doing things based on random numbers. */ // just for shorthand
const $f1ed8354ebe33615$var$r = Math.random;
function $f1ed8354ebe33615$export$1ab1062261c98efe(min, max) {
    if (min === undefined) return $f1ed8354ebe33615$var$r();
    if (max === undefined) {
        max = min;
        min = 0;
    }
    return (max - min) * $f1ed8354ebe33615$var$r() + min;
}
function $f1ed8354ebe33615$export$6c5277ffd5bb6b0b() {
    return $f1ed8354ebe33615$export$1ab1062261c98efe(0, Math.PI * 2);
}
function $f1ed8354ebe33615$export$d2675ab7bc8f0cd4() {
    return $f1ed8354ebe33615$export$7877a478dd30fd3d(0, Math.PI / 2, Math.PI, 3 * Math.PI / 2);
}
function $f1ed8354ebe33615$export$4dc4a801a9bb2c7e(mean = 0.0, deviation = 1.0) {
    return deviation * ($f1ed8354ebe33615$var$r() + $f1ed8354ebe33615$var$r() + $f1ed8354ebe33615$var$r() + $f1ed8354ebe33615$var$r() + $f1ed8354ebe33615$var$r() + $f1ed8354ebe33615$var$r() - 3) / 3 + mean;
}
function $f1ed8354ebe33615$export$e0c4b1630ec012c1(chanceOfTrue = 0.5) {
    return $f1ed8354ebe33615$var$r() < chanceOfTrue;
}
function $f1ed8354ebe33615$export$e8015c10d27df017(chanceOfPositive = 0.5) {
    return $f1ed8354ebe33615$export$e0c4b1630ec012c1(chanceOfPositive) ? 1 : -1;
}
function $f1ed8354ebe33615$export$4b740f64b13739ef(min, max) {
    return Math.floor($f1ed8354ebe33615$export$1ab1062261c98efe(min, max));
}
function $f1ed8354ebe33615$export$73b235628570e6fd() {
    return $f1ed8354ebe33615$export$4b740f64b13739ef(0, 256);
}
function $f1ed8354ebe33615$export$9f5ea5e22d955aad(x) {
    const low = Math.floor(x);
    return $f1ed8354ebe33615$export$e0c4b1630ec012c1(x - low) ? low : low + 1;
}
function $f1ed8354ebe33615$export$7877a478dd30fd3d(...options) {
    return options[$f1ed8354ebe33615$export$4b740f64b13739ef(0, options.length)];
}
function $f1ed8354ebe33615$export$b7df5d561049483a(options) {
    return options.splice($f1ed8354ebe33615$export$4b740f64b13739ef(0, options.length), 1)[0];
}
function $f1ed8354ebe33615$export$448332262467e042(a) {
    let i, j;
    i = a.length;
    while(--i > 0){
        j = $f1ed8354ebe33615$export$4b740f64b13739ef(0, i + 1);
        [a[i], a[j]] = [
            a[j],
            a[i]
        ];
    }
    return a;
}
function $f1ed8354ebe33615$export$9292fb87b153dc08(a, seed) {
    let i, j, temp;
    i = a.length;
    while(--i > 0){
        seed = seed * 1103515245 + 12345 | 0;
        j = (0, $2172aedd5a25ff17$export$842a2cf37af977e1)(seed, i + 1);
        temp = a[j];
        a[j] = a[i];
        a[i] = temp;
    }
    return a;
}
function $f1ed8354ebe33615$export$8a254833e92ed41(items, getWeight) {
    if (items.length === 0) throw new Error("No items to choose from");
    // Calculate total weight
    let totalWeight = 0;
    for (const item of items){
        const weight = getWeight(item);
        if (weight < 0) throw new Error("Weight must be >= 0");
        totalWeight += weight;
    }
    if (totalWeight <= 0) throw new Error("Total weight must be > 0");
    // Pick random point in weight space
    let pick = $f1ed8354ebe33615$var$r() * totalWeight;
    for (const item of items){
        pick -= getWeight(item);
        if (pick <= 0) return item;
    }
    // Fallback for floating point edge cases
    return items[items.length - 1];
}
class $f1ed8354ebe33615$export$512e060e7e15fe56 {
    constructor(items){
        this.items = [];
        this.weights = [];
        this.cumulative = [];
        this.itemToIndex = new Map();
        this.dirty = false;
        this._totalWeight = 0;
        if (items) for (const [item, weight] of items)this.add(item, weight);
    }
    /** Add an item with its weight. Weight must be >= 0. */ add(item, weight) {
        if (weight < 0) throw new Error("Weight must be >= 0");
        if (this.itemToIndex.has(item)) throw new Error("Item already exists in selector");
        const index = this.items.length;
        this.items.push(item);
        this.weights.push(weight);
        this.itemToIndex.set(item, index);
        this._totalWeight += weight;
        this.dirty = true;
        return this;
    }
    /** Remove an item from the selector. */ remove(item) {
        const index = this.itemToIndex.get(item);
        if (index === undefined) throw new Error("Item not found in selector");
        this._totalWeight -= this.weights[index];
        // Swap with last element for O(1) removal
        const lastIndex = this.items.length - 1;
        if (index !== lastIndex) {
            const lastItem = this.items[lastIndex];
            this.items[index] = lastItem;
            this.weights[index] = this.weights[lastIndex];
            this.itemToIndex.set(lastItem, index);
        }
        this.items.pop();
        this.weights.pop();
        this.itemToIndex.delete(item);
        this.dirty = true;
        return this;
    }
    /** Remove all items from the selector. */ clear() {
        this.items = [];
        this.weights = [];
        this.cumulative = [];
        this.itemToIndex.clear();
        this._totalWeight = 0;
        this.dirty = false;
        return this;
    }
    /** Pick a random item weighted by the stored weights. Returns undefined if empty. */ pick() {
        if (this.items.length === 0) return undefined;
        if (this._totalWeight <= 0) return undefined;
        if (this.dirty) this.rebuild();
        const target = $f1ed8354ebe33615$var$r() * this._totalWeight;
        // Binary search for first cumulative > target
        let low = 0;
        let high = this.cumulative.length - 1;
        while(low < high){
            const mid = low + high >>> 1;
            if (this.cumulative[mid] <= target) low = mid + 1;
            else high = mid;
        }
        return this.items[low];
    }
    /** The number of items in the selector. */ get size() {
        return this.items.length;
    }
    /** The total weight of all items. */ get totalWeight() {
        return this._totalWeight;
    }
    rebuild() {
        this.cumulative.length = this.weights.length;
        let sum = 0;
        for(let i = 0; i < this.weights.length; i++){
            sum += this.weights[i];
            this.cumulative[i] = sum;
        }
        this.dirty = false;
    }
}


class $059518e50ce5c25e$export$9df2da69341d6f5a extends (0, $c59361981bac2575$export$4342ba5c6ad1f6f1) {
    set speed(value) {
        this._speed = value;
        this.updatePlaybackRate();
    }
    get speed() {
        return this._speed;
    }
    set pan(value) {
        if (!this.isAdded) this.options.pan = value;
        else this.panNode.pan.value = value;
    }
    get pan() {
        if (!this.isAdded) return this.options.pan ?? 0;
        else return this.panNode.pan.value;
    }
    set gain(value) {
        if (!this.isAdded) this.options.gain = value;
        else this.gainNode.gain.value = value;
    }
    get gain() {
        if (!this.isAdded) return this.options.gain ?? 1;
        else return this.gainNode.gain.value;
    }
    constructor(soundName, options = {}){
        super(), this.soundName = soundName, this.options = options, this.tags = [
            "sound"
        ], this._speed = 1.0, this.elapsed = 0, this.lastTick = 0, this.paused = false;
        this.speed = options.speed ?? 1.0;
        this.continuous = options.continuous ?? false;
        this.reactToSlowMo = options.reactToSlowMo ?? true;
        this.persistenceLevel = options.persistenceLevel ?? 0;
        this.pausable = options.pauseable ?? true;
        if (!(0, $ccca576b723d73ff$export$ac84dee4d6d87cfb)(soundName)) throw new Error(`Unloaded Sound ${soundName}`);
        this._promise = new Promise((resolve)=>{
            this._resolve = resolve;
        });
    }
    onAdd({ game: game }) {
        const chain = this.makeChain(game);
        if (this.options.outnode) chain.connect(this.options.outnode());
        else chain.connect(game.masterGain);
        this.sourceNode.onended = ()=>{
            if (!this.paused) this.destroy();
        };
        this.lastTick = game.audio.currentTime;
        const startTime = this.options.randomStart ? (0, $f1ed8354ebe33615$export$1ab1062261c98efe)(0, this.sourceNode.buffer.duration * 0.99) : undefined;
        this.sourceNode.start(startTime);
    }
    /** Creates the  */ makeChain({ audio: audio, slowMo: slowMo }) {
        this.sourceNode = audio.createBufferSource();
        this.sourceNode.buffer = (0, $ccca576b723d73ff$export$4addc79a408174e5)(this.soundName);
        this.sourceNode.loop = this.continuous;
        if (this.reactToSlowMo) this.sourceNode.playbackRate.value = this._speed * slowMo;
        else this.sourceNode.playbackRate.value = this._speed;
        this.panNode = audio.createStereoPanner();
        this.panNode.pan.value = this.options.pan ?? 0.0;
        this.gainNode = audio.createGain();
        this.gainNode.gain.value = this.options.gain ?? 1.0;
        this.sourceNode.connect(this.panNode);
        this.panNode.connect(this.gainNode);
        return this.gainNode;
    }
    async waitTillEnded() {
        if (this.continuous) throw new Error("Can't wait for end of continuous sound");
        return this._promise;
    }
    onTick() {
        const now = this.game.audio.currentTime;
        this.elapsed += (now - this.lastTick) * this.sourceNode.playbackRate.value;
        if (this.continuous) this.elapsed = this.elapsed % this.sourceNode.buffer.duration;
        this.lastTick = now;
    }
    updatePlaybackRate() {
        if (this.sourceNode && this.game) {
            if (this.reactToSlowMo) this.sourceNode.playbackRate.value = this._speed * this.game.slowMo;
            else this.sourceNode.playbackRate.value = this._speed;
        }
    }
    onSlowMoChanged() {
        this.updatePlaybackRate();
    }
    pause() {
        if (this.pausable) {
            this.paused = true;
            this.sourceNode.onended = null;
            this.sourceNode.stop();
        }
    }
    unpause() {
        if (this.paused) {
            this.paused = false;
            const bufferDuration = this.sourceNode.buffer.duration;
            if (!this.continuous && this.elapsed >= bufferDuration) this.destroy();
            else this.restartSound(this.elapsed % bufferDuration);
        }
    }
    restartSound(startTime) {
        this.sourceNode.disconnect();
        const newNode = this.game.audio.createBufferSource();
        newNode.buffer = this.sourceNode.buffer;
        newNode.loop = this.sourceNode.loop;
        this.sourceNode = newNode;
        this.sourceNode.connect(this.panNode);
        this.sourceNode.start(this.game.audio.currentTime, (0, $2172aedd5a25ff17$export$7d15b64cf5a3a4c4)(startTime, 0, this.sourceNode.buffer.duration));
    }
    jumpToRandom() {
        this.restartSound((0, $f1ed8354ebe33615$export$1ab1062261c98efe)(0, this.sourceNode.buffer.duration * 0.99));
    }
    onPause() {
        this.pause();
    }
    onUnpause() {
        this.unpause();
    }
    onDestroy() {
        this.sourceNode.stop();
        this._resolve();
    }
}
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $aa1f0309d9dba6d2$export$af631764ddc44097)("add")
], $059518e50ce5c25e$export$9df2da69341d6f5a.prototype, "onAdd", null);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $aa1f0309d9dba6d2$export$af631764ddc44097)("tick")
], $059518e50ce5c25e$export$9df2da69341d6f5a.prototype, "onTick", null);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $aa1f0309d9dba6d2$export$af631764ddc44097)("slowMoChanged")
], $059518e50ce5c25e$export$9df2da69341d6f5a.prototype, "onSlowMoChanged", null);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $aa1f0309d9dba6d2$export$af631764ddc44097)("pause")
], $059518e50ce5c25e$export$9df2da69341d6f5a.prototype, "onPause", null);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $aa1f0309d9dba6d2$export$af631764ddc44097)("unpause")
], $059518e50ce5c25e$export$9df2da69341d6f5a.prototype, "onUnpause", null);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $aa1f0309d9dba6d2$export$af631764ddc44097)("destroy")
], $059518e50ce5c25e$export$9df2da69341d6f5a.prototype, "onDestroy", null);




/**
 * Hull mesh builder from station-based cross-section profiles.
 *
 * Takes a HullShape (stations with y-z half-profiles) and produces a HullMesh
 * with classified triangle index lists, matching the interface expected by Hull.ts.
 *
 * Pipeline:
 *   1. Resample each station's profile via Catmull-Rom spline → uniform arc-length points
 *   2. Mirror starboard half-profiles to full cross-sections
 *   3. Interpolate subdivided stations between defined stations (Catmull-Rom along x)
 *   4. Loft adjacent cross-sections into quad strips
 *   5. Cap the deck with ear-clip triangulation
 *   6. Classify triangles by centroid z-height
 *   7. Extract deck outline for gunwale rendering
 */ 
// --------------------------------------------------------------------
// Catmull-Rom spline evaluation
// --------------------------------------------------------------------
/**
 * Evaluate a Catmull-Rom spline at parameter t in [0, 1] between p1 and p2,
 * using p0 and p3 as neighboring control points. Standard centripetal form
 * with alpha = 0 (uniform parameterization — simpler and sufficient here
 * since we resample to arc length anyway).
 */ function $779a9fe58269ee84$var$catmullRom(p0y, p0z, p1y, p1z, p2y, p2z, p3y, p3z, t) {
    const t2 = t * t;
    const t3 = t2 * t;
    // Catmull-Rom basis (tau = 0.5)
    const y = 0.5 * ((-p0y + 3 * p1y - 3 * p2y + p3y) * t3 + (2 * p0y - 5 * p1y + 4 * p2y - p3y) * t2 + (-p0y + p2y) * t + 2 * p1y);
    const z = 0.5 * ((-p0z + 3 * p1z - 3 * p2z + p3z) * t3 + (2 * p0z - 5 * p1z + 4 * p2z - p3z) * t2 + (-p0z + p2z) * t + 2 * p1z);
    return [
        y,
        z
    ];
}
/**
 * Evaluate Catmull-Rom for a 1D value (used for scalar x interpolation between stations).
 */ function $779a9fe58269ee84$var$catmullRom1D(v0, v1, v2, v3, t) {
    const t2 = t * t;
    const t3 = t2 * t;
    return 0.5 * ((-v0 + 3 * v1 - 3 * v2 + v3) * t3 + (2 * v0 - 5 * v1 + 4 * v2 - v3) * t2 + (-v0 + v2) * t + 2 * v1);
}
// --------------------------------------------------------------------
// Profile resampling
// --------------------------------------------------------------------
/**
 * Resample a half-profile's control points into `count` uniformly-spaced
 * points along the arc length using Catmull-Rom interpolation.
 *
 * Returns [y, z] pairs from keel (first point) to gunwale (last point).
 * A single-point profile (bow collapse) returns `count` copies of that point.
 */ function $779a9fe58269ee84$var$resampleProfile(profile, count) {
    const n = profile.length;
    // Degenerate: single point (bow tip). Return identical copies.
    if (n === 1) {
        const pt = [
            profile[0][0],
            profile[0][1]
        ];
        return Array.from({
            length: count
        }, ()=>[
                pt[0],
                pt[1]
            ]);
    }
    // Two-point profile: straight line, no spline needed.
    if (n === 2) {
        const out = [];
        for(let i = 0; i < count; i++){
            const t = i / (count - 1);
            out.push([
                profile[0][0] + (profile[1][0] - profile[0][0]) * t,
                profile[0][1] + (profile[1][1] - profile[0][1]) * t
            ]);
        }
        return out;
    }
    // Step 1: densely sample the Catmull-Rom spline to measure arc length.
    const DENSE = 256;
    const dense = [];
    const segments = n - 1;
    for(let seg = 0; seg < segments; seg++){
        const samplesInSeg = seg === segments - 1 ? DENSE + 1 : DENSE;
        for(let s = 0; s < samplesInSeg; s++){
            const t = s / DENSE;
            // Clamp neighbor indices for endpoint tangents
            const i0 = Math.max(0, seg - 1);
            const i1 = seg;
            const i2 = Math.min(n - 1, seg + 1);
            const i3 = Math.min(n - 1, seg + 2);
            dense.push($779a9fe58269ee84$var$catmullRom(profile[i0][0], profile[i0][1], profile[i1][0], profile[i1][1], profile[i2][0], profile[i2][1], profile[i3][0], profile[i3][1], t));
        }
    }
    // Step 2: compute cumulative arc lengths along the dense samples.
    const arcLengths = new Float64Array(dense.length);
    arcLengths[0] = 0;
    for(let i = 1; i < dense.length; i++){
        const dy = dense[i][0] - dense[i - 1][0];
        const dz = dense[i][1] - dense[i - 1][1];
        arcLengths[i] = arcLengths[i - 1] + Math.sqrt(dy * dy + dz * dz);
    }
    const totalLength = arcLengths[dense.length - 1];
    // Step 3: walk the arc-length table to produce uniformly spaced samples.
    const out = [];
    let cursor = 0;
    for(let i = 0; i < count; i++){
        const targetLen = i / (count - 1) * totalLength;
        // Advance cursor until we bracket the target length
        while(cursor < dense.length - 2 && arcLengths[cursor + 1] < targetLen)cursor++;
        const segLen = arcLengths[cursor + 1] - arcLengths[cursor];
        const localT = segLen > 1e-12 ? (targetLen - arcLengths[cursor]) / segLen : 0;
        out.push([
            dense[cursor][0] + (dense[cursor + 1][0] - dense[cursor][0]) * localT,
            dense[cursor][1] + (dense[cursor + 1][1] - dense[cursor][1]) * localT
        ]);
    }
    return out;
}
// --------------------------------------------------------------------
// Station interpolation along the hull length
// --------------------------------------------------------------------
/**
 * Given an array of resampled station profiles (each M points), interpolate
 * `subdivisions` new stations between each adjacent pair using Catmull-Rom
 * in the x-direction, and per-profile-point Catmull-Rom in y-z.
 *
 * Returns the full array of station cross-sections including originals.
 * Each entry: { x, profile: [y, z][] }.
 *
 * sharpSet contains indices of original stations that should not be smoothed
 * past — the interpolated stations still appear, but the sharp station's
 * profile is kept exact (no tangent blending past it).
 */ function $779a9fe58269ee84$var$interpolateStations(stations, subdivisions, sharpSet) {
    if (subdivisions <= 0 || stations.length < 2) return stations.map((s)=>({
            x: s.x,
            profile: s.profile.map(([y, z])=>[
                    y,
                    z
                ])
        }));
    const n = stations.length;
    const M = stations[0].profile.length; // all profiles same size
    const result = [];
    for(let i = 0; i < n - 1; i++){
        // Neighbor stations for Catmull-Rom tangent computation.
        // Clamp at endpoints; sharp stations act as tangent barriers.
        const i0 = sharpSet.has(i) ? i : Math.max(0, i - 1);
        const i1 = i;
        const i2 = i + 1;
        const i3 = sharpSet.has(i + 1) ? i + 1 : Math.min(n - 1, i + 2);
        const s0 = stations[i0];
        const s1 = stations[i1];
        const s2 = stations[i2];
        const s3 = stations[i3];
        // Emit the original station
        result.push({
            x: s1.x,
            profile: s1.profile.map(([y, z])=>[
                    y,
                    z
                ])
        });
        // Emit subdivided intermediate stations
        for(let sub = 1; sub <= subdivisions; sub++){
            if (sub === subdivisions && i < n - 2) continue;
            if (sub === subdivisions) break;
            const t = sub / subdivisions;
            // Clamp x to the segment range to prevent Catmull-Rom overshoot
            // past the stern or bow. This avoids concave hull outlines that
            // break Sutherland-Hodgman polygon clipping.
            const xRaw = $779a9fe58269ee84$var$catmullRom1D(s0.x, s1.x, s2.x, s3.x, t);
            const xMin = Math.min(s1.x, s2.x);
            const xMax = Math.max(s1.x, s2.x);
            const x = Math.max(xMin, Math.min(xMax, xRaw));
            const profile = [];
            for(let m = 0; m < M; m++){
                const [y, z] = $779a9fe58269ee84$var$catmullRom(s0.profile[m][0], s0.profile[m][1], s1.profile[m][0], s1.profile[m][1], s2.profile[m][0], s2.profile[m][1], s3.profile[m][0], s3.profile[m][1], t);
                profile.push([
                    y,
                    z
                ]);
            }
            result.push({
                x: x,
                profile: profile
            });
        }
    }
    // Emit the final station
    const last = stations[n - 1];
    result.push({
        x: last.x,
        profile: last.profile.map(([y, z])=>[
                y,
                z
            ])
    });
    return result;
}
// --------------------------------------------------------------------
// Mirror a half-profile to a full cross-section
// --------------------------------------------------------------------
/**
 * Take a starboard half-profile [y, z] (y >= 0) and produce the full
 * cross-section as [y, z] pairs going:
 *   starboard gunwale → ... → keel center → ... → port gunwale
 *
 * The keel center (first profile point, y ≈ 0) appears once.
 * Port points are mirrored (y negated), reversed so the cross-section
 * traces a continuous U shape.
 *
 * Returns the mirrored profile and the index of the keel-center vertex
 * within the full ring, plus the ring size.
 */ function $779a9fe58269ee84$var$mirrorProfile(halfProfile) {
    const n = halfProfile.length;
    // Full cross-section: port gunwale (reversed, y < 0) → keel → starboard gunwale
    // We go: starboard gunwale ... keel ... port gunwale
    // That is: halfProfile reversed (gunwale→keel), then port side (keel→gunwale) minus keel duplicate
    // Starboard side: from gunwale (last) down to keel (first)
    const full = [];
    for(let i = n - 1; i >= 0; i--)full.push([
        halfProfile[i][0],
        halfProfile[i][1]
    ]);
    // Port side: mirror from second point (skip keel duplicate) up to gunwale
    for(let i = 1; i < n; i++)full.push([
        -halfProfile[i][0],
        halfProfile[i][1]
    ]);
    return full;
}
// --------------------------------------------------------------------
// Detect whether a profile has collapsed to (near) a point
// --------------------------------------------------------------------
function $779a9fe58269ee84$var$isCollapsedProfile(profile) {
    let maxY = 0;
    for (const [y] of profile){
        const absY = Math.abs(y);
        if (absY > maxY) maxY = absY;
    }
    return maxY < 1e-4; // effectively zero beam
}
function $779a9fe58269ee84$export$da258e5b085eea85(mesh, targetZ) {
    const { xyPositions: xyPositions, zValues: zValues, ringSize: ringSize } = mesh;
    const totalVerts = xyPositions.length;
    const numStations = totalVerts / ringSize;
    // Half-profile point count (starboard side including keel center)
    const halfM = (ringSize + 1) / 2;
    // For each station, find the starboard beam at targetZ
    const starboardPoints = [];
    for(let si = 0; si < numStations; si++){
        const base = si * ringSize;
        const stationX = xyPositions[base][0];
        const gunwaleZ = zValues[base]; // vertex 0 = starboard gunwale (highest z)
        const keelZ = zValues[base + halfM - 1]; // keel center (lowest z)
        if (targetZ >= gunwaleZ) {
            // Zone at or above gunwale — use full gunwale beam
            starboardPoints.push([
                stationX,
                xyPositions[base][1]
            ]);
            continue;
        }
        if (targetZ <= keelZ) continue;
        // Walk starboard half from gunwale (high z) to keel (low z),
        // find first segment crossing targetZ
        for(let j = 0; j < halfM - 1; j++){
            const z0 = zValues[base + j];
            const z1 = zValues[base + j + 1];
            if (z0 >= targetZ && z1 < targetZ) {
                const t = (targetZ - z0) / (z1 - z0);
                const y0 = xyPositions[base + j][1];
                const y1 = xyPositions[base + j + 1][1];
                starboardPoints.push([
                    stationX,
                    y0 + t * (y1 - y0)
                ]);
                break;
            }
        }
    }
    if (starboardPoints.length < 2) return [];
    // Build outline: starboard stern→bow, port bow→stern
    const outline = [];
    for (const [x, y] of starboardPoints)outline.push([
        x,
        y
    ]);
    // Port side (mirror y), reversed to close the polygon.
    // Skip collapsed points (y ≈ 0) to avoid duplicate at bow.
    for(let i = starboardPoints.length - 1; i >= 0; i--){
        const [x, y] = starboardPoints[i];
        if (Math.abs(y) < 0.01) continue;
        outline.push([
            x,
            -y
        ]);
    }
    // Ensure CCW winding for Sutherland-Hodgman clipping
    let area = 0;
    for(let i = 0; i < outline.length; i++){
        const j = (i + 1) % outline.length;
        area += outline[i][0] * outline[j][1] - outline[j][0] * outline[i][1];
    }
    if (area < 0) outline.reverse();
    return outline;
}
function $779a9fe58269ee84$export$c170a8e7ce4ad263(shape) {
    const profileSubdivisions = shape.profileSubdivisions ?? 4;
    const stationSubdivisions = shape.stationSubdivisions ?? 4;
    const sharpSet = new Set(shape.sharpStations ?? []);
    // Number of resampled points per half-profile.
    // Take the densest control point count and multiply by subdivisions.
    let maxControlPoints = 0;
    for (const station of shape.stations)if (station.profile.length > maxControlPoints) maxControlPoints = station.profile.length;
    const M = Math.max(3, (maxControlPoints - 1) * profileSubdivisions + 1);
    // Step 1: Resample all station profiles to M points.
    const resampledStations = shape.stations.map((station)=>({
            x: station.x,
            profile: $779a9fe58269ee84$var$resampleProfile(station.profile, M)
        }));
    // Step 2: Interpolate subdivided stations along the hull length.
    const allStations = $779a9fe58269ee84$var$interpolateStations(resampledStations, stationSubdivisions, sharpSet);
    // Step 3: Mirror half-profiles to full cross-sections and build 3D vertices.
    const positions = [];
    const xyPositions = [];
    const zValues = [];
    // Track which stations are collapsed (bow/stern points) for fan triangulation.
    const collapsed = [];
    // Store the full cross-section for each station for deck outline extraction.
    const fullSections = [];
    // Ring size (vertices per full cross-section) — same for all non-collapsed stations.
    const ringSize = 2 * M - 1;
    for (const station of allStations){
        const full = $779a9fe58269ee84$var$mirrorProfile(station.profile);
        fullSections.push(full);
        const isPoint = $779a9fe58269ee84$var$isCollapsedProfile(station.profile);
        collapsed.push(isPoint);
        if (isPoint) {
            // Collapsed station: emit a single vertex (repeated to fill the ring for
            // index consistency — but we'll use fan triangulation from the first vertex).
            // Actually, we emit ringSize vertices all at the same position so that
            // the index math stays uniform. The triangle generator handles collapse.
            const z = station.profile[0][1];
            for(let j = 0; j < ringSize; j++){
                positions.push(station.x, 0, z);
                xyPositions.push([
                    station.x,
                    0
                ]);
                zValues.push(z);
            }
        } else for (const [y, z] of full){
            positions.push(station.x, y, z);
            xyPositions.push([
                station.x,
                y
            ]);
            zValues.push(z);
        }
    }
    // Step 4: Generate triangle indices between adjacent station rings.
    const upperSideIndices = [];
    const lowerSideIndices = [];
    const bottomIndices = [];
    const numStations = allStations.length;
    for(let si = 0; si < numStations - 1; si++){
        const baseA = si * ringSize;
        const baseB = (si + 1) * ringSize;
        const colA = collapsed[si];
        const colB = collapsed[si + 1];
        if (colA && colB) continue;
        for(let j = 0; j < ringSize - 1; j++){
            const a0 = baseA + j;
            const a1 = baseA + j + 1;
            const b0 = baseB + j;
            const b1 = baseB + j + 1;
            // Two triangles forming the quad strip panel.
            // If one station is collapsed, only one triangle is non-degenerate (fan).
            // Winding: we want outward-facing normals.
            // For the hull exterior viewed from outside:
            //   On the starboard side (y > 0), looking from +Y, the surface goes
            //   aft-to-fore left-to-right, and the outward normal points +Y.
            //   CCW winding from outside means: a0, b0, b1 and a0, b1, a1.
            // This holds because stations go stern→bow (+X direction), and within
            // each ring the cross-section goes starboard gunwale → keel → port gunwale.
            if (colA) // Fan from collapsed station A to ring B.
            // a0 == a1 (same point), so only one triangle: a0, b0, b1
            $779a9fe58269ee84$var$pushTriClassified(a0, b0, b1, positions, zValues, upperSideIndices, lowerSideIndices, bottomIndices);
            else if (colB) // Fan from ring A to collapsed station B.
            // b0 == b1 (same point), so only one triangle: a0, a1, b0
            $779a9fe58269ee84$var$pushTriClassified(a0, a1, b0, positions, zValues, upperSideIndices, lowerSideIndices, bottomIndices);
            else {
                // Normal quad: two triangles
                $779a9fe58269ee84$var$pushTriClassified(a0, b0, b1, positions, zValues, upperSideIndices, lowerSideIndices, bottomIndices);
                $779a9fe58269ee84$var$pushTriClassified(a0, b1, a1, positions, zValues, upperSideIndices, lowerSideIndices, bottomIndices);
            }
        }
    }
    // Step 4b: Generate transom cap (stern closure).
    // The first station's cross-section is an open U-shape. We triangulate it
    // as a flat polygon in the y-z plane to close off the stern.
    if (!collapsed[0]) {
        const base = 0;
        // Build 2D polygon from the cross-section (y, z) for ear-clip.
        const transomPoly = [];
        for(let j = 0; j < ringSize; j++)transomPoly.push({
            x: xyPositions[base + j][1],
            y: zValues[base + j]
        });
        const rawTransom = (0, $dc2c60c9a54ba1c2$export$4d77c9cbb3bd528)(transomPoly);
        if (rawTransom) for(let t = 0; t < rawTransom.length; t += 3){
            const i0 = base + rawTransom[t];
            const i1 = base + rawTransom[t + 1];
            const i2 = base + rawTransom[t + 2];
            const centroidZ = (zValues[i0] + zValues[i1] + zValues[i2]) / 3;
            const target = centroidZ > 0 ? upperSideIndices : lowerSideIndices;
            // Reversed winding so outward normal points aft (-x)
            target.push(i2, i1, i0);
        }
    }
    // Step 5: Build deck cap polygon from gunwale points.
    // The gunwale points are the first and last vertex of each non-collapsed
    // full cross-section. We trace the starboard gunwale forward then the
    // port gunwale back to form a closed polygon.
    const deckOutline = [];
    const deckPolygon = [];
    // Map from deck polygon vertex index to positions array index
    const deckVertexMap = [];
    // Starboard gunwale: first vertex of each ring (index 0 = starboard gunwale)
    // going stern → bow
    for(let si = 0; si < numStations; si++)if (collapsed[si]) {
        // Collapsed station: single bow/stern point is part of the outline
        const base = si * ringSize;
        deckVertexMap.push(base);
        const x = xyPositions[base][0];
        const y = xyPositions[base][1];
        deckPolygon.push({
            x: x,
            y: y
        });
        deckOutline.push([
            x,
            y
        ]);
    } else {
        const base = si * ringSize;
        // Starboard gunwale is vertex 0 in the full cross-section
        deckVertexMap.push(base);
        const x = xyPositions[base][0];
        const y = xyPositions[base][1];
        deckPolygon.push({
            x: x,
            y: y
        });
        deckOutline.push([
            x,
            y
        ]);
    }
    // Port gunwale: last vertex of each ring (index ringSize-1 = port gunwale)
    // going bow → stern (reverse direction to close the polygon)
    for(let si = numStations - 1; si >= 0; si--){
        if (collapsed[si]) continue;
        const base = si * ringSize;
        const idx = base + ringSize - 1;
        // Skip if same as starboard (would happen if only 1 point wide — already caught by collapsed)
        if (Math.abs(xyPositions[idx][1] - xyPositions[base][1]) < 1e-6 && Math.abs(xyPositions[idx][0] - xyPositions[base][0]) < 1e-6) continue;
        deckVertexMap.push(idx);
        const x = xyPositions[idx][0];
        const y = xyPositions[idx][1];
        deckPolygon.push({
            x: x,
            y: y
        });
        deckOutline.push([
            x,
            y
        ]);
    }
    // Ensure CCW winding (positive signed area) — matches existing hull polygon convention.
    // The mirror function puts positive-y (starboard) first, which may produce CW winding.
    {
        let area = 0;
        for(let i = 0; i < deckPolygon.length; i++){
            const j = (i + 1) % deckPolygon.length;
            area += deckPolygon[i].x * deckPolygon[j].y - deckPolygon[j].x * deckPolygon[i].y;
        }
        if (area < 0) {
            // CW — reverse to CCW
            deckPolygon.reverse();
            deckVertexMap.reverse();
            deckOutline.reverse();
        }
    }
    // Triangulate deck polygon
    let deckIndices = [];
    if (deckPolygon.length >= 3) {
        const rawDeck = (0, $dc2c60c9a54ba1c2$export$4d77c9cbb3bd528)(deckPolygon);
        if (rawDeck) // Remap from deck polygon indices to positions array indices
        for (const idx of rawDeck)deckIndices.push(deckVertexMap[idx]);
    }
    return {
        positions: positions,
        ringSize: ringSize,
        xyPositions: xyPositions,
        zValues: zValues,
        deckIndices: deckIndices,
        upperSideIndices: upperSideIndices,
        lowerSideIndices: lowerSideIndices,
        bottomIndices: bottomIndices,
        deckOutline: deckOutline,
        deckVertexMap: deckVertexMap
    };
}
// --------------------------------------------------------------------
// Triangle classification helper
// --------------------------------------------------------------------
/**
 * Classify a triangle by its centroid z-height and push its indices into
 * the appropriate bucket.
 *
 * Classification:
 *   - Bottom: centroid z is within 0.05 ft of the minimum z in the mesh
 *     and the triangle is roughly horizontal (used for the keel line).
 *     In practice, triangles near the very bottom of the hull go here.
 *   - Upper side: centroid z > 0 (above waterline)
 *   - Lower side: centroid z <= 0 (below waterline)
 */ function $779a9fe58269ee84$var$pushTriClassified(i0, i1, i2, positions, zValues, upperSide, lowerSide, bottom) {
    const z0 = zValues[i0];
    const z1 = zValues[i1];
    const z2 = zValues[i2];
    const centroidZ = (z0 + z1 + z2) / 3;
    // Check if the triangle is nearly horizontal and at the very bottom.
    // A bottom triangle has all vertices at roughly the same z, and that z
    // is the lowest in its local neighborhood. We approximate by checking
    // if the triangle's normal is mostly vertical (large |nz|) and z < -draft + epsilon.
    // Simpler heuristic: if the y-span of all three vertices is very small,
    // the triangle lies along the keel centerline — classify as bottom.
    const y0 = positions[i0 * 3 + 1];
    const y1 = positions[i1 * 3 + 1];
    const y2 = positions[i2 * 3 + 1];
    const ySpan = Math.max(y0, y1, y2) - Math.min(y0, y1, y2);
    if (ySpan < 0.01 && centroidZ < 0) // Keel centerline strip — classify as bottom
    bottom.push(i0, i1, i2);
    else if (centroidZ > 0) upperSide.push(i0, i1, i2);
    else lowerSide.push(i0, i1, i2);
}


/**
 * Boat air rasterization pass.
 *
 * Publishes each boat's "air gap" — the 3D region above the bilge surface
 * and below the deck cap — into a screen-space rgba16float texture
 * (`boatAirTexture`). Read by the water height compute shader, which
 * substitutes the bilge surface for the ocean wherever the ocean would
 * lie inside the air column. One uniform per-pixel range test naturally
 * handles dry boats, wet bilges, partial submersion, and full submersion.
 *
 * Texture layout:
 *   R = airMin     (bilge surface Z, or sentinel low when dry / outside)
 *   G = airMax     (deck cap Z,     or sentinel low outside the hull)
 *   B = turbulence (slosh velocity magnitude, drives bilge foam)
 *   A = unused
 *
 * Two draws per boat, sharing one render pass and one vertex shader:
 *
 *   1. Bilge polygon — only the wetted cross-section. writeMask = R | B.
 *      Fragment outputs (interpolated bilge Z, _, slosh, _).
 *
 *   2. Deck cap mesh — the full hull top-down footprint. writeMask = G.
 *      Fragment outputs (_, interpolated deck Z, _, _).
 *
 * Channel write masks let the two draws layer non-destructively into the
 * same texture: each touches disjoint channels, and unwritten channels
 * keep the clear value (or whatever the other draw wrote earlier).
 *
 * Vertex format is shared: 3 floats per vertex (worldX, worldY, worldZ).
 * The bilge draw interprets worldZ as the bilge surface height; the deck
 * draw interprets it as the deck cap height. The vertex shader is
 * identical in both cases.
 */ 

const $8090446e3dad5a4c$export$eb62c777ab9c5892 = 3;
const $8090446e3dad5a4c$var$BOAT_AIR_VERTEX_STRIDE = $8090446e3dad5a4c$export$eb62c777ab9c5892 * 4; // 12 bytes
const $8090446e3dad5a4c$export$ddb20cce1856c539 = -10000;
const $8090446e3dad5a4c$var$BoatAirUniforms = (0, $ca6793d1abd58997$export$99bb2281c7368d10)("BoatAirUniforms", {
    // World → clip for the target texture (screen-aligned, rotation-aware).
    worldToTexClip: (0, $ca6793d1abd58997$export$a9b01fc77c97438b),
    turbulence: (0, $ca6793d1abd58997$export$e33361ff41014190)
});
const $8090446e3dad5a4c$var$SHADER_SOURCE = /*wgsl*/ `
${$8090446e3dad5a4c$var$BoatAirUniforms.wgsl}

@group(0) @binding(0) var<uniform> uniforms: BoatAirUniforms;

struct VertexInput {
  @location(0) worldPos: vec3<f32>,
}

struct VertexOutput {
  @builtin(position) clipPos: vec4<f32>,
  @location(0) worldZ: f32,
}

@vertex
fn vs_main(in: VertexInput) -> VertexOutput {
  // Map world XY into the air texture's clip coordinates (screen-aligned,
  // rotation-aware). Same matrix feeds every screen-space pass so the
  // boat air texture, water height texture, and modifier texture share a
  // texel grid exactly.
  let clip = (uniforms.worldToTexClip * vec3<f32>(in.worldPos.xy, 1.0)).xy;
  var out: VertexOutput;
  out.clipPos = vec4<f32>(clip, 0.0, 1.0);
  out.worldZ = in.worldPos.z;
  return out;
}

// Bilge fragment: writes airMin (R) and turbulence (B). G and A are
// masked out by the pipeline writeMask, so the deck cap draw can layer
// independently. Only invoked over the wetted bilge cross-section.
@fragment
fn fs_bilge(in: VertexOutput) -> @location(0) vec4<f32> {
  return vec4<f32>(in.worldZ, 0.0, uniforms.turbulence, 0.0);
}

// Deck cap fragment: writes airMax (G). R, B, and A are masked out.
// Invoked over the entire hull top-down footprint (deckIndices polygon).
@fragment
fn fs_deck(in: VertexOutput) -> @location(0) vec4<f32> {
  return vec4<f32>(0.0, in.worldZ, 0.0, 0.0);
}
`;
let $8090446e3dad5a4c$var$bilgePipeline = null;
let $8090446e3dad5a4c$var$deckPipeline = null;
let $8090446e3dad5a4c$var$bindGroupLayout = null;
let $8090446e3dad5a4c$var$initPromise = null;
async function $8090446e3dad5a4c$var$ensureInitialized() {
    if ($8090446e3dad5a4c$var$bilgePipeline && $8090446e3dad5a4c$var$deckPipeline) return;
    if ($8090446e3dad5a4c$var$initPromise) return $8090446e3dad5a4c$var$initPromise;
    $8090446e3dad5a4c$var$initPromise = (async ()=>{
        const gpu = (0, $558c2f47f1fdd57f$export$297162150ea0f6af)();
        const device = gpu.device;
        const shaderModule = await gpu.createShaderModuleChecked($8090446e3dad5a4c$var$SHADER_SOURCE, "Boat Air Shader");
        $8090446e3dad5a4c$var$bindGroupLayout = device.createBindGroupLayout({
            entries: [
                {
                    binding: 0,
                    visibility: GPUShaderStage.VERTEX | GPUShaderStage.FRAGMENT,
                    buffer: {
                        type: "uniform"
                    }
                }
            ],
            label: "Boat Air Bind Group Layout"
        });
        const pipelineLayout = device.createPipelineLayout({
            bindGroupLayouts: [
                $8090446e3dad5a4c$var$bindGroupLayout
            ],
            label: "Boat Air Pipeline Layout"
        });
        const vertexBufferLayout = {
            arrayStride: $8090446e3dad5a4c$var$BOAT_AIR_VERTEX_STRIDE,
            attributes: [
                {
                    shaderLocation: 0,
                    offset: 0,
                    format: "float32x3"
                }
            ]
        };
        // Bilge pipeline: writes only R (airMin) and B (turbulence).
        $8090446e3dad5a4c$var$bilgePipeline = device.createRenderPipeline({
            layout: pipelineLayout,
            vertex: {
                module: shaderModule,
                entryPoint: "vs_main",
                buffers: [
                    vertexBufferLayout
                ]
            },
            fragment: {
                module: shaderModule,
                entryPoint: "fs_bilge",
                targets: [
                    {
                        format: "rgba16float",
                        writeMask: GPUColorWrite.RED | GPUColorWrite.BLUE
                    }
                ]
            },
            primitive: {
                topology: "triangle-list"
            },
            label: "Boat Air Bilge Pipeline"
        });
        // Deck cap pipeline: writes only G (airMax).
        $8090446e3dad5a4c$var$deckPipeline = device.createRenderPipeline({
            layout: pipelineLayout,
            vertex: {
                module: shaderModule,
                entryPoint: "vs_main",
                buffers: [
                    vertexBufferLayout
                ]
            },
            fragment: {
                module: shaderModule,
                entryPoint: "fs_deck",
                targets: [
                    {
                        format: "rgba16float",
                        writeMask: GPUColorWrite.GREEN
                    }
                ]
            },
            primitive: {
                topology: "triangle-list"
            },
            label: "Boat Air Deck Cap Pipeline"
        });
    })();
    return $8090446e3dad5a4c$var$initPromise;
}
const $8090446e3dad5a4c$var$CLEAR_COLOR = {
    r: $8090446e3dad5a4c$export$ddb20cce1856c539,
    g: $8090446e3dad5a4c$export$ddb20cce1856c539,
    b: 0,
    a: 0
};
class $8090446e3dad5a4c$export$bf09a74867d3a39b {
    constructor(){
        this.uniformBuffer = null;
        this.bindGroup = null;
        this.uniforms = $8090446e3dad5a4c$var$BoatAirUniforms.create();
        // Scratch vertex/index buffers, grown on demand. Shared across boats
        // since we draw them sequentially within one render pass.
        this.deckVertexBuffer = null;
        this.deckIndexBuffer = null;
        this.deckVertexCapacity = 0;
        this.deckIndexCapacity = 0;
        this.deckScratchVerts = new Float32Array(0);
        this.bilgeVertexBuffer = null;
        this.bilgeIndexBuffer = null;
        this.bilgeVertexCapacity = 0;
        this.bilgeIndexCapacity = 0;
        this.bilgeScratchVerts = new Float32Array(0);
        this.bilgeScratchIndices = new Uint16Array(0);
        $8090446e3dad5a4c$var$ensureInitialized();
    }
    /**
   * Rasterize a single boat's air gap into `boatAirTexture`. Runs as a
   * standalone command encoder + render pass with `loadOp: "clear"` so
   * each frame starts from sentinel everywhere.
   */ render(targetView, worldToTexClip, boat) {
        if (!$8090446e3dad5a4c$var$bilgePipeline || !$8090446e3dad5a4c$var$deckPipeline || !$8090446e3dad5a4c$var$bindGroupLayout) {
            // Pipelines still initializing — fall back to a clear so the
            // texture isn't garbage. Air substitution will be a no-op this
            // frame.
            this.clear(targetView);
            return;
        }
        const device = (0, $558c2f47f1fdd57f$export$297162150ea0f6af)().device;
        this.ensureUniformBuffer(device);
        // Bake deck cap vertices in world space.
        const heightMesh = boat.hull.getHeightMeshData();
        const deckVertexCount = this.bakeDeckCapVerts(boat, heightMesh);
        const deckIndexCount = heightMesh.deckIndices.length;
        // Bake bilge surface polygon (optional — only when wet).
        let bilgeVertexCount = 0;
        let bilgeIndexCount = 0;
        let bilgeTurbulence = 0;
        if (boat.bilge.getWaterFraction() > 0) {
            const built = this.bakeBilgeSurface(boat);
            bilgeVertexCount = built.vertexCount;
            bilgeIndexCount = built.indexCount;
            bilgeTurbulence = this.computeBilgeTurbulence(boat);
        }
        // Upload uniforms.
        this.uniforms.set.worldToTexClip(worldToTexClip);
        this.uniforms.set.turbulence(bilgeTurbulence);
        this.uniforms.uploadTo(this.uniformBuffer);
        // Upload deck cap GPU buffers.
        this.uploadDeckBuffers(device, deckVertexCount, heightMesh.deckIndices);
        // Upload bilge GPU buffers if we have a surface.
        if (bilgeVertexCount > 0) this.uploadBilgeBuffers(device, bilgeVertexCount, bilgeIndexCount);
        const commandEncoder = device.createCommandEncoder({
            label: "Boat Air Command Encoder"
        });
        const pass = commandEncoder.beginRenderPass({
            label: "Boat Air Pass",
            colorAttachments: [
                {
                    view: targetView,
                    loadOp: "clear",
                    storeOp: "store",
                    clearValue: $8090446e3dad5a4c$var$CLEAR_COLOR
                }
            ]
        });
        pass.setBindGroup(0, this.bindGroup);
        // Draw 1: bilge surface (writes airMin R + turbulence B).
        if (bilgeVertexCount >= 3 && bilgeIndexCount >= 3) {
            pass.setPipeline($8090446e3dad5a4c$var$bilgePipeline);
            pass.setVertexBuffer(0, this.bilgeVertexBuffer);
            pass.setIndexBuffer(this.bilgeIndexBuffer, "uint16");
            pass.drawIndexed(bilgeIndexCount);
        }
        // Draw 2: deck cap (writes airMax G).
        if (deckVertexCount >= 3 && deckIndexCount >= 3) {
            pass.setPipeline($8090446e3dad5a4c$var$deckPipeline);
            pass.setVertexBuffer(0, this.deckVertexBuffer);
            pass.setIndexBuffer(this.deckIndexBuffer, "uint16");
            pass.drawIndexed(deckIndexCount);
        }
        pass.end();
        device.queue.submit([
            commandEncoder.finish()
        ]);
    }
    /**
   * Clear the air texture to the no-air sentinel. Called when there are
   * no boats (editor mode, between levels) so the water height compute's
   * substitution is a uniform no-op.
   */ clear(targetView) {
        const device = (0, $558c2f47f1fdd57f$export$297162150ea0f6af)().device;
        const commandEncoder = device.createCommandEncoder({
            label: "Boat Air Clear"
        });
        const pass = commandEncoder.beginRenderPass({
            label: "Boat Air Clear Pass",
            colorAttachments: [
                {
                    view: targetView,
                    loadOp: "clear",
                    storeOp: "store",
                    clearValue: $8090446e3dad5a4c$var$CLEAR_COLOR
                }
            ]
        });
        pass.end();
        device.queue.submit([
            commandEncoder.finish()
        ]);
    }
    ensureUniformBuffer(device) {
        if (this.uniformBuffer) return;
        this.uniformBuffer = device.createBuffer({
            size: $8090446e3dad5a4c$var$BoatAirUniforms.byteSize,
            usage: GPUBufferUsage.UNIFORM | GPUBufferUsage.COPY_DST,
            label: "Boat Air Uniform Buffer"
        });
        this.bindGroup = device.createBindGroup({
            layout: $8090446e3dad5a4c$var$bindGroupLayout,
            entries: [
                {
                    binding: 0,
                    resource: {
                        buffer: this.uniformBuffer
                    }
                }
            ],
            label: "Boat Air Bind Group"
        });
    }
    /**
   * Bake the hull's deck cap vertices (xyPositions + zValues) into
   * world-space (worldX, worldY, worldZ) triples by transforming each
   * vertex through the boat's 6DOF body orientation. Re-uses
   * `deckIndices` unchanged.
   */ bakeDeckCapVerts(boat, mesh) {
        const xy = mesh.xyPositions;
        const z = mesh.zValues;
        const vertexCount = xy.length;
        const needed = vertexCount * $8090446e3dad5a4c$export$eb62c777ab9c5892;
        if (this.deckScratchVerts.length < needed) this.deckScratchVerts = new Float32Array(needed);
        const body = boat.hull.body;
        const R = body.orientation;
        const bx = body.position[0];
        const by = body.position[1];
        const bz = body.z;
        const out = this.deckScratchVerts;
        for(let i = 0; i < vertexCount; i++){
            const lx = xy[i][0];
            const ly = xy[i][1];
            const lz = z[i];
            const wx = R[0] * lx + R[1] * ly + R[2] * lz + bx;
            const wy = R[3] * lx + R[4] * ly + R[5] * lz + by;
            const wz = R[6] * lx + R[7] * ly + R[8] * lz + bz;
            const off = i * $8090446e3dad5a4c$export$eb62c777ab9c5892;
            out[off] = wx;
            out[off + 1] = wy;
            out[off + 2] = wz;
        }
        return vertexCount;
    }
    bakeBilgeSurface(boat) {
        const maxVerts = boat.bilge.maxHullWaterVertices;
        const neededVerts = maxVerts * $8090446e3dad5a4c$export$eb62c777ab9c5892;
        if (this.bilgeScratchVerts.length < neededVerts) this.bilgeScratchVerts = new Float32Array(neededVerts);
        const maxTris = Math.max(0, maxVerts - 2);
        const neededIndices = maxTris * 3;
        // Pad to even length so the byte length is a 4-byte multiple (uint16).
        const paddedIndices = neededIndices + (neededIndices & 1);
        if (this.bilgeScratchIndices.length < paddedIndices) this.bilgeScratchIndices = new Uint16Array(paddedIndices);
        return boat.bilge.buildHullWaterVertices(this.bilgeScratchVerts, this.bilgeScratchIndices);
    }
    computeBilgeTurbulence(boat) {
        // Slosh velocity magnitude — drives the water filter's foam pathway
        // through the B channel of boatAirTexture (and via the substitution,
        // into the G channel of waterHeightTexture).
        const sx = boat.bilge.getSlopeXVelocity();
        const sy = boat.bilge.getSlopeYVelocity();
        return Math.hypot(sx, sy);
    }
    uploadDeckBuffers(device, vertexCount, indices) {
        if (vertexCount > this.deckVertexCapacity) {
            this.deckVertexBuffer?.destroy();
            this.deckVertexCapacity = vertexCount;
            this.deckVertexBuffer = device.createBuffer({
                size: vertexCount * $8090446e3dad5a4c$var$BOAT_AIR_VERTEX_STRIDE,
                usage: GPUBufferUsage.VERTEX | GPUBufferUsage.COPY_DST,
                label: "Boat Air Deck Vertex Buffer"
            });
        }
        const vBytes = vertexCount * $8090446e3dad5a4c$var$BOAT_AIR_VERTEX_STRIDE;
        device.queue.writeBuffer(this.deckVertexBuffer, 0, this.deckScratchVerts.buffer, this.deckScratchVerts.byteOffset, vBytes);
        const paddedCount = indices.length + (indices.length & 1);
        if (paddedCount > this.deckIndexCapacity) {
            this.deckIndexBuffer?.destroy();
            this.deckIndexCapacity = paddedCount;
            this.deckIndexBuffer = device.createBuffer({
                size: paddedCount * 2,
                usage: GPUBufferUsage.INDEX | GPUBufferUsage.COPY_DST,
                label: "Boat Air Deck Index Buffer"
            });
        }
        const indexData = new Uint16Array(paddedCount);
        for(let i = 0; i < indices.length; i++)indexData[i] = indices[i];
        device.queue.writeBuffer(this.deckIndexBuffer, 0, indexData.buffer, indexData.byteOffset, indexData.byteLength);
    }
    uploadBilgeBuffers(device, vertexCount, indexCount) {
        if (vertexCount > this.bilgeVertexCapacity) {
            this.bilgeVertexBuffer?.destroy();
            this.bilgeVertexCapacity = vertexCount;
            this.bilgeVertexBuffer = device.createBuffer({
                size: vertexCount * $8090446e3dad5a4c$var$BOAT_AIR_VERTEX_STRIDE,
                usage: GPUBufferUsage.VERTEX | GPUBufferUsage.COPY_DST,
                label: "Boat Air Bilge Vertex Buffer"
            });
        }
        const vBytes = vertexCount * $8090446e3dad5a4c$var$BOAT_AIR_VERTEX_STRIDE;
        device.queue.writeBuffer(this.bilgeVertexBuffer, 0, this.bilgeScratchVerts.buffer, this.bilgeScratchVerts.byteOffset, vBytes);
        const paddedCount = indexCount + (indexCount & 1);
        if (paddedCount > this.bilgeIndexCapacity) {
            this.bilgeIndexBuffer?.destroy();
            this.bilgeIndexCapacity = paddedCount;
            this.bilgeIndexBuffer = device.createBuffer({
                size: paddedCount * 2,
                usage: GPUBufferUsage.INDEX | GPUBufferUsage.COPY_DST,
                label: "Boat Air Bilge Index Buffer"
            });
        }
        device.queue.writeBuffer(this.bilgeIndexBuffer, 0, this.bilgeScratchIndices.buffer, this.bilgeScratchIndices.byteOffset, paddedCount * 2);
    }
    destroy() {
        this.deckVertexBuffer?.destroy();
        this.deckIndexBuffer?.destroy();
        this.bilgeVertexBuffer?.destroy();
        this.bilgeIndexBuffer?.destroy();
        this.uniformBuffer?.destroy();
        this.deckVertexBuffer = null;
        this.deckIndexBuffer = null;
        this.bilgeVertexBuffer = null;
        this.bilgeIndexBuffer = null;
        this.uniformBuffer = null;
        this.bindGroup = null;
    }
}


const $509b490762ff55e4$var$GRAVITY = 32.174; // ft/s²
// Weir flow ingress coefficient: Cd × (2/3) × sqrt(2g).
// The (2/3)×sqrt(2g) comes from integrating Torricelli velocity sqrt(2gh) over
// the submersion depth (standard sharp-crested weir derivation).
// A textbook sharp-crested weir has Cd ≈ 0.6; we use 0.4 as a starting point
// to account for hull geometry deflecting some flow. In the future this could be
// computed dynamically from boat velocity, angular velocity, and sea state.
const $509b490762ff55e4$var$INGRESS_COEFF = 0.4 * (2 / 3) * Math.sqrt(2 * $509b490762ff55e4$var$GRAVITY); // ~2.14
// Water drag coefficient applied per lb of water mass per ft/s of boat speed
const $509b490762ff55e4$var$WATER_DRAG_COEFF = 0.08;
// Number of bisection iterations for the volume-conserving offset solve.
// 8 gives ~draft/256 precision on a ±(draft+deckHeight) initial bracket.
const $509b490762ff55e4$var$BISECTION_ITERATIONS = 8;
// Hull-local z bias applied to the rendered bilge water surface. Lifts the
// polygon a hair above the hull geometry so it doesn't z-fight at full fill
// (surface at gunwale) or empty (surface at hull bottom). ~3/16" in feet.
const $509b490762ff55e4$var$HULL_WATER_Z_BIAS = 0.015;
/** Shoelace formula — signed area of a 2D polygon, absolute value returned. */ function $509b490762ff55e4$var$polygonArea(verts) {
    const n = verts.length;
    if (n < 3) return 0;
    let area = 0;
    for(let i = 0; i < n; i++){
        const j = (i + 1) % n;
        area += verts[i][0] * verts[j][1] - verts[j][0] * verts[i][1];
    }
    return Math.abs(area) * 0.5;
}
class $509b490762ff55e4$export$ad16b76b041f5fb4 extends (0, $c59361981bac2575$export$4342ba5c6ad1f6f1) {
    constructor(boat, config, hullVolume){
        super(), this.boat = boat, this.config = config, this.layer = "boat", this./** Current water volume in cubic ft */ waterVolume = 0, this.slopeX = 0, this.slopeY = 0, this.slopeXVelocity = 0, this.slopeYVelocity = 0, this.offset = 0, this.prevVelocityX = 0, this.prevVelocityY = 0, this.prevVelocityZ = 0, this.hasPrevVelocity = false, this.poolCentroidX = 0, this.poolCentroidY = 0, this.poolCentroidZ = 0, this.bailing = false, this.bailTimer = 0, this.sinking = false, this.sinkTimer = 0, this.sunk = false, this.getHullLeakRate = ()=>0, this.staticCentroidX = 0, this.staticCentroidY = 0, this.staticCentroidZ = 0;
        this.maxWaterVolume = config.maxWaterVolume ?? hullVolume;
        // Precompute gunwale geometry from hull mesh
        const mesh = boat.hull.getPhysicsMesh();
        this.gunwaleVertexIndices = mesh.deckVertexMap ?? Array.from({
            length: mesh.ringSize
        }, (_, i)=>i);
        const n = this.gunwaleVertexIndices.length;
        this.gunwaleSegmentLengths = new Float64Array(n);
        this.gunwaleSubmersionDepths = new Float64Array(n);
        // Compute segment lengths and half-beam from gunwale vertices
        let maxAbsY = 0;
        for(let i = 0; i < n; i++){
            const vi = this.gunwaleVertexIndices[i];
            const vj = this.gunwaleVertexIndices[(i + 1) % n];
            const dx = mesh.xyPositions[vi][0] - mesh.xyPositions[vj][0];
            const dy = mesh.xyPositions[vi][1] - mesh.xyPositions[vj][1];
            this.gunwaleSegmentLengths[i] = Math.sqrt(dx * dx + dy * dy);
            const absY = Math.abs(mesh.xyPositions[vi][1]);
            if (absY > maxAbsY) maxAbsY = absY;
        }
        this.halfBeam = maxAbsY;
        // Bilge render geometry
        this.hullMesh = mesh;
        const numStations = mesh.xyPositions.length / mesh.ringSize;
        this.maxHullWaterVertices = 2 * numStations;
        this.stationX = new Float64Array(numStations);
        this.starboardY = new Float64Array(numStations);
        this.starboardZ = new Float64Array(numStations);
        this.portY = new Float64Array(numStations);
        this.portZ = new Float64Array(numStations);
        this.starboardValid = new Uint8Array(numStations);
        this.portValid = new Uint8Array(numStations);
        // Clip scratch: Sutherland-Hodgman can at most double the input vertex
        // count per clip edge; we only clip against one half-plane so the output
        // is at most ringSize + 1 vertices. Allocate generously.
        const clipCap = mesh.ringSize * 2 + 4;
        this.clipInY = new Float64Array(clipCap);
        this.clipInZ = new Float64Array(clipCap);
        this.clipOutY = new Float64Array(clipCap);
        this.clipOutZ = new Float64Array(clipCap);
        // Build cumulative-volume table. For each sample z between hull bottom
        // and deck, extract the hull cross-section, compute its area, and
        // integrate (trapezoidal rule) to get cumulative volume below z.
        const draft = boat.config.hull.draft;
        const deckHeight = boat.config.hull.deckHeight;
        const VOLUME_SAMPLES = 48;
        this.volumeTableZ = new Float64Array(VOLUME_SAMPLES);
        this.volumeTableV = new Float64Array(VOLUME_SAMPLES);
        let cumV = 0;
        let prevArea = 0;
        let prevZ = -draft;
        for(let i = 0; i < VOLUME_SAMPLES; i++){
            const t = i / (VOLUME_SAMPLES - 1);
            const z = -draft + (deckHeight + draft) * t;
            const outline = (0, $779a9fe58269ee84$export$da258e5b085eea85)(mesh, z);
            const area = $509b490762ff55e4$var$polygonArea(outline);
            if (i > 0) cumV += (prevArea + area) * 0.5 * (z - prevZ);
            this.volumeTableZ[i] = z;
            this.volumeTableV[i] = cumV;
            prevArea = area;
            prevZ = z;
        }
        this.totalHullVolume = cumV > 0 ? cumV : hullVolume;
        // Precompute the static interior centroid by integrating with a level
        // plane well above the deck, so every hull cross-section is fully below it.
        const fullStats = this.integratePoolUnderPlane(0, 0, deckHeight + draft + 1);
        this.staticCentroidX = fullStats.cx;
        this.staticCentroidY = fullStats.cy;
        this.staticCentroidZ = fullStats.cz;
    }
    /**
   * Invert the cumulative-volume table: given a water volume (cubic ft),
   * return the hull-local z where that volume sits in the upright boat.
   * Linear interpolation between the nearest table entries. Water below the
   * hull bottom clamps to -draft; above the deck clamps to deckHeight.
   */ volumeToZ(targetVolume) {
        const tv = this.volumeTableV;
        const tz = this.volumeTableZ;
        const n = tv.length;
        if (targetVolume <= 0) return tz[0];
        if (targetVolume >= tv[n - 1]) return tz[n - 1];
        for(let i = 1; i < n; i++)if (tv[i] >= targetVolume) {
            const v0 = tv[i - 1];
            const v1 = tv[i];
            const denom = v1 - v0;
            const f = denom > 1e-9 ? (targetVolume - v0) / denom : 0;
            return tz[i - 1] + f * (tz[i] - tz[i - 1]);
        }
        return tz[n - 1];
    }
    /** Get the max water volume in cubic ft */ getMaxWaterVolume() {
        return this.maxWaterVolume;
    }
    /** Get the water level as a fraction 0-1 */ getWaterFraction() {
        return this.waterVolume / this.maxWaterVolume;
    }
    /** Check if the boat is sinking or has sunk */ isSinking() {
        return this.sinking;
    }
    isSunk() {
        return this.sunk;
    }
    setHullLeakRate(fn) {
        this.getHullLeakRate = fn;
    }
    /** Set bailing state (called by PlayerBoatController) */ setBailing(value) {
        this.bailing = value;
    }
    onTick({ dt: dt }) {
        if (this.sunk) return;
        if (this.sinking) {
            this.sinkTimer += dt;
            if (this.sinkTimer >= this.config.sinkingDuration) {
                this.sunk = true;
                this.game.dispatch("boatSunk", {});
                return;
            }
        }
        // --- Water ingress from deck edge submersion ---
        const waterFraction = this.getWaterFraction();
        // Effective deck height decreases as water accumulates (boat sits lower)
        const effectiveDeckHeight = this.boat.config.hull.deckHeight * (1 - waterFraction * 0.8);
        // Compute per-vertex submersion depth along the gunwale
        const hull = this.boat.hull;
        const body = hull.body;
        const wq = hull.getWaterQuery();
        const mesh = hull.getPhysicsMesh();
        const n = this.gunwaleVertexIndices.length;
        for(let i = 0; i < n; i++){
            const vi = this.gunwaleVertexIndices[i];
            // World Z of this gunwale vertex, accounting for roll, pitch, heave
            const worldZ = body.worldZ(mesh.xyPositions[vi][0], mesh.xyPositions[vi][1], effectiveDeckHeight);
            // Water surface height at this vertex (from GPU query)
            const waterSurface = vi < wq.length ? wq.get(vi).surfaceHeight : 0;
            this.gunwaleSubmersionDepths[i] = Math.max(0, waterSurface - worldZ);
        }
        // Sum ingress across all gunwale segments using weir flow: length × depth^(3/2).
        // The h^(3/2) comes from integrating Torricelli velocity sqrt(2gh) over the
        // submersion depth — correct scaling from gentle heel to full capsize.
        let totalFlow = 0;
        for(let i = 0; i < n; i++){
            const avgDepth = (this.gunwaleSubmersionDepths[i] + this.gunwaleSubmersionDepths[(i + 1) % n]) * 0.5;
            if (avgDepth > 0) totalFlow += this.gunwaleSegmentLengths[i] * avgDepth * Math.sqrt(avgDepth);
        }
        if (totalFlow > 0) this.waterVolume += $509b490762ff55e4$var$INGRESS_COEFF * totalFlow * dt;
        // Hull damage leak ingress
        const hullLeakRate = this.getHullLeakRate();
        if (hullLeakRate > 0) this.waterVolume += hullLeakRate * dt;
        // --- Water egress ---
        // Automatic bilge pump (if equipped)
        if (this.config.pumpDrainRate) this.waterVolume -= this.config.pumpDrainRate * dt;
        // Manual bailing — discrete bucket scoops
        if (this.bailing && this.waterVolume > 0) {
            this.bailTimer += dt;
            if (this.bailTimer >= this.config.bailInterval) {
                this.bailTimer -= this.config.bailInterval;
                this.waterVolume -= this.config.bailBucketSize;
                this.game.addEntity(new (0, $059518e50ce5c25e$export$9df2da69341d6f5a)("bail1", {
                    gain: 0.5,
                    speed: (0, $f1ed8354ebe33615$export$1ab1062261c98efe)(0.9, 1.1)
                }));
            }
        } else this.bailTimer = 0;
        // Clamp
        this.waterVolume = (0, $2172aedd5a25ff17$export$7d15b64cf5a3a4c4)(this.waterVolume, 0, this.maxWaterVolume);
        // --- Check for sinking ---
        if (!this.sinking && this.waterVolume >= this.maxWaterVolume) {
            this.sinking = true;
            this.sinkTimer = 0;
            this.game.dispatch("boatSinking", {});
        }
        // --- Water mass effects ---
        const waterMass = this.waterVolume * this.config.waterDensity;
        if (waterMass > 0) {
            // Added drag: water weight makes the boat sluggish
            const velocity = body.velocity;
            const speed = velocity.magnitude;
            if (speed > 0.01) {
                const dragMagnitude = $509b490762ff55e4$var$WATER_DRAG_COEFF * waterMass * speed;
                const norm = velocity.normalize();
                body.applyForce3D(-norm.x * dragMagnitude, -norm.y * dragMagnitude, 0, 0, 0, 0);
            }
        }
        // --- Slosh physics: 2-axis damped oscillator driven by effective gravity ---
        //
        // In the hull-local frame, gravity is R^T * (0, 0, -G). If the hull is
        // accelerating, water in the hull's non-inertial frame feels an extra
        // pseudo-force -a, so effective gravity is (g_world - a_world). Projecting
        // this into the hull frame and normalizing gives the target plane normal,
        // from which we read off the target (slopeX, slopeY).
        //
        // We finite-difference body velocity to get world-frame acceleration.
        const vx = body.velocity.x;
        const vy = body.velocity.y;
        const vz = body.zVelocity;
        let ax = 0;
        let ay = 0;
        let az = 0;
        if (this.hasPrevVelocity && dt > 1e-9) {
            ax = (vx - this.prevVelocityX) / dt;
            ay = (vy - this.prevVelocityY) / dt;
            az = (vz - this.prevVelocityZ) / dt;
        }
        this.prevVelocityX = vx;
        this.prevVelocityY = vy;
        this.prevVelocityZ = vz;
        this.hasPrevVelocity = true;
        // Effective gravity in world frame: gravity - hull_accel.
        const gEffWorldX = -ax;
        const gEffWorldY = -ay;
        const gEffWorldZ = -$509b490762ff55e4$var$GRAVITY - az;
        // Rotate into hull-local: g_local = R^T * g_world. With R row-major,
        // column i of R is (R[i], R[i+3], R[i+6]), and (R^T v)_i = dot(col_i, v).
        const R = body.orientation;
        const gLocalX = R[0] * gEffWorldX + R[3] * gEffWorldY + R[6] * gEffWorldZ;
        const gLocalY = R[1] * gEffWorldX + R[4] * gEffWorldY + R[7] * gEffWorldZ;
        const gLocalZ = R[2] * gEffWorldX + R[5] * gEffWorldY + R[8] * gEffWorldZ;
        // Plane normal in hull frame is opposite to effective gravity. Writing the
        // plane as z = offset + sX*x + sY*y, the normal is (-sX, -sY, 1), parallel
        // to (-g_local). So sX = -g_local.x / g_local.z, sY = -g_local.y / g_local.z.
        // gLocalZ is normally strongly negative; guard for the inverted-boat edge.
        const safeGz = Math.abs(gLocalZ) > 1e-3 ? gLocalZ : gLocalZ >= 0 ? 1e-3 : -0.001;
        // Cap slope targets at extreme attitudes. Past ~72° tilt of the water
        // plane the bilge integration and centroid are meaningless anyway, and
        // unclamped targets drive violent oscillator transients when the hull
        // is inverted or on its side.
        const MAX_SLOPE = 3;
        const rawSlopeX = -gLocalX / safeGz;
        const rawSlopeY = -gLocalY / safeGz;
        const slopeXTarget = Math.max(-MAX_SLOPE, Math.min(MAX_SLOPE, rawSlopeX));
        const slopeYTarget = Math.max(-MAX_SLOPE, Math.min(MAX_SLOPE, rawSlopeY));
        if (this.waterVolume > 0.01) {
            const wxLat = this.config.sloshFreqLateral;
            const wxLon = this.config.sloshFreqLongitudinal;
            const zeta = this.config.sloshDampingRatio;
            const kLon = wxLon * wxLon;
            const kLat = wxLat * wxLat;
            const cLon = 2 * zeta * wxLon;
            const cLat = 2 * zeta * wxLat;
            const accelSlopeX = (slopeXTarget - this.slopeX) * kLon - this.slopeXVelocity * cLon;
            const accelSlopeY = (slopeYTarget - this.slopeY) * kLat - this.slopeYVelocity * cLat;
            this.slopeXVelocity += accelSlopeX * dt;
            this.slopeYVelocity += accelSlopeY * dt;
            this.slopeX += this.slopeXVelocity * dt;
            this.slopeY += this.slopeYVelocity * dt;
        } else {
            // No water: relax everything toward the target (so the plane is already
            // warmed up if water arrives mid-heel) but skip bisection and forces.
            this.slopeX = slopeXTarget;
            this.slopeY = slopeYTarget;
            this.slopeXVelocity = 0;
            this.slopeYVelocity = 0;
            this.offset = this.volumeToZ(0);
            this.poolCentroidX = 0;
            this.poolCentroidY = 0;
            this.poolCentroidZ = this.offset;
            return;
        }
        // --- Volume-conserving offset via bisection ---
        //
        // Target the same mapped volume the renderer expects: scale the physical
        // waterVolume by totalHullVolume/maxWaterVolume so a full bilge corresponds
        // to a full hull interior at the rendering geometry.
        const targetVolume = this.waterVolume / this.maxWaterVolume * this.totalHullVolume;
        const seedZ = this.volumeToZ(targetVolume);
        const draft = this.boat.config.hull.draft;
        const deckHeight = this.boat.config.hull.deckHeight;
        const bracket = draft + deckHeight;
        let lo = seedZ - bracket;
        let hi = seedZ + bracket;
        let lastStats = this.integratePoolUnderPlane(this.slopeX, this.slopeY, seedZ);
        for(let iter = 0; iter < $509b490762ff55e4$var$BISECTION_ITERATIONS; iter++){
            const mid = (lo + hi) * 0.5;
            lastStats = this.integratePoolUnderPlane(this.slopeX, this.slopeY, mid);
            if (lastStats.volume > targetVolume) hi = mid;
            else lo = mid;
        }
        this.offset = (lo + hi) * 0.5;
        // One more integration at the final midpoint so the centroid matches the
        // offset we actually use for rendering and force application.
        lastStats = this.integratePoolUnderPlane(this.slopeX, this.slopeY, this.offset);
        this.poolCentroidX = lastStats.cx;
        this.poolCentroidY = lastStats.cy;
        this.poolCentroidZ = lastStats.cz;
        // --- Water weight application ---
        //
        // The free-surface effect exists because water redistributes into space
        // formerly occupied by air. When the bilge is fully flooded there is no
        // air to swap with, so the slosh torque must vanish and the water weight
        // should act at a fixed interior centroid. We blend between the sloshing
        // pool centroid and the precomputed static centroid by `airFraction`.
        // At airFraction = 1 this reduces exactly to the previous behavior; at
        // airFraction = 0 the water acts as a rigid ballast at the hull interior
        // centroid, eliminating the self-reinforcing slosh loop that destabilizes
        // the hull when it sinks completely.
        if (waterMass > 0) {
            const fillFraction = Math.max(0, Math.min(1, this.waterVolume / this.maxWaterVolume));
            const airFraction = 1 - fillFraction;
            const appCx = this.staticCentroidX + (this.poolCentroidX - this.staticCentroidX) * airFraction;
            const appCy = this.staticCentroidY + (this.poolCentroidY - this.staticCentroidY) * airFraction;
            const appCz = this.staticCentroidZ + (this.poolCentroidZ - this.staticCentroidZ) * airFraction;
            body.applyForce3D(0, 0, -waterMass * $509b490762ff55e4$var$GRAVITY, appCx, appCy, appCz);
        }
    }
    /**
   * Walk all hull stations, computing per-station wetted area and first moments
   * under the tilted plane z(x, y) = offset + slopeX*x + slopeY*y. Trapezoidal-
   * integrates along x to get total volume and centroid (cx, cy, cz) in
   * hull-local coordinates. Returns zero-volume stats if the plane is entirely
   * above or below the hull.
   */ integratePoolUnderPlane(slopeX, slopeY, offset) {
        const mesh = this.hullMesh;
        const xyPositions = mesh.xyPositions;
        const ringSize = mesh.ringSize;
        const numStations = xyPositions.length / ringSize;
        let volume = 0;
        let mx = 0;
        let my = 0;
        let mz = 0;
        // Trapezoidal integration along x: accumulate ∫ A(x) dx with
        // A(x) the station's wetted area, and ∫ A(x)*cy(x) dx for the lateral
        // moment, etc. Station x is fixed per ring so we just need area and the
        // area-weighted (y, z) centroid at each station.
        let prevStationX = 0;
        let prevA = 0;
        let prevAy = 0;
        let prevAz = 0;
        let haveHPrev = false;
        for(let si = 0; si < numStations; si++){
            const base = si * ringSize;
            const xStation = xyPositions[base][0];
            // Plane intersection line for this station: z(y) = planeZ0 + slopeY*y
            const planeZ0 = offset + slopeX * xStation;
            const { area: area, areaY: areaY, areaZ: areaZ } = this.wettedStationStats(base, ringSize, planeZ0, slopeY);
            if (haveHPrev) {
                const dx = xStation - prevStationX;
                // Midpoint x across the segment for the x moment (linear A assumed).
                // ∫ x * A(x) dx over trapezoid ≈ 0.5*dx*(xPrev*Aprev + xCur*Acur).
                volume += 0.5 * dx * (prevA + area);
                mx += 0.5 * dx * (prevStationX * prevA + xStation * area);
                my += 0.5 * dx * (prevAy + areaY);
                mz += 0.5 * dx * (prevAz + areaZ);
            }
            prevStationX = xStation;
            prevA = area;
            prevAy = areaY;
            prevAz = areaZ;
            haveHPrev = true;
        }
        if (volume <= 1e-9) return {
            volume: 0,
            cx: 0,
            cy: 0,
            cz: offset
        };
        return {
            volume: volume,
            cx: mx / volume,
            cy: my / volume,
            cz: mz / volume
        };
    }
    /**
   * For one hull station, given the plane z(y) = planeZ0 + slopeY*y in the
   * station's (y, z) frame, clip the full cross-section polygon against the
   * half-plane z < z_plane(y) and return the wetted area plus first moments
   * (∫ y dA, ∫ z dA). Uses Sutherland-Hodgman clipping with a shoelace pass.
   */ wettedStationStats(base, ringSize, planeZ0, slopeY) {
        const xyPositions = this.hullMesh.xyPositions;
        const zValues = this.hullMesh.zValues;
        // Build the clip input: full cross-section in (y, z). The vertices are
        // already ordered starboard-gunwale → keel → port-gunwale, which is a
        // simple closed polygon in the (y, z) plane (non-self-intersecting).
        const inY = this.clipInY;
        const inZ = this.clipInZ;
        for(let j = 0; j < ringSize; j++){
            inY[j] = xyPositions[base + j][1];
            inZ[j] = zValues[base + j];
        }
        let inCount = ringSize;
        // Collapsed station (bow/stern pinch): no area.
        let anyY = false;
        for(let j = 0; j < ringSize; j++)if (Math.abs(inY[j]) > 1e-6) {
            anyY = true;
            break;
        }
        if (!anyY) return {
            area: 0,
            areaY: 0,
            areaZ: 0
        };
        // Clip against the half-plane f(y, z) = (planeZ0 + slopeY*y) - z >= 0,
        // i.e. keep points where z <= planeZ0 + slopeY*y (water is *below* the
        // tilted free surface in hull frame).
        const outY = this.clipOutY;
        const outZ = this.clipOutZ;
        let outCount = 0;
        const cap = outY.length;
        // We rely on the "polygon" input being closed — treat (last, first) as
        // the final edge. For each edge, keep points inside the half-plane and
        // emit crossing points where it straddles.
        let prevY = inY[inCount - 1];
        let prevZ = inZ[inCount - 1];
        let prevF = planeZ0 + slopeY * prevY - prevZ;
        for(let j = 0; j < inCount; j++){
            const curY = inY[j];
            const curZ = inZ[j];
            const curF = planeZ0 + slopeY * curY - curZ;
            if (curF >= 0) {
                if (prevF < 0 && outCount < cap) {
                    // Entering: emit crossing, then current vertex.
                    const t = prevF / (prevF - curF);
                    outY[outCount] = prevY + t * (curY - prevY);
                    outZ[outCount] = prevZ + t * (curZ - prevZ);
                    outCount++;
                }
                if (outCount < cap) {
                    outY[outCount] = curY;
                    outZ[outCount] = curZ;
                    outCount++;
                }
            } else if (prevF >= 0 && outCount < cap) {
                // Leaving: emit crossing only.
                const t = prevF / (prevF - curF);
                outY[outCount] = prevY + t * (curY - prevY);
                outZ[outCount] = prevZ + t * (curZ - prevZ);
                outCount++;
            }
            prevY = curY;
            prevZ = curZ;
            prevF = curF;
        }
        if (outCount < 3) return {
            area: 0,
            areaY: 0,
            areaZ: 0
        };
        // Shoelace area and first moments. Standard formulas:
        //   A    = 0.5 * Σ (y_i * z_{i+1} - y_{i+1} * z_i)
        //   Cy*A = (1/6) * Σ (y_i + y_{i+1}) * (y_i*z_{i+1} - y_{i+1}*z_i)
        //   Cz*A = (1/6) * Σ (z_i + z_{i+1}) * (y_i*z_{i+1} - y_{i+1}*z_i)
        // Sign of A tracks winding; take absolute value and flip moment signs to match.
        let signedArea = 0;
        let signedMy = 0;
        let signedMz = 0;
        for(let i = 0; i < outCount; i++){
            const i1 = (i + 1) % outCount;
            const yi = outY[i];
            const zi = outZ[i];
            const yj = outY[i1];
            const zj = outZ[i1];
            const cross = yi * zj - yj * zi;
            signedArea += cross;
            signedMy += (yi + yj) * cross;
            signedMz += (zi + zj) * cross;
        }
        const area = 0.5 * Math.abs(signedArea);
        if (area < 1e-9) return {
            area: 0,
            areaY: 0,
            areaZ: 0
        };
        const sign = signedArea >= 0 ? 1 : -1;
        const areaY = sign * signedMy / 6;
        const areaZ = sign * signedMz / 6;
        return {
            area: area,
            areaY: areaY,
            areaZ: areaZ
        };
    }
    /**
   * Bake the interior water quad's vertex and index data into `outVerts`
   * and `outIndices` for rendering by `BoatRenderer`. Returns `{ vertexCount,
   * indexCount }` — both zero when there's nothing to draw.
   *
   * For each station, find where the tilted water plane
   *     z(x, y) = offset + slopeX*x + slopeY*y
   * intersects the station's half-profile on the starboard (+y) and port (-y)
   * sides. Those two points per station form the outline of the pool at that
   * station. Walking stations stern→bow on starboard and bow→stern on port
   * gives a closed polygon tracing the water-hull intersection.
   *
   * Vertex layout matches `BOAT_AIR_VERTEX_SIZE`: position.xy (world),
   * z (world). The z component carries the bilge surface height that the
   * stamp shader writes into `waterHeightTexture`.
   */ buildHullWaterVertices(outVerts, outIndices) {
        if (this.waterVolume < 0.01) return {
            vertexCount: 0,
            indexCount: 0
        };
        const offset = this.offset;
        const slopeX = this.slopeX;
        const slopeY = this.slopeY;
        const mesh = this.hullMesh;
        const xyPositions = mesh.xyPositions;
        const zValues = mesh.zValues;
        const ringSize = mesh.ringSize;
        const halfM = (ringSize + 1) / 2;
        const numStations = xyPositions.length / ringSize;
        const maxOutVerts = outVerts.length / (0, $8090446e3dad5a4c$export$eb62c777ab9c5892);
        const body = this.boat.hull.body;
        const R = body.orientation;
        const bx = body.position[0];
        const by = body.position[1];
        const bz = body.z;
        const sX = this.stationX;
        const sYStar = this.starboardY;
        const sZStar = this.starboardZ;
        const sYPort = this.portY;
        const sZPort = this.portZ;
        const sValidStar = this.starboardValid;
        const sValidPort = this.portValid;
        // The outline of the pool at each station is the intersection of the tilted
        // water plane with the station cross-section, clipped to the hull interior.
        // Key invariant: outline vertices must lie ON the hull surface — never
        // above the gunwale z — otherwise the rendered polygon spills out of the
        // boat. When the plane is above the gunwale we clamp to the gunwale z; at
        // a profile crossing we use the interpolated profile z (which is on the
        // hull by construction).
        for(let si = 0; si < numStations; si++){
            const base = si * ringSize;
            const xStation = xyPositions[base][0];
            sX[si] = xStation;
            sValidStar[si] = 0;
            sValidPort[si] = 0;
            // Per-station plane in (y, z): z(y) = planeZ0 + slopeY*y
            const planeZ0 = offset + slopeX * xStation;
            // --- Starboard side (+y half-profile, j=0 at gunwale .. halfM-1 at keel) ---
            {
                const gunwaleY = xyPositions[base][1];
                const gunwaleZ = zValues[base];
                let d0 = gunwaleZ - (planeZ0 + slopeY * gunwaleY);
                if (d0 < 0) {
                    sYStar[si] = gunwaleY;
                    sZStar[si] = gunwaleZ;
                    sValidStar[si] = 1;
                } else for(let j = 0; j < halfM - 1; j++){
                    const y1 = xyPositions[base + j + 1][1];
                    const z1 = zValues[base + j + 1];
                    const d1 = z1 - (planeZ0 + slopeY * y1);
                    if (d1 < 0) {
                        const y0 = xyPositions[base + j][1];
                        const z0 = zValues[base + j];
                        const denom = d0 - d1;
                        const t = denom > 1e-9 ? d0 / denom : 0;
                        sYStar[si] = y0 + t * (y1 - y0);
                        sZStar[si] = z0 + t * (z1 - z0);
                        sValidStar[si] = 1;
                        break;
                    }
                    d0 = d1;
                }
            }
            // --- Port side (mirrored half-profile, y_port = -y_profile) ---
            {
                const y0Profile = xyPositions[base][1];
                const gunwaleZ = zValues[base];
                let d0 = gunwaleZ - (planeZ0 + slopeY * -y0Profile);
                if (d0 < 0) {
                    sYPort[si] = -y0Profile;
                    sZPort[si] = gunwaleZ;
                    sValidPort[si] = 1;
                } else for(let j = 0; j < halfM - 1; j++){
                    const y1Profile = xyPositions[base + j + 1][1];
                    const z1 = zValues[base + j + 1];
                    const d1 = z1 - (planeZ0 + slopeY * -y1Profile);
                    if (d1 < 0) {
                        const yjProfile = xyPositions[base + j][1];
                        const zjProfile = zValues[base + j];
                        const denom = d0 - d1;
                        const t = denom > 1e-9 ? d0 / denom : 0;
                        sYPort[si] = -(yjProfile + t * (y1Profile - yjProfile));
                        sZPort[si] = zjProfile + t * (z1 - zjProfile);
                        sValidPort[si] = 1;
                        break;
                    }
                    d0 = d1;
                }
            }
        }
        // --- Bake outline: starboard stern→bow, then port bow→stern ---
        // Small hull-local z nudge to avoid z-fighting with the hull mesh when
        // the water plane coincides with the gunwale (full bilge) or bottom.
        let n = 0;
        const writeVertex = (vx, vy, vzRaw)=>{
            if (n >= maxOutVerts) return;
            const vz = vzRaw + $509b490762ff55e4$var$HULL_WATER_Z_BIAS;
            const worldX = R[0] * vx + R[1] * vy + R[2] * vz + bx;
            const worldY = R[3] * vx + R[4] * vy + R[5] * vz + by;
            const worldZ = R[6] * vx + R[7] * vy + R[8] * vz + bz;
            const off = n * (0, $8090446e3dad5a4c$export$eb62c777ab9c5892);
            outVerts[off] = worldX;
            outVerts[off + 1] = worldY;
            outVerts[off + 2] = worldZ;
            n++;
        };
        for(let si = 0; si < numStations; si++)if (sValidStar[si]) writeVertex(sX[si], sYStar[si], sZStar[si]);
        for(let si = numStations - 1; si >= 0; si--)if (sValidPort[si]) {
            const vy = sYPort[si];
            if (Math.abs(vy) < 0.01) continue; // collapsed bow/stern point
            writeVertex(sX[si], vy, sZPort[si]);
        }
        if (n < 3) return {
            vertexCount: 0,
            indexCount: 0
        };
        // Fan triangulation from vertex 0. The outline is convex (hull cross-
        // sections are ~elliptical and the tilted plane preserves convexity).
        const triCount = n - 2;
        const indexCount = triCount * 3;
        for(let i = 0; i < triCount; i++){
            outIndices[i * 3] = 0;
            outIndices[i * 3 + 1] = i + 1;
            outIndices[i * 3 + 2] = i + 2;
        }
        return {
            vertexCount: n,
            indexCount: indexCount
        };
    }
    /** Longitudinal slope of the bilge water plane (dz/dx in hull-local). */ getSlopeX() {
        return this.slopeX;
    }
    /** Lateral slope of the bilge water plane (dz/dy in hull-local). */ getSlopeY() {
        return this.slopeY;
    }
    /** Rate of change of the longitudinal slope (1/s). */ getSlopeXVelocity() {
        return this.slopeXVelocity;
    }
    /** Rate of change of the lateral slope (1/s). */ getSlopeYVelocity() {
        return this.slopeYVelocity;
    }
}
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $aa1f0309d9dba6d2$export$af631764ddc44097)("tick")
], $509b490762ff55e4$export$ad16b76b041f5fb4.prototype, "onTick", null);




const $7154ee0e27d3cb2e$export$877edbcccdf46bfb = {
    hull: {
        fill: 0xffffff,
        stroke: 0xe1af00,
        side: 0x3b9ab2,
        bottom: 0x1a4552
    },
    deckZones: {
        foredeck: 0xffffff,
        cockpit: 0x3b9ab2,
        bench: 0x1a4552,
        bulkhead: 0xffffff,
        companionway: 0x0f3a47
    },
    foils: 0x1a4552,
    rig: {
        mast: 0x888888,
        boom: 0xe1af00
    },
    sails: 0xfafafa,
    ropes: {
        // Racing red 16-plait mainsheet with a pair of white flecks per family.
        mainsheet: {
            type: "braid",
            carriers: [
                0xf21a00,
                0xf21a00,
                0xffffff,
                0xf21a00,
                0xf21a00,
                0xf21a00,
                0xf21a00,
                0xf21a00,
                0xf21a00,
                0xf21a00,
                0xffffff,
                0xf21a00,
                0xf21a00,
                0xf21a00,
                0xf21a00,
                0xf21a00
            ],
            helixAngle: 35
        },
        // Teal jib sheets with a gold fleck so the windward trim pops.
        jibSheet: {
            type: "braid",
            carriers: [
                0x3b9ab2,
                0x3b9ab2,
                0xe1af00,
                0x3b9ab2,
                0x3b9ab2,
                0x3b9ab2,
                0x3b9ab2,
                0x3b9ab2,
                0x3b9ab2,
                0x3b9ab2,
                0xe1af00,
                0x3b9ab2,
                0x3b9ab2,
                0x3b9ab2,
                0x3b9ab2,
                0x3b9ab2
            ],
            helixAngle: 35
        },
        // Poolside-yellow-and-teal anchor rode.
        anchorRode: {
            type: "braid",
            carriers: [
                0xebcc2a,
                0xebcc2a,
                0x3b9ab2,
                0x3b9ab2,
                0xebcc2a,
                0xebcc2a,
                0x3b9ab2,
                0x3b9ab2
            ],
            helixAngle: 40
        },
        // White halyard with a lightweight red tracer — reads clearly against
        // the teal topsides and matches the racing-red mainsheet at a glance.
        halyard: {
            type: "braid",
            carriers: [
                0xeeeeee,
                0xeeeeee,
                0xf21a00,
                0xeeeeee,
                0xeeeeee,
                0xeeeeee,
                0xeeeeee,
                0xeeeeee,
                0xeeeeee,
                0xeeeeee,
                0xf21a00,
                0xeeeeee,
                0xeeeeee,
                0xeeeeee,
                0xeeeeee,
                0xeeeeee
            ],
            helixAngle: 35
        }
    },
    bowsprit: 0xe1af00,
    lifelines: {
        tube: 0xcccccc,
        wire: 0x888888
    }
};
const $7154ee0e27d3cb2e$export$abaec88eb99a7b21 = {
    hull: {
        fill: 0xd8c89c,
        stroke: 0x6a4a1a,
        side: 0xe8dbb0,
        bottom: 0x4a3018
    },
    deckZones: {
        foredeck: 0xc4a46c,
        cockpit: 0x8a6538,
        bench: 0xa88450,
        bulkhead: 0x6a4620,
        companionway: 0x2a1808
    },
    foils: 0x5a4030,
    rig: {
        mast: 0xa09080,
        boom: 0x8a6a40
    },
    sails: 0xeeeedd,
    ropes: {
        // Classic 3-strand manila mainsheet.
        mainsheet: {
            type: "laid",
            carriers: [
                0xc9a968,
                0xb89050,
                0xc9a968
            ],
            helixAngle: 38
        },
        // Hemp-toned jib sheets with a brown tracer.
        jibSheet: {
            type: "braid",
            carriers: [
                0xd8b878,
                0xd8b878,
                0x6a4a1a,
                0xd8b878,
                0xd8b878,
                0xd8b878,
                0xd8b878,
                0xd8b878,
                0xd8b878,
                0xd8b878,
                0x6a4a1a,
                0xd8b878,
                0xd8b878,
                0xd8b878,
                0xd8b878,
                0xd8b878
            ],
            helixAngle: 35
        },
        // Tarred marline anchor rode.
        anchorRode: {
            type: "laid",
            carriers: [
                0x6a4a1a,
                0x553818,
                0x6a4a1a
            ],
            helixAngle: 42
        },
        // Classic 3-strand manila halyard — utilitarian cream hemp.
        halyard: {
            type: "laid",
            carriers: [
                0xd8b878,
                0xc9a968,
                0xd8b878
            ],
            helixAngle: 38
        }
    },
    bowsprit: 0x775533,
    lifelines: {
        tube: 0xaaaaaa,
        wire: 0x777777
    }
};
const $7154ee0e27d3cb2e$export$d0e813f3f2fad874 = {
    hull: {
        fill: 0xe8e0cc,
        stroke: 0xb09030,
        side: 0x162648,
        bottom: 0x060b1a
    },
    deckZones: {
        foredeck: 0xe8e0cc,
        cockpit: 0x6a4a28,
        bench: 0x8a6236,
        bulkhead: 0xe8e0cc,
        companionway: 0x0a1028
    },
    foils: 0x162648,
    rig: {
        mast: 0xbbbbcc,
        boom: 0xb09030
    },
    sails: 0xf4f2ee,
    ropes: {
        // Deep navy mainsheet with a thin gold tracer.
        mainsheet: {
            type: "braid",
            carriers: [
                0x0a1a40,
                0x0a1a40,
                0xb09030,
                0x0a1a40,
                0x0a1a40,
                0x0a1a40,
                0x0a1a40,
                0x0a1a40,
                0x0a1a40,
                0x0a1a40,
                0xb09030,
                0x0a1a40,
                0x0a1a40,
                0x0a1a40,
                0x0a1a40,
                0x0a1a40
            ],
            helixAngle: 32
        },
        // Ivory jib sheets with a navy fleck.
        jibSheet: {
            type: "braid",
            carriers: [
                0xf4f2ee,
                0xf4f2ee,
                0x0a1a40,
                0xf4f2ee,
                0xf4f2ee,
                0xf4f2ee,
                0xf4f2ee,
                0xf4f2ee,
                0xf4f2ee,
                0xf4f2ee,
                0x0a1a40,
                0xf4f2ee,
                0xf4f2ee,
                0xf4f2ee,
                0xf4f2ee,
                0xf4f2ee
            ],
            helixAngle: 32
        },
        // Navy-and-gold anchor rode, ostentatious by design.
        anchorRode: {
            type: "braid",
            carriers: [
                0x0a1a40,
                0x0a1a40,
                0xb09030,
                0xb09030,
                0x0a1a40,
                0x0a1a40,
                0xb09030,
                0xb09030
            ],
            helixAngle: 40
        },
        // Ivory halyard with a fine gold tracer — matches the mainsheet trim.
        halyard: {
            type: "braid",
            carriers: [
                0xf4f2ee,
                0xf4f2ee,
                0xb09030,
                0xf4f2ee,
                0xf4f2ee,
                0xf4f2ee,
                0xf4f2ee,
                0xf4f2ee,
                0xf4f2ee,
                0xf4f2ee,
                0xb09030,
                0xf4f2ee,
                0xf4f2ee,
                0xf4f2ee,
                0xf4f2ee,
                0xf4f2ee
            ],
            helixAngle: 32
        }
    },
    bowsprit: 0xb09030,
    lifelines: {
        tube: 0xccccdd,
        wire: 0x999999
    }
};
/**
 * Map a deckPlan zone name to its palette color. Falls back to the foredeck
 * color for unrecognized zone names.
 */ function $7154ee0e27d3cb2e$var$zoneColorFor(name, palette) {
    if (name === "foredeck") return palette.deckZones.foredeck;
    if (name === "cockpit") return palette.deckZones.cockpit;
    if (name === "companionway") return palette.deckZones.companionway;
    if (name.includes("bench")) return palette.deckZones.bench;
    if (name.includes("bulkhead")) return palette.deckZones.bulkhead;
    return palette.deckZones.foredeck;
}
function $7154ee0e27d3cb2e$export$989dedabf426811c(base, palette) {
    return {
        ...base,
        hull: {
            ...base.hull,
            colors: {
                ...palette.hull
            },
            deckPlan: base.hull.deckPlan ? {
                zones: base.hull.deckPlan.zones.map((zone)=>{
                    const color = $7154ee0e27d3cb2e$var$zoneColorFor(zone.name, palette);
                    return {
                        ...zone,
                        color: color,
                        wallColor: zone.wallColor !== undefined ? color : undefined
                    };
                })
            } : undefined
        },
        keel: {
            ...base.keel,
            color: palette.foils
        },
        rudder: {
            ...base.rudder,
            color: palette.foils
        },
        rig: {
            ...base.rig,
            colors: {
                mast: palette.rig.mast,
                boom: palette.rig.boom
            },
            mainsail: {
                ...base.rig.mainsail,
                color: palette.sails
            }
        },
        jib: base.jib ? {
            ...base.jib,
            color: palette.sails
        } : undefined,
        mainsheet: {
            ...base.mainsheet,
            ropeColor: palette.ropes.mainsheet.carriers[0],
            ropePattern: palette.ropes.mainsheet
        },
        jibSheet: base.jibSheet ? {
            ...base.jibSheet,
            ropeColor: palette.ropes.jibSheet.carriers[0],
            ropePattern: palette.ropes.jibSheet
        } : undefined,
        anchor: {
            ...base.anchor,
            ropePattern: palette.ropes.anchorRode
        },
        halyard: {
            ...base.halyard,
            ropeColor: palette.ropes.halyard.carriers[0],
            ropePattern: palette.ropes.halyard
        },
        bowsprit: base.bowsprit ? {
            ...base.bowsprit,
            color: palette.bowsprit
        } : undefined,
        lifelines: base.lifelines ? {
            ...base.lifelines,
            tubeColor: palette.lifelines.tube,
            wireColor: palette.lifelines.wire
        } : undefined
    };
}




const $629e228c0746ac24$export$316bcd36a9fcbe45 = {
    hull: {
        mass: 900,
        // 2D collision polygon (deck outline, CCW winding)
        vertices: [
            (0, $6b6a54a072724620$export$e7c866399fa523f5)(-9.5, -1.5),
            (0, $6b6a54a072724620$export$e7c866399fa523f5)(-9, -2.7),
            (0, $6b6a54a072724620$export$e7c866399fa523f5)(-4, -4),
            (0, $6b6a54a072724620$export$e7c866399fa523f5)(1, -4),
            (0, $6b6a54a072724620$export$e7c866399fa523f5)(6, -3),
            (0, $6b6a54a072724620$export$e7c866399fa523f5)(10, -1.5),
            (0, $6b6a54a072724620$export$e7c866399fa523f5)(13, 0),
            (0, $6b6a54a072724620$export$e7c866399fa523f5)(10, 1.5),
            (0, $6b6a54a072724620$export$e7c866399fa523f5)(6, 3.0),
            (0, $6b6a54a072724620$export$e7c866399fa523f5)(1, 4.0),
            (0, $6b6a54a072724620$export$e7c866399fa523f5)(-4, 4.0),
            (0, $6b6a54a072724620$export$e7c866399fa523f5)(-9, 2.7),
            (0, $6b6a54a072724620$export$e7c866399fa523f5)(-9.5, 1.5)
        ],
        // 3D hull shape — station profiles from stern to bow.
        // Each profile is a half-curve [y, z] from keel center to gunwale (starboard).
        shape: {
            stations: [
                // Stern transom — narrow, relatively flat
                {
                    x: -9.5,
                    profile: [
                        [
                            0,
                            -0.5
                        ],
                        [
                            0.5,
                            -0.5
                        ],
                        [
                            1.15,
                            0
                        ],
                        [
                            1.5,
                            2.5
                        ]
                    ]
                },
                // Stern shoulder — widening aft sections
                {
                    x: -9,
                    profile: [
                        [
                            0,
                            -0.8
                        ],
                        [
                            0.9,
                            -0.8
                        ],
                        [
                            2.1,
                            0
                        ],
                        [
                            2.7,
                            2.5
                        ]
                    ]
                },
                // Aft quarter — approaching max beam
                {
                    x: -4,
                    profile: [
                        [
                            0,
                            -1
                        ],
                        [
                            1.4,
                            -1
                        ],
                        [
                            3.3,
                            0
                        ],
                        [
                            4.0,
                            2.5
                        ]
                    ]
                },
                // Midships — max beam, deepest draft
                {
                    x: 1,
                    profile: [
                        [
                            0,
                            -1
                        ],
                        [
                            1.4,
                            -1
                        ],
                        [
                            3.3,
                            0
                        ],
                        [
                            4.0,
                            2.5
                        ]
                    ]
                },
                // Forward quarter — narrowing
                {
                    x: 6,
                    profile: [
                        [
                            0,
                            -1
                        ],
                        [
                            1.1,
                            -1
                        ],
                        [
                            2.5,
                            0
                        ],
                        [
                            3.0,
                            2.5
                        ]
                    ]
                },
                // Forward shoulder — fine entry
                {
                    x: 10,
                    profile: [
                        [
                            0,
                            -0.8
                        ],
                        [
                            0.5,
                            -0.6
                        ],
                        [
                            1.15,
                            0
                        ],
                        [
                            1.5,
                            2.5
                        ]
                    ]
                },
                // Bow — collapses to a point
                {
                    x: 13,
                    profile: [
                        [
                            0,
                            -0.3
                        ],
                        [
                            0,
                            2.5
                        ]
                    ]
                }
            ],
            sharpStations: [
                6
            ]
        },
        // Deck plan — interior layout
        deckPlan: {
            zones: [
                // Foredeck — flat deck forward of bulkhead
                {
                    name: "foredeck",
                    type: "deck",
                    outline: [
                        [
                            2.0,
                            -5
                        ],
                        [
                            2.0,
                            5
                        ],
                        [
                            14,
                            5
                        ],
                        [
                            14,
                            -5
                        ]
                    ],
                    floorZ: 2.5,
                    color: 0xc4a46c
                },
                // Cockpit sole — recessed floor (oversized, clipped to hull outline)
                {
                    name: "cockpit",
                    type: "cockpit",
                    outline: [
                        [
                            -10,
                            -5
                        ],
                        [
                            -10,
                            5
                        ],
                        [
                            2.0,
                            5
                        ],
                        [
                            2.0,
                            -5
                        ]
                    ],
                    floorZ: 1.0,
                    color: 0x7d6040
                },
                // Port bench — extends from stern to bulkhead
                {
                    name: "port-bench",
                    type: "bench",
                    outline: [
                        [
                            -10,
                            1.8
                        ],
                        [
                            -10,
                            5
                        ],
                        [
                            2.0,
                            5
                        ],
                        [
                            2.0,
                            1.8
                        ]
                    ],
                    floorZ: 1.8,
                    color: 0xb09050
                },
                // Starboard bench
                {
                    name: "starboard-bench",
                    type: "bench",
                    outline: [
                        [
                            -10,
                            -5
                        ],
                        [
                            -10,
                            -1.8
                        ],
                        [
                            2.0,
                            -1.8
                        ],
                        [
                            2.0,
                            -5
                        ]
                    ],
                    floorZ: 1.8,
                    color: 0xb09050
                },
                // Port bulkhead — forward cockpit wall (port side of companionway)
                {
                    name: "port-bulkhead",
                    type: "deck",
                    outline: [
                        [
                            2.0,
                            0.9
                        ],
                        [
                            2.0,
                            5
                        ],
                        [
                            2.5,
                            5
                        ],
                        [
                            2.5,
                            0.9
                        ]
                    ],
                    floorZ: 1.0,
                    wallHeight: 1.5,
                    color: 0x8a6a3c,
                    wallColor: 0x8a6a3c
                },
                // Starboard bulkhead — forward cockpit wall (starboard side of companionway)
                {
                    name: "starboard-bulkhead",
                    type: "deck",
                    outline: [
                        [
                            2.0,
                            -5
                        ],
                        [
                            2.0,
                            -0.9
                        ],
                        [
                            2.5,
                            -0.9
                        ],
                        [
                            2.5,
                            -5
                        ]
                    ],
                    floorZ: 1.0,
                    wallHeight: 1.5,
                    color: 0x8a6a3c,
                    wallColor: 0x8a6a3c
                },
                // Companionway — dark opening between cockpit and cabin
                {
                    name: "companionway",
                    type: "companionway",
                    outline: [
                        [
                            2.0,
                            -0.9
                        ],
                        [
                            2.0,
                            0.9
                        ],
                        [
                            2.5,
                            0.9
                        ],
                        [
                            2.5,
                            -0.9
                        ]
                    ],
                    floorZ: 1.0,
                    color: 0x3a2810
                }
            ]
        },
        skinFrictionCoefficient: 0.003,
        stagnationCoefficient: 0.4,
        separationCoefficient: 0.12,
        draft: 1.0,
        deckHeight: 2.5,
        colors: {
            fill: 0xc4a46c,
            stroke: 0x7a5230,
            side: 0xc4a46c,
            bottom: 0x6b4226
        }
    },
    keel: {
        vertices: [
            (0, $6b6a54a072724620$export$e7c866399fa523f5)(-4, 0),
            (0, $6b6a54a072724620$export$e7c866399fa523f5)(4, 0)
        ],
        draft: 3.75,
        chord: 2.0,
        color: 0x4a3a3d
    },
    rudder: {
        position: (0, $6b6a54a072724620$export$e7c866399fa523f5)(-9.75, 0),
        length: 2.5,
        draft: 3.0,
        chord: 2.0,
        maxSteerAngle: (0, $2172aedd5a25ff17$export$e6bfdeff8bfc94f9)(60),
        steerAdjustSpeed: 0.8,
        steerAdjustSpeedFast: 2.0,
        color: 0x4a3a3d
    },
    rig: {
        mastPosition: (0, $6b6a54a072724620$export$e7c866399fa523f5)(5, 0),
        boomLength: 9.5,
        boomWidth: 0.5,
        boomMass: 18,
        colors: {
            mast: 0x4a3a3d,
            boom: 0x997744
        },
        mainsail: {
            nodeMass: 0.8,
            liftScale: 1.0,
            dragScale: 1.0,
            hoistSpeed: 0.35,
            color: 0xeeeeff,
            zFoot: 4.0,
            zHead: 26
        },
        stays: {
            forestay: (0, $6b6a54a072724620$export$e7c866399fa523f5)(15.4, 0),
            portShroud: (0, $6b6a54a072724620$export$e7c866399fa523f5)(3.5, 3.3),
            starboardShroud: (0, $6b6a54a072724620$export$e7c866399fa523f5)(3.5, -3.3),
            backstay: {
                split: (0, $6b6a54a072724620$export$e7c866399fa523f5)(-9, 0),
                splitZ: 5.0,
                port: (0, $6b6a54a072724620$export$e7c866399fa523f5)(-9.2, 2.3),
                starboard: (0, $6b6a54a072724620$export$e7c866399fa523f5)(-9.2, -2.3)
            },
            deckHeight: 2.5
        }
    },
    bowsprit: {
        attachPoint: (0, $6b6a54a072724620$export$e7c866399fa523f5)(12.9, 0),
        size: (0, $6b6a54a072724620$export$e7c866399fa523f5)(2.5, 0.35),
        color: 0x775533
    },
    lifelines: {
        // Stanchion positions interpolated along hull deck edge vertices
        portStanchions: [
            [
                6.0,
                2.85
            ],
            [
                1,
                3.85
            ],
            [
                -4,
                3.85
            ]
        ],
        starboardStanchions: [
            [
                6.0,
                -2.85
            ],
            [
                1,
                -3.85
            ],
            [
                -4,
                -3.85
            ]
        ],
        bowPulpit: [
            [
                8.5,
                -2
            ],
            [
                11,
                -1
            ],
            [
                13,
                0
            ],
            [
                11,
                1.0
            ],
            [
                8.5,
                2.0
            ]
        ],
        sternPulpit: [
            [
                -8.85,
                -2.47
            ],
            [
                -9.35,
                -1.27
            ],
            [
                -9.35,
                0
            ],
            [
                -9.35,
                1.27
            ],
            [
                -8.85,
                2.47
            ]
        ],
        stanchionHeight: 1.5,
        tubeColor: 0xbbbbbb,
        wireColor: 0x999999,
        tubeWidth: 0.2,
        wireWidth: 0.1
    },
    anchor: {
        bowAttachPoint: (0, $6b6a54a072724620$export$e7c866399fa523f5)(13, 0),
        maxRodeLength: 60,
        anchorSize: 1.2,
        anchorMass: 15,
        deckHeight: 2.5,
        rollInertia: 0.3,
        pitchInertia: 1.5,
        yawInertia: 1.5,
        rodeAttachOffset: [
            1.02,
            0,
            0.36
        ],
        anchorDragCoefficient: 500,
        ropePattern: {
            type: "braid",
            carriers: [
                0x22aa44,
                0x22aa44,
                0xddaa00,
                0xddaa00,
                0x22aa44,
                0x22aa44,
                0x22aa44,
                0x22aa44
            ],
            helixAngle: 40
        }
    },
    jib: {
        nodeMass: 0.6,
        liftScale: 1.0,
        dragScale: 1.0,
        hoistSpeed: 0.4,
        color: 0xeeeeff,
        zFoot: 4.0,
        zHead: 26
    },
    mainsheet: {
        boomAttachRatio: 0.9,
        hullAttachPoint: (0, $6b6a54a072724620$export$e7c866399fa523f5)(-7.5, 0),
        winchPoint: (0, $6b6a54a072724620$export$e7c866399fa523f5)(-6.5, 0),
        minLength: 2,
        maxLength: 12,
        ropeThickness: 0.15,
        ropeColor: 0xeeeeee,
        // White base with a single navy fleck (symmetric 16-plait)
        ropePattern: {
            type: "braid",
            carriers: [
                0xeeeeee,
                0xeeeeee,
                0x113366,
                0xeeeeee,
                0xeeeeee,
                0xeeeeee,
                0xeeeeee,
                0xeeeeee,
                0xeeeeee,
                0xeeeeee,
                0x113366,
                0xeeeeee,
                0xeeeeee,
                0xeeeeee,
                0xeeeeee,
                0xeeeeee
            ],
            helixAngle: 35
        }
    },
    jibSheet: {
        portAttachPoint: (0, $6b6a54a072724620$export$e7c866399fa523f5)(-6, 2.6),
        starboardAttachPoint: (0, $6b6a54a072724620$export$e7c866399fa523f5)(-6, -2.6),
        portBlockPoint: (0, $6b6a54a072724620$export$e7c866399fa523f5)(3, 3.0),
        starboardBlockPoint: (0, $6b6a54a072724620$export$e7c866399fa523f5)(3, -3),
        blockFrictionCoefficient: 0.4,
        portWinchPoint: (0, $6b6a54a072724620$export$e7c866399fa523f5)(-4, 2.8),
        starboardWinchPoint: (0, $6b6a54a072724620$export$e7c866399fa523f5)(-4, -2.8),
        minLength: 6,
        maxLength: 18,
        ropeThickness: 0.15,
        ropeColor: 0x113366,
        // Navy base with a single white fleck (symmetric 16-plait)
        ropePattern: {
            type: "braid",
            carriers: [
                0x113366,
                0x113366,
                0xeeeeee,
                0x113366,
                0x113366,
                0x113366,
                0x113366,
                0x113366,
                0x113366,
                0x113366,
                0xeeeeee,
                0x113366,
                0x113366,
                0x113366,
                0x113366,
                0x113366
            ],
            helixAngle: 35
        }
    },
    halyard: {
        // Classic halyard U-shape: tail cleated on the foredeck FORWARD of the
        // mast, runs up the forward face to the masthead sheave, wraps ~180°,
        // and comes back down the aft face to the sail head. Forward-cleat +
        // aft-head puts the ascending and descending runs on opposite sides of
        // the pulley so both segments read clearly from above.
        cleatPoint: (0, $6b6a54a072724620$export$e7c866399fa523f5)(7.5, 0.2),
        cleatZ: 2.8,
        // Sheave sits at the mast centerline, a couple of feet above the sail
        // head's fully-hoisted position — real masthead hardware keeps the
        // sheave above the sail track so the head can swing freely. Rendering
        // extends the mast up to the sheave, producing a visible drop from the
        // pulley back down to the head.
        sheaveElevation: 2.0,
        sheaveRadius: 0.25,
        // Sail-head shackle rides aft of the mast, along the sail's luff
        // track — gives the descending segment a substantial XY offset so it
        // doesn't collapse into the mast cylinder from above.
        headOffset: (0, $6b6a54a072724620$export$e7c866399fa523f5)(-0.6, 0),
        ropeThickness: 0.15,
        ropeColor: 0xeeeeee
    },
    rowing: {
        duration: 0.7,
        force: 7000
    },
    grounding: {
        keelFriction: 800,
        rudderFriction: 500,
        hullFriction: 3200
    },
    bilge: {
        bailBucketSize: 0.4,
        bailInterval: 1.0,
        waterDensity: 64,
        sloshFreqLateral: 4.0,
        sloshFreqLongitudinal: 2.2,
        sloshDampingRatio: 0.4,
        sinkingDuration: 15.0
    },
    hullDamage: {
        groundingDamageRate: 0.15,
        groundingSpeedThreshold: 1.0,
        damageFrictionMultiplier: 2.0,
        damageLeakRate: 0.4,
        repairRate: 0
    },
    rudderDamage: {
        groundingDamageRate: 0.25,
        groundingSpeedThreshold: 0.8,
        maxSteeringReduction: 0.7,
        maxSteeringBias: 0.3,
        repairRate: 0
    },
    sailDamage: {
        overpowerForceThreshold: 600,
        overpowerDamageRate: 0.00004,
        jibeDamagePerForce: 0.00008,
        maxLiftReduction: 0.6,
        repairRate: 0
    },
    // Sailor station layout
    initialStationId: "helm",
    stations: [
        {
            id: "helm",
            name: "Helm",
            position: [
                -8,
                0
            ],
            steerAxis: "rudder",
            primaryAxis: "mainsheet",
            secondaryAxis: "jibSheets"
        },
        {
            id: "mast",
            name: "Mast",
            position: [
                5,
                0
            ],
            primaryAxis: "mainHoist",
            actions: [
                "bail"
            ]
        },
        {
            id: "bow",
            name: "Bow",
            position: [
                11,
                0
            ],
            primaryAxis: "jibHoistFurl",
            actions: [
                "anchor",
                "mooring"
            ]
        }
    ],
    // Tilt parameters derived from hull geometry and ~2100 lb displacement
    // (900 lb hull + 600 lb keel ballast + ~600 lb crew/rigging/sails/supplies).
    // GM_roll ≈ 3.0 ft (swing keel, moderate form stability).
    tilt: {
        rollInertia: 14933,
        pitchInertia: 66445,
        rollDamping: 22007,
        pitchDamping: 56854,
        rightingMomentCoeff: 202696,
        pitchRightingCoeff: 304044,
        waveRollCoeff: 2000,
        wavePitchCoeff: 2000,
        zHeights: {
            deck: 1.2,
            boom: 4.0,
            mastTop: 26,
            keel: -3.75,
            rudder: -1.5,
            bowsprit: 2.5
        }
    },
    buoyancy: {
        verticalMass: 2100,
        rollInertia: 14933,
        pitchInertia: 66445,
        centerOfGravityZ: -1.2,
        zHeights: {
            deck: 1.2,
            boom: 4.0,
            mastTop: 26,
            keel: -3.75,
            rudder: -1.5,
            bowsprit: 2.5
        }
    }
};


const $15d2d1238b44a5eb$export$4932a959e7a6b520 = (0, $ef964d2446f06ea8$export$292cc4076c86be71)((0, $7154ee0e27d3cb2e$export$989dedabf426811c)((0, $629e228c0746ac24$export$316bcd36a9fcbe45), (0, $7154ee0e27d3cb2e$export$877edbcccdf46bfb)), {
    hull: {
        mass: 640,
        skinFrictionCoefficient: 0.0025
    },
    keel: {
        draft: 3.83
    },
    rudder: {
        steerAdjustSpeed: 0.9,
        steerAdjustSpeedFast: 2.2
    },
    rig: {
        mainsail: {
            liftScale: 1.05,
            dragScale: 0.9
        }
    },
    jib: {
        liftScale: 1.05,
        dragScale: 0.9
    },
    hullDamage: {
        groundingDamageRate: 0.2
    },
    tilt: {
        rollInertia: 12729,
        pitchInertia: 56635,
        rollDamping: 17602,
        pitchDamping: 48466,
        rightingMomentCoeff: 152082,
        pitchRightingCoeff: 259201,
        waveRollCoeff: 1500,
        wavePitchCoeff: 1700
    },
    buoyancy: {
        verticalMass: 1790,
        rollInertia: 12729,
        pitchInertia: 56635,
        centerOfGravityZ: -1.1,
        zHeights: {
            keel: -3.83
        }
    }
});






function $465f9271ed7bfe48$export$56f2bd11627aefc4(base, sx, sy, sz) {
    const h = base.hull;
    const k = base.keel;
    const r = base.rudder;
    const rig = base.rig;
    const a = base.anchor;
    const ms = base.mainsheet;
    const js = base.jibSheet;
    const ll = base.lifelines;
    const bp = base.bowsprit;
    return {
        hull: {
            ...h,
            vertices: h.vertices.map((v)=>(0, $6b6a54a072724620$export$e7c866399fa523f5)(v[0] * sx, v[1] * sy)),
            shape: {
                ...h.shape,
                stations: h.shape.stations.map((s)=>({
                        x: s.x * sx,
                        profile: s.profile.map(([y, z])=>[
                                y * sy,
                                z * sz
                            ])
                    }))
            },
            deckPlan: h.deckPlan ? {
                zones: h.deckPlan.zones.map((zone)=>({
                        ...zone,
                        outline: zone.outline.map(([x, y])=>[
                                x * sx,
                                y * sy
                            ]),
                        floorZ: zone.floorZ * sz,
                        wallHeight: zone.wallHeight !== undefined ? zone.wallHeight * sz : undefined
                    }))
            } : undefined,
            draft: h.draft * sz,
            deckHeight: h.deckHeight * sz
        },
        keel: {
            ...k,
            vertices: k.vertices.map((v)=>(0, $6b6a54a072724620$export$e7c866399fa523f5)(v[0] * sx, v[1] * sy)),
            chord: k.chord * sz
        },
        rudder: {
            ...r,
            position: (0, $6b6a54a072724620$export$e7c866399fa523f5)(r.position[0] * sx, r.position[1] * sy),
            length: r.length * sy,
            chord: r.chord * sz
        },
        helm: base.helm ? {
            ...base.helm,
            position: base.helm.position ? (0, $6b6a54a072724620$export$e7c866399fa523f5)(base.helm.position[0] * sx, base.helm.position[1] * sy) : undefined,
            radius: base.helm.radius !== undefined ? base.helm.radius * Math.min(sx, sy) : undefined
        } : undefined,
        rig: {
            ...rig,
            mastPosition: (0, $6b6a54a072724620$export$e7c866399fa523f5)(rig.mastPosition[0] * sx, rig.mastPosition[1] * sy),
            boomLength: rig.boomLength * sx,
            boomWidth: rig.boomWidth * sy,
            boomMass: rig.boomMass * sx,
            mainsail: {
                ...rig.mainsail,
                zFoot: rig.mainsail.zFoot !== undefined ? rig.mainsail.zFoot * sz : undefined,
                zHead: rig.mainsail.zHead !== undefined ? rig.mainsail.zHead * sz : undefined
            },
            stays: {
                forestay: (0, $6b6a54a072724620$export$e7c866399fa523f5)(rig.stays.forestay[0] * sx, rig.stays.forestay[1] * sy),
                portShroud: (0, $6b6a54a072724620$export$e7c866399fa523f5)(rig.stays.portShroud[0] * sx, rig.stays.portShroud[1] * sy),
                starboardShroud: (0, $6b6a54a072724620$export$e7c866399fa523f5)(rig.stays.starboardShroud[0] * sx, rig.stays.starboardShroud[1] * sy),
                backstay: {
                    split: (0, $6b6a54a072724620$export$e7c866399fa523f5)(rig.stays.backstay.split[0] * sx, rig.stays.backstay.split[1] * sy),
                    splitZ: rig.stays.backstay.splitZ * sz,
                    port: (0, $6b6a54a072724620$export$e7c866399fa523f5)(rig.stays.backstay.port[0] * sx, rig.stays.backstay.port[1] * sy),
                    starboard: (0, $6b6a54a072724620$export$e7c866399fa523f5)(rig.stays.backstay.starboard[0] * sx, rig.stays.backstay.starboard[1] * sy)
                },
                deckHeight: rig.stays.deckHeight * sz
            }
        },
        bowsprit: bp ? {
            ...bp,
            attachPoint: (0, $6b6a54a072724620$export$e7c866399fa523f5)(bp.attachPoint[0] * sx, bp.attachPoint[1] * sy),
            size: (0, $6b6a54a072724620$export$e7c866399fa523f5)(bp.size[0] * sx, bp.size[1] * sy)
        } : undefined,
        lifelines: ll ? {
            ...ll,
            portStanchions: ll.portStanchions.map(([x, y])=>[
                    x * sx,
                    y * sy
                ]),
            starboardStanchions: ll.starboardStanchions.map(([x, y])=>[
                    x * sx,
                    y * sy
                ]),
            bowPulpit: ll.bowPulpit.map(([x, y])=>[
                    x * sx,
                    y * sy
                ]),
            sternPulpit: ll.sternPulpit.map(([x, y])=>[
                    x * sx,
                    y * sy
                ]),
            stanchionHeight: ll.stanchionHeight * sz,
            tubeWidth: ll.tubeWidth * Math.min(sx, sy),
            wireWidth: ll.wireWidth * Math.min(sx, sy)
        } : undefined,
        anchor: {
            ...a,
            bowAttachPoint: (0, $6b6a54a072724620$export$e7c866399fa523f5)(a.bowAttachPoint[0] * sx, a.bowAttachPoint[1] * sy),
            maxRodeLength: a.maxRodeLength * sx,
            anchorSize: a.anchorSize * Math.sqrt(sx * sy),
            anchorMass: a.anchorMass * sx * sy * sz,
            deckHeight: a.deckHeight * sz,
            rodeAttachOffset: [
                a.rodeAttachOffset[0] * sx,
                a.rodeAttachOffset[1] * sy,
                a.rodeAttachOffset[2] * sz
            ]
        },
        jib: base.jib ? {
            ...base.jib,
            zFoot: base.jib.zFoot !== undefined ? base.jib.zFoot * sz : undefined,
            zHead: base.jib.zHead !== undefined ? base.jib.zHead * sz : undefined
        } : undefined,
        mainsheet: {
            ...ms,
            hullAttachPoint: (0, $6b6a54a072724620$export$e7c866399fa523f5)(ms.hullAttachPoint[0] * sx, ms.hullAttachPoint[1] * sy),
            winchPoint: ms.winchPoint ? (0, $6b6a54a072724620$export$e7c866399fa523f5)(ms.winchPoint[0] * sx, ms.winchPoint[1] * sy) : undefined,
            minLength: (ms.minLength ?? 2) * sx,
            maxLength: (ms.maxLength ?? 12) * sx
        },
        jibSheet: js ? {
            ...js,
            portAttachPoint: (0, $6b6a54a072724620$export$e7c866399fa523f5)(js.portAttachPoint[0] * sx, js.portAttachPoint[1] * sy),
            starboardAttachPoint: (0, $6b6a54a072724620$export$e7c866399fa523f5)(js.starboardAttachPoint[0] * sx, js.starboardAttachPoint[1] * sy),
            portBlockPoint: js.portBlockPoint ? (0, $6b6a54a072724620$export$e7c866399fa523f5)(js.portBlockPoint[0] * sx, js.portBlockPoint[1] * sy) : undefined,
            starboardBlockPoint: js.starboardBlockPoint ? (0, $6b6a54a072724620$export$e7c866399fa523f5)(js.starboardBlockPoint[0] * sx, js.starboardBlockPoint[1] * sy) : undefined,
            portWinchPoint: js.portWinchPoint ? (0, $6b6a54a072724620$export$e7c866399fa523f5)(js.portWinchPoint[0] * sx, js.portWinchPoint[1] * sy) : undefined,
            starboardWinchPoint: js.starboardWinchPoint ? (0, $6b6a54a072724620$export$e7c866399fa523f5)(js.starboardWinchPoint[0] * sx, js.starboardWinchPoint[1] * sy) : undefined,
            minLength: (js.minLength ?? 6) * sx,
            maxLength: (js.maxLength ?? 18) * sx
        } : undefined,
        halyard: {
            ...base.halyard,
            cleatPoint: (0, $6b6a54a072724620$export$e7c866399fa523f5)(base.halyard.cleatPoint[0] * sx, base.halyard.cleatPoint[1] * sy),
            cleatZ: base.halyard.cleatZ * sz,
            sheaveOffset: base.halyard.sheaveOffset ? (0, $6b6a54a072724620$export$e7c866399fa523f5)(base.halyard.sheaveOffset[0] * sx, base.halyard.sheaveOffset[1] * sy) : undefined,
            sheaveElevation: base.halyard.sheaveElevation !== undefined ? base.halyard.sheaveElevation * sz : undefined,
            headOffset: base.halyard.headOffset ? (0, $6b6a54a072724620$export$e7c866399fa523f5)(base.halyard.headOffset[0] * sx, base.halyard.headOffset[1] * sy) : undefined
        },
        rowing: {
            ...base.rowing,
            force: base.rowing.force * sx * sy
        },
        initialStationId: base.initialStationId,
        stations: base.stations.map((s)=>({
                ...s,
                position: [
                    s.position[0] * sx,
                    s.position[1] * sy
                ]
            })),
        grounding: {
            keelFriction: base.grounding.keelFriction * sx * sy,
            rudderFriction: base.grounding.rudderFriction * sx * sy,
            hullFriction: base.grounding.hullFriction * sx * sy
        },
        bilge: {
            ...base.bilge,
            bailBucketSize: base.bilge.bailBucketSize * sx * sy * sz
        },
        hullDamage: {
            ...base.hullDamage
        },
        rudderDamage: {
            ...base.rudderDamage
        },
        sailDamage: {
            ...base.sailDamage,
            // Scale the force threshold with sail area (sx * sz) so damage
            // activation stays proportional to the bigger rig's loads.
            overpowerForceThreshold: base.sailDamage.overpowerForceThreshold * sx * sz
        },
        tilt: {
            ...base.tilt,
            zHeights: {
                deck: base.tilt.zHeights.deck * sz,
                boom: base.tilt.zHeights.boom * sz,
                mastTop: base.tilt.zHeights.mastTop * sz,
                keel: base.tilt.zHeights.keel * sz,
                rudder: base.tilt.zHeights.rudder * sz,
                bowsprit: base.tilt.zHeights.bowsprit * sz
            }
        },
        buoyancy: {
            ...base.buoyancy,
            zHeights: {
                deck: base.buoyancy.zHeights.deck * sz,
                boom: base.buoyancy.zHeights.boom * sz,
                mastTop: base.buoyancy.zHeights.mastTop * sz,
                keel: base.buoyancy.zHeights.keel * sz,
                rudder: base.buoyancy.zHeights.rudder * sz,
                bowsprit: base.buoyancy.zHeights.bowsprit * sz
            }
        }
    };
}



// J/105: LOA 34.5ft, beam 11ft, draft 6.5ft, disp 7750 lbs, ballast 3400 lbs (44%)
const $25abc6f868b897a0$var$sx = 1.533; // 34.5 / 22.5
const $25abc6f868b897a0$var$sy = 1.375; // (11 / 2) / 4.0 half-beam
const $25abc6f868b897a0$var$sz = $25abc6f868b897a0$var$sx;
const $25abc6f868b897a0$export$159425d2e13e2762 = (0, $ef964d2446f06ea8$export$292cc4076c86be71)((0, $7154ee0e27d3cb2e$export$989dedabf426811c)((0, $465f9271ed7bfe48$export$56f2bd11627aefc4)((0, $629e228c0746ac24$export$316bcd36a9fcbe45), $25abc6f868b897a0$var$sx, $25abc6f868b897a0$var$sy, $25abc6f868b897a0$var$sz), (0, $7154ee0e27d3cb2e$export$877edbcccdf46bfb)), {
    hull: {
        mass: 3450,
        skinFrictionCoefficient: 0.0025
    },
    keel: {
        draft: 6.5
    },
    rudder: {
        draft: 4.6,
        steerAdjustSpeed: 0.9,
        steerAdjustSpeedFast: 2.2
    },
    helm: {
        type: "wheel",
        position: (0, $6b6a54a072724620$export$e7c866399fa523f5)(-10, 0),
        radius: 1.7,
        turns: 1.5
    },
    rig: {
        mainsail: {
            liftScale: 1.05,
            dragScale: 0.9
        }
    },
    jib: {
        liftScale: 1.05,
        dragScale: 0.9
    },
    hullDamage: {
        groundingDamageRate: 0.2
    },
    tilt: {
        rollInertia: 104147,
        pitchInertia: 576486,
        rollDamping: 122742,
        pitchDamping: 398276,
        rightingMomentCoeff: 904108,
        pitchRightingCoeff: 1719862,
        waveRollCoeff: 9000,
        wavePitchCoeff: 11000
    },
    buoyancy: {
        verticalMass: 7750,
        rollInertia: 104147,
        pitchInertia: 576486,
        centerOfGravityZ: -2.2,
        zHeights: {
            keel: -6.5
        }
    }
});







// J/133: LOA 43ft, beam 12.75ft, draft 7.5ft, disp 17900 lbs, ballast 6900 lbs (38.5%)
const $3df8a6c50260f72e$var$sx = 1.911; // 43.0 / 22.5
const $3df8a6c50260f72e$var$sy = 1.594; // (12.75 / 2) / 4.0 half-beam
const $3df8a6c50260f72e$var$sz = $3df8a6c50260f72e$var$sx;
const $3df8a6c50260f72e$export$d53f99a813f4ed00 = (0, $ef964d2446f06ea8$export$292cc4076c86be71)((0, $7154ee0e27d3cb2e$export$989dedabf426811c)((0, $465f9271ed7bfe48$export$56f2bd11627aefc4)((0, $629e228c0746ac24$export$316bcd36a9fcbe45), $3df8a6c50260f72e$var$sx, $3df8a6c50260f72e$var$sy, $3df8a6c50260f72e$var$sz), (0, $7154ee0e27d3cb2e$export$877edbcccdf46bfb)), {
    hull: {
        mass: 9500,
        skinFrictionCoefficient: 0.0025
    },
    keel: {
        draft: 7.5
    },
    rudder: {
        draft: 5.7,
        steerAdjustSpeed: 0.85,
        steerAdjustSpeedFast: 2.0
    },
    helm: {
        type: "wheel",
        position: (0, $6b6a54a072724620$export$e7c866399fa523f5)(-13, 0),
        radius: 2.0,
        turns: 1.5
    },
    rig: {
        mainsail: {
            liftScale: 1.05,
            dragScale: 0.9
        }
    },
    jib: {
        liftScale: 1.05,
        dragScale: 0.9
    },
    hullDamage: {
        groundingDamageRate: 0.18
    },
    tilt: {
        rollInertia: 323287,
        pitchInertia: 2068490,
        rollDamping: 354124,
        pitchDamping: 1280000,
        rightingMomentCoeff: 2424593,
        pitchRightingCoeff: 4951000,
        waveRollCoeff: 24000,
        wavePitchCoeff: 32500
    },
    buoyancy: {
        verticalMass: 17900,
        rollInertia: 323287,
        pitchInertia: 2068490,
        centerOfGravityZ: -2.8,
        zHeights: {
            keel: -7.5
        }
    }
});







// Farr 60: LOA 60.25ft, beam 18ft, draft 9.17ft, disp 54000 lbs, ballast 18000 lbs (33%)
const $6d9855689a5e7a90$var$sx = 2.678; // 60.25 / 22.5
const $6d9855689a5e7a90$var$sy = 2.25; // (18.0 / 2) / 4.0 half-beam
const $6d9855689a5e7a90$var$sz = $6d9855689a5e7a90$var$sx;
const $6d9855689a5e7a90$export$5188184813ddfa14 = (0, $ef964d2446f06ea8$export$292cc4076c86be71)((0, $7154ee0e27d3cb2e$export$989dedabf426811c)((0, $465f9271ed7bfe48$export$56f2bd11627aefc4)((0, $629e228c0746ac24$export$316bcd36a9fcbe45), $6d9855689a5e7a90$var$sx, $6d9855689a5e7a90$var$sy, $6d9855689a5e7a90$var$sz), (0, $7154ee0e27d3cb2e$export$877edbcccdf46bfb)), {
    hull: {
        mass: 33500,
        skinFrictionCoefficient: 0.0023
    },
    keel: {
        draft: 9.17
    },
    rudder: {
        draft: 8.0,
        steerAdjustSpeed: 0.75,
        steerAdjustSpeedFast: 1.8
    },
    helm: {
        type: "wheel",
        position: (0, $6b6a54a072724620$export$e7c866399fa523f5)(-18, 0),
        radius: 2.8,
        turns: 1.5
    },
    rig: {
        mainsail: {
            liftScale: 1.08,
            dragScale: 0.88
        }
    },
    jib: {
        liftScale: 1.08,
        dragScale: 0.88
    },
    hullDamage: {
        groundingDamageRate: 0.15
    },
    tilt: {
        rollInertia: 1944000,
        pitchInertia: 12251520,
        rollDamping: 1792000,
        pitchDamping: 6406000,
        rightingMomentCoeff: 10320232,
        pitchRightingCoeff: 20935622,
        waveRollCoeff: 102000,
        wavePitchCoeff: 138000
    },
    buoyancy: {
        verticalMass: 54000,
        rollInertia: 1944000,
        pitchInertia: 12251520,
        centerOfGravityZ: -3.5,
        zHeights: {
            keel: -9.17
        }
    }
});






// Catalina 22: LOA 21.5ft, beam 7.67ft, draft 5.0ft (swing keel down), disp 2490 lbs, ballast 800 lbs (32%)
const $f8654cd672e9a2f9$var$sx = 0.956; // 21.5 / 22.5
const $f8654cd672e9a2f9$var$sy = 0.956; // uniform (beam scales similarly)
const $f8654cd672e9a2f9$var$sz = $f8654cd672e9a2f9$var$sx;
const $f8654cd672e9a2f9$export$c057f9a6df871496 = (0, $ef964d2446f06ea8$export$292cc4076c86be71)((0, $7154ee0e27d3cb2e$export$989dedabf426811c)((0, $465f9271ed7bfe48$export$56f2bd11627aefc4)((0, $629e228c0746ac24$export$316bcd36a9fcbe45), $f8654cd672e9a2f9$var$sx, $f8654cd672e9a2f9$var$sy, $f8654cd672e9a2f9$var$sz), (0, $7154ee0e27d3cb2e$export$abaec88eb99a7b21)), {
    hull: {
        mass: 1240,
        skinFrictionCoefficient: 0.0035
    },
    keel: {
        draft: 5.0
    },
    rudder: {
        draft: 2.87,
        steerAdjustSpeed: 0.65,
        steerAdjustSpeedFast: 1.6
    },
    rig: {
        mainsail: {
            liftScale: 0.92,
            dragScale: 1.05
        }
    },
    jib: {
        liftScale: 0.92,
        dragScale: 1.05
    },
    hullDamage: {
        groundingDamageRate: 0.12
    },
    tilt: {
        rollInertia: 16230,
        pitchInertia: 71939,
        rollDamping: 28264,
        pitchDamping: 62985,
        rightingMomentCoeff: 307638,
        pitchRightingCoeff: 344556,
        waveRollCoeff: 3000,
        wavePitchCoeff: 2300
    },
    buoyancy: {
        verticalMass: 2490,
        rollInertia: 16230,
        pitchInertia: 71939,
        centerOfGravityZ: -1.5,
        zHeights: {
            keel: -5
        }
    }
});







// Catalina 30: LOA 29.92ft, beam 10.83ft, draft 5.25ft, disp 10200 lbs, ballast 4200 lbs (41%)
const $2dd6935249bb0d67$var$sx = 1.33; // 29.92 / 22.5
const $2dd6935249bb0d67$var$sy = 1.354; // (10.83 / 2) / 4.0 half-beam
const $2dd6935249bb0d67$var$sz = $2dd6935249bb0d67$var$sx;
const $2dd6935249bb0d67$export$29b02d3ee8978da = (0, $ef964d2446f06ea8$export$292cc4076c86be71)((0, $7154ee0e27d3cb2e$export$989dedabf426811c)((0, $465f9271ed7bfe48$export$56f2bd11627aefc4)((0, $629e228c0746ac24$export$316bcd36a9fcbe45), $2dd6935249bb0d67$var$sx, $2dd6935249bb0d67$var$sy, $2dd6935249bb0d67$var$sz), (0, $7154ee0e27d3cb2e$export$abaec88eb99a7b21)), {
    hull: {
        mass: 5100,
        skinFrictionCoefficient: 0.0033
    },
    keel: {
        draft: 5.25
    },
    rudder: {
        draft: 4.0,
        steerAdjustSpeed: 0.65,
        steerAdjustSpeedFast: 1.6
    },
    helm: {
        type: "wheel",
        position: (0, $6b6a54a072724620$export$e7c866399fa523f5)(-9, 0),
        radius: 1.5,
        turns: 1.5
    },
    rig: {
        mainsail: {
            liftScale: 0.92,
            dragScale: 1.05
        }
    },
    jib: {
        liftScale: 0.92,
        dragScale: 1.05
    },
    hullDamage: {
        groundingDamageRate: 0.12
    },
    tilt: {
        rollInertia: 132704,
        pitchInertia: 570763,
        rollDamping: 194258,
        pitchDamping: 423424,
        rightingMomentCoeff: 1777750,
        pitchRightingCoeff: 1962881,
        waveRollCoeff: 17500,
        wavePitchCoeff: 13000
    },
    buoyancy: {
        verticalMass: 10200,
        rollInertia: 132704,
        pitchInertia: 570763,
        centerOfGravityZ: -1.7,
        zHeights: {
            keel: -5.25
        }
    }
});







// Catalina 42 MkII: LOA 41.83ft, beam 13.83ft, draft 6.0ft, disp 20500 lbs, ballast 8300 lbs (40%)
const $517bcd07177ba604$var$sx = 1.859; // 41.83 / 22.5
const $517bcd07177ba604$var$sy = 1.729; // (13.83 / 2) / 4.0 half-beam
const $517bcd07177ba604$var$sz = $517bcd07177ba604$var$sx;
const $517bcd07177ba604$export$ab94cb2b46827db6 = (0, $ef964d2446f06ea8$export$292cc4076c86be71)((0, $7154ee0e27d3cb2e$export$989dedabf426811c)((0, $465f9271ed7bfe48$export$56f2bd11627aefc4)((0, $629e228c0746ac24$export$316bcd36a9fcbe45), $517bcd07177ba604$var$sx, $517bcd07177ba604$var$sy, $517bcd07177ba604$var$sz), (0, $7154ee0e27d3cb2e$export$abaec88eb99a7b21)), {
    hull: {
        mass: 10700,
        skinFrictionCoefficient: 0.0033
    },
    keel: {
        draft: 6.0
    },
    rudder: {
        draft: 5.6,
        steerAdjustSpeed: 0.62,
        steerAdjustSpeedFast: 1.5
    },
    helm: {
        type: "wheel",
        position: (0, $6b6a54a072724620$export$e7c866399fa523f5)(-12.5, 0),
        radius: 2.0,
        turns: 1.5
    },
    rig: {
        mainsail: {
            liftScale: 0.92,
            dragScale: 1.05
        }
    },
    jib: {
        liftScale: 0.92,
        dragScale: 1.05
    },
    hullDamage: {
        groundingDamageRate: 0.1
    },
    tilt: {
        rollInertia: 435625,
        pitchInertia: 2230810,
        rollDamping: 564000,
        pitchDamping: 1403000,
        rightingMomentCoeff: 4564204,
        pitchRightingCoeff: 5520576,
        waveRollCoeff: 45000,
        wavePitchCoeff: 36000
    },
    buoyancy: {
        verticalMass: 20500,
        rollInertia: 435625,
        pitchInertia: 2230810,
        centerOfGravityZ: -2.3,
        zHeights: {
            keel: -6
        }
    }
});







// Oyster 575: LOA 58.67ft, beam 16.42ft, draft 8.82ft, disp 58422 lbs, ballast 17855 lbs (30.6%)
const $3824aca903ff016f$var$sx = 2.608; // 58.67 / 22.5
const $3824aca903ff016f$var$sy = 2.053; // (16.42 / 2) / 4.0 half-beam
const $3824aca903ff016f$var$sz = $3824aca903ff016f$var$sx;
const $3824aca903ff016f$export$f5a343db5beaa01f = (0, $ef964d2446f06ea8$export$292cc4076c86be71)((0, $7154ee0e27d3cb2e$export$989dedabf426811c)((0, $465f9271ed7bfe48$export$56f2bd11627aefc4)((0, $629e228c0746ac24$export$316bcd36a9fcbe45), $3824aca903ff016f$var$sx, $3824aca903ff016f$var$sy, $3824aca903ff016f$var$sz), (0, $7154ee0e27d3cb2e$export$abaec88eb99a7b21)), {
    hull: {
        mass: 38067,
        skinFrictionCoefficient: 0.0033
    },
    keel: {
        draft: 8.82
    },
    rudder: {
        draft: 7.8,
        steerAdjustSpeed: 0.58,
        steerAdjustSpeedFast: 1.4
    },
    helm: {
        type: "wheel",
        position: (0, $6b6a54a072724620$export$e7c866399fa523f5)(-17, 0),
        radius: 2.6,
        turns: 1.5
    },
    rig: {
        mainsail: {
            liftScale: 0.92,
            dragScale: 1.05
        }
    },
    jib: {
        liftScale: 0.92,
        dragScale: 1.05
    },
    hullDamage: {
        groundingDamageRate: 0.08
    },
    tilt: {
        rollInertia: 1748827,
        pitchInertia: 12551719,
        rollDamping: 2078000,
        pitchDamping: 6652000,
        rightingMomentCoeff: 15429984,
        pitchRightingCoeff: 22041000,
        waveRollCoeff: 152000,
        wavePitchCoeff: 145000
    },
    buoyancy: {
        verticalMass: 58422,
        rollInertia: 1748827,
        pitchInertia: 12551719,
        centerOfGravityZ: -3.2,
        zHeights: {
            keel: -8.82
        }
    }
});






// J/24: LOA 24ft, beam 8.9ft, draft 4.0ft, disp 3100 lbs, ballast 950 lbs (30.6%)
const $16119decb1123822$var$sx = 1.067; // 24.0 / 22.5
const $16119decb1123822$var$sy = 1.067; // uniform (beam 8.54ft vs actual 8.9ft — close enough)
const $16119decb1123822$var$sz = $16119decb1123822$var$sx;
const $16119decb1123822$export$958feed7eef456ff = (0, $ef964d2446f06ea8$export$292cc4076c86be71)((0, $7154ee0e27d3cb2e$export$989dedabf426811c)((0, $465f9271ed7bfe48$export$56f2bd11627aefc4)((0, $629e228c0746ac24$export$316bcd36a9fcbe45), $16119decb1123822$var$sx, $16119decb1123822$var$sy, $16119decb1123822$var$sz), (0, $7154ee0e27d3cb2e$export$d0e813f3f2fad874)), {
    hull: {
        mass: 1700,
        skinFrictionCoefficient: 0.0028
    },
    keel: {
        draft: 4.0
    },
    rudder: {
        draft: 3.2,
        steerAdjustSpeed: 0.78,
        steerAdjustSpeedFast: 1.95
    },
    rig: {
        mainsail: {
            liftScale: 1.0,
            dragScale: 0.95
        }
    },
    jib: {
        liftScale: 1.0,
        dragScale: 0.95
    },
    hullDamage: {
        groundingDamageRate: 0.14
    },
    tilt: {
        rollInertia: 25107,
        pitchInertia: 111600,
        rollDamping: 37940,
        pitchDamping: 92459,
        rightingMomentCoeff: 358241,
        pitchRightingCoeff: 478753,
        waveRollCoeff: 3500,
        wavePitchCoeff: 3100
    },
    buoyancy: {
        verticalMass: 3100,
        rollInertia: 25107,
        pitchInertia: 111600,
        centerOfGravityZ: -1.5,
        zHeights: {
            keel: -4
        }
    }
});







// Dehler 34: LOA 35.1ft, beam 11.8ft, draft 6.4ft, disp 13117 lbs, ballast 4630 lbs (35%)
const $61f11857d1d358b1$var$sx = 1.56; // 35.1 / 22.5
const $61f11857d1d358b1$var$sy = 1.475; // (11.8 / 2) / 4.0 half-beam
const $61f11857d1d358b1$var$sz = $61f11857d1d358b1$var$sx;
const $61f11857d1d358b1$export$b18b136ccaf0cee5 = (0, $ef964d2446f06ea8$export$292cc4076c86be71)((0, $7154ee0e27d3cb2e$export$989dedabf426811c)((0, $465f9271ed7bfe48$export$56f2bd11627aefc4)((0, $629e228c0746ac24$export$316bcd36a9fcbe45), $61f11857d1d358b1$var$sx, $61f11857d1d358b1$var$sy, $61f11857d1d358b1$var$sz), (0, $7154ee0e27d3cb2e$export$d0e813f3f2fad874)), {
    hull: {
        mass: 7587,
        skinFrictionCoefficient: 0.0027
    },
    keel: {
        draft: 6.4
    },
    rudder: {
        draft: 4.7,
        steerAdjustSpeed: 0.78,
        steerAdjustSpeedFast: 1.95
    },
    helm: {
        type: "wheel",
        position: (0, $6b6a54a072724620$export$e7c866399fa523f5)(-10.5, 0),
        radius: 1.7,
        turns: 1.5
    },
    rig: {
        mainsail: {
            liftScale: 1.0,
            dragScale: 0.95
        }
    },
    jib: {
        liftScale: 1.0,
        dragScale: 0.95
    },
    hullDamage: {
        groundingDamageRate: 0.13
    },
    tilt: {
        rollInertia: 202453,
        pitchInertia: 1009668,
        rollDamping: 260366,
        pitchDamping: 691762,
        rightingMomentCoeff: 2093017,
        pitchRightingCoeff: 2962006,
        waveRollCoeff: 20700,
        wavePitchCoeff: 19500
    },
    buoyancy: {
        verticalMass: 13117,
        rollInertia: 202453,
        pitchInertia: 1009668,
        centerOfGravityZ: -2,
        zHeights: {
            keel: -6.4
        }
    }
});







// Jeanneau Sun Odyssey 45: LOA 45ft, beam 14.8ft, draft 6.7ft, disp 22250 lbs, ballast 6504 lbs
const $cdedc71a6fbe09f4$var$sx = 2.0; // 45.0 / 22.5
const $cdedc71a6fbe09f4$var$sy = 1.85; // (14.8 / 2) / 4.0 half-beam
const $cdedc71a6fbe09f4$var$sz = $cdedc71a6fbe09f4$var$sx;
const $cdedc71a6fbe09f4$export$957df533eedbfa69 = (0, $ef964d2446f06ea8$export$292cc4076c86be71)((0, $7154ee0e27d3cb2e$export$989dedabf426811c)((0, $465f9271ed7bfe48$export$56f2bd11627aefc4)((0, $629e228c0746ac24$export$316bcd36a9fcbe45), $cdedc71a6fbe09f4$var$sx, $cdedc71a6fbe09f4$var$sy, $cdedc71a6fbe09f4$var$sz), (0, $7154ee0e27d3cb2e$export$d0e813f3f2fad874)), {
    hull: {
        mass: 14246,
        skinFrictionCoefficient: 0.0027
    },
    keel: {
        draft: 6.7
    },
    rudder: {
        draft: 6.0,
        steerAdjustSpeed: 0.75,
        steerAdjustSpeedFast: 1.85
    },
    helm: {
        type: "wheel",
        position: (0, $6b6a54a072724620$export$e7c866399fa523f5)(-13.5, 0),
        radius: 2.1,
        turns: 1.5
    },
    rig: {
        mainsail: {
            liftScale: 1.02,
            dragScale: 0.95
        }
    },
    jib: {
        liftScale: 1.02,
        dragScale: 0.95
    },
    hullDamage: {
        groundingDamageRate: 0.11
    },
    tilt: {
        rollInertia: 540068,
        pitchInertia: 2815900,
        rollDamping: 620418,
        pitchDamping: 1703000,
        rightingMomentCoeff: 4452724,
        pitchRightingCoeff: 6442848,
        waveRollCoeff: 44000,
        wavePitchCoeff: 42500
    },
    buoyancy: {
        verticalMass: 22250,
        rollInertia: 540068,
        pitchInertia: 2815900,
        centerOfGravityZ: -2.5,
        zHeights: {
            keel: -6.7
        }
    }
});







// Swan 60: LOA 61.9ft, beam 16.75ft, draft 9.8ft, disp 52250 lbs, ballast 18078 lbs (34.6%)
const $00659e84c14701b9$var$sx = 2.751; // 61.9 / 22.5
const $00659e84c14701b9$var$sy = 2.094; // (16.75 / 2) / 4.0 half-beam
const $00659e84c14701b9$var$sz = $00659e84c14701b9$var$sx;
const $00659e84c14701b9$export$3a0795937393c2ae = (0, $ef964d2446f06ea8$export$292cc4076c86be71)((0, $7154ee0e27d3cb2e$export$989dedabf426811c)((0, $465f9271ed7bfe48$export$56f2bd11627aefc4)((0, $629e228c0746ac24$export$316bcd36a9fcbe45), $00659e84c14701b9$var$sx, $00659e84c14701b9$var$sy, $00659e84c14701b9$var$sz), (0, $7154ee0e27d3cb2e$export$d0e813f3f2fad874)), {
    hull: {
        mass: 31672,
        skinFrictionCoefficient: 0.0025
    },
    keel: {
        draft: 9.8
    },
    rudder: {
        draft: 8.3,
        steerAdjustSpeed: 0.72,
        steerAdjustSpeedFast: 1.8
    },
    helm: {
        type: "wheel",
        position: (0, $6b6a54a072724620$export$e7c866399fa523f5)(-18.5, 0),
        radius: 2.9,
        turns: 1.5
    },
    rig: {
        mainsail: {
            liftScale: 1.05,
            dragScale: 0.93
        }
    },
    jib: {
        liftScale: 1.05,
        dragScale: 0.93
    },
    hullDamage: {
        groundingDamageRate: 0.1
    },
    tilt: {
        rollInertia: 1628603,
        pitchInertia: 12517233,
        rollDamping: 1756000,
        pitchDamping: 6456000,
        rightingMomentCoeff: 11834874,
        pitchRightingCoeff: 20804000,
        waveRollCoeff: 117000,
        wavePitchCoeff: 137000
    },
    buoyancy: {
        verticalMass: 52250,
        rollInertia: 1628603,
        pitchInertia: 12517233,
        centerOfGravityZ: -3.4,
        zHeights: {
            keel: -9.8
        }
    }
});


function $ef964d2446f06ea8$export$292cc4076c86be71(base, overrides) {
    return (0, $25c6ed34d0d559af$export$6969335ea1e4e77c)(base, overrides);
}


/**
 * Boat grounding physics.
 *
 * Keeps the boat from sinking through the seabed and from passing through
 * terrain when running aground. One {@link TerrainContactConstraint} per
 * contact point (hull-outline vertices at draft depth, rudder, mast tip)
 * couples the hull body to `game.ground` via a point-to-rigid contact
 * equation that supplies both the normal push-up and Coulomb friction for
 * that point.
 *
 * Terrain and water heights are sampled once per tick via GPU queries
 * (1-frame latency). The owning entity keeps the cached floor-z values and
 * each constraint reads its own slot via a closure captured at construction.
 */ 




class $63235e744c2c6cbe$export$aec1359a0a40a615 {
    constructor(bodyA, bodyB, options = {}){
        /** Equations to be solved in this constraint */ this.equations = [];
        this.collideConnected = options?.collideConnected ?? true;
        const wakeUpBodies = options?.wakeUpBodies ?? true;
        this.bodyA = bodyA;
        this.bodyB = bodyB;
        // Wake up dynamic bodies when connected
        if (wakeUpBodies) {
            if (bodyA.motion === "dynamic") bodyA.wakeUp();
            if (bodyB.motion === "dynamic") bodyB.wakeUp();
        }
    }
    /** Set stiffness for this constraint. */ setStiffness(stiffness) {
        const eqs = this.equations;
        for(let i = 0; i !== eqs.length; i++){
            const eq = eqs[i];
            eq.stiffness = stiffness;
            eq.needsUpdate = true;
        }
        return this;
    }
    /** Set relaxation for this constraint. */ setRelaxation(relaxation) {
        const eqs = this.equations;
        for(let i = 0; i !== eqs.length; i++){
            const eq = eqs[i];
            eq.relaxation = relaxation;
            eq.needsUpdate = true;
        }
        return this;
    }
}


class $d08dc95f3f961954$export$fb8c86c8990ab189 extends (0, $63235e744c2c6cbe$export$aec1359a0a40a615) {
    constructor(groundAnchor, hullBody, localX, localY, localZ, getFloorZ, frictionCoefficient = 0.5, options){
        super(groundAnchor, hullBody, options), this._active = false, this._penetration = 0, // Scratch V3d reused across update() calls to avoid per-tick allocation.
        this._scratchContact = new (0, $3480ec8c2fb5ff20$export$d2de7ccaa2f4bf9f)(0, 0, 0);
        this.localX = localX;
        this.localY = localY;
        this.localZ = localZ;
        this.getFloorZ = getFloorZ;
        this.frictionCoefficient = frictionCoefficient;
        const normal = new (0, $7c2ab345e8402709$export$72aece4f82bc5bee)(groundAnchor, hullBody, 0, Number.MAX_VALUE);
        const friction1 = new (0, $7c2ab345e8402709$export$72aece4f82bc5bee)(groundAnchor, hullBody, 0, 0);
        const friction2 = new (0, $7c2ab345e8402709$export$72aece4f82bc5bee)(groundAnchor, hullBody, 0, 0);
        this.equations = [
            normal,
            friction1,
            friction2
        ];
    }
    update() {
        const hull = this.bodyB;
        const normal = this.equations[0];
        const friction1 = this.equations[1];
        const friction2 = this.equations[2];
        const floorZ = this.getFloorZ();
        if (floorZ === null) {
            this.disableAll(normal, friction1, friction2);
            return this;
        }
        // Contact point in world frame (water-relative z, matching hull.body.z).
        const contact = hull.toWorldFrame3D(this.localX, this.localY, this.localZ, this._scratchContact);
        const wx = contact[0];
        const wy = contact[1];
        const wz = contact[2];
        // Signed elevation above the floor. Positive = separated (no force),
        // negative = penetrating (constraint pushes up). Disable when well above.
        const signedDistance = wz - floorZ;
        if (signedDistance > 0.5) {
            this.disableAll(normal, friction1, friction2);
            return this;
        }
        this._active = true;
        this._penetration = Math.max(0, -signedDistance);
        // Lever arm from hull body origin to the contact point, in world frame.
        const rjX = wx - hull.position[0];
        const rjY = wy - hull.position[1];
        const rjZ = wz - hull.z;
        // Normal: origN = -Z (downward). setShapeJacobian stores -origN, so
        // positive lambda pushes body B (+Z) and body A (-Z). See class docs.
        normal.enabled = true;
        this.setShapeJacobian(normal, 0, 0, -1, rjX, rjY, rjZ);
        normal.offset = signedDistance;
        // Friction bounds scale with the most recent normal impulse. Same pattern
        // as DeckContactConstraint.setFriction.
        const normalForce = Math.abs(normal.multiplier);
        const slipForce = this.frictionCoefficient * normalForce;
        if (slipForce > 0) {
            friction1.enabled = true;
            friction1.minForce = -slipForce;
            friction1.maxForce = slipForce;
            friction2.enabled = true;
            friction2.minForce = -slipForce;
            friction2.maxForce = slipForce;
        } else {
            friction1.enabled = false;
            friction2.enabled = false;
        }
        // Tangents: world +X and world +Y. Pure velocity constraints (offset = 0).
        this.setShapeJacobian(friction1, 1, 0, 0, rjX, rjY, rjZ);
        friction1.offset = 0;
        this.setShapeJacobian(friction2, 0, 1, 0, rjX, rjY, rjZ);
        friction2.offset = 0;
        return this;
    }
    /**
   * Write a point-to-rigid constraint direction to the shape fields. Same
   * math as `DeckContactConstraint.setShapeJacobian`: the equation stores a
   * direction `n` where body A linearly receives `-n` and body B `+n`, so we
   * negate the incoming direction when assigning, and the angular block is
   * `rj × (-origN) = rj × n` via the cross product expanded below.
   */ setShapeJacobian(eq, origNx, origNy, origNz, rjX, rjY, rjZ) {
        eq.nx = -origNx;
        eq.ny = -origNy;
        eq.nz = -origNz;
        eq.rjXnX = -(rjY * origNz - rjZ * origNy);
        eq.rjXnY = -(rjZ * origNx - rjX * origNz);
        eq.rjXnZ = -(rjX * origNy - rjY * origNx);
    }
    disableAll(normal, friction1, friction2) {
        normal.enabled = false;
        friction1.enabled = false;
        friction2.enabled = false;
        this._active = false;
        this._penetration = 0;
    }
    /** Whether the constraint is currently engaged (contact point on/below the floor). */ isActive() {
        return this._active;
    }
    /** How far the contact point has penetrated the floor this tick (ft, ≥0). */ getPenetration() {
        return this._penetration;
    }
}




class $1f13ac9ee87de92a$export$e56fd5b11ed42a5c extends (0, $c59361981bac2575$export$4342ba5c6ad1f6f1) {
    constructor(getPoints){
        super(), // Double-buffered: points that match current results
        this._points = [], /**
   * Float32Array view into the QueryManager's shared data buffer.
   * Contains only this query's result data, starting at offset 0.
   * Updated each frame by QueryManager.
   * @internal
   */ this._data = new Float32Array(0), this._resultCount = 0, // Cached results array for backward compatibility with .results accessor
        this._resultsCache = null, this._resultsCacheCount = -1;
        this.getPointsCallback = getPoints;
    }
    /** Number of results currently available. */ get length() {
        return this._resultCount;
    }
    /**
   * Get results as an array (backward compatibility).
   * Prefer using get(i) + length for hot paths.
   */ get results() {
        if (!this._resultsCache || this._resultsCacheCount !== this._resultCount) {
            if (!this._resultsCache) this._resultsCache = [];
            this._resultsCache.length = this._resultCount;
            for(let i = 0; i < this._resultCount; i++)this._resultsCache[i] = this.get(i);
            this._resultsCacheCount = this._resultCount;
        }
        return this._resultsCache;
    }
    /**
   * Get the current query points (synchronized with results).
   */ get points() {
        return this._points;
    }
    /**
   * Get the result for a specific point.
   *
   * @param point The query point to look up
   * @returns The result for that point, or undefined if not found
   */ getResultForPoint(point) {
        const index = this._points.findIndex((p)=>p.equals(point));
        return index >= 0 ? this.get(index) : undefined;
    }
    /**
   * Iterator support for iterating over (point, result) pairs.
   *
   * @example
   * for (const [point, result] of query) {
   *   console.log(`Point ${point} has result ${result}`);
   * }
   */ *[Symbol.iterator]() {
        for(let i = 0; i < this._resultCount; i++)yield [
            this._points[i],
            this.get(i)
        ];
    }
    /**
   * Wait for results and then destroy the query.
   *
   * Useful for one-shot queries:
   * @example
   * const results = await new TerrainQuery(() => [V(0, 0)]).getResultAndDestroy();
   */ async getResultAndDestroy() {
        // Wait one frame for results to be computed
        await new Promise((resolve)=>setTimeout(resolve, 16));
        const results = [];
        for(let i = 0; i < this._resultCount; i++)results.push(this.get(i));
        this.destroy();
        return results;
    }
    /**
   * Internal method called by QueryManager to collect points.
   * Stores points in pending buffer - they'll become active when results arrive.
   * @internal
   */ getQueryPoints() {
        this._pendingPoints = this.getPointsCallback();
        return this._pendingPoints;
    }
    /**
   * Internal method called by QueryManager to deliver result data.
   * Creates a zero-copy Float32Array view into the manager's shared buffer.
   * @internal
   */ receiveData(managerBuffer, floatOffset, count) {
        // Create a zero-copy view into the manager's buffer for this query's slice
        const floatLength = count * this.stride;
        this._data = new Float32Array(managerBuffer.buffer, managerBuffer.byteOffset + floatOffset * Float32Array.BYTES_PER_ELEMENT, floatLength);
        this._resultCount = count;
        this._resultsCacheCount = -1; // invalidate results cache
        // Swap pending points into active
        this._points = this._pendingPoints;
        this._pendingPoints = undefined;
    }
}



var $aed9a4be5f3eb254$export$1bd3aab7cfc60670 = /*#__PURE__*/ function(TerrainType) {
    TerrainType[TerrainType["Water"] = 0] = "Water";
    TerrainType[TerrainType["Sand"] = 1] = "Sand";
    TerrainType[TerrainType["Grass"] = 2] = "Grass";
    TerrainType[TerrainType["Rock"] = 3] = "Rock";
    return TerrainType;
}({});
const $aed9a4be5f3eb254$export$8d2d30a13189ff2e = {
    stride: 4,
    fields: {
        height: 0,
        normalX: 1,
        normalY: 2,
        terrainType: 3
    }
};
class $aed9a4be5f3eb254$export$759fcec56b6ce686 {
    get height() {
        return this._data[this._offset + $aed9a4be5f3eb254$export$8d2d30a13189ff2e.fields.height];
    }
    get normal() {
        this._normal.set(this._data[this._offset + $aed9a4be5f3eb254$export$8d2d30a13189ff2e.fields.normalX], this._data[this._offset + $aed9a4be5f3eb254$export$8d2d30a13189ff2e.fields.normalY]);
        return this._normal;
    }
    get terrainType() {
        return this._data[this._offset + $aed9a4be5f3eb254$export$8d2d30a13189ff2e.fields.terrainType];
    }
    constructor(){
        this._normal = (0, $6b6a54a072724620$export$e7c866399fa523f5)(0, 0);
    }
}


class $178448b994cda479$export$b2f87c4d67934c2d extends (0, $1f13ac9ee87de92a$export$e56fd5b11ed42a5c) {
    constructor(getPoints){
        super(getPoints), this.tags = [
            "terrainQuery"
        ], this.stride = (0, $aed9a4be5f3eb254$export$8d2d30a13189ff2e).stride, this.views = [];
    }
    get(index) {
        let view = this.views[index];
        if (!view) {
            view = new (0, $aed9a4be5f3eb254$export$759fcec56b6ce686)();
            this.views[index] = view;
        }
        view._data = this._data;
        view._offset = index * this.stride;
        return view;
    }
}




const $f728bf7dee894052$export$1b2b4f6c83daac41 = {
    stride: 6,
    fields: {
        surfaceHeight: 0,
        velocityX: 1,
        velocityY: 2,
        normalX: 3,
        normalY: 4,
        depth: 5
    }
};
class $f728bf7dee894052$export$4033ea56299966bb {
    get surfaceHeight() {
        return this._data[this._offset + $f728bf7dee894052$export$1b2b4f6c83daac41.fields.surfaceHeight];
    }
    /**
   * Water current velocity in world frame — the direction the water is flowing TOWARD.
   * Includes contributions from Gerstner wave orbital motion, currents, and modifiers.
   */ get velocity() {
        this._velocity.set(this._data[this._offset + $f728bf7dee894052$export$1b2b4f6c83daac41.fields.velocityX], this._data[this._offset + $f728bf7dee894052$export$1b2b4f6c83daac41.fields.velocityY]);
        return this._velocity;
    }
    get normal() {
        this._normal.set(this._data[this._offset + $f728bf7dee894052$export$1b2b4f6c83daac41.fields.normalX], this._data[this._offset + $f728bf7dee894052$export$1b2b4f6c83daac41.fields.normalY]);
        return this._normal;
    }
    get depth() {
        return this._data[this._offset + $f728bf7dee894052$export$1b2b4f6c83daac41.fields.depth];
    }
    constructor(){
        this._velocity = (0, $6b6a54a072724620$export$e7c866399fa523f5)(0, 0);
        this._normal = (0, $6b6a54a072724620$export$e7c866399fa523f5)(0, 0);
    }
}


class $2f31bbbd4b5b01e3$export$38b1d297f12cec06 extends (0, $1f13ac9ee87de92a$export$e56fd5b11ed42a5c) {
    constructor(getPoints){
        super(getPoints), this.tags = [
            "waterQuery"
        ], this.stride = (0, $f728bf7dee894052$export$1b2b4f6c83daac41).stride, this.views = [];
    }
    get(index) {
        let view = this.views[index];
        if (!view) {
            view = new (0, $f728bf7dee894052$export$4033ea56299966bb)();
            this.views[index] = view;
        }
        view._data = this._data;
        view._offset = index * this.stride;
        return view;
    }
}


class $ef3d72bebf669cf8$export$b3b355ccc72406cc extends (0, $c59361981bac2575$export$4342ba5c6ad1f6f1) {
    constructor(boat){
        super(), // Scratch array for query point positions; reused each tick.
        this.queryPoints = [], this.contactConstraints = [];
        this.boat = boat;
        this.config = boat.config.grounding;
        const hullVertices = boat.config.hull.vertices;
        const rudderPos = boat.config.rudder.position;
        const hullDraft = boat.config.hull.draft;
        const rudderDraft = boat.config.rudder.draft;
        const mastPos = boat.config.rig.mastPosition;
        const mastTopZ = boat.config.rig.mainsail.zHead ?? 20;
        // One contact point under each gunwale/deck vertex, projected down to
        // the hull bottom. Sampling the full outline lets the hull rest tilted
        // on an uneven seabed rather than pivoting on a single center point.
        this.contactLocals = [];
        for (const v of hullVertices)this.contactLocals.push({
            x: v.x,
            y: v.y,
            z: -hullDraft
        });
        this.hullVertexCount = hullVertices.length;
        this.contactLocals.push({
            x: rudderPos.x,
            y: rudderPos.y,
            z: -rudderDraft
        });
        this.rudderIndex = this.contactLocals.length - 1;
        // Mast tip: hull-local XY at the mast pivot, z at the mast head. The
        // mast is rigidly attached to the hull body, so this local point
        // transforms to the mast tip world position every tick through the
        // hull's 3D orientation.
        this.contactLocals.push({
            x: mastPos.x,
            y: mastPos.y,
            z: mastTopZ
        });
        // Pre-allocate query points (updated each tick to match current hull pose).
        for(let i = 0; i < this.contactLocals.length; i++)this.queryPoints.push((0, $6b6a54a072724620$export$e7c866399fa523f5)(0, 0));
        this.floorZCache = new Array(this.contactLocals.length).fill(null);
        this.terrainQuery = this.addChild(new (0, $178448b994cda479$export$b2f87c4d67934c2d)(()=>this.queryPoints));
        this.waterQuery = this.addChild(new (0, $2f31bbbd4b5b01e3$export$38b1d297f12cec06)(()=>this.queryPoints));
    }
    onAdd() {
        const hullBody = this.boat.hull.body;
        const ground = this.game.ground;
        // Per-contact friction coefficients: hull vertices and the mast tip use
        // the hull friction, the rudder uses its own. Keel friction is unused
        // now that the keel isn't part of the contact set.
        const frictions = [];
        for(let i = 0; i < this.hullVertexCount; i++)frictions.push(this.config.hullFriction);
        frictions.push(this.config.rudderFriction);
        frictions.push(this.config.hullFriction);
        const constraints = [];
        for(let i = 0; i < this.contactLocals.length; i++){
            const local = this.contactLocals[i];
            const index = i;
            constraints.push(new (0, $d08dc95f3f961954$export$fb8c86c8990ab189)(ground, hullBody, local.x, local.y, local.z, ()=>this.floorZCache[index], frictions[i], {
                collideConnected: true
            }));
        }
        this.contactConstraints = constraints;
        this.constraints = constraints;
    }
    onTick({ dt: dt }) {
        const hull = this.boat.hull;
        const body = hull.body;
        // Refresh query XY to match the current hull pose so next frame's
        // terrain/water results correspond to the *current* contact positions.
        for(let i = 0; i < this.contactLocals.length; i++){
            const local = this.contactLocals[i];
            const world = body.toWorldFrame((0, $6b6a54a072724620$export$e7c866399fa523f5)(local.x, local.y));
            this.queryPoints[i].set(world[0], world[1]);
        }
        // Refresh the cached floor z values from the latest query results.
        // Water-relative frame: floorZ = terrainHeight - waterSurfaceHeight.
        const tCount = this.terrainQuery.length;
        const wCount = this.waterQuery.length;
        const count = Math.min(tCount, wCount, this.contactLocals.length);
        for(let i = 0; i < count; i++){
            const terrainHeight = this.terrainQuery.get(i).height;
            const surfaceHeight = this.waterQuery.get(i).surfaceHeight;
            this.floorZCache[i] = terrainHeight - surfaceHeight;
        }
        for(let i = count; i < this.floorZCache.length; i++)this.floorZCache[i] = null;
        if (count === 0) return;
        // Accumulate grounding damage from the constraints' reported penetration.
        // The constraints handle all force application; this is gameplay
        // bookkeeping. Per-vertex contributions are averaged across the hull
        // outline so total damage stays comparable to the old single-point model.
        const speed = body.velocity.magnitude;
        if (speed < 0.01) return;
        const hullShare = this.hullVertexCount > 0 ? 1 / this.hullVertexCount : 0;
        for(let i = 0; i < this.hullVertexCount; i++){
            const c = this.contactConstraints[i];
            if (!c.isActive()) continue;
            const penetration = c.getPenetration();
            if (penetration > 0) this.boat.hullDamage.applyGroundingDamage(penetration * hullShare, speed, dt);
        }
        const rudderC = this.contactConstraints[this.rudderIndex];
        if (rudderC.isActive() && rudderC.getPenetration() > 0) this.boat.rudderDamage.applyGroundingDamage(rudderC.getPenetration(), speed, dt);
    }
}
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $aa1f0309d9dba6d2$export$af631764ddc44097)("add")
], $ef3d72bebf669cf8$export$b3b355ccc72406cc.prototype, "onAdd", null);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $aa1f0309d9dba6d2$export$af631764ddc44097)("tick")
], $ef3d72bebf669cf8$export$b3b355ccc72406cc.prototype, "onTick", null);








/**
 * Deck plan renderer — builds triangle meshes for interior deck features
 * (cockpits, cabins, benches, etc.) from zone-based definitions.
 *
 * Zone polygons are clipped to the hull's deck outline using
 * Sutherland-Hodgman, then triangulated with ear-clipping.
 * Walls are generated as vertical quads around zone boundaries.
 */ 

function $9783a58f4a31b8ed$export$cf9573e980d97240(subject, clip) {
    if (subject.length === 0 || clip.length < 3) return [];
    let output = subject.slice();
    for(let i = 0; i < clip.length; i++){
        if (output.length === 0) return [];
        const edgeA = clip[i];
        const edgeB = clip[(i + 1) % clip.length];
        const input = output;
        output = [];
        for(let j = 0; j < input.length; j++){
            const current = input[j];
            const previous = input[(j - 1 + input.length) % input.length];
            const currInside = $9783a58f4a31b8ed$var$isInside(current, edgeA, edgeB);
            const prevInside = $9783a58f4a31b8ed$var$isInside(previous, edgeA, edgeB);
            if (currInside) {
                if (!prevInside) // Entering: add intersection then current
                output.push($9783a58f4a31b8ed$var$lineIntersect(previous, current, edgeA, edgeB));
                output.push(current);
            } else if (prevInside) // Leaving: add intersection only
            output.push($9783a58f4a31b8ed$var$lineIntersect(previous, current, edgeA, edgeB));
        }
    }
    return output;
}
/**
 * Test if point P is on the inside (left side) of directed edge A->B.
 * Uses the cross product sign; positive = left of edge = inside.
 */ function $9783a58f4a31b8ed$var$isInside(p, edgeA, edgeB) {
    return (edgeB[0] - edgeA[0]) * (p[1] - edgeA[1]) - (edgeB[1] - edgeA[1]) * (p[0] - edgeA[0]) >= 0;
}
/**
 * Compute the intersection of line segment P1-P2 with the infinite line
 * through edgeA-edgeB.
 */ function $9783a58f4a31b8ed$var$lineIntersect(p1, p2, edgeA, edgeB) {
    const x1 = p1[0], y1 = p1[1];
    const x2 = p2[0], y2 = p2[1];
    const x3 = edgeA[0], y3 = edgeA[1];
    const x4 = edgeB[0], y4 = edgeB[1];
    const denom = (x1 - x2) * (y3 - y4) - (y1 - y2) * (x3 - x4);
    if (Math.abs(denom) < 1e-12) // Lines are parallel; return midpoint as fallback
    return [
        (x1 + x2) / 2,
        (y1 + y2) / 2
    ];
    const t = ((x1 - x3) * (y3 - y4) - (y1 - y3) * (x3 - x4)) / denom;
    return [
        x1 + t * (x2 - x1),
        y1 + t * (y2 - y1)
    ];
}
/** Darken a hex RGB color by multiplying each channel by factor (0-1). */ function $9783a58f4a31b8ed$var$darkenColor(color, factor) {
    const r = Math.round((color >> 16 & 0xff) * factor);
    const g = Math.round((color >> 8 & 0xff) * factor);
    const b = Math.round((color & 0xff) * factor);
    return r << 16 | g << 8 | b;
}
function $9783a58f4a31b8ed$export$ed43fcbd0ec203c(plan, hullOutline, defaultDeckZ, hullMesh) {
    const meshes = [];
    // Sort zones by floorZ ascending — lowest floors first
    const sortedZones = [
        ...plan.zones
    ].sort((a, b)=>a.floorZ - b.floorZ);
    // Cache extracted outlines by z-level (many zones share the same floorZ)
    const outlineCache = new Map();
    for (const zone of sortedZones){
        // Clip zone outline to the hull boundary at this zone's z-level.
        // When the hull mesh is available, we extract the precise hull outline
        // at the zone's floorZ — this handles hull taper perfectly.
        let clipOutline;
        if (hullMesh && zone.floorZ < defaultDeckZ) {
            let cached = outlineCache.get(zone.floorZ);
            if (!cached) {
                cached = (0, $779a9fe58269ee84$export$da258e5b085eea85)(hullMesh, zone.floorZ);
                outlineCache.set(zone.floorZ, cached);
            }
            clipOutline = cached.length >= 3 ? cached : hullOutline;
        } else clipOutline = hullOutline;
        const outline = zone.outline.map(([x, y])=>[
                x,
                y
            ]);
        const clipped = $9783a58f4a31b8ed$export$cf9573e980d97240(outline, clipOutline);
        if (clipped.length < 3) continue;
        // --- Walls (drawn before floor so floor of higher zones covers wall tops) ---
        if (zone.wallHeight != null && zone.wallHeight > 0) {
            const wallColor = zone.wallColor ?? $9783a58f4a31b8ed$var$darkenColor(zone.color, 0.75);
            const bottomZ = zone.floorZ;
            const topZ = zone.floorZ + zone.wallHeight;
            const positions = [];
            const zValues = [];
            const indices = [];
            for(let i = 0; i < clipped.length; i++){
                const next = (i + 1) % clipped.length;
                const ax = clipped[i][0], ay = clipped[i][1];
                const bx = clipped[next][0], by = clipped[next][1];
                // Each wall segment is a quad: 4 vertices, 2 triangles.
                // Bottom-left, bottom-right, top-right, top-left
                const base = positions.length;
                positions.push([
                    ax,
                    ay
                ], [
                    bx,
                    by
                ], [
                    bx,
                    by
                ], [
                    ax,
                    ay
                ]);
                zValues.push(bottomZ, bottomZ, topZ, topZ);
                indices.push(base, base + 1, base + 2, base, base + 2, base + 3);
            }
            meshes.push({
                positions: positions,
                zValues: zValues,
                indices: indices,
                color: wallColor,
                alpha: 1
            });
        }
        // --- Floor polygon ---
        const points = clipped.map(([x, y])=>({
                x: x,
                y: y
            }));
        const triIndices = (0, $dc2c60c9a54ba1c2$export$4d77c9cbb3bd528)(points);
        if (!triIndices || triIndices.length === 0) continue;
        const floorPositions = clipped.map(([x, y])=>[
                x,
                y
            ]);
        const floorZValues = clipped.map(()=>zone.floorZ);
        meshes.push({
            positions: floorPositions,
            zValues: floorZValues,
            indices: triIndices,
            color: zone.color,
            alpha: 1
        });
    }
    return meshes;
}


/**
 * TimeOfDay entity - tracks game-world time separately from real elapsed time.
 *
 * Singleton entity that provides the source of truth for game-world time.
 * Used for time-dependent effects like tides.
 *
 * Default: 1 real second = 1 game minute (60x time scale),
 * so a full 24-hour cycle = 24 real minutes.
 */ 


/** Seconds in a day */ const $4df5c29ec7839388$var$SECONDS_PER_DAY = 86400;
/** Seconds per hour */ const $4df5c29ec7839388$var$SECONDS_PER_HOUR = 3600;
/** Default time scale: game-world seconds per real second (1 = real-time) */ const $4df5c29ec7839388$var$DEFAULT_TIME_SCALE = 1;
/** Default starting hour (noon) */ const $4df5c29ec7839388$var$DEFAULT_STARTING_HOUR = 12;
class $4df5c29ec7839388$export$1467403458327a44 extends (0, $c59361981bac2575$export$4342ba5c6ad1f6f1) {
    constructor(config = {}){
        super(), this.id = "timeOfDay", this.tickLayer = "environment", // Cached scene-lighting tuples. Getters mutate and return the same tuple
        // each call so the per-frame uniform push is allocation-free.
        this._sunDirection = [
            0,
            0,
            1
        ], this._sunColor = [
            0,
            0,
            0
        ], this._skyColor = [
            0,
            0,
            0
        ], this._ambientLight = [
            0,
            0,
            0
        ];
        const startingHour = config.startingHour ?? $4df5c29ec7839388$var$DEFAULT_STARTING_HOUR;
        this.timeInSeconds = startingHour * $4df5c29ec7839388$var$SECONDS_PER_HOUR;
        this.timeScale = config.timeScale ?? $4df5c29ec7839388$var$DEFAULT_TIME_SCALE;
    }
    /**
   * Advance time each tick.
   */ onTick({ dt: dt }) {
        if (this.game.io.isKeyDown("Period")) this.timeInSeconds += dt * this.timeScale * 5000;
        else this.timeInSeconds += dt * this.timeScale;
        // Wrap at 24 hours
        while(this.timeInSeconds >= $4df5c29ec7839388$var$SECONDS_PER_DAY)this.timeInSeconds -= $4df5c29ec7839388$var$SECONDS_PER_DAY;
        while(this.timeInSeconds < 0)this.timeInSeconds += $4df5c29ec7839388$var$SECONDS_PER_DAY;
    }
    /**
   * Get the current hour (0-24, can be fractional).
   */ getHour() {
        return this.timeInSeconds / $4df5c29ec7839388$var$SECONDS_PER_HOUR;
    }
    /**
   * Get the current time in seconds since midnight.
   */ getTimeInSeconds() {
        return this.timeInSeconds;
    }
    /**
   * Set the time scale (game-world seconds per real second).
   */ setTimeScale(scale) {
        this.timeScale = scale;
    }
    /**
   * Get the current time scale.
   */ getTimeScale() {
        return this.timeScale;
    }
    /**
   * Jump to a specific hour (0-24).
   */ setHour(hour) {
        this.timeInSeconds = hour * $4df5c29ec7839388$var$SECONDS_PER_HOUR;
        // Normalize to valid range
        while(this.timeInSeconds >= $4df5c29ec7839388$var$SECONDS_PER_DAY)this.timeInSeconds -= $4df5c29ec7839388$var$SECONDS_PER_DAY;
        while(this.timeInSeconds < 0)this.timeInSeconds += $4df5c29ec7839388$var$SECONDS_PER_DAY;
    }
    // ============================================================================
    // Scene lighting
    //
    // CPU port of what was previously in scene-lighting.wgsl.ts. Computed once per
    // frame on the CPU; shaders receive the results as uniform vec3s instead of
    // recomputing per-pixel. Altitude math and color ramps are intentionally
    // identical to the original WGSL so visuals don't drift.
    // ============================================================================
    /**
   * Raw (unclamped) sun altitude in [-1, 1]: +1 at zenith, 0 at horizon,
   * -1 at nadir. Daytime is altitude > 0, night is altitude < 0.
   */ getSunAltitude() {
        const hour = this.timeInSeconds / $4df5c29ec7839388$var$SECONDS_PER_HOUR;
        const sunPhase = (hour - 6.0) * Math.PI / 12.0; // 6am..6pm → 0..π
        return Math.sin(sunPhase);
    }
    /**
   * Normalized unit vector pointing toward the sun.
   * X: south/north, Y: east/west, Z: up/down. Sun rises east, sets west.
   *
   * Returns a cached tuple — do not store across frames.
   */ getSunDirection() {
        const hour = this.timeInSeconds / $4df5c29ec7839388$var$SECONDS_PER_HOUR;
        const sunElevation = Math.max(this.getSunAltitude(), 0);
        const azimuth = (hour - 12.0) * Math.PI / 6.0; // noon = 0, sweeps east to west
        const x = Math.cos(azimuth) * 0.3 + 0.3;
        const y = Math.sin(azimuth) * 0.2 + 0.2;
        const z = sunElevation * 0.9 + 0.1;
        const len = Math.sqrt(x * x + y * y + z * z);
        this._sunDirection[0] = x / len;
        this._sunDirection[1] = y / len;
        this._sunDirection[2] = z / len;
        return this._sunDirection;
    }
    /**
   * Direct sunlight color. (0,0,0) when the sun is below the horizon — no
   * direct sunlight at night. Warm orange near the horizon (atmospheric
   * scattering) transitioning to near-white at zenith.
   *
   * Returns a cached tuple — do not store across frames.
   */ getSunColor() {
        const altitude = this.getSunAltitude();
        // Sun visibility ramps in as the sun clears the horizon.
        const sunVisible = $4df5c29ec7839388$var$smoothstep(-0.02, 0.08, altitude);
        // Warmth: high near horizon (long atmospheric path), cool overhead.
        const warmth = 1.0 - $4df5c29ec7839388$var$smoothstep(0.0, 0.4, altitude);
        // mix(whiteColor, warmColor, warmth) * sunVisible
        const r = $4df5c29ec7839388$var$lerp(1.0, 1.0, warmth) * sunVisible;
        const g = $4df5c29ec7839388$var$lerp(0.95, 0.55, warmth) * sunVisible;
        const b = $4df5c29ec7839388$var$lerp(0.85, 0.25, warmth) * sunVisible;
        this._sunColor[0] = r;
        this._sunColor[1] = g;
        this._sunColor[2] = b;
        return this._sunColor;
    }
    /**
   * Sky color — deep blue-black at night (full-moon-lit), bright blue at day,
   * with a warm twilight bump near the horizon.
   *
   * Returns a cached tuple — do not store across frames.
   */ getSkyColor() {
        const altitude = this.getSunAltitude();
        const dayness = $4df5c29ec7839388$var$smoothstep(-0.1, 0.25, altitude);
        // Night base: bright cool blue for a moonlit night.
        const baseR = $4df5c29ec7839388$var$lerp(0.18, 0.5, dayness);
        const baseG = $4df5c29ec7839388$var$lerp(0.25, 0.7, dayness);
        const baseB = $4df5c29ec7839388$var$lerp(0.45, 0.95, dayness);
        // Twilight glow: Gaussian bump centered at the horizon.
        const twilightBump = Math.exp(-altitude * altitude * 40.0);
        const twilightR = 0.55;
        const twilightG = 0.28;
        const twilightB = 0.25;
        this._skyColor[0] = baseR + twilightR * twilightBump * 0.35;
        this._skyColor[1] = baseG + twilightG * twilightBump * 0.35;
        this._skyColor[2] = baseB + twilightB * twilightBump * 0.35;
        return this._skyColor;
    }
    /**
   * Combined RGB illumination for objects without a meaningful surface
   * normal (particles, buoys, ropes, etc.). Mirrors the shader-side
   * `skyColor * ambient + sunColor * diffuse` model with diffuse=1, so
   * these objects pick up the same cool-blue floor at night and warm
   * directional brightness during the day as lit surfaces.
   *
   * Returns a cached tuple — do not store across frames.
   */ getAmbientLight() {
        const sun = this.getSunColor();
        const sky = this.getSkyColor();
        const AMBIENT = 0.5;
        this._ambientLight[0] = sky[0] * AMBIENT + sun[0];
        this._ambientLight[1] = sky[1] * AMBIENT + sun[1];
        this._ambientLight[2] = sky[2] * AMBIENT + sun[2];
        return this._ambientLight;
    }
}
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $aa1f0309d9dba6d2$export$af631764ddc44097)("tick")
], $4df5c29ec7839388$export$1467403458327a44.prototype, "onTick", null);
function $4df5c29ec7839388$var$smoothstep(edge0, edge1, x) {
    const t = Math.max(0, Math.min(1, (x - edge0) / (edge1 - edge0)));
    return t * t * (3 - 2 * t);
}
function $4df5c29ec7839388$var$lerp(a, b, t) {
    return a + (b - a) * t;
}


/**
 * Custom WebGPU render pipeline for procedural rope rendering.
 *
 * Unified laid/braid shader: renders both traditional twisted-laid rope and
 * plaited-braid rope using a single diamond-grid fragment function. Each rope
 * carries a set of per-carrier colors; the shader samples them based on the
 * construction type (one strand family for laid, two crossing families with
 * over/under checkerboard for braid).
 *
 * Follows the SailShader pattern: module-level singleton pipeline, per-rope
 * instance with its own GPU buffers.
 */ 




/**
 * Tessellation utilities for converting 3D boat geometry (lines, polylines,
 * rectangles, circles) into triangle meshes with per-vertex z-values.
 *
 * All functions produce data suitable for WebGPURenderer.submitTrianglesWithZ().
 */ 
/**
 * Pure geometry helpers: corner rounding and curve subdivision.
 *
 * These functions operate on point/z arrays — no VertexSink involvement.
 * They're used as inputs to the polygon/polyline/spline tessellators.
 */ /**
 * Round the corners of a polyline by inserting bezier arcs at each interior vertex.
 * Straight segments stay straight; only the corners get rounded.
 * The original vertex becomes the bezier control point, with on-curve points
 * offset inward along each adjacent segment by `radius`.
 *
 * @param radius How far from each corner to start rounding (ft)
 * @param arcPoints Number of points to sample along each corner arc (4-8 typical)
 */ function $ed1092a083b9ec20$export$28cc47cdc2523da5(points, zPerPoint, radius, arcPoints = 16) {
    const n = points.length;
    if (n < 3 || radius <= 0) return {
        points: points.map((p)=>[
                p[0],
                p[1]
            ]),
        zValues: [
            ...zPerPoint
        ],
        arcMidpoints: []
    };
    const out = [];
    const outZ = [];
    const arcMidpoints = [];
    out.push([
        points[0][0],
        points[0][1]
    ]);
    outZ.push(zPerPoint[0]);
    for(let i = 1; i < n - 1; i++){
        const prev = points[i - 1];
        const curr = points[i];
        const next = points[i + 1];
        const dix = curr[0] - prev[0];
        const diy = curr[1] - prev[1];
        const dox = next[0] - curr[0];
        const doy = next[1] - curr[1];
        const lenIn = Math.sqrt(dix * dix + diy * diy);
        const lenOut = Math.sqrt(dox * dox + doy * doy);
        if (lenIn < 1e-6 || lenOut < 1e-6) {
            out.push([
                curr[0],
                curr[1]
            ]);
            outZ.push(zPerPoint[i]);
            arcMidpoints.push({
                x: curr[0],
                y: curr[1],
                z: zPerPoint[i]
            });
            continue;
        }
        const r = Math.min(radius, lenIn * 0.5, lenOut * 0.5);
        const ax = curr[0] - dix / lenIn * r;
        const ay = curr[1] - diy / lenIn * r;
        const aZ = zPerPoint[i] - (zPerPoint[i] - zPerPoint[i - 1]) * (r / lenIn);
        const bx = curr[0] + dox / lenOut * r;
        const by = curr[1] + doy / lenOut * r;
        const bZ = zPerPoint[i] + (zPerPoint[i + 1] - zPerPoint[i]) * (r / lenOut);
        arcMidpoints.push({
            x: 0.25 * ax + 0.5 * curr[0] + 0.25 * bx,
            y: 0.25 * ay + 0.5 * curr[1] + 0.25 * by,
            z: 0.25 * aZ + 0.5 * zPerPoint[i] + 0.25 * bZ
        });
        const dot = dix / lenIn * (dox / lenOut) + diy / lenIn * (doy / lenOut);
        const turnAmount = (1 - dot) / 2;
        const samples = Math.max(2, Math.round(arcPoints * turnAmount));
        for(let s = 0; s <= samples; s++){
            const t = s / samples;
            const u = 1 - t;
            out.push([
                u * u * ax + 2 * u * t * curr[0] + t * t * bx,
                u * u * ay + 2 * u * t * curr[1] + t * t * by
            ]);
            outZ.push(u * u * aZ + 2 * u * t * zPerPoint[i] + t * t * bZ);
        }
    }
    out.push([
        points[n - 1][0],
        points[n - 1][1]
    ]);
    outZ.push(zPerPoint[n - 1]);
    return {
        points: out,
        zValues: outZ,
        arcMidpoints: arcMidpoints
    };
}
function $ed1092a083b9ec20$export$c94998931f2285c4(points, zPerPoint, subdivisions = 3) {
    const n = points.length;
    if (n < 3) return {
        points: points.map((p)=>[
                p[0],
                p[1]
            ]),
        zValues: [
            ...zPerPoint
        ]
    };
    const out = [];
    const outZ = [];
    out.push([
        points[0][0],
        points[0][1]
    ]);
    outZ.push(zPerPoint[0]);
    for(let i = 0; i < n - 2; i++){
        const p0x = i === 0 ? points[0][0] : (points[i][0] + points[i + 1][0]) / 2;
        const p0y = i === 0 ? points[0][1] : (points[i][1] + points[i + 1][1]) / 2;
        const p0z = i === 0 ? zPerPoint[0] : (zPerPoint[i] + zPerPoint[i + 1]) / 2;
        const cpx = points[i + 1][0];
        const cpy = points[i + 1][1];
        const cpz = zPerPoint[i + 1];
        const p1x = i === n - 3 ? points[n - 1][0] : (points[i + 1][0] + points[i + 2][0]) / 2;
        const p1y = i === n - 3 ? points[n - 1][1] : (points[i + 1][1] + points[i + 2][1]) / 2;
        const p1z = i === n - 3 ? zPerPoint[n - 1] : (zPerPoint[i + 1] + zPerPoint[i + 2]) / 2;
        for(let s = 1; s <= subdivisions; s++){
            const t = s / subdivisions;
            const u = 1 - t;
            const x = u * u * p0x + 2 * u * t * cpx + t * t * p1x;
            const y = u * u * p0y + 2 * u * t * cpy + t * t * p1y;
            const z = u * u * p0z + 2 * u * t * cpz + t * t * p1z;
            out.push([
                x,
                y
            ]);
            outZ.push(z);
        }
    }
    return {
        points: out,
        zValues: outZ
    };
}
function $ed1092a083b9ec20$export$db25ba51ff51beac(points, zPerPoint, subdivisions, outPoints, outZ, /** Optional per-input-point material v-coordinate. When provided, output
   *  v-values are linearly interpolated (not Catmull-Rom — avoids overshoot)
   *  so the texture sticks to the rope material. */ vPerPoint, outV) {
    const n = points.length;
    if (n < 2) {
        if (n === 1) {
            outPoints[0][0] = points[0][0];
            outPoints[0][1] = points[0][1];
            outZ[0] = zPerPoint[0];
            if (vPerPoint && outV) outV[0] = vPerPoint[0];
            return 1;
        }
        return 0;
    }
    let idx = 0;
    outPoints[idx][0] = points[0][0];
    outPoints[idx][1] = points[0][1];
    outZ[idx] = zPerPoint[0];
    if (vPerPoint && outV) outV[idx] = vPerPoint[0];
    idx++;
    for(let i = 0; i < n - 1; i++){
        const i0 = Math.max(0, i - 1);
        const i1 = i;
        const i2 = i + 1;
        const i3 = Math.min(n - 1, i + 2);
        const p0x = points[i0][0];
        const p0y = points[i0][1];
        const p0z = zPerPoint[i0];
        const p1x = points[i1][0];
        const p1y = points[i1][1];
        const p1z = zPerPoint[i1];
        const p2x = points[i2][0];
        const p2y = points[i2][1];
        const p2z = zPerPoint[i2];
        const p3x = points[i3][0];
        const p3y = points[i3][1];
        const p3z = zPerPoint[i3];
        const v1 = vPerPoint ? vPerPoint[i1] : 0;
        const v2 = vPerPoint ? vPerPoint[i2] : 0;
        for(let s = 1; s <= subdivisions; s++){
            const t = s / subdivisions;
            const t2 = t * t;
            const t3 = t2 * t;
            outPoints[idx][0] = 0.5 * (2 * p1x + (-p0x + p2x) * t + (2 * p0x - 5 * p1x + 4 * p2x - p3x) * t2 + (-p0x + 3 * p1x - 3 * p2x + p3x) * t3);
            outPoints[idx][1] = 0.5 * (2 * p1y + (-p0y + p2y) * t + (2 * p0y - 5 * p1y + 4 * p2y - p3y) * t2 + (-p0y + 3 * p1y - 3 * p2y + p3y) * t3);
            outZ[idx] = 0.5 * (2 * p1z + (-p0z + p2z) * t + (2 * p0z - 5 * p1z + 4 * p2z - p3z) * t2 + (-p0z + 3 * p1z - 3 * p2z + p3z) * t3);
            if (outV) outV[idx] = v1 + (v2 - v1) * t;
            idx++;
        }
    }
    return idx;
}
function $ed1092a083b9ec20$export$89164c2f10f6b8fa(inputPoints, subdivisions) {
    if (inputPoints < 2) return inputPoints;
    return (inputPoints - 1) * subdivisions + 1;
}


function $65c81fa1e5a3b256$export$7e28a7b51b86db6a(x1, y1, z1, x2, y2, z2, width, color, alpha = 1) {
    const dx = x2 - x1;
    const dy = y2 - y1;
    const len = Math.sqrt(dx * dx + dy * dy);
    const hw = width / 2;
    let nx, ny;
    if (len < 1e-6) {
        // Purely vertical line (same XY, different z) — use arbitrary perpendicular.
        // The tilt context zCoeffs will spread vertices apart on screen.
        nx = hw;
        ny = 0;
    } else {
        nx = -dy / len * hw;
        ny = dx / len * hw;
    }
    return {
        positions: [
            [
                x1 + nx,
                y1 + ny
            ],
            [
                x2 + nx,
                y2 + ny
            ],
            [
                x2 - nx,
                y2 - ny
            ],
            [
                x1 - nx,
                y1 - ny
            ]
        ],
        zValues: [
            z1,
            z2,
            z2,
            z1
        ],
        indices: [
            0,
            1,
            2,
            0,
            2,
            3
        ],
        color: color,
        alpha: alpha
    };
}
function $65c81fa1e5a3b256$export$da1828449b1d0ea1(x1, y1, z1, x2, y2, z2, width, tilt, color, alpha = 1, roundCaps = false) {
    // Project line direction to screen space
    const dlx = x2 - x1;
    const dly = y2 - y1;
    const dlz = z2 - z1;
    const dsx = tilt.m00 * dlx + tilt.m01 * dly + tilt.zx * dlz;
    const dsy = tilt.m10 * dlx + tilt.m11 * dly + tilt.zy * dlz;
    // Screen-space perpendicular (normalized)
    const sLen = Math.sqrt(dsx * dsx + dsy * dsy);
    if (sLen < 1e-6) return {
        positions: [],
        zValues: [],
        indices: [],
        color: color,
        alpha: alpha
    };
    const hw = width / 2;
    const spx = -dsy / sLen * hw;
    const spy = dsx / sLen * hw;
    // Inverse-transform screen perpendicular to hull-local offset
    const nx = tilt.inv00 * spx + tilt.inv01 * spy;
    const ny = tilt.inv10 * spx + tilt.inv11 * spy;
    const positions = [
        [
            x1 + nx,
            y1 + ny
        ],
        [
            x2 + nx,
            y2 + ny
        ],
        [
            x2 - nx,
            y2 - ny
        ],
        [
            x1 - nx,
            y1 - ny
        ]
    ];
    const zValues = [
        z1,
        z2,
        z2,
        z1
    ];
    const indices = [
        0,
        1,
        2,
        0,
        2,
        3
    ];
    if (roundCaps) {
        const perpAngle = Math.atan2(spy, spx);
        const capSteps = 8;
        // Helper: add a semicircular cap fan at a point
        const addCap = (cx, cy, z, startAngle, sweep)=>{
            const center = positions.length;
            positions.push([
                cx,
                cy
            ]);
            zValues.push(z);
            for(let s = 0; s <= capSteps; s++){
                const angle = startAngle + sweep * s / capSteps;
                const sx = Math.cos(angle) * hw;
                const sy = Math.sin(angle) * hw;
                positions.push([
                    cx + tilt.inv00 * sx + tilt.inv01 * sy,
                    cy + tilt.inv10 * sx + tilt.inv11 * sy
                ]);
                zValues.push(z);
                if (s > 0) indices.push(center, center + s, center + s + 1);
            }
        };
        // Start cap: fan from +perp through backward to -perp
        addCap(x1, y1, z1, perpAngle, Math.PI);
        // End cap: fan from +perp through forward to -perp
        addCap(x2, y2, z2, perpAngle, -Math.PI);
    }
    return {
        positions: positions,
        zValues: zValues,
        indices: indices,
        color: color,
        alpha: alpha
    };
}
function $65c81fa1e5a3b256$export$7260a9f54460c34a(points, zPerPoint, width, tilt, color, alpha = 1, closed = false, roundCaps = false) {
    if (points.length < 2) return {
        positions: [],
        zValues: [],
        indices: [],
        color: color,
        alpha: alpha
    };
    const halfWidth = width / 2;
    const positions = [];
    const zValues = [];
    const indices = [];
    // Compute unit screen-space perpendicular for a hull-local segment
    const screenPerpDir = (dx, dy, dz)=>{
        const sx = tilt.m00 * dx + tilt.m01 * dy + tilt.zx * dz;
        const sy = tilt.m10 * dx + tilt.m11 * dy + tilt.zy * dz;
        const len = Math.sqrt(sx * sx + sy * sy);
        if (len === 0) return [
            0,
            0
        ];
        return [
            -sy / len,
            sx / len
        ];
    };
    // Inverse-project a screen-space offset to hull-local
    const toLocal = (sx, sy)=>[
            tilt.inv00 * sx + tilt.inv01 * sy,
            tilt.inv10 * sx + tilt.inv11 * sy
        ];
    // Emit a vertex pair offset from a point along a screen-space direction
    const emitPair = (cx, cy, z, sx, sy)=>{
        const [lx, ly] = toLocal(sx, sy);
        positions.push([
            cx + lx * halfWidth,
            cy + ly * halfWidth
        ], [
            cx - lx * halfWidth,
            cy - ly * halfWidth
        ]);
        zValues.push(z, z);
    };
    // Track the base index of the last pair emitted for segment connections.
    let prevPairEnd = -1;
    let firstPairStart = 0;
    for(let i = 0; i < points.length; i++){
        const curr = points[i];
        const currZ = zPerPoint[i];
        let prev = null;
        let prevZ = currZ;
        let next = null;
        let nextZ = currZ;
        if (i > 0) {
            prev = points[i - 1];
            prevZ = zPerPoint[i - 1];
        } else if (closed) {
            prev = points[points.length - 1];
            prevZ = zPerPoint[points.length - 1];
        }
        if (i < points.length - 1) {
            next = points[i + 1];
            nextZ = zPerPoint[i + 1];
        } else if (closed) {
            next = points[0];
            nextZ = zPerPoint[0];
        }
        const pairStart = positions.length;
        if (i === 0) firstPairStart = pairStart;
        if (prev === null && next !== null) {
            const [sx, sy] = screenPerpDir(next[0] - curr[0], next[1] - curr[1], nextZ - currZ);
            emitPair(curr[0], curr[1], currZ, sx, sy);
        } else if (next === null && prev !== null) {
            const [sx, sy] = screenPerpDir(curr[0] - prev[0], curr[1] - prev[1], currZ - prevZ);
            emitPair(curr[0], curr[1], currZ, sx, sy);
        } else if (prev !== null && next !== null) {
            const [s1x, s1y] = screenPerpDir(curr[0] - prev[0], curr[1] - prev[1], currZ - prevZ);
            const [s2x, s2y] = screenPerpDir(next[0] - curr[0], next[1] - curr[1], nextZ - currZ);
            // Check if the miter would need clamping
            let mx = (s1x + s2x) / 2;
            let my = (s1y + s2y) / 2;
            const mLen = Math.sqrt(mx * mx + my * my);
            const dot = mLen > 0.001 ? s1x * mx + s1y * my : 0;
            const miterScale = dot > 0.1 ? 1 / dot : 10;
            if (miterScale > 1.05) {
                // Round join: fan from incoming to outgoing perpendicular
                const angle1 = Math.atan2(s1y, s1x);
                let angle2 = Math.atan2(s2y, s2x);
                let angleDiff = angle2 - angle1;
                if (angleDiff > Math.PI) angleDiff -= 2 * Math.PI;
                if (angleDiff < -Math.PI) angleDiff += 2 * Math.PI;
                const steps = Math.max(2, Math.ceil(Math.abs(angleDiff) / (Math.PI / 8)));
                for(let s = 0; s <= steps; s++){
                    const angle = angle1 + angleDiff * (s / steps);
                    emitPair(curr[0], curr[1], currZ, Math.cos(angle), Math.sin(angle));
                }
            } else {
                // Normal miter
                const clampedScale = Math.min(miterScale, 1);
                emitPair(curr[0], curr[1], currZ, mx / mLen * clampedScale, my / mLen * clampedScale);
            }
        } else emitPair(curr[0], curr[1], currZ, 0, 1);
        // Connect consecutive vertex pairs within this vertex (round join fan)
        for(let p = pairStart; p < positions.length - 2; p += 2)indices.push(p, p + 2, p + 3, p, p + 3, p + 1);
        // Connect to previous vertex's last pair
        const pairEnd = positions.length - 2;
        if (prevPairEnd >= 0) indices.push(prevPairEnd, pairStart, pairStart + 1, prevPairEnd, pairStart + 1, prevPairEnd + 1);
        prevPairEnd = pairEnd;
    }
    if (closed && points.length >= 3 && prevPairEnd >= 0) indices.push(prevPairEnd, firstPairStart, firstPairStart + 1, prevPairEnd, firstPairStart + 1, prevPairEnd + 1);
    // Round end caps for open polylines
    if (roundCaps && !closed && points.length >= 2) {
        const capSteps = 8;
        const addCap = (cx, cy, z, perpSx, perpSy, sweep)=>{
            const perpAngle = Math.atan2(perpSy, perpSx);
            const center = positions.length;
            positions.push([
                cx,
                cy
            ]);
            zValues.push(z);
            for(let s = 0; s <= capSteps; s++){
                const angle = perpAngle + sweep * s / capSteps;
                const sx = Math.cos(angle);
                const sy = Math.sin(angle);
                const [lx, ly] = toLocal(sx, sy);
                positions.push([
                    cx + lx * halfWidth,
                    cy + ly * halfWidth
                ]);
                zValues.push(z);
                if (s > 0) indices.push(center, center + s, center + s + 1);
            }
        };
        // Start cap: perpendicular of first segment, fanning through backward
        const p0 = points[0];
        const p1 = points[1];
        const [sp0x, sp0y] = screenPerpDir(p1[0] - p0[0], p1[1] - p0[1], zPerPoint[1] - zPerPoint[0]);
        addCap(p0[0], p0[1], zPerPoint[0], sp0x, sp0y, Math.PI);
        // End cap: perpendicular of last segment, fanning through forward
        const pLast = points[points.length - 1];
        const pPrev = points[points.length - 2];
        const [spLx, spLy] = screenPerpDir(pLast[0] - pPrev[0], pLast[1] - pPrev[1], zPerPoint[points.length - 1] - zPerPoint[points.length - 2]);
        addCap(pLast[0], pLast[1], zPerPoint[points.length - 1], spLx, spLy, -Math.PI);
    }
    return {
        positions: positions,
        zValues: zValues,
        indices: indices,
        color: color,
        alpha: alpha
    };
}
function $65c81fa1e5a3b256$export$b46f487f1fde3d2d(x, y, w, h, z, color, alpha = 1) {
    return {
        positions: [
            [
                x,
                y
            ],
            [
                x + w,
                y
            ],
            [
                x + w,
                y + h
            ],
            [
                x,
                y + h
            ]
        ],
        zValues: [
            z,
            z,
            z,
            z
        ],
        indices: [
            0,
            1,
            2,
            0,
            2,
            3
        ],
        color: color,
        alpha: alpha
    };
}
function $65c81fa1e5a3b256$export$8958e4b711161d49(cx, cy, offsetX, offsetY, w, h, angle, z, color, alpha = 1) {
    const cos = Math.cos(angle);
    const sin = Math.sin(angle);
    // Rectangle corners relative to rotation center, then offset
    const corners = [
        [
            offsetX,
            offsetY
        ],
        [
            offsetX + w,
            offsetY
        ],
        [
            offsetX + w,
            offsetY + h
        ],
        [
            offsetX,
            offsetY + h
        ]
    ];
    const positions = corners.map(([lx, ly])=>[
            cx + cos * lx - sin * ly,
            cy + sin * lx + cos * ly
        ]);
    return {
        positions: positions,
        zValues: [
            z,
            z,
            z,
            z
        ],
        indices: [
            0,
            1,
            2,
            0,
            2,
            3
        ],
        color: color,
        alpha: alpha
    };
}
function $65c81fa1e5a3b256$export$44893fdbbdec8bb4(cx, cy, z, radius, segments, color, alpha = 1) {
    const positions = [
        [
            cx,
            cy
        ]
    ];
    const zValues = [
        z
    ];
    const indices = [];
    for(let i = 0; i <= segments; i++){
        const a = i / segments * Math.PI * 2;
        positions.push([
            cx + Math.cos(a) * radius,
            cy + Math.sin(a) * radius
        ]);
        zValues.push(z);
    }
    for(let i = 1; i <= segments; i++)indices.push(0, i, i + 1 > segments ? 1 : i + 1);
    return {
        positions: positions,
        zValues: zValues,
        indices: indices,
        color: color,
        alpha: alpha
    };
}
function $65c81fa1e5a3b256$export$4202d7a1c044998c(cx, cy, z, radius, segments, tilt, color, alpha = 1) {
    const positions = [
        [
            cx,
            cy
        ]
    ];
    const zValues = [
        z
    ];
    const indices = [];
    for(let i = 0; i <= segments; i++){
        const a = i / segments * Math.PI * 2;
        // Screen-space offset
        const sx = Math.cos(a) * radius;
        const sy = Math.sin(a) * radius;
        // Inverse-project to hull-local
        const lx = tilt.inv00 * sx + tilt.inv01 * sy;
        const ly = tilt.inv10 * sx + tilt.inv11 * sy;
        positions.push([
            cx + lx,
            cy + ly
        ]);
        zValues.push(z);
    }
    for(let i = 1; i <= segments; i++)indices.push(0, i, i + 1 > segments ? 1 : i + 1);
    return {
        positions: positions,
        zValues: zValues,
        indices: indices,
        color: color,
        alpha: alpha
    };
}
function $65c81fa1e5a3b256$export$27463b3bbb1adbb2(points, zPerPoint, width, color, alpha = 1, closed = false, roundJoins = false) {
    if (points.length < 2) return {
        positions: [],
        zValues: [],
        indices: [],
        color: color,
        alpha: alpha
    };
    const halfWidth = width / 2;
    const positions = [];
    const zValues = [];
    const indices = [];
    const perp = (dx, dy)=>{
        const len = Math.sqrt(dx * dx + dy * dy);
        if (len === 0) return [
            0,
            0
        ];
        return [
            -dy / len,
            dx / len
        ];
    };
    const emitPair = (cx, cy, z, nx, ny)=>{
        positions.push([
            cx + nx * halfWidth,
            cy + ny * halfWidth
        ], [
            cx - nx * halfWidth,
            cy - ny * halfWidth
        ]);
        zValues.push(z, z);
    };
    let prevPairEnd = -1;
    let firstPairStart = 0;
    for(let i = 0; i < points.length; i++){
        const curr = points[i];
        let prev = null;
        let next = null;
        if (i > 0) prev = points[i - 1];
        else if (closed) prev = points[points.length - 1];
        if (i < points.length - 1) next = points[i + 1];
        else if (closed) next = points[0];
        const z = zPerPoint[i];
        const pairStart = positions.length;
        if (i === 0) firstPairStart = pairStart;
        if (prev === null && next !== null) {
            const [nx, ny] = perp(next[0] - curr[0], next[1] - curr[1]);
            emitPair(curr[0], curr[1], z, nx, ny);
        } else if (next === null && prev !== null) {
            const [nx, ny] = perp(curr[0] - prev[0], curr[1] - prev[1]);
            emitPair(curr[0], curr[1], z, nx, ny);
        } else if (prev !== null && next !== null) {
            const [n1x, n1y] = perp(curr[0] - prev[0], curr[1] - prev[1]);
            const [n2x, n2y] = perp(next[0] - curr[0], next[1] - curr[1]);
            let mx = (n1x + n2x) / 2;
            let my = (n1y + n2y) / 2;
            const mLen = Math.sqrt(mx * mx + my * my);
            const dot = mLen > 0.001 ? n1x * mx + n1y * my : 0;
            const miterScale = dot > 0.1 ? 1 / dot : 10;
            if (roundJoins && miterScale > 1.05) {
                // Round join: fan from incoming to outgoing perpendicular
                const angle1 = Math.atan2(n1y, n1x);
                let angle2 = Math.atan2(n2y, n2x);
                let angleDiff = angle2 - angle1;
                if (angleDiff > Math.PI) angleDiff -= 2 * Math.PI;
                if (angleDiff < -Math.PI) angleDiff += 2 * Math.PI;
                const steps = Math.max(2, Math.ceil(Math.abs(angleDiff) / (Math.PI / 8)));
                for(let s = 0; s <= steps; s++){
                    const angle = angle1 + angleDiff * (s / steps);
                    emitPair(curr[0], curr[1], z, Math.cos(angle), Math.sin(angle));
                }
            } else {
                // Miter join
                if (mLen > 0.001) {
                    const clampedScale = Math.min(miterScale, 1);
                    mx = mx / mLen * clampedScale;
                    my = my / mLen * clampedScale;
                } else {
                    mx = n1x;
                    my = n1y;
                }
                emitPair(curr[0], curr[1], z, mx, my);
            }
        } else emitPair(curr[0], curr[1], z, 0, 1);
        // Connect consecutive vertex pairs within this vertex (round join fan)
        for(let p = pairStart; p < positions.length - 2; p += 2)indices.push(p, p + 2, p + 3, p, p + 3, p + 1);
        // Connect to previous vertex's last pair
        const pairEnd = positions.length - 2;
        if (prevPairEnd >= 0) indices.push(prevPairEnd, pairStart, pairStart + 1, prevPairEnd, pairStart + 1, prevPairEnd + 1);
        prevPairEnd = pairEnd;
    }
    // Close the strip if needed
    if (closed && points.length >= 3 && prevPairEnd >= 0) indices.push(prevPairEnd, firstPairStart, firstPairStart + 1, prevPairEnd, firstPairStart + 1, prevPairEnd + 1);
    return {
        positions: positions,
        zValues: zValues,
        indices: indices,
        color: color,
        alpha: alpha
    };
}
const $65c81fa1e5a3b256$export$4cb9e45bb8672b46 = 5;
function $65c81fa1e5a3b256$export$5c2d7918f7c1ec24(cam) {
    const { a: a, b: b, c: c, d: d } = cam;
    const det = a * d - b * c;
    const invDet = det !== 0 ? 1 / det : 0;
    return {
        fa: a,
        fb: b,
        fc: c,
        fd: d,
        ia: d * invDet,
        ib: -b * invDet,
        ic: -c * invDet,
        id: a * invDet
    };
}
function $65c81fa1e5a3b256$export$f8d929b067cb2821(points, zPerPoint, width, cam, outVertices, outIndices, /** Number of points to use. Defaults to points.length. */ count, /** World-space z gradient (dz/dx, dz/dy). When provided, z varies across
   *  the strip width to match a tilted surface (e.g. a heeled deck). */ zSlope, /** Pre-computed material v-coordinate per point. When provided, the texture
   *  is pinned to the rope material instead of sliding with arc length. */ vPerPoint) {
    const n = count ?? points.length;
    if (n < 2) return {
        vertexCount: 0,
        indexCount: 0
    };
    const halfWidth = width / 2;
    let vOff = 0; // vertex float offset
    let iOff = 0; // index offset
    let cumulativeDist = 0;
    // Compute the perpendicular direction for a world-space segment.
    // The direction is determined in screen space (so the rope faces the
    // camera), then inverse-projected and re-normalized to unit length
    // in world space (so halfWidth stays in world units, not pixels).
    const screenPerp = (dx, dy)=>{
        // Forward-project direction to screen
        const sx = cam.fa * dx + cam.fc * dy;
        const sy = cam.fb * dx + cam.fd * dy;
        const sLen = Math.sqrt(sx * sx + sy * sy);
        if (sLen < 1e-6) return [
            0,
            0
        ];
        // Screen-space perpendicular (unit in screen space)
        const px = -sy / sLen;
        const py = sx / sLen;
        // Inverse-project back to world
        const wx = cam.ia * px + cam.ic * py;
        const wy = cam.ib * px + cam.id * py;
        // Re-normalize to unit length in WORLD space
        const wLen = Math.sqrt(wx * wx + wy * wy);
        if (wLen < 1e-6) return [
            0,
            0
        ];
        return [
            wx / wLen,
            wy / wLen
        ];
    };
    for(let i = 0; i < n; i++){
        const cx = points[i][0];
        const cy = points[i][1];
        const z = zPerPoint[i];
        // Accumulate distance along the centerline (fallback when no material v)
        if (!vPerPoint && i > 0) {
            const dx = cx - points[i - 1][0];
            const dy = cy - points[i - 1][1];
            cumulativeDist += Math.sqrt(dx * dx + dy * dy);
        }
        const vCoord = vPerPoint ? vPerPoint[i] : cumulativeDist;
        // Compute perpendicular direction in screen space
        let nx, ny;
        if (i === 0) [nx, ny] = screenPerp(points[1][0] - cx, points[1][1] - cy);
        else if (i === n - 1) [nx, ny] = screenPerp(cx - points[i - 1][0], cy - points[i - 1][1]);
        else {
            // Interior: average screen perpendiculars (miter)
            const [s1x, s1y] = screenPerp(cx - points[i - 1][0], cy - points[i - 1][1]);
            const [s2x, s2y] = screenPerp(points[i + 1][0] - cx, points[i + 1][1] - cy);
            let mx = (s1x + s2x) / 2;
            let my = (s1y + s2y) / 2;
            const mLen = Math.sqrt(mx * mx + my * my);
            if (mLen > 0.001) {
                const dot = s1x * mx + s1y * my;
                const miterScale = Math.min(dot > 0.1 ? 1 / dot : 1, 1);
                mx = mx / mLen * miterScale;
                my = my / mLen * miterScale;
            } else {
                mx = s1x;
                my = s1y;
            }
            nx = mx;
            ny = my;
        }
        // Per-vertex z offset from the center z, accounting for deck tilt.
        // On a heeled surface, the left and right edges of the strip sit at
        // different heights — without this, one edge clips through the deck.
        const offX = nx * halfWidth;
        const offY = ny * halfWidth;
        const dz = zSlope ? zSlope.dx * offX + zSlope.dy * offY : 0;
        // Left vertex: u = +1
        outVertices[vOff++] = cx + offX;
        outVertices[vOff++] = cy + offY;
        outVertices[vOff++] = 1; // u
        outVertices[vOff++] = vCoord; // v
        outVertices[vOff++] = z + dz;
        // Right vertex: u = -1
        outVertices[vOff++] = cx - offX;
        outVertices[vOff++] = cy - offY;
        outVertices[vOff++] = -1; // u
        outVertices[vOff++] = vCoord; // v
        outVertices[vOff++] = z - dz;
        // Indices: connect to previous pair
        if (i > 0) {
            const base = (i - 1) * 2;
            outIndices[iOff++] = base;
            outIndices[iOff++] = base + 2;
            outIndices[iOff++] = base + 3;
            outIndices[iOff++] = base;
            outIndices[iOff++] = base + 3;
            outIndices[iOff++] = base + 1;
        }
    }
    return {
        vertexCount: n * 2,
        indexCount: (n - 1) * 6
    };
}


/** 5 floats per vertex: position (2) + uv (2) + z (1) */ const $9d345f252bc77a52$var$ROPE_VERTEX_STRIDE = (0, $65c81fa1e5a3b256$export$4cb9e45bb8672b46) * 4; // 20 bytes
const $9d345f252bc77a52$export$e155887fc1de07bb = 32;
const $9d345f252bc77a52$var$RopeUniforms = (0, $ca6793d1abd58997$export$99bb2281c7368d10)("RopeUniforms", {
    viewMatrix: (0, $ca6793d1abd58997$export$a9b01fc77c97438b),
    alpha: (0, $ca6793d1abd58997$export$e33361ff41014190),
    twistFrequency: (0, $ca6793d1abd58997$export$e33361ff41014190),
    carriersPerFamily: (0, $ca6793d1abd58997$export$8bacf4ad828c7fe7),
    isBraid: (0, $ca6793d1abd58997$export$8bacf4ad828c7fe7),
    weaveOver: (0, $ca6793d1abd58997$export$8bacf4ad828c7fe7),
    weaveUnder: (0, $ca6793d1abd58997$export$8bacf4ad828c7fe7),
    helixScale: (0, $ca6793d1abd58997$export$e33361ff41014190),
    // Global scene illumination (sun + sky), pushed per-frame from TimeOfDay.
    ambientLight: (0, $ca6793d1abd58997$export$9100789c9d999364),
    // 8 × vec4<u32> = 32 carrier slots, packed 0xRRGGBB.
    carriers0: (0, $ca6793d1abd58997$export$a4a790709c608b06),
    carriers1: (0, $ca6793d1abd58997$export$a4a790709c608b06),
    carriers2: (0, $ca6793d1abd58997$export$a4a790709c608b06),
    carriers3: (0, $ca6793d1abd58997$export$a4a790709c608b06),
    carriers4: (0, $ca6793d1abd58997$export$a4a790709c608b06),
    carriers5: (0, $ca6793d1abd58997$export$a4a790709c608b06),
    carriers6: (0, $ca6793d1abd58997$export$a4a790709c608b06),
    carriers7: (0, $ca6793d1abd58997$export$a4a790709c608b06)
});
const $9d345f252bc77a52$var$ROPE_SHADER_SOURCE = /*wgsl*/ `
${$9d345f252bc77a52$var$RopeUniforms.wgsl}

// Depth mapping \u{2014} must match WebGPURenderer constants
const Z_MIN: f32 = ${(0, $5453fd34f01ad367$export$738c420ee12b9cdb)};
const Z_MAX: f32 = ${(0, $5453fd34f01ad367$export$e06187491332e57c)};
const PI: f32 = 3.14159265;

@group(0) @binding(0) var<uniform> uniforms: RopeUniforms;

struct VertexInput {
  @location(0) position: vec2<f32>,
  @location(1) uv: vec2<f32>,
  @location(2) z: f32,
}

struct VertexOutput {
  @builtin(position) position: vec4<f32>,
  @location(0) uv: vec2<f32>,
}

@vertex
fn vs_main(in: VertexInput) -> VertexOutput {
  let worldPos = vec3<f32>(in.position, 1.0);
  let clipPos = uniforms.viewMatrix * worldPos;
  // Small depth bias to break z-fighting with deck geometry that sits at
  // the same world z (different depth computation paths: rope shader vs
  // shape shader with tilt transform). Kept tiny so deck hardware drawn
  // above the rope at rope_z + small \u{394} wins on the depth test.
  let depth = (in.z - Z_MIN) / (Z_MAX - Z_MIN) + 0.0001;

  var out: VertexOutput;
  out.position = vec4<f32>(clipPos.xy, depth, 1.0);
  out.uv = in.uv;
  return out;
}

fn unpackRGB(packed: u32) -> vec3<f32> {
  return vec3<f32>(
    f32((packed >> 16u) & 0xFFu) / 255.0,
    f32((packed >> 8u) & 0xFFu) / 255.0,
    f32(packed & 0xFFu) / 255.0
  );
}

fn getCarrierColor(id: u32) -> vec3<f32> {
  let chunk = id >> 2u;   // which vec4<u32> (0-7)
  let lane = id & 3u;     // which element within vec4 (0-3)
  var v: vec4<u32>;
  switch chunk {
    case 0u: { v = uniforms.carriers0; }
    case 1u: { v = uniforms.carriers1; }
    case 2u: { v = uniforms.carriers2; }
    case 3u: { v = uniforms.carriers3; }
    case 4u: { v = uniforms.carriers4; }
    case 5u: { v = uniforms.carriers5; }
    case 6u: { v = uniforms.carriers6; }
    case 7u: { v = uniforms.carriers7; }
    default: { v = uniforms.carriers0; }
  }
  return unpackRGB(v[lane]);
}

// --- Unified rope pattern ---
// Scales UV into a diamond grid sized so carriersPerFamily/2 diamonds fit
// across the visible width (matches the circumference geometry of real rope).
// For laid: samples one diagonal only \u{2192} parallel helical stripes.
// For braid: samples both diagonals with a checkerboard \u{2192} diamond weave with
// independent S-laid and Z-laid families.

// Evaluate the procedural pattern at a single (u, v) sample, returning the
// carrier color for that cell. Cheap \u{2014} a handful of floor/mod ops.
fn sampleCarrier(u: f32, v: f32) -> vec3<f32> {
  let cpf = f32(uniforms.carriersPerFamily);
  let nVisible = cpf * 0.5;

  // Recover physical rope width from twist frequency (2\u{3C0} / (8 * width)).
  let ropeWidth = 2.0 * PI / (8.0 * uniforms.twistFrequency);

  // Orthographic cylinder projection: screen u \u{2192} surface angle via asin.
  let su = asin(clamp(u, -1.0, 1.0)) * nVisible / PI;
  let sv = v * nVisible / ropeWidth;
  let hs = uniforms.helixScale;

  let du = su + sv * hs;
  let ci = floor(du);
  let sId = ((ci % cpf) + cpf) % cpf;

  var carrierIdx: u32;
  if (uniforms.isBraid == 0u) {
    carrierIdx = u32(sId);
  } else {
    let dv = -su + sv * hs;
    let cj = floor(dv);
    let period = f32(uniforms.weaveOver + uniforms.weaveUnder);
    let phase = ((ci + cj) % period + period) % period;
    let isOver = phase < f32(uniforms.weaveOver);
    let zId = ((cj % cpf) + cpf) % cpf;
    if (isOver) {
      carrierIdx = u32(sId);
    } else {
      carrierIdx = u32(zId) + uniforms.carriersPerFamily;
    }
  }
  return getCarrierColor(carrierIdx);
}

// Adaptive supersampling: evaluate the pattern multiple times per fragment
// when the strand cells shrink below pixel size, resolving shimmer.
// Grid dimension N is chosen from the screen-space cell density, so close-up
// ropes run a single tap and only distant/thin ropes pay for more samples.
// NMax = 4 \u{2192} at most 16 taps at the heaviest LOD.
@fragment
fn fs_main(in: VertexOutput) -> @location(0) vec4<f32> {
  let u = in.uv.x;
  let v = in.uv.y;

  // Derivatives MUST be taken in uniform control flow, so compute them up
  // front before any data-dependent branching.
  let dudx = dpdx(u);
  let dudy = dpdy(u);
  let dvdx = dpdx(v);
  let dvdy = dpdy(v);

  // Estimate cells-per-pixel along the dominant pattern diagonal so we can
  // size the supersample grid. Uses the same coordinate transform as
  // sampleCarrier(), linearized: d(asin)/du \u{2248} 1/sqrt(1-u\xb2).
  let cpf = f32(uniforms.carriersPerFamily);
  let nVisible = cpf * 0.5;
  let ropeWidth = 2.0 * PI / (8.0 * uniforms.twistFrequency);
  let asinScale = 1.0 / sqrt(max(1.0 - u * u, 1e-4));
  let suPerU = asinScale * nVisible / PI;
  let svPerV = nVisible / ropeWidth;
  let hs = uniforms.helixScale;
  // |d(du)/dx| + |d(du)/dy| \u{2014} derivative of the first diagonal in screen px.
  let fwDu = abs(suPerU * dudx + hs * svPerV * dvdx)
           + abs(suPerU * dudy + hs * svPerV * dvdy);
  let fwDv = abs(-suPerU * dudx + hs * svPerV * dvdx)
           + abs(-suPerU * dudy + hs * svPerV * dvdy);
  let cellsPerPixel = select(fwDu, max(fwDu, fwDv), uniforms.isBraid != 0u);

  // Nyquist: need ~2 samples per cell along the worst axis. With an NxN
  // grid each tap covers 1/N of a pixel, so we want N \u{2248} 2*cellsPerPixel.
  // Clamp to [1, 4]; 4 means 16 taps, reserved for heavily-compressed ropes.
  let nF = clamp(ceil(2.0 * cellsPerPixel), 1.0, 4.0);
  let N = i32(nF);

  var acc = vec3<f32>(0.0);
  let invN = 1.0 / nF;
  for (var j = 0; j < N; j = j + 1) {
    let sy = (f32(j) + 0.5) * invN - 0.5;
    for (var i = 0; i < N; i = i + 1) {
      let sx = (f32(i) + 0.5) * invN - 0.5;
      let uu = u + sx * dudx + sy * dudy;
      let vv = v + sx * dvdx + sy * dvdy;
      acc = acc + sampleCarrier(uu, vv);
    }
  }
  let color = acc / f32(N * N);
  return vec4<f32>(color * uniforms.ambientLight, uniforms.alpha);
}
`;
// Module-level singleton state
let $9d345f252bc77a52$var$pipelineWithDepth = null;
let $9d345f252bc77a52$var$bindGroupLayout = null;
let $9d345f252bc77a52$var$initPromise = null;
let $9d345f252bc77a52$var$shaderModule = null;
let $9d345f252bc77a52$var$pipelineLayout = null;
let $9d345f252bc77a52$var$msaaSubscribed = false;
function $9d345f252bc77a52$var$rebuildRopePipeline() {
    if (!$9d345f252bc77a52$var$shaderModule || !$9d345f252bc77a52$var$pipelineLayout) return;
    const gpu = (0, $558c2f47f1fdd57f$export$297162150ea0f6af)();
    const device = gpu.device;
    const vertexBufferLayout = {
        arrayStride: $9d345f252bc77a52$var$ROPE_VERTEX_STRIDE,
        attributes: [
            {
                shaderLocation: 0,
                offset: 0,
                format: "float32x2"
            },
            {
                shaderLocation: 1,
                offset: 8,
                format: "float32x2"
            },
            {
                shaderLocation: 2,
                offset: 16,
                format: "float32"
            }
        ]
    };
    $9d345f252bc77a52$var$pipelineWithDepth = device.createRenderPipeline({
        layout: $9d345f252bc77a52$var$pipelineLayout,
        vertex: {
            module: $9d345f252bc77a52$var$shaderModule,
            entryPoint: "vs_main",
            buffers: [
                vertexBufferLayout
            ]
        },
        fragment: {
            module: $9d345f252bc77a52$var$shaderModule,
            entryPoint: "fs_main",
            targets: [
                {
                    format: gpu.preferredFormat,
                    blend: {
                        color: {
                            srcFactor: "src-alpha",
                            dstFactor: "one-minus-src-alpha",
                            operation: "add"
                        },
                        alpha: {
                            srcFactor: "one",
                            dstFactor: "one-minus-src-alpha",
                            operation: "add"
                        }
                    }
                }
            ]
        },
        primitive: {
            topology: "triangle-list"
        },
        depthStencil: {
            format: "depth24plus",
            depthCompare: "greater-equal",
            depthWriteEnabled: true
        },
        multisample: {
            count: (0, $3d4164726c38f33c$export$688369c54d530641)()
        },
        label: "Rope Pipeline"
    });
}
async function $9d345f252bc77a52$var$ensureInitialized() {
    if ($9d345f252bc77a52$var$pipelineWithDepth) return;
    if ($9d345f252bc77a52$var$initPromise) return $9d345f252bc77a52$var$initPromise;
    $9d345f252bc77a52$var$initPromise = (async ()=>{
        const gpu = (0, $558c2f47f1fdd57f$export$297162150ea0f6af)();
        const device = gpu.device;
        $9d345f252bc77a52$var$shaderModule = await gpu.createShaderModuleChecked($9d345f252bc77a52$var$ROPE_SHADER_SOURCE, "Rope Shader");
        $9d345f252bc77a52$var$bindGroupLayout = device.createBindGroupLayout({
            entries: [
                {
                    binding: 0,
                    visibility: GPUShaderStage.VERTEX | GPUShaderStage.FRAGMENT,
                    buffer: {
                        type: "uniform"
                    }
                }
            ],
            label: "Rope Bind Group Layout"
        });
        $9d345f252bc77a52$var$pipelineLayout = device.createPipelineLayout({
            bindGroupLayouts: [
                $9d345f252bc77a52$var$bindGroupLayout
            ],
            label: "Rope Pipeline Layout"
        });
        $9d345f252bc77a52$var$rebuildRopePipeline();
        if (!$9d345f252bc77a52$var$msaaSubscribed) {
            $9d345f252bc77a52$var$msaaSubscribed = true;
            (0, $3d4164726c38f33c$export$19f5a511f7104745)($9d345f252bc77a52$var$rebuildRopePipeline);
        }
    })();
    return $9d345f252bc77a52$var$initPromise;
}
class $9d345f252bc77a52$export$35a221965e8cc345 {
    constructor(maxPoints){
        this.vertexBuffer = null;
        this.indexBuffer = null;
        this.uniformBuffer = null;
        this.bindGroup = null;
        this.uniforms = $9d345f252bc77a52$var$RopeUniforms.create();
        this.combinedMatrix = new (0, $b29a77d98f1bc0d5$export$8ff26dafa08918)();
        this.maxVertices = maxPoints * 2;
        this.maxIndices = (maxPoints - 1) * 6;
        this.scratchVertexData = new Float32Array(this.maxVertices * (0, $65c81fa1e5a3b256$export$4cb9e45bb8672b46));
        // Pad to even length for 4-byte alignment
        this.scratchIndexData = new Uint16Array(this.maxIndices + 1 & -2);
    }
    /** Lazily create GPU buffers. Returns false if not ready yet. */ ensureBuffers() {
        if (this.vertexBuffer) return true;
        if (!$9d345f252bc77a52$var$pipelineWithDepth || !$9d345f252bc77a52$var$bindGroupLayout) return false;
        const device = (0, $558c2f47f1fdd57f$export$297162150ea0f6af)().device;
        this.vertexBuffer = device.createBuffer({
            size: this.maxVertices * $9d345f252bc77a52$var$ROPE_VERTEX_STRIDE,
            usage: GPUBufferUsage.VERTEX | GPUBufferUsage.COPY_DST,
            label: "Rope Vertex Buffer"
        });
        this.indexBuffer = device.createBuffer({
            size: this.scratchIndexData.byteLength,
            usage: GPUBufferUsage.INDEX | GPUBufferUsage.COPY_DST,
            label: "Rope Index Buffer"
        });
        this.uniformBuffer = device.createBuffer({
            size: $9d345f252bc77a52$var$RopeUniforms.byteSize,
            usage: GPUBufferUsage.UNIFORM | GPUBufferUsage.COPY_DST,
            label: "Rope Uniform Buffer"
        });
        this.bindGroup = device.createBindGroup({
            layout: $9d345f252bc77a52$var$bindGroupLayout,
            entries: [
                {
                    binding: 0,
                    resource: {
                        buffer: this.uniformBuffer
                    }
                }
            ],
            label: "Rope Bind Group"
        });
        return true;
    }
    /**
   * Upload vertex data and draw the rope with the given pattern.
   * Caller must have called renderer.flush() before this.
   */ draw(renderer, vertexData, vertexCount, indexData, indexCount, pattern, alpha, ropeWidth, timeOfDay) {
        if (!$9d345f252bc77a52$var$pipelineWithDepth) {
            $9d345f252bc77a52$var$ensureInitialized();
            return;
        }
        if (!this.ensureBuffers()) return;
        if (vertexCount === 0 || indexCount === 0) return;
        const device = (0, $558c2f47f1fdd57f$export$297162150ea0f6af)().device;
        const renderPass = renderer.getCurrentRenderPass();
        if (!renderPass) return;
        // Upload vertex data
        const vBytes = vertexCount * $9d345f252bc77a52$var$ROPE_VERTEX_STRIDE;
        device.queue.writeBuffer(this.vertexBuffer, 0, vertexData.buffer, vertexData.byteOffset, vBytes);
        // Upload index data
        const iBytes = Math.ceil(indexCount * 2 / 4) * 4; // 4-byte aligned
        device.queue.writeBuffer(this.indexBuffer, 0, indexData.buffer, indexData.byteOffset, iBytes);
        // Derive shader parameters from the pattern
        const isBraid = pattern.type === "braid" ? 1 : 0;
        const carriersPerFamily = pattern.type === "braid" ? Math.floor(pattern.carriers.length / 2) : pattern.carriers.length;
        const cpf = Math.max(1, Math.min(carriersPerFamily, $9d345f252bc77a52$export$e155887fc1de07bb / 2));
        const weaveOver = Math.max(1, pattern.weave?.[0] ?? 1);
        const weaveUnder = Math.max(1, pattern.weave?.[1] ?? 1);
        const helixAngleDeg = pattern.helixAngle ?? 45;
        const helixScale = Math.tan(helixAngleDeg * Math.PI / 180);
        // Upload uniforms
        this.combinedMatrix.copyFrom(renderer.getViewMatrix());
        this.combinedMatrix.multiply(renderer.getTransform());
        this.uniforms.set.viewMatrix(this.combinedMatrix);
        this.uniforms.set.alpha(alpha);
        this.uniforms.set.twistFrequency(2 * Math.PI / (8 * Math.max(ropeWidth, 0.01)));
        this.uniforms.set.carriersPerFamily(cpf);
        this.uniforms.set.isBraid(isBraid);
        this.uniforms.set.weaveOver(weaveOver);
        this.uniforms.set.weaveUnder(weaveUnder);
        this.uniforms.set.helixScale(helixScale);
        this.uniforms.set.ambientLight(timeOfDay?.getAmbientLight() ?? [
            1,
            1,
            1
        ]);
        // Pack carriers into 8 vec4<u32> slots. Pad with the first color.
        const pad = pattern.carriers[0] ?? 0x888888;
        const slots = [
            this.uniforms.set.carriers0,
            this.uniforms.set.carriers1,
            this.uniforms.set.carriers2,
            this.uniforms.set.carriers3,
            this.uniforms.set.carriers4,
            this.uniforms.set.carriers5,
            this.uniforms.set.carriers6,
            this.uniforms.set.carriers7
        ];
        for(let chunk = 0; chunk < 8; chunk++){
            const i = chunk * 4;
            slots[chunk]([
                pattern.carriers[i + 0] ?? pad,
                pattern.carriers[i + 1] ?? pad,
                pattern.carriers[i + 2] ?? pad,
                pattern.carriers[i + 3] ?? pad
            ]);
        }
        this.uniforms.uploadTo(this.uniformBuffer);
        // Draw
        renderPass.setPipeline($9d345f252bc77a52$var$pipelineWithDepth);
        renderPass.setBindGroup(0, this.bindGroup);
        renderPass.setVertexBuffer(0, this.vertexBuffer);
        renderPass.setIndexBuffer(this.indexBuffer, "uint16");
        renderPass.drawIndexed(indexCount);
    }
    /** Clean up GPU resources. */ destroy() {
        this.vertexBuffer?.destroy();
        this.indexBuffer?.destroy();
        this.uniformBuffer?.destroy();
        this.vertexBuffer = null;
        this.indexBuffer = null;
        this.uniformBuffer = null;
        this.bindGroup = null;
    }
}



/**
 * Drawing helper for rendering geometry inside a 3D tilt context.
 *
 * Wraps the screen-width tessellation functions and renderer submission into
 * a concise API. Lines, polylines, and circles maintain constant screen-space
 * width regardless of the boat's roll, pitch, and yaw.
 *
 * Usage:
 *   const td = new TiltDraw(draw.renderer, tilt);
 *   td.line(x1, y1, z1, x2, y2, z2, 0.4, color, 1, true);
 */ 
class $aefe0d50abc5ab3a$export$dd1846c3fb304cae {
    constructor(renderer, tilt){
        this.renderer = renderer;
        this.tilt = tilt;
    }
    /** Submit pre-built mesh geometry (hull, keel, deck plan zones, etc.). */ mesh(mesh) {
        if (!mesh || mesh.indices.length === 0) return;
        this.renderer.submitTrianglesWithZ(mesh.positions, mesh.indices, mesh.color, mesh.alpha, mesh.zValues);
    }
    /** Cylindrical line with constant screen width and optional round caps. */ line(x1, y1, z1, x2, y2, z2, width, color, alpha = 1, roundCaps = false) {
        this.mesh((0, $65c81fa1e5a3b256$export$da1828449b1d0ea1)(x1, y1, z1, x2, y2, z2, width, this.tilt, color, alpha, roundCaps));
    }
    /**
   * Polyline with constant screen width.
   * @param closed — Join first and last points (default false).
   * @param roundJoins — Use rounded joins and end caps (default false).
   */ polyline(points, zValues, width, color, alpha = 1, closed = false, roundJoins = false) {
        this.mesh((0, $65c81fa1e5a3b256$export$7260a9f54460c34a)(points, zValues, width, this.tilt, color, alpha, closed, roundJoins));
    }
    /**
   * Flat filled disk in the hull-local horizontal plane. Unlike `circle`,
   * this foreshortens naturally under roll/pitch (so deck hardware doesn't
   * visually grow outboard of the deck when the boat heels).
   */ flatCircle(x, y, z, radius, segments, color, alpha = 1) {
        this.mesh((0, $65c81fa1e5a3b256$export$44893fdbbdec8bb4)(x, y, z, radius, segments, color, alpha));
    }
    /** Filled circle with constant screen radius. */ circle(x, y, z, radius, segments, color, alpha = 1) {
        this.mesh((0, $65c81fa1e5a3b256$export$4202d7a1c044998c)(x, y, z, radius, segments, this.tilt, color, alpha));
    }
}


class $cbea09b7c78e78c3$export$a1ffd5948b27dfc8 extends (0, $c59361981bac2575$export$4342ba5c6ad1f6f1) {
    constructor(boat){
        super(), this.boat = boat, this.layer = "boat", this.keelMesh = null, this.deckPlanMeshes = [], this.ropeRenderState = new Map(), this.rodeState = null;
        this.config = boat.config;
        this.buildStaticMeshes();
    }
    buildStaticMeshes() {
        // Keel: vertical blade from hull bottom to keel tip
        const keel = this.boat.keel;
        const keelVertices = keel.getVertices();
        const keelColor = keel.getColor();
        const topZ = -this.config.hull.draft; // hull bottom
        const bottomZ = -this.config.keel.draft; // keel tip
        // Build a vertical quad strip: for each vertex, top and bottom copies
        const n = keelVertices.length;
        const positions = [];
        const zValues = [];
        for (const v of keelVertices){
            positions.push([
                v.x,
                v.y
            ]); // top edge (at hull bottom)
            positions.push([
                v.x,
                v.y
            ]); // bottom edge (at keel tip)
            zValues.push(topZ, bottomZ);
        }
        // Triangle strip indices: pairs of quads between consecutive vertices
        const indices = [];
        for(let i = 0; i < n - 1; i++){
            const tl = i * 2; // top-left
            const bl = tl + 1; // bottom-left
            const tr = tl + 2; // top-right
            const br = tl + 3; // bottom-right
            indices.push(tl, tr, br, tl, br, bl);
        }
        this.keelMesh = {
            positions: positions,
            zValues: zValues,
            indices: indices,
            color: keelColor,
            alpha: 1
        };
        // Build deck plan meshes if configured
        const deckPlan = this.config.hull.deckPlan;
        if (deckPlan) {
            const hullMeshData = this.boat.hull.getHeightMeshData();
            const hullOutline = hullMeshData.deckOutline ?? // Fallback: extract from first ringSize vertices (legacy ring mesh)
            Array.from({
                length: hullMeshData.ringSize
            }, (_, i)=>[
                    hullMeshData.xyPositions[i][0],
                    hullMeshData.xyPositions[i][1]
                ]);
            this.deckPlanMeshes = (0, $9783a58f4a31b8ed$export$ed43fcbd0ec203c)(deckPlan, hullOutline, this.config.hull.deckHeight, hullMeshData);
        }
    }
    onRender({ draw: draw }) {
        const hull = this.boat.hull;
        const hullBody = hull.body;
        const [x, y] = hullBody.position;
        // Precompute tilt projection for screen-width tessellation
        const tilt = (0, $0180785820f28c5a$export$be524feb371e374f)(hullBody.angle, hullBody.roll, hullBody.pitch);
        draw.at({
            pos: (0, $6b6a54a072724620$export$e7c866399fa523f5)(x, y),
            angle: hullBody.angle,
            tilt: {
                roll: hullBody.roll,
                pitch: hullBody.pitch,
                zOffset: hullBody.z
            }
        }, ()=>{
            const renderer = draw.renderer;
            const td = new (0, $aefe0d50abc5ab3a$export$dd1846c3fb304cae)(renderer, tilt);
            // === 1. Keel (deepest, drawn first) ===
            td.mesh(this.keelMesh);
            // === 2. Rudder blade (underwater, flat — hull-local width is correct) ===
            this.renderRudder(td);
            // === 3. Hull mesh (lower sides → upper sides → deck) ===
            const { xyPositions: xyPositions, zValues: zValues, lowerSideIndices: lowerSideIndices, upperSideIndices: upperSideIndices, deckIndices: deckIndices, ringSize: ringSize } = hull.getHeightMeshData();
            renderer.submitTrianglesWithZ(xyPositions, lowerSideIndices, hull.getSideColor(), 1.0, zValues);
            renderer.submitTrianglesWithZ(xyPositions, upperSideIndices, hull.getSideColor(), 1.0, zValues);
            // Deck surface: use deck plan zones if configured, otherwise flat deck cap
            if (this.deckPlanMeshes.length > 0) for (const mesh of this.deckPlanMeshes)td.mesh(mesh);
            else renderer.submitTrianglesWithZ(xyPositions, deckIndices, hull.getFillColor(), 1.0, zValues);
            // === 4. Gunwale stroke ===
            const meshData = hull.getHeightMeshData();
            const deckZ = meshData.zValues[0]; // deck ring z
            const gunwalePoints = meshData.deckOutline ? meshData.deckOutline.map(([x, y])=>[
                    x,
                    y
                ]) : Array.from({
                length: ringSize
            }, (_, i)=>xyPositions[i]);
            // Gunwales sit a couple of inches above the deck surface
            const gunwaleZ = deckZ + 0.2;
            td.polyline(gunwalePoints, gunwalePoints.map(()=>gunwaleZ), 0.25, hull.getStrokeColor(), 1, true);
            // === 5. Helm (tiller or wheel) ===
            this.renderHelm(td);
            // === 6. Bowsprit (cylindrical — screen-width, with round caps) ===
            if (this.boat.bowsprit) {
                const bs = this.boat.bowsprit;
                const bsZ = this.config.tilt.zHeights.bowsprit;
                td.line(bs.localPosition.x, bs.localPosition.y, bsZ, bs.localPosition.x + bs.size.x, bs.localPosition.y, bsZ, bs.size.y, bs.getColor(), 1, true);
            }
            // === 7. Boom (cylindrical — screen-width) ===
            this.renderBoom(td);
            // === 8. Sheet blocks/winches — bottom cheek (below ropes) ===
            this.renderBlocksPass(td, false);
            // === 9. Standing rigging (wires — screen-width) ===
            this.renderStandingRigging(td);
            // === 10. Lifeline stanchions (tubes — screen-width) ===
            this.renderStanchions(td);
            // === 11. Lifeline pulpits and wires (screen-width) ===
            this.renderLifelineWires(td);
            // === 12. Mast (cylindrical — screen-width, tallest, drawn last) ===
            this.renderMast(td);
        });
        // === 13. Sheets/ropes — rendered in world space (outside draw.at) ===
        // Sheet rope endpoints come from the cloth sim which includes tilt parallax,
        // matching the sail rendering. Rendering through the hull model matrix would
        // double-count the tilt.
        const renderer = draw.renderer;
        renderer.flush();
        (0, $5a1d1d3ab1ff9c51$export$e8e2fad003b4d4ce).start("rope.render.draw");
        this.renderSheet(renderer, this.boat.mainsheet, hullBody);
        if (this.boat.portJibSheet) this.renderSheet(renderer, this.boat.portJibSheet, hullBody);
        if (this.boat.starboardJibSheet) this.renderSheet(renderer, this.boat.starboardJibSheet, hullBody);
        this.renderSheet(renderer, this.boat.mainHalyard, hullBody);
        // === 14. Anchor rode ===
        this.renderRode(renderer);
        (0, $5a1d1d3ab1ff9c51$export$e8e2fad003b4d4ce).end("rope.render.draw");
        // === 15. Sheet blocks/winches — top cheek + handles (above ropes) ===
        renderer.flush();
        draw.at({
            pos: (0, $6b6a54a072724620$export$e7c866399fa523f5)(x, y),
            angle: hullBody.angle,
            tilt: {
                roll: hullBody.roll,
                pitch: hullBody.pitch,
                zOffset: hullBody.z
            }
        }, ()=>{
            const td = new (0, $aefe0d50abc5ab3a$export$dd1846c3fb304cae)(draw.renderer, tilt);
            this.renderBlocksPass(td, true);
        });
    // Bilge water and hull silhouette masking are handled by
    // BoatWaterStampShader in the surface-rendering pass, which stamps
    // water heights directly into waterHeightTexture. The water filter
    // then renders both uniformly with the same physically-based model
    // it uses for the ocean.
    }
    renderRudder(td) {
        const rudder = this.boat.rudder;
        const relAngle = rudder.getTillerAngleOffset();
        const pivot = rudder.getPosition();
        const rudderZ = rudder.getRudderZ();
        const rudderLength = rudder.getLength();
        const rudderColor = rudder.getColor();
        const deckZ = this.config.hull.deckHeight;
        const bladeTopZ = 0.5; // blade starts just above waterline
        const stockWidth = 0.3;
        // Blade trailing edge in hull-local coords (extends aft from the stock)
        const cos = Math.cos(relAngle);
        const sin = Math.sin(relAngle);
        const trailingX = pivot.x - rudderLength * cos;
        const trailingY = pivot.y - rudderLength * sin;
        // Rudder blade — vertical rectangle: leading edge at stock, trailing edge aft.
        td.mesh({
            positions: [
                [
                    pivot.x,
                    pivot.y
                ],
                [
                    trailingX,
                    trailingY
                ],
                [
                    trailingX,
                    trailingY
                ],
                [
                    pivot.x,
                    pivot.y
                ]
            ],
            zValues: [
                bladeTopZ,
                bladeTopZ,
                rudderZ,
                rudderZ
            ],
            indices: [
                0,
                1,
                2,
                0,
                2,
                3
            ],
            color: rudderColor,
            alpha: 1
        });
        // Blade top edge — screen-width line so blade has visible thickness from above
        td.line(pivot.x, pivot.y, bladeTopZ, trailingX, trailingY, bladeTopZ, 0.2, rudderColor, 1, true);
        // Rudder stock — vertical shaft from deck down through hull to blade
        td.line(pivot.x, pivot.y, deckZ, pivot.x, pivot.y, rudderZ, stockWidth, rudderColor, 1, true);
    }
    renderHelm(td) {
        if (this.config.helm?.type === "wheel") this.renderWheel(td);
        else this.renderTiller(td);
    }
    renderTiller(td) {
        const rudder = this.boat.rudder;
        const tillerAngle = rudder.getTillerAngleOffset();
        const basePos = this.config.helm?.position ?? rudder.getPosition();
        const deckZ = this.config.hull.deckHeight;
        const cos = Math.cos(tillerAngle);
        const sin = Math.sin(tillerAngle);
        const tipX = basePos.x + 3 * cos;
        const tipY = basePos.y + 3 * sin;
        td.line(basePos.x, basePos.y, deckZ, tipX, tipY, deckZ, 0.25, 0x886633, 1, true);
    }
    renderWheel(td) {
        const helm = this.config.helm;
        if (!helm || helm.type !== "wheel" || !helm.position) return;
        const rudder = this.boat.rudder;
        const deckZ = this.config.hull.deckHeight;
        const radius = helm.radius ?? 1.5;
        const turns = helm.turns ?? 1;
        // The wheel rotates faster than the rudder: visually it turns through
        // `turns` revolutions while the rudder swings from center to full lock.
        const maxSteer = this.config.rudder.maxSteerAngle;
        const wheelAngle = rudder.getTillerAngleOffset() * turns * (Math.PI / maxSteer);
        const cx = helm.position.x;
        const cy = helm.position.y;
        // The wheel stands vertical on a pedestal, axis pointing fore-aft.
        // Its plane is Y-Z (port-starboard × up-down), so from above the rim
        // is a horizontal line port-starboard. Handles rotate in Y-Z and
        // appear as bumps extending past that line (when horizontal) or as
        // dots rising above the rim (when vertical).
        const axisZ = deckZ + radius + 0.3;
        const woodColor = this.boat.rig.getBoomColor();
        const handleColor = (0, $913afda613ebf2cb$export$c0816ed86df316af)(woodColor, 0.25);
        const hubColor = rudder.getColor();
        const numSpokes = 8;
        const rimSegments = 32;
        const innerR = radius * 0.85;
        const handleLength = radius * 0.3;
        const rimWidth = Math.max(0.15, radius * 0.18);
        const spokeWidth = Math.max(0.08, radius * 0.08);
        const handleWidth = Math.max(0.12, radius * 0.13);
        // Pedestal post — vertical from deck to wheel axis
        td.line(cx, cy, deckZ, cx, cy, axisZ, 0.35, 0x2a2a2a, 1, true);
        // Wheel rim — circle in Y-Z plane (all points at x = cx)
        const rimPts = [];
        const rimZs = [];
        for(let i = 0; i <= rimSegments; i++){
            const a = i / rimSegments * Math.PI * 2;
            rimPts.push([
                cx,
                cy + Math.cos(a) * radius
            ]);
            rimZs.push(axisZ + Math.sin(a) * radius);
        }
        td.polyline(rimPts, rimZs, rimWidth, woodColor, 1, true, true);
        // Spokes (hub → inner rim) and handles (rim → tip) in Y-Z plane
        for(let i = 0; i < numSpokes; i++){
            const a = wheelAngle + i / numSpokes * Math.PI * 2;
            const co = Math.cos(a);
            const si = Math.sin(a);
            const rimY = cy + co * innerR;
            const rimZ = axisZ + si * innerR;
            td.line(cx, cy, axisZ, cx, rimY, rimZ, spokeWidth, woodColor, 1, true);
            const handleBaseY = cy + co * radius;
            const handleBaseZ = axisZ + si * radius;
            const handleTipY = cy + co * (radius + handleLength);
            const handleTipZ = axisZ + si * (radius + handleLength);
            td.line(cx, handleBaseY, handleBaseZ, cx, handleTipY, handleTipZ, handleWidth, handleColor, 1, true);
        }
        // Hub — short horizontal axle pointing fore-aft (visible from above as a
        // short line along X, centered on the wheel axis)
        const hubHalfLen = radius * 0.15;
        td.line(cx - hubHalfLen, cy, axisZ, cx + hubHalfLen, cy, axisZ, Math.max(0.2, radius * 0.22), hubColor, 1, true);
    }
    renderBoom(td) {
        const rig = this.boat.rig;
        const boomRelAngle = rig.getBoomRelativeYaw();
        const mastPos = rig.getMastPosition();
        const boomLength = rig.getBoomLength();
        const boomZ = rig.getBoomZ();
        const cos = Math.cos(boomRelAngle);
        const sin = Math.sin(boomRelAngle);
        const endX = mastPos.x - boomLength * cos;
        const endY = mastPos.y - boomLength * sin;
        td.line(mastPos.x, mastPos.y, boomZ, endX, endY, boomZ, rig.getBoomWidth(), rig.getBoomColor(), 1, true);
    }
    // Blocks and winches are rendered as two circles: a bottom cheek drawn
    // before the ropes and a top cheek drawn after, so the rope visually
    // passes through the hardware. Winches also get a handle on top.
    // The rope has a small depth bias; the top cheek clears it by sitting
    // ~0.3 ft above the rope anchor plane, and the bottom cheek sits at the
    // anchor plane so the rope wins against it.
    renderBlocksPass(td, above) {
        const hullBody = this.boat.hull.body;
        const winchRadius = 0.3;
        const topCheekZ = 0.3;
        const handleZ = 0.42;
        const sheets = [
            this.boat.mainsheet,
            this.boat.portJibSheet,
            this.boat.starboardJibSheet
        ];
        for (const sheet of sheets){
            if (!sheet) continue;
            for (const wp of sheet.getWaypointInfo()){
                const [wx, wy, wz] = wp.position;
                const local = hullBody.toLocalFrame3D(wx, wy, wz);
                const anchorZ = local[2];
                if (!above) td.flatCircle(local[0], local[1], anchorZ, winchRadius, 32, 0x333333);
                else {
                    td.flatCircle(local[0], local[1], anchorZ + topCheekZ, winchRadius, 32, 0x555555);
                    if (wp.type === "winch") {
                        const handleLen = winchRadius * 1.6;
                        const cos = Math.cos(wp.winchAngle);
                        const sin = Math.sin(wp.winchAngle);
                        td.line(local[0], local[1], anchorZ + handleZ, local[0] + cos * handleLen, local[1] + sin * handleLen, anchorZ + handleZ, 0.12, 0x777777, 1, true);
                    }
                }
            }
        }
    }
    renderStandingRigging(td) {
        const rig = this.boat.rig;
        const mastPos = rig.getMastPosition();
        const mastTopZ = rig.getMastTopZ();
        const stays = rig.getStays();
        // The forestay attaches to the top of the roller furler on the bowsprit,
        // not the deck — use the jib's zFoot so the furled jib lies on the stay.
        const forestayZ = this.config.jib?.zFoot ?? stays.deckHeight;
        for (const [attach, bottomZ] of [
            [
                stays.forestay,
                forestayZ
            ],
            [
                stays.portShroud,
                stays.deckHeight
            ],
            [
                stays.starboardShroud,
                stays.deckHeight
            ]
        ])td.line(mastPos.x, mastPos.y, mastTopZ, attach.x, attach.y, bottomZ, 0.1, 0x999999);
        const bridle = stays.backstay;
        td.line(mastPos.x, mastPos.y, mastTopZ, bridle.split.x, bridle.split.y, bridle.splitZ, 0.1, 0x999999);
        for (const corner of [
            bridle.port,
            bridle.starboard
        ])td.line(bridle.split.x, bridle.split.y, bridle.splitZ, corner.x, corner.y, stays.deckHeight, 0.1, 0x999999);
    }
    renderStanchions(td) {
        const lifelineConfig = this.config.lifelines;
        if (!lifelineConfig) return;
        const deckZ = this.config.hull.deckHeight;
        const topZ = deckZ + lifelineConfig.stanchionHeight;
        for (const [sx, sy] of [
            ...lifelineConfig.portStanchions,
            ...lifelineConfig.starboardStanchions
        ])td.line(sx, sy, deckZ, sx, sy, topZ, lifelineConfig.tubeWidth, lifelineConfig.tubeColor, 1, true);
    }
    renderLifelineWires(td) {
        const lifelineConfig = this.config.lifelines;
        if (!lifelineConfig) return;
        const deckZ = this.config.hull.deckHeight;
        const topZ = deckZ + lifelineConfig.stanchionHeight;
        const { tubeColor: tubeColor, wireColor: wireColor, tubeWidth: tubeWidth, wireWidth: wireWidth } = lifelineConfig;
        // Bow pulpit
        if (lifelineConfig.bowPulpit.length >= 2) {
            const points = lifelineConfig.bowPulpit.map((p)=>[
                    p[0],
                    p[1]
                ]);
            const rounded = (0, $ed1092a083b9ec20$export$28cc47cdc2523da5)(points, points.map(()=>topZ), 1.5, 16);
            td.polyline(rounded.points, rounded.zValues, tubeWidth, tubeColor, 1, false, true);
            this.renderPulpitPosts(td, points, rounded, deckZ, topZ, tubeWidth, tubeColor);
        }
        // Stern pulpit
        if (lifelineConfig.sternPulpit.length >= 2) {
            const points = lifelineConfig.sternPulpit.map((p)=>[
                    p[0],
                    p[1]
                ]);
            const rounded = (0, $ed1092a083b9ec20$export$28cc47cdc2523da5)(points, points.map(()=>topZ), 1.5, 16);
            td.polyline(rounded.points, rounded.zValues, tubeWidth, tubeColor, 1, false, true);
            this.renderPulpitPosts(td, points, rounded, deckZ, topZ, tubeWidth, tubeColor);
        }
        // Lifeline wires (port and starboard)
        for (const isPort of [
            true,
            false
        ]){
            const stanchions = isPort ? lifelineConfig.portStanchions : lifelineConfig.starboardStanchions;
            if (stanchions.length === 0) continue;
            const points = [];
            if (lifelineConfig.bowPulpit.length > 0) {
                const bp = isPort ? lifelineConfig.bowPulpit[lifelineConfig.bowPulpit.length - 1] : lifelineConfig.bowPulpit[0];
                points.push([
                    bp[0],
                    bp[1]
                ]);
            }
            for (const s of stanchions)points.push([
                s[0],
                s[1]
            ]);
            if (lifelineConfig.sternPulpit.length > 0) {
                const sp = isPort ? lifelineConfig.sternPulpit[lifelineConfig.sternPulpit.length - 1] : lifelineConfig.sternPulpit[0];
                points.push([
                    sp[0],
                    sp[1]
                ]);
            }
            if (points.length >= 2) {
                // Wires thread through eyes ~½ inch below the stanchion caps
                const wireZ = topZ - 0.5 / 12;
                td.polyline(points, points.map(()=>wireZ), wireWidth, wireColor);
            }
        }
    }
    renderPulpitPosts(td, originalPoints, rounded, deckZ, topZ, tubeWidth, tubeColor) {
        for(let i = 0; i < originalPoints.length; i++){
            // First and last points aren't rounded, use original positions.
            // Interior points use arc midpoints so posts align with the rounded path.
            let px, py;
            if (i === 0 || i === originalPoints.length - 1) [px, py] = originalPoints[i];
            else {
                const mid = rounded.arcMidpoints[i - 1];
                px = mid.x;
                py = mid.y;
            }
            td.line(px, py, deckZ, px, py, topZ, tubeWidth, tubeColor, 1, true);
        }
    }
    static{
        /** Subdivisions per segment for Catmull-Rom rope smoothing. */ this.ROPE_SUBDIVISIONS = 5;
    }
    getRopeRenderState(rawPointCount, sheet) {
        let state = this.ropeRenderState.get(sheet);
        if (!state || state.rawCount !== rawPointCount) {
            const smoothCount = (0, $ed1092a083b9ec20$export$89164c2f10f6b8fa)(rawPointCount, $cbea09b7c78e78c3$export$a1ffd5948b27dfc8.ROPE_SUBDIVISIONS);
            state = {
                shader: new (0, $9d345f252bc77a52$export$35a221965e8cc345)(smoothCount),
                smoothPoints: Array.from({
                    length: smoothCount
                }, ()=>[
                        0,
                        0
                    ]),
                smoothZ: new Array(smoothCount).fill(0),
                rawV: new Array(rawPointCount).fill(0),
                smoothV: new Array(smoothCount).fill(0),
                rawCount: rawPointCount
            };
            this.ropeRenderState.set(sheet, state);
        }
        return state;
    }
    renderSheet(renderer, sheet, hullBody) {
        const opacity = sheet.getOpacity();
        if (opacity <= 0) return;
        const { points: rawPoints, z: rawZ, vPerPoint: vPerPoint } = sheet.getRopePointsWithZ();
        if (rawPoints.length < 2) return;
        const state = this.getRopeRenderState(rawPoints.length, sheet);
        // Use the material-v coordinates supplied by the rope's render layer;
        // spacing is non-uniform (sections can differ in length).
        for(let i = 0; i < rawPoints.length; i++)state.rawV[i] = vPerPoint[i];
        // Smooth the physics points with Catmull-Rom interpolation
        const smoothCount = (0, $ed1092a083b9ec20$export$db25ba51ff51beac)(rawPoints, rawZ, $cbea09b7c78e78c3$export$a1ffd5948b27dfc8.ROPE_SUBDIVISIONS, state.smoothPoints, state.smoothZ, state.rawV, state.smoothV);
        const width = sheet.getRopeThickness();
        const cam = (0, $65c81fa1e5a3b256$export$5c2d7918f7c1ec24)(renderer.getTransform());
        // Compute world-space z-slope from the hull's deck normal so the rope
        // strip tilts with the deck when heeled. Without this, one edge of the
        // strip clips through the tilted deck surface.
        const R = hullBody.orientation;
        const nz = R[8]; // deck normal z-component (cos of combined tilt)
        const zSlope = Math.abs(nz) > 0.01 ? {
            dx: -R[2] / nz,
            dy: -R[5] / nz
        } : {
            dx: 0,
            dy: 0
        };
        const { vertexCount: vertexCount, indexCount: indexCount } = (0, $65c81fa1e5a3b256$export$f8d929b067cb2821)(state.smoothPoints, state.smoothZ, width, cam, state.shader.scratchVertexData, state.shader.scratchIndexData, smoothCount, zSlope, state.smoothV);
        if (vertexCount === 0) return;
        state.shader.draw(renderer, state.shader.scratchVertexData, vertexCount, state.shader.scratchIndexData, indexCount, sheet.getRopePattern(), opacity, width, this.game.entities.tryGetSingleton((0, $4df5c29ec7839388$export$1467403458327a44)) ?? null);
    }
    renderRode(renderer) {
        const rodeData = this.boat.anchor.getRodePointsWithZ();
        if (!rodeData) return;
        const { points: rawPoints, z: rawZ, vPerPoint: vPerPoint } = rodeData;
        if (rawPoints.length < 2) return;
        // Lazy-create or recreate if point count changed
        if (!this.rodeState || this.rodeState.rawCount !== rawPoints.length) {
            const smoothCount = (0, $ed1092a083b9ec20$export$89164c2f10f6b8fa)(rawPoints.length, $cbea09b7c78e78c3$export$a1ffd5948b27dfc8.ROPE_SUBDIVISIONS);
            this.rodeState = {
                shader: new (0, $9d345f252bc77a52$export$35a221965e8cc345)(smoothCount),
                smoothPoints: Array.from({
                    length: smoothCount
                }, ()=>[
                        0,
                        0
                    ]),
                smoothZ: new Array(smoothCount).fill(0),
                rawV: new Array(rawPoints.length).fill(0),
                smoothV: new Array(smoothCount).fill(0),
                rawCount: rawPoints.length
            };
        }
        // Copy supplied variable-spaced material-v coordinates into the scratch
        // buffer consumed by subdivideCatmullRom.
        for(let i = 0; i < rawPoints.length; i++)this.rodeState.rawV[i] = vPerPoint[i];
        const smoothCount = (0, $ed1092a083b9ec20$export$db25ba51ff51beac)(rawPoints, rawZ, $cbea09b7c78e78c3$export$a1ffd5948b27dfc8.ROPE_SUBDIVISIONS, this.rodeState.smoothPoints, this.rodeState.smoothZ, this.rodeState.rawV, this.rodeState.smoothV);
        const width = this.boat.anchor.getRodeThickness();
        const cam = (0, $65c81fa1e5a3b256$export$5c2d7918f7c1ec24)(renderer.getTransform());
        const { vertexCount: vertexCount, indexCount: indexCount } = (0, $65c81fa1e5a3b256$export$f8d929b067cb2821)(this.rodeState.smoothPoints, this.rodeState.smoothZ, width, cam, this.rodeState.shader.scratchVertexData, this.rodeState.shader.scratchIndexData, smoothCount, undefined, this.rodeState.smoothV);
        if (vertexCount === 0) return;
        this.rodeState.shader.draw(renderer, this.rodeState.shader.scratchVertexData, vertexCount, this.rodeState.shader.scratchIndexData, indexCount, this.boat.anchor.getRodePattern(), 1, width, this.game.entities.tryGetSingleton((0, $4df5c29ec7839388$export$1467403458327a44)) ?? null);
    }
    renderMast(td) {
        const rig = this.boat.rig;
        const mastPos = rig.getMastPosition();
        const mastTopZ = rig.getMastTopZ();
        const mastColor = rig.getMastColor();
        // The physical masthead extends a bit above the sail's fully-hoisted
        // position so the halyard sheave can sit at the very top. Derive that
        // height from the halyard config rather than duplicating the offset.
        const sheaveOffset = this.config.halyard.sheaveOffset;
        const sheaveDX = sheaveOffset?.x ?? 0;
        const sheaveDY = sheaveOffset?.y ?? 0;
        const sheaveElevation = this.config.halyard.sheaveElevation ?? 0;
        const sheaveRadius = this.config.halyard.sheaveRadius ?? 0.12;
        const mastShaftTopZ = mastTopZ + sheaveElevation;
        // Mast shaft (cylindrical — screen-width, with round caps)
        td.line(mastPos.x, mastPos.y, 0, mastPos.x, mastPos.y, mastShaftTopZ, 0.4, mastColor, 1, true);
        // Boom connection cap
        td.circle(mastPos.x, mastPos.y, rig.getBoomZ() + 0.01, 0.2, 16, mastColor);
        // Masthead sheave — small disc at the halyard block so the pulley
        // reads as hardware rather than a bare rope bend.
        td.circle(mastPos.x + sheaveDX, mastPos.y + sheaveDY, mastShaftTopZ + 0.01, sheaveRadius, 12, (0, $913afda613ebf2cb$export$c0816ed86df316af)(mastColor, 0.25));
    }
}
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $aa1f0309d9dba6d2$export$af631764ddc44097)("render")
], $cbea09b7c78e78c3$export$a1ffd5948b27dfc8.prototype, "onRender", null);








// Minimum time between consecutive sounds from the same source (seconds)
const $77131e34d87ca548$var$MIN_SHEET_INTERVAL = 0.15;
const $77131e34d87ca548$var$MIN_BOOM_INTERVAL = 0.3;
// Sheet snap thresholds — peak tension (engine-force units) in the winch's
// working section. Tuned for the capstan-network rope; calibrate in-game by
// trimming aggressively and logging the peak.
const $77131e34d87ca548$var$SHEET_FORCE_MIN = 200;
const $77131e34d87ca548$var$SHEET_FORCE_MAX = 1500;
// Boom slam thresholds — same tension signal; gates on mainsheet only.
const $77131e34d87ca548$var$BOOM_FORCE_MIN = 400;
const $77131e34d87ca548$var$BOOM_FORCE_MAX = 2000;
// Volume
const $77131e34d87ca548$var$SHEET_MAX_GAIN = 0.4;
const $77131e34d87ca548$var$BOOM_MAX_GAIN = 0.6;
class $77131e34d87ca548$export$b2c121e758c36aae extends (0, $c59361981bac2575$export$4342ba5c6ad1f6f1) {
    constructor(boat){
        super(), this.boat = boat, this.tickLayer = "effects", this.sheetStates = new Map(), this.lastBoomSlamTime = -Infinity;
    }
    onAdd() {
        // Track all sheets on the boat
        this.trackSheet(this.boat.mainsheet);
        if (this.boat.portJibSheet) this.trackSheet(this.boat.portJibSheet);
        if (this.boat.starboardJibSheet) this.trackSheet(this.boat.starboardJibSheet);
    }
    trackSheet(sheet) {
        this.sheetStates.set(sheet, {
            wasActive: false,
            lastSnapTime: -Infinity
        });
    }
    onTick({ audioTime: audioTime }) {
        for (const [sheet, state] of this.sheetStates)this.updateSheet(sheet, state, audioTime);
    }
    updateSheet(sheet, state, now) {
        // Read the capstan-network's peak working-side tension. The Sheet
        // suppresses this during spawn transients, so no extra warm-up here.
        const isActive = sheet.isWorkingTaut();
        const force = sheet.getWorkingTension();
        // Detect transition from slack to taut
        if (isActive && !state.wasActive && force > $77131e34d87ca548$var$SHEET_FORCE_MIN) {
            const isMainsheet = sheet === this.boat.mainsheet;
            // Check if this is a boom slam (mainsheet with high force = boom hit hard)
            if (isMainsheet && force > $77131e34d87ca548$var$BOOM_FORCE_MIN) {
                if (now - this.lastBoomSlamTime > $77131e34d87ca548$var$MIN_BOOM_INTERVAL) this.playBoomSlam(force, now);
            }
            // Play sheet snap (for any sheet, including mainsheet)
            if (now - state.lastSnapTime > $77131e34d87ca548$var$MIN_SHEET_INTERVAL) {
                this.playSheetSnap(sheet, force, now);
                state.lastSnapTime = now;
            }
        }
        state.wasActive = isActive;
    }
    playSheetSnap(sheet, force, _now) {
        const t = (0, $2172aedd5a25ff17$export$7d15b64cf5a3a4c4)((force - $77131e34d87ca548$var$SHEET_FORCE_MIN) / ($77131e34d87ca548$var$SHEET_FORCE_MAX - $77131e34d87ca548$var$SHEET_FORCE_MIN));
        const gain = t * t * $77131e34d87ca548$var$SHEET_MAX_GAIN;
        // Pitch variation: higher force = slightly lower pitch (heavier snap)
        const speed = (0, $f1ed8354ebe33615$export$1ab1062261c98efe)(0.9, 1.1) - t * 0.15;
        this.game.addEntity(new (0, $059518e50ce5c25e$export$9df2da69341d6f5a)("sheetSnap", {
            gain: gain,
            speed: speed
        }));
    }
    playBoomSlam(force, now) {
        this.lastBoomSlamTime = now;
        const t = (0, $2172aedd5a25ff17$export$7d15b64cf5a3a4c4)((force - $77131e34d87ca548$var$BOOM_FORCE_MIN) / ($77131e34d87ca548$var$BOOM_FORCE_MAX - $77131e34d87ca548$var$BOOM_FORCE_MIN));
        const gain = t * $77131e34d87ca548$var$BOOM_MAX_GAIN;
        // Higher force = slightly higher pitch (harder impact)
        const speed = (0, $f1ed8354ebe33615$export$1ab1062261c98efe)(0.85, 1.0) + t * 0.15;
        this.game.addEntity(new (0, $059518e50ce5c25e$export$9df2da69341d6f5a)("boomSlam", {
            gain: gain,
            speed: speed
        }));
    }
}
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $aa1f0309d9dba6d2$export$af631764ddc44097)("add")
], $77131e34d87ca548$export$b2c121e758c36aae.prototype, "onAdd", null);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $aa1f0309d9dba6d2$export$af631764ddc44097)("tick")
], $77131e34d87ca548$export$b2c121e758c36aae.prototype, "onTick", null);








const $86fc3e1f47795d45$var$MAX_SCRATCHES = 20;
const $86fc3e1f47795d45$var$SCRATCH_COLOR = 0x443322;
class $86fc3e1f47795d45$export$6737acbbaec69573 extends (0, $c59361981bac2575$export$4342ba5c6ad1f6f1) {
    constructor(boat, config){
        super(), this.layer = "boat", this.health = 1.0, this.scratches = [];
        this.boat = boat;
        this.config = config;
    }
    /** Get current damage level (0 = pristine, 1 = destroyed) */ getDamage() {
        return 1 - this.health;
    }
    /** Get current health (1 = pristine, 0 = destroyed) */ getHealth() {
        return this.health;
    }
    /** Set health directly, clamped to [0, 1]. Clears scratch marks. */ setHealth(value) {
        this.health = (0, $2172aedd5a25ff17$export$7d15b64cf5a3a4c4)(value, 0, 1);
        this.scratches = [];
    }
    /** Effective skin friction multiplier based on damage */ getSkinFrictionMultiplier() {
        return 1 + this.config.damageFrictionMultiplier * this.getDamage();
    }
    /** Current hull leak rate in cubic ft/s */ getLeakRate() {
        return this.config.damageLeakRate * this.getDamage();
    }
    /**
   * Apply damage from a grounding event.
   * Called by BoatGrounding each tick while hull/keel is in contact with terrain.
   */ applyGroundingDamage(penetration, speed, dt) {
        if (speed < this.config.groundingSpeedThreshold) return;
        if (this.health <= 0) return;
        const effectiveSpeed = speed - this.config.groundingSpeedThreshold;
        const damage = this.config.groundingDamageRate * penetration * effectiveSpeed * dt;
        if (damage > 0) this.takeDamage(damage, "grounding");
    }
    takeDamage(amount, source) {
        const prevHealth = this.health;
        this.health = (0, $2172aedd5a25ff17$export$7d15b64cf5a3a4c4)(this.health - amount, 0, 1);
        if (this.health < prevHealth) {
            this.addScratch(amount);
            this.game.dispatch("hullDamaged", {
                damage: amount,
                health: this.health,
                source: source
            });
        }
    }
    onTick({ dt: dt }) {
        if (this.config.repairRate > 0 && this.health < 1) this.health = (0, $2172aedd5a25ff17$export$7d15b64cf5a3a4c4)(this.health + this.config.repairRate * dt, 0, 1);
    }
    onRender({ draw: draw }) {
        if (this.scratches.length === 0) return;
        const [x, y] = this.boat.hull.body.position;
        const roll = this.boat.hull.body.roll;
        const pitch = this.boat.hull.body.pitch;
        const zOffset = this.boat.hull.body.z;
        draw.at({
            pos: (0, $6b6a54a072724620$export$e7c866399fa523f5)(x, y),
            angle: this.boat.hull.body.angle,
            tilt: {
                roll: roll,
                pitch: pitch,
                zOffset: zOffset
            }
        }, ()=>{
            for (const scratch of this.scratches){
                const alpha = scratch.severity * 0.7;
                draw.line(scratch.x1, scratch.y1, scratch.x2, scratch.y2, {
                    color: $86fc3e1f47795d45$var$SCRATCH_COLOR,
                    width: scratch.width,
                    alpha: alpha,
                    z: scratch.z
                });
            }
        });
    }
    addScratch(damage) {
        if (this.scratches.length >= $86fc3e1f47795d45$var$MAX_SCRATCHES) this.scratches.shift();
        const verts = this.boat.config.hull.vertices;
        let minX = Infinity, maxX = -Infinity;
        let minY = Infinity, maxY = -Infinity;
        for (const v of verts){
            minX = Math.min(minX, v.x);
            maxX = Math.max(maxX, v.x);
            minY = Math.min(minY, v.y);
            maxY = Math.max(maxY, v.y);
        }
        // Random position within hull bounds (shrunk slightly to stay inside)
        const cx = (0, $f1ed8354ebe33615$export$1ab1062261c98efe)(minX * 0.8, maxX * 0.8);
        const cy = (0, $f1ed8354ebe33615$export$1ab1062261c98efe)(minY * 0.6, maxY * 0.6);
        const angle = (0, $f1ed8354ebe33615$export$1ab1062261c98efe)(0, Math.PI);
        const length = (0, $f1ed8354ebe33615$export$1ab1062261c98efe)(0.5, 2.0);
        const halfLen = length / 2;
        this.scratches.push({
            x1: cx - Math.cos(angle) * halfLen,
            y1: cy - Math.sin(angle) * halfLen,
            x2: cx + Math.cos(angle) * halfLen,
            y2: cy + Math.sin(angle) * halfLen,
            z: this.boat.config.hull.deckHeight,
            width: (0, $2172aedd5a25ff17$export$7d15b64cf5a3a4c4)(damage * 20, 0.08, 0.25),
            severity: (0, $2172aedd5a25ff17$export$7d15b64cf5a3a4c4)(damage * 5, 0.3, 1.0)
        });
    }
}
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $aa1f0309d9dba6d2$export$af631764ddc44097)("tick")
], $86fc3e1f47795d45$export$6737acbbaec69573.prototype, "onTick", null);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $aa1f0309d9dba6d2$export$af631764ddc44097)("render")
], $86fc3e1f47795d45$export$6737acbbaec69573.prototype, "onRender", null);






class $6997f3124be71fbe$export$4a0455c9a96b39c9 extends (0, $c59361981bac2575$export$4342ba5c6ad1f6f1) {
    constructor(boat, config){
        super(), this.health = 1.0, /** Direction of steering bias: -1 or 1, chosen randomly on first damage */ this.biasDirection = 0;
        this.boat = boat;
        this.config = config;
    }
    getDamage() {
        return 1 - this.health;
    }
    getHealth() {
        return this.health;
    }
    /** Set health directly, clamped to [0, 1]. */ setHealth(value) {
        this.health = (0, $2172aedd5a25ff17$export$7d15b64cf5a3a4c4)(value, 0, 1);
    }
    /** Multiplier for rudder lift forces (1.0 = full authority) */ getSteeringMultiplier() {
        return 1 - this.config.maxSteeringReduction * this.getDamage();
    }
    /** Steering bias in steer units (-1 to 1 range), pulls rudder to one side */ getSteeringBias() {
        return this.biasDirection * this.config.maxSteeringBias * this.getDamage();
    }
    /**
   * Apply damage from a grounding event.
   * Called by BoatGrounding each tick while rudder is in contact with terrain.
   */ applyGroundingDamage(penetration, speed, dt) {
        if (speed < this.config.groundingSpeedThreshold) return;
        if (this.health <= 0) return;
        const effectiveSpeed = speed - this.config.groundingSpeedThreshold;
        const damage = this.config.groundingDamageRate * penetration * effectiveSpeed * dt;
        if (damage > 0) this.takeDamage(damage, "grounding");
    }
    takeDamage(amount, source) {
        const prevHealth = this.health;
        this.health = (0, $2172aedd5a25ff17$export$7d15b64cf5a3a4c4)(this.health - amount, 0, 1);
        if (this.health < prevHealth) {
            // Lock in bias direction on first damage
            if (this.biasDirection === 0) this.biasDirection = Math.random() < 0.5 ? -1 : 1;
            this.game.dispatch("rudderDamaged", {
                damage: amount,
                health: this.health,
                source: source
            });
        }
    }
    onTick({ dt: dt }) {
        if (this.config.repairRate > 0 && this.health < 1) this.health = (0, $2172aedd5a25ff17$export$7d15b64cf5a3a4c4)(this.health + this.config.repairRate * dt, 0, 1);
    }
}
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $aa1f0309d9dba6d2$export$af631764ddc44097)("tick")
], $6997f3124be71fbe$export$4a0455c9a96b39c9.prototype, "onTick", null);






class $7f3fd39e55083312$export$fd5fe28aa072e04d extends (0, $c59361981bac2575$export$4342ba5c6ad1f6f1) {
    constructor(boat, config, sail, sailName, sheet){
        super(), this.health = 1.0, /** Track sheet constraint state for jibe detection (same pattern as BoatSoundGenerator) */ this.wasSheetActive = false;
        this.boat = boat;
        this.config = config;
        this.sail = sail;
        this.sailName = sailName;
        this.sheet = sheet;
    }
    getDamage() {
        return 1 - this.health;
    }
    getHealth() {
        return this.health;
    }
    /** Set health directly, clamped to [0, 1]. */ setHealth(value) {
        this.health = (0, $2172aedd5a25ff17$export$7d15b64cf5a3a4c4)(value, 0, 1);
    }
    /** Lift multiplier for the sail (1.0 = full lift) */ getLiftMultiplier() {
        return 1 - this.config.maxLiftReduction * this.getDamage();
    }
    onTick({ dt: dt }) {
        // Natural repair
        if (this.config.repairRate > 0 && this.health < 1) this.health = (0, $2172aedd5a25ff17$export$7d15b64cf5a3a4c4)(this.health + this.config.repairRate * dt, 0, 1);
        if (this.health <= 0) return;
        // --- Overpowering damage ---
        const reactionForce = this.sail.getTotalReactionForce();
        const excessForce = reactionForce - this.config.overpowerForceThreshold;
        if (excessForce > 0) {
            const damage = this.config.overpowerDamageRate * excessForce * dt;
            this.takeDamage(damage, "overpower");
        }
        // --- Jibe damage (detect sheet going taut with high force) ---
        if (this.sheet) this.checkJibeDamage();
    }
    checkJibeDamage() {
        const constraint = this.sheet.constraints?.[0];
        if (!constraint) return;
        const equation = constraint.equations[0];
        if (!equation) return;
        const isActive = equation.enabled;
        const force = Math.abs(equation.multiplier);
        // Detect transition from slack to taut with significant force
        if (isActive && !this.wasSheetActive && force > 0) {
            const damage = this.config.jibeDamagePerForce * force;
            if (damage > 0.001) this.takeDamage(damage, "jibe");
        }
        this.wasSheetActive = isActive;
    }
    takeDamage(amount, source) {
        const prevHealth = this.health;
        this.health = (0, $2172aedd5a25ff17$export$7d15b64cf5a3a4c4)(this.health - amount, 0, 1);
        if (this.health < prevHealth) this.game.dispatch("sailDamaged", {
            damage: amount,
            health: this.health,
            sail: this.sailName,
            source: source
        });
    }
}
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $aa1f0309d9dba6d2$export$af631764ddc44097)("tick")
], $7f3fd39e55083312$export$fd5fe28aa072e04d.prototype, "onTick", null);



class $c31dec775204da9f$export$8068c6f3648e316e extends (0, $c59361981bac2575$export$4342ba5c6ad1f6f1) {
    constructor(boat, config){
        super();
        this.localPosition = config.attachPoint;
        this.size = config.size;
        this.boat = boat;
        this.color = config.color;
    }
    /** Visual color for the bowsprit. */ getColor() {
        return this.color;
    }
}










// Fluid densities in slugs/ft³ (produces lbf when used with ft and ft/s)
// Using slugs ensures F = ρ * v² * A gives force in lbf directly
// Extracted to a separate file so worker threads can import without engine deps.
const $76df497339ed0c67$export$e922b9569f201f18 = 1.94; // Seawater at 60°F
const $76df497339ed0c67$export$b2c4fea6cb9591e = 0.00238; // Air at sea level, 60°F
const $76df497339ed0c67$export$d6989026b8609618 = 32.174;


const $cc2f69d6c6f8f07b$export$a424b0cb70c6e358 = 1.5; // ft - typical keelboat rudder depth
const $cc2f69d6c6f8f07b$export$26cfd129304a7615 = 1.25; // ft - centerboard/daggerboard chord
// =============================================================================
// Simulation Constants
// =============================================================================
const $cc2f69d6c6f8f07b$var$MAX_RELATIVE_SPEED = 25; // ft/s - cap for numerical stability (~15 kts)
// Pre-allocated result array to avoid allocation on hot path
const $cc2f69d6c6f8f07b$var$_forceResults = [
    {
        fx: 0,
        fy: 0,
        localX: 0,
        localY: 0
    },
    {
        fx: 0,
        fy: 0,
        localX: 0,
        localY: 0
    }
];
function $cc2f69d6c6f8f07b$export$85bbd5a77391c6ab(body, v1, v2, getLiftMagnitude, getDragMagnitude, getFluidVelocity = ()=>(0, $6b6a54a072724620$export$e7c866399fa523f5)(0, 0), results = $cc2f69d6c6f8f07b$var$_forceResults) {
    const v1World = body.toWorldFrame(v1);
    const v2World = body.toWorldFrame(v2);
    const edge = v2World.sub(v1World);
    const edgeLength = edge.magnitude;
    if (edgeLength < 0.001) return 0;
    edge.inormalize();
    const edgeNormal = edge.rotate90cw();
    const halfLength = edgeLength / 2;
    let count = 0;
    if ($cc2f69d6c6f8f07b$var$computeFluidForceAtPoint(body, v1, v1World, edge, edgeNormal, halfLength, getLiftMagnitude, getDragMagnitude, getFluidVelocity, results[0])) count++;
    if ($cc2f69d6c6f8f07b$var$computeFluidForceAtPoint(body, v2, v2World, edge, edgeNormal, halfLength, getLiftMagnitude, getDragMagnitude, getFluidVelocity, results[count])) count++;
    return count;
}
function $cc2f69d6c6f8f07b$export$f160c78967a796c6(body, v1, v2, getLiftMagnitude, getDragMagnitude, getFluidVelocity = ()=>(0, $6b6a54a072724620$export$e7c866399fa523f5)(0, 0)) {
    const count = $cc2f69d6c6f8f07b$export$85bbd5a77391c6ab(body, v1, v2, getLiftMagnitude, getDragMagnitude, getFluidVelocity);
    for(let i = 0; i < count; i++){
        const r = $cc2f69d6c6f8f07b$var$_forceResults[i];
        const relPoint = body.vectorToWorldFrame((0, $6b6a54a072724620$export$e7c866399fa523f5)(r.localX, r.localY));
        body.applyForce((0, $6b6a54a072724620$export$e7c866399fa523f5)(r.fx, r.fy), relPoint);
    }
}
function $cc2f69d6c6f8f07b$var$computeFluidForceAtPoint(body, localPoint, worldPoint, edge, edgeNormal, edgeLength, getLiftMagnitude, getDragMagnitude, getFluidVelocity, out) {
    // Calculate relative velocity (body velocity minus fluid velocity = apparent flow)
    const r = worldPoint.sub((0, $6b6a54a072724620$export$e7c866399fa523f5)(body.position));
    const pointVelocity = (0, $6b6a54a072724620$export$e7c866399fa523f5)(body.velocity).add(r.rotate90ccw().mul(body.angularVelocity));
    const fluidVelocity = getFluidVelocity(worldPoint);
    const relativeVelocity = pointVelocity.sub(fluidVelocity);
    const rawSpeed = relativeVelocity.magnitude;
    if (rawSpeed < 0.0001) return false;
    const speed = Math.min(rawSpeed, $cc2f69d6c6f8f07b$var$MAX_RELATIVE_SPEED);
    const velDir = relativeVelocity.normalize();
    const velDotNormal = velDir.dot(edgeNormal);
    const velDotEdge = velDir.dot(edge);
    // Skip if flow is from behind the surface
    if (velDotNormal < 0) return false;
    // Calculate angle of attack (angle between flow and edge/chord)
    const angleOfAttack = Math.atan2(velDotNormal, velDotEdge);
    // Get magnitudes from caller-provided functions
    const params = {
        angleOfAttack: angleOfAttack,
        speed: speed,
        edgeLength: edgeLength
    };
    const dragMag = getDragMagnitude(params);
    const liftMag = getLiftMagnitude(params);
    // Compute forces: drag opposes motion, lift is perpendicular to flow
    const drag = velDir.mul(-dragMag);
    const lift = velDir.rotate90cw().mul(-liftMag);
    const totalForce = drag.add(lift);
    out.fx = totalForce.x;
    out.fy = totalForce.y;
    out.localX = localPoint.x;
    out.localY = localPoint.y;
    return true;
}
function $cc2f69d6c6f8f07b$export$b0fe55128dcf642e(chord, rho = (0, $76df497339ed0c67$export$e922b9569f201f18)) {
    return ({ angleOfAttack: angleOfAttack, speed: speed, edgeLength: edgeLength })=>{
        // Flat plate drag coefficient: Cd = 1.28 · sin(α)
        // The 1.28 factor comes from Kirchhoff free-streamline theory, accounting
        // for the wake pressure deficit behind a flat plate in a real fluid.
        const cd = 1.28 * Math.abs(Math.sin(angleOfAttack));
        const area = edgeLength * chord;
        const dynamicPressure = 0.5 * rho * speed * speed;
        return cd * dynamicPressure * area;
    };
}
// ============================================================================
// Symmetric Foil Model (for keel, rudder - NACA-style symmetric hydrofoils)
// ============================================================================
const $cc2f69d6c6f8f07b$var$FOIL_STALL_ANGLE = (0, $2172aedd5a25ff17$export$e6bfdeff8bfc94f9)(15); // ~15 degrees - typical for symmetric foils
function $cc2f69d6c6f8f07b$export$17e29cb2a12a29cc(chord, rho = (0, $76df497339ed0c67$export$e922b9569f201f18)) {
    return ({ angleOfAttack: angleOfAttack, speed: speed, edgeLength: edgeLength })=>{
        // Use the effective angle (0 to 90°) for coefficient calculation
        // but preserve the sign from cos(angleOfAttack) for correct force direction
        const alpha = Math.abs(angleOfAttack);
        const effectiveAlpha = alpha > Math.PI / 2 ? Math.PI - alpha : alpha;
        // Lift coefficient based on thin airfoil theory
        let cl;
        if (effectiveAlpha < $cc2f69d6c6f8f07b$var$FOIL_STALL_ANGLE) // Linear region: Cl = 2π·sin(α)
        cl = 2 * Math.PI * Math.sin(effectiveAlpha);
        else {
            // Post-stall: simplified decay model. Exponent of 1.5 gives gradual
            // falloff — real foils and sails maintain partial lift well past stall.
            const peak = 2 * Math.PI * Math.sin($cc2f69d6c6f8f07b$var$FOIL_STALL_ANGLE);
            const decay = Math.exp(-1.5 * (effectiveAlpha - $cc2f69d6c6f8f07b$var$FOIL_STALL_ANGLE));
            cl = peak * decay;
        }
        // Sign from cos(angleOfAttack) ensures correct force direction
        cl *= Math.sign(Math.cos(angleOfAttack));
        // Proper fluid dynamics formula: F = 0.5 * ρ * v² * Cl * A
        const area = edgeLength * chord;
        const dynamicPressure = 0.5 * rho * speed * speed;
        return cl * dynamicPressure * area;
    };
}
function $cc2f69d6c6f8f07b$export$42313db6ebd1acc(chord, aspectRatio, rho = (0, $76df497339ed0c67$export$e922b9569f201f18)) {
    // Oswald efficiency factor — accounts for non-elliptical lift distribution.
    // e ≈ 0.9 is typical for well-designed symmetric foils.
    const e = 0.9;
    // Compute the lift coefficient at the stall angle for the transition point.
    // Cl = 2π·sin(α) from thin airfoil theory.
    const clAtStall = 2 * Math.PI * Math.sin($cc2f69d6c6f8f07b$var$FOIL_STALL_ANGLE);
    // Induced drag at stall: Cd_i = Cl² / (π · AR · e)
    // This is the maximum induced drag before we switch to the flat-plate model.
    const cdInducedAtStall = clAtStall * clAtStall / (Math.PI * aspectRatio * e);
    return ({ angleOfAttack: angleOfAttack, speed: speed, edgeLength: edgeLength })=>{
        // Use effective angle (0 to 90°) for coefficient calculation
        const alpha = Math.abs(angleOfAttack);
        const effectiveAlpha = alpha > Math.PI / 2 ? Math.PI - alpha : alpha;
        let cd;
        // Minimum profile drag for symmetric NACA foil section (Cd0 ≈ 0.006-0.008)
        const cdBase = 0.007;
        if (effectiveAlpha < $cc2f69d6c6f8f07b$var$FOIL_STALL_ANGLE) {
            // Pre-stall regime: base profile drag + induced drag from lifting-line theory.
            //
            // Induced drag formula (Prandtl lifting-line theory):
            //   Cd_induced = Cl² / (π · AR · e)
            // where:
            //   Cl  = lift coefficient = 2π·sin(α) (thin airfoil theory)
            //   AR  = aspect ratio = span / chord
            //   e   = Oswald efficiency factor (≈ 0.9)
            //   π   = pi
            //
            // This is the minimum induced drag for a finite wing; the 1/AR dependence
            // means high-aspect-ratio foils (long, narrow) have less induced drag.
            const cl = 2 * Math.PI * Math.sin(effectiveAlpha);
            const cdInduced = cl * cl / (Math.PI * aspectRatio * e);
            cd = cdBase + cdInduced;
        } else {
            // Post-stall regime: transition from foil drag to flat-plate behavior.
            //
            // Flat-plate normal drag (Kirchhoff theory):
            //   Cd_flatplate = 1.28 · sin²(α)
            // This naturally saturates at Cd = 1.28 at α = 90° (broadside to flow),
            // is near zero at small α, and rises smoothly through stall.
            //
            // We take the maximum of:
            //   - The foil drag at stall (continuity with pre-stall)
            //   - The flat-plate drag model
            // This ensures a smooth, physically bounded transition.
            const CD_FLAT_PLATE = 1.28;
            const sinAlpha = Math.sin(effectiveAlpha);
            const cdFlatPlate = CD_FLAT_PLATE * sinAlpha * sinAlpha;
            cd = Math.max(cdBase + cdInducedAtStall, cdFlatPlate);
        }
        // Proper fluid dynamics formula: F = 0.5 * ρ * v² * Cd * A
        const area = edgeLength * chord;
        const dynamicPressure = 0.5 * rho * speed * speed;
        return cd * dynamicPressure * area;
    };
}
function $cc2f69d6c6f8f07b$export$d43fb434dfbb6108(body, vertices, roll, bodyAngle, getLiftMagnitude, getDragMagnitude, getWaterVelocity, results, fluidForceResults) {
    // Cache trig values for 3D force decomposition
    const cosRoll = Math.cos(roll);
    const sinRoll = Math.sin(roll);
    const cosA = Math.cos(bodyAngle);
    const sinA = Math.sin(bodyAngle);
    let totalCount = 0;
    // Iterate all edge pairs, both forward and reversed
    for(let vi = 0; vi < vertices.length - 1; vi++){
        const start = vertices[vi];
        const end = vertices[vi + 1];
        for(let dir = 0; dir < 2; dir++){
            const a = dir === 0 ? start : end;
            const b = dir === 0 ? end : start;
            const count = $cc2f69d6c6f8f07b$export$85bbd5a77391c6ab(body, a, b, getLiftMagnitude, getDragMagnitude, getWaterVelocity, fluidForceResults);
            for(let i = 0; i < count; i++){
                const r = fluidForceResults[i];
                // 3D force decomposition: rotate lateral force component by heel angle.
                // The foil tilts with the boat's heel, so its lift vector tilts too.
                // Decompose world-frame force into longitudinal (along heading) and
                // lateral (perpendicular to heading) components relative to bodyAngle.
                const longitudinal = r.fx * cosA + r.fy * sinA;
                const lateral = -r.fx * sinA + r.fy * cosA;
                // The longitudinal component (drag) stays horizontal regardless of heel.
                // The lateral component (lift) tilts with the foil:
                //   horizontal part = lateral * cos(roll)
                //   vertical part   = lateral * sin(roll) — this provides righting force
                const lateralH = lateral * cosRoll;
                const out = results[totalCount];
                out.fx = longitudinal * cosA - lateralH * sinA;
                out.fy = longitudinal * sinA + lateralH * cosA;
                out.fz = lateral * sinRoll;
                out.localX = r.localX;
                out.localY = r.localY;
                totalCount++;
            }
        }
    }
    return totalCount;
}
function $cc2f69d6c6f8f07b$export$82b2d0eed3d1f81c(body, wettedArea, frictionCoefficient, getFluidVelocity = ()=>(0, $6b6a54a072724620$export$e7c866399fa523f5)(0, 0), rho = (0, $76df497339ed0c67$export$e922b9569f201f18)) {
    const fluidVelocity = getFluidVelocity((0, $6b6a54a072724620$export$e7c866399fa523f5)(body.position));
    const relativeVelocity = (0, $6b6a54a072724620$export$e7c866399fa523f5)(body.velocity).sub(fluidVelocity);
    const speed = relativeVelocity.magnitude;
    if (speed < 0.0001) return;
    const cappedSpeed = Math.min(speed, $cc2f69d6c6f8f07b$var$MAX_RELATIVE_SPEED);
    // Proper skin friction formula: F = 0.5 * ρ * v² * Cf * A
    // Result is in lbf; convert to engine force units
    const dynamicPressure = 0.5 * rho * cappedSpeed * cappedSpeed;
    const forceMagnitude = frictionCoefficient * dynamicPressure * wettedArea * (0, $76df497339ed0c67$export$d6989026b8609618);
    const force = relativeVelocity.normalize().mul(-forceMagnitude);
    // Apply at center of mass (no torque)
    body.applyForce(force, (0, $6b6a54a072724620$export$e7c866399fa523f5)());
}
function $cc2f69d6c6f8f07b$export$151fa087a7ff594d(body, worldPoint, area, frictionCoefficient, fluidVelocity, pointZVelocity = 0, rho = (0, $76df497339ed0c67$export$e922b9569f201f18)) {
    // Calculate relative velocity at this point
    const r = worldPoint.sub((0, $6b6a54a072724620$export$e7c866399fa523f5)(body.position));
    const pointVelocity = (0, $6b6a54a072724620$export$e7c866399fa523f5)(body.velocity).add(r.rotate90ccw().mul(body.angularVelocity));
    // 2D relative velocity (hull vs water)
    const relVx = pointVelocity.x - fluidVelocity.x;
    const relVy = pointVelocity.y - fluidVelocity.y;
    // Vertical relative velocity (from roll/pitch rotation)
    const relVz = pointZVelocity;
    const speed3D = Math.sqrt(relVx * relVx + relVy * relVy + relVz * relVz);
    if (speed3D < 0.0001) return null;
    const cappedSpeed = Math.min(speed3D, $cc2f69d6c6f8f07b$var$MAX_RELATIVE_SPEED);
    // F = 0.5 * ρ * v² * Cf * A, converted to engine units
    const dynamicPressure = 0.5 * rho * cappedSpeed * cappedSpeed;
    const forceMagnitude = frictionCoefficient * dynamicPressure * area * (0, $76df497339ed0c67$export$d6989026b8609618);
    // Force opposes relative velocity (normalized)
    const invSpeed = -forceMagnitude / speed3D;
    return {
        fx: relVx * invSpeed,
        fy: relVy * invSpeed,
        fz: relVz * invSpeed
    };
}






const $83fe61aef90c7444$export$f074865b5380d6bd = {
    stride: 4,
    fields: {
        velocityX: 0,
        velocityY: 1,
        speed: 2,
        direction: 3
    }
};
class $83fe61aef90c7444$export$6099b036f89a7647 {
    /**
   * True wind velocity in world frame — the direction the wind is blowing TOWARD,
   * not the direction it is coming from. For example, a northerly wind (blowing
   * from north to south) has velocity pointing south (negative Y in screen coords).
   *
   * To compute apparent/relative wind at a point on the boat:
   *   apparent_wind = wind_velocity - boat_point_velocity
   */ get velocity() {
        this._velocity.set(this._data[this._offset + $83fe61aef90c7444$export$f074865b5380d6bd.fields.velocityX], this._data[this._offset + $83fe61aef90c7444$export$f074865b5380d6bd.fields.velocityY]);
        return this._velocity;
    }
    get speed() {
        return this._data[this._offset + $83fe61aef90c7444$export$f074865b5380d6bd.fields.speed];
    }
    get direction() {
        return this._data[this._offset + $83fe61aef90c7444$export$f074865b5380d6bd.fields.direction];
    }
    constructor(){
        this._velocity = (0, $6b6a54a072724620$export$e7c866399fa523f5)(0, 0);
    }
}


class $3d4e827a36d4d6ff$export$20101e03857a552b extends (0, $1f13ac9ee87de92a$export$e56fd5b11ed42a5c) {
    constructor(getPoints){
        super(getPoints), this.tags = [
            "windQuery"
        ], this.stride = (0, $83fe61aef90c7444$export$f074865b5380d6bd).stride, this.views = [];
    }
    get(index) {
        let view = this.views[index];
        if (!view) {
            view = new (0, $83fe61aef90c7444$export$6099b036f89a7647)();
            this.views[index] = view;
        }
        view._data = this._data;
        view._offset = index * this.stride;
        return view;
    }
}



const $d106d09a724e422d$var$GRAVITY = 32.174; // ft/s²
// Hydrostatic pressure: F = ρ * g * depth * area (lbf), converted to engine units (* g)
const $d106d09a724e422d$var$BUOYANCY_FORCE_PER_DEPTH_PER_AREA = (0, $76df497339ed0c67$export$e922b9569f201f18) * $d106d09a724e422d$var$GRAVITY * $d106d09a724e422d$var$GRAVITY;
// Waterline transition band half-width (ft)
const $d106d09a724e422d$var$WATERLINE_BAND = 0.1;
// Maximum foam particles spawned per hull per tick. Round-robin picks which
// triangles flush their accumulators; others wait their turn. Total live
// foam particles ≈ FOAM_EMISSIONS_PER_TICK × tick rate × foam lifetime.
const $d106d09a724e422d$var$FOAM_EMISSIONS_PER_TICK = 4;
// Triangles whose accumulator hasn't reached this volume are skipped by the
// round-robin cursor (prevents wasted emissions from barely-active triangles).
const $d106d09a724e422d$var$MIN_FOAM_ACCUM_VOLUME = 0.001; // ft³
// Cap on how much flux volume a single triangle can have pending emission.
// Without this, startup transients (hull settling into water, queries
// warming up) dump a pile into every accumulator, and when the round-robin
// cursor gets there it paints an over-bright "silhouette" of the hull at
// the boat's current position. The cap scales `_foamAccumTime` down
// proportionally so the resulting avgFlux is preserved — we lose the tail
// of old history, not the current rate.
const $d106d09a724e422d$var$MAX_FOAM_ACCUM_VOLUME = 2.0; // ft³
function $d106d09a724e422d$export$1da007e63d4d3b8e(vertices) {
    let best = vertices[0];
    for (const v of vertices)if (v.x > best.x) best = v;
    return best;
}
function $d106d09a724e422d$export$4746840bf6466a0f(vertices) {
    const sorted = [
        ...vertices
    ].sort((a, b)=>a.x - b.x);
    const v1 = sorted[0];
    const v2 = sorted[1];
    if (v1.y > v2.y) return {
        port: v1,
        starboard: v2
    };
    else return {
        port: v2,
        starboard: v1
    };
}
/**
 * Precompute per-triangle force data (centroid, outward normal, area)
 * from the hull mesh geometry.
 */ function $d106d09a724e422d$var$buildHullForceData(mesh) {
    const allIndices = [
        ...mesh.deckIndices,
        ...mesh.upperSideIndices,
        ...mesh.lowerSideIndices,
        ...mesh.bottomIndices
    ];
    const triCount = allIndices.length / 3;
    const data = {
        count: triCount,
        cx: new Float64Array(triCount),
        cy: new Float64Array(triCount),
        cz: new Float64Array(triCount),
        nx: new Float64Array(triCount),
        ny: new Float64Array(triCount),
        nz: new Float64Array(triCount),
        area: new Float64Array(triCount),
        vertexIndices: new Uint16Array(allIndices),
        vertexCount: mesh.xyPositions.length
    };
    const pos = mesh.xyPositions;
    const zVals = mesh.zValues;
    for(let t = 0; t < triCount; t++){
        const i0 = allIndices[t * 3];
        const i1 = allIndices[t * 3 + 1];
        const i2 = allIndices[t * 3 + 2];
        // Vertex positions
        const x0 = pos[i0][0], y0 = pos[i0][1], z0 = zVals[i0];
        const x1 = pos[i1][0], y1 = pos[i1][1], z1 = zVals[i1];
        const x2 = pos[i2][0], y2 = pos[i2][1], z2 = zVals[i2];
        // Centroid
        data.cx[t] = (x0 + x1 + x2) / 3;
        data.cy[t] = (y0 + y1 + y2) / 3;
        data.cz[t] = (z0 + z1 + z2) / 3;
        // Edge vectors
        const e1x = x1 - x0, e1y = y1 - y0, e1z = z1 - z0;
        const e2x = x2 - x0, e2y = y2 - y0, e2z = z2 - z0;
        // Cross product (outward normal, unnormalized)
        let nx = e1y * e2z - e1z * e2y;
        let ny = e1z * e2x - e1x * e2z;
        let nz = e1x * e2y - e1y * e2x;
        const len = Math.sqrt(nx * nx + ny * ny + nz * nz);
        data.area[t] = len * 0.5;
        if (len > 1e-8) {
            nx /= len;
            ny /= len;
            nz /= len;
        }
        // Ensure outward-facing: normal should point away from hull interior.
        // For side triangles, the centroid's XY direction from the centerline
        // should align with the normal's XY direction.
        // For caps, check Z direction.
        const centroidDot = data.cx[t] * nx + data.cy[t] * ny + data.cz[t] * nz;
        if (centroidDot < 0) {
            nx = -nx;
            ny = -ny;
            nz = -nz;
        }
        data.nx[t] = nx;
        data.ny[t] = ny;
        data.nz[t] = nz;
    }
    return data;
}
/**
 * Compute the enclosed volume of the hull mesh using the divergence theorem.
 * For a closed surface: V = (1/3) * Σ (centroid · outward_normal) * area
 */ function $d106d09a724e422d$var$computeHullVolume(data) {
    let volume = 0;
    for(let i = 0; i < data.count; i++)volume += (data.cx[i] * data.nx[i] + data.cy[i] * data.ny[i] + data.cz[i] * data.nz[i]) * data.area[i];
    return Math.abs(volume) / 3;
}
class $d106d09a724e422d$export$c4813cc5e4374a49 extends (0, $c59361981bac2575$export$4342ba5c6ad1f6f1) {
    constructor(config, sixDOF, boatMass = 0, centerOfGravityZ = 0){
        super(), this.layer = "boat", this.getDamageMultiplier = ()=>1, // Wave sources collected from waterline-straddling triangles each tick.
        // Reused across ticks — length is reset, objects are mutated in place.
        this._waveSources = [], this._waveSourceCount = 0, // Foam sources emitted via round-robin from the per-triangle accumulator.
        // Capped at FOAM_EMISSIONS_PER_TICK per tick regardless of how many
        // triangles are separating — gives a fixed foam particle budget.
        this._foamSources = [], this._foamSourceCount = 0, // Round-robin cursor over all physics triangles.
        this._foamCursor = 0;
        this.skinFrictionCoefficient = config.skinFrictionCoefficient;
        this.stagnationCoefficient = config.stagnationCoefficient ?? 1.0;
        this.separationCoefficient = config.separationCoefficient ?? 0.5;
        this.vertices = config.vertices;
        this.fillColor = config.colors.fill;
        this.strokeColor = config.colors.stroke;
        this.sideColor = config.colors.side ?? $d106d09a724e422d$var$darkenColor(config.colors.fill, 0.85);
        this.bottomColor = config.colors.bottom ?? $d106d09a724e422d$var$darkenColor(config.colors.fill, 0.6);
        this.boatMass = boatMass;
        this.centerOfGravityZ = centerOfGravityZ;
        // Pre-sort deck zones by floorZ descending for getDeckHeight lookups
        this.deckZonesByHeight = config.deckPlan ? [
            ...config.deckPlan.zones
        ].sort((a, b)=>b.floorZ - a.floorZ) : [];
        this.body = sixDOF ? (0, $4aa863c0a97fa3b4$export$d8062929709d2dca)({
            motion: "dynamic",
            mass: config.mass,
            rollInertia: sixDOF.rollInertia,
            pitchInertia: sixDOF.pitchInertia,
            zMass: sixDOF.zMass,
            z: sixDOF.zPosition,
            zDamping: sixDOF.zDamping,
            rollPitchDamping: sixDOF.rollPitchDamping
        }) : (0, $4aa863c0a97fa3b4$export$c9dd59e0dcee4be9)({
            motion: "dynamic",
            mass: config.mass
        });
        this.body.addShape(new (0, $6ae562c24c0aa510$export$bc1767a8c6770562)({
            vertices: [
                ...config.vertices
            ]
        }));
        // Physics mesh uses lower subdivision for cache-friendly force computation.
        this.mesh = (0, $779a9fe58269ee84$export$c170a8e7ce4ad263)({
            ...config.shape,
            profileSubdivisions: 2,
            stationSubdivisions: 2
        });
        // Render mesh uses full subdivision for visual smoothness.
        this.renderMesh = (0, $779a9fe58269ee84$export$c170a8e7ce4ad263)(config.shape);
        // Precompute per-triangle force data
        this.forceData = $d106d09a724e422d$var$buildHullForceData(this.mesh);
        // Persistent per-triangle foam accumulators (volume + time since emit).
        this._foamAccumVolume = new Float64Array(this.forceData.count);
        this._foamAccumTime = new Float64Array(this.forceData.count);
        // Compute enclosed hull volume via divergence theorem: V = (1/3) Σ (c · n) * A
        this.hullVolume = $d106d09a724e422d$var$computeHullVolume(this.forceData);
        // Pre-allocate vertex query points (one per unique mesh vertex)
        const vertCount = this.forceData.vertexCount;
        this.vertexQueryPoints = Array.from({
            length: vertCount
        }, ()=>(0, $6b6a54a072724620$export$e7c866399fa523f5)(0, 0));
        // Water and wind queries at mesh vertices (shared across triangles)
        this.waterQuery = this.addChild(new (0, $2f31bbbd4b5b01e3$export$38b1d297f12cec06)(()=>this.getVertexWorldPoints()));
        this.windQuery = this.addChild(new (0, $3d4e827a36d4d6ff$export$20101e03857a552b)(()=>this.getVertexWorldPoints()));
    }
    /** Get the water query for reading per-vertex water data. */ getWaterQuery() {
        return this.waterQuery;
    }
    /** Get the physics mesh (vertex positions correspond to water query indices). */ getPhysicsMesh() {
        return this.mesh;
    }
    /**
   * Number of active wave sources from this tick.
   * Iterate [0, count) and read via `getWaveSource(i)`.
   */ get waveSourceCount() {
        return this._waveSourceCount;
    }
    /** Read wave source at index; only valid for i < waveSourceCount. */ getWaveSource(i) {
        return this._waveSources[i];
    }
    /** Number of foam sources emitted this tick (0..FOAM_EMISSIONS_PER_TICK). */ get foamSourceCount() {
        return this._foamSourceCount;
    }
    /** Read foam source at index; only valid for i < foamSourceCount. */ getFoamSource(i) {
        return this._foamSources[i];
    }
    /**
   * Transform body-local mesh vertices to world XY for queries.
   */ getVertexWorldPoints() {
        const pos = this.mesh.xyPositions;
        for(let i = 0; i < pos.length; i++){
            const world = this.body.toWorldFrame((0, $6b6a54a072724620$export$e7c866399fa523f5)(pos[i][0], pos[i][1]));
            this.vertexQueryPoints[i].set(world.x, world.y);
        }
        return this.vertexQueryPoints;
    }
    onTick({ dt: dt }) {
        const body = this.body;
        const R = body.orientation;
        const fd = this.forceData;
        const cf = this.skinFrictionCoefficient * this.getDamageMultiplier();
        // Apply gravity at center of gravity
        if (this.boatMass > 0) body.applyForce3D(0, 0, -this.boatMass * $d106d09a724e422d$var$GRAVITY, 0, 0, this.centerOfGravityZ);
        // Per-triangle force loop.
        // Water/wind are queried at mesh vertices; per-triangle values are
        // averaged from the three vertex results for better partial-submersion handling.
        const meshPos = this.mesh.xyPositions;
        const meshZ = this.mesh.zValues;
        const vi = fd.vertexIndices;
        const wq = this.waterQuery;
        const wiq = this.windQuery;
        // Reset per-tick wave and foam source lists (reuse the backing arrays).
        this._waveSourceCount = 0;
        this._foamSourceCount = 0;
        // Cache current boat speed — used as the group-velocity scale for all
        // wave sources this tick. Deep-water dispersion: c_g = 0.5 * v for the
        // hull-wavelength group.
        const boatSpeed = Math.sqrt(body.velocity[0] * body.velocity[0] + body.velocity[1] * body.velocity[1]);
        const sourceGroupSpeed = 0.5 * boatSpeed;
        // Pressure coefficients for form drag
        const cpStag = this.stagnationCoefficient;
        const cpSep = this.separationCoefficient;
        // Depth baseline for buoyancy: the minimum submersion across all mesh
        // vertices. When the hull is fully submerged every vertex has sub > 0, and
        // subtracting this baseline from each triangle's depth keeps individual
        // buoyancy force magnitudes bounded by hull height instead of sink depth.
        // For a closed mesh the constant offset integrates to zero, so the net
        // buoyancy force and torque are unchanged — only the numerical cancellation
        // between near-equal top/bottom forces is improved. When any part of the
        // hull is above water (minSub <= 0) the baseline is clamped to 0 and the
        // computation reduces exactly to the previous behavior.
        let minSub = Infinity;
        for(let v = 0; v < meshPos.length; v++){
            const wz = body.worldZ(meshPos[v][0], meshPos[v][1], meshZ[v]);
            const wh = v < wq.length ? wq.get(v).surfaceHeight : 0;
            const sub = wh - wz;
            if (sub < minSub) minSub = sub;
        }
        const depthBaseline = Math.max(0, minSub);
        for(let i = 0; i < fd.count; i++){
            const area = fd.area[i];
            if (area < 0.001) continue;
            // Triangle centroid (body-local, for force application point)
            const localX = fd.cx[i];
            const localY = fd.cy[i];
            const localZ = fd.cz[i];
            // Transform normal to world frame via rotation matrix
            const lnx = fd.nx[i], lny = fd.ny[i], lnz = fd.nz[i];
            const wnx = R[0] * lnx + R[1] * lny + R[2] * lnz;
            const wny = R[3] * lnx + R[4] * lny + R[5] * lnz;
            const wnz = R[6] * lnx + R[7] * lny + R[8] * lnz;
            // Look up per-vertex water data and average submersion across the triangle.
            // This handles partial submersion much better than centroid-only sampling:
            // a triangle with one vertex underwater gets ~1/3 submersion contribution.
            const v0 = vi[i * 3], v1 = vi[i * 3 + 1], v2 = vi[i * 3 + 2];
            // Per-vertex world Z (from body orientation + z offset)
            const wz0 = body.worldZ(meshPos[v0][0], meshPos[v0][1], meshZ[v0]);
            const wz1 = body.worldZ(meshPos[v1][0], meshPos[v1][1], meshZ[v1]);
            const wz2 = body.worldZ(meshPos[v2][0], meshPos[v2][1], meshZ[v2]);
            // Per-vertex water surface height
            const wh0 = v0 < wq.length ? wq.get(v0).surfaceHeight : 0;
            const wh1 = v1 < wq.length ? wq.get(v1).surfaceHeight : 0;
            const wh2 = v2 < wq.length ? wq.get(v2).surfaceHeight : 0;
            // Per-vertex submersion (positive = underwater, negative = above)
            const sub0 = wh0 - wz0;
            const sub1 = wh1 - wz1;
            const sub2 = wh2 - wz2;
            // Average submersion across the triangle (can be negative = above water)
            const avgSubmersion = (sub0 + sub1 + sub2) / 3;
            // Average of clamped submersion depths (for buoyancy magnitude)
            const avgDepth = (Math.max(0, sub0) + Math.max(0, sub1) + Math.max(0, sub2)) / 3;
            // Smooth water fraction based on average submersion with transition band.
            // This avoids discrete force jumps as individual vertices cross the waterline.
            let waterFrac;
            if (avgSubmersion > $d106d09a724e422d$var$WATERLINE_BAND) waterFrac = 1;
            else if (avgSubmersion < -$d106d09a724e422d$var$WATERLINE_BAND) waterFrac = 0;
            else waterFrac = (avgSubmersion + $d106d09a724e422d$var$WATERLINE_BAND) / (2 * $d106d09a724e422d$var$WATERLINE_BAND);
            // === UNDERWATER FORCES ===
            if (waterFrac > 0) {
                // Buoyancy: vertical force proportional to submersion depth × area.
                // Applied in Z (vertical), not in -normal direction, because our hull
                // mesh is not closed at the waterline — the "pressure on surface" approach
                // requires a closed surface for lateral forces to cancel. Without a
                // waterplane cap, normal-directed buoyancy creates unbalanced lateral
                // forces that push the boat around. Vertical buoyancy with distributed
                // application points naturally produces righting moment (deeper points
                // get more upward force, creating torque that opposes heel).
                //
                // The buoyancy contribution is weighted by -wnz — the negated world-frame
                // vertical component of the triangle's outward normal. The sign matters:
                //   - Bottom triangles (outward normal points down, wnz < 0): -wnz > 0,
                //     so force is upward — water pushes up on the hull bottom.
                //   - Submerged deck triangles (outward normal points up, wnz > 0):
                //     -wnz < 0, so force is downward — water presses down on the top
                //     surface. This is critical at extreme heel when deck edges submerge.
                //   - Side triangles (wnz ≈ 0): negligible contribution either way.
                const effectiveDepth = avgDepth - depthBaseline;
                if (effectiveDepth > 0) {
                    const buoyancyMag = $d106d09a724e422d$var$BUOYANCY_FORCE_PER_DEPTH_PER_AREA * effectiveDepth * area * -wnz;
                    body.applyForce3D(0, 0, buoyancyMag, localX, localY, localZ);
                }
                // Average water velocity from vertices (weighted by submersion)
                let waterVx = 0, waterVy = 0;
                {
                    // Simple average of all three vertex water velocities
                    let count = 0;
                    if (v0 < wq.length) {
                        const vel = wq.get(v0).velocity;
                        waterVx += vel.x;
                        waterVy += vel.y;
                        count++;
                    }
                    if (v1 < wq.length) {
                        const vel = wq.get(v1).velocity;
                        waterVx += vel.x;
                        waterVy += vel.y;
                        count++;
                    }
                    if (v2 < wq.length) {
                        const vel = wq.get(v2).velocity;
                        waterVx += vel.x;
                        waterVy += vel.y;
                        count++;
                    }
                    if (count > 0) {
                        waterVx /= count;
                        waterVy /= count;
                    }
                }
                // Skin friction on submerged area
                const centroidWorldWater = this.body.toWorldFrame((0, $6b6a54a072724620$export$e7c866399fa523f5)(localX, localY));
                const pointZVelocity = localY * body.rollVelocity - localX * body.pitchVelocity;
                const friction = (0, $cc2f69d6c6f8f07b$export$151fa087a7ff594d)(body, centroidWorldWater, area * waterFrac, cf, (0, $6b6a54a072724620$export$e7c866399fa523f5)(waterVx, waterVy), pointZVelocity);
                if (friction) body.applyForce3D(friction.fx, friction.fy, friction.fz, localX, localY, localZ);
                // Form drag: pressure-based drag from normal component of 3D relative velocity.
                // Uses separate stagnation (front-facing) and separation (rear-facing) models.
                // The vertical velocity from roll/pitch is critical for roll damping —
                // when the boat heels, hull triangles push through water vertically.
                //
                // Relative velocity at this point (hull velocity minus water velocity):
                //   rv = point_velocity - water_velocity
                // where point_velocity includes body translation, rotation, and z-axis rotation.
                const rrWaterX = centroidWorldWater.x - body.position[0];
                const rrWaterY = centroidWorldWater.y - body.position[1];
                const pvxW = body.velocity[0] - rrWaterY * body.angularVelocity;
                const pvyW = body.velocity[1] + rrWaterX * body.angularVelocity;
                const pvzW = pointZVelocity + body.zVelocity;
                const rvxW = pvxW - waterVx;
                const rvyW = pvyW - waterVy;
                const rvzW = pvzW; // water has no vertical velocity
                const speedW = Math.sqrt(rvxW * rvxW + rvyW * rvyW + rvzW * rvzW);
                if (speedW > 0.01) {
                    // vDotN > 0: flow hitting front-facing surface (stagnation pressure)
                    // vDotN < 0: surface is in the wake (separation/suction pressure)
                    const vDotN = rvxW * wnx + rvyW * wny + rvzW * wnz;
                    if (vDotN > 0) {
                        // --- Stagnation pressure (front-facing triangles) ---
                        // F = Cp_stag * 0.5 * rho * v^2 * A_projected
                        // where A_projected = area * |vDotN / speed| (projected area normal to flow)
                        // Force direction: along inward normal (-n), opposing the impinging flow.
                        const aProjected = area * (vDotN / speedW); // ft² — projected area normal to flow
                        const dynamicPressure = 0.5 * (0, $76df497339ed0c67$export$e922b9569f201f18) * speedW * speedW; // lbf/ft²
                        const forceMag = cpStag * dynamicPressure * aProjected * waterFrac * (0, $76df497339ed0c67$export$d6989026b8609618);
                        body.applyForce3D(-wnx * forceMag, -wny * forceMag, -wnz * forceMag, localX, localY, localZ);
                    } else if (vDotN < 0) {
                        // --- Separation/suction pressure (rear-facing triangles) ---
                        // In the wake region behind the hull, flow separates and creates a
                        // low-pressure zone. This suction pulls the surface backward.
                        // F = Cp_sep * 0.5 * rho * v^2 * A_projected
                        // where A_projected = area * |vDotN / speed|
                        // Force direction: along outward normal (+n), pulling surface into the wake.
                        const absVDotN = -vDotN; // positive magnitude
                        const aProjected = area * (absVDotN / speedW); // ft²
                        const dynamicPressure = 0.5 * (0, $76df497339ed0c67$export$e922b9569f201f18) * speedW * speedW; // lbf/ft²
                        const forceMag = cpSep * dynamicPressure * aProjected * waterFrac * (0, $76df497339ed0c67$export$d6989026b8609618);
                        // Suction force: +n direction (pulling surface into wake = opposing motion)
                        body.applyForce3D(wnx * forceMag, wny * forceMag, wnz * forceMag, localX, localY, localZ);
                    }
                    // Wave-making vs foam emission have different physical gates:
                    //
                    // - Wave-making (front-facing, pushFlux): surface phenomenon, only
                    //   emitted from waterline-straddling triangles. A submerged hull
                    //   chunk doesn't make surface waves; the water just flows around.
                    //   Emitted every tick from every eligible triangle.
                    //
                    // - Foam / turbulence (rear-facing, suckFlux): originates from
                    //   submerged rear-facing triangles too (turbulent wake behind a
                    //   squatting stern is mostly below the surface). Accumulated
                    //   per-triangle and emitted round-robin by the pass below.
                    if (sourceGroupSpeed > 0.05) {
                        const atWaterline = waterFrac > 0.05 && waterFrac < 0.95;
                        const submerged = waterFrac > 0.05;
                        if (atWaterline && vDotN > 0) {
                            const pushFlux = vDotN * area;
                            const halfWidth = Math.max(Math.sqrt(area), 0.5);
                            while(this._waveSources.length <= this._waveSourceCount)this._waveSources.push({
                                worldX: 0,
                                worldY: 0,
                                pushFlux: 0,
                                halfWidth: 0,
                                groupSpeed: 0
                            });
                            const src = this._waveSources[this._waveSourceCount++];
                            src.worldX = centroidWorldWater.x;
                            src.worldY = centroidWorldWater.y;
                            src.pushFlux = pushFlux;
                            src.halfWidth = halfWidth;
                            src.groupSpeed = sourceGroupSpeed;
                        }
                        if (submerged && vDotN < 0) {
                            this._foamAccumVolume[i] += -vDotN * area * dt;
                            this._foamAccumTime[i] += dt;
                            // Cap accumulator; preserve avgFlux ratio by scaling time.
                            const v = this._foamAccumVolume[i];
                            if (v > $d106d09a724e422d$var$MAX_FOAM_ACCUM_VOLUME) {
                                const scale = $d106d09a724e422d$var$MAX_FOAM_ACCUM_VOLUME / v;
                                this._foamAccumVolume[i] = $d106d09a724e422d$var$MAX_FOAM_ACCUM_VOLUME;
                                this._foamAccumTime[i] *= scale;
                            }
                        }
                    }
                }
            }
            // === ABOVE-WATER FORCES ===
            if (waterFrac < 1) {
                const airFrac = 1 - waterFrac;
                // Average wind velocity from vertices
                let windVx = 0, windVy = 0;
                {
                    let count = 0;
                    if (v0 < wiq.length) {
                        const vel = wiq.get(v0).velocity;
                        windVx += vel.x;
                        windVy += vel.y;
                        count++;
                    }
                    if (v1 < wiq.length) {
                        const vel = wiq.get(v1).velocity;
                        windVx += vel.x;
                        windVy += vel.y;
                        count++;
                    }
                    if (v2 < wiq.length) {
                        const vel = wiq.get(v2).velocity;
                        windVx += vel.x;
                        windVy += vel.y;
                        count++;
                    }
                    if (count > 0) {
                        windVx /= count;
                        windVy /= count;
                    }
                }
                // Wind drag on above-water surface
                const centroidWorld = this.body.toWorldFrame((0, $6b6a54a072724620$export$e7c866399fa523f5)(localX, localY));
                const rr = (0, $6b6a54a072724620$export$e7c866399fa523f5)(centroidWorld.x - body.position[0], centroidWorld.y - body.position[1]);
                const pvx = body.velocity[0] - rr.y * body.angularVelocity;
                const pvy = body.velocity[1] + rr.x * body.angularVelocity;
                const rvx = pvx - windVx;
                const rvy = pvy - windVy;
                const speed = Math.sqrt(rvx * rvx + rvy * rvy);
                if (speed > 0.01) {
                    const vDotN = rvx * wnx + rvy * wny;
                    if (vDotN > 0) {
                        const Cd = vDotN / speed;
                        const dynamicPressure = 0.5 * (0, $76df497339ed0c67$export$b2c4fea6cb9591e) * speed * speed;
                        const forceMag = Cd * dynamicPressure * area * airFrac * (0, $76df497339ed0c67$export$d6989026b8609618);
                        body.applyForce3D(-wnx * forceMag, -wny * forceMag, -wnz * forceMag, localX, localY, localZ);
                    }
                }
            }
        }
        // Round-robin foam emission. Advance the cursor forward, skipping
        // triangles whose accumulator hasn't built up enough volume, and flush
        // up to FOAM_EMISSIONS_PER_TICK triangles this tick. Each emitted
        // particle represents the time-averaged suction flux at that triangle
        // over its accumulation period — intensity is calibrated via avgFlux.
        const triCount = fd.count;
        if (triCount > 0) {
            let emitted = 0;
            let scanned = 0;
            while(emitted < $d106d09a724e422d$var$FOAM_EMISSIONS_PER_TICK && scanned < triCount){
                const idx = this._foamCursor;
                const vol = this._foamAccumVolume[idx];
                if (vol >= $d106d09a724e422d$var$MIN_FOAM_ACCUM_VOLUME) {
                    const time = this._foamAccumTime[idx];
                    const avgFlux = time > 0 ? vol / time : 0;
                    // Transform this triangle's body-local centroid to world frame
                    // at emission time. The water this represents was displaced a
                    // little earlier along the boat's path — for typical tick rates
                    // and boat speeds that offset is sub-foot and visually ignorable.
                    const localX = fd.cx[idx];
                    const localY = fd.cy[idx];
                    const centroidWorld = body.toWorldFrame((0, $6b6a54a072724620$export$e7c866399fa523f5)(localX, localY));
                    const halfWidth = Math.max(Math.sqrt(fd.area[idx]), 0.5);
                    while(this._foamSources.length <= this._foamSourceCount)this._foamSources.push({
                        worldX: 0,
                        worldY: 0,
                        avgFlux: 0,
                        halfWidth: 0,
                        groupSpeed: 0
                    });
                    const src = this._foamSources[this._foamSourceCount++];
                    src.worldX = centroidWorld.x;
                    src.worldY = centroidWorld.y;
                    src.avgFlux = avgFlux;
                    src.halfWidth = halfWidth;
                    src.groupSpeed = sourceGroupSpeed;
                    this._foamAccumVolume[idx] = 0;
                    this._foamAccumTime[idx] = 0;
                    emitted++;
                }
                this._foamCursor = (this._foamCursor + 1) % triCount;
                scanned++;
            }
        }
    }
    /** Deck/fill color. */ getFillColor() {
        return this.fillColor;
    }
    /** Gunwale stroke color. */ getStrokeColor() {
        return this.strokeColor;
    }
    /** Hull topsides color. */ getSideColor() {
        return this.sideColor;
    }
    /** Hull bottom color. */ getBottomColor() {
        return this.bottomColor;
    }
    /**
   * Get the z-height of the topmost deck surface at a hull-local (x, y) point.
   * Returns the floorZ of the highest deck zone containing the point,
   * or null if the point is not over any deck zone.
   */ getDeckHeight(localX, localY) {
        for (const zone of this.deckZonesByHeight){
            if ($d106d09a724e422d$var$pointInPolygonTuple(localX, localY, zone.outline)) return zone.floorZ;
        }
        return null;
    }
    /** Data needed by BoatCompositor for hull height rendering. */ getHeightMeshData() {
        return this.renderMesh;
    }
    getPosition() {
        return (0, $6b6a54a072724620$export$e7c866399fa523f5)(this.body.position);
    }
    getAngle() {
        return this.body.angle;
    }
    setDamageMultiplier(fn) {
        this.getDamageMultiplier = fn;
    }
}
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $aa1f0309d9dba6d2$export$af631764ddc44097)("tick")
], $d106d09a724e422d$export$c4813cc5e4374a49.prototype, "onTick", null);
/**
 * Ray-casting point-in-polygon test for [number, number][] outlines.
 * Casts a ray in the +x direction and counts edge crossings.
 */ function $d106d09a724e422d$var$pointInPolygonTuple(px, py, polygon) {
    const n = polygon.length;
    if (n < 3) return false;
    let inside = false;
    for(let i = 0, j = n - 1; i < n; j = i++){
        const xi = polygon[i][0], yi = polygon[i][1];
        const xj = polygon[j][0], yj = polygon[j][1];
        if (yi > py !== yj > py && px < (xj - xi) * (py - yi) / (yj - yi) + xi) inside = !inside;
    }
    return inside;
}
/** Darken a hex color by a factor (0-1). */ function $d106d09a724e422d$var$darkenColor(color, factor) {
    const r = Math.round((color >> 16 & 0xff) * factor);
    const g = Math.round((color >> 8 & 0xff) * factor);
    const b = Math.round((color & 0xff) * factor);
    return r << 16 | g << 8 | b;
}




/**
 * Shared 2D queries against pre-computed hull boundary outlines.
 *
 * These helpers were originally private to `DeckContactConstraint` and have
 * been hoisted here so that other constraints (like the rope wrap constraint)
 * can reuse them without duplicating the flat-array traversal math.
 *
 * All routines are zero-allocation and operate on the `HullBoundaryLevel`
 * shape built by `buildBoundaryLevel()`.
 */ function $16af0982eee53e14$export$7f6bc8d3d7d61b11(level, px, py) {
    const n = level.count;
    const vx = level.vx;
    const vy = level.vy;
    let inside = false;
    for(let i = 0, j = n - 1; i < n; j = i++){
        const yi = vy[i];
        const yj = vy[j];
        if (yi > py !== yj > py && px < (vx[j] - vx[i]) * (py - yi) / (yj - yi) + vx[i]) inside = !inside;
    }
    return inside;
}
function $16af0982eee53e14$export$bffdeceb379536b2(level, px, py) {
    const n = level.count;
    const vx = level.vx;
    const vy = level.vy;
    let bestDistSq = Infinity;
    let bestIdx = 0;
    let bestCx = 0;
    let bestCy = 0;
    for(let i = 0; i < n; i++){
        const j = (i + 1) % n;
        const ax = vx[i];
        const ay = vy[i];
        const ex = vx[j] - ax;
        const ey = vy[j] - ay;
        const lenSq = ex * ex + ey * ey;
        // Project point onto edge, clamped to [0, 1]
        let t;
        if (lenSq < 1e-16) t = 0;
        else {
            t = ((px - ax) * ex + (py - ay) * ey) / lenSq;
            if (t < 0) t = 0;
            else if (t > 1) t = 1;
        }
        const cx = ax + t * ex;
        const cy = ay + t * ey;
        const dx = px - cx;
        const dy = py - cy;
        const dSq = dx * dx + dy * dy;
        if (dSq < bestDistSq) {
            bestDistSq = dSq;
            bestIdx = i;
            bestCx = cx;
            bestCy = cy;
        }
    }
    return {
        edgeIndex: bestIdx,
        cx: bestCx,
        cy: bestCy,
        distSq: bestDistSq
    };
}
function $16af0982eee53e14$export$25a58447bdd3cec0(boundary, z) {
    const levels = boundary.levels;
    if (levels.length === 0) return null;
    // Below everything → use bottom level
    if (z <= levels[0].z) return levels[0];
    // Walk down to find the level at or just below z
    for(let i = levels.length - 1; i >= 0; i--){
        if (levels[i].z <= z) return levels[i];
    }
    return levels[0];
}
// Scratch object reused across calls — callers must read before the next call.
const $16af0982eee53e14$var$CROSSING_SCRATCH = {
    px: 0,
    py: 0,
    pz: 0
};
function $16af0982eee53e14$export$9de20d5862b372cb(boundary, aLocalX, aLocalY, aInside, bLocalX, bLocalY) {
    const levels = boundary.levels;
    if (levels.length === 0) return null;
    const deckLevel = levels[levels.length - 1];
    const n = deckLevel.count;
    const vx = deckLevel.vx;
    const vy = deckLevel.vy;
    // Chord direction (A → B in hull-local XY).
    const dx = bLocalX - aLocalX;
    const dy = bLocalY - aLocalY;
    // We want the crossing closest to whichever endpoint is *outside* the
    // hull. If A is inside, outside = B (t → 1); otherwise outside = A (t → 0).
    // Track the best t accordingly.
    const preferLargeT = aInside;
    let bestT = preferLargeT ? -Infinity : Infinity;
    let bestX = 0;
    let bestY = 0;
    let found = false;
    for(let i = 0; i < n; i++){
        const j = (i + 1) % n;
        const ex = vx[j] - vx[i];
        const ey = vy[j] - vy[i];
        // Solve: aLocal + t*(b-a) = v_i + u*e,  with t,u ∈ [0,1].
        // Cramer's rule on the 2x2 system:
        //   [ dx  -ex ] [ t ]   [ vx[i] - aLocalX ]
        //   [ dy  -ey ] [ u ] = [ vy[i] - aLocalY ]
        const denom = dx * -ey - dy * -ex; // = -dx*ey + dy*ex
        if (denom === 0) continue; // parallel
        const rx = vx[i] - aLocalX;
        const ry = vy[i] - aLocalY;
        const t = (rx * -ey - ry * -ex) / denom;
        if (t < 0 || t > 1) continue;
        const u = (dx * ry - dy * rx) / denom;
        if (u < 0 || u > 1) continue;
        if (preferLargeT ? t > bestT : t < bestT) {
            bestT = t;
            bestX = aLocalX + t * dx;
            bestY = aLocalY + t * dy;
            found = true;
        }
    }
    if (!found) return null;
    $16af0982eee53e14$var$CROSSING_SCRATCH.px = bestX;
    $16af0982eee53e14$var$CROSSING_SCRATCH.py = bestY;
    $16af0982eee53e14$var$CROSSING_SCRATCH.pz = boundary.deckHeight;
    return $16af0982eee53e14$var$CROSSING_SCRATCH;
}



function $3060cd7907214b09$export$a1b6c2945208a187(outline, z) {
    const n = outline.length;
    if (n < 3) return null;
    const vx = new Float64Array(n);
    const vy = new Float64Array(n);
    const edgeNx = new Float64Array(n);
    const edgeNy = new Float64Array(n);
    const edgeTx = new Float64Array(n);
    const edgeTy = new Float64Array(n);
    for(let i = 0; i < n; i++){
        vx[i] = outline[i][0];
        vy[i] = outline[i][1];
    }
    // Compute signed area to determine winding
    let area = 0;
    for(let i = 0; i < n; i++){
        const j = (i + 1) % n;
        area += vx[i] * vy[j] - vx[j] * vy[i];
    }
    // area > 0 → CCW, < 0 → CW
    const sign = area >= 0 ? 1 : -1;
    for(let i = 0; i < n; i++){
        const j = (i + 1) % n;
        const ex = vx[j] - vx[i];
        const ey = vy[j] - vy[i];
        const len = Math.sqrt(ex * ex + ey * ey);
        if (len < 1e-10) {
            edgeTx[i] = 1;
            edgeTy[i] = 0;
            edgeNx[i] = 0;
            edgeNy[i] = -sign;
        } else {
            const invLen = 1 / len;
            edgeTx[i] = ex * invLen;
            edgeTy[i] = ey * invLen;
            // CCW outward normal: (ty, -tx). CW: (-ty, tx). Handled by sign.
            edgeNx[i] = sign * edgeTy[i];
            edgeNy[i] = sign * -edgeTx[i];
        }
    }
    return {
        z: z,
        vx: vx,
        vy: vy,
        edgeNx: edgeNx,
        edgeNy: edgeNy,
        edgeTx: edgeTx,
        edgeTy: edgeTy,
        count: n
    };
}
class $3060cd7907214b09$export$f1acd6513b925c2b extends (0, $63235e744c2c6cbe$export$aec1359a0a40a615) {
    constructor(particle, hullBody, getDeckHeight, hullBoundary, frictionCoefficient = 0.5, radius = 0, options){
        super(particle, hullBody, options), /** Whether the constraint is currently engaged (particle on or near a surface). */ this._active = false;
        this.getDeckHeight = getDeckHeight;
        this.boundary = hullBoundary;
        this.frictionCoefficient = frictionCoefficient;
        this.radius = radius;
        // Particle is bodyA (point-like, no angular), hull is bodyB (rigid). The
        // PointToRigidEquation3D shape encodes G = [-n, 0, +n, rj×n] so the
        // solver skips all body-A angular work. Friction equations reuse the
        // same shape — they're pure velocity constraints, so update() leaves
        // `offset = 0` on them.
        const normal = new (0, $7c2ab345e8402709$export$72aece4f82bc5bee)(particle, hullBody, 0, Number.MAX_VALUE);
        const friction1 = new (0, $7c2ab345e8402709$export$72aece4f82bc5bee)(particle, hullBody, 0, 0);
        const friction2 = new (0, $7c2ab345e8402709$export$72aece4f82bc5bee)(particle, hullBody, 0, 0);
        this.equations = [
            normal,
            friction1,
            friction2
        ];
        // Determine initial inside/outside state from current particle position
        const deckLevel = hullBoundary.levels[hullBoundary.levels.length - 1];
        if (deckLevel) {
            const [lx, ly] = hullBody.toLocalFrame3D(particle.position[0], particle.position[1], particle.z);
            this.inside = (0, $16af0982eee53e14$export$7f6bc8d3d7d61b11)(deckLevel, lx, ly);
        } else this.inside = true;
    }
    update() {
        const particle = this.bodyA;
        const hull = this.bodyB;
        const normal = this.equations[0];
        const friction1 = this.equations[1];
        const friction2 = this.equations[2];
        const boundary = this.boundary;
        // Convert particle world position to hull-local coordinates
        const pz = particle.z;
        if (!isFinite(pz)) {
            this.disableAll(normal, friction1, friction2);
            return this;
        }
        const [lx, ly, lz] = hull.toLocalFrame3D(particle.position[0], particle.position[1], pz);
        // Use the topmost level (deck-level outline) for state transitions
        const deckLevel = boundary.levels[boundary.levels.length - 1];
        if (!deckLevel) {
            this.disableAll(normal, friction1, friction2);
            return this;
        }
        const insideDeckOutline = (0, $16af0982eee53e14$export$7f6bc8d3d7d61b11)(deckLevel, lx, ly);
        // ── State transitions ──────────────────────────────────────────
        if (this.inside && !insideDeckOutline) {
            // Was inside, slid over gunwale → outside
            this.inside = false;
            this.resetWarmStart();
        } else if (!this.inside && insideDeckOutline) // Was outside, XY is now within deck outline
        {
            if (lz >= boundary.deckHeight - this.radius - 0.1) {
                // Entered from above the gunwale (open edge) → allowed
                this.inside = true;
                this.resetWarmStart();
            }
        }
        // ── Dispatch to mode ───────────────────────────────────────────
        if (this.inside) this.updateInside(lx, ly, normal, friction1, friction2);
        else this.updateOutside(lx, ly, lz, normal, friction1, friction2);
        return this;
    }
    // ── Inside mode: deck surface contact ────────────────────────────
    updateInside(lx, ly, normal, friction1, friction2) {
        const particle = this.bodyA;
        const hull = this.bodyB;
        // Query deck height (with fallback to gunwale height)
        const deckZ = this.getDeckHeight(lx, ly) ?? this.boundary.deckHeight;
        // Deck surface point in world space
        const [dx, dy, dz] = hull.toWorldFrame3D(lx, ly, deckZ);
        // Particle world position
        const px = particle.position[0];
        const py = particle.position[1];
        const pz = particle.z;
        // Hull orientation matrix (row-major 3x3)
        const R = hull.orientation;
        // World deck normal: hull's local Z axis
        const nx = R[2];
        const ny = R[5];
        const nz = R[8];
        // Signed distance from particle center to the effective surface
        const rawDist = nx * (px - dx) + ny * (py - dy) + nz * (pz - dz);
        const penetration = rawDist - this.radius;
        this._active = true;
        normal.enabled = true;
        // Lever arm from hull center to deck contact point (world frame)
        const rjX = dx - hull.position[0];
        const rjY = dy - hull.position[1];
        const rjZ = dz - hull.z;
        // Write the point-to-rigid shape fields: G_A = -n, G_B = +n, G_B_ang = rj×n.
        // Position error is the penetration depth (negative = penetrating).
        this.setShapeJacobian(normal, nx, ny, nz, rjX, rjY, rjZ);
        normal.offset = penetration;
        // Friction
        this.setFriction(normal, friction1, friction2, R, rjX, rjY, rjZ);
    }
    // ── Outside mode: hull wall contact ──────────────────────────────
    updateOutside(lx, ly, lz, normal, friction1, friction2) {
        const particle = this.bodyA;
        const hull = this.bodyB;
        const boundary = this.boundary;
        // Above gunwale → no wall constraint (open edge)
        if (lz > boundary.deckHeight + this.radius) {
            this.disableAll(normal, friction1, friction2);
            return;
        }
        // Find the z-appropriate hull outline level
        const zLevel = (0, $16af0982eee53e14$export$25a58447bdd3cec0)(boundary, lz);
        if (!zLevel) {
            this.disableAll(normal, friction1, friction2);
            return;
        }
        // Find nearest hull edge at this z-level
        const nearest = (0, $16af0982eee53e14$export$bffdeceb379536b2)(zLevel, lx, ly);
        if (nearest.distSq > 25) {
            // > 5 ft from hull → disable
            this.disableAll(normal, friction1, friction2);
            return;
        }
        // Below hull bottom → bottom contact (push downward, away from hull)
        if (lz <= -boundary.draft + this.radius) {
            this.updateBottomContact(lx, ly, normal, friction1, friction2);
            return;
        }
        // Wall contact: push particle outward from nearest hull edge
        // Wall normal: always use pre-computed edge outward normal.
        // (Using particle-to-edge direction would point inward when penetrating.)
        const localNx = zLevel.edgeNx[nearest.edgeIndex];
        const localNy = zLevel.edgeNy[nearest.edgeIndex];
        // Signed distance along outward normal from nearest edge point to particle.
        // Positive = outside hull (gap), negative = penetrating through wall.
        const signedDist = (lx - nearest.cx) * localNx + (ly - nearest.cy) * localNy;
        const penetration = signedDist - this.radius;
        // Transform wall normal to world frame
        const R = hull.orientation;
        const wnx = R[0] * localNx + R[1] * localNy;
        const wny = R[3] * localNx + R[4] * localNy;
        const wnz = R[6] * localNx + R[7] * localNy;
        // Contact point on the wall in world space
        const [wx, wy, wz] = hull.toWorldFrame3D(nearest.cx, nearest.cy, lz);
        this._active = true;
        normal.enabled = true;
        // Lever arm from hull center to wall contact point
        const rjX = wx - hull.position[0];
        const rjY = wy - hull.position[1];
        const rjZ = wz - hull.z;
        // Shape fields: push particle outward from wall along world normal
        this.setShapeJacobian(normal, wnx, wny, wnz, rjX, rjY, rjZ);
        normal.offset = penetration;
        // Friction tangents for wall contact
        const slipForce = this.frictionCoefficient * Math.abs(normal.multiplier);
        if (slipForce > 0) {
            friction1.enabled = true;
            friction1.minForce = -slipForce;
            friction1.maxForce = slipForce;
            friction2.enabled = true;
            friction2.minForce = -slipForce;
            friction2.maxForce = slipForce;
        } else {
            friction1.enabled = false;
            friction2.enabled = false;
        }
        // Tangent 1: along the hull edge in world space
        const t1lx = zLevel.edgeTx[nearest.edgeIndex];
        const t1ly = zLevel.edgeTy[nearest.edgeIndex];
        const t1x = R[0] * t1lx + R[1] * t1ly;
        const t1y = R[3] * t1lx + R[4] * t1ly;
        const t1z = R[6] * t1lx + R[7] * t1ly;
        // Tangent 2: hull Z axis (vertical along wall)
        const t2x = R[2];
        const t2y = R[5];
        const t2z = R[8];
        this.setShapeJacobian(friction1, t1x, t1y, t1z, rjX, rjY, rjZ);
        friction1.offset = 0;
        this.setShapeJacobian(friction2, t2x, t2y, t2z, rjX, rjY, rjZ);
        friction2.offset = 0;
    }
    // ── Bottom contact (outside, below hull) ─────────────────────────
    updateBottomContact(lx, ly, normal, friction1, friction2) {
        const hull = this.bodyB;
        const R = hull.orientation;
        // Push particle downward (hull's -Z axis in world = away from hull interior)
        const nx = -R[2];
        const ny = -R[5];
        const nz = -R[8];
        // Contact point: on the hull bottom surface
        const [bx, by, bz] = hull.toWorldFrame3D(lx, ly, -this.boundary.draft);
        const px = this.bodyA.position[0];
        const py = this.bodyA.position[1];
        const pz = this.bodyA.z;
        const rawDist = nx * (px - bx) + ny * (py - by) + nz * (pz - bz);
        const penetration = rawDist - this.radius;
        this._active = true;
        normal.enabled = true;
        const rjX = bx - hull.position[0];
        const rjY = by - hull.position[1];
        const rjZ = bz - hull.z;
        this.setShapeJacobian(normal, nx, ny, nz, rjX, rjY, rjZ);
        normal.offset = penetration;
        // Friction on hull bottom: hull X and Y axes
        this.setFriction(normal, friction1, friction2, R, rjX, rjY, rjZ);
    }
    // ── Jacobian helpers ─────────────────────────────────────────────
    /**
   * Write a point-to-rigid constraint direction to the shape fields.
   *
   * Historical convention of this constraint had body A (the particle)
   * receiving `+origN` linearly. The {@link PointToRigidEquation3D} shape
   * instead stores a direction `n` where body A gets `-n`, so we negate
   * the incoming direction when assigning. The angular contribution for
   * body B matches the original `G[9..11] = -(rj × origN)` expression —
   * which is exactly `rj × (-origN) = rj × n` — so the cross-product
   * formulas are unchanged from the original `setNormalJacobian`.
   */ setShapeJacobian(eq, origNx, origNy, origNz, rjX, rjY, rjZ) {
        eq.nx = -origNx;
        eq.ny = -origNy;
        eq.nz = -origNz;
        eq.rjXnX = -(rjY * origNz - rjZ * origNy);
        eq.rjXnY = -(rjZ * origNx - rjX * origNz);
        eq.rjXnZ = -(rjX * origNy - rjY * origNx);
    }
    /** Set up both friction equations using hull X/Y axes as tangents. */ setFriction(normal, friction1, friction2, R, rjX, rjY, rjZ) {
        const slipForce = this.frictionCoefficient * Math.abs(normal.multiplier);
        if (slipForce > 0) {
            friction1.enabled = true;
            friction1.minForce = -slipForce;
            friction1.maxForce = slipForce;
            friction2.enabled = true;
            friction2.minForce = -slipForce;
            friction2.maxForce = slipForce;
        } else {
            friction1.enabled = false;
            friction2.enabled = false;
        }
        // Tangent 1: hull's local X axis (forward) in world space
        this.setShapeJacobian(friction1, R[0], R[3], R[6], rjX, rjY, rjZ);
        friction1.offset = 0;
        // Tangent 2: hull's local Y axis (starboard) in world space
        this.setShapeJacobian(friction2, R[1], R[4], R[7], rjX, rjY, rjZ);
        friction2.offset = 0;
    }
    disableAll(normal, friction1, friction2) {
        normal.enabled = false;
        friction1.enabled = false;
        friction2.enabled = false;
        this._active = false;
    }
    /** Reset warm-starting impulses on state transition to prevent stale directional impulses. */ resetWarmStart() {
        for (const eq of this.equations){
            eq.warmLambda = 0;
            eq.multiplier = 0;
        }
    }
    /** Whether the constraint is currently active (particle on/near a surface). */ isActive() {
        return this._active;
    }
    /** Whether the particle is currently inside the hull. */ isInside() {
        return this.inside;
    }
}








class $9e287f6f6f4a3625$export$979f3f46cb02524b extends (0, $c59361981bac2575$export$4342ba5c6ad1f6f1) {
    constructor(hull, config, hullDraft){
        super(), this.hull = hull, this.layer = "boat", this.waterQuery = this.addChild(new (0, $2f31bbbd4b5b01e3$export$38b1d297f12cec06)(()=>this.getQueryPoints())), this.velocityCache = new Map(), this.fluidForceResults = [
            {
                fx: 0,
                fy: 0,
                localX: 0,
                localY: 0
            },
            {
                fx: 0,
                fy: 0,
                localX: 0,
                localY: 0
            }
        ], this.hydrofoilResults = Array.from({
            length: 12
        }, ()=>({
                fx: 0,
                fy: 0,
                fz: 0,
                localX: 0,
                localY: 0
            }));
        this.vertices = config.vertices;
        this.chord = config.chord;
        this.color = config.color;
        // Apply keel forces at the midpoint of the keel blade span.
        // The keel extends from hull bottom (-hullDraft) to keel tip (-config.draft).
        // Center of pressure is roughly at the midpoint of the blade.
        this.keelZ = -(hullDraft + config.draft) / 2;
        // Aspect ratio = span / chord. Span is the keel blade depth (draft below hull bottom).
        const keelSpan = config.draft - hullDraft;
        this.aspectRatio = keelSpan / config.chord;
    }
    /**
   * Get query points in world space for all keel vertices.
   */ getQueryPoints() {
        const points = [];
        for (const v of this.vertices)points.push(this.hull.body.toWorldFrame(v));
        return points;
    }
    onTick() {
        // Build velocity cache from query results
        this.velocityCache.clear();
        const queryPoints = this.getQueryPoints();
        for(let i = 0; i < this.waterQuery.results.length; i++){
            const point = queryPoints[i];
            if (point) {
                const key = `${point.x.toFixed(2)},${point.y.toFixed(2)}`;
                this.velocityCache.set(key, this.waterQuery.results[i].velocity);
            }
        }
        // Scale keel effectiveness by heel angle — keel loses lateral resistance at extreme heel
        const heelFactor = Math.cos(this.hull.body.roll);
        const effectiveChord = this.chord * Math.max(0.1, heelFactor);
        // Use proper foil physics with heel-adjusted chord dimension
        const lift = (0, $cc2f69d6c6f8f07b$export$17e29cb2a12a29cc)(effectiveChord);
        const drag = (0, $cc2f69d6c6f8f07b$export$42313db6ebd1acc)(effectiveChord, this.aspectRatio);
        // Get water velocity from cache or default to zero
        const getWaterVelocity = (point)=>{
            const key = `${point.x.toFixed(2)},${point.y.toFixed(2)}`;
            return this.velocityCache.get(key) ?? (0, $6b6a54a072724620$export$e7c866399fa523f5)(0, 0);
        };
        const roll = this.hull.body.roll;
        const angle = this.hull.body.angle;
        // Compute 3D hydrofoil forces with heel decomposition
        const count = (0, $cc2f69d6c6f8f07b$export$d43fb434dfbb6108)(this.hull.body, this.vertices, roll, angle, lift, drag, getWaterVelocity, this.hydrofoilResults, this.fluidForceResults);
        // Apply keel forces to hull at keelZ depth (produces anti-heeling torque)
        for(let i = 0; i < count; i++){
            const r = this.hydrofoilResults[i];
            this.hull.body.applyForce3D(r.fx, r.fy, r.fz, r.localX, r.localY, this.keelZ);
        }
    }
    /** Hull-local keel vertices for rendering. */ getVertices() {
        return this.vertices;
    }
    /** Z-depth of the keel blade midpoint. */ getKeelZ() {
        return this.keelZ;
    }
    /** Visual color for the keel. */ getColor() {
        return this.color;
    }
}
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $aa1f0309d9dba6d2$export$af631764ddc44097)("tick")
], $9e287f6f6f4a3625$export$979f3f46cb02524b.prototype, "onTick", null);



class $772958a7afcb0bb0$export$c28251d0c7617e9e extends (0, $c59361981bac2575$export$4342ba5c6ad1f6f1) {
    constructor(boat, config){
        super();
        this.boat = boat;
        this.config = config;
    }
}







/**
 * Capstan-network rope entity.
 *
 * Owns an ordered list of nodes (endpoints, blocks, winches) and the
 * scalar-length sections between them. Each tick, refreshes each node's
 * world position from its body, runs the pure capstan solver, and applies
 * the resulting tensions as forces at node anchors.
 *
 * Rendering is handled separately in Phase 3 by `RopeRender`; this entity
 * exposes enough state for that module (and for material-v computation)
 * via read-only accessors. Phase 2 provides a naive straight-chord sampler
 * so callers can render the rope while the full render layer is still
 * under construction.
 *
 * Hull interaction is intentionally absent from the physics: obstacles
 * and deck contact are render-only concerns.
 */ 



/**
 * Pure capstan-network rope solver.
 *
 * A rope is modeled as an ordered list of nodes (endpoints, blocks, winches)
 * with scalar-length sections between them. Each interior node may have a
 * Coulomb friction coefficient μ; the capstan equation bounds the ratio of
 * tensions on either side to [e^{-μθ}, e^{+μθ}] where θ is the bend angle.
 * When the tension ratio exceeds the bound, length flows between adjacent
 * sections at a rate proportional to the excess.
 *
 * This module is deliberately free of entity and physics-engine imports:
 * callers pass in world positions (already resolved via `toWorldFrame3D`)
 * and receive updated section lengths + tensions. The caller is responsible
 * for applying tensions as forces on bodies.
 *
 * Sign conventions:
 *  - Node index 0 is the "far" endpoint (sail clew, anchor body).
 *  - Last node is the "tail" endpoint (free end or hull tie-off).
 *  - Section i connects nodes i and i+1.
 *  - Flow > 0 at node i means length moves from section i-1 (working side)
 *    to section i (tail side). This is the "trim in" direction at a winch.
 */ const $0bfa53e2a1bf70ca$export$4f64e66a39679892 = {
    kAxial: 20000,
    cDamping: 1500,
    // Safety rail well above any winch's stall force (the Sheet winch stalls
    // ~8k engine units, the anchor windlass ~16k). Set high enough that the
    // winch taper — not this cap — is what actually limits trim tension.
    maxTension: 30000,
    flowRateCoef: 0.005,
    iterations: 4,
    degenerateChord: 1e-4
};
function $0bfa53e2a1bf70ca$export$b8ad1621112a78f4(length = 0) {
    // prevChord = NaN signals "uninitialized" — first solveNetwork() call
    // seeds it from the current chord so we don't apply spurious damping
    // based on a zero previous value.
    return {
        length: length,
        chord: 0,
        prevChord: NaN,
        tension: 0,
        flow: 0
    };
}
function $0bfa53e2a1bf70ca$export$f79bc20650bb7519(nodes, sections, dt, config = $0bfa53e2a1bf70ca$export$4f64e66a39679892) {
    const k = nodes.length;
    if (k < 2 || sections.length !== k - 1) return;
    // 1. Chord distances (fixed for the whole tick — node worldPos doesn't
    //    change during solve; body integration happens later). Also seed
    //    prevChord on first use so the initial tick doesn't see a spurious
    //    huge chord-rate from NaN/zero.
    for(let i = 0; i < sections.length; i++){
        const a = nodes[i].worldPos;
        const b = nodes[i + 1].worldPos;
        const dx = b[0] - a[0];
        const dy = b[1] - a[1];
        const dz = b[2] - a[2];
        sections[i].chord = Math.sqrt(dx * dx + dy * dy + dz * dz);
        sections[i].flow = 0;
        if (!isFinite(sections[i].prevChord)) sections[i].prevChord = sections[i].chord;
    }
    // 2. Jacobi sweeps: (a) recompute tensions, (b) capstan redistribution at
    //    interior nodes, (c) winch-driven flow injection.
    for(let iter = 0; iter < config.iterations; iter++){
        $0bfa53e2a1bf70ca$var$recomputeTensions(sections, config, dt);
        // Capstan sweep at each interior node (friction-bounded tension jump).
        for(let i = 1; i < k - 1; i++){
            const node = nodes[i];
            const sL = sections[i - 1];
            const sR = sections[i];
            if (sL.chord < config.degenerateChord || sR.chord < config.degenerateChord) continue;
            const theta = $0bfa53e2a1bf70ca$var$bendAngle(nodes, i, sL.chord, sR.chord);
            const maxRatio = Math.exp(node.mu * theta);
            // Add a small floor so a slack side (T=0) doesn't cause infinite ratio.
            const TLref = sL.tension + 1e-3;
            const TRref = sR.tension + 1e-3;
            let flow = 0;
            if (TRref > TLref * maxRatio) {
                const excess = TRref - TLref * maxRatio;
                flow = config.flowRateCoef * excess * dt;
            } else if (TLref > TRref * maxRatio) {
                const excess = TLref - TRref * maxRatio;
                flow = -config.flowRateCoef * excess * dt;
            }
            // A winch's ratchet clamps natural capstan flow too, not just the
            // player-injected flow rate. Without this, the capstan happily lets
            // rope slide through an "engaged" winch whenever the working side
            // is under load — effectively disabling the ratchet.
            if (node.kind === "winch") {
                const ratchet = node.ratchetSign ?? 0;
                if (ratchet === 1 && flow < 0) flow = 0;
                else if (ratchet === -1 && flow > 0) flow = 0;
            }
            flow = $0bfa53e2a1bf70ca$var$clampFlow(flow, sL.length, sR.length);
            sL.length -= flow;
            sR.length += flow;
            sL.flow += flow;
        }
        // Winch-driven flow injection. Positive flowRateIn = trim (L → R).
        // Ratchet is enforced after clamping sign, before clamping availability.
        //
        // Strength cap: the effective rate is scaled down as working-side
        // tension approaches `winchMaxForce`. This models the fact that hand
        // winches can only exert a bounded force; cranking harder against a
        // taut sheet doesn't pull in more rope, it just stops moving. Without
        // this, tension spikes to the kAxial cap on its own and the mast↔block
        // lever arm turns it into a huge yaw torque on the hull.
        for(let i = 1; i < k - 1; i++){
            const node = nodes[i];
            if (node.kind !== "winch") continue;
            const rate = node.flowRateIn ?? 0;
            if (rate === 0) continue;
            const sL = sections[i - 1];
            const sR = sections[i];
            const maxForce = node.winchMaxForce ?? Infinity;
            let rateScale = 1;
            if (isFinite(maxForce) && maxForce > 0) {
                // Trimming pulls from L → R; tension that resists trim is the
                // working-side (L) tension.
                const workingT = sL.tension;
                rateScale = Math.max(0, 1 - workingT / maxForce);
            }
            let flow = rate * rateScale * dt;
            const ratchet = node.ratchetSign ?? 0;
            if (ratchet === 1 && flow < 0) flow = 0;
            else if (ratchet === -1 && flow > 0) flow = 0;
            flow = $0bfa53e2a1bf70ca$var$clampFlow(flow, sL.length, sR.length);
            sL.length -= flow;
            sR.length += flow;
            sL.flow += flow;
        }
    }
    // 3. Final tension pass so callers see values consistent with final lengths.
    $0bfa53e2a1bf70ca$var$recomputeTensions(sections, config, dt);
    // Clamp non-negative lengths and roll prevChord forward for next tick.
    for(let i = 0; i < sections.length; i++){
        if (sections[i].length < 0) sections[i].length = 0;
        sections[i].prevChord = sections[i].chord;
    }
}
/**
 * Tension = max(0, min(maxTension, kAxial * strain + cDamping * chord_rate)).
 *
 * The damping term (chord_rate = d/dt (chord)) turns the pure spring into a
 * Kelvin–Voigt element: relative motion between the endpoints dissipates
 * energy, so transient oscillations settle instead of ringing indefinitely.
 * Without it, stiff rope + inertial endpoints form an undamped oscillator
 * that pumps energy back into whatever's driving it (the winch, the boom).
 *
 * Degenerate sections (chord ≈ 0) always get zero tension.
 */ function $0bfa53e2a1bf70ca$var$recomputeTensions(sections, config, dt) {
    const k = config.kAxial;
    const c = config.cDamping;
    const maxT = config.maxTension;
    const invDt = dt > 0 ? 1 / dt : 0;
    for(let i = 0; i < sections.length; i++){
        const s = sections[i];
        if (s.chord < config.degenerateChord) {
            s.tension = 0;
            continue;
        }
        const strain = s.chord - s.length;
        const elastic = strain > 0 ? k * strain : 0;
        const chordRate = (s.chord - s.prevChord) * invDt;
        const damping = c * chordRate;
        let t = elastic + damping;
        if (t < 0) t = 0;
        else if (t > maxT) t = maxT;
        s.tension = t;
    }
}
/**
 * Bend angle θ at an interior node.
 *
 * θ = 0 when rope runs straight through, π when it folds back.
 * Computed as π − angle between the two outgoing direction vectors.
 */ function $0bfa53e2a1bf70ca$var$bendAngle(nodes, i, chordL, chordR) {
    const pN = nodes[i].worldPos;
    const pL = nodes[i - 1].worldPos;
    const pR = nodes[i + 1].worldPos;
    const invL = 1 / chordL;
    const invR = 1 / chordR;
    const dLx = (pL[0] - pN[0]) * invL;
    const dLy = (pL[1] - pN[1]) * invL;
    const dLz = (pL[2] - pN[2]) * invL;
    const dRx = (pR[0] - pN[0]) * invR;
    const dRy = (pR[1] - pN[1]) * invR;
    const dRz = (pR[2] - pN[2]) * invR;
    let cos = dLx * dRx + dLy * dRy + dLz * dRz;
    if (cos > 1) cos = 1;
    else if (cos < -1) cos = -1;
    return Math.PI - Math.acos(cos);
}
/**
 * Bound a proposed flow by the amount of length available on each side.
 * A flow greater than half the source section's length would drain it
 * entirely in one step; halving prevents a single tick from starving a
 * section before subsequent iterations can re-equilibrate.
 */ function $0bfa53e2a1bf70ca$var$clampFlow(flow, leftLen, rightLen) {
    const maxOut = leftLen * 0.5;
    const maxIn = rightLen * 0.5;
    if (flow > maxOut) return maxOut;
    if (flow < -maxIn) return -maxIn;
    return flow;
}
function $0bfa53e2a1bf70ca$export$93e1ae62717a452e(nodes, sections, nodeIdx, outForce) {
    outForce[0] = 0;
    outForce[1] = 0;
    outForce[2] = 0;
    const k = nodes.length;
    const pN = nodes[nodeIdx].worldPos;
    if (nodeIdx > 0) {
        const sL = sections[nodeIdx - 1];
        if (sL.chord > 1e-6 && sL.tension > 0) {
            const pL = nodes[nodeIdx - 1].worldPos;
            const scale = sL.tension / sL.chord;
            outForce[0] += (pL[0] - pN[0]) * scale;
            outForce[1] += (pL[1] - pN[1]) * scale;
            outForce[2] += (pL[2] - pN[2]) * scale;
        }
    }
    if (nodeIdx < k - 1) {
        const sR = sections[nodeIdx];
        if (sR.chord > 1e-6 && sR.tension > 0) {
            const pR = nodes[nodeIdx + 1].worldPos;
            const scale = sR.tension / sR.chord;
            outForce[0] += (pR[0] - pN[0]) * scale;
            outForce[1] += (pR[1] - pN[1]) * scale;
            outForce[2] += (pR[2] - pN[2]) * scale;
        }
    }
}


/**
 * Entity-level rope node: a body + local anchor plus the solver fields.
 *
 * Each node's `worldPos` is refreshed from the body's world transform at
 * the start of every tick; the capstan solver then reads `worldPos` and
 * the friction/winch fields directly via the CapstanNode interface.
 */ 
function $d3af85fe11a3ab16$export$709128881a216da4(config) {
    const localAnchor = (0, $3480ec8c2fb5ff20$export$d2aa6c54a5925f01)(config.localAnchor);
    const worldPos = config.body.toWorldFrame3D(localAnchor);
    const node = {
        body: config.body,
        localAnchor: localAnchor,
        kind: config.kind,
        mu: config.mu ?? 0,
        worldPos: worldPos
    };
    return node;
}
function $d3af85fe11a3ab16$export$22142295318b730c(node) {
    node.body.toWorldFrame3D(node.localAnchor, node.worldPos);
}


/**
 * A section of rope between two adjacent nodes.
 *
 * This module re-exports the solver-level `CapstanSection` as the canonical
 * section type; the entity layer doesn't need to add any physics-state
 * fields. Visual-only state (oscillator, effective gravity, material-v
 * offset) lives in the render module alongside its own lifecycle.
 */ 


/**
 * Decorative free-end tail: a short Verlet chain attached at the last node
 * of a rope network. Gravity + drag; no rope-to-rope coupling. Provides
 * the visual flop / swing / coil the capstan-network physics doesn't
 * simulate.
 *
 * The tail does not feed back into the rope network's tension — it's pure
 * decoration. Its first particle is pinned to the anchor node's worldPos
 * each tick; subsequent particles hang from it under gravity.
 */ 



/** Gravity applied to tail particles (ft/s²). Mild — tails are lightweight. */ const $87cb75869f54e2f8$var$TAIL_GRAVITY = 18;
/** Linear damping per tick (fraction of velocity retained). */ const $87cb75869f54e2f8$var$TAIL_DAMPING = 0.92;
/** Verlet constraint iterations per tick. */ const $87cb75869f54e2f8$var$TAIL_ITERATIONS = 4;
class $87cb75869f54e2f8$export$aa6668811a9d4e3 extends (0, $c59361981bac2575$export$4342ba5c6ad1f6f1) {
    constructor(anchorNode, config){
        super();
        this.anchorNode = anchorNode;
        this.totalLength = Math.max(0.1, config.length);
        const count = Math.max(2, config.count ?? 7);
        this.restSegmentLength = this.totalLength / (count - 1);
        // Seed all particles at the anchor position so the tail hangs straight
        // down over the first few ticks (gravity pulls them apart).
        const a = anchorNode.worldPos;
        this.positions = [];
        this.prevPositions = [];
        for(let i = 0; i < count; i++){
            this.positions.push(new (0, $3480ec8c2fb5ff20$export$d2de7ccaa2f4bf9f)(a[0], a[1], a[2] - i * 0.001));
            this.prevPositions.push(new (0, $3480ec8c2fb5ff20$export$d2de7ccaa2f4bf9f)(a[0], a[1], a[2] - i * 0.001));
        }
    }
    /** Update tail length (e.g., when rope ease/trim changes available tail). */ setLength(length) {
        this.totalLength = Math.max(0.1, length);
    // Note: `restSegmentLength` is fixed at construction. When length grows,
    // the tail stretches rather than spawning particles; when it shrinks,
    // particles crowd together. This is good enough for decoration.
    }
    getPositions() {
        return this.positions;
    }
    onTick({ dt: dt }) {
        // Pin particle 0 to the anchor.
        const a = this.anchorNode.worldPos;
        this.positions[0][0] = a[0];
        this.positions[0][1] = a[1];
        this.positions[0][2] = a[2];
        this.prevPositions[0][0] = a[0];
        this.prevPositions[0][1] = a[1];
        this.prevPositions[0][2] = a[2];
        // Verlet integration for the rest.
        const g = $87cb75869f54e2f8$var$TAIL_GRAVITY * dt * dt;
        const damping = $87cb75869f54e2f8$var$TAIL_DAMPING;
        for(let i = 1; i < this.positions.length; i++){
            const p = this.positions[i];
            const prev = this.prevPositions[i];
            const vx = (p[0] - prev[0]) * damping;
            const vy = (p[1] - prev[1]) * damping;
            const vz = (p[2] - prev[2]) * damping;
            prev[0] = p[0];
            prev[1] = p[1];
            prev[2] = p[2];
            p[0] += vx;
            p[1] += vy;
            p[2] += vz - g;
        }
        // Segment-length constraints. Length scales with totalLength so an
        // eased-out tail visibly lengthens.
        const segLen = this.totalLength / (this.positions.length - 1) * (this.totalLength > this.restSegmentLength * (this.positions.length - 1) * 1.5 ? 1.5 : 1);
        for(let iter = 0; iter < $87cb75869f54e2f8$var$TAIL_ITERATIONS; iter++)for(let i = 0; i < this.positions.length - 1; i++){
            const a = this.positions[i];
            const b = this.positions[i + 1];
            const dx = b[0] - a[0];
            const dy = b[1] - a[1];
            const dz = b[2] - a[2];
            const d = Math.sqrt(dx * dx + dy * dy + dz * dz);
            if (d < 1e-6) continue;
            const diff = (d - segLen) / d;
            // Pin particle 0 (i=0). For i>0, distribute correction between the two.
            if (i === 0) {
                b[0] -= dx * diff;
                b[1] -= dy * diff;
                b[2] -= dz * diff;
            } else {
                const half = diff * 0.5;
                a[0] += dx * half;
                a[1] += dy * half;
                a[2] += dz * half;
                b[0] -= dx * half;
                b[1] -= dy * half;
                b[2] -= dz * half;
            }
        }
    }
}
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $aa1f0309d9dba6d2$export$af631764ddc44097)("tick")
], $87cb75869f54e2f8$export$aa6668811a9d4e3.prototype, "onTick", null);


// Scratch force vector reused by the tick loop to avoid per-tick allocation.
const $e9097ea37a6a213b$var$SCRATCH_FORCE = [
    0,
    0,
    0
];
class $e9097ea37a6a213b$export$4b1b918a1b0a0738 extends (0, $c59361981bac2575$export$4342ba5c6ad1f6f1) {
    constructor(nodeSpecs, config){
        super();
        if (nodeSpecs.length < 2) throw new Error("RopeNetwork requires at least 2 nodes.");
        this.nodes = nodeSpecs.map((s)=>(0, $d3af85fe11a3ab16$export$709128881a216da4)({
                body: s.body,
                localAnchor: s.localAnchor,
                kind: s.kind,
                mu: s.mu ?? 0
            }));
        // Seed section rest-lengths. Strategy: working-side sections start
        // near-taut (chord + ~5% slack) so they render as subtle arcs rather
        // than huge V-shapes. The last section absorbs all remaining rope as
        // the "tail coil" — the part of the rope that sits loose near the
        // final anchor point (cockpit for sheets, bow locker for anchor rodes).
        const chords = this.nodes.slice(0, -1).map((_, i)=>$e9097ea37a6a213b$var$chordBetween(this.nodes[i], this.nodes[i + 1]));
        const chordSum = chords.reduce((a, b)=>a + b, 0);
        this.totalRopeLength = Math.max(config.totalLength, chordSum);
        const workingSlack = 0.05;
        const sections = [];
        let assigned = 0;
        for(let i = 0; i < chords.length; i++){
            let length;
            if (i === chords.length - 1) // Last section soaks up all remaining material.
            length = Math.max(chords[i], this.totalRopeLength - assigned);
            else length = chords[i] * (1 + workingSlack);
            assigned += length;
            sections.push((0, $0bfa53e2a1bf70ca$export$b8ad1621112a78f4)(length));
        }
        this.sections = sections;
        this.solverConfig = {
            ...(0, $0bfa53e2a1bf70ca$export$4f64e66a39679892),
            ...config.solver
        };
        // Free-end tail: if the last node is kind "free", spawn a decorative
        // Verlet chain there.
        const lastNode = this.nodes[this.nodes.length - 1];
        if (lastNode.kind === "free") {
            this.tail = new (0, $87cb75869f54e2f8$export$aa6668811a9d4e3)(lastNode, {
                length: config.tailLength ?? 4,
                count: config.tailParticleCount ?? 7
            });
            this.addChild(this.tail);
        } else this.tail = null;
    }
    onTick({ dt: dt }) {
        (0, $5a1d1d3ab1ff9c51$export$e8e2fad003b4d4ce).start("rope.network.tick");
        // 1. Refresh every node's world position from its body.
        for (const node of this.nodes)(0, $d3af85fe11a3ab16$export$22142295318b730c)(node);
        // 2. Run the solver in place on sections.
        (0, $0bfa53e2a1bf70ca$export$f79bc20650bb7519)(this.nodes, this.sections, dt, this.solverConfig);
        // 3. Apply tension forces to each node's body.
        for(let i = 0; i < this.nodes.length; i++){
            const node = this.nodes[i];
            const body = node.body;
            if (body.motion !== "dynamic") continue;
            (0, $0bfa53e2a1bf70ca$export$93e1ae62717a452e)(this.nodes, this.sections, i, $e9097ea37a6a213b$var$SCRATCH_FORCE);
            if ($e9097ea37a6a213b$var$SCRATCH_FORCE[0] === 0 && $e9097ea37a6a213b$var$SCRATCH_FORCE[1] === 0 && $e9097ea37a6a213b$var$SCRATCH_FORCE[2] === 0) continue;
            body.applyForce3D($e9097ea37a6a213b$var$SCRATCH_FORCE[0], $e9097ea37a6a213b$var$SCRATCH_FORCE[1], $e9097ea37a6a213b$var$SCRATCH_FORCE[2], node.localAnchor[0], node.localAnchor[1], node.localAnchor[2]);
        }
        (0, $5a1d1d3ab1ff9c51$export$e8e2fad003b4d4ce).end("rope.network.tick");
    }
    // ─── Queries ─────────────────────────────────────────────────────
    getNodeCount() {
        return this.nodes.length;
    }
    getNode(i) {
        return this.nodes[i];
    }
    getSectionCount() {
        return this.sections.length;
    }
    getSection(i) {
        return this.sections[i];
    }
    /** Total rope length set at construction. Conserved by solver flow. */ getTotalLength() {
        return this.totalRopeLength;
    }
    /**
   * Cumulative material length from node 0 up to the given node.
   * Node 0 → 0; node k-1 → total rope length. Used for computing
   * working length and render material-v coordinates.
   */ getMaterialLengthAt(nodeIdx) {
        let sum = 0;
        for(let i = 0; i < nodeIdx && i < this.sections.length; i++)sum += this.sections[i].length;
        return sum;
    }
    /** Tension in a specific section (engine-force units). */ getSectionTension(sectionIdx) {
        return this.sections[sectionIdx].tension;
    }
    /**
   * Peak tension in the sections adjacent to the given (typically winch)
   * node. Used by the sound system to detect shock loads.
   */ getPeakTensionAt(nodeIdx) {
        let peak = 0;
        if (nodeIdx > 0) peak = Math.max(peak, this.sections[nodeIdx - 1].tension);
        if (nodeIdx < this.sections.length) peak = Math.max(peak, this.sections[nodeIdx].tension);
        return peak;
    }
    getTail() {
        return this.tail;
    }
    // ─── Winch / block control (invoked by RopeBlock adapter) ────────
    /**
   * Move length between the two sections adjacent to the given winch node
   * so that the sum of sections strictly before the node equals the target.
   * Used by `RopeBlock.setWorkingLength` for initial positioning.
   */ /**
   * Shift length between the winch's two adjacent sections so the section
   * immediately upstream of the winch gets the requested new length. The
   * rest of the working chain re-equilibrates naturally via capstan flow
   * over the next few ticks.
   */ setWorkingLengthAt(winchNodeIdx, targetWorkingLength) {
        const sL = this.sections[winchNodeIdx - 1];
        const sR = this.sections[winchNodeIdx];
        if (!sL || !sR) return;
        const leftPrefix = this.getMaterialLengthAt(winchNodeIdx - 1);
        const targetSL = targetWorkingLength - leftPrefix;
        const totalAdjacent = sL.length + sR.length;
        const clampedSL = Math.max(0, Math.min(totalAdjacent, targetSL));
        const delta = sL.length - clampedSL;
        sL.length = clampedSL;
        sR.length += delta;
    }
    setWinchRatchet(winchNodeIdx, sign) {
        const node = this.nodes[winchNodeIdx];
        if (node && node.kind === "winch") node.ratchetSign = sign;
    }
    setWinchFlowRate(winchNodeIdx, rate) {
        const node = this.nodes[winchNodeIdx];
        if (node && node.kind === "winch") node.flowRateIn = rate;
    }
    clearWinchFlowRate(winchNodeIdx) {
        const node = this.nodes[winchNodeIdx];
        if (node && node.kind === "winch") node.flowRateIn = 0;
    }
    // ─── Rendering (Phase 2 stub) ────────────────────────────────────
    /**
   * Naive straight-chord sampler: returns one point per node + tail particle.
   * Phase 3 replaces this with `RopeRender.computeRenderSamples` producing
   * catenary + oscillator + deck-clamp curves. Here to keep Sheet/Anchor's
   * public API alive during the migration.
   */ getPointsWithZ() {
        const points = [];
        const z = [];
        for (const node of this.nodes){
            points.push([
                node.worldPos[0],
                node.worldPos[1]
            ]);
            z.push(node.worldPos[2]);
        }
        if (this.tail) {
            const tailPos = this.tail.getPositions();
            // First tail particle is pinned to the last node; skip it to avoid dup.
            for(let i = 1; i < tailPos.length; i++){
                points.push([
                    tailPos[i][0],
                    tailPos[i][1]
                ]);
                z.push(tailPos[i][2]);
            }
        }
        return {
            points: points,
            z: z
        };
    }
}
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $aa1f0309d9dba6d2$export$af631764ddc44097)("tick")
], $e9097ea37a6a213b$export$4b1b918a1b0a0738.prototype, "onTick", null);
function $e9097ea37a6a213b$var$chordBetween(a, b) {
    const dx = b.worldPos[0] - a.worldPos[0];
    const dy = b.worldPos[1] - a.worldPos[1];
    const dz = b.worldPos[2] - a.worldPos[2];
    return Math.sqrt(dx * dx + dy * dy + dz * dz);
}


/**
 * Rope render sampler.
 *
 * Converts a capstan-network rope's abstract state (node positions + scalar
 * section lengths/tensions) into a per-section polyline suitable for
 * `tessellateRopeStrip`.
 *
 * Each section is decorated with a small Verlet/PBD particle chain that
 * lives between the section's two anchor points (or, for sections adjacent
 * to a winch/block drum, between the precomputed tangent points on the
 * drums). Gravity makes the chain droop, distance constraints keep its arc
 * length close to the section's current rest length, and a deck-height
 * constraint stops the chain from sinking through the hull. The chain is
 * strictly visual — no physics feedback into the rope network.
 */ 
/**
 * Visual-only particle chain for one rope section.
 *
 * Verlet integration plus a position-based distance constraint between
 * neighbouring particles, with the two endpoints pinned (zero inverse mass)
 * to whatever world positions the owning RopeRender feeds in each tick.
 * Gravity makes the chain droop; the constraint keeps total length close to
 * the section's current rest length.
 *
 * No coupling back into RopeNetwork — this is decoration. The capstan solver
 * remains the authority on per-section length and tension.
 */ const $967c3305cf939bc0$var$GRAVITY = 32.2;
/** Per-tick velocity retention (Verlet damping). 1 = none, 0 = total. */ const $967c3305cf939bc0$var$DAMPING = 0.94;
/** Default PBD constraint solve passes per tick. Higher = stiffer chain. */ const $967c3305cf939bc0$var$DEFAULT_ITERATIONS = 6;
class $967c3305cf939bc0$export$20cb9ad71b7685e {
    constructor(count, ax, ay, az, bx, by, bz, sectionLength, iterations = $967c3305cf939bc0$var$DEFAULT_ITERATIONS, gravityScale = 1){
        /** Scratch vector for reference-frame velocity sampling. */ this.refVelScratch = new Float64Array(3);
        if (count < 2) throw new Error("Particle chain needs >= 2 particles");
        this.count = count;
        this.iterations = iterations;
        this.gravityScale = gravityScale;
        this.pos = new Float64Array(count * 3);
        this.prev = new Float64Array(count * 3);
        this.invMass = new Float64Array(count);
        for(let i = 0; i < count; i++)this.invMass[i] = i === 0 || i === count - 1 ? 0 : 1;
        this.seed(ax, ay, az, bx, by, bz, sectionLength);
    }
    /**
   * Place particles along the chord with a parabolic sag matching the
   * section's current slack. Used at construction and on hard re-init.
   */ seed(ax, ay, az, bx, by, bz, sectionLength) {
        const dx = bx - ax;
        const dy = by - ay;
        const dz = bz - az;
        const chord = Math.sqrt(dx * dx + dy * dy + dz * dz);
        const slack = Math.max(0, sectionLength - chord);
        let sagMag = chord > 1e-6 ? Math.sqrt(3 * chord * slack / 8) : 0;
        if (sagMag > chord * 1.2) sagMag = chord * 1.2;
        for(let i = 0; i < this.count; i++){
            const t = i / (this.count - 1);
            const px = ax + dx * t;
            const py = ay + dy * t;
            const pz = az + dz * t - sagMag * 4 * t * (1 - t);
            const o = i * 3;
            this.pos[o] = px;
            this.pos[o + 1] = py;
            this.pos[o + 2] = pz;
            this.prev[o] = px;
            this.prev[o + 1] = py;
            this.prev[o + 2] = pz;
        }
    }
    /**
   * Pin the two endpoints to the supplied world positions. Resets prev to
   * pos for the endpoints so they don't accumulate spurious velocity from
   * being teleported with the rigid body each tick.
   */ setEndpoints(ax, ay, az, bx, by, bz) {
        this.pos[0] = ax;
        this.pos[1] = ay;
        this.pos[2] = az;
        this.prev[0] = ax;
        this.prev[1] = ay;
        this.prev[2] = az;
        const last = (this.count - 1) * 3;
        this.pos[last] = bx;
        this.pos[last + 1] = by;
        this.pos[last + 2] = bz;
        this.prev[last] = bx;
        this.prev[last + 1] = by;
        this.prev[last + 2] = bz;
    }
    /**
   * Verlet integrate, then run distance + floor constraint passes.
   *
   * @param sectionLength current rest length (ft) — chain target arc length.
   * @param dt timestep (s).
   * @param floorAt optional world (x,y,z) → min-z floor (e.g., deck surface).
   * @param refVelAt optional reference-frame velocity (e.g., hull velocity
   *   at the particle's world position). Damping pulls particle motion
   *   toward this velocity rather than toward zero world velocity, so a
   *   rope on a moving boat rides with the boat.
   */ update(sectionLength, dt, floorAt, refVelAt) {
        const N = this.count;
        const restSeg = sectionLength / (N - 1);
        const gdt2 = $967c3305cf939bc0$var$GRAVITY * dt * dt * this.gravityScale;
        const ref = this.refVelScratch;
        // Verlet step on interior particles only; endpoints are held by setEndpoints.
        for(let i = 1; i < N - 1; i++){
            const o = i * 3;
            const px = this.pos[o];
            const py = this.pos[o + 1];
            const pz = this.pos[o + 2];
            // Damp displacement toward the reference frame's displacement over
            // this tick. With refVel = 0 this reduces to the usual world-frame
            // damping (velocity * DAMPING).
            let refDx = 0;
            let refDy = 0;
            let refDz = 0;
            if (refVelAt) {
                refVelAt(px, py, pz, ref);
                refDx = ref[0] * dt;
                refDy = ref[1] * dt;
                refDz = ref[2] * dt;
            }
            const dx = (px - this.prev[o] - refDx) * $967c3305cf939bc0$var$DAMPING + refDx;
            const dy = (py - this.prev[o + 1] - refDy) * $967c3305cf939bc0$var$DAMPING + refDy;
            const dz = (pz - this.prev[o + 2] - refDz) * $967c3305cf939bc0$var$DAMPING + refDz;
            this.prev[o] = px;
            this.prev[o + 1] = py;
            this.prev[o + 2] = pz;
            this.pos[o] = px + dx;
            this.pos[o + 1] = py + dy;
            this.pos[o + 2] = pz + dz - gdt2;
        }
        for(let iter = 0; iter < this.iterations; iter++){
            // Distance constraints, Gauss-Seidel pass forward then backward so
            // the chain can equilibrate from both anchor ends in the same iteration.
            this.solveDistancesForward(restSeg);
            this.solveDistancesBackward(restSeg);
            if (floorAt) this.projectFloor(floorAt);
        }
    }
    solveDistancesForward(restSeg) {
        const N = this.count;
        for(let i = 0; i < N - 1; i++)this.solveDistanceConstraint(i, restSeg);
    }
    solveDistancesBackward(restSeg) {
        for(let i = this.count - 2; i >= 0; i--)this.solveDistanceConstraint(i, restSeg);
    }
    solveDistanceConstraint(i, restSeg) {
        const oA = i * 3;
        const oB = oA + 3;
        const wA = this.invMass[i];
        const wB = this.invMass[i + 1];
        const sumW = wA + wB;
        if (sumW <= 0) return;
        const dx = this.pos[oB] - this.pos[oA];
        const dy = this.pos[oB + 1] - this.pos[oA + 1];
        const dz = this.pos[oB + 2] - this.pos[oA + 2];
        const d2 = dx * dx + dy * dy + dz * dz;
        if (d2 < 1e-12) return;
        const d = Math.sqrt(d2);
        const corr = (d - restSeg) / (d * sumW);
        const cx = dx * corr;
        const cy = dy * corr;
        const cz = dz * corr;
        this.pos[oA] += cx * wA;
        this.pos[oA + 1] += cy * wA;
        this.pos[oA + 2] += cz * wA;
        this.pos[oB] -= cx * wB;
        this.pos[oB + 1] -= cy * wB;
        this.pos[oB + 2] -= cz * wB;
    }
    projectFloor(floorAt) {
        const N = this.count;
        for(let i = 1; i < N - 1; i++){
            const o = i * 3;
            const floor = floorAt(this.pos[o], this.pos[o + 1], this.pos[o + 2]);
            if (!isFinite(floor)) continue;
            if (this.pos[o + 2] < floor) {
                const dz = floor - this.pos[o + 2];
                this.pos[o + 2] = floor;
                // Lift prev z by the same amount so the next Verlet step sees no
                // residual downward velocity at the contact — rope settles instead
                // of bouncing.
                this.prev[o + 2] += dz;
            }
        }
    }
}


/** Number of particles per foot of section (clamped). Stable for a given network. */ const $0e6eaf95bade212c$var$PARTICLES_PER_FOOT = 4;
const $0e6eaf95bade212c$var$MIN_PARTICLES_PER_SECTION = 8;
const $0e6eaf95bade212c$var$MAX_PARTICLES_PER_SECTION = 48;
/** Small number treated as zero. */ const $0e6eaf95bade212c$var$EPS = 1e-6;
/**
 * Render-time Laplacian smoothing passes applied to each chain's particles
 * before they feed the renderer's Catmull-Rom spline. Catmull-Rom passes
 * exactly through its input, so small PBD position jitter would otherwise
 * show through as wiggles — pre-smoothing irons those out without disturbing
 * the PBD state (smoothing runs on a scratch copy). Endpoints are kept
 * fixed so the emitted polyline still meets each drum arc exactly.
 */ const $0e6eaf95bade212c$var$RENDER_SMOOTH_PASSES = 5;
const $0e6eaf95bade212c$var$RENDER_SMOOTH_LAMBDA = 0.5;
/** Softplus smoothing strength for the deck-floor clamp on emitted samples (ft). */ const $0e6eaf95bade212c$var$FLOOR_SOFTNESS = 0.02;
/** Distance (ft) outside the deck polygon over which the floor tapers to -∞. */ const $0e6eaf95bade212c$var$FLOOR_EDGE_TAPER = 0.5;
/**
 * Fixed wrap side for winches. The rope always tangents the drum on the
 * +perp side of the chord (looking down at the drum in its body frame),
 * which visually corresponds to a consistent clockwise spool. Flip to -1
 * if the wrap reads backwards for a given configuration.
 */ const $0e6eaf95bade212c$var$WINCH_WRAP_SIGN = 1;
class $0e6eaf95bade212c$export$e9cfe13cdaf9c3a7 {
    constructor(network, config = {}){
        /**
   * Per-chain scratch buffer holding a smoothed copy of chain.pos used only
   * for sample emission. Keeping this separate from chain.pos means the PBD
   * state stays authoritative and unsmoothed.
   */ this.smoothScratch = [];
        // Tangent-point caches reused across update + computeSamples each tick.
        // World-space leave/enter points per node — degenerate to node center
        // when the node has no drum radius.
        this.leaveWX = [];
        this.leaveWY = [];
        this.leaveWZ = [];
        this.enterWX = [];
        this.enterWY = [];
        this.enterWZ = [];
        // Body-local tangent coords, kept around so the drum arc step in
        // computeSamples can compute sweep angles in the drum's own frame.
        this.leaveLX = [];
        this.leaveLY = [];
        this.enterLX = [];
        this.enterLY = [];
        // Output buffers reused across frames.
        this.points = [];
        this.z = [];
        this.vCoords = [];
        this.network = network;
        this.config = config;
        this.floorFn = (x, y, z)=>this.ropeFloor(x, y, z);
        this.refVelFn = config.hullBody ? $0e6eaf95bade212c$var$buildHullVelocityFn(config.hullBody) : null;
        this.chains = [];
        this.refreshTangentPoints();
        for(let i = 0; i < network.getSectionCount(); i++)this.chains.push(this.createChainForSection(i));
    }
    /** Total render samples across all sections. Stable for a given network. */ getTotalSampleCount() {
        let total = 0;
        for(let i = 0; i < this.chains.length; i++)total += i === 0 ? this.chains[i].count : this.chains[i].count - 1;
        return total;
    }
    /**
   * Step every PBD chain forward one tick. Called each tick by the owning
   * Sheet/Anchor. Pure render-state update — no body forces applied.
   */ update(dt) {
        (0, $5a1d1d3ab1ff9c51$export$e8e2fad003b4d4ce).start("rope.render.update");
        const n = this.network.getSectionCount();
        while(this.chains.length < n)this.chains.push(this.createChainForSection(this.chains.length));
        this.refreshTangentPoints();
        for(let i = 0; i < n; i++){
            const chain = this.chains[i];
            const section = this.network.getSection(i);
            chain.setEndpoints(this.leaveWX[i], this.leaveWY[i], this.leaveWZ[i], this.enterWX[i + 1], this.enterWY[i + 1], this.enterWZ[i + 1]);
            chain.update(section.length, dt, this.floorFn, this.refVelFn);
        }
        (0, $5a1d1d3ab1ff9c51$export$e8e2fad003b4d4ce).end("rope.render.update");
    }
    /** Compute the rope polyline for this frame. Returns re-used buffers. */ computeSamples() {
        (0, $5a1d1d3ab1ff9c51$export$e8e2fad003b4d4ce).start("rope.render.samples");
        const result = this.computeSamplesInner();
        (0, $5a1d1d3ab1ff9c51$export$e8e2fad003b4d4ce).end("rope.render.samples");
        return result;
    }
    computeSamplesInner() {
        this.points.length = 0;
        this.z.length = 0;
        this.vCoords.length = 0;
        const network = this.network;
        const sectionCount = network.getSectionCount();
        if (sectionCount === 0) return {
            points: this.points,
            z: this.z,
            vPerPoint: this.vCoords
        };
        // Refresh tangent points so render geometry tracks any sub-tick body
        // movement. Chain endpoints are also pinned to the fresh values so the
        // emitted polyline meets each drum arc exactly.
        this.refreshTangentPoints();
        const nodeCount = network.getNodeCount();
        const winchR = this.config.winchRadius ?? 0;
        const blockR = this.config.blockRadius ?? 0;
        const radius = new Array(nodeCount);
        for(let i = 0; i < nodeCount; i++){
            const n = network.getNode(i);
            radius[i] = n.kind === "winch" ? winchR : n.kind === "block" ? blockR : 0;
        }
        let vStart = 0;
        let firstSample = true;
        for(let si = 0; si < sectionCount; si++){
            const section = network.getSection(si);
            const chain = this.chains[si];
            const L = section.length;
            // Copy chain positions into a smoothing scratch, snap endpoints to
            // current tangent points, and run a few Laplacian passes to remove
            // PBD-induced jitter before the renderer's Catmull-Rom subdivision
            // interpolates through these points.
            const ax = this.leaveWX[si];
            const ay = this.leaveWY[si];
            const az = this.leaveWZ[si];
            const bx = this.enterWX[si + 1];
            const by = this.enterWY[si + 1];
            const bz = this.enterWZ[si + 1];
            const smoothed = this.getSmoothScratch(si, chain.count);
            smoothed.set(chain.pos);
            smoothed[0] = ax;
            smoothed[1] = ay;
            smoothed[2] = az;
            const lastIdx = (chain.count - 1) * 3;
            smoothed[lastIdx] = bx;
            smoothed[lastIdx + 1] = by;
            smoothed[lastIdx + 2] = bz;
            $0e6eaf95bade212c$var$laplacianSmooth(smoothed, chain.count, $0e6eaf95bade212c$var$RENDER_SMOOTH_PASSES, $0e6eaf95bade212c$var$RENDER_SMOOTH_LAMBDA);
            // Emit particle positions. Skip the duplicate shared endpoint at si > 0
            // (already emitted by the previous section's drum arc, or its last
            // particle if no drum sat between them).
            const startI = firstSample ? 0 : 1;
            const N = chain.count;
            const segLen = L / (N - 1);
            let v = vStart + startI * segLen;
            for(let i = startI; i < N; i++){
                const o = i * 3;
                const px = smoothed[o];
                const py = smoothed[o + 1];
                const pz = this.clampToFloor(px, py, smoothed[o + 2]);
                this.points.push([
                    px,
                    py
                ]);
                this.z.push(pz);
                this.vCoords.push(v);
                v += segLen;
            }
            vStart += L;
            firstSample = false;
            // Wrap arc around drum at node si+1 (if interior drum). The arc is
            // generated in the drum body's local xy plane at the anchor z and
            // transformed to world, so it coincides exactly with the hull-local
            // cheek disks drawn in BoatRenderer regardless of heel.
            const drumIdx = si + 1;
            if (drumIdx < nodeCount - 1 && radius[drumIdx] > 0 && si + 1 < sectionCount) {
                const drumNode = network.getNode(drumIdx);
                const la = drumNode.localAnchor;
                const r = radius[drumIdx];
                const ain = Math.atan2(this.enterLY[drumIdx] - la[1], this.enterLX[drumIdx] - la[0]);
                const aout = Math.atan2(this.leaveLY[drumIdx] - la[1], this.leaveLX[drumIdx] - la[0]);
                let delta = aout - ain;
                while(delta > Math.PI)delta -= 2 * Math.PI;
                while(delta < -Math.PI)delta += 2 * Math.PI;
                const arcLen = Math.abs(delta) * r;
                const nArc = 8;
                for(let i = 1; i <= nArc; i++){
                    const t = i / nArc;
                    const a = ain + delta * t;
                    const lx = la[0] + r * Math.cos(a);
                    const ly = la[1] + r * Math.sin(a);
                    const w = drumNode.body.toWorldFrame3D(lx, ly, la[2]);
                    const pz = this.clampToFloor(w[0], w[1], w[2]);
                    this.points.push([
                        w[0],
                        w[1]
                    ]);
                    this.z.push(pz);
                    this.vCoords.push(vStart + t * arcLen);
                }
                vStart += arcLen;
            }
        }
        return {
            points: this.points,
            z: this.z,
            vPerPoint: this.vCoords
        };
    }
    // ─── Internals ───────────────────────────────────────────────────
    getSmoothScratch(idx, count) {
        const existing = this.smoothScratch[idx];
        if (existing && existing.length === count * 3) return existing;
        const buf = new Float64Array(count * 3);
        this.smoothScratch[idx] = buf;
        return buf;
    }
    createChainForSection(idx) {
        const section = this.network.getSection(idx);
        const count = this.config.particlesPerSection ?? $0e6eaf95bade212c$var$particleCountFor(section.length);
        const chain = new (0, $967c3305cf939bc0$export$20cb9ad71b7685e)(count, this.leaveWX[idx], this.leaveWY[idx], this.leaveWZ[idx], this.enterWX[idx + 1], this.enterWY[idx + 1], this.enterWZ[idx + 1], section.length);
        if (this.config.chainIterations !== undefined) chain.iterations = this.config.chainIterations;
        if (this.config.chainGravityScale !== undefined) chain.gravityScale = this.config.chainGravityScale;
        return chain;
    }
    /**
   * Recompute every node's leave/enter tangent points (world + body-local)
   * from the current node world positions and configured drum radii. Nodes
   * without a drum degenerate to the node's own world position.
   */ refreshTangentPoints() {
        const network = this.network;
        const nodeCount = network.getNodeCount();
        const sectionCount = network.getSectionCount();
        const winchR = this.config.winchRadius ?? 0;
        const blockR = this.config.blockRadius ?? 0;
        // Resize caches on demand.
        while(this.leaveWX.length < nodeCount){
            this.leaveWX.push(0);
            this.leaveWY.push(0);
            this.leaveWZ.push(0);
            this.enterWX.push(0);
            this.enterWY.push(0);
            this.enterWZ.push(0);
            this.leaveLX.push(0);
            this.leaveLY.push(0);
            this.enterLX.push(0);
            this.enterLY.push(0);
        }
        const nodeX = new Array(nodeCount);
        const nodeY = new Array(nodeCount);
        const nodeZ = new Array(nodeCount);
        const radius = new Array(nodeCount);
        for(let i = 0; i < nodeCount; i++){
            const n = network.getNode(i);
            nodeX[i] = n.worldPos[0];
            nodeY[i] = n.worldPos[1];
            nodeZ[i] = n.worldPos[2];
            radius[i] = n.kind === "winch" ? winchR : n.kind === "block" ? blockR : 0;
            // Default the tangent points to the node center.
            this.leaveWX[i] = nodeX[i];
            this.leaveWY[i] = nodeY[i];
            this.leaveWZ[i] = nodeZ[i];
            this.enterWX[i] = nodeX[i];
            this.enterWY[i] = nodeY[i];
            this.enterWZ[i] = nodeZ[i];
        }
        // Wrap sign per interior drum: which side of the chord the rope tangents.
        //   - Winches: fixed sign so the wrap stays visually consistent as the
        //     sail clew swings; otherwise tiny geometry shifts flip it.
        //   - Blocks: derived from incoming/outgoing chord cross product, so a
        //     free-running block wraps whichever way the rope actually bends.
        const wrapSign = new Array(nodeCount).fill(0);
        for(let i = 1; i < nodeCount - 1; i++){
            if (radius[i] <= 0) continue;
            const node = network.getNode(i);
            if (node.kind === "winch") {
                wrapSign[i] = $0e6eaf95bade212c$var$WINCH_WRAP_SIGN;
                continue;
            }
            const body = node.body;
            const la = body.toLocalFrame3D(nodeX[i - 1], nodeY[i - 1], nodeZ[i - 1]);
            const lb = body.toLocalFrame3D(nodeX[i], nodeY[i], nodeZ[i]);
            const lc = body.toLocalFrame3D(nodeX[i + 1], nodeY[i + 1], nodeZ[i + 1]);
            const dxIn = lb[0] - la[0];
            const dyIn = lb[1] - la[1];
            const dxOut = lc[0] - lb[0];
            const dyOut = lc[1] - lb[1];
            const cross = dxIn * dyOut - dyIn * dxOut;
            wrapSign[i] = cross > $0e6eaf95bade212c$var$EPS ? -1 : cross < -$0e6eaf95bade212c$var$EPS ? 1 : 0;
        }
        for(let si = 0; si < sectionCount; si++){
            const a = si;
            const b = si + 1;
            const rA = radius[a];
            const rB = radius[b];
            if (rA <= 0 && rB <= 0) continue;
            const nA = network.getNode(a);
            const nB = network.getNode(b);
            const laA = nA.localAnchor;
            const laB = nB.localAnchor;
            const sA = wrapSign[a];
            const sB = wrapSign[b];
            if (rA > 0 && rB > 0 && nA.body === nB.body) {
                // Two drums on the same body: proper circle-to-circle tangent in
                // the shared body's xy plane.
                const res = $0e6eaf95bade212c$var$computeCircleTangent(laA[0], laA[1], rA, sA, laB[0], laB[1], rB, sB);
                if (res) {
                    this.leaveLX[a] = res.tax;
                    this.leaveLY[a] = res.tay;
                    const wA = nA.body.toWorldFrame3D(res.tax, res.tay, laA[2]);
                    this.leaveWX[a] = wA[0];
                    this.leaveWY[a] = wA[1];
                    this.leaveWZ[a] = wA[2];
                    this.enterLX[b] = res.tbx;
                    this.enterLY[b] = res.tby;
                    const wB = nB.body.toWorldFrame3D(res.tbx, res.tby, laB[2]);
                    this.enterWX[b] = wB[0];
                    this.enterWY[b] = wB[1];
                    this.enterWZ[b] = wB[2];
                }
                continue;
            }
            // Per-drum point-to-circle tangent in each drum's body frame.
            // (Also the two-drum different-body fallback.) computePointTangent's
            // `u` points from the external point toward the drum; for the enter
            // tangent that matches rope travel, but for the leave tangent the
            // rope travels drum→next, so we negate the sign to keep both tangent
            // points on the same side of the rope path.
            if (rA > 0) {
                const pLocal = nA.body.toLocalFrame3D(nodeX[b], nodeY[b], nodeZ[b]);
                const tp = $0e6eaf95bade212c$var$computePointTangent(pLocal[0], pLocal[1], laA[0], laA[1], rA, -(sA !== 0 ? sA : 1));
                this.leaveLX[a] = tp.tx;
                this.leaveLY[a] = tp.ty;
                const w = nA.body.toWorldFrame3D(tp.tx, tp.ty, laA[2]);
                this.leaveWX[a] = w[0];
                this.leaveWY[a] = w[1];
                this.leaveWZ[a] = w[2];
            }
            if (rB > 0) {
                const pLocal = nB.body.toLocalFrame3D(nodeX[a], nodeY[a], nodeZ[a]);
                const tp = $0e6eaf95bade212c$var$computePointTangent(pLocal[0], pLocal[1], laB[0], laB[1], rB, sB !== 0 ? sB : 1);
                this.enterLX[b] = tp.tx;
                this.enterLY[b] = tp.ty;
                const w = nB.body.toWorldFrame3D(tp.tx, tp.ty, laB[2]);
                this.enterWX[b] = w[0];
                this.enterWY[b] = w[1];
                this.enterWZ[b] = w[2];
            }
        }
    }
    /** Clamp a world-space z-value up to the rope floor at (x, y, z). */ clampToFloor(x, y, z) {
        const floor = this.ropeFloor(x, y, z);
        if (!isFinite(floor)) return z;
        // Softplus: smoothly transitions between z and floor.
        return $0e6eaf95bade212c$var$softplusAbove(z, floor, $0e6eaf95bade212c$var$FLOOR_SOFTNESS);
    }
    /**
   * World-space z-value below which a rope sample at world (x, y, z) must
   * not dip. Returns -∞ where there is no floor.
   *
   * The hull body tilts in 3D (heel + pitch), so a yaw-only inverse to
   * hull-local (lx, ly) places the deck lookup at the wrong point and the
   * returned floor is too low — the rope visibly sinks into the deck. Use
   * the body's full 3D rotation matrix instead, matching the convention
   * `DeckContactConstraint` uses for the same query.
   */ ropeFloor(x, y, z) {
        const hb = this.config.hullBoundary;
        const gd = this.config.getDeckHeight;
        const hull = this.config.hullBody;
        if (!hb || !gd || !hull || hb.levels.length === 0) return -Infinity;
        const R = hull.orientation;
        const dx = x - hull.position[0];
        const dy = y - hull.position[1];
        const dz = z - hull.z;
        const lx = R[0] * dx + R[3] * dy + R[6] * dz;
        const ly = R[1] * dx + R[4] * dy + R[7] * dz;
        const ropeRadius = this.config.ropeRadius ?? 0.025;
        // Use the topmost level (the deck outline at z = deckHeight).
        const deckLevel = hb.levels[hb.levels.length - 1];
        if ($0e6eaf95bade212c$var$pointInBoundary(deckLevel.vx, deckLevel.vy, lx, ly)) {
            const localFloor = gd(lx, ly);
            if (localFloor == null) return -Infinity;
            return hull.worldZ(lx, ly, localFloor + ropeRadius);
        }
        // Outside the deck polygon but close — taper the floor down rapidly so
        // rope drapes over the gunwale without a hard cliff.
        const edge = $0e6eaf95bade212c$var$nearestBoundaryPoint(deckLevel.vx, deckLevel.vy, lx, ly);
        if (!edge || edge.distance >= $0e6eaf95bade212c$var$FLOOR_EDGE_TAPER) return -Infinity;
        const localFloor = gd(edge.x, edge.y);
        if (localFloor == null) return -Infinity;
        const edgeWorldZ = hull.worldZ(edge.x, edge.y, localFloor + ropeRadius);
        const fade = 1 - edge.distance / $0e6eaf95bade212c$var$FLOOR_EDGE_TAPER;
        return edgeWorldZ - (1 - fade) * 1000;
    }
}
/**
 * Build a closure that fills `out` with the hull body's world-frame velocity
 * at the given world point — linear + angular contribution (ω × r). Used as
 * the PBD damping reference frame so a rope on a moving/yawing/heeling boat
 * stays visually attached to the deck instead of lagging in world space.
 */ function $0e6eaf95bade212c$var$buildHullVelocityFn(hull) {
    return (x, y, z, out)=>{
        const w = hull.angularVelocity3;
        const rx = x - hull.position[0];
        const ry = y - hull.position[1];
        const rz = z - hull.z;
        // v = v_linear + ω × r
        out[0] = hull.velocity[0] + w[1] * rz - w[2] * ry;
        out[1] = hull.velocity[1] + w[2] * rx - w[0] * rz;
        out[2] = hull.zVelocity + w[0] * ry - w[1] * rx;
    };
}
/**
 * In-place Laplacian smoothing on a flat [x0,y0,z0,x1,y1,z1,…] buffer of
 * `count` particles. Endpoints (i=0 and i=count-1) are held fixed. Uses
 * Gauss-Seidel (single forward pass per iteration) since the shift bias
 * relative to Jacobi is imperceptible for visual rope smoothing.
 */ function $0e6eaf95bade212c$var$laplacianSmooth(buf, count, passes, lambda) {
    if (count < 3 || passes <= 0) return;
    const keep = 1 - lambda;
    const half = lambda * 0.5;
    for(let p = 0; p < passes; p++)for(let i = 1; i < count - 1; i++){
        const o = i * 3;
        buf[o] = keep * buf[o] + half * (buf[o - 3] + buf[o + 3]);
        buf[o + 1] = keep * buf[o + 1] + half * (buf[o - 2] + buf[o + 4]);
        buf[o + 2] = keep * buf[o + 2] + half * (buf[o - 1] + buf[o + 5]);
    }
}
function $0e6eaf95bade212c$var$particleCountFor(length) {
    return $0e6eaf95bade212c$var$clampInt(Math.round(length * $0e6eaf95bade212c$var$PARTICLES_PER_FOOT), $0e6eaf95bade212c$var$MIN_PARTICLES_PER_SECTION, $0e6eaf95bade212c$var$MAX_PARTICLES_PER_SECTION);
}
/**
 * Tangent point from external point (px, py) to circle centered at (cx, cy)
 * with radius r, on side `s` (+1 or -1). Returned in the same 2D frame as
 * the inputs.
 */ function $0e6eaf95bade212c$var$computePointTangent(px, py, cx, cy, r, s) {
    const dx = cx - px;
    const dy = cy - py;
    const d = Math.sqrt(dx * dx + dy * dy);
    if (d <= r) return {
        tx: cx,
        ty: cy
    };
    const ux = dx / d;
    const uy = dy / d;
    const perpX = -uy; // 90° CCW of u
    const perpY = ux;
    const cosB = r / d;
    const sinB = Math.sqrt(1 - cosB * cosB);
    return {
        tx: cx + r * (s * sinB * perpX - cosB * ux),
        ty: cy + r * (s * sinB * perpY - cosB * uy)
    };
}
/**
 * Tangent between two circles (A, rA, sA) and (B, rB, sB) where sA/sB are
 * each ±1 for the drum's wrap side. Chooses external vs internal tangent
 * from the signs. Returns null if the drums overlap.
 */ function $0e6eaf95bade212c$var$computeCircleTangent(ax, ay, rA, sA, bx, by, rB, sB) {
    const dx = bx - ax;
    const dy = by - ay;
    const c = Math.sqrt(dx * dx + dy * dy);
    if (c < $0e6eaf95bade212c$var$EPS) return null;
    const ux = dx / c;
    const uy = dy / c;
    const perpX = -uy;
    const perpY = ux;
    // Zero sign (shouldn't happen for a radius-bearing drum in normal
    // geometry) falls back to external with the other end's sign.
    const effA = sA !== 0 ? sA : sB !== 0 ? sB : 1;
    const effB = sB !== 0 ? sB : effA;
    const crossed = effA * effB < 0;
    const sinAlpha = (rA - (crossed ? -rB : rB)) / c;
    if (Math.abs(sinAlpha) >= 1) return null;
    const cosAlpha = Math.sqrt(1 - sinAlpha * sinAlpha);
    const nx = sinAlpha * ux + cosAlpha * perpX;
    const ny = sinAlpha * uy + cosAlpha * perpY;
    const signB = crossed ? -effA : effB;
    return {
        tax: ax + rA * effA * nx,
        tay: ay + rA * effA * ny,
        tbx: bx + rB * signB * nx,
        tby: by + rB * signB * ny
    };
}
/** softplus: max(a, b) smoothed with scale ε. */ function $0e6eaf95bade212c$var$softplusAbove(a, b, eps) {
    // b + ε * log(1 + exp((a - b) / ε)); avoids overflow for large a-b.
    const diff = (a - b) / eps;
    if (diff > 30) return a;
    if (diff < -30) return b;
    return b + eps * Math.log(1 + Math.exp(diff));
}
function $0e6eaf95bade212c$var$clampInt(n, lo, hi) {
    if (n < lo) return lo;
    if (n > hi) return hi;
    return n;
}
/** Standard ray-casting point-in-polygon on separate x/y arrays. */ function $0e6eaf95bade212c$var$pointInBoundary(vx, vy, x, y) {
    let inside = false;
    const n = vx.length;
    for(let i = 0, j = n - 1; i < n; j = i++){
        const xi = vx[i];
        const yi = vy[i];
        const xj = vx[j];
        const yj = vy[j];
        const intersect = yi > y !== yj > y && x < (xj - xi) * (y - yi) / (yj - yi + $0e6eaf95bade212c$var$EPS) + xi;
        if (intersect) inside = !inside;
    }
    return inside;
}
/** Nearest point on any polygon edge (separate x/y arrays). */ function $0e6eaf95bade212c$var$nearestBoundaryPoint(vx, vy, x, y) {
    const n = vx.length;
    if (n < 2) return null;
    let bestX = 0;
    let bestY = 0;
    let bestD = Infinity;
    for(let i = 0, j = n - 1; i < n; j = i++){
        const ax = vx[j];
        const ay = vy[j];
        const bx = vx[i];
        const by = vy[i];
        const dx = bx - ax;
        const dy = by - ay;
        const len2 = dx * dx + dy * dy;
        if (len2 < $0e6eaf95bade212c$var$EPS) continue;
        let t = ((x - ax) * dx + (y - ay) * dy) / len2;
        if (t < 0) t = 0;
        else if (t > 1) t = 1;
        const cx = ax + dx * t;
        const cy = ay + dy * t;
        const ex = x - cx;
        const ey = y - cy;
        const d = Math.sqrt(ex * ex + ey * ey);
        if (d < bestD) {
            bestD = d;
            bestX = cx;
            bestY = cy;
        }
    }
    return isFinite(bestD) ? {
        x: bestX,
        y: bestY,
        distance: bestD
    } : null;
}


class $85dad0c9138bbb78$export$dae18d6265d3c893 extends (0, $c59361981bac2575$export$4342ba5c6ad1f6f1) {
    constructor(hullBody, cleatAnchor, sheaveAnchor, headAnchor, config = {}, getDeckHeight, hullBoundary, headTracker){
        super(), this.layer = "boat", this.opacity = 1.0;
        this.ropeThickness = config.ropeThickness ?? 0.15;
        this.ropeColor = config.ropeColor ?? 0xeeeeee;
        this.ropePattern = config.ropePattern;
        const ropeDiameter = config.ropeDiameter ?? this.ropeThickness;
        const sheaveRadius = config.sheaveRadius ?? 0.12;
        this.slackRatio = config.slackRatio ?? -0.01;
        this.headTracker = headTracker ?? null;
        const nodeSpecs = [
            {
                body: hullBody,
                localAnchor: cleatAnchor,
                kind: "endpoint"
            },
            {
                body: hullBody,
                localAnchor: sheaveAnchor,
                kind: "block"
            },
            {
                body: hullBody,
                localAnchor: headAnchor,
                kind: "endpoint"
            }
        ];
        const ascentChord = $85dad0c9138bbb78$var$chord(cleatAnchor, sheaveAnchor);
        // Size the rope for the maximum possible descending chord so that
        // furling the sail (which drops the head down the mast) doesn't
        // stretch the rope taut.
        const worstHeadZ = headTracker ? headTracker.minHeadZ : headAnchor[2];
        const worstHead = new (0, $3480ec8c2fb5ff20$export$d2de7ccaa2f4bf9f)(headAnchor[0], headAnchor[1], worstHeadZ);
        const maxDescentChord = $85dad0c9138bbb78$var$chord(sheaveAnchor, worstHead);
        this.maxDescentLength = maxDescentChord * (1 + this.slackRatio);
        const totalRopeLength = (ascentChord + maxDescentChord) * (1 + this.slackRatio);
        this.rope = this.addChild(new (0, $e9097ea37a6a213b$export$4b1b918a1b0a0738)(nodeSpecs, {
            totalLength: totalRopeLength
        }));
        // Override the RopeNetwork constructor's hardcoded 5% working-slack
        // seed — halyards read as taut lines, not catenaries. The ascending
        // chord is fixed (both anchors on the hull), so this value is set
        // once here; the descending section is re-set every tick as the head
        // moves with the hoist.
        this.rope.getSection(0).length = ascentChord * (1 + this.slackRatio);
        const initialDescent = $85dad0c9138bbb78$var$chord(sheaveAnchor, headAnchor);
        this.rope.getSection(1).length = initialDescent * (1 + this.slackRatio);
        this.render = new (0, $0e6eaf95bade212c$export$e9cfe13cdaf9c3a7)(this.rope, {
            hullBody: hullBody,
            getDeckHeight: getDeckHeight,
            hullBoundary: hullBoundary,
            ropeRadius: ropeDiameter / 2,
            blockRadius: sheaveRadius,
            // Few particles per section — a halyard should read as a taut
            // straight line, and PBD convergence is dramatically better with
            // short chains (rate ≈ 1 − 2π²/N² per iteration). 4 particles is
            // enough for Catmull-Rom subdivision to produce a smooth curve
            // around the sheave wrap, while keeping residual sag invisible.
            particlesPerSection: 6
        });
    }
    onTick({ dt: dt }) {
        if (this.headTracker) this.syncHeadAnchor();
        this.render.update(dt);
    }
    /**
   * Mutate the head node's anchor z and the descending section's rest
   * length so the halyard tracks the sail head as it rises or falls with
   * the hoist. Without this, the descending section's length is fixed at
   * construction and the rope either slacks into a loop or gets visibly
   * stretched when the head moves.
   */ syncHeadAnchor() {
        if (!this.headTracker) return;
        const headNode = this.rope.getNode(2);
        const sheaveNode = this.rope.getNode(1);
        headNode.localAnchor[2] = this.headTracker.getHeadZ();
        const dx = sheaveNode.localAnchor[0] - headNode.localAnchor[0];
        const dy = sheaveNode.localAnchor[1] - headNode.localAnchor[1];
        const dz = sheaveNode.localAnchor[2] - headNode.localAnchor[2];
        const descentChord = Math.sqrt(dx * dx + dy * dy + dz * dz);
        this.rope.getSection(1).length = descentChord * (1 + this.slackRatio);
    }
    setOpacity(opacity) {
        this.opacity = (0, $2172aedd5a25ff17$export$7d15b64cf5a3a4c4)(opacity, 0, 1);
    }
    getOpacity() {
        return this.opacity;
    }
    getRopePointsWithZ() {
        const samples = this.render.computeSamples();
        // Shift every v-coord so the sail end stays at a constant material
        // position. The rope shader's pattern is periodic in v, so a uniform
        // shift makes the pattern scroll along the rope axis — exactly the
        // look of material flowing through the sheave as the sail is hoisted
        // or furled. Ascending length is fixed; only the descending section
        // shortens, so the offset is driven entirely by section 1.
        const currentDescent = this.rope.getSection(1).length;
        const vOffset = this.maxDescentLength - currentDescent;
        if (vOffset !== 0) {
            const vs = samples.vPerPoint;
            for(let i = 0; i < vs.length; i++)vs[i] += vOffset;
        }
        return samples;
    }
    getRopeRenderSampleCount() {
        return this.render.getTotalSampleCount();
    }
    getRopeThickness() {
        return this.ropeThickness;
    }
    getRopePattern() {
        return this.ropePattern ?? {
            type: "laid",
            carriers: [
                this.ropeColor
            ]
        };
    }
}
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $aa1f0309d9dba6d2$export$af631764ddc44097)("tick")
], $85dad0c9138bbb78$export$dae18d6265d3c893.prototype, "onTick", null);
function $85dad0c9138bbb78$var$chord(a, b) {
    const dx = a[0] - b[0];
    const dy = a[1] - b[1];
    const dz = a[2] - b[2];
    return Math.sqrt(dx * dx + dy * dy + dz * dz);
}








class $f42edb861d6f7614$export$242825d9f7aec7dd extends (0, $db841a8c0b719e01$export$5056eba3315bf3f4) {
    constructor(bodyA, bodyB, dirA, hingeB){
        super(bodyA, bodyB, -Number.MAX_VALUE, Number.MAX_VALUE);
        this.dirA = dirA;
        this.hingeB = hingeB;
    }
    /**
   * Recompute the world-frame axis vectors and write `u × u'` into the
   * angular shape fields `(cx, cy, cz)`. Called each step by the owning
   * constraint's `update()`.
   */ refreshJacobian() {
        const RA = this.bodyA.orientation;
        const RB = this.bodyB.orientation;
        const dA = this.dirA;
        const hB = this.hingeB;
        // u = RA · dirA  (bodyA reference direction in world frame)
        const ux = RA[0] * dA[0] + RA[1] * dA[1] + RA[2] * dA[2];
        const uy = RA[3] * dA[0] + RA[4] * dA[1] + RA[5] * dA[2];
        const uz = RA[6] * dA[0] + RA[7] * dA[1] + RA[8] * dA[2];
        // u' = RB · hingeB  (bodyB hinge axis in world frame)
        const vx = RB[0] * hB[0] + RB[1] * hB[1] + RB[2] * hB[2];
        const vy = RB[3] * hB[0] + RB[4] * hB[1] + RB[5] * hB[2];
        const vz = RB[6] * hB[0] + RB[7] * hB[1] + RB[8] * hB[2];
        // c = u × u'
        this.cx = uy * vz - uz * vy;
        this.cy = uz * vx - ux * vz;
        this.cz = ux * vy - uy * vx;
        // Position error: u · u' (zero at rest, non-zero when the axes tilt).
        this.offset = ux * vx + uy * vy + uz * vz;
    }
    /**
   * The owning constraint should call `refreshJacobian()` each update
   * instead of relying on the default computeGq, but this is kept as a
   * fallback for compatibility with code paths that call it directly.
   */ computeGq() {
        const RA = this.bodyA.orientation;
        const RB = this.bodyB.orientation;
        const dA = this.dirA;
        const hB = this.hingeB;
        const ux = RA[0] * dA[0] + RA[1] * dA[1] + RA[2] * dA[2];
        const uy = RA[3] * dA[0] + RA[4] * dA[1] + RA[5] * dA[2];
        const uz = RA[6] * dA[0] + RA[7] * dA[1] + RA[8] * dA[2];
        const vx = RB[0] * hB[0] + RB[1] * hB[1] + RB[2] * hB[2];
        const vy = RB[3] * hB[0] + RB[4] * hB[1] + RB[5] * hB[2];
        const vz = RB[6] * hB[0] + RB[7] * hB[1] + RB[8] * hB[2];
        return ux * vx + uy * vy + uz * vz;
    }
}




class $0586da9d77e4ba3d$export$e0d4115b1d7cf6fc extends (0, $63235e744c2c6cbe$export$aec1359a0a40a615) {
    constructor(bodyA, bodyB, options = {}){
        super(bodyA, bodyB, options), /** Lower/upper angle limits (radians). Enabled via `setLimits`. */ this.lowerLimitEnabled = false, this.upperLimitEnabled = false, this.lowerLimit = 0, this.upperLimit = 0, this.lowerLimitActive = false, this.upperLimitActive = false, /** Current hinge-axis rotation angle of bodyB relative to bodyA (radians). */ this.angle = 0;
        const maxForce = options.maxForce ?? Number.MAX_VALUE;
        this.maxForce = maxForce;
        this.pivotA = options.localPivotA ? (0, $3480ec8c2fb5ff20$export$d2aa6c54a5925f01)(options.localPivotA) : new (0, $3480ec8c2fb5ff20$export$d2de7ccaa2f4bf9f)(0, 0, 0);
        this.pivotB = options.localPivotB ? (0, $3480ec8c2fb5ff20$export$d2aa6c54a5925f01)(options.localPivotB) : new (0, $3480ec8c2fb5ff20$export$d2de7ccaa2f4bf9f)(0, 0, 0);
        this.hingeAxisA = options.hingeAxisA ? (0, $3480ec8c2fb5ff20$export$d2aa6c54a5925f01)(options.hingeAxisA) : new (0, $3480ec8c2fb5ff20$export$d2de7ccaa2f4bf9f)(0, 0, 1);
        this.hingeAxisB = options.hingeAxisB ? (0, $3480ec8c2fb5ff20$export$d2aa6c54a5925f01)(options.hingeAxisB) : new (0, $3480ec8c2fb5ff20$export$d2de7ccaa2f4bf9f)(0, 0, 1);
        // Pick two directions on bodyA perpendicular to hingeAxisA to form
        // the axis-alignment constraints. For the common case hingeAxisA =
        // [0,0,1], these become the body's local x and y axes.
        [this.dirA1, this.dirA2] = $0586da9d77e4ba3d$var$perpendicularBasis(this.hingeAxisA);
        // Create position equations. Jacobians are filled in update().
        this.xEq = new (0, $0113af86cc04b089$export$9e6be560da9da590)(bodyA, bodyB, -maxForce, maxForce);
        this.yEq = new (0, $0113af86cc04b089$export$9e6be560da9da590)(bodyA, bodyB, -maxForce, maxForce);
        this.zEq = new (0, $0113af86cc04b089$export$9e6be560da9da590)(bodyA, bodyB, -maxForce, maxForce);
        const that = this;
        this.xEq.computeGq = function() {
            return that.computePositionGq(0);
        };
        this.yEq.computeGq = function() {
            return that.computePositionGq(1);
        };
        this.zEq.computeGq = function() {
            return that.computePositionGq(2);
        };
        // Create axis-alignment equations.
        this.axis1Eq = new (0, $f42edb861d6f7614$export$242825d9f7aec7dd)(bodyA, bodyB, this.dirA1, this.hingeAxisB);
        this.axis2Eq = new (0, $f42edb861d6f7614$export$242825d9f7aec7dd)(bodyA, bodyB, this.dirA2, this.hingeAxisB);
        // Create limit equations (added/removed from equations array dynamically).
        // Jacobian convention: positive lambda increases the hinge angle, so:
        //   - Lower limit (angle too low): need positive lambda ⇒ Gq must be
        //     negative when violated ⇒ Gq = angle - lower, force bounds [0, max].
        //   - Upper limit (angle too high): need negative lambda ⇒ Gq must be
        //     positive when violated ⇒ Gq = angle - upper, force bounds [-max, 0].
        this.lowerLimitEq = new (0, $0113af86cc04b089$export$9e6be560da9da590)(bodyA, bodyB, 0, maxForce);
        this.upperLimitEq = new (0, $0113af86cc04b089$export$9e6be560da9da590)(bodyA, bodyB, -maxForce, 0);
        this.lowerLimitEq.computeGq = function() {
            return that.angle - that.lowerLimit;
        };
        this.upperLimitEq.computeGq = function() {
            return that.angle - that.upperLimit;
        };
        this.equations = [
            this.xEq,
            this.yEq,
            this.zEq,
            this.axis1Eq,
            this.axis2Eq
        ];
    }
    /** Compute XY/Z pivot separation for the given component (0=x, 1=y, 2=z). */ computePositionGq(component) {
        const RA = this.bodyA.orientation;
        const RB = this.bodyB.orientation;
        const pA = this.pivotA;
        const pB = this.pivotB;
        // 3D world-frame pivot offsets (lever arms from body center to pivot).
        const row = component * 3;
        const rAc = RA[row] * pA[0] + RA[row + 1] * pA[1] + RA[row + 2] * pA[2];
        const rBc = RB[row] * pB[0] + RB[row + 1] * pB[1] + RB[row + 2] * pB[2];
        const posA = component === 0 ? this.bodyA.position[0] : component === 1 ? this.bodyA.position[1] : this.bodyA.z;
        const posB = component === 0 ? this.bodyB.position[0] : component === 1 ? this.bodyB.position[1] : this.bodyB.z;
        return posB + rBc - posA - rAc;
    }
    /** Set (or clear) the hinge angle limits. Pass `undefined` to disable. */ setLimits(lower, upper) {
        if (typeof lower === "number") {
            this.lowerLimit = lower;
            this.lowerLimitEnabled = true;
        } else this.lowerLimitEnabled = false;
        if (typeof upper === "number") {
            this.upperLimit = upper;
            this.upperLimitEnabled = true;
        } else this.upperLimitEnabled = false;
    }
    /**
   * True relative rotation of bodyB around bodyA's hinge axis, in radians.
   * Uses axis projection rather than the (lossy) atan2(R[3], R[0]) extraction.
   */ getRelativeAngle() {
        return this.angle;
    }
    update() {
        const bodyA = this.bodyA;
        const bodyB = this.bodyB;
        const RA = bodyA.orientation;
        const RB = bodyB.orientation;
        const pA = this.pivotA;
        const pB = this.pivotB;
        // 3D world-frame lever arms from each body's center to the pivot.
        const rAx = RA[0] * pA[0] + RA[1] * pA[1] + RA[2] * pA[2];
        const rAy = RA[3] * pA[0] + RA[4] * pA[1] + RA[5] * pA[2];
        const rAz = RA[6] * pA[0] + RA[7] * pA[1] + RA[8] * pA[2];
        const rBx = RB[0] * pB[0] + RB[1] * pB[1] + RB[2] * pB[2];
        const rBy = RB[3] * pB[0] + RB[4] * pB[1] + RB[5] * pB[2];
        const rBz = RB[6] * pB[0] + RB[7] * pB[1] + RB[8] * pB[2];
        // X-position equation:
        //   constraint: (pB + rB) · x̂ − (pA + rA) · x̂ = 0
        //   d/dvA · x̂ = −1;   d/dvB · x̂ = 1
        //   d/dωA · (−rA × x̂) = −(0, rAz, -rAy) = (0, -rAz, rAy)
        //   d/dωB · (rB × x̂)  = (0, rBz, -rBy)
        const Gx = this.xEq.G;
        Gx[0] = -1;
        Gx[1] = 0;
        Gx[2] = 0;
        Gx[3] = 0;
        Gx[4] = -rAz;
        Gx[5] = rAy;
        Gx[6] = 1;
        Gx[7] = 0;
        Gx[8] = 0;
        Gx[9] = 0;
        Gx[10] = rBz;
        Gx[11] = -rBy;
        // Y-position equation
        const Gy = this.yEq.G;
        Gy[0] = 0;
        Gy[1] = -1;
        Gy[2] = 0;
        Gy[3] = rAz;
        Gy[4] = 0;
        Gy[5] = -rAx;
        Gy[6] = 0;
        Gy[7] = 1;
        Gy[8] = 0;
        Gy[9] = -rBz;
        Gy[10] = 0;
        Gy[11] = rBx;
        // Z-position equation
        //   d/dωA · (−rA × ẑ) = −(rAy, −rAx, 0) = (−rAy, rAx, 0)
        //   d/dωB · (rB × ẑ)  = (rBy, −rBx, 0)
        const Gz = this.zEq.G;
        Gz[0] = 0;
        Gz[1] = 0;
        Gz[2] = -1;
        Gz[3] = -rAy;
        Gz[4] = rAx;
        Gz[5] = 0;
        Gz[6] = 0;
        Gz[7] = 0;
        Gz[8] = 1;
        Gz[9] = rBy;
        Gz[10] = -rBx;
        Gz[11] = 0;
        // Refresh axis-alignment Jacobians.
        this.axis1Eq.refreshJacobian();
        this.axis2Eq.refreshJacobian();
        // Update relative hinge angle via axis projection.
        // Project bodyB's dirA1-equivalent direction onto bodyA's {dirA1, dirA2}.
        // For the hinge = z-axis case with dirA1 = [1,0,0], dirA2 = [0,1,0]:
        //   forward-dot: RB[col0] · RA[col0]
        //   lateral-dot: RB[col0] · RA[col1]
        // Generalized: pick the "reference" direction on bodyB — use dirA1 rotated
        // into bodyB's local frame. But since the hinge axes are aligned, we can
        // use bodyB's own dirA1-equivalent: any direction perpendicular to its
        // hinge axis. Simplest: use the world-frame projection of bodyB's dir
        // onto bodyA's perpendicular basis.
        const d1 = this.dirA1;
        const d2 = this.dirA2;
        // bodyB's reference direction in world: RB · dirA1 (treating dirA1
        // in bodyB's local frame works because both bodies share the same
        // body-local axis layout for the hinge's perpendicular basis).
        const bf0 = RB[0] * d1[0] + RB[1] * d1[1] + RB[2] * d1[2];
        const bf1 = RB[3] * d1[0] + RB[4] * d1[1] + RB[5] * d1[2];
        const bf2 = RB[6] * d1[0] + RB[7] * d1[1] + RB[8] * d1[2];
        // bodyA's perpendicular basis in world
        const a1x = RA[0] * d1[0] + RA[1] * d1[1] + RA[2] * d1[2];
        const a1y = RA[3] * d1[0] + RA[4] * d1[1] + RA[5] * d1[2];
        const a1z = RA[6] * d1[0] + RA[7] * d1[1] + RA[8] * d1[2];
        const a2x = RA[0] * d2[0] + RA[1] * d2[1] + RA[2] * d2[2];
        const a2y = RA[3] * d2[0] + RA[4] * d2[1] + RA[5] * d2[2];
        const a2z = RA[6] * d2[0] + RA[7] * d2[1] + RA[8] * d2[2];
        const fwdDot = bf0 * a1x + bf1 * a1y + bf2 * a1z;
        const latDot = bf0 * a2x + bf1 * a2y + bf2 * a2z;
        this.angle = Math.atan2(latDot, fwdDot);
        // Hinge-axis rotation limits: add/remove limit equations based on angle.
        const eqs = this.equations;
        const hingeAxisWorldX = a1y * a2z - a1z * a2y;
        const hingeAxisWorldY = a1z * a2x - a1x * a2z;
        const hingeAxisWorldZ = a1x * a2y - a1y * a2x;
        this.updateLimitEquation(this.lowerLimitEq, this.lowerLimitEnabled && this.angle < this.lowerLimit, hingeAxisWorldX, hingeAxisWorldY, hingeAxisWorldZ, eqs, true);
        this.updateLimitEquation(this.upperLimitEq, this.upperLimitEnabled && this.angle > this.upperLimit, hingeAxisWorldX, hingeAxisWorldY, hingeAxisWorldZ, eqs, false);
        return this;
    }
    updateLimitEquation(eq, shouldBeActive, axisX, axisY, axisZ, eqs, isLower) {
        const currentlyActive = isLower ? this.lowerLimitActive : this.upperLimitActive;
        if (shouldBeActive) {
            // Velocity-level constraint: relative angular velocity around hinge axis.
            //   G[wA] · ωA = -(ωA · hinge)
            //   G[wB] · ωB =  (ωB · hinge)
            const G = eq.G;
            G[0] = 0;
            G[1] = 0;
            G[2] = 0;
            G[3] = -axisX;
            G[4] = -axisY;
            G[5] = -axisZ;
            G[6] = 0;
            G[7] = 0;
            G[8] = 0;
            G[9] = axisX;
            G[10] = axisY;
            G[11] = axisZ;
            if (!currentlyActive) {
                eqs.push(eq);
                if (isLower) this.lowerLimitActive = true;
                else this.upperLimitActive = true;
            }
        } else if (currentlyActive) {
            const idx = eqs.indexOf(eq);
            if (idx >= 0) eqs.splice(idx, 1);
            if (isLower) this.lowerLimitActive = false;
            else this.upperLimitActive = false;
        }
    }
}
/**
 * Pick two orthonormal vectors perpendicular to `axis` (assumed unit length).
 */ function $0586da9d77e4ba3d$var$perpendicularBasis(axis) {
    // Find any vector not parallel to axis, then cross-product to build basis.
    const ax = Math.abs(axis[0]);
    const ay = Math.abs(axis[1]);
    const az = Math.abs(axis[2]);
    let ux, uy, uz;
    if (ax <= ay && ax <= az) {
        ux = 1;
        uy = 0;
        uz = 0;
    } else if (ay <= az) {
        ux = 0;
        uy = 1;
        uz = 0;
    } else {
        ux = 0;
        uy = 0;
        uz = 1;
    }
    // e1 = normalize(u × axis)
    let e1x = uy * axis[2] - uz * axis[1];
    let e1y = uz * axis[0] - ux * axis[2];
    let e1z = ux * axis[1] - uy * axis[0];
    const e1len = Math.hypot(e1x, e1y, e1z);
    e1x /= e1len;
    e1y /= e1len;
    e1z /= e1len;
    // e2 = axis × e1
    const e2x = axis[1] * e1z - axis[2] * e1y;
    const e2y = axis[2] * e1x - axis[0] * e1z;
    const e2z = axis[0] * e1y - axis[1] * e1x;
    return [
        new (0, $3480ec8c2fb5ff20$export$d2de7ccaa2f4bf9f)(e1x, e1y, e1z),
        new (0, $3480ec8c2fb5ff20$export$d2de7ccaa2f4bf9f)(e2x, e2y, e2z)
    ];
}








/**
 * 3D point-lock constraint between a particle-like body and a rigid body
 * with a local anchor. Holds the particle coincident with the anchor in all
 * three world-space position axes, so both radial and tangential motion are
 * resisted (unlike {@link DistanceConstraint3D}, which only
 * constrains radial separation).
 *
 * Owns three {@link PointToRigidEquation3D}s with fixed world-axis normals
 * (1,0,0), (0,1,0), (0,0,1). Each axis equation tracks its own per-axis
 * position error and the corresponding `rj × n` lever-arm term on the rigid.
 *
 * The particle must be `bodyA` per `PointToRigidEquation3D`'s convention.
 */ 


const $30a388d2d8931336$var$SCRATCH_ANCHOR_B = new (0, $3480ec8c2fb5ff20$export$d2de7ccaa2f4bf9f)(0, 0, 0);
class $30a388d2d8931336$export$53bb26c88568ac39 extends (0, $63235e744c2c6cbe$export$aec1359a0a40a615) {
    constructor(particle, rigid, options = {}){
        super(particle, rigid, options), /** When true, update() disables the equations and short-circuits. */ this.disabled = false;
        this.localAnchorB = options.localAnchorB ? (0, $3480ec8c2fb5ff20$export$d2aa6c54a5925f01)(options.localAnchorB) : new (0, $3480ec8c2fb5ff20$export$d2de7ccaa2f4bf9f)(0, 0, 0);
        this.maxForce = options.maxForce ?? Number.MAX_VALUE;
        this.equationX = new (0, $7c2ab345e8402709$export$72aece4f82bc5bee)(particle, rigid, -this.maxForce, this.maxForce);
        this.equationY = new (0, $7c2ab345e8402709$export$72aece4f82bc5bee)(particle, rigid, -this.maxForce, this.maxForce);
        this.equationZ = new (0, $7c2ab345e8402709$export$72aece4f82bc5bee)(particle, rigid, -this.maxForce, this.maxForce);
        // Fixed world-axis normals — never change during update().
        this.equationX.nx = 1;
        this.equationY.ny = 1;
        this.equationZ.nz = 1;
        this.equations = [
            this.equationX,
            this.equationY,
            this.equationZ
        ];
    }
    update() {
        const eqX = this.equationX;
        const eqY = this.equationY;
        const eqZ = this.equationZ;
        if (this.disabled) {
            eqX.enabled = false;
            eqY.enabled = false;
            eqZ.enabled = false;
            return this;
        }
        const particle = this.bodyA;
        const rigid = this.bodyB;
        const worldB = rigid.toWorldFrame3D(this.localAnchorB, $30a388d2d8931336$var$SCRATCH_ANCHOR_B);
        const bx = worldB[0];
        const by = worldB[1];
        const bz = worldB[2];
        // Lever arm from rigid CoM to anchor.
        const rjX = bx - rigid.position[0];
        const rjY = by - rigid.position[1];
        const rjZ = bz - rigid.z;
        // Per-axis signed gap, sign matched to the distance-constraint convention
        // (n points from particle toward anchor, offset positive when anchor is
        // on the +axis side of the particle).
        eqX.enabled = true;
        eqX.offset = bx - particle.position[0];
        // n = (1,0,0) → rj × n = (0, rjZ, -rjY)
        eqX.rjXnX = 0;
        eqX.rjXnY = rjZ;
        eqX.rjXnZ = -rjY;
        eqY.enabled = true;
        eqY.offset = by - particle.position[1];
        // n = (0,1,0) → rj × n = (-rjZ, 0, rjX)
        eqY.rjXnX = -rjZ;
        eqY.rjXnY = 0;
        eqY.rjXnZ = rjX;
        eqZ.enabled = true;
        eqZ.offset = bz - particle.z;
        // n = (0,0,1) → rj × n = (rjY, -rjX, 0)
        eqZ.rjXnX = rjY;
        eqZ.rjXnY = -rjX;
        eqZ.rjXnZ = 0;
        return this;
    }
    setMaxForce(maxForce) {
        this.maxForce = maxForce;
        this.equationX.minForce = -maxForce;
        this.equationX.maxForce = maxForce;
        this.equationY.minForce = -maxForce;
        this.equationY.maxForce = maxForce;
        this.equationZ.minForce = -maxForce;
        this.equationZ.maxForce = maxForce;
    }
}







/**
 * Renders a cloth sail mesh with cel-shaded lighting via a custom GPU pipeline.
 *
 * Computes per-vertex normals (averaged face normals) on the CPU, then
 * submits positions + normals to the SailShader for per-fragment lighting
 * with discrete tone quantization.
 */ /**
 * Custom WebGPU render pipeline for cel-shaded sail triangles.
 *
 * Takes projected 2D positions + 3D normals per vertex, computes
 * per-fragment lighting from the sun direction, and quantizes into
 * 2-3 discrete tones for a stylized look.
 *
 * Initialized lazily on first use. Pipeline and GPU buffers are
 * shared across all sails (one pipeline, separate draw calls).
 */ 




/**
 * Shared scene-lighting fields for shader uniforms.
 *
 * Every lighting-aware shader receives the same three per-frame values —
 * sun color, sun direction, and sky color — computed once per frame on the
 * CPU by `TimeOfDay`. Each shader spreads these fields into its own uniform
 * struct (both TS and WGSL) and uses `pushSceneLighting` to populate them.
 *
 * Using consistent field names across shaders keeps the lighting vocabulary
 * the same everywhere; values are always derived from `TimeOfDay` so there's
 * one source of truth.
 */ 
const $07d5066b6e7a4428$export$d4ca37c4b9500695 = {
    sunColor: (0, $ca6793d1abd58997$export$9100789c9d999364),
    sunDirection: (0, $ca6793d1abd58997$export$9100789c9d999364),
    skyColor: (0, $ca6793d1abd58997$export$9100789c9d999364)
};
const $07d5066b6e7a4428$export$750bd88a1db58bed = /*wgsl*/ `
  sunColor: vec3<f32>,
  sunDirection: vec3<f32>,
  skyColor: vec3<f32>,
`;
/**
 * Midday fallback lighting for contexts without a TimeOfDay entity (the
 * level editor, preview renderers, tests). Keeps the world looking sane
 * instead of pitch black.
 */ const $07d5066b6e7a4428$var$NOON_SUN_COLOR = [
    1.0,
    0.95,
    0.85
];
const $07d5066b6e7a4428$var$NOON_SUN_DIRECTION = [
    0.316,
    0.211,
    0.925
];
const $07d5066b6e7a4428$var$NOON_SKY_COLOR = [
    0.5,
    0.7,
    0.95
];
function $07d5066b6e7a4428$export$8143d277ae9e6de4(setters, timeOfDay) {
    if (timeOfDay) {
        setters.sunColor(timeOfDay.getSunColor());
        setters.sunDirection(timeOfDay.getSunDirection());
        setters.skyColor(timeOfDay.getSkyColor());
    } else {
        setters.sunColor($07d5066b6e7a4428$var$NOON_SUN_COLOR);
        setters.sunDirection($07d5066b6e7a4428$var$NOON_SUN_DIRECTION);
        setters.skyColor($07d5066b6e7a4428$var$NOON_SKY_COLOR);
    }
}


const $ddf31997cfadc92c$export$56a87f42736dfac0 = 6;
const $ddf31997cfadc92c$var$SAIL_VERTEX_STRIDE = $ddf31997cfadc92c$export$56a87f42736dfac0 * 4; // 24 bytes
const $ddf31997cfadc92c$var$SailUniforms = (0, $ca6793d1abd58997$export$99bb2281c7368d10)("SailUniforms", {
    viewMatrix: (0, $ca6793d1abd58997$export$a9b01fc77c97438b),
    baseColor: (0, $ca6793d1abd58997$export$6dba2a1f0d609415),
    // Scene lighting (see SceneLighting.ts). Populated from TimeOfDay.
    ...(0, $07d5066b6e7a4428$export$d4ca37c4b9500695)
});
const $ddf31997cfadc92c$var$SAIL_SHADER_SOURCE = /*wgsl*/ `
${$ddf31997cfadc92c$var$SailUniforms.wgsl}

// Depth mapping \u{2014} must match WebGPURenderer constants
const Z_MIN: f32 = ${(0, $5453fd34f01ad367$export$738c420ee12b9cdb)};
const Z_MAX: f32 = ${(0, $5453fd34f01ad367$export$e06187491332e57c)};

@group(0) @binding(0) var<uniform> uniforms: SailUniforms;

struct VertexInput {
  @location(0) position: vec2<f32>,
  @location(1) normal: vec3<f32>,
  @location(2) z: f32,
}

struct VertexOutput {
  @builtin(position) position: vec4<f32>,
  @location(0) normal: vec3<f32>,
}

@vertex
fn vs_main(in: VertexInput) -> VertexOutput {
  let worldPos = vec3<f32>(in.position, 1.0);
  let clipPos = uniforms.viewMatrix * worldPos;

  let depth = (in.z - Z_MIN) / (Z_MAX - Z_MIN);

  var out: VertexOutput;
  out.position = vec4<f32>(clipPos.xy, depth, 1.0);
  out.normal = in.normal;
  return out;
}

@fragment
fn fs_main(in: VertexOutput) -> @location(0) vec4<f32> {
  // Normalize interpolated normal (interpolation denormalizes)
  let n = normalize(in.normal);

  // Lambertian diffuse \u{2014} abs so both sides of sail are lit
  let diffuse = abs(dot(n, uniforms.sunDirection));

  // Quantize into discrete tones (cel-shading)
  var tone: f32;
  if (diffuse > 0.5) {
    tone = 1.0;       // lit \u{2014} full brightness
  } else if (diffuse > 0.2) {
    tone = 0.96;      // slight shadow
  } else {
    tone = 0.92;      // shadow
  }

  // Ambient (sky) + directional (sun * cel tone). Sky keeps sails visible
  // at night as a cool-blue floor; sun warms them at sunrise/sunset and
  // reads as bright white at midday.
  let ambient = 0.5;
  let illumination = uniforms.skyColor * ambient + uniforms.sunColor * tone;
  let tintedColor = uniforms.baseColor.rgb * illumination;

  return vec4<f32>(tintedColor, uniforms.baseColor.a);
}
`;
// Module-level singleton state
let $ddf31997cfadc92c$var$pipelineWithDepth = null;
let $ddf31997cfadc92c$var$bindGroupLayout = null;
let $ddf31997cfadc92c$var$initPromise = null;
let $ddf31997cfadc92c$var$shaderModule = null;
let $ddf31997cfadc92c$var$pipelineLayout = null;
let $ddf31997cfadc92c$var$msaaSubscribed = false;
function $ddf31997cfadc92c$var$rebuildSailPipeline() {
    if (!$ddf31997cfadc92c$var$shaderModule || !$ddf31997cfadc92c$var$pipelineLayout) return;
    const gpu = (0, $558c2f47f1fdd57f$export$297162150ea0f6af)();
    const device = gpu.device;
    const vertexBufferLayout = {
        arrayStride: $ddf31997cfadc92c$var$SAIL_VERTEX_STRIDE,
        attributes: [
            {
                shaderLocation: 0,
                offset: 0,
                format: "float32x2"
            },
            {
                shaderLocation: 1,
                offset: 8,
                format: "float32x3"
            },
            {
                shaderLocation: 2,
                offset: 20,
                format: "float32"
            }
        ]
    };
    $ddf31997cfadc92c$var$pipelineWithDepth = device.createRenderPipeline({
        layout: $ddf31997cfadc92c$var$pipelineLayout,
        vertex: {
            module: $ddf31997cfadc92c$var$shaderModule,
            entryPoint: "vs_main",
            buffers: [
                vertexBufferLayout
            ]
        },
        fragment: {
            module: $ddf31997cfadc92c$var$shaderModule,
            entryPoint: "fs_main",
            targets: [
                {
                    format: gpu.preferredFormat,
                    blend: {
                        color: {
                            srcFactor: "src-alpha",
                            dstFactor: "one-minus-src-alpha",
                            operation: "add"
                        },
                        alpha: {
                            srcFactor: "one",
                            dstFactor: "one-minus-src-alpha",
                            operation: "add"
                        }
                    }
                }
            ]
        },
        primitive: {
            topology: "triangle-list"
        },
        depthStencil: {
            format: "depth24plus",
            depthCompare: "greater-equal",
            depthWriteEnabled: true
        },
        multisample: {
            count: (0, $3d4164726c38f33c$export$688369c54d530641)()
        },
        label: "Sail Pipeline"
    });
}
async function $ddf31997cfadc92c$var$ensureInitialized() {
    if ($ddf31997cfadc92c$var$pipelineWithDepth) return;
    if ($ddf31997cfadc92c$var$initPromise) return $ddf31997cfadc92c$var$initPromise;
    $ddf31997cfadc92c$var$initPromise = (async ()=>{
        const gpu = (0, $558c2f47f1fdd57f$export$297162150ea0f6af)();
        const device = gpu.device;
        $ddf31997cfadc92c$var$shaderModule = await gpu.createShaderModuleChecked($ddf31997cfadc92c$var$SAIL_SHADER_SOURCE, "Sail Shader");
        $ddf31997cfadc92c$var$bindGroupLayout = device.createBindGroupLayout({
            entries: [
                {
                    binding: 0,
                    visibility: GPUShaderStage.VERTEX | GPUShaderStage.FRAGMENT,
                    buffer: {
                        type: "uniform"
                    }
                }
            ],
            label: "Sail Bind Group Layout"
        });
        $ddf31997cfadc92c$var$pipelineLayout = device.createPipelineLayout({
            bindGroupLayouts: [
                $ddf31997cfadc92c$var$bindGroupLayout
            ],
            label: "Sail Pipeline Layout"
        });
        $ddf31997cfadc92c$var$rebuildSailPipeline();
        if (!$ddf31997cfadc92c$var$msaaSubscribed) {
            $ddf31997cfadc92c$var$msaaSubscribed = true;
            (0, $3d4164726c38f33c$export$19f5a511f7104745)($ddf31997cfadc92c$var$rebuildSailPipeline);
        }
    })();
    return $ddf31997cfadc92c$var$initPromise;
}
class $ddf31997cfadc92c$export$db5c6a77b5092ab1 {
    constructor(maxVertices, maxIndices){
        this.vertexBuffer = null;
        this.indexBuffer = null;
        this.uniformBuffer = null;
        this.bindGroup = null;
        this.uniforms = $ddf31997cfadc92c$var$SailUniforms.create();
        /** Scratch matrix for combining view + camera transforms. */ this.combinedMatrix = new (0, $b29a77d98f1bc0d5$export$8ff26dafa08918)();
        this.maxVertices = maxVertices;
        this.maxIndices = maxIndices;
    }
    /** Lazily create GPU buffers. Returns false if not ready yet. */ ensureBuffers() {
        if (this.vertexBuffer) return true;
        if (!$ddf31997cfadc92c$var$pipelineWithDepth || !$ddf31997cfadc92c$var$bindGroupLayout) return false;
        const device = (0, $558c2f47f1fdd57f$export$297162150ea0f6af)().device;
        this.vertexBuffer = device.createBuffer({
            size: this.maxVertices * $ddf31997cfadc92c$var$SAIL_VERTEX_STRIDE,
            usage: GPUBufferUsage.VERTEX | GPUBufferUsage.COPY_DST,
            label: "Sail Vertex Buffer"
        });
        // Pad index buffer to 4-byte multiple
        const indexBufferSize = Math.ceil(this.maxIndices * 2 / 4) * 4;
        this.indexBuffer = device.createBuffer({
            size: indexBufferSize,
            usage: GPUBufferUsage.INDEX | GPUBufferUsage.COPY_DST,
            label: "Sail Index Buffer"
        });
        this.uniformBuffer = device.createBuffer({
            size: $ddf31997cfadc92c$var$SailUniforms.byteSize,
            usage: GPUBufferUsage.UNIFORM | GPUBufferUsage.COPY_DST,
            label: "Sail Uniform Buffer"
        });
        this.bindGroup = device.createBindGroup({
            layout: $ddf31997cfadc92c$var$bindGroupLayout,
            entries: [
                {
                    binding: 0,
                    resource: {
                        buffer: this.uniformBuffer
                    }
                }
            ],
            label: "Sail Bind Group"
        });
        return true;
    }
    /**
   * Upload vertex data and draw.
   * Call renderer.flush() before this.
   */ draw(renderer, vertexData, vertexCount, indexData, indexCount, color, alpha, timeOfDay) {
        // Kick off async init if not done yet
        if (!$ddf31997cfadc92c$var$pipelineWithDepth) {
            $ddf31997cfadc92c$var$ensureInitialized();
            return; // Skip this frame, will render next frame
        }
        if (!this.ensureBuffers()) return;
        const device = (0, $558c2f47f1fdd57f$export$297162150ea0f6af)().device;
        const renderPass = renderer.getCurrentRenderPass();
        if (!renderPass) return;
        // Upload vertex data
        const vData = vertexData.subarray(0, vertexCount * $ddf31997cfadc92c$export$56a87f42736dfac0);
        device.queue.writeBuffer(this.vertexBuffer, 0, vData.buffer, vData.byteOffset, vData.byteLength);
        // Upload index data — caller pre-pads indexData to even length (4-byte multiple)
        device.queue.writeBuffer(this.indexBuffer, 0, indexData.buffer, indexData.byteOffset, indexData.byteLength);
        // Upload uniforms
        // Combine camera transform (world → screen pixels) with view matrix (pixels → clip)
        // so the shader only needs: combinedMatrix * vec3(worldPos, 1.0)
        const baseR = (color >> 16 & 0xff) / 255;
        const baseG = (color >> 8 & 0xff) / 255;
        const baseB = (color & 0xff) / 255;
        // viewMatrix converts screen pixels → clip space
        // getTransform() is the current camera transform (world → screen pixels)
        // Combined: world → screen → clip
        this.combinedMatrix.copyFrom(renderer.getViewMatrix());
        this.combinedMatrix.multiply(renderer.getTransform());
        this.uniforms.set.viewMatrix(this.combinedMatrix);
        this.uniforms.set.baseColor([
            baseR,
            baseG,
            baseB,
            alpha
        ]);
        (0, $07d5066b6e7a4428$export$8143d277ae9e6de4)(this.uniforms.set, timeOfDay);
        this.uniforms.uploadTo(this.uniformBuffer);
        // Draw
        renderPass.setPipeline($ddf31997cfadc92c$var$pipelineWithDepth);
        renderPass.setBindGroup(0, this.bindGroup);
        renderPass.setVertexBuffer(0, this.vertexBuffer);
        renderPass.setIndexBuffer(this.indexBuffer, "uint16");
        renderPass.drawIndexed(indexCount);
    }
    /** Clean up GPU resources. */ destroy() {
        this.vertexBuffer?.destroy();
        this.indexBuffer?.destroy();
        this.uniformBuffer?.destroy();
        this.vertexBuffer = null;
        this.indexBuffer = null;
        this.uniformBuffer = null;
        this.bindGroup = null;
    }
}


class $dd84229691ec56ab$export$469e2ca99fadb59 {
    constructor(vertexCount, indices){
        this.vertexCount = vertexCount;
        this.indices = indices;
        this.indexCount = indices.length;
        this.vertexData = new Float32Array(vertexCount * (0, $ddf31997cfadc92c$export$56a87f42736dfac0));
        this.normalAccum = new Float32Array(vertexCount * 3);
        // Pre-fill index buffer (indices never change)
        // Allocate padded to even count so writeBuffer gets a 4-byte-multiple size
        const paddedLen = indices.length + 1 & -2;
        this.indexData = new Uint16Array(paddedLen);
        for(let i = 0; i < indices.length; i++)this.indexData[i] = indices[i];
        this.shaderInstance = new (0, $ddf31997cfadc92c$export$db5c6a77b5092ab1)(vertexCount, paddedLen);
    }
    /**
   * Read solver positions (already in heeled world space), compute normals,
   * and submit for rendering.
   *
   * @param vertexActive Optional per-vertex active mask. If provided, triangles
   *   with any inactive vertex are skipped.
   */ render(solver, draw, color, alpha, timeOfDay, vertexActive) {
        const n = this.vertexCount;
        const verts = this.vertexData;
        const normals = this.normalAccum;
        const indices = this.indices;
        // Clear normals
        normals.fill(0);
        // Solver positions are already in heeled world space — read directly
        for(let i = 0; i < n; i++){
            const vi = i * (0, $ddf31997cfadc92c$export$56a87f42736dfac0);
            verts[vi] = solver.getPositionX(i);
            verts[vi + 1] = solver.getPositionY(i);
            // normal slots (vi+2, vi+3, vi+4) filled below
            verts[vi + 5] = solver.getZ(i); // world z-height for depth testing
        }
        // Build index buffer, skipping inactive triangles
        let activeIndexCount = 0;
        for(let t = 0; t < indices.length; t += 3){
            const i0 = indices[t];
            const i1 = indices[t + 1];
            const i2 = indices[t + 2];
            // Skip triangles with any inactive vertex
            if (vertexActive && (!vertexActive[i0] || !vertexActive[i1] || !vertexActive[i2])) continue;
            const x0 = solver.getPositionX(i0), y0 = solver.getPositionY(i0), z0 = solver.getZ(i0);
            const x1 = solver.getPositionX(i1), y1 = solver.getPositionY(i1), z1 = solver.getZ(i1);
            const x2 = solver.getPositionX(i2), y2 = solver.getPositionY(i2), z2 = solver.getZ(i2);
            const e1x = x1 - x0, e1y = y1 - y0, e1z = z1 - z0;
            const e2x = x2 - x0, e2y = y2 - y0, e2z = z2 - z0;
            // Cross product (area-weighted face normal)
            const nx = e1y * e2z - e1z * e2y;
            const ny = e1z * e2x - e1x * e2z;
            const nz = e1x * e2y - e1y * e2x;
            normals[i0 * 3] += nx;
            normals[i0 * 3 + 1] += ny;
            normals[i0 * 3 + 2] += nz;
            normals[i1 * 3] += nx;
            normals[i1 * 3 + 1] += ny;
            normals[i1 * 3 + 2] += nz;
            normals[i2 * 3] += nx;
            normals[i2 * 3 + 1] += ny;
            normals[i2 * 3 + 2] += nz;
            // Write to index buffer
            this.indexData[activeIndexCount] = i0;
            this.indexData[activeIndexCount + 1] = i1;
            this.indexData[activeIndexCount + 2] = i2;
            activeIndexCount += 3;
        }
        if (activeIndexCount === 0) return;
        // Write normalized normals into vertex buffer
        for(let i = 0; i < n; i++){
            const i3 = i * 3;
            let nx = normals[i3], ny = normals[i3 + 1], nz = normals[i3 + 2];
            const len = Math.sqrt(nx * nx + ny * ny + nz * nz);
            if (len > 0.0001) {
                nx /= len;
                ny /= len;
                nz /= len;
            } else {
                nx = 0;
                ny = 0;
                nz = 1;
            }
            const vi = i * (0, $ddf31997cfadc92c$export$56a87f42736dfac0);
            verts[vi + 2] = nx;
            verts[vi + 3] = ny;
            verts[vi + 4] = nz;
        }
        // Flush pending batches so our custom draw doesn't disrupt layer ordering
        draw.renderer.flush();
        // Draw with custom sail shader
        this.shaderInstance.draw(draw.renderer, verts, n, this.indexData, activeIndexCount, color, alpha, timeOfDay);
    }
    /** Clean up GPU resources. */ destroy() {
        this.shaderInstance.destroy();
    }
}


/**
 * 3D Verlet cloth solver for sail simulation.
 * Pre-allocated typed arrays, zero allocation after warmup.
 * Does NOT use the physics engine.
 *
 * Each vertex has a full 3D position (x, y, z). Constraints operate on
 * 3D distances, so the sail has structural integrity in all directions:
 * the foot spans x,y along the boom, the luff spans z up the mast, and
 * wind pushes the sail perpendicular in x,y creating billow.
 */ class $a51afe1ae1598db3$export$9803b909cc610fc {
    constructor(mesh, config){
        this.explosionLogged = false;
        this.vertexCount = mesh.vertexCount;
        this.damping = config.damping;
        this.bendStiffness = config.bendStiffness;
        this.constraintDamping = config.constraintDamping;
        const n = mesh.vertexCount;
        this.positions = new Float64Array(n * 3);
        this.prevPositions = new Float64Array(n * 3);
        this.forces = new Float64Array(n * 3);
        this.pinned = new Uint8Array(n);
        this.pinTargets = new Float64Array(n * 3);
        this.skipped = new Uint8Array(n);
        this.reactionForces = new Float64Array(n * 3);
        // Pack constraints into flat arrays
        const pack = (src)=>{
            const a = new Int32Array(src.length);
            const b = new Int32Array(src.length);
            const rest = new Float64Array(src.length);
            for(let i = 0; i < src.length; i++){
                a[i] = src[i][0];
                b[i] = src[i][1];
                rest[i] = src[i][2]; // UV rest lengths — will be recomputed after init
            }
            return {
                a: a,
                b: b,
                rest: rest
            };
        };
        const sc = pack(mesh.structuralConstraints);
        this.structA = sc.a;
        this.structB = sc.b;
        this.structRest = sc.rest;
        const sh = pack(mesh.shearConstraints);
        this.shearA = sh.a;
        this.shearB = sh.b;
        this.shearRest = sh.rest;
        const bc = pack(mesh.bendConstraints);
        this.bendA = bc.a;
        this.bendB = bc.b;
        this.bendRest = bc.rest;
    }
    /**
   * Construct a ClothSolver from a snapshot (for use in workers).
   * The snapshot provides pre-computed arrays so no SailMeshData is needed.
   */ static fromSnapshot(snapshot) {
        // Create a minimal mesh-like object just to satisfy the constructor
        const dummy = {
            vertexCount: snapshot.vertexCount,
            restPositions: new Float64Array(0),
            zHeights: new Float64Array(0),
            indices: [],
            structuralConstraints: [],
            shearConstraints: [],
            bendConstraints: [],
            luffVertices: [],
            footVertices: [],
            leechVertices: [],
            rowStarts: [],
            colCounts: []
        };
        const solver = new $a51afe1ae1598db3$export$9803b909cc610fc(dummy, {
            damping: snapshot.damping,
            constraintIterations: 0,
            bendStiffness: snapshot.bendStiffness,
            constraintDamping: snapshot.constraintDamping
        });
        // Overwrite the arrays with the snapshot data
        solver.positions.set(snapshot.positions);
        solver.prevPositions.set(snapshot.prevPositions);
        solver.pinned.set(snapshot.pinned);
        solver.pinTargets.set(snapshot.pinTargets);
        if (snapshot.skipped) solver.skipped.set(snapshot.skipped);
        solver.structA = snapshot.structA;
        solver.structB = snapshot.structB;
        solver.structRest = snapshot.structRest;
        solver.shearA = snapshot.shearA;
        solver.shearB = snapshot.shearB;
        solver.shearRest = snapshot.shearRest;
        solver.bendA = snapshot.bendA;
        solver.bendB = snapshot.bendB;
        solver.bendRest = snapshot.bendRest;
        return solver;
    }
    /**
   * Initialize all 3D positions. Call once after construction.
   * Recomputes constraint rest lengths from 3D distances.
   */ initializePositions(worldX, worldY, worldZ) {
        for(let i = 0; i < this.vertexCount; i++){
            const i3 = i * 3;
            this.positions[i3] = worldX[i];
            this.positions[i3 + 1] = worldY[i];
            this.positions[i3 + 2] = worldZ[i];
            this.prevPositions[i3] = worldX[i];
            this.prevPositions[i3 + 1] = worldY[i];
            this.prevPositions[i3 + 2] = worldZ[i];
        }
        this.recomputeRestLengths();
    }
    /**
   * Set all positions without recomputing rest lengths.
   * Use after initializePositions to move vertices to a different starting
   * state while keeping the rest lengths from the original shape.
   */ resetPositions(worldX, worldY, worldZ) {
        for(let i = 0; i < this.vertexCount; i++){
            const i3 = i * 3;
            this.positions[i3] = worldX[i];
            this.positions[i3 + 1] = worldY[i];
            this.positions[i3 + 2] = worldZ[i];
            this.prevPositions[i3] = worldX[i];
            this.prevPositions[i3 + 1] = worldY[i];
            this.prevPositions[i3 + 2] = worldZ[i];
        }
    }
    /** Recompute all constraint rest lengths from current 3D positions. */ recomputeRestLengths() {
        const pos = this.positions;
        const recompute = (aArr, bArr, restArr)=>{
            for(let c = 0; c < aArr.length; c++){
                const a3 = aArr[c] * 3;
                const b3 = bArr[c] * 3;
                const dx = pos[b3] - pos[a3];
                const dy = pos[b3 + 1] - pos[a3 + 1];
                const dz = pos[b3 + 2] - pos[a3 + 2];
                restArr[c] = Math.max(0.01, Math.sqrt(dx * dx + dy * dy + dz * dz));
            }
        };
        recompute(this.structA, this.structB, this.structRest);
        recompute(this.shearA, this.shearB, this.shearRest);
        recompute(this.bendA, this.bendB, this.bendRest);
    }
    /** Clear force accumulators. */ clearForces() {
        this.forces.fill(0);
    }
    /** Accumulate force on a vertex. */ applyForce(index, fx, fy, fz) {
        const i3 = index * 3;
        this.forces[i3] += fx;
        this.forces[i3 + 1] += fy;
        this.forces[i3 + 2] += fz;
    }
    /** Set pin target for a vertex. */ setPinTarget(index, x, y, z) {
        const i3 = index * 3;
        this.pinTargets[i3] = x;
        this.pinTargets[i3 + 1] = y;
        this.pinTargets[i3 + 2] = z;
    }
    /** Toggle pinning for a vertex. */ setPinned(index, pinned) {
        this.pinned[index] = pinned ? 1 : 0;
    }
    /** Update constraint damping coefficient at runtime. */ setConstraintDamping(value) {
        this.constraintDamping = value;
    }
    /** Mark a vertex as skipped (excluded from simulation entirely). */ setSkipped(index, skip) {
        this.skipped[index] = skip ? 1 : 0;
    }
    /** Reset a single vertex position and zero its velocity. */ resetVertex(index, x, y, z) {
        const i3 = index * 3;
        this.positions[i3] = x;
        this.positions[i3 + 1] = y;
        this.positions[i3 + 2] = z;
        this.prevPositions[i3] = x;
        this.prevPositions[i3 + 1] = y;
        this.prevPositions[i3 + 2] = z;
    }
    /** Set pos and prev separately so the Verlet-implicit velocity is pos-prev. */ setPositionAndPrev(index, x, y, z, prevX, prevY, prevZ) {
        const i3 = index * 3;
        this.positions[i3] = x;
        this.positions[i3 + 1] = y;
        this.positions[i3 + 2] = z;
        this.prevPositions[i3] = prevX;
        this.prevPositions[i3 + 1] = prevY;
        this.prevPositions[i3 + 2] = prevZ;
    }
    /** Blend pos and prev toward target values by t in [0,1]. t=0: no change.
   *  t=1: snap to target. Used for soft-pinning partially-active cloth verts. */ blendTowardTarget(index, x, y, z, prevX, prevY, prevZ, t) {
        const i3 = index * 3;
        const ti = 1 - t;
        this.positions[i3] = this.positions[i3] * ti + x * t;
        this.positions[i3 + 1] = this.positions[i3 + 1] * ti + y * t;
        this.positions[i3 + 2] = this.positions[i3 + 2] * ti + z * t;
        this.prevPositions[i3] = this.prevPositions[i3] * ti + prevX * t;
        this.prevPositions[i3 + 1] = this.prevPositions[i3 + 1] * ti + prevY * t;
        this.prevPositions[i3 + 2] = this.prevPositions[i3 + 2] * ti + prevZ * t;
    }
    /**
   * Snapshot solver state for transfer to a worker.
   * Returns copies of internal arrays for one-time transfer.
   */ snapshotState() {
        return {
            positions: new Float64Array(this.positions),
            prevPositions: new Float64Array(this.prevPositions),
            pinned: new Uint8Array(this.pinned),
            pinTargets: new Float64Array(this.pinTargets),
            skipped: new Uint8Array(this.skipped),
            structA: new Int32Array(this.structA),
            structB: new Int32Array(this.structB),
            structRest: new Float64Array(this.structRest),
            shearA: new Int32Array(this.shearA),
            shearB: new Int32Array(this.shearB),
            shearRest: new Float64Array(this.shearRest),
            bendA: new Int32Array(this.bendA),
            bendB: new Int32Array(this.bendB),
            bendRest: new Float64Array(this.bendRest),
            damping: this.damping,
            bendStiffness: this.bendStiffness,
            constraintDamping: this.constraintDamping
        };
    }
    getPositionX(index) {
        return this.positions[index * 3];
    }
    getPositionY(index) {
        return this.positions[index * 3 + 1];
    }
    getZ(index) {
        return this.positions[index * 3 + 2];
    }
    getPrevPositionX(index) {
        return this.prevPositions[index * 3];
    }
    getPrevPositionY(index) {
        return this.prevPositions[index * 3 + 1];
    }
    getReactionForceX(index) {
        return this.reactionForces[index * 3];
    }
    getReactionForceY(index) {
        return this.reactionForces[index * 3 + 1];
    }
    getReactionForceZ(index) {
        return this.reactionForces[index * 3 + 2];
    }
    /** Sum reaction forces for a set of vertex indices. Returns [fx, fy, fz]. */ sumReactionForces(indices) {
        let fx = 0, fy = 0, fz = 0;
        for (const i of indices){
            const i3 = i * 3;
            fx += this.reactionForces[i3];
            fy += this.reactionForces[i3 + 1];
            fz += this.reactionForces[i3 + 2];
        }
        return [
            fx,
            fy,
            fz
        ];
    }
    /**
   * Run one simulation step.
   * External code should call clearForces(), applyForce(), setPinTarget() before this.
   */ update(dt, constraintIterations) {
        const dtSq = dt * dt;
        const invDtSq = dtSq > 0 ? 1 / dtSq : 0;
        const n = this.vertexCount;
        const pos = this.positions;
        const prev = this.prevPositions;
        const forces = this.forces;
        const pinned = this.pinned;
        const skipped = this.skipped;
        const damping = this.damping;
        const reactions = this.reactionForces;
        // Reaction forces on pinned vertices have two components:
        // 1. External forces (gravity, wind) applied directly to the vertex
        // 2. Constraint corrections from neighboring vertices pulling on it
        // Start at zero; constraint displacement is accumulated during solving,
        // then converted to force and combined with external forces at the end.
        reactions.fill(0);
        // Verlet integration for free vertices — all 3 axes
        for(let i = 0; i < n; i++){
            if (pinned[i] || skipped[i]) continue;
            const i3 = i * 3;
            const vx = (pos[i3] - prev[i3]) * damping;
            const vy = (pos[i3 + 1] - prev[i3 + 1]) * damping;
            const vz = (pos[i3 + 2] - prev[i3 + 2]) * damping;
            prev[i3] = pos[i3];
            prev[i3 + 1] = pos[i3 + 1];
            prev[i3 + 2] = pos[i3 + 2];
            pos[i3] += vx + forces[i3] * dtSq;
            pos[i3 + 1] += vy + forces[i3 + 1] * dtSq;
            pos[i3 + 2] += vz + forces[i3 + 2] * dtSq;
        }
        // Check for explosion
        if (this.checkExplosion()) return;
        // Pin vertices to targets
        this.applyPins();
        // Constraint projection — 3D distances.
        // Structural constraints are one-sided (stretch only): real sailcloth
        // resists stretching but buckles freely under compression. Shear and
        // bend stay symmetric.
        for(let iter = 0; iter < constraintIterations; iter++){
            this.solveConstraints(this.structA, this.structB, this.structRest, 0.2, true);
            this.solveConstraints(this.shearA, this.shearB, this.shearRest, 0.2, false);
            this.solveConstraints(this.bendA, this.bendB, this.bendRest, 0.5 * this.bendStiffness, false);
            this.applyPins();
        }
        // Convert constraint displacement to force, add external forces.
        // reactions = externalForces + constraintDisplacement / dt²
        for(let i = 0; i < n; i++){
            if (!pinned[i] || skipped[i]) continue;
            const i3 = i * 3;
            reactions[i3] = forces[i3] + reactions[i3] * invDtSq;
            reactions[i3 + 1] = forces[i3 + 1] + reactions[i3 + 1] * invDtSq;
            reactions[i3 + 2] = forces[i3 + 2] + reactions[i3 + 2] * invDtSq;
        }
    }
    static{
        this.EXPLOSION_RADIUS = 200;
    }
    checkExplosion() {
        const pos = this.positions;
        const pinned = this.pinned;
        const n = this.vertexCount;
        let cx = 0, cy = 0, cz = 0, pinCount = 0;
        for(let i = 0; i < n; i++)if (pinned[i]) {
            const i3 = i * 3;
            cx += this.pinTargets[i3];
            cy += this.pinTargets[i3 + 1];
            cz += this.pinTargets[i3 + 2];
            pinCount++;
        }
        if (pinCount === 0) return false;
        cx /= pinCount;
        cy /= pinCount;
        cz /= pinCount;
        const maxR2 = $a51afe1ae1598db3$export$9803b909cc610fc.EXPLOSION_RADIUS * $a51afe1ae1598db3$export$9803b909cc610fc.EXPLOSION_RADIUS;
        for(let i = 0; i < n; i++){
            if (pinned[i] || this.skipped[i]) continue;
            const i3 = i * 3;
            const dx = pos[i3] - cx;
            const dy = pos[i3 + 1] - cy;
            const dz = pos[i3 + 2] - cz;
            const r2 = dx * dx + dy * dy + dz * dz;
            if (r2 > maxR2 || !isFinite(pos[i3]) || !isFinite(pos[i3 + 1]) || !isFinite(pos[i3 + 2])) {
                if (!this.explosionLogged) {
                    console.error(`[ClothSolver] Cloth exploded \u{2014} vertex ${i} is ${Math.sqrt(r2).toFixed(0)}ft from centroid. Resetting.`);
                    this.explosionLogged = true;
                }
                this.resetToPin();
                return true;
            }
        }
        this.explosionLogged = false;
        return false;
    }
    resetToPin() {
        const n = this.vertexCount;
        for(let i = 0; i < n; i++)if (this.pinned[i]) {
            const i3 = i * 3;
            this.positions[i3] = this.pinTargets[i3];
            this.positions[i3 + 1] = this.pinTargets[i3 + 1];
            this.positions[i3 + 2] = this.pinTargets[i3 + 2];
            this.prevPositions[i3] = this.pinTargets[i3];
            this.prevPositions[i3 + 1] = this.pinTargets[i3 + 1];
            this.prevPositions[i3 + 2] = this.pinTargets[i3 + 2];
        }
        let cx = 0, cy = 0, cz = 0, count = 0;
        for(let i = 0; i < n; i++)if (this.pinned[i]) {
            const i3 = i * 3;
            cx += this.pinTargets[i3];
            cy += this.pinTargets[i3 + 1];
            cz += this.pinTargets[i3 + 2];
            count++;
        }
        if (count > 0) {
            cx /= count;
            cy /= count;
            cz /= count;
        }
        for(let i = 0; i < n; i++){
            if (this.pinned[i]) continue;
            const i3 = i * 3;
            this.positions[i3] = cx;
            this.positions[i3 + 1] = cy;
            this.positions[i3 + 2] = cz;
            this.prevPositions[i3] = cx;
            this.prevPositions[i3 + 1] = cy;
            this.prevPositions[i3 + 2] = cz;
        }
        this.reactionForces.fill(0);
    }
    /**
   * 3D constraint projection.
   * When one end is pinned, the full correction goes to the free end.
   * The displacement the pinned end resisted is accumulated into reactionForces
   * (in displacement units — converted to force after all iterations).
   */ solveConstraints(aArr, bArr, restArr, correctionFactor, oneSided) {
        const pos = this.positions;
        const prev = this.prevPositions;
        const pinned = this.pinned;
        const skipped = this.skipped;
        const reactions = this.reactionForces;
        const cDamp = this.constraintDamping;
        const count = aArr.length;
        for(let c = 0; c < count; c++){
            const a = aArr[c];
            const b = bArr[c];
            // Skip constraints involving skipped (excluded) vertices
            if (skipped[a] || skipped[b]) continue;
            const rest = restArr[c];
            const a3 = a * 3;
            const b3 = b * 3;
            const dx = pos[b3] - pos[a3];
            const dy = pos[b3 + 1] - pos[a3 + 1];
            const dz = pos[b3 + 2] - pos[a3 + 2];
            const dist = Math.sqrt(dx * dx + dy * dy + dz * dz);
            if (dist < 0.0001) continue;
            if (oneSided && dist < rest) continue;
            const invDist = 1 / dist;
            // Position correction (spring)
            const error = (dist - rest) * correctionFactor * invDist;
            let ex = dx * error;
            let ey = dy * error;
            let ez = dz * error;
            // Constraint damping: damp relative velocity along the constraint direction.
            // Like a dashpot in parallel with the spring — targets oscillation
            // without damping overall cloth motion.
            if (cDamp > 0) {
                // Relative velocity (in displacement units: pos - prev)
                const dvx = pos[b3] - prev[b3] - (pos[a3] - prev[a3]);
                const dvy = pos[b3 + 1] - prev[b3 + 1] - (pos[a3 + 1] - prev[a3 + 1]);
                const dvz = pos[b3 + 2] - prev[b3 + 2] - (pos[a3 + 2] - prev[a3 + 2]);
                // Project onto constraint direction
                const relVel = (dvx * dx + dvy * dy + dvz * dz) * invDist;
                // Add damping correction along constraint direction
                const dampCorr = relVel * cDamp * invDist;
                ex += dx * dampCorr;
                ey += dy * dampCorr;
                ez += dz * dampCorr;
            }
            const aPin = pinned[a];
            const bPin = pinned[b];
            if (aPin && bPin) continue;
            if (aPin) {
                pos[b3] -= ex;
                pos[b3 + 1] -= ey;
                pos[b3 + 2] -= ez;
                // The constraint pulls A toward B by (ex, ey, ez); pin absorbs it
                reactions[a3] += ex;
                reactions[a3 + 1] += ey;
                reactions[a3 + 2] += ez;
            } else if (bPin) {
                pos[a3] += ex;
                pos[a3 + 1] += ey;
                pos[a3 + 2] += ez;
                // The constraint pulls B toward A by (-ex, -ey, -ez); pin absorbs it
                reactions[b3] -= ex;
                reactions[b3 + 1] -= ey;
                reactions[b3 + 2] -= ez;
            } else {
                pos[a3] += ex * 0.5;
                pos[a3 + 1] += ey * 0.5;
                pos[a3 + 2] += ez * 0.5;
                pos[b3] -= ex * 0.5;
                pos[b3 + 1] -= ey * 0.5;
                pos[b3 + 2] -= ez * 0.5;
            }
        }
    }
    applyPins() {
        const pos = this.positions;
        const prev = this.prevPositions;
        const pinned = this.pinned;
        const skipped = this.skipped;
        const targets = this.pinTargets;
        for(let i = 0; i < this.vertexCount; i++){
            if (!pinned[i] || skipped[i]) continue;
            const i3 = i * 3;
            pos[i3] = targets[i3];
            pos[i3 + 1] = targets[i3 + 1];
            pos[i3 + 2] = targets[i3 + 2];
            prev[i3] = targets[i3];
            prev[i3 + 1] = targets[i3 + 1];
            prev[i3 + 2] = targets[i3 + 2];
        }
    }
}


/**
 * Singleton entity that manages Web Workers for cloth sail simulation.
 * Spawns one worker per sail, communicating via SharedArrayBuffer.
 * Falls back to synchronous solving when SharedArrayBuffer is unavailable.
 */ 


/**
 * Synchronous fallback for cloth solving when SharedArrayBuffer is unavailable.
 * Same interface as SailWorkerHandle but runs the solver on the main thread.
 * Includes furling logic (luff pinning, active region, furl modes).
 */ 

const $6c439dd60468057e$export$a112bc5e3de103e3 = (0, $2172aedd5a25ff17$export$e6bfdeff8bfc94f9)(15);
/** Calculate the lift coefficient for a sail at a given angle of attack. */ function $6c439dd60468057e$var$getSailLiftCoefficient(angleOfAttack) {
    const alpha = Math.abs(angleOfAttack);
    const effectiveAlpha = alpha > Math.PI / 2 ? Math.PI - alpha : alpha;
    let cl;
    if (effectiveAlpha < $6c439dd60468057e$export$a112bc5e3de103e3) cl = 2 * Math.PI * Math.sin(effectiveAlpha);
    else {
        const peak = 2 * Math.PI * Math.sin($6c439dd60468057e$export$a112bc5e3de103e3);
        const decay = Math.exp(-3 * (effectiveAlpha - $6c439dd60468057e$export$a112bc5e3de103e3));
        cl = peak * decay;
    }
    cl *= Math.sign(Math.cos(angleOfAttack));
    return cl;
}
/**
 * Compute drag coefficient for a sail segment.
 * Base drag + induced drag + stall penalty.
 */ function $6c439dd60468057e$var$computeDragCoefficient(aoa) {
    const effectiveAlpha = aoa > Math.PI / 2 ? Math.PI - aoa : aoa;
    const baseDrag = 0.02;
    const inducedDrag = 0.1 * effectiveAlpha * effectiveAlpha;
    const stallDrag = effectiveAlpha > $6c439dd60468057e$export$a112bc5e3de103e3 ? 0.5 * (effectiveAlpha - $6c439dd60468057e$export$a112bc5e3de103e3) : 0;
    return baseDrag + inducedDrag + stallDrag;
}
function $6c439dd60468057e$export$140a16ae5ce2d06b(solver, i0, i1, i2, windX, windY, liftScale, dragScale, tickRate = 120) {
    // Get vertex positions
    const x0 = solver.getPositionX(i0);
    const y0 = solver.getPositionY(i0);
    const z0 = solver.getZ(i0);
    const x1 = solver.getPositionX(i1);
    const y1 = solver.getPositionY(i1);
    const z1 = solver.getZ(i1);
    const x2 = solver.getPositionX(i2);
    const y2 = solver.getPositionY(i2);
    const z2 = solver.getZ(i2);
    // Centroid velocity from Verlet (pos - prevPos) * tickRate
    const vx = (x0 - solver.getPrevPositionX(i0) + (x1 - solver.getPrevPositionX(i1)) + (x2 - solver.getPrevPositionX(i2))) * (tickRate / 3);
    const vy = (y0 - solver.getPrevPositionY(i0) + (y1 - solver.getPrevPositionY(i1)) + (y2 - solver.getPrevPositionY(i2))) * (tickRate / 3);
    // Relative wind = true wind - surface velocity
    const relX = windX - vx;
    const relY = windY - vy;
    const relSpeed = Math.hypot(relX, relY);
    if (relSpeed < 0.01) return [
        0,
        0,
        0
    ];
    // Edge vectors
    const e1x = x1 - x0;
    const e1y = y1 - y0;
    const e1z = z1 - z0;
    const e2x = x2 - x0;
    const e2y = y2 - y0;
    const e2z = z2 - z0;
    // 3D cross product → face normal
    const nx = e1y * e2z - e1z * e2y;
    const ny = e1z * e2x - e1x * e2z;
    const nz = e1x * e2y - e1y * e2x;
    const nLen = Math.hypot(nx, ny, nz);
    if (nLen < 0.0001) return [
        0,
        0,
        0
    ];
    // Triangle area = 0.5 * |cross product|
    const area = nLen * 0.5;
    // Normalize normal
    const nnx = nx / nLen;
    const nny = ny / nLen;
    const nnz = nz / nLen;
    // Relative wind direction (normalized, treat as 2D with z=0)
    const wdx = relX / relSpeed;
    const wdy = relY / relSpeed;
    // Angle of attack: angle between wind direction and face normal
    // dot(wind3d, normal) where wind3d = (wdx, wdy, 0)
    const dot = wdx * nnx + wdy * nny;
    // The angle of attack is the complement: cos(aoa) = |dot| means aoa = acos(|dot|)
    // But for a sail, aoa is angle between wind and the surface plane, not the normal
    const sinAoa = Math.abs(dot); // sin of angle between wind and surface
    const aoa = Math.asin((0, $2172aedd5a25ff17$export$7d15b64cf5a3a4c4)(sinAoa, 0, 1));
    // Dynamic pressure from relative wind
    const q = 0.5 * (0, $76df497339ed0c67$export$b2c4fea6cb9591e) * relSpeed * relSpeed;
    // Lift and drag coefficients
    const cl = $6c439dd60468057e$var$getSailLiftCoefficient(aoa) * liftScale;
    const cd = $6c439dd60468057e$var$computeDragCoefficient(aoa) * dragScale;
    const liftMag = cl * q * area * (0, $76df497339ed0c67$export$d6989026b8609618);
    const dragMag = cd * q * area * (0, $76df497339ed0c67$export$d6989026b8609618);
    // Drag force: along relative wind direction
    const fdx = wdx * dragMag;
    const fdy = wdy * dragMag;
    // Lift force: perpendicular to wind, in the direction the normal faces
    // Lift pushes the sail in the direction of the face normal (leeward)
    // Project normal onto plane perpendicular to wind
    const normalDotWind = nnx * wdx + nny * wdy;
    let liftDirX = nnx - normalDotWind * wdx;
    let liftDirY = nny - normalDotWind * wdy;
    let liftDirZ = nnz;
    const liftDirLen = Math.hypot(liftDirX, liftDirY, liftDirZ);
    if (liftDirLen > 0.001) {
        liftDirX /= liftDirLen;
        liftDirY /= liftDirLen;
        liftDirZ /= liftDirLen;
    } else {
        liftDirX = 0;
        liftDirY = 0;
        liftDirZ = 0;
    }
    const fx = fdx + liftDirX * liftMag;
    const fy = fdy + liftDirY * liftMag;
    const fz = liftDirZ * liftMag;
    return [
        fx,
        fy,
        fz
    ];
}


// Gravity in ft/s² (downward in z)
const $964b1eaff0db64a8$var$GRAVITY_Z = -32.174;
// Activation band width (in v or u units) over which rows ease in.
const $964b1eaff0db64a8$var$ACTIVATION_BAND = 0.1;
class $964b1eaff0db64a8$export$8cf456eb3a136b3c {
    constructor(solver, indices, tackIdx, clewIdx, headIdx, luffVertices, vertexU, vertexV, vertexChordFrac, furlMode){
        this.restShapeInitialized = false;
        this.solved = false;
        // Reaction force accumulators
        this.luffRx = 0;
        this.luffRy = 0;
        this.clewRx = 0;
        this.clewRy = 0;
        this.solver = solver;
        this.indices = indices;
        this.tackIdx = tackIdx;
        this.clewIdx = clewIdx;
        this.headIdx = headIdx;
        this.luffVertices = luffVertices;
        this.vertexU = vertexU;
        this.vertexV = vertexV;
        this.vertexChordFrac = vertexChordFrac;
        this.furlMode = furlMode;
        this.vertexActive = new Uint8Array(solver.vertexCount);
        this.prevActive = new Uint8Array(solver.vertexCount);
        this.vertexBlend = new Float64Array(solver.vertexCount);
        this.restShape = new Float64Array(solver.vertexCount * 3);
        this.prevRestShape = new Float64Array(solver.vertexCount * 3);
        this.luffSet = new Set(luffVertices);
    }
    computeBlend(i, hoistAmount) {
        const excess = this.furlMode === "v-cutoff" ? hoistAmount - this.vertexV[i] : this.vertexU[i] - (1 - hoistAmount);
        if (excess <= 0) return 0;
        if (excess >= $964b1eaff0db64a8$var$ACTIVATION_BAND) return 1;
        const t = excess / $964b1eaff0db64a8$var$ACTIVATION_BAND;
        return t * t * (3 - 2 * t);
    }
    computeRestShape(tackX, tackY, tackZ, clewX, clewY, clewZ, headX, headY, headZ) {
        const out = this.restShape;
        const vertexCount = this.solver.vertexCount;
        const chordX = clewX - tackX;
        const chordY = clewY - tackY;
        for(let i = 0; i < vertexCount; i++){
            const u = this.vertexU[i];
            const v = this.vertexV[i];
            const cf = this.vertexChordFrac[i];
            const i3 = i * 3;
            out[i3] = tackX + v * (headX - tackX) + u * cf * chordX;
            out[i3 + 1] = tackY + v * (headY - tackY) + u * cf * chordY;
            out[i3 + 2] = tackZ + v * (headZ - tackZ);
        }
    }
    hasNewResults() {
        return this.solved;
    }
    readReactionForces() {
        return new Float64Array([
            0,
            0,
            this.luffRx,
            this.luffRy,
            this.clewRx,
            this.clewRy
        ]);
    }
    ackResults() {
        this.solved = false;
    }
    writeInputsAndKick(inputs) {
        const { dt: dt, substeps: substeps, iterations: iterations, constraintDamping: constraintDamping, clothMass: clothMass, hoistAmount: hoistAmount, windX: windX, windY: windY, liftScale: liftScale, dragScale: dragScale, tackX: tackX, tackY: tackY, tackZ: tackZ, clewX: clewX, clewY: clewY, clewZ: clewZ, headX: headX, headY: headY, headZ: headZ, clewPinned: clewPinned } = inputs;
        const solver = this.solver;
        const vertexCount = solver.vertexCount;
        // Update solver config
        solver.setConstraintDamping(constraintDamping);
        // Update clew pin target
        solver.setPinTarget(this.clewIdx, clewX, clewY, clewZ);
        // Compute rest-shape positions and seed prev on the first frame.
        this.computeRestShape(tackX, tackY, tackZ, clewX, clewY, clewZ, headX, headY, headZ);
        if (!this.restShapeInitialized) {
            this.prevRestShape.set(this.restShape);
            this.restShapeInitialized = true;
        }
        // Compute blend weights, luff pins, skipped verts, activation seeding
        this.updateFurlState(hoistAmount, clewPinned);
        const vertexMass = clothMass / vertexCount;
        solver.clearForces();
        // Gravity — scaled by blend so partially-active verts ease in
        const gravZ = $964b1eaff0db64a8$var$GRAVITY_Z * vertexMass;
        for(let i = 0; i < vertexCount; i++){
            const w = this.vertexBlend[i];
            if (w > 0) solver.applyForce(i, 0, 0, gravZ * w);
        }
        // Aerodynamic forces — scaled by minimum blend across triangle
        if (hoistAmount > 0 && (windX !== 0 || windY !== 0)) {
            const invVertexMass = 1 / vertexMass;
            const indices = this.indices;
            const blend = this.vertexBlend;
            for(let t = 0; t < indices.length; t += 3){
                const i0 = indices[t];
                const i1 = indices[t + 1];
                const i2 = indices[t + 2];
                const wTri = Math.min(blend[i0], blend[i1], blend[i2]);
                if (wTri <= 0) continue;
                const [fx, fy, fz] = (0, $6c439dd60468057e$export$140a16ae5ce2d06b)(solver, i0, i1, i2, windX, windY, liftScale, dragScale);
                const scale = invVertexMass / 3 * wTri;
                const sfx = fx * scale;
                const sfy = fy * scale;
                const sfz = fz * scale;
                solver.applyForce(i0, sfx, sfy, sfz);
                solver.applyForce(i1, sfx, sfy, sfz);
                solver.applyForce(i2, sfx, sfy, sfz);
            }
        }
        // Sub-step the solver
        const subDt = dt / substeps;
        const subIter = Math.max(1, Math.round(iterations / substeps));
        let sumLuffRx = 0, sumLuffRy = 0;
        let sumClewRx = 0, sumClewRy = 0;
        for(let s = 0; s < substeps; s++){
            solver.update(subDt, subIter);
            for (const li of this.luffVertices)if (this.vertexActive[li]) {
                sumLuffRx += solver.getReactionForceX(li);
                sumLuffRy += solver.getReactionForceY(li);
            }
            sumClewRx += solver.getReactionForceX(this.clewIdx);
            sumClewRy += solver.getReactionForceY(this.clewIdx);
        }
        // Post-solve soft pin for partially-active verts
        for(let i = 0; i < vertexCount; i++){
            const w = this.vertexBlend[i];
            if (w <= 0 || w >= 1) continue;
            const i3 = i * 3;
            solver.blendTowardTarget(i, this.restShape[i3], this.restShape[i3 + 1], this.restShape[i3 + 2], this.prevRestShape[i3], this.prevRestShape[i3 + 1], this.prevRestShape[i3 + 2], 1 - w);
        }
        // Store current rest shape for next frame
        this.prevRestShape.set(this.restShape);
        this.luffRx = sumLuffRx;
        this.luffRy = sumLuffRy;
        this.clewRx = sumClewRx;
        this.clewRy = sumClewRy;
        this.solved = true;
    }
    updateFurlState(hoistAmount, clewPinned) {
        const solver = this.solver;
        const vertexCount = solver.vertexCount;
        const active = this.vertexActive;
        const blend = this.vertexBlend;
        const restShape = this.restShape;
        const prevRestShape = this.prevRestShape;
        // Compute blend weights and active flags
        for(let i = 0; i < vertexCount; i++){
            const w = this.computeBlend(i, hoistAmount);
            blend[i] = w;
            active[i] = w > 0 ? 1 : 0;
        }
        // Clear pin and skipped states — set fresh each frame
        for(let i = 0; i < vertexCount; i++){
            solver.setPinned(i, false);
            solver.setSkipped(i, false);
        }
        // Luff verts: hard-pinned at rest shape (which is exactly the luff line)
        for (const li of this.luffVertices){
            const i3 = li * 3;
            if (active[li]) {
                solver.setPinned(li, true);
                solver.setPinTarget(li, restShape[i3], restShape[i3 + 1], restShape[i3 + 2]);
            }
        }
        // Non-luff skipped verts: position = rest shape, prev = prev rest shape
        for(let i = 0; i < vertexCount; i++){
            if (this.luffSet.has(i)) continue;
            if (!active[i]) {
                solver.setSkipped(i, true);
                const i3 = i * 3;
                solver.setPositionAndPrev(i, restShape[i3], restShape[i3 + 1], restShape[i3 + 2], prevRestShape[i3], prevRestShape[i3 + 1], prevRestShape[i3 + 2]);
            }
        }
        // Clew pin — only when fully active
        if (clewPinned && blend[this.clewIdx] >= 1) solver.setPinned(this.clewIdx, true);
        // Activation seeding: newly-active verts inherit the boat's velocity via
        // prev = prevRestShape (the previous frame's rest shape tracks boat motion)
        const prevActive = this.prevActive;
        for(let i = 0; i < vertexCount; i++){
            if (active[i] && !prevActive[i]) {
                const i3 = i * 3;
                solver.setPositionAndPrev(i, restShape[i3], restShape[i3 + 1], restShape[i3 + 2], prevRestShape[i3], prevRestShape[i3 + 1], prevRestShape[i3 + 2]);
            }
            prevActive[i] = active[i];
        }
    }
    // ---- ClothPositionReader interface ----
    getPositionX(i) {
        return this.solver.getPositionX(i);
    }
    getPositionY(i) {
        return this.solver.getPositionY(i);
    }
    getZ(i) {
        return this.solver.getZ(i);
    }
    // ---- Previous positions for TellTail velocity ----
    getPrevPositionX(i) {
        return this.solver.getPrevPositionX(i);
    }
    getPrevPositionY(i) {
        return this.solver.getPrevPositionY(i);
    }
}


/**
 * SharedArrayBuffer protocol for cloth solver worker communication.
 * No engine dependencies — importable from both main thread and worker.
 */ // State machine constants (Int32 values)
const $434b7d3d47cd8f34$export$cc2b4ce5f63aa8e8 = 0;
const $434b7d3d47cd8f34$export$151e59225a043bbe = 1;
const $434b7d3d47cd8f34$export$4f4ee1545877b7a1 = 2;
// SAB layout:
//   [0]       Int32: state (IDLE / SOLVING / DONE)
//   [4]       Int32: swap flag (0 or 1 — which position buffer is "front")
//   [8..INPUT_END) Float64: input region
//   [INPUT_END..] Float64: position buffer A, position buffer B, reaction forces
// Input region offsets (in Float64 indices, starting at byte 8)
const $434b7d3d47cd8f34$var$INPUT_F64_START = 1; // byte 8 = Float64 index 1
const $434b7d3d47cd8f34$export$3edd0927099186ee = 0;
const $434b7d3d47cd8f34$export$feaccbb8231134be = 1;
const $434b7d3d47cd8f34$export$40d32c766e7453ee = 2;
const $434b7d3d47cd8f34$export$ba15b7d9f8983eec = 3;
const $434b7d3d47cd8f34$export$e8c6004896aa32f6 = 4;
const $434b7d3d47cd8f34$export$4d7f2c55cadc0a4a = 5;
const $434b7d3d47cd8f34$export$c02df3b080d8417d = 6;
const $434b7d3d47cd8f34$export$ae8145c3f5ba35b7 = 7;
const $434b7d3d47cd8f34$export$96803404c380e2a = 8;
const $434b7d3d47cd8f34$export$acc926a2a95f46d7 = 9;
const $434b7d3d47cd8f34$export$b4b54c71ece86847 = 10;
const $434b7d3d47cd8f34$export$acf9a7be90f527d8 = 11;
const $434b7d3d47cd8f34$export$1e81f693c84527d0 = 12;
const $434b7d3d47cd8f34$export$4145070cc1d10c3e = 13;
const $434b7d3d47cd8f34$export$5704d4017fd1f930 = 14;
const $434b7d3d47cd8f34$export$d4918d2b67653d1a = 15;
const $434b7d3d47cd8f34$export$ceb9b5890e792f1b = 16;
const $434b7d3d47cd8f34$export$8a1ac6efe1a6669d = 17;
const $434b7d3d47cd8f34$export$683cc0d1d097f797 = 18;
const $434b7d3d47cd8f34$export$eb844ef87b6b10e8 = 19;
const $434b7d3d47cd8f34$export$9f0dfd0927548059 = 20;
const $434b7d3d47cd8f34$export$d6b68dfa7625d4dc = 9;
const $434b7d3d47cd8f34$export$435cb6d3bce09739 = 0;
const $434b7d3d47cd8f34$export$bf477ff780f58fce = 1;
const $434b7d3d47cd8f34$export$cb47675bfc2fbb46 = 2;
const $434b7d3d47cd8f34$export$e220da57dc3aa03e = 3;
const $434b7d3d47cd8f34$export$6bd75116ec90ab19 = 4;
const $434b7d3d47cd8f34$export$3783d68fadedbc71 = 5;
const $434b7d3d47cd8f34$export$2b9a595ea7306f33 = 6;
const $434b7d3d47cd8f34$export$2e4a3eb023dd7438 = 7;
const $434b7d3d47cd8f34$export$d6cb1570696215f2 = 8;
function $434b7d3d47cd8f34$export$7b85b809d53bc520(vertexCount) {
    // Control: 2 Int32 values = 8 bytes (state + swap flag)
    const controlBytes = 8;
    // Input region: INPUT_COUNT Float64 values
    const inputBytes = $434b7d3d47cd8f34$export$9f0dfd0927548059 * 8;
    // Position buffer: vertexCount * 3 (x, y, z) Float64 values each
    const posBufferBytes = vertexCount * 24;
    // Reaction forces: REACTION_COUNT Float64 values
    const reactionBytes = $434b7d3d47cd8f34$export$d6b68dfa7625d4dc * 8;
    const inputByteOffset = controlBytes;
    const posAByteOffset = inputByteOffset + inputBytes;
    const posBByteOffset = posAByteOffset + posBufferBytes;
    const reactionByteOffset = posBByteOffset + posBufferBytes;
    const totalBytes = reactionByteOffset + reactionBytes;
    return {
        totalBytes: totalBytes,
        controlByteOffset: 0,
        inputByteOffset: inputByteOffset,
        posAByteOffset: posAByteOffset,
        posBByteOffset: posBByteOffset,
        reactionByteOffset: reactionByteOffset,
        vertexCount: vertexCount
    };
}
function $434b7d3d47cd8f34$export$41f5a0aaa2cea95(vertexCount) {
    const layout = $434b7d3d47cd8f34$export$7b85b809d53bc520(vertexCount);
    return new SharedArrayBuffer(layout.totalBytes);
}
function $434b7d3d47cd8f34$export$1e14316d9e39b6dc(sab) {
    return new Int32Array(sab, 0, 2);
}
function $434b7d3d47cd8f34$export$32f3bf73ea787c9e(sab) {
    return new Float64Array(sab, 8, $434b7d3d47cd8f34$export$9f0dfd0927548059);
}
function $434b7d3d47cd8f34$export$359b961cefc669da(sab, vertexCount) {
    const layout = $434b7d3d47cd8f34$export$7b85b809d53bc520(vertexCount);
    return new Float64Array(sab, layout.posAByteOffset, vertexCount * 3);
}
function $434b7d3d47cd8f34$export$502fa86247ee480e(sab, vertexCount) {
    const layout = $434b7d3d47cd8f34$export$7b85b809d53bc520(vertexCount);
    return new Float64Array(sab, layout.posBByteOffset, vertexCount * 3);
}
function $434b7d3d47cd8f34$export$2e4a67e2dffd22ad(sab, vertexCount) {
    const layout = $434b7d3d47cd8f34$export$7b85b809d53bc520(vertexCount);
    return new Float64Array(sab, layout.reactionByteOffset, $434b7d3d47cd8f34$export$d6b68dfa7625d4dc);
}


/**
 * Main-thread handle for a cloth solver running in a Web Worker.
 * Wraps a SharedArrayBuffer and implements ClothPositionReader
 * so ClothRenderer can read positions directly.
 */ 
class $75d1d9ac1542d53b$export$9cc0ed25f76345b5 {
    constructor(sab, vertexCount, initialPositions){
        /** Which buffer is currently "front" (readable by renderer). */ this.frontIsA = true;
        this.vertexCount = vertexCount;
        this.control = (0, $434b7d3d47cd8f34$export$1e14316d9e39b6dc)(sab);
        this.input = (0, $434b7d3d47cd8f34$export$32f3bf73ea787c9e)(sab);
        this.posA = (0, $434b7d3d47cd8f34$export$359b961cefc669da)(sab, vertexCount);
        this.posB = (0, $434b7d3d47cd8f34$export$502fa86247ee480e)(sab, vertexCount);
        this.reactionBuf = (0, $434b7d3d47cd8f34$export$2e4a67e2dffd22ad)(sab, vertexCount);
        this.prevFrontPositions = new Float64Array(vertexCount * 3);
        if (initialPositions) this.prevFrontPositions.set(initialPositions);
    }
    /** Check if the worker has finished a solve since last ack. */ hasNewResults() {
        return Atomics.load(this.control, 0) === (0, $434b7d3d47cd8f34$export$4f4ee1545877b7a1);
    }
    /** Read accumulated reaction forces. Returns [tackRx, tackRy, headRx, headRy, clewRx, clewRy]. */ readReactionForces() {
        return this.reactionBuf;
    }
    /** Acknowledge results — copies current front to prev, swaps front/back, resets state to IDLE. */ ackResults() {
        // Save current front positions as "previous" for velocity estimation
        const front = this.getFrontBuffer();
        this.prevFrontPositions.set(front);
        // The worker flipped the swap flag, so our front/back swap
        const swapFlag = Atomics.load(this.control, 1);
        this.frontIsA = swapFlag !== 0; // worker wrote to back then flipped; new front is the opposite
        // Reset state to IDLE so the worker can wait again
        Atomics.store(this.control, 0, (0, $434b7d3d47cd8f34$export$cc2b4ce5f63aa8e8));
    }
    /** Write inputs to SAB and kick off the next solve. */ writeInputsAndKick(inputs) {
        this.input[0, $434b7d3d47cd8f34$export$3edd0927099186ee] = inputs.dt;
        this.input[0, $434b7d3d47cd8f34$export$feaccbb8231134be] = inputs.substeps;
        this.input[0, $434b7d3d47cd8f34$export$40d32c766e7453ee] = inputs.iterations;
        this.input[0, $434b7d3d47cd8f34$export$ba15b7d9f8983eec] = inputs.constraintDamping;
        this.input[0, $434b7d3d47cd8f34$export$e8c6004896aa32f6] = inputs.clothMass;
        this.input[0, $434b7d3d47cd8f34$export$4d7f2c55cadc0a4a] = inputs.hoistAmount;
        this.input[0, $434b7d3d47cd8f34$export$c02df3b080d8417d] = inputs.windX;
        this.input[0, $434b7d3d47cd8f34$export$ae8145c3f5ba35b7] = inputs.windY;
        this.input[0, $434b7d3d47cd8f34$export$96803404c380e2a] = inputs.liftScale;
        this.input[0, $434b7d3d47cd8f34$export$acc926a2a95f46d7] = inputs.dragScale;
        this.input[0, $434b7d3d47cd8f34$export$b4b54c71ece86847] = inputs.tackX;
        this.input[0, $434b7d3d47cd8f34$export$acf9a7be90f527d8] = inputs.tackY;
        this.input[0, $434b7d3d47cd8f34$export$1e81f693c84527d0] = inputs.tackZ;
        this.input[0, $434b7d3d47cd8f34$export$4145070cc1d10c3e] = inputs.clewX;
        this.input[0, $434b7d3d47cd8f34$export$5704d4017fd1f930] = inputs.clewY;
        this.input[0, $434b7d3d47cd8f34$export$d4918d2b67653d1a] = inputs.clewZ;
        this.input[0, $434b7d3d47cd8f34$export$ceb9b5890e792f1b] = inputs.headX;
        this.input[0, $434b7d3d47cd8f34$export$8a1ac6efe1a6669d] = inputs.headY;
        this.input[0, $434b7d3d47cd8f34$export$683cc0d1d097f797] = inputs.headZ;
        this.input[0, $434b7d3d47cd8f34$export$eb844ef87b6b10e8] = inputs.clewPinned ? 1 : 0;
        // Signal the worker to start solving
        Atomics.store(this.control, 0, (0, $434b7d3d47cd8f34$export$151e59225a043bbe));
        Atomics.notify(this.control, 0);
    }
    // ---- ClothPositionReader interface ----
    getPositionX(i) {
        return this.getFrontBuffer()[i * 3];
    }
    getPositionY(i) {
        return this.getFrontBuffer()[i * 3 + 1];
    }
    getZ(i) {
        return this.getFrontBuffer()[i * 3 + 2];
    }
    // ---- Previous positions for TellTail velocity ----
    getPrevPositionX(i) {
        return this.prevFrontPositions[i * 3];
    }
    getPrevPositionY(i) {
        return this.prevFrontPositions[i * 3 + 1];
    }
    getFrontBuffer() {
        return this.frontIsA ? this.posA : this.posB;
    }
}


var $89d031970c2f39fd$exports = {};
var $56b621a6dd25b2cb$exports = {};
"use strict";
$56b621a6dd25b2cb$exports = function(workerUrl, origin, isESM) {
    if (origin === self.location.origin) // If the worker bundle's url is on the same origin as the document,
    // use the worker bundle's own url.
    return workerUrl;
    else {
        // Otherwise, create a blob URL which loads the worker bundle with `importScripts`.
        var source = isESM ? 'import ' + JSON.stringify(workerUrl) + ';' : 'importScripts(' + JSON.stringify(workerUrl) + ');';
        return URL.createObjectURL(new Blob([
            source
        ], {
            type: 'application/javascript'
        }));
    }
};


let $89d031970c2f39fd$var$url = new URL(import.meta.resolve("IRHVe"));
$89d031970c2f39fd$exports = $56b621a6dd25b2cb$exports($89d031970c2f39fd$var$url.toString(), $89d031970c2f39fd$var$url.origin, true);


class $94ee08abd30b7ab8$export$ac63f54694fe4370 extends (0, $c59361981bac2575$export$4342ba5c6ad1f6f1) {
    constructor(){
        super(), this.id = "clothWorkerPool", this.persistenceLevel = 50, this.workers = new Map();
        // Feature-detect SharedArrayBuffer
        this.useWorkers = typeof SharedArrayBuffer !== "undefined" && typeof Atomics !== "undefined";
    }
    /**
   * Register a sail for off-thread solving.
   * Returns a handle for reading results and kicking solves.
   */ register(config) {
        if (!this.useWorkers) return new (0, $964b1eaff0db64a8$export$8cf456eb3a136b3c)(config.solver, config.indices, config.tackIdx, config.clewIdx, config.headIdx, config.luffVertices, config.vertexU, config.vertexV, config.vertexChordFrac, config.furlMode);
        const { solver: solver, vertexCount: vertexCount, indices: indices, tackIdx: tackIdx, clewIdx: clewIdx, headIdx: headIdx, luffVertices: luffVertices, vertexU: vertexU, vertexV: vertexV, furlMode: furlMode } = config;
        // Create SharedArrayBuffer
        const sab = (0, $434b7d3d47cd8f34$export$41f5a0aaa2cea95)(vertexCount);
        // Spawn worker
        const worker = new Worker($89d031970c2f39fd$exports);
        // Snapshot solver state for both handle init and worker init message
        const snapshot = solver.snapshotState();
        // Write initial positions to both SAB position buffers so reads are valid
        // immediately (before the worker has processed its init message)
        const posA = (0, $434b7d3d47cd8f34$export$359b961cefc669da)(sab, vertexCount);
        const posB = (0, $434b7d3d47cd8f34$export$502fa86247ee480e)(sab, vertexCount);
        posA.set(snapshot.positions);
        posB.set(snapshot.positions);
        // Create handle — seed prevFrontPositions from solver so first-frame velocity is zero
        const handle = new (0, $75d1d9ac1542d53b$export$9cc0ed25f76345b5)(sab, vertexCount, snapshot.positions);
        this.workers.set(handle, worker);
        // Send init message to worker
        const msg = {
            type: "init",
            sab: sab,
            vertexCount: vertexCount,
            indices: indices,
            positions: snapshot.positions,
            prevPositions: snapshot.prevPositions,
            pinned: snapshot.pinned,
            pinTargets: snapshot.pinTargets,
            skipped: snapshot.skipped,
            structA: snapshot.structA,
            structB: snapshot.structB,
            structRest: snapshot.structRest,
            shearA: snapshot.shearA,
            shearB: snapshot.shearB,
            shearRest: snapshot.shearRest,
            bendA: snapshot.bendA,
            bendB: snapshot.bendB,
            bendRest: snapshot.bendRest,
            damping: snapshot.damping,
            bendStiffness: snapshot.bendStiffness,
            constraintDamping: snapshot.constraintDamping,
            tackIdx: tackIdx,
            clewIdx: clewIdx,
            headIdx: headIdx,
            luffVertices: luffVertices,
            vertexU: new Float64Array(vertexU),
            vertexV: new Float64Array(vertexV),
            vertexChordFrac: new Float64Array(config.vertexChordFrac),
            furlMode: furlMode
        };
        worker.postMessage(msg);
        return handle;
    }
    /** Unregister a sail and terminate its worker. */ unregister(handle) {
        const worker = this.workers.get(handle);
        if (worker) {
            worker.postMessage({
                type: "destroy"
            });
            worker.terminate();
            this.workers.delete(handle);
        }
    }
    onDestroy() {
        for (const [handle, worker] of this.workers){
            worker.postMessage({
                type: "destroy"
            });
            worker.terminate();
        }
        this.workers.clear();
    }
}
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $aa1f0309d9dba6d2$export$af631764ddc44097)("destroy")
], $94ee08abd30b7ab8$export$ac63f54694fe4370.prototype, "onDestroy", null);



/**
 * Generate a triangular 2D particle mesh in normalized UV space for cloth simulation.
 * The sail is a triangle: foot (u-axis, along boom) and luff (v-axis, along mast).
 * Rows taper from footColumns at v=0 to 2 vertices at v=1.
 */ function $60d258b7c6f7ed9f$export$2779256edcb3758c(config) {
    const { footColumns: footColumns, luffRows: luffRows, taperFactor: taperFactor, zFoot: zFoot, zHead: zHead } = config;
    // Build rows: each row j has a varying number of columns that tapers
    const rowStarts = [];
    const colCounts = [];
    const positions = []; // u, v pairs
    const zHeights = [];
    let vertexCount = 0;
    for(let j = 0; j < luffRows; j++){
        const v = j / (luffRows - 1);
        const colCount = Math.max(2, Math.round(footColumns * (1 - v * taperFactor)));
        rowStarts.push(vertexCount);
        colCounts.push(colCount);
        const z = zFoot + (zHead - zFoot) * v;
        for(let i = 0; i < colCount; i++){
            const u = colCount > 1 ? i / (colCount - 1) : 0;
            positions.push(u, v);
            zHeights.push(z);
            vertexCount++;
        }
    }
    const restPositions = new Float64Array(positions);
    const zHeightsArray = new Float64Array(zHeights);
    // Collect edge vertices
    const luffVertices = [];
    const footVertices = [];
    const leechVertices = [];
    for(let j = 0; j < luffRows; j++){
        luffVertices.push(rowStarts[j]); // col 0
        leechVertices.push(rowStarts[j] + colCounts[j] - 1); // last col
    }
    for(let i = 0; i < colCounts[0]; i++)footVertices.push(rowStarts[0] + i);
    // Triangulation: stitch adjacent rows
    const indices = [];
    const edgeSet = new Set(); // track structural edges
    const structuralConstraints = [];
    const addEdge = (a, b)=>{
        const key = a < b ? `${a},${b}` : `${b},${a}`;
        if (!edgeSet.has(key)) {
            edgeSet.add(key);
            const au = restPositions[a * 2], av = restPositions[a * 2 + 1];
            const bu = restPositions[b * 2], bv = restPositions[b * 2 + 1];
            const dist = Math.hypot(bu - au, bv - av);
            structuralConstraints.push([
                a,
                b,
                dist
            ]);
        }
    };
    for(let j = 0; j < luffRows - 1; j++){
        const topStart = rowStarts[j];
        const topCount = colCounts[j];
        const botStart = rowStarts[j + 1];
        const botCount = colCounts[j + 1];
        // Walk both rows by u-parameter proximity, greedy stitching
        let ti = 0, bi = 0;
        while(ti < topCount - 1 || bi < botCount - 1){
            const topIdx = topStart + ti;
            const botIdx = botStart + bi;
            if (ti >= topCount - 1) {
                // Only bottom row can advance
                indices.push(topIdx, botIdx, botIdx + 1);
                addEdge(topIdx, botIdx);
                addEdge(botIdx, botIdx + 1);
                addEdge(topIdx, botIdx + 1);
                bi++;
            } else if (bi >= botCount - 1) {
                // Only top row can advance
                indices.push(topIdx, botIdx, topIdx + 1);
                addEdge(topIdx, botIdx);
                addEdge(topIdx, topIdx + 1);
                addEdge(botIdx, topIdx + 1);
                ti++;
            } else {
                // Both can advance - pick the one whose next vertex is closer in u
                const topU = topCount > 1 ? (ti + 1) / (topCount - 1) : 1;
                const botU = botCount > 1 ? (bi + 1) / (botCount - 1) : 1;
                if (topU <= botU) {
                    // Advance top
                    indices.push(topIdx, botIdx, topIdx + 1);
                    addEdge(topIdx, botIdx);
                    addEdge(topIdx, topIdx + 1);
                    addEdge(botIdx, topIdx + 1);
                    ti++;
                } else {
                    // Advance bottom
                    indices.push(topIdx, botIdx, botIdx + 1);
                    addEdge(topIdx, botIdx);
                    addEdge(botIdx, botIdx + 1);
                    addEdge(topIdx, botIdx + 1);
                    bi++;
                }
            }
        }
    }
    // Shear constraints: diagonals within quads formed by adjacent row pairs
    const shearConstraints = [];
    const shearSet = new Set();
    for(let j = 0; j < luffRows - 1; j++){
        const topStart = rowStarts[j];
        const topCount = colCounts[j];
        const botStart = rowStarts[j + 1];
        const botCount = colCounts[j + 1];
        // For each pair of adjacent vertices in the top row,
        // find the corresponding pair in the bottom row and add diagonals
        const minCount = Math.min(topCount, botCount);
        for(let i = 0; i < minCount - 1; i++){
            // Map i to actual vertex indices proportionally
            const ti = Math.round(i / (minCount - 1) * (topCount - 1));
            const ti2 = Math.round((i + 1) / (minCount - 1) * (topCount - 1));
            const bi = Math.round(i / (minCount - 1) * (botCount - 1));
            const bi2 = Math.round((i + 1) / (minCount - 1) * (botCount - 1));
            // Single shear diagonal per quad — both diagonals would rigid-triangulate
            // the quad and prevent in-plane shear, making the cloth too stiff.
            const a1 = topStart + ti;
            const b1 = botStart + bi2;
            const key1 = a1 < b1 ? `${a1},${b1}` : `${b1},${a1}`;
            if (!shearSet.has(key1) && !edgeSet.has(key1)) {
                shearSet.add(key1);
                const du = restPositions[b1 * 2] - restPositions[a1 * 2];
                const dv = restPositions[b1 * 2 + 1] - restPositions[a1 * 2 + 1];
                shearConstraints.push([
                    a1,
                    b1,
                    Math.hypot(du, dv)
                ]);
            }
        }
    }
    // Bend constraints: skip-one along rows and columns
    const bendConstraints = [];
    const bendSet = new Set();
    const addBend = (a, b)=>{
        const key = a < b ? `${a},${b}` : `${b},${a}`;
        if (!bendSet.has(key)) {
            bendSet.add(key);
            const du = restPositions[b * 2] - restPositions[a * 2];
            const dv = restPositions[b * 2 + 1] - restPositions[a * 2 + 1];
            bendConstraints.push([
                a,
                b,
                Math.hypot(du, dv)
            ]);
        }
    };
    // Skip-one along rows
    for(let j = 0; j < luffRows; j++){
        const start = rowStarts[j];
        const count = colCounts[j];
        for(let i = 0; i < count - 2; i++)addBend(start + i, start + i + 2);
    }
    // Skip-one along columns (luff direction)
    for(let j = 0; j < luffRows - 2; j++){
        const count0 = colCounts[j];
        const count2 = colCounts[j + 2];
        const minC = Math.min(count0, count2);
        for(let i = 0; i < minC; i++){
            const idx0 = rowStarts[j] + Math.round(i / (minC - 1) * (count0 - 1));
            const idx2 = rowStarts[j + 2] + Math.round(i / (minC - 1) * (count2 - 1));
            addBend(idx0, idx2);
        }
    }
    return {
        vertexCount: vertexCount,
        restPositions: restPositions,
        zHeights: zHeightsArray,
        indices: indices,
        structuralConstraints: structuralConstraints,
        shearConstraints: shearConstraints,
        bendConstraints: bendConstraints,
        luffVertices: luffVertices,
        footVertices: footVertices,
        leechVertices: leechVertices,
        rowStarts: rowStarts,
        colCounts: colCounts
    };
}











// Module-level scratch vectors reused across all DistanceConstraint instances
// to avoid allocating a fresh V2d on every update() call.
const $dd44cce75657a83e$var$SCRATCH_RI = (0, $6b6a54a072724620$export$e7c866399fa523f5)();
const $dd44cce75657a83e$var$SCRATCH_RJ = (0, $6b6a54a072724620$export$e7c866399fa523f5)();
const $dd44cce75657a83e$var$SCRATCH_N = (0, $6b6a54a072724620$export$e7c866399fa523f5)();
class $dd44cce75657a83e$export$7f13e3afb2fe70fe extends (0, $63235e744c2c6cbe$export$aec1359a0a40a615) {
    constructor(bodyA, bodyB, options = {}){
        // Normalize: if we have (rigid2d, pm2d), swap to (pm2d, rigid2d) so the
        // particle is always bodyA (matches PointToRigidEquation2D convention).
        let a = bodyA;
        let b = bodyB;
        let localA = options?.localAnchorA ?? [
            0,
            0
        ];
        let localB = options?.localAnchorB ?? [
            0,
            0
        ];
        if (a.shape === "rigid2d" && b.shape === "pm2d") {
            const tmp = a;
            a = b;
            b = tmp;
            const tmpL = localA;
            localA = localB;
            localB = tmpL;
        }
        super(a, b, options), /** If the upper limit is enabled or not. */ this.upperLimitEnabled = false, /** The upper constraint limit. */ this.upperLimit = 1, /** If the lower limit is enabled or not. */ this.lowerLimitEnabled = false, /** The lower constraint limit. */ this.lowerLimit = 0, /** Current distance between the world anchor points (refreshed by update()). */ this.position = 0;
        this.localAnchorA = (0, $6b6a54a072724620$export$e7c866399fa523f5)(localA[0], localA[1]);
        this.localAnchorB = (0, $6b6a54a072724620$export$e7c866399fa523f5)(localB[0], localB[1]);
        // Compute initial distance if not given — world anchor separation.
        if (typeof options.distance === "number") this.distance = options.distance;
        else {
            const ri = a.shape === "pm2d" ? $dd44cce75657a83e$var$SCRATCH_RI.set([
                0,
                0
            ]) : $dd44cce75657a83e$var$SCRATCH_RI.set(this.localAnchorA).irotate(a.angle);
            const rj = b.shape === "pm2d" ? $dd44cce75657a83e$var$SCRATCH_RJ.set([
                0,
                0
            ]) : $dd44cce75657a83e$var$SCRATCH_RJ.set(this.localAnchorB).irotate(b.angle);
            const n = $dd44cce75657a83e$var$SCRATCH_N.set(b.position).iadd(rj).isub(ri).isub(a.position);
            this.distance = n.magnitude;
        }
        const maxForce = typeof options.maxForce === "undefined" ? Number.MAX_VALUE : options.maxForce;
        this.maxForce = maxForce;
        // Pick the equation shape based on body shape tags.
        if (a.shape === "pm2d" && b.shape === "pm2d") {
            this._kind = "pp";
            this.equations = [
                new (0, $c4f03894cac5871e$export$632992fd3b57ba7)(a, b, -maxForce, maxForce)
            ];
            this._updateFn = this._updatePointToPoint.bind(this);
        } else if (a.shape === "pm2d" && b.shape === "rigid2d") {
            this._kind = "pr";
            this.equations = [
                new (0, $0db35f7ff61d3604$export$6a45afae7f6f373e)(a, b, -maxForce, maxForce)
            ];
            this._updateFn = this._updatePointToRigid.bind(this);
        } else if (a.shape === "rigid2d" && b.shape === "rigid2d") {
            this._kind = "rr";
            this.equations = [
                new (0, $a406b5b317398f9e$export$87c9791c969e8729)(a, b, -maxForce, maxForce)
            ];
            this._updateFn = this._updateRigidRigid.bind(this);
        } else throw new Error(`DistanceConstraint: unsupported 2D body shape combination: ${a.shape} + ${b.shape}`);
        this.setMaxForce(maxForce);
    }
    /** Update the constraint equations. Should be called before solving. */ update() {
        this._updateFn();
        return this;
    }
    /**
   * Check upper/lower limits against `this.position` and adjust the
   * equation's force clamps + `enabled` flag accordingly. Returns true if
   * the caller should short-circuit (constraint disabled by a slack limit).
   */ _applyLimits() {
        const eq = this.equations[0];
        let violating = false;
        if (this.upperLimitEnabled) {
            if (this.position > this.upperLimit) {
                eq.maxForce = 0;
                eq.minForce = -this.maxForce;
                this.distance = this.upperLimit;
                violating = true;
            }
        }
        if (this.lowerLimitEnabled) {
            if (this.position < this.lowerLimit) {
                eq.maxForce = this.maxForce;
                eq.minForce = 0;
                this.distance = this.lowerLimit;
                violating = true;
            }
        }
        if ((this.lowerLimitEnabled || this.upperLimitEnabled) && !violating) {
            eq.enabled = false;
            return true;
        }
        eq.enabled = true;
        return false;
    }
    /** pm2d × pm2d: no anchors, no angular. */ _updatePointToPoint() {
        const a = this.bodyA;
        const b = this.bodyB;
        const eq = this.equations[0];
        const dx = b.position[0] - a.position[0];
        const dy = b.position[1] - a.position[1];
        const len = Math.sqrt(dx * dx + dy * dy);
        this.position = len;
        if (this._applyLimits()) return;
        eq.offset = len - this.distance;
        if (len > 1e-6) {
            const inv = 1 / len;
            eq.nx = dx * inv;
            eq.ny = dy * inv;
        } else {
            eq.nx = 1;
            eq.ny = 0;
        }
    }
    /** pm2d (A) × rigid2d (B): only B has an anchor + angular contribution. */ _updatePointToRigid() {
        const a = this.bodyA;
        const b = this.bodyB;
        const eq = this.equations[0];
        // rj = localAnchorB rotated by bodyB.angle
        const rj = $dd44cce75657a83e$var$SCRATCH_RJ.set(this.localAnchorB).irotate(b.angle);
        const dx = b.position[0] + rj[0] - a.position[0];
        const dy = b.position[1] + rj[1] - a.position[1];
        const len = Math.sqrt(dx * dx + dy * dy);
        this.position = len;
        if (this._applyLimits()) return;
        eq.offset = len - this.distance;
        let nx;
        let ny;
        if (len > 1e-6) {
            const inv = 1 / len;
            nx = dx * inv;
            ny = dy * inv;
        } else {
            nx = 1;
            ny = 0;
        }
        eq.nx = nx;
        eq.ny = ny;
        // rj × n projected to Z: rj.x * n.y - rj.y * n.x
        eq.rjCrossN = rj[0] * ny - rj[1] * nx;
    }
    /** rigid2d × rigid2d: both have anchors + angular contributions. */ _updateRigidRigid() {
        const a = this.bodyA;
        const b = this.bodyB;
        const eq = this.equations[0];
        const ri = $dd44cce75657a83e$var$SCRATCH_RI.set(this.localAnchorA).irotate(a.angle);
        const rj = $dd44cce75657a83e$var$SCRATCH_RJ.set(this.localAnchorB).irotate(b.angle);
        const dx = b.position[0] + rj[0] - (a.position[0] + ri[0]);
        const dy = b.position[1] + rj[1] - (a.position[1] + ri[1]);
        const len = Math.sqrt(dx * dx + dy * dy);
        this.position = len;
        if (this._applyLimits()) return;
        eq.offset = len - this.distance;
        let nx;
        let ny;
        if (len > 1e-6) {
            const inv = 1 / len;
            nx = dx * inv;
            ny = dy * inv;
        } else {
            nx = 1;
            ny = 0;
        }
        eq.linX = nx;
        eq.linY = ny;
        // Body A angular Z: -(ri × n)
        eq.angAz = -(ri[0] * ny - ri[1] * nx);
        // Body B angular Z: +(rj × n)
        eq.angBz = rj[0] * ny - rj[1] * nx;
    }
    /** Set the max force to be used. */ setMaxForce(maxForce) {
        this.maxForce = maxForce;
        const eq = this.equations[0];
        eq.minForce = -maxForce;
        eq.maxForce = maxForce;
    }
    /** Get the max force. */ getMaxForce() {
        return this.equations[0].maxForce;
    }
}



function $9015b6c2ef849b52$export$f0954fd7d5368655(a) {
    return a;
}
function $9015b6c2ef849b52$export$4c7897fafd92b108(a) {
    return a[a.length - 1];
}
function $9015b6c2ef849b52$export$589748d90c221be3(arr) {
    const result = [];
    for(let i = 0; i < arr.length - 1; i++)result.push([
        arr[i],
        arr[i + 1]
    ]);
    return result;
}
function $9015b6c2ef849b52$export$d02631cccf789723(n) {
    const result = [];
    for(let i = 0; i < n; i++)result.push(i);
    return result;
}






// Units: feet (ft), lbs
// TellTail dimensions
const $d67011e4b6bd9ef7$var$TELLTAIL_NODES = 6;
const $d67011e4b6bd9ef7$var$TELLTAIL_NODE_MASS = 0.01; // lbs per particle (tuned for physics)
const $d67011e4b6bd9ef7$var$TELLTAIL_LENGTH = 1; // ft - total streamer length
const $d67011e4b6bd9ef7$var$SLACK_FACTOR = 1.02; // Dimensionless constraint slack
// Drag parameters
const $d67011e4b6bd9ef7$var$DRAG_SCALE = 5.0; // Dimensionless drag coefficient
// Rendering
const $d67011e4b6bd9ef7$var$TELLTAIL_WIDTH = 0.1; // ft - visual ribbon width
const $d67011e4b6bd9ef7$var$TELLTAIL_COLOR = 0xff6600;
/** No lift for a thin streamer - it just gets pushed by the wind. */ const $d67011e4b6bd9ef7$var$noLift = ()=>0;
class $d67011e4b6bd9ef7$export$132a97ff3742e9d7 extends (0, $c59361981bac2575$export$4342ba5c6ad1f6f1) {
    constructor(getAttachmentPoint, getAttachmentVelocity, getHoistAmount = ()=>1, getAttachmentZ = ()=>5){
        super(), this.layer = "boat";
        this.getAttachmentPoint = getAttachmentPoint;
        this.getAttachmentVelocity = getAttachmentVelocity;
        this.getHoistAmount = getHoistAmount;
        this.getAttachmentZ = getAttachmentZ;
        const attachPos = this.getAttachmentPoint();
        const segmentLength = $d67011e4b6bd9ef7$var$TELLTAIL_LENGTH / ($d67011e4b6bd9ef7$var$TELLTAIL_NODES - 1);
        // Create particle chain - initially laid out horizontally from attachment
        this.bodies = (0, $9015b6c2ef849b52$export$d02631cccf789723)($d67011e4b6bd9ef7$var$TELLTAIL_NODES).map((i)=>{
            const b = (0, $4aa863c0a97fa3b4$export$7d27618aebc86361)({
                motion: "dynamic",
                mass: $d67011e4b6bd9ef7$var$TELLTAIL_NODE_MASS,
                position: attachPos.add([
                    i * segmentLength,
                    0
                ]),
                collisionResponse: false
            });
            b.addShape(new (0, $5decb6115b59ebc8$export$c36c68baa13912a5)());
            return b;
        });
        // Connect adjacent particles with distance constraints
        this.constraints = (0, $9015b6c2ef849b52$export$589748d90c221be3)(this.bodies).map(([a, b])=>new (0, $dd44cce75657a83e$export$7f13e3afb2fe70fe)(a, b, {
                distance: segmentLength * $d67011e4b6bd9ef7$var$SLACK_FACTOR,
                collideConnected: false
            }));
        // Wind query for body positions (skip first which is attached)
        this.windQuery = this.addChild(new (0, $3d4e827a36d4d6ff$export$20101e03857a552b)(()=>this.getWindQueryPoints()));
    }
    /**
   * Get points to query for wind data at each body position (except first).
   */ getWindQueryPoints() {
        const points = [];
        for(let i = 1; i < this.bodies.length; i++)points.push((0, $6b6a54a072724620$export$e7c866399fa523f5)(this.bodies[i].position));
        return points;
    }
    onTick() {
        // Manually position first particle to follow the sail (one-way coupling)
        const firstBody = this.bodies[0];
        firstBody.position.set(this.getAttachmentPoint());
        firstBody.velocity.set(this.getAttachmentVelocity());
        // Need wind query results (1-frame latency)
        if (this.windQuery.results.length === 0) return;
        const drag = (0, $cc2f69d6c6f8f07b$export$b0fe55128dcf642e)($d67011e4b6bd9ef7$var$DRAG_SCALE, (0, $76df497339ed0c67$export$b2c4fea6cb9591e));
        // Apply wind forces to all particles except the first (which is fixed to sail)
        for(let i = 1; i < this.bodies.length; i++){
            const body = this.bodies[i];
            const bodyPos = body.position;
            // Get previous and next positions for edge calculation
            const prevPos = i === 0 ? this.getAttachmentPoint() : this.bodies[i - 1].position;
            const nextPos = i === this.bodies.length - 1 ? bodyPos.add(bodyPos.sub(prevPos).normalize()) // Extrapolate past end
             : this.bodies[i + 1].position;
            // Virtual edge from prev to next, expressed in body-local coordinates
            const v1Local = prevPos.sub(bodyPos);
            const v2Local = nextPos.sub(bodyPos);
            // Get wind velocity from query results (index is i-1 since we skip first body)
            const windResult = this.windQuery.results[i - 1];
            const getFluidVelocity = (_point)=>windResult.velocity;
            (0, $cc2f69d6c6f8f07b$export$f160c78967a796c6)(body, v1Local, v2Local, $d67011e4b6bd9ef7$var$noLift, drag, getFluidVelocity);
            (0, $cc2f69d6c6f8f07b$export$f160c78967a796c6)(body, v2Local, v1Local, $d67011e4b6bd9ef7$var$noLift, drag, getFluidVelocity);
        }
    }
    onRender({ draw: draw }) {
        if (this.bodies.length < 2) return;
        const hoistAmount = this.getHoistAmount();
        if (hoistAmount <= 0) return;
        const vertices = this.bodies.map((b)=>b.position.clone());
        // Use the z-height of the sail attachment point for depth
        draw.spline(vertices, {
            color: $d67011e4b6bd9ef7$var$TELLTAIL_COLOR,
            width: $d67011e4b6bd9ef7$var$TELLTAIL_WIDTH,
            z: this.getAttachmentZ()
        });
    }
}
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $aa1f0309d9dba6d2$export$af631764ddc44097)("tick")
], $d67011e4b6bd9ef7$export$132a97ff3742e9d7.prototype, "onTick", null);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $aa1f0309d9dba6d2$export$af631764ddc44097)("render")
], $d67011e4b6bd9ef7$export$132a97ff3742e9d7.prototype, "onRender", null);


//#tunable { min: 1, max: 100, step: 1 }
let $829cf18f7acab1e1$var$CLOTH_ITERATIONS = 20;
//#tunable { min: 1, max: 16, step: 1 }
let $829cf18f7acab1e1$var$CLOTH_SUBSTEPS = 4;
//#tunable { min: 0, max: 1, step: 0.01 }
let $829cf18f7acab1e1$var$CONSTRAINT_DAMPING = 0.2;
//#tunable { min: 0.1, max: 50 }
let $829cf18f7acab1e1$var$CLOTH_MASS = 8.0;
const $829cf18f7acab1e1$var$DEFAULT_CONFIG = {
    nodeMass: 1.0,
    liftScale: 1.0,
    dragScale: 1.0,
    sailShape: "boom",
    hoistSpeed: 0.4,
    color: 0xeeeeff,
    attachTellTail: true,
    clothColumns: 32,
    clothRows: 16,
    clothDamping: 1.0,
    clothIterations: 10,
    bendStiffness: 0.3,
    constraintDamping: 0.1,
    zFoot: 3,
    zHead: 20
};
class $829cf18f7acab1e1$export$b7805bbaedd56cd extends (0, $c59361981bac2575$export$4342ba5c6ad1f6f1) {
    static{
        this.FURL_QUAD_INDICES = [
            0,
            1,
            2,
            0,
            2,
            3
        ];
    }
    constructor(config){
        super(), this.layer = "boat", this.tickLayer = "sail", this.tags = [
            "sail"
        ], // Hoist state (0 = fully furled, 1 = fully deployed)
        this.hoistAmount = 0, this.hoistDirection = 0, /**
   * Lock constraint pinning the jib clew body to a hull-local anchor when
   * the sail is fully furled. Replaces the previous kinematic teleport:
   * with this in place, any force applied to the clew body (e.g., jib-sheet
   * tension) is transmitted to the hull via the constraint's solver
   * equations rather than absorbed silently.
   *
   * Null for mainsail (boom-clew) or any non-jib config. Disabled while
   * hoisted so the cloth-sim reactions own the clew position.
   */ this.furledLock = null, // Cached geometry for mapping UV to world
        this.headPos = (0, $6b6a54a072724620$export$e7c866399fa523f5)(0, 0), this.clewPos = (0, $6b6a54a072724620$export$e7c866399fa523f5)(0, 0), // Pre-allocated buffers for furled sail line quad rendering
        this.furlQuadVerts = [
            [
                0,
                0
            ],
            [
                0,
                0
            ],
            [
                0,
                0
            ],
            [
                0,
                0
            ]
        ], this.furlQuadZ = [
            0,
            0,
            0,
            0
        ], /** Total reaction force magnitude from all pins (lbf). Updated each tick. */ this._totalReactionForce = 0, /** Damage multiplier applied to liftScale (1.0 = no damage) */ this.getDamageMultiplier = ()=>1, this._clothSolveToken = null;
        this.config = {
            ...$829cf18f7acab1e1$var$DEFAULT_CONFIG,
            ...config
        };
        const { getHeadPosition: getHeadPosition, initialClewPosition: initialClewPosition, getClewPosition: getClewPosition, clothColumns: clothColumns, clothRows: clothRows, clothDamping: clothDamping, clothIterations: clothIterations, bendStiffness: bendStiffness, zFoot: zFoot, zHead: zHead, sailShape: sailShape, attachTellTail: attachTellTail } = this.config;
        // Generate mesh
        const taperFactor = 1.0;
        this.mesh = (0, $60d258b7c6f7ed9f$export$2779256edcb3758c)({
            footColumns: clothColumns,
            luffRows: clothRows,
            taperFactor: taperFactor,
            zFoot: zFoot,
            zHead: zHead
        });
        // Extract per-vertex UV from mesh for furling
        this.vertexU = new Float64Array(this.mesh.vertexCount);
        this.vertexV = new Float64Array(this.mesh.vertexCount);
        this.vertexChordFrac = new Float64Array(this.mesh.vertexCount);
        const footColCount = this.mesh.colCounts[0];
        for(let j = 0; j < this.mesh.colCounts.length; j++){
            const cf = (this.mesh.colCounts[j] - 1) / Math.max(1, footColCount - 1);
            const start = this.mesh.rowStarts[j];
            for(let c = 0; c < this.mesh.colCounts[j]; c++)this.vertexChordFrac[start + c] = cf;
        }
        for(let i = 0; i < this.mesh.vertexCount; i++){
            this.vertexU[i] = this.mesh.restPositions[i * 2];
            this.vertexV[i] = this.mesh.restPositions[i * 2 + 1];
        }
        this.furlMode = sailShape === "boom" ? "v-cutoff" : "u-wrap";
        this.vertexActive = new Uint8Array(this.mesh.vertexCount);
        // Create cloth solver (used for initial position computation, then handed off)
        this.solver = new (0, $a51afe1ae1598db3$export$9803b909cc610fc)(this.mesh, {
            damping: clothDamping,
            constraintIterations: clothIterations,
            bendStiffness: bendStiffness,
            constraintDamping: this.config.constraintDamping
        });
        // Create cloth renderer
        this.clothRenderer = new (0, $dd84229691ec56ab$export$469e2ca99fadb59)(this.mesh.vertexCount, this.mesh.indices);
        // Initialize cloth positions in world space
        const head = getHeadPosition();
        const initialClew = initialClewPosition ?? getClewPosition?.() ?? head;
        this.headPos.set(head);
        this.clewPos.set(initialClew);
        const worldX = new Float64Array(this.mesh.vertexCount);
        const worldY = new Float64Array(this.mesh.vertexCount);
        const worldZ = new Float64Array(this.mesh.vertexCount);
        // Initialize at full height so rest lengths match the hoisted sail shape
        this.mapUVToWorld(head, initialClew, worldX, worldY, worldZ);
        this.solver.initializePositions(worldX, worldY, worldZ);
        // Collapse to lowered state — all Z at zFoot, XY along the boom.
        // Rest lengths are preserved, so constraints will pull the cloth
        // into the correct shape as the head pin rises during hoisting.
        worldZ.fill(zFoot);
        this.solver.resetPositions(worldX, worldY, worldZ);
        // Pin all luff vertices to the mast/forestay
        this.tackIdx = this.mesh.footVertices[0]; // (u=0, v=0)
        this.clewIdx = this.mesh.footVertices[this.mesh.footVertices.length - 1]; // (u=1, v=0)
        this.headIdx = this.mesh.luffVertices[this.mesh.luffVertices.length - 1]; // (u=0, v=1)
        for (const luffIdx of this.mesh.luffVertices)this.solver.setPinned(luffIdx, true);
        if (sailShape === "boom") // Mainsail: clew pinned to boom end
        this.solver.setPinned(this.clewIdx, true);
        // For jib: create a 6DOF Body for the clew (last vertex of foot row)
        // to couple with 3D sheet constraints. The clew is pinned in the cloth sim
        // and reaction forces are applied to this body, creating two-way coupling.
        if (sailShape === "triangle") {
            const clewVertexIdx = this.mesh.footVertices[this.mesh.footVertices.length - 1];
            const cx = this.solver.getPositionX(clewVertexIdx);
            const cy = this.solver.getPositionY(clewVertexIdx);
            // Mass is set high enough to stabilize the two-way coupling with the
            // cloth sim (reaction forces feed back with a one-frame delay).
            const clewMass = 5;
            const clewBody = (0, $4aa863c0a97fa3b4$export$f49b83b66b23fb37)({
                motion: "dynamic",
                mass: clewMass,
                position: [
                    cx,
                    cy
                ],
                damping: 0.9,
                collisionResponse: false,
                allowSleep: false,
                zMass: clewMass,
                z: zFoot,
                zDamping: 0.9
            });
            // No collision shape — the clew body is inside the hull polygon
            // and would collide with it. It only needs to participate in
            // constraint solving and force application.
            this.bodies = [
                clewBody
            ];
            this.constraints = [];
            // Furled-state pin: when the jib is rolled up, the clew sits at the
            // forestay alongside the head. Modelled as a PointToRigidLock that
            // stays disabled while hoisted (cloth sim owns the clew then) and
            // enables once hoistAmount drops to zero. Using a real constraint
            // here — rather than a kinematic teleport — means rope forces on the
            // clew body round-trip through the solver into the hull at the pin's
            // lever arm, preserving Newton's third law on the boat as a whole.
            const hullBodyForPin = this.config.getHullBody?.();
            if (hullBodyForPin) {
                const head = this.config.headLocalPosition;
                this.furledLock = new (0, $30a388d2d8931336$export$53bb26c88568ac39)(clewBody, hullBodyForPin, {
                    localAnchorB: [
                        head.x,
                        head.y,
                        this.config.zFoot
                    ],
                    collideConnected: true
                });
                this.furledLock.disabled = this.hoistAmount > 0;
                this.constraints.push(this.furledLock);
            }
        } else {
            this.bodies = [];
            this.constraints = [];
        }
        // Wind query at sail centroid
        this.windQuery = this.addChild(new (0, $3d4e827a36d4d6ff$export$20101e03857a552b)(()=>{
            if (this.hoistAmount <= 0) return [];
            const head = this.config.getHeadPosition();
            const clew = this.getClewPositionFromConfig();
            return [
                head.add(clew.sub(head).mul(0.33))
            ];
        }));
        // Attach tell tails along the leech (trailing edge) at 1/4, 1/2, 3/4 height
        if (attachTellTail) {
            const leech = this.mesh.leechVertices;
            const reader = ()=>this.handle ?? this.solver;
            for (const frac of [
                0.25,
                0.5,
                0.75
            ]){
                const leechIdx = leech[Math.round(frac * (leech.length - 1))];
                this.addChild(new (0, $d67011e4b6bd9ef7$export$132a97ff3742e9d7)(()=>(0, $6b6a54a072724620$export$e7c866399fa523f5)(reader().getPositionX(leechIdx), reader().getPositionY(leechIdx)), ()=>{
                    const r = reader();
                    const dx = r.getPositionX(leechIdx) - r.getPrevPositionX(leechIdx);
                    const dy = r.getPositionY(leechIdx) - r.getPrevPositionY(leechIdx);
                    return (0, $6b6a54a072724620$export$e7c866399fa523f5)(dx * 120, dy * 120);
                }, ()=>this.vertexActive[leechIdx] ? this.hoistAmount : 0, ()=>reader().getZ(leechIdx)));
            }
        }
    }
    onAdd() {
        // Register with the ClothWorkerPool to get an off-thread (or sync fallback) handle
        const pool = this.game.entities.getSingleton((0, $94ee08abd30b7ab8$export$ac63f54694fe4370));
        this.handle = pool.register({
            solver: this.solver,
            vertexCount: this.mesh.vertexCount,
            indices: this.mesh.indices,
            tackIdx: this.tackIdx,
            clewIdx: this.clewIdx,
            headIdx: this.headIdx,
            luffVertices: this.mesh.luffVertices,
            vertexU: this.vertexU,
            vertexV: this.vertexV,
            vertexChordFrac: this.vertexChordFrac,
            furlMode: this.furlMode
        });
    }
    /**
   * Map UV mesh positions to initial 3D world positions.
   *
   * The sail is a triangle in 3D:
   *   Tack  (u=0, v=0) → (tack_x, tack_y, zFoot)
   *   Clew  (u=1, v=0) → (clew_x, clew_y, zFoot)
   *   Head  (u=0, v=1) → (luffTop_x, luffTop_y, zHead)
   *
   * u interpolates along the chord (foot direction) in x,y, tapered by row.
   * v interpolates z from zFoot to zHead and shifts luff XY from tack to luffTop.
   * For mainsails, tack and luffTop have the same XY (mast). For jibs, the luff
   * runs diagonally from bowsprit (tack) to masthead (luffTop) along the forestay.
   */ mapUVToWorld(tack, clew, outX, outY, outZ) {
        const footX = clew.x - tack.x;
        const footY = clew.y - tack.y;
        const { zFoot: zFoot, zHead: zHead } = this.config;
        // Compute luffTop in world space (forestay head / masthead).
        // For mainsails this is the same as the tack XY (vertical mast).
        // For jibs this is the mast position (diagonal forestay).
        let luffTopWorld = null;
        if (this.config.luffTopLocalPosition) {
            const hullBody = this.config.getHullBody?.();
            if (hullBody) {
                const [ltx, lty] = hullBody.toWorldFrame(this.config.luffTopLocalPosition);
                luffTopWorld = (0, $6b6a54a072724620$export$e7c866399fa523f5)(ltx, lty);
            } else luffTopWorld = (0, $6b6a54a072724620$export$e7c866399fa523f5)(this.config.luffTopLocalPosition.x, this.config.luffTopLocalPosition.y);
        }
        const footColCount = this.mesh.colCounts[0];
        for(let j = 0; j < this.mesh.colCounts.length; j++){
            const rowStart = this.mesh.rowStarts[j];
            const colCount = this.mesh.colCounts[j];
            const chordFrac = (colCount - 1) / Math.max(1, footColCount - 1);
            const v = j / (this.mesh.colCounts.length - 1);
            // Luff base XY at this row: lerp from tack to luffTop (forestay diagonal)
            const luffX = luffTopWorld ? tack.x + v * (luffTopWorld.x - tack.x) : tack.x;
            const luffY = luffTopWorld ? tack.y + v * (luffTopWorld.y - tack.y) : tack.y;
            for(let c = 0; c < colCount; c++){
                const i = rowStart + c;
                const u = colCount > 1 ? c / (colCount - 1) : 0;
                // x,y: from luff base along the chord, tapered by row height
                outX[i] = luffX + u * footX * chordFrac;
                outY[i] = luffY + u * footY * chordFrac;
                // z: interpolate from zFoot to zHead by row
                outZ[i] = zFoot + v * (zHead - zFoot);
            }
        }
    }
    /** Get head body - for mainsail, returns the head constraint body. For jib, returns first body or constraint body */ getHead() {
        return this.config.headConstraint.body;
    }
    /** Get clew body - for jib returns the Body; for mainsail returns the clew constraint body */ getClew() {
        if (this.bodies.length > 0) return this.bodies[0]; // jib clew Body
        // Mainsail: clew is on the boom, use clewConstraint body
        return this.config.clewConstraint?.body ?? this.config.headConstraint.body;
    }
    /** Get current head position */ getHeadPosition() {
        return this.config.getHeadPosition();
    }
    /** Get current clew position - from config or from cloth handle */ getClewPosition() {
        if (this.config.getClewPosition) return this.config.getClewPosition();
        // Read from handle - clew is the last vertex of foot row
        return (0, $6b6a54a072724620$export$e7c866399fa523f5)(this.handle.getPositionX(this.clewIdx), this.handle.getPositionY(this.clewIdx));
    }
    /** Check if sail is hoisted (or hoisting) */ isHoisted() {
        return this.hoistAmount > 0.5;
    }
    /** Get current hoist amount (0 = furled, 1 = deployed) */ getHoistAmount() {
        return this.hoistAmount;
    }
    /**
   * Z-height of the sail head at the current hoist state (ft). Interpolates
   * from `zFoot` (fully furled — head rides down at the boom) to `zHead`
   * (fully hoisted — head at the masthead).
   */ getHeadZ() {
        const { zFoot: zFoot, zHead: zHead } = this.config;
        return zFoot + this.hoistAmount * (zHead - zFoot);
    }
    /** Set hoist direction: 1 = hoisting, -1 = furling, 0 = hold position */ setHoistInput(direction) {
        this.hoistDirection = direction;
    }
    getTotalReactionForce() {
        return this._totalReactionForce;
    }
    setDamageMultiplier(fn) {
        this.getDamageMultiplier = fn;
    }
    /**
   * onTick runs on the "sail" tick layer, BEFORE physics.
   * Reads results from the previous tick's worker solve and applies reaction forces.
   */ onTick({ dt: dt }) {
        const { hoistSpeed: hoistSpeed, sailShape: sailShape } = this.config;
        // Ramp hoist amount based on input direction
        if (this.hoistDirection !== 0) this.hoistAmount = (0, $2172aedd5a25ff17$export$7d15b64cf5a3a4c4)(this.hoistAmount + this.hoistDirection * hoistSpeed * dt);
        // Furled-state pin: enable the lock constraint when the jib is rolled up
        // so the clew rides at the forestay, disable it otherwise so the cloth
        // sim's reaction forces own the clew's position. The constraint solver
        // handles the actual positioning during the physics step — no kinematic
        // teleport needed, and rope forces on the clew transfer cleanly to the
        // hull via the pin's lever arm.
        if (this.furledLock) this.furledLock.disabled = this.hoistAmount > 0;
        // Read results from the worker's previous solve (one-tick lag)
        if (this.handle.hasNewResults()) {
            if (this._clothSolveToken) {
                (0, $87110bde7a27e156$export$c160a1ab3b49575c).endAsync(this._clothSolveToken);
                this._clothSolveToken = null;
            }
            const reactions = this.handle.readReactionForces();
            const vertexMass = $829cf18f7acab1e1$var$CLOTH_MASS / this.mesh.vertexCount;
            // Feed reaction forces from pinned vertices to constraint bodies.
            // Reaction forces are summed across sub-steps; divide by substeps to average.
            const { headConstraint: headConstraint, clewConstraint: clewConstraint } = this.config;
            const vm = vertexMass / $829cf18f7acab1e1$var$CLOTH_SUBSTEPS;
            const tackRx = reactions[0, $434b7d3d47cd8f34$export$435cb6d3bce09739] * vm;
            const tackRy = reactions[0, $434b7d3d47cd8f34$export$bf477ff780f58fce] * vm;
            const tackRz = reactions[0, $434b7d3d47cd8f34$export$cb47675bfc2fbb46] * vm;
            const headRx = reactions[0, $434b7d3d47cd8f34$export$e220da57dc3aa03e] * vm;
            const headRy = reactions[0, $434b7d3d47cd8f34$export$6bd75116ec90ab19] * vm;
            const headRz = reactions[0, $434b7d3d47cd8f34$export$3783d68fadedbc71] * vm;
            const clewRx = reactions[0, $434b7d3d47cd8f34$export$2b9a595ea7306f33] * vm;
            const clewRy = reactions[0, $434b7d3d47cd8f34$export$2e4a3eb023dd7438] * vm;
            const clewRz = reactions[0, $434b7d3d47cd8f34$export$d6cb1570696215f2] * vm;
            // Total reaction force magnitude across all pins (for damage tracking)
            this._totalReactionForce = Math.hypot(tackRx, tackRy, tackRz) + Math.hypot(headRx, headRy, headRz) + Math.hypot(clewRx, clewRy, clewRz);
            // Only feed reactions into rigid bodies while hoisted. When furled the
            // worker still runs so cloth positions track the boat, but any reaction
            // it produces is from tracking drag, not sail load — applying it would
            // push the hull/boom for no reason.
            if (this.hoistAmount > 0) {
                // Tack + head both attach at the mast (headConstraint)
                const hBody = headConstraint.body;
                hBody.applyForce3D(tackRx + headRx, tackRy + headRy, tackRz + headRz, headConstraint.localAnchor.x, headConstraint.localAnchor.y, 0);
                // Clew reaction forces — apply to constraint body (mainsail: boom)
                // or directly to the clew body (jib: free body constrained by sheets)
                if (clewConstraint) {
                    const cBody = clewConstraint.body;
                    cBody.applyForce3D(clewRx, clewRy, clewRz, clewConstraint.localAnchor.x, clewConstraint.localAnchor.y, 0);
                } else if (sailShape === "triangle" && this.bodies.length > 0) {
                    const cBody = this.bodies[0];
                    cBody.applyForce3D(clewRx, clewRy, clewRz, 0, 0, 0);
                }
            } else this._totalReactionForce = 0;
            this.handle.ackResults();
        }
    }
    /**
   * onAfterPhysicsStep runs AFTER physics.
   * Gathers fresh pin targets from post-physics body positions and kicks off
   * the next worker solve (non-blocking).
   */ onAfterPhysicsStep(dt) {
        // Furled clew pin is now enforced by `furledLock` during the solver
        // step, so no post-physics teleport is needed. (The constraint
        // transmits rope forces to the hull correctly; a teleport would
        // silently discard them.)
        const { sailShape: sailShape, liftScale: liftScale, dragScale: dragScale } = this.config;
        // Apply damage multiplier to lift (damaged sails produce less drive)
        const effectiveLiftScale = liftScale * this.getDamageMultiplier();
        // Get hull body for 3D pin targets (or use identity-like defaults when no body)
        const hullBody = this.config.getHullBody?.();
        const local = this.config.headLocalPosition;
        // Update pin targets for 3 pinned vertices: tack, clew, head
        const head = this.config.getHeadPosition();
        const clew = this.getClewPositionFromConfig();
        this.headPos.set(head);
        this.clewPos.set(clew);
        // Tack (u=0, v=0): at mast/forestay junction, z=zFoot — transformed to heeled 3D
        let tackX, tackY, tackZ;
        if (hullBody) {
            // toWorldFrame3D includes body.z in Z; subtract it to get rotation-only Z
            // (the cloth sim works in its own coordinate frame, not absolute world height)
            [tackX, tackY, tackZ] = hullBody.toWorldFrame3D(local.x, local.y, this.config.zFoot);
            tackZ -= hullBody.z;
        } else {
            tackX = local.x;
            tackY = local.y;
            tackZ = this.config.zFoot;
        }
        // Clew (u=1, v=0): position depends on sail type
        let clewX, clewY, clewZ;
        if (sailShape === "triangle" && this.bodies.length > 0) {
            // Jib: use the clew body's physics position as the pin target.
            // The sheet constrains this body, so when trimmed the body moves
            // inward → cloth sim pins the vertex to the new position → wind
            // pushes back via reaction forces → equilibrium.
            const clewBody = this.bodies[0];
            clewX = clewBody.position[0];
            clewY = clewBody.position[1];
            // Z from the body's 6DOF position, minus hull heave (cloth sim frame)
            clewZ = clewBody.z - (hullBody?.z ?? 0);
        } else {
            // Mainsail: clew at boom end. The boom body is 6DOF with its
            // orientation kinematically slaved to the hull (Rig.syncOrientationToHull),
            // so toWorldFrame3D returns the 3D boom end position directly.
            const boomBody = this.config.clewConstraint?.body;
            const clewLocal = this.config.clewConstraint?.localAnchor;
            if (boomBody && clewLocal) {
                const [bcx, bcy, bcz] = boomBody.toWorldFrame3D(clewLocal.x, clewLocal.y, 0);
                clewX = bcx;
                clewY = bcy;
                // Cloth sim frame: subtract hull heave like the jib pin does
                clewZ = bcz - (hullBody?.z ?? 0);
            } else {
                clewX = clew.x;
                clewY = clew.y;
                clewZ = this.config.zFoot;
            }
        }
        // Head (u=0, v=1): full mast/forestay top position — worker uses hoistAmount
        // to determine the active region and interpolate luff pin targets.
        // For jibs, luffTopLocalPosition is at the mast (different XY from the tack
        // at the bowsprit), so the luff runs diagonally along the forestay.
        const luffTop = this.config.luffTopLocalPosition ?? local;
        let headWX, headWY, headWZ;
        if (hullBody) {
            [headWX, headWY, headWZ] = hullBody.toWorldFrame3D(luffTop.x, luffTop.y, this.config.zHead);
            headWZ -= hullBody.z;
        } else {
            headWX = luffTop.x;
            headWY = luffTop.y;
            headWZ = this.config.zHead;
        }
        // Sample wind
        let windX = 0, windY = 0;
        if (this.hoistAmount > 0 && this.windQuery.length > 0) {
            const wind = this.windQuery.get(0).velocity;
            windX = wind.x;
            windY = wind.y;
        }
        // Kick off worker solve and start async profiling
        this._clothSolveToken = (0, $87110bde7a27e156$export$c160a1ab3b49575c).startAsync("Cloth.solve");
        this.handle.writeInputsAndKick({
            dt: dt,
            substeps: $829cf18f7acab1e1$var$CLOTH_SUBSTEPS,
            iterations: $829cf18f7acab1e1$var$CLOTH_ITERATIONS,
            constraintDamping: $829cf18f7acab1e1$var$CONSTRAINT_DAMPING,
            clothMass: $829cf18f7acab1e1$var$CLOTH_MASS,
            hoistAmount: this.hoistAmount,
            windX: windX,
            windY: windY,
            liftScale: effectiveLiftScale,
            dragScale: dragScale,
            tackX: tackX,
            tackY: tackY,
            tackZ: tackZ,
            clewX: clewX,
            clewY: clewY,
            clewZ: clewZ,
            headX: headWX,
            headY: headWY,
            headZ: headWZ,
            clewPinned: true
        });
    // The jib clew body is a real 3D physics body — sheet constraints and
    // cloth 3D reaction forces find equilibrium in all three axes.
    }
    /** Get clew position from config (for boom/constraint based sails) */ getClewPositionFromConfig() {
        if (this.config.getClewPosition) return this.config.getClewPosition();
        if (this.config.initialClewPosition) return this.config.initialClewPosition;
        return this.config.getHeadPosition();
    }
    onRender({ draw: draw }) {
        // Draw furled sail as a white line along the boom/forestay.
        // Min width matches the spar it wraps; drawn slightly above to stay visible.
        if (this.hoistAmount < 1) {
            const hullBody = this.config.getHullBody?.();
            const sparWidth = this.furlMode === "v-cutoff" ? 0.5 : 0.1;
            const furlWidth = sparWidth + 0.5 * (1 - this.hoistAmount);
            // The furled sail wraps around the spar, sitting slightly above its surface.
            const zBump = 0.05;
            let x1, y1, z1;
            let x2, y2, z2;
            let valid = false;
            if (this.furlMode === "v-cutoff") {
                // Mainsail: line along the boom from mast to boom end. The boom body
                // is 6DOF, locked to the hull's tilt, so toWorldFrame3D gives the
                // correct 3D position at both endpoints.
                const clewLocal = this.config.clewConstraint?.localAnchor;
                const boomBody = this.config.clewConstraint?.body;
                if (boomBody && clewLocal) {
                    [x1, y1, z1] = boomBody.toWorldFrame3D(0, 0, zBump);
                    [x2, y2, z2] = boomBody.toWorldFrame3D(clewLocal.x, clewLocal.y, zBump);
                    valid = true;
                } else x1 = y1 = z1 = x2 = y2 = z2 = 0;
            } else {
                // Jib: line along the forestay from bowsprit tip to mast top
                const local = this.config.headLocalPosition;
                const luffTop = this.config.luffTopLocalPosition ?? local;
                if (hullBody) {
                    [x1, y1, z1] = hullBody.toWorldFrame3D(local.x, local.y, this.config.zFoot + zBump);
                    [x2, y2, z2] = hullBody.toWorldFrame3D(luffTop.x, luffTop.y, this.config.zHead + zBump);
                    valid = true;
                } else x1 = y1 = z1 = x2 = y2 = z2 = 0;
            }
            if (valid) {
                // Build a quad perpendicular to the line with per-vertex z
                const dx = x2 - x1;
                const dy = y2 - y1;
                const len = Math.sqrt(dx * dx + dy * dy);
                if (len > 1e-6) {
                    const hw = furlWidth / 2;
                    const nx = -dy / len * hw;
                    const ny = dx / len * hw;
                    this.furlQuadVerts[0][0] = x1 + nx;
                    this.furlQuadVerts[0][1] = y1 + ny;
                    this.furlQuadVerts[1][0] = x2 + nx;
                    this.furlQuadVerts[1][1] = y2 + ny;
                    this.furlQuadVerts[2][0] = x2 - nx;
                    this.furlQuadVerts[2][1] = y2 - ny;
                    this.furlQuadVerts[3][0] = x1 - nx;
                    this.furlQuadVerts[3][1] = y1 - ny;
                    this.furlQuadZ[0] = z1;
                    this.furlQuadZ[1] = z2;
                    this.furlQuadZ[2] = z2;
                    this.furlQuadZ[3] = z1;
                    draw.renderer.submitTrianglesWithZ(this.furlQuadVerts, $829cf18f7acab1e1$export$b7805bbaedd56cd.FURL_QUAD_INDICES, 0xffffff, 0.9, this.furlQuadZ);
                }
            }
        }
        if (this.hoistAmount <= 0) return;
        // Compute vertex active flags for rendering
        const active = this.vertexActive;
        if (this.furlMode === "v-cutoff") for(let i = 0; i < this.mesh.vertexCount; i++)active[i] = this.vertexV[i] <= this.hoistAmount ? 1 : 0;
        else {
            const wrapThreshold = 1 - this.hoistAmount;
            for(let i = 0; i < this.mesh.vertexCount; i++)active[i] = this.vertexU[i] >= wrapThreshold ? 1 : 0;
        }
        const { color: color } = this.config;
        const alpha = 1.0;
        const timeOfDay = this.game.entities.tryGetSingleton((0, $4df5c29ec7839388$export$1467403458327a44)) ?? null;
        this.clothRenderer.render(this.handle, draw, color, alpha, timeOfDay, active);
        // Draw a line along the leech (trailing edge) to give the sail more definition.
        // Each segment uses the average z of its endpoints so the line sits on the
        // sail surface rather than at z=0 (which would be behind the sail mesh).
        const leech = this.mesh.leechVertices;
        for(let i = 0; i < leech.length - 1; i++){
            const a = leech[i];
            const b = leech[i + 1];
            // Skip inactive leech segments
            if (!active[a] || !active[b]) continue;
            const z = (this.handle.getZ(a) + this.handle.getZ(b)) / 2;
            draw.line(this.handle.getPositionX(a), this.handle.getPositionY(a), this.handle.getPositionX(b), this.handle.getPositionY(b), {
                color: 0xffffff,
                alpha: 0.95,
                width: 0.15,
                z: z
            });
        }
    }
    onDestroy() {
        if (this.isDestroyed) return;
        const pool = this.game.entities.tryGetSingleton((0, $94ee08abd30b7ab8$export$ac63f54694fe4370));
        if (pool && this.handle) pool.unregister(this.handle);
    }
}
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $aa1f0309d9dba6d2$export$af631764ddc44097)("add")
], $829cf18f7acab1e1$export$b7805bbaedd56cd.prototype, "onAdd", null);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $aa1f0309d9dba6d2$export$af631764ddc44097)("tick")
], $829cf18f7acab1e1$export$b7805bbaedd56cd.prototype, "onTick", null);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $aa1f0309d9dba6d2$export$af631764ddc44097)("afterPhysicsStep")
], $829cf18f7acab1e1$export$b7805bbaedd56cd.prototype, "onAfterPhysicsStep", null);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $aa1f0309d9dba6d2$export$af631764ddc44097)("render")
], $829cf18f7acab1e1$export$b7805bbaedd56cd.prototype, "onRender", null);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $aa1f0309d9dba6d2$export$af631764ddc44097)("destroy")
], $829cf18f7acab1e1$export$b7805bbaedd56cd.prototype, "onDestroy", null);


const $d9694b9d28aa2066$var$GRAVITY = 32.174; // ft/s²
class $d9694b9d28aa2066$export$5a9e73b136955cd3 extends (0, $c59361981bac2575$export$4342ba5c6ad1f6f1) {
    constructor(hull, config){
        super(), this.hull = hull, this.layer = "boat";
        const { mastPosition: mastPosition, boomLength: boomLength, boomWidth: boomWidth, boomMass: boomMass, colors: colors, mainsail: mainsail } = config;
        this.mastPosition = mastPosition;
        this.boomLength = boomLength;
        this.boomWidth = boomWidth;
        this.boomMass = boomMass;
        this.boomZ = mainsail.zFoot ?? 3;
        this.mastTopZ = mainsail.zHead ?? 20;
        this.mastColor = colors.mast;
        this.boomColor = colors.boom;
        this.stays = config.stays;
        // Boom physics body — 6DOF so the 3D revolute joint can lock its
        // orientation to the hull's (hinge around the mast axis). Pivot is at
        // origin, boom extends in -x direction.
        const [mastWorldX, mastWorldY, mastWorldZ] = hull.body.toWorldFrame3D(mastPosition.x, mastPosition.y, this.boomZ);
        // Moments of inertia about the pivot end (the body's origin is at the
        // mast, so roll/pitch rotate about the pivot, not the boom's CoM).
        // For a uniform rod of length L pivoted at one end: I = m L² / 3.
        // Roll is about the boom's long axis, so it's dominated by width, not length.
        const pitchInertia = boomMass * boomLength * boomLength / 3;
        const rollInertia = boomMass * boomWidth * boomWidth / 3;
        this.body = (0, $4aa863c0a97fa3b4$export$d8062929709d2dca)({
            motion: "dynamic",
            mass: boomMass,
            position: [
                mastWorldX,
                mastWorldY
            ],
            rollInertia: rollInertia,
            pitchInertia: pitchInertia,
            zMass: boomMass,
            z: mastWorldZ
        });
        this.body.addShape(new (0, $7cebb72687875576$export$e71c4d32a2263218)({
            width: boomLength,
            height: boomWidth
        }), [
            -boomLength / 2,
            0
        ]);
        // 3D revolute joint (hinge around the mast axis): pins the boom to the
        // hull at the mast pivot in 3D and locks the boom's roll/pitch to the
        // hull's, leaving only yaw around the mast axis free.
        this.boomConstraint = new (0, $0586da9d77e4ba3d$export$e0d4115b1d7cf6fc)(hull.body, this.body, {
            localPivotA: [
                mastPosition.x,
                mastPosition.y,
                this.boomZ
            ],
            localPivotB: [
                0,
                0,
                0
            ],
            collideConnected: false
        });
        this.constraints = [
            this.boomConstraint
        ];
        // Create mainsail
        this.sail = this.addChild(new (0, $829cf18f7acab1e1$export$b7805bbaedd56cd)({
            ...mainsail,
            getHeadPosition: ()=>this.getMastWorldPosition(),
            headLocalPosition: mastPosition,
            getClewPosition: ()=>this.getBoomEndWorldPosition(),
            headConstraint: {
                body: hull.body,
                localAnchor: mastPosition
            },
            clewConstraint: {
                body: this.body,
                localAnchor: (0, $6b6a54a072724620$export$e7c866399fa523f5)(-boomLength, 0)
            },
            getHullBody: ()=>this.hull.body
        }));
    }
    onTick() {
        // Gravity at the boom's CoM (midpoint of the rod along its local x-axis).
        // The revolute joint locks roll/pitch to the hull, so the resulting
        // moment transfers through the pivot and heels the hull based on boom
        // yaw — which is the physically meaningful effect of boom weight.
        if (this.boomMass > 0) this.body.applyForce3D(0, 0, -this.boomMass * $d9694b9d28aa2066$var$GRAVITY, -this.boomLength / 2, 0, 0);
    }
    /** Hull-local mast position. */ getMastPosition() {
        return this.mastPosition;
    }
    /** Z-height of mast top. */ getMastTopZ() {
        return this.mastTopZ;
    }
    /** Z-height of the boom. */ getBoomZ() {
        return this.boomZ;
    }
    /** Boom width in ft. */ getBoomWidth() {
        return this.boomWidth;
    }
    /** Mast visual color. */ getMastColor() {
        return this.mastColor;
    }
    /** Boom visual color. */ getBoomColor() {
        return this.boomColor;
    }
    /** Stay attachment config. */ getStays() {
        return this.stays;
    }
    getMastWorldPosition() {
        const [x, y] = this.hull.body.position;
        return this.mastPosition.rotate(this.hull.body.angle).iadd([
            x,
            y
        ]);
    }
    getBoomEndWorldPosition() {
        // Use the boom body's full 3D transform. The 3D revolute joint keeps
        // the boom body's orientation and z in sync with the hull's tilt, so
        // this naturally includes hull roll/pitch parallax.
        const [x, y] = this.body.toWorldFrame3D(-this.boomLength, 0, 0);
        return (0, $6b6a54a072724620$export$e7c866399fa523f5)(x, y);
    }
    getBoomLength() {
        return this.boomLength;
    }
    /**
   * Boom yaw relative to hull (around the hull's z-axis), maintained by
   * the 3D revolute joint via axis projection. Prefer this over
   * `boom.angle - hull.angle` — with hull tilt, that extraction mixes yaw
   * with tilt due to atan2 projection.
   */ getBoomRelativeYaw() {
        return this.boomConstraint.getRelativeAngle();
    }
}
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $aa1f0309d9dba6d2$export$af631764ddc44097)("tick")
], $d9694b9d28aa2066$export$5a9e73b136955cd3.prototype, "onTick", null);











// Rudder body mass — light enough to respond quickly to input,
// heavy enough for the constraint solver to be stable.
const $25e0c89662f4d37c$var$RUDDER_MASS = 5; // lbs
// Torque applied by player input to turn the rudder
const $25e0c89662f4d37c$var$STEER_TORQUE = 800;
const $25e0c89662f4d37c$var$STEER_TORQUE_FAST = 1200;
// Angular damping on the rudder body so it doesn't oscillate wildly
const $25e0c89662f4d37c$var$RUDDER_ANGULAR_DAMPING = 0.98;
class $25e0c89662f4d37c$export$73c07ddd07f99ce5 extends (0, $c59361981bac2575$export$4342ba5c6ad1f6f1) {
    constructor(hull, config){
        super(), this.hull = hull, this.layer = "boat", this.steerInput = 0, this.fastMode = false, this.getSteeringMultiplier = ()=>1, this.getSteeringBias = ()=>0, this.waterQuery = this.addChild(new (0, $2f31bbbd4b5b01e3$export$38b1d297f12cec06)(()=>this.getQueryPoints())), this.velocityCache = new Map(), this.fluidForceResults = [
            {
                fx: 0,
                fy: 0,
                localX: 0,
                localY: 0
            },
            {
                fx: 0,
                fy: 0,
                localX: 0,
                localY: 0
            }
        ], this.hydrofoilResults = Array.from({
            length: 12
        }, ()=>({
                fx: 0,
                fy: 0,
                fz: 0,
                localX: 0,
                localY: 0
            })), this.rudderVertices = [];
        this.pivotPosition = config.position;
        this.length = config.length;
        this.chord = config.chord;
        this.maxSteerAngle = config.maxSteerAngle;
        this.color = config.color;
        this.rudderZ = -config.draft;
        // Aspect ratio = span / chord. Span is the rudder blade depth (draft).
        this.aspectRatio = config.draft / config.chord;
        // Pre-allocate rudder vertices: pivot at origin, tip at (-length, 0)
        this.rudderVertices = [
            (0, $6b6a54a072724620$export$e7c866399fa523f5)(0, 0),
            (0, $6b6a54a072724620$export$e7c866399fa523f5)(-this.length, 0)
        ];
        // Create a dynamic body for the rudder blade. 6DOF so the 3D revolute
        // joint can lock its orientation (roll/pitch/z) to the hull. The pivot
        // is at the body's origin (0,0 in local space). The blade extends in
        // the -x direction (aft).
        const [pivotWorldX, pivotWorldY, pivotWorldZ] = hull.body.toWorldFrame3D(config.position.x, config.position.y, this.rudderZ);
        this.body = (0, $4aa863c0a97fa3b4$export$d8062929709d2dca)({
            motion: "dynamic",
            mass: $25e0c89662f4d37c$var$RUDDER_MASS,
            position: [
                pivotWorldX,
                pivotWorldY
            ],
            angularDamping: $25e0c89662f4d37c$var$RUDDER_ANGULAR_DAMPING,
            allowSleep: false,
            rollInertia: 1,
            pitchInertia: 1,
            zMass: $25e0c89662f4d37c$var$RUDDER_MASS,
            z: pivotWorldZ
        });
        this.body.angle = hull.body.angle;
        // Small box shape for the rudder blade
        this.body.addShape(new (0, $7cebb72687875576$export$e71c4d32a2263218)({
            width: config.length,
            height: 0.4
        }), [
            -config.length / 2,
            0
        ]);
        // 3D revolute joint: pins the rudder to the hull at the pivot in 3D
        // and locks the rudder's roll/pitch to the hull's, leaving only yaw
        // around the pivot axis free (the steering DOF).
        this.rudderConstraint = new (0, $0586da9d77e4ba3d$export$e0d4115b1d7cf6fc)(hull.body, this.body, {
            localPivotA: [
                config.position.x,
                config.position.y,
                this.rudderZ
            ],
            localPivotB: [
                0,
                0,
                0
            ],
            collideConnected: false
        });
        // Set angle limits so rudder can't spin freely
        this.rudderConstraint.setLimits(-config.maxSteerAngle, config.maxSteerAngle);
        this.constraints = [
            this.rudderConstraint
        ];
    }
    /**
   * Get query points in world space for rudder pivot and end.
   */ getQueryPoints() {
        // Pivot is at the body origin, blade tip is at (-length, 0) in body-local space
        const pivotWorld = (0, $6b6a54a072724620$export$e7c866399fa523f5)(this.body.position);
        const tipWorld = this.body.toWorldFrame((0, $6b6a54a072724620$export$e7c866399fa523f5)(-this.length, 0));
        return [
            pivotWorld,
            tipWorld
        ];
    }
    /**
   * Set steering input. Applies torque to the rudder body.
   * @param input -1 to 1 where negative = steer left, positive = steer right
   * @param fast Whether to use fast adjustment speed
   */ setSteer(input, fast = false) {
        this.steerInput = input;
        this.fastMode = fast;
    }
    getSteer() {
        // Return normalized steer position based on actual rudder angle
        if (this.maxSteerAngle === 0) return 0;
        return -(this.rudderConstraint.getRelativeAngle() / this.maxSteerAngle);
    }
    /** Get the actual angle of the rudder relative to the hull */ getRelativeAngle() {
        return this.rudderConstraint.getRelativeAngle();
    }
    onTick({ dt: dt }) {
        // Build velocity cache from query results
        this.velocityCache.clear();
        const queryPoints = this.getQueryPoints();
        for(let i = 0; i < this.waterQuery.results.length; i++){
            const point = queryPoints[i];
            if (point) {
                const key = `${point.x.toFixed(2)},${point.y.toFixed(2)}`;
                this.velocityCache.set(key, this.waterQuery.results[i].velocity);
            }
        }
        // Apply steering torque from player input
        // Negative sign: positive steerInput should rotate rudder in -angle direction
        // (turning the rudder clockwise when viewed from above steers the boat to starboard)
        const torqueMag = this.fastMode ? $25e0c89662f4d37c$var$STEER_TORQUE_FAST : $25e0c89662f4d37c$var$STEER_TORQUE;
        const steerTorque = -this.steerInput * torqueMag;
        // Apply damage bias as a constant torque pulling rudder to one side
        const biasTorque = this.getSteeringBias() * torqueMag * 0.5;
        const totalSteerTorque = steerTorque + biasTorque;
        this.body.angularForce += totalSteerTorque;
        // Counter-torque on hull: the helmsperson is inside the boat, so steering
        // is an internal force — their body absorbs the reaction. Without this,
        // the constraint reaction dumps the full steer torque into the hull as yaw.
        this.hull.body.angularForce -= totalSteerTorque;
        // Scale rudder effectiveness by heel angle — rudder lifts out at extreme heel
        const heelFactor = Math.cos(this.hull.body.roll);
        const effectiveChord = this.chord * Math.max(0.1, heelFactor);
        // Use proper foil physics with heel-adjusted chord dimension
        // Damage reduces lift (steering authority) but not drag
        const steeringMultiplier = this.getSteeringMultiplier();
        const baseLift = (0, $cc2f69d6c6f8f07b$export$17e29cb2a12a29cc)(effectiveChord);
        const lift = (params)=>baseLift(params) * steeringMultiplier;
        const drag = (0, $cc2f69d6c6f8f07b$export$42313db6ebd1acc)(effectiveChord, this.aspectRatio);
        // Get water velocity from cache or default to zero
        const getWaterVelocity = (point)=>{
            const key = `${point.x.toFixed(2)},${point.y.toFixed(2)}`;
            return this.velocityCache.get(key) ?? (0, $6b6a54a072724620$export$e7c866399fa523f5)(0, 0);
        };
        // Use the hull's roll (the rudder tilts with the hull) and the rudder
        // body's own angle (forces are computed in the rudder's frame).
        const roll = this.hull.body.roll;
        const rudderAngle = this.body.angle;
        // Compute 3D hydrofoil forces with heel decomposition
        const count = (0, $cc2f69d6c6f8f07b$export$d43fb434dfbb6108)(this.body, this.rudderVertices, roll, rudderAngle, lift, drag, getWaterVelocity, this.hydrofoilResults, this.fluidForceResults);
        // Apply horizontal force to rudder body (constraint transfers to hull
        // with correct yaw torque). Apply vertical force directly to hull body
        // at the rudder pivot, since the 2D constraint can't transfer fz.
        for(let i = 0; i < count; i++){
            const r = this.hydrofoilResults[i];
            const relPoint = this.body.vectorToWorldFrame((0, $6b6a54a072724620$export$e7c866399fa523f5)(r.localX, r.localY));
            this.body.applyForce((0, $6b6a54a072724620$export$e7c866399fa523f5)(r.fx, r.fy), relPoint);
            if (r.fz !== 0) this.hull.body.applyForce3D(0, 0, r.fz, this.pivotPosition.x, this.pivotPosition.y, this.rudderZ);
        }
    }
    /** Get rudder pivot position in hull-local coordinates */ getPosition() {
        return this.pivotPosition;
    }
    /** Get the current tiller angle offset (actual angle from physics) */ getTillerAngleOffset() {
        return this.getRelativeAngle();
    }
    /** Get angular velocity of rudder relative to hull yaw (rad/s). */ getRelativeAngularVelocity() {
        return this.body.angularVelocity - this.hull.body.angularVelocity;
    }
    /** Z-depth of the rudder blade tip. */ getRudderZ() {
        return this.rudderZ;
    }
    /** Rudder blade length (ft). */ getLength() {
        return this.length;
    }
    /** Visual color for the rudder blade. */ getColor() {
        return this.color;
    }
    setDamageEffects(steeringMultiplier, steeringBias) {
        this.getSteeringMultiplier = steeringMultiplier;
        this.getSteeringBias = steeringBias;
    }
}
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $aa1f0309d9dba6d2$export$af631764ddc44097)("tick")
], $25e0c89662f4d37c$export$73c07ddd07f99ce5.prototype, "onTick", null);









/**
 * Thin adapter that exposes a block/winch interface on top of a
 * `RopeNetwork` node. Replaces the old `Pulley` entity for the new
 * capstan-network ropes (Sheet in Phase 2, Anchor in Phase 4).
 *
 * Unlike `Pulley`, this class owns no physics constraint — the rope's
 * capstan solver handles everything. A `RopeBlock` is just a named
 * reference to a specific network node, with a convenience API for
 * winches (ratchet, trim-rate injection, working-length query).
 */ 

class $6e6c2adb4681d8ab$export$58b65ca36483d388 extends (0, $c59361981bac2575$export$4342ba5c6ad1f6f1) {
    constructor(network, body, localAnchor, config = {}){
        super();
        this.network = network;
        this.anchorBody = body;
        this.type = config.mode ?? "block";
        // Find the node on this network that matches (body, localAnchor).
        // Construction-time convenience: callers build the network first, then
        // layer RopeBlock instances over specific nodes by world anchor match.
        this.nodeIdx = $6e6c2adb4681d8ab$var$findNodeIndex(network, body, (0, $3480ec8c2fb5ff20$export$d2aa6c54a5925f01)(localAnchor));
        if (this.nodeIdx < 0) throw new Error("RopeBlock: no matching node found on the provided RopeNetwork.");
        // Apply friction and set initial winch state.
        const node = network.getNode(this.nodeIdx);
        node.mu = config.frictionCoefficient ?? 0;
        if (this.type === "winch") {
            // Default winches start in ratchet mode (matches old Pulley behavior).
            network.setWinchRatchet(this.nodeIdx, 1);
            if (config.winchMaxForce != null) node.winchMaxForce = config.winchMaxForce;
        }
    }
    /** Current world-space position of the node's anchor. */ getWorldPosition() {
        return this.anchorBody.toWorldFrame3D(this.network.getNode(this.nodeIdx).localAnchor);
    }
    /** Index of this block's node within its RopeNetwork. */ getNodeIndex() {
        return this.nodeIdx;
    }
    /**
   * Material length of rope on the "working" side of this node — the sum
   * of section lengths from node 0 to this node.
   */ getWorkingLength() {
        return this.network.getMaterialLengthAt(this.nodeIdx);
    }
    /**
   * Rearrange section lengths so the working side equals `targetLength`.
   * Only the section immediately adjacent to this node on the working
   * side changes (other sections are preserved).
   */ setWorkingLength(targetLength) {
        this.network.setWorkingLengthAt(this.nodeIdx, targetLength);
    }
    /**
   * Set winch ratchet mode.
   *  - "ratchet": rope can only flow working → tail (trim), not the reverse.
   *  - "free": rope can flow either way based on tension balance.
   */ setMode(mode) {
        if (this.type !== "winch") return;
        this.network.setWinchRatchet(this.nodeIdx, mode === "ratchet" ? 1 : 0);
    }
    /**
   * Inject a trim-direction flow rate (ft/s). Positive = working side shrinks.
   * The rate persists across ticks until changed — call with 0 to stop
   * trimming. Sheet.adjust / Anchor.raise set this every tick from player
   * input, so the persistence is invisible in practice.
   */ applyTrimRate(rate) {
        if (this.type !== "winch") return;
        this.network.setWinchFlowRate(this.nodeIdx, rate);
    }
}
/** Locate a node on the network whose (body, localAnchor) matches within ε. */ function $6e6c2adb4681d8ab$var$findNodeIndex(network, body, localAnchor) {
    const eps2 = 1e-6;
    for(let i = 0; i < network.getNodeCount(); i++){
        const node = network.getNode(i);
        if (node.body !== body) continue;
        const la = node.localAnchor;
        const dx = la[0] - localAnchor[0];
        const dy = la[1] - localAnchor[1];
        const dz = la[2] - localAnchor[2];
        if (dx * dx + dy * dy + dz * dz < eps2) return i;
    }
    return -1;
}




const $d62dd12816171ede$var$DEFAULT_CONFIG = {
    minLength: 6,
    maxLength: 35,
    ropeThickness: 0.75,
    ropeColor: 0x444444,
    winchMaxSpeed: 3,
    // Hand-winch peak force in lbf. Bounds how much tension the winch can
    // drive into the rope before stalling; prevents a player cranking
    // against a taut sheet from generating runaway yaw torque on the hull.
    winchForce: 250,
    ropeDiameter: 0.026
};
class $d62dd12816171ede$export$a9bf29f8d87ebbee extends (0, $c59361981bac2575$export$4342ba5c6ad1f6f1) {
    constructor(bodyA, localAnchorA, bodyB, localAnchorB, config = {}, waypoints = [], // Rendering-only hull plumbing: the RopeRender uses these to clamp
    // sample z-values above the deck surface.
    getDeckHeight, hullBoundary){
        super(), this.localAnchorA = localAnchorA, this.localAnchorB = localAnchorB, this.getDeckHeight = getDeckHeight, this.hullBoundary = hullBoundary, this.layer = "boat", this.winch = null, this.blocks = [], this.opacity = 1.0, this.winchAngle = 0, this.prevWorkingLength = -1, this.tickCount = 0;
        this.config = {
            ...$d62dd12816171ede$var$DEFAULT_CONFIG,
            ...config
        };
        this.hullBody = bodyB;
        // Compute total path distance so we can size the rope.
        const pathPoints = [
            bodyA.toWorldFrame((0, $6b6a54a072724620$export$e7c866399fa523f5)(localAnchorA[0], localAnchorA[1])),
            ...waypoints.map((w)=>w.body.toWorldFrame((0, $6b6a54a072724620$export$e7c866399fa523f5)(w.localAnchor[0], w.localAnchor[1]))),
            bodyB.toWorldFrame((0, $6b6a54a072724620$export$e7c866399fa523f5)(localAnchorB[0], localAnchorB[1]))
        ];
        let totalPathDist = 0;
        for(let i = 0; i < pathPoints.length - 1; i++){
            const dx = pathPoints[i + 1][0] - pathPoints[i][0];
            const dy = pathPoints[i + 1][1] - pathPoints[i][1];
            totalPathDist += Math.sqrt(dx * dx + dy * dy);
        }
        // Total rope length: enough for max working length plus tail.
        const totalRopeLength = Math.max(this.config.maxLength * 1.3, totalPathDist * 1.3);
        // Build node specs: [clew endpoint, ...waypoints, tail endpoint].
        const nodeSpecs = [
            {
                body: bodyA,
                localAnchor: localAnchorA,
                kind: "endpoint"
            },
            ...waypoints.map((wp)=>({
                    body: wp.body,
                    localAnchor: wp.localAnchor,
                    kind: wp.type === "winch" ? "winch" : "block",
                    mu: wp.frictionCoefficient ?? 0
                })),
            {
                body: bodyB,
                localAnchor: localAnchorB,
                kind: "endpoint"
            }
        ];
        this.rope = this.addChild(new (0, $e9097ea37a6a213b$export$4b1b918a1b0a0738)(nodeSpecs, {
            totalLength: totalRopeLength
        }));
        this.render = new (0, $0e6eaf95bade212c$export$e9cfe13cdaf9c3a7)(this.rope, {
            hullBody: this.hullBody,
            getDeckHeight: this.getDeckHeight,
            hullBoundary: this.hullBoundary,
            ropeRadius: (this.config.ropeDiameter ?? 0.026) / 2,
            // Rope wrap radius — the groove sits inboard of the cheek disks
            // (cheek radius is 0.3 ft in BoatRenderer), so the rope hugs a
            // smaller drum nested inside the visible hardware.
            winchRadius: 0.18,
            blockRadius: 0.18
        });
        // Wrap each waypoint with a RopeBlock adapter. Must match by (body, localAnchor).
        // Winch max-force comes from the config's `winchForce` (lbf, converted
        // to engine units) so a player cranking against a taut sheet stalls
        // instead of spiking tension unbounded.
        const winchMaxForceEngine = this.config.winchForce != null ? this.config.winchForce * (0, $76df497339ed0c67$export$d6989026b8609618) : undefined;
        for (const wp of waypoints){
            const block = this.addChild(new (0, $6e6c2adb4681d8ab$export$58b65ca36483d388)(this.rope, wp.body, wp.localAnchor, {
                mode: wp.type ?? "block",
                frictionCoefficient: wp.frictionCoefficient,
                winchMaxForce: wp.type === "winch" ? winchMaxForceEngine : undefined
            }));
            this.blocks.push(block);
            if (block.type === "winch" && !this.winch) this.winch = block;
        }
    }
    /**
   * Current material length of rope on the sail side of the winch.
   */ getWorkingLength() {
        if (!this.winch) return this.rope.getTotalLength();
        return this.winch.getWorkingLength();
    }
    /**
   * Adjust sheet length based on player input.
   *
   * When trimming (input < 0): ratchet + positive flow rate (length flows
   * working → tail). When easing (input > 0): free mode + zero flow; sail
   * loads pull rope out naturally. When idle (input = 0): ratchet + zero
   * flow; rope locked against easing.
   *
   * @param input Negative = trim in, positive = ease out.
   *   Magnitude controls speed: 1 = normal, >1 = grinding harder.
   */ adjust(input) {
        if (!this.winch) return;
        if (input === 0) {
            this.winch.setMode("ratchet");
            this.winch.applyTrimRate(0);
            return;
        }
        const workingLen = this.winch.getWorkingLength();
        if (input < 0 && workingLen <= this.config.minLength) {
            this.winch.applyTrimRate(0);
            return;
        }
        if (input > 0 && workingLen >= this.config.maxLength) {
            this.winch.applyTrimRate(0);
            return;
        }
        const maxSpeed = this.config.winchMaxSpeed ?? $d62dd12816171ede$var$DEFAULT_CONFIG.winchMaxSpeed;
        if (input < 0) {
            // Trimming: ratchet + positive flow rate.
            this.winch.setMode("ratchet");
            const rate = Math.min(1, Math.abs(input)) * maxSpeed;
            this.winch.applyTrimRate(rate);
        } else {
            // Easing: free + zero flow. Sail loads carry the rope out on their own.
            this.winch.setMode("free");
            this.winch.applyTrimRate(0);
        }
    }
    /**
   * Release the sheet for tacking. Clears winch grip so sail loads can pull
   * rope out freely.
   */ release() {
        if (!this.winch) return;
        this.winch.setMode("free");
        this.winch.applyTrimRate(0);
    }
    getSheetPosition() {
        const workingLen = this.getWorkingLength();
        const range = this.config.maxLength - this.config.minLength;
        return (0, $2172aedd5a25ff17$export$7d15b64cf5a3a4c4)((workingLen - this.config.minLength) / (range || 1), 0, 1);
    }
    getSheetLength() {
        return this.getWorkingLength();
    }
    /** Set the visual opacity of the sheet (0 = invisible, 1 = fully visible). */ setOpacity(opacity) {
        this.opacity = (0, $2172aedd5a25ff17$export$7d15b64cf5a3a4c4)(opacity, 0, 1);
    }
    /** Check if sheet is fully eased out (at max working length). */ isAtMaxLength() {
        return this.getSheetPosition() >= 0.99;
    }
    /**
   * Whether the working-side section is currently under tension. Used by
   * the sound system to detect sheet snap.
   */ isWorkingTaut() {
        if (this.tickCount < 2) return false; // suppress spawn transients
        return this.getWorkingTension() > 0;
    }
    /**
   * Peak tension in sections adjacent to the winch (or the working
   * endpoint section if no winch). Engine-force units.
   */ getWorkingTension() {
        if (this.winch) return this.rope.getPeakTensionAt(this.winch.getNodeIndex());
        // Fallback: peak across all sections.
        let peak = 0;
        for(let i = 0; i < this.rope.getSectionCount(); i++)peak = Math.max(peak, this.rope.getSectionTension(i));
        return peak;
    }
    onTick({ dt: dt }) {
        this.tickCount++;
        this.updateWinchAngle();
        this.render.update(dt);
    }
    /** Update winch handle rotation based on rope length change. */ updateWinchAngle() {
        if (!this.winch) return;
        const len = this.winch.getWorkingLength();
        if (this.prevWorkingLength >= 0) {
            const delta = this.prevWorkingLength - len;
            // Geared down: one full handle turn per ~6ft of rope travel.
            this.winchAngle += delta / (6 / (2 * Math.PI));
        }
        this.prevWorkingLength = len;
    }
    /**
   * Get world-space rope render samples: points, z, and per-point material-v
   * coordinates. Variable-spaced (non-uniform along the rope) — callers must
   * consume `vPerPoint` rather than multiplying by `getRopeSegmentLength()`.
   */ getRopePointsWithZ() {
        return this.render.computeSamples();
    }
    /** Stable total sample count for this sheet's render (for buffer sizing). */ getRopeRenderSampleCount() {
        return this.render.getTotalSampleCount();
    }
    /** Get visual opacity. */ getOpacity() {
        return this.opacity;
    }
    /** Z-height at anchor A (sail end). */ getZA() {
        return this.localAnchorA[2];
    }
    /** Z-height at anchor B (tail end). */ getZB() {
        return this.localAnchorB[2];
    }
    /** Waypoint info for rendering — world position, type, and winch angle. */ getWaypointInfo() {
        return this.blocks.map((b)=>({
                position: b.getWorldPosition(),
                type: b.type,
                winchAngle: b.type === "winch" ? this.winchAngle : 0
            }));
    }
    /**
   * Reference material length per render segment. In the capstan model,
   * sections are non-uniform, so this returns an average — used only for
   * material-v spacing in the rope shader.
   */ getRopeSegmentLength() {
        const n = this.rope.getNodeCount();
        if (n < 2) return 1;
        return this.rope.getTotalLength() / (n - 1);
    }
    /** Rope thickness for rendering. */ getRopeThickness() {
        return this.config.ropeThickness;
    }
    /** Rope construction and carrier colors for rendering. */ getRopePattern() {
        return this.config.ropePattern ?? {
            type: "laid",
            carriers: [
                this.config.ropeColor
            ]
        };
    }
}
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $aa1f0309d9dba6d2$export$af631764ddc44097)("tick")
], $d62dd12816171ede$export$a9bf29f8d87ebbee.prototype, "onTick", null);









class $34555dd463019ed0$export$49e34aa2229adb65 extends (0, $c59361981bac2575$export$4342ba5c6ad1f6f1) {
    constructor(...args){
        super(...args), this.tags = [
            "waterModifier"
        ];
    }
}
var $34555dd463019ed0$export$125ddb01a2b383f0 = /*#__PURE__*/ function(WaterModifierType) {
    WaterModifierType[WaterModifierType["Wake"] = 1] = "Wake";
    WaterModifierType[WaterModifierType["Foam"] = 5] = "Foam";
    return WaterModifierType;
}({});


// Scales time-averaged suction flux → foam intensity.
// Formula: avgFlux / halfWidth² (flux density, units 1/s). Scale calibrates
// typical cruising stern flux (~1.5 ft³/s over ~0.5 ft² triangles) to ~0.4,
// with strong stern sources approaching 1.0. Intentionally does NOT divide
// by group speed — the previous formulation inverted the physics, making
// foam dim at high speed and bright at rest, the opposite of reality.
const $4c61ecdc567dd885$var$TURBULENCE_SCALE = 0.2;
// Foam fades out exponentially with this e-folding time. Long tail lets the
// trail linger well after the boat has passed.
const $4c61ecdc567dd885$var$FOAM_DAMPING_TIME = 8; // s
// Kill once intensity falls below this.
const $4c61ecdc567dd885$var$MIN_VISIBLE_INTENSITY = 0.02;
// Fraction of lifetime over which intensity is linearly ramped from the
// exponential curve down to exactly 0. Guarantees clean disappearance
// instead of a visible snap-off when the particle destroys itself — the
// exponential alone leaves intensity at MIN_VISIBLE_INTENSITY at death,
// which the downstream foam shader visibly amplifies.
const $4c61ecdc567dd885$var$TAIL_FRACTION = 0.3;
class $4c61ecdc567dd885$export$9775135718728fda extends (0, $34555dd463019ed0$export$49e34aa2229adb65) {
    constructor(options){
        super(), this.tickLayer = "effects", this.age = 0, this.aabb = new (0, $dd0ee6ed41f5ec2f$export$8ec70f2db73b49aa)();
        this.posX = options.worldX;
        this.posY = options.worldY;
        this.radius = options.halfWidth;
        // Intensity from time-averaged suction flux per unit source footprint.
        // Scales with speed (because flux does), not inversely — a fast boat's
        // stern generates more visible foam than a stationary one.
        const rSq = Math.max(this.radius * this.radius, 0.01);
        const raw = $4c61ecdc567dd885$var$TURBULENCE_SCALE * options.avgFlux / rSq;
        this.initialIntensity = Math.min(1, raw);
        // Lifespan: fade until intensity drops below visible threshold.
        this.maxAge = this.initialIntensity > $4c61ecdc567dd885$var$MIN_VISIBLE_INTENSITY ? $4c61ecdc567dd885$var$FOAM_DAMPING_TIME * Math.log(this.initialIntensity / $4c61ecdc567dd885$var$MIN_VISIBLE_INTENSITY) : 0;
    }
    onTick({ dt: dt }) {
        this.age += dt;
        if (this.age >= this.maxAge) this.destroy();
    }
    getWaterModifierAABB() {
        const r = this.radius * 3;
        this.aabb.lowerBound.x = this.posX - r;
        this.aabb.lowerBound.y = this.posY - r;
        this.aabb.upperBound.x = this.posX + r;
        this.aabb.upperBound.y = this.posY + r;
        return this.aabb;
    }
    getGPUModifierData() {
        if (this.isDestroyed) return null;
        const decay = Math.exp(-this.age / $4c61ecdc567dd885$var$FOAM_DAMPING_TIME);
        const lifeFrac = this.maxAge > 0 ? this.age / this.maxAge : 1;
        const tailStart = 1 - $4c61ecdc567dd885$var$TAIL_FRACTION;
        const tail = lifeFrac < tailStart ? 1 : Math.max(0, 1 - (lifeFrac - tailStart) / $4c61ecdc567dd885$var$TAIL_FRACTION);
        const intensity = this.initialIntensity * decay * tail;
        return {
            type: (0, $34555dd463019ed0$export$125ddb01a2b383f0).Foam,
            bounds: this.getWaterModifierAABB(),
            data: {
                type: (0, $34555dd463019ed0$export$125ddb01a2b383f0).Foam,
                posX: this.posX,
                posY: this.posY,
                radius: this.radius,
                intensity: intensity
            }
        };
    }
}
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $aa1f0309d9dba6d2$export$af631764ddc44097)("tick")
], $4c61ecdc567dd885$export$9775135718728fda.prototype, "onTick", null);






const $f23c1ebc8c309993$var$GRAVITY = 32.174; // ft/s²
// Dimensionless tuning: scales flux → ring-wave height.
// Amplitude formula is (flux * dt) / halfWidth² — volume per unit area.
const $f23c1ebc8c309993$var$WAVE_HEIGHT_SCALE = 1.5;
// Destroy once peak amplitude falls below this.
const $f23c1ebc8c309993$var$MIN_VISIBLE_AMPLITUDE = 0.001; // ft
// Viscous damping e-folding time for the coherent ring wave.
const $f23c1ebc8c309993$var$DAMPING_TIME = 0.75; // s
class $f23c1ebc8c309993$export$641ba3be698a29db extends (0, $34555dd463019ed0$export$49e34aa2229adb65) {
    constructor(options){
        super(), this.tickLayer = "effects", this.age = 0, this.aabb = new (0, $dd0ee6ed41f5ec2f$export$8ec70f2db73b49aa)();
        this.posX = options.worldX;
        this.posY = options.worldY;
        this.ringWidth = options.halfWidth;
        this.groupSpeed = options.groupSpeed;
        // Deep-water dispersion: omega = g / (2 * c_g). Clamp to avoid blowup.
        this.omega = $f23c1ebc8c309993$var$GRAVITY / (2 * Math.max(this.groupSpeed, 0.1));
        // Initial amplitude: volume pushed this tick spread over the source's
        // characteristic footprint (halfWidth²). Speed-invariant — growing
        // flux at higher speeds naturally grows the wake.
        const volume = options.pushFlux * options.dt; // ft³
        this.initialAmplitude = $f23c1ebc8c309993$var$WAVE_HEIGHT_SCALE * volume / (this.ringWidth * this.ringWidth);
        // Lifespan: kill when damped peak amplitude drops below visible threshold.
        // Peak ~ initial * exp(-t/tau) (ignoring 1/√r spreading for upper bound).
        this.maxAge = this.initialAmplitude > $f23c1ebc8c309993$var$MIN_VISIBLE_AMPLITUDE ? $f23c1ebc8c309993$var$DAMPING_TIME * Math.log(this.initialAmplitude / $f23c1ebc8c309993$var$MIN_VISIBLE_AMPLITUDE) : 0;
    }
    onTick({ dt: dt }) {
        this.age += dt;
        if (this.age >= this.maxAge) this.destroy();
    }
    getRingRadius() {
        return this.groupSpeed * this.age;
    }
    getWaterModifierAABB() {
        const radius = this.getRingRadius() + this.ringWidth * 3;
        this.aabb.lowerBound.x = this.posX - radius;
        this.aabb.lowerBound.y = this.posY - radius;
        this.aabb.upperBound.x = this.posX + radius;
        this.aabb.upperBound.y = this.posY + radius;
        return this.aabb;
    }
    getGPUModifierData() {
        if (this.isDestroyed) return null;
        const ringRadius = this.getRingRadius();
        const damping = Math.exp(-this.age / $f23c1ebc8c309993$var$DAMPING_TIME);
        const spreading = ringRadius > 1 ? 1 / Math.sqrt(ringRadius) : 1;
        return {
            type: (0, $34555dd463019ed0$export$125ddb01a2b383f0).Wake,
            bounds: this.getWaterModifierAABB(),
            data: {
                type: (0, $34555dd463019ed0$export$125ddb01a2b383f0).Wake,
                posX: this.posX,
                posY: this.posY,
                ringRadius: ringRadius,
                ringWidth: this.ringWidth,
                amplitude: this.initialAmplitude * damping * spreading,
                omega: this.omega
            }
        };
    }
}
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $aa1f0309d9dba6d2$export$af631764ddc44097)("tick")
], $f23c1ebc8c309993$export$641ba3be698a29db.prototype, "onTick", null);


// Below this, a source is too weak to bother spawning a particle for.
const $5ec49109b3a14edd$var$MIN_SOURCE_FLUX = 0.01; // ft³/s
class $5ec49109b3a14edd$export$e65e6447faad556c extends (0, $c59361981bac2575$export$4342ba5c6ad1f6f1) {
    constructor(boat){
        super(), this.layer = "wake", this.tickLayer = "effects";
        this.boat = boat;
    }
    onTick({ dt: dt }) {
        const hull = this.boat.hull;
        // Coherent ring waves — emitted every tick from waterline sources.
        const waveCount = hull.waveSourceCount;
        for(let i = 0; i < waveCount; i++){
            const src = hull.getWaveSource(i);
            if (src.pushFlux <= $5ec49109b3a14edd$var$MIN_SOURCE_FLUX) continue;
            this.game.addEntity(new (0, $f23c1ebc8c309993$export$641ba3be698a29db)({
                worldX: src.worldX,
                worldY: src.worldY,
                pushFlux: src.pushFlux,
                halfWidth: src.halfWidth,
                groupSpeed: src.groupSpeed,
                dt: dt
            }));
        }
        // Foam blobs — round-robin throttled, bounded particles/tick.
        const foamCount = hull.foamSourceCount;
        for(let i = 0; i < foamCount; i++){
            const src = hull.getFoamSource(i);
            if (src.avgFlux <= $5ec49109b3a14edd$var$MIN_SOURCE_FLUX) continue;
            this.game.addEntity(new (0, $4c61ecdc567dd885$export$9775135718728fda)({
                worldX: src.worldX,
                worldY: src.worldY,
                avgFlux: src.avgFlux,
                halfWidth: src.halfWidth,
                groupSpeed: src.groupSpeed
            }));
        }
    }
}
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $aa1f0309d9dba6d2$export$af631764ddc44097)("tick")
], $5ec49109b3a14edd$export$e65e6447faad556c.prototype, "onTick", null);










// Mooring line visual properties
const $2a4b558bc22b4f97$var$MOORING_LINE_COLOR = 0x666644;
const $2a4b558bc22b4f97$var$MOORING_LINE_WIDTH = 0.3; // ft
// Cast-off impulse
const $2a4b558bc22b4f97$var$CAST_OFF_IMPULSE = 50; // lbs * ft/s
class $2a4b558bc22b4f97$export$6238d4b9ead0a783 extends (0, $c59361981bac2575$export$4342ba5c6ad1f6f1) {
    constructor(boat){
        super(), this.boat = boat, this.layer = "boat", this.state = "free", this.currentPort = null, this.bowAnchorBody = null, this.sternAnchorBody = null, this.bowConstraint = null, this.sternConstraint = null;
        // Compute bow and stern attach points from hull vertices
        const vertices = boat.config.hull.vertices;
        this.bowAttachLocal = (0, $d106d09a724e422d$export$1da007e63d4d3b8e)(vertices);
        const sternPoints = (0, $d106d09a724e422d$export$4746840bf6466a0f)(vertices);
        this.sternAttachLocal = sternPoints.port.add(sternPoints.starboard).imul(0.5);
    }
    getState() {
        return this.state;
    }
    isMoored() {
        return this.state === "moored" || this.state === "mooring";
    }
    getCurrentPort() {
        return this.currentPort;
    }
    /** Moor the boat to a port */ moorTo(port) {
        if (this.state !== "free") return;
        this.currentPort = port;
        // Get cleat positions from the port
        const bowCleatWorld = port.getBowCleatWorld();
        const sternCleatWorld = port.getSternCleatWorld();
        // Create static anchor bodies at cleat positions
        // (using tiny dynamic bodies with high mass to act as fixed points for constraints)
        this.bowAnchorBody = (0, $4aa863c0a97fa3b4$export$7d27618aebc86361)({
            motion: "dynamic",
            mass: 1e6,
            position: [
                bowCleatWorld.x,
                bowCleatWorld.y
            ],
            damping: 1.0
        });
        this.bowAnchorBody.addShape(new (0, $5decb6115b59ebc8$export$c36c68baa13912a5)());
        this.game.world.bodies.add(this.bowAnchorBody);
        this.sternAnchorBody = (0, $4aa863c0a97fa3b4$export$7d27618aebc86361)({
            motion: "dynamic",
            mass: 1e6,
            position: [
                sternCleatWorld.x,
                sternCleatWorld.y
            ],
            damping: 1.0
        });
        this.sternAnchorBody.addShape(new (0, $5decb6115b59ebc8$export$c36c68baa13912a5)());
        this.game.world.bodies.add(this.sternAnchorBody);
        // Create distance constraints from hull attach points to cleat anchor bodies
        this.bowConstraint = new (0, $dd44cce75657a83e$export$7f13e3afb2fe70fe)(this.bowAnchorBody, this.boat.hull.body, {
            localAnchorA: [
                0,
                0
            ],
            localAnchorB: [
                this.bowAttachLocal.x,
                this.bowAttachLocal.y
            ],
            collideConnected: false
        });
        this.bowConstraint.upperLimitEnabled = true;
        this.bowConstraint.upperLimit = this.bowConstraint.distance;
        this.bowConstraint.lowerLimitEnabled = false;
        this.game.world.constraints.add(this.bowConstraint);
        this.sternConstraint = new (0, $dd44cce75657a83e$export$7f13e3afb2fe70fe)(this.sternAnchorBody, this.boat.hull.body, {
            localAnchorA: [
                0,
                0
            ],
            localAnchorB: [
                this.sternAttachLocal.x,
                this.sternAttachLocal.y
            ],
            collideConnected: false
        });
        this.sternConstraint.upperLimitEnabled = true;
        this.sternConstraint.upperLimit = this.sternConstraint.distance;
        this.sternConstraint.lowerLimitEnabled = false;
        this.game.world.constraints.add(this.sternConstraint);
        this.state = "moored";
        this.dispatch("boatMoored", {
            portId: port.getId(),
            portName: port.getName()
        });
    }
    /** Cast off from the current port */ castOff() {
        if (this.state !== "moored" && this.state !== "mooring") return;
        const port = this.currentPort;
        // Remove constraints
        this.removeConstraints();
        // Apply a small impulse away from dock
        if (port) {
            // Push perpendicular to dock (away from it)
            const portPos = port.getPosition();
            const boatPos = this.boat.getPosition();
            const awayDir = (0, $6b6a54a072724620$export$e7c866399fa523f5)(boatPos).isub(portPos).inormalize();
            this.boat.hull.body.applyForce(awayDir.imul($2a4b558bc22b4f97$var$CAST_OFF_IMPULSE));
            this.dispatch("boatUnmoored", {
                portId: port.getId()
            });
        }
        this.currentPort = null;
        this.state = "free";
    }
    /** Remove all physics objects for mooring */ removeConstraints() {
        if (this.bowConstraint) {
            this.game.world.constraints.remove(this.bowConstraint);
            this.bowConstraint = null;
        }
        if (this.sternConstraint) {
            this.game.world.constraints.remove(this.sternConstraint);
            this.sternConstraint = null;
        }
        if (this.bowAnchorBody) {
            this.game.world.bodies.remove(this.bowAnchorBody);
            this.bowAnchorBody = null;
        }
        if (this.sternAnchorBody) {
            this.game.world.bodies.remove(this.sternAnchorBody);
            this.sternAnchorBody = null;
        }
    }
    getBowWorldPosition() {
        const [hx, hy] = this.boat.hull.body.position;
        return this.bowAttachLocal.rotate(this.boat.hull.body.angle).iadd([
            hx,
            hy
        ]);
    }
    getSternWorldPosition() {
        const [hx, hy] = this.boat.hull.body.position;
        return this.sternAttachLocal.rotate(this.boat.hull.body.angle).iadd([
            hx,
            hy
        ]);
    }
    onRender({ draw: draw }) {
        if (this.state === "free") return;
        if (!this.currentPort) return;
        const bowWorld = this.getBowWorldPosition();
        const sternWorld = this.getSternWorldPosition();
        const bowCleat = this.currentPort.getBowCleatWorld();
        const sternCleat = this.currentPort.getSternCleatWorld();
        // Draw mooring lines from hull to cleats
        draw.line(bowWorld.x, bowWorld.y, bowCleat.x, bowCleat.y, {
            color: $2a4b558bc22b4f97$var$MOORING_LINE_COLOR,
            width: $2a4b558bc22b4f97$var$MOORING_LINE_WIDTH
        });
        draw.line(sternWorld.x, sternWorld.y, sternCleat.x, sternCleat.y, {
            color: $2a4b558bc22b4f97$var$MOORING_LINE_COLOR,
            width: $2a4b558bc22b4f97$var$MOORING_LINE_WIDTH
        });
    }
    onDestroy() {
        if (this.isAdded) this.removeConstraints();
    }
}
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $aa1f0309d9dba6d2$export$af631764ddc44097)("render")
], $2a4b558bc22b4f97$export$6238d4b9ead0a783.prototype, "onRender", null);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $aa1f0309d9dba6d2$export$af631764ddc44097)("destroy")
], $2a4b558bc22b4f97$export$6238d4b9ead0a783.prototype, "onDestroy", null);

















// Z-axis physics constants
const $0d3ea614828af746$var$ANCHOR_NET_GRAVITY = 28; // ft/s² (gravity × 0.87 after buoyancy for iron)
const $0d3ea614828af746$var$ANCHOR_Z_DRAG = 3.0; // Water drag coefficient for anchor body (1/s)
const $0d3ea614828af746$var$ANCHOR_ANGULAR_DRAG = 8; // Angular drag coefficient (1/s)
// Rode geometry
const $0d3ea614828af746$var$RODE_DIAMETER = 0.03125; // ft (3/8" chain)
const $0d3ea614828af746$var$RODE_FLOOR_FRICTION = 0.8; // Friction damping when anchor rests on bottom
// Rode rendering
const $0d3ea614828af746$var$RODE_THICKNESS = 0.15; // ft (~2 inches)
const $0d3ea614828af746$var$RODE_COLOR = 0x333322; // Dark rope color
// Winch trim speed for hoisting the anchor
const $0d3ea614828af746$var$WINCH_MAX_SPEED = 2; // ft/s
// Winch peak hoist force (lbf). Generous — anchor weight + rode friction
// is well under this; the cap exists to stop the winch from cranking
// against a nothing-to-pull-in state and generating hull yaw torque.
const $0d3ea614828af746$var$WINCH_MAX_FORCE_LBF = 500;
// Anchor shape constants
const $0d3ea614828af746$var$ANCHOR_COLOR = 0x333333;
const $0d3ea614828af746$var$ANCHOR_SHAPE_LINE_WIDTH_RATIO = 0.12;
// Anchor geometry ratios
const $0d3ea614828af746$var$ANCHOR_LENGTH_RATIO = 1.55; // anchorLen = anchorSize * this
const $0d3ea614828af746$var$ANCHOR_CG_RATIO = 0.55; // CG distance from flukes / anchorLen
class $0d3ea614828af746$export$b688253958b8dfe7 extends (0, $c59361981bac2575$export$4342ba5c6ad1f6f1) {
    constructor(hull, config){
        super(), this.hull = hull, this.layer = "boat", this.rode = null, this.rodeRender = null, this.winch = null, this.blocks = [], this.onBottom = false, this.contactLocals = [], this.contactQueryPoints = [], this.contactConstraints = [], this.floorZCache = [], this.anchorTerrainQuery = null, this.anchorWaterQuery = null, this.contactWorld = new (0, $3480ec8c2fb5ff20$export$d2de7ccaa2f4bf9f)(0, 0, 0);
        this.bowAttachPoint = config.bowAttachPoint;
        this.maxRodeLength = config.maxRodeLength;
        this.anchorSize = config.anchorSize;
        this.anchorMass = config.anchorMass;
        this.anchorDragCoefficient = config.anchorDragCoefficient;
        this.ropePattern = config.ropePattern;
        this.rodeAttachOffset = config.rodeAttachOffset;
        this.deckHeight = config.deckHeight;
        this.rollInertia = config.rollInertia;
        this.pitchInertia = config.pitchInertia;
        this.yawInertia = config.yawInertia;
        this.anchorLen = config.anchorSize * $0d3ea614828af746$var$ANCHOR_LENGTH_RATIO;
        this.d_cg = this.anchorLen * $0d3ea614828af746$var$ANCHOR_CG_RATIO;
    }
    onAdd() {
        const bowWorld = this.getBowWorldPosition();
        // Create anchor body — 6DOF with proper inertia on all axes
        // Yaw inertia comes from the Circle shape: I = 0.5 * m * r²
        // So r = sqrt(2 * I_yaw / m)
        const yawRadius = Math.sqrt(2 * this.yawInertia / this.anchorMass);
        this.anchorBody = (0, $4aa863c0a97fa3b4$export$d8062929709d2dca)({
            motion: "dynamic",
            mass: this.anchorMass,
            position: [
                bowWorld.x,
                bowWorld.y
            ],
            angle: this.hull.body.angle,
            damping: 0.5,
            angularDamping: 0.95,
            allowSleep: false,
            rollInertia: this.rollInertia,
            pitchInertia: this.pitchInertia,
            zMass: this.anchorMass,
            zDamping: 0,
            rollPitchDamping: 0,
            z: this.deckHeight
        });
        this.anchorBody.addShape(new (0, $45a22be5c0ab570f$export$c89a927ffc67e6fa)({
            radius: yawRadius,
            collisionGroup: 0,
            collisionMask: 0
        }));
        // Waypoints: bow roller (block) redirects rode from vertical to horizontal,
        // winch sits a few feet aft on foredeck, tail extends further aft
        const winchPoint = (0, $6b6a54a072724620$export$e7c866399fa523f5)(this.bowAttachPoint.x - 3, 0);
        const tailPoint = (0, $6b6a54a072724620$export$e7c866399fa523f5)(this.bowAttachPoint.x - 8, 0);
        const rodeAttach = new (0, $3480ec8c2fb5ff20$export$d2de7ccaa2f4bf9f)(this.rodeAttachOffset[0], this.rodeAttachOffset[1], this.rodeAttachOffset[2]);
        const bowAnchor = new (0, $3480ec8c2fb5ff20$export$d2de7ccaa2f4bf9f)(this.bowAttachPoint.x, this.bowAttachPoint.y, this.deckHeight);
        const winchAnchor = new (0, $3480ec8c2fb5ff20$export$d2de7ccaa2f4bf9f)(winchPoint.x, winchPoint.y, this.deckHeight);
        const tailAnchor = new (0, $3480ec8c2fb5ff20$export$d2de7ccaa2f4bf9f)(tailPoint.x, tailPoint.y, this.deckHeight);
        // Nodes: [anchorBody, bowRoller (block), winch, tailAnchor (endpoint)]
        const nodeSpecs = [
            {
                body: this.anchorBody,
                localAnchor: rodeAttach,
                kind: "endpoint"
            },
            {
                body: this.hull.body,
                localAnchor: bowAnchor,
                kind: "block",
                mu: 0.1
            },
            {
                body: this.hull.body,
                localAnchor: winchAnchor,
                kind: "winch",
                mu: 0.3
            },
            {
                body: this.hull.body,
                localAnchor: tailAnchor,
                kind: "endpoint"
            }
        ];
        this.rode = this.addChild(new (0, $e9097ea37a6a213b$export$4b1b918a1b0a0738)(nodeSpecs, {
            totalLength: this.maxRodeLength,
            // Anchor rode is long (up to ~100 ft deployed) and expected to be
            // stretchy nylon that acts as a shock absorber against wave loads.
            // The stiffer sheet defaults make a long rope behave like a rigid
            // link, which yanks the anchor body and drives oscillation.
            solver: {
                kAxial: 3000,
                cDamping: 400
            }
        }));
        this.rodeRender = new (0, $0e6eaf95bade212c$export$e9cfe13cdaf9c3a7)(this.rode, {
            hullBody: this.hull.body,
            // Anchor rode has no deck query hook plumbed in yet — the rode mostly
            // goes over the bow and into the water. Phase 3/4 can layer on a
            // water/terrain floor for the underwater sag if needed.
            ropeRadius: $0d3ea614828af746$var$RODE_DIAMETER / 2
        });
        this.bodies = [
            this.anchorBody
        ];
        // Create block adapters so getWaypointInfo / winch controls work.
        const bowRoller = this.addChild(new (0, $6e6c2adb4681d8ab$export$58b65ca36483d388)(this.rode, this.hull.body, bowAnchor, {
            mode: "block",
            frictionCoefficient: 0.1
        }));
        this.blocks.push(bowRoller);
        const winch = this.addChild(new (0, $6e6c2adb4681d8ab$export$58b65ca36483d388)(this.rode, this.hull.body, winchAnchor, {
            mode: "winch",
            frictionCoefficient: 0.3,
            winchMaxForce: $0d3ea614828af746$var$WINCH_MAX_FORCE_LBF * (0, $76df497339ed0c67$export$d6989026b8609618)
        }));
        this.blocks.push(winch);
        this.winch = winch;
        // Start fully retracted: minimal working length so the anchor sits at
        // the bow roller with nearly all the rode wound on the winch side.
        const bowToWinch = this.bowAttachPoint.distanceTo(winchPoint);
        winch.setWorkingLength(bowToWinch);
        // Contact points in anchor-local coords, matching the rendered geometry
        // so the anchor rests on its flukes/stock/crown instead of the body origin
        // punching through the seabed.
        const size = this.anchorSize;
        const flukeEnd = -(this.anchorLen - this.d_cg);
        const ringEnd = this.d_cg;
        const stockX = ringEnd - size * 0.25;
        const crownHalf = size * 0.25;
        const stockHalf = size * 0.45;
        const flukeLen = size * 0.45;
        const flukeSpread = size * 0.15;
        const flukeEndX = flukeEnd + flukeSpread;
        this.contactLocals = [
            {
                x: 0,
                y: 0,
                z: 0
            },
            {
                x: flukeEndX,
                y: -(crownHalf + flukeLen),
                z: 0
            },
            {
                x: flukeEndX,
                y: crownHalf + flukeLen,
                z: 0
            },
            {
                x: flukeEnd,
                y: -crownHalf,
                z: 0
            },
            {
                x: flukeEnd,
                y: crownHalf,
                z: 0
            },
            {
                x: stockX,
                y: -stockHalf,
                z: 0
            },
            {
                x: stockX,
                y: stockHalf,
                z: 0
            },
            {
                x: ringEnd,
                y: 0,
                z: 0
            }
        ];
        this.contactQueryPoints = this.contactLocals.map(()=>(0, $6b6a54a072724620$export$e7c866399fa523f5)(0, 0));
        this.floorZCache = new Array(this.contactLocals.length).fill(null);
        this.anchorTerrainQuery = this.addChild(new (0, $178448b994cda479$export$b2f87c4d67934c2d)(()=>this.contactQueryPoints));
        this.anchorWaterQuery = this.addChild(new (0, $2f31bbbd4b5b01e3$export$38b1d297f12cec06)(()=>this.contactQueryPoints));
        const ground = this.game.ground;
        const contactConstraints = [];
        for(let i = 0; i < this.contactLocals.length; i++){
            const local = this.contactLocals[i];
            const idx = i;
            contactConstraints.push(new (0, $d08dc95f3f961954$export$fb8c86c8990ab189)(ground, this.anchorBody, local.x, local.y, local.z, ()=>this.floorZCache[idx], $0d3ea614828af746$var$RODE_FLOOR_FRICTION, {
                collideConnected: true
            }));
        }
        this.contactConstraints = contactConstraints;
        this.constraints = contactConstraints;
    }
    // ---- Winch controls (called by PlayerBoatController) ----
    /** Release the winch — rode pays out freely under anchor weight. */ lower() {
        if (!this.winch) return;
        this.winch.setMode("free");
    }
    /** Engage ratchet + apply tailing force to hoist the anchor. */ raise() {
        if (!this.winch) return;
        this.winch.setMode("ratchet");
        this.winch.applyTrimRate($0d3ea614828af746$var$WINCH_MAX_SPEED);
    }
    /** Lock the rode in place (ratchet, no force). */ idle() {
        if (!this.winch) return;
        this.winch.setMode("ratchet");
        this.winch.applyTrimRate(0);
    }
    // ---- Public accessors ----
    isDeployed() {
        return this.anchorBody != null && this.anchorBody.z < -1;
    }
    getRodePointsWithZ() {
        if (!this.rodeRender) return null;
        return this.rodeRender.computeSamples();
    }
    getRodeSegmentLength() {
        if (!this.rode) return 0;
        const n = this.rode.getNodeCount();
        if (n < 2) return 1;
        return this.rode.getTotalLength() / (n - 1);
    }
    getRodeThickness() {
        return $0d3ea614828af746$var$RODE_THICKNESS;
    }
    getRodeColor() {
        return $0d3ea614828af746$var$RODE_COLOR;
    }
    getRodePattern() {
        return this.ropePattern ?? {
            type: "laid",
            carriers: [
                $0d3ea614828af746$var$RODE_COLOR
            ]
        };
    }
    getWaypointInfo() {
        return this.blocks.map((b)=>({
                position: b.getWorldPosition(),
                type: b.type
            }));
    }
    // ---- Per-tick physics ----
    onTick({ dt: dt }) {
        if (!this.rode) return;
        // Update anchor body query point
        this.updateQueryPoints();
        // Anchor body underwater forces: gravity + drag + floor collision
        this.applyAnchorUnderwaterForces();
        // Anchor-specific forces: gravity at CG offset, angular drag
        this.applyAnchorBodyForces();
        // XY drag on the anchor body (scope-dependent holding power)
        this.applyAnchorDrag();
        // Rode render liveness (catenary sag + decorative oscillator).
        this.rodeRender?.update(dt);
    }
    updateQueryPoints() {
        const body = this.anchorBody;
        for(let i = 0; i < this.contactLocals.length; i++){
            const local = this.contactLocals[i];
            const world = body.toWorldFrame3D(local.x, local.y, local.z, this.contactWorld);
            this.contactQueryPoints[i].set(world[0], world[1]);
        }
        const terrainQuery = this.anchorTerrainQuery;
        const waterQuery = this.anchorWaterQuery;
        const tCount = terrainQuery?.length ?? 0;
        const wCount = waterQuery?.length ?? 0;
        const count = Math.min(tCount, wCount, this.contactLocals.length);
        for(let i = 0; i < count; i++){
            const terrainHeight = terrainQuery.get(i).height;
            const surfaceHeight = waterQuery.get(i).surfaceHeight;
            this.floorZCache[i] = terrainHeight - surfaceHeight;
        }
        for(let i = count; i < this.floorZCache.length; i++)this.floorZCache[i] = null;
    }
    /** Apply underwater forces to the anchor body: gravity and drag. */ applyAnchorUnderwaterForces() {
        // Gravity (buoyancy-reduced)
        this.anchorBody.applyForce3D(0, 0, -$0d3ea614828af746$var$ANCHOR_NET_GRAVITY * this.anchorMass, 0, 0, 0);
        // Water drag (linear)
        const [vx, vy] = this.anchorBody.velocity;
        const vz = this.anchorBody.zVelocity;
        this.anchorBody.applyForce3D(-$0d3ea614828af746$var$ANCHOR_Z_DRAG * vx * this.anchorMass, -$0d3ea614828af746$var$ANCHOR_Z_DRAG * vy * this.anchorMass, -$0d3ea614828af746$var$ANCHOR_Z_DRAG * vz * this.anchorMass, 0, 0, 0);
    }
    applyAnchorBodyForces() {
        // Shift the gravity application point from the origin (where
        // applyAnchorUnderwaterForces applies it) to the CG offset, creating
        // a righting torque that keeps the anchor oriented properly.
        const cgOffsetZ = -this.anchorSize * 0.15;
        // Cancel origin gravity, re-apply at CG offset
        this.anchorBody.applyForce3D(0, 0, $0d3ea614828af746$var$ANCHOR_NET_GRAVITY * this.anchorMass, 0, 0, 0);
        this.anchorBody.applyForce3D(0, 0, -$0d3ea614828af746$var$ANCHOR_NET_GRAVITY * this.anchorMass, 0, 0, cgOffsetZ);
        // Angular drag on all rotation axes
        const av3 = this.anchorBody.angularVelocity3;
        if (av3) {
            this.anchorBody.angularForce3[0] -= $0d3ea614828af746$var$ANCHOR_ANGULAR_DRAG * av3[0] * this.rollInertia;
            this.anchorBody.angularForce3[1] -= $0d3ea614828af746$var$ANCHOR_ANGULAR_DRAG * av3[1] * this.pitchInertia;
            this.anchorBody.angularForce3[2] -= $0d3ea614828af746$var$ANCHOR_ANGULAR_DRAG * av3[2] * this.yawInertia;
        }
        // Any active contact constraint means a part of the anchor is touching
        // (or penetrating) the seabed — that's what the scope-drag holding-power
        // bonus cares about.
        let anyContact = false;
        for(let i = 0; i < this.contactConstraints.length; i++)if (this.contactConstraints[i].isActive()) {
            anyContact = true;
            break;
        }
        this.onBottom = anyContact;
    }
    applyAnchorDrag() {
        const velocity = this.anchorBody.velocity;
        const speed = velocity.magnitude;
        if (speed < 0.01) return;
        // Scope-based drag: more rode out = better holding
        const workingLength = this.winch ? this.winch.getWorkingLength() : 0;
        const scope = workingLength / this.maxRodeLength;
        let dragMagnitude = this.anchorDragCoefficient * scope * speed;
        // Bottom rode bonus: extra holding when rode lies on the bottom
        if (this.onBottom && this.anchorWaterQuery && this.anchorWaterQuery.length > 0) {
            const waterDepth = this.anchorWaterQuery.get(0).depth;
            const bottomRodeLength = Math.max(0, workingLength - waterDepth * 1.5);
            const scopeBonus = bottomRodeLength / this.maxRodeLength;
            dragMagnitude *= 1 + scopeBonus * 2;
        }
        const dragForce = velocity.normalize().imul(-dragMagnitude);
        this.anchorBody.applyForce(dragForce);
    }
    // ---- Rendering ----
    onRender({ draw: draw }) {
        this.renderDeployedAnchor(draw);
    }
    renderDeployedAnchor(draw) {
        const size = this.anchorSize;
        const lineWidth = size * $0d3ea614828af746$var$ANCHOR_SHAPE_LINE_WIDTH_RATIO;
        // Use the 6DOF body's pitch to determine foreshortening
        const pitch = this.anchorBody.pitch;
        const foreshorten = Math.abs(Math.cos(pitch));
        const thicknessBoost = 1 + (1 - foreshorten) * 2;
        const w = lineWidth * thicknessBoost;
        const ringEnd = this.d_cg;
        const flukeEnd = -(this.anchorLen - this.d_cg);
        // Use 6DOF body's toWorldFrame3D for all transforms
        const tw = (lx, ly, lz)=>this.anchorBody.toWorldFrame3D(lx, ly, lz);
        // Shank (main vertical bar)
        const [sx1, sy1, sz1] = tw(flukeEnd, 0, 0);
        const [sx2, sy2, sz2] = tw(ringEnd, 0, 0);
        this.submitMesh(draw, (0, $65c81fa1e5a3b256$export$7e28a7b51b86db6a)(sx1, sy1, sz1, sx2, sy2, sz2, w, $0d3ea614828af746$var$ANCHOR_COLOR));
        // Stock (crossbar near top)
        const stockX = ringEnd - size * 0.25;
        const stockHalf = size * 0.45;
        const [st1x, st1y, st1z] = tw(stockX, -stockHalf, 0);
        const [st2x, st2y, st2z] = tw(stockX, stockHalf, 0);
        this.submitMesh(draw, (0, $65c81fa1e5a3b256$export$7e28a7b51b86db6a)(st1x, st1y, st1z, st2x, st2y, st2z, w, $0d3ea614828af746$var$ANCHOR_COLOR));
        // Crown (crossbar at bottom)
        const crownHalf = size * 0.25;
        const [c1x, c1y, c1z] = tw(flukeEnd, -crownHalf, 0);
        const [c2x, c2y, c2z] = tw(flukeEnd, crownHalf, 0);
        this.submitMesh(draw, (0, $65c81fa1e5a3b256$export$7e28a7b51b86db6a)(c1x, c1y, c1z, c2x, c2y, c2z, w, $0d3ea614828af746$var$ANCHOR_COLOR));
        // Left fluke
        const flukeLen = size * 0.45;
        const flukeSpread = size * 0.15;
        const flukeEndX = flukeEnd + flukeSpread;
        const [lf1x, lf1y, lf1z] = tw(flukeEnd, -crownHalf, 0);
        const [lf2x, lf2y, lf2z] = tw(flukeEndX, -crownHalf - flukeLen, 0);
        this.submitMesh(draw, (0, $65c81fa1e5a3b256$export$7e28a7b51b86db6a)(lf1x, lf1y, lf1z, lf2x, lf2y, lf2z, w, $0d3ea614828af746$var$ANCHOR_COLOR));
        // Right fluke
        const [rf1x, rf1y, rf1z] = tw(flukeEnd, crownHalf, 0);
        const [rf2x, rf2y, rf2z] = tw(flukeEndX, crownHalf + flukeLen, 0);
        this.submitMesh(draw, (0, $65c81fa1e5a3b256$export$7e28a7b51b86db6a)(rf1x, rf1y, rf1z, rf2x, rf2y, rf2z, w, $0d3ea614828af746$var$ANCHOR_COLOR));
        // Ring at top
        const ringRadius = size * 0.15;
        const [rx, ry, rz] = tw(ringEnd + ringRadius, 0, 0);
        draw.fillCircle(rx, ry, ringRadius * thicknessBoost, {
            color: $0d3ea614828af746$var$ANCHOR_COLOR,
            z: rz
        });
    }
    submitMesh(draw, mesh) {
        if (mesh.positions.length === 0) return;
        draw.renderer.submitTrianglesWithZ(mesh.positions, mesh.indices, mesh.color, mesh.alpha, mesh.zValues);
    }
    getBowWorldPosition() {
        const [hx, hy] = this.hull.body.position;
        return this.bowAttachPoint.rotate(this.hull.body.angle).iadd([
            hx,
            hy
        ]);
    }
    onDestroy() {
        if (this.anchorTerrainQuery) {
            this.anchorTerrainQuery.destroy();
            this.anchorTerrainQuery = null;
        }
        if (this.anchorWaterQuery) {
            this.anchorWaterQuery.destroy();
            this.anchorWaterQuery = null;
        }
    }
}
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $aa1f0309d9dba6d2$export$af631764ddc44097)("add")
], $0d3ea614828af746$export$b688253958b8dfe7.prototype, "onAdd", null);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $aa1f0309d9dba6d2$export$af631764ddc44097)("tick")
], $0d3ea614828af746$export$b688253958b8dfe7.prototype, "onTick", null);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $aa1f0309d9dba6d2$export$af631764ddc44097)("render")
], $0d3ea614828af746$export$b688253958b8dfe7.prototype, "onRender", null);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $aa1f0309d9dba6d2$export$af631764ddc44097)("destroy")
], $0d3ea614828af746$export$b688253958b8dfe7.prototype, "onDestroy", null);










class $792dbae47b9a5637$export$9bd7938412e8b748 extends (0, $63235e744c2c6cbe$export$aec1359a0a40a615) {
    constructor(particle, hullBody, getDeckHeight, hullBoundary, frictionCoefficient = 0.5, radius = 0, edgeBuffer = 0.5, options){
        super(particle, hullBody, options), /**
   * Decoupled lateral grip (force units). Replaces the Coulomb bound so the
   * walk motor has consistent authority regardless of the normal force cap.
   */ this.fixedFrictionForce = 0, /**
   * Target relative velocity along hull-local X axis (ft/s). The friction
   * equation drives toward this speed so the sailor walks forward/back.
   */ this.targetVelocityX = 0, /** Target relative velocity along hull-local Y axis (ft/s). */ this.targetVelocityY = 0, /** When true, all equations disable (used while the sailor is welded to a station). */ this.disabled = false, this._active = false, /** Tracks whether the edge wall was engaged last tick, so we can clear its
   * warm-start impulse on re-engage (the direction can have rotated while
   * disabled, and a stale impulse would push in the wrong direction). */ this._wallEngaged = false;
        this.getDeckHeight = getDeckHeight;
        this.boundary = hullBoundary;
        this.frictionCoefficient = frictionCoefficient;
        this.radius = radius;
        this.edgeBuffer = edgeBuffer;
        const normal = new (0, $7c2ab345e8402709$export$72aece4f82bc5bee)(particle, hullBody, 0, Number.MAX_VALUE);
        const friction1 = new (0, $7c2ab345e8402709$export$72aece4f82bc5bee)(particle, hullBody, 0, 0);
        const friction2 = new (0, $7c2ab345e8402709$export$72aece4f82bc5bee)(particle, hullBody, 0, 0);
        const wall = new (0, $7c2ab345e8402709$export$72aece4f82bc5bee)(particle, hullBody, 0, Number.MAX_VALUE);
        this.equations = [
            normal,
            friction1,
            friction2,
            wall
        ];
    }
    update() {
        const particle = this.bodyA;
        const hull = this.bodyB;
        const normal = this.equations[0];
        const friction1 = this.equations[1];
        const friction2 = this.equations[2];
        const wall = this.equations[3];
        const boundary = this.boundary;
        if (this.disabled) {
            this.disableAll();
            return this;
        }
        const pz = particle.z;
        if (!isFinite(pz)) {
            this.disableAll();
            return this;
        }
        const [lx, ly] = hull.toLocalFrame3D(particle.position[0], particle.position[1], pz);
        const deckLevel = boundary.levels[boundary.levels.length - 1];
        if (!deckLevel) {
            this.disableAll();
            return this;
        }
        const R = hull.orientation;
        // ── Deck normal contact ───────────────────────────────────────
        const deckZ = this.getDeckHeight(lx, ly) ?? boundary.deckHeight;
        const [dx, dy, dz] = hull.toWorldFrame3D(lx, ly, deckZ);
        const px = particle.position[0];
        const py = particle.position[1];
        // Hull Z axis in world (deck normal)
        const deckNx = R[2];
        const deckNy = R[5];
        const deckNz = R[8];
        const rawDeckDist = deckNx * (px - dx) + deckNy * (py - dy) + deckNz * (pz - dz);
        const deckPenetration = rawDeckDist - this.radius;
        const rjDeckX = dx - hull.position[0];
        const rjDeckY = dy - hull.position[1];
        const rjDeckZ = dz - hull.z;
        normal.enabled = true;
        this.setShapeJacobian(normal, deckNx, deckNy, deckNz, rjDeckX, rjDeckY, rjDeckZ);
        normal.offset = deckPenetration;
        this._active = true;
        // ── Edge proximity ───────────────────────────────────────────
        const nearest = (0, $16af0982eee53e14$export$bffdeceb379536b2)(deckLevel, lx, ly);
        const inside = (0, $16af0982eee53e14$export$7f6bc8d3d7d61b11)(deckLevel, lx, ly);
        const dist = Math.sqrt(nearest.distSq);
        const signedDist = inside ? dist : -dist;
        const engageRange = this.radius + this.edgeBuffer;
        const nearEdge = signedDist < engageRange;
        // Inward normal in hull-local XY: points from boundary toward sailor
        // when inside, flipped when outside. Only meaningful near the edge
        // (far from any edge the nearest-edge direction flips around and is
        // unstable), so we only compute it when nearEdge.
        let inNx = 0;
        let inNy = 0;
        if (nearEdge) {
            if (dist > 1e-6) {
                const invDist = 1 / dist;
                const sign = inside ? 1 : -1;
                inNx = sign * (lx - nearest.cx) * invDist;
                inNy = sign * (ly - nearest.cy) * invDist;
            } else {
                inNx = -deckLevel.edgeNx[nearest.edgeIndex];
                inNy = -deckLevel.edgeNy[nearest.edgeIndex];
            }
        }
        // ── Wall contact (unilateral, only when near edge) ──────────
        if (nearEdge) {
            const [wx, wy, wz] = hull.toWorldFrame3D(nearest.cx, nearest.cy, deckZ);
            const rjWallX = wx - hull.position[0];
            const rjWallY = wy - hull.position[1];
            const rjWallZ = wz - hull.z;
            // World-frame inward normal (rotate hull-local (inNx, inNy, 0) to world).
            const wnx = R[0] * inNx + R[1] * inNy;
            const wny = R[3] * inNx + R[4] * inNy;
            const wnz = R[6] * inNx + R[7] * inNy;
            if (!this._wallEngaged) {
                // Re-engaging after being disabled — drop stale warm-start so an
                // impulse cached in a different direction doesn't fire.
                wall.warmLambda = 0;
                wall.multiplier = 0;
            }
            wall.enabled = true;
            this.setShapeJacobian(wall, wnx, wny, wnz, rjWallX, rjWallY, rjWallZ);
            // Penetration: negative when sailor center is within `radius` of
            // boundary (or past it). Unilateral bound → no force when positive.
            wall.offset = signedDist - this.radius;
            this._wallEngaged = true;
        } else {
            wall.enabled = false;
            this._wallEngaged = false;
        }
        // ── Friction (walk motor on hull X/Y, with projected target near edge) ──
        const slipForce = this.fixedFrictionForce > 0 ? this.fixedFrictionForce : this.frictionCoefficient * Math.abs(normal.multiplier);
        if (slipForce > 0) {
            friction1.enabled = true;
            friction1.minForce = -slipForce;
            friction1.maxForce = slipForce;
            friction2.enabled = true;
            friction2.minForce = -slipForce;
            friction2.maxForce = slipForce;
        } else {
            friction1.enabled = false;
            friction2.enabled = false;
        }
        // Project the walk motor onto the along-edge tangent when near the
        // boundary, so the solver isn't asked to drive the sailor through the
        // wall.  NOTE: the friction equations' Jacobian sign convention makes a
        // positive `relativeVelocity` drive motion in the -tangent direction
        // (see PlayerBoatController.onTickWalking), so the *actual* desired
        // velocity is `-target`. Target has an inward component means actual
        // motion is outward; strip that component.
        let targetX = this.targetVelocityX;
        let targetY = this.targetVelocityY;
        if (nearEdge) {
            const c = targetX * inNx + targetY * inNy;
            if (c > 0) {
                targetX -= c * inNx;
                targetY -= c * inNy;
            }
        }
        // Tangent 1: hull's local X axis (forward) in world space
        this.setShapeJacobian(friction1, R[0], R[3], R[6], rjDeckX, rjDeckY, rjDeckZ);
        friction1.offset = 0;
        friction1.relativeVelocity = targetX;
        // Tangent 2: hull's local Y axis (starboard) in world space
        this.setShapeJacobian(friction2, R[1], R[4], R[7], rjDeckX, rjDeckY, rjDeckZ);
        friction2.offset = 0;
        friction2.relativeVelocity = targetY;
        return this;
    }
    /**
   * Write a point-to-rigid constraint direction to the shape fields. Mirrors
   * the helper in {@link DeckContactConstraint}: body A (point) receives `-n`,
   * body B receives `+n` linear and `rj × n` angular.
   */ setShapeJacobian(eq, origNx, origNy, origNz, rjX, rjY, rjZ) {
        eq.nx = -origNx;
        eq.ny = -origNy;
        eq.nz = -origNz;
        eq.rjXnX = -(rjY * origNz - rjZ * origNy);
        eq.rjXnY = -(rjZ * origNx - rjX * origNz);
        eq.rjXnZ = -(rjX * origNy - rjY * origNx);
    }
    disableAll() {
        for (const eq of this.equations)eq.enabled = false;
        this._active = false;
        this._wallEngaged = false;
    }
    isActive() {
        return this._active;
    }
}




const $ec21187209955c1c$export$5d3fb96893a98a56 = 170;
const $ec21187209955c1c$export$8626ab6fd80544d1 = 6;
const $ec21187209955c1c$export$fcd1687772d55577 = 12;
const $ec21187209955c1c$export$106f49812c8cd7f8 = 2.5;
const $ec21187209955c1c$var$SAILOR_RADIUS = 0.8; // ft — visual radius of the orange circle
const $ec21187209955c1c$var$SAILOR_GRAVITY = 32.174; // ft/s² (standard gravity in engine units)
const $ec21187209955c1c$var$SAILOR_FRICTION = 20.0; // high friction to track target velocity closely
/**
 * Cap on the deck-normal reaction force (in force units, measured as
 * multiples of the sailor's weight). The normal equation stays stiff so
 * the sailor rests on the deck without sagging, but bounding the force
 * means a sudden deck-height discontinuity produces a manageable impulse
 * on the hull instead of yanking the ship downward.
 */ const $ec21187209955c1c$var$SAILOR_NORMAL_FORCE_CAP = 4; // × sailor weight
/**
 * Cap on the station weld's max force per axis (× sailor weight). Bounds
 * the impulse if the sailor happens to activate with a nonzero position
 * error and limits how hard the weld can yank the hull.
 */ const $ec21187209955c1c$var$SAILOR_WELD_FORCE_CAP = 8; // × sailor weight
/**
 * Relaxation for the station weld's three axis equations. The weld is a
 * full 3-axis position lock, so radial and tangential motion both settle
 * naturally; default-ish relaxation is sufficient.
 */ const $ec21187209955c1c$var$SAILOR_WELD_RELAXATION = 6;
/**
 * Seconds to slide the weld's hull-local anchor from the sailor's entry
 * position to the actual station position. The constraint stays stiff
 * throughout; only the target moves, so the sailor tracks it without a
 * large position-error impulse at activation.
 */ const $ec21187209955c1c$var$SAILOR_WELD_RAMP_DURATION = 0.3;
class $ec21187209955c1c$export$50a23803b0fb559f extends (0, $c59361981bac2575$export$4342ba5c6ad1f6f1) {
    constructor(stations, initialStationId, hullBody, getDeckHeight, hullBoundary, deckHeight){
        super(), this.layer = "boat", /**
   * Ramp progress [0, 1] for sliding the weld's hull-local anchor from the
   * sailor's entry position toward the station's actual position. 1 = anchor
   * fully at the station. Reset to 0 on station entry and advances each tick
   * while stationed.
   */ this._weldRampT = 1, /** Hull-local anchor position at activation (start of the slide). */ this._weldRampStart = new (0, $3480ec8c2fb5ff20$export$d2de7ccaa2f4bf9f)(0, 0, 0), /** Hull-local anchor position at the station (end of the slide). */ this._weldRampTarget = new (0, $3480ec8c2fb5ff20$export$d2de7ccaa2f4bf9f)(0, 0, 0);
        this.stations = stations;
        this.hullBody = hullBody;
        this.deckHeight = deckHeight;
        // Find the initial station and compute world position
        const initialStation = this.getStation(initialStationId);
        const worldPos = this.stationWorldPosition(initialStation);
        // Create the sailor's physics body — a point particle on the deck
        this.body = (0, $4aa863c0a97fa3b4$export$f49b83b66b23fb37)({
            motion: "dynamic",
            mass: $ec21187209955c1c$export$5d3fb96893a98a56,
            position: [
                worldPos.x,
                worldPos.y
            ],
            damping: 0.1,
            allowSleep: false,
            zMass: $ec21187209955c1c$export$5d3fb96893a98a56,
            zDamping: 0.9,
            z: deckHeight + $ec21187209955c1c$var$SAILOR_RADIUS
        });
        // Create deck contact constraint — keeps sailor on deck with a
        // vertex-aware inward wall that prevents walking off the edge.
        this.deckConstraint = new (0, $792dbae47b9a5637$export$9bd7938412e8b748)(this.body, hullBody, getDeckHeight, hullBoundary, $ec21187209955c1c$var$SAILOR_FRICTION, $ec21187209955c1c$var$SAILOR_RADIUS, $ec21187209955c1c$var$SAILOR_RADIUS, {
            collideConnected: true,
            wakeUpBodies: false
        });
        // Cap the normal equation's max force so sudden deck-height
        // discontinuities don't jerk the hull. Steady-state support (gravity)
        // sits well below the cap, so normal behavior is unaffected. Friction
        // is decoupled from the (now-bounded) normal multiplier so lateral
        // grip stays firm regardless of transient normal dips.
        const sailorWeight = $ec21187209955c1c$export$5d3fb96893a98a56 * $ec21187209955c1c$var$SAILOR_GRAVITY;
        this.deckConstraint.equations[0].maxForce = sailorWeight * $ec21187209955c1c$var$SAILOR_NORMAL_FORCE_CAP;
        this.deckConstraint.fixedFrictionForce = sailorWeight * $ec21187209955c1c$var$SAILOR_FRICTION;
        // 3-axis position lock that holds the sailor at a station's hull-local
        // anchor while stationed. Disabled while walking. The per-axis maxForce
        // cap bounds activation impulses and limits how hard the weld can yank
        // the hull.
        this.stationWeld = new (0, $30a388d2d8931336$export$53bb26c88568ac39)(this.body, hullBody, {
            localAnchorB: [
                initialStation.position[0],
                initialStation.position[1],
                deckHeight + $ec21187209955c1c$var$SAILOR_RADIUS
            ],
            maxForce: sailorWeight * $ec21187209955c1c$var$SAILOR_WELD_FORCE_CAP,
            collideConnected: true,
            wakeUpBodies: false
        });
        for (const eq of this.stationWeld.equations){
            eq.relaxation = $ec21187209955c1c$var$SAILOR_WELD_RELAXATION;
            eq.needsUpdate = true;
        }
        // Start pinned to the initial station: deck constraint off, weld on.
        this.deckConstraint.disabled = true;
        this.stationWeld.disabled = false;
        this.constraints = [
            this.deckConstraint,
            this.stationWeld
        ];
        this._state = {
            kind: "atStation",
            stationId: initialStationId
        };
    }
    // ── Public API ──────────────────────────────────────────────────
    get state() {
        return this._state;
    }
    /** The current station, or null if walking. */ getCurrentStation() {
        if (this._state.kind === "atStation") return this.getStation(this._state.stationId);
        return null;
    }
    /** Whether the sailor is at the given station. */ isAtStation(id) {
        return this._state.kind === "atStation" && this._state.stationId === id;
    }
    /** Leave the current station and begin walking. */ beginWalking() {
        if (this._state.kind === "atStation") {
            const prevStation = this._state.stationId;
            this._state = {
                kind: "walking"
            };
            this.deckConstraint.disabled = false;
            this.stationWeld.disabled = true;
            this.game.dispatch("sailorLeftStation", {
                stationId: prevStation
            });
        }
    }
    /**
   * Set the walk velocity in hull-local coordinates (ft/s), clamped to
   * `maxSpeed` by magnitude. Only has effect while walking.
   */ setWalkVelocity(localX, localY, maxSpeed) {
        if (this._state.kind !== "walking") return;
        const mag = Math.sqrt(localX * localX + localY * localY);
        if (mag > maxSpeed) {
            const scale = maxSpeed / mag;
            localX *= scale;
            localY *= scale;
        }
        this.deckConstraint.targetVelocityX = localX;
        this.deckConstraint.targetVelocityY = localY;
    }
    // ── Tick ─────────────────────────────────────────────────────────
    onTick({ dt: dt }) {
        // Gravity always acts on the sailor body. When stationed, the 3-axis
        // station weld resists gravity and transfers the reaction to the hull
        // at the station anchor. When walking, the deck constraint handles it.
        this.body.applyForce3D(0, 0, -$ec21187209955c1c$var$SAILOR_GRAVITY * this.body.mass, 0, 0, 0);
        if (this._state.kind === "atStation") {
            this.deckConstraint.targetVelocityX = 0;
            this.deckConstraint.targetVelocityY = 0;
            this.advanceWeldRamp(dt);
        }
    }
    advanceWeldRamp(dt) {
        if (this._weldRampT >= 1) return;
        this._weldRampT = Math.min(1, this._weldRampT + dt / $ec21187209955c1c$var$SAILOR_WELD_RAMP_DURATION);
        // Smoothstep ease so the anchor accelerates in and decelerates out.
        const t = this._weldRampT;
        const eased = t * t * (3 - 2 * t);
        const start = this._weldRampStart;
        const target = this._weldRampTarget;
        this.stationWeld.localAnchorB[0] = start[0] + (target[0] - start[0]) * eased;
        this.stationWeld.localAnchorB[1] = start[1] + (target[1] - start[1]) * eased;
        this.stationWeld.localAnchorB[2] = start[2] + (target[2] - start[2]) * eased;
    }
    /**
   * Kick off a fresh pull-in ramp toward the given station. Snapshots the
   * sailor's current hull-local 3D position as the slide's start so the
   * weld activates with zero position error, then lerps the anchor over
   * `SAILOR_WELD_RAMP_DURATION` to the station's actual local position.
   */ beginWeldRamp(station) {
        const localStart = this.hullBody.toLocalFrame3D(this.body.position[0], this.body.position[1], this.body.z);
        this._weldRampStart.set(localStart[0], localStart[1], localStart[2]);
        this._weldRampTarget.set(station.position[0], station.position[1], this.deckHeight + $ec21187209955c1c$var$SAILOR_RADIUS);
        this.stationWeld.localAnchorB.set(this._weldRampStart[0], this._weldRampStart[1], this._weldRampStart[2]);
        this._weldRampT = 0;
        for (const eq of this.stationWeld.equations){
            eq.warmLambda = 0;
            eq.multiplier = 0;
        }
    }
    /** Return the station within snapRadius of the sailor, or null. */ findNearbyStation() {
        const [lx, ly] = this.getLocalPosition();
        const r2 = $ec21187209955c1c$export$106f49812c8cd7f8 * $ec21187209955c1c$export$106f49812c8cd7f8;
        for (const station of this.stations){
            const dx = lx - station.position[0];
            const dy = ly - station.position[1];
            if (dx * dx + dy * dy < r2) return station;
        }
        return null;
    }
    /** Snap to a nearby station if one is in range. Does nothing otherwise. */ snapToNearbyStation() {
        if (this._state.kind !== "walking") return;
        const near = this.findNearbyStation();
        if (near) this.snapToStation(near);
    }
    snapToStation(station) {
        // Switch from walking to the station weld. No position/velocity
        // teleport — the ramped weld slides the anchor from the sailor's
        // current spot to the station, dragging them along smoothly.
        this.deckConstraint.targetVelocityX = 0;
        this.deckConstraint.targetVelocityY = 0;
        this.deckConstraint.disabled = true;
        this.stationWeld.disabled = false;
        this.beginWeldRamp(station);
        this._state = {
            kind: "atStation",
            stationId: station.id
        };
        this.game.dispatch("sailorEnteredStation", {
            stationId: station.id
        });
    }
    // ── Rendering ───────────────────────────────────────────────────
    onRender({ draw: draw }) {
        // Draw in world space without the hull's tilt transform so the sailor
        // always reads as a flat 2D circle regardless of roll/pitch.
        const [px, py] = this.body.position;
        draw.fillCircle(px, py, $ec21187209955c1c$var$SAILOR_RADIUS, {
            color: 0xf21a00,
            z: this.body.z
        });
    }
    // ── Helpers ─────────────────────────────────────────────────────
    getStation(id) {
        const station = this.stations.find((s)=>s.id === id);
        if (!station) throw new Error(`Unknown station: ${id}`);
        return station;
    }
    stationWorldPosition(station) {
        return this.hullBody.toWorldFrame((0, $6b6a54a072724620$export$e7c866399fa523f5)(station.position[0], station.position[1]));
    }
    /** Get the sailor's hull-local position. */ getLocalPosition() {
        const [lx, ly] = this.hullBody.toLocalFrame3D(this.body.position[0], this.body.position[1], this.body.z);
        return [
            lx,
            ly
        ];
    }
    /**
   * Restore sailor state from a save file.
   * If stationId is non-null, snaps to that station.
   * Otherwise, places the sailor at the given hull-local position in walking mode.
   */ restoreState(stationId, position) {
        if (stationId) {
            const station = this.stations.find((s)=>s.id === stationId);
            if (station) {
                const worldPos = this.stationWorldPosition(station);
                this.body.position.set(worldPos);
                this.body.velocity.set(0, 0);
                this.body.zVelocity = 0;
                this.deckConstraint.disabled = true;
                this.stationWeld.localAnchorB.set(station.position[0], station.position[1], this.deckHeight + $ec21187209955c1c$var$SAILOR_RADIUS);
                this.stationWeld.disabled = false;
                // Load fully pinned — no pull-in animation on a fresh game.
                this._weldRampT = 1;
                this._weldRampStart.set(this.stationWeld.localAnchorB);
                this._weldRampTarget.set(this.stationWeld.localAnchorB);
                for (const eq of this.stationWeld.equations){
                    eq.warmLambda = 0;
                    eq.multiplier = 0;
                }
                this._state = {
                    kind: "atStation",
                    stationId: stationId
                };
                return;
            }
        }
        // Walking or unknown station — place at position
        const [wx, wy] = this.hullBody.toWorldFrame3D(position[0], position[1], 0);
        this.body.position.set(wx, wy);
        this.body.velocity.set(0, 0);
        this.body.zVelocity = 0;
        this.deckConstraint.disabled = false;
        this.stationWeld.disabled = true;
        this._state = {
            kind: "walking"
        };
    }
}
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $aa1f0309d9dba6d2$export$af631764ddc44097)("tick")
], $ec21187209955c1c$export$50a23803b0fb559f.prototype, "onTick", null);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $aa1f0309d9dba6d2$export$af631764ddc44097)("render")
], $ec21187209955c1c$export$50a23803b0fb559f.prototype, "onRender", null);


class $52fa7c25729534ad$export$50202e6ddd188c3a extends (0, $c59361981bac2575$export$4342ba5c6ad1f6f1) {
    // Convenience accessors for roll/pitch (delegates to hull body's 6DOF state)
    get roll() {
        return this.hull.body.roll;
    }
    get pitch() {
        return this.hull.body.pitch;
    }
    get rollVelocity() {
        return this.hull.body.rollVelocity;
    }
    get pitchVelocity() {
        return this.hull.body.pitchVelocity;
    }
    getPosition() {
        return this.hull.body.position;
    }
    getVelocity() {
        return this.hull.body.velocity;
    }
    get toWorldFrame() {
        return this.hull.body.toWorldFrame.bind(this.hull.body);
    }
    constructor(startPosition = (0, $6b6a54a072724620$export$e7c866399fa523f5)(0, 0), config = (0, $15d2d1238b44a5eb$export$4932a959e7a6b520), startRotation = 0){
        super(), this.id = "boat", this.bowsprit = null, this.jib = null, this.jibSailDamage = null, this.portJibSheet = null, this.starboardJibSheet = null;
        this.config = config;
        // Compute derived positions from config
        this.bowspritTipPosition = config.bowsprit ? config.bowsprit.attachPoint.add([
            config.bowsprit.size.x,
            0
        ]) : null;
        // Create hull first with 6DOF physics (z, roll, pitch integrated by engine)
        const bc = config.buoyancy;
        this.hull = this.addChild(new (0, $d106d09a724e422d$export$c4813cc5e4374a49)(config.hull, {
            rollInertia: bc.rollInertia,
            pitchInertia: bc.pitchInertia,
            zMass: bc.verticalMass
        }, bc.verticalMass, bc.centerOfGravityZ));
        // Set hull position BEFORE creating sub-entities so that physics bodies
        // (boom, sail particles, jib particles) are positioned correctly in world space.
        this.hull.body.position.set(startPosition);
        this.hull.body.angle = startRotation;
        // Create parts that attach to hull
        this.keel = this.addChild(new (0, $9e287f6f6f4a3625$export$979f3f46cb02524b)(this.hull, config.keel, config.hull.draft));
        this.rudder = this.addChild(new (0, $25e0c89662f4d37c$export$73c07ddd07f99ce5)(this.hull, config.rudder));
        this.rig = this.addChild(new (0, $d9694b9d28aa2066$export$5a9e73b136955cd3)(this.hull, config.rig));
        if (config.bowsprit) this.bowsprit = this.addChild(new (0, $c31dec775204da9f$export$8068c6f3648e316e)(this, config.bowsprit));
        // Build hull boundary data for deck contact constraints (shared by all sheets).
        // Samples the hull cross-section at multiple z-levels so wall constraints
        // respect the hull's tapering shape at different depths.
        const hullBoundary = $52fa7c25729534ad$var$buildHullBoundary(this.hull.getPhysicsMesh(), config.hull.deckHeight, config.hull.draft);
        // Create mainsheet (boom to hull)
        const { hullAttachPoint: hullAttachPoint, boomAttachRatio: boomAttachRatio, winchPoint: winchPoint, ...mainsheetConfig } = config.mainsheet;
        const boomZ = config.rig.mainsail.zFoot ?? 3;
        const deckZ = config.hull.deckHeight;
        const getDeckHeight = (lx, ly)=>this.hull.getDeckHeight(lx, ly);
        // Hardware (blocks, winches) sits slightly above the deck surface.
        const hardwareOffset = 0.3;
        const deckZAt = (anchor)=>(getDeckHeight(anchor.x, anchor.y) ?? deckZ) + hardwareOffset;
        const mainsheetWaypoints = winchPoint ? [
            {
                body: this.hull.body,
                localAnchor: new (0, $3480ec8c2fb5ff20$export$d2de7ccaa2f4bf9f)(winchPoint.x, winchPoint.y, deckZAt(winchPoint)),
                type: "winch",
                radius: 0
            }
        ] : [];
        // zA = 0 for the boom: the boom body is 6DOF with zPosition = boomZ
        // (set in Rig), so the local anchor z is relative to the boom's own plane.
        this.mainsheet = this.addChild(new (0, $d62dd12816171ede$export$a9bf29f8d87ebbee)(this.rig.body, new (0, $3480ec8c2fb5ff20$export$d2de7ccaa2f4bf9f)(-this.rig.getBoomLength() * boomAttachRatio, 0, 0), this.hull.body, new (0, $3480ec8c2fb5ff20$export$d2de7ccaa2f4bf9f)(hullAttachPoint.x, hullAttachPoint.y, deckZAt(hullAttachPoint)), mainsheetConfig, mainsheetWaypoints, getDeckHeight, hullBoundary));
        // Main halyard: 3-node rope that runs from a deck cleat up the mast,
        // over a sheave block at the masthead, and down to the sail-head
        // shackle. Physics-inert — the rope network has slack so the capstan
        // solver never drives the hull.
        const mastPos = config.rig.mastPosition;
        const mastTopZ = this.rig.getMastTopZ();
        const { cleatPoint: cleatPoint, cleatZ: cleatZ, sheaveOffset: sheaveOffset, sheaveElevation: sheaveElevation, headOffset: headOffset, ...halyardRender } = config.halyard;
        const sheaveX = mastPos.x + (sheaveOffset?.x ?? 0);
        const sheaveY = mastPos.y + (sheaveOffset?.y ?? 0);
        const sheaveZ = mastTopZ + (sheaveElevation ?? 0.3);
        const headX = mastPos.x + (headOffset?.x ?? 0);
        const headY = mastPos.y + (headOffset?.y ?? 0);
        const mainsail = this.rig.sail;
        const sailZFoot = config.rig.mainsail.zFoot ?? 3;
        this.mainHalyard = this.addChild(new (0, $85dad0c9138bbb78$export$dae18d6265d3c893)(this.hull.body, new (0, $3480ec8c2fb5ff20$export$d2de7ccaa2f4bf9f)(cleatPoint.x, cleatPoint.y, cleatZ), new (0, $3480ec8c2fb5ff20$export$d2de7ccaa2f4bf9f)(sheaveX, sheaveY, sheaveZ), new (0, $3480ec8c2fb5ff20$export$d2de7ccaa2f4bf9f)(headX, headY, mainsail.getHeadZ()), halyardRender, getDeckHeight, hullBoundary, {
            getHeadZ: ()=>mainsail.getHeadZ(),
            // When fully furled, the head rides at the boom height — that's
            // the longest the descending run ever gets, so size the rope
            // for that worst case.
            minHeadZ: sailZFoot
        }));
        // Create jib and jib sheets if configured
        if (config.jib && config.jibSheet && this.bowspritTipPosition) {
            const jibTackPosition = this.bowspritTipPosition;
            const jibHeadPosition = config.rig.mastPosition;
            // Compute initial clew position for jib
            const tack = this.toWorldFrame(jibTackPosition);
            const head = this.toWorldFrame(jibHeadPosition);
            const footDir = tack.sub(head).irotate90cw().inormalize();
            const initialClewPosition = tack.addScaled(footDir, 5).iadd((0, $6b6a54a072724620$export$e7c866399fa523f5)(-1.5, 0).irotate(this.hull.body.angle));
            // Create jib sail
            this.jib = this.addChild(new (0, $829cf18f7acab1e1$export$b7805bbaedd56cd)({
                ...config.jib,
                getHeadPosition: ()=>this.toWorldFrame(jibTackPosition),
                headLocalPosition: jibTackPosition,
                luffTopLocalPosition: jibHeadPosition,
                initialClewPosition: initialClewPosition,
                headConstraint: {
                    body: this.hull.body,
                    localAnchor: jibTackPosition
                },
                sailShape: "triangle",
                getHullBody: ()=>this.hull.body
            }));
            // Create jib sheets (clew to hull, port and starboard)
            const { portAttachPoint: portAttachPoint, starboardAttachPoint: starboardAttachPoint, portBlockPoint: portBlockPoint, starboardBlockPoint: starboardBlockPoint, portWinchPoint: portWinchPoint, starboardWinchPoint: starboardWinchPoint, ...jibSheetConfig } = config.jibSheet;
            const clewBody = this.jib.getClew();
            const jibClewZ = config.jib.zFoot ?? 3;
            // Build waypoint arrays: blocks first, then winch
            const portWaypoints = [];
            if (portBlockPoint) portWaypoints.push({
                body: this.hull.body,
                localAnchor: new (0, $3480ec8c2fb5ff20$export$d2de7ccaa2f4bf9f)(portBlockPoint.x, portBlockPoint.y, deckZAt(portBlockPoint)),
                frictionCoefficient: jibSheetConfig.blockFrictionCoefficient,
                radius: 0
            });
            if (portWinchPoint) portWaypoints.push({
                body: this.hull.body,
                localAnchor: new (0, $3480ec8c2fb5ff20$export$d2de7ccaa2f4bf9f)(portWinchPoint.x, portWinchPoint.y, deckZAt(portWinchPoint)),
                type: "winch",
                radius: 0
            });
            const starboardWaypoints = [];
            if (starboardBlockPoint) starboardWaypoints.push({
                body: this.hull.body,
                localAnchor: new (0, $3480ec8c2fb5ff20$export$d2de7ccaa2f4bf9f)(starboardBlockPoint.x, starboardBlockPoint.y, deckZAt(starboardBlockPoint)),
                frictionCoefficient: jibSheetConfig.blockFrictionCoefficient,
                radius: 0
            });
            if (starboardWinchPoint) starboardWaypoints.push({
                body: this.hull.body,
                localAnchor: new (0, $3480ec8c2fb5ff20$export$d2de7ccaa2f4bf9f)(starboardWinchPoint.x, starboardWinchPoint.y, deckZAt(starboardWinchPoint)),
                type: "winch",
                radius: 0
            });
            // zA = 0 for jib sheets: the clew body already has z = jibClewZ
            // from its sixDOF setup. The local anchor z is relative to the body.
            this.portJibSheet = this.addChild(new (0, $d62dd12816171ede$export$a9bf29f8d87ebbee)(clewBody, new (0, $3480ec8c2fb5ff20$export$d2de7ccaa2f4bf9f)(0, 0, 0), this.hull.body, new (0, $3480ec8c2fb5ff20$export$d2de7ccaa2f4bf9f)(portAttachPoint.x, portAttachPoint.y, deckZAt(portAttachPoint)), {
                ...jibSheetConfig,
                tailDirection: (0, $6b6a54a072724620$export$e7c866399fa523f5)(-1, -1).normalize()
            }, portWaypoints, getDeckHeight, hullBoundary));
            this.starboardJibSheet = this.addChild(new (0, $d62dd12816171ede$export$a9bf29f8d87ebbee)(clewBody, new (0, $3480ec8c2fb5ff20$export$d2de7ccaa2f4bf9f)(0, 0, 0), this.hull.body, new (0, $3480ec8c2fb5ff20$export$d2de7ccaa2f4bf9f)(starboardAttachPoint.x, starboardAttachPoint.y, deckZAt(starboardAttachPoint)), {
                ...jibSheetConfig,
                tailDirection: (0, $6b6a54a072724620$export$e7c866399fa523f5)(-1, 1).normalize()
            }, starboardWaypoints, getDeckHeight, hullBoundary));
            this.starboardJibSheet.release();
        }
        // Create lifelines (stanchions, pulpits, lifeline wires)
        if (config.lifelines) this.addChild(new (0, $772958a7afcb0bb0$export$c28251d0c7617e9e)(this, config.lifelines));
        // Unified boat renderer — all boat visual components rendered through
        // a single tilt context with per-vertex z for correct depth ordering
        this.addChild(new (0, $cbea09b7c78e78c3$export$a1ffd5948b27dfc8)(this));
        // Create sailor character
        this.sailor = this.addChild(new (0, $ec21187209955c1c$export$50a23803b0fb559f)(config.stations, config.initialStationId, this.hull.body, getDeckHeight, hullBoundary, config.hull.deckHeight));
        this.mooring = this.addChild(new (0, $2a4b558bc22b4f97$export$6238d4b9ead0a783)(this));
        this.anchor = this.addChild(new (0, $0d3ea614828af746$export$b688253958b8dfe7)(this.hull, config.anchor));
        // Wake sources are emitted per-tick from waterline-straddling hull
        // triangles; this single Wake consumes them and spawns ring particles.
        this.addChild(new (0, $5ec49109b3a14edd$export$e65e6447faad556c)(this));
        // Create terrain querier for grounding physics
        this.addChild(new (0, $ef3d72bebf669cf8$export$b3b355ccc72406cc)(this));
        // Water accumulation, slosh, and bilge system
        this.bilge = this.addChild(new (0, $509b490762ff55e4$export$ad16b76b041f5fb4)(this, config.bilge, this.hull.hullVolume));
        // Hull damage tracking
        this.hullDamage = this.addChild(new (0, $86fc3e1f47795d45$export$6737acbbaec69573)(this, config.hullDamage));
        // Wire damage effects to hull friction and bilge leaking
        this.hull.setDamageMultiplier(()=>this.hullDamage.getSkinFrictionMultiplier());
        this.bilge.setHullLeakRate(()=>this.hullDamage.getLeakRate());
        // Rudder damage tracking
        this.rudderDamage = this.addChild(new (0, $6997f3124be71fbe$export$4a0455c9a96b39c9)(this, config.rudderDamage));
        // Wire rudder damage effects to steering
        this.rudder.setDamageEffects(()=>this.rudderDamage.getSteeringMultiplier(), ()=>this.rudderDamage.getSteeringBias());
        // Sail damage tracking (mainsail)
        this.mainSailDamage = this.addChild(new (0, $7f3fd39e55083312$export$fd5fe28aa072e04d)(this, config.sailDamage, this.rig.sail, "main", this.mainsheet));
        this.rig.sail.setDamageMultiplier(()=>this.mainSailDamage.getLiftMultiplier());
        // Sail damage tracking (jib, if present)
        if (this.jib) {
            this.jibSailDamage = this.addChild(new (0, $7f3fd39e55083312$export$fd5fe28aa072e04d)(this, config.sailDamage, this.jib, "jib", this.portJibSheet));
            this.jib.setDamageMultiplier(()=>this.jibSailDamage.getLiftMultiplier());
        }
        // Boat sound effects (sheet snaps, boom slams)
        this.addChild(new (0, $77131e34d87ca548$export$b2c121e758c36aae)(this));
    }
    /** Row the boat forward */ row() {
        const angle = this.hull.body.angle;
        const force = this.config.rowing.force;
        this.hull.body.applyForce3D(Math.cos(angle) * force, Math.sin(angle) * force, 0, 0, 0, 0);
    }
}
/**
 * Build hull boundary data by sampling the hull cross-section at multiple
 * z-levels. The resulting outlines taper from wide (deck) to narrow (keel),
 * so wall constraints at different depths correctly match the hull shape.
 */ function $52fa7c25729534ad$var$buildHullBoundary(mesh, deckHeight, draft) {
    // Sample z-levels from hull bottom to deck
    const zSamples = [
        -draft,
        -draft * 0.5,
        0,
        deckHeight * 0.33,
        deckHeight * 0.67,
        deckHeight
    ];
    const levels = [];
    for (const z of zSamples){
        const outline = (0, $779a9fe58269ee84$export$da258e5b085eea85)(mesh, z);
        const level = (0, $3060cd7907214b09$export$a1b6c2945208a187)(outline, z);
        if (level) levels.push(level);
    }
    // Sort ascending by z (should already be, but ensure)
    levels.sort((a, b)=>a.z - b.z);
    return {
        levels: levels,
        deckHeight: deckHeight,
        draft: draft
    };
}





const $2aa82da197f24de3$var$FT_PER_SEC_TO_KNOTS = 1 / 1.69;
class $2aa82da197f24de3$export$3e4593ac014e28d7 extends (0, $7d9b0c3658290da5$export$690dd8da38397efd) {
    constructor(){
        super(()=>this.renderContent());
    }
    renderContent() {
        const boat = this.game?.entities.getById("boat");
        if (!boat) return /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("div", {});
        const knots = boat.getVelocity().magnitude * $2aa82da197f24de3$var$FT_PER_SEC_TO_KNOTS;
        const rollDeg = (0, $2172aedd5a25ff17$export$54390e3b44c4a9cb)(boat.roll);
        const pitchDeg = (0, $2172aedd5a25ff17$export$54390e3b44c4a9cb)(boat.pitch);
        const zHeight = boat.hull.body.z;
        const waterPct = boat.bilge.getWaterFraction() * 100;
        const wheelLabel = this.game.io.getSteeringWheelDebugLabel();
        return /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("div", {
            style: {
                position: "fixed",
                top: "140px",
                right: "20px",
                color: "white",
                textShadow: "0 0 2px rgba(0, 0, 0, 0.6)",
                opacity: 0.7,
                fontFamily: "var(--font-body)",
                fontWeight: "300",
                fontSize: "12px",
                userSelect: "none",
                pointerEvents: "none",
                textAlign: "right",
                lineHeight: "1.4"
            },
            children: [
                /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("div", {
                    children: [
                        knots.toFixed(1),
                        " kt"
                    ]
                }),
                /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("div", {
                    children: [
                        "heel ",
                        rollDeg.toFixed(1),
                        "\xb0"
                    ]
                }),
                /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("div", {
                    children: [
                        "pitch ",
                        pitchDeg.toFixed(1),
                        "\xb0"
                    ]
                }),
                /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("div", {
                    children: [
                        "z ",
                        zHeight.toFixed(2),
                        " ft"
                    ]
                }),
                /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("div", {
                    children: [
                        "water ",
                        waterPct.toFixed(0),
                        "%"
                    ]
                }),
                /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("div", {
                    children: wheelLabel
                })
            ]
        });
    }
}














const $6d17b959f73c0724$export$b33d38c11e634c46 = [
    {
        id: "reinforced-hull",
        name: "Reinforced Hull",
        description: "Fiberglass reinforcement on the hull bottom. Halves damage from groundings.",
        cost: 150,
        applyToConfig: (config)=>({
                hullDamage: {
                    groundingDamageRate: config.hullDamage.groundingDamageRate * 0.5
                }
            })
    },
    {
        id: "bilge-pump",
        name: "Bilge Pump",
        description: "An electric bilge pump that automatically drains water from the cockpit.",
        cost: 100,
        applyToConfig: ()=>({
                bilge: {
                    pumpDrainRate: 0.3
                }
            })
    },
    {
        id: "better-oars",
        name: "Better Oars",
        description: "Longer, lighter oars with better blade shape. 50% more rowing force.",
        cost: 75,
        applyToConfig: (config)=>({
                rowing: {
                    force: config.rowing.force * 1.5
                }
            })
    },
    {
        id: "deeper-keel",
        name: "Deeper Keel",
        description: "Extended keel for better lateral resistance and pointing ability.",
        cost: 200,
        applyToConfig: (config)=>({
                keel: {
                    draft: config.keel.draft * 1.3
                }
            })
    },
    {
        id: "racing-sails",
        name: "Racing Sails",
        description: "High-performance laminate sails with better shape and less drag.",
        cost: 300,
        applyToConfig: ()=>({
                rig: {
                    mainsail: {
                        liftScale: 1.15,
                        dragScale: 0.9
                    }
                }
            })
    }
];
const $6d17b959f73c0724$export$cf8efd331d9fbe25 = [
    // ---- Shaff ----
    {
        id: "shaff-s7",
        name: "Shaff S-7",
        description: "A pure one-design racer built for speed over everything else. Tender and demanding \u2014 the boat teaches you to sail by punishing mistakes and rewarding precision.",
        cost: 0,
        baseConfig: (0, $15d2d1238b44a5eb$export$4932a959e7a6b520),
        displayStats: {
            speed: 7,
            stability: 3,
            durability: 4,
            maneuverability: 8
        },
        availableUpgrades: [
            "reinforced-hull",
            "bilge-pump",
            "racing-sails"
        ]
    },
    {
        id: "shaff-s11",
        name: "Shaff S-11",
        description: "Stiff, fast, and unforgiving. The J/105-inspired S-11 carries her sail better than you'd expect and rewards aggressive upwind tactics. One-design fleet racing at its best.",
        cost: 800,
        baseConfig: (0, $25abc6f868b897a0$export$159425d2e13e2762),
        displayStats: {
            speed: 8,
            stability: 5,
            durability: 4,
            maneuverability: 7
        },
        availableUpgrades: [
            "reinforced-hull",
            "bilge-pump",
            "deeper-keel",
            "racing-sails"
        ]
    },
    {
        id: "shaff-s15",
        name: "Shaff S-15",
        description: "An offshore race boat that'll push your crew to their limits. Enormous sail plan, fine entry, and a deep fin keel. When the wind pipes up, she comes alive.",
        cost: 3500,
        baseConfig: (0, $3df8a6c50260f72e$export$d53f99a813f4ed00),
        displayStats: {
            speed: 9,
            stability: 5,
            durability: 4,
            maneuverability: 6
        },
        availableUpgrades: [
            "reinforced-hull",
            "bilge-pump",
            "racing-sails"
        ]
    },
    {
        id: "shaff-s20",
        name: "Shaff S-20",
        description: "The flagship Shaff. A grand-prix offshore racer that demands a professional crew and rewards them with astonishing speed. Not for the faint-hearted.",
        cost: 12000,
        baseConfig: (0, $6d9855689a5e7a90$export$5188184813ddfa14),
        displayStats: {
            speed: 10,
            stability: 4,
            durability: 5,
            maneuverability: 5
        },
        availableUpgrades: [
            "reinforced-hull",
            "racing-sails"
        ]
    },
    // ---- BHC ----
    {
        id: "bhc-daysailer",
        name: "BHC Daysailer",
        description: "The most forgiving boat on the water. Swing keel, comfortable cockpit, basic sails \u2014 everything you need, nothing you don't. Great for learning and lazy afternoons.",
        cost: 0,
        baseConfig: (0, $f8654cd672e9a2f9$export$c057f9a6df871496),
        displayStats: {
            speed: 4,
            stability: 7,
            durability: 7,
            maneuverability: 6
        },
        availableUpgrades: [
            "reinforced-hull",
            "bilge-pump",
            "better-oars",
            "deeper-keel"
        ]
    },
    {
        id: "bhc-weekender",
        name: "BHC Weekender",
        description: "Six thousand hulls built for a reason. Comfortable enough for overnight passages, capable enough for club racing. Practically impossible to embarrass yourself on.",
        cost: 700,
        baseConfig: (0, $2dd6935249bb0d67$export$29b02d3ee8978da),
        displayStats: {
            speed: 5,
            stability: 8,
            durability: 7,
            maneuverability: 5
        },
        availableUpgrades: [
            "reinforced-hull",
            "bilge-pump",
            "better-oars",
            "deeper-keel"
        ]
    },
    {
        id: "bhc-journey",
        name: "BHC Journey",
        description: "Built for real passages. Wide, stable, and immensely livable. Not the fastest, but she'll get you there comfortably \u2014 and keep everyone sane doing it.",
        cost: 3000,
        baseConfig: (0, $517bcd07177ba604$export$ab94cb2b46827db6),
        displayStats: {
            speed: 5,
            stability: 9,
            durability: 8,
            maneuverability: 4
        },
        availableUpgrades: [
            "reinforced-hull",
            "bilge-pump",
            "better-oars"
        ]
    },
    {
        id: "bhc-expedition",
        name: "BHC Expedition",
        description: "Purpose-built for ocean passages. Heavy, supremely stable, built like a brick. The boat you want when the forecast turns bad three days from land.",
        cost: 10000,
        baseConfig: (0, $3824aca903ff016f$export$f5a343db5beaa01f),
        displayStats: {
            speed: 4,
            stability: 10,
            durability: 9,
            maneuverability: 3
        },
        availableUpgrades: [
            "reinforced-hull",
            "bilge-pump"
        ]
    },
    // ---- Maestro ----
    {
        id: "maestro-etude",
        name: "Maestro Etude",
        description: "The smallest Maestro is the most fun. Hand-laid hull, precision-cut sails, and a deeper feel than anything else in the S class. Faster than it looks.",
        cost: 600,
        baseConfig: (0, $16119decb1123822$export$958feed7eef456ff),
        displayStats: {
            speed: 7,
            stability: 6,
            durability: 6,
            maneuverability: 7
        },
        availableUpgrades: [
            "reinforced-hull",
            "bilge-pump",
            "deeper-keel",
            "racing-sails"
        ]
    },
    {
        id: "maestro-trio",
        name: "Maestro Trio",
        description: "More sail area than any other M-class boat, a beautifully balanced helm, and enough interior to mean something. Fast upwind, composed downwind, impeccably finished.",
        cost: 2800,
        baseConfig: (0, $61f11857d1d358b1$export$b18b136ccaf0cee5),
        displayStats: {
            speed: 8,
            stability: 7,
            durability: 6,
            maneuverability: 6
        },
        availableUpgrades: [
            "reinforced-hull",
            "bilge-pump",
            "deeper-keel",
            "racing-sails"
        ]
    },
    {
        id: "maestro-fantasia",
        name: "Maestro Fantasia",
        description: "The boat you commission when you've already crossed an ocean and know exactly what you want. More sail than the competition, better stability, and a level of finish that makes everything else feel unfinished.",
        cost: 9000,
        baseConfig: (0, $cdedc71a6fbe09f4$export$957df533eedbfa69),
        displayStats: {
            speed: 8,
            stability: 8,
            durability: 7,
            maneuverability: 5
        },
        availableUpgrades: [
            "reinforced-hull",
            "bilge-pump",
            "racing-sails"
        ]
    },
    {
        id: "maestro-opus",
        name: "Maestro Opus",
        description: "The pinnacle of the Maestro lineup. Deep lead keel, carbon-reinforced hull, enough sail area to humble a crew of ten. You do not buy an Opus \u2014 you earn one.",
        cost: 28000,
        baseConfig: (0, $00659e84c14701b9$export$3a0795937393c2ae),
        displayStats: {
            speed: 9,
            stability: 8,
            durability: 7,
            maneuverability: 5
        },
        availableUpgrades: [
            "reinforced-hull",
            "racing-sails"
        ]
    }
];
function $6d17b959f73c0724$export$9f9db6a27c89416f(id) {
    return $6d17b959f73c0724$export$cf8efd331d9fbe25.find((def)=>def.id === id);
}
function $6d17b959f73c0724$export$7a5d40ee6c1e39e(id) {
    return $6d17b959f73c0724$export$b33d38c11e634c46.find((def)=>def.id === id);
}











/**
 * Menu navigation helpers that use real DOM focus as the selection model.
 *
 * Menus built on this approach get:
 * - Click and keyboard Enter/Space unified (browser fires click on focused
 *   button for Enter/Space automatically — no separate code path).
 * - Selection highlight via `:focus-visible` CSS (no `--selected` class state).
 * - A single source of truth: whichever element has focus is the selection.
 *
 * Arrow key navigation still needs to be wired up manually because the
 * browser doesn't move focus between sibling buttons on its own.
 */ const $b3d670cfac76cf94$var$FOCUSABLE_SELECTOR = 'button:not([disabled]), [tabindex]:not([tabindex="-1"])';
function $b3d670cfac76cf94$var$getFocusable(container) {
    return Array.from(container.querySelectorAll($b3d670cfac76cf94$var$FOCUSABLE_SELECTOR));
}
function $b3d670cfac76cf94$export$e4c43fd18762e8ea(container, delta) {
    const items = $b3d670cfac76cf94$var$getFocusable(container);
    if (items.length === 0) return;
    const current = document.activeElement;
    const idx = current ? items.indexOf(current) : -1;
    const next = idx < 0 ? delta > 0 ? 0 : items.length - 1 : (idx + delta + items.length) % items.length;
    const target = items[next];
    if (!target) return;
    // Focus without the browser's built-in scroll, then do our own. This
    // decouples the focus act from scrolling so that a subsequent reflow (e.g.
    // the detail panel next to the list resizing) can't race with a second
    // browser-initiated scroll.
    target.focus({
        preventScroll: true
    });
    target.scrollIntoView({
        block: "nearest",
        inline: "nearest"
    });
}
function $b3d670cfac76cf94$export$4117a64304d253b0(container) {
    $b3d670cfac76cf94$var$getFocusable(container)[0]?.focus();
}
function $b3d670cfac76cf94$export$d1f245275b1f5da9(container) {
    const active = document.activeElement;
    if (!active) return -1;
    return $b3d670cfac76cf94$var$getFocusable(container).indexOf(active);
}







class $a1603b9cc09f9d46$export$caa51bcb55fa9d65 extends (0, $c59361981bac2575$export$4342ba5c6ad1f6f1) {
    constructor(){
        super(), this.id = "progressionManager", this.money = 0, this.currentBoatId = "shaff-s7", /** Map of boat ID -> set of owned upgrade IDs */ this.ownedBoats = new Map();
        this.ownedBoats.set("shaff-s7", new Set());
    }
    // ============================================
    // Money
    // ============================================
    getMoney() {
        return this.money;
    }
    spendMoney(amount) {
        if (amount > this.money) return false;
        this.money -= amount;
        return true;
    }
    addMoney(amount) {
        this.money += amount;
    }
    // ============================================
    // Boats
    // ============================================
    getOwnedBoats() {
        return [
            ...this.ownedBoats.keys()
        ];
    }
    getCurrentBoatId() {
        return this.currentBoatId;
    }
    ownsBoat(id) {
        return this.ownedBoats.has(id);
    }
    // ============================================
    // Upgrades
    // ============================================
    hasUpgrade(boatId, upgradeId) {
        const upgrades = this.ownedBoats.get(boatId);
        return upgrades !== undefined && upgrades.has(upgradeId);
    }
    getUpgradesForBoat(boatId) {
        const upgrades = this.ownedBoats.get(boatId);
        return upgrades ? [
            ...upgrades
        ] : [];
    }
    // ============================================
    // Actions
    // ============================================
    buyBoat(boatId) {
        if (this.ownsBoat(boatId)) return false;
        const def = (0, $6d17b959f73c0724$export$9f9db6a27c89416f)(boatId);
        if (!def) return false;
        if (!this.spendMoney(def.cost)) return false;
        this.ownedBoats.set(boatId, new Set());
        return true;
    }
    buyUpgrade(boatId, upgradeId) {
        if (!this.ownsBoat(boatId)) return false;
        if (this.hasUpgrade(boatId, upgradeId)) return false;
        const def = (0, $6d17b959f73c0724$export$7a5d40ee6c1e39e)(upgradeId);
        if (!def) return false;
        if (!this.spendMoney(def.cost)) return false;
        this.ownedBoats.get(boatId).add(upgradeId);
        return true;
    }
    switchBoat(boatId) {
        if (!this.ownsBoat(boatId)) return false;
        if (boatId === this.currentBoatId) return false;
        this.currentBoatId = boatId;
        return true;
    }
    // ============================================
    // Event Handlers
    // ============================================
    onBuyBoat({ boatId: boatId }) {
        this.buyBoat(boatId);
    }
    onBuyUpgrade({ boatId: boatId, upgradeId: upgradeId }) {
        this.buyUpgrade(boatId, upgradeId);
    }
    onSwitchBoat({ boatId: boatId }) {
        this.switchBoat(boatId);
    }
    /** Restore state from a save file's progression data. */ restoreFromSave(data) {
        this.money = data.money;
        this.currentBoatId = data.currentBoatId;
        this.ownedBoats.clear();
        for (const { boatId: boatId, purchasedUpgrades: purchasedUpgrades } of data.ownedBoats)this.ownedBoats.set(boatId, new Set(purchasedUpgrades));
    }
    onRepairBoat() {
        const boat = this.game.entities.getById("boat");
        if (!boat) return;
        // Repairs are free for now
        boat.hullDamage.setHealth(1.0);
        boat.rudderDamage.setHealth(1.0);
        boat.mainSailDamage.setHealth(1.0);
        if (boat.jibSailDamage) boat.jibSailDamage.setHealth(1.0);
    }
}
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $aa1f0309d9dba6d2$export$af631764ddc44097)("buyBoat")
], $a1603b9cc09f9d46$export$caa51bcb55fa9d65.prototype, "onBuyBoat", null);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $aa1f0309d9dba6d2$export$af631764ddc44097)("buyUpgrade")
], $a1603b9cc09f9d46$export$caa51bcb55fa9d65.prototype, "onBuyUpgrade", null);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $aa1f0309d9dba6d2$export$af631764ddc44097)("switchBoat")
], $a1603b9cc09f9d46$export$caa51bcb55fa9d65.prototype, "onSwitchBoat", null);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $aa1f0309d9dba6d2$export$af631764ddc44097)("repairBoat")
], $a1603b9cc09f9d46$export$caa51bcb55fa9d65.prototype, "onRepairBoat", null);




const $30ea968e6cf290b8$export$b1df07288187ea67 = [
    {
        id: "boats",
        label: "Boats"
    },
    {
        id: "upgrades",
        label: "Upgrades"
    },
    {
        id: "repairs",
        label: "Repairs"
    }
];
function $30ea968e6cf290b8$export$dfb14ca0df8939f6({ game: game, activeTab: activeTab, onSetTab: onSetTab }) {
    const prog = game.entities.getSingleton((0, $a1603b9cc09f9d46$export$caa51bcb55fa9d65));
    const boat = game.entities.getById("boat");
    return /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("div", {
        class: "shipyard",
        children: /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("div", {
            class: "shipyard__panel",
            children: [
                /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("div", {
                    class: "shipyard__header",
                    children: [
                        /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("div", {
                            class: "shipyard__title",
                            children: "Shipyard"
                        }),
                        /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("div", {
                            class: "shipyard__money",
                            children: [
                                prog.getMoney(),
                                " gold"
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("div", {
                    class: "shipyard__tabs",
                    children: $30ea968e6cf290b8$export$b1df07288187ea67.map((tab)=>/*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("button", {
                            class: `shipyard__tab ${tab.id === activeTab ? "shipyard__tab--active" : ""}`,
                            onClick: ()=>onSetTab(tab.id),
                            children: tab.label
                        }))
                }),
                activeTab === "boats" && $30ea968e6cf290b8$var$renderBoatsTab(game, prog),
                activeTab === "upgrades" && $30ea968e6cf290b8$var$renderUpgradesTab(game, prog),
                activeTab === "repairs" && $30ea968e6cf290b8$var$renderRepairsTab(game, boat),
                /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("div", {
                    class: "shipyard__footer",
                    children: "Esc to close / Tab to switch tabs / Arrow keys to browse"
                })
            ]
        })
    });
}
function $30ea968e6cf290b8$var$renderBoatsTab(game, prog) {
    return /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("div", {
        class: "shipyard__list",
        children: (0, $6d17b959f73c0724$export$cf8efd331d9fbe25).map((def)=>{
            const owned = prog.ownsBoat(def.id);
            const isCurrent = def.id === prog.getCurrentBoatId();
            const disabled = isCurrent || !owned && prog.getMoney() < def.cost;
            const actionLabel = isCurrent ? "" : owned ? "Switch" : "Buy";
            return /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("button", {
                class: "shipyard__item",
                disabled: disabled,
                onClick: ()=>$30ea968e6cf290b8$var$executeBoatAction(game, prog, def),
                children: [
                    /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("div", {
                        class: "shipyard__item-header",
                        children: [
                            /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("span", {
                                class: "shipyard__item-name",
                                children: [
                                    def.name,
                                    isCurrent && /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("span", {
                                        class: "shipyard__badge shipyard__badge--current",
                                        children: [
                                            " ",
                                            "Current"
                                        ]
                                    }),
                                    owned && !isCurrent && /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("span", {
                                        class: "shipyard__badge shipyard__badge--owned",
                                        children: [
                                            " ",
                                            "Owned"
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("span", {
                                class: "shipyard__item-cost",
                                children: [
                                    actionLabel && /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("span", {
                                        class: "shipyard__item-action",
                                        children: actionLabel
                                    }),
                                    !owned && ` ${def.cost} gold`
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("div", {
                        class: "shipyard__item-desc",
                        children: def.description
                    }),
                    $30ea968e6cf290b8$var$renderDisplayStats(def)
                ]
            });
        })
    });
}
function $30ea968e6cf290b8$var$renderDisplayStats(def) {
    const stats = def.displayStats;
    const entries = [
        {
            label: "SPD",
            value: stats.speed
        },
        {
            label: "STB",
            value: stats.stability
        },
        {
            label: "DUR",
            value: stats.durability
        },
        {
            label: "MAN",
            value: stats.maneuverability
        }
    ];
    return /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("div", {
        class: "shipyard__stats",
        children: entries.map(({ label: label, value: value })=>/*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("div", {
                class: "shipyard__stat",
                children: [
                    /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("span", {
                        class: "shipyard__stat-label",
                        children: label
                    }),
                    /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("div", {
                        class: "shipyard__stat-bar",
                        children: /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("div", {
                            class: "shipyard__stat-fill",
                            style: `width: ${value * 10}%`
                        })
                    })
                ]
            }))
    });
}
function $30ea968e6cf290b8$var$renderUpgradesTab(game, prog) {
    const boatId = prog.getCurrentBoatId();
    const boatDef = (0, $6d17b959f73c0724$export$9f9db6a27c89416f)(boatId);
    if (!boatDef) return /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("div", {
        class: "shipyard__empty",
        children: "No boat selected."
    });
    const availableUpgrades = boatDef.availableUpgrades.map((id)=>(0, $6d17b959f73c0724$export$7a5d40ee6c1e39e)(id)).filter((u)=>u !== undefined);
    if (availableUpgrades.length === 0) return /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("div", {
        class: "shipyard__empty",
        children: "No upgrades available for this boat."
    });
    return /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("div", {
        class: "shipyard__list",
        children: availableUpgrades.map((def)=>{
            const purchased = prog.hasUpgrade(boatId, def.id);
            const disabled = purchased || prog.getMoney() < def.cost;
            return /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("button", {
                class: "shipyard__item",
                disabled: disabled,
                onClick: ()=>$30ea968e6cf290b8$var$executeUpgradeAction(game, prog, def),
                children: [
                    /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("div", {
                        class: "shipyard__item-header",
                        children: [
                            /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("span", {
                                class: "shipyard__item-name",
                                children: [
                                    def.name,
                                    purchased && /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("span", {
                                        class: "shipyard__badge shipyard__badge--owned",
                                        children: [
                                            " ",
                                            "Installed"
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("span", {
                                class: "shipyard__item-cost",
                                children: !purchased && /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)((0, $13c40c34b78c8ee2$export$ffb0004e005737fa), {
                                    children: [
                                        /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("span", {
                                            class: "shipyard__item-action",
                                            children: "Buy"
                                        }),
                                        ` ${def.cost} gold`
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("div", {
                        class: "shipyard__item-desc",
                        children: def.description
                    })
                ]
            });
        })
    });
}
function $30ea968e6cf290b8$var$getRepairEntries(boat) {
    if (!boat) return [];
    const entries = [
        {
            label: "Hull",
            health: boat.hullDamage.getHealth()
        },
        {
            label: "Rudder",
            health: boat.rudderDamage.getHealth()
        },
        {
            label: "Mainsail",
            health: boat.mainSailDamage.getHealth()
        }
    ];
    if (boat.jibSailDamage) entries.push({
        label: "Jib",
        health: boat.jibSailDamage.getHealth()
    });
    return entries;
}
function $30ea968e6cf290b8$var$renderRepairsTab(game, boat) {
    const entries = $30ea968e6cf290b8$var$getRepairEntries(boat);
    if (entries.length === 0) return /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("div", {
        class: "shipyard__empty",
        children: "No boat to repair."
    });
    const anyDamaged = entries.some((e)=>e.health < 1);
    return /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("div", {
        class: "shipyard__list",
        children: /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("div", {
            class: "shipyard__repair-card",
            children: [
                entries.map((entry)=>{
                    const pct = Math.round(entry.health * 100);
                    const fillClass = pct >= 70 ? "shipyard__repair-fill--good" : pct >= 40 ? "shipyard__repair-fill--warn" : "shipyard__repair-fill--bad";
                    return /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("div", {
                        class: "shipyard__repair-item",
                        children: [
                            /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("span", {
                                class: "shipyard__repair-label",
                                children: entry.label
                            }),
                            /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("div", {
                                class: "shipyard__repair-bar",
                                children: /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("div", {
                                    class: `shipyard__repair-fill ${fillClass}`,
                                    style: `width: ${pct}%`
                                })
                            }),
                            /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("span", {
                                class: "shipyard__repair-pct",
                                children: [
                                    pct,
                                    "%"
                                ]
                            })
                        ]
                    });
                }),
                /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("button", {
                    class: "shipyard__action shipyard__repair-all",
                    disabled: !anyDamaged,
                    onClick: ()=>game.dispatch("repairBoat", {}),
                    children: "Repair All (Free)"
                })
            ]
        })
    });
}
function $30ea968e6cf290b8$var$executeBoatAction(game, prog, def) {
    if (prog.ownsBoat(def.id)) {
        if (def.id !== prog.getCurrentBoatId()) game.dispatch("switchBoat", {
            boatId: def.id
        });
    } else if (prog.getMoney() >= def.cost) game.dispatch("buyBoat", {
        boatId: def.id
    });
}
function $30ea968e6cf290b8$var$executeUpgradeAction(game, prog, def) {
    const boatId = prog.getCurrentBoatId();
    if (!prog.hasUpgrade(boatId, def.id) && prog.getMoney() >= def.cost) game.dispatch("buyUpgrade", {
        boatId: boatId,
        upgradeId: def.id
    });
}





function $319436b4db037a61$export$b5b6844e276e1d30({ manager: manager, missions: missions, onAcceptMission: onAcceptMission }) {
    const activeMission = manager.getActiveMission();
    const hasActive = activeMission !== null;
    return /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("div", {
        class: "mission-board",
        children: [
            /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("div", {
                class: "mission-board__title",
                children: "Mission Board"
            }),
            hasActive && /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("div", {
                class: "mission-board__current",
                children: [
                    /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("div", {
                        class: "mission-board__current-label",
                        children: "Current Mission"
                    }),
                    /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("div", {
                        class: "mission-board__current-card",
                        children: [
                            /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("div", {
                                class: "mission-board__current-name",
                                children: activeMission.def.name
                            }),
                            /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("div", {
                                class: "mission-board__current-desc",
                                children: activeMission.def.description
                            })
                        ]
                    })
                ]
            }),
            missions.length === 0 ? /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("div", {
                class: "mission-board__empty",
                children: "No missions available at this port"
            }) : /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("div", {
                class: "mission-board__list",
                children: missions.map((mission)=>/*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("button", {
                        class: "mission-board__entry",
                        disabled: hasActive,
                        onClick: ()=>onAcceptMission(mission.id),
                        children: [
                            /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("div", {
                                class: "mission-board__entry-name",
                                children: mission.name
                            }),
                            /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("div", {
                                class: "mission-board__entry-desc",
                                children: mission.description
                            }),
                            /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("div", {
                                class: "mission-board__entry-rewards",
                                children: $319436b4db037a61$var$renderRewards(mission)
                            })
                        ]
                    }))
            }),
            /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("div", {
                class: "mission-board__hint",
                children: missions.length > 0 && !hasActive ? "Enter to accept / Esc to go back" : "Esc to go back"
            })
        ]
    });
}
function $319436b4db037a61$var$renderRewards(mission) {
    const rewards = mission.rewards;
    return /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)((0, $13c40c34b78c8ee2$export$ffb0004e005737fa), {
        children: [
            rewards?.money ? /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("span", {
                class: "mission-board__reward mission-board__reward-money",
                children: [
                    "$",
                    rewards.money
                ]
            }) : null,
            rewards?.revealPorts && rewards.revealPorts.length > 0 ? /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("span", {
                class: "mission-board__reward mission-board__reward-ports",
                children: [
                    "Reveals ",
                    rewards.revealPorts.length,
                    " ",
                    rewards.revealPorts.length === 1 ? "port" : "ports"
                ]
            }) : null
        ]
    });
}


/**
 * MissionManager - singleton entity that manages the mission/progression system.
 *
 * Tracks available, active, and completed missions. Listens for port mooring
 * events to automatically detect mission completion.
 */ 



class $678b4e73c8f763d8$export$2e44203b34959a7f extends (0, $c59361981bac2575$export$4342ba5c6ad1f6f1) {
    constructor(missions){
        super(), this.id = "missionManager", this.activeMission = null, this.completedMissionIds = new Set(), this.revealedPortIds = new Set(), this.money = 0;
        this.missionDefs = missions;
    }
    /**
   * Get missions available at a given port, filtering by prerequisites.
   */ getAvailableMissions(portId) {
        return this.missionDefs.filter((mission)=>{
            // Must originate from this port
            if (mission.sourcePortId !== portId) return false;
            // Must not already be completed
            if (this.completedMissionIds.has(mission.id)) return false;
            // Must not be the currently active mission
            if (this.activeMission?.def.id === mission.id) return false;
            // All prerequisites must be completed
            if (mission.prerequisites?.completedMissions) for (const prereq of mission.prerequisites.completedMissions){
                if (!this.completedMissionIds.has(prereq)) return false;
            }
            // Must meet money prerequisite
            if (mission.prerequisites?.money !== undefined && this.money < mission.prerequisites.money) return false;
            return true;
        });
    }
    /** Look up a mission definition by ID. */ getMissionDef(missionId) {
        return this.missionDefs.find((m)=>m.id === missionId);
    }
    /**
   * Accept a mission by ID. Sets it as the active mission and dispatches
   * the missionAccepted event.
   */ acceptMission(missionId) {
        if (this.activeMission !== null) {
            console.warn(`[MissionManager] Cannot accept mission "${missionId}" \u{2014} already have active mission "${this.activeMission.def.id}"`);
            return;
        }
        const def = this.missionDefs.find((m)=>m.id === missionId);
        if (!def) {
            console.warn(`[MissionManager] Mission "${missionId}" not found in level data`);
            return;
        }
        if (this.completedMissionIds.has(missionId)) {
            console.warn(`[MissionManager] Mission "${missionId}" is already completed`);
            return;
        }
        this.activeMission = {
            def: def,
            startTime: this.game.elapsedTime
        };
        this.game.dispatch("missionAccepted", {
            missionId: missionId
        });
    }
    /**
   * Complete the currently active mission, granting rewards.
   */ completeMission() {
        if (!this.activeMission) {
            console.warn("[MissionManager] No active mission to complete");
            return;
        }
        const { def: def } = this.activeMission;
        const rewards = def.rewards ?? {};
        // Grant money reward via ProgressionManager
        if (rewards.money) {
            const progression = this.game.entities.tryGetSingleton((0, $a1603b9cc09f9d46$export$caa51bcb55fa9d65));
            if (progression) progression.addMoney(rewards.money);
            this.money += rewards.money;
        }
        // Reveal ports
        if (rewards.revealPorts) for (const portId of rewards.revealPorts)this.revealedPortIds.add(portId);
        // Track completion
        this.completedMissionIds.add(def.id);
        this.activeMission = null;
        this.game.dispatch("missionCompleted", {
            missionId: def.id,
            rewards: {
                money: rewards.money,
                revealPorts: rewards.revealPorts
            }
        });
    }
    /**
   * Listen for boat mooring events to check for delivery mission completion.
   */ onBoatMoored({ portId: portId }) {
        if (!this.activeMission) return;
        if (this.activeMission.def.type !== "delivery") return;
        if (this.activeMission.def.destinationPortId !== portId) return;
        this.completeMission();
    }
    // ---- State accessors for HUD and save/load ----
    getActiveMission() {
        return this.activeMission;
    }
    getCompletedMissionIds() {
        return this.completedMissionIds;
    }
    getRevealedPortIds() {
        return this.revealedPortIds;
    }
    getMoney() {
        return this.money;
    }
    // ---- Save/load state ----
    /**
   * Get serializable state for the save system.
   */ getState() {
        return {
            completedMissionIds: [
                ...this.completedMissionIds
            ],
            currentMissionId: this.activeMission?.def.id,
            money: this.money,
            revealedPortIds: [
                ...this.revealedPortIds
            ]
        };
    }
    /**
   * Restore state from the save system.
   */ setState(state) {
        this.completedMissionIds.clear();
        if (state.completedMissionIds) for (const id of state.completedMissionIds)this.completedMissionIds.add(id);
        this.revealedPortIds.clear();
        if (state.revealedPortIds) for (const id of state.revealedPortIds)this.revealedPortIds.add(id);
        this.money = state.money ?? 0;
        // Restore active mission
        this.activeMission = null;
        if (state.currentMissionId) {
            const def = this.missionDefs.find((m)=>m.id === state.currentMissionId);
            if (def) this.activeMission = {
                def: def,
                startTime: this.game.elapsedTime
            };
        }
    }
}
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $aa1f0309d9dba6d2$export$af631764ddc44097)("boatMoored")
], $678b4e73c8f763d8$export$2e44203b34959a7f.prototype, "onBoatMoored", null);



const $e4d56de93920a762$var$ACTIONS = [
    {
        key: "missionBoard",
        label: "Mission Board"
    },
    {
        key: "shipyard",
        label: "Shipyard"
    },
    {
        key: "castOff",
        label: "Cast Off"
    }
];
class $e4d56de93920a762$export$dfd81546518a5c0c extends (0, $7d9b0c3658290da5$export$690dd8da38397efd) {
    constructor(portId, portName){
        super(()=>/*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("div", {
                class: "port-menu",
                children: [
                    this.submenu === null && this.renderRoot(),
                    this.submenu === "shipyard" && /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)((0, $30ea968e6cf290b8$export$dfb14ca0df8939f6), {
                        game: this.game,
                        activeTab: this.shipyardTab,
                        onSetTab: (tab)=>this.setShipyardTab(tab)
                    }),
                    this.submenu === "missionBoard" && /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)((0, $319436b4db037a61$export$b5b6844e276e1d30), {
                        manager: this.game.entities.getSingleton((0, $678b4e73c8f763d8$export$2e44203b34959a7f)),
                        missions: this.missions,
                        onAcceptMission: (id)=>this.acceptMission(id)
                    })
                ]
            })), this.portId = portId, this.portName = portName, this.submenu = null, this.shipyardTab = "boats", this.missions = [];
    }
    renderRoot() {
        return /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)((0, $13c40c34b78c8ee2$export$ffb0004e005737fa), {
            children: [
                /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("div", {
                    class: "port-menu__title",
                    children: this.portName
                }),
                /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("div", {
                    class: "port-menu__subtitle",
                    children: "Port Services"
                }),
                /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("div", {
                    class: "port-menu__actions",
                    children: $e4d56de93920a762$var$ACTIONS.map(({ key: key, label: label })=>/*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("button", {
                            class: `port-menu__button ${key === "castOff" ? "port-menu__button--cast-off" : ""}`,
                            onClick: ()=>this.execute(key),
                            children: label
                        }))
                })
            ]
        });
    }
    onAdd() {
        super.onAdd();
        if (!this.game.paused) this.game.pause();
    }
    onDestroy(data) {
        if (data.game.paused) data.game.unpause();
        super.onDestroy(data);
    }
    onAfterAdded() {
        this.reactRender();
        (0, $b3d670cfac76cf94$export$4117a64304d253b0)(this.el);
    }
    setSubmenu(next) {
        this.submenu = next;
        this.reactRender();
        this.focusForSubmenu();
    }
    focusForSubmenu() {
        if (this.submenu === "shipyard") {
            const list = this.el.querySelector(".shipyard__list");
            if (list) {
                (0, $b3d670cfac76cf94$export$4117a64304d253b0)(list);
                return;
            }
        }
        (0, $b3d670cfac76cf94$export$4117a64304d253b0)(this.el);
    }
    setShipyardTab(tab) {
        this.shipyardTab = tab;
        this.reactRender();
        const list = this.el.querySelector(".shipyard__list");
        if (list) (0, $b3d670cfac76cf94$export$4117a64304d253b0)(list);
    }
    cycleShipyardTab(direction) {
        const idx = (0, $30ea968e6cf290b8$export$b1df07288187ea67).findIndex((t)=>t.id === this.shipyardTab);
        const next = (idx + direction + (0, $30ea968e6cf290b8$export$b1df07288187ea67).length) % (0, $30ea968e6cf290b8$export$b1df07288187ea67).length;
        this.setShipyardTab((0, $30ea968e6cf290b8$export$b1df07288187ea67)[next].id);
    }
    execute(action) {
        switch(action){
            case "missionBoard":
                this.openMissionBoard();
                break;
            case "shipyard":
                this.openShipyard();
                break;
            case "castOff":
                this.castOff();
                break;
        }
    }
    openShipyard() {
        this.shipyardTab = "boats";
        this.setSubmenu("shipyard");
    }
    openMissionBoard() {
        const manager = this.game.entities.getSingleton((0, $678b4e73c8f763d8$export$2e44203b34959a7f));
        this.missions = manager.getAvailableMissions(this.portId);
        this.setSubmenu("missionBoard");
    }
    acceptMission(missionId) {
        const manager = this.game.entities.getSingleton((0, $678b4e73c8f763d8$export$2e44203b34959a7f));
        if (manager.getActiveMission() !== null) return;
        manager.acceptMission(missionId);
        this.destroy();
    }
    castOff() {
        const boat = this.game.entities.getById("boat");
        if (boat) boat.mooring.castOff();
    }
    onKeyDown({ key: key, event: event }) {
        if (key === "Escape") {
            event.preventDefault();
            if (this.submenu !== null) this.setSubmenu(null);
            else this.castOff();
            return;
        }
        if (this.submenu === "shipyard") {
            if (key === "Tab" || key === "ArrowRight") {
                this.cycleShipyardTab(1);
                return;
            }
            if (key === "ArrowLeft") {
                this.cycleShipyardTab(-1);
                return;
            }
            const list = this.el.querySelector(".shipyard__list");
            if (!list) return;
            if (key === "ArrowUp") (0, $b3d670cfac76cf94$export$e4c43fd18762e8ea)(list, -1);
            else if (key === "ArrowDown") (0, $b3d670cfac76cf94$export$e4c43fd18762e8ea)(list, 1);
            return;
        }
        if (this.submenu === "missionBoard") {
            if (this.missions.length === 0) return;
            if (key === "ArrowUp" || key === "ArrowLeft") (0, $b3d670cfac76cf94$export$e4c43fd18762e8ea)(this.el, -1);
            else if (key === "ArrowDown" || key === "ArrowRight") (0, $b3d670cfac76cf94$export$e4c43fd18762e8ea)(this.el, 1);
            return;
        }
        // Root menu
        if (key === "ArrowUp" || key === "ArrowLeft") (0, $b3d670cfac76cf94$export$e4c43fd18762e8ea)(this.el, -1);
        else if (key === "ArrowDown" || key === "ArrowRight") (0, $b3d670cfac76cf94$export$e4c43fd18762e8ea)(this.el, 1);
    }
}
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $aa1f0309d9dba6d2$export$af631764ddc44097)("afterAdded")
], $e4d56de93920a762$export$dfd81546518a5c0c.prototype, "onAfterAdded", null);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $aa1f0309d9dba6d2$export$af631764ddc44097)("keyDown")
], $e4d56de93920a762$export$dfd81546518a5c0c.prototype, "onKeyDown", null);




const $a1db6edab9cae626$var$DOCK_RANGE = 30; // feet — max distance to dock from bow
class $a1db6edab9cae626$export$338e656c65562d29 extends (0, $c59361981bac2575$export$4342ba5c6ad1f6f1) {
    constructor(boat){
        super(), this.boat = boat, this.tickLayer = "input", this.activeJibSheet = "port";
    }
    onTick({ dt: dt }) {
        const io = this.game.io;
        // Port menu open — no controls
        if (this.game.entities.tryGetSingleton((0, $e4d56de93920a762$export$dfd81546518a5c0c))) {
            io.setSteeringWheelForceFeedback(0);
            return;
        }
        // Boat is sinking — no controls
        if (this.boat.bilge.isSinking()) {
            this.boat.bilge.setBailing(false);
            io.setSteeringWheelForceFeedback(0);
            return;
        }
        const sailor = this.boat.sailor;
        // Not at a bail station — ensure bailing is off
        this.boat.bilge.setBailing(false);
        // Sailor is walking — WASD drives walking, boat controls inert
        if (sailor.state.kind === "walking") {
            this.onTickWalking(sailor);
            return;
        }
        // Sailor is at a station — dispatch controls based on station bindings
        const station = sailor.getCurrentStation();
        this.onTickAtStation(station, dt);
    }
    // ── Walking mode ────────────────────────────────────────────────
    onTickWalking(sailor) {
        const io = this.game.io;
        // Release the rudder — it floats when unattended
        this.boat.rudder.setSteer(0);
        io.setSteeringWheelForceFeedback(0);
        // Idle the anchor (no input)
        this.boat.anchor.idle();
        // WASD → walk velocity, interpreted in camera space (W = up on screen).
        // Screen direction is rotated into hull-local coords via the camera and
        // hull angles. The deck friction equations' Jacobian sign convention
        // makes a positive `relativeVelocity` push the sailor along the
        // -tangent direction, so we negate at the end.
        const running = io.isKeyDown("ShiftLeft") || io.isKeyDown("ShiftRight");
        const speed = running ? (0, $ec21187209955c1c$export$fcd1687772d55577) : (0, $ec21187209955c1c$export$8626ab6fd80544d1);
        let sx = 0;
        let sy = 0;
        if (io.isKeyDown("KeyW")) sy -= 1;
        if (io.isKeyDown("KeyS")) sy += 1;
        if (io.isKeyDown("KeyA")) sx -= 1;
        if (io.isKeyDown("KeyD")) sx += 1;
        const hullAngle = this.boat.hull.getAngle();
        const cameraAngle = this.game.camera.angle;
        const local = (0, $6b6a54a072724620$export$e7c866399fa523f5)(sx, sy).irotate(-cameraAngle - hullAngle);
        sailor.setWalkVelocity(-local.x * speed, -local.y * speed, speed);
    }
    // ── Station mode ────────────────────────────────────────────────
    onTickAtStation(station, dt) {
        const io = this.game.io;
        const shiftHeld = io.isKeyDown("ShiftLeft") || io.isKeyDown("ShiftRight");
        // --- Steer axis (A/D) ---
        if (station.steerAxis) {
            const steer = io.getRudderSteerInput();
            switch(station.steerAxis){
                case "rudder":
                    this.boat.rudder.setSteer(steer, shiftHeld);
                    io.setSteeringWheelForceFeedback(this.computeWheelFeedback(steer));
                    break;
            }
        } else {
            // No steer binding — rudder floats
            this.boat.rudder.setSteer(0);
            io.setSteeringWheelForceFeedback(0);
        }
        // --- Primary axis (W/S) ---
        if (station.primaryAxis) {
            // getSheetInput: W → -1, S → +1
            const raw = io.getSheetInput();
            switch(station.primaryAxis){
                case "mainsheet":
                    this.boat.mainsheet.adjust(-raw * (shiftHeld ? 1.0 : 0.3));
                    break;
                case "mainHoist":
                    {
                        const hoist = -raw > 0 ? 1 : -raw < 0 ? -1 : 0;
                        this.boat.rig.sail.setHoistInput(hoist);
                        break;
                    }
                case "jibHoistFurl":
                    {
                        const hoist = -raw > 0 ? 1 : -raw < 0 ? -1 : 0;
                        this.boat.jib?.setHoistInput(hoist);
                        break;
                    }
                case "jibSheets":
                    this.updateJibSheets(raw, shiftHeld);
                    break;
            }
        }
        // --- Secondary axis (Q/E) ---
        if (station.secondaryAxis) switch(station.secondaryAxis){
            case "jibSheets":
                {
                    // Q/E jib sheet logic uses its own key reading
                    const qHeld = io.isKeyDown("KeyQ");
                    const eHeld = io.isKeyDown("KeyE");
                    this.updateJibSheetsQE(qHeld, eHeld, shiftHeld);
                    break;
                }
        }
        // --- Station actions ---
        if (station.actions?.includes("anchor")) {
            if (io.isKeyDown("KeyG") && !this.boat.mooring.isMoored()) this.boat.anchor.lower();
            else if (io.isKeyDown("KeyR")) this.boat.anchor.raise();
            else this.boat.anchor.idle();
        } else this.boat.anchor.idle();
        // Bailing — only at stations with the bail action
        if (station.actions?.includes("bail")) {
            const bailing = io.isKeyDown("KeyB") && this.boat.bilge.getWaterFraction() > 0;
            this.boat.bilge.setBailing(bailing);
        }
        // Rowing — always available at any station
        if (io.isKeyDown("Space")) this.boat.row();
        // Debug controls
        if (io.isKeyDown("KeyJ")) this.boat.hull.body.applyForce3D(0, 0, 80000, 0, 3, 0);
        if (io.isKeyDown("KeyL")) this.boat.hull.body.applyForce3D(0, 0, -80000, 0, 3, 0);
        if (io.isKeyDown("KeyI")) this.boat.hull.body.applyForce3D(0, 0, -80000, 3, 0, 0);
        if (io.isKeyDown("KeyK")) this.boat.hull.body.applyForce3D(0, 0, 80000, 3, 0, 0);
        if (io.isKeyDown("Quote")) {
            const rate = shiftHeld ? 0.25 : 0.05;
            this.boat.bilge.waterVolume += this.boat.bilge.getMaxWaterVolume() * rate * dt;
        }
    }
    // ── Jib sheet helpers ───────────────────────────────────────────
    /**
   * Jib sheet trimming via Q/E keys (when secondaryAxis = "jibSheets").
   * Single active sheet model with auto-tacking.
   */ updateJibSheetsQE(qHeld, eHeld, shiftHeld) {
        if (!this.boat.jib || !this.boat.portJibSheet || !this.boat.starboardJibSheet) return;
        const activeSheet = this.activeJibSheet === "port" ? this.boat.portJibSheet : this.boat.starboardJibSheet;
        // Calculate trim input based on active sheet
        let trimInput = 0;
        if (this.activeJibSheet === "port") {
            if (eHeld) trimInput = -1; // E = trim in (port)
            else if (qHeld) trimInput = 1; // Q = ease out
        } else {
            if (qHeld) trimInput = -1; // Q = trim in (starboard)
            else if (eHeld) trimInput = 1; // E = ease out
        }
        // Handle tacking (switching sheets)
        if (shiftHeld) {
            if (qHeld) {
                this.activeJibSheet = "starboard";
                this.boat.portJibSheet.release();
            } else if (eHeld) {
                this.activeJibSheet = "port";
                this.boat.starboardJibSheet.release();
            }
        } else if (trimInput > 0 && activeSheet.isAtMaxLength()) {
            const newSheet = this.activeJibSheet === "port" ? "starboard" : "port";
            this.activeJibSheet = newSheet;
            if (newSheet === "port") this.boat.starboardJibSheet.release();
            else this.boat.portJibSheet.release();
        }
        const jibInput = trimInput * (shiftHeld ? 1.0 : 0.3);
        activeSheet.adjust(jibInput);
    }
    /**
   * Jib sheet trimming via W/S primary axis (when primaryAxis = "jibSheets").
   * Uses sheet input directly for trim.
   */ updateJibSheets(rawSheetInput, shiftHeld) {
        if (!this.boat.jib || !this.boat.portJibSheet || !this.boat.starboardJibSheet) return;
        const activeSheet = this.activeJibSheet === "port" ? this.boat.portJibSheet : this.boat.starboardJibSheet;
        const trimInput = rawSheetInput;
        // Auto-switch when easing a fully slack sheet
        if (trimInput > 0 && activeSheet.isAtMaxLength()) {
            const newSheet = this.activeJibSheet === "port" ? "starboard" : "port";
            this.activeJibSheet = newSheet;
            if (newSheet === "port") this.boat.starboardJibSheet.release();
            else this.boat.portJibSheet.release();
        }
        const jibInput = -trimInput * (shiftHeld ? 1.0 : 0.3);
        activeSheet.adjust(jibInput);
    }
    // ── Steering wheel force feedback ───────────────────────────────
    computeWheelFeedback(driverSteerInput) {
        const rudderSteer = this.boat.rudder.getSteer();
        const rudderAngularVelocity = this.boat.rudder.getRelativeAngularVelocity();
        const speed = this.boat.getVelocity().magnitude;
        const speedFactor = Math.min(speed / 16, 1);
        const centering = driverSteerInput * 0.25;
        const waterLoad = rudderSteer * speedFactor * 0.65;
        const damping = rudderAngularVelocity * 0.06;
        return (0, $2172aedd5a25ff17$export$7d15b64cf5a3a4c4)(-(centering + waterLoad + damping), -1, 1);
    }
    // ── Port detection ──────────────────────────────────────────────
    /** Find the nearest port within docking range, or null. */ findNearbyPort() {
        const bowLocal = (0, $d106d09a724e422d$export$1da007e63d4d3b8e)(this.boat.config.hull.vertices);
        const bowWorld = bowLocal.rotate(this.boat.hull.body.angle).iadd(this.boat.hull.body.position);
        let closest = null;
        let closestDist = $a1db6edab9cae626$var$DOCK_RANGE;
        for (const entity of this.game.entities.getTagged("port")){
            const port = entity;
            const dist = (0, $6b6a54a072724620$export$e7c866399fa523f5)(port.getPosition()).sub(bowWorld).magnitude;
            if (dist < closestDist) {
                closestDist = dist;
                closest = port;
            }
        }
        return closest;
    }
    // ── Key events ──────────────────────────────────────────────────
    onKeyDown({ key: key }) {
        if (key === "Comma") this.game.io.requestSteeringWheelConnection().then((result)=>{
            if (result.connected) console.info(`[Wheel] ${result.message}`);
            else console.warn(`[Wheel] ${result.message}`);
        });
        // No actions while port menu is open
        if (this.game.entities.tryGetSingleton((0, $e4d56de93920a762$export$dfd81546518a5c0c))) return;
        const sailor = this.boat.sailor;
        if (sailor.state.kind === "atStation") {
            const station = sailor.getCurrentStation();
            // F at any station → leave and start walking
            if (key === "KeyF") {
                sailor.beginWalking();
                return;
            }
            // M at a station with mooring action → dock toggle
            if (key === "KeyM" && station.actions?.includes("mooring")) {
                if (this.boat.mooring.isMoored()) this.boat.mooring.castOff();
                else {
                    const nearbyPort = this.findNearbyPort();
                    if (nearbyPort) this.boat.mooring.moorTo(nearbyPort);
                }
                return;
            }
        } else // Walking — F snaps to a nearby station (auto-snap also runs each tick).
        if (key === "KeyF") {
            sailor.snapToNearbyStation();
            return;
        }
    }
    onDestroy({ game: game }) {
        game.io.setSteeringWheelForceFeedback(0);
    }
}
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $aa1f0309d9dba6d2$export$af631764ddc44097)("tick")
], $a1db6edab9cae626$export$338e656c65562d29.prototype, "onTick", null);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $aa1f0309d9dba6d2$export$af631764ddc44097)("keyDown")
], $a1db6edab9cae626$export$338e656c65562d29.prototype, "onKeyDown", null);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $aa1f0309d9dba6d2$export$af631764ddc44097)("destroy")
], $a1db6edab9cae626$export$338e656c65562d29.prototype, "onDestroy", null);




/** Human-readable labels for axis controls. */ const $1e968766b871c95d$var$AXIS_LABELS = {
    rudder: "Rudder",
    mainsheet: "Mainsheet",
    mainHoist: "Main Hoist",
    jibSheets: "Jib Sheets",
    jibHoistFurl: "Jib Hoist"
};
/** Key labels for each input axis. */ const $1e968766b871c95d$var$AXIS_KEYS = {
    steer: "A/D",
    primary: "W/S",
    secondary: "Q/E"
};
class $1e968766b871c95d$export$dad5dd4a2e9f9608 extends (0, $7d9b0c3658290da5$export$690dd8da38397efd) {
    constructor(){
        super(()=>this.renderContent());
    }
    renderContent() {
        const boat = this.game?.entities.getById("boat");
        const sailor = boat?.sailor;
        if (!sailor) return null;
        return /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("div", {
            style: {
                position: "fixed",
                bottom: "20px",
                left: "20px",
                color: "white",
                textShadow: "0 0 4px rgba(0, 0, 0, 0.8)",
                fontFamily: "var(--font-body)",
                fontWeight: "300",
                fontSize: "14px",
                userSelect: "none",
                pointerEvents: "none",
                lineHeight: "1.5"
            },
            children: sailor.state.kind === "walking" ? this.renderWalking() : this.renderStation(sailor)
        });
    }
    renderWalking() {
        const boat = this.game?.entities.getById("boat");
        const sailor = boat?.sailor;
        const nearStation = sailor?.findNearbyStation() ?? null;
        const bindings = [
            {
                keys: "WASD",
                label: "Walk"
            },
            {
                keys: "Shift",
                label: "Run"
            }
        ];
        if (nearStation) bindings.push({
            keys: "F",
            label: `Enter ${nearStation.name}`
        });
        return /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("div", {
            children: [
                /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("div", {
                    style: {
                        fontSize: "16px",
                        fontWeight: "600",
                        marginBottom: "4px",
                        color: "#ff8800"
                    },
                    children: "Walking"
                }),
                this.renderBindingList(bindings)
            ]
        });
    }
    renderStation(sailor) {
        const station = sailor.getCurrentStation();
        if (!station) return null;
        return /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("div", {
            children: [
                /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("div", {
                    style: {
                        fontSize: "16px",
                        fontWeight: "600",
                        marginBottom: "4px",
                        color: "#ff8800"
                    },
                    children: station.name
                }),
                this.renderBindings(station)
            ]
        });
    }
    renderBindings(station) {
        const bindings = [];
        if (station.steerAxis) bindings.push({
            keys: $1e968766b871c95d$var$AXIS_KEYS.steer,
            label: $1e968766b871c95d$var$AXIS_LABELS[station.steerAxis]
        });
        if (station.primaryAxis) bindings.push({
            keys: $1e968766b871c95d$var$AXIS_KEYS.primary,
            label: $1e968766b871c95d$var$AXIS_LABELS[station.primaryAxis]
        });
        if (station.secondaryAxis) bindings.push({
            keys: $1e968766b871c95d$var$AXIS_KEYS.secondary,
            label: $1e968766b871c95d$var$AXIS_LABELS[station.secondaryAxis]
        });
        if (station.actions?.includes("anchor")) {
            bindings.push({
                keys: "R",
                label: "Raise Anchor"
            });
            bindings.push({
                keys: "G",
                label: "Lower Anchor"
            });
        }
        if (station.actions?.includes("mooring")) bindings.push({
            keys: "M",
            label: "Dock"
        });
        if (station.actions?.includes("bail")) bindings.push({
            keys: "B",
            label: "Bail"
        });
        bindings.push({
            keys: "F",
            label: "Leave Station"
        });
        return this.renderBindingList(bindings);
    }
    renderBindingList(bindings) {
        if (bindings.length === 0) return null;
        return /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("div", {
            style: {
                opacity: 0.7
            },
            children: bindings.map((b)=>/*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("div", {
                    children: [
                        /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("span", {
                            style: {
                                display: "inline-block",
                                minWidth: "52px",
                                fontWeight: "600",
                                opacity: 0.9
                            },
                            children: b.keys
                        }),
                        " ",
                        b.label
                    ]
                }, b.keys))
        });
    }
}








//#tunable { min: 0.1, max: 5 }
let $04c54d944dd254c7$var$ZOOM_SPEED = 1.5;
//#tunable { min: 100, max: 5000 }
let $04c54d944dd254c7$var$PAN_SPEED = 1000;
//#tunable { min: 0.5, max: 20 }
let $04c54d944dd254c7$var$STIFFNESS = 4.0;
// #tunable { min: 0.0, max: 1.0 }
let $04c54d944dd254c7$var$ROTATION_SPEED = 0.1;
class $04c54d944dd254c7$export$d53514a691eb5346 extends (0, $c59361981bac2575$export$4342ba5c6ad1f6f1) {
    constructor(boat, camera, rotateWithBoat = true){
        super(), this.boat = boat, this.camera = camera, this.tickLayer = "camera", this.zTarget = 8, this.offset = (0, $6b6a54a072724620$export$e7c866399fa523f5)(0, 0), this.rotateWithBoat = true, this.pausable = true;
        this.rotateWithBoat = rotateWithBoat;
        this.camera.center(boat.getPosition());
        if (this.rotateWithBoat) this.camera.angle = -Math.PI / 2 - this.boat.hull.getAngle();
    }
    setZoomTarget(z) {
        this.zTarget = z;
    }
    onKeyDown({ key: key }) {
        if (key === "KeyC") this.rotateWithBoat = !this.rotateWithBoat;
    }
    onTick({ dt: dt }) {
        const boatPosition = this.boat.getPosition().add(this.offset.rotate(-this.camera.angle));
        const boatVelocity = this.boat.getVelocity();
        this.camera.smoothCenter(boatPosition, boatVelocity, $04c54d944dd254c7$var$STIFFNESS);
        this.camera.smoothZoom(this.zTarget);
        // Smoothly rotate camera to match boat heading (or back to 0)
        // -π/2 - boatAngle makes the boat's forward direction point UP on screen
        const targetAngle = this.rotateWithBoat ? -Math.PI / 2 - this.boat.hull.getAngle() : 0;
        // Use shortest-path rotation via angle normalization
        const angleDiff = (0, $2172aedd5a25ff17$export$e3df76cf4464bc81)(targetAngle - this.camera.angle);
        this.camera.angle = (0, $2172aedd5a25ff17$export$e4d952dcf42a5ff5)(this.camera.angle, this.camera.angle + angleDiff, $04c54d944dd254c7$var$ROTATION_SPEED, 0.001);
        if (this.game.io.isKeyDown("Minus")) this.zTarget -= this.zTarget * dt * $04c54d944dd254c7$var$ZOOM_SPEED;
        if (this.game.io.isKeyDown("Equal")) this.zTarget += this.zTarget * dt * $04c54d944dd254c7$var$ZOOM_SPEED;
        const panAmount = $04c54d944dd254c7$var$PAN_SPEED * dt / this.camera.z;
        if (this.game.io.isKeyDown("ArrowDown")) this.offset.y += panAmount;
        if (this.game.io.isKeyDown("ArrowUp")) this.offset.y -= panAmount;
        if (this.game.io.isKeyDown("ArrowLeft")) this.offset.x -= panAmount;
        if (this.game.io.isKeyDown("ArrowRight")) this.offset.x += panAmount;
    }
}
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $aa1f0309d9dba6d2$export$af631764ddc44097)("keyDown")
], $04c54d944dd254c7$export$d53514a691eb5346.prototype, "onKeyDown", null);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $aa1f0309d9dba6d2$export$af631764ddc44097)("tick")
], $04c54d944dd254c7$export$d53514a691eb5346.prototype, "onTick", null);


/**
 * Unified Debug Renderer entity.
 *
 * Consolidates separate debug visualizations into a single entity with
 * consistent keyboard controls:
 * - Tab: Cycle forward through modes (including "Off")
 * - Shift+Tab: Cycle backward through modes
 * - [/]: Sub-mode cycling (delegated to active mode)
 */ 




/**
 * Terrain Gradient Debug Mode
 *
 * Visualizes the analytical terrain gradient computed by
 * computeTerrainHeightAndGradient at every screen pixel.
 * A compute shader evaluates the contour tree per pixel,
 * then a fullscreen fragment shader maps gradient direction
 * to hue and magnitude to brightness.
 */ 


/**
 * Compute shader built from composable modules.
 *
 * Create a compute shader by providing:
 * - `modules`: array of shader modules (last one typically contains entry point)
 * - `workgroupSize`: workgroup dimensions for dispatch
 *
 * The shader automatically:
 * - Resolves module dependencies
 * - Merges bindings from all modules
 * - Builds code in correct order: preambles → bindings → code
 */ 
/**
 * Base class for shaders with module composition support.
 *
 * Shaders are built from composable modules. Each module can provide:
 * - preamble: struct definitions (before bindings)
 * - bindings: GPU resource bindings
 * - code: functions, constants, entry points (after bindings)
 *
 * The shader automatically:
 * - Resolves module dependencies in correct order
 * - Deduplicates shared dependencies
 * - Merges bindings from all modules
 * - Builds code in correct order: preambles → bindings → code
 */ /**
 * Type definitions for shader bindings.
 *
 * These types provide a declarative way to define shader bindings that can be
 * used to automatically generate bind group layouts and type-safe bind group creation.
 */ /**
 * Binding type for uniform buffers.
 */ function $d2f5615874242f0f$export$b26f06e8044ad5f2(binding, definition, visibility) {
    const entry = {
        binding: binding,
        visibility: visibility
    };
    switch(definition.type){
        case "uniform":
            entry.buffer = {
                type: "uniform"
            };
            break;
        case "storage":
            entry.buffer = {
                type: "read-only-storage"
            };
            break;
        case "storageRW":
            entry.buffer = {
                type: "storage"
            };
            break;
        case "storageTexture":
            entry.storageTexture = {
                access: "write-only",
                format: definition.format,
                viewDimension: "2d"
            };
            break;
        case "texture":
            entry.texture = {
                sampleType: definition.sampleType ?? "float",
                viewDimension: definition.viewDimension ?? "2d"
            };
            break;
        case "sampler":
            entry.sampler = {
                type: definition.samplerType ?? "filtering"
            };
            break;
    }
    return entry;
}
function $d2f5615874242f0f$export$dc4e0cd81249daaa(bindings, visibility) {
    const keys = Object.keys(bindings);
    return keys.map((key, index)=>$d2f5615874242f0f$export$b26f06e8044ad5f2(index, bindings[key], visibility));
}
function $d2f5615874242f0f$export$1836a18167ffc599(bindings, resources) {
    const keys = Object.keys(bindings);
    return keys.map((key, index)=>{
        const definition = bindings[key];
        const resource = resources[key];
        if (definition.type === "uniform" || definition.type === "storage" || definition.type === "storageRW") return {
            binding: index,
            resource: resource
        };
        else return {
            binding: index,
            resource: resource
        };
    });
}
function $d2f5615874242f0f$export$28718608db82d296(bindings, group = 0) {
    const keys = Object.keys(bindings);
    const lines = keys.map((name, index)=>{
        const definition = bindings[name];
        let declaration;
        switch(definition.type){
            case "uniform":
                declaration = `var<uniform> ${name}: ${definition.wgslType}`;
                break;
            case "storage":
                declaration = `var<storage, read> ${name}: ${definition.wgslType}`;
                break;
            case "storageRW":
                declaration = `var<storage, read_write> ${name}: ${definition.wgslType}`;
                break;
            case "storageTexture":
                {
                    const format = definition.format;
                    declaration = `var ${name}: texture_storage_2d<${format}, write>`;
                    break;
                }
            case "texture":
                {
                    const viewDimension = definition.viewDimension ?? "2d";
                    const sampleType = definition.sampleType ?? "float";
                    if (sampleType === "depth") {
                        // Depth textures use special WGSL types (texture_depth_2d, etc.)
                        const depthType = viewDimension === "2d-array" ? "texture_depth_2d_array" : viewDimension === "cube" ? "texture_depth_cube" : "texture_depth_2d";
                        declaration = `var ${name}: ${depthType}`;
                    } else {
                        const textureType = $d2f5615874242f0f$var$viewDimensionToTextureType[viewDimension];
                        const wgslSampleType = $d2f5615874242f0f$var$sampleTypeToWgslType[sampleType];
                        const wgslType = `${textureType}<${wgslSampleType}>`;
                        declaration = `var ${name}: ${wgslType}`;
                    }
                    break;
                }
            case "sampler":
                declaration = `var ${name}: sampler`;
                break;
        }
        return `@group(${group}) @binding(${index}) ${declaration};`;
    });
    return lines.join("\n");
}
const $d2f5615874242f0f$var$viewDimensionToTextureType = {
    "1d": "texture_1d",
    "2d": "texture_2d",
    "2d-array": "texture_2d_array",
    cube: "texture_cube",
    "cube-array": "texture_cube_array",
    "3d": "texture_3d"
};
const $d2f5615874242f0f$var$sampleTypeToWgslType = {
    float: "f32",
    "unfilterable-float": "f32",
    sint: "i32",
    uint: "u32",
    depth: "f32"
};



function $aaca451bdcf23d29$export$e97d257db3b251a7(modules) {
    const seen = new Set();
    const ordered = [];
    function collect(module) {
        if (!seen.has(module)) {
            seen.add(module);
            module.dependencies?.forEach(collect);
            ordered.push(module);
        }
    }
    modules.forEach(collect);
    return ordered;
}
const $aaca451bdcf23d29$export$74dca2e9c6bae7b7 = /*wgsl*/ `
// Fundamental constants (included automatically)
const PI: f32 = 3.14159265359;
const TWO_PI: f32 = 6.28318530718;
const HALF_PI: f32 = 1.57079632679;
const GRAVITY: f32 = 32.174; // ft/s^2
`;
class $aaca451bdcf23d29$export$462bb059fed9d9e5 {
    /**
   * Collect all modules and their dependencies in correct order.
   * Uses depth-first traversal to ensure dependencies come before dependents.
   * Deduplicates shared dependencies.
   */ collectModules() {
        return $aaca451bdcf23d29$export$e97d257db3b251a7(this.modules ?? []);
    }
    /**
   * Get the standard math and physics constants that should be included once per shader.
   * @returns WGSL code for fundamental constants
   */ getMathConstants() {
        return $aaca451bdcf23d29$export$74dca2e9c6bae7b7;
    }
    /**
   * Build complete WGSL code from modules.
   * Order: preambles → auto-generated bindings → code
   *
   * @returns Complete WGSL shader code (without math constants - those are added by the shader class)
   */ buildCode() {
        const modules = this.collectModules();
        // 1. Collect preambles (structs needed by bindings)
        const preambles = modules.filter((m)=>m.preamble).map((m)=>m.preamble).join("\n\n");
        // 2. Auto-generate binding declarations
        const bindingsWgsl = this.buildBindingsWgsl();
        // 3. Collect module code (functions, constants, entry points)
        const code = modules.map((m)=>m.code).join("\n\n");
        return [
            preambles,
            bindingsWgsl,
            code
        ].filter(Boolean).join("\n\n");
    }
    /**
   * Build merged bindings from all modules.
   * Later modules override earlier ones if binding names conflict.
   *
   * @returns Merged bindings definition
   */ buildBindings() {
        const modules = this.collectModules();
        const merged = {};
        for (const module of modules)if (module.bindings) Object.assign(merged, module.bindings);
        return merged;
    }
    /**
   * Helper to merge module bindings with additional shader-specific bindings.
   * Use this with the BindingsFromModules type helper.
   *
   * @param modules - Array of shader modules
   * @param additional - Additional shader-specific bindings
   * @returns Merged bindings definition
   *
   * @example
   * static readonly MODULES = [queryPointsModule, waterModule] as const;
   * static readonly BINDINGS = Shader.mergeBindings(MyShader.MODULES, {
   *   results: { type: "storageRW", wgslType: "array<f32>" }
   * });
   */ static mergeBindings(modules, additional) {
        const merged = {};
        for (const module of modules)if (module.bindings) Object.assign(merged, module.bindings);
        Object.assign(merged, additional);
        return merged;
    }
    /**
   * Get the bind group layout for creating bind groups.
   */ getBindGroupLayout() {
        if (!this.bindGroupLayout) throw new Error(`${this.label} not initialized`);
        return this.bindGroupLayout;
    }
    /**
   * Create a bind group with type-safe named parameters.
   */ createBindGroup(resources) {
        const device = (0, $558c2f47f1fdd57f$export$297162150ea0f6af)().device;
        return device.createBindGroup({
            layout: this.getBindGroupLayout(),
            entries: (0, $d2f5615874242f0f$export$1836a18167ffc599)(this.bindings, resources),
            label: `${this.label} Bind Group`
        });
    }
    /**
   * Generate WGSL binding declarations from the TypeScript bindings definition.
   *
   * This ensures the WGSL and TypeScript are always in sync.
   *
   * @param group - Group number (default: 0)
   * @returns WGSL code declaring the bindings
   *
   * @example
   * const wgsl = this.buildBindingsWgsl();
   */ buildBindingsWgsl(group = 0) {
        return (0, $d2f5615874242f0f$export$28718608db82d296)(this.bindings, group);
    }
    constructor(){
        /** Bind group layout (created during init) */ this.bindGroupLayout = null;
    }
}



function $4016c3d8f65071ed$export$c7db606d6ed8f14(config) {
    const modules = (0, $aaca451bdcf23d29$export$e97d257db3b251a7)(config.modules);
    // Collect preambles
    const preambles = modules.filter((m)=>m.preamble).map((m)=>m.preamble).join("\n\n");
    // Merge bindings from all modules
    const merged = {};
    for (const module of modules)if (module.bindings) Object.assign(merged, module.bindings);
    const bindingsWgsl = (0, $d2f5615874242f0f$export$28718608db82d296)(merged, 0);
    // Collect code
    const code = modules.map((m)=>m.code).join("\n\n");
    return [
        (0, $aaca451bdcf23d29$export$74dca2e9c6bae7b7),
        preambles,
        bindingsWgsl,
        code
    ].filter(Boolean).join("\n\n");
}
class $4016c3d8f65071ed$export$cdde5429dd049099 extends (0, $aaca451bdcf23d29$export$462bb059fed9d9e5) {
    constructor(config){
        super(), this.pipeline = null;
        this.modules = config.modules;
        this.workgroupSize = config.workgroupSize;
        this._label = config.label ?? "ComputeShader";
    }
    get label() {
        return this._label;
    }
    /**
   * Bindings merged from all modules.
   */ get bindings() {
        return this.buildBindings();
    }
    /**
   * Initialize the compute pipeline.
   * Must be called before dispatch.
   */ async init() {
        const gpu = (0, $558c2f47f1fdd57f$export$297162150ea0f6af)();
        const device = gpu.device;
        // Build complete shader with math constants at the top
        const completeShaderCode = this.getMathConstants() + "\n\n" + this.buildCode();
        const shaderModule = await gpu.createShaderModuleChecked(completeShaderCode, `${this.label} Shader Module`);
        // Create bind group layout from merged bindings
        this.bindGroupLayout = device.createBindGroupLayout({
            entries: (0, $d2f5615874242f0f$export$dc4e0cd81249daaa)(this.bindings, GPUShaderStage.COMPUTE),
            label: `${this.label} Bind Group Layout`
        });
        const pipelineLayout = device.createPipelineLayout({
            bindGroupLayouts: [
                this.bindGroupLayout
            ],
            label: `${this.label} Pipeline Layout`
        });
        this.pipeline = device.createComputePipeline({
            layout: pipelineLayout,
            compute: {
                module: shaderModule,
                entryPoint: "main"
            },
            label: `${this.label} Compute Pipeline`
        });
    }
    /**
   * Get the compute pipeline.
   */ getPipeline() {
        if (!this.pipeline) throw new Error(`${this.label} not initialized`);
        return this.pipeline;
    }
    /**
   * Dispatch the compute shader.
   *
   * @param computePass - The compute pass to dispatch on
   * @param bindGroup - Bind group with resources
   * @param textureWidth - Width of the output texture
   * @param textureHeight - Height of the output texture (defaults to width for square textures)
   */ dispatch(computePass, bindGroup, textureWidth, textureHeight) {
        if (!this.pipeline) {
            console.warn(`${this.label} not initialized`);
            return;
        }
        computePass.setPipeline(this.pipeline);
        computePass.setBindGroup(0, bindGroup);
        const height = textureHeight ?? textureWidth;
        const workgroupsX = Math.ceil(textureWidth / this.workgroupSize[0]);
        const workgroupsY = Math.ceil(height / this.workgroupSize[1]);
        computePass.dispatchWorkgroups(workgroupsX, workgroupsY);
    }
    /**
   * Clean up resources.
   */ destroy() {
        this.pipeline = null;
        this.bindGroupLayout = null;
    }
}


/**
 * Fullscreen render shader built from composable modules.
 *
 * Create a fullscreen shader by providing:
 * - `modules`: array of shader modules (last one typically contains vs_main and fs_main)
 * - Optional: `blendState`, `targetFormat`, `label`
 *
 * The shader automatically:
 * - Resolves module dependencies
 * - Merges bindings from all modules
 * - Builds code in correct order: preambles → bindings → code
 */ 

/**
 * Static fullscreen quad for WebGPU fullscreen effects.
 * Provides a simple vertex buffer covering clip space from (-1,-1) to (1,1).
 */ 
class $62c887db2be5e7ca$export$d929c5e245d43fa4 {
    static{
        // Vertex data: position (x, y) only
        // Two triangles covering clip space
        this.VERTICES = new Float32Array([
            -1,
            -1,
            1.0,
            -1,
            1.0,
            1.0,
            -1,
            1.0
        ]);
    }
    static{
        this.INDICES = new Uint16Array([
            0,
            1,
            2,
            0,
            2,
            3
        ]);
    }
    constructor(){
        const device = (0, $558c2f47f1fdd57f$export$297162150ea0f6af)().device;
        // Create vertex buffer
        this.vertexBuffer = device.createBuffer({
            size: $62c887db2be5e7ca$export$d929c5e245d43fa4.VERTICES.byteLength,
            usage: GPUBufferUsage.VERTEX | GPUBufferUsage.COPY_DST,
            label: "Fullscreen Quad Vertex Buffer",
            mappedAtCreation: true
        });
        new Float32Array(this.vertexBuffer.getMappedRange()).set($62c887db2be5e7ca$export$d929c5e245d43fa4.VERTICES);
        this.vertexBuffer.unmap();
        // Create index buffer
        this.indexBuffer = device.createBuffer({
            size: $62c887db2be5e7ca$export$d929c5e245d43fa4.INDICES.byteLength,
            usage: GPUBufferUsage.INDEX | GPUBufferUsage.COPY_DST,
            label: "Fullscreen Quad Index Buffer",
            mappedAtCreation: true
        });
        new Uint16Array(this.indexBuffer.getMappedRange()).set($62c887db2be5e7ca$export$d929c5e245d43fa4.INDICES);
        this.indexBuffer.unmap();
    }
    /** Get the vertex buffer layout for pipeline creation */ static getVertexBufferLayout() {
        return {
            arrayStride: 8,
            attributes: [
                {
                    shaderLocation: 0,
                    offset: 0,
                    format: "float32x2"
                }
            ]
        };
    }
    /** Bind the vertex and index buffers to a render pass */ bind(renderPass) {
        renderPass.setVertexBuffer(0, this.vertexBuffer);
        renderPass.setIndexBuffer(this.indexBuffer, "uint16");
    }
    /** Draw the fullscreen quad (call after bind) */ draw(renderPass) {
        renderPass.drawIndexed(6);
    }
    /** Convenience method to bind and draw */ render(renderPass) {
        this.bind(renderPass);
        this.draw(renderPass);
    }
    destroy() {
        this.vertexBuffer.destroy();
        this.indexBuffer.destroy();
    }
}




class $c43b1a1e19bbbf4b$export$b176bfba5cd328c9 extends (0, $aaca451bdcf23d29$export$462bb059fed9d9e5) {
    constructor(config){
        super(), this.pipeline = null, this.quad = null, // Cached inputs for sync MSAA rebuild.
        this.shaderModule = null, this.pipelineLayout = null, this.unsubscribeMSAA = null;
        this.modules = config.modules;
        this._label = config.label ?? "FullscreenShader";
        this.blendState = config.blendState;
        this.targetFormat = config.targetFormat;
        // Default: depth-compatible no-op (always pass, no write) since the main render
        // pass has a depth attachment. Override with explicit depthStencilState for
        // depth-writing shaders, or set to undefined for offscreen-only shaders.
        this.depthStencilState = config.depthStencilState ?? {
            format: "depth24plus",
            depthCompare: "always",
            depthWriteEnabled: false
        };
        this.disableMSAA = config.disableMSAA ?? false;
    }
    get label() {
        return this._label;
    }
    /**
   * Bindings merged from all modules.
   */ get bindings() {
        return this.buildBindings();
    }
    /**
   * Get the render target format.
   */ getTargetFormat() {
        return this.targetFormat ?? (0, $558c2f47f1fdd57f$export$297162150ea0f6af)().preferredFormat;
    }
    /**
   * Initialize the render pipeline.
   * Must be called before render.
   */ async init() {
        const gpu = (0, $558c2f47f1fdd57f$export$297162150ea0f6af)();
        const device = gpu.device;
        // Build complete shader with math constants at the top
        const completeShaderCode = this.getMathConstants() + "\n\n" + this.buildCode();
        this.shaderModule = await gpu.createShaderModuleChecked(completeShaderCode, `${this.label} Shader Module`);
        // Create bind group layout from merged bindings
        // Use both VERTEX and FRAGMENT visibility for flexibility
        this.bindGroupLayout = device.createBindGroupLayout({
            entries: (0, $d2f5615874242f0f$export$dc4e0cd81249daaa)(this.bindings, GPUShaderStage.VERTEX | GPUShaderStage.FRAGMENT),
            label: `${this.label} Bind Group Layout`
        });
        this.pipelineLayout = device.createPipelineLayout({
            bindGroupLayouts: [
                this.bindGroupLayout
            ],
            label: `${this.label} Pipeline Layout`
        });
        this.rebuildPipeline();
        this.quad = new (0, $62c887db2be5e7ca$export$d929c5e245d43fa4)();
        if (!this.disableMSAA) this.unsubscribeMSAA = (0, $3d4164726c38f33c$export$19f5a511f7104745)(()=>this.rebuildPipeline());
    }
    /**
   * Recreate the render pipeline using cached shader/layout inputs and the
   * current MSAA sample count. Cheap; called on MSAA toggle.
   */ rebuildPipeline() {
        const gpu = (0, $558c2f47f1fdd57f$export$297162150ea0f6af)();
        const device = gpu.device;
        if (!this.shaderModule || !this.pipelineLayout) return;
        const multisample = this.disableMSAA ? undefined : {
            count: (0, $3d4164726c38f33c$export$688369c54d530641)()
        };
        this.pipeline = device.createRenderPipeline({
            layout: this.pipelineLayout,
            vertex: {
                module: this.shaderModule,
                entryPoint: "vs_main",
                buffers: [
                    (0, $62c887db2be5e7ca$export$d929c5e245d43fa4).getVertexBufferLayout()
                ]
            },
            fragment: {
                module: this.shaderModule,
                entryPoint: "fs_main",
                targets: [
                    {
                        format: this.getTargetFormat(),
                        blend: this.blendState
                    }
                ]
            },
            primitive: {
                topology: "triangle-list"
            },
            depthStencil: this.depthStencilState,
            multisample: multisample,
            label: `${this.label} Render Pipeline`
        });
    }
    /**
   * Get the render pipeline.
   */ getPipeline() {
        if (!this.pipeline) throw new Error(`${this.label} not initialized`);
        return this.pipeline;
    }
    /**
   * Render the fullscreen shader.
   *
   * @param renderPass - The render pass to render on
   * @param bindGroup - Bind group with resources
   */ render(renderPass, bindGroup) {
        if (!this.pipeline || !this.quad) {
            console.warn(`${this.label} not initialized`);
            return;
        }
        renderPass.setPipeline(this.pipeline);
        renderPass.setBindGroup(0, bindGroup);
        this.quad.render(renderPass);
    }
    /**
   * Clean up resources.
   */ destroy() {
        this.unsubscribeMSAA?.();
        this.unsubscribeMSAA = null;
        this.quad?.destroy();
        this.pipeline = null;
        this.bindGroupLayout = null;
        this.pipelineLayout = null;
        this.shaderModule = null;
        this.quad = null;
    }
}




/**
 * Terrain shader modules for height field computation.
 *
 * Naming convention:
 * - `fn_` prefix for function modules
 * - `struct_` prefix for struct modules
 * - `const_` prefix for constant modules
 *
 * Each module exports exactly one thing, named to match the export.
 */ 

/**
 * Polygon utility shader modules for point-in-polygon testing.
 *
 * These functions are used by both terrain and shadow-attenuation shaders
 * for determining containment within arbitrary polygons.
 *
 * Naming convention:
 * - `fn_` prefix for function modules
 */ const $c27996d532f2c2fb$export$678007dccea7cb57 = {
    code: /*wgsl*/ `
fn pointLeftOfSegment(a: vec2<f32>, b: vec2<f32>, p: vec2<f32>) -> f32 {
  return (b.x - a.x) * (p.y - a.y) - (p.x - a.x) * (b.y - a.y);
}
`
};
const $c27996d532f2c2fb$export$fc8fa4ea0c1d3e6f = {
    dependencies: [
        $c27996d532f2c2fb$export$678007dccea7cb57
    ],
    code: /*wgsl*/ `
fn isInsidePolygon(
  worldPos: vec2<f32>,
  vertices: ptr<storage, array<vec2<f32>>, read>,
  startIndex: u32,
  vertexCount: u32,
) -> bool {
  var windingNumber: i32 = 0;

  // Iterate over polygon edges
  for (var i: u32 = 0u; i < vertexCount; i++) {
    let a = (*vertices)[startIndex + i];
    let b = (*vertices)[startIndex + ((i + 1u) % vertexCount)];

    // Winding number calculation
    if (a.y <= worldPos.y) {
      if (b.y > worldPos.y && pointLeftOfSegment(a, b, worldPos) > 0.0) {
        windingNumber += 1;
      }
    } else {
      if (b.y <= worldPos.y && pointLeftOfSegment(a, b, worldPos) < 0.0) {
        windingNumber -= 1;
      }
    }
  }

  return windingNumber != 0;
}
`
};
const $c27996d532f2c2fb$export$17b09e34e3cef7c2 = {
    dependencies: [
        $c27996d532f2c2fb$export$678007dccea7cb57
    ],
    code: /*wgsl*/ `
fn isInsidePolygonWithBBox(
  worldPos: vec2<f32>,
  vertices: ptr<storage, array<vec2<f32>>, read>,
  startIndex: u32,
  vertexCount: u32,
  bboxMin: vec2<f32>,
  bboxMax: vec2<f32>,
) -> bool {
  // Early bbox check
  if (worldPos.x < bboxMin.x || worldPos.x > bboxMax.x ||
      worldPos.y < bboxMin.y || worldPos.y > bboxMax.y) {
    return false;
  }

  var windingNumber: i32 = 0;

  // Iterate over polygon edges
  for (var i: u32 = 0u; i < vertexCount; i++) {
    let a = (*vertices)[startIndex + i];
    let b = (*vertices)[startIndex + ((i + 1u) % vertexCount)];

    // Winding number calculation
    if (a.y <= worldPos.y) {
      if (b.y > worldPos.y && pointLeftOfSegment(a, b, worldPos) > 0.0) {
        windingNumber += 1;
      }
    } else {
      if (b.y <= worldPos.y && pointLeftOfSegment(a, b, worldPos) < 0.0) {
        windingNumber -= 1;
      }
    }
  }

  return windingNumber != 0;
}
`
};
const $c27996d532f2c2fb$export$3bcd2589c657b092 = {
    code: /*wgsl*/ `
fn pointToLineSegmentDistanceSq(p: vec2<f32>, a: vec2<f32>, b: vec2<f32>) -> f32 {
  let ab = b - a;
  let lengthSq = dot(ab, ab);
  if (lengthSq == 0.0) {
    let diff = p - a;
    return dot(diff, diff);
  }
  let t = clamp(dot(p - a, ab) / lengthSq, 0.0, 1.0);
  let nearest = a + t * ab;
  let diff = p - nearest;
  return dot(diff, diff);
}
`
};
const $c27996d532f2c2fb$export$f4db9c0a4172a79b = {
    dependencies: [
        $c27996d532f2c2fb$export$3bcd2589c657b092
    ],
    code: /*wgsl*/ `
fn distanceToPolygonBoundary(
  worldPos: vec2<f32>,
  vertices: ptr<storage, array<vec2<f32>>, read>,
  startIndex: u32,
  vertexCount: u32,
) -> f32 {
  var minDistSq: f32 = 1e20;

  for (var i: u32 = 0u; i < vertexCount; i++) {
    let a = (*vertices)[startIndex + i];
    let b = (*vertices)[startIndex + ((i + 1u) % vertexCount)];

    let distSq = pointToLineSegmentDistanceSq(worldPos, a, b);
    minDistSq = min(minDistSq, distSq);
  }

  return sqrt(minDistSq);
}
`
};


/**
 * Packed terrain accessor functions for reading from a single array<u32> buffer.
 *
 * The packed terrain buffer layout:
 * [0] verticesOffset - element index where vertex data starts
 * [1] contoursOffset - element index where contour data starts
 * [2] childrenOffset - element index where children data starts
 * [3] containmentGridOffset - element index where containment grid data starts
 * [4] idwGridDataOffset - element index where IDW grid data starts
 * [5] lookupGridOffset - element index where lookup grid data starts (0 = no grid)
 * [...] vertex data (f32 pairs stored as u32)
 * [...] contour data (14 fields per contour, mixed u32/f32)
 * [...] children data (u32 indices)
 * [...] containment grid data (256 u32 per contour, 2-bit packed flags)
 * [...] IDW grid data (variable, prefix-sum cell_starts + packed entries)
 * [...] lookup grid data (level-wide 256×256 contour lookup grid)
 *
 * All float values are stored as u32 and recovered via bitcast<f32>().
 */ 

const $d2770abe96d7e153$export$bf8b0ba9719f8192 = {
    code: /*wgsl*/ `
    struct ContourData {
      pointStartIndex: u32,
      pointCount: u32,
      height: f32,
      parentIndex: i32,
      depth: u32,
      childStartIndex: u32,
      childCount: u32,
      isCoastline: u32,
      bboxMinX: f32,
      bboxMinY: f32,
      bboxMaxX: f32,
      bboxMaxY: f32,
      skipCount: u32,           // Number of contours in subtree (for DFS skip traversal)
      idwGridDataOffset: u32,   // Absolute offset in packed buffer for IDW grid (0 = no grid)
    }
  `
};
const $d2770abe96d7e153$export$5183996e4a541d94 = {
    code: /*wgsl*/ `
fn getTerrainVertex(packed: ptr<storage, array<u32>, read>, index: u32) -> vec2<f32> {
  let offset = (*packed)[0u]; // verticesOffset
  let base = offset + index * 2u;
  return vec2<f32>(
    bitcast<f32>((*packed)[base]),
    bitcast<f32>((*packed)[base + 1u])
  );
}
`
};
const $d2770abe96d7e153$export$1060ea61b2a3edfa = {
    dependencies: [
        $d2770abe96d7e153$export$bf8b0ba9719f8192
    ],
    code: /*wgsl*/ `
fn getContourData(packed: ptr<storage, array<u32>, read>, contourIndex: u32) -> ContourData {
  let offset = (*packed)[1u]; // contoursOffset
  let base = offset + contourIndex * ${(0, $7bf8a1354b31a70a$export$517cfe62b5c858e2)}u;
  var c: ContourData;
  c.pointStartIndex = (*packed)[base + 0u];
  c.pointCount = (*packed)[base + 1u];
  c.height = bitcast<f32>((*packed)[base + 2u]);
  c.parentIndex = bitcast<i32>((*packed)[base + 3u]);
  c.depth = (*packed)[base + 4u];
  c.childStartIndex = (*packed)[base + 5u];
  c.childCount = (*packed)[base + 6u];
  c.isCoastline = (*packed)[base + 7u];
  c.bboxMinX = bitcast<f32>((*packed)[base + 8u]);
  c.bboxMinY = bitcast<f32>((*packed)[base + 9u]);
  c.bboxMaxX = bitcast<f32>((*packed)[base + 10u]);
  c.bboxMaxY = bitcast<f32>((*packed)[base + 11u]);
  c.skipCount = (*packed)[base + 12u];
  c.idwGridDataOffset = (*packed)[base + 13u];
  return c;
}
`
};
const $d2770abe96d7e153$export$72f359d8d9607d09 = {
    code: /*wgsl*/ `
fn getTerrainChild(packed: ptr<storage, array<u32>, read>, index: u32) -> u32 {
  let offset = (*packed)[2u]; // childrenOffset
  return (*packed)[offset + index];
}
`
};
const $d2770abe96d7e153$export$9bcda2b8c6c3bb50 = {
    code: /*wgsl*/ `
fn getContainmentCellFlag(packed: ptr<storage, array<u32>, read>, contourIndex: u32, cellIndex: u32) -> u32 {
  let gridOffset = (*packed)[3u]; // containmentGridOffset
  let contourGridBase = gridOffset + contourIndex * 256u;
  let wordIndex = cellIndex >> 4u;  // cellIndex / 16
  let word = (*packed)[contourGridBase + wordIndex];
  return (word >> ((cellIndex & 15u) * 2u)) & 3u;
}
`
};
const $d2770abe96d7e153$export$2515000327e8f4a = {
    code: /*wgsl*/ `
fn getIDWGridCandidateRange(packed: ptr<storage, array<u32>, read>, gridBase: u32, cellIndex: u32) -> vec2<u32> {
  let entryStart = (*packed)[gridBase + cellIndex];
  let entryEnd = (*packed)[gridBase + cellIndex + 1u];
  return vec2<u32>(entryStart, entryEnd);
}
`
};
const $d2770abe96d7e153$export$68d7cb5ef9263fa3 = {
    code: /*wgsl*/ `
fn getIDWGridEntry(packed: ptr<storage, array<u32>, read>, gridBase: u32, entryIndex: u32) -> u32 {
  let entriesBase = gridBase + ${(0, $50f569eac7e9a7b2$export$ceb121c650229aae)}u;  // after cell_starts prefix-sum
  return (*packed)[entriesBase + entryIndex];
}
`
};
const $d2770abe96d7e153$export$527fd7a3221541b9 = {
    code: /*wgsl*/ `
fn getLookupGridBaseContour(packed: ptr<storage, array<u32>, read>, gridBase: u32, cellIndex: u32) -> u32 {
  return (*packed)[gridBase + ${(0, $50f569eac7e9a7b2$export$99fc3a7da177e747)}u + cellIndex];
}
`
};
const $d2770abe96d7e153$export$113e91cfc53b565 = {
    code: /*wgsl*/ `
fn getLookupGridCandidateRange(packed: ptr<storage, array<u32>, read>, gridBase: u32, cellIndex: u32) -> vec2<u32> {
  let cellStartsBase = gridBase + ${(0, $50f569eac7e9a7b2$export$99fc3a7da177e747)}u + ${(0, $50f569eac7e9a7b2$export$858e2636b73e378f)}u;
  let start = (*packed)[cellStartsBase + cellIndex];
  let end = (*packed)[cellStartsBase + cellIndex + 1u];
  return vec2<u32>(start, end);
}
`
};
const $d2770abe96d7e153$export$10eca64cf69224a9 = {
    code: /*wgsl*/ `
fn getLookupGridCandidate(packed: ptr<storage, array<u32>, read>, gridBase: u32, candidateIndex: u32) -> u32 {
  let candidatesBase = gridBase + ${(0, $50f569eac7e9a7b2$export$99fc3a7da177e747)}u + ${(0, $50f569eac7e9a7b2$export$858e2636b73e378f)}u + ${(0, $50f569eac7e9a7b2$export$858e2636b73e378f) + 1}u;
  return (*packed)[candidatesBase + candidateIndex];
}
`
};


const $cef462b61853a9de$export$2d713608fd2cb7c5 = {
    code: /*wgsl*/ `
    fn computeIDWWeight(distance: f32, minDist: f32) -> f32 {
      return 1.0 / max(distance, minDist);
    }
  `
};
const $cef462b61853a9de$export$7cd62faa318850d = {
    code: /*wgsl*/ `
    fn blendIDW(value1: f32, weight1: f32, value2: f32, weight2: f32) -> f32 {
      let totalWeight = weight1 + weight2;
      return (value1 * weight1 + value2 * weight2) / totalWeight;
    }
  `
};
const $cef462b61853a9de$export$a8b1d45732633c84 = {
    code: /*wgsl*/ `
    fn isInsideContour(
      worldPos: vec2<f32>,
      contourIndex: u32,
      packedTerrain: ptr<storage, array<u32>, read>
    ) -> bool {
      let c = getContourData(packedTerrain, contourIndex);

      // Early bbox check
      let bboxW = c.bboxMaxX - c.bboxMinX;
      let bboxH = c.bboxMaxY - c.bboxMinY;
      if (worldPos.x < c.bboxMinX || worldPos.x > c.bboxMaxX ||
          worldPos.y < c.bboxMinY || worldPos.y > c.bboxMaxY ||
          bboxW <= 0.0 || bboxH <= 0.0) {
        return false;
      }

      // Containment grid fast path \u{2014} O(1) for ~95% of queries
      let col = u32(clamp(floor((worldPos.x - c.bboxMinX) * (64.0 / bboxW)), 0.0, 63.0));
      let row = u32(clamp(floor((worldPos.y - c.bboxMinY) * (64.0 / bboxH)), 0.0, 63.0));
      let flag = getContainmentCellFlag(packedTerrain, contourIndex, row * 64u + col);
      if (flag == 0u) { return false; }   // OUTSIDE
      if (flag == 1u) { return true; }    // INSIDE
      // BOUNDARY (flag == 2): fall through to winding test

      let n = c.pointCount;
      let start = c.pointStartIndex;

      var windingNumber: i32 = 0;

      // Iterate over pre-sampled polygon edges - winding test only
      for (var i: u32 = 0u; i < n; i++) {
        let a = getTerrainVertex(packedTerrain, start + i);
        let b = getTerrainVertex(packedTerrain, start + ((i + 1u) % n));

        // Winding number calculation (no distance computation)
        if (a.y <= worldPos.y) {
          if (b.y > worldPos.y && pointLeftOfSegment(a, b, worldPos) > 0.0) {
            windingNumber += 1;
          }
        } else {
          if (b.y <= worldPos.y && pointLeftOfSegment(a, b, worldPos) < 0.0) {
            windingNumber -= 1;
          }
        }
      }

      return windingNumber != 0;
    }
  `,
    dependencies: [
        (0, $c27996d532f2c2fb$export$678007dccea7cb57),
        (0, $d2770abe96d7e153$export$bf8b0ba9719f8192),
        (0, $d2770abe96d7e153$export$1060ea61b2a3edfa),
        (0, $d2770abe96d7e153$export$5183996e4a541d94),
        (0, $d2770abe96d7e153$export$9bcda2b8c6c3bb50)
    ]
};
const $cef462b61853a9de$export$6413859db2042f5f = {
    code: /*wgsl*/ `
    fn computeDistanceToBoundary(
      worldPos: vec2<f32>,
      contourIndex: u32,
      packedTerrain: ptr<storage, array<u32>, read>
    ) -> f32 {
      let c = getContourData(packedTerrain, contourIndex);
      let n = c.pointCount;
      let start = c.pointStartIndex;

      // Track squared distance to avoid sqrt in inner loop
      var minDistSq: f32 = 1e20;

      // Iterate over pre-sampled polygon edges - distance only
      for (var i: u32 = 0u; i < n; i++) {
        let a = getTerrainVertex(packedTerrain, start + i);
        let b = getTerrainVertex(packedTerrain, start + ((i + 1u) % n));

        let distSq = pointToLineSegmentDistanceSq(worldPos, a, b);
        minDistSq = min(minDistSq, distSq);
      }

      return sqrt(minDistSq);
    }
  `,
    dependencies: [
        (0, $c27996d532f2c2fb$export$3bcd2589c657b092),
        (0, $d2770abe96d7e153$export$bf8b0ba9719f8192),
        (0, $d2770abe96d7e153$export$1060ea61b2a3edfa),
        (0, $d2770abe96d7e153$export$5183996e4a541d94)
    ]
};
const $cef462b61853a9de$export$c7b326d049bf9ed1 = {
    code: /*wgsl*/ `
    fn computeSignedDistance(
      worldPos: vec2<f32>,
      contourIndex: u32,
      packedTerrain: ptr<storage, array<u32>, read>
    ) -> f32 {
      let inside = isInsideContour(worldPos, contourIndex, packedTerrain);
      let dist = computeDistanceToBoundary(worldPos, contourIndex, packedTerrain);
      return select(dist, -dist, inside);
    }
  `,
    dependencies: [
        $cef462b61853a9de$export$a8b1d45732633c84,
        $cef462b61853a9de$export$6413859db2042f5f
    ]
};
const $cef462b61853a9de$export$9f1d721728839dd9 = {
    code: /*wgsl*/ `
    struct BoundaryDistanceGradient {
      distance: f32,
      gradientX: f32,
      gradientY: f32,
    }
  `
};
const $cef462b61853a9de$export$46a464d4966cd9c1 = {
    code: /*wgsl*/ `
    fn computeDistanceToBoundaryWithGradient(
      worldPos: vec2<f32>,
      contourIndex: u32,
      packedTerrain: ptr<storage, array<u32>, read>
    ) -> BoundaryDistanceGradient {
      let c = getContourData(packedTerrain, contourIndex);
      let n = c.pointCount;
      let start = c.pointStartIndex;

      var minDistSq: f32 = 1e20;
      var bestDx: f32 = 0.0;
      var bestDy: f32 = 0.0;

      for (var i: u32 = 0u; i < n; i++) {
        let a = getTerrainVertex(packedTerrain, start + i);
        let b = getTerrainVertex(packedTerrain, start + ((i + 1u) % n));

        let ab = b - a;
        let lengthSq = dot(ab, ab);

        var dx: f32;
        var dy: f32;
        var distSq: f32;
        if (lengthSq == 0.0) {
          dx = worldPos.x - a.x;
          dy = worldPos.y - a.y;
          distSq = dx * dx + dy * dy;
        } else {
          let t = clamp(dot(worldPos - a, ab) / lengthSq, 0.0, 1.0);
          let nearest = a + t * ab;
          dx = worldPos.x - nearest.x;
          dy = worldPos.y - nearest.y;
          distSq = dx * dx + dy * dy;
        }

        if (distSq < minDistSq) {
          minDistSq = distSq;
          bestDx = dx;
          bestDy = dy;
        }
      }

      var result: BoundaryDistanceGradient;
      let distance = sqrt(minDistSq);
      result.distance = distance;
      if (distance > 1e-9) {
        let invDist = 1.0 / distance;
        result.gradientX = bestDx * invDist;
        result.gradientY = bestDy * invDist;
      } else {
        result.gradientX = 0.0;
        result.gradientY = 0.0;
      }
      return result;
    }
  `,
    dependencies: [
        $cef462b61853a9de$export$9f1d721728839dd9,
        (0, $d2770abe96d7e153$export$bf8b0ba9719f8192),
        (0, $d2770abe96d7e153$export$1060ea61b2a3edfa),
        (0, $d2770abe96d7e153$export$5183996e4a541d94)
    ]
};
const $cef462b61853a9de$export$3fb9b31381321192 = {
    code: /*wgsl*/ `
    // Minimum distance to avoid division by zero in IDW (private to this module)
    const _IDW_MIN_DIST: f32 = 0.1;

    fn computeTerrainHeight(
      worldPos: vec2<f32>,
      packedTerrain: ptr<storage, array<u32>, read>,
      contourCount: u32,
      defaultDepth: f32
    ) -> f32 {
      // Phase 1: Find the deepest containing contour
      var deepestIndex: i32 = -1;

      let lookupGridOffset = (*packedTerrain)[5u];
      if (lookupGridOffset != 0u) {
        // Lookup grid fast path: O(candidates) instead of O(contours)
        let gridCols = (*packedTerrain)[lookupGridOffset];
        let gridRows = (*packedTerrain)[lookupGridOffset + 1u];
        let gridMinX = bitcast<f32>((*packedTerrain)[lookupGridOffset + 2u]);
        let gridMinY = bitcast<f32>((*packedTerrain)[lookupGridOffset + 3u]);
        let gridInvCellW = bitcast<f32>((*packedTerrain)[lookupGridOffset + 4u]);
        let gridInvCellH = bitcast<f32>((*packedTerrain)[lookupGridOffset + 5u]);

        let col = i32(floor((worldPos.x - gridMinX) * gridInvCellW));
        let row = i32(floor((worldPos.y - gridMinY) * gridInvCellH));

        if (col >= 0 && row >= 0 && u32(col) < gridCols && u32(row) < gridRows) {
          let cellIndex = u32(row) * gridCols + u32(col);

          // Check candidates deepest-first; first match is the deepest containing contour
          let range = getLookupGridCandidateRange(packedTerrain, lookupGridOffset, cellIndex);
          for (var c = range.x; c < range.y; c++) {
            let candidateIdx = getLookupGridCandidate(packedTerrain, lookupGridOffset, c);
            if (isInsideContour(worldPos, candidateIdx, packedTerrain)) {
              deepestIndex = i32(candidateIdx);
              break;
            }
          }

          // If no candidate matched, use base contour
          if (deepestIndex < 0) {
            let base = getLookupGridBaseContour(packedTerrain, lookupGridOffset, cellIndex);
            if (base != 0xFFFFFFFFu) {
              deepestIndex = i32(base);
            }
          }
        }
        // Outside grid bounds \u{2192} outside all contours \u{2192} deepestIndex stays -1
      } else {
        // DFS skip traversal fallback (when no lookup grid is available)
        var deepestDepth: u32 = 0u;
        var i: u32 = 0u;
        var lastToCheck: u32 = contourCount;

        while (i < lastToCheck) {
          let contour = getContourData(packedTerrain, i);

          if (isInsideContour(worldPos, i, packedTerrain)) {
            if (contour.depth >= deepestDepth) {
              deepestDepth = contour.depth;
              deepestIndex = i32(i);
            }
            lastToCheck = i + contour.skipCount + 1u;
            i += 1u;
          } else {
            i += contour.skipCount + 1u;
          }
        }
      }

      // Phase 2: If not inside any contour, return default depth
      if (deepestIndex < 0) {
        return defaultDepth;
      }

      let parent = getContourData(packedTerrain, u32(deepestIndex));

      // Phase 3: If the parent has no children, return its height directly
      // (no IDW blending needed, so skip distance calculation entirely)
      if (parent.childCount == 0u) {
        return parent.height;
      }

      // Phase 4: IDW interpolation between parent and children
      let gridBase = parent.idwGridDataOffset;
      if (gridBase == 0u) {
        // Fallback: no IDW grid \u{2014} linear scan of all edges
        let distToParent = computeDistanceToBoundary(worldPos, u32(deepestIndex), packedTerrain);
        let parentWeight = 1.0 / max(distToParent, _IDW_MIN_DIST);
        var totalWeight = parentWeight;
        var weightedSum = parent.height * parentWeight;

        for (var c: u32 = 0u; c < parent.childCount; c++) {
          let childIndex = getTerrainChild(packedTerrain, parent.childStartIndex + c);
          let child = getContourData(packedTerrain, childIndex);
          let distToChild = computeDistanceToBoundary(worldPos, childIndex, packedTerrain);
          let childWeight = 1.0 / max(distToChild, _IDW_MIN_DIST);
          totalWeight += childWeight;
          weightedSum += child.height * childWeight;
        }
        return weightedSum / totalWeight;
      }

      // Grid-accelerated IDW: map world pos to grid cell
      let bboxW = parent.bboxMaxX - parent.bboxMinX;
      let bboxH = parent.bboxMaxY - parent.bboxMinY;
      let col = u32(clamp(floor((worldPos.x - parent.bboxMinX) * (${(0, $50f569eac7e9a7b2$export$5d2b3ec3c5830b3e)}.0 / bboxW)), 0.0, ${(0, $50f569eac7e9a7b2$export$5d2b3ec3c5830b3e) - 1}.0));
      let row = u32(clamp(floor((worldPos.y - parent.bboxMinY) * (${(0, $50f569eac7e9a7b2$export$5d2b3ec3c5830b3e)}.0 / bboxH)), 0.0, ${(0, $50f569eac7e9a7b2$export$5d2b3ec3c5830b3e) - 1}.0));
      let cellIdx = row * ${(0, $50f569eac7e9a7b2$export$5d2b3ec3c5830b3e)}u + col;

      let range = getIDWGridCandidateRange(packedTerrain, gridBase, cellIdx);

      // Track per-contour best distances
      let contourCount2 = 1u + parent.childCount;
      var bestDistSq: array<f32, ${(0, $50f569eac7e9a7b2$export$443d7f6df6e65b63)}>;
      for (var t = 0u; t < contourCount2; t++) { bestDistSq[t] = 1e20; }

      // Read parent contour vertex info once
      let contoursBase = (*packedTerrain)[1u];

      // Process candidates
      for (var e = range.x; e < range.y; e++) {
        let packed_entry = getIDWGridEntry(packedTerrain, gridBase, e);
        let tag = packed_entry >> 16u;
        let edgeIdx = packed_entry & 0xFFFFu;

        // Resolve contour index for this tag
        var cIdx: u32;
        if (tag == 0u) { cIdx = u32(deepestIndex); }
        else { cIdx = getTerrainChild(packedTerrain, parent.childStartIndex + tag - 1u); }

        let cBase = contoursBase + cIdx * ${(0, $7bf8a1354b31a70a$export$517cfe62b5c858e2)}u;
        let pStart = (*packedTerrain)[cBase];
        let pCount = (*packedTerrain)[cBase + 1u];

        let a = getTerrainVertex(packedTerrain, pStart + edgeIdx);
        let b = getTerrainVertex(packedTerrain, pStart + ((edgeIdx + 1u) % pCount));

        let distSq = pointToLineSegmentDistanceSq(worldPos, a, b);
        if (distSq < bestDistSq[tag]) { bestDistSq[tag] = distSq; }
      }

      // IDW blend using per-contour best distances
      let parentDist = max(sqrt(bestDistSq[0u]), _IDW_MIN_DIST);
      let parentW = 1.0 / parentDist;
      var totalWeight2 = parentW;
      var weightedSum2 = parent.height * parentW;

      for (var c2: u32 = 0u; c2 < parent.childCount; c2++) {
        let childIdx = getTerrainChild(packedTerrain, parent.childStartIndex + c2);
        let child = getContourData(packedTerrain, childIdx);
        let childDist = max(sqrt(bestDistSq[c2 + 1u]), _IDW_MIN_DIST);
        let childW = 1.0 / childDist;
        totalWeight2 += childW;
        weightedSum2 += child.height * childW;
      }
      return weightedSum2 / totalWeight2;
    }
  `,
    dependencies: [
        $cef462b61853a9de$export$a8b1d45732633c84,
        $cef462b61853a9de$export$6413859db2042f5f,
        (0, $c27996d532f2c2fb$export$3bcd2589c657b092),
        (0, $d2770abe96d7e153$export$1060ea61b2a3edfa),
        (0, $d2770abe96d7e153$export$72f359d8d9607d09),
        (0, $d2770abe96d7e153$export$5183996e4a541d94),
        (0, $d2770abe96d7e153$export$2515000327e8f4a),
        (0, $d2770abe96d7e153$export$68d7cb5ef9263fa3),
        (0, $d2770abe96d7e153$export$527fd7a3221541b9),
        (0, $d2770abe96d7e153$export$113e91cfc53b565),
        (0, $d2770abe96d7e153$export$10eca64cf69224a9)
    ]
};
const $cef462b61853a9de$export$8aa5da975f6e05cd = {
    code: /*wgsl*/ `
    struct TerrainHeightAndGradient {
      height: f32,
      gradientX: f32,
      gradientY: f32,
    }

    const _IDW_MIN_DIST: f32 = 0.1;

    fn computeTerrainHeightAndGradient(
      worldPos: vec2<f32>,
      packedTerrain: ptr<storage, array<u32>, read>,
      contourCount: u32,
      defaultDepth: f32
    ) -> TerrainHeightAndGradient {
      var result: TerrainHeightAndGradient;

      // Phase 1: Find the deepest containing contour
      var deepestIndex: i32 = -1;

      let lookupGridOffset = (*packedTerrain)[5u];
      if (lookupGridOffset != 0u) {
        // Lookup grid fast path
        let gridCols = (*packedTerrain)[lookupGridOffset];
        let gridRows = (*packedTerrain)[lookupGridOffset + 1u];
        let gridMinX = bitcast<f32>((*packedTerrain)[lookupGridOffset + 2u]);
        let gridMinY = bitcast<f32>((*packedTerrain)[lookupGridOffset + 3u]);
        let gridInvCellW = bitcast<f32>((*packedTerrain)[lookupGridOffset + 4u]);
        let gridInvCellH = bitcast<f32>((*packedTerrain)[lookupGridOffset + 5u]);

        let col = i32(floor((worldPos.x - gridMinX) * gridInvCellW));
        let row = i32(floor((worldPos.y - gridMinY) * gridInvCellH));

        if (col >= 0 && row >= 0 && u32(col) < gridCols && u32(row) < gridRows) {
          let cellIndex = u32(row) * gridCols + u32(col);

          let range = getLookupGridCandidateRange(packedTerrain, lookupGridOffset, cellIndex);
          for (var c = range.x; c < range.y; c++) {
            let candidateIdx = getLookupGridCandidate(packedTerrain, lookupGridOffset, c);
            if (isInsideContour(worldPos, candidateIdx, packedTerrain)) {
              deepestIndex = i32(candidateIdx);
              break;
            }
          }

          if (deepestIndex < 0) {
            let base = getLookupGridBaseContour(packedTerrain, lookupGridOffset, cellIndex);
            if (base != 0xFFFFFFFFu) {
              deepestIndex = i32(base);
            }
          }
        }
      } else {
        // DFS skip traversal fallback
        var deepestDepth: u32 = 0u;
        var i: u32 = 0u;
        var lastToCheck: u32 = contourCount;

        while (i < lastToCheck) {
          let contour = getContourData(packedTerrain, i);

          if (isInsideContour(worldPos, i, packedTerrain)) {
            if (contour.depth >= deepestDepth) {
              deepestDepth = contour.depth;
              deepestIndex = i32(i);
            }
            lastToCheck = i + contour.skipCount + 1u;
            i += 1u;
          } else {
            i += contour.skipCount + 1u;
          }
        }
      }

      // Phase 2: If not inside any contour, return default depth with zero gradient
      if (deepestIndex < 0) {
        result.height = defaultDepth;
        result.gradientX = 0.0;
        result.gradientY = 0.0;
        return result;
      }

      let parent = getContourData(packedTerrain, u32(deepestIndex));

      // Phase 3: If the parent has no children, height is constant \u{2014} zero gradient
      if (parent.childCount == 0u) {
        result.height = parent.height;
        result.gradientX = 0.0;
        result.gradientY = 0.0;
        return result;
      }

      // Phase 4: IDW interpolation with analytical gradient
      let gridBase = parent.idwGridDataOffset;
      if (gridBase == 0u) {
        // Fallback: no IDW grid \u{2014} linear scan
        var weightSum: f32 = 0.0;
        var weightedHeightSum: f32 = 0.0;
        var gradWeightSumX: f32 = 0.0;
        var gradWeightSumY: f32 = 0.0;
        var gradWeightedHeightSumX: f32 = 0.0;
        var gradWeightedHeightSumY: f32 = 0.0;

        let parentBdg = computeDistanceToBoundaryWithGradient(worldPos, u32(deepestIndex), packedTerrain);
        var weight: f32;
        var gradWeightX: f32 = 0.0;
        var gradWeightY: f32 = 0.0;
        if (parentBdg.distance <= _IDW_MIN_DIST) {
          weight = 1.0 / _IDW_MIN_DIST;
          let scale = -1.0 / (_IDW_MIN_DIST * _IDW_MIN_DIST);
          gradWeightX = scale * parentBdg.gradientX;
          gradWeightY = scale * parentBdg.gradientY;
        } else {
          let invDist = 1.0 / parentBdg.distance;
          weight = invDist;
          let scale = -invDist * invDist;
          gradWeightX = scale * parentBdg.gradientX;
          gradWeightY = scale * parentBdg.gradientY;
        }
        weightSum += weight;
        weightedHeightSum += parent.height * weight;
        gradWeightSumX += gradWeightX;
        gradWeightSumY += gradWeightY;
        gradWeightedHeightSumX += parent.height * gradWeightX;
        gradWeightedHeightSumY += parent.height * gradWeightY;

        for (var c: u32 = 0u; c < parent.childCount; c++) {
          let childIndex = getTerrainChild(packedTerrain, parent.childStartIndex + c);
          let child = getContourData(packedTerrain, childIndex);
          let childBdg = computeDistanceToBoundaryWithGradient(worldPos, childIndex, packedTerrain);
          var cWeight: f32;
          var cGradWeightX: f32 = 0.0;
          var cGradWeightY: f32 = 0.0;
          if (childBdg.distance <= _IDW_MIN_DIST) {
            cWeight = 1.0 / _IDW_MIN_DIST;
            let cScale = -1.0 / (_IDW_MIN_DIST * _IDW_MIN_DIST);
            cGradWeightX = cScale * childBdg.gradientX;
            cGradWeightY = cScale * childBdg.gradientY;
          } else {
            let cInvDist = 1.0 / childBdg.distance;
            cWeight = cInvDist;
            let cScale = -cInvDist * cInvDist;
            cGradWeightX = cScale * childBdg.gradientX;
            cGradWeightY = cScale * childBdg.gradientY;
          }
          weightSum += cWeight;
          weightedHeightSum += child.height * cWeight;
          gradWeightSumX += cGradWeightX;
          gradWeightSumY += cGradWeightY;
          gradWeightedHeightSumX += child.height * cGradWeightX;
          gradWeightedHeightSumY += child.height * cGradWeightY;
        }

        let invWeightSum = 1.0 / weightSum;
        let invWeightSumSq = invWeightSum * invWeightSum;
        result.height = weightedHeightSum * invWeightSum;
        result.gradientX = (gradWeightedHeightSumX * weightSum - weightedHeightSum * gradWeightSumX) * invWeightSumSq;
        result.gradientY = (gradWeightedHeightSumY * weightSum - weightedHeightSum * gradWeightSumY) * invWeightSumSq;
        return result;
      }

      // Grid-accelerated IDW with gradient
      let bboxW = parent.bboxMaxX - parent.bboxMinX;
      let bboxH = parent.bboxMaxY - parent.bboxMinY;
      let col = u32(clamp(floor((worldPos.x - parent.bboxMinX) * (${(0, $50f569eac7e9a7b2$export$5d2b3ec3c5830b3e)}.0 / bboxW)), 0.0, ${(0, $50f569eac7e9a7b2$export$5d2b3ec3c5830b3e) - 1}.0));
      let row = u32(clamp(floor((worldPos.y - parent.bboxMinY) * (${(0, $50f569eac7e9a7b2$export$5d2b3ec3c5830b3e)}.0 / bboxH)), 0.0, ${(0, $50f569eac7e9a7b2$export$5d2b3ec3c5830b3e) - 1}.0));
      let cellIdx = row * ${(0, $50f569eac7e9a7b2$export$5d2b3ec3c5830b3e)}u + col;

      let range = getIDWGridCandidateRange(packedTerrain, gridBase, cellIdx);

      let contourCount2 = 1u + parent.childCount;
      var bestDistSq: array<f32, ${(0, $50f569eac7e9a7b2$export$443d7f6df6e65b63)}>;
      var bestDx: array<f32, ${(0, $50f569eac7e9a7b2$export$443d7f6df6e65b63)}>;
      var bestDy: array<f32, ${(0, $50f569eac7e9a7b2$export$443d7f6df6e65b63)}>;
      for (var t = 0u; t < contourCount2; t++) {
        bestDistSq[t] = 1e20;
        bestDx[t] = 0.0;
        bestDy[t] = 0.0;
      }

      let contoursBase = (*packedTerrain)[1u];

      for (var e = range.x; e < range.y; e++) {
        let packed_entry = getIDWGridEntry(packedTerrain, gridBase, e);
        let tag = packed_entry >> 16u;
        let edgeIdx = packed_entry & 0xFFFFu;

        var cIdx: u32;
        if (tag == 0u) { cIdx = u32(deepestIndex); }
        else { cIdx = getTerrainChild(packedTerrain, parent.childStartIndex + tag - 1u); }

        let cBase = contoursBase + cIdx * ${(0, $7bf8a1354b31a70a$export$517cfe62b5c858e2)}u;
        let pStart = (*packedTerrain)[cBase];
        let pCount = (*packedTerrain)[cBase + 1u];

        let a = getTerrainVertex(packedTerrain, pStart + edgeIdx);
        let b = getTerrainVertex(packedTerrain, pStart + ((edgeIdx + 1u) % pCount));

        // Compute distance and gradient direction to nearest point on edge
        let ab = b - a;
        let lengthSq = dot(ab, ab);
        var dx: f32;
        var dy: f32;
        var distSq: f32;
        if (lengthSq == 0.0) {
          dx = worldPos.x - a.x;
          dy = worldPos.y - a.y;
          distSq = dx * dx + dy * dy;
        } else {
          let t2 = clamp(dot(worldPos - a, ab) / lengthSq, 0.0, 1.0);
          let nearest = a + t2 * ab;
          dx = worldPos.x - nearest.x;
          dy = worldPos.y - nearest.y;
          distSq = dx * dx + dy * dy;
        }

        if (distSq < bestDistSq[tag]) {
          bestDistSq[tag] = distSq;
          bestDx[tag] = dx;
          bestDy[tag] = dy;
        }
      }

      // IDW blend with gradient using quotient rule
      var gWeightSum: f32 = 0.0;
      var gWeightedHeightSum: f32 = 0.0;
      var gGradWeightSumX: f32 = 0.0;
      var gGradWeightSumY: f32 = 0.0;
      var gGradWHSumX: f32 = 0.0;
      var gGradWHSumY: f32 = 0.0;

      for (var c2: u32 = 0u; c2 < contourCount2; c2++) {
        var height: f32;
        if (c2 == 0u) {
          height = parent.height;
        } else {
          let childIdx = getTerrainChild(packedTerrain, parent.childStartIndex + c2 - 1u);
          let child = getContourData(packedTerrain, childIdx);
          height = child.height;
        }

        let dist = sqrt(bestDistSq[c2]);
        var w: f32;
        var gwx: f32 = 0.0;
        var gwy: f32 = 0.0;
        if (dist <= _IDW_MIN_DIST) {
          w = 1.0 / _IDW_MIN_DIST;
          // Use clamped distance for gradient magnitude, keep direction
          if (dist > 1e-9) {
            let invD = 1.0 / dist;
            let gradDx = bestDx[c2] * invD;
            let gradDy = bestDy[c2] * invD;
            let scale = -1.0 / (_IDW_MIN_DIST * _IDW_MIN_DIST);
            gwx = scale * gradDx;
            gwy = scale * gradDy;
          }
        } else {
          let invD = 1.0 / dist;
          w = invD;
          // Gradient of distance = unit direction from nearest boundary point
          let gradDx = bestDx[c2] * invD;
          let gradDy = bestDy[c2] * invD;
          // Gradient of weight = -1/d\xb2 * grad(d)
          let scale = -invD * invD;
          gwx = scale * gradDx;
          gwy = scale * gradDy;
        }
        gWeightSum += w;
        gWeightedHeightSum += height * w;
        gGradWeightSumX += gwx;
        gGradWeightSumY += gwy;
        gGradWHSumX += height * gwx;
        gGradWHSumY += height * gwy;
      }

      let invWS = 1.0 / gWeightSum;
      let invWSSq = invWS * invWS;
      result.height = gWeightedHeightSum * invWS;
      result.gradientX = (gGradWHSumX * gWeightSum - gWeightedHeightSum * gGradWeightSumX) * invWSSq;
      result.gradientY = (gGradWHSumY * gWeightSum - gWeightedHeightSum * gGradWeightSumY) * invWSSq;
      return result;
    }
  `,
    dependencies: [
        $cef462b61853a9de$export$a8b1d45732633c84,
        $cef462b61853a9de$export$46a464d4966cd9c1,
        (0, $c27996d532f2c2fb$export$3bcd2589c657b092),
        (0, $d2770abe96d7e153$export$1060ea61b2a3edfa),
        (0, $d2770abe96d7e153$export$72f359d8d9607d09),
        (0, $d2770abe96d7e153$export$5183996e4a541d94),
        (0, $d2770abe96d7e153$export$2515000327e8f4a),
        (0, $d2770abe96d7e153$export$68d7cb5ef9263fa3),
        (0, $d2770abe96d7e153$export$527fd7a3221541b9),
        (0, $d2770abe96d7e153$export$113e91cfc53b565),
        (0, $d2770abe96d7e153$export$10eca64cf69224a9)
    ]
};
const $cef462b61853a9de$export$3111076505cb5ef6 = {
    code: /*wgsl*/ `
    fn computeTerrainNormal(
      worldPos: vec2<f32>,
      packedTerrain: ptr<storage, array<u32>, read>,
      contourCount: u32,
      defaultDepth: f32
    ) -> vec2<f32> {
      let h = 1.0; // Sample offset
      let hCenter = computeTerrainHeight(worldPos, packedTerrain, contourCount, defaultDepth);
      let hRight = computeTerrainHeight(worldPos + vec2<f32>(h, 0.0), packedTerrain, contourCount, defaultDepth);
      let hUp = computeTerrainHeight(worldPos + vec2<f32>(0.0, h), packedTerrain, contourCount, defaultDepth);

      let dx = hRight - hCenter;
      let dy = hUp - hCenter;

      // Normal from gradient (pointing up from surface)
      let normal3d = normalize(vec3<f32>(-dx, -dy, h));
      return vec2<f32>(normal3d.x, normal3d.y);
    }
  `,
    dependencies: [
        $cef462b61853a9de$export$3fb9b31381321192
    ]
};


/**
 * Terrain GPU resource manager.
 *
 * Owns and manages GPU buffers for terrain contour data.
 * Provides read-only access to buffers for query shaders and render pipelines.
 * Also stores the terrain definition and tracks version changes.
 */ 



/** Header size for packed terrain buffer: 6 u32 offsets (vertices, contours, children, containmentGrid, idwGridData, lookupGrid) */ const $cd92036e590b44aa$var$PACKED_TERRAIN_HEADER_SIZE = 6;
function $cd92036e590b44aa$export$cac16c08ff3293bc(gpuData) {
    const { vertexData: vertexData, contourData: contourData, childrenData: childrenData, containmentGridData: containmentGridData, idwGridData: idwGridData, lookupGridData: lookupGridData, contourCount: contourCount } = gpuData;
    // Compute section offsets from actual data sizes (tightly packed)
    const verticesOffset = $cd92036e590b44aa$var$PACKED_TERRAIN_HEADER_SIZE;
    const vertexCount = vertexData.length; // number of f32s (2 per vertex)
    const contoursOffset = verticesOffset + vertexCount;
    const contourFloatCount = contourCount * (0, $7bf8a1354b31a70a$export$517cfe62b5c858e2);
    const childrenOffset = contoursOffset + contourFloatCount;
    const containmentGridOffset = childrenOffset + childrenData.length;
    const idwGridDataOffset = containmentGridOffset + containmentGridData.length;
    const lookupGridOffset = lookupGridData.length > 0 ? idwGridDataOffset + idwGridData.length : 0;
    const packedSize = idwGridDataOffset + idwGridData.length + lookupGridData.length;
    const packed = new Uint32Array(packedSize);
    const packedFloat = new Float32Array(packed.buffer);
    // Write header
    packed[0] = verticesOffset;
    packed[1] = contoursOffset;
    packed[2] = childrenOffset;
    packed[3] = containmentGridOffset;
    packed[4] = idwGridDataOffset;
    packed[5] = lookupGridOffset;
    // Write vertex data (f32 pairs → stored as u32 via shared buffer)
    for(let i = 0; i < vertexCount; i++)packedFloat[verticesOffset + i] = vertexData[i];
    // Write contour data (mixed u32/f32 - contourData is already an ArrayBuffer)
    // Contour field 13 (idwGridDataOffset) stores (relative offset + 1) where
    // 0 means "no grid". Convert to absolute offset in packed buffer.
    const contourSrc = new Uint32Array(contourData);
    for(let i = 0; i < contourFloatCount; i++)packed[contoursOffset + i] = contourSrc[i];
    for(let ci = 0; ci < contourCount; ci++){
        const fieldOffset = contoursOffset + ci * (0, $7bf8a1354b31a70a$export$517cfe62b5c858e2) + 13;
        const encoded = packed[fieldOffset];
        if (encoded !== 0) packed[fieldOffset] = idwGridDataOffset + (encoded - 1);
    }
    // Write children data
    for(let i = 0; i < childrenData.length; i++)packed[childrenOffset + i] = childrenData[i];
    // Write containment grid data
    for(let i = 0; i < containmentGridData.length; i++)packed[containmentGridOffset + i] = containmentGridData[i];
    // Write IDW grid data
    for(let i = 0; i < idwGridData.length; i++)packed[idwGridDataOffset + i] = idwGridData[i];
    // Write lookup grid data
    if (lookupGridOffset > 0) for(let i = 0; i < lookupGridData.length; i++)packed[lookupGridOffset + i] = lookupGridData[i];
    return packed;
}
class $cd92036e590b44aa$export$74cf638da29b900d extends (0, $c59361981bac2575$export$4342ba5c6ad1f6f1) {
    constructor(terrainDefinition){
        super(), this.id = "terrainResources", // Version number - increments when terrain changes
        this.version = 0, this.contourCount = 0;
        // Normalize contour winding to CCW for consistent wave physics
        this.terrainDefinition = (0, $7bf8a1354b31a70a$export$6de2c26936e89d30)(terrainDefinition);
    }
    onAdd() {
        // Upload initial terrain data (creates buffer sized to actual data)
        this.uploadTerrainData(this.terrainDefinition);
    }
    onDestroy() {
        this.packedTerrainBuffer.destroy();
    }
    /**
   * Upload terrain data to packed GPU buffer.
   *
   * Packed layout (all u32):
   * [0] verticesOffset - element index where vertex data starts
   * [1] contoursOffset - element index where contour data starts
   * [2] childrenOffset - element index where children data starts
   * [3] containmentGridOffset - element index where containment grid data starts
   * [4] idwGridDataOffset - element index where IDW grid data starts
   * [5] lookupGridOffset - element index where lookup grid data starts (0 = no grid)
   * [6..] vertex data (f32 pairs stored as u32 via bitcast)
   * [...] contour data (14 fields per contour, mixed u32/f32 via bitcast)
   * [...] children data (u32 indices)
   * [...] containment grid data (256 u32 per contour, 2-bit packed flags)
   * [...] IDW grid data (variable, prefix-sum + packed entries)
   * [...] lookup grid data (level-wide 256×256 contour lookup grid)
   *
   * @internal
   */ uploadTerrainData(definition) {
        const device = this.game.getWebGPUDevice();
        const gpuData = definition.precomputedGPUData ? (0, $7bf8a1354b31a70a$export$6375e47041b2104e)(definition.precomputedGPUData) : (0, $7bf8a1354b31a70a$export$14b690e8105d8014)(definition);
        const packed = $cd92036e590b44aa$export$cac16c08ff3293bc(gpuData);
        // Recreate GPU buffer sized to actual data
        this.packedTerrainBuffer?.destroy();
        this.packedTerrainBuffer = device.createBuffer({
            size: packed.byteLength,
            usage: GPUBufferUsage.STORAGE | GPUBufferUsage.COPY_DST,
            label: "Packed Terrain Buffer"
        });
        device.queue.writeBuffer(this.packedTerrainBuffer, 0, packed.buffer);
        this.contourCount = gpuData.contourCount;
    }
    /**
   * Get the number of contours.
   */ getContourCount() {
        return this.contourCount;
    }
    /**
   * Get all contours (read-only).
   */ getContours() {
        return this.terrainDefinition.contours;
    }
    /**
   * Get the full terrain definition.
   */ getTerrainDefinition() {
        return this.terrainDefinition;
    }
    /**
   * Update the terrain definition (e.g., for level loading or editor changes).
   * Normalizes contour winding to CCW for consistent wave physics.
   */ setTerrainDefinition(definition) {
        this.terrainDefinition = (0, $7bf8a1354b31a70a$export$6de2c26936e89d30)(definition);
        this.uploadTerrainData(this.terrainDefinition);
        this.version++;
    }
    /**
   * Get the terrain definition version.
   * Increments whenever terrain data changes.
   */ getVersion() {
        return this.version;
    }
}
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $aa1f0309d9dba6d2$export$af631764ddc44097)("add")
], $cd92036e590b44aa$export$74cf638da29b900d.prototype, "onAdd", null);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $aa1f0309d9dba6d2$export$af631764ddc44097)("destroy")
], $cd92036e590b44aa$export$74cf638da29b900d.prototype, "onDestroy", null);




class $6eb211648954ac4c$export$8230771f441ce638 extends (0, $c59361981bac2575$export$4342ba5c6ad1f6f1) {
    /** Get HUD info content for this debug mode */ getHudInfo() {
        return null;
    }
    /** Get cursor info content for this debug mode */ getCursorInfo() {
        return null;
    }
}


const $c586fbebc8a88baa$var$WORKGROUP_SIZE = [
    8,
    8
];
// --- Compute shader: evaluate gradient per pixel ---
const $c586fbebc8a88baa$var$ComputeUniforms = (0, $ca6793d1abd58997$export$99bb2281c7368d10)("ComputeParams", {
    screenWidth: (0, $ca6793d1abd58997$export$e33361ff41014190),
    screenHeight: (0, $ca6793d1abd58997$export$e33361ff41014190),
    viewportLeft: (0, $ca6793d1abd58997$export$e33361ff41014190),
    viewportTop: (0, $ca6793d1abd58997$export$e33361ff41014190),
    viewportWidth: (0, $ca6793d1abd58997$export$e33361ff41014190),
    viewportHeight: (0, $ca6793d1abd58997$export$e33361ff41014190),
    contourCount: (0, $ca6793d1abd58997$export$8bacf4ad828c7fe7),
    _padding0: (0, $ca6793d1abd58997$export$8bacf4ad828c7fe7)
});
const $c586fbebc8a88baa$var$computeParamsModule = {
    preamble: /*wgsl*/ `
struct ComputeParams {
  screenWidth: f32,
  screenHeight: f32,
  viewportLeft: f32,
  viewportTop: f32,
  viewportWidth: f32,
  viewportHeight: f32,
  contourCount: u32,
  _padding0: u32,
}

const DEFAULT_DEPTH: f32 = ${(0, $50f569eac7e9a7b2$export$7f882bb969de14a3)}.0;
`,
    bindings: {
        params: {
            type: "uniform",
            wgslType: "ComputeParams"
        },
        packedTerrain: {
            type: "storage",
            wgslType: "array<u32>"
        },
        outputTexture: {
            type: "storageTexture",
            format: "rgba32float"
        }
    },
    code: ""
};
const $c586fbebc8a88baa$var$computeMainModule = {
    dependencies: [
        $c586fbebc8a88baa$var$computeParamsModule,
        (0, $d2770abe96d7e153$export$bf8b0ba9719f8192),
        (0, $cef462b61853a9de$export$8aa5da975f6e05cd)
    ],
    code: /*wgsl*/ `
fn pixelToWorld(pixel: vec2<u32>) -> vec2<f32> {
  let uv = vec2<f32>(
    f32(pixel.x) / params.screenWidth,
    f32(pixel.y) / params.screenHeight
  );
  return vec2<f32>(
    params.viewportLeft + uv.x * params.viewportWidth,
    params.viewportTop + uv.y * params.viewportHeight
  );
}

@compute @workgroup_size(${$c586fbebc8a88baa$var$WORKGROUP_SIZE[0]}, ${$c586fbebc8a88baa$var$WORKGROUP_SIZE[1]})
fn main(@builtin(global_invocation_id) global_id: vec3<u32>) {
  let pixel = global_id.xy;
  if (pixel.x >= u32(params.screenWidth) || pixel.y >= u32(params.screenHeight)) {
    return;
  }

  let worldPos = pixelToWorld(pixel);
  let hg = computeTerrainHeightAndGradient(
    worldPos,
    &packedTerrain,
    params.contourCount,
    DEFAULT_DEPTH
  );

  textureStore(outputTexture, pixel, vec4<f32>(hg.height, hg.gradientX, hg.gradientY, 0.0));
}
`
};
const $c586fbebc8a88baa$var$computeShaderConfig = {
    modules: [
        $c586fbebc8a88baa$var$computeMainModule
    ],
    workgroupSize: $c586fbebc8a88baa$var$WORKGROUP_SIZE,
    label: "TerrainGradientComputeShader"
};
// --- Fullscreen fragment shader: visualize gradient texture ---
const $c586fbebc8a88baa$var$vizParamsModule = {
    preamble: /*wgsl*/ `
struct VizParams {
  cameraMatrix0: vec4<f32>,
  cameraMatrix1: vec4<f32>,
  cameraMatrix2: vec4<f32>,
  screenWidth: f32,
  screenHeight: f32,
  viewportLeft: f32,
  viewportTop: f32,
  viewportWidth: f32,
  viewportHeight: f32,
  _padding0: f32,
  _padding1: f32,
}
`,
    bindings: {
        vizParams: {
            type: "uniform",
            wgslType: "VizParams"
        },
        gradientTexture: {
            type: "texture",
            sampleType: "unfilterable-float"
        }
    },
    code: ""
};
const $c586fbebc8a88baa$var$vizMainModule = {
    dependencies: [
        $c586fbebc8a88baa$var$vizParamsModule
    ],
    code: /*wgsl*/ `
struct VertexOutput {
  @builtin(position) position: vec4<f32>,
  @location(0) clipPosition: vec2<f32>,
}

@vertex
fn vs_main(@location(0) position: vec2<f32>) -> VertexOutput {
  var out: VertexOutput;
  out.position = vec4<f32>(position, 0.0, 1.0);
  out.clipPosition = position;
  return out;
}

fn getCameraMatrix() -> mat3x3<f32> {
  return mat3x3<f32>(
    vizParams.cameraMatrix0.xyz,
    vizParams.cameraMatrix1.xyz,
    vizParams.cameraMatrix2.xyz
  );
}

fn clipToWorld(clipPos: vec2<f32>) -> vec2<f32> {
  let screenPos = (clipPos * 0.5 + 0.5) * vec2<f32>(vizParams.screenWidth, vizParams.screenHeight);
  let cameraMatrix = getCameraMatrix();
  let worldPosH = cameraMatrix * vec3<f32>(screenPos, 1.0);
  return worldPosH.xy;
}

fn worldToTexCoord(worldPos: vec2<f32>) -> vec2<i32> {
  let uv = vec2<f32>(
    (worldPos.x - vizParams.viewportLeft) / vizParams.viewportWidth,
    (worldPos.y - vizParams.viewportTop) / vizParams.viewportHeight
  );
  return vec2<i32>(
    i32(uv.x * vizParams.screenWidth),
    i32(uv.y * vizParams.screenHeight)
  );
}

fn hsv2rgb(h: f32, s: f32, v: f32) -> vec3<f32> {
  let h6 = h * 6.0;
  let i = floor(h6);
  let f = h6 - i;
  let p = v * (1.0 - s);
  let q = v * (1.0 - s * f);
  let t = v * (1.0 - s * (1.0 - f));
  let sector = i32(i) % 6;
  switch (sector) {
    case 0: { return vec3<f32>(v, t, p); }
    case 1: { return vec3<f32>(q, v, p); }
    case 2: { return vec3<f32>(p, v, t); }
    case 3: { return vec3<f32>(p, q, v); }
    case 4: { return vec3<f32>(t, p, v); }
    default: { return vec3<f32>(v, p, q); }
  }
}

@fragment
fn fs_main(in: VertexOutput) -> @location(0) vec4<f32> {
  let worldPos = clipToWorld(in.clipPosition);
  let texCoord = worldToTexCoord(worldPos);
  let data = textureLoad(gradientTexture, texCoord, 0);
  let height = data.r;
  let gx = data.g;
  let gy = data.b;

  let magnitude = sqrt(gx * gx + gy * gy);

  // Outside terrain: black
  if (height <= ${(0, $50f569eac7e9a7b2$export$7f882bb969de14a3)}.0 + 1.0) {
    return vec4<f32>(0.0, 0.0, 0.0, 1.0);
  }

  // Flat areas: dark gray
  if (magnitude < 0.001) {
    return vec4<f32>(0.08, 0.08, 0.08, 1.0);
  }

  // Direction as hue, magnitude as brightness
  let angle = atan2(gy, gx);
  let hue = (angle / (2.0 * 3.14159265) + 1.0) % 1.0;
  let brightness = clamp(magnitude * 1.5, 0.15, 1.0);

  let color = hsv2rgb(hue, 0.85, brightness);
  return vec4<f32>(color, 1.0);
}
`
};
const $c586fbebc8a88baa$var$VizUniforms = (0, $ca6793d1abd58997$export$99bb2281c7368d10)("VizParams", {
    cameraMatrix: (0, $ca6793d1abd58997$export$a9b01fc77c97438b),
    screenWidth: (0, $ca6793d1abd58997$export$e33361ff41014190),
    screenHeight: (0, $ca6793d1abd58997$export$e33361ff41014190),
    viewportLeft: (0, $ca6793d1abd58997$export$e33361ff41014190),
    viewportTop: (0, $ca6793d1abd58997$export$e33361ff41014190),
    viewportWidth: (0, $ca6793d1abd58997$export$e33361ff41014190),
    viewportHeight: (0, $ca6793d1abd58997$export$e33361ff41014190)
});
const $c586fbebc8a88baa$var$vizShaderConfig = {
    modules: [
        $c586fbebc8a88baa$var$vizMainModule
    ],
    label: "TerrainGradientVizShader"
};
// Margin for render viewport expansion (must match SurfaceRenderer)
const $c586fbebc8a88baa$var$RENDER_VIEWPORT_MARGIN = 0.1;
// Convert radians to compass direction
function $c586fbebc8a88baa$var$radiansToCompass(radians) {
    const normalized = (radians % (2 * Math.PI) + 2 * Math.PI) % (2 * Math.PI);
    const degrees = normalized * 180 / Math.PI;
    const compassDeg = (degrees + 90) % 360;
    const directions = [
        "N",
        "NE",
        "E",
        "SE",
        "S",
        "SW",
        "W",
        "NW"
    ];
    const index = Math.round(compassDeg / 45) % 8;
    return directions[index];
}
function $c586fbebc8a88baa$var$radiansToCompassBearingDeg(radians) {
    const normalized = (radians % (2 * Math.PI) + 2 * Math.PI) % (2 * Math.PI);
    const degrees = normalized * 180 / Math.PI;
    return (degrees + 90) % 360;
}
class $c586fbebc8a88baa$export$45dd5d5affb3f66b extends (0, $6eb211648954ac4c$export$8230771f441ce638) {
    constructor(){
        super(), this.layer = "windViz", // Compute pass
        this.computeShader = null, this.computeUniformBuffer = null, this.computeUniforms = null, this.computeBindGroup = null, // Gradient texture (output of compute, input to viz)
        this.gradientTexture = null, this.gradientTextureView = null, this.lastTextureWidth = 0, this.lastTextureHeight = 0, // Viz pass
        this.vizShader = null, this.vizUniformBuffer = null, this.vizUniforms = null, this.vizBindGroup = null, this.initialized = false, this.lastTerrainBuffer = null;
        this.terrainQuery = this.addChild(new (0, $178448b994cda479$export$b2f87c4d67934c2d)(()=>this.getCursorQueryPoint()));
    }
    getCursorQueryPoint() {
        if (!this.game) return [];
        const mouseWorldPos = this.game.camera.toWorld(this.game.io.mousePosition);
        if (!mouseWorldPos) return [];
        return [
            mouseWorldPos
        ];
    }
    async onAdd() {
        await this.ensureInitialized();
    }
    async ensureInitialized() {
        if (this.initialized) return;
        const device = this.game.getWebGPUDevice();
        // Compute shader
        this.computeShader = new (0, $4016c3d8f65071ed$export$cdde5429dd049099)($c586fbebc8a88baa$var$computeShaderConfig);
        await this.computeShader.init();
        this.computeUniformBuffer = device.createBuffer({
            size: $c586fbebc8a88baa$var$ComputeUniforms.byteSize,
            usage: GPUBufferUsage.UNIFORM | GPUBufferUsage.COPY_DST,
            label: "Terrain Gradient Compute Uniform Buffer"
        });
        this.computeUniforms = $c586fbebc8a88baa$var$ComputeUniforms.create();
        // Viz shader
        this.vizShader = new (0, $c43b1a1e19bbbf4b$export$b176bfba5cd328c9)($c586fbebc8a88baa$var$vizShaderConfig);
        await this.vizShader.init();
        this.vizUniformBuffer = device.createBuffer({
            size: $c586fbebc8a88baa$var$VizUniforms.byteSize,
            usage: GPUBufferUsage.UNIFORM | GPUBufferUsage.COPY_DST,
            label: "Terrain Gradient Viz Uniform Buffer"
        });
        this.vizUniforms = $c586fbebc8a88baa$var$VizUniforms.create();
        this.initialized = true;
    }
    ensureGradientTexture(width, height) {
        if (this.lastTextureWidth === width && this.lastTextureHeight === height) return;
        const device = this.game.getWebGPUDevice();
        this.gradientTexture?.destroy();
        this.gradientTexture = device.createTexture({
            size: {
                width: width,
                height: height
            },
            format: "rgba32float",
            usage: GPUTextureUsage.STORAGE_BINDING | GPUTextureUsage.TEXTURE_BINDING,
            label: "Terrain Gradient Debug Texture"
        });
        this.gradientTextureView = this.gradientTexture.createView();
        this.lastTextureWidth = width;
        this.lastTextureHeight = height;
        // Force bind group recreation
        this.computeBindGroup = null;
        this.vizBindGroup = null;
    }
    getExpandedViewport(margin) {
        const worldViewport = this.game.camera.getWorldViewport();
        const marginX = worldViewport.width * margin;
        const marginY = worldViewport.height * margin;
        return {
            left: worldViewport.left - marginX,
            top: worldViewport.top - marginY,
            width: worldViewport.width + marginX * 2,
            height: worldViewport.height + marginY * 2
        };
    }
    onRender(_event) {
        if (!this.initialized || !this.computeShader || !this.computeUniforms || !this.vizShader || !this.vizUniforms) return;
        const terrainResources = this.game.entities.tryGetSingleton((0, $cd92036e590b44aa$export$74cf638da29b900d));
        if (!terrainResources) return;
        const renderer = this.game.getRenderer();
        const device = this.game.getWebGPUDevice();
        const renderPass = renderer.getCurrentRenderPass();
        if (!renderPass) return;
        const width = renderer.getWidth();
        const height = renderer.getHeight();
        const expandedViewport = this.getExpandedViewport($c586fbebc8a88baa$var$RENDER_VIEWPORT_MARGIN);
        this.ensureGradientTexture(width, height);
        // Rebuild bind groups if terrain buffer changed
        const terrainBuffer = terrainResources.packedTerrainBuffer;
        if (!this.computeBindGroup || !this.vizBindGroup || this.lastTerrainBuffer !== terrainBuffer) {
            this.computeBindGroup = this.computeShader.createBindGroup({
                params: {
                    buffer: this.computeUniformBuffer
                },
                packedTerrain: {
                    buffer: terrainBuffer
                },
                outputTexture: this.gradientTextureView
            });
            this.vizBindGroup = this.vizShader.createBindGroup({
                vizParams: {
                    buffer: this.vizUniformBuffer
                },
                gradientTexture: this.gradientTextureView
            });
            this.lastTerrainBuffer = terrainBuffer;
        }
        // Update compute uniforms
        this.computeUniforms.set.screenWidth(width);
        this.computeUniforms.set.screenHeight(height);
        this.computeUniforms.set.viewportLeft(expandedViewport.left);
        this.computeUniforms.set.viewportTop(expandedViewport.top);
        this.computeUniforms.set.viewportWidth(expandedViewport.width);
        this.computeUniforms.set.viewportHeight(expandedViewport.height);
        this.computeUniforms.set.contourCount(terrainResources.getContourCount());
        this.computeUniforms.uploadTo(this.computeUniformBuffer);
        // Run compute pass
        const commandEncoder = device.createCommandEncoder({
            label: "Terrain Gradient Debug Compute"
        });
        const computePass = commandEncoder.beginComputePass({
            label: "Terrain Gradient Debug Compute Pass"
        });
        this.computeShader.dispatch(computePass, this.computeBindGroup, width, height);
        computePass.end();
        device.queue.submit([
            commandEncoder.finish()
        ]);
        // Update viz uniforms
        const cameraMatrix = this.game.camera.getMatrix().clone().invert();
        this.vizUniforms.set.cameraMatrix(cameraMatrix);
        this.vizUniforms.set.screenWidth(width);
        this.vizUniforms.set.screenHeight(height);
        this.vizUniforms.set.viewportLeft(expandedViewport.left);
        this.vizUniforms.set.viewportTop(expandedViewport.top);
        this.vizUniforms.set.viewportWidth(expandedViewport.width);
        this.vizUniforms.set.viewportHeight(expandedViewport.height);
        this.vizUniforms.uploadTo(this.vizUniformBuffer);
        // Render visualization
        this.vizShader.render(renderPass, this.vizBindGroup);
    }
    onDestroy() {
        this.computeShader?.destroy();
        this.vizShader?.destroy();
        this.computeUniformBuffer?.destroy();
        this.vizUniformBuffer?.destroy();
        this.gradientTexture?.destroy();
    }
    getModeName() {
        return "Terrain Gradient";
    }
    getHudInfo() {
        return "Analytical gradient from contour tree\nHue = downhill direction, Brightness = steepness\nDark = flat, Black = outside terrain";
    }
    getCursorInfo() {
        const mouseWorldPos = this.game.camera.toWorld(this.game.io.mousePosition);
        if (!mouseWorldPos) return null;
        if (this.terrainQuery.length === 0) return null;
        const result = this.terrainQuery.get(0);
        const height = result.height;
        const normal = result.normal;
        const horizontalComponent = Math.hypot(normal.x, normal.y);
        const nz = Math.sqrt(Math.max(0, 1 - horizontalComponent * horizontalComponent));
        const slopeAngleDeg = (0, $2172aedd5a25ff17$export$54390e3b44c4a9cb)(Math.atan2(horizontalComponent, nz));
        const gradePercent = nz > 1e-5 ? horizontalComponent / nz * 100 : Number.POSITIVE_INFINITY;
        const gradeText = Number.isFinite(gradePercent) ? `${gradePercent.toFixed(1)}% grade` : "~vertical";
        if (horizontalComponent < 1e-4) return `Terrain Height: ${height.toFixed(1)} ft\nSteepness: ${slopeAngleDeg.toFixed(1)}\xb0 (${gradeText})\nDownhill: Flat`;
        const downhillAngle = Math.atan2(normal.y, normal.x);
        const downhillCompass = $c586fbebc8a88baa$var$radiansToCompass(downhillAngle);
        const downhillBearingDeg = $c586fbebc8a88baa$var$radiansToCompassBearingDeg(downhillAngle);
        return `Terrain Height: ${height.toFixed(1)} ft\nSteepness: ${slopeAngleDeg.toFixed(1)}\xb0 (${gradeText})\nDownhill: ${downhillCompass} (${downhillBearingDeg.toFixed(0)}\xb0)`;
    }
}
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $aa1f0309d9dba6d2$export$af631764ddc44097)("add")
], $c586fbebc8a88baa$export$45dd5d5affb3f66b.prototype, "onAdd", null);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $aa1f0309d9dba6d2$export$af631764ddc44097)("render")
], $c586fbebc8a88baa$export$45dd5d5affb3f66b.prototype, "onRender", null);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $aa1f0309d9dba6d2$export$af631764ddc44097)("destroy")
], $c586fbebc8a88baa$export$45dd5d5affb3f66b.prototype, "onDestroy", null);


/**
 * Terrain Height Debug Mode
 *
 * Visualizes the terrain height texture computed by SurfaceRenderer.
 * Uses a simple fullscreen shader that samples the pre-computed texture
 * and maps height values to a color gradient:
 * - Deep blue: Deep ocean (< -10ft)
 * - Light blue: Shallow water (-10ft to 0ft)
 * - Green: Low land (0ft to 5ft)
 * - Brown/tan: Higher elevation (> 5ft)
 */ 





/**
 * Surface rendering entity - Multi-pass version.
 *
 * Renders the ocean and terrain using three GPU passes:
 * 1. Terrain Screen (compute) - Sample tile atlas → screen-space terrain height
 * 2. Water Height (compute) - Gerstner waves + modifiers (uses terrain height for refraction/shoaling)
 * 3. Surface Composite (fragment) - Normals + lighting
 *
 * This separation enables:
 * - Per-pass GPU timing for performance diagnosis
 * - Future optimizations (lower resolution, caching, etc.)
 * - Terrain height available to water height shader for refraction and shoaling
 */ 





/**
 * Wave Physics Manager
 *
 * Manages analytical wave physics computation:
 * - Computes terrain bounds for mesh building domain
 * - Coordinates worker-based wavefront mesh building
 * - Provides packed mesh data buffer for GPU shaders
 */ /**
 * CPU-side mesh packing for wavefront mesh query lookup.
 *
 * Packs vertex/index data and a spatial grid index into a single array<u32>
 * buffer for GPU compute shader access. The spatial grid enables efficient
 * triangle lookup via barycentric interpolation.
 *
 * Buffer layout:
 * GLOBAL HEADER (16 u32s):
 *   [0]     numWaveSources
 *   [1..8]  meshOffset[0..7] (absolute u32 offset to each wave's mesh header)
 *   [9..15] padding
 *
 * PER-WAVE MESH HEADER (16 u32s each):
 *   [+0]  vertexOffset      [+1]  vertexCount
 *   [+2]  indexOffset        [+3]  triangleCount
 *   [+4]  gridOffset         [+5]  gridCols
 *   [+6]  gridRows           [+7]  gridMinX (f32)
 *   [+8]  gridMinY (f32)     [+9]  gridCellWidth (f32)
 *   [+10] gridCellHeight (f32) [+11] gridCosA (f32)
 *   [+12] gridSinA (f32)     [+13..15] padding
 *
 * VERTEX DATA (6 f32-as-u32 per vertex, all sources concatenated)
 * INDEX DATA (3 u32 per triangle, all sources concatenated)
 * GRID CELL HEADERS (2 u32 per cell: triListOffset, triListCount)
 * GRID TRIANGLE LISTS (u32 triangle indices, variable length per cell)
 */ 
/**
 * Wavefront Mesh data class.
 *
 * Holds GPU buffers and CPU data for a wavefront mesh built by any builder type.
 * Each mesh represents the propagation of a single wave source through
 * the terrain, with vertices tracking position, amplitude, direction,
 * and phase as the wavefront advances.
 *
 * Vertex layout (6 floats, 24 bytes per vertex):
 * [0] positionX (f32)
 * [1] positionY (f32)
 * [2] amplitudeFactor (f32): 0=blocked, 1=open ocean
 * [3] turbulence (f32): instantaneous energy dissipated by breaking
 * [4] phaseOffset (f32): accumulated phase correction
 * [5] blendWeight (f32): 0=use open ocean defaults, 1=use mesh values
 */ const $507f47de806c09bd$export$7289f13d9ecb686e = 6;
class $507f47de806c09bd$export$e727579f4b184b35 {
    constructor(params){
        this.vertexBuffer = params.vertexBuffer;
        this.indexBuffer = params.indexBuffer;
        this.cpuVertexData = params.cpuVertexData;
        this.cpuIndexData = params.cpuIndexData;
        this.vertexCount = params.vertexCount;
        this.indexCount = params.indexCount;
        this.wavelength = params.wavelength;
        this.waveDirection = params.waveDirection;
        this.builderType = params.builderType;
        this.buildTimeMs = params.buildTimeMs;
        this.coverageQuad = params.coverageQuad;
    }
    /**
   * Create a WavefrontMesh from CPU mesh data by uploading to GPU buffers.
   * Workers produce WavefrontMeshData, main thread calls this to create GPU resources.
   */ static fromMeshData(data, waveSource, builderType, buildTimeMs, device) {
        // Create GPU vertex buffer
        const vertexBuffer = device.createBuffer({
            size: data.vertices.byteLength,
            usage: GPUBufferUsage.STORAGE | GPUBufferUsage.VERTEX | GPUBufferUsage.COPY_SRC | GPUBufferUsage.COPY_DST,
            label: `Wavefront Mesh Vertices (${builderType})`
        });
        device.queue.writeBuffer(vertexBuffer, 0, data.vertices.buffer, data.vertices.byteOffset, data.vertices.byteLength);
        // Create GPU index buffer
        const indexBuffer = device.createBuffer({
            size: data.indices.byteLength,
            usage: GPUBufferUsage.INDEX | GPUBufferUsage.COPY_DST,
            label: `Wavefront Mesh Index Buffer (${builderType})`
        });
        device.queue.writeBuffer(indexBuffer, 0, data.indices.buffer, data.indices.byteOffset, data.indices.byteLength);
        return new $507f47de806c09bd$export$e727579f4b184b35({
            vertexBuffer: vertexBuffer,
            indexBuffer: indexBuffer,
            cpuVertexData: data.vertices,
            cpuIndexData: data.indices,
            vertexCount: data.vertexCount,
            indexCount: data.indexCount,
            wavelength: waveSource.wavelength,
            waveDirection: waveSource.direction,
            builderType: builderType,
            buildTimeMs: buildTimeMs,
            coverageQuad: data.coverageQuad
        });
    }
    /** Destroy GPU buffers */ destroy() {
        this.vertexBuffer.destroy();
        this.indexBuffer.destroy();
    }
}


const $9bee309488e32516$var$GLOBAL_HEADER_U32S = 16;
const $9bee309488e32516$var$MESH_HEADER_U32S = 16;
const $9bee309488e32516$var$MAX_GRID_DIM = 1024;
const $9bee309488e32516$var$ENABLE_MESH_PACKING_LOGS = false;
/** Float bits → u32 for buffer packing */ const $9bee309488e32516$var$f32Buf = new Float32Array(1);
const $9bee309488e32516$var$u32Buf = new Uint32Array($9bee309488e32516$var$f32Buf.buffer);
function $9bee309488e32516$var$floatToU32(f) {
    $9bee309488e32516$var$f32Buf[0] = f;
    return $9bee309488e32516$var$u32Buf[0];
}
/**
 * Build a spatial grid index for a single mesh.
 * The grid is built in wave-aligned (rotated) space for tighter packing.
 */ function $9bee309488e32516$var$buildSpatialGrid(mesh) {
    const verts = mesh.cpuVertexData;
    const indices = mesh.cpuIndexData;
    const triCount = mesh.indexCount / 3;
    // Rotation to wave-aligned space
    const cosA = Math.cos(mesh.waveDirection);
    const sinA = Math.sin(mesh.waveDirection);
    // Compute AABB in rotated space
    let minX = Infinity, minY = Infinity, maxX = -Infinity, maxY = -Infinity;
    for(let v = 0; v < mesh.vertexCount; v++){
        const wx = verts[v * (0, $507f47de806c09bd$export$7289f13d9ecb686e)];
        const wy = verts[v * (0, $507f47de806c09bd$export$7289f13d9ecb686e) + 1];
        const rx = wx * cosA + wy * sinA;
        const ry = -wx * sinA + wy * cosA;
        minX = Math.min(minX, rx);
        minY = Math.min(minY, ry);
        maxX = Math.max(maxX, rx);
        maxY = Math.max(maxY, ry);
    }
    // Add margin
    const margin = 10;
    minX -= margin;
    minY -= margin;
    maxX += margin;
    maxY += margin;
    const width = maxX - minX;
    const height = maxY - minY;
    // Compute average triangle x/y extents for aspect ratio
    let totalXExtent = 0;
    let totalYExtent = 0;
    for(let t = 0; t < triCount; t++){
        const i0 = indices[t * 3];
        const i1 = indices[t * 3 + 1];
        const i2 = indices[t * 3 + 2];
        const rx0 = verts[i0 * (0, $507f47de806c09bd$export$7289f13d9ecb686e)] * cosA + verts[i0 * (0, $507f47de806c09bd$export$7289f13d9ecb686e) + 1] * sinA;
        const ry0 = -verts[i0 * (0, $507f47de806c09bd$export$7289f13d9ecb686e)] * sinA + verts[i0 * (0, $507f47de806c09bd$export$7289f13d9ecb686e) + 1] * cosA;
        const rx1 = verts[i1 * (0, $507f47de806c09bd$export$7289f13d9ecb686e)] * cosA + verts[i1 * (0, $507f47de806c09bd$export$7289f13d9ecb686e) + 1] * sinA;
        const ry1 = -verts[i1 * (0, $507f47de806c09bd$export$7289f13d9ecb686e)] * sinA + verts[i1 * (0, $507f47de806c09bd$export$7289f13d9ecb686e) + 1] * cosA;
        const rx2 = verts[i2 * (0, $507f47de806c09bd$export$7289f13d9ecb686e)] * cosA + verts[i2 * (0, $507f47de806c09bd$export$7289f13d9ecb686e) + 1] * sinA;
        const ry2 = -verts[i2 * (0, $507f47de806c09bd$export$7289f13d9ecb686e)] * sinA + verts[i2 * (0, $507f47de806c09bd$export$7289f13d9ecb686e) + 1] * cosA;
        totalXExtent += Math.max(rx0, rx1, rx2) - Math.min(rx0, rx1, rx2);
        totalYExtent += Math.max(ry0, ry1, ry2) - Math.min(ry0, ry1, ry2);
    }
    const avgXExtent = totalXExtent / triCount;
    const avgYExtent = totalYExtent / triCount;
    // Rectangular cells sized to triangle density with matching aspect ratio.
    // Dividing area by 4 halves the linear cell dimensions for finer resolution.
    const meshArea = width * height;
    const targetCellArea = meshArea / triCount / 4;
    const aspect = avgXExtent / Math.max(avgYExtent, 1e-10);
    let cellWidth = Math.sqrt(targetCellArea * aspect);
    let cellHeight = Math.sqrt(targetCellArea / aspect);
    // Clamp each dimension to MAX_GRID_DIM independently
    cellWidth = Math.max(cellWidth, width / $9bee309488e32516$var$MAX_GRID_DIM);
    cellHeight = Math.max(cellHeight, height / $9bee309488e32516$var$MAX_GRID_DIM);
    const cols = Math.max(1, Math.ceil(width / cellWidth));
    const rows = Math.max(1, Math.ceil(height / cellHeight));
    // Build cell → triangle mappings using rotated coordinates
    const cellTriLists = [];
    for(let i = 0; i < cols * rows; i++)cellTriLists.push([]);
    const invCellWidth = 1 / cellWidth;
    const invCellHeight = 1 / cellHeight;
    for(let t = 0; t < triCount; t++){
        const i0 = indices[t * 3];
        const i1 = indices[t * 3 + 1];
        const i2 = indices[t * 3 + 2];
        // Rotated vertices — sort by y (ascending) for scanline rasterization
        let sx0 = verts[i0 * (0, $507f47de806c09bd$export$7289f13d9ecb686e)] * cosA + verts[i0 * (0, $507f47de806c09bd$export$7289f13d9ecb686e) + 1] * sinA;
        let sy0 = -verts[i0 * (0, $507f47de806c09bd$export$7289f13d9ecb686e)] * sinA + verts[i0 * (0, $507f47de806c09bd$export$7289f13d9ecb686e) + 1] * cosA;
        let sx1 = verts[i1 * (0, $507f47de806c09bd$export$7289f13d9ecb686e)] * cosA + verts[i1 * (0, $507f47de806c09bd$export$7289f13d9ecb686e) + 1] * sinA;
        let sy1 = -verts[i1 * (0, $507f47de806c09bd$export$7289f13d9ecb686e)] * sinA + verts[i1 * (0, $507f47de806c09bd$export$7289f13d9ecb686e) + 1] * cosA;
        let sx2 = verts[i2 * (0, $507f47de806c09bd$export$7289f13d9ecb686e)] * cosA + verts[i2 * (0, $507f47de806c09bd$export$7289f13d9ecb686e) + 1] * sinA;
        let sy2 = -verts[i2 * (0, $507f47de806c09bd$export$7289f13d9ecb686e)] * sinA + verts[i2 * (0, $507f47de806c09bd$export$7289f13d9ecb686e) + 1] * cosA;
        // Sort by y: sy0 <= sy1 <= sy2
        let tmp;
        if (sy0 > sy1) {
            tmp = sx0;
            sx0 = sx1;
            sx1 = tmp;
            tmp = sy0;
            sy0 = sy1;
            sy1 = tmp;
        }
        if (sy1 > sy2) {
            tmp = sx1;
            sx1 = sx2;
            sx2 = tmp;
            tmp = sy1;
            sy1 = sy2;
            sy2 = tmp;
        }
        if (sy0 > sy1) {
            tmp = sx0;
            sx0 = sx1;
            sx1 = tmp;
            tmp = sy0;
            sy0 = sy1;
            sy1 = tmp;
        }
        // Skip degenerate triangles
        const dy02 = sy2 - sy0;
        if (dy02 < 1e-10) continue;
        const dy01 = sy1 - sy0;
        const dy12 = sy2 - sy1;
        const dx02 = sx2 - sx0;
        const dx01 = sx1 - sx0;
        const dx12 = sx2 - sx1;
        const invDy02 = 1 / dy02;
        const invDy01 = dy01 > 1e-10 ? 1 / dy01 : 0;
        const invDy12 = dy12 > 1e-10 ? 1 / dy12 : 0;
        // Scanline: for each grid row the triangle spans, compute the x range
        const rStart = Math.max(0, Math.floor((sy0 - minY) * invCellHeight));
        const rEnd = Math.min(rows - 1, Math.floor((sy2 - minY) * invCellHeight));
        for(let r = rStart; r <= rEnd; r++){
            const yTop = minY + r * cellHeight;
            const yBot = yTop + cellHeight;
            const yLo = Math.max(yTop, sy0);
            const yHi = Math.min(yBot, sy2);
            // x along the long edge (v0→v2) at yLo and yHi
            let xMin = sx0 + (yLo - sy0) * invDy02 * dx02;
            let xMax = xMin;
            const xLong_hi = sx0 + (yHi - sy0) * invDy02 * dx02;
            if (xLong_hi < xMin) xMin = xLong_hi;
            if (xLong_hi > xMax) xMax = xLong_hi;
            // x along the short edge(s)
            if (yLo < sy1 && invDy01 !== 0) {
                const xShort = sx0 + (yLo - sy0) * invDy01 * dx01;
                if (xShort < xMin) xMin = xShort;
                if (xShort > xMax) xMax = xShort;
                const yEnd = Math.min(yHi, sy1);
                const xShortEnd = sx0 + (yEnd - sy0) * invDy01 * dx01;
                if (xShortEnd < xMin) xMin = xShortEnd;
                if (xShortEnd > xMax) xMax = xShortEnd;
            }
            if (yHi > sy1 && invDy12 !== 0) {
                const yStart = Math.max(yLo, sy1);
                const xShort = sx1 + (yStart - sy1) * invDy12 * dx12;
                if (xShort < xMin) xMin = xShort;
                if (xShort > xMax) xMax = xShort;
                const xShortEnd = sx1 + (yHi - sy1) * invDy12 * dx12;
                if (xShortEnd < xMin) xMin = xShortEnd;
                if (xShortEnd > xMax) xMax = xShortEnd;
            }
            // Include v1 if it falls in this row
            if (sy1 >= yTop && sy1 <= yBot) {
                if (sx1 < xMin) xMin = sx1;
                if (sx1 > xMax) xMax = sx1;
            }
            const cStart = Math.max(0, Math.floor((xMin - minX) * invCellWidth));
            const cEnd = Math.min(cols - 1, Math.floor((xMax - minX) * invCellWidth));
            for(let c = cStart; c <= cEnd; c++)cellTriLists[r * cols + c].push(t);
        }
    }
    // Convert to Uint32Arrays
    const cells = cellTriLists.map((list)=>new Uint32Array(list));
    const grid = {
        cells: cells,
        cols: cols,
        rows: rows,
        minX: minX,
        minY: minY,
        cellWidth: cellWidth,
        cellHeight: cellHeight,
        cosA: cosA,
        sinA: sinA
    };
    if ($9bee309488e32516$var$ENABLE_MESH_PACKING_LOGS) $9bee309488e32516$var$logGridStats(mesh, grid);
    return grid;
}
function $9bee309488e32516$export$f4d03863b4af6c39(device, meshes) {
    const numWaves = Math.min(meshes.length, (0, $302274bc574a4592$export$3ff414ae503bfcf8));
    // Build spatial grids for each mesh
    const grids = [];
    for(let i = 0; i < numWaves; i++)grids.push($9bee309488e32516$var$buildSpatialGrid(meshes[i]));
    // Calculate total buffer size
    let totalU32s = $9bee309488e32516$var$GLOBAL_HEADER_U32S;
    totalU32s += numWaves * $9bee309488e32516$var$MESH_HEADER_U32S;
    // Vertex data
    let totalVertexU32s = 0;
    for(let i = 0; i < numWaves; i++)totalVertexU32s += meshes[i].vertexCount * (0, $507f47de806c09bd$export$7289f13d9ecb686e);
    totalU32s += totalVertexU32s;
    // Index data
    let totalIndexU32s = 0;
    for(let i = 0; i < numWaves; i++)totalIndexU32s += meshes[i].indexCount;
    totalU32s += totalIndexU32s;
    // Grid cell headers + triangle lists
    let totalGridHeaderU32s = 0;
    let totalGridListU32s = 0;
    for (const grid of grids){
        totalGridHeaderU32s += grid.cols * grid.rows * 2;
        for (const cell of grid.cells)totalGridListU32s += cell.length;
    }
    totalU32s += totalGridHeaderU32s + totalGridListU32s;
    // Allocate buffer
    const data = new ArrayBuffer(totalU32s * 4);
    const u32View = new Uint32Array(data);
    const f32View = new Float32Array(data);
    // Write global header
    u32View[0] = numWaves;
    // Calculate offsets
    const headersStart = $9bee309488e32516$var$GLOBAL_HEADER_U32S;
    let vertexStart = headersStart + numWaves * $9bee309488e32516$var$MESH_HEADER_U32S;
    let indexStart = vertexStart + totalVertexU32s;
    let gridHeaderStart = indexStart + totalIndexU32s;
    let gridListStart = gridHeaderStart + totalGridHeaderU32s;
    let currentVertexOffset = vertexStart;
    let currentIndexOffset = indexStart;
    let currentGridHeaderOffset = gridHeaderStart;
    let currentGridListOffset = gridListStart;
    for(let w = 0; w < numWaves; w++){
        const mesh = meshes[w];
        const grid = grids[w];
        const headerOffset = headersStart + w * $9bee309488e32516$var$MESH_HEADER_U32S;
        // Write mesh offset to global header
        u32View[1 + w] = headerOffset;
        // Write per-wave mesh header
        u32View[headerOffset + 0] = currentVertexOffset;
        u32View[headerOffset + 1] = mesh.vertexCount;
        u32View[headerOffset + 2] = currentIndexOffset;
        u32View[headerOffset + 3] = mesh.indexCount / 3;
        u32View[headerOffset + 4] = currentGridHeaderOffset;
        u32View[headerOffset + 5] = grid.cols;
        u32View[headerOffset + 6] = grid.rows;
        u32View[headerOffset + 7] = $9bee309488e32516$var$floatToU32(grid.minX);
        u32View[headerOffset + 8] = $9bee309488e32516$var$floatToU32(grid.minY);
        u32View[headerOffset + 9] = $9bee309488e32516$var$floatToU32(grid.cellWidth);
        u32View[headerOffset + 10] = $9bee309488e32516$var$floatToU32(grid.cellHeight);
        u32View[headerOffset + 11] = $9bee309488e32516$var$floatToU32(grid.cosA);
        u32View[headerOffset + 12] = $9bee309488e32516$var$floatToU32(grid.sinA);
        // Write vertex data (6 floats per vertex, stored as u32 via shared buffer)
        for(let v = 0; v < mesh.vertexCount * (0, $507f47de806c09bd$export$7289f13d9ecb686e); v++)f32View[currentVertexOffset + v] = mesh.cpuVertexData[v];
        currentVertexOffset += mesh.vertexCount * (0, $507f47de806c09bd$export$7289f13d9ecb686e);
        // Write index data
        for(let idx = 0; idx < mesh.indexCount; idx++)u32View[currentIndexOffset + idx] = mesh.cpuIndexData[idx];
        currentIndexOffset += mesh.indexCount;
        // Write grid cell headers and triangle lists
        const numCells = grid.cols * grid.rows;
        for(let c = 0; c < numCells; c++){
            const cell = grid.cells[c];
            u32View[currentGridHeaderOffset + c * 2] = currentGridListOffset;
            u32View[currentGridHeaderOffset + c * 2 + 1] = cell.length;
            for(let t = 0; t < cell.length; t++)u32View[currentGridListOffset + t] = cell[t];
            currentGridListOffset += cell.length;
        }
        currentGridHeaderOffset += numCells * 2;
    }
    // Pad remaining global header slots
    for(let i = numWaves; i < (0, $302274bc574a4592$export$3ff414ae503bfcf8); i++)u32View[1 + i] = 0;
    if ($9bee309488e32516$var$ENABLE_MESH_PACKING_LOGS) $9bee309488e32516$var$logBufferStats(numWaves, totalU32s, totalVertexU32s, totalIndexU32s, totalGridHeaderU32s, totalGridListU32s);
    // Create GPU buffer
    const buffer = device.createBuffer({
        size: Math.max(data.byteLength, 64),
        usage: GPUBufferUsage.STORAGE | GPUBufferUsage.COPY_DST,
        label: "Packed Wavefront Mesh Buffer"
    });
    device.queue.writeBuffer(buffer, 0, data);
    return buffer;
}
// ---------------------------------------------------------------------------
// Diagnostic logging
// ---------------------------------------------------------------------------
function $9bee309488e32516$var$logGridStats(mesh, grid) {
    const { cells: cells, cols: cols, rows: rows, minX: minX, minY: minY, cellWidth: cellWidth, cellHeight: cellHeight, cosA: cosA, sinA: sinA } = grid;
    const triCount = mesh.indexCount / 3;
    const verts = mesh.cpuVertexData;
    const indices = mesh.cpuIndexData;
    const totalCells = cols * rows;
    // Basic cell stats
    let totalRefs = 0;
    let maxTrisInCell = 0;
    let nonEmptyCells = 0;
    for (const cell of cells){
        totalRefs += cell.length;
        if (cell.length > 0) nonEmptyCells++;
        maxTrisInCell = Math.max(maxTrisInCell, cell.length);
    }
    const avgPerCell = nonEmptyCells > 0 ? totalRefs / nonEmptyCells : 0;
    // Histogram of per-cell triangle counts
    const buckets = [
        0,
        5,
        10,
        20,
        50,
        100,
        Infinity
    ];
    const histogram = new Map();
    for (const cell of cells){
        const bucket = buckets.find((b)=>cell.length <= b) ?? Infinity;
        histogram.set(bucket, (histogram.get(bucket) ?? 0) + 1);
    }
    // Measure actual point-in-triangle overlap by sampling each cell's center
    let maxActualOverlap = 0;
    let totalActualOverlap = 0;
    let sampledCells = 0;
    for(let r = 0; r < rows; r++)for(let c = 0; c < cols; c++){
        const cell = cells[r * cols + c];
        if (cell.length === 0) continue;
        // Cell center in rotated space → world space
        const cxRot = minX + (c + 0.5) * cellWidth;
        const cyRot = minY + (r + 0.5) * cellHeight;
        const px = cxRot * cosA - cyRot * sinA;
        const py = cxRot * sinA + cyRot * cosA;
        let actual = 0;
        for(let ti = 0; ti < cell.length; ti++){
            const t = cell[ti];
            const ax = verts[indices[t * 3] * (0, $507f47de806c09bd$export$7289f13d9ecb686e)];
            const ay = verts[indices[t * 3] * (0, $507f47de806c09bd$export$7289f13d9ecb686e) + 1];
            const bx = verts[indices[t * 3 + 1] * (0, $507f47de806c09bd$export$7289f13d9ecb686e)];
            const by = verts[indices[t * 3 + 1] * (0, $507f47de806c09bd$export$7289f13d9ecb686e) + 1];
            const cx = verts[indices[t * 3 + 2] * (0, $507f47de806c09bd$export$7289f13d9ecb686e)];
            const cy = verts[indices[t * 3 + 2] * (0, $507f47de806c09bd$export$7289f13d9ecb686e) + 1];
            const v0x = bx - ax, v0y = by - ay;
            const v1x = cx - ax, v1y = cy - ay;
            const v2x = px - ax, v2y = py - ay;
            const d00 = v0x * v0x + v0y * v0y;
            const d01 = v0x * v1x + v0y * v1y;
            const d11 = v1x * v1x + v1y * v1y;
            const d20 = v2x * v0x + v2y * v0y;
            const d21 = v2x * v1x + v2y * v1y;
            const denom = d00 * d11 - d01 * d01;
            if (Math.abs(denom) < 1e-10) continue;
            const inv = 1 / denom;
            const u = (d11 * d20 - d01 * d21) * inv;
            const w = (d00 * d21 - d01 * d20) * inv;
            if (u >= -0.001 && w >= -0.001 && 1 - u - w >= -0.001) actual++;
        }
        maxActualOverlap = Math.max(maxActualOverlap, actual);
        totalActualOverlap += actual;
        sampledCells++;
    }
    const avgActualOverlap = sampledCells > 0 ? totalActualOverlap / sampledCells : 0;
    const gridMemoryKB = (totalCells * 2 + totalRefs) * 4 / 1024;
    console.log(`[MeshPacking] Spatial grid for wave ${mesh.vertexCount} verts, ${triCount} tris:` + `\n  Grid: ${cols}\xd7${rows} = ${totalCells} cells, cellSize=${cellWidth.toFixed(1)}\xd7${cellHeight.toFixed(1)}` + `\n  Non-empty cells: ${nonEmptyCells}/${totalCells} (${(nonEmptyCells / totalCells * 100).toFixed(0)}%)` + `\n  Triangle refs: ${totalRefs} (${(totalRefs / triCount).toFixed(1)}\xd7 expansion from ${triCount} tris)` + `\n  Per non-empty cell: avg=${avgPerCell.toFixed(1)}, max=${maxTrisInCell}` + `\n  Actual overlap (cell center sample): avg=${avgActualOverlap.toFixed(1)}, max=${maxActualOverlap}` + `\n  Histogram: ${[
        ...histogram.entries()
    ].sort((a, b)=>a[0] - b[0]).map(([k, v])=>`\u{2264}${k === Infinity ? "\u221E" : k}:${v}`).join(", ")}` + `\n  Grid memory: ${gridMemoryKB.toFixed(1)} KB`);
}
function $9bee309488e32516$var$logBufferStats(numWaves, totalU32s, vertexU32s, indexU32s, gridHeaderU32s, gridListU32s) {
    const pct = (n)=>(n / totalU32s * 100).toFixed(0);
    console.log(`[MeshPacking] Packed mesh buffer: ${numWaves} wave(s), ${(totalU32s * 4 / 1024).toFixed(1)} KB` + `\n  Vertices: ${pct(vertexU32s)}%, Indices: ${pct(indexU32s)}%` + `\n  Grid headers: ${pct(gridHeaderU32s)}%, Grid lists: ${pct(gridListU32s)}%`);
}
function $9bee309488e32516$export$850e8c442d1d26f2(device) {
    const buffer = device.createBuffer({
        size: 64,
        usage: GPUBufferUsage.STORAGE | GPUBufferUsage.COPY_DST,
        label: "Placeholder Packed Mesh Buffer"
    });
    const data = new Uint32Array($9bee309488e32516$var$GLOBAL_HEADER_U32S);
    data[0] = 0; // numWaveSources = 0
    device.queue.writeBuffer(buffer, 0, data);
    return buffer;
}



/**
 * Wavefront Mesh Rasterizer
 *
 * Rasterizes wavefront meshes to a screen-space rgba16float 2D texture array.
 * Each layer corresponds to one wave source. The water height shader samples
 * this texture to get per-wave amplitude, direction offset, and phase correction
 * instead of computing shadow/refraction/terrain-factor per pixel.
 *
 * Fragment output: vec4(phasorCos, phasorSin, 0, turbulence)
 * Clear color: (0, 0, 0, 0) = shadow zone (zero amplitude)
 * Skirt geometry extends the mesh far beyond the domain, so uncovered pixels
 * are always shadow zones behind terrain, never open ocean.
 * RGB channels use additive blending to accumulate phasor contributions.
 * Alpha channel uses max blending to preserve peak breaking intensity.
 */ 

const $0c25aba216a5fdb2$var$RasterizerUniforms = (0, $ca6793d1abd58997$export$99bb2281c7368d10)("RasterizerParams", {
    // World → clip for the target texture (screen-aligned, rotation-aware).
    worldToTexClip: (0, $ca6793d1abd58997$export$a9b01fc77c97438b)
});
const $0c25aba216a5fdb2$var$SHADER_CODE = /*wgsl*/ `
struct RasterizerParams {
  worldToTexClip: mat3x3<f32>,
}

@group(0) @binding(0) var<uniform> params: RasterizerParams;

struct VertexInput {
  @location(0) position: vec2<f32>,
  @location(1) amplitudeFactor: f32,
  @location(2) turbulence: f32,
  @location(3) phaseOffset: f32,
  @location(4) blendWeight: f32,
}

struct VertexOutput {
  @builtin(position) position: vec4<f32>,
  @location(0) amplitudeFactor: f32,
  @location(1) turbulence: f32,
  @location(2) phaseOffset: f32,
  @location(3) blendWeight: f32,
}

@vertex
fn vs_main(in: VertexInput) -> VertexOutput {
  // World position \u{2192} texture clip (screen-aligned, rotation-aware)
  let clip = (params.worldToTexClip * vec3<f32>(in.position, 1.0)).xy;

  var out: VertexOutput;
  out.position = vec4<f32>(clip, 0.0, 1.0);
  out.amplitudeFactor = in.amplitudeFactor;
  out.turbulence = in.turbulence;
  out.phaseOffset = in.phaseOffset;
  out.blendWeight = in.blendWeight;
  return out;
}

@fragment
fn fs_main(in: VertexOutput) -> @location(0) vec4<f32> {
  let pc = in.amplitudeFactor * cos(in.phaseOffset);
  let ps = in.amplitudeFactor * sin(in.phaseOffset);
  return vec4<f32>(pc, ps, 0.0, in.turbulence);
}
`;
class $0c25aba216a5fdb2$export$be0b0bd298a3e1df {
    constructor(device){
        this.pipeline = null;
        this.uniformBuffer = null;
        this.uniforms = $0c25aba216a5fdb2$var$RasterizerUniforms.create();
        this.bindGroupLayout = null;
        this.bindGroup = null;
        this.coverageQuadVertexBuffer = null;
        this.coverageQuadIndexBuffer = null;
        this.coverageQuadVertices = new Float32Array(24);
        this.initialized = false;
        this.device = device;
    }
    async init() {
        if (this.initialized) return;
        const device = this.device;
        const shaderModule = device.createShaderModule({
            code: $0c25aba216a5fdb2$var$SHADER_CODE,
            label: "Wavefront Rasterizer Shader"
        });
        await (0, $558c2f47f1fdd57f$export$bdd7f96686113d46)(shaderModule, $0c25aba216a5fdb2$var$SHADER_CODE, "Wavefront Rasterizer Shader");
        this.bindGroupLayout = device.createBindGroupLayout({
            entries: [
                {
                    binding: 0,
                    visibility: GPUShaderStage.VERTEX,
                    buffer: {
                        type: "uniform"
                    }
                }
            ],
            label: "Wavefront Rasterizer Bind Group Layout"
        });
        const pipelineLayout = device.createPipelineLayout({
            bindGroupLayouts: [
                this.bindGroupLayout
            ],
            label: "Wavefront Rasterizer Pipeline Layout"
        });
        this.pipeline = device.createRenderPipeline({
            layout: pipelineLayout,
            vertex: {
                module: shaderModule,
                entryPoint: "vs_main",
                buffers: [
                    {
                        arrayStride: 24,
                        attributes: [
                            {
                                format: "float32x2",
                                offset: 0,
                                shaderLocation: 0
                            },
                            {
                                format: "float32",
                                offset: 8,
                                shaderLocation: 1
                            },
                            {
                                format: "float32",
                                offset: 12,
                                shaderLocation: 2
                            },
                            {
                                format: "float32",
                                offset: 16,
                                shaderLocation: 3
                            },
                            {
                                format: "float32",
                                offset: 20,
                                shaderLocation: 4
                            }
                        ]
                    }
                ]
            },
            fragment: {
                module: shaderModule,
                entryPoint: "fs_main",
                targets: [
                    {
                        format: "rgba16float",
                        blend: {
                            color: {
                                srcFactor: "one",
                                dstFactor: "one",
                                operation: "add"
                            },
                            alpha: {
                                srcFactor: "one",
                                dstFactor: "one",
                                operation: "max"
                            }
                        }
                    }
                ]
            },
            primitive: {
                topology: "triangle-list"
            },
            label: "Wavefront Rasterizer Pipeline"
        });
        this.uniformBuffer = device.createBuffer({
            size: $0c25aba216a5fdb2$var$RasterizerUniforms.byteSize,
            usage: GPUBufferUsage.UNIFORM | GPUBufferUsage.COPY_DST,
            label: "Wavefront Rasterizer Uniforms"
        });
        this.bindGroup = device.createBindGroup({
            layout: this.bindGroupLayout,
            entries: [
                {
                    binding: 0,
                    resource: {
                        buffer: this.uniformBuffer
                    }
                }
            ],
            label: "Wavefront Rasterizer Bind Group"
        });
        // Coverage quad buffers for shadow zone marking
        this.coverageQuadVertexBuffer = device.createBuffer({
            size: 96,
            usage: GPUBufferUsage.VERTEX | GPUBufferUsage.COPY_DST,
            label: "Coverage Quad Vertex Buffer"
        });
        const quadIndices = new Uint32Array([
            0,
            1,
            2,
            0,
            2,
            3
        ]);
        this.coverageQuadIndexBuffer = device.createBuffer({
            size: quadIndices.byteLength,
            usage: GPUBufferUsage.INDEX | GPUBufferUsage.COPY_DST,
            label: "Coverage Quad Index Buffer"
        });
        device.queue.writeBuffer(this.coverageQuadIndexBuffer, 0, quadIndices);
        this.initialized = true;
    }
    /**
   * Render wavefront meshes to the wave field texture array.
   * One render pass per wave source, targeting that source's layer.
   *
   * @param encoder - Command encoder to record into
   * @param meshes - One mesh per wave source
   * @param worldToTexClip - World → texture clip transform (screen-aligned)
   * @param texture - Target rgba16float 2D array texture
   */ render(encoder, meshes, worldToTexClip, texture, gpuProfiler) {
        if (!this.initialized || !this.pipeline || !this.bindGroup || !this.uniformBuffer) return;
        // Update transform uniform
        this.uniforms.set.worldToTexClip(worldToTexClip);
        this.uniforms.uploadTo(this.uniformBuffer);
        // Find first and last non-empty mesh indices for GPU profiling
        let firstMeshIdx = -1;
        let lastMeshIdx = -1;
        for(let i = 0; i < meshes.length; i++)if (meshes[i].indexCount > 0) {
            if (firstMeshIdx === -1) firstMeshIdx = i;
            lastMeshIdx = i;
        }
        // Render each wave source to its layer
        for(let i = 0; i < meshes.length; i++){
            const mesh = meshes[i];
            if (mesh.indexCount === 0) continue;
            // Attach begin timestamp to first pass, end timestamp to last pass
            let timestampWrites;
            if (i === firstMeshIdx && i === lastMeshIdx) timestampWrites = gpuProfiler?.getTimestampWrites("surface.rasterize");
            else if (i === firstMeshIdx) timestampWrites = gpuProfiler?.getTimestampWritesBegin("surface.rasterize");
            else if (i === lastMeshIdx) timestampWrites = gpuProfiler?.getTimestampWritesEnd("surface.rasterize");
            const layerView = texture.createView({
                dimension: "2d",
                baseArrayLayer: i,
                arrayLayerCount: 1,
                label: `Wave Field Layer ${i}`
            });
            const renderPass = encoder.beginRenderPass({
                colorAttachments: [
                    {
                        view: layerView,
                        clearValue: {
                            r: 0.0,
                            g: 0.0,
                            b: 0.0,
                            a: 0.0
                        },
                        loadOp: "clear",
                        storeOp: "store"
                    }
                ],
                timestampWrites: timestampWrites,
                label: `Wavefront Rasterize Wave ${i}`
            });
            renderPass.setPipeline(this.pipeline);
            renderPass.setBindGroup(0, this.bindGroup);
            // Draw mesh triangles — additive blending accumulates phasors.
            // Skirt geometry extends beyond the domain, so uncovered pixels (clear
            // color 0,0,0,0) are either shadow zones or unreachable far-field.
            renderPass.setVertexBuffer(0, mesh.vertexBuffer);
            renderPass.setIndexBuffer(mesh.indexBuffer, "uint32");
            renderPass.drawIndexed(mesh.indexCount);
            renderPass.end();
        }
        // Clear remaining layers that don't have meshes
        const totalLayers = texture.depthOrArrayLayers;
        for(let i = meshes.length; i < totalLayers; i++){
            const layerView = texture.createView({
                dimension: "2d",
                baseArrayLayer: i,
                arrayLayerCount: 1,
                label: `Wave Field Layer ${i} (empty)`
            });
            const renderPass = encoder.beginRenderPass({
                colorAttachments: [
                    {
                        view: layerView,
                        clearValue: {
                            r: 0.0,
                            g: 0.0,
                            b: 0.0,
                            a: 0.0
                        },
                        loadOp: "clear",
                        storeOp: "store"
                    }
                ],
                label: `Wavefront Clear Layer ${i}`
            });
            renderPass.end();
        }
    }
    destroy() {
        this.uniformBuffer?.destroy();
        this.coverageQuadVertexBuffer?.destroy();
        this.coverageQuadIndexBuffer?.destroy();
        this.uniformBuffer = null;
        this.coverageQuadVertexBuffer = null;
        this.coverageQuadIndexBuffer = null;
        this.pipeline = null;
        this.bindGroup = null;
        this.bindGroupLayout = null;
        this.initialized = false;
    }
}


const $302274bc574a4592$export$3ff414ae503bfcf8 = 8;
class $302274bc574a4592$export$2a398387dc2bea92 {
    /**
   * Create a WavePhysicsManager.
   * @param device - GPU device for creating GPU resources
   * @param waveSources - Wave source configurations
   */ constructor(device, waveSources = []){
        /** Wavefront meshes organized by builder type */ this.meshSets = new Map();
        /** Currently selected builder type for rendering/queries */ this.activeBuilderType = "marching";
        /** Packed mesh buffer for query shader lookup */ this.packedMeshBuffer = null;
        /** Whether the manager has been initialized with terrain */ this.initialized = false;
        this.device = device;
        this.waveSources = waveSources;
        this.rasterizer = new (0, $0c25aba216a5fdb2$export$be0b0bd298a3e1df)(this.device);
    }
    /**
   * Initialize the wave physics manager with prebuilt mesh data.
   *
   * @param prebuiltMeshData - Prebuilt mesh data from .wavemesh file (one per wave source)
   */ async initialize(prebuiltMeshData) {
        // Initialize rasterizer
        await this.rasterizer.init();
        if (prebuiltMeshData) {
            const meshes = prebuiltMeshData.map((data, i)=>(0, $507f47de806c09bd$export$e727579f4b184b35).fromMeshData(data, this.waveSources[i], "marching", 0, this.device));
            this.meshSets.set("marching", meshes);
            console.log(`[WavePhysics] Loaded prebuilt mesh data (${meshes.length} meshes)`);
        } else console.warn("[WavePhysics] No prebuilt mesh data provided \u2014 wave physics will be inactive");
        // Build packed mesh buffer for query shader
        this.rebuildPackedMeshBuffer();
        this.initialized = true;
    }
    /**
   * Check if the manager is initialized.
   */ isInitialized() {
        return this.initialized;
    }
    /**
   * Get meshes for a specific builder type, or the first available type.
   */ getMeshes(builderType) {
        if (builderType) return this.meshSets.get(builderType) ?? [];
        // Return first available
        for (const meshes of this.meshSets.values()){
            if (meshes.length > 0) return meshes;
        }
        return [];
    }
    /**
   * Get all mesh sets organized by builder type.
   */ getMeshSets() {
        return this.meshSets;
    }
    /**
   * Get list of builder types that have meshes.
   */ getActiveBuilderTypes() {
        return [
            ...this.meshSets.keys()
        ].filter((type)=>(this.meshSets.get(type)?.length ?? 0) > 0);
    }
    /**
   * Get wavefront mesh for a specific wave source index.
   */ getMeshForWave(index, builderType) {
        return this.getMeshes(builderType)[index];
    }
    /**
   * Get the packed mesh buffer for query shader binding.
   */ getPackedMeshBuffer() {
        return this.packedMeshBuffer;
    }
    /**
   * Get the rasterizer for rendering meshes to screen-space texture.
   */ getRasterizer() {
        return this.rasterizer;
    }
    /**
   * Get the currently active builder type.
   */ getActiveBuilderType() {
        return this.activeBuilderType;
    }
    /**
   * Set the active builder type and rebuild packed mesh buffer.
   */ setActiveBuilderType(type) {
        if (this.activeBuilderType === type) return;
        this.activeBuilderType = type;
        this.rebuildPackedMeshBuffer();
    }
    /**
   * Get meshes for the currently active builder type.
   */ getActiveMeshes() {
        return this.getMeshes(this.activeBuilderType);
    }
    /**
   * Rebuild the packed mesh buffer from the active builder type's meshes.
   */ rebuildPackedMeshBuffer() {
        this.packedMeshBuffer?.destroy();
        const meshes = this.getActiveMeshes();
        if (meshes.length > 0) this.packedMeshBuffer = (0, $9bee309488e32516$export$f4d03863b4af6c39)(this.device, meshes);
        else this.packedMeshBuffer = (0, $9bee309488e32516$export$850e8c442d1d26f2)(this.device);
    }
    /**
   * Clean up GPU resources.
   */ destroy() {
        this.destroyResources();
        this.rasterizer.destroy();
    }
    destroyResources() {
        this.packedMeshBuffer?.destroy();
        this.packedMeshBuffer = null;
        for (const meshes of this.meshSets.values())for (const mesh of meshes)mesh.destroy();
        this.meshSets = new Map();
        this.initialized = false;
    }
}


/**
 * Wave Physics Resources
 *
 * Singleton entity that owns and manages the WavePhysicsManager for analytical
 * wave-terrain interaction via wavefront meshes.
 *
 * Responsibilities:
 * - Initialize WavePhysicsManager with terrain data
 * - Provide access to packed mesh buffer for GPU shaders
 */ 




class $ffbca396848d8854$export$8b9e0edba56abb99 extends (0, $c59361981bac2575$export$4342ba5c6ad1f6f1) {
    constructor(waveConfig, prebuiltMeshData){
        super(), this.id = "wavePhysicsResources", this.wavePhysicsManager = null, this.initPromise = null;
        this.waveConfig = waveConfig ?? (0, $2f4d0b169c8eccfe$export$483d573411d408a4);
        this.prebuiltMeshData = prebuiltMeshData;
    }
    onAfterAdded() {
        const device = this.game.getWebGPUDevice();
        this.wavePhysicsManager = new (0, $302274bc574a4592$export$2a398387dc2bea92)(device, this.waveConfig.sources);
        this.initPromise = this.wavePhysicsManager.initialize(this.prebuiltMeshData);
    }
    /**
   * Returns a promise that resolves when wave mesh building is complete.
   */ whenReady() {
        return this.initPromise ?? Promise.resolve();
    }
    /**
   * Get the WavePhysicsManager instance.
   */ getWavePhysicsManager() {
        return this.wavePhysicsManager;
    }
    /**
   * Get the packed mesh buffer for binding in query shaders.
   */ getPackedMeshBuffer() {
        return this.wavePhysicsManager?.getPackedMeshBuffer() ?? null;
    }
    /**
   * Get the rasterizer for rendering meshes to screen-space texture.
   */ getRasterizer() {
        return this.wavePhysicsManager?.getRasterizer() ?? null;
    }
    /**
   * Get the active meshes (for the currently selected builder type).
   */ getActiveMeshes() {
        return this.wavePhysicsManager?.getActiveMeshes() ?? [];
    }
    /**
   * Get the currently active builder type.
   */ getActiveBuilderType() {
        return this.wavePhysicsManager?.getActiveBuilderType() ?? "marching";
    }
    /**
   * Switch the active builder type and rebuild resources.
   */ switchBuilderType(type) {
        this.wavePhysicsManager?.setActiveBuilderType(type);
    }
    /**
   * Check if wave physics is initialized and ready.
   */ isInitialized() {
        return this.wavePhysicsManager?.isInitialized() ?? false;
    }
    onDestroy() {
        this.wavePhysicsManager?.destroy();
    }
}
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $aa1f0309d9dba6d2$export$af631764ddc44097)("afterAdded")
], $ffbca396848d8854$export$8b9e0edba56abb99.prototype, "onAfterAdded", null);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $aa1f0309d9dba6d2$export$af631764ddc44097)("destroy")
], $ffbca396848d8854$export$8b9e0edba56abb99.prototype, "onDestroy", null);



/**
 * Water GPU resource manager.
 *
 * Owns and manages GPU buffers for water data including wave parameters and modifiers.
 * Provides read-only access to buffers for query shaders and render pipelines.
 * Eliminates duplication between the tile pipeline and query system.
 *
 * Also handles:
 * - Collecting water modifiers from "waterModifier" tagged entities each tick
 * - Updating tide height from TimeOfDay
 */ 






const $cb7a1399420ef9b3$export$f163568a8f0e136f = 16384;
const $cb7a1399420ef9b3$export$e66a374ba39daa3c = 14;
// Tide configuration
// Semi-diurnal tide: 2 cycles per day (high at 0h & 12h, low at 6h & 18h)
const $cb7a1399420ef9b3$var$DEFAULT_TIDE_RANGE = 4; // ft total range (±2 ft from mean)
class $cb7a1399420ef9b3$export$56d2cf3a64cd00a4 extends (0, $c59361981bac2575$export$4342ba5c6ad1f6f1) {
    constructor(waveConfig){
        super(), this.id = "waterResources", this.tickLayer = "query", // Current modifier count (updated each frame)
        this.modifierCount = 0, // Tide height offset (updated each tick)
        this.tideHeight = 0, // Cached modifier data for current frame (for render pipeline access)
        this.cachedModifiers = [];
        this.waveConfig = waveConfig ?? (0, $2f4d0b169c8eccfe$export$483d573411d408a4);
    }
    onAdd({ game: game }) {
        const device = game.getWebGPUDevice();
        // Create wave data storage buffer (static, uploaded once)
        const waveData = (0, $2f4d0b169c8eccfe$export$6487fa7469de11cf)(this.waveConfig.sources);
        this.waveDataBuffer = device.createBuffer({
            size: waveData.byteLength,
            usage: GPUBufferUsage.STORAGE | GPUBufferUsage.COPY_DST,
            label: "Water Wave Data Buffer (Shared)",
            mappedAtCreation: true
        });
        new Float32Array(this.waveDataBuffer.getMappedRange()).set(waveData);
        this.waveDataBuffer.unmap();
        // Create modifiers storage buffer (dynamic, updated each frame)
        this.modifierData = new Float32Array($cb7a1399420ef9b3$export$f163568a8f0e136f * $cb7a1399420ef9b3$export$e66a374ba39daa3c);
        this.modifiersBuffer = device.createBuffer({
            size: this.modifierData.byteLength,
            usage: GPUBufferUsage.STORAGE | GPUBufferUsage.COPY_DST,
            label: "Water Modifiers Buffer (Shared)"
        });
    }
    /**
   * Collect modifiers and update tide each tick.
   */ onTick() {
        // Update tide height from TimeOfDay
        const timeOfDay = this.game.entities.tryGetSingleton((0, $4df5c29ec7839388$export$1467403458327a44));
        if (timeOfDay) {
            const hour = timeOfDay.getHour();
            // Semi-diurnal: 2 cycles per day (high at 0h & 12h, low at 6h & 18h)
            const tidePhase = hour / 12 * Math.PI;
            this.tideHeight = Math.sin(tidePhase) * ($cb7a1399420ef9b3$var$DEFAULT_TIDE_RANGE / 2);
        }
        // Collect and cache modifier data for this frame
        this.cachedModifiers = this.collectModifierData();
        // Upload modifiers to GPU buffer
        this.updateModifiers(this.cachedModifiers);
    }
    /**
   * Collect water modifier data from all waterModifier-tagged entities.
   */ collectModifierData() {
        const modifiers = [];
        for (const entity of this.game.entities.getTagged("waterModifier"))if (entity instanceof (0, $34555dd463019ed0$export$49e34aa2229adb65)) {
            const data = entity.getGPUModifierData();
            if (data !== null) modifiers.push(data);
        }
        return modifiers;
    }
    onDestroy() {
        this.waveDataBuffer.destroy();
        this.modifiersBuffer.destroy();
    }
    /**
   * Update the modifiers buffer with water modifier data.
   * Returns the actual number of modifiers uploaded.
   */ updateModifiers(modifiers) {
        const device = this.game.getWebGPUDevice();
        const modifierCount = Math.min(modifiers.length, $cb7a1399420ef9b3$export$f163568a8f0e136f);
        if (modifiers.length > $cb7a1399420ef9b3$export$f163568a8f0e136f) console.warn(`Water modifiers (${modifiers.length}) exceeds MAX_MODIFIERS (${$cb7a1399420ef9b3$export$f163568a8f0e136f}), truncating`);
        for(let i = 0; i < modifierCount; i++){
            const mod = modifiers[i];
            const base = i * $cb7a1399420ef9b3$export$e66a374ba39daa3c;
            // Header: type + bounds (AABB)
            this.modifierData[base + 0] = mod.type;
            this.modifierData[base + 1] = mod.bounds.lowerBound.x;
            this.modifierData[base + 2] = mod.bounds.lowerBound.y;
            this.modifierData[base + 3] = mod.bounds.upperBound.x;
            this.modifierData[base + 4] = mod.bounds.upperBound.y;
            // Pack type-specific data (see FLOATS_PER_MODIFIER comment for layout)
            const d = mod.data;
            if (d.type === (0, $34555dd463019ed0$export$125ddb01a2b383f0).Wake) {
                this.modifierData[base + 5] = d.posX;
                this.modifierData[base + 6] = d.posY;
                this.modifierData[base + 7] = d.ringRadius;
                this.modifierData[base + 8] = d.ringWidth;
                this.modifierData[base + 9] = d.amplitude;
                this.modifierData[base + 10] = d.omega;
                this.modifierData[base + 11] = 0;
                this.modifierData[base + 12] = 0;
                this.modifierData[base + 13] = 0;
            } else {
                // Foam
                this.modifierData[base + 5] = d.posX;
                this.modifierData[base + 6] = d.posY;
                this.modifierData[base + 7] = d.radius;
                this.modifierData[base + 8] = d.intensity;
                this.modifierData[base + 9] = 0;
                this.modifierData[base + 10] = 0;
                this.modifierData[base + 11] = 0;
                this.modifierData[base + 12] = 0;
                this.modifierData[base + 13] = 0;
            }
        }
        // Only upload the portion we need
        if (modifierCount > 0) {
            const uploadSize = modifierCount * $cb7a1399420ef9b3$export$e66a374ba39daa3c * 4;
            device.queue.writeBuffer(this.modifiersBuffer, 0, this.modifierData.buffer, 0, uploadSize);
        }
        this.modifierCount = modifierCount;
        return modifierCount;
    }
    /**
   * Set the tide height offset.
   */ setTideHeight(height) {
        this.tideHeight = height;
    }
    /**
   * Get the current tide height offset.
   */ getTideHeight() {
        return this.tideHeight;
    }
    /**
   * Get the number of active modifiers.
   */ getModifierCount() {
        return this.modifierCount;
    }
    /**
   * Get the number of wave sources.
   */ getNumWaves() {
        return this.waveConfig.sources.length;
    }
    /**
   * Get the wave configuration.
   */ getWaveConfig() {
        return this.waveConfig;
    }
    /**
   * Get the cached modifier data for the current frame.
   * Used by render pipelines that need access to modifier data.
   */ getCachedModifiers() {
        return this.cachedModifiers;
    }
}
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $aa1f0309d9dba6d2$export$af631764ddc44097)("add")
], $cb7a1399420ef9b3$export$56d2cf3a64cd00a4.prototype, "onAdd", null);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $aa1f0309d9dba6d2$export$af631764ddc44097)("tick"),
    (0, $5a1d1d3ab1ff9c51$export$4882ae973e0491e)
], $cb7a1399420ef9b3$export$56d2cf3a64cd00a4.prototype, "onTick", null);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $aa1f0309d9dba6d2$export$af631764ddc44097)("destroy")
], $cb7a1399420ef9b3$export$56d2cf3a64cd00a4.prototype, "onDestroy", null);


/**
 * Biome terrain coloring configuration.
 *
 * Defines how terrain surfaces are colored based on elevation zones,
 * slope-dependent rock exposure, optional snow, and noise variation.
 */ const $be7b0a69b0f1c572$var$MAX_BIOME_ZONES = 6;
const $be7b0a69b0f1c572$export$968fde8d838bc38d = {
    zones: [
        {
            maxHeight: 99999,
            color: [
                0.96,
                0.91,
                0.76
            ],
            colorAlt: [
                0.76,
                0.7,
                0.5
            ],
            noiseBlend: 0
        }
    ],
    rockColor: [
        0.5,
        0.5,
        0.5
    ],
    rockThreshold: 2.0,
    snowColor: [
        0.95,
        0.97,
        1.0
    ],
    snowlineHeight: -1,
    largeNoiseScale: 0.005,
    smallNoiseScale: 0.3
};
function $be7b0a69b0f1c572$export$53718d50d05e05a3(json) {
    if (!json) return $be7b0a69b0f1c572$export$968fde8d838bc38d;
    const zones = json.zones.slice(0, $be7b0a69b0f1c572$var$MAX_BIOME_ZONES).map((z)=>({
            maxHeight: z.maxHeight,
            color: z.color,
            colorAlt: z.colorAlt,
            noiseBlend: z.noiseBlend
        }));
    // Ensure at least one zone
    if (zones.length === 0) return $be7b0a69b0f1c572$export$968fde8d838bc38d;
    return {
        zones: zones,
        rockColor: json.rockColor,
        rockThreshold: json.rockThreshold,
        snowColor: json.snowColor ?? [
            0.95,
            0.97,
            1.0
        ],
        snowlineHeight: json.snowlineHeight ?? -1,
        largeNoiseScale: json.largeNoiseScale ?? 0.005,
        smallNoiseScale: json.smallNoiseScale ?? 0.3
    };
}
const $be7b0a69b0f1c572$export$31dcfe447568361d = 240;
function $be7b0a69b0f1c572$export$dfc4d347d6e53f50(config) {
    const data = new Float32Array(60);
    const uintView = new Uint32Array(data.buffer);
    // Pack zones (8 floats per zone, 6 zones max)
    for(let i = 0; i < $be7b0a69b0f1c572$var$MAX_BIOME_ZONES; i++){
        const offset = i * 8;
        if (i < config.zones.length) {
            const zone = config.zones[i];
            // colorAndHeight: vec4(r, g, b, maxHeight)
            data[offset + 0] = zone.color[0];
            data[offset + 1] = zone.color[1];
            data[offset + 2] = zone.color[2];
            data[offset + 3] = zone.maxHeight;
            // altColorAndBlend: vec4(r, g, b, noiseBlend)
            data[offset + 4] = zone.colorAlt[0];
            data[offset + 5] = zone.colorAlt[1];
            data[offset + 6] = zone.colorAlt[2];
            data[offset + 7] = zone.noiseBlend;
        }
    // Unused zones remain zero-filled
    }
    // rockColorAndThreshold: vec4 at offset 48
    data[48] = config.rockColor[0];
    data[49] = config.rockColor[1];
    data[50] = config.rockColor[2];
    data[51] = config.rockThreshold;
    // snowColorAndLine: vec4 at offset 52
    data[52] = config.snowColor[0];
    data[53] = config.snowColor[1];
    data[54] = config.snowColor[2];
    data[55] = config.snowlineHeight;
    // noiseScales: vec2 at offset 56
    data[56] = config.largeNoiseScale;
    data[57] = config.smallNoiseScale;
    // zoneCount: u32 at offset 58
    uintView[58] = config.zones.length;
    // _pad at offset 59 (already 0)
    return data;
}



/**
 * LOD Terrain Tile Cache — Sliding Window
 *
 * Maintains a sliding window of 3 TerrainTileCache instances that follow the
 * camera zoom: one for the current LOD level, one finer, one coarser.
 *
 * LOD levels are computed from a formula rather than a static list:
 *   worldUnitsPerTile(level) = BASE_WORLD_UNITS * SCALE^level
 *   zoomThreshold(level)     = BASE_ZOOM * (1/SCALE)^level
 *
 * Level 0 is highest detail. No upper bound — infinite zoom out.
 *
 * Memory: 3 × 256-tile atlas = 192 MB fixed, regardless of zoom range.
 */ /**
 * Terrain Tile Cache
 *
 * Caches terrain height tiles in a GPU texture atlas for efficient rendering.
 * Tiles are computed on-demand and cached until evicted.
 *
 * This class manages:
 * - World-to-tile coordinate mapping
 * - Tile request/render lifecycle
 * - Cache invalidation when terrain changes
 * - Atlas sampling information for the composite shader
 */ /**
 * Tile Atlas - GPU texture atlas for storing cached tiles.
 *
 * Manages a large GPU texture divided into fixed-size slots.
 * Tiles can be rendered to individual slots and sampled from the atlas.
 */ 
class $7a1659fd6ab6c859$export$920e0c8dc706de91 {
    constructor(config){
        const device = (0, $558c2f47f1fdd57f$export$297162150ea0f6af)().device;
        this.tileSize = config.tileSize;
        this.tilesX = config.tilesX;
        this.tilesY = config.tilesY;
        this.maxTiles = config.tilesX * config.tilesY;
        this.width = config.tileSize * config.tilesX;
        this.height = config.tileSize * config.tilesY;
        // Create the atlas texture
        // Needs STORAGE_BINDING for compute shader output
        // Needs TEXTURE_BINDING for sampling in fragment shader
        this.texture = device.createTexture({
            size: {
                width: this.width,
                height: this.height
            },
            format: config.format,
            usage: GPUTextureUsage.STORAGE_BINDING | GPUTextureUsage.TEXTURE_BINDING | GPUTextureUsage.COPY_DST,
            label: config.label ?? "TileAtlas"
        });
        this.view = this.texture.createView();
    }
    /**
   * Get the pixel coordinates of a tile slot.
   */ getSlotPixelCoords(slot) {
        const tileX = slot % this.tilesX;
        const tileY = Math.floor(slot / this.tilesX);
        return {
            x: tileX * this.tileSize,
            y: tileY * this.tileSize
        };
    }
    /**
   * Get UV coordinates for a tile slot.
   */ getSlotUV(slot) {
        const tileX = slot % this.tilesX;
        const tileY = Math.floor(slot / this.tilesX);
        return {
            u: tileX / this.tilesX,
            v: tileY / this.tilesY,
            size: 1.0 / this.tilesX
        };
    }
    /**
   * Get atlas dimensions for shader uniforms.
   */ getAtlasInfo() {
        return {
            atlasWidth: this.width,
            atlasHeight: this.height,
            tileSize: this.tileSize,
            tilesX: this.tilesX,
            tilesY: this.tilesY
        };
    }
    /**
   * Clean up GPU resources.
   */ destroy() {
        this.texture.destroy();
    }
}
function $7a1659fd6ab6c859$export$88f6633f9dd0a287(tileCount, _tileSize) {
    // Try to make it roughly square
    const tilesPerSide = Math.ceil(Math.sqrt(tileCount));
    // Calculate rows needed
    const tilesX = tilesPerSide;
    const tilesY = Math.ceil(tileCount / tilesX);
    return {
        tilesX: tilesX,
        tilesY: tilesY
    };
}


/**
 * Virtual Texture Cache - Direct-mapped tile caching system.
 *
 * Manages a cache of rendered tiles where each tile coordinate maps to a
 * deterministic slot via modulo. This allows shaders to compute the slot
 * from world coordinates without an indirection texture.
 *
 * When a new tile needs a slot that's occupied by a different tile,
 * the old tile is evicted (direct-mapped cache behavior).
 */ /**
 * State of a tile in the cache.
 */ class $add3f8be284d3a8e$export$3df54fb5465ab5a1 {
    constructor(config){
        /** Map from tile key to slot for quick lookup */ this.keyToSlot = new Map();
        this.tilesX = config.tilesX;
        this.tilesY = config.tilesY;
        this.maxTiles = config.tilesX * config.tilesY;
        // Initialize all slots as empty
        this.slots = new Array(this.maxTiles).fill(null);
    }
    /**
   * Compute the slot for a tile based on its coordinates.
   * This must match the shader's computation.
   */ computeSlot(tileX, tileY) {
        // Handle negative coordinates with proper modulo
        let slotX = tileX % this.tilesX;
        let slotY = tileY % this.tilesY;
        if (slotX < 0) slotX += this.tilesX;
        if (slotY < 0) slotY += this.tilesY;
        return slotY * this.tilesX + slotX;
    }
    /**
   * Parse tile coordinates from a key.
   */ parseTileKey(key) {
        const [x, y] = key.split(",").map(Number);
        return {
            tileX: x,
            tileY: y
        };
    }
    /**
   * Request tiles for the current frame.
   *
   * Returns a list of tiles that need to be rendered (status: pending).
   * If a slot is occupied by a different tile, that tile is evicted.
   *
   * @param keys - Array of tile keys needed this frame (format: "x,y")
   * @returns Array of tile requests that need rendering
   */ requestTiles(keys) {
        const requests = [];
        for (const key of keys){
            const { tileX: tileX, tileY: tileY } = this.parseTileKey(key);
            const slot = this.computeSlot(tileX, tileY);
            const existing = this.slots[slot];
            if (existing && existing.key === key) // Tile is already in its slot
            {
                if (existing.status === "pending") requests.push({
                    key: key,
                    atlasSlot: slot
                });
            } else {
                // Slot is empty or occupied by a different tile - evict and allocate
                if (existing) // Evict the old tile
                this.keyToSlot.delete(existing.key);
                // Allocate new tile
                const state = {
                    key: key,
                    status: "pending",
                    tileX: tileX,
                    tileY: tileY
                };
                this.slots[slot] = state;
                this.keyToSlot.set(key, slot);
                requests.push({
                    key: key,
                    atlasSlot: slot
                });
            }
        }
        return requests;
    }
    /**
   * Mark a tile as ready (rendered and available for sampling).
   */ markTileReady(key) {
        const slot = this.keyToSlot.get(key);
        if (slot !== undefined) {
            const state = this.slots[slot];
            if (state && state.key === key) state.status = "ready";
        }
    }
    /**
   * Get a cached tile by key.
   *
   * @returns The cached tile info if ready, null otherwise
   */ getTile(key) {
        const slot = this.keyToSlot.get(key);
        if (slot !== undefined) {
            const state = this.slots[slot];
            if (state && state.key === key && state.status === "ready") return {
                key: key,
                atlasSlot: slot
            };
        }
        return null;
    }
    /**
   * Get the status of a tile.
   */ getTileStatus(key) {
        const slot = this.keyToSlot.get(key);
        if (slot !== undefined) {
            const state = this.slots[slot];
            if (state && state.key === key) return state.status;
        }
        return "empty";
    }
    /**
   * Clear all cached tiles.
   */ clear() {
        for(let i = 0; i < this.maxTiles; i++)this.slots[i] = null;
        this.keyToSlot.clear();
    }
    /**
   * Get the number of cached tiles (pending + ready).
   */ getCachedTileCount() {
        return this.keyToSlot.size;
    }
    /**
   * Get the number of ready tiles.
   */ getReadyTileCount() {
        let count = 0;
        for (const slot of this.keyToSlot.values()){
            const state = this.slots[slot];
            if (state && state.status === "ready") count++;
        }
        return count;
    }
}


/**
 * Terrain Tile Compute Shader
 *
 * Computes terrain height for a single tile and writes to an atlas slot.
 * Output is a portion of the terrain atlas texture (r32float).
 *
 * This shader is used by the terrain tile cache to render individual tiles
 * which are then composited during the surface render pass.
 */ 


const $ce27887b6eb2b2b6$var$WORKGROUP_SIZE = [
    8,
    8
];
/**
 * Params module with uniforms and bindings for terrain tile computation.
 */ const $ce27887b6eb2b2b6$var$terrainTileParamsModule = {
    preamble: /*wgsl*/ `
// Terrain tile computation parameters
struct TileParams {
  // Tile pixel size
  tileSize: u32,

  // Atlas offset in pixels (where to write)
  atlasOffsetX: u32,
  atlasOffsetY: u32,

  // Terrain params
  contourCount: u32,

  // World-space bounds of this tile
  tileWorldLeft: f32,
  tileWorldTop: f32,
  tileWorldWidth: f32,
  tileWorldHeight: f32,
}

// Terrain constants
const DEFAULT_DEPTH: f32 = ${(0, $50f569eac7e9a7b2$export$7f882bb969de14a3)}.0;
`,
    bindings: {
        params: {
            type: "uniform",
            wgslType: "TileParams"
        },
        packedTerrain: {
            type: "storage",
            wgslType: "array<u32>"
        },
        atlasTexture: {
            type: "storageTexture",
            format: "r32float"
        }
    },
    code: ""
};
/**
 * Main compute module for terrain tile.
 */ const $ce27887b6eb2b2b6$var$terrainTileMainModule = {
    dependencies: [
        $ce27887b6eb2b2b6$var$terrainTileParamsModule,
        (0, $d2770abe96d7e153$export$bf8b0ba9719f8192),
        (0, $cef462b61853a9de$export$3fb9b31381321192)
    ],
    code: /*wgsl*/ `
// Convert tile-local pixel coordinates to world position
fn tilePixelToWorld(pixel: vec2<u32>) -> vec2<f32> {
  let uv = vec2<f32>(
    f32(pixel.x) / f32(params.tileSize),
    f32(pixel.y) / f32(params.tileSize)
  );
  return vec2<f32>(
    params.tileWorldLeft + uv.x * params.tileWorldWidth,
    params.tileWorldTop + uv.y * params.tileWorldHeight
  );
}

@compute @workgroup_size(${$ce27887b6eb2b2b6$var$WORKGROUP_SIZE[0]}, ${$ce27887b6eb2b2b6$var$WORKGROUP_SIZE[1]})
fn main(@builtin(global_invocation_id) global_id: vec3<u32>) {
  let localPixel = global_id.xy;

  // Bounds check against tile size
  if (localPixel.x >= params.tileSize || localPixel.y >= params.tileSize) {
    return;
  }

  let worldPos = tilePixelToWorld(localPixel);

  // Compute terrain height using contour-based algorithm
  let terrainHeight = computeTerrainHeight(
    worldPos,
    &packedTerrain,
    params.contourCount,
    DEFAULT_DEPTH
  );

  // Write to atlas at the offset position
  let atlasPixel = vec2<u32>(
    params.atlasOffsetX + localPixel.x,
    params.atlasOffsetY + localPixel.y
  );
  textureStore(atlasTexture, atlasPixel, vec4<f32>(terrainHeight, 0.0, 0.0, 0.0));
}
`
};
const $ce27887b6eb2b2b6$var$terrainTileShaderConfig = {
    modules: [
        $ce27887b6eb2b2b6$var$terrainTileMainModule
    ],
    workgroupSize: $ce27887b6eb2b2b6$var$WORKGROUP_SIZE,
    label: "TerrainTileShader"
};
function $ce27887b6eb2b2b6$export$fd97f1846b1841f3() {
    return new (0, $4016c3d8f65071ed$export$cdde5429dd049099)($ce27887b6eb2b2b6$var$terrainTileShaderConfig);
}


/**
 * Uniform buffer definition for the Terrain Tile compute shader.
 *
 * This shader renders a single terrain tile to an atlas slot.
 */ 
const $47aa85d588e93371$export$e45e3cfbe095233a = (0, $ca6793d1abd58997$export$99bb2281c7368d10)("TileParams", {
    // Tile pixel size (e.g., 256)
    tileSize: (0, $ca6793d1abd58997$export$8bacf4ad828c7fe7),
    // Atlas slot offset in pixels (where to write in the atlas)
    atlasOffsetX: (0, $ca6793d1abd58997$export$8bacf4ad828c7fe7),
    atlasOffsetY: (0, $ca6793d1abd58997$export$8bacf4ad828c7fe7),
    // Terrain params
    contourCount: (0, $ca6793d1abd58997$export$8bacf4ad828c7fe7),
    // World-space bounds of this tile
    tileWorldLeft: (0, $ca6793d1abd58997$export$e33361ff41014190),
    tileWorldTop: (0, $ca6793d1abd58997$export$e33361ff41014190),
    tileWorldWidth: (0, $ca6793d1abd58997$export$e33361ff41014190),
    tileWorldHeight: (0, $ca6793d1abd58997$export$e33361ff41014190)
});


const $0fa8324aa9fe88a5$var$DEFAULT_TILE_SIZE = 256;
// 512 tiles (23x23 grid) covers ~1500x1500 world units, supporting zoom >= 1.3
// This prevents cache collisions when zoomed out moderately
const $0fa8324aa9fe88a5$var$DEFAULT_MAX_TILES = 512;
const $0fa8324aa9fe88a5$var$DEFAULT_WORLD_UNITS_PER_TILE = 64;
class $0fa8324aa9fe88a5$export$e8ac4723eb1e76ca {
    constructor(device, config = {}){
        this.lastTerrainVersion = -1;
        this.initialized = false;
        this.bindGroup = null;
        this.lastPackedTerrainBuffer = null;
        // Current frame's visible tiles
        this.visibleTiles = [];
        this.device = device;
        this.tileSize = config.tileSize ?? $0fa8324aa9fe88a5$var$DEFAULT_TILE_SIZE;
        const maxTiles = config.maxTiles ?? $0fa8324aa9fe88a5$var$DEFAULT_MAX_TILES;
        this.worldUnitsPerTile = config.worldUnitsPerTile ?? $0fa8324aa9fe88a5$var$DEFAULT_WORLD_UNITS_PER_TILE;
        // Calculate atlas dimensions
        const { tilesX: tilesX, tilesY: tilesY } = (0, $7a1659fd6ab6c859$export$88f6633f9dd0a287)(maxTiles);
        // Create the virtual texture cache (direct-mapped by tile coordinates)
        this.cache = new (0, $add3f8be284d3a8e$export$3df54fb5465ab5a1)({
            tilesX: tilesX,
            tilesY: tilesY
        });
        // Create the atlas texture
        this.atlas = new (0, $7a1659fd6ab6c859$export$920e0c8dc706de91)({
            tileSize: this.tileSize,
            tilesX: tilesX,
            tilesY: tilesY,
            format: "r32float",
            label: "Terrain Tile Atlas"
        });
        // Create the tile shader
        this.shader = (0, $ce27887b6eb2b2b6$export$fd97f1846b1841f3)();
        // Create uniform buffer and instance
        this.uniformBuffer = device.createBuffer({
            size: (0, $47aa85d588e93371$export$e45e3cfbe095233a).byteSize,
            usage: GPUBufferUsage.UNIFORM | GPUBufferUsage.COPY_DST,
            label: "Terrain Tile Uniform Buffer"
        });
        this.uniforms = (0, $47aa85d588e93371$export$e45e3cfbe095233a).create();
    }
    /**
   * Initialize the cache (must be called before use).
   */ async init() {
        if (this.initialized) return;
        await this.shader.init();
        this.initialized = true;
    }
    /**
   * Check if terrain has changed and invalidate cache if needed.
   *
   * @returns true if cache was invalidated
   */ checkInvalidation(terrainResources) {
        const version = terrainResources.getVersion();
        if (version !== this.lastTerrainVersion) {
            this.cache.clear();
            this.lastTerrainVersion = version;
            this.bindGroup = null; // Force rebind
            return true;
        }
        return false;
    }
    /**
   * Update the cache for the current viewport.
   * Returns tile requests that need rendering.
   */ update(viewport, terrainResources) {
        if (!this.initialized) return [];
        // Calculate which tiles are visible
        const tileKeys = this.calculateVisibleTileKeys(viewport);
        // Request tiles from cache
        const requests = this.cache.requestTiles(tileKeys);
        // Update visible tiles list (only ready tiles)
        this.updateVisibleTiles(viewport, terrainResources);
        return requests;
    }
    /**
   * Render missing tiles to the atlas.
   *
   * Each tile is rendered in a separate command encoder submission to ensure
   * the uniform buffer updates are applied correctly. This is necessary because
   * writeBuffer goes to the queue immediately, but compute pass commands
   * aren't executed until submit().
   */ renderTiles(requests, terrainResources, gpuProfiler) {
        if (!this.initialized || requests.length === 0) return;
        const device = this.device;
        // Ensure bind group is up to date
        this.ensureBindGroup(terrainResources);
        if (!this.bindGroup) return;
        // Render each tile with a separate submit to ensure uniforms are applied
        // Only add profiling timestamps to the first tile
        let isFirst = true;
        for (const request of requests){
            // Skip if this tile was evicted by a later request for the same slot.
            // This happens when multiple visible tiles hash to the same slot in
            // the direct-mapped cache.
            if (this.cache.getTileStatus(request.key) !== "pending") continue;
            // Update uniforms for this tile
            const { tileX: tileX, tileY: tileY } = this.parseTileKey(request.key);
            const { x: atlasX, y: atlasY } = this.atlas.getSlotPixelCoords(request.atlasSlot);
            this.uniforms.set.tileSize(this.tileSize);
            this.uniforms.set.atlasOffsetX(atlasX);
            this.uniforms.set.atlasOffsetY(atlasY);
            this.uniforms.set.contourCount(terrainResources.getContourCount());
            this.uniforms.set.tileWorldLeft(tileX * this.worldUnitsPerTile);
            this.uniforms.set.tileWorldTop(tileY * this.worldUnitsPerTile);
            this.uniforms.set.tileWorldWidth(this.worldUnitsPerTile);
            this.uniforms.set.tileWorldHeight(this.worldUnitsPerTile);
            // Upload uniforms
            this.uniforms.uploadTo(this.uniformBuffer);
            // Create and submit command encoder for this tile
            const commandEncoder = device.createCommandEncoder({
                label: `Terrain Tile ${request.key}`
            });
            const computePass = commandEncoder.beginComputePass({
                label: `Terrain Tile Compute ${request.key}`,
                timestampWrites: isFirst ? gpuProfiler?.getComputeTimestampWrites("surface.terrain") : undefined
            });
            this.shader.dispatch(computePass, this.bindGroup, this.tileSize, this.tileSize);
            computePass.end();
            device.queue.submit([
                commandEncoder.finish()
            ]);
            this.cache.markTileReady(request.key);
            isFirst = false;
        }
    }
    /**
   * Get the atlas texture view for sampling.
   */ getAtlasView() {
        return this.atlas.view;
    }
    /**
   * Get the atlas texture for binding.
   */ getAtlasTexture() {
        return this.atlas.texture;
    }
    /**
   * Get list of currently visible tiles that are ready for rendering.
   */ getVisibleTiles() {
        return this.visibleTiles;
    }
    /**
   * Get atlas info for shader uniforms.
   */ getAtlasInfo() {
        return {
            ...this.atlas.getAtlasInfo(),
            worldUnitsPerTile: this.worldUnitsPerTile
        };
    }
    /**
   * Get the number of cached tiles.
   */ getCachedTileCount() {
        return this.cache.getCachedTileCount();
    }
    /**
   * Get the number of ready tiles.
   */ getReadyTileCount() {
        return this.cache.getReadyTileCount();
    }
    /**
   * Clean up GPU resources.
   */ destroy() {
        this.atlas.destroy();
        this.shader.destroy();
        this.uniformBuffer.destroy();
    }
    // ============ Private Methods ============
    /**
   * Calculate tile keys for all tiles visible in the viewport.
   */ calculateVisibleTileKeys(viewport) {
        const keys = [];
        // Calculate tile range that covers viewport (with some margin)
        const margin = this.worldUnitsPerTile * 0.5;
        const minTileX = Math.floor((viewport.left - margin) / this.worldUnitsPerTile);
        const maxTileX = Math.ceil((viewport.left + viewport.width + margin) / this.worldUnitsPerTile);
        const minTileY = Math.floor((viewport.top - margin) / this.worldUnitsPerTile);
        const maxTileY = Math.ceil((viewport.top + viewport.height + margin) / this.worldUnitsPerTile);
        for(let ty = minTileY; ty < maxTileY; ty++)for(let tx = minTileX; tx < maxTileX; tx++)keys.push(this.makeTileKey(tx, ty));
        return keys;
    }
    /**
   * Update the list of visible tiles that are ready.
   */ updateVisibleTiles(viewport, _terrainResources) {
        this.visibleTiles = [];
        const margin = this.worldUnitsPerTile * 0.5;
        const minTileX = Math.floor((viewport.left - margin) / this.worldUnitsPerTile);
        const maxTileX = Math.ceil((viewport.left + viewport.width + margin) / this.worldUnitsPerTile);
        const minTileY = Math.floor((viewport.top - margin) / this.worldUnitsPerTile);
        const maxTileY = Math.ceil((viewport.top + viewport.height + margin) / this.worldUnitsPerTile);
        for(let ty = minTileY; ty < maxTileY; ty++)for(let tx = minTileX; tx < maxTileX; tx++){
            const key = this.makeTileKey(tx, ty);
            const cached = this.cache.getTile(key);
            if (cached) this.visibleTiles.push({
                key: key,
                tileX: tx,
                tileY: ty,
                worldLeft: tx * this.worldUnitsPerTile,
                worldTop: ty * this.worldUnitsPerTile,
                worldSize: this.worldUnitsPerTile,
                atlasSlot: cached.atlasSlot
            });
        }
    }
    /**
   * Create a tile key from coordinates.
   */ makeTileKey(tileX, tileY) {
        return `${tileX},${tileY}`;
    }
    /**
   * Parse tile coordinates from a key.
   */ parseTileKey(key) {
        const [x, y] = key.split(",").map(Number);
        return {
            tileX: x,
            tileY: y
        };
    }
    /**
   * Ensure the bind group is up to date.
   */ ensureBindGroup(terrainResources) {
        const packedTerrainBuffer = terrainResources.packedTerrainBuffer;
        const needsRebuild = !this.bindGroup || this.lastPackedTerrainBuffer !== packedTerrainBuffer;
        if (!needsRebuild) return;
        this.bindGroup = this.shader.createBindGroup({
            params: {
                buffer: this.uniformBuffer
            },
            packedTerrain: {
                buffer: packedTerrainBuffer
            },
            atlasTexture: this.atlas.view
        });
        this.lastPackedTerrainBuffer = packedTerrainBuffer;
    }
}


const $838fb2a40177c423$var$BASE_WORLD_UNITS = 16;
const $838fb2a40177c423$var$SCALE_FACTOR = 4;
const $838fb2a40177c423$var$BASE_ZOOM = 48.0;
const $838fb2a40177c423$var$DEFAULT_MAX_TILES = 256;
const $838fb2a40177c423$var$DEFAULT_HYSTERESIS = 0.05;
const $838fb2a40177c423$var$NEAR_ADJACENT_TILE_BUDGET = 2;
const $838fb2a40177c423$var$FAR_ADJACENT_TILE_BUDGET = 1;
/**
 * Compute world units per tile for a given LOD level.
 */ function $838fb2a40177c423$var$worldUnitsForLevel(level) {
    return $838fb2a40177c423$var$BASE_WORLD_UNITS * $838fb2a40177c423$var$SCALE_FACTOR ** level;
}
/**
 * Compute the zoom threshold for a given LOD level.
 * At or above this zoom, this level is the ideal LOD.
 */ function $838fb2a40177c423$var$zoomThresholdForLevel(level) {
    return $838fb2a40177c423$var$BASE_ZOOM * (1 / $838fb2a40177c423$var$SCALE_FACTOR) ** level;
}
/**
 * Compute the ideal LOD level for a given zoom.
 * Higher zoom → lower level (finer detail).
 */ function $838fb2a40177c423$var$levelForZoom(zoom) {
    if (zoom >= $838fb2a40177c423$var$BASE_ZOOM) return 0;
    // level = log(BASE_ZOOM / zoom) / log(SCALE_FACTOR)
    const level = Math.floor(Math.log($838fb2a40177c423$var$BASE_ZOOM / zoom) / Math.log($838fb2a40177c423$var$SCALE_FACTOR));
    return Math.max(0, level);
}
class $838fb2a40177c423$export$a9ff94037f423d7d {
    constructor(device){
        this.currentLevel = 0;
        this.lastZoom = $838fb2a40177c423$var$BASE_ZOOM;
        this.initialized = false;
        // Queued adjacent tile requests for budget-limited rendering
        this.adjacentRequests = [];
        this.device = device;
        this.maxTilesPerCache = $838fb2a40177c423$var$DEFAULT_MAX_TILES;
        this.hysteresis = $838fb2a40177c423$var$DEFAULT_HYSTERESIS;
        // Initialize window at level 0: [clamped(0-1)=0, 0, 1]
        this.slots = [
            this.createSlot(0),
            this.createSlot(0),
            this.createSlot(1)
        ];
    }
    async init() {
        if (this.initialized) return;
        await Promise.all(this.slots.map((s)=>s.cache.init()));
        this.initialized = true;
    }
    /**
   * Select LOD based on zoom with hysteresis, reshuffle caches if level changes.
   */ selectLOD(zoom) {
        this.lastZoom = zoom;
        const idealLevel = $838fb2a40177c423$var$levelForZoom(zoom);
        if (idealLevel === this.currentLevel) return;
        // Apply hysteresis
        const currentThreshold = $838fb2a40177c423$var$zoomThresholdForLevel(this.currentLevel);
        if (idealLevel < this.currentLevel) {
            // Zooming in → finer detail (lower level number)
            const threshold = currentThreshold * (1 + this.hysteresis);
            if (zoom < threshold) return;
        } else {
            // Zooming out → coarser detail (higher level number)
            const threshold = currentThreshold * (1 - this.hysteresis);
            if (zoom > threshold) return;
        }
        this.reshuffleCaches(idealLevel);
    }
    /**
   * Reshuffle the 3 cache slots for a new current level.
   * Reuses caches whose levels are still in the new window.
   */ reshuffleCaches(newLevel) {
        this.currentLevel = newLevel;
        const newWindowLevels = [
            Math.max(0, newLevel - 1),
            newLevel,
            newLevel + 1
        ];
        // Build a map of old slots by level for reuse
        const oldSlotsByLevel = new Map();
        for (const slot of this.slots)oldSlotsByLevel.set(slot.level, slot);
        const newSlots = [
            null,
            null,
            null
        ];
        const reused = new Set();
        // Assign reusable caches, prioritizing the current slot (index 1) first
        const assignOrder = [
            1,
            0,
            2
        ];
        for (const i of assignOrder){
            const level = newWindowLevels[i];
            const existing = oldSlotsByLevel.get(level);
            if (existing && !reused.has(existing)) {
                newSlots[i] = existing;
                reused.add(existing);
            }
        }
        // Destroy old slots that aren't reused, create new ones
        for (const slot of this.slots)if (!reused.has(slot)) slot.cache.destroy();
        for(let i = 0; i < 3; i++)if (!newSlots[i]) {
            const slot = this.createSlot(newWindowLevels[i]);
            if (this.initialized) // Fire-and-forget init for dynamically created caches.
            // The cache handles the not-initialized state gracefully.
            slot.cache.init();
            newSlots[i] = slot;
        }
        this.slots = newSlots;
    }
    createSlot(level) {
        return {
            level: level,
            cache: new (0, $0fa8324aa9fe88a5$export$e8ac4723eb1e76ca)(this.device, {
                worldUnitsPerTile: $838fb2a40177c423$var$worldUnitsForLevel(level),
                maxTiles: this.maxTilesPerCache
            })
        };
    }
    getCurrentSlot() {
        return this.slots[1];
    }
    checkInvalidation(terrainResources) {
        let invalidated = false;
        for (const slot of this.slots)if (slot.cache.checkInvalidation(terrainResources)) invalidated = true;
        return invalidated;
    }
    /**
   * Update all 3 slots. Returns only the current slot's tile requests for the caller.
   * Adjacent slots are pre-warmed and their requests queued for budget-limited rendering.
   */ update(viewport, zoom, terrainResources) {
        if (!this.initialized) return [];
        this.selectLOD(zoom);
        // Update all slots with current viewport
        this.adjacentRequests = [];
        // Viewport center for prioritizing adjacent tile requests
        const cx = viewport.left + viewport.width * 0.5;
        const cy = viewport.top + viewport.height * 0.5;
        let currentRequests = [];
        for (const slot of this.slots){
            const requests = slot.cache.update(viewport, terrainResources);
            if (slot === this.getCurrentSlot()) currentRequests = requests;
            else if (requests.length > 0) {
                // Sort adjacent requests by distance to viewport center so the
                // most useful tiles get rendered first within the budget
                const wu = $838fb2a40177c423$var$worldUnitsForLevel(slot.level);
                requests.sort((a, b)=>{
                    const [ax, ay] = a.key.split(",");
                    const [bx, by] = b.key.split(",");
                    const da = (Number(ax) * wu + wu * 0.5 - cx) ** 2 + (Number(ay) * wu + wu * 0.5 - cy) ** 2;
                    const db = (Number(bx) * wu + wu * 0.5 - cx) ** 2 + (Number(by) * wu + wu * 0.5 - cy) ** 2;
                    return da - db;
                });
                this.adjacentRequests.push({
                    slot: slot,
                    requests: requests
                });
            }
        }
        return currentRequests;
    }
    /**
   * Render current cache's tiles (all of them),
   * plus adjacent tiles with budget, prioritized by which level we're closer to.
   */ renderTiles(requests, terrainResources, gpuProfiler) {
        if (!this.initialized) return;
        // Render all current LOD tiles — these are needed immediately
        if (requests.length > 0) this.getCurrentSlot().cache.renderTiles(requests, terrainResources, gpuProfiler);
        // Sort adjacent caches: the level we're closer to transitioning to gets more budget.
        // If zoom is below the current threshold, we're closer to zooming out (higher level).
        const currentThreshold = $838fb2a40177c423$var$zoomThresholdForLevel(this.currentLevel);
        const zoomingOut = this.lastZoom < currentThreshold;
        const sorted = [
            ...this.adjacentRequests
        ].sort((a, b)=>{
            const aIsCoarser = a.slot.level > this.currentLevel;
            const bIsCoarser = b.slot.level > this.currentLevel;
            if (zoomingOut) return aIsCoarser === bIsCoarser ? 0 : aIsCoarser ? -1 : 1;
            else return aIsCoarser === bIsCoarser ? 0 : aIsCoarser ? 1 : -1;
        });
        // Near adjacent gets more budget, far gets less
        let adjacentRendered = 0;
        const budgets = [
            $838fb2a40177c423$var$NEAR_ADJACENT_TILE_BUDGET,
            $838fb2a40177c423$var$FAR_ADJACENT_TILE_BUDGET
        ];
        for(let i = 0; i < sorted.length; i++){
            const budget = budgets[i] ?? 0;
            if (budget <= 0) continue;
            const { slot: slot, requests: adjRequests } = sorted[i];
            const limited = adjRequests.slice(0, budget);
            slot.cache.renderTiles(limited, terrainResources);
            adjacentRendered += limited.length;
        }
    }
    getAtlasView() {
        return this.getCurrentSlot().cache.getAtlasView();
    }
    getAtlasTexture() {
        return this.getCurrentSlot().cache.getAtlasTexture();
    }
    getAtlasInfo() {
        return this.getCurrentSlot().cache.getAtlasInfo();
    }
    getVisibleTiles() {
        return this.getCurrentSlot().cache.getVisibleTiles();
    }
    getCurrentLOD() {
        return this.currentLevel;
    }
    getCurrentLODConfig() {
        const level = this.currentLevel;
        return {
            worldUnitsPerTile: $838fb2a40177c423$var$worldUnitsForLevel(level),
            maxTiles: this.maxTilesPerCache,
            minZoom: $838fb2a40177c423$var$zoomThresholdForLevel(level)
        };
    }
    getCachedTileCount() {
        return this.getCurrentSlot().cache.getCachedTileCount();
    }
    getReadyTileCount() {
        return this.getCurrentSlot().cache.getReadyTileCount();
    }
    getAllLODStats() {
        return this.slots.map((slot)=>({
                lod: slot.level,
                worldUnitsPerTile: $838fb2a40177c423$var$worldUnitsForLevel(slot.level),
                cachedTiles: slot.cache.getCachedTileCount(),
                readyTiles: slot.cache.getReadyTileCount()
            }));
    }
    destroy() {
        for (const slot of this.slots)slot.cache.destroy();
    }
}


/**
 * Water Modifier Rasterizer
 *
 * Rasterizes water modifier contributions (wakes, ripples, etc.) to a
 * screen-space rgba16float texture using instanced annular polygons.
 *
 * Each modifier gets an 8-segment annular polygon covering only the ring
 * band where the contribution is significant, avoiding wasted fragments in
 * the AABB corners and empty ring interior. The fragment shader computes
 * the type-specific contribution. Additive blending accumulates height
 * (R channel); max blending preserves peak turbulence (A channel).
 *
 * Output: vec4(height, 0, 0, turbulence)
 * Clear color: (0, 0, 0, 0) = no modifier contribution
 *
 * Reuses the existing modifiersBuffer from WaterResources directly as a
 * storage buffer binding — no new CPU-side data packing needed.
 */ 

const $12d54cf0e8ceaf5c$var$ModifierRasterizerUniforms = (0, $ca6793d1abd58997$export$99bb2281c7368d10)("ModifierParams", {
    // World → clip for the target texture (screen-aligned, rotation-aware).
    worldToTexClip: (0, $ca6793d1abd58997$export$a9b01fc77c97438b),
    modifierCount: (0, $ca6793d1abd58997$export$8bacf4ad828c7fe7),
    floatsPerModifier: (0, $ca6793d1abd58997$export$8bacf4ad828c7fe7)
});
const $12d54cf0e8ceaf5c$var$SHADER_CODE = /*wgsl*/ `
struct ModifierParams {
  worldToTexClip: mat3x3<f32>,
  modifierCount: u32,
  floatsPerModifier: u32,
}

@group(0) @binding(0) var<uniform> params: ModifierParams;
@group(0) @binding(1) var<storage, read> modifiers: array<f32>;

// 8-segment annular polygon: 8 segments \xd7 6 vertices = 48 vertices per instance
const RING_SEGMENTS: u32 = 8u;
const VERTS_PER_INSTANCE: u32 = 48u; // RING_SEGMENTS * 6
const TWO_PI: f32 = 6.283185307;
// Expand outer radius so inscribed polygon fully covers the circle: 1/cos(\u{3C0}/8)
const POLYGON_COVERAGE: f32 = 1.0824;

struct VertexOutput {
  @builtin(position) position: vec4<f32>,
  @location(0) worldPos: vec2<f32>,
  @location(1) @interpolate(flat) instanceIndex: u32,
}

@vertex
fn vs_main(
  @builtin(vertex_index) vertexIndex: u32,
  @builtin(instance_index) instanceIndex: u32,
) -> VertexOutput {
  let base = instanceIndex * params.floatsPerModifier;
  let modType = u32(modifiers[base + 0u]);

  let minX = modifiers[base + 1u];
  let minY = modifiers[base + 2u];
  let maxX = modifiers[base + 3u];
  let maxY = modifiers[base + 4u];

  // Compute center and inner/outer radii based on modifier type
  var centerX: f32;
  var centerY: f32;
  var innerR: f32;
  var outerR: f32;

  if (modType == 1u) {
    // Wake: ring centered on source position
    centerX = modifiers[base + 5u];
    centerY = modifiers[base + 6u];
    let ringRadius = modifiers[base + 7u];
    let ringWidth = modifiers[base + 8u];
    innerR = max(0.0, ringRadius - 3.0 * ringWidth);
    outerR = ringRadius + 3.0 * ringWidth;
  } else if (modType == 2u) {
    // Ripple: ring centered on AABB center
    centerX = (minX + maxX) * 0.5;
    centerY = (minY + maxY) * 0.5;
    let radius = modifiers[base + 5u];
    innerR = max(0.0, radius - 2.0);
    outerR = radius + 2.0;
  } else if (modType == 5u) {
    // Foam: filled Gaussian blob centered on source position
    centerX = modifiers[base + 5u];
    centerY = modifiers[base + 6u];
    let radius = modifiers[base + 7u];
    innerR = 0.0;
    outerR = radius * 3.0;
  } else {
    // Fallback: filled circle from AABB
    centerX = (minX + maxX) * 0.5;
    centerY = (minY + maxY) * 0.5;
    innerR = 0.0;
    outerR = max(maxX - minX, maxY - minY) * 0.5;
  }

  // Expand outer radius so polygon edges fully cover the circle
  outerR *= POLYGON_COVERAGE;

  // Generate annular polygon vertex
  // Each segment has 6 vertices forming 2 triangles (inner/outer ring band)
  let segment = vertexIndex / 6u;
  let local = vertexIndex % 6u;

  let angle0 = f32(segment) * TWO_PI / f32(RING_SEGMENTS);
  let angle1 = f32(segment + 1u) * TWO_PI / f32(RING_SEGMENTS);

  // 6 vertices per segment: 2 triangles forming a trapezoid
  //   Tri 1: (inner,a0), (outer,a0), (inner,a1)
  //   Tri 2: (inner,a1), (outer,a0), (outer,a1)
  var r: f32;
  var angle: f32;
  switch (local) {
    case 0u: { r = innerR; angle = angle0; }
    case 1u: { r = outerR; angle = angle0; }
    case 2u: { r = innerR; angle = angle1; }
    case 3u: { r = innerR; angle = angle1; }
    case 4u: { r = outerR; angle = angle0; }
    default: { r = outerR; angle = angle1; }
  }

  let worldX = centerX + r * cos(angle);
  let worldY = centerY + r * sin(angle);

  // World \u{2192} texture clip (screen-aligned)
  let clip = (params.worldToTexClip * vec3<f32>(worldX, worldY, 1.0)).xy;

  var out: VertexOutput;
  out.position = vec4<f32>(clip, 0.0, 1.0);
  out.worldPos = vec2<f32>(worldX, worldY);
  out.instanceIndex = instanceIndex;
  return out;
}

// Modifier type discriminators
const MODIFIER_TYPE_WAKE: u32 = 1u;
const MODIFIER_TYPE_RIPPLE: u32 = 2u;
const MODIFIER_TYPE_FOAM: u32 = 5u;

@fragment
fn fs_main(in: VertexOutput) -> @location(0) vec4<f32> {
  let base = in.instanceIndex * params.floatsPerModifier;
  let modType = u32(modifiers[base + 0u]);

  switch (modType) {
    case MODIFIER_TYPE_WAKE: {
      return computeWake(in.worldPos, base);
    }
    case MODIFIER_TYPE_RIPPLE: {
      return computeRipple(in.worldPos, base);
    }
    case MODIFIER_TYPE_FOAM: {
      return computeFoam(in.worldPos, base);
    }
    default: {
      return vec4<f32>(0.0, 0.0, 0.0, 0.0);
    }
  }
}

fn computeWake(worldPos: vec2<f32>, base: u32) -> vec4<f32> {
  let srcX = modifiers[base + 5u];
  let srcY = modifiers[base + 6u];
  let ringRadius = modifiers[base + 7u];
  let ringWidth = modifiers[base + 8u];
  let amplitude = modifiers[base + 9u];

  let dx = worldPos.x - srcX;
  let dy = worldPos.y - srcY;
  let dist = sqrt(dx * dx + dy * dy);

  let distFromRing = dist - ringRadius;
  let ring = exp(-(distFromRing * distFromRing) / (ringWidth * ringWidth));

  // Wake is height-only \u{2014} turbulence is the Foam modifier's job.
  return vec4<f32>(amplitude * ring, 0.0, 0.0, 0.0);
}

fn computeFoam(worldPos: vec2<f32>, base: u32) -> vec4<f32> {
  let srcX = modifiers[base + 5u];
  let srcY = modifiers[base + 6u];
  let radius = modifiers[base + 7u];
  let intensity = modifiers[base + 8u];

  let dx = worldPos.x - srcX;
  let dy = worldPos.y - srcY;
  let dist2 = dx * dx + dy * dy;
  let rSq = max(radius * radius, 1e-4);

  let falloff = exp(-dist2 / rSq);
  return vec4<f32>(0.0, 0.0, 0.0, intensity * falloff);
}

fn computeRipple(worldPos: vec2<f32>, base: u32) -> vec4<f32> {
  let radius = modifiers[base + 5u];
  let intensity = modifiers[base + 6u];
  let phase = modifiers[base + 7u];

  let minX = modifiers[base + 1u];
  let minY = modifiers[base + 2u];
  let maxX = modifiers[base + 3u];
  let maxY = modifiers[base + 4u];
  let centerX = (minX + maxX) * 0.5;
  let centerY = (minY + maxY) * 0.5;
  let dx = worldPos.x - centerX;
  let dy = worldPos.y - centerY;
  let dist = sqrt(dx * dx + dy * dy);

  let ringWidth = 2.0;
  let distFromRing = abs(dist - radius);
  let falloff = max(0.0, 1.0 - distFromRing / ringWidth);
  let height = intensity * falloff * cos(phase);

  return vec4<f32>(height, 0.0, 0.0, 0.0);
}
`;
class $12d54cf0e8ceaf5c$export$f5aa9a4020b2444d {
    constructor(device){
        this.pipeline = null;
        this.uniformBuffer = null;
        this.uniforms = $12d54cf0e8ceaf5c$var$ModifierRasterizerUniforms.create();
        this.bindGroupLayout = null;
        this.bindGroup = null;
        this.lastModifiersBuffer = null;
        this.initialized = false;
        this.device = device;
    }
    async init() {
        if (this.initialized) return;
        const device = this.device;
        const shaderModule = device.createShaderModule({
            code: $12d54cf0e8ceaf5c$var$SHADER_CODE,
            label: "Modifier Rasterizer Shader"
        });
        this.bindGroupLayout = device.createBindGroupLayout({
            entries: [
                {
                    binding: 0,
                    visibility: GPUShaderStage.VERTEX | GPUShaderStage.FRAGMENT,
                    buffer: {
                        type: "uniform"
                    }
                },
                {
                    binding: 1,
                    visibility: GPUShaderStage.VERTEX | GPUShaderStage.FRAGMENT,
                    buffer: {
                        type: "read-only-storage"
                    }
                }
            ],
            label: "Modifier Rasterizer Bind Group Layout"
        });
        const pipelineLayout = device.createPipelineLayout({
            bindGroupLayouts: [
                this.bindGroupLayout
            ],
            label: "Modifier Rasterizer Pipeline Layout"
        });
        this.pipeline = device.createRenderPipeline({
            layout: pipelineLayout,
            vertex: {
                module: shaderModule,
                entryPoint: "vs_main"
            },
            fragment: {
                module: shaderModule,
                entryPoint: "fs_main",
                targets: [
                    {
                        format: "rgba16float",
                        blend: {
                            color: {
                                srcFactor: "one",
                                dstFactor: "one",
                                operation: "add"
                            },
                            alpha: {
                                srcFactor: "one",
                                dstFactor: "one",
                                operation: "max"
                            }
                        }
                    }
                ]
            },
            primitive: {
                topology: "triangle-list"
            },
            label: "Modifier Rasterizer Pipeline"
        });
        this.uniformBuffer = device.createBuffer({
            size: $12d54cf0e8ceaf5c$var$ModifierRasterizerUniforms.byteSize,
            usage: GPUBufferUsage.UNIFORM | GPUBufferUsage.COPY_DST,
            label: "Modifier Rasterizer Uniforms"
        });
        this.initialized = true;
    }
    /**
   * Render modifier contributions to the modifier texture.
   *
   * @param encoder - Command encoder to record into
   * @param modifiersBuffer - Storage buffer with modifier data (from WaterResources)
   * @param modifierCount - Number of active modifiers
   * @param worldToTexClip - World → texture clip transform (screen-aligned)
   * @param texture - Target rgba16float 2D texture
   * @param gpuProfiler - Optional GPU profiler for timing
   */ render(encoder, modifiersBuffer, modifierCount, worldToTexClip, texture, gpuProfiler) {
        if (!this.initialized || !this.pipeline || !this.uniformBuffer || !this.bindGroupLayout) return;
        // Update uniforms
        this.uniforms.set.worldToTexClip(worldToTexClip);
        this.uniforms.set.modifierCount(modifierCount);
        this.uniforms.set.floatsPerModifier((0, $cb7a1399420ef9b3$export$e66a374ba39daa3c));
        this.uniforms.uploadTo(this.uniformBuffer);
        // Rebuild bind group if buffer changed
        if (this.lastModifiersBuffer !== modifiersBuffer) {
            this.bindGroup = this.device.createBindGroup({
                layout: this.bindGroupLayout,
                entries: [
                    {
                        binding: 0,
                        resource: {
                            buffer: this.uniformBuffer
                        }
                    },
                    {
                        binding: 1,
                        resource: {
                            buffer: modifiersBuffer
                        }
                    }
                ],
                label: "Modifier Rasterizer Bind Group"
            });
            this.lastModifiersBuffer = modifiersBuffer;
        }
        if (!this.bindGroup) return;
        const textureView = texture.createView({
            label: "Modifier Texture Render Target"
        });
        const renderPass = encoder.beginRenderPass({
            colorAttachments: [
                {
                    view: textureView,
                    clearValue: {
                        r: 0.0,
                        g: 0.0,
                        b: 0.0,
                        a: 0.0
                    },
                    loadOp: "clear",
                    storeOp: "store"
                }
            ],
            timestampWrites: gpuProfiler?.getTimestampWrites("surface.modifiers"),
            label: "Modifier Rasterization Pass"
        });
        renderPass.setPipeline(this.pipeline);
        renderPass.setBindGroup(0, this.bindGroup);
        if (modifierCount > 0) renderPass.draw(48, modifierCount); // RING_SEGMENTS * 6
        renderPass.end();
    }
    destroy() {
        this.uniformBuffer?.destroy();
        this.uniformBuffer = null;
        this.pipeline = null;
        this.bindGroup = null;
        this.bindGroupLayout = null;
        this.lastModifiersBuffer = null;
        this.initialized = false;
    }
}


/**
 * Terrain Composite Fullscreen Shader
 *
 * Renders above-water terrain (sand, rock, snow) into the scene color target.
 * Runs after the boat layer but before the water filter pass. Pixels where
 * waterDepth >= 0 are discarded — the water filter handles those.
 *
 * Depth test is greater-equal so boat pixels (higher z) already written to
 * the depth buffer correctly block terrain draws.
 */ 


/**
 * Procedural terrain surface rendering shader module.
 *
 * Replaces the flat sand renderer with biome-aware terrain coloring
 * based on elevation zones, slope, noise variation, and optional snow.
 *
 * Scene-lighting values (sun direction, sun color) come from the caller's
 * uniform buffer — populated once per frame by `TimeOfDay`.
 */ /**
 * Noise function shader modules.
 */ const $29eb555f6f6dd288$export$d30c1ef1b1de4c71 = {
    code: /*wgsl*/ `
    // Internal helper functions for simplex3D
    fn _simplex3D_mod289_vec3(x: vec3<f32>) -> vec3<f32> {
      return x - floor(x * (1.0 / 289.0)) * 289.0;
    }

    fn _simplex3D_mod289_vec4(x: vec4<f32>) -> vec4<f32> {
      return x - floor(x * (1.0 / 289.0)) * 289.0;
    }

    fn _simplex3D_permute(x: vec4<f32>) -> vec4<f32> {
      return _simplex3D_mod289_vec4(((x * 34.0) + 10.0) * x);
    }

    fn _simplex3D_taylorInvSqrt(r: vec4<f32>) -> vec4<f32> {
      return 1.79284291400159 - 0.85373472095314 * r;
    }

    fn simplex3D(v: vec3<f32>) -> f32 {
      let C = vec2<f32>(1.0 / 6.0, 1.0 / 3.0);
      let D = vec4<f32>(0.0, 0.5, 1.0, 2.0);

      // First corner
      var i = floor(v + dot(v, C.yyy));
      let x0 = v - i + dot(i, C.xxx);

      // Other corners
      let g = step(x0.yzx, x0.xyz);
      let l = 1.0 - g;
      let i1 = min(g.xyz, l.zxy);
      let i2 = max(g.xyz, l.zxy);

      let x1 = x0 - i1 + C.xxx;
      let x2 = x0 - i2 + C.yyy;
      let x3 = x0 - D.yyy;

      // Permutations
      i = _simplex3D_mod289_vec3(i);
      let p = _simplex3D_permute(_simplex3D_permute(_simplex3D_permute(
          i.z + vec4<f32>(0.0, i1.z, i2.z, 1.0))
        + i.y + vec4<f32>(0.0, i1.y, i2.y, 1.0))
        + i.x + vec4<f32>(0.0, i1.x, i2.x, 1.0));

      // Gradients
      let n_ = 0.142857142857; // 1.0/7.0
      let ns = n_ * D.wyz - D.xzx;

      let j = p - 49.0 * floor(p * ns.z * ns.z);

      let x_ = floor(j * ns.z);
      let y_ = floor(j - 7.0 * x_);

      let x = x_ * ns.x + ns.yyyy;
      let y = y_ * ns.x + ns.yyyy;
      let h = 1.0 - abs(x) - abs(y);

      let b0 = vec4<f32>(x.xy, y.xy);
      let b1 = vec4<f32>(x.zw, y.zw);

      let s0 = floor(b0) * 2.0 + 1.0;
      let s1 = floor(b1) * 2.0 + 1.0;
      let sh = -step(h, vec4<f32>(0.0));

      let a0 = b0.xzyw + s0.xzyw * sh.xxyy;
      let a1 = b1.xzyw + s1.xzyw * sh.zzww;

      var p0 = vec3<f32>(a0.xy, h.x);
      var p1 = vec3<f32>(a0.zw, h.y);
      var p2 = vec3<f32>(a1.xy, h.z);
      var p3 = vec3<f32>(a1.zw, h.w);

      // Normalise gradients
      let norm = _simplex3D_taylorInvSqrt(vec4<f32>(dot(p0, p0), dot(p1, p1), dot(p2, p2), dot(p3, p3)));
      p0 = p0 * norm.x;
      p1 = p1 * norm.y;
      p2 = p2 * norm.z;
      p3 = p3 * norm.w;

      // Mix final noise value
      var m = max(0.6 - vec4<f32>(dot(x0, x0), dot(x1, x1), dot(x2, x2), dot(x3, x3)), vec4<f32>(0.0));
      m = m * m;
      return 42.0 * dot(m * m, vec4<f32>(dot(p0, x0), dot(p1, x1), dot(p2, x2), dot(p3, x3)));
    }
  `
};
const $29eb555f6f6dd288$export$2bac5e86bca46ddd = {
    dependencies: [
        $29eb555f6f6dd288$export$d30c1ef1b1de4c71
    ],
    code: /*wgsl*/ `
    fn fractalNoise3D(pos: vec3<f32>) -> f32 {
      var n = 0.0;
      var amp = 0.5;
      var p = pos;
      for (var i = 0; i < 4; i++) {
        n += amp * simplex3D(p);
        p *= 2.0;
        amp *= 0.5;
      }
      return n;
    }
  `
};


const $bcac5e7a37891377$export$ddb28a895b5d55ab = {
    preamble: /*wgsl*/ `
    struct BiomeZone {
      colorAndHeight: vec4<f32>,
      altColorAndBlend: vec4<f32>,
    }

    struct BiomeParams {
      zones: array<BiomeZone, 6>,
      rockColorAndThreshold: vec4<f32>,
      snowColorAndLine: vec4<f32>,
      noiseScales: vec2<f32>,
      zoneCount: u32,
      _pad: u32,
    }
  `,
    bindings: {
        biomeParams: {
            type: "uniform",
            wgslType: "BiomeParams"
        }
    },
    code: /*wgsl*/ `
    // Render terrain surface with biome-based coloring.
    // height: terrain height (world units, feet)
    // normal: surface normal
    // worldPos: world position (for noise sampling)
    // wetness: wetness factor (0.0 = dry, 1.0 = wet)
    // sunDir: normalized direction toward the sun (from scene lighting)
    // sunColor: direct sunlight RGB \u{2014} (0,0,0) at night
    // skyColor: ambient sky/moonlight RGB \u{2014} bluish at day, dim blue at night
    // Returns RGB color.
    fn renderTerrain(
      height: f32,
      normal: vec3<f32>,
      worldPos: vec2<f32>,
      wetness: f32,
      sunDir: vec3<f32>,
      sunColor: vec3<f32>,
      skyColor: vec3<f32>,
    ) -> vec3<f32> {
      let zoneCount = biomeParams.zoneCount;

      // Multi-scale noise for zone boundary perturbation and within-zone variation.
      // Use different z-offsets so the two noise fields are uncorrelated.
      let largeNoise = simplex3D(vec3<f32>(worldPos * biomeParams.noiseScales.x, 0.0));
      let smallNoise = simplex3D(vec3<f32>(worldPos * biomeParams.noiseScales.y, 3.7));

      // Remap noise from [-1,1] to [0,1]
      let largeNoiseT = largeNoise * 0.5 + 0.5;

      // Find the zone this height falls in, with noise-perturbed boundaries.
      var zoneIdx = 0u;
      for (var i = 0u; i < zoneCount; i = i + 1u) {
        let boundary = biomeParams.zones[i].colorAndHeight.w;
        let perturbAmount = min(boundary * 0.15, 15.0);
        let perturbedBoundary = boundary + largeNoise * perturbAmount;
        if (height < perturbedBoundary) {
          zoneIdx = i;
          break;
        }
        zoneIdx = i;
      }

      // Compute color for a zone with noise variation
      let zone = biomeParams.zones[zoneIdx];
      let baseColor = zone.colorAndHeight.rgb;
      let altColor = zone.altColorAndBlend.rgb;
      let noiseBlend = zone.altColorAndBlend.w;
      var color = mix(baseColor, altColor, largeNoiseT * noiseBlend);

      // Blend with the zone below at the lower boundary.
      // Measure how far above the lower boundary we are and fade toward it.
      if (zoneIdx > 0u) {
        let lowerBoundary = biomeParams.zones[zoneIdx - 1u].colorAndHeight.w;
        let perturbAmount = min(lowerBoundary * 0.15, 15.0);
        let perturbedLower = lowerBoundary + largeNoise * perturbAmount;
        let distAboveLower = height - perturbedLower;
        let transitionWidth = max(lowerBoundary * 0.3, 8.0);
        if (distAboveLower < transitionWidth) {
          let t = smoothstep(0.0, 1.0, distAboveLower / transitionWidth);
          let prevZone = biomeParams.zones[zoneIdx - 1u];
          let prevColor = mix(prevZone.colorAndHeight.rgb, prevZone.altColorAndBlend.rgb, largeNoiseT * prevZone.altColorAndBlend.w);
          color = mix(prevColor, color, t);
        }
      }

      // Slope-dependent rock exposure
      let slope = 1.0 - normal.z;
      let rockThreshold = biomeParams.rockColorAndThreshold.w;
      let rockBlend = smoothstep(rockThreshold - 0.1, rockThreshold + 0.1, slope);
      color = mix(color, biomeParams.rockColorAndThreshold.rgb, rockBlend);

      // Snow above snowline (if enabled)
      let snowline = biomeParams.snowColorAndLine.w;
      if (snowline >= 0.0) {
        // Noise-perturbed snowline
        let snowNoise = largeNoise * 20.0;
        var snowBlend = smoothstep(snowline - 10.0, snowline + 10.0, height + snowNoise);
        // Reduce snow on steep slopes (snow slides off cliffs)
        let slopeSnowReduction = smoothstep(0.3, 0.6, slope);
        snowBlend = snowBlend * (1.0 - slopeSnowReduction);
        color = mix(color, biomeParams.snowColorAndLine.rgb, snowBlend);
      }

      // Wetness darkening near waterline
      let visualWetness = pow(wetness, 2.5);
      let wetColor = color * 0.75;
      color = mix(color, wetColor, visualWetness);

      // Ambient (sky) + directional (sun\xb7normal) illumination. Sky provides
      // the cool-blue moonlit floor at night; sun adds warm directional
      // brightness during the day.
      let diffuse = max(dot(normal, sunDir), 0.0);
      let ambient = 0.5;
      let illumination = skyColor * ambient + sunColor * diffuse;
      return color * illumination;
    }
  `,
    dependencies: [
        (0, $29eb555f6f6dd288$export$d30c1ef1b1de4c71)
    ]
};



/**
 * Integer-pixel margin around the screen for the surface-rendering textures
 * (terrain height, water height, wave field, boat air, modifier, wetness).
 *
 * All surface textures are sized (screenWidth + 2*margin) × (screenHeight +
 * 2*margin). Screen pixel (i, j) maps to texture texel (i + margin, j +
 * margin) — an integer offset, no scaling. Keeping the two grids exactly
 * aligned means downstream passes can point-sample the water height at the
 * fragment's exact pixel, which eliminates the linear-filter halo at sharp
 * discontinuities (most visibly the boat outline).
 *
 * The margin itself provides:
 *   • Finite-difference normal computation in WaterFilter/TerrainComposite
 *     valid samples past the screen edge (~4 pixels needed).
 *   • Wetness reprojection a budget of off-screen data to pull from when the
 *     camera pans. Beyond the margin, the wetness shader falls back to the
 *     "new area entering viewport" initialization — still correct, just
 *     without temporal smoothing across the reset.
 */ const $f1d767035e355263$export$c4411bf1f7186f47 = 32;


const $d97c0317de9871e7$var$terrainCompositeParamsModule = {
    preamble: /*wgsl*/ `
struct Params {
  // clip \u{2192} world for the actual screen
  cameraMatrix: mat3x3<f32>,

  screenWidth: f32,
  screenHeight: f32,
  pixelRatio: f32,
  tideHeight: f32,
  hasTerrainData: i32,

  atlasTileSize: u32,
  atlasTilesX: u32,
  atlasTilesY: u32,
  atlasWorldUnitsPerTile: f32,

  // Scene lighting \u{2014} populated from TimeOfDay on the CPU each frame.
  ${(0, $07d5066b6e7a4428$export$750bd88a1db58bed)}
}
`,
    bindings: {
        params: {
            type: "uniform",
            wgslType: "Params"
        },
        terrainTileAtlas: {
            type: "texture",
            viewDimension: "2d",
            sampleType: "unfilterable-float"
        },
        wetnessTexture: {
            type: "texture",
            viewDimension: "2d",
            sampleType: "unfilterable-float"
        }
    },
    code: ""
};
const $d97c0317de9871e7$var$terrainCompositeVertexModule = {
    code: /*wgsl*/ `
struct VertexOutput {
  @builtin(position) position: vec4<f32>,
  @location(0) clipPosition: vec2<f32>,
}

@vertex
fn vs_main(@location(0) position: vec2<f32>) -> VertexOutput {
  var output: VertexOutput;
  output.position = vec4<f32>(position, 0.0, 1.0);
  output.clipPosition = position;
  return output;
}
`
};
const $d97c0317de9871e7$var$terrainCompositeFragmentModule = {
    dependencies: [
        $d97c0317de9871e7$var$terrainCompositeVertexModule,
        $d97c0317de9871e7$var$terrainCompositeParamsModule,
        (0, $29eb555f6f6dd288$export$d30c1ef1b1de4c71),
        (0, $bcac5e7a37891377$export$ddb28a895b5d55ab)
    ],
    code: /*wgsl*/ `
fn clipToWorld(clipPos: vec2<f32>) -> vec2<f32> {
  let world = params.cameraMatrix * vec3<f32>(clipPos, 1.0);
  return world.xy;
}

// Logical pixel (i,j) \u{2192} wetness texel (i+M, j+M). The wetness texture shares
// the surface-texture layout: logical + 2*margin with pixel-aligned texels.
fn sampleWetnessAtLogical(logicalCoord: vec2<i32>) -> f32 {
  let t = logicalCoord + vec2<i32>(SURFACE_TEXTURE_MARGIN, SURFACE_TEXTURE_MARGIN);
  return textureLoad(wetnessTexture, t, 0).r;
}

// Manual bilinear sample of terrain tile atlas (r32float is unfilterable).
fn sampleTerrainHeightBilinear(worldPos: vec2<f32>) -> f32 {
  let worldUnitsPerTile = params.atlasWorldUnitsPerTile;
  let tileSize = params.atlasTileSize;

  let tileX = floor(worldPos.x / worldUnitsPerTile);
  let tileY = floor(worldPos.y / worldUnitsPerTile);

  let localX = (worldPos.x - tileX * worldUnitsPerTile) / worldUnitsPerTile * f32(tileSize);
  let localY = (worldPos.y - tileY * worldUnitsPerTile) / worldUnitsPerTile * f32(tileSize);

  let slotX = i32(tileX) % i32(params.atlasTilesX);
  let slotY = i32(tileY) % i32(params.atlasTilesY);
  let wrappedSlotX = u32(select(slotX, slotX + i32(params.atlasTilesX), slotX < 0));
  let wrappedSlotY = u32(select(slotY, slotY + i32(params.atlasTilesY), slotY < 0));

  let px = floor(localX - 0.5);
  let py = floor(localY - 0.5);
  let fx = localX - 0.5 - px;
  let fy = localY - 0.5 - py;

  let px0 = u32(clamp(px, 0.0, f32(tileSize - 1)));
  let py0 = u32(clamp(py, 0.0, f32(tileSize - 1)));
  let px1 = u32(clamp(px + 1.0, 0.0, f32(tileSize - 1)));
  let py1 = u32(clamp(py + 1.0, 0.0, f32(tileSize - 1)));

  let baseX = wrappedSlotX * tileSize;
  let baseY = wrappedSlotY * tileSize;

  let h00 = textureLoad(terrainTileAtlas, vec2<i32>(i32(baseX + px0), i32(baseY + py0)), 0).r;
  let h10 = textureLoad(terrainTileAtlas, vec2<i32>(i32(baseX + px1), i32(baseY + py0)), 0).r;
  let h01 = textureLoad(terrainTileAtlas, vec2<i32>(i32(baseX + px0), i32(baseY + py1)), 0).r;
  let h11 = textureLoad(terrainTileAtlas, vec2<i32>(i32(baseX + px1), i32(baseY + py1)), 0).r;

  let h0 = mix(h00, h10, fx);
  let h1 = mix(h01, h11, fx);
  return mix(h0, h1, fy);
}

fn sampleTerrainHeight(worldPos: vec2<f32>) -> f32 {
  return sampleTerrainHeightBilinear(worldPos);
}

fn computeTerrainNormal(worldPos: vec2<f32>) -> vec3<f32> {
  // World-space eps \u{2248} 2 screen pixels. cameraMatrix[0].xy is the world vector
  // for one clip-X unit; clip spans 2 units across screenWidth pixels.
  let eps = length(params.cameraMatrix[0].xy) * 4.0 / params.screenWidth;

  let hL = sampleTerrainHeight(worldPos + vec2<f32>(-eps, 0.0));
  let hR = sampleTerrainHeight(worldPos + vec2<f32>(eps, 0.0));
  let hD = sampleTerrainHeight(worldPos + vec2<f32>(0.0, -eps));
  let hU = sampleTerrainHeight(worldPos + vec2<f32>(0.0, eps));

  let dx = (hR - hL) / (2.0 * eps);
  let dy = (hU - hD) / (2.0 * eps);

  return normalize(vec3<f32>(-dx, -dy, 1.0));
}

const Z_MIN: f32 = ${(0, $5453fd34f01ad367$export$738c420ee12b9cdb)};
const Z_MAX: f32 = ${(0, $5453fd34f01ad367$export$e06187491332e57c)};

// Integer offset from screen pixel to surface-texture texel. See
// SurfaceConstants.ts.
const SURFACE_TEXTURE_MARGIN: i32 = ${(0, $f1d767035e355263$export$c4411bf1f7186f47)};

fn mapZToDepth(z: f32) -> f32 {
  return (z - Z_MIN) / (Z_MAX - Z_MIN);
}

struct FragmentOutput {
  @location(0) color: vec4<f32>,
  @builtin(frag_depth) depth: f32,
}

@fragment
fn fs_main(@builtin(position) fragPos: vec4<f32>, @location(0) clipPosition: vec2<f32>) -> FragmentOutput {
  let worldPos = clipToWorld(clipPosition);
  // fragPos.xy is in physical framebuffer pixels; convert to logical pixel
  // coords to index the logical-sized wetness texture.
  let logicalCoord = vec2<i32>(fragPos.xy / params.pixelRatio);

  // Nothing to draw if the level has no terrain at all.
  if (params.hasTerrainData == 0) {
    discard;
  }

  // Render terrain at every pixel (both above AND below water). The water
  // filter reads the color + depth and applies absorption for submerged
  // pixels; without terrain color/depth here it would treat underwater
  // pixels as infinitely deep and all depths would look the same.
  let terrainHeight = sampleTerrainHeight(worldPos);
  let terrainNormal = computeTerrainNormal(worldPos);
  let wetness = sampleWetnessAtLogical(logicalCoord);

  let finalColor = renderTerrain(
    terrainHeight,
    terrainNormal,
    worldPos,
    wetness,
    params.sunDirection,
    params.sunColor,
    params.skyColor,
  );

  var out: FragmentOutput;
  out.color = vec4<f32>(finalColor, 1.0);
  out.depth = mapZToDepth(terrainHeight);
  return out;
}
`
};
const $d97c0317de9871e7$var$terrainCompositeShaderConfig = {
    modules: [
        $d97c0317de9871e7$var$terrainCompositeFragmentModule
    ],
    label: "TerrainCompositeShader",
    // Opaque — terrain owns every above-water pixel it writes.
    // No blendState means no color blending (default overwrite).
    depthStencilState: {
        format: "depth24plus",
        // Boat pixels that are higher in z were written first and will block
        // terrain pixels underneath them from being drawn.
        depthCompare: "greater-equal",
        depthWriteEnabled: true
    }
};
function $d97c0317de9871e7$export$3c452f8d5ad6e480() {
    return new (0, $c43b1a1e19bbbf4b$export$b176bfba5cd328c9)($d97c0317de9871e7$var$terrainCompositeShaderConfig);
}


/**
 * Uniform buffer definition for the Terrain Composite shader.
 *
 * Renders above-water terrain (sand, rock, snow) into the scene color target
 * before the water filter pass.
 */ 

const $958e0ac08c7b3345$export$2658b319af430064 = (0, $ca6793d1abd58997$export$99bb2281c7368d10)("Params", {
    // Clip → world for the actual screen (used for world-position reconstruction).
    cameraMatrix: (0, $ca6793d1abd58997$export$a9b01fc77c97438b),
    // Screen dimensions (logical/CSS pixels)
    screenWidth: (0, $ca6793d1abd58997$export$e33361ff41014190),
    screenHeight: (0, $ca6793d1abd58997$export$e33361ff41014190),
    // Device pixel ratio — the fragment shader's fragPos.xy is in physical
    // framebuffer pixels, but the surface textures are sized at logical+margin
    // resolution. Divide fragPos.xy by this to get logical pixel coords.
    pixelRatio: (0, $ca6793d1abd58997$export$e33361ff41014190),
    tideHeight: (0, $ca6793d1abd58997$export$e33361ff41014190),
    hasTerrainData: (0, $ca6793d1abd58997$export$b71748db06371c77),
    // Terrain tile atlas parameters
    atlasTileSize: (0, $ca6793d1abd58997$export$8bacf4ad828c7fe7),
    atlasTilesX: (0, $ca6793d1abd58997$export$8bacf4ad828c7fe7),
    atlasTilesY: (0, $ca6793d1abd58997$export$8bacf4ad828c7fe7),
    atlasWorldUnitsPerTile: (0, $ca6793d1abd58997$export$e33361ff41014190),
    // Scene lighting (see SceneLighting.ts). Populated from TimeOfDay.
    ...(0, $07d5066b6e7a4428$export$d4ca37c4b9500695)
});


/**
 * Terrain Screen Compute Shader
 *
 * Samples terrain height from the tile atlas and writes to a screen-space
 * r32float texture. This runs before WaterHeightShader so that water
 * calculations can access terrain height for refraction and shoaling.
 *
 * Input: Terrain tile atlas (from LODTerrainTileCache)
 * Output: Screen-space terrain height texture (r32float)
 */ 
const $a2e50d56dea5829d$var$WORKGROUP_SIZE = [
    8,
    8
];
/**
 * Params module with uniforms and bindings for terrain screen computation.
 */ const $a2e50d56dea5829d$var$terrainScreenParamsModule = {
    preamble: /*wgsl*/ `
// Terrain screen computation parameters
struct Params {
  // clip \u{2192} world for this texture (screen-aligned, rotation-aware, includes margin)
  texClipToWorld: mat3x3<f32>,

  textureWidth: f32,
  textureHeight: f32,

  // Terrain tile atlas parameters
  atlasTileSize: u32,
  atlasTilesX: u32,
  atlasTilesY: u32,
  atlasWorldUnitsPerTile: f32,
}
`,
    bindings: {
        params: {
            type: "uniform",
            wgslType: "Params"
        },
        terrainTileAtlas: {
            type: "texture",
            viewDimension: "2d",
            sampleType: "unfilterable-float"
        },
        outputTexture: {
            type: "storageTexture",
            format: "r32float"
        }
    },
    code: ""
};
/**
 * Main compute module for terrain screen pass.
 */ const $a2e50d56dea5829d$var$terrainScreenComputeModule = {
    dependencies: [
        $a2e50d56dea5829d$var$terrainScreenParamsModule
    ],
    code: /*wgsl*/ `
// Convert pixel coordinates to world position via the texture's clip\u{2192}world
// matrix. Texel (x,y) center maps to clip (2*(x+0.5)/W - 1, 1 - 2*(y+0.5)/H).
fn pixelToWorld(pixel: vec2<u32>) -> vec2<f32> {
  let uv = vec2<f32>(
    (f32(pixel.x) + 0.5) / params.textureWidth,
    (f32(pixel.y) + 0.5) / params.textureHeight
  );
  let clip = vec2<f32>(uv.x * 2.0 - 1.0, 1.0 - uv.y * 2.0);
  return (params.texClipToWorld * vec3<f32>(clip, 1.0)).xy;
}

// Sample terrain height from tile atlas
// This logic matches SurfaceCompositeShader.sampleTerrainHeight
fn sampleTerrainHeight(worldPos: vec2<f32>) -> f32 {
  // Convert world position to tile coordinates
  let worldUnitsPerTile = params.atlasWorldUnitsPerTile;
  let tileSize = params.atlasTileSize;

  // Calculate which tile this world position is in
  let tileX = floor(worldPos.x / worldUnitsPerTile);
  let tileY = floor(worldPos.y / worldUnitsPerTile);

  // Calculate position within the tile (0-1)
  // Clamp to [0, 1) to handle floating point precision at boundaries
  let localX = clamp((worldPos.x - tileX * worldUnitsPerTile) / worldUnitsPerTile, 0.0, 0.999999);
  let localY = clamp((worldPos.y - tileY * worldUnitsPerTile) / worldUnitsPerTile, 0.0, 0.999999);

  // Calculate atlas slot from tile coordinates using modulo for wrapping
  // This gives us the slot that would contain this tile if it's cached
  let slotX = i32(tileX) % i32(params.atlasTilesX);
  let slotY = i32(tileY) % i32(params.atlasTilesY);

  // Handle negative coordinates (WGSL % can return negative values)
  let wrappedSlotX = u32(select(slotX, slotX + i32(params.atlasTilesX), slotX < 0));
  let wrappedSlotY = u32(select(slotY, slotY + i32(params.atlasTilesY), slotY < 0));

  // Calculate pixel coordinates within the tile, then offset to atlas position
  // Use the same mapping as the tile shader: pixel i -> world (i/tileSize)
  // So world -> pixel is: localX * tileSize, clamped to valid pixel range
  let pixelInTileX = min(u32(localX * f32(tileSize)), tileSize - 1u);
  let pixelInTileY = min(u32(localY * f32(tileSize)), tileSize - 1u);

  let atlasPixelX = wrappedSlotX * tileSize + pixelInTileX;
  let atlasPixelY = wrappedSlotY * tileSize + pixelInTileY;

  let texCoord = vec2<i32>(i32(atlasPixelX), i32(atlasPixelY));
  return textureLoad(terrainTileAtlas, texCoord, 0).r;
}

@compute @workgroup_size(${$a2e50d56dea5829d$var$WORKGROUP_SIZE[0]}, ${$a2e50d56dea5829d$var$WORKGROUP_SIZE[1]})
fn main(@builtin(global_invocation_id) global_id: vec3<u32>) {
  let pixel = global_id.xy;

  // Bounds check
  if (pixel.x >= u32(params.textureWidth) || pixel.y >= u32(params.textureHeight)) {
    return;
  }

  let worldPos = pixelToWorld(pixel);
  let terrainHeight = sampleTerrainHeight(worldPos);

  // Write to output texture
  textureStore(outputTexture, pixel, vec4<f32>(terrainHeight, 0.0, 0.0, 0.0));
}
`
};
const $a2e50d56dea5829d$var$terrainScreenShaderConfig = {
    modules: [
        $a2e50d56dea5829d$var$terrainScreenComputeModule
    ],
    workgroupSize: $a2e50d56dea5829d$var$WORKGROUP_SIZE,
    label: "TerrainScreenShader"
};
function $a2e50d56dea5829d$export$4bca3e109b584d8b() {
    return new (0, $4016c3d8f65071ed$export$cdde5429dd049099)($a2e50d56dea5829d$var$terrainScreenShaderConfig);
}


/**
 * Uniform buffer definition for the Terrain Screen compute shader.
 */ 
const $05f4032174e06375$export$5c35225518ffbe66 = (0, $ca6793d1abd58997$export$99bb2281c7368d10)("Params", {
    // Clip-space → world transform for the output texture. Texel (x,y) maps to
    // clip = (2*(x+0.5)/W - 1, 1 - 2*(y+0.5)/H), then world = M * vec3(clip, 1).
    // Covers the screen-aligned expanded viewport (includes rotation).
    texClipToWorld: (0, $ca6793d1abd58997$export$a9b01fc77c97438b),
    // Dimensions of the output texture in texels.
    textureWidth: (0, $ca6793d1abd58997$export$e33361ff41014190),
    textureHeight: (0, $ca6793d1abd58997$export$e33361ff41014190),
    // Terrain tile atlas parameters
    atlasTileSize: (0, $ca6793d1abd58997$export$8bacf4ad828c7fe7),
    atlasTilesX: (0, $ca6793d1abd58997$export$8bacf4ad828c7fe7),
    atlasTilesY: (0, $ca6793d1abd58997$export$8bacf4ad828c7fe7),
    atlasWorldUnitsPerTile: (0, $ca6793d1abd58997$export$e33361ff41014190)
});


/**
 * Water Filter Fullscreen Shader
 *
 * Runs after terrain composite + depth/color copies. Reads the frozen scene
 * color and depth and applies a fully physically-based water model:
 *
 *   T           = exp(-(ABSORPTION + SCATTERING) * submersion)   // vec3
 *   absorbed    = sceneColor * T
 *   inscatter   = skyColor * (SCATTERING / EXTINCTION) * (1 - exp(-EXTINCTION * d))
 *   transmitted = absorbed + inscatter
 *   output      = (1 - F) * transmitted + F * sky + sunColor * specular + foam
 *
 * No hand-tuned color ramps. The water's apparent color falls out of the
 * absorption + scattering spectra applied to the actual scene and sky.
 */ 


/**
 * Water surface lighting module.
 *
 * Physically-based surface reflection at the air-water interface:
 *   - Schlick Fresnel mixing the transmitted light with the sky color
 *   - Direct sun specular highlight
 *
 * The transmitted light (absorbed scene + inscatter) is computed by the
 * caller; this module only handles what happens at the water surface.
 *
 * Scene-lighting values (sun direction, sun color, sky color) come from
 * the caller's uniform buffer — populated once per frame by `TimeOfDay`.
 */ const $ac5315efa56074c0$export$3040863a7ca6c7b2 = {
    code: /*wgsl*/ `
    // Reflectance of the air-water interface at normal incidence.
    // F0 = ((n1 - n2) / (n1 + n2))^2 with n_air = 1.0, n_water = 1.333
    //    \u{2248} 0.0204. Real ocean water at normal incidence reflects ~2%.
    const WATER_F0: f32 = 0.02;

    // Effective sun radiance relative to the tone-mapped sky color. In
    // reality the sun's disc is ~10^4\xd7 the sky's luminance; in LDR we
    // need an explicit scale factor so specular sparkles are visible
    // against the already-bright sky. This is the one "HDR compensation"
    // knob in the otherwise-physical surface model.
    const SUN_INTENSITY: f32 = 12.0;

    // Surface micro-roughness controls how wide the sun glint lobe is.
    // Real water has tiny ripples from wind that spread the mirror
    // reflection over a much wider angle than a perfectly flat surface.
    // Smaller = wider, more sparkle; larger = sharper point highlight.
    // 64 is broad enough that gentle wave slopes light up visibly when
    // viewed from above.
    const WATER_SPECULAR_POWER: f32 = 64.0;

    // Schlick Fresnel approximation. 'facing' is dot(normal, viewDir).
    fn waterFresnel(facing: f32) -> f32 {
      let f = clamp(facing, 0.0, 1.0);
      return WATER_F0 + (1.0 - WATER_F0) * pow(1.0 - f, 5.0);
    }

    // Composite surface lighting: energy-conserving mix of transmitted
    // light and sky reflection via Fresnel, plus direct sun specular.
    //
    //   base = (1 - F) * transmitted + F * sky
    //   spec = F * SUN_INTENSITY * sunColor * pow(n\xb7h, SPECULAR_POWER)
    //   out  = base + spec
    //
    // The specular term scales by F so the Fresnel response still shapes
    // the highlight (brighter toward grazing angles), but SUN_INTENSITY
    // compensates for LDR so sparkles are actually visible.
    fn waterSurfaceLight(
      normal: vec3<f32>,
      viewDir: vec3<f32>,
      transmitted: vec3<f32>,
      sunDir: vec3<f32>,
      sunColor: vec3<f32>,
      skyColor: vec3<f32>,
    ) -> vec3<f32> {
      let facing = max(dot(normal, viewDir), 0.0);
      let F = waterFresnel(facing);

      let base = mix(transmitted, skyColor, F);

      let halfway = normalize(sunDir + viewDir);
      let specAngle = max(dot(normal, halfway), 0.0);
      let specular = pow(specAngle, WATER_SPECULAR_POWER) * F * SUN_INTENSITY;

      return base + sunColor * specular;
    }
  `
};


/**
 * Math utility shader modules.
 *
 * Note: PI, TWO_PI, HALF_PI, and GRAVITY are automatically included
 * by the base Shader class via getMathConstants(). No need to import them.
 */ const $3a1ba48c84b364a2$export$398f807fa131e803 = {
    code: /*wgsl*/ `
    // Hash function for procedural noise (2D -> 1D)
    fn hash21(p: vec2<f32>) -> f32 {
      var q = fract(p * vec2<f32>(234.34, 435.345));
      q = q + dot(q, q + 34.23);
      return fract(q.x * q.y);
    }
  `
};




const $5207256e8fe29dfd$var$waterFilterParamsModule = {
    preamble: /*wgsl*/ `
struct Params {
  // clip \u{2192} world for the actual screen
  cameraMatrix: mat3x3<f32>,
  // world \u{2192} clip for the screen-space water height texture
  worldToTexClip: mat3x3<f32>,

  screenWidth: f32,
  screenHeight: f32,
  pixelRatio: f32,
  time: f32,
  tideHeight: f32,
  hasTerrainData: i32,

  // Bio-optical water chemistry (per level/region)
  chlorophyll: f32,
  cdom: f32,
  sediment: f32,

  // Scene lighting \u{2014} populated from TimeOfDay on the CPU each frame.
  ${(0, $07d5066b6e7a4428$export$750bd88a1db58bed)}
}
`,
    bindings: {
        params: {
            type: "uniform",
            wgslType: "Params"
        },
        sceneColorTexture: {
            type: "texture",
            viewDimension: "2d",
            sampleType: "float"
        },
        sceneDepthTexture: {
            type: "texture",
            viewDimension: "2d",
            sampleType: "depth"
        },
        waterHeightTexture: {
            type: "texture",
            viewDimension: "2d",
            sampleType: "float"
        },
        // Per-boat air gap texture. Encodes bilge surface Z (R), deck cap Z (G),
        // and bilge slosh turbulence (B) at pixels inside any hull footprint;
        // sentinel low outside. Used here — not in the water height compute —
        // so that the water height texture stays a continuous ocean surface
        // and its finite-differenced normal has no cliffs at hull edges.
        boatAirTexture: {
            type: "texture",
            viewDimension: "2d",
            sampleType: "float"
        },
        heightSampler: {
            type: "sampler",
            samplerType: "filtering"
        }
    },
    code: ""
};
const $5207256e8fe29dfd$var$waterFilterVertexModule = {
    code: /*wgsl*/ `
struct VertexOutput {
  @builtin(position) position: vec4<f32>,
  @location(0) clipPosition: vec2<f32>,
}

@vertex
fn vs_main(@location(0) position: vec2<f32>) -> VertexOutput {
  var output: VertexOutput;
  output.position = vec4<f32>(position, 0.0, 1.0);
  output.clipPosition = position;
  return output;
}
`
};
const $5207256e8fe29dfd$var$waterFilterFragmentModule = {
    dependencies: [
        $5207256e8fe29dfd$var$waterFilterVertexModule,
        $5207256e8fe29dfd$var$waterFilterParamsModule,
        (0, $3a1ba48c84b364a2$export$398f807fa131e803),
        (0, $29eb555f6f6dd288$export$d30c1ef1b1de4c71),
        (0, $29eb555f6f6dd288$export$2bac5e86bca46ddd),
        (0, $ac5315efa56074c0$export$3040863a7ca6c7b2)
    ],
    code: /*wgsl*/ `
// ============================================================================
// Bio-optical water model
// ============================================================================
//
// Water optics decompose into contributions from four constituents, each
// with a fixed spectral signature (vec3 per RGB channel, per foot). The
// runtime mixes them using scalar concentrations supplied via uniforms:
//
//   a(\u{3BB}) = a_water(\u{3BB}) + a_phyto(\u{3BB})*C_chl + a_cdom(\u{3BB})*C_cdom + a_part(\u{3BB})*C_sed
//   b(\u{3BB}) = b_water(\u{3BB}) + b_phyto(\u{3BB})*C_chl +                  b_part(\u{3BB})*C_sed
//
// (CDOM is dissolved, doesn't scatter, only absorbs.)
//
// Constants below are physically motivated rough-fits to published IOCCG
// bio-optical data, scaled to per-foot units. They're in the right ballpark
// but tuned by eye for good-looking water at default concentrations.

// --- Pure water (Pope & Fry 1997, scaled to per-foot) ---
// Red absorbs fast; blue barely at all. Nearly zero scattering.
const A_WATER_PURE: vec3<f32> = vec3<f32>(0.20, 0.018, 0.004);
const B_WATER_PURE: vec3<f32> = vec3<f32>(0.0002, 0.0004, 0.0009);

// --- Phytoplankton (per mg/m\xb3 chlorophyll-a) ---
// Absorbs blue (440nm) and red (675nm); transmits green \u{2014} algae look green.
// Scattering is mild and slightly blue-biased.
const A_PHYTO: vec3<f32> = vec3<f32>(0.040, 0.010, 0.030);
const B_PHYTO: vec3<f32> = vec3<f32>(0.003, 0.004, 0.005);

// --- CDOM / yellow substance (per normalized concentration) ---
// Dissolved organic matter \u{2014} exponential decay toward red. Strong blue
// absorber, negligible at red. Gives tea-stained coastal water its
// yellow-brown cast. Does not scatter.
const A_CDOM: vec3<f32> = vec3<f32>(0.001, 0.020, 0.100);

// --- Suspended particles (per normalized concentration) ---
// Sand, silt, resuspended sediment. Scatters strongly and nearly flat
// across wavelengths; absorption is mild.
const A_PARTICLES: vec3<f32> = vec3<f32>(0.015, 0.015, 0.015);
const B_PARTICLES: vec3<f32> = vec3<f32>(0.040, 0.045, 0.050);

struct WaterOptics {
  absorption: vec3<f32>,
  scattering: vec3<f32>,
  extinction: vec3<f32>,
};

// Compute per-pixel water optics from three constituent concentrations.
fn computeWaterOptics(chl: f32, cdom: f32, sediment: f32) -> WaterOptics {
  let a = A_WATER_PURE
        + A_PHYTO * chl
        + A_CDOM * cdom
        + A_PARTICLES * sediment;
  let b = B_WATER_PURE
        + B_PHYTO * chl
        + B_PARTICLES * sediment;
  var optics: WaterOptics;
  optics.absorption = a;
  optics.scattering = b;
  optics.extinction = a + b;
  return optics;
}

const Z_MIN: f32 = ${(0, $5453fd34f01ad367$export$738c420ee12b9cdb)};
const Z_MAX: f32 = ${(0, $5453fd34f01ad367$export$e06187491332e57c)};

// Integer offset from screen pixel to surface-texture texel (texels are
// 1:1 with screen pixels, shifted by this margin). See SurfaceConstants.ts.
const SURFACE_TEXTURE_MARGIN: i32 = ${(0, $f1d767035e355263$export$c4411bf1f7186f47)};

fn mapZToDepth(z: f32) -> f32 {
  return (z - Z_MIN) / (Z_MAX - Z_MIN);
}

fn depthToZ(d: f32) -> f32 {
  return d * (Z_MAX - Z_MIN) + Z_MIN;
}

fn clipToWorld(clipPos: vec2<f32>) -> vec2<f32> {
  let world = params.cameraMatrix * vec3<f32>(clipPos, 1.0);
  return world.xy;
}

// World \u{2192} surface-texture UV. The surface texture is (screen + 2*margin)
// on each axis with a pixel-integer margin, so worldToTexClip maps the
// texture's clip[-1,1] over screen pixel range [-m, W+m]. Used by the
// finite-diff normal sample since eps is non-integer in texel space.
fn worldToHeightUV(worldPos: vec2<f32>) -> vec2<f32> {
  let clip = (params.worldToTexClip * vec3<f32>(worldPos, 1.0)).xy;
  return vec2<f32>((clip.x + 1.0) * 0.5, (1.0 - clip.y) * 0.5);
}

fn sampleWaterData(worldPos: vec2<f32>) -> vec2<f32> {
  let uv = worldToHeightUV(worldPos);
  return textureSampleLevel(waterHeightTexture, heightSampler, uv, 0.0).rg;
}

fn sampleWaterHeight(worldPos: vec2<f32>) -> f32 {
  return sampleWaterData(worldPos).x;
}

fn computeWaterNormal(worldPos: vec2<f32>) -> vec3<f32> {
  // World-space eps \u{2248} 2 screen pixels (see TerrainCompositeShader).
  let eps = length(params.cameraMatrix[0].xy) * 4.0 / params.screenWidth;

  let hL = sampleWaterHeight(worldPos + vec2<f32>(-eps, 0.0));
  let hR = sampleWaterHeight(worldPos + vec2<f32>(eps, 0.0));
  let hD = sampleWaterHeight(worldPos + vec2<f32>(0.0, -eps));
  let hU = sampleWaterHeight(worldPos + vec2<f32>(0.0, eps));

  let dx = (hR - hL) / (2.0 * eps);
  let dy = (hU - hD) / (2.0 * eps);

  return normalize(vec3<f32>(-dx, -dy, 1.0));
}

// Physically motivated inscatter: the amount of sky light scattered toward
// the viewer from a water column of thickness d.
//
// Derivation (uniformly-lit column, simple single-scattering):
//   dL/dz = scattering * L_sky - extinction * L   (radiative transfer)
//   L(d)  = (scattering / extinction) * L_sky * (1 - exp(-extinction * d))
//
// As d \u{2192} \u{221E} this saturates at (scattering / extinction) * L_sky \u{2014} the
// characteristic water color. Shallow water is nearly clear; deep water
// converges to the single-scattering albedo tinted by the sky.
fn waterInscatter(
  skyColor: vec3<f32>,
  scattering: vec3<f32>,
  extinction: vec3<f32>,
  d: f32,
) -> vec3<f32> {
  let albedo = scattering / extinction;
  let columnFraction = vec3<f32>(1.0) - exp(-extinction * d);
  return skyColor * albedo * columnFraction;
}

struct FragmentOutput {
  @location(0) color: vec4<f32>,
  @builtin(frag_depth) depth: f32,
}

@fragment
fn fs_main(@builtin(position) fragPos: vec4<f32>, @location(0) clipPosition: vec2<f32>) -> FragmentOutput {
  let worldPos = clipToWorld(clipPosition);
  let pixelCoord = vec2<i32>(fragPos.xy);

  // Ocean surface data at this pixel \u{2014} point-sampled at the exact texel
  // so the submersion test can't pick up a linearly-interpolated value
  // across a discontinuity. Linear sampling is still used below for
  // finite-diff normals; that's safe now because the water height texture
  // is a continuous ocean surface (no substitution cliffs at hull edges).
  //
  // fragPos.xy is in physical framebuffer pixels; the surface textures are
  // sized at logical + margin, so divide by pixelRatio before offsetting.
  let logicalCoord = vec2<i32>(fragPos.xy / params.pixelRatio);
  let waterTexel = logicalCoord + vec2<i32>(SURFACE_TEXTURE_MARGIN, SURFACE_TEXTURE_MARGIN);
  let waterData = textureLoad(waterHeightTexture, waterTexel, 0).rg;
  let oceanHeight = waterData.x;
  var turbulence = waterData.y;

  // Boat air substitution. BoatAirShader publishes per-pixel air gaps
  // (bilge surface Z in R, deck cap Z in G, bilge turbulence in B) at
  // pixels inside any hull footprint. If the ocean surface would lie
  // inside an air column at this pixel, the effective water surface here
  // is the bilge level \u{2014} substitute it into waterHeight. Outside any
  // hull, R and G are sentinel low so the range test fails and we fall
  // through to the ocean value.
  let airData = textureLoad(boatAirTexture, waterTexel, 0);
  let airMin = airData.r;
  let airMax = airData.g;
  let bilgeTurb = airData.b;
  var waterHeight = oceanHeight;
  if (airMax > airMin && oceanHeight >= airMin && oceanHeight <= airMax) {
    waterHeight = airMin;
    turbulence = bilgeTurb;
  }

  // Scene info from the frozen copies. Z_MIN is deep enough (-100ft) that the
  // depth buffer can represent every terrain/object z we care to distinguish
  // \u{2014} anything clamped to Z_MIN is beyond the underwater visibility horizon
  // and will render as pure water regardless.
  let sceneColor = textureLoad(sceneColorTexture, pixelCoord, 0).rgb;
  let sceneDepthNDC = textureLoad(sceneDepthTexture, pixelCoord, 0);
  let sceneZ = depthToZ(sceneDepthNDC);
  // Depth cleared to 0 (= Z_MIN). Anything drawn lifts it above Z_MIN.
  let scenePresent = sceneZ > (Z_MIN + 0.1);

  let submersion = waterHeight - sceneZ;

  // Foam lit by ambient (sky + sun) so it doesn't glow at night.
  let foamColor = vec3<f32>(0.95, 0.98, 1.0) * (params.skyColor * 0.5 + params.sunColor);

  // Foam from turbulence (wave breaking + wake)
  var turbulenceFoam = 0.0;
  if (turbulence > 0.0) {
    let foamNoise = fractalNoise3D(vec3<f32>(
      worldPos.x * 0.5,
      worldPos.y * 0.5,
      params.time * 0.4
    )) * 0.5 + 0.5;
    let foamCoverage = (1.0 - exp(-turbulence * 1.0)) * 0.7;
    let foamThreshold = 1.0 - foamCoverage;
    turbulenceFoam = smoothstep(foamThreshold - 0.15, foamThreshold, foamNoise) * foamCoverage;
  }

  var finalColor: vec3<f32>;
  var surfaceZ: f32;

  if (scenePresent && submersion <= 0.0) {
    // Scene pixel is above the water surface \u{2014} pass through untouched.
    finalColor = sceneColor;
    surfaceZ = sceneZ;
  } else {
    // Scene pixel is underwater, OR no scene at all (open ocean: treat as
    // infinite depth so the column fully saturates to the water albedo).
    let effectiveSubmersion = select(submersion, 1000.0, !scenePresent);

    // -----------------------------------------------------------------
    // Per-pixel bio-optical modulation
    // -----------------------------------------------------------------
    // Start from the level/region base concentrations and modulate by
    // local conditions:
    //   - shallowFactor: near-bottom water has more resuspended sediment,
    //     more plankton in the photic zone, more shore-runoff CDOM.
    //     Decays exponentially with water column depth.
    //   - turbulenceFactor: breaking waves and wakes stir the bottom,
    //     boosting sediment locally. Turbulence comes from the G channel
    //     of waterHeightTexture (wake/breakers).
    let depthForMod = select(1000.0, max(submersion, 0.0), scenePresent);
    let shallowFactor = 1.0 + 2.0 * exp(-depthForMod * 0.15);
    let turbulenceFactor = 1.0 + 3.0 * turbulence;

    let localChl = params.chlorophyll * shallowFactor;
    let localCdom = params.cdom * shallowFactor;
    let localSediment = params.sediment * shallowFactor * turbulenceFactor;

    let optics = computeWaterOptics(localChl, localCdom, localSediment);
    let extinction = optics.extinction;
    let scattering = optics.scattering;

    // Extinction transmittance per channel: light surviving a direct path
    // from the scene point up to the surface.
    let T = exp(-extinction * effectiveSubmersion);

    // Absorbed scene: scene color multiplied by the wavelength-dependent
    // transmittance. Red dies fastest, blue survives \u{2014} color shifts cyan.
    let absorbed = select(vec3<f32>(0.0), sceneColor * T, scenePresent);

    // Inscatter: sky light scattered by the water column toward the viewer.
    let inscatter = waterInscatter(params.skyColor, scattering, extinction, effectiveSubmersion);

    // Light arriving at the underside of the water surface
    let transmitted = absorbed + inscatter;

    // Surface: Fresnel-weighted mix of transmitted and sky, plus sun specular
    let waterNormal = computeWaterNormal(worldPos);
    let viewDir = vec3<f32>(0.0, 0.0, 1.0);
    finalColor = waterSurfaceLight(
      waterNormal,
      viewDir,
      transmitted,
      params.sunDirection,
      params.sunColor,
      params.skyColor,
    );

    // Shoreline / object-waterline foam: where submersion is tiny.
    // Works uniformly for terrain shores and hull waterlines.
    if (scenePresent) {
      let shorelineThreshold = 0.2;
      if (submersion < shorelineThreshold) {
        let foamIntensity = (1.0 - (submersion / shorelineThreshold)) * 0.7;
        finalColor = mix(finalColor, foamColor, foamIntensity);
      }
    }

    // Turbulence foam layered on top of the water
    finalColor = mix(finalColor, foamColor, turbulenceFoam);

    // Write water surface z to depth so post-water particles sort correctly.
    surfaceZ = max(waterHeight, sceneZ);
  }

  var out: FragmentOutput;
  out.color = vec4<f32>(finalColor, 1.0);
  out.depth = mapZToDepth(surfaceZ);
  return out;
}
`
};
const $5207256e8fe29dfd$var$waterFilterShaderConfig = {
    modules: [
        $5207256e8fe29dfd$var$waterFilterFragmentModule
    ],
    label: "WaterFilterShader",
    // Opaque: no hardware blend. The shader is the compositor — it reads the
    // already-rendered scene from colorCopyTexture and writes the final pixel.
    depthStencilState: {
        format: "depth24plus",
        depthCompare: "always",
        depthWriteEnabled: true
    }
};
function $5207256e8fe29dfd$export$591e5cd40d9ef433() {
    return new (0, $c43b1a1e19bbbf4b$export$b176bfba5cd328c9)($5207256e8fe29dfd$var$waterFilterShaderConfig);
}


/**
 * Uniform buffer definition for the Water Filter shader.
 *
 * Applies wavelength-dependent Beer-Lambert absorption to the already-rendered
 * scene (boats + terrain) based on how far each pixel is below the water surface.
 */ 

const $1c36d45eda421de5$export$189deabf57f10291 = (0, $ca6793d1abd58997$export$99bb2281c7368d10)("Params", {
    // Clip → world for the actual screen.
    cameraMatrix: (0, $ca6793d1abd58997$export$a9b01fc77c97438b),
    // World → clip for the screen-space water height texture.
    worldToTexClip: (0, $ca6793d1abd58997$export$a9b01fc77c97438b),
    screenWidth: (0, $ca6793d1abd58997$export$e33361ff41014190),
    screenHeight: (0, $ca6793d1abd58997$export$e33361ff41014190),
    // Device pixel ratio — fragPos.xy is in physical framebuffer pixels, but
    // the surface textures are sized at logical+margin resolution. Divide
    // fragPos.xy by this to get logical pixel coords before texel indexing.
    pixelRatio: (0, $ca6793d1abd58997$export$e33361ff41014190),
    time: (0, $ca6793d1abd58997$export$e33361ff41014190),
    tideHeight: (0, $ca6793d1abd58997$export$e33361ff41014190),
    hasTerrainData: (0, $ca6793d1abd58997$export$b71748db06371c77),
    // Bio-optical water chemistry (per-level / per-region).
    // These drive the absorption/scattering calculation in the shader.
    // Typical ranges:
    //   chlorophyll: 0.01 (open ocean) – 10 (algal bloom), mg/m³
    //   cdom:        0.0  – 1.5 (tannic/coastal), normalized
    //   sediment:    0.0  – 3.0 (turbid estuary), normalized
    chlorophyll: (0, $ca6793d1abd58997$export$e33361ff41014190),
    cdom: (0, $ca6793d1abd58997$export$e33361ff41014190),
    sediment: (0, $ca6793d1abd58997$export$e33361ff41014190),
    // Scene lighting (see SceneLighting.ts). Populated from TimeOfDay.
    ...(0, $07d5066b6e7a4428$export$d4ca37c4b9500695)
});


/**
 * Water Height Compute Shader
 *
 * Computes water surface height and turbulence at each pixel using Gerstner
 * waves and modifiers. Output is an rgba16float texture (R=height, G=turbulence;
 * B and A unused). rgba16float is used instead of rg16float because only the
 * former is a mandatory WebGPU storage format, and instead of rg32float because
 * fp16 precision is sufficient here and the format is filterable.
 *
 * This is the first pass of the multi-pass surface rendering pipeline.
 */ 
/**
 * Gerstner wave shader module.
 * Analytical wave calculation using Gerstner formulation.
 */ /**
 * Wave system constants shared between CPU and GPU.
 */ 
const $ce7c6fb1dc074fb7$export$5d13ae1a39a3cc8b = {
    code: /*wgsl*/ `
const MAX_WAVE_SOURCES: u32 = ${(0, $302274bc574a4592$export$3ff414ae503bfcf8)}u;
`
};


const $be2e36db65cf9cb3$export$e6be6718ae498db4 = {
    dependencies: [
        (0, $ce7c6fb1dc074fb7$export$5d13ae1a39a3cc8b)
    ],
    code: /*wgsl*/ `
    // Calculate Gerstner waves with per-wave energy factors
    // worldPos: world position (feet)
    // time: simulation time (seconds)
    // waveData: wave parameters (storage buffer, 8 floats per wave)
    // numWaves: number of waves
    // steepness: Gerstner steepness factor
    // energyFactors: per-wave energy multiplier (0.0 = blocked, 1.0 = full)
    // directionOffsets: per-wave direction offset in radians (from direction bending)
    // phaseCorrections: per-wave phase correction in radians (from wavefront mesh)
    // ampMod: amplitude modulation factor (from noise)
    // Returns vec4<f32>(height, velX, velY, dhdt) \u{2014} horizontal orbital velocity
    // in .yz (Gerstner time-derivative of displacement, evaluated at the
    // back-displaced sample point, with per-wave energy and amp-mod scaling).
    fn calculateGerstnerWaves(
      worldPos: vec2<f32>,
      time: f32,
      waveData: ptr<storage, array<f32>, read>,
      numWaves: i32,
      steepness: f32,
      energyFactors: array<f32, MAX_WAVE_SOURCES>,
      directionOffsets: array<f32, MAX_WAVE_SOURCES>,
      phaseCorrections: array<f32, MAX_WAVE_SOURCES>,
      ampMod: f32,
    ) -> vec4<f32> {
      let x = worldPos.x;
      let y = worldPos.y;

      // First pass: compute Gerstner horizontal displacement
      var dispX = 0.0;
      var dispY = 0.0;

      for (var i = 0; i < numWaves; i++) {
        let base = i * 8;
        let amplitude = waveData[base + 0];
        let wavelength = waveData[base + 1];
        let direction = waveData[base + 2];
        let phaseOffset = waveData[base + 3];
        let speedMult = waveData[base + 4];
        let sourceDist = waveData[base + 5];
        let sourceOffsetX = waveData[base + 6];
        let sourceOffsetY = waveData[base + 7];

        let k = TWO_PI / wavelength;
        let omega = sqrt(GRAVITY * k) * speedMult;

        var dx: f32;
        var dy: f32;
        var phase: f32;

        // Plane wave or point source?
        if (sourceDist > 1e9) {
          // Plane wave - apply direction offset for direction bending
          let bentDirection = direction + directionOffsets[i];
          dx = cos(bentDirection);
          dy = sin(bentDirection);
          let projected = x * dx + y * dy;
          phase = k * projected - omega * time + phaseOffset + phaseCorrections[i];
        } else {
          // Point source - direction from geometry, no offset
          let baseDx = cos(direction);
          let baseDy = sin(direction);
          let sourceX = -baseDx * sourceDist + sourceOffsetX;
          let sourceY = -baseDy * sourceDist + sourceOffsetY;

          let toPointX = x - sourceX;
          let toPointY = y - sourceY;
          let distFromSource = sqrt(toPointX * toPointX + toPointY * toPointY);

          dx = toPointX / distFromSource;
          dy = toPointY / distFromSource;
          phase = k * distFromSource - omega * time + phaseOffset + phaseCorrections[i];
        }

        let Q = steepness / (k * amplitude * f32(numWaves));
        let cosPhase = cos(phase);
        dispX += Q * amplitude * dx * cosPhase;
        dispY += Q * amplitude * dy * cosPhase;
      }

      // Second pass: compute height, dh/dt, and horizontal orbital velocity
      // at the displaced-back sample point.
      let sampleX = x - dispX;
      let sampleY = y - dispY;
      var height = 0.0;
      var dhdt = 0.0;
      var velX = 0.0;
      var velY = 0.0;

      for (var i = 0; i < numWaves; i++) {
        let base = i * 8;
        var amplitude = waveData[base + 0];
        let wavelength = waveData[base + 1];
        let direction = waveData[base + 2];
        let phaseOffset = waveData[base + 3];
        let speedMult = waveData[base + 4];
        let sourceDist = waveData[base + 5];
        let sourceOffsetX = waveData[base + 6];
        let sourceOffsetY = waveData[base + 7];

        // Apply per-wave energy factor
        amplitude *= energyFactors[i];

        let k = TWO_PI / wavelength;
        let omega = sqrt(GRAVITY * k) * speedMult;

        var phase: f32;
        var propDx: f32;
        var propDy: f32;

        if (sourceDist > 1e9) {
          // Plane wave - apply direction offset for direction bending
          let bentDirection = direction + directionOffsets[i];
          propDx = cos(bentDirection);
          propDy = sin(bentDirection);
          let projected = sampleX * propDx + sampleY * propDy;
          phase = k * projected - omega * time + phaseOffset + phaseCorrections[i];
        } else {
          // Point source - direction from geometry, no offset
          let baseDx = cos(direction);
          let baseDy = sin(direction);
          let sourceX = -baseDx * sourceDist + sourceOffsetX;
          let sourceY = -baseDy * sourceDist + sourceOffsetY;

          let toPointX = sampleX - sourceX;
          let toPointY = sampleY - sourceY;
          let distFromSource = sqrt(toPointX * toPointX + toPointY * toPointY);

          let invDist = select(0.0, 1.0 / distFromSource, distFromSource > 1e-4);
          propDx = toPointX * invDist;
          propDy = toPointY * invDist;
          phase = k * distFromSource - omega * time + phaseOffset + phaseCorrections[i];
        }

        let sinPhase = sin(phase);
        let cosPhase = cos(phase);

        height += amplitude * ampMod * sinPhase;
        dhdt += -amplitude * ampMod * omega * cosPhase;

        // Horizontal orbital velocity (Gerstner time-derivative of displacement).
        // Q * A = steepness / (k * numWaves), independent of amplitude, so the
        // velocity magnitude depends only on wavenumber, steepness, and omega.
        // Scale by energy factor and ampMod to match the height attenuation.
        let velCoeff = (steepness / (k * f32(numWaves))) * omega * ampMod * energyFactors[i] * sinPhase;
        velX += velCoeff * propDx;
        velY += velCoeff * propDy;
      }

      return vec4<f32>(height, velX, velY, dhdt);
    }
  `
};




/**
 * Shared constants for water simulation.
 * These are used by both TypeScript code and GLSL shaders (via interpolation).
 */ // Gerstner wave configuration
const $b5703c4302ca52a6$export$3964cd37339b1861 = 0.7;
const $b5703c4302ca52a6$export$78cdc675ec1bf7b4 = 9.8 * 3.28084; // gravity in ft/s²
const $b5703c4302ca52a6$export$acb8118f0ec101ba = 0.005;
const $b5703c4302ca52a6$export$c0f77092ccbbffbf = 0.015;
const $b5703c4302ca52a6$export$22431cdd22054254 = 0; // Disabled for testing
const $b5703c4302ca52a6$export$f3ae2520668c9cb4 = 16;
const $b5703c4302ca52a6$export$d9a4c5d634bc0a8c = 5.0;


const $b524c0c97549a964$var$WORKGROUP_SIZE = [
    8,
    8
];
/**
 * Params module with uniforms and bindings for water height computation.
 */ const $b524c0c97549a964$var$waterHeightParamsModule = {
    preamble: /*wgsl*/ `
// Water height computation parameters
struct Params {
  // clip \u{2192} world for this texture (screen-aligned, rotation-aware, includes margin)
  texClipToWorld: mat3x3<f32>,
  textureWidth: f32,
  textureHeight: f32,
  time: f32,
  tideHeight: f32,
  numWaves: u32,
}

// Wave computation constants
const MAX_WAVES: i32 = ${(0, $b5703c4302ca52a6$export$f3ae2520668c9cb4)};
const GERSTNER_STEEPNESS: f32 = ${(0, $b5703c4302ca52a6$export$3964cd37339b1861)};
const WAVE_AMP_MOD_SPATIAL_SCALE: f32 = ${(0, $b5703c4302ca52a6$export$acb8118f0ec101ba)};
const WAVE_AMP_MOD_TIME_SCALE: f32 = ${(0, $b5703c4302ca52a6$export$c0f77092ccbbffbf)};
const WAVE_AMP_MOD_STRENGTH: f32 = ${(0, $b5703c4302ca52a6$export$22431cdd22054254)};

// Breaking zone turbulence
const BREAK_PHASE_NOISE_STRENGTH: f32 = 0.8;
const BREAK_AMP_NOISE_STRENGTH: f32 = 0.15;
const BREAK_NOISE_SPATIAL_SCALE: f32 = 0.3;
const BREAK_NOISE_TIME_SCALE: f32 = 1.2;

`,
    bindings: {
        params: {
            type: "uniform",
            wgslType: "Params"
        },
        waveData: {
            type: "storage",
            wgslType: "array<f32>"
        },
        modifierTexture: {
            type: "texture",
            viewDimension: "2d",
            sampleType: "float"
        },
        modifierSampler: {
            type: "sampler"
        },
        waveFieldTexture: {
            type: "texture",
            viewDimension: "2d-array",
            sampleType: "float"
        },
        waveFieldSampler: {
            type: "sampler"
        },
        outputTexture: {
            type: "storageTexture",
            format: "rgba16float"
        }
    },
    code: ""
};
/**
 * Main compute module for water height.
 */ const $b524c0c97549a964$var$waterHeightComputeModule = {
    dependencies: [
        $b524c0c97549a964$var$waterHeightParamsModule,
        (0, $3a1ba48c84b364a2$export$398f807fa131e803),
        (0, $29eb555f6f6dd288$export$d30c1ef1b1de4c71),
        (0, $be2e36db65cf9cb3$export$e6be6718ae498db4)
    ],
    code: /*wgsl*/ `
// Convert pixel coordinates to world position via the texture's clip\u{2192}world
// matrix. Texel (x,y) center maps to clip (2*(x+0.5)/W - 1, 1 - 2*(y+0.5)/H).
fn pixelToWorld(pixel: vec2<u32>) -> vec2<f32> {
  let uv = vec2<f32>(
    (f32(pixel.x) + 0.5) / params.textureWidth,
    (f32(pixel.y) + 0.5) / params.textureHeight
  );
  let clip = vec2<f32>(uv.x * 2.0 - 1.0, 1.0 - uv.y * 2.0);
  return (params.texClipToWorld * vec3<f32>(clip, 1.0)).xy;
}

// Calculate water height and turbulence at a point using wave field texture
fn calculateWaterHeight(worldPos: vec2<f32>, pixel: vec2<u32>) -> vec2<f32> {
  // Sample wave field texture for per-wave energy, direction offset, and phase correction
  var energyFactors: array<f32, MAX_WAVE_SOURCES>;
  var directionOffsets: array<f32, MAX_WAVE_SOURCES>;
  var phaseCorrections: array<f32, MAX_WAVE_SOURCES>;

  let uv = vec2<f32>(
    (f32(pixel.x) + 0.5) / params.textureWidth,
    (f32(pixel.y) + 0.5) / params.textureHeight
  );

  var maxTurbulence = 0.0;

  for (var i = 0u; i < u32(params.numWaves); i++) {
    // Wave field texture: (phasorCos, phasorSin, unused, turbulence)
    // Uncovered pixels are (0,0,0,0) = shadow zone (zero amplitude).
    // Skirt geometry ensures open ocean areas have correct phasors from mesh triangles.
    let waveField = textureSampleLevel(waveFieldTexture, waveFieldSampler, uv, i32(i), 0.0);
    let pc = waveField.r;
    let ps = waveField.g;
    let turbulence = waveField.a;

    maxTurbulence = max(maxTurbulence, turbulence);

    let mag = sqrt(pc * pc + ps * ps);
    energyFactors[i] = mag;
    // Avoid atan2(0, 0) which is undefined on GPU \u{2014} can produce NaN
    if (mag > 0.001) {
      phaseCorrections[i] = atan2(ps, pc);
    } else {
      phaseCorrections[i] = 0.0;
    }

    // Breaking zone turbulence: add per-wave-source noise for chaotic breaking
    if (turbulence > 0.0) {
      let waveSeed = f32(i) * 17.31;
      let breakPhaseNoise = simplex3D(vec3<f32>(
        worldPos.x * BREAK_NOISE_SPATIAL_SCALE,
        worldPos.y * BREAK_NOISE_SPATIAL_SCALE,
        params.time * BREAK_NOISE_TIME_SCALE + waveSeed
      ));
      phaseCorrections[i] += turbulence * breakPhaseNoise * BREAK_PHASE_NOISE_STRENGTH;

      let breakAmpNoise = simplex3D(vec3<f32>(
        worldPos.x * BREAK_NOISE_SPATIAL_SCALE * 1.7 + 100.0,
        worldPos.y * BREAK_NOISE_SPATIAL_SCALE * 1.7 + 100.0,
        params.time * BREAK_NOISE_TIME_SCALE * 0.8 + waveSeed + 50.0
      ));
      energyFactors[i] *= 1.0 + turbulence * breakAmpNoise * BREAK_AMP_NOISE_STRENGTH;
    }
    directionOffsets[i] = 0.0;
  }

  // Sample amplitude modulation noise
  let ampModTime = params.time * WAVE_AMP_MOD_TIME_SCALE;
  let ampMod = 1.0 + simplex3D(vec3<f32>(
    worldPos.x * WAVE_AMP_MOD_SPATIAL_SCALE,
    worldPos.y * WAVE_AMP_MOD_SPATIAL_SCALE,
    ampModTime
  )) * WAVE_AMP_MOD_STRENGTH;

  // Calculate Gerstner waves with per-wave energy factors, direction bending, and phase corrections
  let waveResult = calculateGerstnerWaves(
    worldPos,
    params.time,
    &waveData,
    i32(params.numWaves),
    GERSTNER_STEEPNESS,
    energyFactors,
    directionOffsets,
    phaseCorrections,
    ampMod,
  );

  // Sample modifier texture (rasterized in a prior pass)
  let modifierSample = textureSampleLevel(modifierTexture, modifierSampler, uv, 0.0);
  let modifierHeight = modifierSample.r;
  let modifierTurbulence = modifierSample.a;

  // Combined height = waves + modifiers + tide. No boat-air substitution
  // here \u{2014} the water height texture represents the pure ocean surface, so
  // its finite-differenced normal has no cliffs at hull edges. Boat-air
  // substitution happens in WaterFilterShader, where a per-fragment test
  // against boatAirTexture decides the effective water Z for the
  // submersion calculation only.
  let height = waveResult.x + modifierHeight + params.tideHeight;
  // Combine wave breaking turbulence with modifier turbulence (e.g. wake foam)
  let totalTurbulence = max(maxTurbulence, modifierTurbulence);

  return vec2<f32>(height, totalTurbulence);
}

@compute @workgroup_size(${$b524c0c97549a964$var$WORKGROUP_SIZE[0]}, ${$b524c0c97549a964$var$WORKGROUP_SIZE[1]})
fn main(@builtin(global_invocation_id) global_id: vec3<u32>) {
  let pixel = global_id.xy;

  // Bounds check
  if (pixel.x >= u32(params.textureWidth) || pixel.y >= u32(params.textureHeight)) {
    return;
  }

  let worldPos = pixelToWorld(pixel);

  // Calculate water height and turbulence using wave field texture
  let result = calculateWaterHeight(worldPos, pixel);

  // Write to output texture (R = height, G = turbulence)
  textureStore(outputTexture, pixel, vec4<f32>(result.x, result.y, 0.0, 0.0));
}
`
};
const $b524c0c97549a964$var$waterHeightShaderConfig = {
    modules: [
        $b524c0c97549a964$var$waterHeightComputeModule
    ],
    workgroupSize: $b524c0c97549a964$var$WORKGROUP_SIZE,
    label: "WaterHeightShader"
};
function $b524c0c97549a964$export$e47dea04b261012c() {
    return new (0, $4016c3d8f65071ed$export$cdde5429dd049099)($b524c0c97549a964$var$waterHeightShaderConfig);
}


/**
 * Uniform buffer definition for the Water Height compute shader.
 */ 
const $c4d76e19f53fbac5$export$91f278f3e5b47a28 = (0, $ca6793d1abd58997$export$99bb2281c7368d10)("Params", {
    // Clip-space → world transform for the output texture.
    // Same layout as TerrainScreenUniforms.texClipToWorld.
    texClipToWorld: (0, $ca6793d1abd58997$export$a9b01fc77c97438b),
    // Dimensions of the output texture in texels.
    textureWidth: (0, $ca6793d1abd58997$export$e33361ff41014190),
    textureHeight: (0, $ca6793d1abd58997$export$e33361ff41014190),
    // Time and water params
    time: (0, $ca6793d1abd58997$export$e33361ff41014190),
    tideHeight: (0, $ca6793d1abd58997$export$e33361ff41014190),
    // Wave configuration (from level data)
    numWaves: (0, $ca6793d1abd58997$export$8bacf4ad828c7fe7)
});



/**
 * Wetness rendering compute pipeline.
 *
 * Tracks sand wetness over time using ping-pong textures.
 * When waves wash over sand, it becomes wet. When water recedes,
 * sand slowly dries out.
 *
 * Uses reprojection to maintain wetness state as the camera moves.
 */ 

/**
 * Wetness state compute shader.
 *
 * Computes sand wetness over time based on water depth.
 * Uses ping-pong textures with reprojection to persist wetness
 * as the camera moves.
 *
 * Output format (r32float):
 * - R: Wetness value (0 = dry, 1 = fully wet)
 */ 

// Wetness rates (configurable defaults)
const $717f2c8894b041dd$export$7d1be6070ea30518 = 5.0; // Reach full wet in ~0.25 seconds
const $717f2c8894b041dd$export$6d0273d24748b5ac = 0.05; // Reach fully dry in ~20 seconds
const $717f2c8894b041dd$var$WORKGROUP_SIZE = [
    8,
    8
];
const $717f2c8894b041dd$export$627d6d2bbfd12437 = (0, $ca6793d1abd58997$export$99bb2281c7368d10)("Params", {
    currentTexClipToWorld: (0, $ca6793d1abd58997$export$a9b01fc77c97438b),
    prevWorldToTexClip: (0, $ca6793d1abd58997$export$a9b01fc77c97438b),
    dt: (0, $ca6793d1abd58997$export$e33361ff41014190),
    wettingRate: (0, $ca6793d1abd58997$export$e33361ff41014190),
    dryingRate: (0, $ca6793d1abd58997$export$e33361ff41014190),
    textureSizeX: (0, $ca6793d1abd58997$export$e33361ff41014190),
    textureSizeY: (0, $ca6793d1abd58997$export$e33361ff41014190)
});
/**
 * Module containing Params struct and bindings.
 */ const $717f2c8894b041dd$var$wetnessParamsModule = {
    preamble: /*wgsl*/ `
struct Params {
  currentTexClipToWorld: mat3x3<f32>,
  prevWorldToTexClip: mat3x3<f32>,
  dt: f32,
  wettingRate: f32,
  dryingRate: f32,
  textureSizeX: f32,
  textureSizeY: f32,
}
  `,
    bindings: {
        params: {
            type: "uniform",
            wgslType: "Params"
        },
        prevWetnessTexture: {
            type: "texture"
        },
        waterTexture: {
            type: "texture"
        },
        terrainTexture: {
            type: "texture"
        },
        textureSampler: {
            type: "sampler"
        },
        outputTexture: {
            type: "storageTexture",
            format: "r32float"
        }
    },
    code: ""
};
/**
 * Module containing the compute entry point.
 */ const $717f2c8894b041dd$var$wetnessMainModule = {
    dependencies: [
        $717f2c8894b041dd$var$wetnessParamsModule
    ],
    code: /*wgsl*/ `
// Constants
const DEFAULT_WETTING_RATE: f32 = ${$717f2c8894b041dd$export$7d1be6070ea30518};
const DEFAULT_DRYING_RATE: f32 = ${$717f2c8894b041dd$export$6d0273d24748b5ac};

@compute @workgroup_size(${$717f2c8894b041dd$var$WORKGROUP_SIZE[0]}, ${$717f2c8894b041dd$var$WORKGROUP_SIZE[1]})
fn main(@builtin(global_invocation_id) globalId: vec3<u32>) {
  let texSizeX = params.textureSizeX;
  let texSizeY = params.textureSizeY;

  if (f32(globalId.x) >= texSizeX || f32(globalId.y) >= texSizeY) {
    return;
  }

  // Current texel UV (shared with water/terrain textures \u{2014} same layout).
  let uv = vec2<f32>(f32(globalId.x) + 0.5, f32(globalId.y) + 0.5) / vec2<f32>(texSizeX, texSizeY);

  // World position for this texel (needed for reprojection into the
  // previous frame's wetness texture).
  let clip = vec2<f32>(uv.x * 2.0 - 1.0, 1.0 - uv.y * 2.0);
  let worldPos = (params.currentTexClipToWorld * vec3<f32>(clip, 1.0)).xy;

  // Reproject to previous wetness texture UV.
  let prevClip = (params.prevWorldToTexClip * vec3<f32>(worldPos, 1.0)).xy;
  let prevUV = vec2<f32>((prevClip.x + 1.0) * 0.5, (1.0 - prevClip.y) * 0.5);

  // Water and terrain textures share this texel's UV (same layout).
  let waterData = textureSampleLevel(waterTexture, textureSampler, uv, 0.0);
  let terrainData = textureSampleLevel(terrainTexture, textureSampler, uv, 0.0);

  // Compute water depth
  let waterSurfaceHeight = waterData.r;
  let terrainHeight = terrainData.r;
  let waterDepth = waterSurfaceHeight - terrainHeight;

  // Get previous wetness with reprojection
  var prevWetness: f32;
  let inBounds = prevUV.x >= 0.0 && prevUV.x <= 1.0 && prevUV.y >= 0.0 && prevUV.y <= 1.0;
  if (inBounds) {
    prevWetness = textureSampleLevel(prevWetnessTexture, textureSampler, prevUV, 0.0).r;
  } else {
    // New area entering viewport - initialize based on current water depth
    if (waterDepth > 0.0) {
      prevWetness = 1.0;  // Underwater = wet
    } else {
      prevWetness = 0.0;  // Exposed = dry
    }
  }

  // Update wetness based on water depth
  var newWetness: f32;
  if (waterDepth > 0.0) {
    // Underwater - rapidly wet (reach 1.0 based on wetting rate)
    newWetness = min(1.0, prevWetness + params.wettingRate * params.dt);
  } else {
    // Exposed - slowly dry (reach 0.0 based on drying rate)
    newWetness = max(0.0, prevWetness - params.dryingRate * params.dt);
  }

  // Write output (sharpening applied in display shader, not here)
  textureStore(outputTexture, vec2<i32>(globalId.xy), vec4<f32>(newWetness, 0.0, 0.0, 1.0));
}
  `
};
const $717f2c8894b041dd$export$d78cc59bf067d333 = {
    modules: [
        $717f2c8894b041dd$var$wetnessMainModule
    ],
    workgroupSize: $717f2c8894b041dd$var$WORKGROUP_SIZE,
    label: "WetnessStateShader"
};
function $717f2c8894b041dd$export$51571a0c124e8eb() {
    return new (0, $4016c3d8f65071ed$export$cdde5429dd049099)($717f2c8894b041dd$export$d78cc59bf067d333);
}


class $dfc996ae07e1d449$export$cfbc13f76fe0b34f {
    constructor(device, textureWidth, textureHeight){
        this.device = device;
        this.shader = null;
        this.wetnessTextureA = null;
        this.wetnessTextureB = null;
        this.wetnessTextureViewA = null;
        this.wetnessTextureViewB = null;
        this.currentReadTexture = "A";
        this.bindGroupAtoB = null;
        this.bindGroupBtoA = null;
        this.prevWorldToTexClip = null;
        this.paramsBuffer = null;
        this.uniforms = (0, $717f2c8894b041dd$export$627d6d2bbfd12437).create();
        this.sampler = null;
        this.initialized = false;
        this.wettingRate = (0, $717f2c8894b041dd$export$7d1be6070ea30518);
        this.dryingRate = (0, $717f2c8894b041dd$export$6d0273d24748b5ac);
        this.textureWidth = textureWidth;
        this.textureHeight = textureHeight;
    }
    /**
   * Initialize WebGPU resources.
   */ async init() {
        if (this.initialized) return;
        const device = this.device;
        // Initialize compute shader
        this.shader = (0, $717f2c8894b041dd$export$51571a0c124e8eb)();
        await this.shader.init();
        // Create params buffer
        this.paramsBuffer = device.createBuffer({
            size: (0, $717f2c8894b041dd$export$627d6d2bbfd12437).byteSize,
            usage: GPUBufferUsage.UNIFORM | GPUBufferUsage.COPY_DST,
            label: "Wetness Params Buffer"
        });
        // Create sampler (linear for smooth reprojection)
        this.sampler = device.createSampler({
            magFilter: "linear",
            minFilter: "linear",
            addressModeU: "clamp-to-edge",
            addressModeV: "clamp-to-edge",
            label: "Wetness Sampler"
        });
        // Create ping-pong textures (r32float for single channel wetness)
        this.wetnessTextureA = device.createTexture({
            size: {
                width: this.textureWidth,
                height: this.textureHeight
            },
            format: "r32float",
            usage: GPUTextureUsage.STORAGE_BINDING | GPUTextureUsage.TEXTURE_BINDING | GPUTextureUsage.COPY_DST,
            label: "Wetness Texture A"
        });
        this.wetnessTextureViewA = this.wetnessTextureA.createView();
        this.wetnessTextureB = device.createTexture({
            size: {
                width: this.textureWidth,
                height: this.textureHeight
            },
            format: "r32float",
            usage: GPUTextureUsage.STORAGE_BINDING | GPUTextureUsage.TEXTURE_BINDING | GPUTextureUsage.COPY_DST,
            label: "Wetness Texture B"
        });
        this.wetnessTextureViewB = this.wetnessTextureB.createView();
        // Initialize textures to 0 (dry)
        this.clearTextures();
        // Bind groups will be created when we have water/terrain textures
        this.initialized = true;
    }
    /**
   * Clear wetness textures to initial state (dry).
   */ clearTextures() {
        const device = this.device;
        // Create a zeroed buffer to clear the textures
        const clearData = new Float32Array(this.textureWidth * this.textureHeight);
        const bytesPerRow = this.textureWidth * 4; // 4 bytes per f32
        if (this.wetnessTextureA) device.queue.writeTexture({
            texture: this.wetnessTextureA
        }, clearData, {
            bytesPerRow: bytesPerRow
        }, {
            width: this.textureWidth,
            height: this.textureHeight
        });
        if (this.wetnessTextureB) device.queue.writeTexture({
            texture: this.wetnessTextureB
        }, clearData, {
            bytesPerRow: bytesPerRow
        }, {
            width: this.textureWidth,
            height: this.textureHeight
        });
    }
    /**
   * Create bind groups for the given water and terrain textures.
   */ createBindGroups(waterTextureView, terrainTextureView) {
        if (!this.shader || !this.paramsBuffer || !this.sampler) return;
        // Bind group A->B: read from A, write to B
        this.bindGroupAtoB = this.shader.createBindGroup({
            params: {
                buffer: this.paramsBuffer
            },
            prevWetnessTexture: this.wetnessTextureViewA,
            waterTexture: waterTextureView,
            terrainTexture: terrainTextureView,
            textureSampler: this.sampler,
            outputTexture: this.wetnessTextureViewB
        });
        // Bind group B->A: read from B, write to A
        this.bindGroupBtoA = this.shader.createBindGroup({
            params: {
                buffer: this.paramsBuffer
            },
            prevWetnessTexture: this.wetnessTextureViewB,
            waterTexture: waterTextureView,
            terrainTexture: terrainTextureView,
            textureSampler: this.sampler,
            outputTexture: this.wetnessTextureViewA
        });
    }
    /**
   * Update wetness texture with current state.
   *
   * The wetness texture shares its layout with the water/terrain textures
   * (same size, same screen-aligned expanded-viewport mapping), so current
   * texel UV reads directly into water/terrain. Reprojection uses the stored
   * previous-frame transform.
   *
   * @param texClipToWorld - Current frame's clip→world for the wetness texture
   * @param worldToTexClip - Current frame's world→clip (inverse of above)
   */ update(texClipToWorld, worldToTexClip, waterTextureView, terrainTextureView, dt, gpuProfiler) {
        if (!this.initialized || !this.shader || !this.paramsBuffer) return;
        const device = this.device;
        // Recreate bind groups (textures may have changed)
        this.createBindGroups(waterTextureView, terrainTextureView);
        if (!this.bindGroupAtoB || !this.bindGroupBtoA) return;
        // Use current transform as prev on first frame.
        const prevWorldToTexClip = this.prevWorldToTexClip ?? worldToTexClip;
        // Update params buffer
        this.uniforms.set.currentTexClipToWorld(texClipToWorld);
        this.uniforms.set.prevWorldToTexClip(prevWorldToTexClip);
        this.uniforms.set.dt(dt);
        this.uniforms.set.wettingRate(this.wettingRate);
        this.uniforms.set.dryingRate(this.dryingRate);
        this.uniforms.set.textureSizeX(this.textureWidth);
        this.uniforms.set.textureSizeY(this.textureHeight);
        this.uniforms.uploadTo(this.paramsBuffer);
        // Select bind group based on current read texture
        const bindGroup = this.currentReadTexture === "A" ? this.bindGroupAtoB : this.bindGroupBtoA;
        // Create command encoder
        const commandEncoder = device.createCommandEncoder({
            label: "Wetness Render Compute Encoder"
        });
        const computePass = commandEncoder.beginComputePass({
            label: "Wetness Render Compute Pass",
            timestampWrites: gpuProfiler?.getComputeTimestampWrites("surface.wetness")
        });
        this.shader.dispatch(computePass, bindGroup, this.textureWidth, this.textureHeight);
        computePass.end();
        // Submit
        device.queue.submit([
            commandEncoder.finish()
        ]);
        // Swap textures for next frame
        this.currentReadTexture = this.currentReadTexture === "A" ? "B" : "A";
        // Store world→clip for next frame's reprojection.
        this.prevWorldToTexClip = worldToTexClip.clone();
    }
    /**
   * Get the output texture view for rendering.
   * Returns the texture that was just written to.
   */ getOutputTextureView() {
        // After swap, currentReadTexture points to what we just wrote
        // So we return that one for rendering
        return this.currentReadTexture === "A" ? this.wetnessTextureViewA : this.wetnessTextureViewB;
    }
    /**
   * Get the texture width.
   */ getTextureWidth() {
        return this.textureWidth;
    }
    /**
   * Get the texture height.
   */ getTextureHeight() {
        return this.textureHeight;
    }
    /**
   * Check if the pipeline is initialized.
   */ isInitialized() {
        return this.initialized;
    }
    /**
   * Set wetness rates.
   */ setWetnessRates(wettingRate, dryingRate) {
        this.wettingRate = wettingRate;
        this.dryingRate = dryingRate;
    }
    /**
   * Clean up GPU resources.
   */ destroy() {
        this.wetnessTextureA?.destroy();
        this.wetnessTextureB?.destroy();
        this.paramsBuffer?.destroy();
        this.shader?.destroy();
        this.wetnessTextureA = null;
        this.wetnessTextureB = null;
        this.wetnessTextureViewA = null;
        this.wetnessTextureViewB = null;
        this.paramsBuffer = null;
        this.sampler = null;
        this.bindGroupAtoB = null;
        this.bindGroupBtoA = null;
        this.shader = null;
        this.prevWorldToTexClip = null;
        this.initialized = false;
    }
}
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $5a1d1d3ab1ff9c51$export$4882ae973e0491e)
], $dfc996ae07e1d449$export$cfbc13f76fe0b34f.prototype, "update", null);


// World viewport margin for the terrain tile cache. Independent of the
// texture-pixel margin — this drives which tiles the cache keeps hot.
const $8f91167edee9a01b$var$TILE_CACHE_VIEWPORT_MARGIN = 0.1;
// Modifier texture resolution scale (fraction of surface texture resolution)
const $8f91167edee9a01b$var$MODIFIER_RESOLUTION_SCALE = 0.5;
// Default bio-optical water chemistry. These drive the water filter's
// absorption/scattering computation. Eventually they should come from the
// level's BiomeConfig / region file; for now they're clean-coastal defaults.
//   chlorophyll: mg/m³     — 0.01 open ocean, 1 coastal, 10 bloom
//   cdom:        normalized — 0 clean, 1 typical coastal, 2+ tannic
//   sediment:    normalized — 0 clean, 1 typical coastal, 3 turbid
const $8f91167edee9a01b$var$DEFAULT_CHLOROPHYLL = 0.5;
const $8f91167edee9a01b$var$DEFAULT_CDOM = 0.3;
const $8f91167edee9a01b$var$DEFAULT_SEDIMENT = 0.4;
class $8f91167edee9a01b$export$86ec1cc3842ae5f extends (0, $c59361981bac2575$export$4342ba5c6ad1f6f1) {
    constructor(biomeConfig){
        super(), this.id = "waterRenderer", this.layer = "surface", this.initialized = false, this.enabled = false, // Shaders for each pass
        this.terrainScreenShader = null, this.waterHeightShader = null, this.terrainCompositeShader = null, this.waterFilterShader = null, // LOD terrain tile cache (multiple LOD levels for extreme zoom ranges)
        this.terrainTileCache = null, // Wetness render pipeline (tracks sand wetness over time)
        this.wetnessPipeline = null, // Modifier rasterizer (wakes, ripples → screen-space texture)
        this.modifierRasterizer = null, this.modifierTexture = null, this.modifierTextureView = null, this.modifierSampler = null, // Intermediate textures
        this.terrainHeightTexture = null, this.terrainHeightView = null, this.waterHeightTexture = null, this.waterHeightView = null, // Per-boat air gap (bilge surface Z + deck cap Z + bilge turbulence).
        // Read by the water height compute as a substitution input — see
        // BoatAirShader and WaterHeightShader.
        this.boatAirTexture = null, this.boatAirTextureView = null, // Wave field texture array (rgba16float, one layer per wave source)
        this.waveFieldTexture = null, this.waveFieldTextureView = null, this.waveFieldSampler = null, // Uniform buffers
        this.terrainScreenUniformBuffer = null, this.waterHeightUniformBuffer = null, this.terrainCompositeUniformBuffer = null, this.waterFilterUniformBuffer = null, this.biomeUniformBuffer = null, // Uniform instances
        this.terrainScreenUniforms = null, this.waterHeightUniforms = null, this.terrainCompositeUniforms = null, this.waterFilterUniforms = null, // Boat air rasterizer — feeds boatAirTexture to the water height compute.
        this.boatAirShader = null, // Samplers
        this.heightSampler = null, // Bind groups (recreated when resources change)
        this.terrainScreenBindGroup = null, this.waterHeightBindGroup = null, this.terrainCompositeBindGroup = null, this.waterFilterBindGroup = null, // Track last resources
        this.lastTextureWidth = 0, this.lastTextureHeight = 0, this.lastWaveDataBuffer = null, this.lastTerrainAtlasView = null, this.lastWaveFieldTextureView = null, this.initPromise = null;
        this.biomeConfig = biomeConfig ?? (0, $be7b0a69b0f1c572$export$968fde8d838bc38d);
    }
    async ensureInitialized() {
        if (this.initialized || !this.game) return;
        try {
            const device = this.game.getWebGPUDevice();
            // Create shaders
            this.terrainScreenShader = (0, $a2e50d56dea5829d$export$4bca3e109b584d8b)();
            this.waterHeightShader = (0, $b524c0c97549a964$export$e47dea04b261012c)();
            this.terrainCompositeShader = (0, $d97c0317de9871e7$export$3c452f8d5ad6e480)();
            this.waterFilterShader = (0, $5207256e8fe29dfd$export$591e5cd40d9ef433)();
            // Create LOD terrain tile cache (multiple LOD levels for extreme zoom ranges)
            // Supports zoom range 0.02 to 1.0+ by using progressively larger world units per tile
            this.terrainTileCache = new (0, $838fb2a40177c423$export$a9ff94037f423d7d)(device);
            // Create wetness render pipeline (will be sized when textures are created)
            // Using placeholder size - will be recreated when ensureTextures is called
            this.wetnessPipeline = new (0, $dfc996ae07e1d449$export$cfbc13f76fe0b34f)(device, 1, 1);
            // Create modifier rasterizer
            this.modifierRasterizer = new (0, $12d54cf0e8ceaf5c$export$f5aa9a4020b2444d)(device);
            // Create boat air rasterizer (publishes per-boat air gap to boatAirTexture)
            this.boatAirShader = new (0, $8090446e3dad5a4c$export$bf09a74867d3a39b)();
            await Promise.all([
                this.terrainScreenShader.init(),
                this.waterHeightShader.init(),
                this.terrainCompositeShader.init(),
                this.waterFilterShader.init(),
                this.terrainTileCache.init(),
                this.wetnessPipeline.init(),
                this.modifierRasterizer.init()
            ]);
            // Create uniform buffers
            this.terrainScreenUniformBuffer = device.createBuffer({
                size: (0, $05f4032174e06375$export$5c35225518ffbe66).byteSize,
                usage: GPUBufferUsage.UNIFORM | GPUBufferUsage.COPY_DST,
                label: "Terrain Screen Uniform Buffer"
            });
            this.waterHeightUniformBuffer = device.createBuffer({
                size: (0, $c4d76e19f53fbac5$export$91f278f3e5b47a28).byteSize,
                usage: GPUBufferUsage.UNIFORM | GPUBufferUsage.COPY_DST,
                label: "Water Height Uniform Buffer"
            });
            this.terrainCompositeUniformBuffer = device.createBuffer({
                size: (0, $958e0ac08c7b3345$export$2658b319af430064).byteSize,
                usage: GPUBufferUsage.UNIFORM | GPUBufferUsage.COPY_DST,
                label: "Terrain Composite Uniform Buffer"
            });
            this.waterFilterUniformBuffer = device.createBuffer({
                size: (0, $1c36d45eda421de5$export$189deabf57f10291).byteSize,
                usage: GPUBufferUsage.UNIFORM | GPUBufferUsage.COPY_DST,
                label: "Water Filter Uniform Buffer"
            });
            // Biome uniform buffer — uploaded once per level load
            this.biomeUniformBuffer = device.createBuffer({
                size: (0, $be7b0a69b0f1c572$export$31dcfe447568361d),
                usage: GPUBufferUsage.UNIFORM | GPUBufferUsage.COPY_DST,
                label: "Biome Uniform Buffer"
            });
            const biomeData = (0, $be7b0a69b0f1c572$export$dfc4d347d6e53f50)(this.biomeConfig);
            device.queue.writeBuffer(this.biomeUniformBuffer, 0, biomeData.buffer);
            // Create uniform instances
            this.terrainScreenUniforms = (0, $05f4032174e06375$export$5c35225518ffbe66).create();
            this.waterHeightUniforms = (0, $c4d76e19f53fbac5$export$91f278f3e5b47a28).create();
            this.terrainCompositeUniforms = (0, $958e0ac08c7b3345$export$2658b319af430064).create();
            this.waterFilterUniforms = (0, $1c36d45eda421de5$export$189deabf57f10291).create();
            this.terrainCompositeUniforms.set.hasTerrainData(0);
            this.waterFilterUniforms.set.hasTerrainData(0);
            // Linear filtering: rgba16float is filterable, so bilinear sampling
            // smooths water height / normals between texels for free.
            this.heightSampler = device.createSampler({
                magFilter: "linear",
                minFilter: "linear",
                addressModeU: "clamp-to-edge",
                addressModeV: "clamp-to-edge",
                label: "Height Texture Sampler"
            });
            // Create wave field sampler (linear filtering for smooth interpolation)
            this.waveFieldSampler = device.createSampler({
                magFilter: "linear",
                minFilter: "linear",
                addressModeU: "clamp-to-edge",
                addressModeV: "clamp-to-edge",
                label: "Wave Field Sampler"
            });
            // Create modifier sampler (linear filtering, clamp-to-edge)
            this.modifierSampler = device.createSampler({
                magFilter: "linear",
                minFilter: "linear",
                addressModeU: "clamp-to-edge",
                addressModeV: "clamp-to-edge",
                label: "Modifier Sampler"
            });
            this.initialized = true;
        } catch (error) {
            console.error("Failed to initialize SurfaceRenderer:", error);
        }
    }
    onAdd() {
        this.initPromise = this.ensureInitialized();
    }
    /**
   * Returns a promise that resolves when shader compilation is complete.
   */ whenReady() {
        return this.initPromise ?? Promise.resolve();
    }
    /**
   * Allow rendering to begin. Called by GameController once all systems are ready.
   */ setEnabled(value) {
        this.enabled = value;
    }
    /**
   * Ensure intermediate textures exist and match screen size.
   *
   * All surface textures are sized (width + 2*margin) × (height + 2*margin)
   * so that screen pixel (i, j) lines up with texel (i + margin, j + margin)
   * exactly. See SurfaceConstants.ts.
   */ ensureTextures(width, height) {
        if (this.lastTextureWidth === width && this.lastTextureHeight === height) return;
        const device = this.game.getWebGPUDevice();
        const texW = width + 2 * (0, $f1d767035e355263$export$c4411bf1f7186f47);
        const texH = height + 2 * (0, $f1d767035e355263$export$c4411bf1f7186f47);
        // Destroy old textures
        this.terrainHeightTexture?.destroy();
        this.waterHeightTexture?.destroy();
        this.waveFieldTexture?.destroy();
        this.modifierTexture?.destroy();
        this.boatAirTexture?.destroy();
        // Destroy old wetness pipeline (will be recreated with new size)
        this.wetnessPipeline?.destroy();
        // Create terrain height texture (screen-space, sampled from tile atlas)
        this.terrainHeightTexture = device.createTexture({
            size: {
                width: texW,
                height: texH
            },
            format: "r32float",
            usage: GPUTextureUsage.STORAGE_BINDING | GPUTextureUsage.TEXTURE_BINDING,
            label: "Terrain Height Texture"
        });
        this.terrainHeightView = this.terrainHeightTexture.createView();
        // Create water height texture (R=height, G=turbulence; B/A unused).
        // rgba16float rather than rg16float because only rgba16float is a
        // mandatory WebGPU storage format.
        this.waterHeightTexture = device.createTexture({
            size: {
                width: texW,
                height: texH
            },
            format: "rgba16float",
            usage: GPUTextureUsage.STORAGE_BINDING | GPUTextureUsage.TEXTURE_BINDING,
            label: "Water Height Texture"
        });
        this.waterHeightView = this.waterHeightTexture.createView();
        // Create boat air texture: per-pixel air gap published by BoatAirShader
        // and consumed by WaterHeightShader. R = bilge surface Z, G = deck cap
        // Z, B = bilge turbulence. Cleared each frame to a low sentinel.
        this.boatAirTexture = device.createTexture({
            size: {
                width: texW,
                height: texH
            },
            format: "rgba16float",
            usage: GPUTextureUsage.RENDER_ATTACHMENT | GPUTextureUsage.TEXTURE_BINDING,
            label: "Boat Air Texture"
        });
        this.boatAirTextureView = this.boatAirTexture.createView();
        // Create wave field texture array (one layer per wave source)
        this.waveFieldTexture = device.createTexture({
            size: {
                width: texW,
                height: texH,
                depthOrArrayLayers: (0, $302274bc574a4592$export$3ff414ae503bfcf8)
            },
            format: "rgba16float",
            usage: GPUTextureUsage.RENDER_ATTACHMENT | GPUTextureUsage.TEXTURE_BINDING,
            label: "Wave Field Texture"
        });
        this.waveFieldTextureView = this.waveFieldTexture.createView({
            dimension: "2d-array",
            label: "Wave Field Texture View"
        });
        // Create modifier texture at reduced resolution (wakes are low-frequency)
        const modW = Math.max(1, Math.round(texW * $8f91167edee9a01b$var$MODIFIER_RESOLUTION_SCALE));
        const modH = Math.max(1, Math.round(texH * $8f91167edee9a01b$var$MODIFIER_RESOLUTION_SCALE));
        this.modifierTexture = device.createTexture({
            size: {
                width: modW,
                height: modH
            },
            format: "rgba16float",
            usage: GPUTextureUsage.RENDER_ATTACHMENT | GPUTextureUsage.TEXTURE_BINDING,
            label: "Modifier Texture"
        });
        this.modifierTextureView = this.modifierTexture.createView({
            label: "Modifier Texture View"
        });
        // Recreate wetness pipeline with new texture size (shares surface layout)
        this.wetnessPipeline = new (0, $dfc996ae07e1d449$export$cfbc13f76fe0b34f)(device, texW, texH);
        this.wetnessPipeline.init();
        this.lastTextureWidth = width;
        this.lastTextureHeight = height;
        // Force bind group recreation
        this.terrainScreenBindGroup = null;
        this.waterHeightBindGroup = null;
        this.terrainCompositeBindGroup = null;
        this.waterFilterBindGroup = null;
    }
    /**
   * Get viewport expanded by the given margin factor.
   */ getExpandedViewport(margin) {
        const camera = this.game.camera;
        const worldViewport = camera.getWorldViewport();
        const marginX = worldViewport.width * margin;
        const marginY = worldViewport.height * margin;
        return {
            left: worldViewport.left - marginX,
            top: worldViewport.top - marginY,
            width: worldViewport.width + marginX * 2,
            height: worldViewport.height + marginY * 2
        };
    }
    /**
   * Update uniforms for terrain screen pass.
   */ updateTerrainScreenUniforms(texClipToWorld, textureWidth, textureHeight) {
        if (!this.terrainScreenUniforms || !this.terrainTileCache) return;
        this.terrainScreenUniforms.set.texClipToWorld(texClipToWorld);
        this.terrainScreenUniforms.set.textureWidth(textureWidth);
        this.terrainScreenUniforms.set.textureHeight(textureHeight);
        // Set terrain tile atlas parameters
        const atlasInfo = this.terrainTileCache.getAtlasInfo();
        this.terrainScreenUniforms.set.atlasTileSize(atlasInfo.tileSize);
        this.terrainScreenUniforms.set.atlasTilesX(atlasInfo.tilesX);
        this.terrainScreenUniforms.set.atlasTilesY(atlasInfo.tilesY);
        this.terrainScreenUniforms.set.atlasWorldUnitsPerTile(atlasInfo.worldUnitsPerTile);
    }
    /**
   * Update uniforms for water height pass.
   */ updateWaterHeightUniforms(texClipToWorld, currentTime, textureWidth, textureHeight, waterResources) {
        if (!this.waterHeightUniforms) return;
        this.waterHeightUniforms.set.texClipToWorld(texClipToWorld);
        this.waterHeightUniforms.set.textureWidth(textureWidth);
        this.waterHeightUniforms.set.textureHeight(textureHeight);
        this.waterHeightUniforms.set.time(currentTime);
        this.waterHeightUniforms.set.tideHeight(waterResources.getTideHeight());
        this.waterHeightUniforms.set.numWaves(waterResources.getNumWaves());
    }
    /**
   * Update uniforms for terrain composite pass.
   */ updateTerrainCompositeUniforms(clipToWorldMatrix, timeOfDay, width, height, waterResources, terrainResources) {
        if (!this.terrainCompositeUniforms || !this.terrainTileCache) return;
        this.terrainCompositeUniforms.set.cameraMatrix(clipToWorldMatrix);
        this.terrainCompositeUniforms.set.screenWidth(width);
        this.terrainCompositeUniforms.set.screenHeight(height);
        this.terrainCompositeUniforms.set.pixelRatio(this.game.getRenderer().getPixelRatio());
        this.terrainCompositeUniforms.set.tideHeight(waterResources.getTideHeight());
        this.terrainCompositeUniforms.set.hasTerrainData(terrainResources ? 1 : 0);
        const atlasInfo = this.terrainTileCache.getAtlasInfo();
        this.terrainCompositeUniforms.set.atlasTileSize(atlasInfo.tileSize);
        this.terrainCompositeUniforms.set.atlasTilesX(atlasInfo.tilesX);
        this.terrainCompositeUniforms.set.atlasTilesY(atlasInfo.tilesY);
        this.terrainCompositeUniforms.set.atlasWorldUnitsPerTile(atlasInfo.worldUnitsPerTile);
        (0, $07d5066b6e7a4428$export$8143d277ae9e6de4)(this.terrainCompositeUniforms.set, timeOfDay);
    }
    /**
   * Update uniforms for water filter pass.
   */ updateWaterFilterUniforms(clipToWorldMatrix, worldToTexClipMatrix, currentTime, timeOfDay, width, height, waterResources, terrainResources) {
        if (!this.waterFilterUniforms) return;
        this.waterFilterUniforms.set.cameraMatrix(clipToWorldMatrix);
        this.waterFilterUniforms.set.worldToTexClip(worldToTexClipMatrix);
        this.waterFilterUniforms.set.screenWidth(width);
        this.waterFilterUniforms.set.screenHeight(height);
        this.waterFilterUniforms.set.pixelRatio(this.game.getRenderer().getPixelRatio());
        this.waterFilterUniforms.set.time(currentTime);
        this.waterFilterUniforms.set.tideHeight(waterResources.getTideHeight());
        this.waterFilterUniforms.set.hasTerrainData(terrainResources ? 1 : 0);
        this.waterFilterUniforms.set.chlorophyll($8f91167edee9a01b$var$DEFAULT_CHLOROPHYLL);
        this.waterFilterUniforms.set.cdom($8f91167edee9a01b$var$DEFAULT_CDOM);
        this.waterFilterUniforms.set.sediment($8f91167edee9a01b$var$DEFAULT_SEDIMENT);
        (0, $07d5066b6e7a4428$export$8143d277ae9e6de4)(this.waterFilterUniforms.set, timeOfDay);
    }
    /**
   * Ensure bind groups are up to date.
   */ ensureBindGroups(waterResources, terrainAtlasView) {
        const waveDataBuffer = waterResources.waveDataBuffer;
        const needsRebuild = !this.terrainScreenBindGroup || !this.waterHeightBindGroup || !this.terrainCompositeBindGroup || this.lastWaveDataBuffer !== waveDataBuffer || this.lastTerrainAtlasView !== terrainAtlasView || this.lastWaveFieldTextureView !== this.waveFieldTextureView;
        if (!needsRebuild) return;
        // Terrain screen bind group (samples atlas → screen-space texture)
        if (this.terrainScreenShader && this.terrainScreenUniformBuffer && this.terrainHeightView) this.terrainScreenBindGroup = this.terrainScreenShader.createBindGroup({
            params: {
                buffer: this.terrainScreenUniformBuffer
            },
            terrainTileAtlas: terrainAtlasView,
            outputTexture: this.terrainHeightView
        });
        // Water height bind group (pure ocean surface; boat-air substitution
        // moved to the water filter so the height texture stays continuous).
        if (this.waterHeightShader && this.waterHeightUniformBuffer && this.waterHeightView && this.waveFieldTextureView && this.waveFieldSampler && this.modifierTextureView && this.modifierSampler) this.waterHeightBindGroup = this.waterHeightShader.createBindGroup({
            params: {
                buffer: this.waterHeightUniformBuffer
            },
            waveData: {
                buffer: waveDataBuffer
            },
            modifierTexture: this.modifierTextureView,
            modifierSampler: this.modifierSampler,
            waveFieldTexture: this.waveFieldTextureView,
            waveFieldSampler: this.waveFieldSampler,
            outputTexture: this.waterHeightView
        });
        // Terrain composite bind group (stable — reads only compute outputs)
        const wetnessTextureView = this.wetnessPipeline?.getOutputTextureView();
        if (this.terrainCompositeShader && this.terrainCompositeUniformBuffer && this.biomeUniformBuffer && wetnessTextureView) this.terrainCompositeBindGroup = this.terrainCompositeShader.createBindGroup({
            params: {
                buffer: this.terrainCompositeUniformBuffer
            },
            terrainTileAtlas: terrainAtlasView,
            wetnessTexture: wetnessTextureView,
            biomeParams: {
                buffer: this.biomeUniformBuffer
            }
        });
        // Note: water filter bind group is rebuilt separately in
        // rebuildWaterFilterBindGroup() right before the filter pass, after
        // depth and color copies produce their readable views.
        // Update tracking
        this.lastWaveDataBuffer = waveDataBuffer;
        this.lastTerrainAtlasView = terrainAtlasView;
        this.lastWaveFieldTextureView = this.waveFieldTextureView;
    }
    /**
   * Rebuild the water filter bind group with current scene color and depth
   * copy views. Called right before the water filter pass.
   */ rebuildWaterFilterBindGroup(sceneColorView, sceneDepthView) {
        if (this.waterFilterShader && this.waterFilterUniformBuffer && this.waterHeightView && this.heightSampler && this.boatAirTextureView && sceneColorView && sceneDepthView) this.waterFilterBindGroup = this.waterFilterShader.createBindGroup({
            params: {
                buffer: this.waterFilterUniformBuffer
            },
            boatAirTexture: this.boatAirTextureView,
            sceneColorTexture: sceneColorView,
            sceneDepthTexture: sceneDepthView,
            waterHeightTexture: this.waterHeightView,
            heightSampler: this.heightSampler
        });
    }
    onRender(event) {
        if (!this.initialized || !this.terrainTileCache || !this.enabled) return;
        const camera = this.game.camera;
        const renderer = this.game.getRenderer();
        const gpuProfiler = renderer.getGpuProfiler();
        const device = this.game.getWebGPUDevice();
        const width = renderer.getWidth();
        const height = renderer.getHeight();
        const expandedViewport = this.getExpandedViewport($8f91167edee9a01b$var$TILE_CACHE_VIEWPORT_MARGIN);
        // Use TimeOfDay as unified time source
        const timeOfDay = this.game.entities.tryGetSingleton((0, $4df5c29ec7839388$export$1467403458327a44));
        const currentTime = timeOfDay ? timeOfDay.getTimeInSeconds() : this.game.elapsedUnpausedTime;
        // Push the current ambient illumination to the generic shape pipeline so
        // every `draw.*` call this frame picks up day/night tinting automatically.
        // Callers opt out by setting `ignoreLight: true` in DrawOptions.
        if (timeOfDay) {
            const [ar, ag, ab] = timeOfDay.getAmbientLight();
            renderer.setAmbientLight(ar, ag, ab);
        } else renderer.setAmbientLight(1, 1, 1);
        // Get resources (these are required - will throw if missing)
        const wavePhysicsResources = this.game.entities.tryGetSingleton((0, $ffbca396848d8854$export$8b9e0edba56abb99));
        const waterResources = this.game.entities.getSingleton((0, $cb7a1399420ef9b3$export$56d2cf3a64cd00a4));
        const terrainResources = this.game.entities.getSingleton((0, $cd92036e590b44aa$export$74cf638da29b900d));
        // Ensure intermediate textures
        this.ensureTextures(width, height);
        // Compute clip-to-world matrix: maps clip space (-1,1) directly to world space.
        // Composed as: screenToWorld * clipToScreen
        // Note: clipToScreen does NOT flip Y here. The old UV-based clipToWorld used
        // uvY = -clipY*0.5+0.5, which combined with the viewport bounds produced a
        // mapping equivalent to clip(-1,-1)→screen(0,0). The camera inverse already
        // handles the world Y-up ↔ screen Y-down conversion.
        const clipToScreen = new (0, $b29a77d98f1bc0d5$export$8ff26dafa08918)();
        clipToScreen.translate(width / 2, height / 2);
        clipToScreen.scale(width / 2, height / 2);
        const clipToWorldMatrix = camera.getMatrix().clone().invert();
        clipToWorldMatrix.multiply(clipToScreen);
        // Screen-aligned mapping for the surface textures. Each texture is
        // (width + 2m) × (height + 2m) texels with a pixel-integer margin, so
        // screen pixel (i, j) lines up with texel (i + m, j + m) exactly. The
        // texture's clip[-1,1] covers screen-pixel range [-m, width+m] on X and
        // [-m, height+m] on Y. Built by scaling the screen clipToWorld by
        // texW/width (equivalent to texScale in the old 10%-margin form, just
        // with a pixel-integer margin instead of a fractional one).
        const texW = width + 2 * (0, $f1d767035e355263$export$c4411bf1f7186f47);
        const texH = height + 2 * (0, $f1d767035e355263$export$c4411bf1f7186f47);
        const texClipToWorldMatrix = clipToWorldMatrix.clone().scale(texW / width, texH / height);
        const worldToTexClipMatrix = texClipToWorldMatrix.clone().invert();
        // === Terrain Tile Cache Update ===
        // Check for terrain changes and invalidate if needed
        this.terrainTileCache.checkInvalidation(terrainResources);
        // Update tile cache and get tiles that need rendering
        // Pass camera.z (zoom level) for LOD selection
        const tileRequests = this.terrainTileCache.update(expandedViewport, camera.z, terrainResources);
        // Render any missing tiles (current LOD + budget-limited adjacent pre-warming)
        this.terrainTileCache.renderTiles(tileRequests, terrainResources, gpuProfiler ?? undefined);
        // Get terrain atlas view for composite shader
        const terrainAtlasView = this.terrainTileCache.getAtlasView();
        // Update all uniforms. Compute shaders dispatch one invocation per
        // surface-texture texel, so they receive texW × texH. Fragment shaders
        // still use screen width/height for pixel-space math (e.g. normal eps).
        this.updateTerrainScreenUniforms(texClipToWorldMatrix, texW, texH);
        this.updateWaterHeightUniforms(texClipToWorldMatrix, currentTime, texW, texH, waterResources);
        this.updateTerrainCompositeUniforms(clipToWorldMatrix, timeOfDay, width, height, waterResources, terrainResources);
        this.updateWaterFilterUniforms(clipToWorldMatrix, worldToTexClipMatrix, currentTime, timeOfDay, width, height, waterResources, terrainResources);
        // Upload uniforms
        this.terrainScreenUniforms?.uploadTo(this.terrainScreenUniformBuffer);
        this.waterHeightUniforms?.uploadTo(this.waterHeightUniformBuffer);
        this.terrainCompositeUniforms?.uploadTo(this.terrainCompositeUniformBuffer);
        this.waterFilterUniforms?.uploadTo(this.waterFilterUniformBuffer);
        // Ensure bind groups
        this.ensureBindGroups(waterResources, terrainAtlasView);
        // === Pass 1: Terrain Screen Compute ===
        // Sample terrain atlas to screen-space texture for water height shader
        if (this.terrainScreenShader && this.terrainScreenBindGroup) {
            const commandEncoder = device.createCommandEncoder({
                label: "Terrain Screen Compute"
            });
            const computePass = commandEncoder.beginComputePass({
                label: "Terrain Screen Compute Pass",
                timestampWrites: gpuProfiler?.getComputeTimestampWrites("surface.terrain")
            });
            this.terrainScreenShader.dispatch(computePass, this.terrainScreenBindGroup, texW, texH);
            computePass.end();
            device.queue.submit([
                commandEncoder.finish()
            ]);
        }
        // === Pass 1.5: Wave Field Rasterization ===
        // Rasterize wavefront meshes to screen-space texture array
        if (this.waveFieldTexture && wavePhysicsResources) {
            const rasterizer = wavePhysicsResources.getRasterizer();
            if (rasterizer) {
                const activeMeshes = wavePhysicsResources.getActiveMeshes();
                const commandEncoder = device.createCommandEncoder({
                    label: "Wave Field Rasterization"
                });
                rasterizer.render(commandEncoder, activeMeshes, worldToTexClipMatrix, this.waveFieldTexture, gpuProfiler);
                device.queue.submit([
                    commandEncoder.finish()
                ]);
            }
        }
        // === Pass 1.75: Modifier Rasterization ===
        // Rasterize wake/ripple contributions to screen-space texture
        if (this.modifierRasterizer && this.modifierTexture) {
            const commandEncoder = device.createCommandEncoder({
                label: "Modifier Rasterization"
            });
            this.modifierRasterizer.render(commandEncoder, waterResources.modifiersBuffer, waterResources.getModifierCount(), worldToTexClipMatrix, this.modifierTexture, gpuProfiler);
            device.queue.submit([
                commandEncoder.finish()
            ]);
        }
        // === Pass 1.8: Boat Air Rasterization ===
        // Rasterize each boat's air gap (bilge surface Z + deck cap Z) into
        // boatAirTexture. The water height compute reads this and substitutes
        // the bilge surface for the ocean wherever the ocean would lie inside
        // an air column. One uniform per-pixel mechanism handles dry boats,
        // wet bilges, partial submersion, and full submersion.
        if (this.boatAirShader && this.boatAirTextureView) {
            const boat = this.game.entities.getById("boat");
            if (boat) this.boatAirShader.render(this.boatAirTextureView, worldToTexClipMatrix, boat);
            else // No boat — clear the air texture to "no air anywhere" so the
            // water height compute's substitution is a no-op.
            this.boatAirShader.clear(this.boatAirTextureView);
        }
        // === Pass 2: Water Height Compute ===
        if (this.waterHeightShader && this.waterHeightBindGroup) {
            const commandEncoder = device.createCommandEncoder({
                label: "Water Height Compute"
            });
            const computePass = commandEncoder.beginComputePass({
                label: "Water Height Compute Pass",
                timestampWrites: gpuProfiler?.getComputeTimestampWrites("surface.water")
            });
            this.waterHeightShader.dispatch(computePass, this.waterHeightBindGroup, texW, texH);
            computePass.end();
            device.queue.submit([
                commandEncoder.finish()
            ]);
        }
        // === Wetness Update Pass ===
        if (this.wetnessPipeline && this.wetnessPipeline.isInitialized() && this.waterHeightView && this.terrainHeightView) // Wetness texture shares the screen-space layout of water/terrain.
        this.wetnessPipeline.update(texClipToWorldMatrix, worldToTexClipMatrix, this.waterHeightView, this.terrainHeightView, event.dt, gpuProfiler);
        const webgpuRenderer = this.game.getRenderer();
        // === Pass 3a: Terrain Composite (fragment) ===
        // Renders above-water terrain into the current mainColorTexture pass.
        // greater-equal depth test: boat pixels already at higher z block terrain.
        // Pixels where waterDepth >= 0 are discarded — water filter handles those.
        const terrainPass = renderer.getCurrentRenderPass();
        if (terrainPass && this.terrainCompositeShader && this.terrainCompositeBindGroup) this.terrainCompositeShader.render(terrainPass, this.terrainCompositeBindGroup);
        // Copy depth and color so the water filter can read the frozen scene.
        // Ordering: terrain composite → copyDepthBuffer → copyColorBuffer.
        // copyColorBuffer switches the active render target from mainColorTexture
        // to the swapchain; subsequent draw calls go to the final frame output.
        webgpuRenderer.copyDepthBuffer();
        webgpuRenderer.copyColorBuffer();
        const sceneColorView = webgpuRenderer.getColorCopyTextureView();
        const sceneDepthView = webgpuRenderer.getDepthCopyTextureView();
        this.rebuildWaterFilterBindGroup(sceneColorView, sceneDepthView);
        // === Pass 3b: Water Filter (fragment) ===
        // Applies physically-based absorption to the frozen scene and writes
        // the final composited pixel to the swapchain. Post-water particles
        // (wake) render on top in their own layers afterward.
        const filterPass = renderer.getCurrentRenderPass();
        if (filterPass && this.waterFilterShader && this.waterFilterBindGroup) this.waterFilterShader.render(filterPass, this.waterFilterBindGroup);
    }
    /**
   * Get the screen-space water height texture (output of Pass 2).
   * Returns null if not initialized.
   */ getWaterHeightTextureView() {
        return this.waterHeightView;
    }
    /**
   * Get the screen-space terrain height texture (output of Pass 1).
   * Returns null if not initialized.
   */ getTerrainHeightTextureView() {
        return this.terrainHeightView;
    }
    /**
   * Get the terrain tile atlas view for debug visualization.
   * Returns null if not initialized.
   */ getTerrainAtlasView() {
        return this.terrainTileCache?.getAtlasView() ?? null;
    }
    /**
   * Get terrain tile cache stats for debugging.
   */ getTerrainTileCacheStats() {
        if (!this.terrainTileCache) return null;
        const lodConfig = this.terrainTileCache.getCurrentLODConfig();
        return {
            cachedTiles: this.terrainTileCache.getCachedTileCount(),
            readyTiles: this.terrainTileCache.getReadyTileCount(),
            currentLOD: this.terrainTileCache.getCurrentLOD(),
            worldUnitsPerTile: lodConfig.worldUnitsPerTile
        };
    }
    onDestroy() {
        this.terrainScreenShader?.destroy();
        this.waterHeightShader?.destroy();
        this.terrainCompositeShader?.destroy();
        this.waterFilterShader?.destroy();
        this.terrainTileCache?.destroy();
        this.wetnessPipeline?.destroy();
        this.modifierRasterizer?.destroy();
        this.terrainHeightTexture?.destroy();
        this.waterHeightTexture?.destroy();
        this.waveFieldTexture?.destroy();
        this.modifierTexture?.destroy();
        this.terrainScreenUniformBuffer?.destroy();
        this.waterHeightUniformBuffer?.destroy();
        this.terrainCompositeUniformBuffer?.destroy();
        this.waterFilterUniformBuffer?.destroy();
        this.biomeUniformBuffer?.destroy();
    }
}
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $aa1f0309d9dba6d2$export$af631764ddc44097)("add")
], $8f91167edee9a01b$export$86ec1cc3842ae5f.prototype, "onAdd", null);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $aa1f0309d9dba6d2$export$af631764ddc44097)("render")
], $8f91167edee9a01b$export$86ec1cc3842ae5f.prototype, "onRender", null);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $aa1f0309d9dba6d2$export$af631764ddc44097)("destroy")
], $8f91167edee9a01b$export$86ec1cc3842ae5f.prototype, "onDestroy", null);






/** Max terrain height for debug visualization gradient (ft) */ const $c1bea5f7b6d46ebf$var$MAX_TERRAIN_HEIGHT = 500;
// Margin for render viewport expansion (must match SurfaceRenderer)
const $c1bea5f7b6d46ebf$var$RENDER_VIEWPORT_MARGIN = 0.1;
/**
 * Uniforms for the terrain height debug shader.
 */ const $c1bea5f7b6d46ebf$var$TerrainHeightDebugUniforms = (0, $ca6793d1abd58997$export$99bb2281c7368d10)("Params", {
    cameraMatrix: (0, $ca6793d1abd58997$export$a9b01fc77c97438b),
    worldToTexClip: (0, $ca6793d1abd58997$export$a9b01fc77c97438b),
    screenWidth: (0, $ca6793d1abd58997$export$e33361ff41014190),
    screenHeight: (0, $ca6793d1abd58997$export$e33361ff41014190)
});
/**
 * Params module with uniforms and bindings for terrain height visualization.
 */ const $c1bea5f7b6d46ebf$var$terrainHeightDebugParamsModule = {
    preamble: /*wgsl*/ `
struct Params {
  cameraMatrix: mat3x3<f32>,
  worldToTexClip: mat3x3<f32>,
  screenWidth: f32,
  screenHeight: f32,
}
`,
    bindings: {
        params: {
            type: "uniform",
            wgslType: "Params"
        },
        heightTexture: {
            type: "texture",
            sampleType: "unfilterable-float"
        }
    },
    code: ""
};
/**
 * Main fullscreen shader module for terrain height visualization.
 */ const $c1bea5f7b6d46ebf$var$terrainHeightDebugMainModule = {
    dependencies: [
        $c1bea5f7b6d46ebf$var$terrainHeightDebugParamsModule
    ],
    code: /*wgsl*/ `
// Vertex output
struct VertexOutput {
  @builtin(position) position: vec4<f32>,
  @location(0) clipPosition: vec2<f32>,
}

// Fullscreen vertex shader
@vertex
fn vs_main(@location(0) position: vec2<f32>) -> VertexOutput {
  var out: VertexOutput;
  out.position = vec4<f32>(position, 0.0, 1.0);
  out.clipPosition = position;
  return out;
}

// Convert clip position to world position using screen clipToWorld.
fn clipToWorld(clipPos: vec2<f32>) -> vec2<f32> {
  return (params.cameraMatrix * vec3<f32>(clipPos, 1.0)).xy;
}

// World \u{2192} screen-space texture UV (covers clip[-1,1] of the expanded
// screen-aligned viewport).
fn worldToHeightUV(worldPos: vec2<f32>) -> vec2<f32> {
  let clip = (params.worldToTexClip * vec3<f32>(worldPos, 1.0)).xy;
  return vec2<f32>((clip.x + 1.0) * 0.5, (1.0 - clip.y) * 0.5);
}

// Sample terrain height at world position
fn sampleTerrainHeight(worldPos: vec2<f32>) -> f32 {
  let uv = worldToHeightUV(worldPos);
  let w = i32(params.screenWidth);
  let h = i32(params.screenHeight);
  let tx = clamp(i32(uv.x * params.screenWidth), 0, w - 1);
  let ty = clamp(i32(uv.y * params.screenHeight), 0, h - 1);
  return textureLoad(heightTexture, vec2<i32>(tx, ty), 0).r;
}

// Map height to grayscale (linear from dark to light)
fn heightToColor(height: f32) -> vec3<f32> {
  // Map height range [${(0, $50f569eac7e9a7b2$export$7f882bb969de14a3)}, ${$c1bea5f7b6d46ebf$var$MAX_TERRAIN_HEIGHT}] to [0.1, 0.9] grayscale
  let t = clamp((height - ${(0, $50f569eac7e9a7b2$export$7f882bb969de14a3)}.0) / ${$c1bea5f7b6d46ebf$var$MAX_TERRAIN_HEIGHT - (0, $50f569eac7e9a7b2$export$7f882bb969de14a3)}.0, 0.0, 1.0);
  let gray = mix(0.1, 0.9, t);
  return vec3<f32>(gray, gray, gray);
}

// Fragment shader
@fragment
fn fs_main(in: VertexOutput) -> @location(0) vec4<f32> {
  let worldPos = clipToWorld(in.clipPosition);
  let height = sampleTerrainHeight(worldPos);
  let color = heightToColor(height);
  return vec4<f32>(color, 1.0);
}
`
};
const $c1bea5f7b6d46ebf$var$terrainHeightDebugShaderConfig = {
    modules: [
        $c1bea5f7b6d46ebf$var$terrainHeightDebugMainModule
    ],
    label: "TerrainHeightDebugShader"
};
// Convert radians to compass direction
function $c1bea5f7b6d46ebf$var$radiansToCompass(radians) {
    // Normalize to 0-2π
    const normalized = (radians % (2 * Math.PI) + 2 * Math.PI) % (2 * Math.PI);
    // Convert to degrees (0° = East, with +Y=down so positive angles rotate clockwise on screen)
    const degrees = normalized * 180 / Math.PI;
    // Convert to compass bearing (0° = North, clockwise)
    const compassDeg = (degrees + 90) % 360;
    const directions = [
        "N",
        "NE",
        "E",
        "SE",
        "S",
        "SW",
        "W",
        "NW"
    ];
    const index = Math.round(compassDeg / 45) % 8;
    return directions[index];
}
function $c1bea5f7b6d46ebf$var$radiansToCompassBearingDeg(radians) {
    const normalized = (radians % (2 * Math.PI) + 2 * Math.PI) % (2 * Math.PI);
    const degrees = normalized * 180 / Math.PI;
    return (degrees + 90) % 360;
}
class $c1bea5f7b6d46ebf$export$5719f1b5c6492235 extends (0, $6eb211648954ac4c$export$8230771f441ce638) {
    constructor(){
        super(), this.layer = "windViz", this.shader = null, this.uniformBuffer = null, this.uniforms = null, this.bindGroup = null, this.initialized = false, // Track texture view to detect changes
        this.lastTextureView = null, // Placeholder texture for when surface renderer isn't ready
        this.placeholderTexture = null, this.placeholderTextureView = null;
        // Query terrain at cursor position
        this.terrainQuery = this.addChild(new (0, $178448b994cda479$export$b2f87c4d67934c2d)(()=>this.getCursorQueryPoint()));
    }
    getCursorQueryPoint() {
        if (!this.game) return [];
        const mouseWorldPos = this.game.camera.toWorld(this.game.io.mousePosition);
        if (!mouseWorldPos) return [];
        return [
            mouseWorldPos
        ];
    }
    async onAdd() {
        await this.ensureInitialized();
    }
    async ensureInitialized() {
        if (this.initialized) return;
        const device = this.game.getWebGPUDevice();
        // Create shader
        this.shader = new (0, $c43b1a1e19bbbf4b$export$b176bfba5cd328c9)($c1bea5f7b6d46ebf$var$terrainHeightDebugShaderConfig);
        await this.shader.init();
        // Create uniform buffer
        this.uniformBuffer = device.createBuffer({
            size: $c1bea5f7b6d46ebf$var$TerrainHeightDebugUniforms.byteSize,
            usage: GPUBufferUsage.UNIFORM | GPUBufferUsage.COPY_DST,
            label: "Terrain Height Debug Uniform Buffer"
        });
        // Create uniform instance
        this.uniforms = $c1bea5f7b6d46ebf$var$TerrainHeightDebugUniforms.create();
        // Create placeholder texture (1x1 with default depth value)
        this.placeholderTexture = device.createTexture({
            size: {
                width: 1,
                height: 1
            },
            format: "r32float",
            usage: GPUTextureUsage.TEXTURE_BINDING | GPUTextureUsage.COPY_DST,
            label: "Terrain Height Debug Placeholder"
        });
        this.placeholderTextureView = this.placeholderTexture.createView();
        // Write default depth value
        const data = new Float32Array([
            (0, $50f569eac7e9a7b2$export$7f882bb969de14a3)
        ]);
        device.queue.writeTexture({
            texture: this.placeholderTexture
        }, data, {
            bytesPerRow: 4
        }, {
            width: 1,
            height: 1
        });
        this.initialized = true;
    }
    onRender(_event) {
        if (!this.initialized || !this.shader || !this.uniforms) return;
        const renderer = this.game.getRenderer();
        const renderPass = renderer.getCurrentRenderPass();
        if (!renderPass) return;
        const width = renderer.getWidth();
        const height = renderer.getHeight();
        // Build clipToWorld (screen) and texClipToWorld (expanded, same as
        // SurfaceRenderer). worldToTexClip is its inverse.
        const clipToScreen = new (0, $b29a77d98f1bc0d5$export$8ff26dafa08918)();
        clipToScreen.translate(width / 2, height / 2);
        clipToScreen.scale(width / 2, height / 2);
        const clipToWorld = this.game.camera.getMatrix().clone().invert();
        clipToWorld.multiply(clipToScreen);
        const texScale = 1 + 2 * $c1bea5f7b6d46ebf$var$RENDER_VIEWPORT_MARGIN;
        const texClipToWorld = clipToWorld.clone().scale(texScale, texScale);
        const worldToTexClip = texClipToWorld.clone().invert();
        // Update uniforms
        this.uniforms.set.cameraMatrix(clipToWorld);
        this.uniforms.set.worldToTexClip(worldToTexClip);
        this.uniforms.set.screenWidth(width);
        this.uniforms.set.screenHeight(height);
        this.uniforms.uploadTo(this.uniformBuffer);
        // Get terrain height texture from SurfaceRenderer
        const surfaceRenderer = this.game.entities.tryGetSingleton((0, $8f91167edee9a01b$export$86ec1cc3842ae5f));
        const textureView = surfaceRenderer?.getTerrainHeightTextureView() ?? this.placeholderTextureView;
        if (!textureView) return;
        // Rebuild bind group if texture changed
        if (this.lastTextureView !== textureView) {
            this.bindGroup = this.shader.createBindGroup({
                params: {
                    buffer: this.uniformBuffer
                },
                heightTexture: textureView
            });
            this.lastTextureView = textureView;
        }
        if (this.bindGroup) this.shader.render(renderPass, this.bindGroup);
    }
    onDestroy() {
        this.shader?.destroy();
        this.uniformBuffer?.destroy();
        this.placeholderTexture?.destroy();
    }
    getModeName() {
        return "Terrain Height";
    }
    getHudInfo() {
        const terrainResources = this.game.entities.tryGetSingleton((0, $cd92036e590b44aa$export$74cf638da29b900d));
        const contourCount = terrainResources?.getContourCount() ?? 0;
        return `Contours: ${contourCount}\nDark=deep (${0, $50f569eac7e9a7b2$export$7f882bb969de14a3}ft), Light=high (+${$c1bea5f7b6d46ebf$var$MAX_TERRAIN_HEIGHT}ft)\nCursor: slope angle + grade + downhill direction`;
    }
    getCursorInfo() {
        const mouseWorldPos = this.game.camera.toWorld(this.game.io.mousePosition);
        if (!mouseWorldPos) return null;
        // Get terrain height at cursor from query
        if (this.terrainQuery.length === 0) return null;
        const result = this.terrainQuery.get(0);
        const height = result.height;
        const normal = result.normal;
        const horizontalComponent = Math.hypot(normal.x, normal.y);
        const nz = Math.sqrt(Math.max(0, 1 - horizontalComponent * horizontalComponent));
        // Slope steepness:
        // - angle from horizontal (degrees)
        // - grade as vertical feet gained/lost per 100 horizontal feet
        const slopeAngleDeg = (0, $2172aedd5a25ff17$export$54390e3b44c4a9cb)(Math.atan2(horizontalComponent, nz));
        const gradePercent = nz > 1e-5 ? horizontalComponent / nz * 100 : Number.POSITIVE_INFINITY;
        const gradeText = Number.isFinite(gradePercent) ? `${gradePercent.toFixed(1)}% grade` : "~vertical";
        if (horizontalComponent < 1e-4) return `Terrain Height: ${height.toFixed(1)} ft\nSteepness: ${slopeAngleDeg.toFixed(1)}\xb0 (${gradeText})\nDownhill: Flat`;
        const downhillAngle = Math.atan2(normal.y, normal.x);
        const downhillCompass = $c1bea5f7b6d46ebf$var$radiansToCompass(downhillAngle);
        const downhillBearingDeg = $c1bea5f7b6d46ebf$var$radiansToCompassBearingDeg(downhillAngle);
        return `Terrain Height: ${height.toFixed(1)} ft\nSteepness: ${slopeAngleDeg.toFixed(1)}\xb0 (${gradeText})\nDownhill: ${downhillCompass} (${downhillBearingDeg.toFixed(0)}\xb0)`;
    }
}
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $aa1f0309d9dba6d2$export$af631764ddc44097)("add")
], $c1bea5f7b6d46ebf$export$5719f1b5c6492235.prototype, "onAdd", null);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $aa1f0309d9dba6d2$export$af631764ddc44097)("render")
], $c1bea5f7b6d46ebf$export$5719f1b5c6492235.prototype, "onRender", null);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $aa1f0309d9dba6d2$export$af631764ddc44097)("destroy")
], $c1bea5f7b6d46ebf$export$5719f1b5c6492235.prototype, "onDestroy", null);


/**
 * Water Height Debug Mode
 *
 * Visualizes water surface state and active water modifiers.
 * - HUD: count of active water modifiers
 * - Visual: rings/outlines for all active modifiers (wakes)
 * - Cursor: surface height, terrain depth, and turbulence at cursor position
 */ 





// Overlay
const $0558c29976e40095$var$OVERLAY_COLOR = 0x001133;
const $0558c29976e40095$var$OVERLAY_ALPHA = 0.35;
// Wake ring
const $0558c29976e40095$var$WAKE_RING_COLOR = 0x44aaff;
const $0558c29976e40095$var$WAKE_RING_ALPHA = 0.7;
const $0558c29976e40095$var$WAKE_SOURCE_COLOR = 0xffffff;
const $0558c29976e40095$var$WAKE_SOURCE_ALPHA = 0.9;
const $0558c29976e40095$var$WAKE_SOURCE_RADIUS = 2; // world-space ft
// Foam blob
const $0558c29976e40095$var$FOAM_BLOB_COLOR = 0xffeecc;
const $0558c29976e40095$var$FOAM_BLOB_ALPHA = 0.5;
const $0558c29976e40095$var$STROKE_WIDTH = 1;
class $0558c29976e40095$export$3ac78b7c96e957b3 extends (0, $6eb211648954ac4c$export$8230771f441ce638) {
    constructor(){
        super(), this.layer = "windViz";
        this.waterQuery = this.addChild(new (0, $2f31bbbd4b5b01e3$export$38b1d297f12cec06)(()=>this.getCursorQueryPoint()));
    }
    getCursorQueryPoint() {
        if (!this.game) return [];
        const mouseWorldPos = this.game.camera.toWorld(this.game.io.mousePosition);
        if (!mouseWorldPos) return [];
        return [
            mouseWorldPos
        ];
    }
    onRender({ draw: draw }) {
        const camera = this.game.camera;
        const viewport = camera.getWorldViewport();
        draw.fillRect(viewport.left, viewport.top, viewport.width, viewport.height, {
            color: $0558c29976e40095$var$OVERLAY_COLOR,
            alpha: $0558c29976e40095$var$OVERLAY_ALPHA,
            ignoreLight: true
        });
        const waterResources = this.game.entities.tryGetSingleton((0, $cb7a1399420ef9b3$export$56d2cf3a64cd00a4));
        if (!waterResources) return;
        for (const mod of waterResources.getCachedModifiers())this.drawModifier(mod, draw);
    }
    drawModifier(mod, draw) {
        const data = mod.data;
        if (data.type === (0, $34555dd463019ed0$export$125ddb01a2b383f0).Wake) {
            draw.strokeCircle(data.posX, data.posY, data.ringRadius, {
                color: $0558c29976e40095$var$WAKE_RING_COLOR,
                alpha: $0558c29976e40095$var$WAKE_RING_ALPHA * Math.min(1, data.amplitude * 20),
                width: $0558c29976e40095$var$STROKE_WIDTH,
                ignoreLight: true
            });
            draw.fillCircle(data.posX, data.posY, $0558c29976e40095$var$WAKE_SOURCE_RADIUS, {
                color: $0558c29976e40095$var$WAKE_SOURCE_COLOR,
                alpha: $0558c29976e40095$var$WAKE_SOURCE_ALPHA,
                ignoreLight: true
            });
        } else // Foam blob
        draw.fillCircle(data.posX, data.posY, data.radius, {
            color: $0558c29976e40095$var$FOAM_BLOB_COLOR,
            alpha: $0558c29976e40095$var$FOAM_BLOB_ALPHA * data.intensity,
            ignoreLight: true
        });
    }
    getModeName() {
        return "Water Height";
    }
    getHudInfo() {
        const waterResources = this.game.entities.tryGetSingleton((0, $cb7a1399420ef9b3$export$56d2cf3a64cd00a4));
        const count = waterResources?.getModifierCount() ?? 0;
        return `Water modifiers: ${count}`;
    }
    getCursorInfo() {
        if (this.waterQuery.length === 0) return null;
        const result = this.waterQuery.get(0);
        const height = result.surfaceHeight;
        const depth = result.depth;
        const turbulence = this.computeTurbulenceAtCursor();
        return [
            `Height: ${height.toFixed(2)} ft`,
            `Depth: ${depth.toFixed(1)} ft`,
            `Turbulence: ${(turbulence * 100).toFixed(0)}%`
        ].join("\n");
    }
    /**
   * Approximate the combined wake turbulence at the cursor position.
   * Matches the GPU shader's Gaussian ring falloff for each wake modifier.
   */ computeTurbulenceAtCursor() {
        const mouseWorldPos = this.game.camera.toWorld(this.game.io.mousePosition);
        if (!mouseWorldPos) return 0;
        const waterResources = this.game.entities.tryGetSingleton((0, $cb7a1399420ef9b3$export$56d2cf3a64cd00a4));
        if (!waterResources) return 0;
        const x = mouseWorldPos.x;
        const y = mouseWorldPos.y;
        let total = 0;
        for (const mod of waterResources.getCachedModifiers()){
            const data = mod.data;
            if (data.type !== (0, $34555dd463019ed0$export$125ddb01a2b383f0).Foam) continue;
            const dx = x - data.posX;
            const dy = y - data.posY;
            const dist2 = dx * dx + dy * dy;
            const rSq = Math.max(data.radius * data.radius, 1e-4);
            const falloff = Math.exp(-dist2 / rSq);
            total += data.intensity * falloff;
        }
        return Math.min(1, total);
    }
}
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $aa1f0309d9dba6d2$export$af631764ddc44097)("render")
], $0558c29976e40095$export$3ac78b7c96e957b3.prototype, "onRender", null);


/**
 * Wavefront Mesh debug mode.
 *
 * Visualizes the wavefront marching mesh for wave-terrain interaction.
 * Renders mesh triangles directly on GPU using a custom render pipeline,
 * with colors mapped from a selectable vertex attribute.
 *
 * Use [ and ] to cycle through wave sources.
 * Use { and } to cycle through active builder type (affects game systems).
 * Use V to cycle through color modes (amplitude, phase, wavefront).
 */ 










const $80f72bdc6bdac008$var$WavefrontDebugUniforms = (0, $ca6793d1abd58997$export$99bb2281c7368d10)("WavefrontDebugParams", {
    cameraMatrix: (0, $ca6793d1abd58997$export$a9b01fc77c97438b),
    screenWidth: (0, $ca6793d1abd58997$export$e33361ff41014190),
    screenHeight: (0, $ca6793d1abd58997$export$e33361ff41014190),
    alpha: (0, $ca6793d1abd58997$export$e33361ff41014190),
    colorMode: (0, $ca6793d1abd58997$export$e33361ff41014190),
    waveDirection: (0, $ca6793d1abd58997$export$e33361ff41014190),
    wavelength: (0, $ca6793d1abd58997$export$e33361ff41014190),
    time: (0, $ca6793d1abd58997$export$e33361ff41014190),
    phaseRange: (0, $ca6793d1abd58997$export$e33361ff41014190)
});
const $80f72bdc6bdac008$var$SHADER_CODE = /*wgsl*/ `
const GRAVITY = 32.174;
const TWO_PI = 6.283185;

struct WavefrontDebugParams {
  cameraMatrix0: vec4<f32>,
  cameraMatrix1: vec4<f32>,
  cameraMatrix2: vec4<f32>,
  screenWidth: f32,
  screenHeight: f32,
  alpha: f32,
  colorMode: f32,
  waveDirection: f32,
  wavelength: f32,
  time: f32,
  phaseRange: f32,
}

@group(0) @binding(0) var<uniform> params: WavefrontDebugParams;

struct VertexInput {
  @location(0) position: vec2<f32>,
  @location(1) amplitude: f32,
  @location(2) turbulence: f32,
  @location(3) phaseOffset: f32,
  @location(4) blendWeight: f32,
  @location(5) barycentric: vec2<f32>,
}

struct VertexOutput {
  @builtin(position) position: vec4<f32>,
  @location(0) amplitude: f32,
  @location(1) turbulence: f32,
  @location(2) phaseOffset: f32,
  @location(3) blendWeight: f32,
  @location(4) barycentric: vec2<f32>,
  @location(5) worldPos: vec2<f32>,
}

fn getCameraMatrix() -> mat3x3<f32> {
  return mat3x3<f32>(
    params.cameraMatrix0.xyz,
    params.cameraMatrix1.xyz,
    params.cameraMatrix2.xyz
  );
}

@vertex
fn vs_main(in: VertexInput) -> VertexOutput {
  let cameraMatrix = getCameraMatrix();
  let pixelPos = cameraMatrix * vec3<f32>(in.position, 1.0);
  let clipX = pixelPos.x * 2.0 / params.screenWidth - 1.0;
  let clipY = pixelPos.y * 2.0 / params.screenHeight - 1.0;

  var out: VertexOutput;
  out.position = vec4<f32>(clipX, clipY, 0.0, 1.0);
  out.amplitude = in.amplitude;
  out.turbulence = in.turbulence;
  out.phaseOffset = in.phaseOffset;
  out.blendWeight = in.blendWeight;
  out.barycentric = in.barycentric;
  out.worldPos = in.position;
  return out;
}

// Mode 0: Amplitude \u{2014} red (blocked) -> yellow -> green (open) -> cyan (convergence)
fn amplitudeToColor(amp: f32) -> vec3<f32> {
  if (amp <= 0.0) { return vec3<f32>(0.3, 0.0, 0.0); }
  if (amp <= 0.5) {
    let t = amp / 0.5;
    return vec3<f32>(1.0, t, 0.0);
  }
  if (amp <= 1.0) {
    let t = (amp - 0.5) / 0.5;
    return vec3<f32>(1.0 - t, 1.0, 0.0);
  }
  let t = min((amp - 1.0) / 0.5, 1.0);
  return vec3<f32>(0.0, 1.0, t);
}

// Mode 1: Phase offset \u{2014} cyclic rainbow
fn phaseToColor(phase: f32) -> vec3<f32> {
  let t = fract(phase / TWO_PI);
  let r = abs(t * 6.0 - 3.0) - 1.0;
  let g = 2.0 - abs(t * 6.0 - 2.0);
  let b = 2.0 - abs(t * 6.0 - 4.0);
  return saturate(vec3<f32>(r, g, b));
}

// Mode 2: Single animated wavefront band sweeping across the mesh
fn wavefrontBand(worldPos: vec2<f32>, phaseOffset: f32) -> f32 {
  let k = TWO_PI / params.wavelength;
  let omega = sqrt(GRAVITY * k);
  let dirUnit = vec2<f32>(cos(params.waveDirection), sin(params.waveDirection));
  let totalPhase = k * dot(worldPos, dirUnit) + phaseOffset;

  // Wrap (totalPhase - omega*time*speedMult) into [0, phaseRange) for a single band
  let diff = totalPhase - omega * params.time * 20.0;
  let range = params.phaseRange;
  let wrapped = diff - floor(diff / range) * range;

  // Highlight near wrapped \u{2248} 0 (with wrapping at range boundary)
  let distToBand = min(wrapped, range - wrapped);
  let bandWidth = range * 0.003;
  return step(distToBand, bandWidth);
}

@fragment
fn fs_main(in: VertexOutput) -> @location(0) vec4<f32> {
  // Reconstruct full barycentric coordinates
  let bary = vec3<f32>(in.barycentric, 1.0 - in.barycentric.x - in.barycentric.y);

  // Distance to nearest edge in screen-space
  let minBary = min(bary.x, min(bary.y, bary.z));
  let fw = fwidth(minBary);
  let edge = smoothstep(0.0, fw * 1.5, minBary);

  let mode = u32(params.colorMode);

  // Wavefront mode: transparent background, band alpha varies with amplitude
  if (mode == 2u) {
    let band = wavefrontBand(in.worldPos, in.phaseOffset);
    if (band < 0.5) { discard; }
    let amp = clamp(in.amplitude, 0.0, 1.5);
    let a = mix(0.15, 1.0, amp);
    return vec4<f32>(0.2, 0.7, 1.0, a);
  }

  var fillColor: vec3<f32>;
  switch (mode) {
    case 1u: { fillColor = phaseToColor(in.phaseOffset); }
    default: { fillColor = amplitudeToColor(in.amplitude); }
  }

  let edgeColor = vec3<f32>(0.0, 0.0, 0.0);
  let color = mix(edgeColor, fillColor, edge);
  return vec4<f32>(color, params.alpha);
}
`;
/** Barycentric coords for each vertex position within a triangle */ const $80f72bdc6bdac008$var$BARY_COORDS = [
    [
        1,
        0
    ],
    [
        0,
        1
    ],
    [
        0,
        0
    ]
];
const $80f72bdc6bdac008$var$BARY_INSIDE_EPS = 0.001;
const $80f72bdc6bdac008$var$DEGENERATE_TRIANGLE_EPS = 1e-10;
const $80f72bdc6bdac008$var$COLOR_MODE_NAMES = [
    "Amplitude",
    "Phase",
    "Wavefront"
];
class $80f72bdc6bdac008$export$5682830a3e9da60c extends (0, $6eb211648954ac4c$export$8230771f441ce638) {
    constructor(){
        super(), this.layer = "windViz", this.selectedWaveIndex = 0, this.colorMode = 0, this.waveTimeOffset = 0, this.pipeline = null, this.bindGroupLayout = null, this.uniformBuffer = null, this.uniforms = null, this.bindGroup = null, this.initialized = false, this.shaderModule = null, this.pipelineLayout = null, this.unsubscribeMSAA = null, /** Cached wireframe buffers keyed by source mesh */ this.wireframeCache = new Map();
        this.terrainQuery = this.addChild(new (0, $178448b994cda479$export$b2f87c4d67934c2d)(()=>this.getCursorQueryPoint()));
        this.waterQuery = this.addChild(new (0, $2f31bbbd4b5b01e3$export$38b1d297f12cec06)(()=>this.getCursorQueryPoint()));
    }
    getCursorQueryPoint() {
        if (!this.game) return [];
        const mouseWorldPos = this.game.camera.toWorld(this.game.io.mousePosition);
        if (!mouseWorldPos) return [];
        return [
            mouseWorldPos
        ];
    }
    async onAdd() {
        await this.initPipeline();
    }
    async initPipeline() {
        if (this.initialized) return;
        const device = this.game.getWebGPUDevice();
        this.shaderModule = device.createShaderModule({
            code: $80f72bdc6bdac008$var$SHADER_CODE,
            label: "Wavefront Debug Shader"
        });
        await (0, $558c2f47f1fdd57f$export$bdd7f96686113d46)(this.shaderModule, $80f72bdc6bdac008$var$SHADER_CODE, "Wavefront Debug Shader");
        this.bindGroupLayout = device.createBindGroupLayout({
            entries: [
                {
                    binding: 0,
                    visibility: GPUShaderStage.VERTEX | GPUShaderStage.FRAGMENT,
                    buffer: {
                        type: "uniform"
                    }
                }
            ],
            label: "Wavefront Debug Bind Group Layout"
        });
        this.pipelineLayout = device.createPipelineLayout({
            bindGroupLayouts: [
                this.bindGroupLayout
            ],
            label: "Wavefront Debug Pipeline Layout"
        });
        this.rebuildPipeline();
        this.unsubscribeMSAA = (0, $3d4164726c38f33c$export$19f5a511f7104745)(()=>this.rebuildPipeline());
        this.uniformBuffer = device.createBuffer({
            size: $80f72bdc6bdac008$var$WavefrontDebugUniforms.byteSize,
            usage: GPUBufferUsage.UNIFORM | GPUBufferUsage.COPY_DST,
            label: "Wavefront Debug Uniforms"
        });
        this.uniforms = $80f72bdc6bdac008$var$WavefrontDebugUniforms.create();
        this.bindGroup = device.createBindGroup({
            layout: this.bindGroupLayout,
            entries: [
                {
                    binding: 0,
                    resource: {
                        buffer: this.uniformBuffer
                    }
                }
            ],
            label: "Wavefront Debug Bind Group"
        });
        this.initialized = true;
    }
    rebuildPipeline() {
        if (!this.shaderModule || !this.pipelineLayout) return;
        const device = this.game.getWebGPUDevice();
        this.pipeline = device.createRenderPipeline({
            layout: this.pipelineLayout,
            vertex: {
                module: this.shaderModule,
                entryPoint: "vs_main",
                buffers: [
                    {
                        arrayStride: 32,
                        attributes: [
                            {
                                format: "float32x2",
                                offset: 0,
                                shaderLocation: 0
                            },
                            {
                                format: "float32",
                                offset: 8,
                                shaderLocation: 1
                            },
                            {
                                format: "float32",
                                offset: 12,
                                shaderLocation: 2
                            },
                            {
                                format: "float32",
                                offset: 16,
                                shaderLocation: 3
                            },
                            {
                                format: "float32",
                                offset: 20,
                                shaderLocation: 4
                            },
                            {
                                format: "float32x2",
                                offset: 24,
                                shaderLocation: 5
                            }
                        ]
                    }
                ]
            },
            fragment: {
                module: this.shaderModule,
                entryPoint: "fs_main",
                targets: [
                    {
                        format: this.game.getWebGPUPreferredFormat(),
                        blend: {
                            color: {
                                srcFactor: "src-alpha",
                                dstFactor: "one-minus-src-alpha",
                                operation: "add"
                            },
                            alpha: {
                                srcFactor: "one",
                                dstFactor: "one-minus-src-alpha",
                                operation: "add"
                            }
                        }
                    }
                ]
            },
            primitive: {
                topology: "triangle-list"
            },
            depthStencil: {
                format: "depth24plus",
                depthCompare: "always",
                depthWriteEnabled: false
            },
            multisample: {
                count: (0, $3d4164726c38f33c$export$688369c54d530641)()
            },
            label: "Wavefront Debug Pipeline"
        });
    }
    onRender(_event) {
        if (!this.initialized || !this.pipeline || !this.bindGroup || !this.uniformBuffer || !this.uniforms) return;
        const wavePhysicsResources = this.game.entities.tryGetSingleton((0, $ffbca396848d8854$export$8b9e0edba56abb99));
        const wavePhysicsManager = wavePhysicsResources?.getWavePhysicsManager();
        if (!wavePhysicsManager || !wavePhysicsManager.isInitialized()) return;
        const meshes = wavePhysicsManager.getActiveMeshes();
        if (meshes.length === 0) return;
        const device = this.game.getWebGPUDevice();
        // Evict wireframe buffers for meshes that no longer exist
        for (const [mesh, cached] of this.wireframeCache)if (!meshes.includes(mesh)) {
            cached.buffer.destroy();
            this.wireframeCache.delete(mesh);
        }
        const renderer = this.game.getRenderer();
        const renderPass = renderer.getCurrentRenderPass();
        if (!renderPass) return;
        // Camera world->pixel matrix (set by setLayer for windViz)
        const cameraMatrix = renderer.getTransform();
        const width = renderer.getWidth();
        const height = renderer.getHeight();
        this.uniforms.set.cameraMatrix(cameraMatrix);
        this.uniforms.set.screenWidth(width);
        this.uniforms.set.screenHeight(height);
        this.uniforms.set.alpha(0.3);
        this.uniforms.set.colorMode(this.colorMode);
        this.uniforms.set.time(this.game.elapsedTime - this.waveTimeOffset);
        renderPass.setPipeline(this.pipeline);
        renderPass.setBindGroup(0, this.bindGroup);
        const selectedWaveIndex = this.normalizeSelectedWaveIndex(meshes.length);
        const mesh = meshes[selectedWaveIndex];
        const wireframe = this.getWireframeBuffer(mesh, device);
        this.uniforms.set.waveDirection(mesh.waveDirection);
        this.uniforms.set.wavelength(mesh.wavelength);
        this.uniforms.set.phaseRange(wireframe.totalPhaseRange);
        this.uniforms.uploadTo(this.uniformBuffer);
        renderPass.setVertexBuffer(0, wireframe.buffer);
        renderPass.draw(wireframe.vertexCount);
    }
    /** Build or retrieve a non-indexed vertex buffer with barycentric coordinates. */ getWireframeBuffer(mesh, device) {
        const cached = this.wireframeCache.get(mesh);
        if (cached) return cached;
        const { cpuVertexData: cpuVertexData, cpuIndexData: cpuIndexData, indexCount: indexCount } = mesh;
        const floatsPerVertex = 8; // posX, posY, amplitude, turbulence, phaseOffset, blendWeight, baryU, baryV
        const expanded = new Float32Array(indexCount * floatsPerVertex);
        // Compute totalPhase range for single-band wavefront mode
        const k = 2 * Math.PI / mesh.wavelength;
        const dirCos = Math.cos(mesh.waveDirection);
        const dirSin = Math.sin(mesh.waveDirection);
        let minPhase = Infinity;
        let maxPhase = -Infinity;
        for(let i = 0; i < indexCount; i++){
            const srcBase = cpuIndexData[i] * (0, $507f47de806c09bd$export$7289f13d9ecb686e);
            const dstBase = i * floatsPerVertex;
            const bary = $80f72bdc6bdac008$var$BARY_COORDS[i % $80f72bdc6bdac008$var$BARY_COORDS.length];
            const vertex = cpuVertexData.slice(srcBase, srcBase + (0, $507f47de806c09bd$export$7289f13d9ecb686e));
            expanded.set(vertex, dstBase);
            expanded.set(bary, dstBase + (0, $507f47de806c09bd$export$7289f13d9ecb686e));
            const px = vertex[0];
            const py = vertex[1];
            const phaseOffset = vertex[4];
            const totalPhase = k * (px * dirCos + py * dirSin) + phaseOffset;
            minPhase = Math.min(minPhase, totalPhase);
            maxPhase = Math.max(maxPhase, totalPhase);
        }
        const buffer = device.createBuffer({
            size: expanded.byteLength,
            usage: GPUBufferUsage.VERTEX | GPUBufferUsage.COPY_DST,
            label: "Wavefront Debug Wireframe"
        });
        device.queue.writeBuffer(buffer, 0, expanded);
        const totalPhaseRange = maxPhase - minPhase;
        const entry = {
            buffer: buffer,
            vertexCount: indexCount,
            totalPhaseRange: totalPhaseRange
        };
        this.wireframeCache.set(mesh, entry);
        return entry;
    }
    computeBarycentric(px, py, ax, ay, bx, by, cx, cy) {
        const v0x = bx - ax;
        const v0y = by - ay;
        const v1x = cx - ax;
        const v1y = cy - ay;
        const v2x = px - ax;
        const v2y = py - ay;
        const d00 = v0x * v0x + v0y * v0y;
        const d01 = v0x * v1x + v0y * v1y;
        const d11 = v1x * v1x + v1y * v1y;
        const d20 = v2x * v0x + v2y * v0y;
        const d21 = v2x * v1x + v2y * v1y;
        const denom = d00 * d11 - d01 * d01;
        if (Math.abs(denom) < $80f72bdc6bdac008$var$DEGENERATE_TRIANGLE_EPS) return null;
        const invDenom = 1 / denom;
        const v = (d11 * d20 - d01 * d21) * invDenom;
        const w = (d00 * d21 - d01 * d20) * invDenom;
        const u = 1 - v - w;
        return [
            u,
            v,
            w
        ];
    }
    isPointInTriangle(px, py, ax, ay, bx, by, cx, cy) {
        const bary = this.computeBarycentric(px, py, ax, ay, bx, by, cx, cy);
        if (!bary) return false;
        return bary[0] >= -$80f72bdc6bdac008$var$BARY_INSIDE_EPS && bary[1] >= -$80f72bdc6bdac008$var$BARY_INSIDE_EPS && bary[2] >= -$80f72bdc6bdac008$var$BARY_INSIDE_EPS;
    }
    isInsideCoverageQuad(mesh, px, py) {
        const q = mesh.coverageQuad;
        if (!q) return false;
        return this.isPointInTriangle(px, py, q.x0, q.y0, q.x1, q.y1, q.x2, q.y2) || this.isPointInTriangle(px, py, q.x0, q.y0, q.x2, q.y2, q.x3, q.y3);
    }
    sampleMeshAtPoint(mesh, px, py) {
        const { cpuVertexData: cpuVertexData, cpuIndexData: cpuIndexData, indexCount: indexCount } = mesh;
        let hitCount = 0;
        let phasorCos = 0;
        let phasorSin = 0;
        let maxTurbulence = 0;
        let firstHit = null;
        for(let i = 0; i < indexCount; i += 3){
            const ia = cpuIndexData[i] * (0, $507f47de806c09bd$export$7289f13d9ecb686e);
            const ib = cpuIndexData[i + 1] * (0, $507f47de806c09bd$export$7289f13d9ecb686e);
            const ic = cpuIndexData[i + 2] * (0, $507f47de806c09bd$export$7289f13d9ecb686e);
            const ax = cpuVertexData[ia];
            const ay = cpuVertexData[ia + 1];
            const bx = cpuVertexData[ib];
            const by = cpuVertexData[ib + 1];
            const cx = cpuVertexData[ic];
            const cy = cpuVertexData[ic + 1];
            const bary = this.computeBarycentric(px, py, ax, ay, bx, by, cx, cy);
            if (!bary) continue;
            const [u, v, w] = bary;
            if (u < -$80f72bdc6bdac008$var$BARY_INSIDE_EPS || v < -$80f72bdc6bdac008$var$BARY_INSIDE_EPS || w < -$80f72bdc6bdac008$var$BARY_INSIDE_EPS) continue;
            const amplitude = cpuVertexData[ia + 2] * u + cpuVertexData[ib + 2] * v + cpuVertexData[ic + 2] * w;
            const turbulence = cpuVertexData[ia + 3] * u + cpuVertexData[ib + 3] * v + cpuVertexData[ic + 3] * w;
            const phaseOffset = cpuVertexData[ia + 4] * u + cpuVertexData[ib + 4] * v + cpuVertexData[ic + 4] * w;
            const blendWeight = cpuVertexData[ia + 5] * u + cpuVertexData[ib + 5] * v + cpuVertexData[ic + 5] * w;
            const weightedAmp = amplitude * blendWeight;
            phasorCos += weightedAmp * Math.cos(phaseOffset);
            phasorSin += weightedAmp * Math.sin(phaseOffset);
            maxTurbulence = Math.max(maxTurbulence, turbulence * blendWeight);
            hitCount++;
            if (!firstHit) firstHit = {
                amplitude: amplitude,
                turbulence: turbulence,
                phaseOffset: phaseOffset,
                blendWeight: blendWeight
            };
        }
        return {
            insideCoverageQuad: this.isInsideCoverageQuad(mesh, px, py),
            hitCount: hitCount,
            phasorCos: phasorCos,
            phasorSin: phasorSin,
            maxTurbulence: maxTurbulence,
            firstHit: firstHit
        };
    }
    onKeyDown({ key: key, event: event }) {
        if (key === "BracketLeft" || key === "BracketRight") {
            const dir = key === "BracketRight" ? 1 : -1;
            if (event.shiftKey) this.cycleBuilderType(dir === 1);
            else this.cycleWaveIndex(dir);
        } else if (key === "KeyV") this.cycleColorMode(event.shiftKey ? -1 : 1);
    }
    cycleBuilderType(forward) {
        const wavePhysicsResources = this.game.entities.tryGetSingleton((0, $ffbca396848d8854$export$8b9e0edba56abb99));
        const wavePhysicsManager = wavePhysicsResources?.getWavePhysicsManager();
        if (!wavePhysicsManager) return;
        const availableTypes = wavePhysicsManager.getActiveBuilderTypes();
        if (availableTypes.length <= 1) return;
        const currentType = wavePhysicsManager.getActiveBuilderType();
        const currentIdx = availableTypes.indexOf(currentType);
        const nextIdx = forward ? (currentIdx + 1) % availableTypes.length : (currentIdx - 1 + availableTypes.length) % availableTypes.length;
        wavePhysicsManager.setActiveBuilderType(availableTypes[nextIdx]);
    }
    onDestroy() {
        this.unsubscribeMSAA?.();
        this.unsubscribeMSAA = null;
        this.uniformBuffer?.destroy();
        for (const cached of this.wireframeCache.values())cached.buffer.destroy();
        this.wireframeCache.clear();
    }
    getModeName() {
        return "Wavefront Mesh";
    }
    cycleColorMode(direction) {
        const n = $80f72bdc6bdac008$var$COLOR_MODE_NAMES.length;
        this.colorMode = (this.colorMode + direction + n) % n;
    }
    normalizeSelectedWaveIndex(numWaves) {
        this.selectedWaveIndex = (this.selectedWaveIndex % numWaves + numWaves) % numWaves;
        return this.selectedWaveIndex;
    }
    cycleWaveIndex(direction) {
        const wavePhysicsResources = this.game.entities.tryGetSingleton((0, $ffbca396848d8854$export$8b9e0edba56abb99));
        const wavePhysicsManager = wavePhysicsResources?.getWavePhysicsManager();
        const numWaves = wavePhysicsManager?.getActiveMeshes().length ?? 0;
        if (numWaves === 0) return;
        this.selectedWaveIndex = (this.normalizeSelectedWaveIndex(numWaves) + direction + numWaves) % numWaves;
    }
    getHudInfo() {
        const wavePhysicsResources = this.game.entities.tryGetSingleton((0, $ffbca396848d8854$export$8b9e0edba56abb99));
        const wavePhysicsManager = wavePhysicsResources?.getWavePhysicsManager();
        if (!wavePhysicsManager) return "No wave physics";
        const builderType = wavePhysicsManager.getActiveBuilderType();
        const meshes = wavePhysicsManager.getActiveMeshes();
        if (meshes.length === 0) return "No active wave meshes";
        const chipStyle = {
            cursor: "pointer",
            padding: "1px 6px",
            borderRadius: "3px",
            background: "rgba(255,255,255,0.1)",
            border: "1px solid rgba(255,255,255,0.2)"
        };
        const labelStyle = {
            color: "#888",
            fontSize: "11px"
        };
        const controlLineStyle = {
            display: "flex",
            alignItems: "center",
            gap: "6px",
            flexWrap: "wrap"
        };
        const dimStyle = {
            color: "#aaa",
            fontSize: "11px"
        };
        const selectedWaveIndex = this.normalizeSelectedWaveIndex(meshes.length);
        const waveLabel = `${selectedWaveIndex + 1} / ${meshes.length}`;
        const mesh = meshes[selectedWaveIndex];
        return /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("div", {
            style: {
                display: "flex",
                flexDirection: "column",
                gap: "4px"
            },
            children: [
                /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("div", {
                    style: {
                        display: "flex",
                        flexDirection: "column",
                        gap: "12px"
                    },
                    children: [
                        /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("span", {
                            style: controlLineStyle,
                            children: [
                                /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("span", {
                                    style: labelStyle,
                                    children: "Mode"
                                }),
                                /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("span", {
                                    style: chipStyle,
                                    onClick: ()=>this.cycleColorMode(1),
                                    title: "Click to cycle (V / Shift+V)",
                                    children: $80f72bdc6bdac008$var$COLOR_MODE_NAMES[this.colorMode]
                                }),
                                this.colorMode === $80f72bdc6bdac008$var$COLOR_MODE_NAMES.indexOf("Wavefront") && /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("span", {
                                    style: chipStyle,
                                    onClick: ()=>{
                                        this.waveTimeOffset = this.game.elapsedTime;
                                    },
                                    title: "Reset wavefront animation",
                                    children: "Reset Wavefront"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("span", {
                            style: controlLineStyle,
                            children: [
                                /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("span", {
                                    style: labelStyle,
                                    children: "Wave"
                                }),
                                /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("span", {
                                    style: chipStyle,
                                    onClick: ()=>this.cycleWaveIndex(1),
                                    title: "Click to cycle ([ / ])",
                                    children: waveLabel
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("div", {
                    style: dimStyle,
                    children: /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("span", {
                        children: [
                            (mesh.vertexCount / 1000).toFixed(1),
                            "k verts ",
                            "\u03BB",
                            "=",
                            mesh.wavelength,
                            "ft dir=",
                            (mesh.waveDirection * 180 / Math.PI).toFixed(0),
                            "\xb0 build=",
                            mesh.buildTimeMs.toFixed(0),
                            "ms"
                        ]
                    })
                })
            ]
        });
    }
    getCursorInfo() {
        const mouseWorldPos = this.game.camera.toWorld(this.game.io.mousePosition);
        if (!mouseWorldPos) return null;
        const terrainHeight = this.terrainQuery.length > 0 ? this.terrainQuery.get(0).height : null;
        const waterHeight = this.waterQuery.length > 0 ? this.waterQuery.get(0).surfaceHeight : null;
        const wavePhysicsResources = this.game.entities.tryGetSingleton((0, $ffbca396848d8854$export$8b9e0edba56abb99));
        const wavePhysicsManager = wavePhysicsResources?.getWavePhysicsManager();
        const rowStyle = {
            display: "flex",
            gap: "8px",
            alignItems: "baseline",
            flexWrap: "wrap"
        };
        const labelStyle = {
            color: "#8fa3b8",
            fontSize: "11px"
        };
        const valueStyle = {
            color: "#d9e6f2",
            fontSize: "11px"
        };
        const dimStyle = {
            color: "#9db1c5",
            fontSize: "11px"
        };
        const heightStyle = {
            color: "#b9cbdd",
            fontSize: "11px"
        };
        const heightRow = /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("span", {
            style: rowStyle,
            children: [
                /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("span", {
                    style: labelStyle,
                    children: "terrain"
                }),
                /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("span", {
                    style: heightStyle,
                    children: [
                        terrainHeight === null ? "--" : terrainHeight.toFixed(2),
                        " ft"
                    ]
                }),
                /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("span", {
                    style: labelStyle,
                    children: "water"
                }),
                /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("span", {
                    style: heightStyle,
                    children: [
                        waterHeight === null ? "--" : waterHeight.toFixed(2),
                        " ft"
                    ]
                })
            ]
        });
        if (!wavePhysicsManager) return /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("div", {
            style: {
                display: "flex",
                flexDirection: "column",
                gap: "2px"
            },
            children: [
                /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("span", {
                    style: labelStyle,
                    children: "Wave Mesh"
                }),
                /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("span", {
                    style: valueStyle,
                    children: "No wave physics"
                }),
                heightRow
            ]
        });
        const meshes = wavePhysicsManager.getActiveMeshes();
        if (meshes.length === 0) return /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("div", {
            style: {
                display: "flex",
                flexDirection: "column",
                gap: "2px"
            },
            children: [
                /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("span", {
                    style: labelStyle,
                    children: "Wave Mesh"
                }),
                /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("span", {
                    style: valueStyle,
                    children: "No active wave meshes"
                }),
                heightRow
            ]
        });
        const selectedWaveIndex = this.normalizeSelectedWaveIndex(meshes.length);
        const mesh = meshes[selectedWaveIndex];
        const sample = this.sampleMeshAtPoint(mesh, mouseWorldPos.x, mouseWorldPos.y);
        if (sample.hitCount === 0) return /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("div", {
            style: {
                display: "flex",
                flexDirection: "column",
                gap: "2px"
            },
            children: [
                /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("span", {
                    style: labelStyle,
                    children: "Wave Mesh"
                }),
                /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("span", {
                    style: valueStyle,
                    children: sample.insideCoverageQuad ? "Shadow zone (coverage=1, no triangle)" : "No mesh coverage at cursor"
                }),
                sample.insideCoverageQuad && /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("span", {
                    style: dimStyle,
                    children: "pc=0.00 ps=0.00 amp=0.00 turb=0.00"
                }),
                heightRow
            ]
        });
        const amplitude = Math.hypot(sample.phasorCos, sample.phasorSin);
        const phase = amplitude > 0.001 ? Math.atan2(sample.phasorSin, sample.phasorCos) : 0;
        return /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("div", {
            style: {
                display: "flex",
                flexDirection: "column",
                gap: "2px"
            },
            children: [
                /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("span", {
                    style: rowStyle,
                    children: [
                        /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("span", {
                            style: labelStyle,
                            children: "Wave Mesh"
                        }),
                        /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("span", {
                            style: valueStyle,
                            children: [
                                sample.hitCount,
                                " tri hit",
                                sample.hitCount === 1 ? "" : "s"
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("span", {
                    style: rowStyle,
                    children: [
                        /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("span", {
                            style: labelStyle,
                            children: "amp"
                        }),
                        /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("span", {
                            style: valueStyle,
                            children: amplitude.toFixed(2)
                        }),
                        /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("span", {
                            style: labelStyle,
                            children: "phase"
                        }),
                        /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("span", {
                            style: valueStyle,
                            children: phase.toFixed(2)
                        }),
                        /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("span", {
                            style: labelStyle,
                            children: "turb"
                        }),
                        /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("span", {
                            style: valueStyle,
                            children: sample.maxTurbulence.toFixed(2)
                        })
                    ]
                }),
                heightRow,
                /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("span", {
                    style: dimStyle,
                    children: [
                        "pc=",
                        sample.phasorCos.toFixed(2),
                        " ps=",
                        sample.phasorSin.toFixed(2)
                    ]
                }),
                sample.firstHit && /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("span", {
                    style: dimStyle,
                    children: [
                        "tri amp=",
                        sample.firstHit.amplitude.toFixed(2),
                        " phase=",
                        sample.firstHit.phaseOffset.toFixed(2),
                        " blend=",
                        sample.firstHit.blendWeight.toFixed(2)
                    ]
                })
            ]
        });
    }
}
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $aa1f0309d9dba6d2$export$af631764ddc44097)("add")
], $80f72bdc6bdac008$export$5682830a3e9da60c.prototype, "onAdd", null);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $aa1f0309d9dba6d2$export$af631764ddc44097)("render")
], $80f72bdc6bdac008$export$5682830a3e9da60c.prototype, "onRender", null);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $aa1f0309d9dba6d2$export$af631764ddc44097)("keyDown")
], $80f72bdc6bdac008$export$5682830a3e9da60c.prototype, "onKeyDown", null);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $aa1f0309d9dba6d2$export$af631764ddc44097)("destroy")
], $80f72bdc6bdac008$export$5682830a3e9da60c.prototype, "onDestroy", null);


/**
 * Wind Field debug mode.
 *
 * Shows wind triangles using an internal world-space visualization.
 * Uses WindQuery for GPU-accelerated wind sampling.
 */ 






// Dim overlay
const $9101ec9a5366ae75$var$DIM_COLOR = 0x000000;
const $9101ec9a5366ae75$var$DIM_ALPHA = 0.4;
// Grid configuration - adaptive LOD
const $9101ec9a5366ae75$var$BASE_SPACING = 8;
const $9101ec9a5366ae75$var$MIN_LOD = -5;
const $9101ec9a5366ae75$var$MAX_LOD = 4;
const $9101ec9a5366ae75$var$WORLD_TRIANGLE_SIZE = 24;
const $9101ec9a5366ae75$var$BASE_VIEWPORT_SIZE = 400;
// Triangle rendering
const $9101ec9a5366ae75$var$TRIANGLE_ALPHA = 0.7;
const $9101ec9a5366ae75$var$SPEED_TO_LENGTH = 0.05;
const $9101ec9a5366ae75$var$TRIANGLE_WIDTH = 0.3;
// Colors
const $9101ec9a5366ae75$var$TRIANGLE_COLOR = 0x88ccff;
const $9101ec9a5366ae75$var$CALM_WIND_COLOR = 0x666666;
// Convert radians to compass direction
function $9101ec9a5366ae75$var$radiansToCompass(radians) {
    // Normalize to 0-2π
    const normalized = (radians % (2 * Math.PI) + 2 * Math.PI) % (2 * Math.PI);
    // Convert to degrees (0° = East, going counter-clockwise)
    const degrees = normalized * 180 / Math.PI;
    // Convert to compass (0° = North, going clockwise)
    // Wind direction in this system: 0 = right (East), π/2 = down (South)
    const compassDeg = (90 - degrees + 360) % 360;
    const directions = [
        "N",
        "NE",
        "E",
        "SE",
        "S",
        "SW",
        "W",
        "NW"
    ];
    const index = Math.round(compassDeg / 45) % 8;
    return directions[index];
}
class $9101ec9a5366ae75$export$4e17af857435c13b extends (0, $6eb211648954ac4c$export$8230771f441ce638) {
    constructor(){
        super(), this.layer = "windViz", // Pre-allocated point pool for zero-allocation point generation
        this.pointPool = [], this.queryPointsResult = [], this.pointCount = 0, this.triTip = (0, $6b6a54a072724620$export$e7c866399fa523f5)(0, 0), this.triWingUp = (0, $6b6a54a072724620$export$e7c866399fa523f5)(0, 0), this.triWingDown = (0, $6b6a54a072724620$export$e7c866399fa523f5)(0, 0);
        // Wind query for grid + cursor positions
        this.windQuery = this.addChild(new (0, $3d4e827a36d4d6ff$export$20101e03857a552b)(()=>this.getWindQueryPoints()));
    }
    allocPoint(x, y) {
        let p;
        if (this.pointCount < this.pointPool.length) p = this.pointPool[this.pointCount].set(x, y);
        else {
            p = (0, $6b6a54a072724620$export$e7c866399fa523f5)(x, y);
            this.pointPool.push(p);
        }
        this.queryPointsResult[this.pointCount] = p;
        this.pointCount++;
        return p;
    }
    getWindQueryPoints() {
        if (!this.game) return [];
        this.pointCount = 0;
        const viewport = this.game.camera.getWorldViewport();
        this.updateGridQueryPoints(viewport);
        // Add cursor position as last point for cursor info
        const mouseWorldPos = this.game.camera.toWorld(this.game.io.mousePosition);
        if (mouseWorldPos) this.allocPoint(mouseWorldPos.x, mouseWorldPos.y);
        this.queryPointsResult.length = this.pointCount;
        return this.queryPointsResult;
    }
    updateGridQueryPoints(viewport) {
        const { left: left, right: right, top: top, bottom: bottom } = viewport;
        // Calculate continuous LOD value based on viewport size.
        const viewportSize = Math.max(right - left, bottom - top);
        const lodValue = Math.log2(viewportSize / $9101ec9a5366ae75$var$BASE_VIEWPORT_SIZE);
        // Single grid at finest visible spacing, consistent spatial order.
        const minVisibleLOD = (0, $2172aedd5a25ff17$export$7d15b64cf5a3a4c4)(Math.floor(lodValue), $9101ec9a5366ae75$var$MIN_LOD, $9101ec9a5366ae75$var$MAX_LOD);
        const spacing = $9101ec9a5366ae75$var$BASE_SPACING * Math.pow(2, minVisibleLOD);
        const startX = Math.floor(left / spacing) * spacing;
        const startY = Math.floor(top / spacing) * spacing;
        const endX = right + spacing;
        const endY = bottom + spacing;
        for(let x = startX; x <= endX; x += spacing)for(let y = startY; y <= endY; y += spacing){
            const lod = this.getPointLOD(x, y, spacing, minVisibleLOD);
            if (this.getLODAlpha(lod, lodValue) > 0.01) this.allocPoint(x, y);
        }
    }
    getPointLOD(x, y, spacing, minVisibleLOD) {
        const ix = Math.round(x / spacing);
        const iy = Math.round(y / spacing);
        const lodX = ix === 0 ? $9101ec9a5366ae75$var$MAX_LOD : Math.min(31 - Math.clz32(ix & -ix) + minVisibleLOD, $9101ec9a5366ae75$var$MAX_LOD);
        const lodY = iy === 0 ? $9101ec9a5366ae75$var$MAX_LOD : Math.min(31 - Math.clz32(iy & -iy) + minVisibleLOD, $9101ec9a5366ae75$var$MAX_LOD);
        return Math.min(lodX, lodY);
    }
    drawGrid(query, points, viewport, camera, draw) {
        const triangleSize = $9101ec9a5366ae75$var$WORLD_TRIANGLE_SIZE / camera.z;
        // Recompute LOD alpha from current viewport for smooth zoom transitions.
        const { left: left, right: right, top: top, bottom: bottom } = viewport;
        const viewportSize = Math.max(right - left, bottom - top);
        const lodValue = Math.log2(viewportSize / $9101ec9a5366ae75$var$BASE_VIEWPORT_SIZE);
        const minVisibleLOD = (0, $2172aedd5a25ff17$export$7d15b64cf5a3a4c4)(Math.floor(lodValue), $9101ec9a5366ae75$var$MIN_LOD, $9101ec9a5366ae75$var$MAX_LOD);
        const spacing = $9101ec9a5366ae75$var$BASE_SPACING * Math.pow(2, minVisibleLOD);
        // Skip the last point (cursor) — grid points only.
        const count = Math.min(query.length, points.length) - 1;
        for(let i = 0; i < count; i++){
            const lod = this.getPointLOD(points[i].x, points[i].y, spacing, minVisibleLOD);
            const alpha = this.getLODAlpha(lod, lodValue);
            if (alpha <= 0.01) continue;
            this.drawTriangle(query.get(i), points[i].x, points[i].y, triangleSize, alpha * $9101ec9a5366ae75$var$TRIANGLE_ALPHA, draw);
        }
    }
    getLODAlpha(triangleLOD, lodValue) {
        if (lodValue <= triangleLOD) return 1;
        if (lodValue >= triangleLOD + 1) return 0;
        return 1 - (lodValue - triangleLOD);
    }
    drawTriangle(result, x, y, maxSize, alpha, draw) {
        const speed = result.speed;
        const angle = result.direction;
        // Draw a small circle for calm/zero wind.
        if (speed < 1) {
            draw.fillCircle(x, y, maxSize * $9101ec9a5366ae75$var$TRIANGLE_WIDTH * 0.5, {
                color: $9101ec9a5366ae75$var$CALM_WIND_COLOR,
                alpha: alpha,
                ignoreLight: true
            });
            return;
        }
        const length = speed * $9101ec9a5366ae75$var$SPEED_TO_LENGTH * maxSize;
        const halfWidth = maxSize * $9101ec9a5366ae75$var$TRIANGLE_WIDTH * 0.5;
        // Build triangle in local space, rotate, and translate to position.
        this.triTip.set(length * 0.6, 0).irotate(angle).iadd([
            x,
            y
        ]);
        this.triWingUp.set(-length * 0.4, halfWidth).irotate(angle).iadd([
            x,
            y
        ]);
        this.triWingDown.set(-length * 0.4, -halfWidth).irotate(angle).iadd([
            x,
            y
        ]);
        draw.fillTriangle(this.triTip, this.triWingUp, this.triWingDown, {
            color: $9101ec9a5366ae75$var$TRIANGLE_COLOR,
            alpha: alpha,
            ignoreLight: true
        });
    }
    onRender({ draw: draw }) {
        const camera = this.game.camera;
        const viewport = camera.getWorldViewport();
        // Draw dim overlay
        draw.fillRect(viewport.left, viewport.top, viewport.width, viewport.height, {
            color: $9101ec9a5366ae75$var$DIM_COLOR,
            alpha: $9101ec9a5366ae75$var$DIM_ALPHA,
            ignoreLight: true
        });
        // Draw wind visualization using query results.
        // Use the query's synced points (not our current-frame pool) so points
        // and results stay aligned despite the one-frame readback latency.
        const queryPoints = this.windQuery.points;
        if (this.windQuery.length > 0 && queryPoints.length > 0) this.drawGrid(this.windQuery, queryPoints, viewport, camera, draw);
    }
    getModeName() {
        return "Wind Field";
    }
    getCursorInfo() {
        const mouseWorldPos = this.game.camera.toWorld(this.game.io.mousePosition);
        if (!mouseWorldPos || this.windQuery.length === 0) return null;
        // Cursor wind is the last result (we add it as last query point)
        const cursorResult = this.windQuery.get(this.windQuery.length - 1);
        const compass = $9101ec9a5366ae75$var$radiansToCompass(cursorResult.direction);
        const knots = cursorResult.speed / 1.69;
        return `Wind: ${knots.toFixed(1)} kt ${compass}`;
    }
}
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $5a1d1d3ab1ff9c51$export$4882ae973e0491e)
], $9101ec9a5366ae75$export$4e17af857435c13b.prototype, "getWindQueryPoints", null);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $aa1f0309d9dba6d2$export$af631764ddc44097)("render")
], $9101ec9a5366ae75$export$4e17af857435c13b.prototype, "onRender", null);


/**
 * Wind Mesh debug mode.
 *
 * Visualizes the wind mesh overlay (uniform grid with wind attributes).
 * Renders mesh triangles directly on GPU using a custom render pipeline,
 * with colors mapped from a selectable vertex attribute.
 *
 * Use V to cycle through color modes (Speed Factor, Direction Offset, Turbulence).
 * Use B to cycle through wind sources.
 */ 





/**
 * Wind GPU resource manager.
 *
 * Holds base wind state (velocity, angle, speed), wind mesh data (multi-source),
 * and per-source weight state for blended terrain influence.
 */ 




/**
 * Shared constants for wind simulation.
 * These are used by both TypeScript code and WGSL shaders.
 */ // Wind variation configuration (matches Wind.ts)
// Units: ft for distances, radians for angles
const $8ecd9f2b11cf50d1$export$dd7d443fcf6b50ed = 0.005; // How quickly wind varies across space
const $8ecd9f2b11cf50d1$export$396c615eb4edc32 = 0.15; // How quickly wind varies over time
const $8ecd9f2b11cf50d1$export$954c8e2afd7a19b5 = 0.5; // ±50% speed variation
const $8ecd9f2b11cf50d1$export$17519356ae9cf5d5 = 0.17; // ±10° direction variation (~0.17 rad)
const $8ecd9f2b11cf50d1$export$7417d004087d724a = 20.0; // Seconds before a flow-map layer resets
const $8ecd9f2b11cf50d1$export$36b566ff16e06fa5 = 0.02; // Very slow temporal evolution in noise z-axis
const $8ecd9f2b11cf50d1$export$ee5acb311d4e0eef = 16;
const $8ecd9f2b11cf50d1$export$b20ebf7084a493d8 = 64;
const $8ecd9f2b11cf50d1$export$859566e52db8a64f = 0.15; // Flow speedup on leeward side
const $8ecd9f2b11cf50d1$export$6e92607452ff5edc = 0.1; // Flow reduction on windward side
const $8ecd9f2b11cf50d1$export$311452eefb321712 = 0.2; // Wind reduction in wake
const $8ecd9f2b11cf50d1$export$ccbde628a24bb4ab = 3.0; // How far wake extends (× chord length)
const $8ecd9f2b11cf50d1$export$f22fb965b601c290 = 1.5; // ft - minimum distance for wind effect
const $8ecd9f2b11cf50d1$export$5eea36b386770040 = 3.0; // ft/s - magnitude of turbulence
const $8ecd9f2b11cf50d1$export$78ef974ada67c621 = 3.0; // ft - influence radius
const $8ecd9f2b11cf50d1$export$7628c5082becdb31 = 8;
const $8ecd9f2b11cf50d1$export$8fc3351ffc929872 = 100.0; // Maps -50..+50 ft/s to 0..1
const $8ecd9f2b11cf50d1$export$40581299b5f6dcd3 = 40.0; // Maps -20..+20 ft/s delta to 0..1


/**
 * CPU-side wind mesh packing for GPU compute shader access.
 *
 * Packs multi-source vertex/index data and spatial grid indices into a single
 * array<u32> buffer.
 *
 * Buffer layout:
 * GLOBAL HEADER (32 u32s):
 *   [0]      numWindSources
 *   [1..8]   meshOffset[0..7]     (u32 offset to each source's mesh header)
 *   [9..16]  direction[0..7]      (f32 bitcast, radians)
 *   [17..31] padding
 *
 * PER-SOURCE MESH HEADER (16 u32s each):
 *   vertexOffset, vertexCount, indexOffset, triangleCount,
 *   gridOffset, gridCols, gridRows,
 *   gridMinX, gridMinY, gridCellWidth, gridCellHeight,
 *   padding x5
 *
 * VERTEX DATA (5 f32-as-u32 per vertex, per source)
 * INDEX DATA (3 u32 per triangle, shared across sources)
 * GRID CELL HEADERS (2 u32 per cell: triListOffset, triListCount, per source)
 * GRID TRIANGLE LISTS (u32 triangle indices, variable length, per source)
 */ 
const $b74f9c512cce7bb4$var$GLOBAL_HEADER_U32S = 32;
const $b74f9c512cce7bb4$var$MESH_HEADER_U32S = 16;
const $b74f9c512cce7bb4$var$WIND_VERTEX_FLOATS = 5;
const $b74f9c512cce7bb4$var$f32Buf = new Float32Array(1);
const $b74f9c512cce7bb4$var$u32Buf = new Uint32Array($b74f9c512cce7bb4$var$f32Buf.buffer);
function $b74f9c512cce7bb4$var$floatToU32(f) {
    $b74f9c512cce7bb4$var$f32Buf[0] = f;
    return $b74f9c512cce7bb4$var$u32Buf[0];
}
/**
 * Build a spatial grid index for a single source's mesh.
 */ function $b74f9c512cce7bb4$var$buildSpatialGrid(source, gridCols, gridRows, gridMinX, gridMinY, gridCellWidth, gridCellHeight) {
    const verts = source.vertices;
    const indices = source.indices;
    const triCount = source.indexCount / 3;
    const cellTriLists = [];
    for(let i = 0; i < gridCols * gridRows; i++)cellTriLists.push([]);
    const invCellWidth = 1 / gridCellWidth;
    const invCellHeight = 1 / gridCellHeight;
    for(let t = 0; t < triCount; t++){
        const i0 = indices[t * 3];
        const i1 = indices[t * 3 + 1];
        const i2 = indices[t * 3 + 2];
        let sx0 = verts[i0 * $b74f9c512cce7bb4$var$WIND_VERTEX_FLOATS];
        let sy0 = verts[i0 * $b74f9c512cce7bb4$var$WIND_VERTEX_FLOATS + 1];
        let sx1 = verts[i1 * $b74f9c512cce7bb4$var$WIND_VERTEX_FLOATS];
        let sy1 = verts[i1 * $b74f9c512cce7bb4$var$WIND_VERTEX_FLOATS + 1];
        let sx2 = verts[i2 * $b74f9c512cce7bb4$var$WIND_VERTEX_FLOATS];
        let sy2 = verts[i2 * $b74f9c512cce7bb4$var$WIND_VERTEX_FLOATS + 1];
        let tmp;
        if (sy0 > sy1) {
            tmp = sx0;
            sx0 = sx1;
            sx1 = tmp;
            tmp = sy0;
            sy0 = sy1;
            sy1 = tmp;
        }
        if (sy1 > sy2) {
            tmp = sx1;
            sx1 = sx2;
            sx2 = tmp;
            tmp = sy1;
            sy1 = sy2;
            sy2 = tmp;
        }
        if (sy0 > sy1) {
            tmp = sx0;
            sx0 = sx1;
            sx1 = tmp;
            tmp = sy0;
            sy0 = sy1;
            sy1 = tmp;
        }
        const dy02 = sy2 - sy0;
        if (dy02 < 1e-10) continue;
        const dy01 = sy1 - sy0;
        const dy12 = sy2 - sy1;
        const dx02 = sx2 - sx0;
        const dx01 = sx1 - sx0;
        const dx12 = sx2 - sx1;
        const invDy02 = 1 / dy02;
        const invDy01 = dy01 > 1e-10 ? 1 / dy01 : 0;
        const invDy12 = dy12 > 1e-10 ? 1 / dy12 : 0;
        const rStart = Math.max(0, Math.floor((sy0 - gridMinY) * invCellHeight));
        const rEnd = Math.min(gridRows - 1, Math.floor((sy2 - gridMinY) * invCellHeight));
        for(let r = rStart; r <= rEnd; r++){
            const yTop = gridMinY + r * gridCellHeight;
            const yBot = yTop + gridCellHeight;
            const yLo = Math.max(yTop, sy0);
            const yHi = Math.min(yBot, sy2);
            let xMin = sx0 + (yLo - sy0) * invDy02 * dx02;
            let xMax = xMin;
            const xLong_hi = sx0 + (yHi - sy0) * invDy02 * dx02;
            if (xLong_hi < xMin) xMin = xLong_hi;
            if (xLong_hi > xMax) xMax = xLong_hi;
            if (yLo < sy1 && invDy01 !== 0) {
                const xShort = sx0 + (yLo - sy0) * invDy01 * dx01;
                if (xShort < xMin) xMin = xShort;
                if (xShort > xMax) xMax = xShort;
                const yEnd = Math.min(yHi, sy1);
                const xShortEnd = sx0 + (yEnd - sy0) * invDy01 * dx01;
                if (xShortEnd < xMin) xMin = xShortEnd;
                if (xShortEnd > xMax) xMax = xShortEnd;
            }
            if (yHi > sy1 && invDy12 !== 0) {
                const yStart = Math.max(yLo, sy1);
                const xShort = sx1 + (yStart - sy1) * invDy12 * dx12;
                if (xShort < xMin) xMin = xShort;
                if (xShort > xMax) xMax = xShort;
                const xShortEnd = sx1 + (yHi - sy1) * invDy12 * dx12;
                if (xShortEnd < xMin) xMin = xShortEnd;
                if (xShortEnd > xMax) xMax = xShortEnd;
            }
            if (sy1 >= yTop && sy1 <= yBot) {
                if (sx1 < xMin) xMin = sx1;
                if (sx1 > xMax) xMax = sx1;
            }
            const cStart = Math.max(0, Math.floor((xMin - gridMinX) * invCellWidth));
            const cEnd = Math.min(gridCols - 1, Math.floor((xMax - gridMinX) * invCellWidth));
            for(let c = cStart; c <= cEnd; c++)cellTriLists[r * gridCols + c].push(t);
        }
    }
    return cellTriLists.map((list)=>new Uint32Array(list));
}
function $b74f9c512cce7bb4$export$13c23c3432c570e8(device, bundle) {
    const numSources = Math.min(bundle.sourceCount, (0, $8ecd9f2b11cf50d1$export$7628c5082becdb31));
    const { gridCols: gridCols, gridRows: gridRows, gridMinX: gridMinX, gridMinY: gridMinY, gridCellWidth: gridCellWidth, gridCellHeight: gridCellHeight } = bundle;
    const numCells = gridCols * gridRows;
    // Build spatial grids for each source
    const grids = [];
    for(let s = 0; s < numSources; s++)grids.push($b74f9c512cce7bb4$var$buildSpatialGrid(bundle.sources[s], gridCols, gridRows, gridMinX, gridMinY, gridCellWidth, gridCellHeight));
    // Calculate total buffer size
    let totalU32s = $b74f9c512cce7bb4$var$GLOBAL_HEADER_U32S + numSources * $b74f9c512cce7bb4$var$MESH_HEADER_U32S;
    // Per-source: vertex data + grid headers + grid lists
    const perSourceSizes = [];
    let sharedIndexU32s = 0;
    for(let s = 0; s < numSources; s++){
        const src = bundle.sources[s];
        const vertexU32s = src.vertexCount * $b74f9c512cce7bb4$var$WIND_VERTEX_FLOATS;
        const gridHeaderU32s = numCells * 2;
        let gridListU32s = 0;
        for (const cell of grids[s])gridListU32s += cell.length;
        perSourceSizes.push({
            vertexU32s: vertexU32s,
            gridHeaderU32s: gridHeaderU32s,
            gridListU32s: gridListU32s
        });
        totalU32s += vertexU32s + gridHeaderU32s + gridListU32s;
        if (s === 0) sharedIndexU32s = src.indexCount;
    }
    totalU32s += sharedIndexU32s;
    const data = new ArrayBuffer(totalU32s * 4);
    const u32View = new Uint32Array(data);
    const f32View = new Float32Array(data);
    // Write global header
    u32View[0] = numSources;
    // Compute mesh header offsets
    let currentOffset = $b74f9c512cce7bb4$var$GLOBAL_HEADER_U32S;
    const meshHeaderOffsets = [];
    for(let s = 0; s < numSources; s++){
        meshHeaderOffsets.push(currentOffset);
        currentOffset += $b74f9c512cce7bb4$var$MESH_HEADER_U32S;
    }
    // Write mesh offsets and directions into global header
    for(let s = 0; s < (0, $8ecd9f2b11cf50d1$export$7628c5082becdb31); s++)if (s < numSources) {
        u32View[1 + s] = meshHeaderOffsets[s];
        u32View[9 + s] = $b74f9c512cce7bb4$var$floatToU32(bundle.sources[s].direction);
    } else {
        u32View[1 + s] = 0;
        u32View[9 + s] = 0;
    }
    // Shared index data comes first after mesh headers
    const indexStart = currentOffset;
    for(let i = 0; i < sharedIndexU32s; i++)u32View[indexStart + i] = bundle.sources[0].indices[i];
    currentOffset = indexStart + sharedIndexU32s;
    // Write per-source data
    for(let s = 0; s < numSources; s++){
        const src = bundle.sources[s];
        const { vertexU32s: vertexU32s, gridHeaderU32s: gridHeaderU32s, gridListU32s: gridListU32s } = perSourceSizes[s];
        const triCount = src.indexCount / 3;
        const grid = grids[s];
        const vertexStart = currentOffset;
        currentOffset += vertexU32s;
        const gridHeaderStart = currentOffset;
        currentOffset += gridHeaderU32s;
        const gridListStart = currentOffset;
        currentOffset += gridListU32s;
        // Write per-source mesh header
        const h = meshHeaderOffsets[s];
        u32View[h + 0] = vertexStart;
        u32View[h + 1] = src.vertexCount;
        u32View[h + 2] = indexStart; // shared
        u32View[h + 3] = triCount;
        u32View[h + 4] = gridHeaderStart;
        u32View[h + 5] = gridCols;
        u32View[h + 6] = gridRows;
        u32View[h + 7] = $b74f9c512cce7bb4$var$floatToU32(gridMinX);
        u32View[h + 8] = $b74f9c512cce7bb4$var$floatToU32(gridMinY);
        u32View[h + 9] = $b74f9c512cce7bb4$var$floatToU32(gridCellWidth);
        u32View[h + 10] = $b74f9c512cce7bb4$var$floatToU32(gridCellHeight);
        // Write vertex data
        for(let v = 0; v < src.vertexCount * $b74f9c512cce7bb4$var$WIND_VERTEX_FLOATS; v++)f32View[vertexStart + v] = src.vertices[v];
        // Write grid cell headers and triangle lists
        let currentGridListOffset = gridListStart;
        for(let c = 0; c < numCells; c++){
            const cell = grid[c];
            u32View[gridHeaderStart + c * 2] = currentGridListOffset;
            u32View[gridHeaderStart + c * 2 + 1] = cell.length;
            for(let t = 0; t < cell.length; t++)u32View[currentGridListOffset + t] = cell[t];
            currentGridListOffset += cell.length;
        }
    }
    const buffer = device.createBuffer({
        size: Math.max(data.byteLength, 64),
        usage: GPUBufferUsage.STORAGE | GPUBufferUsage.COPY_DST,
        label: "Packed Wind Mesh Buffer"
    });
    device.queue.writeBuffer(buffer, 0, data);
    return buffer;
}
function $b74f9c512cce7bb4$export$3e0b6dbba824900f(device) {
    const buffer = device.createBuffer({
        size: $b74f9c512cce7bb4$var$GLOBAL_HEADER_U32S * 4,
        usage: GPUBufferUsage.STORAGE | GPUBufferUsage.COPY_DST,
        label: "Placeholder Packed Wind Mesh Buffer"
    });
    const data = new Uint32Array($b74f9c512cce7bb4$var$GLOBAL_HEADER_U32S);
    data[0] = 0; // numWindSources = 0
    device.queue.writeBuffer(buffer, 0, data);
    return buffer;
}


class $cd5b26e926c7fea1$export$c6b583ea58097b81 extends (0, $c59361981bac2575$export$4342ba5c6ad1f6f1) {
    constructor(windMeshData, windConfig){
        super(), this.id = "windResources", // Base wind velocity - the global wind direction and speed
        // ~15 ft/s (~9 kts), NW breeze
        this.baseVelocity = (0, $6b6a54a072724620$export$e7c866399fa523f5)(11, 11), this.packedWindMeshBuffer = null;
        this.windMeshData = windMeshData;
        this.windConfig = windConfig ?? (0, $26798afcbef2eee0$export$8a2743f6442658aa);
        // Initialize all weights to 0, then set first source to 1.0
        this.sourceWeights = new Array(Math.min(this.windConfig.sources.length, (0, $8ecd9f2b11cf50d1$export$7628c5082becdb31))).fill(0);
        if (this.sourceWeights.length > 0) this.sourceWeights[0] = 1.0;
    }
    onAdd() {
        const device = this.game.getWebGPUDevice();
        if (this.windMeshData) this.packedWindMeshBuffer = (0, $b74f9c512cce7bb4$export$13c23c3432c570e8)(device, this.windMeshData);
        else this.packedWindMeshBuffer = (0, $b74f9c512cce7bb4$export$3e0b6dbba824900f)(device);
    }
    getPackedWindMeshBuffer() {
        return this.packedWindMeshBuffer;
    }
    getWindMeshData() {
        return this.windMeshData;
    }
    getWindConfig() {
        return this.windConfig;
    }
    /**
   * Get per-source weights for blended wind mesh lookup.
   */ getSourceWeights() {
        return this.sourceWeights;
    }
    /**
   * Set weight for a specific wind source.
   */ setSourceWeight(sourceIndex, weight) {
        if (sourceIndex >= 0 && sourceIndex < this.sourceWeights.length) this.sourceWeights[sourceIndex] = weight;
    }
    /**
   * Set all source weights at once.
   */ setSourceWeights(weights) {
        for(let i = 0; i < this.sourceWeights.length; i++)this.sourceWeights[i] = weights[i] ?? 0;
    }
    /**
   * Get the base wind velocity vector.
   */ getBaseVelocity() {
        return this.baseVelocity.clone();
    }
    /**
   * Get the base wind speed.
   */ getSpeed() {
        return this.baseVelocity.magnitude;
    }
    /**
   * Get the base wind angle in radians.
   */ getAngle() {
        return this.baseVelocity.angle;
    }
    /**
   * Set the base wind velocity directly.
   */ setVelocity(velocity) {
        this.baseVelocity.set(velocity);
    }
    /**
   * Set the base wind from angle and speed.
   * @param angle Wind direction in radians (0 = east, PI/2 = north)
   * @param speed Wind speed in ft/s
   */ setFromAngleAndSpeed(angle, speed) {
        this.baseVelocity.set(Math.cos(angle) * speed, Math.sin(angle) * speed);
    }
}
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $aa1f0309d9dba6d2$export$af631764ddc44097)("add")
], $cd5b26e926c7fea1$export$c6b583ea58097b81.prototype, "onAdd", null);



/** Floats per vertex in WindMeshSourceData: posX, posY, speedFactor, directionOffset, turbulence */ const $2642f5341742a843$var$WIND_VERTEX_FLOATS = 5;
const $2642f5341742a843$var$WindMeshDebugUniforms = (0, $ca6793d1abd58997$export$99bb2281c7368d10)("WindMeshDebugParams", {
    cameraMatrix: (0, $ca6793d1abd58997$export$a9b01fc77c97438b),
    screenWidth: (0, $ca6793d1abd58997$export$e33361ff41014190),
    screenHeight: (0, $ca6793d1abd58997$export$e33361ff41014190),
    alpha: (0, $ca6793d1abd58997$export$e33361ff41014190),
    colorMode: (0, $ca6793d1abd58997$export$e33361ff41014190)
});
const $2642f5341742a843$var$SHADER_CODE = /*wgsl*/ `
const TWO_PI = 6.283185;

struct WindMeshDebugParams {
  cameraMatrix0: vec4<f32>,
  cameraMatrix1: vec4<f32>,
  cameraMatrix2: vec4<f32>,
  screenWidth: f32,
  screenHeight: f32,
  alpha: f32,
  colorMode: f32,
}

@group(0) @binding(0) var<uniform> params: WindMeshDebugParams;

struct VertexInput {
  @location(0) position: vec2<f32>,
  @location(1) speedFactor: f32,
  @location(2) directionOffset: f32,
  @location(3) turbulence: f32,
  @location(4) barycentric: vec2<f32>,
}

struct VertexOutput {
  @builtin(position) position: vec4<f32>,
  @location(0) speedFactor: f32,
  @location(1) directionOffset: f32,
  @location(2) turbulence: f32,
  @location(3) barycentric: vec2<f32>,
}

fn getCameraMatrix() -> mat3x3<f32> {
  return mat3x3<f32>(
    params.cameraMatrix0.xyz,
    params.cameraMatrix1.xyz,
    params.cameraMatrix2.xyz
  );
}

@vertex
fn vs_main(in: VertexInput) -> VertexOutput {
  let cameraMatrix = getCameraMatrix();
  let pixelPos = cameraMatrix * vec3<f32>(in.position, 1.0);
  let clipX = pixelPos.x * 2.0 / params.screenWidth - 1.0;
  let clipY = pixelPos.y * 2.0 / params.screenHeight - 1.0;

  var out: VertexOutput;
  out.position = vec4<f32>(clipX, clipY, 0.0, 1.0);
  out.speedFactor = in.speedFactor;
  out.directionOffset = in.directionOffset;
  out.turbulence = in.turbulence;
  out.barycentric = in.barycentric;
  return out;
}

// Mode 0: Speed Factor \u{2014} red (blocked) -> yellow -> green (neutral) -> cyan (accelerated)
fn speedFactorToColor(sf: f32) -> vec3<f32> {
  if (sf <= 0.0) { return vec3<f32>(0.3, 0.0, 0.0); }
  if (sf <= 0.5) {
    let t = sf / 0.5;
    return vec3<f32>(1.0, t, 0.0);
  }
  if (sf <= 1.0) {
    let t = (sf - 0.5) / 0.5;
    return vec3<f32>(1.0 - t, 1.0, 0.0);
  }
  let t = min((sf - 1.0) / 0.5, 1.0);
  return vec3<f32>(0.0, 1.0, t);
}

// Mode 1: Direction Offset \u{2014} cyclic rainbow
fn directionOffsetToColor(offset: f32) -> vec3<f32> {
  let t = fract(offset / TWO_PI);
  let r = abs(t * 6.0 - 3.0) - 1.0;
  let g = 2.0 - abs(t * 6.0 - 2.0);
  let b = 2.0 - abs(t * 6.0 - 4.0);
  return saturate(vec3<f32>(r, g, b));
}

// Mode 2: Turbulence \u{2014} grayscale 0->1
fn turbulenceToColor(turb: f32) -> vec3<f32> {
  let t = clamp(turb, 0.0, 1.0);
  return vec3<f32>(t, t, t);
}

@fragment
fn fs_main(in: VertexOutput) -> @location(0) vec4<f32> {
  let bary = vec3<f32>(in.barycentric, 1.0 - in.barycentric.x - in.barycentric.y);

  let minBary = min(bary.x, min(bary.y, bary.z));
  let fw = fwidth(minBary);
  let edge = smoothstep(0.0, fw * 1.5, minBary);

  let mode = u32(params.colorMode);

  var fillColor: vec3<f32>;
  switch (mode) {
    case 1u: { fillColor = directionOffsetToColor(in.directionOffset); }
    case 2u: { fillColor = turbulenceToColor(in.turbulence); }
    default: { fillColor = speedFactorToColor(in.speedFactor); }
  }

  let edgeColor = vec3<f32>(0.0, 0.0, 0.0);
  let color = mix(edgeColor, fillColor, edge);
  return vec4<f32>(color, params.alpha);
}
`;
/** Barycentric coords for each vertex position within a triangle */ const $2642f5341742a843$var$BARY_COORDS = [
    [
        1,
        0
    ],
    [
        0,
        1
    ],
    [
        0,
        0
    ]
];
const $2642f5341742a843$var$BARY_INSIDE_EPS = 0.001;
const $2642f5341742a843$var$DEGENERATE_TRIANGLE_EPS = 1e-10;
const $2642f5341742a843$var$COLOR_MODE_NAMES = [
    "Speed Factor",
    "Direction Offset",
    "Turbulence"
];
class $2642f5341742a843$export$c3de46f318b3861b extends (0, $6eb211648954ac4c$export$8230771f441ce638) {
    async onAdd() {
        await this.initPipeline();
    }
    async initPipeline() {
        if (this.initialized) return;
        const device = this.game.getWebGPUDevice();
        this.shaderModule = device.createShaderModule({
            code: $2642f5341742a843$var$SHADER_CODE,
            label: "Wind Mesh Debug Shader"
        });
        await (0, $558c2f47f1fdd57f$export$bdd7f96686113d46)(this.shaderModule, $2642f5341742a843$var$SHADER_CODE, "Wind Mesh Debug Shader");
        this.bindGroupLayout = device.createBindGroupLayout({
            entries: [
                {
                    binding: 0,
                    visibility: GPUShaderStage.VERTEX | GPUShaderStage.FRAGMENT,
                    buffer: {
                        type: "uniform"
                    }
                }
            ],
            label: "Wind Mesh Debug Bind Group Layout"
        });
        this.pipelineLayout = device.createPipelineLayout({
            bindGroupLayouts: [
                this.bindGroupLayout
            ],
            label: "Wind Mesh Debug Pipeline Layout"
        });
        this.rebuildPipeline();
        this.unsubscribeMSAA = (0, $3d4164726c38f33c$export$19f5a511f7104745)(()=>this.rebuildPipeline());
        this.uniformBuffer = device.createBuffer({
            size: $2642f5341742a843$var$WindMeshDebugUniforms.byteSize,
            usage: GPUBufferUsage.UNIFORM | GPUBufferUsage.COPY_DST,
            label: "Wind Mesh Debug Uniforms"
        });
        this.uniforms = $2642f5341742a843$var$WindMeshDebugUniforms.create();
        this.bindGroup = device.createBindGroup({
            layout: this.bindGroupLayout,
            entries: [
                {
                    binding: 0,
                    resource: {
                        buffer: this.uniformBuffer
                    }
                }
            ],
            label: "Wind Mesh Debug Bind Group"
        });
        this.initialized = true;
    }
    rebuildPipeline() {
        if (!this.shaderModule || !this.pipelineLayout) return;
        const device = this.game.getWebGPUDevice();
        this.pipeline = device.createRenderPipeline({
            layout: this.pipelineLayout,
            vertex: {
                module: this.shaderModule,
                entryPoint: "vs_main",
                buffers: [
                    {
                        arrayStride: 28,
                        attributes: [
                            {
                                format: "float32x2",
                                offset: 0,
                                shaderLocation: 0
                            },
                            {
                                format: "float32",
                                offset: 8,
                                shaderLocation: 1
                            },
                            {
                                format: "float32",
                                offset: 12,
                                shaderLocation: 2
                            },
                            {
                                format: "float32",
                                offset: 16,
                                shaderLocation: 3
                            },
                            {
                                format: "float32x2",
                                offset: 20,
                                shaderLocation: 4
                            }
                        ]
                    }
                ]
            },
            fragment: {
                module: this.shaderModule,
                entryPoint: "fs_main",
                targets: [
                    {
                        format: this.game.getWebGPUPreferredFormat(),
                        blend: {
                            color: {
                                srcFactor: "src-alpha",
                                dstFactor: "one-minus-src-alpha",
                                operation: "add"
                            },
                            alpha: {
                                srcFactor: "one",
                                dstFactor: "one-minus-src-alpha",
                                operation: "add"
                            }
                        }
                    }
                ]
            },
            primitive: {
                topology: "triangle-list"
            },
            depthStencil: {
                format: "depth24plus",
                depthCompare: "always",
                depthWriteEnabled: false
            },
            multisample: {
                count: (0, $3d4164726c38f33c$export$688369c54d530641)()
            },
            label: "Wind Mesh Debug Pipeline"
        });
    }
    getActiveSource() {
        const windResources = this.game.entities.tryGetSingleton((0, $cd5b26e926c7fea1$export$c6b583ea58097b81));
        const bundle = windResources?.getWindMeshData();
        if (!bundle || bundle.sourceCount === 0) return null;
        const idx = Math.min(this.selectedSource, bundle.sourceCount - 1);
        return bundle.sources[idx];
    }
    onRender(_event) {
        if (!this.initialized || !this.pipeline || !this.bindGroup || !this.uniformBuffer || !this.uniforms) return;
        const source = this.getActiveSource();
        if (!source) return;
        const device = this.game.getWebGPUDevice();
        const wireframe = this.getWireframeBuffer(source, device);
        const renderer = this.game.getRenderer();
        const renderPass = renderer.getCurrentRenderPass();
        if (!renderPass) return;
        const cameraMatrix = renderer.getTransform();
        const width = renderer.getWidth();
        const height = renderer.getHeight();
        this.uniforms.set.cameraMatrix(cameraMatrix);
        this.uniforms.set.screenWidth(width);
        this.uniforms.set.screenHeight(height);
        this.uniforms.set.alpha(0.3);
        this.uniforms.set.colorMode(this.colorMode);
        this.uniforms.uploadTo(this.uniformBuffer);
        renderPass.setPipeline(this.pipeline);
        renderPass.setBindGroup(0, this.bindGroup);
        renderPass.setVertexBuffer(0, wireframe.buffer);
        renderPass.draw(wireframe.vertexCount);
    }
    getWireframeBuffer(sourceData, device) {
        if (this.cachedWireframe && this.cachedSourceData === sourceData) return this.cachedWireframe;
        if (this.cachedWireframe) this.cachedWireframe.buffer.destroy();
        const { vertices: vertices, indices: indices, indexCount: indexCount } = sourceData;
        const floatsPerVertex = 7; // posX, posY, speedFactor, directionOffset, turbulence, baryU, baryV
        const expanded = new Float32Array(indexCount * floatsPerVertex);
        for(let i = 0; i < indexCount; i++){
            const srcBase = indices[i] * $2642f5341742a843$var$WIND_VERTEX_FLOATS;
            const dstBase = i * floatsPerVertex;
            const bary = $2642f5341742a843$var$BARY_COORDS[i % $2642f5341742a843$var$BARY_COORDS.length];
            // Copy 5 source floats (posX, posY, speedFactor, directionOffset, turbulence)
            expanded[dstBase] = vertices[srcBase];
            expanded[dstBase + 1] = vertices[srcBase + 1];
            expanded[dstBase + 2] = vertices[srcBase + 2];
            expanded[dstBase + 3] = vertices[srcBase + 3];
            expanded[dstBase + 4] = vertices[srcBase + 4];
            // Append barycentric coords
            expanded[dstBase + 5] = bary[0];
            expanded[dstBase + 6] = bary[1];
        }
        const buffer = device.createBuffer({
            size: expanded.byteLength,
            usage: GPUBufferUsage.VERTEX | GPUBufferUsage.COPY_DST,
            label: "Wind Mesh Debug Wireframe"
        });
        device.queue.writeBuffer(buffer, 0, expanded);
        this.cachedWireframe = {
            buffer: buffer,
            vertexCount: indexCount
        };
        this.cachedSourceData = sourceData;
        return this.cachedWireframe;
    }
    sampleMeshAtPoint(sourceData, px, py) {
        const { vertices: vertices, indices: indices, indexCount: indexCount } = sourceData;
        for(let i = 0; i < indexCount; i += 3){
            const ia = indices[i] * $2642f5341742a843$var$WIND_VERTEX_FLOATS;
            const ib = indices[i + 1] * $2642f5341742a843$var$WIND_VERTEX_FLOATS;
            const ic = indices[i + 2] * $2642f5341742a843$var$WIND_VERTEX_FLOATS;
            const ax = vertices[ia];
            const ay = vertices[ia + 1];
            const bx = vertices[ib];
            const by = vertices[ib + 1];
            const cx = vertices[ic];
            const cy = vertices[ic + 1];
            const bary = this.computeBarycentric(px, py, ax, ay, bx, by, cx, cy);
            if (!bary) continue;
            const [u, v, w] = bary;
            if (u < -$2642f5341742a843$var$BARY_INSIDE_EPS || v < -$2642f5341742a843$var$BARY_INSIDE_EPS || w < -$2642f5341742a843$var$BARY_INSIDE_EPS) continue;
            return {
                speedFactor: vertices[ia + 2] * u + vertices[ib + 2] * v + vertices[ic + 2] * w,
                directionOffset: vertices[ia + 3] * u + vertices[ib + 3] * v + vertices[ic + 3] * w,
                turbulence: vertices[ia + 4] * u + vertices[ib + 4] * v + vertices[ic + 4] * w
            };
        }
        return null;
    }
    computeBarycentric(px, py, ax, ay, bx, by, cx, cy) {
        const v0x = bx - ax;
        const v0y = by - ay;
        const v1x = cx - ax;
        const v1y = cy - ay;
        const v2x = px - ax;
        const v2y = py - ay;
        const d00 = v0x * v0x + v0y * v0y;
        const d01 = v0x * v1x + v0y * v1y;
        const d11 = v1x * v1x + v1y * v1y;
        const d20 = v2x * v0x + v2y * v0y;
        const d21 = v2x * v1x + v2y * v1y;
        const denom = d00 * d11 - d01 * d01;
        if (Math.abs(denom) < $2642f5341742a843$var$DEGENERATE_TRIANGLE_EPS) return null;
        const invDenom = 1 / denom;
        const v = (d11 * d20 - d01 * d21) * invDenom;
        const w = (d00 * d21 - d01 * d20) * invDenom;
        const u = 1 - v - w;
        return [
            u,
            v,
            w
        ];
    }
    onKeyDown({ key: key, event: event }) {
        if (key === "KeyV") this.cycleColorMode(event.shiftKey ? -1 : 1);
        if (key === "KeyB") this.cycleSource(event.shiftKey ? -1 : 1);
    }
    cycleColorMode(direction) {
        const n = $2642f5341742a843$var$COLOR_MODE_NAMES.length;
        this.colorMode = (this.colorMode + direction + n) % n;
    }
    cycleSource(direction) {
        const windResources = this.game.entities.tryGetSingleton((0, $cd5b26e926c7fea1$export$c6b583ea58097b81));
        const bundle = windResources?.getWindMeshData();
        if (!bundle || bundle.sourceCount <= 1) return;
        const n = bundle.sourceCount;
        this.selectedSource = (this.selectedSource + direction + n) % n;
        // Invalidate cached wireframe so it rebuilds for the new source
        this.cachedSourceData = null;
    }
    onDestroy() {
        this.unsubscribeMSAA?.();
        this.unsubscribeMSAA = null;
        this.uniformBuffer?.destroy();
        if (this.cachedWireframe) {
            this.cachedWireframe.buffer.destroy();
            this.cachedWireframe = null;
        }
    }
    getModeName() {
        return "Wind Mesh";
    }
    getHudInfo() {
        const windResources = this.game.entities.tryGetSingleton((0, $cd5b26e926c7fea1$export$c6b583ea58097b81));
        const bundle = windResources?.getWindMeshData();
        if (!bundle) return "No wind mesh data";
        const chipStyle = {
            cursor: "pointer",
            padding: "1px 6px",
            borderRadius: "3px",
            background: "rgba(255,255,255,0.1)",
            border: "1px solid rgba(255,255,255,0.2)"
        };
        const labelStyle = {
            color: "#888",
            fontSize: "11px"
        };
        const controlLineStyle = {
            display: "flex",
            alignItems: "center",
            gap: "6px",
            flexWrap: "wrap"
        };
        const dimStyle = {
            color: "#aaa",
            fontSize: "11px"
        };
        const sourceIdx = Math.min(this.selectedSource, bundle.sourceCount - 1);
        const source = bundle.sources[sourceIdx];
        const triCount = Math.floor(source.indexCount / 3);
        const dirDeg = (source.direction * 180 / Math.PI).toFixed(1);
        const weights = windResources?.getSourceWeights() ?? [];
        return /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("div", {
            style: {
                display: "flex",
                flexDirection: "column",
                gap: "4px"
            },
            children: [
                /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("span", {
                    style: controlLineStyle,
                    children: [
                        /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("span", {
                            style: labelStyle,
                            children: "Mode"
                        }),
                        /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("span", {
                            style: chipStyle,
                            onClick: ()=>this.cycleColorMode(1),
                            title: "Click to cycle (V / Shift+V)",
                            children: $2642f5341742a843$var$COLOR_MODE_NAMES[this.colorMode]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("span", {
                    style: controlLineStyle,
                    children: [
                        /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("span", {
                            style: labelStyle,
                            children: "Source"
                        }),
                        /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("span", {
                            style: chipStyle,
                            onClick: ()=>this.cycleSource(1),
                            title: "Click to cycle (B / Shift+B)",
                            children: [
                                sourceIdx + 1,
                                "/",
                                bundle.sourceCount,
                                " (",
                                dirDeg,
                                "\xb0, w=",
                                (weights[sourceIdx] ?? 0).toFixed(2),
                                ")"
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("div", {
                    style: dimStyle,
                    children: /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("span", {
                        children: [
                            bundle.gridCols,
                            "\xd7",
                            bundle.gridRows,
                            " grid",
                            " ",
                            (source.vertexCount / 1000).toFixed(1),
                            "k verts ",
                            triCount,
                            " tris"
                        ]
                    })
                })
            ]
        });
    }
    getCursorInfo() {
        const mouseWorldPos = this.game.camera.toWorld(this.game.io.mousePosition);
        if (!mouseWorldPos) return null;
        const source = this.getActiveSource();
        const rowStyle = {
            display: "flex",
            gap: "8px",
            alignItems: "baseline",
            flexWrap: "wrap"
        };
        const labelStyle = {
            color: "#8fa3b8",
            fontSize: "11px"
        };
        const valueStyle = {
            color: "#d9e6f2",
            fontSize: "11px"
        };
        if (!source) return /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("div", {
            style: {
                display: "flex",
                flexDirection: "column",
                gap: "2px"
            },
            children: [
                /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("span", {
                    style: labelStyle,
                    children: "Wind Mesh"
                }),
                /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("span", {
                    style: valueStyle,
                    children: "No wind mesh data"
                })
            ]
        });
        const sample = this.sampleMeshAtPoint(source, mouseWorldPos.x, mouseWorldPos.y);
        if (!sample) return /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("div", {
            style: {
                display: "flex",
                flexDirection: "column",
                gap: "2px"
            },
            children: [
                /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("span", {
                    style: labelStyle,
                    children: "Wind Mesh"
                }),
                /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("span", {
                    style: valueStyle,
                    children: "No mesh coverage at cursor"
                })
            ]
        });
        return /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("div", {
            style: {
                display: "flex",
                flexDirection: "column",
                gap: "2px"
            },
            children: [
                /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("span", {
                    style: rowStyle,
                    children: /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("span", {
                        style: labelStyle,
                        children: "Wind Mesh"
                    })
                }),
                /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("span", {
                    style: rowStyle,
                    children: [
                        /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("span", {
                            style: labelStyle,
                            children: "speed"
                        }),
                        /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("span", {
                            style: valueStyle,
                            children: sample.speedFactor.toFixed(2)
                        }),
                        /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("span", {
                            style: labelStyle,
                            children: "dir"
                        }),
                        /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("span", {
                            style: valueStyle,
                            children: sample.directionOffset.toFixed(2)
                        }),
                        /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("span", {
                            style: labelStyle,
                            children: "turb"
                        }),
                        /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("span", {
                            style: valueStyle,
                            children: sample.turbulence.toFixed(2)
                        })
                    ]
                })
            ]
        });
    }
    constructor(...args){
        super(...args), this.layer = "windViz", this.colorMode = 0, this.selectedSource = 0, this.pipeline = null, this.bindGroupLayout = null, this.uniformBuffer = null, this.uniforms = null, this.bindGroup = null, this.initialized = false, this.shaderModule = null, this.pipelineLayout = null, this.unsubscribeMSAA = null, this.cachedWireframe = null, this.cachedSourceData = null;
    }
}
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $aa1f0309d9dba6d2$export$af631764ddc44097)("add")
], $2642f5341742a843$export$c3de46f318b3861b.prototype, "onAdd", null);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $aa1f0309d9dba6d2$export$af631764ddc44097)("render")
], $2642f5341742a843$export$c3de46f318b3861b.prototype, "onRender", null);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $aa1f0309d9dba6d2$export$af631764ddc44097)("keyDown")
], $2642f5341742a843$export$c3de46f318b3861b.prototype, "onKeyDown", null);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $aa1f0309d9dba6d2$export$af631764ddc44097)("destroy")
], $2642f5341742a843$export$c3de46f318b3861b.prototype, "onDestroy", null);


class $d78f759d9306ad7b$export$2f674e33b9ab74ba extends (0, $7d9b0c3658290da5$export$690dd8da38397efd) {
    constructor(){
        super(()=>this.renderHud(), true), this.id = "debugRenderer", this.modeConstructors = [
            ()=>new (0, $80f72bdc6bdac008$export$5682830a3e9da60c)(),
            ()=>new (0, $c1bea5f7b6d46ebf$export$5719f1b5c6492235)(),
            ()=>new (0, $c586fbebc8a88baa$export$45dd5d5affb3f66b)(),
            ()=>new (0, $0558c29976e40095$export$3ac78b7c96e957b3)(),
            ()=>new (0, $9101ec9a5366ae75$export$4e17af857435c13b)(),
            ()=>new (0, $2642f5341742a843$export$c3de46f318b3861b)()
        ], this.activeModeIndex = -1 // -1 = off
        , this.currentMode = null;
    }
    renderHud() {
        const mouseWorldPos = this.game.camera.toWorld(this.game.io.mousePosition);
        if (!this.currentMode) return /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("div", {
            className: "debug-hud debug-hud--hidden"
        });
        const modeName = this.currentMode.getModeName();
        const modeContent = this.currentMode.getHudInfo();
        const cursorContent = this.currentMode.getCursorInfo();
        const cursorX = mouseWorldPos.x.toFixed(1);
        const cursorY = mouseWorldPos.y.toFixed(1);
        const cursorContentLines = typeof cursorContent === "string" ? cursorContent.split("\n").filter((line)=>line.length > 0) : null;
        return /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("div", {
            className: "debug-hud",
            children: [
                /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("div", {
                    className: "debug-hud__header",
                    children: [
                        /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("button", {
                            className: "debug-hud__nav-btn",
                            title: "Previous mode (Shift+Tab)",
                            onClick: ()=>this.cycleMode(-1),
                            children: "\u25C0"
                        }),
                        /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("span", {
                            className: "debug-hud__mode",
                            children: modeName
                        }),
                        /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("button", {
                            className: "debug-hud__nav-btn",
                            title: "Next mode (Tab)",
                            onClick: ()=>this.cycleMode(1),
                            children: "\u25B6"
                        })
                    ]
                }),
                modeContent && /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("div", {
                    className: "debug-hud__submode",
                    children: modeContent
                }),
                /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("div", {
                    className: "debug-hud__cursor",
                    children: [
                        /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("div", {
                            className: "debug-hud__section-title",
                            children: "Position"
                        }),
                        /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("div", {
                            className: "debug-hud__cursor-pos",
                            children: [
                                /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("span", {
                                    className: "debug-hud__cursor-kv",
                                    children: [
                                        /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("span", {
                                            className: "debug-hud__cursor-key",
                                            children: "x"
                                        }),
                                        /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("span", {
                                            children: [
                                                cursorX,
                                                " ft"
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("span", {
                                    className: "debug-hud__cursor-kv",
                                    children: [
                                        /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("span", {
                                            className: "debug-hud__cursor-key",
                                            children: "y"
                                        }),
                                        /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("span", {
                                            children: [
                                                cursorY,
                                                " ft"
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("div", {
                            className: "debug-hud__cursor-units",
                            children: "world-space feet"
                        }),
                        cursorContent && /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("div", {
                            className: "debug-hud__cursor-extra",
                            children: [
                                /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("div", {
                                    className: "debug-hud__section-title debug-hud__section-title--nested",
                                    children: "Sample"
                                }),
                                cursorContentLines ? cursorContentLines.map((line, idx)=>/*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("div", {
                                        className: "debug-hud__cursor-line",
                                        children: line
                                    }, idx)) : cursorContent
                            ]
                        })
                    ]
                })
            ]
        });
    }
    onKeyDown({ key: key, event: event }) {
        if (key === "Tab") {
            event.preventDefault();
            if (event.shiftKey) // Shift+Tab: Cycle backward
            this.cycleMode(-1);
            else // Tab: Cycle forward
            this.cycleMode(1);
            return;
        }
    }
    cycleMode(direction) {
        // Cycle: -1 -> 0 -> 1 -> ... -> n-1 -> -1
        const total = this.modeConstructors.length + 1; // +1 for "off" state
        const index = (this.activeModeIndex + 1 + direction + total) % total - 1;
        this.setActiveMode(index);
    }
    setActiveMode(index) {
        if (index < -1 || index >= this.modeConstructors.length) throw new Error("Invalid debug mode index: " + index);
        this.activeModeIndex = index;
        if (this.currentMode) {
            this.currentMode.destroy();
            this.currentMode = null;
        }
        // Activate new mode
        if (this.activeModeIndex >= 0) this.currentMode = this.addChild(this.modeConstructors[this.activeModeIndex]());
    }
}
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $aa1f0309d9dba6d2$export$af631764ddc44097)("keyDown")
], $d78f759d9306ad7b$export$2f674e33b9ab74ba.prototype, "onKeyDown", null);




class $313afacd236db9df$export$8c042ec674a35644 extends (0, $7d9b0c3658290da5$export$690dd8da38397efd) {
    constructor(){
        super(()=>/*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("div", {
                style: {
                    position: "fixed",
                    inset: "0",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    background: "radial-gradient(ellipse at center, rgba(0, 18, 36, 0.6) 0%, rgba(0, 10, 24, 0.9) 100%)",
                    color: "#e8e4d9",
                    fontFamily: "var(--font-title)",
                    fontSize: "1.4rem",
                    letterSpacing: "0.08em",
                    textTransform: "uppercase",
                    textShadow: "0 2px 8px rgba(0, 0, 0, 0.7)",
                    pointerEvents: "none"
                },
                children: "Initializing..."
            }));
    }
}












const $cdb13633b55e18a2$export$2f9f9d5a079a17f0 = 3;


function $6b622df3d0355680$export$91c7d7f64fec365f(game, saveName, levelId) {
    const boat = game.entities.getById("boat");
    if (!boat) throw new Error("Cannot save: no boat entity found");
    const body = boat.hull.body;
    // Read progression state
    const progression = game.entities.tryGetSingleton((0, $a1603b9cc09f9d46$export$caa51bcb55fa9d65));
    const missionManager = game.entities.tryGetSingleton((0, $678b4e73c8f763d8$export$2e44203b34959a7f));
    const missionState = missionManager?.getState();
    const activeMission = missionManager?.getActiveMission();
    return {
        saveName: saveName,
        lastSaved: Date.now(),
        version: (0, $cdb13633b55e18a2$export$2f9f9d5a079a17f0),
        levelId: levelId,
        gameTime: game.elapsedUnpausedTime,
        boat: {
            position: [
                body.position.x,
                body.position.y
            ],
            rotation: body.angle,
            velocity: [
                body.velocity.x,
                body.velocity.y
            ],
            angularVelocity: body.angularVelocity,
            damage: {
                hull: boat.hullDamage.getHealth(),
                rudder: boat.rudderDamage.getHealth(),
                sail: boat.mainSailDamage.getHealth()
            },
            bilgeWater: boat.bilge.waterVolume,
            sailor: {
                stationId: boat.sailor.state.kind === "atStation" ? boat.sailor.state.stationId : null,
                position: boat.sailor.getLocalPosition()
            }
        },
        progression: {
            money: progression?.getMoney() ?? 0,
            currentBoatId: progression?.getCurrentBoatId() ?? "shaff-s7",
            ownedBoats: progression ? progression.getOwnedBoats().map((boatId)=>({
                    boatId: boatId,
                    purchasedUpgrades: progression.getUpgradesForBoat(boatId)
                })) : [
                {
                    boatId: "shaff-s7",
                    purchasedUpgrades: []
                }
            ],
            completedMissions: missionState?.completedMissionIds ?? [],
            currentMission: activeMission ? {
                missionId: activeMission.def.id,
                state: {}
            } : null,
            discoveredPorts: missionState?.revealedPortIds ?? []
        },
        world: {
            windSeed: 0
        }
    };
}



const $7ce0eb9a0217be5b$var$MIGRATIONS = [
    // v1 -> v2: Rename old boat IDs to new fleet names
    (data)=>{
        const progression = data.progression;
        if (!progression) return data;
        const oldToNew = {
            "starter-dinghy": "shaff-s7",
            "starter-boat": "shaff-s7"
        };
        const currentBoatId = progression.currentBoatId;
        if (currentBoatId in oldToNew) progression.currentBoatId = oldToNew[currentBoatId];
        const ownedBoats = progression.ownedBoats;
        if (ownedBoats) for (const entry of ownedBoats){
            if (entry.boatId in oldToNew) entry.boatId = oldToNew[entry.boatId];
            // Rename "deeper-centerboard" upgrade to "deeper-keel"
            const idx = entry.purchasedUpgrades.indexOf("deeper-centerboard");
            if (idx !== -1) entry.purchasedUpgrades[idx] = "deeper-keel";
        }
        return data;
    },
    // v2 -> v3: Add sailor state to boat (defaults to helm)
    (data)=>{
        const boat = data.boat;
        if (boat && !boat.sailor) boat.sailor = {
            stationId: "helm",
            position: [
                0,
                0
            ]
        };
        return data;
    }
];
function $7ce0eb9a0217be5b$export$cf4e90b668984ce8(data) {
    if (data === null || data === undefined || typeof data !== "object") throw new Error("Invalid save data: expected an object");
    const record = data;
    let version = typeof record.version === "number" ? record.version : 1;
    if (version > (0, $cdb13633b55e18a2$export$2f9f9d5a079a17f0)) throw new Error(`Save version ${version} is newer than supported version ${(0, $cdb13633b55e18a2$export$2f9f9d5a079a17f0)}`);
    let migrated = {
        ...record
    };
    while(version < (0, $cdb13633b55e18a2$export$2f9f9d5a079a17f0)){
        const migrationIndex = version - 1;
        const migration = $7ce0eb9a0217be5b$var$MIGRATIONS[migrationIndex];
        if (!migration) throw new Error(`Missing migration from version ${version} to ${version + 1}`);
        migrated = migration(migrated);
        version++;
    }
    migrated.version = (0, $cdb13633b55e18a2$export$2f9f9d5a079a17f0);
    return migrated;
}


const $9798613cd356ac0f$var$KEY_PREFIX = "tack-and-trim";
const $9798613cd356ac0f$var$INDEX_KEY = `${$9798613cd356ac0f$var$KEY_PREFIX}:save-index`;
const $9798613cd356ac0f$var$SAVE_KEY_PREFIX = `${$9798613cd356ac0f$var$KEY_PREFIX}:save:`;
function $9798613cd356ac0f$var$saveKey(slotId) {
    return `${$9798613cd356ac0f$var$SAVE_KEY_PREFIX}${slotId}`;
}
function $9798613cd356ac0f$var$readIndex() {
    try {
        const raw = localStorage.getItem($9798613cd356ac0f$var$INDEX_KEY);
        if (!raw) return [];
        const parsed = JSON.parse(raw);
        if (!Array.isArray(parsed)) return [];
        return parsed;
    } catch  {
        return [];
    }
}
function $9798613cd356ac0f$var$writeIndex(index) {
    localStorage.setItem($9798613cd356ac0f$var$INDEX_KEY, JSON.stringify(index));
}
function $9798613cd356ac0f$export$1496ea5d388228d2() {
    const index = $9798613cd356ac0f$var$readIndex();
    return index.sort((a, b)=>b.lastSaved - a.lastSaved);
}
function $9798613cd356ac0f$export$1288435e8f5043bd(slotId) {
    try {
        const raw = localStorage.getItem($9798613cd356ac0f$var$saveKey(slotId));
        if (!raw) return null;
        const parsed = JSON.parse(raw);
        return (0, $7ce0eb9a0217be5b$export$cf4e90b668984ce8)(parsed);
    } catch  {
        return null;
    }
}
function $9798613cd356ac0f$export$d4e60943768174bd(slotId, data) {
    localStorage.setItem($9798613cd356ac0f$var$saveKey(slotId), JSON.stringify(data));
    const index = $9798613cd356ac0f$var$readIndex();
    const existingIndex = index.findIndex((s)=>s.slotId === slotId);
    const slotInfo = {
        slotId: slotId,
        saveName: data.saveName,
        lastSaved: data.lastSaved,
        levelId: data.levelId
    };
    if (existingIndex >= 0) index[existingIndex] = slotInfo;
    else index.push(slotInfo);
    $9798613cd356ac0f$var$writeIndex(index);
}
function $9798613cd356ac0f$export$296ee9f0f472be1d(slotId) {
    localStorage.removeItem($9798613cd356ac0f$var$saveKey(slotId));
    const index = $9798613cd356ac0f$var$readIndex();
    const filtered = index.filter((s)=>s.slotId !== slotId);
    $9798613cd356ac0f$var$writeIndex(filtered);
}
function $9798613cd356ac0f$export$e88b45bda5c13eb9(saveName) {
    const slotId = Date.now().toString();
    const index = $9798613cd356ac0f$var$readIndex();
    index.push({
        slotId: slotId,
        saveName: saveName,
        lastSaved: 0,
        levelId: ""
    });
    $9798613cd356ac0f$var$writeIndex(index);
    return slotId;
}
function $9798613cd356ac0f$export$db9181b90020753a() {
    const saves = $9798613cd356ac0f$export$1496ea5d388228d2();
    return saves.length > 0 ? saves[0] : null;
}


class $010b1213c3fa230c$export$5bfce22a6398152d extends (0, $c59361981bac2575$export$4342ba5c6ad1f6f1) {
    /** Save current game state to the current slot. */ save(saveName) {
        if (!this.currentLevelId) {
            console.warn("SaveManager.save: no level is active, skipping save");
            return;
        }
        const name = saveName ?? this.generateSaveName();
        const saveFile = (0, $6b622df3d0355680$export$91c7d7f64fec365f)(this.game, name, this.currentLevelId);
        (0, $9798613cd356ac0f$export$d4e60943768174bd)(this.currentSlotId, saveFile);
    }
    /** Quick-save to the current slot with an auto-generated name. */ quickSave() {
        this.save();
    }
    /**
   * Load a save from a slot. This triggers a full level reload:
   * 1. Read save data from storage
   * 2. Store as pending
   * 3. Dispatch boatSelected directly (skipping BoatSelectionScreen) with
   *    the boat the player was using when the save was written
   * 4. On gameStart, apply the pending save data
   */ loadFromSlot(slotId) {
        const save = (0, $9798613cd356ac0f$export$1288435e8f5043bd)(slotId);
        if (!save) {
            console.warn(`SaveManager.loadFromSlot: no save found in slot "${slotId}"`);
            return;
        }
        this.pendingSave = save;
        this.currentSlotId = slotId;
        const levelName = save.levelId;
        const boatId = save.progression.currentBoatId;
        // currentLevelId is normally updated via the levelSelected event, but
        // loads skip that path to avoid showing the boat selection screen.
        this.currentLevelId = levelName;
        this.game.clearScene(99);
        this.game.dispatch("boatSelected", {
            boatId: boatId,
            levelName: levelName
        });
    }
    /** Set which slot to use for subsequent saves. */ setCurrentSlot(slotId) {
        this.currentSlotId = slotId;
    }
    /** Get the current slot ID. */ getCurrentSlotId() {
        return this.currentSlotId;
    }
    // -- Event handlers --
    onLevelSelected({ levelName: levelName }) {
        this.currentLevelId = levelName;
    }
    /** Consume the pending save (called by GameController after constructing entities). */ consumePendingSave() {
        const save = this.pendingSave;
        this.pendingSave = null;
        return save;
    }
    onBoatMoored() {
        this.save("Auto-save (moored)");
    }
    onMissionAccepted() {
        this.save("Auto-save (mission accepted)");
    }
    generateSaveName() {
        const now = new Date();
        const date = now.toLocaleDateString("en-US", {
            month: "short",
            day: "numeric"
        });
        const time = now.toLocaleTimeString("en-US", {
            hour: "numeric",
            minute: "2-digit"
        });
        return `${date} ${time}`;
    }
    constructor(...args){
        super(...args), this.id = "saveManager", this.persistenceLevel = 100, /** The slot currently being used for saves. */ this.currentSlotId = "slot-0", /** The level that is currently active (tracked via levelSelected events). */ this.currentLevelId = null, /** Pending save data waiting to be applied after a level reload. */ this.pendingSave = null;
    }
}
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $aa1f0309d9dba6d2$export$af631764ddc44097)("levelSelected")
], $010b1213c3fa230c$export$5bfce22a6398152d.prototype, "onLevelSelected", null);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $aa1f0309d9dba6d2$export$af631764ddc44097)("boatMoored")
], $010b1213c3fa230c$export$5bfce22a6398152d.prototype, "onBoatMoored", null);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $aa1f0309d9dba6d2$export$af631764ddc44097)("missionAccepted")
], $010b1213c3fa230c$export$5bfce22a6398152d.prototype, "onMissionAccepted", null);




const $e53207e7ad42866a$var$ACTIONS = [
    {
        key: "loadSave",
        label: "Load Last Save"
    },
    {
        key: "restart",
        label: "Restart Level"
    },
    {
        key: "menu",
        label: "Main Menu"
    }
];
class $e53207e7ad42866a$export$46f2ab12afeb552e extends (0, $7d9b0c3658290da5$export$690dd8da38397efd) {
    constructor(){
        super(()=>/*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("div", {
                class: "game-over",
                children: [
                    /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("div", {
                        class: "game-over__title",
                        children: "Sunk!"
                    }),
                    /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("div", {
                        class: "game-over__actions",
                        children: $e53207e7ad42866a$var$ACTIONS.map(({ key: key, label: label })=>/*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("button", {
                                class: "game-over__button",
                                onClick: ()=>this.execute(key),
                                children: label
                            }))
                    })
                ]
            }));
    }
    onAfterAdded() {
        this.reactRender();
        (0, $b3d670cfac76cf94$export$4117a64304d253b0)(this.el);
    }
    execute(action) {
        if (action === "loadSave") {
            const recentSave = (0, $9798613cd356ac0f$export$db9181b90020753a)();
            if (recentSave) {
                const saveManager = this.game.entities.tryGetSingleton((0, $010b1213c3fa230c$export$5bfce22a6398152d));
                if (saveManager) {
                    saveManager.loadFromSlot(recentSave.slotId);
                    this.destroy();
                    return;
                }
            }
            this.game.dispatch("restartLevel", {});
        } else if (action === "restart") this.game.dispatch("restartLevel", {});
        else this.game.dispatch("returnToMenu", {});
        this.destroy();
    }
    onKeyDown({ key: key }) {
        if (key === "ArrowUp" || key === "ArrowLeft") (0, $b3d670cfac76cf94$export$e4c43fd18762e8ea)(this.el, -1);
        else if (key === "ArrowDown" || key === "ArrowRight") (0, $b3d670cfac76cf94$export$e4c43fd18762e8ea)(this.el, 1);
    }
}
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $aa1f0309d9dba6d2$export$af631764ddc44097)("afterAdded")
], $e53207e7ad42866a$export$46f2ab12afeb552e.prototype, "onAfterAdded", null);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $aa1f0309d9dba6d2$export$af631764ddc44097)("keyDown")
], $e53207e7ad42866a$export$46f2ab12afeb552e.prototype, "onKeyDown", null);










function $591c16731dd02df0$var$StatBar({ label: label, value: value }) {
    return /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("div", {
        class: "boat-selection__stat",
        children: [
            /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("span", {
                class: "boat-selection__stat-label",
                children: label
            }),
            /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("div", {
                class: "boat-selection__stat-bar",
                children: Array.from({
                    length: 10
                }, (_, i)=>/*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("div", {
                        class: `boat-selection__stat-pip ${i < value ? "boat-selection__stat-pip--filled" : ""}`
                    }))
            })
        ]
    });
}
function $591c16731dd02df0$export$b914569b066f32cc({ focusedIndex: focusedIndex, onFocusBoat: onFocusBoat, onSelectBoat: onSelectBoat, onBack: onBack }) {
    const selected = (0, $6d17b959f73c0724$export$cf8efd331d9fbe25)[focusedIndex];
    return /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)((0, $13c40c34b78c8ee2$export$ffb0004e005737fa), {
        children: [
            /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("div", {
                class: "main-menu__page-title",
                children: "Choose Your Boat"
            }),
            /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("div", {
                class: "main-menu__split",
                children: [
                    /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("div", {
                        class: "main-menu__levels",
                        children: (0, $6d17b959f73c0724$export$cf8efd331d9fbe25).map((boat, i)=>/*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("button", {
                                class: "main-menu__card",
                                onClick: ()=>onSelectBoat(boat.id),
                                onFocus: ()=>onFocusBoat(i),
                                onMouseEnter: ()=>onFocusBoat(i),
                                children: boat.name
                            }))
                    }),
                    selected && /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("div", {
                        class: "main-menu__detail",
                        children: [
                            /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("div", {
                                class: "main-menu__detail-name",
                                children: selected.name
                            }),
                            /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("div", {
                                class: "main-menu__detail-desc",
                                children: selected.description
                            }),
                            /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("div", {
                                class: "boat-selection__stats",
                                children: [
                                    /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)($591c16731dd02df0$var$StatBar, {
                                        label: "Speed",
                                        value: selected.displayStats.speed
                                    }),
                                    /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)($591c16731dd02df0$var$StatBar, {
                                        label: "Stability",
                                        value: selected.displayStats.stability
                                    }),
                                    /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)($591c16731dd02df0$var$StatBar, {
                                        label: "Maneuverability",
                                        value: selected.displayStats.maneuverability
                                    }),
                                    /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)($591c16731dd02df0$var$StatBar, {
                                        label: "Durability",
                                        value: selected.displayStats.durability
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("button", {
                class: "main-menu__back",
                onClick: onBack,
                children: "\u2190 Back"
            })
        ]
    });
}



function $f50f55bc64770839$export$417d3e8424314d4d(name) {
    // "default" → "Default", "vendoviIsland" → "Vendovi Island"
    const spaced = name.replace(/([A-Z])/g, " $1");
    return spaced.charAt(0).toUpperCase() + spaced.slice(1);
}
function $f50f55bc64770839$export$bfe4ac50319c1d9b(ts) {
    const d = new Date(ts);
    return d.toLocaleDateString("en-US", {
        month: "short",
        day: "numeric",
        hour: "numeric",
        minute: "2-digit"
    });
}


function $47d4abe29232a115$export$1686326d930cc41d(props) {
    return /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)((0, $13c40c34b78c8ee2$export$ffb0004e005737fa), {
        children: [
            /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("div", {
                class: "main-menu__page-title",
                children: "Load Game"
            }),
            props.saves.length === 0 ? /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("div", {
                class: "main-menu__empty",
                children: "No saved games."
            }) : /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("div", {
                class: "main-menu__levels",
                children: props.saves.map((save)=>props.pendingDeleteSlotId === save.slotId ? $47d4abe29232a115$var$renderConfirm(save, props) : $47d4abe29232a115$var$renderSave(save, props))
            }),
            /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("button", {
                class: "main-menu__back",
                onClick: props.onBack,
                children: "\u2190 Back"
            })
        ]
    });
}
function $47d4abe29232a115$var$renderSave(save, props) {
    return /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("div", {
        class: "main-menu__save-entry",
        children: [
            /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("button", {
                class: "main-menu__card main-menu__card--save",
                onClick: ()=>props.onLoad(save.slotId),
                onKeyDown: (e)=>{
                    if (e.key === "Delete" || e.key === "Backspace") {
                        e.preventDefault();
                        props.onRequestDelete(save.slotId);
                    }
                },
                children: [
                    /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("div", {
                        class: "main-menu__save-name",
                        children: save.saveName
                    }),
                    /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("div", {
                        class: "main-menu__save-details",
                        children: [
                            (0, $f50f55bc64770839$export$417d3e8424314d4d)(save.levelId),
                            " \xb7 ",
                            (0, $f50f55bc64770839$export$bfe4ac50319c1d9b)(save.lastSaved)
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("button", {
                class: "main-menu__delete",
                tabIndex: -1,
                "aria-label": `Delete save "${save.saveName}"`,
                onClick: (e)=>{
                    e.stopPropagation();
                    props.onRequestDelete(save.slotId);
                },
                children: "\xd7"
            })
        ]
    });
}
function $47d4abe29232a115$var$renderConfirm(save, props) {
    return /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("div", {
        class: "main-menu__card main-menu__card--confirm",
        children: [
            /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("div", {
                class: "main-menu__confirm-prompt",
                children: [
                    "Delete \u201C",
                    save.saveName,
                    "\u201D?"
                ]
            }),
            /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("div", {
                class: "main-menu__confirm-actions",
                children: [
                    /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("button", {
                        class: "main-menu__confirm-button main-menu__confirm-button--danger",
                        onClick: ()=>props.onConfirmDelete(save.slotId),
                        children: "Delete"
                    }),
                    /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("button", {
                        class: "main-menu__confirm-button",
                        onClick: props.onCancelDelete,
                        children: "Cancel"
                    })
                ]
            })
        ]
    });
}






const $db0d09afbd5ca4bf$var$DIFFICULTY_LABEL = {
    beginner: "Beginner",
    intermediate: "Intermediate",
    expert: "Expert"
};
const $db0d09afbd5ca4bf$var$DIFFICULTY_ORDER = {
    beginner: 0,
    intermediate: 1,
    expert: 2
};
function $db0d09afbd5ca4bf$var$buildEntries() {
    const names = Object.keys((0, $bcae27952f7958f2$export$4e841128923ef26).levels);
    return names.map((name)=>{
        const file = (0, $bcae27952f7958f2$export$4e841128923ef26).levels[name];
        return {
            name: name,
            displayName: file.name ?? (0, $f50f55bc64770839$export$417d3e8424314d4d)(name),
            info: file.displayInfo
        };
    }).sort((a, b)=>{
        const da = a.info?.difficulty;
        const db = b.info?.difficulty;
        const oa = da ? $db0d09afbd5ca4bf$var$DIFFICULTY_ORDER[da] : Infinity;
        const ob = db ? $db0d09afbd5ca4bf$var$DIFFICULTY_ORDER[db] : Infinity;
        if (oa !== ob) return oa - ob;
        return a.displayName.localeCompare(b.displayName);
    });
}
const $db0d09afbd5ca4bf$var$ENTRIES = $db0d09afbd5ca4bf$var$buildEntries();
function $db0d09afbd5ca4bf$export$23bf42528c4ff8ea({ focusedIndex: focusedIndex, onFocusLevel: onFocusLevel, onSelectLevel: onSelectLevel, onBack: onBack }) {
    const focused = $db0d09afbd5ca4bf$var$ENTRIES[focusedIndex];
    return /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)((0, $13c40c34b78c8ee2$export$ffb0004e005737fa), {
        children: [
            /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("div", {
                class: "main-menu__page-title",
                children: "New Game"
            }),
            /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("div", {
                class: "main-menu__split",
                children: [
                    /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("div", {
                        class: "main-menu__levels",
                        children: $db0d09afbd5ca4bf$var$ENTRIES.map((entry, i)=>/*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("button", {
                                class: "main-menu__card",
                                onClick: ()=>onSelectLevel(entry.name),
                                onFocus: ()=>onFocusLevel(i),
                                onMouseEnter: ()=>onFocusLevel(i),
                                children: entry.displayName
                            }))
                    }),
                    focused && /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("div", {
                        class: "main-menu__detail",
                        children: [
                            /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("div", {
                                class: "main-menu__detail-name",
                                children: focused.displayName
                            }),
                            focused.info?.difficulty && /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("div", {
                                class: `main-menu__badge main-menu__badge--${focused.info.difficulty}`,
                                children: $db0d09afbd5ca4bf$var$DIFFICULTY_LABEL[focused.info.difficulty]
                            }),
                            focused.info?.description && /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("div", {
                                class: "main-menu__detail-desc",
                                children: focused.info.description
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("button", {
                class: "main-menu__back",
                onClick: onBack,
                children: "\u2190 Back"
            })
        ]
    });
}








function $6f9a7b388f34d0d6$export$fef7159a5e479b3c({ onBack: onBack, onChange: onChange }) {
    const msaa = (0, $3d4164726c38f33c$export$8f47e656fde7db88)();
    const volume = (0, $396ca6dbf1c6942d$export$657f181f46dbfffb)();
    return /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("div", {
        class: "settings-panel",
        children: [
            /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("div", {
                class: "settings-panel__title",
                children: "Settings"
            }),
            /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("div", {
                class: "settings-panel__options",
                children: [
                    /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("label", {
                        class: "settings-panel__option settings-panel__option--slider",
                        children: [
                            /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("span", {
                                class: "settings-panel__option-label",
                                children: "Master Volume"
                            }),
                            /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("input", {
                                class: "settings-panel__slider",
                                type: "range",
                                min: "0",
                                max: "1",
                                step: "0.01",
                                value: volume,
                                onInput: (e)=>{
                                    (0, $396ca6dbf1c6942d$export$bd9196e59b031aae)(Number(e.target.value));
                                    onChange();
                                }
                            }),
                            /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("span", {
                                class: "settings-panel__option-value",
                                children: [
                                    Math.round(volume * 100),
                                    "%"
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("button", {
                        class: "settings-panel__option",
                        onClick: ()=>{
                            (0, $3d4164726c38f33c$export$d7ca61431a454ec7)(!msaa);
                            onChange();
                        },
                        children: [
                            /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("span", {
                                class: "settings-panel__option-label",
                                children: "Antialiasing (MSAA 4x)"
                            }),
                            /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("span", {
                                class: "settings-panel__option-value",
                                children: msaa ? "On" : "Off"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("button", {
                class: "settings-panel__back",
                onClick: onBack,
                children: "\u2190 Back"
            })
        ]
    });
}



class $0e28100eb9c66a46$export$4e08dcf990b776c0 extends (0, $7d9b0c3658290da5$export$690dd8da38397efd) {
    constructor(){
        super(()=>{
            return /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("div", {
                class: "main-menu",
                children: [
                    this.submenu === null && this.renderRoot(),
                    this.submenu === "settings" && /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)((0, $6f9a7b388f34d0d6$export$fef7159a5e479b3c), {
                        onBack: ()=>this.setSubmenu(null),
                        onChange: ()=>this.reactRender()
                    }),
                    this.submenu === "loadGame" && /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)((0, $47d4abe29232a115$export$1686326d930cc41d), {
                        saves: this.saves,
                        pendingDeleteSlotId: this.pendingDeleteSlotId,
                        onBack: ()=>this.setSubmenu(null),
                        onLoad: (slotId)=>this.loadSave(slotId),
                        onRequestDelete: (slotId)=>this.requestDelete(slotId),
                        onConfirmDelete: (slotId)=>this.confirmDelete(slotId),
                        onCancelDelete: ()=>this.cancelDelete()
                    }),
                    this.submenu === "newGame" && /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)((0, $db0d09afbd5ca4bf$export$23bf42528c4ff8ea), {
                        focusedIndex: this.levelFocusedIndex,
                        onFocusLevel: (i)=>this.setLevelFocused(i),
                        onSelectLevel: (name)=>this.selectLevel(name),
                        onBack: ()=>this.setSubmenu(null)
                    }),
                    typeof this.submenu === "object" && this.submenu !== null && this.submenu.kind === "boatSelect" && (()=>{
                        const level = this.submenu.level;
                        return /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)((0, $591c16731dd02df0$export$b914569b066f32cc), {
                            focusedIndex: this.boatFocusedIndex,
                            onFocusBoat: (i)=>this.setBoatFocused(i),
                            onSelectBoat: (boatId)=>this.confirmBoat(boatId, level),
                            onBack: ()=>this.setSubmenu("newGame")
                        });
                    })()
                ]
            });
        }), this.submenu = null, // Root menu state
        this.hasSaves = false, this.mostRecent = null, // Load-game state
        this.saves = [], this.pendingDeleteSlotId = null, // New-game / boat-select focused index
        this.levelFocusedIndex = 0, this.boatFocusedIndex = 0;
    }
    renderRoot() {
        const continueDisabled = this.mostRecent === null;
        const loadDisabled = !this.hasSaves;
        return /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)((0, $13c40c34b78c8ee2$export$ffb0004e005737fa), {
            children: [
                /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("div", {
                    class: "main-menu__title",
                    children: "Tack & Trim"
                }),
                /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("div", {
                    class: "main-menu__buttons",
                    children: [
                        /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("button", {
                            class: "main-menu__card",
                            disabled: continueDisabled,
                            onClick: ()=>this.continueGame(),
                            children: [
                                /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("div", {
                                    class: "main-menu__card-label",
                                    children: "Continue"
                                }),
                                /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("div", {
                                    class: "main-menu__save-details",
                                    children: this.mostRecent ? `${this.mostRecent.saveName} \xb7 ${(0, $f50f55bc64770839$export$417d3e8424314d4d)(this.mostRecent.levelId)} \xb7 ${(0, $f50f55bc64770839$export$bfe4ac50319c1d9b)(this.mostRecent.lastSaved)}` : "No saved games"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("button", {
                            class: "main-menu__card",
                            disabled: loadDisabled,
                            onClick: ()=>this.openLoadGame(),
                            children: "Load Game"
                        }),
                        /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("button", {
                            class: "main-menu__card",
                            onClick: ()=>this.openNewGame(),
                            children: "New Game"
                        }),
                        /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("button", {
                            class: "main-menu__card",
                            onClick: ()=>this.openSettings(),
                            children: "Settings"
                        })
                    ]
                })
            ]
        });
    }
    onAfterAdded() {
        this.refreshSavesSummary();
        this.reactRender();
        (0, $b3d670cfac76cf94$export$4117a64304d253b0)(this.el);
    }
    refreshSavesSummary() {
        const saves = (0, $9798613cd356ac0f$export$1496ea5d388228d2)();
        this.hasSaves = saves.length > 0;
        this.mostRecent = (0, $9798613cd356ac0f$export$db9181b90020753a)();
    }
    setSubmenu(next) {
        this.submenu = next;
        this.reactRender();
        (0, $b3d670cfac76cf94$export$4117a64304d253b0)(this.el);
    }
    // Root actions
    continueGame() {
        if (!this.mostRecent) return;
        const saveManager = this.game.entities.tryGetSingleton((0, $010b1213c3fa230c$export$5bfce22a6398152d));
        if (saveManager) saveManager.loadFromSlot(this.mostRecent.slotId);
        this.destroy();
    }
    openLoadGame() {
        this.saves = (0, $9798613cd356ac0f$export$1496ea5d388228d2)();
        this.pendingDeleteSlotId = null;
        this.setSubmenu("loadGame");
    }
    openNewGame() {
        this.levelFocusedIndex = 0;
        this.setSubmenu("newGame");
    }
    openSettings() {
        this.setSubmenu("settings");
    }
    // Load-game actions
    loadSave(slotId) {
        const saveManager = this.game.entities.tryGetSingleton((0, $010b1213c3fa230c$export$5bfce22a6398152d));
        if (saveManager) saveManager.loadFromSlot(slotId);
        this.destroy();
    }
    requestDelete(slotId) {
        this.pendingDeleteSlotId = slotId;
        this.reactRender();
        const actions = this.el.querySelectorAll(".main-menu__confirm-button");
        actions[actions.length - 1]?.focus();
    }
    confirmDelete(slotId) {
        (0, $9798613cd356ac0f$export$296ee9f0f472be1d)(slotId);
        this.pendingDeleteSlotId = null;
        this.saves = (0, $9798613cd356ac0f$export$1496ea5d388228d2)();
        this.refreshSavesSummary();
        this.reactRender();
        (0, $b3d670cfac76cf94$export$4117a64304d253b0)(this.el);
    }
    cancelDelete() {
        this.pendingDeleteSlotId = null;
        this.reactRender();
        (0, $b3d670cfac76cf94$export$4117a64304d253b0)(this.el);
    }
    // New-game / boat-select actions
    setLevelFocused(index) {
        if (this.levelFocusedIndex === index) return;
        this.levelFocusedIndex = index;
        this.reactRender();
    }
    setBoatFocused(index) {
        if (this.boatFocusedIndex === index) return;
        this.boatFocusedIndex = index;
        this.reactRender();
    }
    selectLevel(levelName) {
        this.game.dispatch("levelSelected", {
            levelName: levelName
        });
        this.boatFocusedIndex = 0;
        this.setSubmenu({
            kind: "boatSelect",
            level: levelName
        });
    }
    confirmBoat(boatId, levelName) {
        this.game.dispatch("boatSelected", {
            boatId: boatId,
            levelName: levelName
        });
        this.destroy();
    }
    // Keyboard
    onKeyDown({ key: key, event: event }) {
        if (key === "Escape") {
            event.preventDefault();
            if (this.submenu === null) return;
            if (this.submenu === "loadGame" && this.pendingDeleteSlotId !== null) {
                this.cancelDelete();
                return;
            }
            if (typeof this.submenu === "object" && this.submenu.kind === "boatSelect") {
                this.setSubmenu("newGame");
                return;
            }
            this.setSubmenu(null);
            return;
        }
        if (key === "ArrowUp" || key === "ArrowLeft") {
            event.preventDefault();
            (0, $b3d670cfac76cf94$export$e4c43fd18762e8ea)(this.el, -1);
        } else if (key === "ArrowDown" || key === "ArrowRight") {
            event.preventDefault();
            (0, $b3d670cfac76cf94$export$e4c43fd18762e8ea)(this.el, 1);
        }
    }
}
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $aa1f0309d9dba6d2$export$af631764ddc44097)("afterAdded")
], $0e28100eb9c66a46$export$4e08dcf990b776c0.prototype, "onAfterAdded", null);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $aa1f0309d9dba6d2$export$af631764ddc44097)("keyDown")
], $0e28100eb9c66a46$export$4e08dcf990b776c0.prototype, "onKeyDown", null);










const $c2cad548d22b70b6$var$ACTIONS = [
    {
        key: "resume",
        label: "Resume"
    },
    {
        key: "save",
        label: "Save Game"
    },
    {
        key: "restart",
        label: "Restart Level"
    },
    {
        key: "settings",
        label: "Settings"
    },
    {
        key: "mainMenu",
        label: "Return to Main Menu"
    }
];
class $c2cad548d22b70b6$export$66bb9231a6614ad8 extends (0, $7d9b0c3658290da5$export$690dd8da38397efd) {
    constructor(){
        super(()=>/*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("div", {
                class: "pause-menu",
                children: [
                    this.submenu === null && this.renderMain(),
                    this.submenu === "settings" && /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)((0, $6f9a7b388f34d0d6$export$fef7159a5e479b3c), {
                        onBack: ()=>this.setSubmenu(null),
                        onChange: ()=>this.reactRender()
                    })
                ]
            })), this.submenu = null;
    }
    renderMain() {
        return /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)((0, $13c40c34b78c8ee2$export$ffb0004e005737fa), {
            children: [
                /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("div", {
                    class: "pause-menu__title",
                    children: "Paused"
                }),
                /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("div", {
                    class: "pause-menu__actions",
                    children: $c2cad548d22b70b6$var$ACTIONS.map(({ key: key, label: label })=>/*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("button", {
                            class: "pause-menu__button",
                            onClick: ()=>this.execute(key),
                            children: label
                        }))
                }),
                /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("div", {
                    class: "pause-menu__hint",
                    children: "Esc to resume"
                })
            ]
        });
    }
    onAdd() {
        super.onAdd();
        if (!this.game.paused) this.game.pause();
    }
    onDestroy(data) {
        if (data.game.paused) data.game.unpause();
        super.onDestroy(data);
    }
    onAfterAdded() {
        this.reactRender();
        (0, $b3d670cfac76cf94$export$4117a64304d253b0)(this.el);
    }
    setSubmenu(next) {
        this.submenu = next;
        this.reactRender();
        (0, $b3d670cfac76cf94$export$4117a64304d253b0)(this.el);
    }
    execute(action) {
        switch(action){
            case "resume":
                this.destroy();
                return;
            case "save":
                this.game.entities.getSingleton((0, $010b1213c3fa230c$export$5bfce22a6398152d)).save();
                this.destroy();
                return;
            case "restart":
                this.game.dispatch("restartLevel", {});
                return;
            case "settings":
                this.setSubmenu("settings");
                return;
            case "mainMenu":
                this.game.dispatch("returnToMenu", {});
                return;
        }
    }
    onKeyDown({ key: key, event: event }) {
        if (key === "Escape") {
            event.preventDefault();
            if (this.submenu !== null) this.setSubmenu(null);
            else this.destroy();
            return;
        }
        if (key === "ArrowUp" || key === "ArrowLeft") (0, $b3d670cfac76cf94$export$e4c43fd18762e8ea)(this.el, -1);
        else if (key === "ArrowDown" || key === "ArrowRight") (0, $b3d670cfac76cf94$export$e4c43fd18762e8ea)(this.el, 1);
    }
}
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $aa1f0309d9dba6d2$export$af631764ddc44097)("afterAdded")
], $c2cad548d22b70b6$export$66bb9231a6614ad8.prototype, "onAfterAdded", null);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $aa1f0309d9dba6d2$export$af631764ddc44097)("keyDown")
], $c2cad548d22b70b6$export$66bb9231a6614ad8.prototype, "onKeyDown", null);


/**
 * MissionHUD - always-visible HUD element showing the current mission objective,
 * plus a temporary "Mission Complete" notification when a mission finishes.
 */ 





const $a82e076dd0014e6c$var$COMPLETION_DISPLAY_SECONDS = 4;
class $a82e076dd0014e6c$export$a293bae3ba54199c extends (0, $7d9b0c3658290da5$export$690dd8da38397efd) {
    constructor(){
        super(()=>this.renderContent()), this.completionNotice = null;
    }
    onMissionCompleted({ missionId: missionId, rewards: rewards }) {
        // Look up the mission name from the MissionManager
        const manager = this.game?.entities.tryGetSingleton((0, $678b4e73c8f763d8$export$2e44203b34959a7f)) ?? null;
        const def = manager?.getMissionDef(missionId);
        this.completionNotice = {
            missionName: def?.name ?? missionId,
            money: rewards.money,
            revealPorts: rewards.revealPorts,
            timeRemaining: $a82e076dd0014e6c$var$COMPLETION_DISPLAY_SECONDS
        };
    }
    onTick({ dt: dt }) {
        if (this.completionNotice) {
            this.completionNotice.timeRemaining -= dt;
            if (this.completionNotice.timeRemaining <= 0) this.completionNotice = null;
        }
    }
    renderContent() {
        const manager = this.game?.entities.tryGetSingleton((0, $678b4e73c8f763d8$export$2e44203b34959a7f)) ?? null;
        const active = manager?.getActiveMission() ?? null;
        return /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("div", {
            className: "mission-hud",
            children: [
                this.completionNotice && this.renderCompletion(this.completionNotice),
                active && this.renderObjective(active)
            ]
        });
    }
    renderCompletion(notice) {
        const fading = notice.timeRemaining < 1;
        return /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("div", {
            className: `mission-hud__completion ${fading ? "mission-hud__completion--fading" : ""}`,
            children: [
                /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("div", {
                    className: "mission-hud__completion-header",
                    children: "Mission Complete"
                }),
                /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("div", {
                    className: "mission-hud__completion-name",
                    children: notice.missionName
                }),
                notice.money && /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("div", {
                    className: "mission-hud__completion-reward",
                    children: [
                        "+",
                        notice.money,
                        " gold"
                    ]
                })
            ]
        });
    }
    renderObjective(active) {
        const objectiveText = active.def.type === "delivery" && active.def.destinationPortId ? `Sail to ${this.getPortName(active.def.destinationPortId)}` : active.def.description;
        return /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("div", {
            className: "mission-hud__panel",
            children: [
                /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("div", {
                    className: "mission-hud__title",
                    children: active.def.name
                }),
                /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("div", {
                    className: "mission-hud__objective",
                    children: [
                        "\u27A4",
                        " ",
                        objectiveText
                    ]
                })
            ]
        });
    }
    getPortName(portId) {
        const portEntity = this.game?.entities.getById(portId);
        if (portEntity && "getName" in portEntity) return portEntity.getName();
        return portId;
    }
}
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $aa1f0309d9dba6d2$export$af631764ddc44097)("missionCompleted")
], $a82e076dd0014e6c$export$a293bae3ba54199c.prototype, "onMissionCompleted", null);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $aa1f0309d9dba6d2$export$af631764ddc44097)("tick")
], $a82e076dd0014e6c$export$a293bae3ba54199c.prototype, "onTick", null);










const $a8d907c4d81bde2c$var$MAP_MAX_POINTS_PER_CONTOUR = 220;
const $a8d907c4d81bde2c$var$MAP_PADDING_RATIO = 0.06;
const $a8d907c4d81bde2c$var$MIN_MAP_PADDING = 200;
const $a8d907c4d81bde2c$var$CARDINAL_DIRECTIONS = [
    "N",
    "NE",
    "E",
    "SE",
    "S",
    "SW",
    "W",
    "NW"
];
function $a8d907c4d81bde2c$var$formatLevelName(levelName) {
    const spaced = levelName.replace(/([A-Z])/g, " $1");
    return spaced.charAt(0).toUpperCase() + spaced.slice(1);
}
class $a8d907c4d81bde2c$export$a105e548efe5f62c extends (0, $7d9b0c3658290da5$export$690dd8da38397efd) {
    constructor(levelName){
        super(()=>this.renderContent()), this.id = "navigationHud", this.isMapOpen = false, this.terrainRef = null, this.mapTerrainVersion = -1, this.mapContours = [], this.mapViewBox = "0 0 100 100";
        this.mapTitle = levelName ? $a8d907c4d81bde2c$var$formatLevelName(levelName) : "Sea Chart";
    }
    onKeyDown({ key: key, event: event }) {
        if (key !== "KeyM") return;
        event.preventDefault();
        this.isMapOpen = !this.isMapOpen;
        this.reactRender();
    }
    renderContent() {
        this.updateMapCache();
        const headingDegrees = this.getHeadingDegrees();
        const headingLabel = $a8d907c4d81bde2c$var$CARDINAL_DIRECTIONS[Math.round(headingDegrees / 45) % $a8d907c4d81bde2c$var$CARDINAL_DIRECTIONS.length];
        return /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("div", {
            className: "navigation-hud",
            children: [
                /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("div", {
                    className: "navigation-hud__heading",
                    children: [
                        /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("div", {
                            className: "navigation-hud__heading-ring",
                            children: [
                                /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("span", {
                                    className: "navigation-hud__heading-cardinal navigation-hud__heading-cardinal--n",
                                    children: "N"
                                }),
                                /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("span", {
                                    className: "navigation-hud__heading-cardinal navigation-hud__heading-cardinal--e",
                                    children: "E"
                                }),
                                /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("span", {
                                    className: "navigation-hud__heading-cardinal navigation-hud__heading-cardinal--s",
                                    children: "S"
                                }),
                                /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("span", {
                                    className: "navigation-hud__heading-cardinal navigation-hud__heading-cardinal--w",
                                    children: "W"
                                }),
                                /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("div", {
                                    className: "navigation-hud__heading-needle",
                                    style: {
                                        transform: `translate(-50%, -100%) rotate(${headingDegrees.toFixed(1)}deg)`
                                    }
                                }),
                                /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("div", {
                                    className: "navigation-hud__heading-dot"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("div", {
                            className: "navigation-hud__heading-label",
                            children: `${headingLabel} ${headingDegrees.toFixed(0)}\xb0`
                        })
                    ]
                }),
                this.isMapOpen && /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("div", {
                    className: "navigation-hud__map-overlay",
                    children: /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("div", {
                        className: "navigation-hud__map-sheet",
                        children: [
                            /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("div", {
                                className: "navigation-hud__map-title",
                                children: this.mapTitle
                            }),
                            this.mapContours.length > 0 ? /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("svg", {
                                className: "navigation-hud__map-svg",
                                viewBox: this.mapViewBox,
                                preserveAspectRatio: "xMidYMid meet",
                                "aria-label": "Map overlay",
                                children: [
                                    this.mapContours.map((line)=>/*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("polygon", {
                                            points: line.points,
                                            className: "navigation-hud__map-line"
                                        }, line.id)),
                                    this.renderMapMarkers()
                                ]
                            }) : /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("div", {
                                className: "navigation-hud__map-empty",
                                children: "No shoreline data available"
                            }),
                            /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("div", {
                                className: "navigation-hud__map-tip",
                                children: "Press M to close"
                            }),
                            /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("div", {
                                className: "navigation-hud__map-rose",
                                children: this.renderCompassRose()
                            })
                        ]
                    })
                })
            ]
        });
    }
    renderCompassRose() {
        return /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("svg", {
            viewBox: "0 0 100 100",
            "aria-hidden": "true",
            children: [
                /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("circle", {
                    cx: "50",
                    cy: "50",
                    r: "42",
                    className: "navigation-hud__rose-ring"
                }),
                /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("line", {
                    x1: "50",
                    y1: "11",
                    x2: "50",
                    y2: "89",
                    className: "navigation-hud__rose-axis"
                }),
                /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("line", {
                    x1: "11",
                    y1: "50",
                    x2: "89",
                    y2: "50",
                    className: "navigation-hud__rose-axis"
                }),
                /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("line", {
                    x1: "22",
                    y1: "22",
                    x2: "78",
                    y2: "78",
                    className: "navigation-hud__rose-axis navigation-hud__rose-axis--minor"
                }),
                /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("line", {
                    x1: "78",
                    y1: "22",
                    x2: "22",
                    y2: "78",
                    className: "navigation-hud__rose-axis navigation-hud__rose-axis--minor"
                }),
                /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("polygon", {
                    points: "50,8 56,26 50,22 44,26",
                    className: "navigation-hud__rose-north"
                }),
                /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("text", {
                    x: "50",
                    y: "23",
                    className: "navigation-hud__rose-label",
                    textAnchor: "middle",
                    children: "N"
                }),
                /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("text", {
                    x: "79",
                    y: "54",
                    className: "navigation-hud__rose-label",
                    textAnchor: "middle",
                    children: "E"
                }),
                /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("text", {
                    x: "50",
                    y: "87",
                    className: "navigation-hud__rose-label",
                    textAnchor: "middle",
                    children: "S"
                }),
                /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("text", {
                    x: "21",
                    y: "54",
                    className: "navigation-hud__rose-label",
                    textAnchor: "middle",
                    children: "W"
                })
            ]
        });
    }
    renderMapMarkers() {
        const ports = this.game?.entities.getTagged("port") ?? [];
        const missionManager = this.game?.entities.tryGetSingleton((0, $678b4e73c8f763d8$export$2e44203b34959a7f)) ?? null;
        const activeMission = missionManager?.getActiveMission() ?? null;
        const destinationPortId = activeMission?.def.type === "delivery" ? activeMission.def.destinationPortId : null;
        // Scale marker sizes relative to the map — read viewBox dimensions
        const vbParts = this.mapViewBox.split(" ").map(Number);
        const vbSize = Math.max(vbParts[2] ?? 100, vbParts[3] ?? 100);
        const markerR = vbSize * 0.003;
        const fontSize = vbSize * 0.022;
        return /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)((0, $13c40c34b78c8ee2$export$ffb0004e005737fa), {
            children: [
                ...ports
            ].map((entity)=>{
                const port = entity;
                const pos = port.getPosition();
                const isDestination = port.getId() === destinationPortId;
                return /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("g", {
                    children: [
                        /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("circle", {
                            cx: pos.x.toFixed(1),
                            cy: pos.y.toFixed(1),
                            r: markerR,
                            className: `navigation-hud__map-port ${isDestination ? "navigation-hud__map-port--destination" : ""}`
                        }),
                        /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("text", {
                            x: pos.x.toFixed(1),
                            y: (pos.y - markerR * 2.2).toFixed(1),
                            textAnchor: "middle",
                            className: "navigation-hud__map-port-label",
                            style: {
                                fontSize: `${fontSize}px`
                            },
                            children: port.getName()
                        })
                    ]
                }, port.getId());
            })
        });
    }
    getHeadingDegrees() {
        if (!this.game) return 0;
        const degrees = this.game.camera.angle * 180 / Math.PI + 90;
        return (degrees % 360 + 360) % 360;
    }
    updateMapCache() {
        const terrain = this.game?.entities.tryGetSingleton((0, $cd92036e590b44aa$export$74cf638da29b900d));
        if (!terrain) {
            this.terrainRef = null;
            this.mapTerrainVersion = -1;
            this.mapContours = [];
            this.mapViewBox = "0 0 100 100";
            return;
        }
        const terrainVersion = terrain.getVersion();
        if (this.terrainRef === terrain && this.mapTerrainVersion === terrainVersion) return;
        this.terrainRef = terrain;
        this.mapTerrainVersion = terrainVersion;
        const contours = terrain.getContours();
        const coastlineContours = contours.filter((contour)=>contour.height === 0);
        const mapContours = [];
        let minX = Infinity;
        let minY = Infinity;
        let maxX = -Infinity;
        let maxY = -Infinity;
        for(let i = 0; i < coastlineContours.length; i++){
            const contour = coastlineContours[i];
            const sampled = this.simplifyContour(contour.sampledPolygon);
            if (sampled.length < 3) continue;
            for (const point of sampled){
                if (point.x < minX) minX = point.x;
                if (point.y < minY) minY = point.y;
                if (point.x > maxX) maxX = point.x;
                if (point.y > maxY) maxY = point.y;
            }
            mapContours.push({
                id: `${i}-${contour.height}`,
                points: sampled.map((point)=>`${point.x.toFixed(1)},${point.y.toFixed(1)}`).join(" ")
            });
        }
        this.mapContours = mapContours;
        if (!isFinite(minX) || !isFinite(minY) || !isFinite(maxX) || !isFinite(maxY)) {
            this.mapViewBox = "0 0 100 100";
            return;
        }
        const width = Math.max(maxX - minX, 1);
        const height = Math.max(maxY - minY, 1);
        const padding = Math.max(Math.max(width, height) * $a8d907c4d81bde2c$var$MAP_PADDING_RATIO, $a8d907c4d81bde2c$var$MIN_MAP_PADDING);
        this.mapViewBox = `${(minX - padding).toFixed(1)} ${(minY - padding).toFixed(1)} ${(width + padding * 2).toFixed(1)} ${(height + padding * 2).toFixed(1)}`;
    }
    simplifyContour(points) {
        if (points.length <= $a8d907c4d81bde2c$var$MAP_MAX_POINTS_PER_CONTOUR) return [
            ...points
        ];
        const stride = Math.ceil(points.length / $a8d907c4d81bde2c$var$MAP_MAX_POINTS_PER_CONTOUR);
        const result = [];
        for(let i = 0; i < points.length; i += stride)result.push(points[i]);
        return result;
    }
}
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $aa1f0309d9dba6d2$export$af631764ddc44097)("keyDown")
], $a8d907c4d81bde2c$export$a105e548efe5f62c.prototype, "onKeyDown", null);


function $0321ce98ded29204$export$9d683875612a4f9e(game, save) {
    const boat = game.entities.getById("boat");
    if (!boat) throw new Error("Cannot load save: no boat entity found");
    const boatState = save.boat;
    // Restore damage health values
    boat.hullDamage.setHealth(boatState.damage.hull);
    boat.rudderDamage.setHealth(boatState.damage.rudder);
    boat.mainSailDamage.setHealth(boatState.damage.sail);
    // Restore bilge water volume
    boat.bilge.waterVolume = boatState.bilgeWater;
    // Restore sailor state
    boat.sailor.restoreState(boatState.sailor.stationId, boatState.sailor.position);
}











// Dock dimensions in feet
const $62c7325363ad2df3$var$DOCK_LENGTH = 50; // ft — long enough for the largest boats
const $62c7325363ad2df3$var$DOCK_WIDTH = 5; // ft
// Bounding radius for view-frustum culling: half the deck's diagonal.
const $62c7325363ad2df3$var$CULL_RADIUS = Math.hypot($62c7325363ad2df3$var$DOCK_LENGTH, $62c7325363ad2df3$var$DOCK_WIDTH) / 2;
// Cleat positions along dock length from shore end (0 = shore, 1 = tip)
// Placed mid-gap between pilings (pilings sit at ratios 0.0, 0.2, 0.4, ...)
const $62c7325363ad2df3$var$BOW_CLEAT_RATIO = 0.7; // near the tip, centered between pilings
const $62c7325363ad2df3$var$STERN_CLEAT_RATIO = 0.3; // near shore, centered between pilings
// Piling / stringer / cleat dimensions
const $62c7325363ad2df3$var$PILING_RADIUS = 0.6; // ft
const $62c7325363ad2df3$var$PILING_SPACING = 10; // ft along the length
const $62c7325363ad2df3$var$PILING_OUTBOARD = 0.5; // ft outside the deck edge
const $62c7325363ad2df3$var$STRINGER_INSET = 0.4; // ft inboard from the deck edge
const $62c7325363ad2df3$var$STRINGER_WIDTH = 0.6; // ft
const $62c7325363ad2df3$var$DECK_BOARD_WIDTH = 0.75; // ft along length
const $62c7325363ad2df3$var$DECK_BOARD_GAP = 0.15; // ft gap between planks
const $62c7325363ad2df3$var$CLEAT_EDGE_INSET = 0.7; // ft from dock edge
const $62c7325363ad2df3$var$CLEAT_HORN_HALF = 0.45; // half-length of the horizontal horn
const $62c7325363ad2df3$var$CLEAT_POST_WIDTH = 0.25;
const $62c7325363ad2df3$var$CLEAT_HORN_WIDTH = 0.3;
// Z heights (waterline = 0)
const $62c7325363ad2df3$var$DECK_HEIGHT = 2.5;
const $62c7325363ad2df3$var$STRINGER_Z = $62c7325363ad2df3$var$DECK_HEIGHT - 0.5;
const $62c7325363ad2df3$var$PILING_Z = $62c7325363ad2df3$var$DECK_HEIGHT + 2;
const $62c7325363ad2df3$var$CLEAT_BASE_Z = $62c7325363ad2df3$var$DECK_HEIGHT + 0.05;
const $62c7325363ad2df3$var$CLEAT_HORN_Z = $62c7325363ad2df3$var$DECK_HEIGHT + 0.5;
// Colors
const $62c7325363ad2df3$var$DECK_BOARD_COLOR = 0x9a7420;
const $62c7325363ad2df3$var$PILING_COLOR = 0x4a3014; // darker wood than the deck
const $62c7325363ad2df3$var$CLEAT_COLOR = 0x2b2b2b;
class $62c7325363ad2df3$export$a2d375858cc72119 extends (0, $c59361981bac2575$export$4342ba5c6ad1f6f1) {
    constructor(data){
        super(), this.tags = [
            "port"
        ], this.layer = "boat";
        this.portData = data;
        // Compute local cleat positions along the dock's length axis
        // The dock extends in the local +x direction from shore
        // Center of dock is at DOCK_LENGTH/2 along x
        const halfLength = $62c7325363ad2df3$var$DOCK_LENGTH / 2;
        const cleatY = $62c7325363ad2df3$var$DOCK_WIDTH / 2 - $62c7325363ad2df3$var$CLEAT_EDGE_INSET;
        this.bowCleatLocal = (0, $6b6a54a072724620$export$e7c866399fa523f5)(-halfLength + $62c7325363ad2df3$var$DOCK_LENGTH * $62c7325363ad2df3$var$BOW_CLEAT_RATIO, cleatY);
        this.sternCleatLocal = (0, $6b6a54a072724620$export$e7c866399fa523f5)(-halfLength + $62c7325363ad2df3$var$DOCK_LENGTH * $62c7325363ad2df3$var$STERN_CLEAT_RATIO, cleatY);
        // Create static body for collision
        this.body = (0, $4aa863c0a97fa3b4$export$c9dd59e0dcee4be9)({
            motion: "static",
            position: [
                data.position.x,
                data.position.y
            ],
            angle: data.angle
        });
        this.body.addShape(new (0, $7cebb72687875576$export$e71c4d32a2263218)({
            width: $62c7325363ad2df3$var$DOCK_LENGTH,
            height: $62c7325363ad2df3$var$DOCK_WIDTH
        }));
    }
    getId() {
        return this.portData.id;
    }
    getName() {
        return this.portData.name;
    }
    getPosition() {
        return (0, $6b6a54a072724620$export$e7c866399fa523f5)(this.body.position);
    }
    getAngle() {
        return this.body.angle;
    }
    /** Get bow cleat position in world space */ getBowCleatWorld() {
        return this.body.toWorldFrame(this.bowCleatLocal);
    }
    /** Get stern cleat position in world space */ getSternCleatWorld() {
        return this.body.toWorldFrame(this.sternCleatLocal);
    }
    onRender({ draw: draw }) {
        const [x, y] = this.body.position;
        if (!draw.camera.isVisible(x, y, $62c7325363ad2df3$var$CULL_RADIUS)) return;
        const angle = this.body.angle;
        const halfW = $62c7325363ad2df3$var$DOCK_WIDTH / 2;
        const halfL = $62c7325363ad2df3$var$DOCK_LENGTH / 2;
        const tilt = (0, $0180785820f28c5a$export$be524feb371e374f)(angle, 0, 0);
        draw.at({
            pos: (0, $6b6a54a072724620$export$e7c866399fa523f5)(x, y),
            angle: angle,
            tilt: {
                roll: 0,
                pitch: 0
            }
        }, ()=>{
            const renderer = draw.renderer;
            const td = new (0, $aefe0d50abc5ab3a$export$dd1846c3fb304cae)(renderer, tilt);
            const quadIndices = [
                0,
                1,
                2,
                0,
                2,
                3
            ];
            const flatZ = (z)=>[
                    z,
                    z,
                    z,
                    z
                ];
            // --- 1. Pilings: flat disks above the deck --------------------------
            const numPilings = Math.round($62c7325363ad2df3$var$DOCK_LENGTH / $62c7325363ad2df3$var$PILING_SPACING) + 1;
            const pilingY = halfW + $62c7325363ad2df3$var$PILING_OUTBOARD;
            for(let i = 0; i < numPilings; i++){
                const px = -halfL + i * $62c7325363ad2df3$var$DOCK_LENGTH / (numPilings - 1);
                for (const py of [
                    -pilingY,
                    pilingY
                ])td.circle(px, py, $62c7325363ad2df3$var$PILING_Z, $62c7325363ad2df3$var$PILING_RADIUS, 16, $62c7325363ad2df3$var$PILING_COLOR);
            }
            // --- 2. Mooring cleats: pair on each side at bow and stern ---------
            const cleatInsetY = halfW - $62c7325363ad2df3$var$CLEAT_EDGE_INSET;
            for (const cx of [
                this.bowCleatLocal.x,
                this.sternCleatLocal.x
            ])for (const cy of [
                -cleatInsetY,
                cleatInsetY
            ]){
                for (const dx of [
                    -$62c7325363ad2df3$var$CLEAT_HORN_HALF,
                    $62c7325363ad2df3$var$CLEAT_HORN_HALF
                ])td.line(cx + dx, cy, $62c7325363ad2df3$var$CLEAT_BASE_Z, cx + dx, cy, $62c7325363ad2df3$var$CLEAT_HORN_Z, $62c7325363ad2df3$var$CLEAT_POST_WIDTH, $62c7325363ad2df3$var$CLEAT_COLOR, 1, true);
                td.line(cx - $62c7325363ad2df3$var$CLEAT_HORN_HALF, cy, $62c7325363ad2df3$var$CLEAT_HORN_Z, cx + $62c7325363ad2df3$var$CLEAT_HORN_HALF, cy, $62c7325363ad2df3$var$CLEAT_HORN_Z, $62c7325363ad2df3$var$CLEAT_HORN_WIDTH, $62c7325363ad2df3$var$CLEAT_COLOR, 1, true);
            }
            // --- 3. Deck boards: crosswise planks with gaps --------------------
            const boardPitch = $62c7325363ad2df3$var$DECK_BOARD_WIDTH + $62c7325363ad2df3$var$DECK_BOARD_GAP;
            const numBoards = Math.floor($62c7325363ad2df3$var$DOCK_LENGTH / boardPitch);
            const boardStartX = -halfL + ($62c7325363ad2df3$var$DOCK_LENGTH - numBoards * boardPitch) / 2;
            for(let i = 0; i < numBoards; i++){
                const x0 = boardStartX + i * boardPitch;
                const x1 = x0 + $62c7325363ad2df3$var$DECK_BOARD_WIDTH;
                renderer.submitTrianglesWithZ([
                    [
                        x0,
                        -halfW
                    ],
                    [
                        x1,
                        -halfW
                    ],
                    [
                        x1,
                        halfW
                    ],
                    [
                        x0,
                        halfW
                    ]
                ], quadIndices, $62c7325363ad2df3$var$DECK_BOARD_COLOR, 1, flatZ($62c7325363ad2df3$var$DECK_HEIGHT));
            }
            // --- 4. Stringers: long beams under the deck boards ----------------
            // Rendered last; depth test rejects them where deck boards already
            // wrote, so they only appear through the gaps between planks.
            const stringerYs = [
                -halfW + $62c7325363ad2df3$var$STRINGER_INSET,
                0,
                halfW - $62c7325363ad2df3$var$STRINGER_INSET
            ];
            for (const sy of stringerYs)renderer.submitTrianglesWithZ([
                [
                    -halfL,
                    sy - $62c7325363ad2df3$var$STRINGER_WIDTH / 2
                ],
                [
                    halfL,
                    sy - $62c7325363ad2df3$var$STRINGER_WIDTH / 2
                ],
                [
                    halfL,
                    sy + $62c7325363ad2df3$var$STRINGER_WIDTH / 2
                ],
                [
                    -halfL,
                    sy + $62c7325363ad2df3$var$STRINGER_WIDTH / 2
                ]
            ], quadIndices, $62c7325363ad2df3$var$PILING_COLOR, 1, flatZ($62c7325363ad2df3$var$STRINGER_Z));
        });
    }
}
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $aa1f0309d9dba6d2$export$af631764ddc44097)("render")
], $62c7325363ad2df3$export$a2d375858cc72119.prototype, "onRender", null);










class $f46554a8dcd678e4$export$8c6b7db3679299d7 extends (0, $7d9b0c3658290da5$export$690dd8da38397efd) {
    constructor(){
        super(()=>this.renderContent());
    }
    renderContent() {
        const timeOfDay = this.game.entities.getSingleton((0, $4df5c29ec7839388$export$1467403458327a44));
        const hour = timeOfDay.getHour();
        // Format time as HH:MM
        const hours = Math.floor(hour);
        const minutes = Math.floor((hour - hours) * 60);
        const timeString = `${hours.toString().padStart(2, "0")}:${minutes.toString().padStart(2, "0")}`;
        return /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("div", {
            style: {
                position: "fixed",
                bottom: "20px",
                right: "20px",
                color: "white",
                textShadow: "0 0 2px rgba(0, 0, 0, 0.6)",
                opacity: 0.5,
                fontFamily: "var(--font-body)",
                fontWeight: "300",
                fontSize: "16px",
                userSelect: "none",
                pointerEvents: "none"
            },
            children: timeString
        });
    }
}







/**
 * Simple fullscreen shader that composites the offscreen tree texture
 * into the main render pass using premultiplied alpha blending.
 */ 
const $31b5de629c92b647$var$treeCompositeModule = {
    bindings: {
        treeTexture: {
            type: "texture",
            viewDimension: "2d",
            sampleType: "float"
        }
    },
    code: /*wgsl*/ `
struct VertexOutput {
  @builtin(position) position: vec4<f32>,
}

@vertex
fn vs_main(@location(0) position: vec2<f32>) -> VertexOutput {
  var output: VertexOutput;
  output.position = vec4<f32>(position, 0.0, 1.0);
  return output;
}

@fragment
fn fs_main(@builtin(position) fragCoord: vec4<f32>) -> @location(0) vec4<f32> {
  return textureLoad(treeTexture, vec2<i32>(fragCoord.xy), 0);
}
`
};
const $31b5de629c92b647$var$treeCompositeConfig = {
    modules: [
        $31b5de629c92b647$var$treeCompositeModule
    ],
    // Tree texture contains premultiplied alpha from multi-layer blending,
    // so use one/one-minus-src-alpha (premultiplied blend mode).
    blendState: {
        color: {
            srcFactor: "one",
            dstFactor: "one-minus-src-alpha",
            operation: "add"
        },
        alpha: {
            srcFactor: "one",
            dstFactor: "one-minus-src-alpha",
            operation: "add"
        }
    },
    label: "TreeCompositeShader"
};
function $31b5de629c92b647$export$737789d16fe2204a() {
    return new (0, $c43b1a1e19bbbf4b$export$b176bfba5cd328c9)($31b5de629c92b647$var$treeCompositeConfig);
}


/**
 * GPU instanced tree renderer using polygon mesh geometry.
 *
 * Renders trees as triangle-fan polygons with depth buffering.
 * Each tree is a vec4(x, y, phase, 0) in a storage buffer.
 * Vertex shader generates N-gon geometry matching each whorl's bumpy
 * branch-tip shape. Depth buffer handles inter-tree layer interleaving.
 * Fragment shader just outputs interpolated vertex color (fully opaque).
 *
 * 6 layers per tree: whorls 0–4 (bottom to top) + leader tip.
 * Each layer is a triangle fan with edgeCount triangles.
 * Single draw call: draw(verticesPerTree, treeCount).
 *
 * Zoom-adaptive LOD varies edge count (all layers always rendered
 * to preserve color composition):
 *   < 0.3x:  6 edges →  108 verts/tree
 *   0.3–1x:  8 edges →  144 verts/tree
 *   1–3x:   16 edges →  288 verts/tree
 *   3–7x:   32 edges →  576 verts/tree
 *   7–14x:  48 edges →  864 verts/tree
 *   > 14x:  64 edges → 1152 verts/tree
 */ 


/**
 * Wind shader modules for velocity field computation.
 */ 
const $378400a833ed6cfa$export$16a15069b23b0c23 = {
    code: /*wgsl*/ `
    // Calculate wind velocity at a world position with noise variation
    // worldPos: position in world coordinates
    // time: game time for noise animation
    // baseWind: base wind velocity (before modulation)
    // influenceSpeedFactor: terrain-induced speed multiplier (1.0 = no change)
    // influenceDirectionOffset: terrain-induced direction change (radians)
    // influenceTurbulence: terrain-induced turbulence boost (0-1+)
    // noiseSpatialScale: spatial frequency of noise
    // noiseTimeScale: temporal frequency of noise
    // speedVariation: amplitude of speed variation (0-1)
    // angleVariation: amplitude of angle variation (radians)
    fn calculateWindVelocity(
      worldPos: vec2<f32>,
      time: f32,
      baseWind: vec2<f32>,
      influenceSpeedFactor: f32,
      influenceDirectionOffset: f32,
      influenceTurbulence: f32,
      noiseSpatialScale: f32,
      noiseTimeScale: f32,
      speedVariation: f32,
      angleVariation: f32,
      flowCyclePeriod: f32,
      slowTimeScale: f32
    ) -> vec2<f32> {
      // Compute local flow velocity from terrain-modified wind
      let localFlow = baseWind * influenceSpeedFactor;
      let cosDir = cos(influenceDirectionOffset);
      let sinDir = sin(influenceDirectionOffset);
      let flow = vec2<f32>(
        localFlow.x * cosDir - localFlow.y * sinDir,
        localFlow.x * sinDir + localFlow.y * cosDir
      );

      // Dual-layer flow-map: two time phases offset by half a cycle
      let t0 = fract(time / flowCyclePeriod);
      let t1 = fract(time / flowCyclePeriod + 0.5);
      let blend = abs(2.0 * t0 - 1.0);

      // Slow time for organic z-axis evolution
      let slowTime = time * slowTimeScale;

      // Flow-advected UVs for speed noise
      let uv0_speed = (worldPos - flow * t0 * flowCyclePeriod) * noiseSpatialScale;
      let uv1_speed = (worldPos - flow * t1 * flowCyclePeriod) * noiseSpatialScale;
      let speedNoise = mix(
        simplex3D(vec3<f32>(uv0_speed, slowTime)),
        simplex3D(vec3<f32>(uv1_speed, slowTime)),
        blend
      );

      // Flow-advected UVs for angle noise (offset for independent variation)
      let uv0_angle = uv0_speed + vec2<f32>(1000.0, 1000.0);
      let uv1_angle = uv1_speed + vec2<f32>(1000.0, 1000.0);
      let angleNoise = mix(
        simplex3D(vec3<f32>(uv0_angle, slowTime)),
        simplex3D(vec3<f32>(uv1_angle, slowTime)),
        blend
      );

      // Apply terrain influence to speed variation (turbulence boosts noise)
      let turbulenceBoost = 1.0 + influenceTurbulence * 0.5;
      var speedScale = 1.0 + speedNoise * speedVariation * turbulenceBoost;
      speedScale *= influenceSpeedFactor; // Apply terrain blocking/acceleration

      // Apply influence direction offset + noise angle
      let totalAngleOffset = angleNoise * angleVariation + influenceDirectionOffset;

      // Apply speed scale to base wind
      let scaledX = baseWind.x * speedScale;
      let scaledY = baseWind.y * speedScale;

      // Rotate by total angle offset
      let cosAngle = cos(totalAngleOffset);
      let sinAngle = sin(totalAngleOffset);
      let velocityX = scaledX * cosAngle - scaledY * sinAngle;
      let velocityY = scaledX * sinAngle + scaledY * cosAngle;

      return vec2<f32>(velocityX, velocityY);
    }
  `,
    dependencies: [
        (0, $29eb555f6f6dd288$export$d30c1ef1b1de4c71)
    ]
};
const $378400a833ed6cfa$export$faaefa413143978 = {
    code: /*wgsl*/ `
    // Wind query result structure
    struct WindResult {
      velocity: vec2<f32>,
      speed: f32,
      direction: f32,
    }
  `,
    dependencies: []
};
const $378400a833ed6cfa$export$54db7b3c706613a8 = {
    code: /*wgsl*/ `
    // Compute wind state at a world position
    // Returns velocity, speed, and direction
    fn computeWindAtPoint(
      worldPos: vec2<f32>,
      time: f32,
      baseWind: vec2<f32>,
      influenceSpeedFactor: f32,
      influenceDirectionOffset: f32,
      influenceTurbulence: f32,
      noiseSpatialScale: f32,
      noiseTimeScale: f32,
      speedVariation: f32,
      angleVariation: f32,
      flowCyclePeriod: f32,
      slowTimeScale: f32
    ) -> WindResult {
      // Calculate velocity using wind module
      let velocity = calculateWindVelocity(
        worldPos,
        time,
        baseWind,
        influenceSpeedFactor,
        influenceDirectionOffset,
        influenceTurbulence,
        noiseSpatialScale,
        noiseTimeScale,
        speedVariation,
        angleVariation,
        flowCyclePeriod,
        slowTimeScale
      );

      // Compute speed and direction from velocity
      let speed = length(velocity);
      let direction = atan2(velocity.y, velocity.x);

      var result: WindResult;
      result.velocity = velocity;
      result.speed = speed;
      result.direction = direction;
      return result;
    }
  `,
    dependencies: [
        $378400a833ed6cfa$export$faaefa413143978,
        $378400a833ed6cfa$export$16a15069b23b0c23
    ]
};



// Quad half-extent in world feet. Must be large enough for the biggest tree
// (outer whorl ~0.64 UV * sizeVar 1.35 + bumps ≈ 0.95 UV → 0.95 * 18 = 17.1 ft).
const $5af5129bb876cb05$var$QUAD_HALF = 18;
// Offscreen texture format for tree rendering
const $5af5129bb876cb05$var$OFFSCREEN_FORMAT = "rgba8unorm";
// Depth texture format
const $5af5129bb876cb05$var$DEPTH_FORMAT = "depth24plus";
// Always render all 6 layers (5 whorls + leader) — dropping layers causes
// visible color shifts across the whole screen. Only vary edge count.
const $5af5129bb876cb05$var$NUM_LAYERS = 6;
// Edge counts by zoom level
const $5af5129bb876cb05$var$EDGE_COUNTS = [
    6,
    8,
    16,
    32,
    48,
    64
];
const $5af5129bb876cb05$var$TreeUniforms = (0, $ca6793d1abd58997$export$99bb2281c7368d10)("TreeParams", {
    cameraA: (0, $ca6793d1abd58997$export$e33361ff41014190),
    cameraB: (0, $ca6793d1abd58997$export$e33361ff41014190),
    cameraC: (0, $ca6793d1abd58997$export$e33361ff41014190),
    cameraD: (0, $ca6793d1abd58997$export$e33361ff41014190),
    cameraTx: (0, $ca6793d1abd58997$export$e33361ff41014190),
    cameraTy: (0, $ca6793d1abd58997$export$e33361ff41014190),
    screenWidth: (0, $ca6793d1abd58997$export$e33361ff41014190),
    screenHeight: (0, $ca6793d1abd58997$export$e33361ff41014190),
    time: (0, $ca6793d1abd58997$export$e33361ff41014190),
    baseWindX: (0, $ca6793d1abd58997$export$e33361ff41014190),
    baseWindY: (0, $ca6793d1abd58997$export$e33361ff41014190),
    noiseSpatialScale: (0, $ca6793d1abd58997$export$e33361ff41014190),
    noiseTimeScale: (0, $ca6793d1abd58997$export$e33361ff41014190),
    speedVariation: (0, $ca6793d1abd58997$export$e33361ff41014190),
    angleVariation: (0, $ca6793d1abd58997$export$e33361ff41014190),
    flowCyclePeriod: (0, $ca6793d1abd58997$export$e33361ff41014190),
    slowTimeScale: (0, $ca6793d1abd58997$export$e33361ff41014190),
    timeOfDay: (0, $ca6793d1abd58997$export$e33361ff41014190),
    treeCount: (0, $ca6793d1abd58997$export$e33361ff41014190),
    sunDirX: (0, $ca6793d1abd58997$export$e33361ff41014190),
    sunDirY: (0, $ca6793d1abd58997$export$e33361ff41014190),
    edgeVertexCount: (0, $ca6793d1abd58997$export$e33361ff41014190),
    // Global scene illumination (sun + sky) pushed per-frame from TimeOfDay.
    // Stored as three f32 fields to match the surrounding flat-struct style.
    ambientLightR: (0, $ca6793d1abd58997$export$e33361ff41014190),
    ambientLightG: (0, $ca6793d1abd58997$export$e33361ff41014190),
    ambientLightB: (0, $ca6793d1abd58997$export$e33361ff41014190)
});
// Inline the simplex3D and calculateWindVelocity WGSL code
const $5af5129bb876cb05$var$SIMPLEX_CODE = (0, $29eb555f6f6dd288$export$d30c1ef1b1de4c71).code;
const $5af5129bb876cb05$var$WIND_CODE = (0, $378400a833ed6cfa$export$16a15069b23b0c23).code;
const $5af5129bb876cb05$var$SHADER_CODE = /*wgsl*/ `
struct TreeParams {
  cameraA: f32,
  cameraB: f32,
  cameraC: f32,
  cameraD: f32,
  cameraTx: f32,
  cameraTy: f32,
  screenWidth: f32,
  screenHeight: f32,
  time: f32,
  baseWindX: f32,
  baseWindY: f32,
  noiseSpatialScale: f32,
  noiseTimeScale: f32,
  speedVariation: f32,
  angleVariation: f32,
  flowCyclePeriod: f32,
  slowTimeScale: f32,
  timeOfDay: f32,
  treeCount: f32,
  sunDirX: f32,
  sunDirY: f32,
  edgeVertexCount: f32,
  ambientLightR: f32,
  ambientLightG: f32,
  ambientLightB: f32,
}

@group(0) @binding(0) var<uniform> params: TreeParams;
@group(0) @binding(1) var<storage, read> trees: array<vec4<f32>>;

struct VertexOutput {
  @builtin(position) position: vec4<f32>,
  @location(0) color: vec3<f32>,
}

const QUAD_HALF: f32 = ${$5af5129bb876cb05$var$QUAD_HALF}.0;
const SWAY_SCALE: f32 = 0.4;
const TWO_PI: f32 = 6.283185307;

// Bright leader tip at top of tree
const LEADER_COLOR: vec3<f32> = vec3<f32>(0.20, 0.36, 0.14);

// Simplex noise (used by wind velocity calculation in vertex shader)
${$5af5129bb876cb05$var$SIMPLEX_CODE}

// Wind velocity (used in vertex shader for per-tree wind)
${$5af5129bb876cb05$var$WIND_CODE}

// Compute the edge radius for a whorl at a given angle
fn whorlEdgeRadius(angle: f32, radius: f32, branches: f32, angularOffset: f32, bumpMag: f32, phase: f32, fi: f32) -> f32 {
  // Primary branch tips
  let branchAngle = angle * branches + angularOffset;
  let tipCos = 0.5 + 0.5 * cos(branchAngle);
  let tipShape = tipCos * tipCos;

  // Secondary sub-bumps
  let subAngle = angle * (branches * 2.0 + 1.0) + phase * 3.7 + fi * 1.9;
  let subCos = 0.5 + 0.5 * cos(subAngle);
  let subBump = subCos * subCos * subCos * 0.25;

  // Per-branch magnitude variation
  let branchVar = 0.7 + 0.3 * sin(angle * 3.17 + phase * 13.0 + fi * 5.3);

  // Single-frequency edge noise
  let edgeNoise = sin(angle * 13.7 + phase * 5.1) * 0.025;

  return radius + (tipShape * branchVar + subBump) * bumpMag + edgeNoise;
}

@vertex
fn vs_main(
  @builtin(vertex_index) vertexIndex: u32,
  @builtin(instance_index) instanceIndex: u32,
) -> VertexOutput {
  let edgeCount = u32(params.edgeVertexCount);
  let verticesPerFan = edgeCount * 3u;

  // Decode layer and triangle from vertex index
  // Layers 0-4 = whorls (bottom to top), layer 5 = leader
  let layer = vertexIndex / verticesPerFan;
  let fanVertex = vertexIndex % verticesPerFan;
  let triangleIndex = fanVertex / 3u;
  let cornerInTriangle = fanVertex % 3u;

  let isLeader = layer == 5u;

  let tree = trees[instanceIndex];
  let treeX = tree.x;
  let treeY = tree.y;
  let phase = tree.z;

  // Per-tree size variation
  let sizeVar = 0.65 + fract(phase * 3.17) * 0.70;

  // Compute wind at tree position
  let windVel = calculateWindVelocity(
    vec2<f32>(treeX, treeY),
    params.time,
    vec2<f32>(params.baseWindX, params.baseWindY),
    1.0, 0.0, 0.0,
    params.noiseSpatialScale,
    params.noiseTimeScale,
    params.speedVariation,
    params.angleVariation,
    params.flowCyclePeriod,
    params.slowTimeScale
  );

  let windSpeed = length(windVel);
  let swayAmount = windSpeed * SWAY_SCALE;
  let invSpeed = select(0.0, 1.0 / windSpeed, windSpeed > 0.01);
  let windDir = windVel * invSpeed;

  // Per-layer sway offset in UV space
  let treePos = vec2<f32>(treeX, treeY);
  var swayOffset = vec2<f32>(0.0, 0.0);
  if (isLeader) {
    swayOffset = windDir * swayAmount * 1.1 * sizeVar / QUAD_HALF;
  } else {
    let fi = f32(layer);
    let height = fi / 4.0;
    let osc = sin(params.time * 1.8 + phase + fi * 0.5) * 0.03;
    swayOffset = windDir * swayAmount * height * sizeVar * (1.0 + osc) / QUAD_HALF;
  }

  // Whorl center in world space
  let centerWorld = treePos + swayOffset * QUAD_HALF;

  // Compute vertex position and color
  var worldPos: vec2<f32>;
  var vertColor: vec3<f32>;

  if (isLeader) {
    // --- Leader tip: small circle ---
    let leaderRadius: f32 = 0.045;
    if (cornerInTriangle == 0u) {
      worldPos = centerWorld;
    } else {
      let edgeIdx = select(triangleIndex, triangleIndex + 1u, cornerInTriangle == 2u);
      let angle = f32(edgeIdx) * TWO_PI / f32(edgeCount);
      worldPos = centerWorld + vec2<f32>(cos(angle), sin(angle)) * leaderRadius * QUAD_HALF;
    }
    vertColor = LEADER_COLOR;
  } else {
    // --- Whorl: bumpy polygon with AO gradient ---
    let fi = f32(layer);
    let height = fi / 4.0;
    let whorlRadius = (0.64 - fi * 0.10) * sizeVar;
    let branches = 5.0 + fract(phase * 1.37 + fi * 0.23) * 3.0;
    let angularOffset = fi * 0.9 + phase;
    let bumpMag = (0.08 + 0.02 * sin(fi * 2.3 + phase)) * sizeVar;

    // Whorl base color
    let lum = 0.16 + height * 0.12;
    let hueShift = fract(phase * 2.71);
    let coolGreen = vec3<f32>(lum * 0.40, lum, lum * 0.45);
    let warmGreen = vec3<f32>(lum * 0.55, lum, lum * 0.25);
    let whorlBaseColor = mix(coolGreen, warmGreen, hueShift);

    if (cornerInTriangle == 0u) {
      // Center vertex: dark (AO effect)
      worldPos = centerWorld;
      vertColor = whorlBaseColor * 0.65;
    } else {
      // Edge vertex: full color with sun-side lighting
      let edgeIdx = select(triangleIndex, triangleIndex + 1u, cornerInTriangle == 2u);
      let angle = f32(edgeIdx) * TWO_PI / f32(edgeCount);
      let edgeR = whorlEdgeRadius(angle, whorlRadius, branches, angularOffset, bumpMag, phase, fi);
      worldPos = centerWorld + vec2<f32>(cos(angle), sin(angle)) * edgeR * QUAD_HALF;

      // Sun-side lighting
      let radialDir = vec2<f32>(cos(angle), sin(angle));
      let sunDir2 = vec2<f32>(params.sunDirX, params.sunDirY);
      let sunDot = dot(radialDir, sunDir2);
      vertColor = whorlBaseColor * (0.85 + 0.15 * sunDot);
    }
  }

  // World \u{2192} screen via camera matrix (2x3 affine)
  let screenX = params.cameraA * worldPos.x + params.cameraC * worldPos.y + params.cameraTx;
  let screenY = params.cameraB * worldPos.x + params.cameraD * worldPos.y + params.cameraTy;

  // Screen \u{2192} NDC
  let ndcX = 2.0 * screenX / params.screenWidth - 1.0;
  let ndcY = 2.0 * screenY / params.screenHeight - 1.0;

  // Depth: layer 0 = 0.9 (farthest), layer 5 (leader) = 0.4 (nearest)
  let z = 0.9 - f32(layer) * 0.1;

  var out: VertexOutput;
  out.position = vec4<f32>(ndcX, ndcY, z, 1.0);
  out.color = vertColor;
  return out;
}

@fragment
fn fs_main(in: VertexOutput) -> @location(0) vec4<f32> {
  let ambientLight = vec3<f32>(params.ambientLightR, params.ambientLightG, params.ambientLightB);
  return vec4<f32>(in.color * ambientLight, 1.0);
}
`;
/**
 * Compute edge count from camera zoom.
 */ function $5af5129bb876cb05$var$getEdgeCount(zoom) {
    if (zoom < 0.3) return $5af5129bb876cb05$var$EDGE_COUNTS[0]; // 6
    if (zoom < 1) return $5af5129bb876cb05$var$EDGE_COUNTS[1]; // 8
    if (zoom < 3) return $5af5129bb876cb05$var$EDGE_COUNTS[2]; // 16
    if (zoom < 7) return $5af5129bb876cb05$var$EDGE_COUNTS[3]; // 32
    if (zoom < 14) return $5af5129bb876cb05$var$EDGE_COUNTS[4]; // 48
    return $5af5129bb876cb05$var$EDGE_COUNTS[5]; // 64
}
class $5af5129bb876cb05$export$9e7420113d2eb407 {
    constructor(device){
        this.pipeline = null;
        this.uniformBuffer = null;
        this.uniforms = $5af5129bb876cb05$var$TreeUniforms.create();
        this.bindGroupLayout = null;
        this.bindGroup = null;
        this.treeBuffer = null;
        this.treeBufferCapacity = 0;
        this.initialized = false;
        // Offscreen texture for rendering trees to a separate render pass
        this.offscreenTexture = null;
        this.offscreenTextureView = null;
        this.depthTexture = null;
        this.depthTextureView = null;
        this.offscreenWidth = 0;
        this.offscreenHeight = 0;
        this.device = device;
    }
    async init() {
        if (this.initialized) return;
        const device = this.device;
        const gpu = (0, $558c2f47f1fdd57f$export$297162150ea0f6af)();
        const shaderModule = await gpu.createShaderModuleChecked($5af5129bb876cb05$var$SHADER_CODE, "Tree Rasterizer Shader");
        this.bindGroupLayout = device.createBindGroupLayout({
            entries: [
                {
                    binding: 0,
                    visibility: GPUShaderStage.VERTEX | GPUShaderStage.FRAGMENT,
                    buffer: {
                        type: "uniform"
                    }
                },
                {
                    binding: 1,
                    visibility: GPUShaderStage.VERTEX,
                    buffer: {
                        type: "read-only-storage"
                    }
                }
            ],
            label: "Tree Rasterizer Bind Group Layout"
        });
        const pipelineLayout = device.createPipelineLayout({
            bindGroupLayouts: [
                this.bindGroupLayout
            ],
            label: "Tree Rasterizer Pipeline Layout"
        });
        this.pipeline = device.createRenderPipeline({
            layout: pipelineLayout,
            vertex: {
                module: shaderModule,
                entryPoint: "vs_main"
            },
            fragment: {
                module: shaderModule,
                entryPoint: "fs_main",
                targets: [
                    {
                        format: $5af5129bb876cb05$var$OFFSCREEN_FORMAT
                    }
                ]
            },
            primitive: {
                topology: "triangle-list"
            },
            depthStencil: {
                format: $5af5129bb876cb05$var$DEPTH_FORMAT,
                depthCompare: "less-equal",
                depthWriteEnabled: true
            },
            label: "Tree Rasterizer Pipeline"
        });
        this.uniformBuffer = device.createBuffer({
            size: $5af5129bb876cb05$var$TreeUniforms.byteSize,
            usage: GPUBufferUsage.UNIFORM | GPUBufferUsage.COPY_DST,
            label: "Tree Rasterizer Uniforms"
        });
        // Start with a small tree buffer, will grow as needed
        this.treeBufferCapacity = 256;
        this.treeBuffer = device.createBuffer({
            size: this.treeBufferCapacity * 16,
            usage: GPUBufferUsage.STORAGE | GPUBufferUsage.COPY_DST,
            label: "Tree Instance Buffer"
        });
        this.rebuildBindGroup();
        this.initialized = true;
    }
    rebuildBindGroup() {
        if (!this.bindGroupLayout || !this.uniformBuffer || !this.treeBuffer) return;
        this.bindGroup = this.device.createBindGroup({
            layout: this.bindGroupLayout,
            entries: [
                {
                    binding: 0,
                    resource: {
                        buffer: this.uniformBuffer
                    }
                },
                {
                    binding: 1,
                    resource: {
                        buffer: this.treeBuffer
                    }
                }
            ],
            label: "Tree Rasterizer Bind Group"
        });
    }
    /**
   * Upload visible tree data to the GPU storage buffer.
   * Data is a Float32Array with stride 4: [x, y, phase, 0] per tree.
   */ updateTreeBuffer(data, count) {
        if (!this.initialized) return;
        // Grow buffer if needed
        if (count > this.treeBufferCapacity) {
            this.treeBuffer?.destroy();
            this.treeBufferCapacity = Math.max(count, this.treeBufferCapacity * 2);
            this.treeBuffer = this.device.createBuffer({
                size: this.treeBufferCapacity * 16,
                usage: GPUBufferUsage.STORAGE | GPUBufferUsage.COPY_DST,
                label: "Tree Instance Buffer"
            });
            this.rebuildBindGroup();
        }
        if (count > 0) {
            const byteLength = count * 16;
            this.device.queue.writeBuffer(this.treeBuffer, 0, data.buffer, data.byteOffset, byteLength);
        }
    }
    /**
   * Render trees into the current render pass.
   */ render(renderPass, treeCount, cameraA, cameraB, cameraC, cameraD, cameraTx, cameraTy, screenWidth, screenHeight, time, baseWindX, baseWindY, timeOfDay, zoom, ambientLight) {
        if (!this.initialized || !this.pipeline || !this.uniformBuffer || !this.bindGroup || treeCount === 0) return;
        const edgeCount = $5af5129bb876cb05$var$getEdgeCount(zoom);
        const verticesPerTree = edgeCount * 3 * $5af5129bb876cb05$var$NUM_LAYERS;
        // Update uniforms
        this.uniforms.set.cameraA(cameraA);
        this.uniforms.set.cameraB(cameraB);
        this.uniforms.set.cameraC(cameraC);
        this.uniforms.set.cameraD(cameraD);
        this.uniforms.set.cameraTx(cameraTx);
        this.uniforms.set.cameraTy(cameraTy);
        this.uniforms.set.screenWidth(screenWidth);
        this.uniforms.set.screenHeight(screenHeight);
        this.uniforms.set.time(time);
        this.uniforms.set.baseWindX(baseWindX);
        this.uniforms.set.baseWindY(baseWindY);
        this.uniforms.set.noiseSpatialScale((0, $8ecd9f2b11cf50d1$export$dd7d443fcf6b50ed));
        this.uniforms.set.noiseTimeScale((0, $8ecd9f2b11cf50d1$export$396c615eb4edc32));
        this.uniforms.set.speedVariation((0, $8ecd9f2b11cf50d1$export$954c8e2afd7a19b5));
        this.uniforms.set.angleVariation((0, $8ecd9f2b11cf50d1$export$17519356ae9cf5d5));
        this.uniforms.set.flowCyclePeriod((0, $8ecd9f2b11cf50d1$export$7417d004087d724a));
        this.uniforms.set.slowTimeScale((0, $8ecd9f2b11cf50d1$export$36b566ff16e06fa5));
        this.uniforms.set.timeOfDay(timeOfDay);
        this.uniforms.set.treeCount(treeCount);
        this.uniforms.set.edgeVertexCount(edgeCount);
        this.uniforms.set.ambientLightR(ambientLight[0]);
        this.uniforms.set.ambientLightG(ambientLight[1]);
        this.uniforms.set.ambientLightB(ambientLight[2]);
        // Precompute sun direction on CPU (saves 5 trig ops per fragment)
        const hour = timeOfDay / 3600;
        const sunPhase = (hour - 6) * Math.PI / 12;
        const elevation = Math.sin(sunPhase);
        const sunElevation = Math.max(elevation, 0);
        const azimuth = (hour - 12) * Math.PI / 6;
        const sx = Math.cos(azimuth) * 0.3 + 0.3;
        const sy = Math.sin(azimuth) * 0.2 + 0.2;
        const sz = sunElevation * 0.9 + 0.1;
        const sunLen2d = Math.sqrt(sx * sx + sy * sy);
        this.uniforms.set.sunDirX(sunLen2d > 0 ? sx / sunLen2d : 1);
        this.uniforms.set.sunDirY(sunLen2d > 0 ? sy / sunLen2d : 0);
        this.uniforms.uploadTo(this.uniformBuffer);
        renderPass.setPipeline(this.pipeline);
        renderPass.setBindGroup(0, this.bindGroup);
        // Single draw call: all layers encoded in vertexIndex
        renderPass.draw(verticesPerTree, treeCount);
    }
    /**
   * Ensure offscreen texture and depth texture match the screen dimensions.
   */ ensureOffscreenTexture(width, height) {
        if (this.offscreenWidth === width && this.offscreenHeight === height) return;
        this.offscreenTexture?.destroy();
        this.offscreenTexture = this.device.createTexture({
            size: {
                width: width,
                height: height
            },
            format: $5af5129bb876cb05$var$OFFSCREEN_FORMAT,
            usage: GPUTextureUsage.RENDER_ATTACHMENT | GPUTextureUsage.TEXTURE_BINDING,
            label: "Tree Offscreen Texture"
        });
        this.offscreenTextureView = this.offscreenTexture.createView();
        this.depthTexture?.destroy();
        this.depthTexture = this.device.createTexture({
            size: {
                width: width,
                height: height
            },
            format: $5af5129bb876cb05$var$DEPTH_FORMAT,
            usage: GPUTextureUsage.RENDER_ATTACHMENT,
            label: "Tree Depth Texture"
        });
        this.depthTextureView = this.depthTexture.createView();
        this.offscreenWidth = width;
        this.offscreenHeight = height;
    }
    /**
   * Get the offscreen texture view for compositing.
   */ getTextureView() {
        return this.offscreenTextureView;
    }
    /**
   * Render trees to the offscreen texture using a separate command encoder.
   * This avoids interrupting the main render pass, which is expensive on
   * tile-based GPUs. The texture can then be composited into the main pass.
   */ renderToTexture(treeCount, cameraA, cameraB, cameraC, cameraD, cameraTx, cameraTy, screenWidth, screenHeight, textureWidth, textureHeight, time, baseWindX, baseWindY, timeOfDay, zoom, ambientLight, gpuProfiler) {
        if (!this.initialized || treeCount === 0) return;
        this.ensureOffscreenTexture(textureWidth, textureHeight);
        const encoder = this.device.createCommandEncoder({
            label: "Tree Render"
        });
        const renderPass = encoder.beginRenderPass({
            colorAttachments: [
                {
                    view: this.offscreenTextureView,
                    loadOp: "clear",
                    storeOp: "store",
                    clearValue: {
                        r: 0,
                        g: 0,
                        b: 0,
                        a: 0
                    }
                }
            ],
            depthStencilAttachment: {
                view: this.depthTextureView,
                depthLoadOp: "clear",
                depthStoreOp: "store",
                depthClearValue: 1.0
            },
            timestampWrites: gpuProfiler?.getTimestampWrites("trees"),
            label: "Trees Render Pass"
        });
        this.render(renderPass, treeCount, cameraA, cameraB, cameraC, cameraD, cameraTx, cameraTy, screenWidth, screenHeight, time, baseWindX, baseWindY, timeOfDay, zoom, ambientLight);
        renderPass.end();
        this.device.queue.submit([
            encoder.finish()
        ]);
    }
    destroy() {
        this.uniformBuffer?.destroy();
        this.treeBuffer?.destroy();
        this.offscreenTexture?.destroy();
        this.depthTexture?.destroy();
        this.uniformBuffer = null;
        this.treeBuffer = null;
        this.offscreenTexture = null;
        this.offscreenTextureView = null;
        this.depthTexture = null;
        this.depthTextureView = null;
        this.pipeline = null;
        this.bindGroup = null;
        this.bindGroupLayout = null;
        this.initialized = false;
    }
}


// Spatial tile size in world feet
const $8003b38afc871c38$var$TILE_SIZE = 500;
// Tree dimensions (used for visibility culling — must cover largest trees)
const $8003b38afc871c38$var$OUTER_RADIUS = 16;
function $8003b38afc871c38$var$tileKey(col, row) {
    return col + 0x8000 << 16 | row + 0x8000 & 0xffff;
}
/**
 * Deterministic phase offset from tree position.
 */ function $8003b38afc871c38$var$phaseFromPosition(x, y) {
    const ix = x * 73856093 | 0;
    const iy = y * 19349663 | 0;
    const h = ((ix ^ iy) & 0x7fffffff) % 10000;
    return h / 10000 * Math.PI * 2;
}
class $8003b38afc871c38$export$76eea51e6331f99a extends (0, $c59361981bac2575$export$4342ba5c6ad1f6f1) {
    constructor(data){
        super(), this.layer = "trees", // GPU rendering
        this.rasterizer = null, this.compositeShader = null, this.compositeBindGroup = null, this.lastTextureView = null;
        const { positions: positions } = data;
        const n = positions.length;
        // Bucket positions by tile key
        const buckets = new Map();
        for(let i = 0; i < n; i++){
            const [x, y] = positions[i];
            const col = Math.floor(x / $8003b38afc871c38$var$TILE_SIZE);
            const row = Math.floor(y / $8003b38afc871c38$var$TILE_SIZE);
            const key = $8003b38afc871c38$var$tileKey(col, row);
            let bucket = buckets.get(key);
            if (!bucket) {
                bucket = [];
                buckets.set(key, bucket);
            }
            bucket.push({
                x: x,
                y: y,
                phase: $8003b38afc871c38$var$phaseFromPosition(x, y)
            });
        }
        // Flatten into contiguous Float32Array sorted by tile
        this.treeData = new Float32Array(n * 3);
        this.tiles = new Map();
        let offset = 0;
        for (const [key, bucket] of buckets){
            const startIndex = offset;
            for (const { x: x, y: y, phase: phase } of bucket){
                this.treeData[offset * 3] = x;
                this.treeData[offset * 3 + 1] = y;
                this.treeData[offset * 3 + 2] = phase;
                offset++;
            }
            const col = (key >> 16 & 0xffff) - 0x8000;
            const row = (key & 0xffff) - 0x8000;
            this.tiles.set(key, {
                startIndex: startIndex,
                count: bucket.length,
                centerX: (col + 0.5) * $8003b38afc871c38$var$TILE_SIZE,
                centerY: (row + 0.5) * $8003b38afc871c38$var$TILE_SIZE
            });
        }
        // Pre-allocate GPU staging buffer
        this.gpuTreeCapacity = Math.max(n, 256);
        this.gpuTreeData = new Float32Array(this.gpuTreeCapacity * 4);
    }
    async onAdd() {
        const device = this.game.getWebGPUDevice();
        this.rasterizer = new (0, $5af5129bb876cb05$export$9e7420113d2eb407)(device);
        await this.rasterizer.init();
        this.compositeShader = (0, $31b5de629c92b647$export$737789d16fe2204a)();
        await this.compositeShader.init();
    }
    onDestroy() {
        this.rasterizer?.destroy();
        this.rasterizer = null;
        this.compositeShader?.destroy();
        this.compositeShader = null;
        this.compositeBindGroup = null;
        this.lastTextureView = null;
    }
    onRender({ draw: draw, camera: camera }) {
        if (!this.rasterizer || !this.compositeShader) return;
        const viewport = camera.getWorldViewport();
        const minCol = Math.floor((viewport.left - $8003b38afc871c38$var$OUTER_RADIUS) / $8003b38afc871c38$var$TILE_SIZE);
        const maxCol = Math.floor((viewport.right + $8003b38afc871c38$var$OUTER_RADIUS) / $8003b38afc871c38$var$TILE_SIZE);
        const minRow = Math.floor((viewport.top - $8003b38afc871c38$var$OUTER_RADIUS) / $8003b38afc871c38$var$TILE_SIZE);
        const maxRow = Math.floor((viewport.bottom + $8003b38afc871c38$var$OUTER_RADIUS) / $8003b38afc871c38$var$TILE_SIZE);
        // Collect visible trees into GPU staging buffer
        let visibleCount = 0;
        const data = this.treeData;
        for(let col = minCol; col <= maxCol; col++)for(let row = minRow; row <= maxRow; row++){
            const key = $8003b38afc871c38$var$tileKey(col, row);
            const tile = this.tiles.get(key);
            if (!tile) continue;
            const end = tile.startIndex + tile.count;
            for(let i = tile.startIndex; i < end; i++){
                const fi = i * 3;
                const x = data[fi];
                const y = data[fi + 1];
                // Per-tree visibility check
                if (x + $8003b38afc871c38$var$OUTER_RADIUS < viewport.left || x - $8003b38afc871c38$var$OUTER_RADIUS > viewport.right || y + $8003b38afc871c38$var$OUTER_RADIUS < viewport.top || y - $8003b38afc871c38$var$OUTER_RADIUS > viewport.bottom) continue;
                // Grow staging buffer if needed
                if (visibleCount >= this.gpuTreeCapacity) {
                    this.gpuTreeCapacity *= 2;
                    const newData = new Float32Array(this.gpuTreeCapacity * 4);
                    newData.set(this.gpuTreeData);
                    this.gpuTreeData = newData;
                }
                const gi = visibleCount * 4;
                this.gpuTreeData[gi] = x;
                this.gpuTreeData[gi + 1] = y;
                this.gpuTreeData[gi + 2] = data[fi + 2]; // phase
                this.gpuTreeData[gi + 3] = 0;
                visibleCount++;
            }
        }
        if (visibleCount === 0) return;
        // Upload visible tree data to GPU
        this.rasterizer.updateTreeBuffer(this.gpuTreeData, visibleCount);
        const renderer = draw.renderer;
        const gpuProfiler = renderer.getGpuProfiler();
        const camMatrix = camera.getMatrix();
        // Use logical (CSS) pixels for camera transform — matches camera.getMatrix()
        const screenWidth = renderer.getWidth();
        const screenHeight = renderer.getHeight();
        // Use physical pixels for the offscreen texture — matches the main render target
        const physicalWidth = renderer.canvas.width;
        const physicalHeight = renderer.canvas.height;
        const windResources = this.game.entities.tryGetSingleton((0, $cd5b26e926c7fea1$export$c6b583ea58097b81));
        const baseWindX = windResources ? windResources.getBaseVelocity().x : 11;
        const baseWindY = windResources ? windResources.getBaseVelocity().y : 11;
        const timeOfDay = this.game.entities.tryGetSingleton((0, $4df5c29ec7839388$export$1467403458327a44));
        const todSeconds = timeOfDay ? timeOfDay.getTimeInSeconds() : 43200;
        const ambientLight = timeOfDay ? timeOfDay.getAmbientLight() : [
            1,
            1,
            1
        ];
        // Render trees to offscreen texture (separate command encoder, like SurfaceRenderer).
        // This avoids interrupting the main render pass — expensive on tile-based GPUs.
        // GPU profiler timestamps are attached to this pass for free.
        this.rasterizer.renderToTexture(visibleCount, camMatrix.a, camMatrix.b, camMatrix.c, camMatrix.d, camMatrix.tx, camMatrix.ty, screenWidth, screenHeight, physicalWidth, physicalHeight, performance.now() / 1000, baseWindX, baseWindY, todSeconds, camera.z, ambientLight, gpuProfiler);
        // Composite tree texture into the main render pass
        renderer.flush();
        const mainPass = renderer.getCurrentRenderPass();
        if (!mainPass) return;
        // Rebuild bind group if texture changed (e.g., resize)
        const textureView = this.rasterizer.getTextureView();
        if (textureView && textureView !== this.lastTextureView) {
            this.compositeBindGroup = this.compositeShader.createBindGroup({
                treeTexture: textureView
            });
            this.lastTextureView = textureView;
        }
        if (this.compositeBindGroup) this.compositeShader.render(mainPass, this.compositeBindGroup);
    }
}
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $aa1f0309d9dba6d2$export$af631764ddc44097)("add")
], $8003b38afc871c38$export$76eea51e6331f99a.prototype, "onAdd", null);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $aa1f0309d9dba6d2$export$af631764ddc44097)("destroy")
], $8003b38afc871c38$export$76eea51e6331f99a.prototype, "onDestroy", null);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $aa1f0309d9dba6d2$export$af631764ddc44097)("render")
], $8003b38afc871c38$export$76eea51e6331f99a.prototype, "onRender", null);












// Configuration (visual/screen-space, not world units)
const $a19c42d2ba21fe93$var$PARTICLE_COUNT = 0; // Target particles per sector
const $a19c42d2ba21fe93$var$SPAWN_RATE = 500; // particles per second (spawn and despawn)
const $a19c42d2ba21fe93$var$TARGET_ALPHA = 0.5; // Dimensionless opacity
const $a19c42d2ba21fe93$var$ALPHA_LERP_SPEED = 0.7; // 1/s - alpha transition speed
const $a19c42d2ba21fe93$var$PARTICLE_SIZE = 0.5; // pixels on screen, regardless of zoom
const $a19c42d2ba21fe93$var$COLOR = 0xffffff;
const $a19c42d2ba21fe93$var$PARTICLE_MOVE_SCALE = 0.5; // Dimensionless - fraction of wind speed
// Sector balancing
const $a19c42d2ba21fe93$var$SECTOR_GRID_SIZE = 6; // Grid divisions per axis
const $a19c42d2ba21fe93$var$REBALANCE_THRESHOLD = 1.5; // max allowed density ratio. Must be > 1.0
class $a19c42d2ba21fe93$export$d95354cdd91795a extends (0, $c59361981bac2575$export$4342ba5c6ad1f6f1) {
    constructor(){
        super(), this.layer = "windParticles", this.particles = [], this.grid = null, this.targetParticleCount = $a19c42d2ba21fe93$var$PARTICLE_COUNT;
        // Wind query for particle positions
        this.windQuery = this.addChild(new (0, $3d4e827a36d4d6ff$export$20101e03857a552b)(()=>this.getWindQueryPoints()));
    }
    /**
   * Get points to query for wind data at each particle position.
   */ getWindQueryPoints() {
        return this.particles.map((p)=>p.pos.clone());
    }
    onAdd() {
        this.grid = new $a19c42d2ba21fe93$var$ParticleGrid($a19c42d2ba21fe93$var$SECTOR_GRID_SIZE, $a19c42d2ba21fe93$var$SECTOR_GRID_SIZE);
    }
    onRender({ dt: dt, draw: draw }) {
        if (!this.game || !this.grid) return;
        const viewport = this.game.camera.getWorldViewport();
        const zoom = this.game.camera.z;
        // Particle radius in world units that appears as PARTICLE_SIZE pixels on screen
        const radius = $a19c42d2ba21fe93$var$PARTICLE_SIZE / zoom * 1.01 ** zoom;
        this.grid.rebuildSectors(this.particles, viewport);
        // Spawn or despawn particles toward target count
        const diff = this.targetParticleCount - this.particles.length;
        const maxChange = Math.ceil($a19c42d2ba21fe93$var$SPAWN_RATE * dt);
        const change = Math.min(Math.abs(diff), maxChange) * Math.sign(diff);
        if (change > 0) // Spawn particles
        for(let i = 0; i < change; i++){
            const pos = this.grid.getSpawnPosition(viewport);
            const particle = new $a19c42d2ba21fe93$var$WindParticle(pos);
            this.particles.push(particle);
        }
        else if (change < 0) // Despawn particles
        for(let i = 0; i < -change; i++){
            const particle = this.grid.popFromDensest();
            if (!particle) break;
            const idx = this.particles.indexOf(particle);
            if (idx !== -1) this.particles.splice(idx, 1);
        }
        this.grid.placeOutOfBoundsParticles(viewport);
        this.grid.rebalance(viewport);
        // Get wind query results (may have 1-frame latency for new particles)
        const windResults = this.windQuery.results;
        // Update and draw particles
        for(let i = 0; i < this.particles.length; i++){
            const p = this.particles[i];
            // Use wind result if available, otherwise skip movement
            const windResult = i < windResults.length ? windResults[i] : null;
            p.update(dt, windResult);
            draw.fillCircle(p.pos.x, p.pos.y, radius, {
                color: $a19c42d2ba21fe93$var$COLOR,
                alpha: p.alpha
            });
        }
    }
}
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $aa1f0309d9dba6d2$export$af631764ddc44097)("add")
], $a19c42d2ba21fe93$export$d95354cdd91795a.prototype, "onAdd", null);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $aa1f0309d9dba6d2$export$af631764ddc44097)("render"),
    (0, $5a1d1d3ab1ff9c51$export$4882ae973e0491e)
], $a19c42d2ba21fe93$export$d95354cdd91795a.prototype, "onRender", null);
/**
 * A single wind particle with position and alpha.
 */ class $a19c42d2ba21fe93$var$WindParticle {
    constructor(pos){
        this.alpha = 0;
        this.pos = pos;
    }
    /** Teleport to a new position, resetting alpha to fade in */ teleport(newPos) {
        this.alpha = 0;
        this.pos.set(newPos);
    }
    /** Update particle state using wind query result */ update(dt, windResult) {
        if (windResult) this.pos.iadd(windResult.velocity.mul(dt * $a19c42d2ba21fe93$var$PARTICLE_MOVE_SCALE));
        this.alpha = (0, $2172aedd5a25ff17$export$b26f3c29b28fecef)(this.alpha, $a19c42d2ba21fe93$var$TARGET_ALPHA, $a19c42d2ba21fe93$var$ALPHA_LERP_SPEED * dt);
    }
}
/**
 * Manages particles in a grid of sectors for efficient rebalancing.
 * Sectors are kept sorted by particle count (sparsest first).
 */ class $a19c42d2ba21fe93$var$ParticleGrid {
    get sparsestIndex() {
        return this.sortedIndices[0];
    }
    get densestIndex() {
        return this.sortedIndices[this.sortedIndices.length - 1];
    }
    constructor(gridWidth, gridHeight){
        this.outOfBounds = [];
        this.gridWidth = gridWidth;
        this.gridHeight = gridHeight;
        // Initialize empty sectors
        const numSectors = gridWidth * gridHeight;
        if (numSectors <= 1) throw new Error(`Invalid sector grid size: ${numSectors} (${gridWidth}x${gridHeight})`);
        this.sectors = (0, $9015b6c2ef849b52$export$d02631cccf789723)(numSectors).map(()=>[]);
        this.sortedIndices = (0, $9015b6c2ef849b52$export$d02631cccf789723)(numSectors);
    }
    /** Get the sector index for a world position, or -1 if out of bounds */ getSectorIndex(pos, viewport) {
        const x = (0, $2172aedd5a25ff17$export$4444e85a8e8eb4d3)(viewport.left, viewport.right, pos.x) * this.gridWidth;
        const y = (0, $2172aedd5a25ff17$export$4444e85a8e8eb4d3)(viewport.top, viewport.bottom, pos.y) * this.gridHeight;
        const col = Math.floor(x);
        const row = Math.floor(y);
        if (col < 0 || col >= this.gridWidth || row < 0 || row >= this.gridHeight) return -1;
        return row * this.gridWidth + col;
    }
    getSectorBounds(sectorIndex, viewport) {
        const col = sectorIndex % this.gridWidth;
        const row = Math.floor(sectorIndex / this.gridWidth);
        const sectorWidth = viewport.width / this.gridWidth;
        const sectorHeight = viewport.height / this.gridHeight;
        const left = viewport.left + col * sectorWidth;
        const right = left + sectorWidth;
        const top = viewport.top + row * sectorHeight;
        const bottom = top + sectorHeight;
        return {
            left: left,
            right: right,
            top: top,
            bottom: bottom
        };
    }
    /** Get a random position within a sector */ getRandomPosInSector(sectorIndex, viewport) {
        const { left: left, right: right, top: top, bottom: bottom } = this.getSectorBounds(sectorIndex, viewport);
        return (0, $6b6a54a072724620$export$e7c866399fa523f5)((0, $f1ed8354ebe33615$export$1ab1062261c98efe)(left, right), (0, $f1ed8354ebe33615$export$1ab1062261c98efe)(top, bottom));
    }
    /** Rebuild sector assignments from particle positions */ rebuildSectors(particles, viewport) {
        // Clear all sectors
        for (const sector of this.sectors)sector.length = 0;
        this.outOfBounds.length = 0;
        // Assign particles to sectors
        for (const p of particles){
            const idx = this.getSectorIndex(p.pos, viewport);
            if (idx === -1) this.outOfBounds.push(p);
            else this.sectors[idx].push(p);
        }
        // Sort indices by sector count (sparsest first)
        this.sortedIndices.sort((a, b)=>this.sectors[a].length - this.sectors[b].length);
    }
    /** Teleport out-of-bounds particles to sparse sectors */ placeOutOfBoundsParticles(viewport) {
        while(this.outOfBounds.length > 0){
            const p = this.outOfBounds.pop();
            const sectorIndex = this.sparsestIndex;
            p.teleport(this.getRandomPosInSector(sectorIndex, viewport));
            this.sectors[sectorIndex].push(p);
            this.bubbleUp();
        }
    }
    /** Rebalance sectors until the ratio is acceptable */ rebalance(viewport) {
        const numSectors = this.sectors.length;
        const totalParticles = (0, $2172aedd5a25ff17$export$8a63f25cc62965f1)(...this.sectors.map((s)=>s.length));
        const perSector = totalParticles / numSectors;
        const maxAllowed = Math.max(Math.ceil(perSector * $a19c42d2ba21fe93$var$REBALANCE_THRESHOLD), 1); // never allow 0
        while(this.sectors[this.densestIndex].length > maxAllowed){
            const p = this.sectors[this.densestIndex].pop();
            const sectorIndex = this.sparsestIndex;
            p.teleport(this.getRandomPosInSector(sectorIndex, viewport));
            this.sectors[sectorIndex].push(p);
            this.bubbleUp();
            this.bubbleDown();
        }
    }
    /** Get a position in the sparsest sector for spawning new particles */ getSpawnPosition(viewport) {
        return this.getRandomPosInSector(this.sparsestIndex, viewport);
    }
    /** Remove and return a particle from the densest sector */ popFromDensest() {
        const sector = this.sectors[this.densestIndex];
        if (sector.length === 0) return undefined;
        const p = sector.pop();
        this.bubbleDown();
        return p;
    }
    /** Bubble a sector up in sortedIndices if it became larger than its neighbors */ bubbleUp() {
        for(let i = 0; i < this.sortedIndices.length - 1 && this.sectors[this.sortedIndices[i]].length > this.sectors[this.sortedIndices[i + 1]].length; i++){
            const temp = this.sortedIndices[i];
            this.sortedIndices[i] = this.sortedIndices[i + 1];
            this.sortedIndices[i + 1] = temp;
        }
    }
    /** Bubble a sector down in sortedIndices if it became smaller than its neighbors */ bubbleDown() {
        for(let i = this.sortedIndices.length - 1; i > 0 && this.sectors[this.sortedIndices[i]].length < this.sectors[this.sortedIndices[i - 1]].length; i--){
            const temp = this.sortedIndices[i];
            this.sortedIndices[i] = this.sortedIndices[i - 1];
            this.sortedIndices[i - 1] = temp;
        }
    }
}






function $99dca07858272978$export$c52d03bf6582e37d(audioContext, duration = 2) {
    const sampleRate = audioContext.sampleRate;
    const length = Math.ceil(sampleRate * duration);
    const buffer = audioContext.createBuffer(1, length, sampleRate);
    const data = buffer.getChannelData(0);
    for(let i = 0; i < length; i++)data[i] = (0, $f1ed8354ebe33615$export$1ab1062261c98efe)(-1, 1);
    return buffer;
}




// Audio parameter smoothing time constant (seconds)
const $28524a8d5666ac48$var$SMOOTHING = 0.05;
// Wind speed range for mapping to audio parameters (ft/s)
const $28524a8d5666ac48$var$MIN_WIND_SPEED = 2; // Below this, wind is inaudible
const $28524a8d5666ac48$var$MAX_WIND_SPEED = 25; // Above this, wind sound is maxed out
// Lowpass filter frequency range (Hz)
const $28524a8d5666ac48$var$MIN_FREQUENCY = 200; // Light breeze - low rumble
const $28524a8d5666ac48$var$MAX_FREQUENCY = 1200; // Strong wind - more hiss
// Volume
const $28524a8d5666ac48$var$MAX_GAIN = 0.08;
class $28524a8d5666ac48$export$5f645a08d3a9611e extends (0, $c59361981bac2575$export$4342ba5c6ad1f6f1) {
    onAdd({ game: game }) {
        const ctx = game.audio;
        // Create wind query at camera position
        this.windQuery = this.addChild(new (0, $3d4e827a36d4d6ff$export$20101e03857a552b)(()=>[
                game.camera.getPosition()
            ]));
        // Create and start looping noise source
        const noiseBuffer = (0, $99dca07858272978$export$c52d03bf6582e37d)(ctx);
        this.noiseSource = ctx.createBufferSource();
        this.noiseSource.buffer = noiseBuffer;
        this.noiseSource.loop = true;
        this.noiseSource.start();
        // Lowpass filter shapes the wind character
        this.lowpass = ctx.createBiquadFilter();
        this.lowpass.type = "lowpass";
        this.lowpass.frequency.value = $28524a8d5666ac48$var$MIN_FREQUENCY;
        this.lowpass.Q.value = 0.7; // Butterworth - smooth rolloff
        // Output gain
        this.outputGain = ctx.createGain();
        this.outputGain.gain.value = 0;
        // Wire the chain
        this.noiseSource.connect(this.lowpass);
        this.lowpass.connect(this.outputGain);
        this.outputGain.connect(game.masterGain);
    }
    onTick({ audioTime: audioTime }) {
        // Wind query results have one-frame latency; skip until data is available.
        if (this.windQuery.length === 0) return;
        const wind = this.windQuery.get(0);
        const speed = wind.speed;
        if (!Number.isFinite(speed)) {
            this.lowpass.frequency.setTargetAtTime($28524a8d5666ac48$var$MIN_FREQUENCY, audioTime, $28524a8d5666ac48$var$SMOOTHING);
            this.outputGain.gain.setTargetAtTime(0, audioTime, $28524a8d5666ac48$var$SMOOTHING);
            return;
        }
        // Normalize wind speed to 0-1 range
        const t = (0, $2172aedd5a25ff17$export$7d15b64cf5a3a4c4)((speed - $28524a8d5666ac48$var$MIN_WIND_SPEED) / ($28524a8d5666ac48$var$MAX_WIND_SPEED - $28524a8d5666ac48$var$MIN_WIND_SPEED));
        // Map to audio parameters
        const frequency = (0, $2172aedd5a25ff17$export$3a89f8d6f6bf6c9f)($28524a8d5666ac48$var$MIN_FREQUENCY, $28524a8d5666ac48$var$MAX_FREQUENCY, t);
        const gain = t * t * t * $28524a8d5666ac48$var$MAX_GAIN; // Cubic curve - gentle ramp
        // Schedule smooth parameter transitions
        this.lowpass.frequency.setTargetAtTime(frequency, audioTime, $28524a8d5666ac48$var$SMOOTHING);
        this.outputGain.gain.setTargetAtTime(gain, audioTime, $28524a8d5666ac48$var$SMOOTHING);
    }
    onDestroy() {
        this.noiseSource.stop();
        this.noiseSource.disconnect();
        this.lowpass.disconnect();
        this.outputGain.disconnect();
    }
    constructor(...args){
        super(...args), this.tickLayer = "effects";
    }
}
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $aa1f0309d9dba6d2$export$af631764ddc44097)("add")
], $28524a8d5666ac48$export$5f645a08d3a9611e.prototype, "onAdd", null);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $aa1f0309d9dba6d2$export$af631764ddc44097)("tick")
], $28524a8d5666ac48$export$5f645a08d3a9611e.prototype, "onTick", null);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $aa1f0309d9dba6d2$export$af631764ddc44097)("destroy")
], $28524a8d5666ac48$export$5f645a08d3a9611e.prototype, "onDestroy", null);






class $d5f38f711f8a9f80$export$7233ea1ab57f474c extends (0, $c59361981bac2575$export$4342ba5c6ad1f6f1) {
    onAdd() {
        for (const entity of this.game.entities.getTagged("queryManager")){
            const manager = entity;
            manager.coordinated = true;
            this.managers.push(manager);
        }
    }
    onAfterPhysicsStep() {
        // Phase 1: Collect and upload points for all managers
        const counts = [];
        let anyPoints = false;
        for (const manager of this.managers){
            const count = manager.collectAndUploadPoints();
            counts.push(count);
            if (count > 0) anyPoints = true;
        }
        if (!anyPoints) return;
        // Phase 2: Record all compute dispatches and copies on one encoder
        const device = this.game.getWebGPUDevice();
        const commandEncoder = device.createCommandEncoder({
            label: "QueryCoordinator Batch"
        });
        for(let i = 0; i < this.managers.length; i++)if (counts[i] > 0) this.managers[i].dispatchCompute(counts[i], commandEncoder);
        for(let i = 0; i < this.managers.length; i++)if (counts[i] > 0) this.managers[i].recordCopyToReadback(counts[i], commandEncoder);
        // Single submit
        device.queue.submit([
            commandEncoder.finish()
        ]);
        // Phase 3: Start all mapAsync readbacks
        for(let i = 0; i < this.managers.length; i++)if (counts[i] > 0) this.managers[i].startReadback(counts[i]);
    }
    onDestroy() {
        for (const manager of this.managers)manager.coordinated = false;
        this.managers = [];
    }
    constructor(...args){
        super(...args), this.id = "queryCoordinator", this.tickLayer = "query", this.managers = [];
    }
}
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $aa1f0309d9dba6d2$export$af631764ddc44097)("add")
], $d5f38f711f8a9f80$export$7233ea1ab57f474c.prototype, "onAdd", null);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $aa1f0309d9dba6d2$export$af631764ddc44097)("afterPhysicsStep"),
    (0, $5a1d1d3ab1ff9c51$export$4882ae973e0491e)
], $d5f38f711f8a9f80$export$7233ea1ab57f474c.prototype, "onAfterPhysicsStep", null);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $aa1f0309d9dba6d2$export$af631764ddc44097)("destroy")
], $d5f38f711f8a9f80$export$7233ea1ab57f474c.prototype, "onDestroy", null);









const $5cb489536d94582d$var$STRIDE_PER_POINT = 2;
class $5cb489536d94582d$export$b986383a50b53ea4 extends (0, $c59361981bac2575$export$4342ba5c6ad1f6f1) {
    get pointBuffer() {
        if (!this._pointBuffer) throw new Error(`${this.constructor.name}: pointBuffer not initialized`);
        return this._pointBuffer;
    }
    set pointBuffer(value) {
        this._pointBuffer = value;
    }
    get resultBuffer() {
        if (!this._resultBuffer) throw new Error(`${this.constructor.name}: resultBuffer not initialized`);
        return this._resultBuffer;
    }
    set resultBuffer(value) {
        this._resultBuffer = value;
    }
    get readbackBuffers() {
        if (!this._readbackBuffers) throw new Error(`${this.constructor.name}: readbackBuffers not initialized`);
        return this._readbackBuffers;
    }
    set readbackBuffers(value) {
        this._readbackBuffers = value;
    }
    /** Size of the point buffer in bytes */ get pointBufferSize() {
        return this.maxPoints * $5cb489536d94582d$var$STRIDE_PER_POINT * Float32Array.BYTES_PER_ELEMENT;
    }
    /** Size of the result buffer in bytes */ get resultBufferSize() {
        return this.maxPoints * this.resultLayout.stride * Float32Array.BYTES_PER_ELEMENT;
    }
    constructor(resultLayout, maxPoints){
        super(), this.tags = [
            "queryManager"
        ], /**
   * When true, this manager's afterPhysicsStep is a no-op.
   * A QueryCoordinator will call the individual dispatch phases instead,
   * batching all managers onto a single command encoder for GPU parallelism.
   */ this.coordinated = false, /**
   * GPU buffer containing input query points (vec2f per point).
   * Written by CPU, read by GPU compute shader.
   */ this._pointBuffer = null, /**
   * GPU buffer containing computation results.
   * Written by GPU compute shader, copied to readback buffer for CPU access.
   * Cannot be directly read by CPU (STORAGE usage doesn't support mapping).
   */ this._resultBuffer = null, /**
   * Double-buffered readback buffers for CPU access.
   * We copy resultBuffer to a readback buffer, then map it asynchronously.
   * While one readback buffer is mapped (waiting for GPU), we can copy new
   * results to the other buffer. This creates one frame of latency but
   * prevents blocking on GPU operations.
   */ this._readbackBuffers = null, /**
   * Promise for the currently pending mapAsync operation.
   * Resolves when GPU has finished copying and buffer is ready to read.
   */ this.readbackPromise = null, /**
   * Number of bytes in the pending readback operation.
   * Used for partial buffer mapping to avoid slow paths for large buffers.
   */ this.pendingReadbackBytes = 0, /**
   * Reusable Float32Array for collecting query points.
   * Avoids allocating a new array every frame.
   */ this.pointsArray = null, /**
   * Persistent CPU-side buffer for result data.
   * Mapped GPU data is copied here immediately, then the GPU buffer is unmapped.
   * Query views reference slices of this buffer.
   */ this.dataBuffer = null, /**
   * Metadata for each query's position in the GPU buffer.
   * WeakMap ensures this data is private to QueryManager and auto-cleans up.
   */ this.queryBufferMetadata = new WeakMap();
        this.resultLayout = resultLayout;
        this.maxPoints = maxPoints;
    }
    onAdd() {
        const device = this.game.getWebGPUDevice();
        // Initialize GPU buffers
        // Point buffer: vec2f per point
        this.pointBuffer = device.createBuffer({
            label: this.constructor.name + " Point Buffer",
            size: this.pointBufferSize,
            usage: GPUBufferUsage.STORAGE | GPUBufferUsage.COPY_DST
        });
        // Result buffer: layout.stride floats per result
        this.resultBuffer = device.createBuffer({
            label: this.constructor.name + " Result Buffer",
            size: this.resultBufferSize,
            usage: GPUBufferUsage.STORAGE | GPUBufferUsage.COPY_SRC
        });
        // Readback buffers
        this.readbackBuffers = new (0, $e41ebc4a8c7c6fe6$export$1c311eac3da4c8b9)(device.createBuffer({
            label: this.constructor.name + " Readback A",
            size: this.resultBufferSize,
            usage: GPUBufferUsage.COPY_DST | GPUBufferUsage.MAP_READ
        }), device.createBuffer({
            label: this.constructor.name + " Readback B",
            size: this.resultBufferSize,
            usage: GPUBufferUsage.COPY_DST | GPUBufferUsage.MAP_READ
        }));
    }
    /**
   * Query pipeline with one-tick latency:
   *
   * Tick N onTick:
   *   1. Await GPU map operation from tick N-1
   *   2. Copy mapped data to persistent CPU buffer, unmap immediately
   *   3. Distribute buffer slices to queries (zero-copy views)
   *
   * Tick N (entities use query results via buffer-backed views)
   *
   * Tick N afterPhysicsStep:
   *   1. Collect query points (based on updated entity positions)
   *   2. Upload to GPU and dispatch compute
   *   3. Copy results to readback buffer
   *   4. Start async map for next tick
   */ async onTick() {
        // Wait for GPU results from previous tick and distribute them
        if (!this.readbackPromise) return;
        const readbackBuffer = this.readbackBuffers.getRead();
        let mappedSuccessfully = false;
        const prefix = this.constructor.name;
        try {
            const awaitStart = performance.now();
            await this.readbackPromise;
            (0, $5a1d1d3ab1ff9c51$export$e8e2fad003b4d4ce).recordElapsed(`${prefix}.awaitMapAsync`, performance.now() - awaitStart);
            mappedSuccessfully = true;
            // Create temporary view over mapped GPU memory
            const mappedView = new Float32Array(readbackBuffer.getMappedRange(0, this.pendingReadbackBytes));
            // Copy to persistent CPU buffer
            const floatCount = this.pendingReadbackBytes / Float32Array.BYTES_PER_ELEMENT;
            if (!this.dataBuffer || this.dataBuffer.length < floatCount) this.dataBuffer = new Float32Array(this.maxPoints * this.resultLayout.stride);
            this.dataBuffer.set(mappedView);
            // Unmap ASAP to free GPU buffer for next frame's copy
            readbackBuffer.unmap();
            mappedSuccessfully = false; // Already unmapped, skip finally unmap
            // Distribute results to queries via zero-copy Float32Array views
            const queries = this.getQueries();
            const stride = this.resultLayout.stride;
            for (const query of queries){
                const metadata = this.queryBufferMetadata.get(query);
                if (!metadata || metadata.offset < 0) continue;
                query.receiveData(this.dataBuffer, metadata.offset * stride, metadata.count);
            }
        } catch (error) {
            console.warn(`[${this.constructor.name}] Query readback failed (context loss?):`, error.message);
        } finally{
            // Unmap if mapping succeeded but we didn't get to the unmap above
            if (mappedSuccessfully) try {
                readbackBuffer.unmap();
            } catch  {
            // Buffer might already be unmapped, ignore
            }
            this.readbackPromise = null;
        }
    }
    /**
   * Collect query points and upload to GPU.
   * Returns the point count (0 means skip this manager).
   */ collectAndUploadPoints() {
        const { points: points, pointCount: pointCount } = this.collectPoints();
        if (pointCount === 0) return 0;
        const pointBytesNeeded = pointCount * $5cb489536d94582d$var$STRIDE_PER_POINT * Float32Array.BYTES_PER_ELEMENT;
        const device = this.game.getWebGPUDevice();
        device.queue.writeBuffer(this.pointBuffer, 0, points.buffer, points.byteOffset, pointBytesNeeded);
        return pointCount;
    }
    /**
   * Record a copy from resultBuffer to the current write readback buffer.
   */ recordCopyToReadback(pointCount, commandEncoder) {
        const resultBytesNeeded = pointCount * this.resultLayout.stride * Float32Array.BYTES_PER_ELEMENT;
        const readbackBuffer = this.readbackBuffers.getWrite();
        commandEncoder.copyBufferToBuffer(this.resultBuffer, 0, readbackBuffer, 0, resultBytesNeeded);
    }
    /**
   * Swap double buffers and start async map for next tick's results.
   */ startReadback(pointCount) {
        const resultBytesNeeded = pointCount * this.resultLayout.stride * Float32Array.BYTES_PER_ELEMENT;
        const readbackBuffer = this.readbackBuffers.getWrite();
        this.readbackBuffers.swap();
        this.pendingReadbackBytes = resultBytesNeeded;
        this.readbackPromise = readbackBuffer.mapAsync(GPUMapMode.READ, 0, resultBytesNeeded);
    }
    onAfterPhysicsStep() {
        if (this.coordinated) return;
        const pointCount = this.collectAndUploadPoints();
        if (pointCount === 0) return;
        const device = this.game.getWebGPUDevice();
        const commandEncoder = device.createCommandEncoder({
            label: `${this.constructor.name} Compute + Copy`
        });
        this.dispatchCompute(pointCount, commandEncoder);
        this.recordCopyToReadback(pointCount, commandEncoder);
        device.queue.submit([
            commandEncoder.finish()
        ]);
        this.startReadback(pointCount);
    }
    collectPoints() {
        const queries = this.getQueries();
        // Reuse or create points array
        if (!this.pointsArray || this.pointsArray.length < this.maxPoints * $5cb489536d94582d$var$STRIDE_PER_POINT) this.pointsArray = new Float32Array(this.maxPoints * $5cb489536d94582d$var$STRIDE_PER_POINT);
        const points = this.pointsArray;
        let currentPoint = 0;
        for (const query of queries){
            const queryPoints = query.getQueryPoints();
            if (currentPoint + queryPoints.length > this.maxPoints) {
                console.warn(`${this.constructor.name}: Buffer overflow! Skipping query with ${queryPoints.length} points.`);
                this.queryBufferMetadata.set(query, {
                    offset: -1,
                    count: 0
                });
                continue;
            }
            this.queryBufferMetadata.set(query, {
                offset: currentPoint,
                count: queryPoints.length
            });
            for (const p of queryPoints){
                const offset = currentPoint * $5cb489536d94582d$var$STRIDE_PER_POINT;
                points[offset] = p.x;
                points[offset + 1] = p.y;
                currentPoint++;
            }
        }
        return {
            points: points,
            queries: queries,
            pointCount: currentPoint
        };
    }
    onDestroy() {
        // Clear the pending promise so the awaiting onTick won't try to use
        // destroyed buffers.  The mapAsync will reject with AbortError when
        // the buffer is destroyed — we intentionally swallow that below.
        const pendingPromise = this.readbackPromise;
        this.readbackPromise = null;
        pendingPromise?.catch(()=>{});
        this.pointBuffer?.destroy();
        this.resultBuffer?.destroy();
        if (this.readbackBuffers) {
            this.readbackBuffers.getRead().destroy();
            this.readbackBuffers.getWrite().destroy();
        }
    }
}
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $aa1f0309d9dba6d2$export$af631764ddc44097)("add")
], $5cb489536d94582d$export$b986383a50b53ea4.prototype, "onAdd", null);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $aa1f0309d9dba6d2$export$af631764ddc44097)("tick"),
    (0, $5a1d1d3ab1ff9c51$export$ba371caaa8f2e40)
], $5cb489536d94582d$export$b986383a50b53ea4.prototype, "onTick", null);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $aa1f0309d9dba6d2$export$af631764ddc44097)("afterPhysicsStep"),
    (0, $5a1d1d3ab1ff9c51$export$4882ae973e0491e)
], $5cb489536d94582d$export$b986383a50b53ea4.prototype, "onAfterPhysicsStep", null);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $5a1d1d3ab1ff9c51$export$4882ae973e0491e)
], $5cb489536d94582d$export$b986383a50b53ea4.prototype, "collectPoints", null);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $aa1f0309d9dba6d2$export$af631764ddc44097)("destroy")
], $5cb489536d94582d$export$b986383a50b53ea4.prototype, "onDestroy", null);





/**
 * Terrain Query Compute Shader
 *
 * Samples terrain data (height, normal, terrain type) at arbitrary query points.
 * Uses terrain shader modules for signed distance computation.
 *
 * Input:  pointBuffer (storage) - array of vec2<f32> query points
 * Output: resultBuffer (storage) - array of TerrainQueryResult structs
 */ 


const $7b9a1743d1804aa6$var$WORKGROUP_SIZE = [
    64,
    1,
    1
];
const $7b9a1743d1804aa6$export$45f0797a8955cd80 = (0, $ca6793d1abd58997$export$99bb2281c7368d10)("Params", {
    pointCount: (0, $ca6793d1abd58997$export$8bacf4ad828c7fe7),
    contourCount: (0, $ca6793d1abd58997$export$8bacf4ad828c7fe7),
    defaultDepth: (0, $ca6793d1abd58997$export$e33361ff41014190),
    _padding: (0, $ca6793d1abd58997$export$e33361ff41014190)
});
/**
 * Module containing Params and result structs, plus bindings.
 */ const $7b9a1743d1804aa6$var$terrainQueryParamsModule = {
    preamble: /*wgsl*/ `
// Query parameters
struct Params {
  pointCount: u32,
  contourCount: u32,
  defaultDepth: f32,
  _padding: f32,
}

// Result structure (matches TerrainQueryResult interface)
// stride = 4 floats
struct TerrainQueryResult {
  height: f32,
  normalX: f32,
  normalY: f32,
  terrainType: f32,
}
  `,
    bindings: {
        params: {
            type: "uniform",
            wgslType: "Params"
        },
        pointBuffer: {
            type: "storage",
            wgslType: "array<vec2<f32>>"
        },
        resultBuffer: {
            type: "storageRW",
            wgslType: "array<TerrainQueryResult>"
        },
        packedTerrain: {
            type: "storage",
            wgslType: "array<u32>"
        }
    },
    code: ""
};
/**
 * Module containing the compute entry point.
 */ const $7b9a1743d1804aa6$var$terrainQueryMainModule = {
    dependencies: [
        (0, $d2770abe96d7e153$export$bf8b0ba9719f8192),
        (0, $cef462b61853a9de$export$8aa5da975f6e05cd),
        $7b9a1743d1804aa6$var$terrainQueryParamsModule
    ],
    code: /*wgsl*/ `
@compute @workgroup_size(${$7b9a1743d1804aa6$var$WORKGROUP_SIZE[0]})
fn main(@builtin(global_invocation_id) globalId: vec3<u32>) {
  let index = globalId.x;

  if (index >= params.pointCount) {
    return;
  }

  let queryPoint = pointBuffer[index];

  // Compute height and gradient analytically in a single terrain traversal
  let hg = computeTerrainHeightAndGradient(
    queryPoint,
    &packedTerrain,
    params.contourCount,
    params.defaultDepth
  );

  var result: TerrainQueryResult;
  result.height = hg.height;

  // Convert gradient to normal (same convention as finite-difference version)
  let horizontalLen = sqrt(hg.gradientX * hg.gradientX + hg.gradientY * hg.gradientY);
  if (horizontalLen > 1e-9) {
    let normal3d = normalize(vec3<f32>(-hg.gradientX, -hg.gradientY, 1.0));
    result.normalX = normal3d.x;
    result.normalY = normal3d.y;
  } else {
    result.normalX = 0.0;
    result.normalY = 0.0;
  }

  // Terrain type: 0 = water (negative height), 1+ = land
  result.terrainType = select(0.0, 1.0, result.height >= 0.0);

  resultBuffer[index] = result;
}
  `
};
const $7b9a1743d1804aa6$export$8432227a63b20697 = {
    modules: [
        $7b9a1743d1804aa6$var$terrainQueryMainModule
    ],
    workgroupSize: $7b9a1743d1804aa6$var$WORKGROUP_SIZE,
    label: "TerrainQueryShader"
};
function $7b9a1743d1804aa6$export$9120a8711cc97db() {
    return new (0, $4016c3d8f65071ed$export$cdde5429dd049099)($7b9a1743d1804aa6$export$8432227a63b20697);
}



const $47b77f125c24cf19$var$MAX_TERRAIN_QUERIES = 2 ** 15;
class $47b77f125c24cf19$export$65e31a0e727fd81f extends (0, $5cb489536d94582d$export$b986383a50b53ea4) {
    constructor(){
        super((0, $aed9a4be5f3eb254$export$8d2d30a13189ff2e), $47b77f125c24cf19$var$MAX_TERRAIN_QUERIES), this.id = "terrainQueryManager", this.tickLayer = "query", this.queryShader = null, this.uniformBuffer = null, this.uniforms = (0, $7b9a1743d1804aa6$export$45f0797a8955cd80).create();
        this.queryShader = (0, $7b9a1743d1804aa6$export$9120a8711cc97db)();
    }
    async onAdd() {
        super.onAdd();
        await this.queryShader.init();
        const device = this.game.getWebGPUDevice();
        this.uniformBuffer = device.createBuffer({
            label: "Terrain Query Uniform Buffer",
            size: (0, $7b9a1743d1804aa6$export$45f0797a8955cd80).byteSize,
            usage: GPUBufferUsage.UNIFORM | GPUBufferUsage.COPY_DST
        });
    }
    getQueries() {
        return [
            ...this.game.entities.byConstructor((0, $178448b994cda479$export$b2f87c4d67934c2d))
        ];
    }
    dispatchCompute(pointCount, commandEncoder) {
        if (!this.queryShader || !this.uniformBuffer) {
            console.warn("[TerrainQuery] Shader not initialized");
            return;
        }
        if (pointCount === 0) return;
        const terrainResources = this.game.entities.getSingleton((0, $cd92036e590b44aa$export$74cf638da29b900d));
        this.uniforms.set.pointCount(pointCount);
        this.uniforms.set.contourCount(terrainResources.getContourCount());
        this.uniforms.set.defaultDepth((0, $50f569eac7e9a7b2$export$7f882bb969de14a3));
        this.uniforms.set._padding(0);
        this.uniforms.uploadTo(this.uniformBuffer);
        const bindGroup = this.queryShader.createBindGroup({
            params: {
                buffer: this.uniformBuffer
            },
            pointBuffer: {
                buffer: this.pointBuffer
            },
            resultBuffer: {
                buffer: this.resultBuffer
            },
            packedTerrain: {
                buffer: terrainResources.packedTerrainBuffer
            }
        });
        const gpuProfiler = this.game.getRenderer().getGpuProfiler();
        const computePass = commandEncoder.beginComputePass({
            label: "Terrain Query Compute Pass",
            timestampWrites: gpuProfiler?.getComputeTimestampWrites("query.terrain")
        });
        this.queryShader.dispatch(computePass, bindGroup, pointCount, 1);
        computePass.end();
    }
}
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $aa1f0309d9dba6d2$export$af631764ddc44097)("add")
], $47b77f125c24cf19$export$65e31a0e727fd81f.prototype, "onAdd", null);







/**
 * CPU-side tide mesh packing for GPU compute shader access.
 *
 * Packs tidal flow vertex/index data and spatial grid indices into a single
 * array<u32> buffer.
 *
 * Buffer layout:
 * HEADER (16 u32s):
 *   [0]  tideLevelCount
 *   [1]  vertexCount
 *   [2]  triangleCount
 *   [3]  gridCols
 *   [4]  gridRows
 *   [5]  gridMinX (f32 as u32)
 *   [6]  gridMinY (f32 as u32)
 *   [7]  gridCellWidth (f32 as u32)
 *   [8]  gridCellHeight (f32 as u32)
 *   [9]  tideLevelTableOffset (u32 offset into buffer)
 *   [10] vertexDataOffset
 *   [11] flowDataOffset
 *   [12] indexDataOffset
 *   [13] gridCellHeadersOffset
 *   [14] gridTriangleListsOffset
 *   [15] padding
 *
 * DATA SECTIONS (packed sequentially after header):
 *   Tide level table: tideLevelCount f32s (as u32 bitcast)
 *   Vertex positions: vertexCount * 2 f32s (as u32)
 *   Flow data: tideLevelCount * vertexCount * 4 f32s (as u32)
 *   Index data: triangleCount * 3 u32s
 *   Grid cell headers: gridCols * gridRows * 2 u32s
 *   Grid triangle lists: variable u32s
 */ const $1863fd274cf26361$var$HEADER_U32S = 16;
/** Float bits -> u32 for buffer packing */ function $1863fd274cf26361$var$f32AsU32(f) {
    const buf = new Float32Array(1);
    buf[0] = f;
    return new Uint32Array(buf.buffer)[0];
}
function $1863fd274cf26361$export$8a65ad61ae52f4d2(data) {
    const { tideLevels: tideLevels, vertexPositions: vertexPositions, flowData: flowData, indices: indices, vertexCount: vertexCount, triangleCount: triangleCount, gridCols: gridCols, gridRows: gridRows, gridMinX: gridMinX, gridMinY: gridMinY, gridCellWidth: gridCellWidth, gridCellHeight: gridCellHeight, gridCellHeaders: gridCellHeaders, gridTriangleLists: gridTriangleLists } = data;
    const tideLevelCount = tideLevels.length;
    const tideLevelU32s = tideLevelCount;
    const vertexU32s = vertexCount * 2;
    const flowU32s = tideLevelCount * vertexCount * 4;
    const indexU32s = triangleCount * 3;
    const gridHeaderU32s = gridCols * gridRows * 2;
    const gridListU32s = gridTriangleLists.length;
    const totalU32s = $1863fd274cf26361$var$HEADER_U32S + tideLevelU32s + vertexU32s + flowU32s + indexU32s + gridHeaderU32s + gridListU32s;
    const buffer = new ArrayBuffer(totalU32s * 4);
    const u32View = new Uint32Array(buffer);
    const f32View = new Float32Array(buffer);
    // Calculate offsets
    let currentOffset = $1863fd274cf26361$var$HEADER_U32S;
    const tideLevelTableOffset = currentOffset;
    currentOffset += tideLevelU32s;
    const vertexDataOffset = currentOffset;
    currentOffset += vertexU32s;
    const flowDataOffset = currentOffset;
    currentOffset += flowU32s;
    const indexDataOffset = currentOffset;
    currentOffset += indexU32s;
    const gridCellHeadersOffset = currentOffset;
    currentOffset += gridHeaderU32s;
    const gridTriangleListsOffset = currentOffset;
    // Write header
    u32View[0] = tideLevelCount;
    u32View[1] = vertexCount;
    u32View[2] = triangleCount;
    u32View[3] = gridCols;
    u32View[4] = gridRows;
    u32View[5] = $1863fd274cf26361$var$f32AsU32(gridMinX);
    u32View[6] = $1863fd274cf26361$var$f32AsU32(gridMinY);
    u32View[7] = $1863fd274cf26361$var$f32AsU32(gridCellWidth);
    u32View[8] = $1863fd274cf26361$var$f32AsU32(gridCellHeight);
    u32View[9] = tideLevelTableOffset;
    u32View[10] = vertexDataOffset;
    u32View[11] = flowDataOffset;
    u32View[12] = indexDataOffset;
    u32View[13] = gridCellHeadersOffset;
    u32View[14] = gridTriangleListsOffset;
    u32View[15] = 0; // padding
    // Write tide level table
    for(let i = 0; i < tideLevelCount; i++)f32View[tideLevelTableOffset + i] = tideLevels[i];
    // Write vertex positions
    for(let i = 0; i < vertexCount * 2; i++)f32View[vertexDataOffset + i] = vertexPositions[i];
    // Write flow data
    let flowOffset = flowDataOffset;
    for(let t = 0; t < tideLevelCount; t++){
        const tideFlowData = flowData[t];
        for(let i = 0; i < vertexCount * 4; i++)f32View[flowOffset + i] = tideFlowData[i];
        flowOffset += vertexCount * 4;
    }
    // Write index data
    for(let i = 0; i < triangleCount * 3; i++)u32View[indexDataOffset + i] = indices[i];
    // Write grid cell headers — adjust triListOffsets to be absolute u32 indices
    const cellCount = gridCols * gridRows;
    for(let i = 0; i < cellCount; i++){
        const rawOffset = gridCellHeaders[i * 2]; // relative to grid triangle lists
        const count = gridCellHeaders[i * 2 + 1];
        u32View[gridCellHeadersOffset + i * 2] = gridTriangleListsOffset + rawOffset;
        u32View[gridCellHeadersOffset + i * 2 + 1] = count;
    }
    // Write grid triangle lists
    for(let i = 0; i < gridListU32s; i++)u32View[gridTriangleListsOffset + i] = gridTriangleLists[i];
    return new Uint32Array(buffer);
}
function $1863fd274cf26361$export$2a9f1f798f1e6547() {
    const buffer = new Uint32Array($1863fd274cf26361$var$HEADER_U32S);
    // All zeros: tideLevelCount=0, vertexCount=0, triangleCount=0, etc.
    return buffer;
}


/**
 * Tidal flow resource manager.
 *
 * Singleton entity that loads tidal flow mesh data and provides GPU buffers
 * and tidal state (phase, strength) for query shaders and rendering.
 *
 * Tidal phase advances based on game-world time from TimeOfDay, following
 * a semi-diurnal tidal cycle (~12.42 hours per cycle).
 */ 




/**
 * Binary .tidemesh file format for prebuilt tidal flow mesh data.
 *
 * Format:
 *   Header (64 bytes):
 *     [0..3]    magic: u32 = 0x4D444954 ("TIDM" LE)
 *     [4..5]    version: u16 = 1
 *     [6..7]    tideLevelCount: u16
 *     [8..11]   inputHash[0]: u32
 *     [12..15]  inputHash[1]: u32
 *     [16..19]  vertexCount: u32
 *     [20..23]  triangleCount: u32
 *     [24..27]  gridCols: u32
 *     [28..31]  gridRows: u32
 *     [32..35]  gridMinX: f32
 *     [36..39]  gridMinY: f32
 *     [40..43]  gridCellWidth: f32
 *     [44..47]  gridCellHeight: f32
 *     [48..63]  reserved
 *
 *   Tide level table (4 bytes x tideLevelCount):
 *     tideHeight: f32
 *
 *   Vertex position data (2 f32 per vertex):
 *     x, y
 *
 *   Flow data (tideLevelCount * vertexCount * 4 f32):
 *     For each tide level, for each vertex: vx_a, vy_a, vx_b, vy_b
 *
 *   Index data (3 u32 per triangle):
 *     i0, i1, i2
 *
 *   Grid cell headers (2 u32 per cell, gridCols * gridRows cells):
 *     triListOffset, triListCount
 *
 *   Grid triangle lists (u32 per entry):
 *     triangleIndex
 */ const $9c669110219a36c8$var$MAGIC = 0x4d444954; // "TIDM" as little-endian u32
const $9c669110219a36c8$var$HEADER_BYTES = 64;
function $9c669110219a36c8$export$189a298f328743d5(buffer) {
    const view = new DataView(buffer);
    const magic = view.getUint32(0, true);
    if (magic !== $9c669110219a36c8$var$MAGIC) throw new Error(`Invalid tidemesh magic: 0x${magic.toString(16)} (expected 0x${$9c669110219a36c8$var$MAGIC.toString(16)})`);
    const version = view.getUint16(4, true);
    if (version !== 1) throw new Error(`Unsupported tidemesh version: ${version}`);
    const tideLevelCount = view.getUint16(6, true);
    const vertexCount = view.getUint32(16, true);
    const triangleCount = view.getUint32(20, true);
    const gridCols = view.getUint32(24, true);
    const gridRows = view.getUint32(28, true);
    const gridMinX = view.getFloat32(32, true);
    const gridMinY = view.getFloat32(36, true);
    const gridCellWidth = view.getFloat32(40, true);
    const gridCellHeight = view.getFloat32(44, true);
    let offset = $9c669110219a36c8$var$HEADER_BYTES;
    // Tide level table
    const tideLevels = new Float32Array(buffer, offset, tideLevelCount);
    offset += tideLevelCount * 4;
    // Vertex positions
    const vertexPositions = new Float32Array(buffer, offset, vertexCount * 2);
    offset += vertexCount * 8;
    // Flow data: tideLevelCount arrays, each vertexCount * 4 floats
    const flowData = [];
    for(let t = 0; t < tideLevelCount; t++){
        const floatCount = vertexCount * 4;
        flowData.push(new Float32Array(buffer, offset, floatCount));
        offset += floatCount * 4;
    }
    // Index data
    const indexCount = triangleCount * 3;
    const indices = new Uint32Array(buffer, offset, indexCount);
    offset += indexCount * 4;
    // Grid cell headers
    const numCells = gridCols * gridRows;
    const gridCellHeaders = new Uint32Array(buffer, offset, numCells * 2);
    offset += numCells * 8;
    // Grid triangle lists (remaining data)
    const remainingU32s = (buffer.byteLength - offset) / 4;
    const gridTriangleLists = new Uint32Array(buffer, offset, remainingU32s);
    return {
        tideLevels: tideLevels,
        vertexPositions: vertexPositions,
        flowData: flowData,
        indices: indices,
        vertexCount: vertexCount,
        triangleCount: triangleCount,
        gridCols: gridCols,
        gridRows: gridRows,
        gridMinX: gridMinX,
        gridMinY: gridMinY,
        gridCellWidth: gridCellWidth,
        gridCellHeight: gridCellHeight,
        gridCellHeaders: gridCellHeaders,
        gridTriangleLists: gridTriangleLists
    };
}


async function $b8c5d0f3ca1ec306$export$7a9023d8ad286374(url) {
    const response = await fetch(url);
    if (!response.ok) throw new Error(`Failed to fetch tidemesh: ${response.status} ${response.statusText}`);
    const buffer = await response.arrayBuffer();
    return (0, $9c669110219a36c8$export$189a298f328743d5)(buffer);
}


/** Semi-diurnal tidal period in seconds (~12.42 hours) */ const $5f98c30f628d2045$var$TIDAL_PERIOD_SECONDS = 44712;
class $5f98c30f628d2045$export$498b84375d34fec1 extends (0, $c59361981bac2575$export$4342ba5c6ad1f6f1) {
    constructor(){
        super(), this.id = "tidalResources", this.tickLayer = "query", this.gpuBuffer = null, this.tidalPhase = 0, this.tidalStrength = 1.5 // ft/s max current speed
        , this.loaded = false;
        this.packedBuffer = (0, $1863fd274cf26361$export$2a9f1f798f1e6547)();
    }
    /**
   * Load tidal flow mesh data from a URL.
   */ async loadTidemesh(url) {
        const data = await (0, $b8c5d0f3ca1ec306$export$7a9023d8ad286374)(url);
        this.packedBuffer = (0, $1863fd274cf26361$export$8a65ad61ae52f4d2)(data);
        this.loaded = true;
        // GPU buffer will be recreated on next access
        this.gpuBuffer?.destroy();
        this.gpuBuffer = null;
    }
    /**
   * Get or create the packed GPU buffer for binding in query/render shaders.
   */ getPackedBuffer(device) {
        if (!this.gpuBuffer) {
            this.gpuBuffer = device.createBuffer({
                size: this.packedBuffer.byteLength,
                usage: GPUBufferUsage.STORAGE | GPUBufferUsage.COPY_DST,
                label: "tidemesh-packed"
            });
            device.queue.writeBuffer(this.gpuBuffer, 0, this.packedBuffer);
        }
        return this.gpuBuffer;
    }
    /**
   * Get the current tidal phase (0..2*PI over one tidal cycle).
   */ getTidalPhase() {
        return this.tidalPhase;
    }
    /**
   * Get the tidal strength scale factor (ft/s).
   */ getTidalStrength() {
        return this.tidalStrength;
    }
    /**
   * Set the tidal strength scale factor (ft/s).
   */ setTidalStrength(strength) {
        this.tidalStrength = strength;
    }
    /**
   * Whether tidal mesh data has been loaded.
   */ isLoaded() {
        return this.loaded;
    }
    /**
   * Update tidal phase from game-world time each tick.
   *
   * Semi-diurnal tide: ~12.42 hour period.
   * tidalPhase rotates 0..2*PI over one tidal cycle.
   */ onTick() {
        const timeOfDay = this.game.entities.tryGetSingleton((0, $4df5c29ec7839388$export$1467403458327a44));
        if (timeOfDay) {
            const timeInSeconds = timeOfDay.getTimeInSeconds();
            this.tidalPhase = timeInSeconds / $5f98c30f628d2045$var$TIDAL_PERIOD_SECONDS * Math.PI * 2 % (Math.PI * 2);
        }
    }
    onDestroy() {
        this.gpuBuffer?.destroy();
        this.gpuBuffer = null;
    }
}
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $aa1f0309d9dba6d2$export$af631764ddc44097)("tick")
], $5f98c30f628d2045$export$498b84375d34fec1.prototype, "onTick", null);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $aa1f0309d9dba6d2$export$af631764ddc44097)("destroy")
], $5f98c30f628d2045$export$498b84375d34fec1.prototype, "onDestroy", null);







/**
 * Water Query Compute Shader
 *
 * Samples water data (height, velocity, normals, depth) at arbitrary query points.
 * Uses the same modular shader code as the water state shader.
 * Includes modifier support for wakes, ripples, currents, and obstacles.
 *
 * Input:  pointBuffer (storage) - array of vec2<f32> query points
 * Output: resultBuffer (storage) - array of WaterQueryResult structs
 */ 


/**
 * Packed wavefront mesh accessor functions for reading from a single array<u32> buffer.
 *
 * Buffer layout matches MeshPacking.ts:
 *
 * GLOBAL HEADER (16 u32s):
 *   [0]     numWaveSources
 *   [1..8]  meshOffset[0..7]
 *   [9..15] padding
 *
 * PER-WAVE MESH HEADER (16 u32s):
 *   [+0]  vertexOffset      [+1]  vertexCount
 *   [+2]  indexOffset        [+3]  triangleCount
 *   [+4]  gridOffset         [+5]  gridCols
 *   [+6]  gridRows           [+7]  gridMinX (f32)
 *   [+8]  gridMinY (f32)     [+9]  gridCellWidth (f32)
 *   [+10] gridCellHeight (f32) [+11] gridCosA (f32)
 *   [+12] gridSinA (f32)     [+13..15] padding
 *
 * All float values are stored as u32 and recovered via bitcast<f32>().
 */ const $fc61fa53c7d19e1c$export$e1ed465c998eb160 = {
    preamble: /*wgsl*/ `
struct MeshHeader {
  vertexOffset: u32,
  vertexCount: u32,
  indexOffset: u32,
  triangleCount: u32,
  gridOffset: u32,
  gridCols: u32,
  gridRows: u32,
  gridMinX: f32,
  gridMinY: f32,
  gridCellWidth: f32,
  gridCellHeight: f32,
  gridCosA: f32,
  gridSinA: f32,
}
`,
    code: ""
};
const $fc61fa53c7d19e1c$export$d06bf2621b87c108 = {
    preamble: /*wgsl*/ `
struct MeshLookupResult {
  phasorCos: f32,
  phasorSin: f32,
  found: bool,
}
`,
    code: ""
};
const $fc61fa53c7d19e1c$export$edd137cb0b36f2fc = {
    code: /*wgsl*/ `
fn getMeshNumWaves(packed: ptr<storage, array<u32>, read>) -> u32 {
  return (*packed)[0u];
}
`
};
const $fc61fa53c7d19e1c$export$5c3e182cad88d138 = {
    dependencies: [
        $fc61fa53c7d19e1c$export$e1ed465c998eb160
    ],
    code: /*wgsl*/ `
fn getMeshHeader(packed: ptr<storage, array<u32>, read>, waveIndex: u32) -> MeshHeader {
  let headerOffset = (*packed)[1u + waveIndex];
  var h: MeshHeader;
  h.vertexOffset = (*packed)[headerOffset + 0u];
  h.vertexCount = (*packed)[headerOffset + 1u];
  h.indexOffset = (*packed)[headerOffset + 2u];
  h.triangleCount = (*packed)[headerOffset + 3u];
  h.gridOffset = (*packed)[headerOffset + 4u];
  h.gridCols = (*packed)[headerOffset + 5u];
  h.gridRows = (*packed)[headerOffset + 6u];
  h.gridMinX = bitcast<f32>((*packed)[headerOffset + 7u]);
  h.gridMinY = bitcast<f32>((*packed)[headerOffset + 8u]);
  h.gridCellWidth = bitcast<f32>((*packed)[headerOffset + 9u]);
  h.gridCellHeight = bitcast<f32>((*packed)[headerOffset + 10u]);
  h.gridCosA = bitcast<f32>((*packed)[headerOffset + 11u]);
  h.gridSinA = bitcast<f32>((*packed)[headerOffset + 12u]);
  return h;
}
`
};
const $fc61fa53c7d19e1c$export$bbb0487e465fc9bc = {
    code: /*wgsl*/ `
fn getMeshVertexPos(packed: ptr<storage, array<u32>, read>, vertexOffset: u32, index: u32) -> vec2<f32> {
  let base = vertexOffset + index * 6u;
  return vec2<f32>(
    bitcast<f32>((*packed)[base]),
    bitcast<f32>((*packed)[base + 1u])
  );
}
`
};
const $fc61fa53c7d19e1c$export$93666e3b3f9e453 = {
    code: /*wgsl*/ `
fn getMeshVertexAttribs(packed: ptr<storage, array<u32>, read>, vertexOffset: u32, index: u32) -> vec4<f32> {
  let base = vertexOffset + index * 6u;
  return vec4<f32>(
    bitcast<f32>((*packed)[base + 2u]),
    bitcast<f32>((*packed)[base + 3u]),
    bitcast<f32>((*packed)[base + 4u]),
    bitcast<f32>((*packed)[base + 5u])
  );
}
`
};
const $fc61fa53c7d19e1c$export$ef40cf2b33923a48 = {
    code: /*wgsl*/ `
fn getMeshTriangle(packed: ptr<storage, array<u32>, read>, indexOffset: u32, triIndex: u32) -> vec3<u32> {
  let base = indexOffset + triIndex * 3u;
  return vec3<u32>(
    (*packed)[base],
    (*packed)[base + 1u],
    (*packed)[base + 2u]
  );
}
`
};
const $fc61fa53c7d19e1c$export$dd7f3b3561b45947 = {
    code: /*wgsl*/ `
fn getMeshGridCell(packed: ptr<storage, array<u32>, read>, gridOffset: u32, cellIndex: u32) -> vec2<u32> {
  let base = gridOffset + cellIndex * 2u;
  return vec2<u32>(
    (*packed)[base],
    (*packed)[base + 1u]
  );
}
`
};
const $fc61fa53c7d19e1c$export$ae5310f1d0c067e0 = {
    code: /*wgsl*/ `
fn getMeshGridTriIndex(packed: ptr<storage, array<u32>, read>, listOffset: u32) -> u32 {
  return (*packed)[listOffset];
}
`
};
const $fc61fa53c7d19e1c$export$2ab14ac05b6d942d = {
    code: /*wgsl*/ `
fn barycentric(p: vec2<f32>, a: vec2<f32>, b: vec2<f32>, c: vec2<f32>) -> vec3<f32> {
  let v0 = b - a;
  let v1 = c - a;
  let v2 = p - a;

  let d00 = dot(v0, v0);
  let d01 = dot(v0, v1);
  let d11 = dot(v1, v1);
  let d20 = dot(v2, v0);
  let d21 = dot(v2, v1);

  let denom = d00 * d11 - d01 * d01;
  if (abs(denom) < 1e-10) {
    return vec3<f32>(-1.0, -1.0, -1.0); // Degenerate triangle
  }

  let invDenom = 1.0 / denom;
  let v = (d11 * d20 - d01 * d21) * invDenom;
  let w = (d00 * d21 - d01 * d20) * invDenom;
  let u = 1.0 - v - w;

  return vec3<f32>(u, v, w);
}
`
};
const $fc61fa53c7d19e1c$export$d78ee8fb5b2f26b1 = {
    dependencies: [
        $fc61fa53c7d19e1c$export$e1ed465c998eb160,
        $fc61fa53c7d19e1c$export$d06bf2621b87c108,
        $fc61fa53c7d19e1c$export$edd137cb0b36f2fc,
        $fc61fa53c7d19e1c$export$5c3e182cad88d138,
        $fc61fa53c7d19e1c$export$bbb0487e465fc9bc,
        $fc61fa53c7d19e1c$export$93666e3b3f9e453,
        $fc61fa53c7d19e1c$export$ef40cf2b33923a48,
        $fc61fa53c7d19e1c$export$dd7f3b3561b45947,
        $fc61fa53c7d19e1c$export$ae5310f1d0c067e0,
        $fc61fa53c7d19e1c$export$2ab14ac05b6d942d
    ],
    code: /*wgsl*/ `
fn lookupMeshForWave(
  worldPos: vec2<f32>,
  packed: ptr<storage, array<u32>, read>,
  waveIndex: u32,
) -> MeshLookupResult {
  var result: MeshLookupResult;
  result.phasorCos = 0.0;
  result.phasorSin = 0.0;
  result.found = false;

  let numWaves = getMeshNumWaves(packed);
  if (waveIndex >= numWaves) {
    result.phasorCos = 1.0;
    return result;
  }

  let header = getMeshHeader(packed, waveIndex);
  if (header.triangleCount == 0u) {
    result.phasorCos = 1.0;
    return result;
  }

  // Rotate world position into wave-aligned grid space
  let rx = worldPos.x * header.gridCosA + worldPos.y * header.gridSinA;
  let ry = -worldPos.x * header.gridSinA + worldPos.y * header.gridCosA;

  // Map rotated position to grid cell
  let gx = (rx - header.gridMinX) / header.gridCellWidth;
  let gy = (ry - header.gridMinY) / header.gridCellHeight;

  let col = i32(floor(gx));
  let row = i32(floor(gy));

  // Out of grid bounds \u{2192} open ocean
  if (col < 0 || col >= i32(header.gridCols) || row < 0 || row >= i32(header.gridRows)) {
    result.phasorCos = 1.0;
    return result;
  }

  let cellIndex = u32(row) * header.gridCols + u32(col);
  let cell = getMeshGridCell(packed, header.gridOffset, cellIndex);
  let triListOffset = cell.x;
  let triListCount = cell.y;

  // Iterate ALL triangles in this cell, accumulating phasor contributions
  for (var t = 0u; t < triListCount; t++) {
    let triIndex = getMeshGridTriIndex(packed, triListOffset + t);
    let tri = getMeshTriangle(packed, header.indexOffset, triIndex);

    let a = getMeshVertexPos(packed, header.vertexOffset, tri.x);
    let b = getMeshVertexPos(packed, header.vertexOffset, tri.y);
    let c = getMeshVertexPos(packed, header.vertexOffset, tri.z);

    let bary = barycentric(worldPos, a, b, c);

    // Check if point is inside triangle (with small tolerance)
    if (bary.x >= -0.001 && bary.y >= -0.001 && bary.z >= -0.001) {
      let attribA = getMeshVertexAttribs(packed, header.vertexOffset, tri.x);
      let attribB = getMeshVertexAttribs(packed, header.vertexOffset, tri.y);
      let attribC = getMeshVertexAttribs(packed, header.vertexOffset, tri.z);

      // Barycentric interpolation of attributes
      let interp = attribA * bary.x + attribB * bary.y + attribC * bary.z;

      let amp = interp.x;   // amplitudeFactor
      let phase = interp.z; // phaseOffset
      result.phasorCos += amp * cos(phase);
      result.phasorSin += amp * sin(phase);
      result.found = true;
    }
  }

  // Inside grid but no containing triangle: this is a shadow zone (zero amplitude).
  // Points outside the grid already returned open ocean defaults above.

  return result;
}
`
};




/**
 * Packed tide mesh accessor functions for reading from a single array<u32> buffer.
 *
 * Buffer layout matches TideMeshPacking.ts:
 *
 * HEADER (16 u32s):
 *   [0]  tideLevelCount
 *   [1]  vertexCount
 *   [2]  triangleCount
 *   [3]  gridCols
 *   [4]  gridRows
 *   [5]  gridMinX (f32 as u32)
 *   [6]  gridMinY (f32 as u32)
 *   [7]  gridCellWidth (f32 as u32)
 *   [8]  gridCellHeight (f32 as u32)
 *   [9]  tideLevelTableOffset
 *   [10] vertexDataOffset
 *   [11] flowDataOffset
 *   [12] indexDataOffset
 *   [13] gridCellHeadersOffset
 *   [14] gridTriangleListsOffset
 *   [15] padding
 *
 * DATA SECTIONS:
 *   Tide level table: tideLevelCount f32s (as u32 bitcast)
 *   Vertex positions: vertexCount * 2 f32s (as u32)
 *   Flow data: tideLevelCount * vertexCount * 4 f32s (as u32) — (vx_a, vy_a, vx_b, vy_b)
 *   Index data: triangleCount * 3 u32s
 *   Grid cell headers: gridCols * gridRows * 2 u32s (offset, count)
 *   Grid triangle lists: variable u32s
 *
 * All float values are stored as u32 and recovered via bitcast<f32>().
 */ 
const $8cb2d80afc13393b$export$2ff41c9d7b687dd1 = {
    code: /*wgsl*/ `
fn tideMeshReadF32(packed: ptr<storage, array<u32>, read>, index: u32) -> f32 {
  return bitcast<f32>((*packed)[index]);
}
`
};
const $8cb2d80afc13393b$export$5c78d5cb1cc821ec = {
    dependencies: [
        $8cb2d80afc13393b$export$2ff41c9d7b687dd1
    ],
    code: /*wgsl*/ `
fn tideMeshGetVertex(packed: ptr<storage, array<u32>, read>, vertexDataOffset: u32, idx: u32) -> vec2<f32> {
  let base = vertexDataOffset + idx * 2u;
  return vec2<f32>(
    tideMeshReadF32(packed, base),
    tideMeshReadF32(packed, base + 1u)
  );
}
`
};
const $8cb2d80afc13393b$export$ff83b1261ed1457a = {
    dependencies: [
        $8cb2d80afc13393b$export$2ff41c9d7b687dd1
    ],
    code: /*wgsl*/ `
fn tideMeshGetFlow(
  packed: ptr<storage, array<u32>, read>,
  flowDataOffset: u32,
  vertexCount: u32,
  tideLevelIdx: u32,
  vertexIdx: u32,
) -> vec4<f32> {
  let base = flowDataOffset + (tideLevelIdx * vertexCount + vertexIdx) * 4u;
  return vec4<f32>(
    tideMeshReadF32(packed, base),
    tideMeshReadF32(packed, base + 1u),
    tideMeshReadF32(packed, base + 2u),
    tideMeshReadF32(packed, base + 3u)
  );
}
`
};
const $8cb2d80afc13393b$export$659b61c150e70967 = {
    dependencies: [
        (0, $fc61fa53c7d19e1c$export$2ab14ac05b6d942d)
    ],
    code: ""
};
const $8cb2d80afc13393b$export$85bc3cad1999a252 = {
    dependencies: [
        $8cb2d80afc13393b$export$2ff41c9d7b687dd1,
        $8cb2d80afc13393b$export$5c78d5cb1cc821ec,
        $8cb2d80afc13393b$export$ff83b1261ed1457a,
        (0, $fc61fa53c7d19e1c$export$2ab14ac05b6d942d)
    ],
    code: /*wgsl*/ `
fn lookupTidalFlow(
  worldPos: vec2<f32>,
  packedTide: ptr<storage, array<u32>, read>,
  tideHeight: f32,
  tidalPhase: f32,
  tidalStrength: f32,
) -> vec2<f32> {
  // Read header
  let tideLevelCount = (*packedTide)[0u];
  let vertexCount = (*packedTide)[1u];
  let triangleCount = (*packedTide)[2u];
  let gridCols = (*packedTide)[3u];
  let gridRows = (*packedTide)[4u];
  let gridMinX = tideMeshReadF32(packedTide, 5u);
  let gridMinY = tideMeshReadF32(packedTide, 6u);
  let gridCellWidth = tideMeshReadF32(packedTide, 7u);
  let gridCellHeight = tideMeshReadF32(packedTide, 8u);
  let tideLevelTableOffset = (*packedTide)[9u];
  let vertexDataOffset = (*packedTide)[10u];
  let flowDataOffset = (*packedTide)[11u];
  let indexDataOffset = (*packedTide)[12u];
  let gridCellHeadersOffset = (*packedTide)[13u];
  let gridTriangleListsOffset = (*packedTide)[14u];

  if (tideLevelCount == 0u) {
    return vec2<f32>(0.0, 0.0);
  }

  // Map world position to grid cell (axis-aligned, no rotation)
  let gx = (worldPos.x - gridMinX) / gridCellWidth;
  let gy = (worldPos.y - gridMinY) / gridCellHeight;

  let col = i32(floor(gx));
  let row = i32(floor(gy));

  // Bounds check
  if (col < 0 || col >= i32(gridCols) || row < 0 || row >= i32(gridRows)) {
    return vec2<f32>(0.0, 0.0);
  }

  // Read cell header (offset, count)
  let cellIndex = u32(row) * gridCols + u32(col);
  let cellBase = gridCellHeadersOffset + cellIndex * 2u;
  let triListOffset = (*packedTide)[cellBase];
  let triListCount = (*packedTide)[cellBase + 1u];

  // Search triangles in this cell
  for (var t = 0u; t < triListCount; t++) {
    let triIndex = (*packedTide)[triListOffset + t];

    // Read 3 vertex indices
    let idxBase = indexDataOffset + triIndex * 3u;
    let i0 = (*packedTide)[idxBase];
    let i1 = (*packedTide)[idxBase + 1u];
    let i2 = (*packedTide)[idxBase + 2u];

    // Read vertex positions
    let v0 = tideMeshGetVertex(packedTide, vertexDataOffset, i0);
    let v1 = tideMeshGetVertex(packedTide, vertexDataOffset, i1);
    let v2 = tideMeshGetVertex(packedTide, vertexDataOffset, i2);

    // Compute barycentric coordinates
    let bary = barycentric(worldPos, v0, v1, v2);

    // Check if point is inside triangle (with small tolerance)
    if (bary.x >= -0.001 && bary.y >= -0.001 && bary.z >= -0.001) {
      // Find bracketing tide levels
      var lowerIdx = 0u;
      var upperIdx = 0u;
      var interpT = 0.0f;

      if (tideLevelCount == 1u) {
        lowerIdx = 0u;
        upperIdx = 0u;
        interpT = 0.0;
      } else {
        // Read tide levels to find bracket
        let firstLevel = tideMeshReadF32(packedTide, tideLevelTableOffset);
        let lastLevel = tideMeshReadF32(packedTide, tideLevelTableOffset + tideLevelCount - 1u);

        if (tideHeight <= firstLevel) {
          lowerIdx = 0u;
          upperIdx = 0u;
          interpT = 0.0;
        } else if (tideHeight >= lastLevel) {
          lowerIdx = tideLevelCount - 1u;
          upperIdx = tideLevelCount - 1u;
          interpT = 0.0;
        } else {
          // Search for bracket
          for (var li = 0u; li < tideLevelCount - 1u; li++) {
            let levelLow = tideMeshReadF32(packedTide, tideLevelTableOffset + li);
            let levelHigh = tideMeshReadF32(packedTide, tideLevelTableOffset + li + 1u);
            if (tideHeight >= levelLow && tideHeight <= levelHigh) {
              lowerIdx = li;
              upperIdx = li + 1u;
              let range = levelHigh - levelLow;
              if (abs(range) > 1e-6) {
                interpT = (tideHeight - levelLow) / range;
              }
              break;
            }
          }
        }
      }

      // Read and interpolate flow at the lower tide level
      let flowA0 = tideMeshGetFlow(packedTide, flowDataOffset, vertexCount, lowerIdx, i0);
      let flowA1 = tideMeshGetFlow(packedTide, flowDataOffset, vertexCount, lowerIdx, i1);
      let flowA2 = tideMeshGetFlow(packedTide, flowDataOffset, vertexCount, lowerIdx, i2);
      let flowLower = flowA0 * bary.x + flowA1 * bary.y + flowA2 * bary.z;

      // Read and interpolate flow at the upper tide level
      let flowB0 = tideMeshGetFlow(packedTide, flowDataOffset, vertexCount, upperIdx, i0);
      let flowB1 = tideMeshGetFlow(packedTide, flowDataOffset, vertexCount, upperIdx, i1);
      let flowB2 = tideMeshGetFlow(packedTide, flowDataOffset, vertexCount, upperIdx, i2);
      let flowUpper = flowB0 * bary.x + flowB1 * bary.y + flowB2 * bary.z;

      // Lerp between tide levels
      let flow = mix(flowLower, flowUpper, interpT);

      // Blend orthogonal fields: field A (cos) + field B (sin)
      let vx = flow.x * cos(tidalPhase) + flow.z * sin(tidalPhase);
      let vy = flow.y * cos(tidalPhase) + flow.w * sin(tidalPhase);

      return vec2<f32>(vx, vy) * tidalStrength;
    }
  }

  // No containing triangle found
  return vec2<f32>(0.0, 0.0);
}
`
};


/**
 * Water modifier shader modules.
 * Compute contributions from wakes, ripples, currents, and obstacles.
 */ const $bda38aaac68f4f20$export$2e885783e07a0a70 = {
    code: /*wgsl*/ `
    // Compute wake contribution as a Gaussian ring pulse.
    // Returns vec4<f32>(height, velocityX, velocityY, turbulence)
    fn computeWakeContribution(
      worldX: f32,
      worldY: f32,
      base: u32,
      modifiers: ptr<storage, array<f32>, read>
    ) -> vec4<f32> {
      let srcX = modifiers[base + 5u];
      let srcY = modifiers[base + 6u];
      let ringRadius = modifiers[base + 7u];
      let ringWidth = modifiers[base + 8u];
      let amplitude = modifiers[base + 9u];
      let omega = modifiers[base + 10u];

      let dx = worldX - srcX;
      let dy = worldY - srcY;
      let dist = sqrt(dx * dx + dy * dy);

      // Distance from the ring center
      let distFromRing = dist - ringRadius;

      // Gaussian ring profile
      let ring = exp(-(distFromRing * distFromRing) / (ringWidth * ringWidth));

      // Local surface elevation at this point.
      let localAmp = amplitude * ring;

      // Radial orbital velocity: linear wave theory gives |u| = A * omega,
      // in phase with surface elevation, directed radially outward at the crest.
      // Cylindrical spreading (1/sqrt(r)) is already baked into amplitude on the CPU.
      let invDist = select(0.0, 1.0 / dist, dist > 1e-4);
      let nx = dx * invDist;
      let ny = dy * invDist;
      let vRadial = localAmp * omega;

      return vec4<f32>(localAmp, vRadial * nx, vRadial * ny, 0.0);
    }
  `
};
const $bda38aaac68f4f20$export$a03be398942ebba0 = {
    code: /*wgsl*/ `
    fn computeFoamContribution(
      worldX: f32,
      worldY: f32,
      base: u32,
      modifiers: ptr<storage, array<f32>, read>
    ) -> vec4<f32> {
      let srcX = modifiers[base + 5u];
      let srcY = modifiers[base + 6u];
      let radius = modifiers[base + 7u];
      let intensity = modifiers[base + 8u];

      let dx = worldX - srcX;
      let dy = worldY - srcY;
      let dist2 = dx * dx + dy * dy;
      let rSq = max(radius * radius, 1e-4);

      let falloff = exp(-dist2 / rSq);
      return vec4<f32>(0.0, 0.0, 0.0, intensity * falloff);
    }
  `
};
const $bda38aaac68f4f20$export$207e3658b2b44e61 = {
    code: /*wgsl*/ `
    // Compute ripple contribution at a world position
    // worldX, worldY: query position (feet)
    // base: start index in modifiers buffer
    // modifiers: modifier data storage buffer
    // Returns vec4<f32>(height, velocityX, velocityY, turbulence)
    fn computeRippleContribution(
      worldX: f32,
      worldY: f32,
      base: u32,
      modifiers: ptr<storage, array<f32>, read>
    ) -> vec4<f32> {
      let radius = modifiers[base + 5u];
      let intensity = modifiers[base + 6u];
      let phase = modifiers[base + 7u];

      let minX = modifiers[base + 1u];
      let minY = modifiers[base + 2u];
      let maxX = modifiers[base + 3u];
      let maxY = modifiers[base + 4u];
      let centerX = (minX + maxX) * 0.5;
      let centerY = (minY + maxY) * 0.5;
      let dx = worldX - centerX;
      let dy = worldY - centerY;
      let dist = sqrt(dx * dx + dy * dy);

      // Ring-based falloff (2ft wide ring)
      let ringWidth = 2.0;
      let distFromRing = abs(dist - radius);
      let falloff = max(0.0, 1.0 - distFromRing / ringWidth);

      // Cosine wave profile
      let height = intensity * falloff * cos(phase);

      return vec4<f32>(height, 0.0, 0.0, 0.0);
    }
  `
};
const $bda38aaac68f4f20$export$e26de0a1a0e2f5ea = {
    code: /*wgsl*/ `
    // Compute current contribution at a world position
    // worldX, worldY: query position (feet)
    // base: start index in modifiers buffer
    // modifiers: modifier data storage buffer
    // Returns vec4<f32>(height, velocityX, velocityY, turbulence)
    fn computeCurrentContribution(
      worldX: f32,
      worldY: f32,
      base: u32,
      modifiers: ptr<storage, array<f32>, read>
    ) -> vec4<f32> {
      let velocityX = modifiers[base + 5u];
      let velocityY = modifiers[base + 6u];
      let fadeDistance = modifiers[base + 7u];

      // Simple constant velocity for now
      return vec4<f32>(0.0, velocityX, velocityY, 0.0);
    }
  `
};
const $bda38aaac68f4f20$export$1cb01bccd3164862 = {
    code: /*wgsl*/ `
    // Compute obstacle contribution at a world position
    // worldX, worldY: query position (feet)
    // base: start index in modifiers buffer
    // modifiers: modifier data storage buffer
    // Returns vec4<f32>(height, velocityX, velocityY, turbulence)
    fn computeObstacleContribution(
      worldX: f32,
      worldY: f32,
      base: u32,
      modifiers: ptr<storage, array<f32>, read>
    ) -> vec4<f32> {
      let dampingFactor = modifiers[base + 5u];

      // Not implemented yet - return zero contribution
      return vec4<f32>(0.0, 0.0, 0.0, 0.0);
    }
  `
};
const $bda38aaac68f4f20$export$7f28ec86dc4d3cbf = {
    code: /*wgsl*/ `
    // Modifier type discriminators
    const MODIFIER_TYPE_WAKE: u32 = 1u;
    const MODIFIER_TYPE_RIPPLE: u32 = 2u;
    const MODIFIER_TYPE_CURRENT: u32 = 3u;
    const MODIFIER_TYPE_OBSTACLE: u32 = 4u;
    const MODIFIER_TYPE_FOAM: u32 = 5u;
  `
};
const $bda38aaac68f4f20$export$21e11df0884ecc79 = {
    code: /*wgsl*/ `
    // Get contribution from a single modifier with type discrimination
    // worldX, worldY: query position (feet)
    // modifierIndex: modifier index
    // modifiers: modifier data storage buffer
    // floatsPerModifier: number of floats per modifier
    // Returns vec4<f32>(height, velocityX, velocityY, turbulence)
    fn getModifierContribution(
      worldX: f32,
      worldY: f32,
      modifierIndex: u32,
      modifiers: ptr<storage, array<f32>, read>,
      floatsPerModifier: u32
    ) -> vec4<f32> {
      let base = modifierIndex * floatsPerModifier;

      // Read header
      let modType = u32(modifiers[base + 0u]);
      let minX = modifiers[base + 1u];
      let minY = modifiers[base + 2u];
      let maxX = modifiers[base + 3u];
      let maxY = modifiers[base + 4u];

      // Bounds culling (early exit)
      if (worldX < minX || worldX > maxX || worldY < minY || worldY > maxY) {
        return vec4<f32>(0.0, 0.0, 0.0, 0.0);
      }

      // Type discrimination
      switch (modType) {
        case MODIFIER_TYPE_WAKE: {
          return computeWakeContribution(worldX, worldY, base, modifiers);
        }
        case MODIFIER_TYPE_RIPPLE: {
          return computeRippleContribution(worldX, worldY, base, modifiers);
        }
        case MODIFIER_TYPE_CURRENT: {
          return computeCurrentContribution(worldX, worldY, base, modifiers);
        }
        case MODIFIER_TYPE_OBSTACLE: {
          return computeObstacleContribution(worldX, worldY, base, modifiers);
        }
        case MODIFIER_TYPE_FOAM: {
          return computeFoamContribution(worldX, worldY, base, modifiers);
        }
        default: {
          return vec4<f32>(0.0, 0.0, 0.0, 0.0);
        }
      }
    }
  `,
    dependencies: [
        $bda38aaac68f4f20$export$7f28ec86dc4d3cbf,
        $bda38aaac68f4f20$export$2e885783e07a0a70,
        $bda38aaac68f4f20$export$207e3658b2b44e61,
        $bda38aaac68f4f20$export$e26de0a1a0e2f5ea,
        $bda38aaac68f4f20$export$1cb01bccd3164862,
        $bda38aaac68f4f20$export$a03be398942ebba0
    ]
};
const $bda38aaac68f4f20$export$c6348f7e6c67b1cb = {
    code: /*wgsl*/ `
    // Calculate combined modifier contributions
    // worldX, worldY: query position (feet)
    // modifierCount: number of active modifiers
    // maxModifiers: maximum modifiers to check
    // modifiers: modifier data storage buffer
    // floatsPerModifier: number of floats per modifier
    // Returns vec4<f32>(totalHeight, totalVelX, totalVelY, maxTurbulence)
    fn calculateModifiers(
      worldX: f32,
      worldY: f32,
      modifierCount: u32,
      maxModifiers: u32,
      modifiers: ptr<storage, array<f32>, read>,
      floatsPerModifier: u32
    ) -> vec4<f32> {
      var totalHeight: f32 = 0.0;
      var totalVelX: f32 = 0.0;
      var totalVelY: f32 = 0.0;
      var maxTurb: f32 = 0.0;

      let count = min(modifierCount, maxModifiers);
      for (var i: u32 = 0u; i < count; i++) {
        let contrib = getModifierContribution(worldX, worldY, i, modifiers, floatsPerModifier);
        totalHeight += contrib.x;
        totalVelX += contrib.y;
        totalVelY += contrib.z;
        maxTurb = max(maxTurb, contrib.w);
      }

      return vec4<f32>(totalHeight, totalVelX, totalVelY, maxTurb);
    }
  `,
    dependencies: [
        $bda38aaac68f4f20$export$21e11df0884ecc79
    ]
};




const $c68491a978aec922$var$WORKGROUP_SIZE = [
    64,
    1,
    1
];
const $c68491a978aec922$export$a1286f379a8cb567 = (0, $ca6793d1abd58997$export$99bb2281c7368d10)("Params", {
    pointCount: (0, $ca6793d1abd58997$export$8bacf4ad828c7fe7),
    time: (0, $ca6793d1abd58997$export$e33361ff41014190),
    tideHeight: (0, $ca6793d1abd58997$export$e33361ff41014190),
    modifierCount: (0, $ca6793d1abd58997$export$8bacf4ad828c7fe7),
    contourCount: (0, $ca6793d1abd58997$export$8bacf4ad828c7fe7),
    defaultDepth: (0, $ca6793d1abd58997$export$e33361ff41014190),
    numWaves: (0, $ca6793d1abd58997$export$8bacf4ad828c7fe7),
    tidalPhase: (0, $ca6793d1abd58997$export$e33361ff41014190),
    tidalStrength: (0, $ca6793d1abd58997$export$e33361ff41014190),
    _padding2: (0, $ca6793d1abd58997$export$e33361ff41014190),
    _padding3: (0, $ca6793d1abd58997$export$e33361ff41014190),
    _padding4: (0, $ca6793d1abd58997$export$e33361ff41014190)
});
/**
 * Module containing Params and result structs, plus bindings.
 */ const $c68491a978aec922$var$waterQueryParamsModule = {
    dependencies: [
        (0, $d2770abe96d7e153$export$bf8b0ba9719f8192)
    ],
    preamble: /*wgsl*/ `
// Query parameters (48 bytes)
struct Params {
  pointCount: u32,
  time: f32,
  tideHeight: f32,
  modifierCount: u32,
  contourCount: u32,
  defaultDepth: f32,
  numWaves: u32,
  tidalPhase: f32,
  tidalStrength: f32,
  _padding2: f32,
  _padding3: f32,
  _padding4: f32,
}

// Result structure (matches WaterQueryResult interface)
struct WaterQueryResult {
  surfaceHeight: f32,
  velocityX: f32,
  velocityY: f32,
  normalX: f32,
  normalY: f32,
  depth: f32,
}
  `,
    bindings: {
        params: {
            type: "uniform",
            wgslType: "Params"
        },
        waveData: {
            type: "storage",
            wgslType: "array<f32>"
        },
        modifiers: {
            type: "storage",
            wgslType: "array<f32>"
        },
        packedMesh: {
            type: "storage",
            wgslType: "array<u32>"
        },
        packedTerrain: {
            type: "storage",
            wgslType: "array<u32>"
        },
        packedTideMesh: {
            type: "storage",
            wgslType: "array<u32>"
        },
        pointBuffer: {
            type: "storage",
            wgslType: "array<vec2<f32>>"
        },
        resultBuffer: {
            type: "storageRW",
            wgslType: "array<WaterQueryResult>"
        }
    },
    code: ""
};
/**
 * Module containing the compute entry point.
 */ const $c68491a978aec922$var$waterQueryMainModule = {
    dependencies: [
        $c68491a978aec922$var$waterQueryParamsModule,
        (0, $29eb555f6f6dd288$export$d30c1ef1b1de4c71),
        (0, $be2e36db65cf9cb3$export$e6be6718ae498db4),
        (0, $bda38aaac68f4f20$export$c6348f7e6c67b1cb),
        (0, $fc61fa53c7d19e1c$export$d78ee8fb5b2f26b1),
        (0, $cef462b61853a9de$export$3fb9b31381321192),
        (0, $8cb2d80afc13393b$export$85bc3cad1999a252)
    ],
    code: /*wgsl*/ `
// Constants
const MAX_WAVES: i32 = ${(0, $b5703c4302ca52a6$export$f3ae2520668c9cb4)};
const GERSTNER_STEEPNESS: f32 = ${(0, $b5703c4302ca52a6$export$3964cd37339b1861)};
const WAVE_AMP_MOD_SPATIAL_SCALE: f32 = ${(0, $b5703c4302ca52a6$export$acb8118f0ec101ba)};
const WAVE_AMP_MOD_TIME_SCALE: f32 = ${(0, $b5703c4302ca52a6$export$c0f77092ccbbffbf)};
const WAVE_AMP_MOD_STRENGTH: f32 = ${(0, $b5703c4302ca52a6$export$22431cdd22054254)};

// Modifier constants
const MAX_MODIFIERS: u32 = ${(0, $cb7a1399420ef9b3$export$f163568a8f0e136f)}u;
const FLOATS_PER_MODIFIER: u32 = ${(0, $cb7a1399420ef9b3$export$e66a374ba39daa3c)}u;

// Normal computation sample offset
const NORMAL_SAMPLE_OFFSET: f32 = 1.0;

// Compute Gerstner wave result at a point using mesh lookup for per-wave data.
// Returns vec4<f32>(height + tide, velX, velY, dhdt).
fn computeWaveResultAtPoint(
  worldPos: vec2<f32>,
  ampMod: f32,
) -> vec4<f32> {
  // Look up per-wave energy factors, direction offsets, and phase corrections from mesh
  var energyFactors: array<f32, MAX_WAVE_SOURCES>;
  var directionOffsets: array<f32, MAX_WAVE_SOURCES>;
  var phaseCorrections: array<f32, MAX_WAVE_SOURCES>;
  for (var i = 0u; i < u32(params.numWaves); i++) {
    let meshResult = lookupMeshForWave(worldPos, &packedMesh, i);
    let pc = meshResult.phasorCos;
    let ps = meshResult.phasorSin;
    energyFactors[i] = sqrt(pc * pc + ps * ps);
    directionOffsets[i] = 0.0;
    // Guard against atan2(0,0): WGSL spec leaves it undefined, some GPUs return NaN.
    // When the phasor is zero (full shadow) the phase correction is irrelevant anyway.
    phaseCorrections[i] = select(atan2(ps, pc), 0.0, pc == 0.0 && ps == 0.0);
  }

  // Calculate Gerstner waves with per-wave energy factors, direction bending, and phase corrections
  let waveResult = calculateGerstnerWaves(
    worldPos,
    params.time,
    &waveData,
    i32(params.numWaves),
    GERSTNER_STEEPNESS,
    energyFactors,
    directionOffsets,
    phaseCorrections,
    ampMod,
  );

  return vec4<f32>(waveResult.x + params.tideHeight, waveResult.y, waveResult.z, waveResult.w);
}

// Height-only helper for finite-difference normals.
fn computeHeightAtPoint(worldPos: vec2<f32>, ampMod: f32) -> f32 {
  return computeWaveResultAtPoint(worldPos, ampMod).x;
}

// Compute normal using finite differences
fn computeNormal(
  worldPos: vec2<f32>,
  ampMod: f32,
) -> vec2<f32> {
  let h0 = computeHeightAtPoint(worldPos, ampMod);
  let hx = computeHeightAtPoint(
    worldPos + vec2<f32>(NORMAL_SAMPLE_OFFSET, 0.0),
    ampMod,
  );
  let hy = computeHeightAtPoint(
    worldPos + vec2<f32>(0.0, NORMAL_SAMPLE_OFFSET),
    ampMod,
  );

  let dx = (hx - h0) / NORMAL_SAMPLE_OFFSET;
  let dy = (hy - h0) / NORMAL_SAMPLE_OFFSET;

  // Handle flat surface (no waves) - return up-facing normal
  let gradientLen = dx * dx + dy * dy;
  if (gradientLen < 0.0001) {
    return vec2<f32>(0.0, 0.0); // Flat surface, no horizontal tilt
  }

  return normalize(vec2<f32>(-dx, -dy));
}

@compute @workgroup_size(${$c68491a978aec922$var$WORKGROUP_SIZE[0]})
fn main(@builtin(global_invocation_id) globalId: vec3<u32>) {
  let index = globalId.x;

  if (index >= params.pointCount) {
    return;
  }

  let queryPoint = pointBuffer[index];

  // Compute terrain height for depth result
  let terrainHeight = computeTerrainHeight(
    queryPoint,
    &packedTerrain,
    params.contourCount,
    params.defaultDepth
  );

  // Sample amplitude modulation noise
  let ampModTime = params.time * WAVE_AMP_MOD_TIME_SCALE;
  let ampMod = 1.0 + simplex3D(vec3<f32>(
    queryPoint.x * WAVE_AMP_MOD_SPATIAL_SCALE,
    queryPoint.y * WAVE_AMP_MOD_SPATIAL_SCALE,
    ampModTime
  )) * WAVE_AMP_MOD_STRENGTH;

  // Compute wave result (height + horizontal orbital velocity) using mesh lookup
  let waveResult = computeWaveResultAtPoint(queryPoint, ampMod);
  let surfaceHeight = waveResult.x;
  let waveVelX = waveResult.y;
  let waveVelY = waveResult.z;

  // Compute normal
  let normal = computeNormal(queryPoint, ampMod);

  // Compute modifier contributions (wakes, ripples, currents, obstacles)
  let modifierResult = calculateModifiers(
    queryPoint.x, queryPoint.y,
    params.modifierCount, MAX_MODIFIERS,
    &modifiers, FLOATS_PER_MODIFIER
  );

  // Final surface height and depth
  let finalSurfaceHeight = surfaceHeight + modifierResult.x;
  let finalDepth = finalSurfaceHeight - terrainHeight;

  // Sample tidal flow from precomputed mesh
  let tidalVel = lookupTidalFlow(
    queryPoint,
    &packedTideMesh,
    params.tideHeight,
    params.tidalPhase,
    params.tidalStrength,
  );

  var result: WaterQueryResult;
  result.surfaceHeight = finalSurfaceHeight;
  result.velocityX = waveVelX + modifierResult.y + tidalVel.x;
  result.velocityY = waveVelY + modifierResult.z + tidalVel.y;
  result.normalX = normal.x;
  result.normalY = normal.y;
  result.depth = finalDepth;

  resultBuffer[index] = result;
}
  `
};
const $c68491a978aec922$export$46e5ccbd66e30701 = {
    modules: [
        $c68491a978aec922$var$waterQueryMainModule
    ],
    workgroupSize: $c68491a978aec922$var$WORKGROUP_SIZE,
    label: "WaterQueryShader"
};
function $c68491a978aec922$export$7f6fcb22d062d7e0() {
    return new (0, $4016c3d8f65071ed$export$cdde5429dd049099)($c68491a978aec922$export$46e5ccbd66e30701);
}



const $e92cdfa4485b40d6$var$MAX_WATER_QUERIES = 2 ** 15;
class $e92cdfa4485b40d6$export$82d267451e6430a extends (0, $5cb489536d94582d$export$b986383a50b53ea4) {
    constructor(){
        super((0, $f728bf7dee894052$export$1b2b4f6c83daac41), $e92cdfa4485b40d6$var$MAX_WATER_QUERIES), this.id = "waterQueryManager", this.tickLayer = "query", this.queryShader = null, this.uniformBuffer = null, this.placeholderPackedMeshBuffer = null, this.placeholderTideMeshBuffer = null, this.uniforms = (0, $c68491a978aec922$export$a1286f379a8cb567).create();
        this.queryShader = (0, $c68491a978aec922$export$7f6fcb22d062d7e0)();
    }
    async onAdd() {
        // Call parent onAdd (not async, so we need to handle separately)
        super.onAdd();
        // Initialize shader
        await this.queryShader.init();
        // Create uniform buffer for query parameters
        const device = this.game.getWebGPUDevice();
        this.uniformBuffer = device.createBuffer({
            label: "Water Query Uniform Buffer",
            size: (0, $c68491a978aec922$export$a1286f379a8cb567).byteSize,
            usage: GPUBufferUsage.UNIFORM | GPUBufferUsage.COPY_DST
        });
        // Create placeholder packed mesh buffer (empty - no wave sources)
        this.placeholderPackedMeshBuffer = (0, $9bee309488e32516$export$850e8c442d1d26f2)(this.game.getWebGPUDevice());
        // Create placeholder tide mesh buffer (empty - no tidal data)
        this.placeholderTideMeshBuffer = device.createBuffer({
            label: "Placeholder Tide Mesh Buffer",
            size: (0, $1863fd274cf26361$export$2a9f1f798f1e6547)().byteLength,
            usage: GPUBufferUsage.STORAGE | GPUBufferUsage.COPY_DST
        });
        device.queue.writeBuffer(this.placeholderTideMeshBuffer, 0, (0, $1863fd274cf26361$export$2a9f1f798f1e6547)());
    }
    getQueries() {
        return [
            ...this.game.entities.byConstructor((0, $2f31bbbd4b5b01e3$export$38b1d297f12cec06))
        ];
    }
    dispatchCompute(pointCount, commandEncoder) {
        if (pointCount === 0) return;
        if (!this.queryShader || !this.uniformBuffer) {
            console.warn("[WaterQuery] Shader not initialized");
            return;
        }
        const waterResources = this.game.entities.tryGetSingleton((0, $cb7a1399420ef9b3$export$56d2cf3a64cd00a4));
        if (!waterResources) {
            console.warn("[WaterQuery] WaterResources not found");
            return;
        }
        const wavePhysicsResources = this.game.entities.tryGetSingleton((0, $ffbca396848d8854$export$8b9e0edba56abb99));
        const packedMeshBuffer = wavePhysicsResources?.getPackedMeshBuffer() ?? this.placeholderPackedMeshBuffer;
        const terrainResources = this.game.entities.tryGetSingleton((0, $cd92036e590b44aa$export$74cf638da29b900d));
        if (!terrainResources) {
            console.warn("[WaterQuery] TerrainResources not found");
            return;
        }
        const tideHeight = waterResources.getTideHeight();
        const modifierCount = waterResources.getModifierCount();
        const tidalResources = this.game.entities.tryGetSingleton((0, $5f98c30f628d2045$export$498b84375d34fec1));
        const packedTideMeshBuffer = tidalResources?.getPackedBuffer(this.game.getWebGPUDevice()) ?? this.placeholderTideMeshBuffer;
        this.uniforms.set.pointCount(pointCount);
        this.uniforms.set.time(performance.now() / 1000);
        this.uniforms.set.tideHeight(tideHeight);
        this.uniforms.set.modifierCount(modifierCount);
        this.uniforms.set.contourCount(terrainResources.getContourCount());
        this.uniforms.set.defaultDepth((0, $50f569eac7e9a7b2$export$7f882bb969de14a3));
        this.uniforms.set.numWaves(waterResources.getNumWaves());
        this.uniforms.set.tidalPhase(tidalResources?.getTidalPhase() ?? 0);
        this.uniforms.set.tidalStrength(tidalResources?.getTidalStrength() ?? 0);
        this.uniforms.set._padding2(0);
        this.uniforms.set._padding3(0);
        this.uniforms.set._padding4(0);
        this.uniforms.uploadTo(this.uniformBuffer);
        const bindGroup = this.queryShader.createBindGroup({
            params: {
                buffer: this.uniformBuffer
            },
            waveData: {
                buffer: waterResources.waveDataBuffer
            },
            modifiers: {
                buffer: waterResources.modifiersBuffer
            },
            packedMesh: {
                buffer: packedMeshBuffer
            },
            packedTerrain: {
                buffer: terrainResources.packedTerrainBuffer
            },
            packedTideMesh: {
                buffer: packedTideMeshBuffer
            },
            pointBuffer: {
                buffer: this.pointBuffer
            },
            resultBuffer: {
                buffer: this.resultBuffer
            }
        });
        const gpuProfiler = this.game.getRenderer().getGpuProfiler();
        const computePass = commandEncoder.beginComputePass({
            label: "Water Query Compute Pass",
            timestampWrites: gpuProfiler?.getComputeTimestampWrites("query.water")
        });
        this.queryShader.dispatch(computePass, bindGroup, pointCount, 1);
        computePass.end();
    }
    onDestroy() {
        this.uniformBuffer?.destroy();
        this.placeholderPackedMeshBuffer?.destroy();
        this.placeholderTideMeshBuffer?.destroy();
    }
}
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $aa1f0309d9dba6d2$export$af631764ddc44097)("add")
], $e92cdfa4485b40d6$export$82d267451e6430a.prototype, "onAdd", null);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $aa1f0309d9dba6d2$export$af631764ddc44097)("destroy")
], $e92cdfa4485b40d6$export$82d267451e6430a.prototype, "onDestroy", null);








/**
 * Wind Query Compute Shader
 *
 * Samples wind data (velocity, speed, direction) at arbitrary query points.
 * Uses wind shader modules for consistent computation with rendering.
 * Supports per-source wind mesh blending via weights.
 *
 * Input:  pointBuffer (storage) - array of vec2<f32> query points
 * Output: resultBuffer (storage) - array of WindQueryResult structs
 */ 



/**
 * Packed wind mesh accessor functions for reading from a single array<u32> buffer.
 *
 * Multi-source buffer layout matches WindMeshPacking.ts:
 *
 * GLOBAL HEADER (32 u32s):
 *   [0]      numWindSources
 *   [1..8]   meshOffset[0..7]
 *   [9..16]  direction[0..7]      (f32 bitcast)
 *   [17..31] padding
 *
 * PER-SOURCE MESH HEADER (16 u32s each):
 *   [0]  vertexOffset    [1]  vertexCount
 *   [2]  indexOffset      [3]  triangleCount
 *   [4]  gridOffset       [5]  gridCols       [6]  gridRows
 *   [7]  gridMinX (f32)   [8]  gridMinY (f32)
 *   [9]  gridCellWidth    [10] gridCellHeight
 *   [11..15] padding
 *
 * All float values are stored as u32 and recovered via bitcast<f32>().
 */ 

const $4a8696539c8460c4$export$9b11d308291fe020 = {
    preamble: /*wgsl*/ `
struct WindMeshSourceHeader {
  vertexOffset: u32,
  vertexCount: u32,
  indexOffset: u32,
  triangleCount: u32,
  gridOffset: u32,
  gridCols: u32,
  gridRows: u32,
  gridMinX: f32,
  gridMinY: f32,
  gridCellWidth: f32,
  gridCellHeight: f32,
}
`,
    code: ""
};
const $4a8696539c8460c4$export$f6c4b78cca1aa6f4 = {
    preamble: /*wgsl*/ `
struct WindMeshLookupResult {
  speedFactor: f32,
  directionOffset: f32,
  turbulence: f32,
  found: bool,
}
`,
    code: ""
};
const $4a8696539c8460c4$export$9f9ddfdf77b4dc66 = {
    dependencies: [
        $4a8696539c8460c4$export$9b11d308291fe020
    ],
    code: /*wgsl*/ `
fn getWindMeshSourceHeader(packed: ptr<storage, array<u32>, read>, meshOffset: u32) -> WindMeshSourceHeader {
  var h: WindMeshSourceHeader;
  h.vertexOffset = (*packed)[meshOffset + 0u];
  h.vertexCount = (*packed)[meshOffset + 1u];
  h.indexOffset = (*packed)[meshOffset + 2u];
  h.triangleCount = (*packed)[meshOffset + 3u];
  h.gridOffset = (*packed)[meshOffset + 4u];
  h.gridCols = (*packed)[meshOffset + 5u];
  h.gridRows = (*packed)[meshOffset + 6u];
  h.gridMinX = bitcast<f32>((*packed)[meshOffset + 7u]);
  h.gridMinY = bitcast<f32>((*packed)[meshOffset + 8u]);
  h.gridCellWidth = bitcast<f32>((*packed)[meshOffset + 9u]);
  h.gridCellHeight = bitcast<f32>((*packed)[meshOffset + 10u]);
  return h;
}
`
};
const $4a8696539c8460c4$export$e7157dc2da79539 = {
    code: /*wgsl*/ `
fn getWindMeshVertexPos(packed: ptr<storage, array<u32>, read>, vertexOffset: u32, index: u32) -> vec2<f32> {
  let base = vertexOffset + index * 5u;
  return vec2<f32>(
    bitcast<f32>((*packed)[base]),
    bitcast<f32>((*packed)[base + 1u])
  );
}
`
};
const $4a8696539c8460c4$export$9e2197ac021e6c5e = {
    code: /*wgsl*/ `
fn getWindMeshVertexAttribs(packed: ptr<storage, array<u32>, read>, vertexOffset: u32, index: u32) -> vec3<f32> {
  let base = vertexOffset + index * 5u + 2u;
  return vec3<f32>(
    bitcast<f32>((*packed)[base]),
    bitcast<f32>((*packed)[base + 1u]),
    bitcast<f32>((*packed)[base + 2u])
  );
}
`
};
const $4a8696539c8460c4$export$a412e849cbd91b87 = {
    code: /*wgsl*/ `
fn getWindMeshTriangle(packed: ptr<storage, array<u32>, read>, indexOffset: u32, triIndex: u32) -> vec3<u32> {
  let base = indexOffset + triIndex * 3u;
  return vec3<u32>(
    (*packed)[base],
    (*packed)[base + 1u],
    (*packed)[base + 2u]
  );
}
`
};
const $4a8696539c8460c4$export$bab865b75aa0eb0 = {
    code: /*wgsl*/ `
fn getWindMeshGridCell(packed: ptr<storage, array<u32>, read>, gridOffset: u32, cellIndex: u32) -> vec2<u32> {
  let base = gridOffset + cellIndex * 2u;
  return vec2<u32>(
    (*packed)[base],
    (*packed)[base + 1u]
  );
}
`
};
const $4a8696539c8460c4$export$567554df0bd8d9d3 = {
    code: /*wgsl*/ `
fn getWindMeshGridTriIndex(packed: ptr<storage, array<u32>, read>, listOffset: u32) -> u32 {
  return (*packed)[listOffset];
}
`
};
const $4a8696539c8460c4$export$638ddecb606b9bf8 = {
    dependencies: [
        $4a8696539c8460c4$export$9b11d308291fe020,
        $4a8696539c8460c4$export$f6c4b78cca1aa6f4,
        $4a8696539c8460c4$export$9f9ddfdf77b4dc66,
        $4a8696539c8460c4$export$e7157dc2da79539,
        $4a8696539c8460c4$export$9e2197ac021e6c5e,
        $4a8696539c8460c4$export$a412e849cbd91b87,
        $4a8696539c8460c4$export$bab865b75aa0eb0,
        $4a8696539c8460c4$export$567554df0bd8d9d3,
        (0, $fc61fa53c7d19e1c$export$2ab14ac05b6d942d)
    ],
    code: /*wgsl*/ `
fn lookupWindMeshForSource(
  worldPos: vec2<f32>,
  packed: ptr<storage, array<u32>, read>,
  meshOffset: u32,
) -> WindMeshLookupResult {
  var result: WindMeshLookupResult;
  result.speedFactor = 1.0;
  result.directionOffset = 0.0;
  result.turbulence = 0.0;
  result.found = false;

  let header = getWindMeshSourceHeader(packed, meshOffset);
  if (header.triangleCount == 0u) {
    return result;
  }

  let gx = (worldPos.x - header.gridMinX) / header.gridCellWidth;
  let gy = (worldPos.y - header.gridMinY) / header.gridCellHeight;

  let col = i32(floor(gx));
  let row = i32(floor(gy));

  if (col < 0 || col >= i32(header.gridCols) || row < 0 || row >= i32(header.gridRows)) {
    return result;
  }

  let cellIndex = u32(row) * header.gridCols + u32(col);
  let cell = getWindMeshGridCell(packed, header.gridOffset, cellIndex);
  let triListOffset = cell.x;
  let triListCount = cell.y;

  for (var t = 0u; t < triListCount; t++) {
    let triIndex = getWindMeshGridTriIndex(packed, triListOffset + t);
    let tri = getWindMeshTriangle(packed, header.indexOffset, triIndex);

    let a = getWindMeshVertexPos(packed, header.vertexOffset, tri.x);
    let b = getWindMeshVertexPos(packed, header.vertexOffset, tri.y);
    let c = getWindMeshVertexPos(packed, header.vertexOffset, tri.z);

    let bary = barycentric(worldPos, a, b, c);

    if (bary.x >= -0.001 && bary.y >= -0.001 && bary.z >= -0.001) {
      let attribA = getWindMeshVertexAttribs(packed, header.vertexOffset, tri.x);
      let attribB = getWindMeshVertexAttribs(packed, header.vertexOffset, tri.y);
      let attribC = getWindMeshVertexAttribs(packed, header.vertexOffset, tri.z);

      let interp = attribA * bary.x + attribB * bary.y + attribC * bary.z;

      result.speedFactor = interp.x;
      result.directionOffset = interp.y;
      result.turbulence = interp.z;
      result.found = true;
      return result;
    }
  }

  return result;
}
`
};
const $4a8696539c8460c4$export$f52dc0a44732e22d = {
    dependencies: [
        $4a8696539c8460c4$export$638ddecb606b9bf8,
        $4a8696539c8460c4$export$f6c4b78cca1aa6f4
    ],
    code: /*wgsl*/ `
const MAX_WIND_SOURCES: u32 = ${(0, $8ecd9f2b11cf50d1$export$7628c5082becdb31)}u;

fn lookupWindMeshBlended(
  worldPos: vec2<f32>,
  packed: ptr<storage, array<u32>, read>,
  weights: array<f32, ${(0, $8ecd9f2b11cf50d1$export$7628c5082becdb31)}>,
) -> WindMeshLookupResult {
  var result: WindMeshLookupResult;
  result.speedFactor = 1.0;
  result.directionOffset = 0.0;
  result.turbulence = 0.0;
  result.found = false;

  let numSources = (*packed)[0u];
  if (numSources == 0u) {
    return result;
  }

  var totalWeight: f32 = 0.0;
  var accSpeed: f32 = 0.0;
  var accDir: f32 = 0.0;
  var accTurb: f32 = 0.0;
  var anyFound: bool = false;

  for (var s = 0u; s < numSources && s < MAX_WIND_SOURCES; s++) {
    let w = weights[s];
    if (w <= 0.0) {
      continue;
    }

    let meshOffset = (*packed)[1u + s];
    let sourceResult = lookupWindMeshForSource(worldPos, packed, meshOffset);

    if (sourceResult.found) {
      accSpeed += sourceResult.speedFactor * w;
      accDir += sourceResult.directionOffset * w;
      accTurb += sourceResult.turbulence * w;
      totalWeight += w;
      anyFound = true;
    }
  }

  if (anyFound && totalWeight > 0.0) {
    let invWeight = 1.0 / totalWeight;
    result.speedFactor = accSpeed * invWeight;
    result.directionOffset = accDir * invWeight;
    result.turbulence = accTurb * invWeight;
    result.found = true;
  }

  return result;
}
`
};


const $e804e609086e00c2$var$WORKGROUP_SIZE = [
    64,
    1,
    1
];
const $e804e609086e00c2$export$41eec3d9d2d130c1 = (0, $ca6793d1abd58997$export$99bb2281c7368d10)("Params", {
    pointCount: (0, $ca6793d1abd58997$export$8bacf4ad828c7fe7),
    time: (0, $ca6793d1abd58997$export$e33361ff41014190),
    baseWindX: (0, $ca6793d1abd58997$export$e33361ff41014190),
    baseWindY: (0, $ca6793d1abd58997$export$e33361ff41014190),
    influenceSpeedFactor: (0, $ca6793d1abd58997$export$e33361ff41014190),
    influenceDirectionOffset: (0, $ca6793d1abd58997$export$e33361ff41014190),
    influenceTurbulence: (0, $ca6793d1abd58997$export$e33361ff41014190),
    numActiveWindSources: (0, $ca6793d1abd58997$export$8bacf4ad828c7fe7),
    // Per-source weights (8 floats, packed as 2 vec4s for alignment)
    weights0: (0, $ca6793d1abd58997$export$e33361ff41014190),
    weights1: (0, $ca6793d1abd58997$export$e33361ff41014190),
    weights2: (0, $ca6793d1abd58997$export$e33361ff41014190),
    weights3: (0, $ca6793d1abd58997$export$e33361ff41014190),
    weights4: (0, $ca6793d1abd58997$export$e33361ff41014190),
    weights5: (0, $ca6793d1abd58997$export$e33361ff41014190),
    weights6: (0, $ca6793d1abd58997$export$e33361ff41014190),
    weights7: (0, $ca6793d1abd58997$export$e33361ff41014190)
});
/**
 * Module containing Params and result structs, plus bindings.
 */ const $e804e609086e00c2$var$windQueryParamsModule = {
    preamble: /*wgsl*/ `
// Query parameters
struct Params {
  pointCount: u32,
  time: f32,
  baseWindX: f32,
  baseWindY: f32,
  influenceSpeedFactor: f32,
  influenceDirectionOffset: f32,
  influenceTurbulence: f32,
  numActiveWindSources: u32,
  weights0: f32,
  weights1: f32,
  weights2: f32,
  weights3: f32,
  weights4: f32,
  weights5: f32,
  weights6: f32,
  weights7: f32,
}

// Result structure (matches WindQueryResult interface)
// stride = 4 floats
struct WindQueryResult {
  velocityX: f32,
  velocityY: f32,
  speed: f32,
  direction: f32,
}
  `,
    bindings: {
        params: {
            type: "uniform",
            wgslType: "Params"
        },
        pointBuffer: {
            type: "storage",
            wgslType: "array<vec2<f32>>"
        },
        resultBuffer: {
            type: "storageRW",
            wgslType: "array<WindQueryResult>"
        },
        packedWindMesh: {
            type: "storage",
            wgslType: "array<u32>"
        }
    },
    code: ""
};
/**
 * Module containing the compute entry point.
 */ const $e804e609086e00c2$var$windQueryMainModule = {
    dependencies: [
        (0, $378400a833ed6cfa$export$54db7b3c706613a8),
        (0, $4a8696539c8460c4$export$f52dc0a44732e22d),
        $e804e609086e00c2$var$windQueryParamsModule
    ],
    code: /*wgsl*/ `
// Wind constants
const WIND_NOISE_SPATIAL_SCALE: f32 = ${(0, $8ecd9f2b11cf50d1$export$dd7d443fcf6b50ed)};
const WIND_NOISE_TIME_SCALE: f32 = ${(0, $8ecd9f2b11cf50d1$export$396c615eb4edc32)};
const WIND_SPEED_VARIATION: f32 = ${(0, $8ecd9f2b11cf50d1$export$954c8e2afd7a19b5)};
const WIND_ANGLE_VARIATION: f32 = ${(0, $8ecd9f2b11cf50d1$export$17519356ae9cf5d5)};
const WIND_FLOW_CYCLE_PERIOD: f32 = ${(0, $8ecd9f2b11cf50d1$export$7417d004087d724a)};
const WIND_SLOW_TIME_SCALE: f32 = ${(0, $8ecd9f2b11cf50d1$export$36b566ff16e06fa5)};

@compute @workgroup_size(${$e804e609086e00c2$var$WORKGROUP_SIZE[0]})
fn main(@builtin(global_invocation_id) globalId: vec3<u32>) {
  let index = globalId.x;

  if (index >= params.pointCount) {
    return;
  }

  let queryPoint = pointBuffer[index];

  // Build weights array from uniform fields
  var weights: array<f32, ${(0, $8ecd9f2b11cf50d1$export$7628c5082becdb31)}>;
  weights[0] = params.weights0;
  weights[1] = params.weights1;
  weights[2] = params.weights2;
  weights[3] = params.weights3;
  weights[4] = params.weights4;
  weights[5] = params.weights5;
  weights[6] = params.weights6;
  weights[7] = params.weights7;

  // Look up blended wind mesh for terrain influence
  let meshResult = lookupWindMeshBlended(queryPoint, &packedWindMesh, weights);
  let speedFactor = select(params.influenceSpeedFactor, meshResult.speedFactor, meshResult.found);
  let dirOffset = select(params.influenceDirectionOffset, meshResult.directionOffset, meshResult.found);
  let turb = select(params.influenceTurbulence, meshResult.turbulence, meshResult.found);

  // Compute wind using shared module
  let windResult = computeWindAtPoint(
    queryPoint,
    params.time,
    vec2<f32>(params.baseWindX, params.baseWindY),
    speedFactor,
    dirOffset,
    turb,
    WIND_NOISE_SPATIAL_SCALE,
    WIND_NOISE_TIME_SCALE,
    WIND_SPEED_VARIATION,
    WIND_ANGLE_VARIATION,
    WIND_FLOW_CYCLE_PERIOD,
    WIND_SLOW_TIME_SCALE
  );

  var result: WindQueryResult;
  result.velocityX = windResult.velocity.x;
  result.velocityY = windResult.velocity.y;
  result.speed = windResult.speed;
  result.direction = windResult.direction;

  resultBuffer[index] = result;
}
  `
};
const $e804e609086e00c2$export$525e29ccdfe2cbc3 = {
    modules: [
        $e804e609086e00c2$var$windQueryMainModule
    ],
    workgroupSize: $e804e609086e00c2$var$WORKGROUP_SIZE,
    label: "WindQueryShader"
};
function $e804e609086e00c2$export$fbead6225eab98c0() {
    return new (0, $4016c3d8f65071ed$export$cdde5429dd049099)($e804e609086e00c2$export$525e29ccdfe2cbc3);
}



const $e87d58ac59661451$var$MAX_WIND_QUERIES = 2 ** 15;
class $e87d58ac59661451$export$ad398e76bc924d9d extends (0, $5cb489536d94582d$export$b986383a50b53ea4) {
    constructor(){
        super((0, $83fe61aef90c7444$export$f074865b5380d6bd), $e87d58ac59661451$var$MAX_WIND_QUERIES), this.id = "windQueryManager", this.tickLayer = "query", this.queryShader = null, this.uniformBuffer = null, this.uniforms = (0, $e804e609086e00c2$export$41eec3d9d2d130c1).create();
        this.queryShader = (0, $e804e609086e00c2$export$fbead6225eab98c0)();
    }
    async onAdd() {
        super.onAdd();
        await this.queryShader.init();
        const device = this.game.getWebGPUDevice();
        this.uniformBuffer = device.createBuffer({
            label: "Wind Query Uniform Buffer",
            size: (0, $e804e609086e00c2$export$41eec3d9d2d130c1).byteSize,
            usage: GPUBufferUsage.UNIFORM | GPUBufferUsage.COPY_DST
        });
    }
    getQueries() {
        return [
            ...this.game.entities.byConstructor((0, $3d4e827a36d4d6ff$export$20101e03857a552b))
        ];
    }
    dispatchCompute(pointCount, commandEncoder) {
        if (pointCount === 0) return;
        if (!this.queryShader || !this.uniformBuffer) {
            console.warn("[WindQuery] Shader not initialized");
            return;
        }
        const windResources = this.game.entities.getSingleton((0, $cd5b26e926c7fea1$export$c6b583ea58097b81));
        const baseWind = windResources.getBaseVelocity();
        const sourceWeights = windResources.getSourceWeights();
        this.uniforms.set.pointCount(pointCount);
        this.uniforms.set.time(performance.now() / 1000);
        this.uniforms.set.baseWindX(baseWind.x);
        this.uniforms.set.baseWindY(baseWind.y);
        this.uniforms.set.influenceSpeedFactor(1.0);
        this.uniforms.set.influenceDirectionOffset(0.0);
        this.uniforms.set.influenceTurbulence(0.0);
        this.uniforms.set.numActiveWindSources(sourceWeights.length);
        this.uniforms.set.weights0(sourceWeights[0] ?? 0);
        this.uniforms.set.weights1(sourceWeights[1] ?? 0);
        this.uniforms.set.weights2(sourceWeights[2] ?? 0);
        this.uniforms.set.weights3(sourceWeights[3] ?? 0);
        this.uniforms.set.weights4(sourceWeights[4] ?? 0);
        this.uniforms.set.weights5(sourceWeights[5] ?? 0);
        this.uniforms.set.weights6(sourceWeights[6] ?? 0);
        this.uniforms.set.weights7(sourceWeights[7] ?? 0);
        this.uniforms.uploadTo(this.uniformBuffer);
        const windMeshBuffer = windResources.getPackedWindMeshBuffer();
        const bindGroup = this.queryShader.createBindGroup({
            params: {
                buffer: this.uniformBuffer
            },
            pointBuffer: {
                buffer: this.pointBuffer
            },
            resultBuffer: {
                buffer: this.resultBuffer
            },
            packedWindMesh: {
                buffer: windMeshBuffer
            }
        });
        const gpuProfiler = this.game.getRenderer().getGpuProfiler();
        const computePass = commandEncoder.beginComputePass({
            label: "Wind Query Compute Pass",
            timestampWrites: gpuProfiler?.getComputeTimestampWrites("query.wind")
        });
        this.queryShader.dispatch(computePass, bindGroup, pointCount, 1);
        computePass.end();
    }
}
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $aa1f0309d9dba6d2$export$af631764ddc44097)("add")
], $e87d58ac59661451$export$ad398e76bc924d9d.prototype, "onAdd", null);



//#tunable("Camera") { min: 0.5, max: 10 }
let $84fec699245406bf$var$MENU_ZOOM = 2;
//#tunable("Camera") { min: 1, max: 20 }
let $84fec699245406bf$var$GAMEPLAY_ZOOM = 8;
class $84fec699245406bf$export$f3f3f6c0124f08de extends (0, $c59361981bac2575$export$4342ba5c6ad1f6f1) {
    onAdd() {
        // Switch from asset preloader UI to main menu
        for (const preloader of [
            ...this.game.entities.byConstructor((0, $2cad9d9952e2fd36$export$aad6cdef011fb02b))
        ])preloader.destroy();
        // Create save manager (persists across scene clears like GameController)
        this.game.addEntity(new (0, $010b1213c3fa230c$export$5bfce22a6398152d)());
        // Start with wide camera shot for menu
        this.game.camera.z = $84fec699245406bf$var$MENU_ZOOM;
        // Show level select menu (no level loading yet)
        this.game.addEntity(new (0, $0e28100eb9c66a46$export$4e08dcf990b776c0)());
    }
    async onBoatSelected({ boatId: boatId, levelName: levelName }) {
        this.currentLevel = levelName;
        this.selectedBoatId = boatId;
        const initScreen = this.game.addEntity(new (0, $313afacd236db9df$export$8c042ec674a35644)());
        // 1. Load level data (terrain + waves + wavemesh + trees)
        const { terrain: terrain, waves: waves, wind: wind, wavemeshData: wavemeshData, windmeshData: windmeshData, treeData: treeData, biome: biome, startPosition: startPosition, ports: ports, missions: missions } = await (0, $375e214684cd760f$export$8394cb0148a08968)(levelName);
        this.treeData = treeData;
        this.startPosition = startPosition ?? (0, $6b6a54a072724620$export$e7c866399fa523f5)(0, 0);
        this.ports = ports ?? [];
        this.missions = missions ?? [];
        this.game.addEntity(new (0, $cd92036e590b44aa$export$74cf638da29b900d)(terrain));
        this.game.addEntity(new (0, $47b77f125c24cf19$export$65e31a0e727fd81f)());
        // 2. Time system (before water, so tides can query time)
        this.game.addEntity(new (0, $4df5c29ec7839388$export$1467403458327a44)());
        // 3. Wave physics
        const wavePhysics = this.game.addEntity(new (0, $ffbca396848d8854$export$8b9e0edba56abb99)(waves, wavemeshData));
        // 4. Water data system (tide, modifiers, GPU buffers, wave sources)
        this.game.addEntity(new (0, $cb7a1399420ef9b3$export$56d2cf3a64cd00a4)(waves));
        this.game.addEntity(new (0, $e92cdfa4485b40d6$export$82d267451e6430a)());
        // 5. Wind data systems
        this.game.addEntity(new (0, $cd5b26e926c7fea1$export$c6b583ea58097b81)(windmeshData, wind));
        this.game.addEntity(new (0, $e87d58ac59661451$export$ad398e76bc924d9d)());
        this.game.addEntity(new (0, $d5f38f711f8a9f80$export$7233ea1ab57f474c)());
        // 6. Visual entities
        const surfaceRenderer = this.game.addEntity(new (0, $8f91167edee9a01b$export$86ec1cc3842ae5f)((0, $be7b0a69b0f1c572$export$53718d50d05e05a3)(biome)));
        this.game.addEntity(new (0, $d78f759d9306ad7b$export$2f674e33b9ab74ba)());
        // Wait for critical systems before starting gameplay
        await Promise.all([
            surfaceRenderer.whenReady(),
            wavePhysics.whenReady()
        ]);
        // Release rendering and start the game
        surfaceRenderer.setEnabled(true);
        initScreen.destroy();
        this.game.dispatch("gameStart", {});
    }
    onKeyDown({ key: key, event: event }) {
        if (key !== "Escape") return;
        // If any menu already handled Escape (via preventDefault), don't open the
        // pause menu on top of the action.
        if (event.defaultPrevented) return;
        if (this.game.entities.tryGetSingleton((0, $c2cad548d22b70b6$export$66bb9231a6614ad8))) return;
        if (this.game.entities.tryGetSingleton((0, $0e28100eb9c66a46$export$4e08dcf990b776c0))) return;
        if (this.portMenu) return;
        if (this.currentLevel === null) return;
        // Defer creation so the newly-added PauseMenu doesn't receive the same
        // keyDown dispatch we're inside — which would destroy it immediately.
        const game = this.game;
        queueMicrotask(()=>game.addEntity(new (0, $c2cad548d22b70b6$export$66bb9231a6614ad8)()));
    }
    onBoatSunk() {
        this.game.addEntity(new (0, $e53207e7ad42866a$export$46f2ab12afeb552e)());
    }
    onBoatMoored({ portId: portId, portName: portName }) {
        if (this.portMenu) return;
        this.portMenu = this.game.addEntity(new (0, $e4d56de93920a762$export$dfd81546518a5c0c)(portId, portName));
    }
    onBoatUnmoored() {
        if (this.portMenu) {
            this.portMenu.destroy();
            this.portMenu = null;
        }
    }
    onRestartLevel() {
        if (this.currentLevel) {
            this.game.clearScene(99);
            this.game.dispatch("boatSelected", {
                boatId: this.selectedBoatId,
                levelName: this.currentLevel
            });
        }
    }
    onReturnToMenu() {
        this.game.clearScene(99);
        this.currentLevel = null;
        this.game.camera.z = $84fec699245406bf$var$MENU_ZOOM;
        this.game.addEntity(new (0, $0e28100eb9c66a46$export$4e08dcf990b776c0)());
    }
    onGameStart() {
        // The clock
        this.game.addEntity(new (0, $f46554a8dcd678e4$export$8c6b7db3679299d7)());
        this.game.addEntity(new (0, $a8d907c4d81bde2c$export$a105e548efe5f62c)(this.currentLevel ?? undefined));
        // Cloth worker pool for off-thread sail simulation (must exist before sails)
        this.game.addEntity(new (0, $94ee08abd30b7ab8$export$ac63f54694fe4370)());
        // Progression system
        this.game.addEntity(new (0, $a1603b9cc09f9d46$export$caa51bcb55fa9d65)());
        // Spawn ports
        for (const portData of this.ports)this.game.addEntity(new (0, $62c7325363ad2df3$export$a2d375858cc72119)(portData));
        // Check for pending save data (load game flow)
        const saveManager = this.game.entities.tryGetSingleton((0, $010b1213c3fa230c$export$5bfce22a6398152d));
        const pendingSave = saveManager?.consumePendingSave() ?? null;
        // Use saved position/rotation if loading, otherwise level start position
        const boatPosition = pendingSave ? (0, $6b6a54a072724620$export$e7c866399fa523f5)(pendingSave.boat.position[0], pendingSave.boat.position[1]) : this.startPosition;
        const boatRotation = pendingSave?.boat.rotation ?? 0;
        // Spawn boat and controls
        const boatConfig = (0, $6d17b959f73c0724$export$9f9db6a27c89416f)(this.selectedBoatId)?.baseConfig;
        const boat = this.game.addEntity(new (0, $52fa7c25729534ad$export$50202e6ddd188c3a)(boatPosition, boatConfig, boatRotation));
        this.game.addEntity(new (0, $a1db6edab9cae626$export$338e656c65562d29)(boat));
        this.game.addEntity(new (0, $1e968766b871c95d$export$dad5dd4a2e9f9608)());
        this.game.addEntity(new (0, $2aa82da197f24de3$export$3e4593ac014e28d7)());
        // Apply remaining save state (damage, bilge, anchor) after construction
        if (pendingSave) (0, $0321ce98ded29204$export$9d683875612a4f9e)(this.game, pendingSave);
        // Spawn camera controller with zoom transition
        const cameraController = this.game.addEntity(new (0, $04c54d944dd254c7$export$d53514a691eb5346)(boat, this.game.camera));
        cameraController.setZoomTarget($84fec699245406bf$var$GAMEPLAY_ZOOM);
        // Spawn wind particles and sound
        this.game.addEntity(new (0, $a19c42d2ba21fe93$export$d95354cdd91795a)());
        this.game.addEntity(new (0, $28524a8d5666ac48$export$5f645a08d3a9611e)());
        // Spawn trees on landmasses from generated .trees file
        if (this.treeData) this.game.addEntity(new (0, $8003b38afc871c38$export$76eea51e6331f99a)(this.treeData));
        // Mission system
        if (this.missions.length > 0) {
            const missionManager = this.game.addEntity(new (0, $678b4e73c8f763d8$export$2e44203b34959a7f)(this.missions));
            this.game.addEntity(new (0, $a82e076dd0014e6c$export$a293bae3ba54199c)());
            // Restore mission state from save
            if (pendingSave) missionManager.setState({
                completedMissionIds: pendingSave.progression.completedMissions,
                currentMissionId: pendingSave.progression.currentMission?.missionId,
                money: pendingSave.progression.money,
                revealedPortIds: pendingSave.progression.discoveredPorts
            });
        }
        // Restore progression state from save
        if (pendingSave) {
            const prog = this.game.entities.tryGetSingleton((0, $a1603b9cc09f9d46$export$caa51bcb55fa9d65));
            if (prog) prog.restoreFromSave(pendingSave.progression);
        }
        // Tutorial disabled for now.
        // Signal for automated profiling / e2e scripts that gameplay is live.
        window.DEBUG.gameStarted = true;
    }
    constructor(...args){
        super(...args), this.id = "gameController", this.persistenceLevel = 100, this.currentLevel = null, this.selectedBoatId = "shaff-s7", this.startPosition = (0, $6b6a54a072724620$export$e7c866399fa523f5)(0, 0), this.ports = [], this.missions = [], this.portMenu = null;
    }
}
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $aa1f0309d9dba6d2$export$af631764ddc44097)("add")
], $84fec699245406bf$export$f3f3f6c0124f08de.prototype, "onAdd", null);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $aa1f0309d9dba6d2$export$af631764ddc44097)("boatSelected")
], $84fec699245406bf$export$f3f3f6c0124f08de.prototype, "onBoatSelected", null);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $aa1f0309d9dba6d2$export$af631764ddc44097)("keyDown")
], $84fec699245406bf$export$f3f3f6c0124f08de.prototype, "onKeyDown", null);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $aa1f0309d9dba6d2$export$af631764ddc44097)("boatSunk")
], $84fec699245406bf$export$f3f3f6c0124f08de.prototype, "onBoatSunk", null);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $aa1f0309d9dba6d2$export$af631764ddc44097)("boatMoored")
], $84fec699245406bf$export$f3f3f6c0124f08de.prototype, "onBoatMoored", null);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $aa1f0309d9dba6d2$export$af631764ddc44097)("boatUnmoored")
], $84fec699245406bf$export$f3f3f6c0124f08de.prototype, "onBoatUnmoored", null);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $aa1f0309d9dba6d2$export$af631764ddc44097)("restartLevel")
], $84fec699245406bf$export$f3f3f6c0124f08de.prototype, "onRestartLevel", null);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $aa1f0309d9dba6d2$export$af631764ddc44097)("returnToMenu")
], $84fec699245406bf$export$f3f3f6c0124f08de.prototype, "onReturnToMenu", null);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $aa1f0309d9dba6d2$export$af631764ddc44097)("gameStart")
], $84fec699245406bf$export$f3f3f6c0124f08de.prototype, "onGameStart", null);





const $da7e16e29ed26d68$export$910dfe656d5d75a4 = new (0, $2cad9d9952e2fd36$export$aad6cdef011fb02b)((0, $bcae27952f7958f2$export$4e841128923ef26), ({ fonts: fonts, images: images, sounds: sounds })=>/*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("div", {
        style: {
            display: "flex",
            justifyContent: "center",
            padding: "8rem",
            position: "absolute",
            inset: 0
        },
        children: /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("div", {
            style: {
                color: "white",
                display: "flex",
                flexDirection: "column",
                fontFamily: "var(--font-body)",
                fontWeight: "300",
                fontSize: "1.5rem",
                gap: "1rem"
            },
            children: [
                /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("span", {
                    style: {
                        fontFamily: "var(--font-title)",
                        fontSize: "2em",
                        fontWeight: "400"
                    },
                    children: "Loading..."
                }),
                /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("label", {
                    children: [
                        /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("span", {
                            children: "fonts"
                        }),
                        /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("progress", {
                            style: {
                                display: "block"
                            },
                            value: fonts.loaded,
                            max: fonts.total
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("label", {
                    children: [
                        /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("span", {
                            children: "images"
                        }),
                        /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("progress", {
                            style: {
                                display: "block"
                            },
                            value: images.loaded,
                            max: images.total
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("label", {
                    children: [
                        /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("span", {
                            children: "sounds"
                        }),
                        /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("progress", {
                            style: {
                                display: "block"
                            },
                            value: sounds.loaded,
                            max: sounds.total
                        })
                    ]
                })
            ]
        })
    }));





const $e7d83f20263597ad$var$MAX_POSITION = 10000;
const $e7d83f20263597ad$var$MAX_VELOCITY = 1000;
class $e7d83f20263597ad$export$a9fd6a9b07f758f3 extends (0, $c59361981bac2575$export$4342ba5c6ad1f6f1) {
    onAfterPhysicsStep() {
        const warnings = [];
        for (const body of this.game.world.bodies){
            if (body.motion === "static") continue;
            const [x, y] = body.position;
            const [vx, vy] = body.velocity;
            const ownerName = body.owner?.constructor?.name ?? "unknown";
            const positionBad = !isFinite(x) || !isFinite(y) || Math.abs(x) > $e7d83f20263597ad$var$MAX_POSITION || Math.abs(y) > $e7d83f20263597ad$var$MAX_POSITION;
            const velocityBad = !isFinite(vx) || !isFinite(vy);
            if (positionBad || velocityBad) {
                warnings.push({
                    owner: ownerName,
                    issue: "reset",
                    details: {
                        position: [
                            x,
                            y
                        ],
                        velocity: [
                            vx,
                            vy
                        ],
                        angularVelocity: body.angularVelocity
                    }
                });
                body.position.set(0, 0);
                body.velocity.set(0, 0);
                body.angularVelocity = 0;
                continue;
            }
            const speed = Math.hypot(vx, vy);
            if (speed > $e7d83f20263597ad$var$MAX_VELOCITY) {
                warnings.push({
                    owner: ownerName,
                    issue: "clamp",
                    details: {
                        velocity: [
                            vx,
                            vy
                        ],
                        angularVelocity: body.angularVelocity,
                        speed: speed,
                        maxVelocity: $e7d83f20263597ad$var$MAX_VELOCITY
                    }
                });
                const scale = $e7d83f20263597ad$var$MAX_VELOCITY / speed;
                body.velocity[0] *= scale;
                body.velocity[1] *= scale;
            }
        }
        if (warnings.length > 0) console.warn("Physics validator detected instability in bodies:", warnings);
    }
}
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $aa1f0309d9dba6d2$export$af631764ddc44097)("afterPhysicsStep")
], $e7d83f20263597ad$export$a9fd6a9b07f758f3.prototype, "onAfterPhysicsStep", null);










function $651571cbe3d225f9$export$bbf4d37c28924780() {
    return {
        id: "simulation",
        render: (ctx)=>{
            const physics = $651571cbe3d225f9$var$getPhysicsStats(ctx);
            const stats = $651571cbe3d225f9$var$getQueryStats(ctx);
            const terrainCache = $651571cbe3d225f9$var$getTerrainCacheStats(ctx);
            const modifiers = $651571cbe3d225f9$var$getModifierStats(ctx);
            return /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)((0, $13c40c34b78c8ee2$export$ffb0004e005737fa), {
                children: [
                    /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("div", {
                        className: "stats-overlay__header",
                        children: /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("span", {
                            children: "Simulation"
                        })
                    }),
                    /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("div", {
                        className: "stats-overlay__section",
                        children: [
                            /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("div", {
                                className: "stats-overlay__section-title",
                                children: "Physics"
                            }),
                            /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("div", {
                                className: "stats-overlay__grid",
                                children: [
                                    /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)((0, $7a2f573c2e376f50$export$ec098db2733c7492), {
                                        label: "Bodies",
                                        value: physics.bodies
                                    }),
                                    /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)((0, $7a2f573c2e376f50$export$ec098db2733c7492), {
                                        label: "Constraints",
                                        value: physics.constraints
                                    }),
                                    /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)((0, $7a2f573c2e376f50$export$ec098db2733c7492), {
                                        label: "Equations",
                                        value: physics.equations
                                    }),
                                    /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)((0, $7a2f573c2e376f50$export$ec098db2733c7492), {
                                        label: "Islands",
                                        value: physics.islands || "off"
                                    }),
                                    /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)((0, $7a2f573c2e376f50$export$ec098db2733c7492), {
                                        label: "Iterations",
                                        value: `${physics.iterations} (max ${physics.maxIterations})`,
                                        color: physics.maxIterations >= 10 ? "warning" : undefined
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("div", {
                        className: "stats-overlay__section",
                        children: [
                            /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("div", {
                                className: "stats-overlay__section-title",
                                children: "Queries"
                            }),
                            /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("div", {
                                className: "stats-overlay__grid",
                                children: [
                                    /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)((0, $7a2f573c2e376f50$export$ec098db2733c7492), {
                                        label: "Water",
                                        value: `${stats.waterPoints.toLocaleString()} (${stats.waterQueries})`
                                    }),
                                    /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)((0, $7a2f573c2e376f50$export$ec098db2733c7492), {
                                        label: "Terrain",
                                        value: `${stats.terrainPoints.toLocaleString()} (${stats.terrainQueries})`
                                    }),
                                    /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)((0, $7a2f573c2e376f50$export$ec098db2733c7492), {
                                        label: "Wind",
                                        value: `${stats.windPoints.toLocaleString()} (${stats.windQueries})`
                                    })
                                ]
                            })
                        ]
                    }),
                    modifiers && /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("div", {
                        className: "stats-overlay__section",
                        children: [
                            /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("div", {
                                className: "stats-overlay__section-title",
                                children: "Water Modifiers"
                            }),
                            /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("div", {
                                className: "stats-overlay__grid",
                                children: [
                                    /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)((0, $7a2f573c2e376f50$export$ec098db2733c7492), {
                                        label: "Total",
                                        value: `${modifiers.total.toLocaleString()} / ${(0, $cb7a1399420ef9b3$export$f163568a8f0e136f).toLocaleString()}`,
                                        color: modifiers.total >= (0, $cb7a1399420ef9b3$export$f163568a8f0e136f) ? "warning" : undefined
                                    }),
                                    /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)((0, $7a2f573c2e376f50$export$ec098db2733c7492), {
                                        label: "Wake",
                                        value: modifiers.wake.toLocaleString()
                                    }),
                                    /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)((0, $7a2f573c2e376f50$export$ec098db2733c7492), {
                                        label: "Foam",
                                        value: modifiers.foam.toLocaleString()
                                    }),
                                    modifiers.other > 0 && /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)((0, $7a2f573c2e376f50$export$ec098db2733c7492), {
                                        label: "Other",
                                        value: modifiers.other.toLocaleString()
                                    })
                                ]
                            })
                        ]
                    }),
                    terrainCache && /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("div", {
                        className: "stats-overlay__section",
                        children: [
                            /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("div", {
                                className: "stats-overlay__section-title",
                                children: "Terrain Cache"
                            }),
                            /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)("div", {
                                className: "stats-overlay__grid",
                                children: [
                                    /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)((0, $7a2f573c2e376f50$export$ec098db2733c7492), {
                                        label: "LOD",
                                        value: `${terrainCache.currentLOD} (${terrainCache.worldUnitsPerTile}u/tile)`
                                    }),
                                    /*#__PURE__*/ (0, $7cf5de2d778dc547$export$34b9dba7ce09269b)((0, $7a2f573c2e376f50$export$ec098db2733c7492), {
                                        label: "Tiles",
                                        value: `${terrainCache.readyTiles}/${terrainCache.cachedTiles}`
                                    })
                                ]
                            })
                        ]
                    })
                ]
            });
        }
    };
}
function $651571cbe3d225f9$var$getPhysicsStats(ctx) {
    const world = ctx.game.world;
    return {
        equations: world.solverEquationCount,
        islands: world.solverIslandCount,
        iterations: world.solverIterations,
        maxIterations: world.solverMaxIterations,
        bodies: world.bodies.dynamic.length,
        constraints: world.constraints.length
    };
}
function $651571cbe3d225f9$var$getQueryStats(ctx) {
    const waterQueries = [
        ...ctx.game.entities.byConstructor((0, $2f31bbbd4b5b01e3$export$38b1d297f12cec06))
    ];
    const terrainQueries = [
        ...ctx.game.entities.byConstructor((0, $178448b994cda479$export$b2f87c4d67934c2d))
    ];
    const windQueries = [
        ...ctx.game.entities.byConstructor((0, $3d4e827a36d4d6ff$export$20101e03857a552b))
    ];
    return {
        waterPoints: waterQueries.reduce((sum, q)=>sum + q.results.length, 0),
        waterQueries: waterQueries.length,
        terrainPoints: terrainQueries.reduce((sum, q)=>sum + q.results.length, 0),
        terrainQueries: terrainQueries.length,
        windPoints: windQueries.reduce((sum, q)=>sum + q.results.length, 0),
        windQueries: windQueries.length
    };
}
function $651571cbe3d225f9$var$getModifierStats(ctx) {
    const waterResources = ctx.game.entities.tryGetSingleton((0, $cb7a1399420ef9b3$export$56d2cf3a64cd00a4));
    if (!waterResources) return null;
    let wake = 0;
    let foam = 0;
    let other = 0;
    for (const mod of waterResources.getCachedModifiers())switch(mod.data.type){
        case (0, $34555dd463019ed0$export$125ddb01a2b383f0).Wake:
            wake++;
            break;
        case (0, $34555dd463019ed0$export$125ddb01a2b383f0).Foam:
            foam++;
            break;
        default:
            other++;
            break;
    }
    return {
        total: wake + foam + other,
        wake: wake,
        foam: foam,
        other: other
    };
}
function $651571cbe3d225f9$var$getTerrainCacheStats(ctx) {
    const surfaceRenderer = ctx.game.entities.tryGetSingleton((0, $8f91167edee9a01b$export$86ec1cc3842ae5f));
    if (!surfaceRenderer) return null;
    return surfaceRenderer.getTerrainTileCacheStats();
}


function $1519c0f4dd754269$var$toggleMSAA() {
    const next = !(0, $3d4164726c38f33c$export$8f47e656fde7db88)();
    (0, $3d4164726c38f33c$export$d7ca61431a454ec7)(next);
    console.log(`MSAA ${next ? "enabled" : "disabled"}`);
}
const $1519c0f4dd754269$var$ticksPerFrame = 1;
async function $1519c0f4dd754269$var$main() {
    const params = new URLSearchParams(window.location.search);
    // ?autoStart=false keeps the animation loop stopped so the game can be
    // stepped one frame at a time from the DevTools console via
    // `window.DEBUG.game.nextFrame()` (or resumed with `game.startLoop()`).
    const autoStart = params.get("autoStart") !== "false";
    const game = new (0, $e4c72b6b95368f7f$export$985739bfa5723e08)({
        ticksPerSecond: 120 * $1519c0f4dd754269$var$ticksPerFrame,
        world: new (0, $916dbba8a53e4e40$export$812cd9544993280d)({
            substeps: 8,
            solverConfig: {
                iterations: 10
            }
        })
    });
    await game.init({
        rendererOptions: {
            backgroundColor: 0x000010
        },
        autoStart: autoStart
    });
    game.setGpuTimingEnabled(true);
    // Make the game accessible from the console
    window.DEBUG = {
        game: game,
        toggleMSAA: $1519c0f4dd754269$var$toggleMSAA
    };
    // Clean up resources when the page is unloaded
    window.addEventListener("beforeunload", ()=>game.destroy());
    const preloader = game.addEntity((0, $da7e16e29ed26d68$export$910dfe656d5d75a4));
    await preloader.waitTillLoaded();
    // Persistent entities
    game.addEntity(new (0, $1580d22674b34959$export$4f7389558ee2443b)([
        (0, $c4d0f7c25f5cdbbc$export$10141b7f938afb4f)(),
        (0, $80a5a5748ded5a10$export$27668a998e86ec76)(),
        (0, $4bf2f65ce36aef66$export$db38f125d817f3ab)(),
        (0, $651571cbe3d225f9$export$bbf4d37c28924780)()
    ]));
    game.addEntity(new (0, $0fd7a79b4c40c2d4$export$a74d3484492ce83d)());
    game.addEntity(new (0, $e7d83f20263597ad$export$a9fd6a9b07f758f3)());
    game.addEntity(new (0, $664bda363017f3bb$export$7f20708c5636d338)());
    // GameController handles menu, game state, and spawning gameplay entities
    game.addEntity(new (0, $84fec699245406bf$export$f3f3f6c0124f08de)());
    // ?quickstart=true (or legacy ?profile=1) skips the menu and boots straight
    // into a level. Combine with ?level=<name>&boat=<id> to pick the level/boat,
    // and ?autoStart=false to stop at the first frame for tick-by-tick debugging.
    if (params.has("quickstart") || params.has("profile")) {
        const levelName = params.get("level") ?? "default";
        const boatId = params.get("boat") ?? "shaff-s7";
        game.dispatch("boatSelected", {
            boatId: boatId,
            levelName: levelName
        });
    }
}
window.addEventListener("load", $1519c0f4dd754269$var$main);


//# sourceMappingURL=path0.0adb5d85.js.map
